
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire13c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire13c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gI0Ov", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $tTiFL = parcelRequire("tTiFL");
"use strict";
function $c2a162f41acbe588$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $c2a162f41acbe588$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $c2a162f41acbe588$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $c2a162f41acbe588$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $tTiFL.cwd();
                path = cwd;
            }
            $c2a162f41acbe588$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $c2a162f41acbe588$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $c2a162f41acbe588$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $c2a162f41acbe588$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $c2a162f41acbe588$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $c2a162f41acbe588$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $c2a162f41acbe588$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $c2a162f41acbe588$var$assertPath(from);
        $c2a162f41acbe588$var$assertPath(to);
        if (from === to) return "";
        from = $c2a162f41acbe588$var$posix.resolve(from);
        to = $c2a162f41acbe588$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $c2a162f41acbe588$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $c2a162f41acbe588$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $c2a162f41acbe588$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $c2a162f41acbe588$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $c2a162f41acbe588$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$c2a162f41acbe588$var$posix.posix = $c2a162f41acbe588$var$posix;
module.exports = $c2a162f41acbe588$var$posix;

});
parcelRegister("tTiFL", function(module, exports) {
// shim for using process in browser
var $059d9b0291ce0841$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $059d9b0291ce0841$var$cachedSetTimeout;
var $059d9b0291ce0841$var$cachedClearTimeout;
function $059d9b0291ce0841$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $059d9b0291ce0841$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $059d9b0291ce0841$var$cachedSetTimeout = setTimeout;
        else $059d9b0291ce0841$var$cachedSetTimeout = $059d9b0291ce0841$var$defaultSetTimout;
    } catch (e) {
        $059d9b0291ce0841$var$cachedSetTimeout = $059d9b0291ce0841$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $059d9b0291ce0841$var$cachedClearTimeout = clearTimeout;
        else $059d9b0291ce0841$var$cachedClearTimeout = $059d9b0291ce0841$var$defaultClearTimeout;
    } catch (e) {
        $059d9b0291ce0841$var$cachedClearTimeout = $059d9b0291ce0841$var$defaultClearTimeout;
    }
})();
function $059d9b0291ce0841$var$runTimeout(fun) {
    if ($059d9b0291ce0841$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($059d9b0291ce0841$var$cachedSetTimeout === $059d9b0291ce0841$var$defaultSetTimout || !$059d9b0291ce0841$var$cachedSetTimeout) && setTimeout) {
        $059d9b0291ce0841$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $059d9b0291ce0841$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $059d9b0291ce0841$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $059d9b0291ce0841$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $059d9b0291ce0841$var$runClearTimeout(marker) {
    if ($059d9b0291ce0841$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($059d9b0291ce0841$var$cachedClearTimeout === $059d9b0291ce0841$var$defaultClearTimeout || !$059d9b0291ce0841$var$cachedClearTimeout) && clearTimeout) {
        $059d9b0291ce0841$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $059d9b0291ce0841$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $059d9b0291ce0841$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $059d9b0291ce0841$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $059d9b0291ce0841$var$queue = [];
var $059d9b0291ce0841$var$draining = false;
var $059d9b0291ce0841$var$currentQueue;
var $059d9b0291ce0841$var$queueIndex = -1;
function $059d9b0291ce0841$var$cleanUpNextTick() {
    if (!$059d9b0291ce0841$var$draining || !$059d9b0291ce0841$var$currentQueue) return;
    $059d9b0291ce0841$var$draining = false;
    if ($059d9b0291ce0841$var$currentQueue.length) $059d9b0291ce0841$var$queue = $059d9b0291ce0841$var$currentQueue.concat($059d9b0291ce0841$var$queue);
    else $059d9b0291ce0841$var$queueIndex = -1;
    if ($059d9b0291ce0841$var$queue.length) $059d9b0291ce0841$var$drainQueue();
}
function $059d9b0291ce0841$var$drainQueue() {
    if ($059d9b0291ce0841$var$draining) return;
    var timeout = $059d9b0291ce0841$var$runTimeout($059d9b0291ce0841$var$cleanUpNextTick);
    $059d9b0291ce0841$var$draining = true;
    var len = $059d9b0291ce0841$var$queue.length;
    while(len){
        $059d9b0291ce0841$var$currentQueue = $059d9b0291ce0841$var$queue;
        $059d9b0291ce0841$var$queue = [];
        while(++$059d9b0291ce0841$var$queueIndex < len)if ($059d9b0291ce0841$var$currentQueue) $059d9b0291ce0841$var$currentQueue[$059d9b0291ce0841$var$queueIndex].run();
        $059d9b0291ce0841$var$queueIndex = -1;
        len = $059d9b0291ce0841$var$queue.length;
    }
    $059d9b0291ce0841$var$currentQueue = null;
    $059d9b0291ce0841$var$draining = false;
    $059d9b0291ce0841$var$runClearTimeout(timeout);
}
$059d9b0291ce0841$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $059d9b0291ce0841$var$queue.push(new $059d9b0291ce0841$var$Item(fun, args));
    if ($059d9b0291ce0841$var$queue.length === 1 && !$059d9b0291ce0841$var$draining) $059d9b0291ce0841$var$runTimeout($059d9b0291ce0841$var$drainQueue);
};
// v8 likes predictible objects
function $059d9b0291ce0841$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$059d9b0291ce0841$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$059d9b0291ce0841$var$process.title = "browser";
$059d9b0291ce0841$var$process.browser = true;
$059d9b0291ce0841$var$process.env = {};
$059d9b0291ce0841$var$process.argv = [];
$059d9b0291ce0841$var$process.version = ""; // empty string to avoid regexp issues
$059d9b0291ce0841$var$process.versions = {};
function $059d9b0291ce0841$var$noop() {}
$059d9b0291ce0841$var$process.on = $059d9b0291ce0841$var$noop;
$059d9b0291ce0841$var$process.addListener = $059d9b0291ce0841$var$noop;
$059d9b0291ce0841$var$process.once = $059d9b0291ce0841$var$noop;
$059d9b0291ce0841$var$process.off = $059d9b0291ce0841$var$noop;
$059d9b0291ce0841$var$process.removeListener = $059d9b0291ce0841$var$noop;
$059d9b0291ce0841$var$process.removeAllListeners = $059d9b0291ce0841$var$noop;
$059d9b0291ce0841$var$process.emit = $059d9b0291ce0841$var$noop;
$059d9b0291ce0841$var$process.prependListener = $059d9b0291ce0841$var$noop;
$059d9b0291ce0841$var$process.prependOnceListener = $059d9b0291ce0841$var$noop;
$059d9b0291ce0841$var$process.listeners = function(name) {
    return [];
};
$059d9b0291ce0841$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$059d9b0291ce0841$var$process.cwd = function() {
    return "/";
};
$059d9b0291ce0841$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$059d9b0291ce0841$var$process.umask = function() {
    return 0;
};

});


/**
 * @author Iker Hurtado
 *
 * @overview File holding the application entry point
 */ /**
 * @author Iker Hurtado
 *
 * @fileoverview File holding the UIComponent base class
 */ /**
 * Base class for building UI components
 */ class $175b311ee190559c$export$2e2bcd8739ae039 {
    /**
   * @param  {string} htmlTag HTMLElement type wrapping the component
   * @param  {string} idOrClass a class name (prefixed by .) or 
   * an identificator (prefixed by #) must be provided
   */ constructor(htmlTag, idOrClass){
        //, appModule = ''){
        this.e = document.createElement(htmlTag);
        if (idOrClass === undefined) return;
        if (idOrClass.startsWith("#")) this.e.id = idOrClass.substring(1);
        else this.e.className = idOrClass.substring(1);
    }
    /**
   * Sets the initial component HTML
   * @param {string} html
   */ setHTML(html) {
        this.e.innerHTML = html;
    }
    /**
   * Returns the first internal HTML elements fulfilling the query selector query
   * @param  {string} query Regular query selector query
   * @return {HTMLElement|HTMLCanvasElement|HTMLInputElement}
   */ getElement(query) {
        return this.e.querySelector(query);
    }
    /**
   * Returns all the internal HTML elements fulfilling the query selector query
   * @param  {string} query Regular query selector query
   * @return {NodeListOf<HTMLElement|HTMLInputElement>}
   */ getElements(query) {
        return this.e.querySelectorAll(query);
    }
    /**
   * Adds a new HTMLElement to the component
   * @param {string} htmlTag 
   * @param {string} innerHTML new element HTML content
   */ addElement(htmlTag, innerHTML = "") {
        let newElement = document.createElement(htmlTag);
        newElement.innerHTML = innerHTML;
        this.e.appendChild(newElement);
        return newElement;
    }
}



class $9d993874406c4873$var$ModalPopup extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("div", ".ModalPopup");
        this.setHTML(`

        <div class="ModalPopup__overlay"></div>

        <span class="ModalPopup__close-button"> [ CLOSE ] </span>

        <div class="ModalPopup__content"></div>
    `);
        let closeModal = ()=>{
            this.e.style.display = "none";
        };
        closeModal();
        this.contentEl = this.getElement(".ModalPopup__content");
        this.getElement(".ModalPopup__overlay").addEventListener("click", closeModal);
        this.getElement("span").addEventListener("click", closeModal);
    }
}
// Creates the application modal popup
const $9d993874406c4873$var$appModal = new $9d993874406c4873$var$ModalPopup();
document.querySelector("body").appendChild($9d993874406c4873$var$appModal.e);
function $9d993874406c4873$export$b964053cbf2907a2(content) {
    $9d993874406c4873$var$appModal.contentEl.innerHTML = content;
}
function $9d993874406c4873$export$a778490beb6e83b8(component, add = false) {
    if (!add) $9d993874406c4873$var$appModal.contentEl.innerHTML = "";
    $9d993874406c4873$var$appModal.contentEl.appendChild(component);
}
function $9d993874406c4873$export$d7e8d4d4450c819c(resetScroll = false) {
    $9d993874406c4873$var$appModal.e.style.display = "block";
    if (resetScroll) $9d993874406c4873$var$appModal.contentEl.scrollTop = 0;
}
function $9d993874406c4873$export$af4939467128bcd0() {
    $9d993874406c4873$var$appModal.e.style.display = "none";
}
function $9d993874406c4873$export$aad8462122ac592b() {
    $9d993874406c4873$var$appModal.contentEl.innerHTML = "";
}


/**
 * @author Iker Hurtado
 *
 * @fileOverview File holding the StructureBuilder module main classes
 */ 
/**
 * @author Iker Hurtado
 *
 * @overview File holding the Structure class
 */ /**
 * @author Iker Hurtado, Sebastian Kokott
 *
 * @overview This is a basic math library.
 * It's coupled with the Three.js library in order to carry out
 * some geometry operations
 */ /**
 * Adds two vectors and returns a new one
 * @param {number[]} p1
 * @param {number[]} p2
 * @return {number[]}
 */ function $a4310c0d7cebdf93$export$e16d8520af44a096(p1, p2) {
    return [
        p2[0] + p1[0],
        p2[1] + p1[1],
        p2[2] + p1[2]
    ];
}
function $a4310c0d7cebdf93$export$631162a40b148a0c(p1, p2) {
    p1[0] += p2[0];
    p1[1] += p2[1];
    p1[2] += p2[2];
    return p1;
}
function $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(p2, p1) {
    return [
        p2[0] - p1[0],
        p2[1] - p1[1],
        p2[2] - p1[2]
    ];
}
function $a4310c0d7cebdf93$export$c697bed75648cdb7(vector, scalar) {
    return [
        vector[0] * scalar,
        vector[1] * scalar,
        vector[2] * scalar
    ];
}
function $a4310c0d7cebdf93$export$67275f837d70084d(vector, scalar) {
    return [
        vector[0] / scalar,
        vector[1] / scalar,
        vector[2] / scalar
    ];
}
function $a4310c0d7cebdf93$export$79376507b09a66f(p1, p2) {
    return Math.sqrt((p1[0] - p2[0]) ** 2 + (p1[1] - p2[1]) ** 2 + (p1[2] - p2[2]) ** 2);
}
/** returns vector length
 * @param v {number[]} a 3D vector
 * @return {number} the length of the vector
 */ function $a4310c0d7cebdf93$var$norm(v) {
    return Math.sqrt(v[0] ** 2 + v[1] ** 2 + v[2] ** 2);
}
/** returns dot product of two 3D vectors
 * @param x {number[]} first vector
 * @param y {number[]} second vector
 * @return {number} dot product
 */ function $a4310c0d7cebdf93$var$cdot(x, y) {
    return x[0] * y[0] + x[1] * y[1] + x[2] * y[2];
}
/** returns cross product of two 3D vectors
 * @param a {number[]} first vector
 * @param b {number[]} second vector
 * @returns {number[]} cross product
 */ function $a4310c0d7cebdf93$var$cross(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
/** returns angle between two 3D vectors
 * @param x {number[]} first vector
 * @param y {number[]} second vector
 * @return {number} angle in radians
 */ function $a4310c0d7cebdf93$var$angle(x, y) {
    return Math.acos($a4310c0d7cebdf93$var$cdot(x, y) / ($a4310c0d7cebdf93$var$norm(x) * $a4310c0d7cebdf93$var$norm(y)));
}
/** Normalizes 3D vector v
 *
 * @param v {number[]} vector
 * @returns {number[]} normalized vector
 */ function $a4310c0d7cebdf93$var$normalize(v) {
    const lenV = $a4310c0d7cebdf93$var$norm(v);
    return [
        v[0] / lenV,
        v[1] / lenV,
        v[2] / lenV
    ];
}
function $a4310c0d7cebdf93$export$b363da9ded343252(p1, p2, p3) {
    let p12v = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(p1, p2);
    let p32v = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(p3, p2);
    return $a4310c0d7cebdf93$var$angle(p12v, p32v) * 180 / Math.PI;
}
function $a4310c0d7cebdf93$export$4abdd6f44ae3d57a(p0, p1, p2, p3) {
    const b0 = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(p0, p1);
    let b1 = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(p2, p1);
    const b2 = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(p3, p2);
    b1 = $a4310c0d7cebdf93$var$normalize(b1);
    const v = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(b0, $a4310c0d7cebdf93$export$c697bed75648cdb7(b1, $a4310c0d7cebdf93$var$cdot(b0, b1)));
    const w = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(b2, $a4310c0d7cebdf93$export$c697bed75648cdb7(b1, $a4310c0d7cebdf93$var$cdot(b2, b1)));
    const x = $a4310c0d7cebdf93$var$cdot(v, w);
    const y = $a4310c0d7cebdf93$var$cdot($a4310c0d7cebdf93$var$cross(b1, v), w);
    return Math.atan2(y, x) * 180 / Math.PI;
}
function $a4310c0d7cebdf93$export$9c1b655deaca4988(mat, axis, op) {
    //
    let extr = [];
    let [m, n] = $a4310c0d7cebdf93$var$getDim(mat);
    let l, matrix;
    if (axis === 0) {
        matrix = mat[0].map((col, i)=>mat.map((row)=>row[i])); //Transpose
        l = n;
    } else {
        matrix = mat;
        l = m;
    }
    for(let i = 0; i < l; i++)extr.push(op(...matrix[i]));
    return extr;
}
function $a4310c0d7cebdf93$export$81b4290faedab233(A, B, C) {
    for(let i in A)for(let j in B){
        let sum = 0;
        for(let k in A[0])sum += A[i][k] * B[k][j];
        C[i][j] = sum;
    }
    return C;
}
function $a4310c0d7cebdf93$export$ea7769f152fc3675(A, B) {
    //
    let C = [];
    for(let i = 0; i < A.length; i++)for(let j = 0; j < B.length; j++)C.push($a4310c0d7cebdf93$export$c697bed75648cdb7(B[j], A[i][0]));
    return C;
}
/**
 * Returns the dimensions of a 2D matrix. If flat, returns 0 as first dimension.
 * @param {number[][]} mat
 * @return {number[]}
 */ function $a4310c0d7cebdf93$var$getDim(mat) {
    if (mat[0].length !== undefined) return [
        mat.length,
        mat[0].length
    ];
    else return [
        0,
        mat.length
    ];
}
function $a4310c0d7cebdf93$export$24b4d95b6fbb3080(arr1, arr2) {
    // Add two arrays.
    let arr = arr1.slice();
    for(let i in arr1)arr[i] = arr1[i] + arr2[i];
    return arr;
}
function $a4310c0d7cebdf93$export$ade607a7db86365e(m) {
    return m[0][0] * m[1][1] * m[2][2] + m[0][1] * m[1][2] * m[2][0] + m[0][2] * m[1][0] * m[2][1] - m[0][0] * m[1][2] * m[2][1] - m[0][1] * m[1][0] * m[2][2] - m[0][2] * m[1][1] * m[2][0];
}
function $a4310c0d7cebdf93$export$a48d4501dfd597fa(m) {
    const n11 = m[0][0], n21 = m[1][0], n31 = m[2][0], n12 = m[0][1], n22 = m[1][1], n32 = m[2][1], n13 = m[0][2], n23 = m[1][2], n33 = m[2][2], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
    if (det === 0) {
        console.error("invert3b3(m): det(m) == 0. m cannot be inverted!");
        return undefined;
    }
    const detInv = 1 / det;
    let i = [
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ]
    ];
    i[0][0] = t11 * detInv;
    i[1][0] = (n31 * n23 - n33 * n21) * detInv;
    i[2][0] = (n32 * n21 - n31 * n22) * detInv;
    i[0][1] = t12 * detInv;
    i[1][1] = (n33 * n11 - n31 * n13) * detInv;
    i[2][1] = (n31 * n12 - n32 * n11) * detInv;
    i[0][2] = t13 * detInv;
    i[1][2] = (n21 * n13 - n23 * n11) * detInv;
    i[2][2] = (n22 * n11 - n21 * n12) * detInv;
    return i;
}
function $a4310c0d7cebdf93$export$e5f48e10b9cc01f1(m, v) {
    return [
        m[0][0] * v[0] + m[0][1] * v[1] + m[0][2] * v[2],
        m[1][0] * v[0] + m[1][1] * v[1] + m[1][2] * v[2],
        m[2][0] * v[0] + m[2][1] * v[1] + m[2][2] * v[2]
    ];
}
function $a4310c0d7cebdf93$export$271d2f969e55c97(m) {
    return [
        [
            m[0][0],
            m[1][0],
            m[2][0]
        ],
        [
            m[0][1],
            m[1][1],
            m[2][1]
        ],
        [
            m[0][2],
            m[1][2],
            m[2][2]
        ]
    ];
}
function $a4310c0d7cebdf93$export$41e3a55430d11464(m, v) {
    const i = $a4310c0d7cebdf93$export$271d2f969e55c97($a4310c0d7cebdf93$export$a48d4501dfd597fa(m));
    return $a4310c0d7cebdf93$export$e5f48e10b9cc01f1(i, v);
}


/**
 * @author Iker Hurtado, Andrey Sobolev
 *
 * @overview Application level utility file
 */ /**
 * @author Iker Hurtado
 *
 * @fileOverview Application configuration file
 */ /**
 * Object storing the configuration
 * @type {Object}
 */ const $e64b414b86723191$export$e2a301f55f143803 = {};
// Default settings
$e64b414b86723191$export$e2a301f55f143803.settings = {
    decimalDigits: 6,
    symmetryThreshold: 1e-5
};
$e64b414b86723191$export$e2a301f55f143803.BASE_FOLDER = ""; // 'static/'  //   
// Species codes
$e64b414b86723191$export$e2a301f55f143803.ELEMENT_NAMES = new Map([
    "H",
    "He",
    "Li",
    "Be",
    "B",
    "C",
    "N",
    "O",
    "F",
    "Ne",
    "Na",
    "Mg",
    "Al",
    "Si",
    "P",
    "S",
    "Cl",
    "Ar",
    "K",
    "Ca",
    "Sc",
    "Ti",
    "V",
    "Cr",
    "Mn",
    "Fe",
    "Co",
    "Ni",
    "Cu",
    "Zn",
    "Ga",
    "Ge",
    "As",
    "Se",
    "Br",
    "Kr",
    "Rb",
    "Sr",
    "Y",
    "Zr",
    "Nb",
    "Mo",
    "Tc",
    "Ru",
    "Rh",
    "Pd",
    "Ag",
    "Cd",
    "In",
    "Sn",
    "Sb",
    "Te",
    "I",
    "Xe",
    "Cs",
    "Ba",
    "La",
    "Ce",
    "Pr",
    "Nd",
    "Pm",
    "Sm",
    "Eu",
    "Gd",
    "Tb",
    "Dy",
    "Ho",
    "Er",
    "Tm",
    "Yb",
    "Lu",
    "Hf",
    "Ta",
    "W",
    "Re",
    "Os",
    "Ir",
    "Pt",
    "Au",
    "Hg",
    "Tl",
    "Pb",
    "Bi",
    "Po",
    "At",
    "Rn",
    "Fr",
    "Ra",
    "Ac",
    "Th",
    "Pa",
    "U",
    "Np",
    "Pu",
    "Am",
    "Cm",
    "Bk",
    "Cf",
    "Es",
    "Fm",
    "Md",
    "No",
    "Lr",
    "Rf",
    "Ha",
    "Sg",
    "Ns",
    "Hs",
    "Mt",
    "Ds",
    "Rg",
    "Cn",
    "Nh",
    "Fl",
    "Mc",
    "Lv",
    "Ts",
    "Og" // Mt = 109
].map((e, i)=>[
        e,
        [
            ...Array(118).keys()
        ][i]
    ]));
// StructureViewer constants
const $e64b414b86723191$var$RADIUS_FACTOR = 0.5;
const $e64b414b86723191$var$MISSING_RADIUS = 0.2;
$e64b414b86723191$export$e2a301f55f143803.ELEMENT_RADII = [
    0.31,
    0.28,
    1.28,
    0.96,
    0.84,
    0.76,
    0.71,
    0.66,
    0.57,
    0.58,
    1.66,
    1.41,
    1.21,
    1.11,
    1.07,
    1.05,
    1.02,
    1.06,
    2.03,
    1.76,
    1.7,
    1.6,
    1.53,
    1.39,
    1.39,
    1.32,
    1.26,
    1.24,
    1.32,
    1.22,
    1.22,
    1.2,
    1.19,
    1.2,
    1.2,
    1.16,
    2.2,
    1.95,
    1.9,
    1.75,
    1.64,
    1.54,
    1.47,
    1.46,
    1.42,
    1.39,
    1.45,
    1.44,
    1.42,
    1.39,
    1.39,
    1.38,
    1.39,
    1.4,
    2.44,
    2.15,
    2.07,
    2.04,
    2.03,
    2.01,
    1.99,
    1.98,
    1.98,
    1.96,
    1.94,
    1.92,
    1.92,
    1.89,
    1.9,
    1.87,
    1.87,
    1.75,
    1.7,
    1.62,
    1.51,
    1.44,
    1.41,
    1.36,
    1.36,
    1.32,
    1.45,
    1.46,
    1.48,
    1.4,
    1.5,
    1.5,
    2.6,
    2.21,
    2.15,
    2.06,
    2.0,
    1.96,
    1.9,
    1.87,
    1.8,
    1.69,
    $e64b414b86723191$var$MISSING_RADIUS,
    $e64b414b86723191$var$MISSING_RADIUS,
    $e64b414b86723191$var$MISSING_RADIUS,
    $e64b414b86723191$var$MISSING_RADIUS,
    $e64b414b86723191$var$MISSING_RADIUS,
    $e64b414b86723191$var$MISSING_RADIUS,
    $e64b414b86723191$var$MISSING_RADIUS
];
const $e64b414b86723191$var$MISSING_COLOR = "#000000";
$e64b414b86723191$export$e2a301f55f143803.ELEMENT_COLORS = [
    "#ffffff",
    "#d9ffff",
    "#cc80ff",
    "#c2ff00",
    "#ffb5b5",
    "#909090",
    "#3050f8",
    "#ff0d0d",
    "#90e050",
    "#b3e3f5",
    "#ab5cf2",
    "#8aff00",
    "#bfa6a6",
    "#f0c8a0",
    "#ff8000",
    "#ffff30",
    "#1ff01f",
    "#80d1e3",
    "#8f40d4",
    "#3dff00",
    "#e6e6e6",
    "#bfc2c7",
    "#a6a6ab",
    "#8a99c7",
    "#9c7ac7",
    "#e06633",
    "#f090a0",
    "#50d050",
    "#c88033",
    "#7d80b0",
    "#c28f8f",
    "#668f8f",
    "#bd80e3",
    "#ffa100",
    "#a62929",
    "#5cb8d1",
    "#702eb0",
    "#00ff00",
    "#94ffff",
    "#94e0e0",
    "#73c2c9",
    "#54b5b5",
    "#3b9e9e",
    "#248f8f",
    "#0a7d8c",
    "#006985",
    "#c0c0c0",
    "#ffd98f",
    "#a67573",
    "#668080",
    "#9e63b5",
    "#d47a00",
    "#940094",
    "#429eb0",
    "#57178f",
    "#00c900",
    "#70d4ff",
    "#ffffc7",
    "#d9ffc7",
    "#c7ffc7",
    "#a3ffc7",
    "#8fffc7",
    "#61ffc7",
    "#45ffc7",
    "#30ffc7",
    "#1fffc7",
    "#00ff9c",
    "#00e675",
    "#00d452",
    "#00bf38",
    "#00ab24",
    "#4dc2ff",
    "#4da6ff",
    "#2194d6",
    "#267dab",
    "#266696",
    "#175487",
    "#d0d0e0",
    "#ffd123",
    "#b8b8d0",
    "#a6544d",
    "#575961",
    "#9e4fb5",
    "#ab5c00",
    "#754f45",
    "#428296",
    "#420066",
    "#007d00",
    "#70abfa",
    "#00baff",
    "#00a1ff",
    "#008fff",
    "#0080ff",
    "#006bff",
    "#545cf2",
    "#785ce3",
    "#8a4fe3",
    "#a136d4",
    "#b31fd4",
    "#b31fba",
    "#b30da6",
    "#bd0d87",
    "#c70066",
    "#cc0059",
    "#d1004f",
    "#d90045",
    "#e00038",
    "#e6002e",
    "#eb0026"
];
// Utility functions related 
/**
 * Returns the species color code
 * @param  {string} species
 * @return {string}
 */ $e64b414b86723191$export$e2a301f55f143803.getSpeciesColor = function(species) {
    //console.log('getSpeciesColor',species, Conf.ELEMENT_NAMES.indexOf(species), Conf.ELEMENT_COLORS[Conf.ELEMENT_NAMES.indexOf(species)]);
    if (species === undefined) return $e64b414b86723191$var$MISSING_COLOR;
    else return $e64b414b86723191$export$e2a301f55f143803.ELEMENT_COLORS[$e64b414b86723191$export$e2a301f55f143803.ELEMENT_NAMES.get(species)];
};
/**
 * Sets a species color code overwriting the original one
 * @param  {string} species
 * @param {string} color
 */ $e64b414b86723191$export$e2a301f55f143803.setSpeciesColor = function(species, color) {
    console.log("setSpeciesColor", species, $e64b414b86723191$export$e2a301f55f143803.ELEMENT_NAMES.get(species), $e64b414b86723191$export$e2a301f55f143803.ELEMENT_COLORS[$e64b414b86723191$export$e2a301f55f143803.ELEMENT_NAMES.indexOf(species)], color);
    $e64b414b86723191$export$e2a301f55f143803.ELEMENT_COLORS[$e64b414b86723191$export$e2a301f55f143803.ELEMENT_NAMES.get(species)] = color;
};
/**
 * Returns the species radius
 * @param  {string} species
 * @return {number}
 */ $e64b414b86723191$export$e2a301f55f143803.getSpeciesRadius = function(species) {
    if (species === undefined) return $e64b414b86723191$var$MISSING_RADIUS;
    else return $e64b414b86723191$export$e2a301f55f143803.ELEMENT_RADII[$e64b414b86723191$export$e2a301f55f143803.ELEMENT_NAMES.get(species)];
};
/**
 * Returns the species radius and color
 * @param  {string} species
 * @return {object}
 */ $e64b414b86723191$export$e2a301f55f143803.getRadiusAndColor = function(species) {
    if (species === undefined) return {
        radius: 0.5,
        color: $e64b414b86723191$var$MISSING_COLOR
    };
    else {
        const index = $e64b414b86723191$export$e2a301f55f143803.ELEMENT_NAMES.get(species);
        return {
            radius: $e64b414b86723191$export$e2a301f55f143803.ELEMENT_RADII[index] * $e64b414b86723191$var$RADIUS_FACTOR,
            color: $e64b414b86723191$export$e2a301f55f143803.ELEMENT_COLORS[index]
        };
    }
};
/**
 * Returns the species atomic number
 * @param  {string} species
 * @return {int}
 */ $e64b414b86723191$export$e2a301f55f143803.getSpeciesAtomicNumber = function(species) {
    return $e64b414b86723191$export$e2a301f55f143803.ELEMENT_NAMES.get(species) + 1;
};




/**
 * @author Iker Hurtado
 *
 * @fileoverview File holding the UserMsgBox UI component
 */ 
/**
 * Text box on the top of the application layout for warning or showing dynamic 
 * and relevant information to the user
 */ class $6ff060c6e60f738f$var$UserMsgBox extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("div", ".UserMsgBox");
    }
    /**
   * Adds an alert div to UserMsgBox
   *
   * @param type {string} An alert type (warning, error)
   * @param msg {string} An alert message
   */ addAlert(type, msg) {
        let alert = document.createElement("div");
        alert.id = Math.floor(Math.random() * Date.now()).toString(16);
        alert.classList.add("alert", type);
        alert.innerHTML = `<span class="alertText">${msg}</span>`;
        this.e.appendChild(alert);
        const timeout = type === "error" ? 5000 : 3000;
        setTimeout(()=>{
            alert.style.display = "none";
            this.e.removeChild(alert);
        }, timeout);
    }
}
/**
 * Creates the application instance (singleton pattern) and adds to the HTML body 
 * @type {UserMsgBox}
 */ const $6ff060c6e60f738f$var$userMsgBox = new $6ff060c6e60f738f$var$UserMsgBox();
document.querySelector("body").appendChild($6ff060c6e60f738f$var$userMsgBox.e);
function $6ff060c6e60f738f$export$ddf018cf7a99d36f(msg) {
    $6ff060c6e60f738f$var$userMsgBox.addAlert("warning", msg);
}
function $6ff060c6e60f738f$export$b8d0bb2aa0adefe5(msg) {
    $6ff060c6e60f738f$var$userMsgBox.addAlert("error", msg);
}


function $4aa0937dc0e8c453$export$f197186eaead7b86(text) {
    // regex: remove several spaces and tabs in a row and split the text in lines
    return text.replace(/[ \t]+/g, " ").split("\n");
}
async function $4aa0937dc0e8c453$export$9d26f8f2be82424f(fileName, type, handler) {
    let data;
    try {
        let response = await fetch((0, $e64b414b86723191$export$e2a301f55f143803).BASE_FOLDER + "data/" + fileName);
        if (type === "text") data = await response.text();
    } catch (err) {
        console.log("loadDataFile error:", err);
    }
    handler(data);
}
function $4aa0937dc0e8c453$export$243c5baa3df6570a(dimArray, sourceStruct) {
    let supercellMatrix = [
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ]
    ];
    if (dimArray.length === 9) for(let i in dimArray)supercellMatrix[Math.floor(i / 3)][i % 3] = parseInt(dimArray[i]);
    else if (dimArray.length === 3) for(let i in dimArray)supercellMatrix[i % 3][i % 3] = parseInt(dimArray[i]);
    const lattice = sourceStruct.latVectors;
    const superLattice = $a4310c0d7cebdf93$export$81b4290faedab233($a4310c0d7cebdf93$export$271d2f969e55c97(supercellMatrix), lattice, [
        ...lattice.map((_)=>[
                0,
                0,
                0
            ])
    ]);
    let fracPoints = $4aa0937dc0e8c453$var$latticePointsInSupercell(supercellMatrix);
    let newStruct = new (0, $495a3b82f25facb5$export$2e2bcd8739ae039)();
    newStruct.fileSource = sourceStruct.fileSource + " (supercell)";
    newStruct.updateLatticeVectors(superLattice, true);
    let points = $a4310c0d7cebdf93$export$81b4290faedab233(fracPoints, superLattice, [
        ...fracPoints.map((_)=>[
                0,
                0,
                0
            ])
    ]);
    for(let p in points)sourceStruct.atoms.forEach((atom)=>{
        let newCart = $a4310c0d7cebdf93$export$e16d8520af44a096(atom.position, points[p]);
        let newFract = newStruct.getFractionalCoordinates(newCart).map((x)=>{
            if (x < 0.) return x + 1.;
            else if (x >= 1.) return x - 1.;
            else return x;
        });
        let newPosition = newStruct.getCartesianCoordinates(newFract);
        newStruct.addAtomData(newPosition, atom.species, false, atom.initMoment, atom.constraint, atom.charge);
    });
    return newStruct;
}
/**
 * Returns all lattice points of the old unit cell within the new supercell.
 * Basically re-written in pymatgen
 * @param  {number[][]} supercellMatrix
 * @return {number[][]}
 */ function $4aa0937dc0e8c453$var$latticePointsInSupercell(supercellMatrix) {
    //
    //
    let diags = [
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            1
        ],
        [
            0,
            1,
            0
        ],
        [
            1,
            0,
            0
        ],
        [
            0,
            1,
            1
        ],
        [
            1,
            0,
            1
        ],
        [
            1,
            1,
            0
        ],
        [
            1,
            1,
            1
        ]
    ];
    let dPoints = [
        ...diags.map((_)=>[
                0,
                0,
                0
            ])
    ]; // Initialize with same size as diags
    $a4310c0d7cebdf93$export$81b4290faedab233(diags, supercellMatrix, dPoints);
    let mins = $a4310c0d7cebdf93$export$9c1b655deaca4988(dPoints, 0, Math.min);
    let maxs = $a4310c0d7cebdf93$export$9c1b655deaca4988(dPoints, 0, Math.max).map((x)=>x + 1);
    let r = [
        [],
        [],
        []
    ];
    for(let i = 0; i < 3; i++)for(let j = mins[i]; j < maxs[i]; j++)r[i].push([
        j
    ]);
    let ar = $a4310c0d7cebdf93$export$ea7769f152fc3675(r[0], [
        [
            1,
            0,
            0
        ]
    ]);
    let br = $a4310c0d7cebdf93$export$ea7769f152fc3675(r[1], [
        [
            0,
            1,
            0
        ]
    ]);
    let cr = $a4310c0d7cebdf93$export$ea7769f152fc3675(r[2], [
        [
            0,
            0,
            1
        ]
    ]);
    let all_points = [];
    for(let i in ar){
        for(let j in br)for(let k in cr)all_points.push($a4310c0d7cebdf93$export$24b4d95b6fbb3080(ar[i], $a4310c0d7cebdf93$export$24b4d95b6fbb3080(br[j], cr[k])));
    }
    let fracPoints = $a4310c0d7cebdf93$export$81b4290faedab233(all_points, $a4310c0d7cebdf93$export$a48d4501dfd597fa(supercellMatrix), [
        ...all_points.map((_)=>[
                0,
                0,
                0
            ])
    ]);
    let result = [];
    for(let i in fracPoints)if (fracPoints[i].every((x)=>x < 1 - 1e-10 && x > -0.0000000001)) result.push(fracPoints[i]);
    console.assert(result.length === $a4310c0d7cebdf93$export$ade607a7db86365e(supercellMatrix), "We are missing some lattice points. Check precision of supercell matrix");
    return result;
}
async function $4aa0937dc0e8c453$export$2f07aec45252693a(slabData, structure) {
    if (!structure.atoms.length) return;
    let sendStructure = {
        cell: structure.latVectors,
        positions: structure.atoms,
        slab_data: slabData,
        fileName: structure.fileSource
    };
    const endPoint = "terminations" in slabData ? "/terminate-slab" : "/get-slab";
    let response = await fetch(endPoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        },
        body: JSON.stringify(sendStructure)
    });
    if (!response.ok) {
        $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("Unknown server ERROR ");
        return;
    }
    const text = await response.text();
    const slab_json = JSON.parse(text);
    let slab_structure = $4aa0937dc0e8c453$export$9fb63025ff3998e0(slab_json);
    // add terminations data to the structure
    slab_structure.extraData["terminations"] = slab_json.terminations;
    return slab_structure;
}
async function $4aa0937dc0e8c453$export$a82e45538f158717(structure) {
    let structureData = undefined;
    if (structure.atoms.length) {
        let sendStructure = {
            cell: structure.latVectors,
            positions: structure.atoms,
            symThresh: (0, $e64b414b86723191$export$e2a301f55f143803).settings.symmetryThreshold
        };
        let response = await fetch("/update-structure-info", {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(sendStructure)
        });
        if (!response.ok) {
            $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("Unknown server ERROR ");
            throw new Error(`HTTP error: ${response.status}`);
        }
        structureData = await response.json();
    }
    return structureData ? structureData.structureInfo : undefined;
}
function $4aa0937dc0e8c453$export$9fb63025ff3998e0(json) {
    const structure = new (0, $495a3b82f25facb5$export$2e2bcd8739ae039)();
    // console.log('getStructureFromJSON', json)
    structure.fileSource = json.fileName;
    structure.structureInfo = json.structureInfo;
    // console.log('structureInfo', json.structureInfo)
    structure.latVectors = json.lattice === null ? undefined : json.lattice;
    json.atoms.forEach((atom)=>{
        structure.addAtomData(atom[0], atom[1], false, atom[3], atom[4], atom[5]); // cartesian coordinates
    });
    return structure;
}
function $4aa0937dc0e8c453$export$8016125d6df85b19(fileName, fileContent) {
    let fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
    let structure;
    if (fileExt === "in") structure = $4aa0937dc0e8c453$export$5b6e940c1562f671(fileContent);
    // else if (fileExt === 'cif')   structure = parseCIFFileFormat(fileContent);
    structure.fileSource = fileName;
    return structure;
}
function $4aa0937dc0e8c453$export$5b6e940c1562f671(text) {
    const VECTOR_KEYWORD = "lattice_vector";
    const ATOM_CART_KEYWORD = "atom";
    const ATOM_FRAC_KEYWORD = "atom_frac";
    const ATOM_INIT_MOMENT_KEYWORD = "initial_moment";
    const ATOM_INIT_CHARGE_KEYWORD = "initial_charge";
    let lines = $4aa0937dc0e8c453$export$f197186eaead7b86(text);
    let structure = new (0, $495a3b82f25facb5$export$2e2bcd8739ae039)();
    // If periodic system
    if (text.indexOf(VECTOR_KEYWORD) >= 0) structure.latVectors = [];
    else structure.latVectors = undefined;
    lines.forEach((line)=>{
        let tokens = line.trim().split(" ");
        if (tokens[0] === VECTOR_KEYWORD) structure.latVectors.push([
            parseFloat(tokens[1]),
            parseFloat(tokens[2]),
            parseFloat(tokens[3])
        ]);
        else if (tokens[0] === ATOM_CART_KEYWORD || tokens[0] === ATOM_FRAC_KEYWORD) {
            let atomPos = [
                parseFloat(tokens[1]),
                parseFloat(tokens[2]),
                parseFloat(tokens[3])
            ];
            structure.addAtomData(atomPos, tokens[4], tokens[0] === ATOM_FRAC_KEYWORD);
        } else if (tokens[0] === ATOM_INIT_MOMENT_KEYWORD) structure.setLastAtomInitMoment(parseFloat(tokens[1]));
        else if (tokens[0] === ATOM_INIT_CHARGE_KEYWORD) structure.setLastAtomCharge(parseFloat(tokens[1]));
    });
    return structure;
}
/**
 * Generates and returns texts in the FHIaims geometry file format from a Structure.
 * It returns two texts: both in cartesian and in fractional coordinates
 * @param  {Structure} structure
 * @return {Array<string>} Two dimension array
 *  [cartesian-coordinates, fractional-coordinates]
 */ function $4aa0937dc0e8c453$var$getGeometryInTexts(structure) {
    //if (structure.latVectors === undefined) return [undefined, undefined]
    let text = "", textFrac = "";
    let decimalDigits = (0, $e64b414b86723191$export$e2a301f55f143803).settings.decimalDigits;
    if (structure.isAPeriodicSystem()) {
        structure.latVectors.forEach((v)=>{
            text += "lattice_vector " + v[0].toFixed(decimalDigits) + " " + v[1].toFixed(decimalDigits) + " " + v[2].toFixed(decimalDigits) + "\n";
        });
        text += "\n";
    }
    textFrac += text;
    structure.atoms.forEach((a)=>{
        if (a !== undefined) {
            //const coors = (isFract ? a.fractPosition : a.position)
            text += "atom " + a.position[0].toFixed(decimalDigits) + " " + a.position[1].toFixed(decimalDigits) + " " + a.position[2].toFixed(decimalDigits) + " " + a.species + "\n";
            text += getRelaxationAndInitMomentText(a);
            if (structure.isAPeriodicSystem()) {
                const fractPosition = structure.getFractionalCoordinates(a.position);
                textFrac += "atom_frac " + fractPosition[0].toFixed(decimalDigits) + " " + fractPosition[1].toFixed(decimalDigits) + " " + fractPosition[2].toFixed(decimalDigits) + " " + a.species + "\n";
                textFrac += getRelaxationAndInitMomentText(a);
            }
        }
    });
    //console.log('getGeometryInTextFile', g, text)
    return [
        text,
        structure.isAPeriodicSystem() ? textFrac : undefined
    ];
    function getRelaxationAndInitMomentText(atom) {
        let text = "";
        if (atom.constraint) text += "    constrain_relaxation .true. \n";
        if (atom.initMoment !== undefined && parseFloat(atom.initMoment) !== 0.0000) text += "    initial_moment " + atom.initMoment + "\n";
        if (atom.charge !== undefined && parseFloat(atom.charge) !== 0.0000) text += "    initial_charge " + atom.charge + "\n";
        return text;
    }
}
/**
 * Generates and returns texts in the Exciting input file format from a Structure.
 * It returns two texts: both in cartesian and in fractional coordinates
 * @param  {Structure} structure
 * @return {Array<string>} Two dimension array
 *  [cartesian-coordinates, fractional-coordinates]
 */ function $4aa0937dc0e8c453$var$getInputXmlTexts(structure) {
    //if (structure.latVectors === undefined) return [undefined, undefined]
    let text = "", textFrac = "";
    let decimalDigits = (0, $e64b414b86723191$export$e2a301f55f143803).settings.decimalDigits;
    if (structure.isAPeriodicSystem()) {
        text += "<crystal>\n";
        structure.latVectors.forEach((v)=>{
            text += "<basevect>" + v[0].toFixed(decimalDigits) + " " + v[1].toFixed(decimalDigits) + " " + v[2].toFixed(decimalDigits) + "</basevect>\n";
        });
        text += "</crystal>\n\n";
    }
    textFrac += text;
    const speciesAtomsMap = new Map();
    structure.atoms.forEach((a)=>{
        if (a !== undefined) {
            if (!speciesAtomsMap.has(a.species)) speciesAtomsMap.set(a.species, []);
            let atoms = speciesAtomsMap.get(a.species);
            atoms.push(a);
        }
    });
    //  log('speciesAtomsMap', speciesAtomsMap)
    speciesAtomsMap.forEach((atoms, species)=>{
        //log('speciesAtomsMap', species, atoms)
        text += '<species speciesfile="' + species + '.xml">\n'; // textFrac +=
        textFrac += '<species speciesfile="' + species + '.xml">\n';
        atoms.forEach((a)=>{
            text += '<atom coord="' + a.position[0].toFixed(decimalDigits) + " " + a.position[1].toFixed(decimalDigits) + " " + a.position[2].toFixed(decimalDigits) + '" />\n';
            if (structure.isAPeriodicSystem()) {
                const fractPosition = structure.getFractionalCoordinates(a.position);
                textFrac += '<atom coord="' + fractPosition[0].toFixed(decimalDigits) + " " + fractPosition[1].toFixed(decimalDigits) + " " + fractPosition[2].toFixed(decimalDigits) + '" />\n';
            }
        });
        //***  the constrain relaxation and initial moment atom values are not included yet
        text += "<species/>\n\n";
        textFrac += "<species/>\n\n";
    });
    // log('text ', text, textFrac)
    return [
        getXmlWrapper(text),
        structure.isAPeriodicSystem() ? getXmlWrapper(textFrac, false) : undefined
    ];
    function getXmlWrapper(structureElement, cartesian = true, title = "Structure generated with elGUI") {
        return `<input>\n\n<title>${title}</title>\n\n` + `<structure speciespath="./" cartesian="${cartesian ? "true" : "false"}">\n\n` + `${structureElement}</structure>\n\n<groundstate></groundstate>\n\n</input>`;
    //'<groundstate rgkmax="7.0d0" ngridk="4 4 4" xctype="GGA_PBE_SOL"></groundstate>\n\n</input>' // Default values
    }
}
function $4aa0937dc0e8c453$export$79b11872a16bdbeb(structure, fhiAims = true) {
    const [inputText, inputTextFrac] = fhiAims ? $4aa0937dc0e8c453$var$getGeometryInTexts(structure) : $4aa0937dc0e8c453$var$getInputXmlTexts(structure);
    return [
        window.URL.createObjectURL(new Blob([
            inputText
        ], {
            type: "text/plain"
        })),
        inputTextFrac === undefined ? undefined : window.URL.createObjectURL(new Blob([
            inputTextFrac
        ], {
            type: "text/plain"
        }))
    ];
}
function $4aa0937dc0e8c453$export$e43df6e0985cf3ba(structure, fhiAims = true) {
    return fhiAims ? $4aa0937dc0e8c453$var$getGeometryInTexts(structure) : $4aa0937dc0e8c453$var$getInputXmlTexts(structure);
}
function $4aa0937dc0e8c453$export$b7d58db314e0ac27(obj) {
    if (typeof obj !== "object") return obj;
    else {
        let newObj = typeof obj === "object" && obj.length !== undefined ? [] : {};
        for(let key in obj)if (key) newObj[key] = $4aa0937dc0e8c453$export$b7d58db314e0ac27(obj[key]);
        return newObj;
    }
}
function $4aa0937dc0e8c453$export$7800b12359c7379e(e) {
    const value = parseInt(e.target.value);
    if (isNaN(value)) e.target.value = "";
    else e.target.value = value;
}
function $4aa0937dc0e8c453$export$68e9a3393520dd2e(e) {
    const value = parseInt(e.target.value);
    if ([
        "0",
        "-"
    ].includes(e.target.value.slice(-1))) ;
    else if (isNaN(value)) e.target.value = "";
    else e.target.value = value;
}
function $4aa0937dc0e8c453$export$3a461cfe4e90e4ad(e) {
    const value = parseFloat(e.target.value);
    if (isNaN(value)) e.target.value = "";
    else e.target.value = value;
}
function $4aa0937dc0e8c453$export$f047cd856756950a(e) {
    const value = parseFloat(e.target.value);
    if ([
        ".",
        "0",
        "-"
    ].includes(e.target.value.slice(-1))) ;
    else if (isNaN(value)) e.target.value = "";
    else e.target.value = value;
}



class $495a3b82f25facb5$export$2e2bcd8739ae039 {
    constructor(){
        this.latVectors = undefined; // Array of arrays (3x3)
        this.atoms = [];
        this.fileSource = "";
        this.structureInfo = {};
        this.extraData = {};
        this.id = undefined;
    }
    /**
   * Reset the structure
   */ reset() {
        this.latVectors = undefined;
        this.atoms = [];
        this.fileSource = undefined;
        this.structureInfo = undefined;
        this.extraData = undefined;
    }
    /**
   * Returns if it's a periodic system or not
   * @return {boolean}
   */ isAPeriodicSystem() {
        //console.log('isAPeriodicSystem',this.latVectors !== undefined, this.latVectors)
        return this.latVectors !== undefined;
    }
    /**
   * Removes the lattice vectors becoming a non-periodic system
   */ removeLatticeVectors() {
        this.latVectors = undefined;
    }
    /**
   * Updates the lattice vectors and scales the atoms positions if specified
   * @param {number[][]} vectors
   * @param {boolean} scaleAtomsPosition This indicates if the atoms positions must be scaled
   */ updateLatticeVectors(vectors, scaleAtomsPosition) {
        // Set or transform a periodic system
        const fractPositions = [];
        if (scaleAtomsPosition) this.atoms.forEach((atom)=>{
            fractPositions.push(this.getFractionalCoordinates(atom.position));
        });
        this.latVectors = vectors;
        if (scaleAtomsPosition) for(let i = 0; i < this.atoms.length; i++)this.atoms[i].position = this.getCartesianCoordinates(fractPositions[i]);
    }
    /**
   * Creates a new atom object (it's not added to the structure)
   * @param {number[]} cartCoords Atom cartesian coordinates
   * @param {string} species
   * @param {number} moment Atom initial moment
   * @param {boolean} constraint
   * @param {number} charge
   * @return {object}
   */ createAtom(cartCoords, species, moment, constraint, charge) {
        return {
            "position": cartCoords,
            "species": species,
            "initMoment": moment,
            "constraint": constraint,
            "charge": charge,
            "radius": (0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesRadius(species)
        };
    }
    /**
   * Creates and add a new atom object
   * @param {number[]} pos Atom cartesian coordinates
   * @param {string} species
   * @param index {number}
   * @param {boolean} isFractional It indicates if the position coordinates are fractional
   * @param {int} moment Atom initial moment
   * @param {boolean} constraint
   * @param charge {number}
   */ addAtomData(pos, species, isFractional = false, moment = 0, constraint = false, charge = 0, index) {
        let cCoors = isFractional ? this.getCartesianCoordinates(pos) : pos;
        let atom = this.createAtom(cCoors, species, moment, constraint, charge);
        if (index === undefined) this.atoms.push(atom);
        else this.atoms.splice(index, 0, atom);
    //console.log('Structure.addAtomData', this.atoms)
    }
    /**
   * Creates an undefined atom.
   * It returns the new atom position in the structure
   * @return {int}
   */ addUndefinedAtom() {
        this.addAtomData([
            0,
            0,
            0
        ], undefined);
        return this.atoms.length - 1;
    }
    /**
   * Updates a structure atom species
   * @param {int} atomIndex Index of the atom  to be updated
   * @param {string} species
   */ updateAtomSpecies(atomIndex, species) {
        this.atoms[atomIndex].species = species;
    }
    /**
   * Updates a structure atom initialization moment
   * @param {int} atomIndex Index of the atom  to be updated
   * @param {int} initMoment
   */ updateAtomInitMoment(atomIndex, initMoment) {
        this.atoms[atomIndex].initMoment = initMoment;
    }
    /**
   * Updates a structure atom constrain
   * @param {int} atomIndex Index of the atom  to be updated
   * @param {int} constraint
   */ updateAtomConstraint(atomIndex, constraint) {
        this.atoms[atomIndex].constraint = constraint;
    }
    updateAtomCharge(atomIndex, charge) {
        this.atoms[atomIndex].charge = charge;
    }
    /**
   * Updates a structure atom position
   * @param {int} atomIndex Index of the atom  to be updated
   * @param {number[]} values
   * @param {boolean} isFract If the values are fractional
   */ updateAtomPosition(atomIndex, values, isFract = false) {
        this.updateAtomCoorValue(atomIndex, 0, values[0], isFract);
        this.updateAtomCoorValue(atomIndex, 1, values[1], isFract);
        this.updateAtomCoorValue(atomIndex, 2, values[2], isFract);
    }
    /**
   * Updates a coordinate of a structure atom
   * If the
   * @param {int} atomIndex Index of the atom to be updated
   * @param {int} coorIndex
   * @param {number} value
   * @param {boolean} isFract If the value is given in fractional
   */ updateAtomCoorValue(atomIndex, coorIndex, value, isFract = false) {
        let atom = this.atoms[atomIndex];
        if (atom === undefined) {
            atom = this.createAtom([
                0,
                0,
                0
            ], undefined, 0, false, 0);
            this.atoms[atomIndex] = atom;
        }
        if (isFract) // console.log('POSSIBLE ERROR HERE')
        atom.position[coorIndex] = this.getCartesianCoordinates(value)[coorIndex];
        else atom.position[coorIndex] = value;
    }
    /**
   * Updates information on this structure
   */ updateInfo() {
        return (0, $4aa0937dc0e8c453$export$a82e45538f158717)(this).then((info)=>this.structureInfo = info);
    }
    /**
   * Sets the initialization moment to the last atom
   * @param {number} moment
   */ setLastAtomInitMoment(moment) {
        //console.log(this.atomPositions.length-1, moment)
        this.atoms[this.atoms.length - 1].initMoment = moment;
    }
    /**
   * Sets the initialization charge to the last atom
   * @param {number} charge
   */ setLastAtomCharge(charge) {
        //console.log(this.atomPositions.length-1, moment)
        this.atoms[this.atoms.length - 1].charge = charge;
    }
    /**
   * Returns the cartesian coordinates corresponding to the
   * fractional coordinates passed as the argument.
   * It behaves as a static method
   * @param {number[]} fractCoors
   * @return {number[]}
   */ getCartesianCoordinates(fractCoors) {
        let cartPos = $a4310c0d7cebdf93$export$c697bed75648cdb7(this.latVectors[0], fractCoors[0]);
        cartPos = $a4310c0d7cebdf93$export$24b4d95b6fbb3080(cartPos, $a4310c0d7cebdf93$export$c697bed75648cdb7(this.latVectors[1], fractCoors[1])); // absPos.add(basisVectors[1].clone().multiplyScalar(position.y));
        cartPos = $a4310c0d7cebdf93$export$24b4d95b6fbb3080(cartPos, $a4310c0d7cebdf93$export$c697bed75648cdb7(this.latVectors[2], fractCoors[2])); // absPos.add(basisVectors[2].clone().multiplyScalar(position.z));
        //console.log('getCartesianCoordinates', cartPos)
        return cartPos;
    }
    /**
   * Finds if the structure is magnetic, that is, if any of initial moments has been set
   * @returns {boolean} Check result
   */ isMagnetic() {
        for (const atom of this.atoms)if (atom.initMoment !== 0) return true;
        return false;
    }
    /**
   * Returns a structure atom fractional coordinates
   * @return {int} i Atom index
   * @return {number[]}
   */ getAtomFractPosition(i) {
        return this.getFractionalCoordinates(this.atoms[i].position);
    }
    /**
   * Returns the fractional coordinates corresponding to the
   * cartesian coordinates passed as the argument.
   * It behaves as a static method
   * @param {number[]} cartCoors
   * @return {number[]}
   */ getFractionalCoordinates(cartCoors) {
        // transform the column format to a regular array
        return this.isAPeriodicSystem() ? $a4310c0d7cebdf93$export$41e3a55430d11464(this.latVectors, cartCoors) : undefined;
    }
}


/**
 * @author Iker Hurtado
 *
 * @fileoverview File holding the main StructureViewer class
 */ // import * as THREE from '../../lib/three.js'
/**
 * @license
 * Copyright 2010-2021 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $0d23c856ce11c301$export$3545e07a80636437 = "130";
const $0d23c856ce11c301$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $0d23c856ce11c301$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $0d23c856ce11c301$export$3237e1f2c1ea1f44 = 0;
const $0d23c856ce11c301$export$b9a7b4fc5cb15f9b = 1;
const $0d23c856ce11c301$export$b8058bcc7037d3f3 = 2;
const $0d23c856ce11c301$export$f24be24dcddeac0d = 3;
const $0d23c856ce11c301$export$346307dbae2b7447 = 0;
const $0d23c856ce11c301$export$5813f879eee7cd88 = 1;
const $0d23c856ce11c301$export$a47c4b43a1be34f0 = 2;
const $0d23c856ce11c301$export$896ae1ade6c829c4 = 3;
const $0d23c856ce11c301$export$2ede184fc2998901 = 0;
const $0d23c856ce11c301$export$d9f0486e75b5ace = 1;
const $0d23c856ce11c301$export$3b296b6f144d5b03 = 2;
const $0d23c856ce11c301$export$a62047d29c96d8ff = 1;
const $0d23c856ce11c301$export$fadb74c06a7f490 = 2;
const $0d23c856ce11c301$export$63b8d6b580fc65ba = 0;
const $0d23c856ce11c301$export$5b29a26d96ee6af0 = 1;
const $0d23c856ce11c301$export$777d8f9551c2216b = 2;
const $0d23c856ce11c301$export$cdfa06f868e2e467 = 3;
const $0d23c856ce11c301$export$4138e1c684b46a20 = 4;
const $0d23c856ce11c301$export$eda4864c68df1fa2 = 5;
const $0d23c856ce11c301$export$20183a0484ce21a0 = 100;
const $0d23c856ce11c301$export$73e0df5177988548 = 101;
const $0d23c856ce11c301$export$28e582859cbec660 = 102;
const $0d23c856ce11c301$export$c8c1508da8d0600c = 103;
const $0d23c856ce11c301$export$99948c02fb51055f = 104;
const $0d23c856ce11c301$export$2110f05edf778d3d = 200;
const $0d23c856ce11c301$export$8805bad65e24940e = 201;
const $0d23c856ce11c301$export$7fbe15b28d28cf52 = 202;
const $0d23c856ce11c301$export$947829af9f2c17f6 = 203;
const $0d23c856ce11c301$export$d5773124e86cf28c = 204;
const $0d23c856ce11c301$export$11d468cc7f19e971 = 205;
const $0d23c856ce11c301$export$a78aed1ca2a87192 = 206;
const $0d23c856ce11c301$export$5d0fe17fd8773bac = 207;
const $0d23c856ce11c301$export$ef5f2dd8ffac5574 = 208;
const $0d23c856ce11c301$export$56b85b2686ab16 = 209;
const $0d23c856ce11c301$export$c05e2a1fc8609506 = 210;
const $0d23c856ce11c301$export$69025ce147cee220 = 0;
const $0d23c856ce11c301$export$7182eb52ea3b3f04 = 1;
const $0d23c856ce11c301$export$eedccec66ab7ebe = 2;
const $0d23c856ce11c301$export$296f78a0b892f81a = 3;
const $0d23c856ce11c301$export$a60d398fc7b7590e = 4;
const $0d23c856ce11c301$export$7d7234c1240a1fc4 = 5;
const $0d23c856ce11c301$export$c5e2c52991f30937 = 6;
const $0d23c856ce11c301$export$2f843afa843d8916 = 7;
const $0d23c856ce11c301$export$e50ac29801f1774d = 0;
const $0d23c856ce11c301$export$9f9d94f963c85479 = 1;
const $0d23c856ce11c301$export$e641dc52bc3494aa = 2;
const $0d23c856ce11c301$export$9fcb6b4294603b2 = 0;
const $0d23c856ce11c301$export$98f52c2a46c598ca = 1;
const $0d23c856ce11c301$export$74b25e54b3bcd548 = 2;
const $0d23c856ce11c301$export$932b3dd283d4a366 = 3;
const $0d23c856ce11c301$export$a0d98fe6d7e4af64 = 4;
const $0d23c856ce11c301$export$2c7b09c1e9abfb5e = 5;
const $0d23c856ce11c301$export$1beec6768cbb3d2d = 300;
const $0d23c856ce11c301$export$8759762a6477f2c4 = 301;
const $0d23c856ce11c301$export$dc59f8aed047f61d = 302;
const $0d23c856ce11c301$export$d64030b316d3b087 = 303;
const $0d23c856ce11c301$export$ee99d97d46898098 = 304;
const $0d23c856ce11c301$export$dbf3e70ff37af79 = 306;
const $0d23c856ce11c301$export$76a9f4355364345c = 307;
const $0d23c856ce11c301$export$533346c8e8dac0f5 = 1000;
const $0d23c856ce11c301$export$9d9334239a5a5e06 = 1001;
const $0d23c856ce11c301$export$c7e7c00b14f51a4f = 1002;
const $0d23c856ce11c301$export$727aa5ec3fe39bf0 = 1003;
const $0d23c856ce11c301$export$d129e38cf6feaa8c = 1004;
const $0d23c856ce11c301$export$14a4936464a36496 = 1004;
const $0d23c856ce11c301$export$d2327c1afe5bfdf2 = 1005;
const $0d23c856ce11c301$export$cbc5b7f5647595d8 = 1005;
const $0d23c856ce11c301$export$8a72f490b25c56c8 = 1006;
const $0d23c856ce11c301$export$19a719f377145a13 = 1007;
const $0d23c856ce11c301$export$dbe96bee3fe9dbf0 = 1007;
const $0d23c856ce11c301$export$5d8599b6a933fb1b = 1008;
const $0d23c856ce11c301$export$90d80f1e3506775f = 1008;
const $0d23c856ce11c301$export$2e8ce08d3f6f5e10 = 1009;
const $0d23c856ce11c301$export$545fce0311a9796a = 1010;
const $0d23c856ce11c301$export$88572337f312435f = 1011;
const $0d23c856ce11c301$export$c63dc51868b06a9d = 1012;
const $0d23c856ce11c301$export$5c612977753abe2 = 1013;
const $0d23c856ce11c301$export$c3c7fc4518ebba96 = 1014;
const $0d23c856ce11c301$export$f6d331659b644596 = 1015;
const $0d23c856ce11c301$export$2697304443f382bc = 1016;
const $0d23c856ce11c301$export$b3969b01faf587f2 = 1017;
const $0d23c856ce11c301$export$18886f8ae33e90de = 1018;
const $0d23c856ce11c301$export$cb1fa50553eb14c4 = 1019;
const $0d23c856ce11c301$export$6c8ea339bfab1301 = 1020;
const $0d23c856ce11c301$export$988473390501ed4b = 1021;
const $0d23c856ce11c301$export$7c67423a5ee6f5eb = 1022;
const $0d23c856ce11c301$export$3f8bb04b555a363c = 1023;
const $0d23c856ce11c301$export$cc09ccbf6d1ed449 = 1024;
const $0d23c856ce11c301$export$9053a81c4a69c289 = 1025;
const $0d23c856ce11c301$export$7f419e36e2229a1d = $0d23c856ce11c301$export$3f8bb04b555a363c;
const $0d23c856ce11c301$export$c1b6b5136be58045 = 1026;
const $0d23c856ce11c301$export$1e113ac2d0905829 = 1027;
const $0d23c856ce11c301$export$4e041a7967d15c4b = 1028;
const $0d23c856ce11c301$export$aa92e870a709d190 = 1029;
const $0d23c856ce11c301$export$6cdf0b461c7ce8a0 = 1030;
const $0d23c856ce11c301$export$1ba1c45f9f77d4d7 = 1031;
const $0d23c856ce11c301$export$d1fd40c11bfa798e = 1032;
const $0d23c856ce11c301$export$c200e7d26f592f21 = 1033;
const $0d23c856ce11c301$export$21d1799c6d552fc0 = 33776;
const $0d23c856ce11c301$export$afa304c3e981b668 = 33777;
const $0d23c856ce11c301$export$d2a1a68024a3e56c = 33778;
const $0d23c856ce11c301$export$9a79c424327dacf9 = 33779;
const $0d23c856ce11c301$export$19ada9bbb1af3573 = 35840;
const $0d23c856ce11c301$export$d0f0355bb3d948e4 = 35841;
const $0d23c856ce11c301$export$b82296714358084c = 35842;
const $0d23c856ce11c301$export$b71692456c47b6c3 = 35843;
const $0d23c856ce11c301$export$6ab91af2d757aee7 = 36196;
const $0d23c856ce11c301$export$7800993ef8106a6a = 37492;
const $0d23c856ce11c301$export$23ed8300a860e7d8 = 37496;
const $0d23c856ce11c301$export$dc5570b4a2b92d48 = 37808;
const $0d23c856ce11c301$export$68880cd325f8b2fb = 37809;
const $0d23c856ce11c301$export$7d2c0be323373d95 = 37810;
const $0d23c856ce11c301$export$22b52da301fc3a3e = 37811;
const $0d23c856ce11c301$export$c009e2cb4a66485e = 37812;
const $0d23c856ce11c301$export$118fff5afa255b63 = 37813;
const $0d23c856ce11c301$export$120713c829ae0667 = 37814;
const $0d23c856ce11c301$export$c79eeabbf53313e9 = 37815;
const $0d23c856ce11c301$export$443cf6567cdd6424 = 37816;
const $0d23c856ce11c301$export$6573984fc9840780 = 37817;
const $0d23c856ce11c301$export$e7aee563f30091de = 37818;
const $0d23c856ce11c301$export$2eb8634622ddeab7 = 37819;
const $0d23c856ce11c301$export$202b1ce7b5d25742 = 37820;
const $0d23c856ce11c301$export$18ab77abd087e467 = 37821;
const $0d23c856ce11c301$export$ce40b115e188bc81 = 36492;
const $0d23c856ce11c301$export$4487000d1baf578b = 37840;
const $0d23c856ce11c301$export$4a1746c7512b1ea1 = 37841;
const $0d23c856ce11c301$export$4208debc782f5653 = 37842;
const $0d23c856ce11c301$export$82c5f9d3037aaea3 = 37843;
const $0d23c856ce11c301$export$64e357a152723eb9 = 37844;
const $0d23c856ce11c301$export$1b7711037f5e380e = 37845;
const $0d23c856ce11c301$export$eb234716dfb52c31 = 37846;
const $0d23c856ce11c301$export$8041d2df79c555f = 37847;
const $0d23c856ce11c301$export$27d2c8c0fcc7b83a = 37848;
const $0d23c856ce11c301$export$27b9de07b84a1334 = 37849;
const $0d23c856ce11c301$export$5c2b31a31ccc15c8 = 37850;
const $0d23c856ce11c301$export$5c4d4b335786f8f3 = 37851;
const $0d23c856ce11c301$export$e0c50c800e38be11 = 37852;
const $0d23c856ce11c301$export$9b0442bae422b2db = 37853;
const $0d23c856ce11c301$export$d62fdc9d1b1cccad = 2200;
const $0d23c856ce11c301$export$dfaf4422ce096e29 = 2201;
const $0d23c856ce11c301$export$f8f6f2041b78e210 = 2202;
const $0d23c856ce11c301$export$995b32462a65e855 = 2300;
const $0d23c856ce11c301$export$30fac1aace31cf4d = 2301;
const $0d23c856ce11c301$export$198b11ff4c72bb30 = 2302;
const $0d23c856ce11c301$export$7f795934b84ab523 = 2400;
const $0d23c856ce11c301$export$24a4ccb5099273b5 = 2401;
const $0d23c856ce11c301$export$8e8c3ecdcd8e1fee = 2402;
const $0d23c856ce11c301$export$bcfbbdcf8de7f8cd = 2500;
const $0d23c856ce11c301$export$d875e029ef558d3 = 2501;
const $0d23c856ce11c301$export$4c28c87c2dc84758 = 0;
const $0d23c856ce11c301$export$b23a071aa286eb29 = 1;
const $0d23c856ce11c301$export$f0d8293634f88842 = 2;
const $0d23c856ce11c301$export$7207336e4151a112 = 3000;
const $0d23c856ce11c301$export$f32388edbb32674 = 3001;
const $0d23c856ce11c301$export$eaab32c1bcea1817 = 3007;
const $0d23c856ce11c301$export$3be4c466a12b5dcf = 3002;
const $0d23c856ce11c301$export$8d4cbbeb1eea9f67 = 3003;
const $0d23c856ce11c301$export$2c4bdfd76b188654 = 3004;
const $0d23c856ce11c301$export$48a0051d6a5a9b9 = 3005;
const $0d23c856ce11c301$export$ca2f89b13b49d951 = 3006;
const $0d23c856ce11c301$export$deeb383078690b50 = 3200;
const $0d23c856ce11c301$export$8f910f4c4f73df11 = 3201;
const $0d23c856ce11c301$export$2852a58ebdac27b8 = 0;
const $0d23c856ce11c301$export$9990ad26f9db5b2c = 1;
const $0d23c856ce11c301$export$69433f11f42d5527 = 0;
const $0d23c856ce11c301$export$9f542ae4b5baca34 = 7680;
const $0d23c856ce11c301$export$8a4f28336ef203d3 = 7681;
const $0d23c856ce11c301$export$2928c0231297c036 = 7682;
const $0d23c856ce11c301$export$c0e9611c8a15f9a8 = 7683;
const $0d23c856ce11c301$export$9c2c08927385dcc4 = 34055;
const $0d23c856ce11c301$export$7c74ea00fa1315e6 = 34056;
const $0d23c856ce11c301$export$22e2e5726612443 = 5386;
const $0d23c856ce11c301$export$1343870698229224 = 512;
const $0d23c856ce11c301$export$8e1d8ed281997fa6 = 513;
const $0d23c856ce11c301$export$55648a1cde8329a7 = 514;
const $0d23c856ce11c301$export$2dff107857e6aca2 = 515;
const $0d23c856ce11c301$export$6f93765ab2f451a2 = 516;
const $0d23c856ce11c301$export$6f3fb2d2440f2b76 = 517;
const $0d23c856ce11c301$export$4119cf7b4c98fd5a = 518;
const $0d23c856ce11c301$export$14cf96713ddd97a8 = 519;
const $0d23c856ce11c301$export$763e8360f4d7f77d = 35044;
const $0d23c856ce11c301$export$8505d14ac8546ca = 35048;
const $0d23c856ce11c301$export$721e63549e51d81e = 35040;
const $0d23c856ce11c301$export$415731dc4f48e299 = 35045;
const $0d23c856ce11c301$export$9e809946455f13bc = 35049;
const $0d23c856ce11c301$export$2ed9499a35b5f832 = 35041;
const $0d23c856ce11c301$export$32ab2503ea19469a = 35046;
const $0d23c856ce11c301$export$ab4022c2c3f86315 = 35050;
const $0d23c856ce11c301$export$ba7f1db36a76a970 = 35042;
const $0d23c856ce11c301$export$43600cc67fabd9f = "100";
const $0d23c856ce11c301$export$f63012db5506e7dd = "300 es";
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $0d23c856ce11c301$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $0d23c856ce11c301$var$_lut = [];
for(let i = 0; i < 256; i++)$0d23c856ce11c301$var$_lut[i] = (i < 16 ? "0" : "") + i.toString(16);
let $0d23c856ce11c301$var$_seed = 1234567;
const $0d23c856ce11c301$var$DEG2RAD = Math.PI / 180;
const $0d23c856ce11c301$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $0d23c856ce11c301$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $0d23c856ce11c301$var$_lut[d0 & 0xff] + $0d23c856ce11c301$var$_lut[d0 >> 8 & 0xff] + $0d23c856ce11c301$var$_lut[d0 >> 16 & 0xff] + $0d23c856ce11c301$var$_lut[d0 >> 24 & 0xff] + "-" + $0d23c856ce11c301$var$_lut[d1 & 0xff] + $0d23c856ce11c301$var$_lut[d1 >> 8 & 0xff] + "-" + $0d23c856ce11c301$var$_lut[d1 >> 16 & 0x0f | 0x40] + $0d23c856ce11c301$var$_lut[d1 >> 24 & 0xff] + "-" + $0d23c856ce11c301$var$_lut[d2 & 0x3f | 0x80] + $0d23c856ce11c301$var$_lut[d2 >> 8 & 0xff] + "-" + $0d23c856ce11c301$var$_lut[d2 >> 16 & 0xff] + $0d23c856ce11c301$var$_lut[d2 >> 24 & 0xff] + $0d23c856ce11c301$var$_lut[d3 & 0xff] + $0d23c856ce11c301$var$_lut[d3 >> 8 & 0xff] + $0d23c856ce11c301$var$_lut[d3 >> 16 & 0xff] + $0d23c856ce11c301$var$_lut[d3 >> 24 & 0xff];
    // .toUpperCase() here flattens concatenated strings to save heap memory space.
    return uuid.toUpperCase();
}
function $0d23c856ce11c301$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidian modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $0d23c856ce11c301$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $0d23c856ce11c301$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $0d23c856ce11c301$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $0d23c856ce11c301$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $0d23c856ce11c301$var$damp(x, y, lambda, dt) {
    return $0d23c856ce11c301$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $0d23c856ce11c301$var$pingpong(x, length = 1) {
    return length - Math.abs($0d23c856ce11c301$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $0d23c856ce11c301$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $0d23c856ce11c301$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $0d23c856ce11c301$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $0d23c856ce11c301$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $0d23c856ce11c301$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $0d23c856ce11c301$var$seededRandom(s) {
    if (s !== undefined) $0d23c856ce11c301$var$_seed = s % 2147483647;
    // Park-Miller algorithm
    $0d23c856ce11c301$var$_seed = $0d23c856ce11c301$var$_seed * 16807 % 2147483647;
    return ($0d23c856ce11c301$var$_seed - 1) / 2147483646;
}
function $0d23c856ce11c301$var$degToRad(degrees) {
    return degrees * $0d23c856ce11c301$var$DEG2RAD;
}
function $0d23c856ce11c301$var$radToDeg(radians) {
    return radians * $0d23c856ce11c301$var$RAD2DEG;
}
function $0d23c856ce11c301$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $0d23c856ce11c301$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $0d23c856ce11c301$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $0d23c856ce11c301$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
var $0d23c856ce11c301$export$380958644dbbc22b = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEG2RAD: $0d23c856ce11c301$var$DEG2RAD,
    RAD2DEG: $0d23c856ce11c301$var$RAD2DEG,
    generateUUID: $0d23c856ce11c301$var$generateUUID,
    clamp: $0d23c856ce11c301$var$clamp,
    euclideanModulo: $0d23c856ce11c301$var$euclideanModulo,
    mapLinear: $0d23c856ce11c301$var$mapLinear,
    inverseLerp: $0d23c856ce11c301$var$inverseLerp,
    lerp: $0d23c856ce11c301$var$lerp,
    damp: $0d23c856ce11c301$var$damp,
    pingpong: $0d23c856ce11c301$var$pingpong,
    smoothstep: $0d23c856ce11c301$var$smoothstep,
    smootherstep: $0d23c856ce11c301$var$smootherstep,
    randInt: $0d23c856ce11c301$var$randInt,
    randFloat: $0d23c856ce11c301$var$randFloat,
    randFloatSpread: $0d23c856ce11c301$var$randFloatSpread,
    seededRandom: $0d23c856ce11c301$var$seededRandom,
    degToRad: $0d23c856ce11c301$var$degToRad,
    radToDeg: $0d23c856ce11c301$var$radToDeg,
    isPowerOfTwo: $0d23c856ce11c301$var$isPowerOfTwo,
    ceilPowerOfTwo: $0d23c856ce11c301$var$ceilPowerOfTwo,
    floorPowerOfTwo: $0d23c856ce11c301$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $0d23c856ce11c301$var$setQuaternionFromProperEuler
});
class $0d23c856ce11c301$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
}
$0d23c856ce11c301$export$c977b3e384af9ae1.prototype.isVector2 = true;
class $0d23c856ce11c301$export$8ff26dafa08918 {
    constructor(){
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    scale(sx, sy) {
        const te = this.elements;
        te[0] *= sx;
        te[3] *= sx;
        te[6] *= sx;
        te[1] *= sy;
        te[4] *= sy;
        te[7] *= sy;
        return this;
    }
    rotate(theta) {
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        const te = this.elements;
        const a11 = te[0], a12 = te[3], a13 = te[6];
        const a21 = te[1], a22 = te[4], a23 = te[7];
        te[0] = c * a11 + s * a21;
        te[3] = c * a12 + s * a22;
        te[6] = c * a13 + s * a23;
        te[1] = -s * a11 + c * a21;
        te[4] = -s * a12 + c * a22;
        te[7] = -s * a13 + c * a23;
        return this;
    }
    translate(tx, ty) {
        const te = this.elements;
        te[0] += tx * te[2];
        te[3] += tx * te[5];
        te[6] += tx * te[8];
        te[1] += ty * te[2];
        te[4] += ty * te[5];
        te[7] += ty * te[8];
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
$0d23c856ce11c301$export$8ff26dafa08918.prototype.isMatrix3 = true;
let $0d23c856ce11c301$var$_canvas;
class $0d23c856ce11c301$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement == "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($0d23c856ce11c301$var$_canvas === undefined) $0d23c856ce11c301$var$_canvas = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
            $0d23c856ce11c301$var$_canvas.width = image.width;
            $0d23c856ce11c301$var$_canvas.height = image.height;
            const context = $0d23c856ce11c301$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $0d23c856ce11c301$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
}
let $0d23c856ce11c301$var$textureId = 0;
class $0d23c856ce11c301$export$5431306cf43de24a extends $0d23c856ce11c301$export$ec8b666c5fe2c75a {
    constructor(image = $0d23c856ce11c301$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $0d23c856ce11c301$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $0d23c856ce11c301$export$9d9334239a5a5e06, wrapT = $0d23c856ce11c301$export$9d9334239a5a5e06, magFilter = $0d23c856ce11c301$export$8a72f490b25c56c8, minFilter = $0d23c856ce11c301$export$5d8599b6a933fb1b, format = $0d23c856ce11c301$export$3f8bb04b555a363c, type = $0d23c856ce11c301$export$2e8ce08d3f6f5e10, anisotropy = 1, encoding = $0d23c856ce11c301$export$7207336e4151a112){
        super();
        Object.defineProperty(this, "id", {
            value: $0d23c856ce11c301$var$textureId++
        });
        this.uuid = $0d23c856ce11c301$var$generateUUID();
        this.name = "";
        this.image = image;
        this.mipmaps = [];
        this.mapping = mapping;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $0d23c856ce11c301$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $0d23c856ce11c301$export$c977b3e384af9ae1(1, 1);
        this.center = new $0d23c856ce11c301$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $0d23c856ce11c301$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
        //
        // Also changing the encoding after already used by a Material will not automatically make the Material
        // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
        this.encoding = encoding;
        this.version = 0;
        this.onUpdate = null;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.image = source.image;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.encoding = source.encoding;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.5,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (this.image !== undefined) {
            // TODO: Move to THREE.Image
            const image = this.image;
            if (image.uuid === undefined) image.uuid = $0d23c856ce11c301$var$generateUUID(); // UGH
            if (!isRootObject && meta.images[image.uuid] === undefined) {
                let url;
                if (Array.isArray(image)) {
                    // process array of images e.g. CubeTexture
                    url = [];
                    for(let i = 0, l = image.length; i < l; i++)// check cube texture with data textures
                    if (image[i].isDataTexture) url.push($0d23c856ce11c301$var$serializeImage(image[i].image));
                    else url.push($0d23c856ce11c301$var$serializeImage(image[i]));
                } else // process single image
                url = $0d23c856ce11c301$var$serializeImage(image);
                meta.images[image.uuid] = {
                    uuid: image.uuid,
                    url: url
                };
            }
            output.image = image.uuid;
        }
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $0d23c856ce11c301$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $0d23c856ce11c301$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $0d23c856ce11c301$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $0d23c856ce11c301$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $0d23c856ce11c301$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $0d23c856ce11c301$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $0d23c856ce11c301$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
$0d23c856ce11c301$export$5431306cf43de24a.DEFAULT_IMAGE = undefined;
$0d23c856ce11c301$export$5431306cf43de24a.DEFAULT_MAPPING = $0d23c856ce11c301$export$1beec6768cbb3d2d;
$0d23c856ce11c301$export$5431306cf43de24a.prototype.isTexture = true;
function $0d23c856ce11c301$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $0d23c856ce11c301$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.prototype.slice.call(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
class $0d23c856ce11c301$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
}
$0d23c856ce11c301$export$fa7daccca11cdbe3.prototype.isVector4 = true;
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $0d23c856ce11c301$export$3c052beb2e51e23f extends $0d23c856ce11c301$export$ec8b666c5fe2c75a {
    constructor(width, height, options = {}){
        super();
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $0d23c856ce11c301$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $0d23c856ce11c301$export$fa7daccca11cdbe3(0, 0, width, height);
        this.texture = new $0d23c856ce11c301$export$5431306cf43de24a(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.image = {
            width: width,
            height: height,
            depth: 1
        };
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $0d23c856ce11c301$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
    }
    setTexture(texture) {
        texture.image = {
            width: this.width,
            height: this.height,
            depth: this.depth
        };
        this.texture = texture;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.image = {
            ...this.texture.image
        }; // See #20328.
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.depthTexture = source.depthTexture;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
$0d23c856ce11c301$export$3c052beb2e51e23f.prototype.isWebGLRenderTarget = true;
class $0d23c856ce11c301$export$bd934554fb721730 extends $0d23c856ce11c301$export$3c052beb2e51e23f {
    constructor(width, height, count){
        super(width, height);
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++)this.texture[i] = texture.clone();
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
        return this;
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.set(0, 0, this.width, this.height);
        this.scissor.set(0, 0, this.width, this.height);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.depthTexture = source.depthTexture;
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++)this.texture[i] = source.texture[i].clone();
        return this;
    }
}
$0d23c856ce11c301$export$bd934554fb721730.prototype.isWebGLMultipleRenderTargets = true;
class $0d23c856ce11c301$export$cb2022643d3c928d extends $0d23c856ce11c301$export$3c052beb2e51e23f {
    constructor(width, height, options){
        super(width, height, options);
        this.samples = 4;
    }
    copy(source) {
        super.copy.call(this, source);
        this.samples = source.samples;
        return this;
    }
}
$0d23c856ce11c301$export$cb2022643d3c928d.prototype.isWebGLMultisampleRenderTarget = true;
class $0d23c856ce11c301$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerp(qa, qb, qm, t) {
        console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead.");
        return qm.slerpQuaternions(qa, qb, t);
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        if (!(euler && euler.isEuler)) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($0d23c856ce11c301$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q, p) {
        if (p !== undefined) {
            console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.");
            return this.multiplyQuaternions(q, p);
        }
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        this.copy(qa).slerp(qb, t);
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
}
$0d23c856ce11c301$export$23d6a54f0bbc85a3.prototype.isQuaternion = true;
class $0d23c856ce11c301$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.");
            return this.multiplyVectors(v, w);
        }
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        if (!(euler && euler.isEuler)) console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.");
        return this.applyQuaternion($0d23c856ce11c301$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($0d23c856ce11c301$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.");
            return this.crossVectors(v, w);
        }
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $0d23c856ce11c301$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($0d23c856ce11c301$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($0d23c856ce11c301$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($0d23c856ce11c301$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
}
$0d23c856ce11c301$export$64b5c384219d3699.prototype.isVector3 = true;
const $0d23c856ce11c301$var$_vector$c = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_quaternion$4 = /*@__PURE__*/ new $0d23c856ce11c301$export$23d6a54f0bbc85a3();
class $0d23c856ce11c301$export$6f7d5a9418ab2aa3 {
    constructor(min = new $0d23c856ce11c301$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $0d23c856ce11c301$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = array.length; i < l; i += 3){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromBufferAttribute(attribute) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = attribute.count; i < l; i++){
            const x = attribute.getX(i);
            const y = attribute.getY(i);
            const z = attribute.getZ(i);
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $0d23c856ce11c301$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object) {
        this.makeEmpty();
        return this.expandByObject(object);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            if (geometry.boundingBox === null) geometry.computeBoundingBox();
            $0d23c856ce11c301$var$_box$3.copy(geometry.boundingBox);
            $0d23c856ce11c301$var$_box$3.applyMatrix4(object.matrixWorld);
            this.union($0d23c856ce11c301$var$_box$3);
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i]);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $0d23c856ce11c301$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $0d23c856ce11c301$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($0d23c856ce11c301$var$_center);
        $0d23c856ce11c301$var$_extents.subVectors(this.max, $0d23c856ce11c301$var$_center);
        // translate triangle to aabb origin
        $0d23c856ce11c301$var$_v0$2.subVectors(triangle.a, $0d23c856ce11c301$var$_center);
        $0d23c856ce11c301$var$_v1$7.subVectors(triangle.b, $0d23c856ce11c301$var$_center);
        $0d23c856ce11c301$var$_v2$3.subVectors(triangle.c, $0d23c856ce11c301$var$_center);
        // compute edge vectors for triangle
        $0d23c856ce11c301$var$_f0.subVectors($0d23c856ce11c301$var$_v1$7, $0d23c856ce11c301$var$_v0$2);
        $0d23c856ce11c301$var$_f1.subVectors($0d23c856ce11c301$var$_v2$3, $0d23c856ce11c301$var$_v1$7);
        $0d23c856ce11c301$var$_f2.subVectors($0d23c856ce11c301$var$_v0$2, $0d23c856ce11c301$var$_v2$3);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$0d23c856ce11c301$var$_f0.z,
            $0d23c856ce11c301$var$_f0.y,
            0,
            -$0d23c856ce11c301$var$_f1.z,
            $0d23c856ce11c301$var$_f1.y,
            0,
            -$0d23c856ce11c301$var$_f2.z,
            $0d23c856ce11c301$var$_f2.y,
            $0d23c856ce11c301$var$_f0.z,
            0,
            -$0d23c856ce11c301$var$_f0.x,
            $0d23c856ce11c301$var$_f1.z,
            0,
            -$0d23c856ce11c301$var$_f1.x,
            $0d23c856ce11c301$var$_f2.z,
            0,
            -$0d23c856ce11c301$var$_f2.x,
            -$0d23c856ce11c301$var$_f0.y,
            $0d23c856ce11c301$var$_f0.x,
            0,
            -$0d23c856ce11c301$var$_f1.y,
            $0d23c856ce11c301$var$_f1.x,
            0,
            -$0d23c856ce11c301$var$_f2.y,
            $0d23c856ce11c301$var$_f2.x,
            0
        ];
        if (!$0d23c856ce11c301$var$satForAxes(axes, $0d23c856ce11c301$var$_v0$2, $0d23c856ce11c301$var$_v1$7, $0d23c856ce11c301$var$_v2$3, $0d23c856ce11c301$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$0d23c856ce11c301$var$satForAxes(axes, $0d23c856ce11c301$var$_v0$2, $0d23c856ce11c301$var$_v1$7, $0d23c856ce11c301$var$_v2$3, $0d23c856ce11c301$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $0d23c856ce11c301$var$_triangleNormal.crossVectors($0d23c856ce11c301$var$_f0, $0d23c856ce11c301$var$_f1);
        axes = [
            $0d23c856ce11c301$var$_triangleNormal.x,
            $0d23c856ce11c301$var$_triangleNormal.y,
            $0d23c856ce11c301$var$_triangleNormal.z
        ];
        return $0d23c856ce11c301$var$satForAxes(axes, $0d23c856ce11c301$var$_v0$2, $0d23c856ce11c301$var$_v1$7, $0d23c856ce11c301$var$_v2$3, $0d23c856ce11c301$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $0d23c856ce11c301$var$_vector$b.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    getBoundingSphere(target) {
        this.getCenter(target.center);
        target.radius = this.getSize($0d23c856ce11c301$var$_vector$b).length() * 0.5;
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $0d23c856ce11c301$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $0d23c856ce11c301$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $0d23c856ce11c301$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $0d23c856ce11c301$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $0d23c856ce11c301$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $0d23c856ce11c301$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $0d23c856ce11c301$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $0d23c856ce11c301$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($0d23c856ce11c301$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
$0d23c856ce11c301$export$6f7d5a9418ab2aa3.prototype.isBox3 = true;
const $0d23c856ce11c301$var$_points = [
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699()
];
const $0d23c856ce11c301$var$_vector$b = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_box$3 = /*@__PURE__*/ new $0d23c856ce11c301$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $0d23c856ce11c301$var$_v0$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_v1$7 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_v2$3 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
// triangle edge vectors
const $0d23c856ce11c301$var$_f0 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_f1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_f2 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_center = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_extents = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_triangleNormal = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_testAxis = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
function $0d23c856ce11c301$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $0d23c856ce11c301$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the seperating axis
        const r = extents.x * Math.abs($0d23c856ce11c301$var$_testAxis.x) + extents.y * Math.abs($0d23c856ce11c301$var$_testAxis.y) + extents.z * Math.abs($0d23c856ce11c301$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the seperating axis
        const p0 = v0.dot($0d23c856ce11c301$var$_testAxis);
        const p1 = v1.dot($0d23c856ce11c301$var$_testAxis);
        const p2 = v2.dot($0d23c856ce11c301$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is seperating and we can exit
        return false;
    }
    return true;
}
const $0d23c856ce11c301$var$_box$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$6f7d5a9418ab2aa3();
const $0d23c856ce11c301$var$_v1$6 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_toFarthestPoint = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_toPoint = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$805e8b72413ccaba {
    constructor(center = new $0d23c856ce11c301$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $0d23c856ce11c301$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L649-L671
        $0d23c856ce11c301$var$_toPoint.subVectors(point, this.center);
        const lengthSq = $0d23c856ce11c301$var$_toPoint.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            const length = Math.sqrt(lengthSq);
            const missingRadiusHalf = (length - this.radius) * 0.5;
            // Nudge this sphere towards the target point. Add half the missing distance to radius,
            // and the other half to position. This gives a tighter enclosure, instead of if
            // the whole missing distance were just added to radius.
            this.center.add($0d23c856ce11c301$var$_toPoint.multiplyScalar(missingRadiusHalf / length));
            this.radius += missingRadiusHalf;
        }
        return this;
    }
    union(sphere) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L759-L769
        // To enclose another sphere into this sphere, we only need to enclose two points:
        // 1) Enclose the farthest point on the other sphere into this sphere.
        // 2) Enclose the opposite point of the farthest point into this sphere.
        $0d23c856ce11c301$var$_toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
        this.expandByPoint($0d23c856ce11c301$var$_v1$6.copy(sphere.center).add($0d23c856ce11c301$var$_toFarthestPoint));
        this.expandByPoint($0d23c856ce11c301$var$_v1$6.copy(sphere.center).sub($0d23c856ce11c301$var$_toFarthestPoint));
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0d23c856ce11c301$var$_vector$a = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_segCenter = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_segDir = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_diff = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_edge1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_edge2 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_normal$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$a186db52eed6d40e {
    constructor(origin = new $0d23c856ce11c301$export$64b5c384219d3699(), direction = new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $0d23c856ce11c301$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $0d23c856ce11c301$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $0d23c856ce11c301$var$_vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
        return $0d23c856ce11c301$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $0d23c856ce11c301$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $0d23c856ce11c301$var$_segDir.copy(v1).sub(v0).normalize();
        $0d23c856ce11c301$var$_diff.copy(this.origin).sub($0d23c856ce11c301$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($0d23c856ce11c301$var$_segDir);
        const b0 = $0d23c856ce11c301$var$_diff.dot(this.direction);
        const b1 = -$0d23c856ce11c301$var$_diff.dot($0d23c856ce11c301$var$_segDir);
        const c = $0d23c856ce11c301$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($0d23c856ce11c301$var$_segDir).multiplyScalar(s1).add($0d23c856ce11c301$var$_segCenter);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $0d23c856ce11c301$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $0d23c856ce11c301$var$_vector$a.dot(this.direction);
        const d2 = $0d23c856ce11c301$var$_vector$a.dot($0d23c856ce11c301$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if both t0 and t1 are behind the ray - if so, return null
        if (t0 < 0 && t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        // These lines also handle the case where tmin or tmax is NaN
        // (result of 0 * Infinity). x !== x returns true if x is NaN
        if (tymin > tmin || tmin !== tmin) tmin = tymin;
        if (tymax < tmax || tmax !== tmax) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $0d23c856ce11c301$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $0d23c856ce11c301$var$_edge1.subVectors(b, a);
        $0d23c856ce11c301$var$_edge2.subVectors(c, a);
        $0d23c856ce11c301$var$_normal$1.crossVectors($0d23c856ce11c301$var$_edge1, $0d23c856ce11c301$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($0d23c856ce11c301$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $0d23c856ce11c301$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($0d23c856ce11c301$var$_edge2.crossVectors($0d23c856ce11c301$var$_diff, $0d23c856ce11c301$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($0d23c856ce11c301$var$_edge1.cross($0d23c856ce11c301$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $0d23c856ce11c301$var$_diff.dot($0d23c856ce11c301$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $0d23c856ce11c301$export$2ae72fc923e5eb5 {
    constructor(){
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $0d23c856ce11c301$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $0d23c856ce11c301$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $0d23c856ce11c301$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $0d23c856ce11c301$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        if (!(euler && euler.isEuler)) console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($0d23c856ce11c301$var$_zero, q, $0d23c856ce11c301$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $0d23c856ce11c301$var$_z.subVectors(eye, target);
        if ($0d23c856ce11c301$var$_z.lengthSq() === 0) // eye and target are in the same position
        $0d23c856ce11c301$var$_z.z = 1;
        $0d23c856ce11c301$var$_z.normalize();
        $0d23c856ce11c301$var$_x.crossVectors(up, $0d23c856ce11c301$var$_z);
        if ($0d23c856ce11c301$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $0d23c856ce11c301$var$_z.x += 0.0001;
            else $0d23c856ce11c301$var$_z.z += 0.0001;
            $0d23c856ce11c301$var$_z.normalize();
            $0d23c856ce11c301$var$_x.crossVectors(up, $0d23c856ce11c301$var$_z);
        }
        $0d23c856ce11c301$var$_x.normalize();
        $0d23c856ce11c301$var$_y.crossVectors($0d23c856ce11c301$var$_z, $0d23c856ce11c301$var$_x);
        te[0] = $0d23c856ce11c301$var$_x.x;
        te[4] = $0d23c856ce11c301$var$_y.x;
        te[8] = $0d23c856ce11c301$var$_z.x;
        te[1] = $0d23c856ce11c301$var$_x.y;
        te[5] = $0d23c856ce11c301$var$_y.y;
        te[9] = $0d23c856ce11c301$var$_z.y;
        te[2] = $0d23c856ce11c301$var$_x.z;
        te[6] = $0d23c856ce11c301$var$_y.z;
        te[10] = $0d23c856ce11c301$var$_z.z;
        return this;
    }
    multiply(m, n) {
        if (n !== undefined) {
            console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.");
            return this.multiplyMatrices(m, n);
        }
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $0d23c856ce11c301$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $0d23c856ce11c301$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $0d23c856ce11c301$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $0d23c856ce11c301$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $0d23c856ce11c301$var$_m1$2.elements[0] *= invSX;
        $0d23c856ce11c301$var$_m1$2.elements[1] *= invSX;
        $0d23c856ce11c301$var$_m1$2.elements[2] *= invSX;
        $0d23c856ce11c301$var$_m1$2.elements[4] *= invSY;
        $0d23c856ce11c301$var$_m1$2.elements[5] *= invSY;
        $0d23c856ce11c301$var$_m1$2.elements[6] *= invSY;
        $0d23c856ce11c301$var$_m1$2.elements[8] *= invSZ;
        $0d23c856ce11c301$var$_m1$2.elements[9] *= invSZ;
        $0d23c856ce11c301$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($0d23c856ce11c301$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        if (far === undefined) console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
const $0d23c856ce11c301$var$_v1$5 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_m1$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_zero = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, 0);
const $0d23c856ce11c301$var$_one = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(1, 1, 1);
const $0d23c856ce11c301$var$_x = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_y = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_z = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_matrix$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_quaternion$3 = /*@__PURE__*/ new $0d23c856ce11c301$export$23d6a54f0bbc85a3();
class $0d23c856ce11c301$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $0d23c856ce11c301$export$d93cc409a0768c5f.DefaultOrder){
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($0d23c856ce11c301$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$0d23c856ce11c301$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($0d23c856ce11c301$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$0d23c856ce11c301$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($0d23c856ce11c301$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$0d23c856ce11c301$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $0d23c856ce11c301$var$_matrix$1.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($0d23c856ce11c301$var$_matrix$1, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $0d23c856ce11c301$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($0d23c856ce11c301$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    toVector3(optionalResult) {
        if (optionalResult) return optionalResult.set(this._x, this._y, this._z);
        else return new $0d23c856ce11c301$export$64b5c384219d3699(this._x, this._y, this._z);
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
}
$0d23c856ce11c301$export$d93cc409a0768c5f.prototype.isEuler = true;
$0d23c856ce11c301$export$d93cc409a0768c5f.DefaultOrder = "XYZ";
$0d23c856ce11c301$export$d93cc409a0768c5f.RotationOrders = [
    "XYZ",
    "YZX",
    "ZXY",
    "XZY",
    "YXZ",
    "ZYX"
];
class $0d23c856ce11c301$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = 1 << channel | 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
}
let $0d23c856ce11c301$var$_object3DId = 0;
const $0d23c856ce11c301$var$_v1$4 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_q1 = /*@__PURE__*/ new $0d23c856ce11c301$export$23d6a54f0bbc85a3();
const $0d23c856ce11c301$var$_m1$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_target = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_position$3 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_scale$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_quaternion$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$23d6a54f0bbc85a3();
const $0d23c856ce11c301$var$_xAxis = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(1, 0, 0);
const $0d23c856ce11c301$var$_yAxis = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(0, 1, 0);
const $0d23c856ce11c301$var$_zAxis = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, 1);
const $0d23c856ce11c301$var$_addedEvent = {
    type: "added"
};
const $0d23c856ce11c301$var$_removedEvent = {
    type: "removed"
};
class $0d23c856ce11c301$export$e4dd07dff30cc924 extends $0d23c856ce11c301$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        Object.defineProperty(this, "id", {
            value: $0d23c856ce11c301$var$_object3DId++
        });
        this.uuid = $0d23c856ce11c301$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $0d23c856ce11c301$export$e4dd07dff30cc924.DefaultUp.clone();
        const position = new $0d23c856ce11c301$export$64b5c384219d3699();
        const rotation = new $0d23c856ce11c301$export$d93cc409a0768c5f();
        const quaternion = new $0d23c856ce11c301$export$23d6a54f0bbc85a3();
        const scale = new $0d23c856ce11c301$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $0d23c856ce11c301$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $0d23c856ce11c301$export$8ff26dafa08918()
            }
        });
        this.matrix = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
        this.matrixWorld = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $0d23c856ce11c301$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate;
        this.matrixWorldNeedsUpdate = false;
        this.layers = new $0d23c856ce11c301$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $0d23c856ce11c301$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($0d23c856ce11c301$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $0d23c856ce11c301$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($0d23c856ce11c301$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($0d23c856ce11c301$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($0d23c856ce11c301$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($0d23c856ce11c301$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $0d23c856ce11c301$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($0d23c856ce11c301$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($0d23c856ce11c301$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($0d23c856ce11c301$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($0d23c856ce11c301$var$_zAxis, distance);
    }
    localToWorld(vector) {
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        return vector.applyMatrix4($0d23c856ce11c301$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $0d23c856ce11c301$var$_target.copy(x);
        else $0d23c856ce11c301$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $0d23c856ce11c301$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $0d23c856ce11c301$var$_m1$1.lookAt($0d23c856ce11c301$var$_position$3, $0d23c856ce11c301$var$_target, this.up);
        else $0d23c856ce11c301$var$_m1$1.lookAt($0d23c856ce11c301$var$_target, $0d23c856ce11c301$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($0d23c856ce11c301$var$_m1$1);
        if (parent) {
            $0d23c856ce11c301$var$_m1$1.extractRotation(parent.matrixWorld);
            $0d23c856ce11c301$var$_q1.setFromRotationMatrix($0d23c856ce11c301$var$_m1$1);
            this.quaternion.premultiply($0d23c856ce11c301$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($0d23c856ce11c301$var$_addedEvent);
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($0d23c856ce11c301$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($0d23c856ce11c301$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        this.updateWorldMatrix(true, false);
        $0d23c856ce11c301$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $0d23c856ce11c301$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($0d23c856ce11c301$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($0d23c856ce11c301$var$_position$3, target, $0d23c856ce11c301$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($0d23c856ce11c301$var$_position$3, $0d23c856ce11c301$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(force);
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateWorldMatrix(false, true);
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {}
            };
            output.metadata = {
                version: 4.5,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (JSON.stringify(this.userData) !== "{}") object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$0d23c856ce11c301$export$e4dd07dff30cc924.DefaultUp = new $0d23c856ce11c301$export$64b5c384219d3699(0, 1, 0);
$0d23c856ce11c301$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate = true;
$0d23c856ce11c301$export$e4dd07dff30cc924.prototype.isObject3D = true;
const $0d23c856ce11c301$var$_v0$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_v1$3 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_v2$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_v3$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vab = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vac = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vbc = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vap = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vbp = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vcp = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$5a465592bfe74b48 {
    constructor(a = new $0d23c856ce11c301$export$64b5c384219d3699(), b = new $0d23c856ce11c301$export$64b5c384219d3699(), c = new $0d23c856ce11c301$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $0d23c856ce11c301$var$_v0$1.subVectors(a, b);
        target.cross($0d23c856ce11c301$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $0d23c856ce11c301$var$_v0$1.subVectors(c, a);
        $0d23c856ce11c301$var$_v1$3.subVectors(b, a);
        $0d23c856ce11c301$var$_v2$2.subVectors(point, a);
        const dot00 = $0d23c856ce11c301$var$_v0$1.dot($0d23c856ce11c301$var$_v0$1);
        const dot01 = $0d23c856ce11c301$var$_v0$1.dot($0d23c856ce11c301$var$_v1$3);
        const dot02 = $0d23c856ce11c301$var$_v0$1.dot($0d23c856ce11c301$var$_v2$2);
        const dot11 = $0d23c856ce11c301$var$_v1$3.dot($0d23c856ce11c301$var$_v1$3);
        const dot12 = $0d23c856ce11c301$var$_v1$3.dot($0d23c856ce11c301$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $0d23c856ce11c301$var$_v3$1);
        return $0d23c856ce11c301$var$_v3$1.x >= 0 && $0d23c856ce11c301$var$_v3$1.y >= 0 && $0d23c856ce11c301$var$_v3$1.x + $0d23c856ce11c301$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        this.getBarycoord(point, p1, p2, p3, $0d23c856ce11c301$var$_v3$1);
        target.set(0, 0);
        target.addScaledVector(uv1, $0d23c856ce11c301$var$_v3$1.x);
        target.addScaledVector(uv2, $0d23c856ce11c301$var$_v3$1.y);
        target.addScaledVector(uv3, $0d23c856ce11c301$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $0d23c856ce11c301$var$_v0$1.subVectors(c, b);
        $0d23c856ce11c301$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $0d23c856ce11c301$var$_v0$1.cross($0d23c856ce11c301$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $0d23c856ce11c301$var$_v0$1.subVectors(this.c, this.b);
        $0d23c856ce11c301$var$_v1$3.subVectors(this.a, this.b);
        return $0d23c856ce11c301$var$_v0$1.cross($0d23c856ce11c301$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $0d23c856ce11c301$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $0d23c856ce11c301$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        return $0d23c856ce11c301$export$5a465592bfe74b48.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    containsPoint(point) {
        return $0d23c856ce11c301$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $0d23c856ce11c301$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $0d23c856ce11c301$var$_vab.subVectors(b, a);
        $0d23c856ce11c301$var$_vac.subVectors(c, a);
        $0d23c856ce11c301$var$_vap.subVectors(p, a);
        const d1 = $0d23c856ce11c301$var$_vab.dot($0d23c856ce11c301$var$_vap);
        const d2 = $0d23c856ce11c301$var$_vac.dot($0d23c856ce11c301$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $0d23c856ce11c301$var$_vbp.subVectors(p, b);
        const d3 = $0d23c856ce11c301$var$_vab.dot($0d23c856ce11c301$var$_vbp);
        const d4 = $0d23c856ce11c301$var$_vac.dot($0d23c856ce11c301$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($0d23c856ce11c301$var$_vab, v);
        }
        $0d23c856ce11c301$var$_vcp.subVectors(p, c);
        const d5 = $0d23c856ce11c301$var$_vab.dot($0d23c856ce11c301$var$_vcp);
        const d6 = $0d23c856ce11c301$var$_vac.dot($0d23c856ce11c301$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($0d23c856ce11c301$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $0d23c856ce11c301$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($0d23c856ce11c301$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($0d23c856ce11c301$var$_vab, v).addScaledVector($0d23c856ce11c301$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $0d23c856ce11c301$var$materialId = 0;
class $0d23c856ce11c301$export$a2d8b23205c25948 extends $0d23c856ce11c301$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        Object.defineProperty(this, "id", {
            value: $0d23c856ce11c301$var$materialId++
        });
        this.uuid = $0d23c856ce11c301$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.fog = true;
        this.blending = $0d23c856ce11c301$export$5b29a26d96ee6af0;
        this.side = $0d23c856ce11c301$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.blendSrc = $0d23c856ce11c301$export$d5773124e86cf28c;
        this.blendDst = $0d23c856ce11c301$export$11d468cc7f19e971;
        this.blendEquation = $0d23c856ce11c301$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $0d23c856ce11c301$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $0d23c856ce11c301$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $0d23c856ce11c301$export$9f542ae4b5baca34;
        this.stencilZFail = $0d23c856ce11c301$export$9f542ae4b5baca34;
        this.stencilZPass = $0d23c856ce11c301$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaTest = 0;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
    }
    onBuild() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn("THREE.Material: '" + key + "' parameter is undefined.");
                continue;
            }
            // for backward compatability if shading is set in the constructor
            if (key === "shading") {
                console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
                this.flatShading = newValue === $0d23c856ce11c301$export$a62047d29c96d8ff ? true : false;
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn("THREE." + this.type + ": '" + key + "' is not a property of this material.");
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRoot = meta === undefined || typeof meta === "string";
        if (isRoot) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.5,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen && this.sheen.isColor) data.sheen = this.sheen.getHex();
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $0d23c856ce11c301$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $0d23c856ce11c301$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.morphTargets === true) data.morphTargets = true;
        if (this.morphNormals === true) data.morphNormals = true;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (JSON.stringify(this.userData) !== "{}") data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.fog = source.fog;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
$0d23c856ce11c301$export$a2d8b23205c25948.prototype.isMaterial = true;
const $0d23c856ce11c301$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $0d23c856ce11c301$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $0d23c856ce11c301$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $0d23c856ce11c301$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
function $0d23c856ce11c301$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $0d23c856ce11c301$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
class $0d23c856ce11c301$export$892596cec99bc70e {
    constructor(r, g, b){
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === "number") this.setHex(value);
        else if (typeof value === "string") this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        return this;
    }
    setRGB(r, g, b) {
        this.r = r;
        this.g = g;
        this.b = b;
        return this;
    }
    setHSL(h, s, l) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $0d23c856ce11c301$var$euclideanModulo(h, 1);
        s = $0d23c856ce11c301$var$clamp(s, 0, 1);
        l = $0d23c856ce11c301$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $0d23c856ce11c301$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $0d23c856ce11c301$var$hue2rgb(q, p, h);
            this.b = $0d23c856ce11c301$var$hue2rgb(q, p, h - 1 / 3);
        }
        return this;
    }
    setStyle(style) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        handleAlpha(color[4]);
                        return this;
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        handleAlpha(color[4]);
                        return this;
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        const h = parseFloat(color[1]) / 360;
                        const s = parseInt(color[2], 10) / 100;
                        const l = parseInt(color[3], 10) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l);
                    }
                    break;
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) {
                // #ff0
                this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                return this;
            } else if (size === 6) {
                // #ff0000
                this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                return this;
            }
        }
        if (style && style.length > 0) return this.setColorName(style);
        return this;
    }
    setColorName(style) {
        // color keywords
        const hex = $0d23c856ce11c301$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copyGammaToLinear(color, gammaFactor = 2.0) {
        this.r = Math.pow(color.r, gammaFactor);
        this.g = Math.pow(color.g, gammaFactor);
        this.b = Math.pow(color.b, gammaFactor);
        return this;
    }
    copyLinearToGamma(color, gammaFactor = 2.0) {
        const safeInverse = gammaFactor > 0 ? 1.0 / gammaFactor : 1.0;
        this.r = Math.pow(color.r, safeInverse);
        this.g = Math.pow(color.g, safeInverse);
        this.b = Math.pow(color.b, safeInverse);
        return this;
    }
    convertGammaToLinear(gammaFactor) {
        this.copyGammaToLinear(this, gammaFactor);
        return this;
    }
    convertLinearToGamma(gammaFactor) {
        this.copyLinearToGamma(this, gammaFactor);
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $0d23c856ce11c301$var$SRGBToLinear(color.r);
        this.g = $0d23c856ce11c301$var$SRGBToLinear(color.g);
        this.b = $0d23c856ce11c301$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $0d23c856ce11c301$var$LinearToSRGB(color.r);
        this.g = $0d23c856ce11c301$var$LinearToSRGB(color.g);
        this.b = $0d23c856ce11c301$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex() {
        return this.r * 255 << 16 ^ this.g * 255 << 8 ^ this.b * 255 << 0;
    }
    getHexString() {
        return ("000000" + this.getHex().toString(16)).slice(-6);
    }
    getHSL(target) {
        // h,s,l ranges are in 0.0 - 1.0
        const r = this.r, g = this.g, b = this.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getStyle() {
        return "rgb(" + (this.r * 255 | 0) + "," + (this.g * 255 | 0) + "," + (this.b * 255 | 0) + ")";
    }
    offsetHSL(h, s, l) {
        this.getHSL($0d23c856ce11c301$var$_hslA);
        $0d23c856ce11c301$var$_hslA.h += h;
        $0d23c856ce11c301$var$_hslA.s += s;
        $0d23c856ce11c301$var$_hslA.l += l;
        this.setHSL($0d23c856ce11c301$var$_hslA.h, $0d23c856ce11c301$var$_hslA.s, $0d23c856ce11c301$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($0d23c856ce11c301$var$_hslA);
        color.getHSL($0d23c856ce11c301$var$_hslB);
        const h = $0d23c856ce11c301$var$lerp($0d23c856ce11c301$var$_hslA.h, $0d23c856ce11c301$var$_hslB.h, alpha);
        const s = $0d23c856ce11c301$var$lerp($0d23c856ce11c301$var$_hslA.s, $0d23c856ce11c301$var$_hslB.s, alpha);
        const l = $0d23c856ce11c301$var$lerp($0d23c856ce11c301$var$_hslA.l, $0d23c856ce11c301$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        if (attribute.normalized === true) {
            // assuming Uint8Array
            this.r /= 255;
            this.g /= 255;
            this.b /= 255;
        }
        return this;
    }
    toJSON() {
        return this.getHex();
    }
}
$0d23c856ce11c301$export$892596cec99bc70e.NAMES = $0d23c856ce11c301$var$_colorKeywords;
$0d23c856ce11c301$export$892596cec99bc70e.prototype.isColor = true;
$0d23c856ce11c301$export$892596cec99bc70e.prototype.r = 1;
$0d23c856ce11c301$export$892596cec99bc70e.prototype.g = 1;
$0d23c856ce11c301$export$892596cec99bc70e.prototype.b = 1;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>
 * }
 */ class $0d23c856ce11c301$export$55cbcc9b622fe1f5 extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshBasicMaterial";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $0d23c856ce11c301$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.morphTargets = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.morphTargets = source.morphTargets;
        return this;
    }
}
$0d23c856ce11c301$export$55cbcc9b622fe1f5.prototype.isMeshBasicMaterial = true;
const $0d23c856ce11c301$var$_vector$9 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vector2$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$c977b3e384af9ae1();
class $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized === true;
        this.usage = $0d23c856ce11c301$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    copyColorsArray(colors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = colors.length; i < l; i++){
            let color = colors[i];
            if (color === undefined) {
                console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", i);
                color = new $0d23c856ce11c301$export$892596cec99bc70e();
            }
            array[offset++] = color.r;
            array[offset++] = color.g;
            array[offset++] = color.b;
        }
        return this;
    }
    copyVector2sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", i);
                vector = new $0d23c856ce11c301$export$c977b3e384af9ae1();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
        }
        return this;
    }
    copyVector3sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", i);
                vector = new $0d23c856ce11c301$export$64b5c384219d3699();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
        }
        return this;
    }
    copyVector4sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", i);
                vector = new $0d23c856ce11c301$export$fa7daccca11cdbe3();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
            array[offset++] = vector.w;
        }
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $0d23c856ce11c301$var$_vector2$1.fromBufferAttribute(this, i);
            $0d23c856ce11c301$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $0d23c856ce11c301$var$_vector2$1.x, $0d23c856ce11c301$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $0d23c856ce11c301$var$_vector$9.fromBufferAttribute(this, i);
            $0d23c856ce11c301$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $0d23c856ce11c301$var$_vector$9.x, $0d23c856ce11c301$var$_vector$9.y, $0d23c856ce11c301$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0d23c856ce11c301$var$_vector$9.x = this.getX(i);
            $0d23c856ce11c301$var$_vector$9.y = this.getY(i);
            $0d23c856ce11c301$var$_vector$9.z = this.getZ(i);
            $0d23c856ce11c301$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $0d23c856ce11c301$var$_vector$9.x, $0d23c856ce11c301$var$_vector$9.y, $0d23c856ce11c301$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0d23c856ce11c301$var$_vector$9.x = this.getX(i);
            $0d23c856ce11c301$var$_vector$9.y = this.getY(i);
            $0d23c856ce11c301$var$_vector$9.z = this.getZ(i);
            $0d23c856ce11c301$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $0d23c856ce11c301$var$_vector$9.x, $0d23c856ce11c301$var$_vector$9.y, $0d23c856ce11c301$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0d23c856ce11c301$var$_vector$9.x = this.getX(i);
            $0d23c856ce11c301$var$_vector$9.y = this.getY(i);
            $0d23c856ce11c301$var$_vector$9.z = this.getZ(i);
            $0d23c856ce11c301$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $0d23c856ce11c301$var$_vector$9.x, $0d23c856ce11c301$var$_vector$9.y, $0d23c856ce11c301$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    getX(index) {
        return this.array[index * this.itemSize];
    }
    setX(index, x) {
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        return this.array[index * this.itemSize + 1];
    }
    setY(index, y) {
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        return this.array[index * this.itemSize + 2];
    }
    setZ(index, z) {
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        return this.array[index * this.itemSize + 3];
    }
    setW(index, w) {
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.prototype.slice.call(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $0d23c856ce11c301$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
}
$0d23c856ce11c301$export$8dea267bd6bde117.prototype.isBufferAttribute = true;
//
class $0d23c856ce11c301$export$f9ff2d6a20248cbf extends $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $0d23c856ce11c301$export$cacc90cf35d11cdd extends $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $0d23c856ce11c301$export$baaa85a1a812c157 extends $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $0d23c856ce11c301$export$2b755a102ccdcefe extends $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $0d23c856ce11c301$export$640a853f68025f2e extends $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $0d23c856ce11c301$export$46b369aed2968a0a extends $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $0d23c856ce11c301$export$7eb8c9fa25cd5bd6 extends $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $0d23c856ce11c301$export$dbd3698c64958d69 extends $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
$0d23c856ce11c301$export$dbd3698c64958d69.prototype.isFloat16BufferAttribute = true;
class $0d23c856ce11c301$export$cbe7a62641830ebd extends $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $0d23c856ce11c301$export$9e0ade74842adbb8 extends $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
function $0d23c856ce11c301$var$arrayMax(array) {
    if (array.length === 0) return -Infinity;
    let max = array[0];
    for(let i = 1, l = array.length; i < l; ++i)if (array[i] > max) max = array[i];
    return max;
}
const $0d23c856ce11c301$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $0d23c856ce11c301$var$getTypedArray(type, buffer) {
    return new $0d23c856ce11c301$var$TYPED_ARRAYS[type](buffer);
}
let $0d23c856ce11c301$var$_id = 0;
const $0d23c856ce11c301$var$_m1 = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_obj = /*@__PURE__*/ new $0d23c856ce11c301$export$e4dd07dff30cc924();
const $0d23c856ce11c301$var$_offset = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_box$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$6f7d5a9418ab2aa3();
const $0d23c856ce11c301$var$_boxMorphTargets = /*@__PURE__*/ new $0d23c856ce11c301$export$6f7d5a9418ab2aa3();
const $0d23c856ce11c301$var$_vector$8 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$b7be63a67df8959 extends $0d23c856ce11c301$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        Object.defineProperty(this, "id", {
            value: $0d23c856ce11c301$var$_id++
        });
        this.uuid = $0d23c856ce11c301$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($0d23c856ce11c301$var$arrayMax(index) > 65535 ? $0d23c856ce11c301$export$7eb8c9fa25cd5bd6 : $0d23c856ce11c301$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $0d23c856ce11c301$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $0d23c856ce11c301$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($0d23c856ce11c301$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $0d23c856ce11c301$var$_m1.makeRotationX(angle);
        this.applyMatrix4($0d23c856ce11c301$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $0d23c856ce11c301$var$_m1.makeRotationY(angle);
        this.applyMatrix4($0d23c856ce11c301$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $0d23c856ce11c301$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($0d23c856ce11c301$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $0d23c856ce11c301$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($0d23c856ce11c301$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $0d23c856ce11c301$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($0d23c856ce11c301$var$_m1);
        return this;
    }
    lookAt(vector) {
        $0d23c856ce11c301$var$_obj.lookAt(vector);
        $0d23c856ce11c301$var$_obj.updateMatrix();
        this.applyMatrix4($0d23c856ce11c301$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($0d23c856ce11c301$var$_offset).negate();
        this.translate($0d23c856ce11c301$var$_offset.x, $0d23c856ce11c301$var$_offset.y, $0d23c856ce11c301$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $0d23c856ce11c301$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $0d23c856ce11c301$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $0d23c856ce11c301$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $0d23c856ce11c301$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $0d23c856ce11c301$var$_vector$8.addVectors(this.boundingBox.min, $0d23c856ce11c301$var$_box$1.min);
                    this.boundingBox.expandByPoint($0d23c856ce11c301$var$_vector$8);
                    $0d23c856ce11c301$var$_vector$8.addVectors(this.boundingBox.max, $0d23c856ce11c301$var$_box$1.max);
                    this.boundingBox.expandByPoint($0d23c856ce11c301$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($0d23c856ce11c301$var$_box$1.min);
                    this.boundingBox.expandByPoint($0d23c856ce11c301$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $0d23c856ce11c301$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $0d23c856ce11c301$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $0d23c856ce11c301$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $0d23c856ce11c301$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $0d23c856ce11c301$var$_vector$8.addVectors($0d23c856ce11c301$var$_box$1.min, $0d23c856ce11c301$var$_boxMorphTargets.min);
                    $0d23c856ce11c301$var$_box$1.expandByPoint($0d23c856ce11c301$var$_vector$8);
                    $0d23c856ce11c301$var$_vector$8.addVectors($0d23c856ce11c301$var$_box$1.max, $0d23c856ce11c301$var$_boxMorphTargets.max);
                    $0d23c856ce11c301$var$_box$1.expandByPoint($0d23c856ce11c301$var$_vector$8);
                } else {
                    $0d23c856ce11c301$var$_box$1.expandByPoint($0d23c856ce11c301$var$_boxMorphTargets.min);
                    $0d23c856ce11c301$var$_box$1.expandByPoint($0d23c856ce11c301$var$_boxMorphTargets.max);
                }
            }
            $0d23c856ce11c301$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $0d23c856ce11c301$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($0d23c856ce11c301$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $0d23c856ce11c301$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $0d23c856ce11c301$var$_offset.fromBufferAttribute(position, j);
                        $0d23c856ce11c301$var$_vector$8.add($0d23c856ce11c301$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($0d23c856ce11c301$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeFaceNormals() {
    // backwards compatibility
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (attributes.tangent === undefined) this.setAttribute("tangent", new $0d23c856ce11c301$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = attributes.tangent.array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $0d23c856ce11c301$export$64b5c384219d3699();
            tan2[i] = new $0d23c856ce11c301$export$64b5c384219d3699();
        }
        const vA = new $0d23c856ce11c301$export$64b5c384219d3699(), vB = new $0d23c856ce11c301$export$64b5c384219d3699(), vC = new $0d23c856ce11c301$export$64b5c384219d3699(), uvA = new $0d23c856ce11c301$export$c977b3e384af9ae1(), uvB = new $0d23c856ce11c301$export$c977b3e384af9ae1(), uvC = new $0d23c856ce11c301$export$c977b3e384af9ae1(), sdir = new $0d23c856ce11c301$export$64b5c384219d3699(), tdir = new $0d23c856ce11c301$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $0d23c856ce11c301$export$64b5c384219d3699(), tmp2 = new $0d23c856ce11c301$export$64b5c384219d3699();
        const n = new $0d23c856ce11c301$export$64b5c384219d3699(), n2 = new $0d23c856ce11c301$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $0d23c856ce11c301$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $0d23c856ce11c301$export$64b5c384219d3699(), pB = new $0d23c856ce11c301$export$64b5c384219d3699(), pC = new $0d23c856ce11c301$export$64b5c384219d3699();
            const nA = new $0d23c856ce11c301$export$64b5c384219d3699(), nB = new $0d23c856ce11c301$export$64b5c384219d3699(), nC = new $0d23c856ce11c301$export$64b5c384219d3699();
            const cb = new $0d23c856ce11c301$export$64b5c384219d3699(), ab = new $0d23c856ce11c301$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    merge(geometry, offset) {
        if (!(geometry && geometry.isBufferGeometry)) {
            console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", geometry);
            return;
        }
        if (offset === undefined) {
            offset = 0;
            console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge.");
        }
        const attributes = this.attributes;
        for(const key in attributes){
            if (geometry.attributes[key] === undefined) continue;
            const attribute1 = attributes[key];
            const attributeArray1 = attribute1.array;
            const attribute2 = geometry.attributes[key];
            const attributeArray2 = attribute2.array;
            const attributeOffset = attribute2.itemSize * offset;
            const length = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
            for(let i = 0, j = attributeOffset; i < length; i++, j++)attributeArray1[j] = attributeArray2[i];
        }
        return this;
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $0d23c856ce11c301$var$_vector$8.fromBufferAttribute(normals, i);
            $0d23c856ce11c301$var$_vector$8.normalize();
            normals.setXYZ(i, $0d23c856ce11c301$var$_vector$8.x, $0d23c856ce11c301$var$_vector$8.y, $0d23c856ce11c301$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $0d23c856ce11c301$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $0d23c856ce11c301$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        /*
		 // Handle primitives

		 const parameters = this.parameters;

		 if ( parameters !== undefined ) {

		 const values = [];

		 for ( const key in parameters ) {

		 values.push( parameters[ key ] );

		 }

		 const geometry = Object.create( this.constructor.prototype );
		 this.constructor.apply( geometry, values );
		 return geometry;

		 }

		 return new this.constructor().copy( this );
		 */ return new $0d23c856ce11c301$export$b7be63a67df8959().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
$0d23c856ce11c301$export$b7be63a67df8959.prototype.isBufferGeometry = true;
const $0d23c856ce11c301$var$_inverseMatrix$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_ray$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$a186db52eed6d40e();
const $0d23c856ce11c301$var$_sphere$3 = /*@__PURE__*/ new $0d23c856ce11c301$export$805e8b72413ccaba();
const $0d23c856ce11c301$var$_vA$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vB$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vC$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_tempA = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_tempB = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_tempC = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_morphA = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_morphB = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_morphC = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_uvA$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$c977b3e384af9ae1();
const $0d23c856ce11c301$var$_uvB$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$c977b3e384af9ae1();
const $0d23c856ce11c301$var$_uvC$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$c977b3e384af9ae1();
const $0d23c856ce11c301$var$_intersectionPoint = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_intersectionPointWorld = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$e176487c05830cc5 extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(geometry = new $0d23c856ce11c301$export$b7be63a67df8959(), material = new $0d23c856ce11c301$export$55cbcc9b622fe1f5()){
        super();
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source) {
        super.copy(source);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error("THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0d23c856ce11c301$var$_sphere$3.copy(geometry.boundingSphere);
        $0d23c856ce11c301$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($0d23c856ce11c301$var$_sphere$3) === false) return;
        //
        $0d23c856ce11c301$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $0d23c856ce11c301$var$_ray$2.copy(raycaster.ray).applyMatrix4($0d23c856ce11c301$var$_inverseMatrix$2);
        // Check boundingBox before continuing
        if (geometry.boundingBox !== null) {
            if ($0d23c856ce11c301$var$_ray$2.intersectsBox(geometry.boundingBox) === false) return;
        }
        let intersection;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const position = geometry.attributes.position;
            const morphPosition = geometry.morphAttributes.position;
            const morphTargetsRelative = geometry.morphTargetsRelative;
            const uv = geometry.attributes.uv;
            const uv2 = geometry.attributes.uv2;
            const groups = geometry.groups;
            const drawRange = geometry.drawRange;
            if (index !== null) {
                // indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = index.getX(j);
                        const b = index.getX(j + 1);
                        const c = index.getX(j + 2);
                        intersection = $0d23c856ce11c301$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $0d23c856ce11c301$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(index.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = index.getX(i);
                        const b = index.getX(i + 1);
                        const c = index.getX(i + 2);
                        intersection = $0d23c856ce11c301$var$checkBufferGeometryIntersection(this, material, raycaster, $0d23c856ce11c301$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            } else if (position !== undefined) {
                // non-indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = j;
                        const b = j + 1;
                        const c = j + 2;
                        intersection = $0d23c856ce11c301$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $0d23c856ce11c301$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(position.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = i;
                        const b = i + 1;
                        const c = i + 2;
                        intersection = $0d23c856ce11c301$var$checkBufferGeometryIntersection(this, material, raycaster, $0d23c856ce11c301$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            }
        } else if (geometry.isGeometry) console.error("THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
}
$0d23c856ce11c301$export$e176487c05830cc5.prototype.isMesh = true;
function $0d23c856ce11c301$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side !== $0d23c856ce11c301$export$3b296b6f144d5b03, point);
    if (intersect === null) return null;
    $0d23c856ce11c301$var$_intersectionPointWorld.copy(point);
    $0d23c856ce11c301$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($0d23c856ce11c301$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $0d23c856ce11c301$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $0d23c856ce11c301$var$checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
    $0d23c856ce11c301$var$_vA$1.fromBufferAttribute(position, a);
    $0d23c856ce11c301$var$_vB$1.fromBufferAttribute(position, b);
    $0d23c856ce11c301$var$_vC$1.fromBufferAttribute(position, c);
    const morphInfluences = object.morphTargetInfluences;
    if (material.morphTargets && morphPosition && morphInfluences) {
        $0d23c856ce11c301$var$_morphA.set(0, 0, 0);
        $0d23c856ce11c301$var$_morphB.set(0, 0, 0);
        $0d23c856ce11c301$var$_morphC.set(0, 0, 0);
        for(let i = 0, il = morphPosition.length; i < il; i++){
            const influence = morphInfluences[i];
            const morphAttribute = morphPosition[i];
            if (influence === 0) continue;
            $0d23c856ce11c301$var$_tempA.fromBufferAttribute(morphAttribute, a);
            $0d23c856ce11c301$var$_tempB.fromBufferAttribute(morphAttribute, b);
            $0d23c856ce11c301$var$_tempC.fromBufferAttribute(morphAttribute, c);
            if (morphTargetsRelative) {
                $0d23c856ce11c301$var$_morphA.addScaledVector($0d23c856ce11c301$var$_tempA, influence);
                $0d23c856ce11c301$var$_morphB.addScaledVector($0d23c856ce11c301$var$_tempB, influence);
                $0d23c856ce11c301$var$_morphC.addScaledVector($0d23c856ce11c301$var$_tempC, influence);
            } else {
                $0d23c856ce11c301$var$_morphA.addScaledVector($0d23c856ce11c301$var$_tempA.sub($0d23c856ce11c301$var$_vA$1), influence);
                $0d23c856ce11c301$var$_morphB.addScaledVector($0d23c856ce11c301$var$_tempB.sub($0d23c856ce11c301$var$_vB$1), influence);
                $0d23c856ce11c301$var$_morphC.addScaledVector($0d23c856ce11c301$var$_tempC.sub($0d23c856ce11c301$var$_vC$1), influence);
            }
        }
        $0d23c856ce11c301$var$_vA$1.add($0d23c856ce11c301$var$_morphA);
        $0d23c856ce11c301$var$_vB$1.add($0d23c856ce11c301$var$_morphB);
        $0d23c856ce11c301$var$_vC$1.add($0d23c856ce11c301$var$_morphC);
    }
    if (object.isSkinnedMesh) {
        object.boneTransform(a, $0d23c856ce11c301$var$_vA$1);
        object.boneTransform(b, $0d23c856ce11c301$var$_vB$1);
        object.boneTransform(c, $0d23c856ce11c301$var$_vC$1);
    }
    const intersection = $0d23c856ce11c301$var$checkIntersection(object, material, raycaster, ray, $0d23c856ce11c301$var$_vA$1, $0d23c856ce11c301$var$_vB$1, $0d23c856ce11c301$var$_vC$1, $0d23c856ce11c301$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $0d23c856ce11c301$var$_uvA$1.fromBufferAttribute(uv, a);
            $0d23c856ce11c301$var$_uvB$1.fromBufferAttribute(uv, b);
            $0d23c856ce11c301$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $0d23c856ce11c301$export$5a465592bfe74b48.getUV($0d23c856ce11c301$var$_intersectionPoint, $0d23c856ce11c301$var$_vA$1, $0d23c856ce11c301$var$_vB$1, $0d23c856ce11c301$var$_vC$1, $0d23c856ce11c301$var$_uvA$1, $0d23c856ce11c301$var$_uvB$1, $0d23c856ce11c301$var$_uvC$1, new $0d23c856ce11c301$export$c977b3e384af9ae1());
        }
        if (uv2) {
            $0d23c856ce11c301$var$_uvA$1.fromBufferAttribute(uv2, a);
            $0d23c856ce11c301$var$_uvB$1.fromBufferAttribute(uv2, b);
            $0d23c856ce11c301$var$_uvC$1.fromBufferAttribute(uv2, c);
            intersection.uv2 = $0d23c856ce11c301$export$5a465592bfe74b48.getUV($0d23c856ce11c301$var$_intersectionPoint, $0d23c856ce11c301$var$_vA$1, $0d23c856ce11c301$var$_vB$1, $0d23c856ce11c301$var$_vC$1, $0d23c856ce11c301$var$_uvA$1, $0d23c856ce11c301$var$_uvB$1, $0d23c856ce11c301$var$_uvC$1, new $0d23c856ce11c301$export$c977b3e384af9ae1());
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $0d23c856ce11c301$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $0d23c856ce11c301$export$5a465592bfe74b48.getNormal($0d23c856ce11c301$var$_vA$1, $0d23c856ce11c301$var$_vB$1, $0d23c856ce11c301$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $0d23c856ce11c301$export$ab3456a079aa7d80 extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $0d23c856ce11c301$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$ab3456a079aa7d80(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $0d23c856ce11c301$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) dst[u][p] = property.clone();
            else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $0d23c856ce11c301$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $0d23c856ce11c301$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
// Legacy
const $0d23c856ce11c301$export$d8ecdf8615bfea69 = {
    clone: $0d23c856ce11c301$var$cloneUniforms,
    merge: $0d23c856ce11c301$var$mergeUniforms
};
var $0d23c856ce11c301$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $0d23c856ce11c301$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * parameters = {
 *  defines: { "label" : "value" },
 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
 *
 *  fragmentShader: <string>,
 *  vertexShader: <string>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  lights: <bool>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ class $0d23c856ce11c301$export$83c7d75d550a8b0d extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.vertexShader = $0d23c856ce11c301$var$default_vertex;
        this.fragmentShader = $0d23c856ce11c301$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.morphTargets = false; // set to use morph targets
        this.morphNormals = false; // set to use morph normals
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv2": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) {
            if (parameters.attributes !== undefined) console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.");
            this.setValues(parameters);
        }
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $0d23c856ce11c301$var$cloneUniforms(source.uniforms);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
$0d23c856ce11c301$export$83c7d75d550a8b0d.prototype.isShaderMaterial = true;
class $0d23c856ce11c301$export$79f141de891a5fed extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Camera";
        this.matrixWorldInverse = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
$0d23c856ce11c301$export$79f141de891a5fed.prototype.isCamera = true;
class $0d23c856ce11c301$export$74e4ae24825f68d7 extends $0d23c856ce11c301$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $0d23c856ce11c301$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($0d23c856ce11c301$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $0d23c856ce11c301$var$RAD2DEG * 2 * Math.atan(Math.tan($0d23c856ce11c301$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($0d23c856ce11c301$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
$0d23c856ce11c301$export$74e4ae24825f68d7.prototype.isPerspectiveCamera = true;
const $0d23c856ce11c301$var$fov = 90, $0d23c856ce11c301$var$aspect = 1;
class $0d23c856ce11c301$export$d0cdd0bd804995de extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        if (renderTarget.isWebGLCubeRenderTarget !== true) {
            console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.");
            return;
        }
        this.renderTarget = renderTarget;
        const cameraPX = new $0d23c856ce11c301$export$74e4ae24825f68d7($0d23c856ce11c301$var$fov, $0d23c856ce11c301$var$aspect, near, far);
        cameraPX.layers = this.layers;
        cameraPX.up.set(0, -1, 0);
        cameraPX.lookAt(new $0d23c856ce11c301$export$64b5c384219d3699(1, 0, 0));
        this.add(cameraPX);
        const cameraNX = new $0d23c856ce11c301$export$74e4ae24825f68d7($0d23c856ce11c301$var$fov, $0d23c856ce11c301$var$aspect, near, far);
        cameraNX.layers = this.layers;
        cameraNX.up.set(0, -1, 0);
        cameraNX.lookAt(new $0d23c856ce11c301$export$64b5c384219d3699(-1, 0, 0));
        this.add(cameraNX);
        const cameraPY = new $0d23c856ce11c301$export$74e4ae24825f68d7($0d23c856ce11c301$var$fov, $0d23c856ce11c301$var$aspect, near, far);
        cameraPY.layers = this.layers;
        cameraPY.up.set(0, 0, 1);
        cameraPY.lookAt(new $0d23c856ce11c301$export$64b5c384219d3699(0, 1, 0));
        this.add(cameraPY);
        const cameraNY = new $0d23c856ce11c301$export$74e4ae24825f68d7($0d23c856ce11c301$var$fov, $0d23c856ce11c301$var$aspect, near, far);
        cameraNY.layers = this.layers;
        cameraNY.up.set(0, 0, -1);
        cameraNY.lookAt(new $0d23c856ce11c301$export$64b5c384219d3699(0, -1, 0));
        this.add(cameraNY);
        const cameraPZ = new $0d23c856ce11c301$export$74e4ae24825f68d7($0d23c856ce11c301$var$fov, $0d23c856ce11c301$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        cameraPZ.up.set(0, -1, 0);
        cameraPZ.lookAt(new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, 1));
        this.add(cameraPZ);
        const cameraNZ = new $0d23c856ce11c301$export$74e4ae24825f68d7($0d23c856ce11c301$var$fov, $0d23c856ce11c301$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        cameraNZ.up.set(0, -1, 0);
        cameraNZ.lookAt(new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, -1));
        this.add(cameraNZ);
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentXrEnabled = renderer.xr.enabled;
        const currentRenderTarget = renderer.getRenderTarget();
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.xr.enabled = currentXrEnabled;
    }
}
class $0d23c856ce11c301$export$ee2e5a18258a4049 extends $0d23c856ce11c301$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $0d23c856ce11c301$export$8759762a6477f2c4;
        format = format !== undefined ? format : $0d23c856ce11c301$export$7c67423a5ee6f5eb;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        // Why CubeTexture._needsFlipEnvMap is necessary:
        //
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag _needsFlipEnvMap controls this conversion. The flip is not required (and thus _needsFlipEnvMap is set to false)
        // when using WebGLCubeRenderTarget.texture as a cube texture.
        this._needsFlipEnvMap = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
$0d23c856ce11c301$export$ee2e5a18258a4049.prototype.isCubeTexture = true;
class $0d23c856ce11c301$export$ac386671d651941e extends $0d23c856ce11c301$export$3c052beb2e51e23f {
    constructor(size, options, dummy){
        if (Number.isInteger(options)) {
            console.warn("THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )");
            options = dummy;
        }
        super(size, size, options);
        options = options || {};
        this.texture = new $0d23c856ce11c301$export$ee2e5a18258a4049(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $0d23c856ce11c301$export$8a72f490b25c56c8;
        this.texture._needsFlipEnvMap = false;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.format = $0d23c856ce11c301$export$3f8bb04b555a363c; // see #18859
        this.texture.encoding = texture.encoding;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $0d23c856ce11c301$export$ab3456a079aa7d80(5, 5, 5);
        const material = new $0d23c856ce11c301$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $0d23c856ce11c301$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $0d23c856ce11c301$export$d9f0486e75b5ace,
            blending: $0d23c856ce11c301$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $0d23c856ce11c301$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $0d23c856ce11c301$export$5d8599b6a933fb1b) texture.minFilter = $0d23c856ce11c301$export$8a72f490b25c56c8;
        const camera = new $0d23c856ce11c301$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
$0d23c856ce11c301$export$ac386671d651941e.prototype.isWebGLCubeRenderTarget = true;
const $0d23c856ce11c301$var$_vector1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vector2 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_normalMatrix = /*@__PURE__*/ new $0d23c856ce11c301$export$8ff26dafa08918();
class $0d23c856ce11c301$export$7ff5ac152ef991b0 {
    constructor(normal = new $0d23c856ce11c301$export$64b5c384219d3699(1, 0, 0), constant = 0){
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $0d23c856ce11c301$var$_vector1.subVectors(c, b).cross($0d23c856ce11c301$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
    }
    intersectLine(line, target) {
        const direction = line.delta($0d23c856ce11c301$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(direction).multiplyScalar(t).add(line.start);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $0d23c856ce11c301$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($0d23c856ce11c301$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
$0d23c856ce11c301$export$7ff5ac152ef991b0.prototype.isPlane = true;
const $0d23c856ce11c301$var$_sphere$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$805e8b72413ccaba();
const $0d23c856ce11c301$var$_vector$7 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$35efe6f4c85463d2 {
    constructor(p0 = new $0d23c856ce11c301$export$7ff5ac152ef991b0(), p1 = new $0d23c856ce11c301$export$7ff5ac152ef991b0(), p2 = new $0d23c856ce11c301$export$7ff5ac152ef991b0(), p3 = new $0d23c856ce11c301$export$7ff5ac152ef991b0(), p4 = new $0d23c856ce11c301$export$7ff5ac152ef991b0(), p5 = new $0d23c856ce11c301$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        return this;
    }
    intersectsObject(object) {
        const geometry = object.geometry;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0d23c856ce11c301$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        return this.intersectsSphere($0d23c856ce11c301$var$_sphere$2);
    }
    intersectsSprite(sprite) {
        $0d23c856ce11c301$var$_sphere$2.center.set(0, 0, 0);
        $0d23c856ce11c301$var$_sphere$2.radius = 0.7071067811865476;
        $0d23c856ce11c301$var$_sphere$2.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($0d23c856ce11c301$var$_sphere$2);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $0d23c856ce11c301$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $0d23c856ce11c301$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $0d23c856ce11c301$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($0d23c856ce11c301$var$_vector$7) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $0d23c856ce11c301$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $0d23c856ce11c301$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type = 5126;
        if (array instanceof Float32Array) type = 5126;
        else if (array instanceof Float64Array) console.warn("THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.");
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = 5131;
                else console.warn("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else type = 5123;
        } else if (array instanceof Int16Array) type = 5122;
        else if (array instanceof Uint32Array) type = 5125;
        else if (array instanceof Int32Array) type = 5124;
        else if (array instanceof Int8Array) type = 5120;
        else if (array instanceof Uint8Array) type = 5121;
        else if (array instanceof Uint8ClampedArray) type = 5121;
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $0d23c856ce11c301$export$e789a11a194ca4e0 extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$e789a11a194ca4e0(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $0d23c856ce11c301$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var $0d23c856ce11c301$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $0d23c856ce11c301$var$alphatest_fragment = "#ifdef ALPHATEST\n	if ( diffuseColor.a < ALPHATEST ) discard;\n#endif";
var $0d23c856ce11c301$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n	#endif\n#endif";
var $0d23c856ce11c301$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $0d23c856ce11c301$var$begin_vertex = "vec3 transformed = vec3( position );";
var $0d23c856ce11c301$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $0d23c856ce11c301$var$bsdfs = "vec2 integrateSpecularBRDF( const in float dotNV, const in float roughness ) {\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	return vec2( -1.04, 1.04 ) * a004 + r.zw;\n}\nfloat punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n	if( cutoffDistance > 0.0 ) {\n		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n	}\n	return distanceFalloff;\n#else\n	if( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n		return pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n	}\n	return 1.0;\n#endif\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotVH ) {\n	float fresnel = exp2( ( -5.55473 * dotVH - 6.98316 ) * dotVH );\n	return ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nvec3 F_Schlick_RoughnessDependent( const in vec3 F0, const in float dotNV, const in float roughness ) {\n	float fresnel = exp2( ( -5.55473 * dotNV - 6.98316 ) * dotNV );\n	vec3 Fr = max( vec3( 1.0 - roughness ), F0 ) - F0;\n	return Fr * fresnel + F0;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	float gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	return 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( incidentLight.direction + viewDir );\n	float dotNL = saturate( dot( normal, incidentLight.direction ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n	vec3 F = F_Schlick( specularColor, dotLH );\n	float G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n	float D = D_GGX( alpha, dotNH );\n	return F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\nvec3 BRDF_Specular_GGX_Environment( const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	vec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n	return specularColor * brdf.x + brdf.y;\n}\nvoid BRDF_Specular_Multiscattering_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n	float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n	vec3 F = F_Schlick_RoughnessDependent( specularColor, dotNV, roughness );\n	vec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n	vec3 FssEss = F * brdf.x + brdf.y;\n	float Ess = brdf.x + brdf.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\nfloat G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n	float dotNH = saturate( dot( geometry.normal, halfDir ) );\n	float dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n	vec3 F = F_Schlick( specularColor, dotLH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n	return ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n	return sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie(float roughness, float NoH) {\n	float invAlpha = 1.0 / roughness;\n	float cos2h = NoH * NoH;\n	float sin2h = max(1.0 - cos2h, 0.0078125);	return (2.0 + invAlpha) * pow(sin2h, invAlpha * 0.5) / (2.0 * PI);\n}\nfloat V_Neubelt(float NoV, float NoL) {\n	return saturate(1.0 / (4.0 * (NoL + NoV - NoL * NoV)));\n}\nvec3 BRDF_Specular_Sheen( const in float roughness, const in vec3 L, const in GeometricContext geometry, vec3 specularColor ) {\n	vec3 N = geometry.normal;\n	vec3 V = geometry.viewDir;\n	vec3 H = normalize( V + L );\n	float dotNH = saturate( dot( N, H ) );\n	return specularColor * D_Charlie( roughness, dotNH ) * V_Neubelt( dot(N, V), dot(N, L) );\n}\n#endif";
var $0d23c856ce11c301$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vUv );\n		vec2 dSTdy = dFdy( vUv );\n		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n		vec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $0d23c856ce11c301$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var $0d23c856ce11c301$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $0d23c856ce11c301$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $0d23c856ce11c301$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $0d23c856ce11c301$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $0d23c856ce11c301$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $0d23c856ce11c301$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var $0d23c856ce11c301$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var $0d23c856ce11c301$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract(sin(sn) * c);\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float max3( vec3 v ) { return max( max( v.x, v.y ), v.z ); }\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n	float distance = dot( planeNormal, point - pointOnPlane );\n	return - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n	return sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n	return lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n	vec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n	return dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}";
var $0d23c856ce11c301$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_maxMipLevel 8.0\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_maxTileSize 256.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		float texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n		vec2 uv = getUV( direction, face ) * ( faceSize - 1.0 );\n		vec2 f = fract( uv );\n		uv += 0.5 - f;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		if ( mipInt < cubeUV_maxMipLevel ) {\n			uv.y += 2.0 * cubeUV_maxTileSize;\n		}\n		uv.y += filterInt * 2.0 * cubeUV_minTileSize;\n		uv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n		uv *= texelSize;\n		vec3 tl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		uv.x += texelSize;\n		vec3 tr = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		uv.y += texelSize;\n		vec3 br = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		uv.x -= texelSize;\n		vec3 bl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		vec3 tm = mix( tl, tr, f.x );\n		vec3 bm = mix( bl, br, f.x );\n		return mix( tm, bm, f.y );\n	}\n	#define r0 1.0\n	#define v0 0.339\n	#define m0 - 2.0\n	#define r1 0.8\n	#define v1 0.276\n	#define m1 - 1.0\n	#define r4 0.4\n	#define v4 0.046\n	#define m4 2.0\n	#define r5 0.305\n	#define v5 0.016\n	#define m5 3.0\n	#define r6 0.21\n	#define v6 0.0038\n	#define m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= r1 ) {\n			mip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n		} else if ( roughness >= r4 ) {\n			mip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n		} else if ( roughness >= r5 ) {\n			mip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n		} else if ( roughness >= r6 ) {\n			mip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $0d23c856ce11c301$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $0d23c856ce11c301$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $0d23c856ce11c301$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var $0d23c856ce11c301$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vUv );\n	emissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $0d23c856ce11c301$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $0d23c856ce11c301$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $0d23c856ce11c301$var$encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n	return vec4( pow( value.rgb, vec3( gammaFactor ) ), value.a );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n	return vec4( pow( value.rgb, vec3( 1.0 / gammaFactor ) ), value.a );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n	return vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n	float maxComponent = max( max( value.r, value.g ), value.b );\n	float fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n	return vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n	return vec4( value.rgb * value.a * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n	float maxRGB = max( value.r, max( value.g, value.b ) );\n	float M = clamp( maxRGB / maxRange, 0.0, 1.0 );\n	M = ceil( M * 255.0 ) / 255.0;\n	return vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n	return vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n	float maxRGB = max( value.r, max( value.g, value.b ) );\n	float D = max( maxRange / maxRGB, 1.0 );\n	D = clamp( floor( D ) / 255.0, 0.0, 1.0 );\n	return vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value ) {\n	vec3 Xp_Y_XYZp = cLogLuvM * value.rgb;\n	Xp_Y_XYZp = max( Xp_Y_XYZp, vec3( 1e-6, 1e-6, 1e-6 ) );\n	vec4 vResult;\n	vResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n	float Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n	vResult.w = fract( Le );\n	vResult.z = ( Le - ( floor( vResult.w * 255.0 ) ) / 255.0 ) / 255.0;\n	return vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n	float Le = value.z * 255.0 + value.w;\n	vec3 Xp_Y_XYZp;\n	Xp_Y_XYZp.y = exp2( ( Le - 127.0 ) / 2.0 );\n	Xp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n	Xp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n	vec3 vRGB = cLogLuvInverseM * Xp_Y_XYZp.rgb;\n	return vec4( max( vRGB, 0.0 ), 1.0 );\n}";
var $0d23c856ce11c301$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifndef ENVMAP_TYPE_CUBE_UV\n		envColor = envMapTexelToLinear( envColor );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $0d23c856ce11c301$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	uniform int maxMipLevel;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $0d23c856ce11c301$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $0d23c856ce11c301$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $0d23c856ce11c301$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $0d23c856ce11c301$var$fog_vertex = "#ifdef USE_FOG\n	fogDepth = - mvPosition.z;\n#endif";
var $0d23c856ce11c301$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float fogDepth;\n#endif";
var $0d23c856ce11c301$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * fogDepth * fogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $0d23c856ce11c301$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float fogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $0d23c856ce11c301$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return texture2D( gradientMap, coord ).rgb;\n	#else\n		return ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n	#endif\n}";
var $0d23c856ce11c301$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel= texture2D( lightMap, vUv2 );\n	reflectedLight.indirectDiffuse += PI * lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n#endif";
var $0d23c856ce11c301$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $0d23c856ce11c301$var$lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n	vLightBack = vec3( 0.0 );\n	vIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry );\n#ifdef DOUBLE_SIDED\n	vIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n	vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry );\n#endif\n#if NUM_POINT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		getPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = PI * directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		getSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = PI * directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		getDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = PI * directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n		vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n		#ifdef DOUBLE_SIDED\n			vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif";
var $0d23c856ce11c301$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in GeometricContext geometry ) {\n	vec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	#ifndef PHYSICALLY_CORRECT_LIGHTS\n		irradiance *= PI;\n	#endif\n	return irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n		directLight.color = directionalLight.color;\n		directLight.direction = directionalLight.direction;\n		directLight.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		directLight.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		directLight.color = pointLight.color;\n		directLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n		directLight.visible = ( directLight.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		directLight.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		float angleCos = dot( directLight.direction, spotLight.direction );\n		if ( angleCos > spotLight.coneCos ) {\n			float spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n			directLight.color = spotLight.color;\n			directLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n			directLight.visible = true;\n		} else {\n			directLight.color = vec3( 0.0 );\n			directLight.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n		float dotNL = dot( geometry.normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		#ifndef PHYSICALLY_CORRECT_LIGHTS\n			irradiance *= PI;\n		#endif\n		return irradiance;\n	}\n#endif";
var $0d23c856ce11c301$var$envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n	#ifdef ENVMAP_MODE_REFRACTION\n		uniform float refractionRatio;\n	#endif\n	vec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n		vec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n		#ifdef ENVMAP_TYPE_CUBE\n			vec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n			#ifdef TEXTURE_LOD_EXT\n				vec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n			#else\n				vec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n			#endif\n			envMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n		#elif defined( ENVMAP_TYPE_CUBE_UV )\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n		#else\n			vec4 envMapColor = vec4( 0.0 );\n		#endif\n		return PI * envMapColor.rgb * envMapIntensity;\n	}\n	float getSpecularMIPLevel( const in float roughness, const in int maxMIPLevel ) {\n		float maxMIPLevelScalar = float( maxMIPLevel );\n		float sigma = PI * roughness * roughness / ( 1.0 + roughness );\n		float desiredMIPLevel = maxMIPLevelScalar + log2( sigma );\n		return clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n	}\n	vec3 getLightProbeIndirectRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in int maxMIPLevel ) {\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( -viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n		#else\n			vec3 reflectVec = refract( -viewDir, normal, refractionRatio );\n		#endif\n		reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n		float specularMIPLevel = getSpecularMIPLevel( roughness, maxMIPLevel );\n		#ifdef ENVMAP_TYPE_CUBE\n			vec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n			#ifdef TEXTURE_LOD_EXT\n				vec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n			#else\n				vec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n			#endif\n			envMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n		#elif defined( ENVMAP_TYPE_CUBE_UV )\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n		#endif\n		return envMapColor.rgb * envMapIntensity;\n	}\n#endif";
var $0d23c856ce11c301$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $0d23c856ce11c301$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	#ifndef PHYSICALLY_CORRECT_LIGHTS\n		irradiance *= PI;\n	#endif\n	reflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )	(0)";
var $0d23c856ce11c301$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $0d23c856ce11c301$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifndef PHYSICALLY_CORRECT_LIGHTS\n		irradiance *= PI;\n	#endif\n	reflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )	(0)";
var $0d23c856ce11c301$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.specularRoughness = max( roughnessFactor, 0.0525 );material.specularRoughness += geometryRoughness;\nmaterial.specularRoughness = min( material.specularRoughness, 1.0 );\n#ifdef REFLECTIVITY\n	material.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#endif\n#ifdef CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheen;\n#endif";
var $0d23c856ce11c301$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float specularRoughness;\n	vec3 specularColor;\n#ifdef CLEARCOAT\n	float clearcoat;\n	float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n	vec3 sheenColor;\n#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearcoatDHRApprox( const in float roughness, const in float dotNL ) {\n	return DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.specularRoughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifndef PHYSICALLY_CORRECT_LIGHTS\n		irradiance *= PI;\n	#endif\n	#ifdef CLEARCOAT\n		float ccDotNL = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = ccDotNL * directLight.color;\n		#ifndef PHYSICALLY_CORRECT_LIGHTS\n			ccIrradiance *= PI;\n		#endif\n		float clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n		reflectedLight.directSpecular += ccIrradiance * material.clearcoat * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n	#else\n		float clearcoatDHR = 0.0;\n	#endif\n	#ifdef USE_SHEEN\n		reflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_Sheen(\n			material.specularRoughness,\n			directLight.direction,\n			geometry,\n			material.sheenColor\n		);\n	#else\n		reflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.normal, material.specularColor, material.specularRoughness);\n	#endif\n	reflectedLight.directDiffuse += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef CLEARCOAT\n		float ccDotNV = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular += clearcoatRadiance * material.clearcoat * BRDF_Specular_GGX_Environment( geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n		float ccDotNL = ccDotNV;\n		float clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n	#else\n		float clearcoatDHR = 0.0;\n	#endif\n	float clearcoatInv = 1.0 - clearcoatDHR;\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	BRDF_Specular_Multiscattering_Environment( geometry, material.specularColor, material.specularRoughness, singleScattering, multiScattering );\n	vec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n	reflectedLight.indirectSpecular += clearcoatInv * radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $0d23c856ce11c301$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointDirectLightIrradiance( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotDirectLightIrradiance( spotLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $0d23c856ce11c301$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel= texture2D( lightMap, vUv2 );\n		vec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n		#ifndef PHYSICALLY_CORRECT_LIGHTS\n			lightMapIrradiance *= PI;\n		#endif\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getLightProbeIndirectIrradiance( geometry, maxMipLevel );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	radiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.normal, material.specularRoughness, maxMipLevel );\n	#ifdef CLEARCOAT\n		clearcoatRadiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness, maxMipLevel );\n	#endif\n#endif";
var $0d23c856ce11c301$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $0d23c856ce11c301$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $0d23c856ce11c301$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $0d23c856ce11c301$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var $0d23c856ce11c301$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var $0d23c856ce11c301$var$map_fragment = "#ifdef USE_MAP\n	vec4 texelColor = texture2D( map, vUv );\n	texelColor = mapTexelToLinear( texelColor );\n	diffuseColor *= texelColor;\n#endif";
var $0d23c856ce11c301$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $0d23c856ce11c301$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n	vec4 mapTexel = texture2D( map, uv );\n	diffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $0d23c856ce11c301$var$map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	uniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $0d23c856ce11c301$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $0d23c856ce11c301$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $0d23c856ce11c301$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n	objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n	objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n	objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n#endif";
var $0d23c856ce11c301$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifndef USE_MORPHNORMALS\n		uniform float morphTargetInfluences[ 8 ];\n	#else\n		uniform float morphTargetInfluences[ 4 ];\n	#endif\n#endif";
var $0d23c856ce11c301$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n	transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n	transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n	transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n	#ifndef USE_MORPHNORMALS\n		transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n		transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n		transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n		transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n	#endif\n#endif";
var $0d23c856ce11c301$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n	vec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	#ifdef USE_TANGENT\n		vec3 tangent = normalize( vTangent );\n		vec3 bitangent = normalize( vBitangent );\n		#ifdef DOUBLE_SIDED\n			tangent = tangent * faceDirection;\n			bitangent = bitangent * faceDirection;\n		#endif\n		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n			mat3 vTBN = mat3( tangent, bitangent, normal );\n		#endif\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var $0d23c856ce11c301$var$normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	#ifdef USE_TANGENT\n		normal = normalize( vTBN * mapN );\n	#else\n		normal = perturbNormal2Arb( -vViewPosition, normal, mapN, faceDirection );\n	#endif\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $0d23c856ce11c301$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n		vec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n		vec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n		vec2 st0 = dFdx( vUv.st );\n		vec2 st1 = dFdy( vUv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n	}\n#endif";
var $0d23c856ce11c301$var$clearcoat_normal_fragment_begin = "#ifdef CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var $0d23c856ce11c301$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	#ifdef USE_TANGENT\n		clearcoatNormal = normalize( vTBN * clearcoatMapN );\n	#else\n		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n	#endif\n#endif";
var $0d23c856ce11c301$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif";
var $0d23c856ce11c301$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ));\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w);\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n	return linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var $0d23c856ce11c301$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $0d23c856ce11c301$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $0d23c856ce11c301$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $0d23c856ce11c301$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $0d23c856ce11c301$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $0d23c856ce11c301$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $0d23c856ce11c301$var$shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n		bool inFrustum = all( inFrustumVec );\n		bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n		bool frustumTest = all( frustumTestVec );\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var $0d23c856ce11c301$var$shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $0d23c856ce11c301$var$shadowmap_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n		vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		vec4 shadowWorldPosition;\n	#endif\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n		vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n		vSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n		vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n#endif";
var $0d23c856ce11c301$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $0d23c856ce11c301$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $0d23c856ce11c301$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	#ifdef BONE_TEXTURE\n		uniform highp sampler2D boneTexture;\n		uniform int boneTextureSize;\n		mat4 getBoneMatrix( const in float i ) {\n			float j = i * 4.0;\n			float x = mod( j, float( boneTextureSize ) );\n			float y = floor( j / float( boneTextureSize ) );\n			float dx = 1.0 / float( boneTextureSize );\n			float dy = 1.0 / float( boneTextureSize );\n			y = dy * ( y + 0.5 );\n			vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n			vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n			vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n			vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n			mat4 bone = mat4( v1, v2, v3, v4 );\n			return bone;\n		}\n	#else\n		uniform mat4 boneMatrices[ MAX_BONES ];\n		mat4 getBoneMatrix( const in float i ) {\n			mat4 bone = boneMatrices[ int(i) ];\n			return bone;\n		}\n	#endif\n#endif";
var $0d23c856ce11c301$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $0d23c856ce11c301$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $0d23c856ce11c301$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $0d23c856ce11c301$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $0d23c856ce11c301$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $0d23c856ce11c301$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $0d23c856ce11c301$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	float transmissionFactor = transmission;\n	float thicknessFactor = thickness;\n	#ifdef USE_TRANSMISSIONMAP\n		transmissionFactor *= texture2D( transmissionMap, vUv ).r;\n	#endif\n	#ifdef USE_THICKNESSNMAP\n		thicknessFactor *= texture2D( thicknessMap, vUv ).g;\n	#endif\n	vec3 pos = vWorldPosition.xyz / vWorldPosition.w;\n	vec3 v = normalize( cameraPosition - pos );\n	float ior = ( 1.0 + 0.4 * reflectivity ) / ( 1.0 - 0.4 * reflectivity );\n	vec3 transmission = transmissionFactor * getIBLVolumeRefraction(\n		normal, v, roughnessFactor, material.diffuseColor, totalSpecular,\n		pos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n		attenuationColor, attenuationDistance );\n	totalDiffuse = mix( totalDiffuse, transmission, transmissionFactor );\n#endif";
var $0d23c856ce11c301$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec4 vWorldPosition;\n	vec3 getVolumeTransmissionRay(vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix) {\n		vec3 refractionVector = refract(-v, normalize(n), 1.0 / ior);\n		vec3 modelScale;\n		modelScale.x = length(vec3(modelMatrix[0].xyz));\n		modelScale.y = length(vec3(modelMatrix[1].xyz));\n		modelScale.z = length(vec3(modelMatrix[2].xyz));\n		return normalize(refractionVector) * thickness * modelScale;\n	}\n	float applyIorToRoughness(float roughness, float ior) {\n		return roughness * clamp(ior * 2.0 - 2.0, 0.0, 1.0);\n	}\n	vec3 getTransmissionSample(vec2 fragCoord, float roughness, float ior) {\n		float framebufferLod = log2(transmissionSamplerSize.x) * applyIorToRoughness(roughness, ior);\n		return texture2DLodEXT(transmissionSamplerMap, fragCoord.xy, framebufferLod).rgb;\n	}\n	vec3 applyVolumeAttenuation(vec3 radiance, float transmissionDistance, vec3 attenuationColor, float attenuationDistance) {\n		if (attenuationDistance == 0.0) {\n			return radiance;\n		} else {\n			vec3 attenuationCoefficient = -log(attenuationColor) / attenuationDistance;\n			vec3 transmittance = exp(-attenuationCoefficient * transmissionDistance);			return transmittance * radiance;\n		}\n	}\n	vec3 getIBLVolumeRefraction(vec3 n, vec3 v, float perceptualRoughness, vec3 baseColor, vec3 specularColor,\n		vec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness,\n		vec3 attenuationColor, float attenuationDistance) {\n		vec3 transmissionRay = getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4(refractedRayExit, 1.0);\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec3 transmittedLight = getTransmissionSample(refractionCoords, perceptualRoughness, ior);\n		vec3 attenuatedColor = applyVolumeAttenuation(transmittedLight, length(transmissionRay), attenuationColor, attenuationDistance);\n		return (1.0 - specularColor) * attenuatedColor * baseColor;\n	}\n#endif";
var $0d23c856ce11c301$var$uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n	varying vec2 vUv;\n#endif";
var $0d23c856ce11c301$var$uv_pars_vertex = "#ifdef USE_UV\n	#ifdef UVS_VERTEX_ONLY\n		vec2 vUv;\n	#else\n		varying vec2 vUv;\n	#endif\n	uniform mat3 uvTransform;\n#endif";
var $0d23c856ce11c301$var$uv_vertex = "#ifdef USE_UV\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var $0d23c856ce11c301$var$uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	varying vec2 vUv2;\n#endif";
var $0d23c856ce11c301$var$uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	attribute vec2 uv2;\n	varying vec2 vUv2;\n	uniform mat3 uv2Transform;\n#endif";
var $0d23c856ce11c301$var$uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var $0d23c856ce11c301$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
var $0d23c856ce11c301$var$background_frag = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	gl_FragColor = mapTexelToLinear( texColor );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
var $0d23c856ce11c301$var$background_vert = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
var $0d23c856ce11c301$var$cube_frag = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	vec3 vReflect = vWorldDirection;\n	#include <envmap_fragment>\n	gl_FragColor = envColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
var $0d23c856ce11c301$var$cube_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
var $0d23c856ce11c301$var$depth_frag = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
var $0d23c856ce11c301$var$depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
var $0d23c856ce11c301$var$distanceRGBA_frag = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
var $0d23c856ce11c301$var$distanceRGBA_vert = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
var $0d23c856ce11c301$var$equirect_frag = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	vec4 texColor = texture2D( tEquirect, sampleUV );\n	gl_FragColor = mapTexelToLinear( texColor );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
var $0d23c856ce11c301$var$equirect_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
var $0d23c856ce11c301$var$linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
var $0d23c856ce11c301$var$linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <color_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
var $0d23c856ce11c301$var$meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n	\n		vec4 lightMapTexel= texture2D( lightMap, vUv2 );\n		reflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var $0d23c856ce11c301$var$meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_ENVMAP\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
var $0d23c856ce11c301$var$meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <emissivemap_fragment>\n	#ifdef DOUBLE_SIDED\n		reflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n	#else\n		reflectedLight.indirectDiffuse += vIndirectFront;\n	#endif\n	#include <lightmap_fragment>\n	reflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n	#ifdef DOUBLE_SIDED\n		reflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n	#else\n		reflectedLight.directDiffuse = vLightFront;\n	#endif\n	reflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var $0d23c856ce11c301$var$meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <lights_lambert_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var $0d23c856ce11c301$var$meshmatcap_frag = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n		matcapColor = matcapTexelToLinear( matcapColor );\n	#else\n		vec4 matcapColor = vec4( 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var $0d23c856ce11c301$var$meshmatcap_vert = "#define MATCAP\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#ifndef FLAT_SHADED\n		vNormal = normalize( transformedNormal );\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
var $0d23c856ce11c301$var$meshtoon_frag = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var $0d23c856ce11c301$var$meshtoon_vert = "#define TOON\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var $0d23c856ce11c301$var$meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var $0d23c856ce11c301$var$meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var $0d23c856ce11c301$var$meshphysical_frag = "#define STANDARD\n#ifdef PHYSICAL\n	#define REFLECTIVITY\n	#define CLEARCOAT\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform vec3 attenuationColor;\n	uniform float attenuationDistance;\n#endif\n#ifdef REFLECTIVITY\n	uniform float reflectivity;\n#endif\n#ifdef CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheen;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <transmission_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var $0d23c856ce11c301$var$meshphysical_vert = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif\n#ifdef USE_TRANSMISSION\n	varying vec4 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition;\n#endif\n}";
var $0d23c856ce11c301$var$normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}";
var $0d23c856ce11c301$var$normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
var $0d23c856ce11c301$var$points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
var $0d23c856ce11c301$var$points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <color_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
var $0d23c856ce11c301$var$shadow_frag = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
var $0d23c856ce11c301$var$shadow_vert = "#include <common>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <begin_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var $0d23c856ce11c301$var$sprite_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
var $0d23c856ce11c301$var$sprite_vert = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $0d23c856ce11c301$export$955f9f2e84c43c8b = {
    alphamap_fragment: $0d23c856ce11c301$var$alphamap_fragment,
    alphamap_pars_fragment: $0d23c856ce11c301$var$alphamap_pars_fragment,
    alphatest_fragment: $0d23c856ce11c301$var$alphatest_fragment,
    aomap_fragment: $0d23c856ce11c301$var$aomap_fragment,
    aomap_pars_fragment: $0d23c856ce11c301$var$aomap_pars_fragment,
    begin_vertex: $0d23c856ce11c301$var$begin_vertex,
    beginnormal_vertex: $0d23c856ce11c301$var$beginnormal_vertex,
    bsdfs: $0d23c856ce11c301$var$bsdfs,
    bumpmap_pars_fragment: $0d23c856ce11c301$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $0d23c856ce11c301$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $0d23c856ce11c301$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $0d23c856ce11c301$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $0d23c856ce11c301$var$clipping_planes_vertex,
    color_fragment: $0d23c856ce11c301$var$color_fragment,
    color_pars_fragment: $0d23c856ce11c301$var$color_pars_fragment,
    color_pars_vertex: $0d23c856ce11c301$var$color_pars_vertex,
    color_vertex: $0d23c856ce11c301$var$color_vertex,
    common: $0d23c856ce11c301$var$common,
    cube_uv_reflection_fragment: $0d23c856ce11c301$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $0d23c856ce11c301$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $0d23c856ce11c301$var$displacementmap_pars_vertex,
    displacementmap_vertex: $0d23c856ce11c301$var$displacementmap_vertex,
    emissivemap_fragment: $0d23c856ce11c301$var$emissivemap_fragment,
    emissivemap_pars_fragment: $0d23c856ce11c301$var$emissivemap_pars_fragment,
    encodings_fragment: $0d23c856ce11c301$var$encodings_fragment,
    encodings_pars_fragment: $0d23c856ce11c301$var$encodings_pars_fragment,
    envmap_fragment: $0d23c856ce11c301$var$envmap_fragment,
    envmap_common_pars_fragment: $0d23c856ce11c301$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $0d23c856ce11c301$var$envmap_pars_fragment,
    envmap_pars_vertex: $0d23c856ce11c301$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $0d23c856ce11c301$var$envmap_physical_pars_fragment,
    envmap_vertex: $0d23c856ce11c301$var$envmap_vertex,
    fog_vertex: $0d23c856ce11c301$var$fog_vertex,
    fog_pars_vertex: $0d23c856ce11c301$var$fog_pars_vertex,
    fog_fragment: $0d23c856ce11c301$var$fog_fragment,
    fog_pars_fragment: $0d23c856ce11c301$var$fog_pars_fragment,
    gradientmap_pars_fragment: $0d23c856ce11c301$var$gradientmap_pars_fragment,
    lightmap_fragment: $0d23c856ce11c301$var$lightmap_fragment,
    lightmap_pars_fragment: $0d23c856ce11c301$var$lightmap_pars_fragment,
    lights_lambert_vertex: $0d23c856ce11c301$var$lights_lambert_vertex,
    lights_pars_begin: $0d23c856ce11c301$var$lights_pars_begin,
    lights_toon_fragment: $0d23c856ce11c301$var$lights_toon_fragment,
    lights_toon_pars_fragment: $0d23c856ce11c301$var$lights_toon_pars_fragment,
    lights_phong_fragment: $0d23c856ce11c301$var$lights_phong_fragment,
    lights_phong_pars_fragment: $0d23c856ce11c301$var$lights_phong_pars_fragment,
    lights_physical_fragment: $0d23c856ce11c301$var$lights_physical_fragment,
    lights_physical_pars_fragment: $0d23c856ce11c301$var$lights_physical_pars_fragment,
    lights_fragment_begin: $0d23c856ce11c301$var$lights_fragment_begin,
    lights_fragment_maps: $0d23c856ce11c301$var$lights_fragment_maps,
    lights_fragment_end: $0d23c856ce11c301$var$lights_fragment_end,
    logdepthbuf_fragment: $0d23c856ce11c301$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $0d23c856ce11c301$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $0d23c856ce11c301$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $0d23c856ce11c301$var$logdepthbuf_vertex,
    map_fragment: $0d23c856ce11c301$var$map_fragment,
    map_pars_fragment: $0d23c856ce11c301$var$map_pars_fragment,
    map_particle_fragment: $0d23c856ce11c301$var$map_particle_fragment,
    map_particle_pars_fragment: $0d23c856ce11c301$var$map_particle_pars_fragment,
    metalnessmap_fragment: $0d23c856ce11c301$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $0d23c856ce11c301$var$metalnessmap_pars_fragment,
    morphnormal_vertex: $0d23c856ce11c301$var$morphnormal_vertex,
    morphtarget_pars_vertex: $0d23c856ce11c301$var$morphtarget_pars_vertex,
    morphtarget_vertex: $0d23c856ce11c301$var$morphtarget_vertex,
    normal_fragment_begin: $0d23c856ce11c301$var$normal_fragment_begin,
    normal_fragment_maps: $0d23c856ce11c301$var$normal_fragment_maps,
    normalmap_pars_fragment: $0d23c856ce11c301$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $0d23c856ce11c301$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $0d23c856ce11c301$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $0d23c856ce11c301$var$clearcoat_pars_fragment,
    packing: $0d23c856ce11c301$var$packing,
    premultiplied_alpha_fragment: $0d23c856ce11c301$var$premultiplied_alpha_fragment,
    project_vertex: $0d23c856ce11c301$var$project_vertex,
    dithering_fragment: $0d23c856ce11c301$var$dithering_fragment,
    dithering_pars_fragment: $0d23c856ce11c301$var$dithering_pars_fragment,
    roughnessmap_fragment: $0d23c856ce11c301$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $0d23c856ce11c301$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $0d23c856ce11c301$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $0d23c856ce11c301$var$shadowmap_pars_vertex,
    shadowmap_vertex: $0d23c856ce11c301$var$shadowmap_vertex,
    shadowmask_pars_fragment: $0d23c856ce11c301$var$shadowmask_pars_fragment,
    skinbase_vertex: $0d23c856ce11c301$var$skinbase_vertex,
    skinning_pars_vertex: $0d23c856ce11c301$var$skinning_pars_vertex,
    skinning_vertex: $0d23c856ce11c301$var$skinning_vertex,
    skinnormal_vertex: $0d23c856ce11c301$var$skinnormal_vertex,
    specularmap_fragment: $0d23c856ce11c301$var$specularmap_fragment,
    specularmap_pars_fragment: $0d23c856ce11c301$var$specularmap_pars_fragment,
    tonemapping_fragment: $0d23c856ce11c301$var$tonemapping_fragment,
    tonemapping_pars_fragment: $0d23c856ce11c301$var$tonemapping_pars_fragment,
    transmission_fragment: $0d23c856ce11c301$var$transmission_fragment,
    transmission_pars_fragment: $0d23c856ce11c301$var$transmission_pars_fragment,
    uv_pars_fragment: $0d23c856ce11c301$var$uv_pars_fragment,
    uv_pars_vertex: $0d23c856ce11c301$var$uv_pars_vertex,
    uv_vertex: $0d23c856ce11c301$var$uv_vertex,
    uv2_pars_fragment: $0d23c856ce11c301$var$uv2_pars_fragment,
    uv2_pars_vertex: $0d23c856ce11c301$var$uv2_pars_vertex,
    uv2_vertex: $0d23c856ce11c301$var$uv2_vertex,
    worldpos_vertex: $0d23c856ce11c301$var$worldpos_vertex,
    background_frag: $0d23c856ce11c301$var$background_frag,
    background_vert: $0d23c856ce11c301$var$background_vert,
    cube_frag: $0d23c856ce11c301$var$cube_frag,
    cube_vert: $0d23c856ce11c301$var$cube_vert,
    depth_frag: $0d23c856ce11c301$var$depth_frag,
    depth_vert: $0d23c856ce11c301$var$depth_vert,
    distanceRGBA_frag: $0d23c856ce11c301$var$distanceRGBA_frag,
    distanceRGBA_vert: $0d23c856ce11c301$var$distanceRGBA_vert,
    equirect_frag: $0d23c856ce11c301$var$equirect_frag,
    equirect_vert: $0d23c856ce11c301$var$equirect_vert,
    linedashed_frag: $0d23c856ce11c301$var$linedashed_frag,
    linedashed_vert: $0d23c856ce11c301$var$linedashed_vert,
    meshbasic_frag: $0d23c856ce11c301$var$meshbasic_frag,
    meshbasic_vert: $0d23c856ce11c301$var$meshbasic_vert,
    meshlambert_frag: $0d23c856ce11c301$var$meshlambert_frag,
    meshlambert_vert: $0d23c856ce11c301$var$meshlambert_vert,
    meshmatcap_frag: $0d23c856ce11c301$var$meshmatcap_frag,
    meshmatcap_vert: $0d23c856ce11c301$var$meshmatcap_vert,
    meshtoon_frag: $0d23c856ce11c301$var$meshtoon_frag,
    meshtoon_vert: $0d23c856ce11c301$var$meshtoon_vert,
    meshphong_frag: $0d23c856ce11c301$var$meshphong_frag,
    meshphong_vert: $0d23c856ce11c301$var$meshphong_vert,
    meshphysical_frag: $0d23c856ce11c301$var$meshphysical_frag,
    meshphysical_vert: $0d23c856ce11c301$var$meshphysical_vert,
    normal_frag: $0d23c856ce11c301$var$normal_frag,
    normal_vert: $0d23c856ce11c301$var$normal_vert,
    points_frag: $0d23c856ce11c301$var$points_frag,
    points_vert: $0d23c856ce11c301$var$points_vert,
    shadow_frag: $0d23c856ce11c301$var$shadow_frag,
    shadow_vert: $0d23c856ce11c301$var$shadow_vert,
    sprite_frag: $0d23c856ce11c301$var$sprite_frag,
    sprite_vert: $0d23c856ce11c301$var$sprite_vert
};
/**
 * Uniforms library for shared webgl shaders
 */ const $0d23c856ce11c301$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new $0d23c856ce11c301$export$8ff26dafa08918()
        },
        uv2Transform: {
            value: new $0d23c856ce11c301$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        refractionRatio: {
            value: 0.98
        },
        maxMipLevel: {
            value: 0
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new $0d23c856ce11c301$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotShadowMap: {
            value: []
        },
        spotShadowMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        uvTransform: {
            value: new $0d23c856ce11c301$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: new $0d23c856ce11c301$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        uvTransform: {
            value: new $0d23c856ce11c301$export$8ff26dafa08918()
        }
    }
};
const $0d23c856ce11c301$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.common,
            $0d23c856ce11c301$export$6643083551874bf5.specularmap,
            $0d23c856ce11c301$export$6643083551874bf5.envmap,
            $0d23c856ce11c301$export$6643083551874bf5.aomap,
            $0d23c856ce11c301$export$6643083551874bf5.lightmap,
            $0d23c856ce11c301$export$6643083551874bf5.fog
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.common,
            $0d23c856ce11c301$export$6643083551874bf5.specularmap,
            $0d23c856ce11c301$export$6643083551874bf5.envmap,
            $0d23c856ce11c301$export$6643083551874bf5.aomap,
            $0d23c856ce11c301$export$6643083551874bf5.lightmap,
            $0d23c856ce11c301$export$6643083551874bf5.emissivemap,
            $0d23c856ce11c301$export$6643083551874bf5.fog,
            $0d23c856ce11c301$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $0d23c856ce11c301$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.common,
            $0d23c856ce11c301$export$6643083551874bf5.specularmap,
            $0d23c856ce11c301$export$6643083551874bf5.envmap,
            $0d23c856ce11c301$export$6643083551874bf5.aomap,
            $0d23c856ce11c301$export$6643083551874bf5.lightmap,
            $0d23c856ce11c301$export$6643083551874bf5.emissivemap,
            $0d23c856ce11c301$export$6643083551874bf5.bumpmap,
            $0d23c856ce11c301$export$6643083551874bf5.normalmap,
            $0d23c856ce11c301$export$6643083551874bf5.displacementmap,
            $0d23c856ce11c301$export$6643083551874bf5.fog,
            $0d23c856ce11c301$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $0d23c856ce11c301$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: new $0d23c856ce11c301$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.common,
            $0d23c856ce11c301$export$6643083551874bf5.envmap,
            $0d23c856ce11c301$export$6643083551874bf5.aomap,
            $0d23c856ce11c301$export$6643083551874bf5.lightmap,
            $0d23c856ce11c301$export$6643083551874bf5.emissivemap,
            $0d23c856ce11c301$export$6643083551874bf5.bumpmap,
            $0d23c856ce11c301$export$6643083551874bf5.normalmap,
            $0d23c856ce11c301$export$6643083551874bf5.displacementmap,
            $0d23c856ce11c301$export$6643083551874bf5.roughnessmap,
            $0d23c856ce11c301$export$6643083551874bf5.metalnessmap,
            $0d23c856ce11c301$export$6643083551874bf5.fog,
            $0d23c856ce11c301$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $0d23c856ce11c301$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.common,
            $0d23c856ce11c301$export$6643083551874bf5.aomap,
            $0d23c856ce11c301$export$6643083551874bf5.lightmap,
            $0d23c856ce11c301$export$6643083551874bf5.emissivemap,
            $0d23c856ce11c301$export$6643083551874bf5.bumpmap,
            $0d23c856ce11c301$export$6643083551874bf5.normalmap,
            $0d23c856ce11c301$export$6643083551874bf5.displacementmap,
            $0d23c856ce11c301$export$6643083551874bf5.gradientmap,
            $0d23c856ce11c301$export$6643083551874bf5.fog,
            $0d23c856ce11c301$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $0d23c856ce11c301$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.common,
            $0d23c856ce11c301$export$6643083551874bf5.bumpmap,
            $0d23c856ce11c301$export$6643083551874bf5.normalmap,
            $0d23c856ce11c301$export$6643083551874bf5.displacementmap,
            $0d23c856ce11c301$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.points,
            $0d23c856ce11c301$export$6643083551874bf5.fog
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.common,
            $0d23c856ce11c301$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.common,
            $0d23c856ce11c301$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.common,
            $0d23c856ce11c301$export$6643083551874bf5.bumpmap,
            $0d23c856ce11c301$export$6643083551874bf5.normalmap,
            $0d23c856ce11c301$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.normal_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.normal_frag
    },
    sprite: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.sprite,
            $0d23c856ce11c301$export$6643083551874bf5.fog
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new $0d23c856ce11c301$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            }
        },
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.background_frag
    },
    /* -------------------------------------------------------------------------
	//	Cube map shader
	 ------------------------------------------------------------------------- */ cube: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.envmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.common,
            $0d23c856ce11c301$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: new $0d23c856ce11c301$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: $0d23c856ce11c301$var$mergeUniforms([
            $0d23c856ce11c301$export$6643083551874bf5.lights,
            $0d23c856ce11c301$export$6643083551874bf5.fog,
            {
                color: {
                    value: new $0d23c856ce11c301$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.shadow_frag
    }
};
$0d23c856ce11c301$export$bee4a7d47f8f5014.physical = {
    uniforms: $0d23c856ce11c301$var$mergeUniforms([
        $0d23c856ce11c301$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new $0d23c856ce11c301$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            sheen: {
                value: new $0d23c856ce11c301$export$892596cec99bc70e(0x000000)
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: new $0d23c856ce11c301$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new $0d23c856ce11c301$export$892596cec99bc70e(0x000000)
            }
        }
    ]),
    vertexShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $0d23c856ce11c301$export$955f9f2e84c43c8b.meshphysical_frag
};
function $0d23c856ce11c301$var$WebGLBackground(renderer, cubemaps, state, objects, premultipliedAlpha) {
    const clearColor = new $0d23c856ce11c301$export$892596cec99bc70e(0x000000);
    let clearAlpha = 0;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) background = cubemaps.get(background);
        // Ignore background in AR
        // TODO: Reconsider this.
        const xr = renderer.xr;
        const session = xr.getSession && xr.getSession();
        if (session && session.environmentBlendMode === "additive") background = null;
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $0d23c856ce11c301$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $0d23c856ce11c301$export$e176487c05830cc5(new $0d23c856ce11c301$export$ab3456a079aa7d80(1, 1, 1), new $0d23c856ce11c301$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $0d23c856ce11c301$var$cloneUniforms($0d23c856ce11c301$export$bee4a7d47f8f5014.cube.uniforms),
                    vertexShader: $0d23c856ce11c301$export$bee4a7d47f8f5014.cube.vertexShader,
                    fragmentShader: $0d23c856ce11c301$export$bee4a7d47f8f5014.cube.fragmentShader,
                    side: $0d23c856ce11c301$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // enable code injection for non-built-in material
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background._needsFlipEnvMap ? -1 : 1;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $0d23c856ce11c301$export$e176487c05830cc5(new $0d23c856ce11c301$export$e789a11a194ca4e0(2, 2), new $0d23c856ce11c301$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $0d23c856ce11c301$var$cloneUniforms($0d23c856ce11c301$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $0d23c856ce11c301$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $0d23c856ce11c301$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $0d23c856ce11c301$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // enable code injection for non-built-in material
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $0d23c856ce11c301$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(34921);
    const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(geometry, index);
            if (updateBuffers) saveCache(geometry, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (object.isInstancedMesh === true) updateBuffers = true;
        if (index !== null) attributes.update(index, 34963);
        if (updateBuffers) {
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(34963, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(geometry, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in geometryAttributes){
            const cachedAttribute = cachedAttributes[key];
            const geometryAttribute = geometryAttributes[key];
            if (cachedAttribute === undefined) return true;
            if (cachedAttribute.attribute !== geometryAttribute) return true;
            if (cachedAttribute.data !== geometryAttribute.data) return true;
            attributesNum++;
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(geometry, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in attributes){
            const attribute = attributes[key];
            const data = {};
            data.attribute = attribute;
            if (attribute.data) data.data = attribute.data;
            cache[key] = data;
            attributesNum++;
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
            extension[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get("ANGLE_instanced_arrays") === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute >= 0) {
                const geometryAttribute = geometryAttributes[name];
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data && data.isInstancedInterleavedBuffer) {
                            enableAttributeAndDivisor(programAttribute, data.meshPerAttribute);
                            if (geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else enableAttribute(programAttribute);
                        gl.bindBuffer(34962, buffer);
                        vertexAttribPointer(programAttribute, size, type, normalized, stride * bytesPerElement, offset * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            enableAttributeAndDivisor(programAttribute, geometryAttribute.meshPerAttribute);
                            if (geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else enableAttribute(programAttribute);
                        gl.bindBuffer(34962, buffer);
                        vertexAttribPointer(programAttribute, size, type, normalized, 0, 0);
                    }
                } else if (name === "instanceMatrix") {
                    const attribute = attributes.get(object.instanceMatrix);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    enableAttributeAndDivisor(programAttribute + 0, 1);
                    enableAttributeAndDivisor(programAttribute + 1, 1);
                    enableAttributeAndDivisor(programAttribute + 2, 1);
                    enableAttributeAndDivisor(programAttribute + 3, 1);
                    gl.bindBuffer(34962, buffer);
                    gl.vertexAttribPointer(programAttribute + 0, 4, type, false, 64, 0);
                    gl.vertexAttribPointer(programAttribute + 1, 4, type, false, 64, 16);
                    gl.vertexAttribPointer(programAttribute + 2, 4, type, false, 64, 32);
                    gl.vertexAttribPointer(programAttribute + 3, 4, type, false, 64, 48);
                } else if (name === "instanceColor") {
                    const attribute = attributes.get(object.instanceColor);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    enableAttributeAndDivisor(programAttribute, 1);
                    gl.bindBuffer(34962, buffer);
                    gl.vertexAttribPointer(programAttribute, 3, type, false, 12, 0);
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatilibity
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $0d23c856ce11c301$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawArraysInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawArraysInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $0d23c856ce11c301$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) return "mediump";
        }
        return "lowp";
    }
    /* eslint-disable no-undef */ const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== "undefined" && gl instanceof WebGL2ComputeRenderingContext;
    /* eslint-enable no-undef */ let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(34930);
    const maxVertexTextures = gl.getParameter(35660);
    const maxTextureSize = gl.getParameter(3379);
    const maxCubemapSize = gl.getParameter(34076);
    const maxAttributes = gl.getParameter(34921);
    const maxVertexUniforms = gl.getParameter(36347);
    const maxVaryings = gl.getParameter(36348);
    const maxFragmentUniforms = gl.getParameter(36349);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $0d23c856ce11c301$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $0d23c856ce11c301$export$7ff5ac152ef991b0(), viewNormalMatrix = new $0d23c856ce11c301$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping, camera) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        globalState = projectPlanes(planes, camera, 0);
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
        resetGlobalState();
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $0d23c856ce11c301$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $0d23c856ce11c301$export$d64030b316d3b087) texture.mapping = $0d23c856ce11c301$export$8759762a6477f2c4;
        else if (mapping === $0d23c856ce11c301$export$ee99d97d46898098) texture.mapping = $0d23c856ce11c301$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === $0d23c856ce11c301$export$d64030b316d3b087 || mapping === $0d23c856ce11c301$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const currentRenderTarget = renderer.getRenderTarget();
                        const renderTarget = new $0d23c856ce11c301$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        renderer.setRenderTarget(currentRenderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $0d23c856ce11c301$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension("EXT_color_buffer_float");
            else {
                getExtension("WEBGL_depth_texture");
                getExtension("OES_texture_float");
                getExtension("OES_texture_half_float");
                getExtension("OES_texture_half_float_linear");
                getExtension("OES_standard_derivatives");
                getExtension("OES_element_index_uint");
                getExtension("OES_vertex_array_object");
                getExtension("ANGLE_instanced_arrays");
            }
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $0d23c856ce11c301$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], 34962);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], 34962);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new ($0d23c856ce11c301$var$arrayMax(indices) > 65535 ? $0d23c856ce11c301$export$7eb8c9fa25cd5bd6 : $0d23c856ce11c301$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $0d23c856ce11c301$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawElementsInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawElementsInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $0d23c856ce11c301$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case 4:
                render.triangles += instanceCount * (count / 3);
                break;
            case 1:
                render.lines += instanceCount * (count / 2);
                break;
            case 3:
                render.lines += instanceCount * (count - 1);
                break;
            case 2:
                render.lines += instanceCount * count;
                break;
            case 0:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $0d23c856ce11c301$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $0d23c856ce11c301$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $0d23c856ce11c301$var$WebGLMorphtargets(gl) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, material, program) {
        const objectInfluences = object.morphTargetInfluences;
        // When object doesn't have morph target influences defined, we treat it as a 0-length array
        // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
        const length = objectInfluences === undefined ? 0 : objectInfluences.length;
        let influences = influencesList[geometry.id];
        if (influences === undefined || influences.length !== length) {
            // initialise list
            influences = [];
            for(let i = 0; i < length; i++)influences[i] = [
                i,
                0
            ];
            influencesList[geometry.id] = influences;
        }
        // Collect influences
        for(let i = 0; i < length; i++){
            const influence = influences[i];
            influence[0] = i;
            influence[1] = objectInfluences[i];
        }
        influences.sort($0d23c856ce11c301$var$absNumericalSort);
        for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
            workInfluences[i][0] = influences[i][0];
            workInfluences[i][1] = influences[i][1];
        } else {
            workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
            workInfluences[i][1] = 0;
        }
        workInfluences.sort($0d23c856ce11c301$var$numericalSort);
        const morphTargets = material.morphTargets && geometry.morphAttributes.position;
        const morphNormals = material.morphNormals && geometry.morphAttributes.normal;
        let morphInfluencesSum = 0;
        for(let i = 0; i < 8; i++){
            const influence = workInfluences[i];
            const index = influence[0];
            const value = influence[1];
            if (index !== Number.MAX_SAFE_INTEGER && value) {
                if (morphTargets && geometry.getAttribute("morphTarget" + i) !== morphTargets[index]) geometry.setAttribute("morphTarget" + i, morphTargets[index]);
                if (morphNormals && geometry.getAttribute("morphNormal" + i) !== morphNormals[index]) geometry.setAttribute("morphNormal" + i, morphNormals[index]);
                morphInfluences[i] = value;
                morphInfluencesSum += value;
            } else {
                if (morphTargets && geometry.hasAttribute("morphTarget" + i) === true) geometry.deleteAttribute("morphTarget" + i);
                if (morphNormals && geometry.hasAttribute("morphNormal" + i) === true) geometry.deleteAttribute("morphNormal" + i);
                morphInfluences[i] = 0;
            }
        }
        // GLSL shader uses formula baseinfluence * base + sum(target * influence)
        // This allows us to switch between absolute morphs and relative morphs without changing shader code
        // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
        const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
        program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
    }
    return {
        update: update
    };
}
function $0d23c856ce11c301$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, 34962);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, 34962);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
class $0d23c856ce11c301$export$e38bf4541665bbbd extends $0d23c856ce11c301$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $0d23c856ce11c301$export$727aa5ec3fe39bf0;
        this.minFilter = $0d23c856ce11c301$export$727aa5ec3fe39bf0;
        this.wrapR = $0d23c856ce11c301$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.needsUpdate = true;
    }
}
$0d23c856ce11c301$export$e38bf4541665bbbd.prototype.isDataTexture2DArray = true;
class $0d23c856ce11c301$export$ef03cdc98340bab4 extends $0d23c856ce11c301$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $0d23c856ce11c301$export$727aa5ec3fe39bf0;
        this.minFilter = $0d23c856ce11c301$export$727aa5ec3fe39bf0;
        this.wrapR = $0d23c856ce11c301$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.needsUpdate = true;
    }
}
$0d23c856ce11c301$export$ef03cdc98340bab4.prototype.isDataTexture3D = true;
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $0d23c856ce11c301$var$emptyTexture = new $0d23c856ce11c301$export$5431306cf43de24a();
const $0d23c856ce11c301$var$emptyTexture2dArray = new $0d23c856ce11c301$export$e38bf4541665bbbd();
const $0d23c856ce11c301$var$emptyTexture3d = new $0d23c856ce11c301$export$ef03cdc98340bab4();
const $0d23c856ce11c301$var$emptyCubeTexture = new $0d23c856ce11c301$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $0d23c856ce11c301$var$arrayCacheF32 = [];
const $0d23c856ce11c301$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $0d23c856ce11c301$var$mat4array = new Float32Array(16);
const $0d23c856ce11c301$var$mat3array = new Float32Array(9);
const $0d23c856ce11c301$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $0d23c856ce11c301$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $0d23c856ce11c301$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $0d23c856ce11c301$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $0d23c856ce11c301$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $0d23c856ce11c301$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $0d23c856ce11c301$var$allocTexUnits(textures, n) {
    let r = $0d23c856ce11c301$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $0d23c856ce11c301$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $0d23c856ce11c301$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $0d23c856ce11c301$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $0d23c856ce11c301$var$copyArray(cache, v);
    }
}
function $0d23c856ce11c301$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $0d23c856ce11c301$var$copyArray(cache, v);
    }
}
function $0d23c856ce11c301$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $0d23c856ce11c301$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $0d23c856ce11c301$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $0d23c856ce11c301$var$copyArray(cache, v);
    } else {
        if ($0d23c856ce11c301$var$arraysEqual(cache, elements)) return;
        $0d23c856ce11c301$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $0d23c856ce11c301$var$mat2array);
        $0d23c856ce11c301$var$copyArray(cache, elements);
    }
}
function $0d23c856ce11c301$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $0d23c856ce11c301$var$copyArray(cache, v);
    } else {
        if ($0d23c856ce11c301$var$arraysEqual(cache, elements)) return;
        $0d23c856ce11c301$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $0d23c856ce11c301$var$mat3array);
        $0d23c856ce11c301$var$copyArray(cache, elements);
    }
}
function $0d23c856ce11c301$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $0d23c856ce11c301$var$copyArray(cache, v);
    } else {
        if ($0d23c856ce11c301$var$arraysEqual(cache, elements)) return;
        $0d23c856ce11c301$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $0d23c856ce11c301$var$mat4array);
        $0d23c856ce11c301$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $0d23c856ce11c301$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array)
function $0d23c856ce11c301$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    $0d23c856ce11c301$var$copyArray(cache, v);
}
function $0d23c856ce11c301$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    $0d23c856ce11c301$var$copyArray(cache, v);
}
function $0d23c856ce11c301$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    $0d23c856ce11c301$var$copyArray(cache, v);
}
// Single unsigned integer
function $0d23c856ce11c301$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array)
function $0d23c856ce11c301$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
    gl.uniform2uiv(this.addr, v);
    $0d23c856ce11c301$var$copyArray(cache, v);
}
function $0d23c856ce11c301$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
    gl.uniform3uiv(this.addr, v);
    $0d23c856ce11c301$var$copyArray(cache, v);
}
function $0d23c856ce11c301$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if ($0d23c856ce11c301$var$arraysEqual(cache, v)) return;
    gl.uniform4uiv(this.addr, v);
    $0d23c856ce11c301$var$copyArray(cache, v);
}
// Single texture (2D / Cube)
function $0d23c856ce11c301$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTexture2D(v || $0d23c856ce11c301$var$emptyTexture, unit);
}
function $0d23c856ce11c301$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $0d23c856ce11c301$var$emptyTexture3d, unit);
}
function $0d23c856ce11c301$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTextureCube(v || $0d23c856ce11c301$var$emptyCubeTexture, unit);
}
function $0d23c856ce11c301$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $0d23c856ce11c301$var$emptyTexture2dArray, unit);
}
// Helper to pick the right setter for the singular case
function $0d23c856ce11c301$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $0d23c856ce11c301$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $0d23c856ce11c301$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $0d23c856ce11c301$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $0d23c856ce11c301$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $0d23c856ce11c301$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $0d23c856ce11c301$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $0d23c856ce11c301$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $0d23c856ce11c301$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $0d23c856ce11c301$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $0d23c856ce11c301$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $0d23c856ce11c301$var$setValueV4i; // _VEC4
        case 0x1405:
            return $0d23c856ce11c301$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $0d23c856ce11c301$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $0d23c856ce11c301$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $0d23c856ce11c301$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $0d23c856ce11c301$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $0d23c856ce11c301$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $0d23c856ce11c301$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $0d23c856ce11c301$var$setValueT2DArray1;
    }
}
// Array of scalars
function $0d23c856ce11c301$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $0d23c856ce11c301$var$setValueV2fArray(gl, v) {
    const data = $0d23c856ce11c301$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $0d23c856ce11c301$var$setValueV3fArray(gl, v) {
    const data = $0d23c856ce11c301$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $0d23c856ce11c301$var$setValueV4fArray(gl, v) {
    const data = $0d23c856ce11c301$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $0d23c856ce11c301$var$setValueM2Array(gl, v) {
    const data = $0d23c856ce11c301$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $0d23c856ce11c301$var$setValueM3Array(gl, v) {
    const data = $0d23c856ce11c301$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $0d23c856ce11c301$var$setValueM4Array(gl, v) {
    const data = $0d23c856ce11c301$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $0d23c856ce11c301$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $0d23c856ce11c301$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $0d23c856ce11c301$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $0d23c856ce11c301$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $0d23c856ce11c301$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $0d23c856ce11c301$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $0d23c856ce11c301$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $0d23c856ce11c301$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / Cube)
function $0d23c856ce11c301$var$setValueT1Array(gl, v, textures) {
    const n = v.length;
    const units = $0d23c856ce11c301$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTexture2D(v[i] || $0d23c856ce11c301$var$emptyTexture, units[i]);
}
function $0d23c856ce11c301$var$setValueT6Array(gl, v, textures) {
    const n = v.length;
    const units = $0d23c856ce11c301$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTextureCube(v[i] || $0d23c856ce11c301$var$emptyCubeTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $0d23c856ce11c301$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $0d23c856ce11c301$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $0d23c856ce11c301$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $0d23c856ce11c301$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $0d23c856ce11c301$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $0d23c856ce11c301$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $0d23c856ce11c301$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $0d23c856ce11c301$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $0d23c856ce11c301$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $0d23c856ce11c301$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $0d23c856ce11c301$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $0d23c856ce11c301$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $0d23c856ce11c301$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $0d23c856ce11c301$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $0d23c856ce11c301$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $0d23c856ce11c301$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $0d23c856ce11c301$var$setValueT1Array;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $0d23c856ce11c301$var$setValueT6Array;
    }
}
// --- Uniform Classes ---
function $0d23c856ce11c301$var$SingleUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.setValue = $0d23c856ce11c301$var$getSingularSetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
function $0d23c856ce11c301$var$PureArrayUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.size = activeInfo.size;
    this.setValue = $0d23c856ce11c301$var$getPureArraySetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
$0d23c856ce11c301$var$PureArrayUniform.prototype.updateCache = function(data) {
    const cache = this.cache;
    if (data instanceof Float32Array && cache.length !== data.length) this.cache = new Float32Array(data.length);
    $0d23c856ce11c301$var$copyArray(cache, data);
};
function $0d23c856ce11c301$var$StructuredUniform(id) {
    this.id = id;
    this.seq = [];
    this.map = {};
}
$0d23c856ce11c301$var$StructuredUniform.prototype.setValue = function(gl, value, textures) {
    const seq = this.seq;
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        u.setValue(gl, value[u.id], textures);
    }
};
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $0d23c856ce11c301$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $0d23c856ce11c301$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $0d23c856ce11c301$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $0d23c856ce11c301$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $0d23c856ce11c301$var$RePathPart.exec(path), matchEnd = $0d23c856ce11c301$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $0d23c856ce11c301$var$addUniform(container, subscript === undefined ? new $0d23c856ce11c301$var$SingleUniform(id, activeInfo, addr) : new $0d23c856ce11c301$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $0d23c856ce11c301$var$StructuredUniform(id);
                $0d23c856ce11c301$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
function $0d23c856ce11c301$var$WebGLUniforms(gl, program) {
    this.seq = [];
    this.map = {};
    const n = gl.getProgramParameter(program, 35718);
    for(let i = 0; i < n; ++i){
        const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
        $0d23c856ce11c301$var$parseUniform(info, addr, this);
    }
}
$0d23c856ce11c301$var$WebGLUniforms.prototype.setValue = function(gl, name, value, textures) {
    const u = this.map[name];
    if (u !== undefined) u.setValue(gl, value, textures);
};
$0d23c856ce11c301$var$WebGLUniforms.prototype.setOptional = function(gl, object, name) {
    const v = object[name];
    if (v !== undefined) this.setValue(gl, name, v);
};
// Static interface
$0d23c856ce11c301$var$WebGLUniforms.upload = function(gl, seq, values, textures) {
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i], v = values[u.id];
        if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
        u.setValue(gl, v.value, textures);
    }
};
$0d23c856ce11c301$var$WebGLUniforms.seqWithValue = function(seq, values) {
    const r = [];
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        if (u.id in values) r.push(u);
    }
    return r;
};
function $0d23c856ce11c301$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $0d23c856ce11c301$var$programIdCount = 0;
function $0d23c856ce11c301$var$addLineNumbers(string) {
    const lines = string.split("\n");
    for(let i = 0; i < lines.length; i++)lines[i] = i + 1 + ": " + lines[i];
    return lines.join("\n");
}
function $0d23c856ce11c301$var$getEncodingComponents(encoding) {
    switch(encoding){
        case $0d23c856ce11c301$export$7207336e4151a112:
            return [
                "Linear",
                "( value )"
            ];
        case $0d23c856ce11c301$export$f32388edbb32674:
            return [
                "sRGB",
                "( value )"
            ];
        case $0d23c856ce11c301$export$3be4c466a12b5dcf:
            return [
                "RGBE",
                "( value )"
            ];
        case $0d23c856ce11c301$export$2c4bdfd76b188654:
            return [
                "RGBM",
                "( value, 7.0 )"
            ];
        case $0d23c856ce11c301$export$48a0051d6a5a9b9:
            return [
                "RGBM",
                "( value, 16.0 )"
            ];
        case $0d23c856ce11c301$export$ca2f89b13b49d951:
            return [
                "RGBD",
                "( value, 256.0 )"
            ];
        case $0d23c856ce11c301$export$eaab32c1bcea1817:
            return [
                "Gamma",
                "( value, float( GAMMA_FACTOR ) )"
            ];
        case $0d23c856ce11c301$export$8d4cbbeb1eea9f67:
            return [
                "LogLuv",
                "( value )"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported encoding:", encoding);
            return [
                "Linear",
                "( value )"
            ];
    }
}
function $0d23c856ce11c301$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, 35713);
    const log = gl.getShaderInfoLog(shader).trim();
    if (status && log === "") return "";
    // --enable-privileged-webgl-extension
    // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
    const source = gl.getShaderSource(shader);
    return "THREE.WebGLShader: gl.getShaderInfoLog() " + type + "\n" + log + $0d23c856ce11c301$var$addLineNumbers(source);
}
function $0d23c856ce11c301$var$getTexelDecodingFunction(functionName, encoding) {
    const components = $0d23c856ce11c301$var$getEncodingComponents(encoding);
    return "vec4 " + functionName + "( vec4 value ) { return " + components[0] + "ToLinear" + components[1] + "; }";
}
function $0d23c856ce11c301$var$getTexelEncodingFunction(functionName, encoding) {
    const components = $0d23c856ce11c301$var$getEncodingComponents(encoding);
    return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function $0d23c856ce11c301$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $0d23c856ce11c301$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $0d23c856ce11c301$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $0d23c856ce11c301$export$932b3dd283d4a366:
            toneMappingName = "OptimizedCineon";
            break;
        case $0d23c856ce11c301$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $0d23c856ce11c301$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function $0d23c856ce11c301$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission > 0.0) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ];
    return chunks.filter($0d23c856ce11c301$var$filterEmptyLine).join("\n");
}
function $0d23c856ce11c301$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $0d23c856ce11c301$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, 35721);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = gl.getAttribLocation(program, name);
    }
    return attributes;
}
function $0d23c856ce11c301$var$filterEmptyLine(string) {
    return string !== "";
}
function $0d23c856ce11c301$var$replaceLightNums(string, parameters) {
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $0d23c856ce11c301$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $0d23c856ce11c301$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $0d23c856ce11c301$var$resolveIncludes(string) {
    return string.replace($0d23c856ce11c301$var$includePattern, $0d23c856ce11c301$var$includeReplacer);
}
function $0d23c856ce11c301$var$includeReplacer(match, include) {
    const string = $0d23c856ce11c301$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error("Can not resolve #include <" + include + ">");
    return $0d23c856ce11c301$var$resolveIncludes(string);
}
// Unroll Loops
const $0d23c856ce11c301$var$deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
const $0d23c856ce11c301$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $0d23c856ce11c301$var$unrollLoops(string) {
    return string.replace($0d23c856ce11c301$var$unrollLoopPattern, $0d23c856ce11c301$var$loopReplacer).replace($0d23c856ce11c301$var$deprecatedUnrollLoopPattern, $0d23c856ce11c301$var$deprecatedLoopReplacer);
}
function $0d23c856ce11c301$var$deprecatedLoopReplacer(match, start, end, snippet) {
    console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.");
    return $0d23c856ce11c301$var$loopReplacer(match, start, end, snippet);
}
function $0d23c856ce11c301$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $0d23c856ce11c301$var$generatePrecision(parameters) {
    let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $0d23c856ce11c301$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $0d23c856ce11c301$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $0d23c856ce11c301$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $0d23c856ce11c301$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $0d23c856ce11c301$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $0d23c856ce11c301$export$8759762a6477f2c4:
        case $0d23c856ce11c301$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $0d23c856ce11c301$export$dbf3e70ff37af79:
        case $0d23c856ce11c301$export$76a9f4355364345c:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $0d23c856ce11c301$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $0d23c856ce11c301$export$dc59f8aed047f61d:
        case $0d23c856ce11c301$export$76a9f4355364345c:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $0d23c856ce11c301$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $0d23c856ce11c301$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $0d23c856ce11c301$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $0d23c856ce11c301$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $0d23c856ce11c301$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $0d23c856ce11c301$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $0d23c856ce11c301$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $0d23c856ce11c301$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $0d23c856ce11c301$var$generateEnvMapBlendingDefine(parameters);
    const gammaFactorDefine = renderer.gammaFactor > 0 ? renderer.gammaFactor : 1.0;
    const customExtensions = parameters.isWebGL2 ? "" : $0d23c856ce11c301$var$generateExtensions(parameters);
    const customDefines = $0d23c856ce11c301$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter($0d23c856ce11c301$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter($0d23c856ce11c301$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $0d23c856ce11c301$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
            "#define GAMMA_FACTOR " + gammaFactorDefine,
            "#define MAX_BONES " + parameters.maxBones,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
            parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.displacementMap && parameters.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUvs ? "#define USE_UV" : "",
            parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.useVertexTexture ? "#define BONE_TEXTURE" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#ifdef USE_MORPHTARGETS",
            "	attribute vec3 morphTarget0;",
            "	attribute vec3 morphTarget1;",
            "	attribute vec3 morphTarget2;",
            "	attribute vec3 morphTarget3;",
            "	#ifdef USE_MORPHNORMALS",
            "		attribute vec3 morphNormal0;",
            "		attribute vec3 morphNormal1;",
            "		attribute vec3 morphNormal2;",
            "		attribute vec3 morphNormal3;",
            "	#else",
            "		attribute vec3 morphTarget4;",
            "		attribute vec3 morphTarget5;",
            "		attribute vec3 morphTarget6;",
            "		attribute vec3 morphTarget7;",
            "	#endif",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($0d23c856ce11c301$var$filterEmptyLine).join("\n");
        prefixFragment = [
            customExtensions,
            $0d23c856ce11c301$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.alphaTest ? "#define ALPHATEST " + parameters.alphaTest + (parameters.alphaTest % 1 ? "" : ".0") : "",
            "#define GAMMA_FACTOR " + gammaFactorDefine,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
            parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUvs ? "#define USE_UV" : "",
            parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            (parameters.extensionShaderTextureLOD || parameters.envMap) && parameters.rendererExtensionShaderTextureLod ? "#define TEXTURE_LOD_EXT" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $0d23c856ce11c301$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $0d23c856ce11c301$export$9fcb6b4294603b2 ? $0d23c856ce11c301$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $0d23c856ce11c301$export$9fcb6b4294603b2 ? $0d23c856ce11c301$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            $0d23c856ce11c301$export$955f9f2e84c43c8b["encodings_pars_fragment"],
            parameters.map ? $0d23c856ce11c301$var$getTexelDecodingFunction("mapTexelToLinear", parameters.mapEncoding) : "",
            parameters.matcap ? $0d23c856ce11c301$var$getTexelDecodingFunction("matcapTexelToLinear", parameters.matcapEncoding) : "",
            parameters.envMap ? $0d23c856ce11c301$var$getTexelDecodingFunction("envMapTexelToLinear", parameters.envMapEncoding) : "",
            parameters.emissiveMap ? $0d23c856ce11c301$var$getTexelDecodingFunction("emissiveMapTexelToLinear", parameters.emissiveMapEncoding) : "",
            parameters.lightMap ? $0d23c856ce11c301$var$getTexelDecodingFunction("lightMapTexelToLinear", parameters.lightMapEncoding) : "",
            $0d23c856ce11c301$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputEncoding),
            parameters.depthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($0d23c856ce11c301$var$filterEmptyLine).join("\n");
    }
    vertexShader = $0d23c856ce11c301$var$resolveIncludes(vertexShader);
    vertexShader = $0d23c856ce11c301$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $0d23c856ce11c301$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $0d23c856ce11c301$var$resolveIncludes(fragmentShader);
    fragmentShader = $0d23c856ce11c301$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $0d23c856ce11c301$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $0d23c856ce11c301$var$unrollLoops(vertexShader);
    fragmentShader = $0d23c856ce11c301$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $0d23c856ce11c301$export$f63012db5506e7dd ? "" : "out highp vec4 pc_fragColor;",
            parameters.glslVersion === $0d23c856ce11c301$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $0d23c856ce11c301$var$WebGLShader(gl, 35633, vertexGlsl);
    const glFragmentShader = $0d23c856ce11c301$var$WebGLShader(gl, 35632, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, 35714) === false) {
            runnable = false;
            const vertexErrors = $0d23c856ce11c301$var$getShaderErrors(gl, glVertexShader, "vertex");
            const fragmentErrors = $0d23c856ce11c301$var$getShaderErrors(gl, glFragmentShader, "fragment");
            console.error("THREE.WebGLProgram: shader error: ", gl.getError(), "35715", gl.getProgramParameter(program, 35715), "gl.getProgramInfoLog", programLog, vertexErrors, fragmentErrors);
        } else if (programLog !== "") console.warn("THREE.WebGLProgram: gl.getProgramInfoLog()", programLog);
        else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $0d23c856ce11c301$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $0d23c856ce11c301$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = $0d23c856ce11c301$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
function $0d23c856ce11c301$var$WebGLPrograms(renderer, cubemaps, extensions, capabilities, bindingStates, clipping) {
    const programs = [];
    const isWebGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const floatVertexTextures = capabilities.floatVertexTextures;
    const maxVertexUniforms = capabilities.maxVertexUniforms;
    const vertexTextures = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    const parameterNames = [
        "precision",
        "isWebGL2",
        "supportsVertexTextures",
        "outputEncoding",
        "instancing",
        "instancingColor",
        "map",
        "mapEncoding",
        "matcap",
        "matcapEncoding",
        "envMap",
        "envMapMode",
        "envMapEncoding",
        "envMapCubeUV",
        "lightMap",
        "lightMapEncoding",
        "aoMap",
        "emissiveMap",
        "emissiveMapEncoding",
        "bumpMap",
        "normalMap",
        "objectSpaceNormalMap",
        "tangentSpaceNormalMap",
        "clearcoatMap",
        "clearcoatRoughnessMap",
        "clearcoatNormalMap",
        "displacementMap",
        "specularMap",
        "roughnessMap",
        "metalnessMap",
        "gradientMap",
        "alphaMap",
        "combine",
        "vertexColors",
        "vertexAlphas",
        "vertexTangents",
        "vertexUvs",
        "uvsVertexOnly",
        "fog",
        "useFog",
        "fogExp2",
        "flatShading",
        "sizeAttenuation",
        "logarithmicDepthBuffer",
        "skinning",
        "maxBones",
        "useVertexTexture",
        "morphTargets",
        "morphNormals",
        "premultipliedAlpha",
        "numDirLights",
        "numPointLights",
        "numSpotLights",
        "numHemiLights",
        "numRectAreaLights",
        "numDirLightShadows",
        "numPointLightShadows",
        "numSpotLightShadows",
        "shadowMapEnabled",
        "shadowMapType",
        "toneMapping",
        "physicallyCorrectLights",
        "alphaTest",
        "doubleSided",
        "flipSided",
        "numClippingPlanes",
        "numClipIntersection",
        "depthPacking",
        "dithering",
        "sheen",
        "transmission",
        "transmissionMap",
        "thicknessMap"
    ];
    function getMaxBones(object) {
        const skeleton = object.skeleton;
        const bones = skeleton.bones;
        if (floatVertexTextures) return 1024;
        else {
            // default for when object is not specified
            // ( for example when prebuilding shader to be used with multiple objects )
            //
            //  - leave some extra space for other uniforms
            //  - limit here is ANGLE's 254 max uniform vectors
            //    (up to 54 should be safe)
            const nVertexUniforms = maxVertexUniforms;
            const nVertexMatrices = Math.floor((nVertexUniforms - 20) / 4);
            const maxBones = Math.min(nVertexMatrices, bones.length);
            if (maxBones < bones.length) {
                console.warn("THREE.WebGLRenderer: Skeleton has " + bones.length + " bones. This GPU supports " + maxBones + ".");
                return 0;
            }
            return maxBones;
        }
    }
    function getTextureEncodingFromMap(map) {
        let encoding;
        if (map && map.isTexture) encoding = map.encoding;
        else if (map && map.isWebGLRenderTarget) {
            console.warn("THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead.");
            encoding = map.texture.encoding;
        } else encoding = $0d23c856ce11c301$export$7207336e4151a112;
        return encoding;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = cubemaps.get(material.envMap || environment);
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        const maxBones = object.isSkinnedMesh ? getMaxBones(object) : 0;
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        let vertexShader, fragmentShader;
        if (shaderID) {
            const shader = $0d23c856ce11c301$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const parameters = {
            isWebGL2: isWebGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: object.isInstancedMesh === true,
            instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
            supportsVertexTextures: vertexTextures,
            outputEncoding: currentRenderTarget !== null ? getTextureEncodingFromMap(currentRenderTarget.texture) : renderer.outputEncoding,
            map: !!material.map,
            mapEncoding: getTextureEncodingFromMap(material.map),
            matcap: !!material.matcap,
            matcapEncoding: getTextureEncodingFromMap(material.matcap),
            envMap: !!envMap,
            envMapMode: envMap && envMap.mapping,
            envMapEncoding: getTextureEncodingFromMap(envMap),
            envMapCubeUV: !!envMap && (envMap.mapping === $0d23c856ce11c301$export$dbf3e70ff37af79 || envMap.mapping === $0d23c856ce11c301$export$76a9f4355364345c),
            lightMap: !!material.lightMap,
            lightMapEncoding: getTextureEncodingFromMap(material.lightMap),
            aoMap: !!material.aoMap,
            emissiveMap: !!material.emissiveMap,
            emissiveMapEncoding: getTextureEncodingFromMap(material.emissiveMap),
            bumpMap: !!material.bumpMap,
            normalMap: !!material.normalMap,
            objectSpaceNormalMap: material.normalMapType === $0d23c856ce11c301$export$9990ad26f9db5b2c,
            tangentSpaceNormalMap: material.normalMapType === $0d23c856ce11c301$export$2852a58ebdac27b8,
            clearcoatMap: !!material.clearcoatMap,
            clearcoatRoughnessMap: !!material.clearcoatRoughnessMap,
            clearcoatNormalMap: !!material.clearcoatNormalMap,
            displacementMap: !!material.displacementMap,
            roughnessMap: !!material.roughnessMap,
            metalnessMap: !!material.metalnessMap,
            specularMap: !!material.specularMap,
            alphaMap: !!material.alphaMap,
            gradientMap: !!material.gradientMap,
            sheen: !!material.sheen,
            transmission: !!material.transmission,
            transmissionMap: !!material.transmissionMap,
            thicknessMap: !!material.thicknessMap,
            combine: material.combine,
            vertexTangents: material.normalMap && material.vertexTangents,
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && object.geometry && object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4,
            vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.displacementMap || !!material.transmissionMap || !!material.thicknessMap,
            uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || !!material.transmission || !!material.transmissionMap || !!material.thicknessMap) && !!material.displacementMap,
            fog: !!fog,
            useFog: material.fog,
            fogExp2: fog && fog.isFogExp2,
            flatShading: !!material.flatShading,
            sizeAttenuation: material.sizeAttenuation,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true && maxBones > 0,
            maxBones: maxBones,
            useVertexTexture: floatVertexTextures,
            morphTargets: material.morphTargets,
            morphNormals: material.morphNormals,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $0d23c856ce11c301$export$9fcb6b4294603b2,
            physicallyCorrectLights: renderer.physicallyCorrectLights,
            premultipliedAlpha: material.premultipliedAlpha,
            alphaTest: material.alphaTest,
            doubleSided: material.side === $0d23c856ce11c301$export$3b296b6f144d5b03,
            flipSided: material.side === $0d23c856ce11c301$export$d9f0486e75b5ace,
            depthPacking: material.depthPacking !== undefined ? material.depthPacking : false,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: material.extensions && material.extensions.derivatives,
            extensionFragDepth: material.extensions && material.extensions.fragDepth,
            extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
            extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: isWebGL2 || extensions.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: isWebGL2 || extensions.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: isWebGL2 || extensions.has("EXT_shader_texture_lod"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.fragmentShader);
            array.push(parameters.vertexShader);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            for(let i = 0; i < parameterNames.length; i++)array.push(parameters[parameterNames[i]]);
            array.push(renderer.outputEncoding);
            array.push(renderer.gammaFactor);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $0d23c856ce11c301$export$bee4a7d47f8f5014[shaderID];
            uniforms = $0d23c856ce11c301$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $0d23c856ce11c301$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs
    };
}
function $0d23c856ce11c301$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $0d23c856ce11c301$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.program !== b.program) return a.program.id - b.program.id;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $0d23c856ce11c301$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $0d23c856ce11c301$var$WebGLRenderList(properties) {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    const defaultProgram = {
        id: -1
    };
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        const materialProperties = properties.get(material);
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                program: materialProperties.program || defaultProgram,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.program = materialProperties.program || defaultProgram;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $0d23c856ce11c301$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $0d23c856ce11c301$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $0d23c856ce11c301$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.program = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $0d23c856ce11c301$var$WebGLRenderLists(properties) {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        let list;
        if (lists.has(scene) === false) {
            list = new $0d23c856ce11c301$var$WebGLRenderList(properties);
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= lists.get(scene).length) {
            list = new $0d23c856ce11c301$var$WebGLRenderList(properties);
            lists.get(scene).push(list);
        } else list = lists.get(scene)[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $0d23c856ce11c301$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $0d23c856ce11c301$export$64b5c384219d3699(),
                        color: new $0d23c856ce11c301$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $0d23c856ce11c301$export$64b5c384219d3699(),
                        direction: new $0d23c856ce11c301$export$64b5c384219d3699(),
                        color: new $0d23c856ce11c301$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $0d23c856ce11c301$export$64b5c384219d3699(),
                        color: new $0d23c856ce11c301$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $0d23c856ce11c301$export$64b5c384219d3699(),
                        skyColor: new $0d23c856ce11c301$export$892596cec99bc70e(),
                        groundColor: new $0d23c856ce11c301$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $0d23c856ce11c301$export$892596cec99bc70e(),
                        position: new $0d23c856ce11c301$export$64b5c384219d3699(),
                        halfWidth: new $0d23c856ce11c301$export$64b5c384219d3699(),
                        halfHeight: new $0d23c856ce11c301$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $0d23c856ce11c301$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0d23c856ce11c301$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0d23c856ce11c301$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0d23c856ce11c301$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $0d23c856ce11c301$var$nextVersion = 0;
function $0d23c856ce11c301$var$shadowCastingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function $0d23c856ce11c301$var$WebGLLights(extensions, capabilities) {
    const cache = new $0d23c856ce11c301$var$UniformsCache();
    const shadowCache = $0d23c856ce11c301$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotShadow: [],
        spotShadowMap: [],
        spotShadowMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: []
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $0d23c856ce11c301$export$64b5c384219d3699());
    const vector3 = new $0d23c856ce11c301$export$64b5c384219d3699();
    const matrix4 = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
    const matrix42 = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        lights.sort($0d23c856ce11c301$var$shadowCastingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    state.spotShadowMatrix[spotLength] = light.shadow.matrix;
                    numSpotShadows++;
                }
                state.spot[spotLength] = uniforms;
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                // (a) intensity is the total visible light emitted
                //uniforms.color.copy( color ).multiplyScalar( intensity / ( light.width * light.height * Math.PI ) );
                // (b) intensity is the brightness of the light
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $0d23c856ce11c301$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $0d23c856ce11c301$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has("OES_texture_float_linear") === true) {
                    state.rectAreaLTC1 = $0d23c856ce11c301$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $0d23c856ce11c301$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has("OES_texture_half_float_linear") === true) {
                    state.rectAreaLTC1 = $0d23c856ce11c301$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $0d23c856ce11c301$export$6643083551874bf5.LTC_HALF_2;
                } else console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotShadowMatrix.length = numSpotShadows;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            state.version = $0d23c856ce11c301$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                uniforms.direction.normalize();
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $0d23c856ce11c301$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $0d23c856ce11c301$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $0d23c856ce11c301$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        let renderState;
        if (renderStates.has(scene) === false) {
            renderState = new $0d23c856ce11c301$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStates.get(scene).length) {
            renderState = new $0d23c856ce11c301$var$WebGLRenderState(extensions, capabilities);
            renderStates.get(scene).push(renderState);
        } else renderState = renderStates.get(scene)[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
/**
 * parameters = {
 *
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 * }
 */ class $0d23c856ce11c301$export$2698c22ec13825db extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshDepthMaterial";
        this.depthPacking = $0d23c856ce11c301$export$deeb383078690b50;
        this.morphTargets = false;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.morphTargets = source.morphTargets;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
$0d23c856ce11c301$export$2698c22ec13825db.prototype.isMeshDepthMaterial = true;
/**
 * parameters = {
 *
 *  referencePosition: <float>,
 *  nearDistance: <float>,
 *  farDistance: <float>,
 *
 *  morphTargets: <bool>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>
 *
 * }
 */ class $0d23c856ce11c301$export$33e187ed002f2a19 extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshDistanceMaterial";
        this.referencePosition = new $0d23c856ce11c301$export$64b5c384219d3699();
        this.nearDistance = 1;
        this.farDistance = 1000;
        this.morphTargets = false;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.fog = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.referencePosition.copy(source.referencePosition);
        this.nearDistance = source.nearDistance;
        this.farDistance = source.farDistance;
        this.morphTargets = source.morphTargets;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
$0d23c856ce11c301$export$33e187ed002f2a19.prototype.isMeshDistanceMaterial = true;
var $0d23c856ce11c301$var$vsm_frag = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy ) / resolution ) );\n	for ( float i = -1.0; i < 1.0 ; i += SAMPLE_RATE) {\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( i, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, i ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean * HALF_SAMPLE_RATE;\n	squared_mean = squared_mean * HALF_SAMPLE_RATE;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
var $0d23c856ce11c301$var$vsm_vert = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
function $0d23c856ce11c301$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $0d23c856ce11c301$export$35efe6f4c85463d2();
    const _shadowMapSize = new $0d23c856ce11c301$export$c977b3e384af9ae1(), _viewportSize = new $0d23c856ce11c301$export$c977b3e384af9ae1(), _viewport = new $0d23c856ce11c301$export$fa7daccca11cdbe3(), _depthMaterials = [], _distanceMaterials = [], _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        0: $0d23c856ce11c301$export$d9f0486e75b5ace,
        1: $0d23c856ce11c301$export$2ede184fc2998901,
        2: $0d23c856ce11c301$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $0d23c856ce11c301$export$83c7d75d550a8b0d({
        defines: {
            SAMPLE_RATE: 0.25,
            HALF_SAMPLE_RATE: 0.125
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $0d23c856ce11c301$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $0d23c856ce11c301$var$vsm_vert,
        fragmentShader: $0d23c856ce11c301$var$vsm_frag
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $0d23c856ce11c301$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $0d23c856ce11c301$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $0d23c856ce11c301$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $0d23c856ce11c301$export$5813f879eee7cd88;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($0d23c856ce11c301$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null && !shadow.isPointLightShadow && this.type === $0d23c856ce11c301$export$896ae1ade6c829c4) {
                const pars = {
                    minFilter: $0d23c856ce11c301$export$8a72f490b25c56c8,
                    magFilter: $0d23c856ce11c301$export$8a72f490b25c56c8,
                    format: $0d23c856ce11c301$export$3f8bb04b555a363c
                };
                shadow.map = new $0d23c856ce11c301$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.mapPass = new $0d23c856ce11c301$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.camera.updateProjectionMatrix();
            }
            if (shadow.map === null) {
                const pars = {
                    minFilter: $0d23c856ce11c301$export$727aa5ec3fe39bf0,
                    magFilter: $0d23c856ce11c301$export$727aa5ec3fe39bf0,
                    format: $0d23c856ce11c301$export$3f8bb04b555a363c
                };
                shadow.map = new $0d23c856ce11c301$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (!shadow.isPointLightShadow && this.type === $0d23c856ce11c301$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterialVariant(useMorphing) {
        const index = useMorphing << 0;
        let material = _depthMaterials[index];
        if (material === undefined) {
            material = new $0d23c856ce11c301$export$2698c22ec13825db({
                depthPacking: $0d23c856ce11c301$export$8f910f4c4f73df11,
                morphTargets: useMorphing
            });
            _depthMaterials[index] = material;
        }
        return material;
    }
    function getDistanceMaterialVariant(useMorphing) {
        const index = useMorphing << 0;
        let material = _distanceMaterials[index];
        if (material === undefined) {
            material = new $0d23c856ce11c301$export$33e187ed002f2a19({
                morphTargets: useMorphing
            });
            _distanceMaterials[index] = material;
        }
        return material;
    }
    function getDepthMaterial(object, geometry, material, light, shadowCameraNear, shadowCameraFar, type) {
        let result = null;
        let getMaterialVariant = getDepthMaterialVariant;
        let customMaterial = object.customDepthMaterial;
        if (light.isPointLight === true) {
            getMaterialVariant = getDistanceMaterialVariant;
            customMaterial = object.customDistanceMaterial;
        }
        if (customMaterial === undefined) {
            let useMorphing = false;
            if (material.morphTargets === true) useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;
            result = getMaterialVariant(useMorphing);
        } else result = customMaterial;
        if (_renderer.localClippingEnabled && material.clipShadows === true && material.clippingPlanes.length !== 0) {
            // in this case we need a unique material instance reflecting the
            // appropriate state
            const keyA = result.uuid, keyB = material.uuid;
            let materialsForVariant = _materialCache[keyA];
            if (materialsForVariant === undefined) {
                materialsForVariant = {};
                _materialCache[keyA] = materialsForVariant;
            }
            let cachedMaterial = materialsForVariant[keyB];
            if (cachedMaterial === undefined) {
                cachedMaterial = result.clone();
                materialsForVariant[keyB] = cachedMaterial;
            }
            result = cachedMaterial;
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $0d23c856ce11c301$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            result.referencePosition.setFromMatrixPosition(light.matrixWorld);
            result.nearDistance = shadowCameraNear;
            result.farDistance = shadowCameraFar;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $0d23c856ce11c301$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, geometry, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, geometry, material, light, shadowCamera.near, shadowCamera.far, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $0d23c856ce11c301$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $0d23c856ce11c301$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $0d23c856ce11c301$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(2929);
                else disable(2929);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    if (depthFunc) switch(depthFunc){
                        case $0d23c856ce11c301$export$69025ce147cee220:
                            gl.depthFunc(512);
                            break;
                        case $0d23c856ce11c301$export$7182eb52ea3b3f04:
                            gl.depthFunc(519);
                            break;
                        case $0d23c856ce11c301$export$eedccec66ab7ebe:
                            gl.depthFunc(513);
                            break;
                        case $0d23c856ce11c301$export$296f78a0b892f81a:
                            gl.depthFunc(515);
                            break;
                        case $0d23c856ce11c301$export$a60d398fc7b7590e:
                            gl.depthFunc(514);
                            break;
                        case $0d23c856ce11c301$export$7d7234c1240a1fc4:
                            gl.depthFunc(518);
                            break;
                        case $0d23c856ce11c301$export$c5e2c52991f30937:
                            gl.depthFunc(516);
                            break;
                        case $0d23c856ce11c301$export$2f843afa843d8916:
                            gl.depthFunc(517);
                            break;
                        default:
                            gl.depthFunc(515);
                    }
                    else gl.depthFunc(515);
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(2960);
                    else disable(2960);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    let enabledCapabilities = {};
    let xrFramebuffer = null;
    let currentBoundFramebuffers = {};
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(35661);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(7938);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(3088);
    const viewportParam = gl.getParameter(2978);
    const currentScissor = new $0d23c856ce11c301$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $0d23c856ce11c301$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, 10241, 9728);
        gl.texParameteri(type, 10240, 9728);
        for(let i = 0; i < count; i++)gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[3553] = createTexture(3553, 3553, 1);
    emptyTextures[34067] = createTexture(34067, 34069, 6);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(2929);
    depthBuffer.setFunc($0d23c856ce11c301$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($0d23c856ce11c301$export$b9a7b4fc5cb15f9b);
    enable(2884);
    setBlending($0d23c856ce11c301$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindXRFramebuffer(framebuffer) {
        if (framebuffer !== xrFramebuffer) {
            gl.bindFramebuffer(36160, framebuffer);
            xrFramebuffer = framebuffer;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (framebuffer === null && xrFramebuffer !== null) framebuffer = xrFramebuffer; // use active XR framebuffer if available
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // 36009 is equivalent to 36160
                if (target === 36009) currentBoundFramebuffers[36160] = framebuffer;
                if (target === 36160) currentBoundFramebuffers[36009] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$0d23c856ce11c301$export$20183a0484ce21a0]: 32774,
        [$0d23c856ce11c301$export$73e0df5177988548]: 32778,
        [$0d23c856ce11c301$export$28e582859cbec660]: 32779
    };
    if (isWebGL2) {
        equationToGL[$0d23c856ce11c301$export$c8c1508da8d0600c] = 32775;
        equationToGL[$0d23c856ce11c301$export$99948c02fb51055f] = 32776;
    } else {
        const extension = extensions.get("EXT_blend_minmax");
        if (extension !== null) {
            equationToGL[$0d23c856ce11c301$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$0d23c856ce11c301$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$0d23c856ce11c301$export$2110f05edf778d3d]: 0,
        [$0d23c856ce11c301$export$8805bad65e24940e]: 1,
        [$0d23c856ce11c301$export$7fbe15b28d28cf52]: 768,
        [$0d23c856ce11c301$export$d5773124e86cf28c]: 770,
        [$0d23c856ce11c301$export$c05e2a1fc8609506]: 776,
        [$0d23c856ce11c301$export$ef5f2dd8ffac5574]: 774,
        [$0d23c856ce11c301$export$a78aed1ca2a87192]: 772,
        [$0d23c856ce11c301$export$947829af9f2c17f6]: 769,
        [$0d23c856ce11c301$export$11d468cc7f19e971]: 771,
        [$0d23c856ce11c301$export$56b85b2686ab16]: 775,
        [$0d23c856ce11c301$export$5d0fe17fd8773bac]: 773
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $0d23c856ce11c301$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(3042);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(3042);
            currentBlendingEnabled = true;
        }
        if (blending !== $0d23c856ce11c301$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $0d23c856ce11c301$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $0d23c856ce11c301$export$20183a0484ce21a0) {
                    gl.blendEquation(32774);
                    currentBlendEquation = $0d23c856ce11c301$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $0d23c856ce11c301$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $0d23c856ce11c301$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case $0d23c856ce11c301$export$777d8f9551c2216b:
                        gl.blendFunc(1, 1);
                        break;
                    case $0d23c856ce11c301$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 0, 769, 771);
                        break;
                    case $0d23c856ce11c301$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $0d23c856ce11c301$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case $0d23c856ce11c301$export$777d8f9551c2216b:
                        gl.blendFunc(770, 1);
                        break;
                    case $0d23c856ce11c301$export$cdfa06f868e2e467:
                        gl.blendFunc(0, 769);
                        break;
                    case $0d23c856ce11c301$export$4138e1c684b46a20:
                        gl.blendFunc(0, 768);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = null;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $0d23c856ce11c301$export$3b296b6f144d5b03 ? disable(2884) : enable(2884);
        let flipSided = material.side === $0d23c856ce11c301$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $0d23c856ce11c301$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($0d23c856ce11c301$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(32926) : disable(32926);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(2304);
            else gl.frontFace(2305);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $0d23c856ce11c301$export$3237e1f2c1ea1f44) {
            enable(2884);
            if (cullFace !== currentCullFace) {
                if (cullFace === $0d23c856ce11c301$export$b9a7b4fc5cb15f9b) gl.cullFace(1029);
                else if (cullFace === $0d23c856ce11c301$export$b8058bcc7037d3f3) gl.cullFace(1028);
                else gl.cullFace(1032);
            }
        } else disable(2884);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(32823);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(32823);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(3089);
        else disable(3089);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture) {
        if (currentTextureSlot === null) activeTexture();
        let boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[currentTextureSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(3042);
        gl.disable(2884);
        gl.disable(2929);
        gl.disable(32823);
        gl.disable(3089);
        gl.disable(2960);
        gl.disable(32926);
        gl.blendEquation(32774);
        gl.blendFunc(1, 0);
        gl.blendFuncSeparate(1, 0, 1, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(513);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(519, 0, 0xffffffff);
        gl.stencilOp(7680, 7680, 7680);
        gl.clearStencil(0);
        gl.cullFace(1029);
        gl.frontFace(2305);
        gl.polygonOffset(0, 0);
        gl.activeTexture(33984);
        gl.bindFramebuffer(36160, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(36009, null);
            gl.bindFramebuffer(36008, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        xrFramebuffer = null;
        currentBoundFramebuffers = {};
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        bindXRFramebuffer: bindXRFramebuffer,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $0d23c856ce11c301$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const _videoTextures = new WeakMap();
    let _canvas;
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? new OffscreenCanvas(width, height) : document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $0d23c856ce11c301$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $0d23c856ce11c301$var$isPowerOfTwo(image.width) && $0d23c856ce11c301$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $0d23c856ce11c301$export$9d9334239a5a5e06 || texture.wrapT !== $0d23c856ce11c301$export$9d9334239a5a5e06 || texture.minFilter !== $0d23c856ce11c301$export$727aa5ec3fe39bf0 && texture.minFilter !== $0d23c856ce11c301$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $0d23c856ce11c301$export$727aa5ec3fe39bf0 && texture.minFilter !== $0d23c856ce11c301$export$8a72f490b25c56c8;
    }
    function generateMipmap(target, texture, width, height, depth = 1) {
        _gl.generateMipmap(target);
        const textureProperties = properties.get(texture);
        textureProperties.__maxMipLevel = Math.log2(Math.max(width, height, depth));
    }
    function getInternalFormat(internalFormatName, glFormat, glType) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === 6403) {
            if (glType === 5126) internalFormat = 33326;
            if (glType === 5131) internalFormat = 33325;
            if (glType === 5121) internalFormat = 33321;
        }
        if (glFormat === 6407) {
            if (glType === 5126) internalFormat = 34837;
            if (glType === 5131) internalFormat = 34843;
            if (glType === 5121) internalFormat = 32849;
        }
        if (glFormat === 6408) {
            if (glType === 5126) internalFormat = 34836;
            if (glType === 5131) internalFormat = 34842;
            if (glType === 5121) internalFormat = 32856;
        }
        if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 34842 || internalFormat === 34836) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $0d23c856ce11c301$export$727aa5ec3fe39bf0 || f === $0d23c856ce11c301$export$d129e38cf6feaa8c || f === $0d23c856ce11c301$export$d2327c1afe5bfdf2) return 9728;
        return 9729;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
        info.memory.textures--;
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        _gl.deleteTexture(textureProperties.__webglTexture);
        properties.remove(texture);
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (!renderTarget) return;
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer);
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === undefined) console.warn("THREE.WebGLRenderer: Texture marked for update but image is undefined");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(3553, textureProperties.__webglTexture);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(35866, textureProperties.__webglTexture);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(32879, textureProperties.__webglTexture);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
    }
    const wrappingToGL = {
        [$0d23c856ce11c301$export$533346c8e8dac0f5]: 10497,
        [$0d23c856ce11c301$export$9d9334239a5a5e06]: 33071,
        [$0d23c856ce11c301$export$c7e7c00b14f51a4f]: 33648
    };
    const filterToGL = {
        [$0d23c856ce11c301$export$727aa5ec3fe39bf0]: 9728,
        [$0d23c856ce11c301$export$d129e38cf6feaa8c]: 9984,
        [$0d23c856ce11c301$export$d2327c1afe5bfdf2]: 9986,
        [$0d23c856ce11c301$export$8a72f490b25c56c8]: 9729,
        [$0d23c856ce11c301$export$19a719f377145a13]: 9985,
        [$0d23c856ce11c301$export$5d8599b6a933fb1b]: 9987
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, 10242, 33071);
            _gl.texParameteri(textureType, 10243, 33071);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, 33071);
            if (texture.wrapS !== $0d23c856ce11c301$export$9d9334239a5a5e06 || texture.wrapT !== $0d23c856ce11c301$export$9d9334239a5a5e06) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
            _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
            if (texture.minFilter !== $0d23c856ce11c301$export$727aa5ec3fe39bf0 && texture.minFilter !== $0d23c856ce11c301$export$8a72f490b25c56c8) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            if (texture.type === $0d23c856ce11c301$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $0d23c856ce11c301$export$2697304443f382bc && extensions.has("OES_texture_half_float_linear") === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
            textureProperties.__webglTexture = _gl.createTexture();
            info.memory.textures++;
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = 3553;
        if (texture.isDataTexture2DArray) textureType = 35866;
        if (texture.isDataTexture3D) textureType = 32879;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(textureType, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        _gl.pixelStorei(37443, 0);
        const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
        const image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
        const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format);
        let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        setTextureParameters(textureType, texture, supportsMips);
        let mipmap;
        const mipmaps = texture.mipmaps;
        if (texture.isDepthTexture) {
            // populate depth texture with dummy data
            glInternalFormat = 6402;
            if (isWebGL2) {
                if (texture.type === $0d23c856ce11c301$export$f6d331659b644596) glInternalFormat = 36012;
                else if (texture.type === $0d23c856ce11c301$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                else if (texture.type === $0d23c856ce11c301$export$6c8ea339bfab1301) glInternalFormat = 35056;
                else glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
            } else if (texture.type === $0d23c856ce11c301$export$f6d331659b644596) console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
            // validation checks for WebGL 1
            if (texture.format === $0d23c856ce11c301$export$c1b6b5136be58045 && glInternalFormat === 6402) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
            // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
            // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
            {
                if (texture.type !== $0d23c856ce11c301$export$c63dc51868b06a9d && texture.type !== $0d23c856ce11c301$export$c3c7fc4518ebba96) {
                    console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
                    texture.type = $0d23c856ce11c301$export$c63dc51868b06a9d;
                    glType = utils.convert(texture.type);
                }
            }
            if (texture.format === $0d23c856ce11c301$export$1e113ac2d0905829 && glInternalFormat === 6402) {
                // Depth stencil textures need the DEPTH_STENCIL internal format
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                glInternalFormat = 34041;
                // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                if (texture.type !== $0d23c856ce11c301$export$6c8ea339bfab1301) {
                    console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
                    texture.type = $0d23c856ce11c301$export$6c8ea339bfab1301;
                    glType = utils.convert(texture.type);
                }
            }
            //
            state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
        } else if (texture.isDataTexture) {
            // use manually created mipmaps if available
            // if there are no manual mipmaps
            // set 0 level mipmap and then use GL to generate other mipmap levels
            if (mipmaps.length > 0 && supportsMips) {
                for(let i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
                texture.generateMipmaps = false;
                textureProperties.__maxMipLevel = mipmaps.length - 1;
            } else {
                state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
                textureProperties.__maxMipLevel = 0;
            }
        } else if (texture.isCompressedTexture) {
            for(let i = 0, il = mipmaps.length; i < il; i++){
                mipmap = mipmaps[i];
                if (texture.format !== $0d23c856ce11c301$export$3f8bb04b555a363c && texture.format !== $0d23c856ce11c301$export$7c67423a5ee6f5eb) {
                    if (glFormat !== null) state.compressedTexImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                    else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                } else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else if (texture.isDataTexture2DArray) {
            state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            textureProperties.__maxMipLevel = 0;
        } else if (texture.isDataTexture3D) {
            state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            textureProperties.__maxMipLevel = 0;
        } else // regular Texture (image, video, canvas)
        // use manually created mipmaps if available
        // if there are no manual mipmaps
        // set 0 level mipmap and then use GL to generate other mipmap levels
        if (mipmaps.length > 0 && supportsMips) {
            for(let i = 0, il = mipmaps.length; i < il; i++){
                mipmap = mipmaps[i];
                state.texImage2D(3553, i, glInternalFormat, glFormat, glType, mipmap);
            }
            texture.generateMipmaps = false;
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else {
            state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
            textureProperties.__maxMipLevel = 0;
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType, texture, image.width, image.height);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        _gl.pixelStorei(37443, 0);
        const isCompressed = texture && (texture.isCompressedTexture || texture.image[0].isCompressedTexture);
        const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
        const cubeImage = [];
        for(let i = 0; i < 6; i++)if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
        else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
        const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        setTextureParameters(34067, texture, supportsMips);
        let mipmaps;
        if (isCompressed) {
            for(let i = 0; i < 6; i++){
                mipmaps = cubeImage[i].mipmaps;
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    if (texture.format !== $0d23c856ce11c301$export$3f8bb04b555a363c && texture.format !== $0d23c856ce11c301$export$7c67423a5ee6f5eb) {
                        if (glFormat !== null) state.compressedTexImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                        else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                    } else state.texImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
            }
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else {
            mipmaps = texture.mipmaps;
            for(let i = 0; i < 6; i++)if (isDataTexture) {
                state.texImage2D(34069 + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    const mipmapImage = mipmap.image[i].image;
                    state.texImage2D(34069 + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                }
            } else {
                state.texImage2D(34069 + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    state.texImage2D(34069 + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                }
            }
            textureProperties.__maxMipLevel = mipmaps.length;
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
        generateMipmap(34067, texture, image.width, image.height);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        const glFormat = utils.convert(texture.format);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        if (textureTarget === 32879 || textureTarget === 35866) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
        else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        state.bindFramebuffer(36160, framebuffer);
        _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(36160, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(36161, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = 33189;
            if (isMultisample) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $0d23c856ce11c301$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (depthTexture.type === $0d23c856ce11c301$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                }
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            if (isMultisample) {
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
        } else {
            // Use the first texture for MRT so far
            const texture = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture[0] : renderTarget.texture;
            const glFormat = utils.convert(texture.format);
            const glType = utils.convert(texture.type);
            const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
            if (isMultisample) {
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
        }
        _gl.bindRenderbuffer(36161, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(36160, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        if (renderTarget.depthTexture.format === $0d23c856ce11c301$export$c1b6b5136be58045) _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
        else if (renderTarget.depthTexture.format === $0d23c856ce11c301$export$1e113ac2d0905829) _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
        else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(36160, null);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const isMultisample = renderTarget.isWebGLMultisampleRenderTarget === true;
        const isRenderTarget3D = texture.isDataTexture3D || texture.isDataTexture2DArray;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Handles WebGL2 RGBFormat fallback - #18858
        if (isWebGL2 && texture.format === $0d23c856ce11c301$export$7c67423a5ee6f5eb && (texture.type === $0d23c856ce11c301$export$f6d331659b644596 || texture.type === $0d23c856ce11c301$export$2697304443f382bc)) {
            texture.format = $0d23c856ce11c301$export$3f8bb04b555a363c;
            console.warn("THREE.WebGLRenderer: Rendering to textures with RGB format is not supported. Using RGBA format instead.");
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            } else if (isMultisample) {
                if (isWebGL2) {
                    renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                    renderTargetProperties.__webglColorRenderbuffer = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer);
                    const glFormat = utils.convert(texture.format);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(36160, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer);
                    _gl.bindRenderbuffer(36161, null);
                    if (renderTarget.depthBuffer) {
                        renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                        setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                    }
                    state.bindFramebuffer(36160, null);
                } else console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(34067, textureProperties.__webglTexture);
            setTextureParameters(34067, texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, 36064, 34069 + i);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(34067, texture, renderTarget.width, renderTarget.height);
            state.bindTexture(34067, null);
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(3553, attachmentProperties.__webglTexture);
                setTextureParameters(3553, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i, 3553);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(3553, attachment, renderTarget.width, renderTarget.height);
            }
            state.bindTexture(3553, null);
        } else {
            let glTextureType = 3553;
            if (isRenderTarget3D) {
                // Render targets containing layers, i.e: Texture 3D and 2d arrays
                if (isWebGL2) {
                    const isTexture3D = texture.isDataTexture3D;
                    glTextureType = isTexture3D ? 32879 : 35866;
                } else console.warn("THREE.DataTexture3D and THREE.DataTexture2DArray only supported with WebGL2.");
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType, texture, renderTarget.width, renderTarget.height, renderTarget.depth);
            state.bindTexture(glTextureType, null);
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target, texture, renderTarget.width, renderTarget.height);
                state.bindTexture(target, null);
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.isWebGLMultisampleRenderTarget) {
            if (isWebGL2) {
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = 16384;
                if (renderTarget.depthBuffer) mask |= 256;
                if (renderTarget.stencilBuffer) mask |= 1024;
                const renderTargetProperties = properties.get(renderTarget);
                state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                state.bindFramebuffer(36008, null);
                state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
            } else console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return isWebGL2 && renderTarget.isWebGLMultisampleRenderTarget ? Math.min(maxSamples, renderTarget.samples) : 0;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    // backwards compatibility
    let warnedTexture2D = false;
    let warnedTextureCube = false;
    function safeSetTexture2D(texture, slot) {
        if (texture && texture.isWebGLRenderTarget) {
            if (warnedTexture2D === false) {
                console.warn("THREE.WebGLTextures.safeSetTexture2D: don't use render targets as textures. Use their .texture property instead.");
                warnedTexture2D = true;
            }
            texture = texture.texture;
        }
        setTexture2D(texture, slot);
    }
    function safeSetTextureCube(texture, slot) {
        if (texture && texture.isWebGLCubeRenderTarget) {
            if (warnedTextureCube === false) {
                console.warn("THREE.WebGLTextures.safeSetTextureCube: don't use cube render targets as textures. Use their .texture property instead.");
                warnedTextureCube = true;
            }
            texture = texture.texture;
        }
        setTextureCube(texture, slot);
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.safeSetTexture2D = safeSetTexture2D;
    this.safeSetTextureCube = safeSetTextureCube;
}
function $0d23c856ce11c301$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p) {
        let extension;
        if (p === $0d23c856ce11c301$export$2e8ce08d3f6f5e10) return 5121;
        if (p === $0d23c856ce11c301$export$b3969b01faf587f2) return 32819;
        if (p === $0d23c856ce11c301$export$18886f8ae33e90de) return 32820;
        if (p === $0d23c856ce11c301$export$cb1fa50553eb14c4) return 33635;
        if (p === $0d23c856ce11c301$export$545fce0311a9796a) return 5120;
        if (p === $0d23c856ce11c301$export$88572337f312435f) return 5122;
        if (p === $0d23c856ce11c301$export$c63dc51868b06a9d) return 5123;
        if (p === $0d23c856ce11c301$export$5c612977753abe2) return 5124;
        if (p === $0d23c856ce11c301$export$c3c7fc4518ebba96) return 5125;
        if (p === $0d23c856ce11c301$export$f6d331659b644596) return 5126;
        if (p === $0d23c856ce11c301$export$2697304443f382bc) {
            if (isWebGL2) return 5131;
            extension = extensions.get("OES_texture_half_float");
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $0d23c856ce11c301$export$988473390501ed4b) return 6406;
        if (p === $0d23c856ce11c301$export$7c67423a5ee6f5eb) return 6407;
        if (p === $0d23c856ce11c301$export$3f8bb04b555a363c) return 6408;
        if (p === $0d23c856ce11c301$export$cc09ccbf6d1ed449) return 6409;
        if (p === $0d23c856ce11c301$export$9053a81c4a69c289) return 6410;
        if (p === $0d23c856ce11c301$export$c1b6b5136be58045) return 6402;
        if (p === $0d23c856ce11c301$export$1e113ac2d0905829) return 34041;
        if (p === $0d23c856ce11c301$export$4e041a7967d15c4b) return 6403;
        // WebGL2 formats.
        if (p === $0d23c856ce11c301$export$aa92e870a709d190) return 36244;
        if (p === $0d23c856ce11c301$export$6cdf0b461c7ce8a0) return 33319;
        if (p === $0d23c856ce11c301$export$1ba1c45f9f77d4d7) return 33320;
        if (p === $0d23c856ce11c301$export$d1fd40c11bfa798e) return 36248;
        if (p === $0d23c856ce11c301$export$c200e7d26f592f21) return 36249;
        if (p === $0d23c856ce11c301$export$21d1799c6d552fc0 || p === $0d23c856ce11c301$export$afa304c3e981b668 || p === $0d23c856ce11c301$export$d2a1a68024a3e56c || p === $0d23c856ce11c301$export$9a79c424327dacf9) {
            extension = extensions.get("WEBGL_compressed_texture_s3tc");
            if (extension !== null) {
                if (p === $0d23c856ce11c301$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                if (p === $0d23c856ce11c301$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                if (p === $0d23c856ce11c301$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                if (p === $0d23c856ce11c301$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            } else return null;
        }
        if (p === $0d23c856ce11c301$export$19ada9bbb1af3573 || p === $0d23c856ce11c301$export$d0f0355bb3d948e4 || p === $0d23c856ce11c301$export$b82296714358084c || p === $0d23c856ce11c301$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $0d23c856ce11c301$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $0d23c856ce11c301$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $0d23c856ce11c301$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $0d23c856ce11c301$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        if (p === $0d23c856ce11c301$export$6ab91af2d757aee7) {
            extension = extensions.get("WEBGL_compressed_texture_etc1");
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        if (p === $0d23c856ce11c301$export$7800993ef8106a6a || p === $0d23c856ce11c301$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $0d23c856ce11c301$export$7800993ef8106a6a) return extension.COMPRESSED_RGB8_ETC2;
                if (p === $0d23c856ce11c301$export$23ed8300a860e7d8) return extension.COMPRESSED_RGBA8_ETC2_EAC;
            }
        }
        if (p === $0d23c856ce11c301$export$dc5570b4a2b92d48 || p === $0d23c856ce11c301$export$68880cd325f8b2fb || p === $0d23c856ce11c301$export$7d2c0be323373d95 || p === $0d23c856ce11c301$export$22b52da301fc3a3e || p === $0d23c856ce11c301$export$c009e2cb4a66485e || p === $0d23c856ce11c301$export$118fff5afa255b63 || p === $0d23c856ce11c301$export$120713c829ae0667 || p === $0d23c856ce11c301$export$c79eeabbf53313e9 || p === $0d23c856ce11c301$export$443cf6567cdd6424 || p === $0d23c856ce11c301$export$6573984fc9840780 || p === $0d23c856ce11c301$export$e7aee563f30091de || p === $0d23c856ce11c301$export$2eb8634622ddeab7 || p === $0d23c856ce11c301$export$202b1ce7b5d25742 || p === $0d23c856ce11c301$export$18ab77abd087e467 || p === $0d23c856ce11c301$export$4487000d1baf578b || p === $0d23c856ce11c301$export$4a1746c7512b1ea1 || p === $0d23c856ce11c301$export$4208debc782f5653 || p === $0d23c856ce11c301$export$82c5f9d3037aaea3 || p === $0d23c856ce11c301$export$64e357a152723eb9 || p === $0d23c856ce11c301$export$1b7711037f5e380e || p === $0d23c856ce11c301$export$eb234716dfb52c31 || p === $0d23c856ce11c301$export$8041d2df79c555f || p === $0d23c856ce11c301$export$27d2c8c0fcc7b83a || p === $0d23c856ce11c301$export$27b9de07b84a1334 || p === $0d23c856ce11c301$export$5c2b31a31ccc15c8 || p === $0d23c856ce11c301$export$5c4d4b335786f8f3 || p === $0d23c856ce11c301$export$e0c50c800e38be11 || p === $0d23c856ce11c301$export$9b0442bae422b2db) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) // TODO Complete?
            return p;
            else return null;
        }
        if (p === $0d23c856ce11c301$export$ce40b115e188bc81) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) // TODO Complete?
            return p;
            else return null;
        }
        if (p === $0d23c856ce11c301$export$6c8ea339bfab1301) {
            if (isWebGL2) return 34042;
            extension = extensions.get("WEBGL_depth_texture");
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
    }
    return {
        convert: convert
    };
}
class $0d23c856ce11c301$export$56b937d9e5581166 extends $0d23c856ce11c301$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.cameras = array;
    }
}
$0d23c856ce11c301$export$56b937d9e5581166.prototype.isArrayCamera = true;
class $0d23c856ce11c301$export$eb2fcfdbd7ba97d4 extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Group";
    }
}
$0d23c856ce11c301$export$eb2fcfdbd7ba97d4.prototype.isGroup = true;
const $0d23c856ce11c301$var$_moveEvent = {
    type: "move"
};
class $0d23c856ce11c301$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $0d23c856ce11c301$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $0d23c856ce11c301$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $0d23c856ce11c301$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $0d23c856ce11c301$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($0d23c856ce11c301$var$_moveEvent);
                }
            }
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    if (hand.joints[inputjoint.jointName] === undefined) {
                        // The transform of this joint will be updated with the joint pose on each frame
                        const joint = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
                        joint.matrixAutoUpdate = false;
                        joint.visible = false;
                        hand.joints[inputjoint.jointName] = joint;
                        // ??
                        hand.add(joint);
                    }
                    const joint = hand.joints[inputjoint.jointName];
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
}
class $0d23c856ce11c301$var$WebXRManager extends $0d23c856ce11c301$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        const state = renderer.state;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        let pose = null;
        let glBinding = null;
        let glFramebuffer = null;
        let glProjLayer = null;
        const controllers = [];
        const inputSourcesMap = new Map();
        //
        const cameraL = new $0d23c856ce11c301$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $0d23c856ce11c301$export$fa7daccca11cdbe3();
        const cameraR = new $0d23c856ce11c301$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $0d23c856ce11c301$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraVR = new $0d23c856ce11c301$export$56b937d9e5581166();
        cameraVR.layers.enable(1);
        cameraVR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0d23c856ce11c301$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0d23c856ce11c301$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0d23c856ce11c301$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controller = inputSourcesMap.get(event.inputSource);
            if (controller) controller.dispatchEvent({
                type: event.type,
                data: event.inputSource
            });
        }
        function onSessionEnd() {
            inputSourcesMap.forEach(function(controller, inputSource) {
                controller.disconnect(inputSource);
            });
            inputSourcesMap.clear();
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            state.bindXRFramebuffer(null);
            renderer.setRenderTarget(renderer.getRenderTarget());
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return referenceSpace;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                const attributes = gl.getContextAttributes();
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: attributes.alpha,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    // eslint-disable-next-line no-undef
                    const baseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: baseLayer
                    });
                } else {
                    let depthFormat = 0;
                    if (attributes.depth) depthFormat = attributes.stencil ? 34041 : 6402;
                    const projectionlayerInit = {
                        colorFormat: attributes.alpha ? 6408 : 6407,
                        depthFormat: depthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    // eslint-disable-next-line no-undef
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    glFramebuffer = gl.createFramebuffer();
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                }
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        function onInputSourcesChange(event) {
            const inputSources = session.inputSources;
            // Assign inputSources to available controllers
            for(let i = 0; i < controllers.length; i++)inputSourcesMap.set(inputSources[i], controllers[i]);
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const controller = inputSourcesMap.get(inputSource);
                if (controller) {
                    controller.dispatchEvent({
                        type: "disconnected",
                        data: inputSource
                    });
                    inputSourcesMap.delete(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                const controller = inputSourcesMap.get(inputSource);
                if (controller) controller.dispatchEvent({
                    type: "connected",
                    data: inputSource
                });
            }
        }
        //
        const cameraLPos = new $0d23c856ce11c301$export$64b5c384219d3699();
        const cameraRPos = new $0d23c856ce11c301$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraVR.near = cameraR.near = cameraL.near = camera.near;
            cameraVR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraVR.near,
                    depthFar: cameraVR.far
                });
                _currentDepthNear = cameraVR.near;
                _currentDepthFar = cameraVR.far;
            }
            const parent = camera.parent;
            const cameras = cameraVR.cameras;
            updateCamera(cameraVR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            cameraVR.matrixWorld.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
            // update user camera and its children
            camera.position.copy(cameraVR.position);
            camera.quaternion.copy(cameraVR.quaternion);
            camera.scale.copy(cameraVR.scale);
            camera.matrix.copy(cameraVR.matrix);
            camera.matrixWorld.copy(cameraVR.matrixWorld);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
        };
        this.getCamera = function() {
            return cameraVR;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(referenceSpace);
            if (pose !== null) {
                const views = pose.views;
                const baseLayer = session.renderState.baseLayer;
                if (session.renderState.layers === undefined) state.bindXRFramebuffer(baseLayer.framebuffer);
                let cameraVRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraVR's camera list
                if (views.length !== cameraVR.cameras.length) {
                    cameraVR.cameras.length = 0;
                    cameraVRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (session.renderState.layers === undefined) viewport = baseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        state.bindXRFramebuffer(glFramebuffer);
                        gl.framebufferTexture2D(36160, 36064, 3553, glSubImage.colorTexture, 0);
                        if (glSubImage.depthStencilTexture !== undefined) gl.framebufferTexture2D(36160, 36096, 3553, glSubImage.depthStencilTexture, 0);
                        viewport = glSubImage.viewport;
                    }
                    const camera = cameras[i];
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) cameraVR.matrix.copy(camera.matrix);
                    if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
                }
            }
            //
            const inputSources = session.inputSources;
            for(let i = 0; i < controllers.length; i++){
                const controller = controllers[i];
                const inputSource = inputSources[i];
                controller.update(inputSource, frame, referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
        }
        const animation = new $0d23c856ce11c301$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $0d23c856ce11c301$var$WebGLMaterials(properties) {
    function refreshFogUniforms(uniforms, fog) {
        uniforms.fogColor.value.copy(fog.color);
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsLambert(uniforms, material);
        } else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
            else refreshUniformsStandard(uniforms, material);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDepth(uniforms, material);
        } else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsNormal(uniforms, material);
        } else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.specularMap) uniforms.specularMap.value = material.specularMap;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap._needsFlipEnvMap ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.refractionRatio.value = material.refractionRatio;
            const maxMipLevel = properties.get(envMap).__maxMipLevel;
            if (maxMipLevel !== undefined) uniforms.maxMipLevel.value = maxMipLevel;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
        }
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. specular map
        // 3. displacementMap map
        // 4. normal map
        // 5. bump map
        // 6. roughnessMap map
        // 7. metalnessMap map
        // 8. alphaMap map
        // 9. emissiveMap map
        // 10. clearcoat map
        // 11. clearcoat normal map
        // 12. clearcoat roughnessMap map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.specularMap) uvScaleMap = material.specularMap;
        else if (material.displacementMap) uvScaleMap = material.displacementMap;
        else if (material.normalMap) uvScaleMap = material.normalMap;
        else if (material.bumpMap) uvScaleMap = material.bumpMap;
        else if (material.roughnessMap) uvScaleMap = material.roughnessMap;
        else if (material.metalnessMap) uvScaleMap = material.metalnessMap;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        else if (material.emissiveMap) uvScaleMap = material.emissiveMap;
        else if (material.clearcoatMap) uvScaleMap = material.clearcoatMap;
        else if (material.clearcoatNormalMap) uvScaleMap = material.clearcoatNormalMap;
        else if (material.clearcoatRoughnessMap) uvScaleMap = material.clearcoatRoughnessMap;
        if (uvScaleMap !== undefined) {
            // backwards compatibility
            if (uvScaleMap.isWebGLRenderTarget) uvScaleMap = uvScaleMap.texture;
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
        // uv repeat and offset setting priorities for uv2
        // 1. ao map
        // 2. light map
        let uv2ScaleMap;
        if (material.aoMap) uv2ScaleMap = material.aoMap;
        else if (material.lightMap) uv2ScaleMap = material.lightMap;
        if (uv2ScaleMap !== undefined) {
            // backwards compatibility
            if (uv2ScaleMap.isWebGLRenderTarget) uv2ScaleMap = uv2ScaleMap.texture;
            if (uv2ScaleMap.matrixAutoUpdate === true) uv2ScaleMap.updateMatrix();
            uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsLambert(uniforms, material) {
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.roughness.value = material.roughness;
        uniforms.metalness.value = material.metalness;
        if (material.roughnessMap) uniforms.roughnessMap.value = material.roughnessMap;
        if (material.metalnessMap) uniforms.metalnessMap.value = material.metalnessMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        refreshUniformsStandard(uniforms, material);
        uniforms.reflectivity.value = material.reflectivity; // also part of uniforms common
        uniforms.clearcoat.value = material.clearcoat;
        uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
        if (material.sheen) uniforms.sheen.value.copy(material.sheen);
        if (material.clearcoatMap) uniforms.clearcoatMap.value = material.clearcoatMap;
        if (material.clearcoatRoughnessMap) uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
        if (material.clearcoatNormalMap) {
            uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
            uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
            if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
        }
        uniforms.transmission.value = material.transmission;
        if (material.transmissionMap) uniforms.transmissionMap.value = material.transmissionMap;
        if (material.transmission > 0.0) {
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
        }
        uniforms.thickness.value = material.thickness;
        if (material.thicknessMap) uniforms.thicknessMap.value = material.thicknessMap;
        uniforms.attenuationDistance.value = material.attenuationDistance;
        uniforms.attenuationColor.value.copy(material.attenuationColor);
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDepth(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDistance(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        uniforms.referencePosition.value.copy(material.referencePosition);
        uniforms.nearDistance.value = material.nearDistance;
        uniforms.farDistance.value = material.farDistance;
    }
    function refreshUniformsNormal(uniforms, material) {
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0d23c856ce11c301$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $0d23c856ce11c301$var$createCanvasElement() {
    const canvas = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
    canvas.style.display = "block";
    return canvas;
}
function $0d23c856ce11c301$export$f6cc00ef28d7cf97(parameters = {}) {
    const _canvas = parameters.canvas !== undefined ? parameters.canvas : $0d23c856ce11c301$var$createCanvasElement(), _context = parameters.context !== undefined ? parameters.context : null, _alpha = parameters.alpha !== undefined ? parameters.alpha : false, _depth = parameters.depth !== undefined ? parameters.depth : true, _stencil = parameters.stencil !== undefined ? parameters.stencil : true, _antialias = parameters.antialias !== undefined ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : "default", _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;
    let currentRenderList = null;
    let currentRenderState = null;
    // render() can be called from within a callback triggered by another render.
    // We track this so that the nested render call gets its list and state isolated from the parent render call.
    const renderListStack = [];
    const renderStateStack = [];
    // public properties
    this.domElement = _canvas;
    // Debug configuration container
    this.debug = {
        /**
		 * Enables error checking and reporting when shader programs are being compiled
		 * @type {boolean}
		 */ checkShaderErrors: true
    };
    // clearing
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    // scene graph
    this.sortObjects = true;
    // user-defined clipping
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    // physically based shading
    this.gammaFactor = 2.0; // for backwards compatibility
    this.outputEncoding = $0d23c856ce11c301$export$7207336e4151a112;
    // physical lights
    this.physicallyCorrectLights = false;
    // tone mapping
    this.toneMapping = $0d23c856ce11c301$export$9fcb6b4294603b2;
    this.toneMappingExposure = 1.0;
    // internal properties
    const _this = this;
    let _isContextLost = false;
    // internal state cache
    let _currentActiveCubeFace = 0;
    let _currentActiveMipmapLevel = 0;
    let _currentRenderTarget = null;
    let _currentMaterialId = -1;
    let _currentCamera = null;
    const _currentViewport = new $0d23c856ce11c301$export$fa7daccca11cdbe3();
    const _currentScissor = new $0d23c856ce11c301$export$fa7daccca11cdbe3();
    let _currentScissorTest = null;
    //
    let _width = _canvas.width;
    let _height = _canvas.height;
    let _pixelRatio = 1;
    let _opaqueSort = null;
    let _transparentSort = null;
    const _viewport = new $0d23c856ce11c301$export$fa7daccca11cdbe3(0, 0, _width, _height);
    const _scissor = new $0d23c856ce11c301$export$fa7daccca11cdbe3(0, 0, _width, _height);
    let _scissorTest = false;
    //
    const _currentDrawBuffers = [];
    // frustum
    const _frustum = new $0d23c856ce11c301$export$35efe6f4c85463d2();
    // clipping
    let _clippingEnabled = false;
    let _localClippingEnabled = false;
    // transmission
    let _transmissionRenderTarget = null;
    // camera matrices cache
    const _projScreenMatrix = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
    const _vector3 = new $0d23c856ce11c301$export$64b5c384219d3699();
    const _emptyScene = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: true
    };
    function getTargetPixelRatio() {
        return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    // initialize
    let _gl = _context;
    function getContext(contextNames, contextAttributes) {
        for(let i = 0; i < contextNames.length; i++){
            const contextName = contextNames[i];
            const context = _canvas.getContext(contextName, contextAttributes);
            if (context !== null) return context;
        }
        return null;
    }
    try {
        const contextAttributes = {
            alpha: _alpha,
            depth: _depth,
            stencil: _stencil,
            antialias: _antialias,
            premultipliedAlpha: _premultipliedAlpha,
            preserveDrawingBuffer: _preserveDrawingBuffer,
            powerPreference: _powerPreference,
            failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
        };
        // event listeners must be registered before WebGL context is created, see #12753
        _canvas.addEventListener("webglcontextlost", onContextLost, false);
        _canvas.addEventListener("webglcontextrestored", onContextRestore, false);
        if (_gl === null) {
            const contextNames = [
                "webgl2",
                "webgl",
                "experimental-webgl"
            ];
            if (_this.isWebGL1Renderer === true) contextNames.shift();
            _gl = getContext(contextNames, contextAttributes);
            if (_gl === null) {
                if (getContext(contextNames)) throw new Error("Error creating WebGL context with your selected attributes.");
                else throw new Error("Error creating WebGL context.");
            }
        }
        // Some experimental-webgl implementations do not have getShaderPrecisionFormat
        if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
            return {
                "rangeMin": 1,
                "rangeMax": 1,
                "precision": 1
            };
        };
    } catch (error) {
        console.error("THREE.WebGLRenderer: " + error.message);
        throw error;
    }
    let extensions, capabilities, state, info;
    let properties, textures, cubemaps, attributes, geometries, objects;
    let programCache, materials, renderLists, renderStates, clipping, shadowMap;
    let background, morphtargets, bufferRenderer, indexedBufferRenderer;
    let utils, bindingStates;
    function initGLContext() {
        extensions = new $0d23c856ce11c301$var$WebGLExtensions(_gl);
        capabilities = new $0d23c856ce11c301$var$WebGLCapabilities(_gl, extensions, parameters);
        extensions.init(capabilities);
        utils = new $0d23c856ce11c301$export$ddaebcad857649a8(_gl, extensions, capabilities);
        state = new $0d23c856ce11c301$var$WebGLState(_gl, extensions, capabilities);
        _currentDrawBuffers[0] = 1029;
        info = new $0d23c856ce11c301$var$WebGLInfo(_gl);
        properties = new $0d23c856ce11c301$var$WebGLProperties();
        textures = new $0d23c856ce11c301$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
        cubemaps = new $0d23c856ce11c301$var$WebGLCubeMaps(_this);
        attributes = new $0d23c856ce11c301$var$WebGLAttributes(_gl, capabilities);
        bindingStates = new $0d23c856ce11c301$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
        geometries = new $0d23c856ce11c301$var$WebGLGeometries(_gl, attributes, info, bindingStates);
        objects = new $0d23c856ce11c301$var$WebGLObjects(_gl, geometries, attributes, info);
        morphtargets = new $0d23c856ce11c301$var$WebGLMorphtargets(_gl);
        clipping = new $0d23c856ce11c301$var$WebGLClipping(properties);
        programCache = new $0d23c856ce11c301$var$WebGLPrograms(_this, cubemaps, extensions, capabilities, bindingStates, clipping);
        materials = new $0d23c856ce11c301$var$WebGLMaterials(properties);
        renderLists = new $0d23c856ce11c301$var$WebGLRenderLists(properties);
        renderStates = new $0d23c856ce11c301$var$WebGLRenderStates(extensions, capabilities);
        background = new $0d23c856ce11c301$var$WebGLBackground(_this, cubemaps, state, objects, _premultipliedAlpha);
        shadowMap = new $0d23c856ce11c301$var$WebGLShadowMap(_this, objects, capabilities);
        bufferRenderer = new $0d23c856ce11c301$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
        indexedBufferRenderer = new $0d23c856ce11c301$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
        info.programs = programCache.programs;
        _this.capabilities = capabilities;
        _this.extensions = extensions;
        _this.properties = properties;
        _this.renderLists = renderLists;
        _this.shadowMap = shadowMap;
        _this.state = state;
        _this.info = info;
    }
    initGLContext();
    // xr
    const xr = new $0d23c856ce11c301$var$WebXRManager(_this, _gl);
    this.xr = xr;
    // API
    this.getContext = function() {
        return _gl;
    };
    this.getContextAttributes = function() {
        return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
        const extension = extensions.get("WEBGL_lose_context");
        if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
        const extension = extensions.get("WEBGL_lose_context");
        if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
        return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
        if (value === undefined) return;
        _pixelRatio = value;
        this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
        return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle) {
        if (xr.isPresenting) {
            console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
            return;
        }
        _width = width;
        _height = height;
        _canvas.width = Math.floor(width * _pixelRatio);
        _canvas.height = Math.floor(height * _pixelRatio);
        if (updateStyle !== false) {
            _canvas.style.width = width + "px";
            _canvas.style.height = height + "px";
        }
        this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
        return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
        _width = width;
        _height = height;
        _pixelRatio = pixelRatio;
        _canvas.width = Math.floor(width * pixelRatio);
        _canvas.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
        return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
        return target.copy(_viewport);
    };
    this.setViewport = function(x, y, width, height) {
        if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
        else _viewport.set(x, y, width, height);
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissor = function(target) {
        return target.copy(_scissor);
    };
    this.setScissor = function(x, y, width, height) {
        if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
        else _scissor.set(x, y, width, height);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissorTest = function() {
        return _scissorTest;
    };
    this.setScissorTest = function(boolean) {
        state.setScissorTest(_scissorTest = boolean);
    };
    this.setOpaqueSort = function(method) {
        _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
        _transparentSort = method;
    };
    // Clearing
    this.getClearColor = function(target) {
        return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
        background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
        return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
        background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color, depth, stencil) {
        let bits = 0;
        if (color === undefined || color) bits |= 16384;
        if (depth === undefined || depth) bits |= 256;
        if (stencil === undefined || stencil) bits |= 1024;
        _gl.clear(bits);
    };
    this.clearColor = function() {
        this.clear(true, false, false);
    };
    this.clearDepth = function() {
        this.clear(false, true, false);
    };
    this.clearStencil = function() {
        this.clear(false, false, true);
    };
    //
    this.dispose = function() {
        _canvas.removeEventListener("webglcontextlost", onContextLost, false);
        _canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
        renderLists.dispose();
        renderStates.dispose();
        properties.dispose();
        cubemaps.dispose();
        objects.dispose();
        bindingStates.dispose();
        xr.dispose();
        xr.removeEventListener("sessionstart", onXRSessionStart);
        xr.removeEventListener("sessionend", onXRSessionEnd);
        if (_transmissionRenderTarget) {
            _transmissionRenderTarget.dispose();
            _transmissionRenderTarget = null;
        }
        animation.stop();
    };
    // Events
    function onContextLost(event) {
        event.preventDefault();
        console.log("THREE.WebGLRenderer: Context Lost.");
        _isContextLost = true;
    }
    function onContextRestore() {
        console.log("THREE.WebGLRenderer: Context Restored.");
        _isContextLost = false;
        const infoAutoReset = info.autoReset;
        const shadowMapEnabled = shadowMap.enabled;
        const shadowMapAutoUpdate = shadowMap.autoUpdate;
        const shadowMapNeedsUpdate = shadowMap.needsUpdate;
        const shadowMapType = shadowMap.type;
        initGLContext();
        info.autoReset = infoAutoReset;
        shadowMap.enabled = shadowMapEnabled;
        shadowMap.autoUpdate = shadowMapAutoUpdate;
        shadowMap.needsUpdate = shadowMapNeedsUpdate;
        shadowMap.type = shadowMapType;
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener("dispose", onMaterialDispose);
        deallocateMaterial(material);
    }
    // Buffer deallocation
    function deallocateMaterial(material) {
        releaseMaterialProgramReferences(material);
        properties.remove(material);
    }
    function releaseMaterialProgramReferences(material) {
        const programs = properties.get(material).programs;
        if (programs !== undefined) programs.forEach(function(program) {
            programCache.releaseProgram(program);
        });
    }
    // Buffer rendering
    function renderObjectImmediate(object, program) {
        object.render(function(object) {
            _this.renderBufferImmediate(object, program);
        });
    }
    this.renderBufferImmediate = function(object, program) {
        bindingStates.initAttributes();
        const buffers = properties.get(object);
        if (object.hasPositions && !buffers.position) buffers.position = _gl.createBuffer();
        if (object.hasNormals && !buffers.normal) buffers.normal = _gl.createBuffer();
        if (object.hasUvs && !buffers.uv) buffers.uv = _gl.createBuffer();
        if (object.hasColors && !buffers.color) buffers.color = _gl.createBuffer();
        const programAttributes = program.getAttributes();
        if (object.hasPositions) {
            _gl.bindBuffer(34962, buffers.position);
            _gl.bufferData(34962, object.positionArray, 35048);
            bindingStates.enableAttribute(programAttributes.position);
            _gl.vertexAttribPointer(programAttributes.position, 3, 5126, false, 0, 0);
        }
        if (object.hasNormals) {
            _gl.bindBuffer(34962, buffers.normal);
            _gl.bufferData(34962, object.normalArray, 35048);
            bindingStates.enableAttribute(programAttributes.normal);
            _gl.vertexAttribPointer(programAttributes.normal, 3, 5126, false, 0, 0);
        }
        if (object.hasUvs) {
            _gl.bindBuffer(34962, buffers.uv);
            _gl.bufferData(34962, object.uvArray, 35048);
            bindingStates.enableAttribute(programAttributes.uv);
            _gl.vertexAttribPointer(programAttributes.uv, 2, 5126, false, 0, 0);
        }
        if (object.hasColors) {
            _gl.bindBuffer(34962, buffers.color);
            _gl.bufferData(34962, object.colorArray, 35048);
            bindingStates.enableAttribute(programAttributes.color);
            _gl.vertexAttribPointer(programAttributes.color, 3, 5126, false, 0, 0);
        }
        bindingStates.disableUnusedAttributes();
        _gl.drawArrays(4, 0, object.count);
        object.count = 0;
    };
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
        if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        const program = setProgram(camera, scene, material, object);
        state.setMaterial(material, frontFaceCW);
        //
        let index = geometry.index;
        const position = geometry.attributes.position;
        //
        if (index === null) {
            if (position === undefined || position.count === 0) return;
        } else if (index.count === 0) return;
        //
        let rangeFactor = 1;
        if (material.wireframe === true) {
            index = geometries.getWireframeAttribute(geometry);
            rangeFactor = 2;
        }
        if (material.morphTargets || material.morphNormals) morphtargets.update(object, geometry, material, program);
        bindingStates.setup(object, material, program, geometry, index);
        let attribute;
        let renderer = bufferRenderer;
        if (index !== null) {
            attribute = attributes.get(index);
            renderer = indexedBufferRenderer;
            renderer.setIndex(attribute);
        }
        //
        const dataCount = index !== null ? index.count : position.count;
        const rangeStart = geometry.drawRange.start * rangeFactor;
        const rangeCount = geometry.drawRange.count * rangeFactor;
        const groupStart = group !== null ? group.start * rangeFactor : 0;
        const groupCount = group !== null ? group.count * rangeFactor : Infinity;
        const drawStart = Math.max(rangeStart, groupStart);
        const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
        const drawCount = Math.max(0, drawEnd - drawStart + 1);
        if (drawCount === 0) return;
        //
        if (object.isMesh) {
            if (material.wireframe === true) {
                state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                renderer.setMode(1);
            } else renderer.setMode(4);
        } else if (object.isLine) {
            let lineWidth = material.linewidth;
            if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
            state.setLineWidth(lineWidth * getTargetPixelRatio());
            if (object.isLineSegments) renderer.setMode(1);
            else if (object.isLineLoop) renderer.setMode(2);
            else renderer.setMode(3);
        } else if (object.isPoints) renderer.setMode(0);
        else if (object.isSprite) renderer.setMode(4);
        if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
        else if (geometry.isInstancedBufferGeometry) {
            const instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
            renderer.renderInstances(drawStart, drawCount, instanceCount);
        } else renderer.render(drawStart, drawCount);
    };
    // Compile
    this.compile = function(scene, camera) {
        currentRenderState = renderStates.get(scene);
        currentRenderState.init();
        scene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            }
        });
        currentRenderState.setupLights();
        scene.traverse(function(object) {
            const material = object.material;
            if (material) {
                if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                    const material2 = material[i];
                    getProgram(material2, scene, object);
                }
                else getProgram(material, scene, object);
            }
        });
    };
    // Animation Loop
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time) {
        if (onAnimationFrameCallback) onAnimationFrameCallback(time);
    }
    function onXRSessionStart() {
        animation.stop();
    }
    function onXRSessionEnd() {
        animation.start();
    }
    const animation = new $0d23c856ce11c301$var$WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof window !== "undefined") animation.setContext(window);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
        xr.setAnimationLoop(callback);
        callback === null ? animation.stop() : animation.start();
    };
    xr.addEventListener("sessionstart", onXRSessionStart);
    xr.addEventListener("sessionend", onXRSessionEnd);
    // Rendering
    this.render = function(scene, camera) {
        if (camera !== undefined && camera.isCamera !== true) {
            console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            return;
        }
        if (_isContextLost === true) return;
        // update scene graph
        if (scene.autoUpdate === true) scene.updateMatrixWorld();
        // update camera matrices and frustum
        if (camera.parent === null) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) {
            if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
            camera = xr.getCamera(); // use XR camera for rendering
        }
        //
        if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
        currentRenderState = renderStates.get(scene, renderStateStack.length);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix);
        _localClippingEnabled = this.localClippingEnabled;
        _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
        currentRenderList = renderLists.get(scene, renderListStack.length);
        currentRenderList.init();
        renderListStack.push(currentRenderList);
        projectObject(scene, camera, 0, _this.sortObjects);
        currentRenderList.finish();
        if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
        //
        if (_clippingEnabled === true) clipping.beginShadows();
        const shadowsArray = currentRenderState.state.shadowsArray;
        shadowMap.render(shadowsArray, scene, camera);
        currentRenderState.setupLights();
        currentRenderState.setupLightsView(camera);
        if (_clippingEnabled === true) clipping.endShadows();
        //
        if (this.info.autoReset === true) this.info.reset();
        //
        background.render(currentRenderList, scene);
        // render scene
        const opaqueObjects = currentRenderList.opaque;
        const transmissiveObjects = currentRenderList.transmissive;
        const transparentObjects = currentRenderList.transparent;
        if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
        if (transmissiveObjects.length > 0) renderTransmissiveObjects(opaqueObjects, transmissiveObjects, scene, camera);
        if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
        //
        if (_currentRenderTarget !== null) {
            // resolve multisample renderbuffers to a single-sample texture if necessary
            textures.updateMultisampleRenderTarget(_currentRenderTarget);
            // Generate mipmap if we're using any kind of mipmap filtering
            textures.updateRenderTargetMipmap(_currentRenderTarget);
        }
        //
        if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
        // Ensure depth buffer writing is enabled so it can be cleared on next render
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        state.setPolygonOffset(false);
        // _gl.finish();
        bindingStates.resetDefaultState();
        _currentMaterialId = -1;
        _currentCamera = null;
        renderStateStack.pop();
        if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
        else currentRenderState = null;
        renderListStack.pop();
        if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
        else currentRenderList = null;
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) groupOrder = object.renderOrder;
            else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            } else if (object.isSprite) {
                if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            } else if (object.isImmediateRenderObject) {
                if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                currentRenderList.push(object, null, object.material, groupOrder, _vector3.z, null);
            } else if (object.isMesh || object.isLine || object.isPoints) {
                if (object.isSkinnedMesh) // update skeleton only once in a frame
                {
                    if (object.skeleton.frame !== info.render.frame) {
                        object.skeleton.update();
                        object.skeleton.frame = info.render.frame;
                    }
                }
                if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                        }
                    } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
    }
    function renderTransmissiveObjects(opaqueObjects, transmissiveObjects, scene, camera) {
        if (_transmissionRenderTarget === null) {
            const needsAntialias = _antialias === true && capabilities.isWebGL2 === true;
            const renderTargetType = needsAntialias ? $0d23c856ce11c301$export$cb2022643d3c928d : $0d23c856ce11c301$export$3c052beb2e51e23f;
            _transmissionRenderTarget = new renderTargetType(1024, 1024, {
                generateMipmaps: true,
                type: utils.convert($0d23c856ce11c301$export$2697304443f382bc) !== null ? $0d23c856ce11c301$export$2697304443f382bc : $0d23c856ce11c301$export$2e8ce08d3f6f5e10,
                minFilter: $0d23c856ce11c301$export$5d8599b6a933fb1b,
                magFilter: $0d23c856ce11c301$export$727aa5ec3fe39bf0,
                wrapS: $0d23c856ce11c301$export$9d9334239a5a5e06,
                wrapT: $0d23c856ce11c301$export$9d9334239a5a5e06
            });
        }
        const currentRenderTarget = _this.getRenderTarget();
        _this.setRenderTarget(_transmissionRenderTarget);
        _this.clear();
        // Turn off the features which can affect the frag color for opaque objects pass.
        // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
        const currentToneMapping = _this.toneMapping;
        _this.toneMapping = $0d23c856ce11c301$export$9fcb6b4294603b2;
        renderObjects(opaqueObjects, scene, camera);
        _this.toneMapping = currentToneMapping;
        textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
        textures.updateRenderTargetMipmap(_transmissionRenderTarget);
        _this.setRenderTarget(currentRenderTarget);
        renderObjects(transmissiveObjects, scene, camera);
    }
    function renderObjects(renderList, scene, camera) {
        const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        for(let i = 0, l = renderList.length; i < l; i++){
            const renderItem = renderList[i];
            const object = renderItem.object;
            const geometry = renderItem.geometry;
            const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
            const group = renderItem.group;
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let j = 0, jl = cameras.length; j < jl; j++){
                    const camera2 = cameras[j];
                    if (object.layers.test(camera2.layers)) {
                        state.viewport(_currentViewport.copy(camera2.viewport));
                        currentRenderState.setupLightsView(camera2);
                        renderObject(object, scene, camera2, geometry, material, group);
                    }
                }
            } else renderObject(object, scene, camera, geometry, material, group);
        }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
        object.onBeforeRender(_this, scene, camera, geometry, material, group);
        object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
        if (object.isImmediateRenderObject) {
            const program = setProgram(camera, scene, material, object);
            state.setMaterial(material);
            bindingStates.reset();
            renderObjectImmediate(object, program);
        } else if (material.transparent === true && material.side === $0d23c856ce11c301$export$3b296b6f144d5b03) {
            material.side = $0d23c856ce11c301$export$d9f0486e75b5ace;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $0d23c856ce11c301$export$2ede184fc2998901;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $0d23c856ce11c301$export$3b296b6f144d5b03;
        } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function getProgram(material, scene, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        const shadowsArray = currentRenderState.state.shadowsArray;
        const lightsStateVersion = lights.state.version;
        const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
        const programCacheKey = programCache.getProgramCacheKey(parameters);
        let programs = materialProperties.programs;
        // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
        materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
        materialProperties.fog = scene.fog;
        materialProperties.envMap = cubemaps.get(material.envMap || materialProperties.environment);
        if (programs === undefined) {
            // new material
            material.addEventListener("dispose", onMaterialDispose);
            programs = new Map();
            materialProperties.programs = programs;
        }
        let program = programs.get(programCacheKey);
        if (program !== undefined) // early out if program and light state is identical
        {
            if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                updateCommonMaterialProperties(material, parameters);
                return program;
            }
        } else {
            parameters.uniforms = programCache.getUniforms(material);
            material.onBuild(parameters, _this);
            material.onBeforeCompile(parameters, _this);
            program = programCache.acquireProgram(parameters, programCacheKey);
            programs.set(programCacheKey, program);
            materialProperties.uniforms = parameters.uniforms;
        }
        const uniforms = materialProperties.uniforms;
        if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
        updateCommonMaterialProperties(material, parameters);
        // store the light setup it was created for
        materialProperties.needsLights = materialNeedsLights(material);
        materialProperties.lightsStateVersion = lightsStateVersion;
        if (materialProperties.needsLights) {
            // wire up the material to this renderer's lighting state
            uniforms.ambientLightColor.value = lights.state.ambient;
            uniforms.lightProbe.value = lights.state.probe;
            uniforms.directionalLights.value = lights.state.directional;
            uniforms.directionalLightShadows.value = lights.state.directionalShadow;
            uniforms.spotLights.value = lights.state.spot;
            uniforms.spotLightShadows.value = lights.state.spotShadow;
            uniforms.rectAreaLights.value = lights.state.rectArea;
            uniforms.ltc_1.value = lights.state.rectAreaLTC1;
            uniforms.ltc_2.value = lights.state.rectAreaLTC2;
            uniforms.pointLights.value = lights.state.point;
            uniforms.pointLightShadows.value = lights.state.pointShadow;
            uniforms.hemisphereLights.value = lights.state.hemi;
            uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
            uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
            uniforms.spotShadowMap.value = lights.state.spotShadowMap;
            uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
            uniforms.pointShadowMap.value = lights.state.pointShadowMap;
            uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
        // TODO (abelnation): add area lights shadow info to uniforms
        }
        const progUniforms = program.getUniforms();
        const uniformsList = $0d23c856ce11c301$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
        materialProperties.currentProgram = program;
        materialProperties.uniformsList = uniformsList;
        return program;
    }
    function updateCommonMaterialProperties(material, parameters) {
        const materialProperties = properties.get(material);
        materialProperties.outputEncoding = parameters.outputEncoding;
        materialProperties.instancing = parameters.instancing;
        materialProperties.skinning = parameters.skinning;
        materialProperties.numClippingPlanes = parameters.numClippingPlanes;
        materialProperties.numIntersection = parameters.numClipIntersection;
        materialProperties.vertexAlphas = parameters.vertexAlphas;
    }
    function setProgram(camera, scene, material, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        textures.resetTextureUnits();
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.texture.encoding;
        const envMap = cubemaps.get(material.envMap || environment);
        const vertexAlphas = material.vertexColors === true && object.geometry && object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4;
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        if (_clippingEnabled === true) {
            if (_localClippingEnabled === true || camera !== _currentCamera) {
                const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                // we might want to call this function with some ClippingGroup
                // object instead of the material, once it becomes feasible
                // (#8465, #8379)
                clipping.setState(material, camera, useCache);
            }
        }
        //
        let needsProgramChange = false;
        if (material.version === materialProperties.__version) {
            if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
            else if (materialProperties.outputEncoding !== encoding) needsProgramChange = true;
            else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
            else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
            else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
            else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
            else if (materialProperties.envMap !== envMap) needsProgramChange = true;
            else if (material.fog && materialProperties.fog !== fog) needsProgramChange = true;
            else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
            else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
        } else {
            needsProgramChange = true;
            materialProperties.__version = material.version;
        }
        //
        let program = materialProperties.currentProgram;
        if (needsProgramChange === true) program = getProgram(material, scene, object);
        let refreshProgram = false;
        let refreshMaterial = false;
        let refreshLights = false;
        const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
        if (state.useProgram(program.program)) {
            refreshProgram = true;
            refreshMaterial = true;
            refreshLights = true;
        }
        if (material.id !== _currentMaterialId) {
            _currentMaterialId = material.id;
            refreshMaterial = true;
        }
        if (refreshProgram || _currentCamera !== camera) {
            p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
            if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
            if (_currentCamera !== camera) {
                _currentCamera = camera;
                // lighting uniforms depend on the camera so enforce an update
                // now, in case this material supports lights - or later, when
                // the next material that does gets activated:
                refreshMaterial = true; // set to true on material change
                refreshLights = true; // remains set until update done
            }
            // load material specific uniforms
            // (shader material also gets them for the sake of genericity)
            if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
            }
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
        }
        // skinning uniforms must be set even if material didn't change
        // auto-setting of texture unit for bone texture must go before other textures
        // otherwise textures used for skinning can take over texture units reserved for other material textures
        if (object.isSkinnedMesh) {
            p_uniforms.setOptional(_gl, object, "bindMatrix");
            p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
            const skeleton = object.skeleton;
            if (skeleton) {
                if (capabilities.floatVertexTextures) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                    p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
                } else p_uniforms.setOptional(_gl, skeleton, "boneMatrices");
            }
        }
        if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
            materialProperties.receiveShadow = object.receiveShadow;
            p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
        }
        if (refreshMaterial) {
            p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
            if (materialProperties.needsLights) // the current material requires lighting info
            // note: all lighting uniforms are always set correctly
            // they simply reference the renderer's state for their
            // values
            //
            // use the current material's .needsUpdate flags to set
            // the GL state when required
            markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
            // refresh uniforms common to several materials
            if (fog && material.fog) materials.refreshFogUniforms(m_uniforms, fog);
            materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
            $0d23c856ce11c301$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
        }
        if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
            $0d23c856ce11c301$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            material.uniformsNeedUpdate = false;
        }
        if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
        // common matrices
        p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
        p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
        p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
        return program;
    }
    // If uniforms are marked as clean, they don't need to be loaded to the GPU.
    function markUniformsLightsNeedsUpdate(uniforms, value) {
        uniforms.ambientLightColor.needsUpdate = value;
        uniforms.lightProbe.needsUpdate = value;
        uniforms.directionalLights.needsUpdate = value;
        uniforms.directionalLightShadows.needsUpdate = value;
        uniforms.pointLights.needsUpdate = value;
        uniforms.pointLightShadows.needsUpdate = value;
        uniforms.spotLights.needsUpdate = value;
        uniforms.spotLightShadows.needsUpdate = value;
        uniforms.rectAreaLights.needsUpdate = value;
        uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
        return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    this.getActiveCubeFace = function() {
        return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
        return _currentActiveMipmapLevel;
    };
    this.getRenderTarget = function() {
        return _currentRenderTarget;
    };
    this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        _currentRenderTarget = renderTarget;
        _currentActiveCubeFace = activeCubeFace;
        _currentActiveMipmapLevel = activeMipmapLevel;
        if (renderTarget && properties.get(renderTarget).__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
        let framebuffer = null;
        let isCube = false;
        let isRenderTarget3D = false;
        if (renderTarget) {
            const texture = renderTarget.texture;
            if (texture.isDataTexture3D || texture.isDataTexture2DArray) isRenderTarget3D = true;
            const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget) {
                framebuffer = __webglFramebuffer[activeCubeFace];
                isCube = true;
            } else if (renderTarget.isWebGLMultisampleRenderTarget) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
            else framebuffer = __webglFramebuffer;
            _currentViewport.copy(renderTarget.viewport);
            _currentScissor.copy(renderTarget.scissor);
            _currentScissorTest = renderTarget.scissorTest;
        } else {
            _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
            _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
            _currentScissorTest = _scissorTest;
        }
        const framebufferBound = state.bindFramebuffer(36160, framebuffer);
        if (framebufferBound && capabilities.drawBuffers) {
            let needsUpdate = false;
            if (renderTarget) {
                if (renderTarget.isWebGLMultipleRenderTargets) {
                    const textures = renderTarget.texture;
                    if (_currentDrawBuffers.length !== textures.length || _currentDrawBuffers[0] !== 36064) {
                        for(let i = 0, il = textures.length; i < il; i++)_currentDrawBuffers[i] = 36064 + i;
                        _currentDrawBuffers.length = textures.length;
                        needsUpdate = true;
                    }
                } else if (_currentDrawBuffers.length !== 1 || _currentDrawBuffers[0] !== 36064) {
                    _currentDrawBuffers[0] = 36064;
                    _currentDrawBuffers.length = 1;
                    needsUpdate = true;
                }
            } else if (_currentDrawBuffers.length !== 1 || _currentDrawBuffers[0] !== 1029) {
                _currentDrawBuffers[0] = 1029;
                _currentDrawBuffers.length = 1;
                needsUpdate = true;
            }
            if (needsUpdate) {
                if (capabilities.isWebGL2) _gl.drawBuffers(_currentDrawBuffers);
                else extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(_currentDrawBuffers);
            }
        }
        state.viewport(_currentViewport);
        state.scissor(_currentScissor);
        state.setScissorTest(_currentScissorTest);
        if (isCube) {
            const textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
        } else if (isRenderTarget3D) {
            const textureProperties = properties.get(renderTarget.texture);
            const layer = activeCubeFace || 0;
            _gl.framebufferTextureLayer(36160, 36064, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
        }
    };
    this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            return;
        }
        let framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
        if (framebuffer) {
            state.bindFramebuffer(36160, framebuffer);
            try {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (textureFormat !== $0d23c856ce11c301$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    return;
                }
                const halfFloatSupportedByExt = textureType === $0d23c856ce11c301$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
                if (textureType !== $0d23c856ce11c301$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
                !(textureType === $0d23c856ce11c301$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
                !halfFloatSupportedByExt) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    return;
                }
                if (_gl.checkFramebufferStatus(36160) === 36053) // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                {
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } else console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.");
            } finally{
                // restore framebuffer of current render target if necessary
                const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                state.bindFramebuffer(36160, framebuffer);
            }
        }
    };
    this.copyFramebufferToTexture = function(position, texture, level = 0) {
        const levelScale = Math.pow(2, -level);
        const width = Math.floor(texture.image.width * levelScale);
        const height = Math.floor(texture.image.height * levelScale);
        let glFormat = utils.convert(texture.format);
        if (capabilities.isWebGL2) {
            // Workaround for https://bugs.chromium.org/p/chromium/issues/detail?id=1120100
            // Not needed in Chrome 93+
            if (glFormat === 6407) glFormat = 32849;
            if (glFormat === 6408) glFormat = 32856;
        }
        textures.setTexture2D(texture, 0);
        _gl.copyTexImage2D(3553, level, glFormat, position.x, position.y, width, height, 0);
        state.unbindTexture();
    };
    this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
        const width = srcTexture.image.width;
        const height = srcTexture.image.height;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        textures.setTexture2D(dstTexture, 0);
        // As another texture upload may have changed pixelStorei
        // parameters, make sure they are correct for the dstTexture
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        if (srcTexture.isDataTexture) _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
        else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
        else _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
        state.unbindTexture();
    };
    this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
        if (_this.isWebGL1Renderer) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
            return;
        }
        const width = sourceBox.max.x - sourceBox.min.x + 1;
        const height = sourceBox.max.y - sourceBox.min.y + 1;
        const depth = sourceBox.max.z - sourceBox.min.z + 1;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        let glTarget;
        if (dstTexture.isDataTexture3D) {
            textures.setTexture3D(dstTexture, 0);
            glTarget = 32879;
        } else if (dstTexture.isDataTexture2DArray) {
            textures.setTexture2DArray(dstTexture, 0);
            glTarget = 35866;
        } else {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
            return;
        }
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        const unpackRowLen = _gl.getParameter(3314);
        const unpackImageHeight = _gl.getParameter(32878);
        const unpackSkipPixels = _gl.getParameter(3316);
        const unpackSkipRows = _gl.getParameter(3315);
        const unpackSkipImages = _gl.getParameter(32877);
        const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
        _gl.pixelStorei(3314, image.width);
        _gl.pixelStorei(32878, image.height);
        _gl.pixelStorei(3316, sourceBox.min.x);
        _gl.pixelStorei(3315, sourceBox.min.y);
        _gl.pixelStorei(32877, sourceBox.min.z);
        if (srcTexture.isDataTexture || srcTexture.isDataTexture3D) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
        else if (srcTexture.isCompressedTexture) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
            _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
        } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
        _gl.pixelStorei(3314, unpackRowLen);
        _gl.pixelStorei(32878, unpackImageHeight);
        _gl.pixelStorei(3316, unpackSkipPixels);
        _gl.pixelStorei(3315, unpackSkipRows);
        _gl.pixelStorei(32877, unpackSkipImages);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
        state.unbindTexture();
    };
    this.initTexture = function(texture) {
        textures.setTexture2D(texture, 0);
        state.unbindTexture();
    };
    this.resetState = function() {
        _currentActiveCubeFace = 0;
        _currentActiveMipmapLevel = 0;
        _currentRenderTarget = null;
        state.reset();
        bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
        detail: this
    })); // eslint-disable-line no-undef
}
class $0d23c856ce11c301$export$a2f65229194348f9 extends $0d23c856ce11c301$export$f6cc00ef28d7cf97 {
}
$0d23c856ce11c301$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $0d23c856ce11c301$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.name = "";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $0d23c856ce11c301$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            color: this.color.getHex(),
            density: this.density
        };
    }
}
$0d23c856ce11c301$export$6f1519f023b8d0f6.prototype.isFogExp2 = true;
class $0d23c856ce11c301$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.name = "";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $0d23c856ce11c301$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
$0d23c856ce11c301$export$3c890837b09508d4.prototype.isFog = true;
class $0d23c856ce11c301$export$38af1803e3442a7f extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.overrideMaterial = null;
        this.autoUpdate = true; // checked by the renderer
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        })); // eslint-disable-line no-undef
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.autoUpdate = source.autoUpdate;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        return data;
    }
}
$0d23c856ce11c301$export$38af1803e3442a7f.prototype.isScene = true;
class $0d23c856ce11c301$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $0d23c856ce11c301$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $0d23c856ce11c301$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $0d23c856ce11c301$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $0d23c856ce11c301$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
$0d23c856ce11c301$export$3d5cd879f108f53f.prototype.isInterleavedBuffer = true;
const $0d23c856ce11c301$var$_vector$6 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized === true;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $0d23c856ce11c301$var$_vector$6.x = this.getX(i);
            $0d23c856ce11c301$var$_vector$6.y = this.getY(i);
            $0d23c856ce11c301$var$_vector$6.z = this.getZ(i);
            $0d23c856ce11c301$var$_vector$6.applyMatrix4(m);
            this.setXYZ(i, $0d23c856ce11c301$var$_vector$6.x, $0d23c856ce11c301$var$_vector$6.y, $0d23c856ce11c301$var$_vector$6.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0d23c856ce11c301$var$_vector$6.x = this.getX(i);
            $0d23c856ce11c301$var$_vector$6.y = this.getY(i);
            $0d23c856ce11c301$var$_vector$6.z = this.getZ(i);
            $0d23c856ce11c301$var$_vector$6.applyNormalMatrix(m);
            this.setXYZ(i, $0d23c856ce11c301$var$_vector$6.x, $0d23c856ce11c301$var$_vector$6.y, $0d23c856ce11c301$var$_vector$6.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0d23c856ce11c301$var$_vector$6.x = this.getX(i);
            $0d23c856ce11c301$var$_vector$6.y = this.getY(i);
            $0d23c856ce11c301$var$_vector$6.z = this.getZ(i);
            $0d23c856ce11c301$var$_vector$6.transformDirection(m);
            this.setXYZ(i, $0d23c856ce11c301$var$_vector$6.x, $0d23c856ce11c301$var$_vector$6.y, $0d23c856ce11c301$var$_vector$6.z);
        }
        return this;
    }
    setX(index, x) {
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        return this.data.array[index * this.data.stride + this.offset];
    }
    getY(index) {
        return this.data.array[index * this.data.stride + this.offset + 1];
    }
    getZ(index) {
        return this.data.array[index * this.data.stride + this.offset + 2];
    }
    getW(index) {
        return this.data.array[index * this.data.stride + this.offset + 3];
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $0d23c856ce11c301$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $0d23c856ce11c301$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // deinterleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interlaved attribtue
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
$0d23c856ce11c301$export$920b6d07334599c7.prototype.isInterleavedBufferAttribute = true;
/**
 * parameters = {
 *  color: <hex>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *  rotation: <float>,
 *  sizeAttenuation: <bool>
 * }
 */ class $0d23c856ce11c301$export$5ec7dd1c6994bf8e extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "SpriteMaterial";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        return this;
    }
}
$0d23c856ce11c301$export$5ec7dd1c6994bf8e.prototype.isSpriteMaterial = true;
let $0d23c856ce11c301$var$_geometry;
const $0d23c856ce11c301$var$_intersectPoint = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_worldScale = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_mvPosition = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_alignedPosition = /*@__PURE__*/ new $0d23c856ce11c301$export$c977b3e384af9ae1();
const $0d23c856ce11c301$var$_rotatedPosition = /*@__PURE__*/ new $0d23c856ce11c301$export$c977b3e384af9ae1();
const $0d23c856ce11c301$var$_viewWorldMatrix = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_vA = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vB = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_vC = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_uvA = /*@__PURE__*/ new $0d23c856ce11c301$export$c977b3e384af9ae1();
const $0d23c856ce11c301$var$_uvB = /*@__PURE__*/ new $0d23c856ce11c301$export$c977b3e384af9ae1();
const $0d23c856ce11c301$var$_uvC = /*@__PURE__*/ new $0d23c856ce11c301$export$c977b3e384af9ae1();
class $0d23c856ce11c301$export$3075603db8e6204c extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.type = "Sprite";
        if ($0d23c856ce11c301$var$_geometry === undefined) {
            $0d23c856ce11c301$var$_geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $0d23c856ce11c301$export$3d5cd879f108f53f(float32Array, 5);
            $0d23c856ce11c301$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $0d23c856ce11c301$var$_geometry.setAttribute("position", new $0d23c856ce11c301$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $0d23c856ce11c301$var$_geometry.setAttribute("uv", new $0d23c856ce11c301$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $0d23c856ce11c301$var$_geometry;
        this.material = material !== undefined ? material : new $0d23c856ce11c301$export$5ec7dd1c6994bf8e();
        this.center = new $0d23c856ce11c301$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $0d23c856ce11c301$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $0d23c856ce11c301$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $0d23c856ce11c301$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $0d23c856ce11c301$var$_worldScale.multiplyScalar(-$0d23c856ce11c301$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $0d23c856ce11c301$var$transformVertex($0d23c856ce11c301$var$_vA.set(-0.5, -0.5, 0), $0d23c856ce11c301$var$_mvPosition, center, $0d23c856ce11c301$var$_worldScale, sin, cos);
        $0d23c856ce11c301$var$transformVertex($0d23c856ce11c301$var$_vB.set(0.5, -0.5, 0), $0d23c856ce11c301$var$_mvPosition, center, $0d23c856ce11c301$var$_worldScale, sin, cos);
        $0d23c856ce11c301$var$transformVertex($0d23c856ce11c301$var$_vC.set(0.5, 0.5, 0), $0d23c856ce11c301$var$_mvPosition, center, $0d23c856ce11c301$var$_worldScale, sin, cos);
        $0d23c856ce11c301$var$_uvA.set(0, 0);
        $0d23c856ce11c301$var$_uvB.set(1, 0);
        $0d23c856ce11c301$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($0d23c856ce11c301$var$_vA, $0d23c856ce11c301$var$_vB, $0d23c856ce11c301$var$_vC, false, $0d23c856ce11c301$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $0d23c856ce11c301$var$transformVertex($0d23c856ce11c301$var$_vB.set(-0.5, 0.5, 0), $0d23c856ce11c301$var$_mvPosition, center, $0d23c856ce11c301$var$_worldScale, sin, cos);
            $0d23c856ce11c301$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($0d23c856ce11c301$var$_vA, $0d23c856ce11c301$var$_vC, $0d23c856ce11c301$var$_vB, false, $0d23c856ce11c301$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($0d23c856ce11c301$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $0d23c856ce11c301$var$_intersectPoint.clone(),
            uv: $0d23c856ce11c301$export$5a465592bfe74b48.getUV($0d23c856ce11c301$var$_intersectPoint, $0d23c856ce11c301$var$_vA, $0d23c856ce11c301$var$_vB, $0d23c856ce11c301$var$_vC, $0d23c856ce11c301$var$_uvA, $0d23c856ce11c301$var$_uvB, $0d23c856ce11c301$var$_uvC, new $0d23c856ce11c301$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source) {
        super.copy(source);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
$0d23c856ce11c301$export$3075603db8e6204c.prototype.isSprite = true;
function $0d23c856ce11c301$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $0d23c856ce11c301$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $0d23c856ce11c301$var$_rotatedPosition.x = cos * $0d23c856ce11c301$var$_alignedPosition.x - sin * $0d23c856ce11c301$var$_alignedPosition.y;
        $0d23c856ce11c301$var$_rotatedPosition.y = sin * $0d23c856ce11c301$var$_alignedPosition.x + cos * $0d23c856ce11c301$var$_alignedPosition.y;
    } else $0d23c856ce11c301$var$_rotatedPosition.copy($0d23c856ce11c301$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $0d23c856ce11c301$var$_rotatedPosition.x;
    vertexPosition.y += $0d23c856ce11c301$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($0d23c856ce11c301$var$_viewWorldMatrix);
}
const $0d23c856ce11c301$var$_v1$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_v2$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$112e7237be0c5f30 extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance < levels[i].distance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $0d23c856ce11c301$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($0d23c856ce11c301$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $0d23c856ce11c301$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $0d23c856ce11c301$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $0d23c856ce11c301$var$_v1$2.distanceTo($0d23c856ce11c301$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance >= levels[i].distance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance
            });
        }
        return data;
    }
}
const $0d23c856ce11c301$var$_basePosition = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_skinIndex = /*@__PURE__*/ new $0d23c856ce11c301$export$fa7daccca11cdbe3();
const $0d23c856ce11c301$var$_skinWeight = /*@__PURE__*/ new $0d23c856ce11c301$export$fa7daccca11cdbe3();
const $0d23c856ce11c301$var$_vector$5 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_matrix = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
class $0d23c856ce11c301$export$b303577035157ecf extends $0d23c856ce11c301$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.type = "SkinnedMesh";
        this.bindMode = "attached";
        this.bindMatrix = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
    }
    copy(source) {
        super.copy(source);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        return this;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $0d23c856ce11c301$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.x = skinWeight.getX(i);
            vector.y = skinWeight.getY(i);
            vector.z = skinWeight.getZ(i);
            vector.w = skinWeight.getW(i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === "attached") this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === "detached") this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    boneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $0d23c856ce11c301$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $0d23c856ce11c301$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $0d23c856ce11c301$var$_basePosition.fromBufferAttribute(geometry.attributes.position, index).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $0d23c856ce11c301$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $0d23c856ce11c301$var$_skinIndex.getComponent(i);
                $0d23c856ce11c301$var$_matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($0d23c856ce11c301$var$_vector$5.copy($0d23c856ce11c301$var$_basePosition).applyMatrix4($0d23c856ce11c301$var$_matrix), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
$0d23c856ce11c301$export$b303577035157ecf.prototype.isSkinnedMesh = true;
class $0d23c856ce11c301$export$b127726e56765aa4 extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Bone";
    }
}
$0d23c856ce11c301$export$b127726e56765aa4.prototype.isBone = true;
class $0d23c856ce11c301$export$b691f601014eabe1 extends $0d23c856ce11c301$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $0d23c856ce11c301$export$727aa5ec3fe39bf0, minFilter = $0d23c856ce11c301$export$727aa5ec3fe39bf0, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.needsUpdate = true;
    }
}
$0d23c856ce11c301$export$b691f601014eabe1.prototype.isDataTexture = true;
const $0d23c856ce11c301$var$_offsetMatrix = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_identityMatrix = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
class $0d23c856ce11c301$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $0d23c856ce11c301$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $0d23c856ce11c301$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $0d23c856ce11c301$var$_identityMatrix;
            $0d23c856ce11c301$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $0d23c856ce11c301$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $0d23c856ce11c301$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $0d23c856ce11c301$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $0d23c856ce11c301$export$b691f601014eabe1(boneMatrices, size, size, $0d23c856ce11c301$export$3f8bb04b555a363c, $0d23c856ce11c301$export$f6d331659b644596);
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $0d23c856ce11c301$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $0d23c856ce11c301$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
const $0d23c856ce11c301$var$_instanceLocalMatrix = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_instanceWorldMatrix = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_instanceIntersects = [];
const $0d23c856ce11c301$var$_mesh = /*@__PURE__*/ new $0d23c856ce11c301$export$e176487c05830cc5();
class $0d23c856ce11c301$export$f3c979c331175ad7 extends $0d23c856ce11c301$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.instanceMatrix = new $0d23c856ce11c301$export$8dea267bd6bde117(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.frustumCulled = false;
    }
    copy(source) {
        super.copy(source);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $0d23c856ce11c301$var$_mesh.geometry = this.geometry;
        $0d23c856ce11c301$var$_mesh.material = this.material;
        if ($0d23c856ce11c301$var$_mesh.material === undefined) return;
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $0d23c856ce11c301$var$_instanceLocalMatrix);
            $0d23c856ce11c301$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $0d23c856ce11c301$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $0d23c856ce11c301$var$_mesh.matrixWorld = $0d23c856ce11c301$var$_instanceWorldMatrix;
            $0d23c856ce11c301$var$_mesh.raycast(raycaster, $0d23c856ce11c301$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $0d23c856ce11c301$var$_instanceIntersects.length; i < l; i++){
                const intersect = $0d23c856ce11c301$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $0d23c856ce11c301$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $0d23c856ce11c301$export$8dea267bd6bde117(new Float32Array(this.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
$0d23c856ce11c301$export$f3c979c331175ad7.prototype.isInstancedMesh = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *  linecap: "round",
 *  linejoin: "round"
 * }
 */ class $0d23c856ce11c301$export$fbaaa33907730a0c extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "LineBasicMaterial";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff);
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.morphTargets = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.morphTargets = source.morphTargets;
        return this;
    }
}
$0d23c856ce11c301$export$fbaaa33907730a0c.prototype.isLineBasicMaterial = true;
const $0d23c856ce11c301$var$_start$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_end$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_inverseMatrix$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_ray$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$a186db52eed6d40e();
const $0d23c856ce11c301$var$_sphere$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$805e8b72413ccaba();
class $0d23c856ce11c301$export$17d680238e50603e extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(geometry = new $0d23c856ce11c301$export$b7be63a67df8959(), material = new $0d23c856ce11c301$export$fbaaa33907730a0c()){
        super();
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source) {
        super.copy(source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [
                    0
                ];
                for(let i = 1, l = positionAttribute.count; i < l; i++){
                    $0d23c856ce11c301$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                    $0d23c856ce11c301$var$_end$1.fromBufferAttribute(positionAttribute, i);
                    lineDistances[i] = lineDistances[i - 1];
                    lineDistances[i] += $0d23c856ce11c301$var$_start$1.distanceTo($0d23c856ce11c301$var$_end$1);
                }
                geometry.setAttribute("lineDistance", new $0d23c856ce11c301$export$cbe7a62641830ebd(lineDistances, 1));
            } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        } else if (geometry.isGeometry) console.error("THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0d23c856ce11c301$var$_sphere$1.copy(geometry.boundingSphere);
        $0d23c856ce11c301$var$_sphere$1.applyMatrix4(matrixWorld);
        $0d23c856ce11c301$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($0d23c856ce11c301$var$_sphere$1) === false) return;
        //
        $0d23c856ce11c301$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $0d23c856ce11c301$var$_ray$1.copy(raycaster.ray).applyMatrix4($0d23c856ce11c301$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $0d23c856ce11c301$export$64b5c384219d3699();
        const vEnd = new $0d23c856ce11c301$export$64b5c384219d3699();
        const interSegment = new $0d23c856ce11c301$export$64b5c384219d3699();
        const interRay = new $0d23c856ce11c301$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, l = end - 1; i < l; i += step){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    vStart.fromBufferAttribute(positionAttribute, a);
                    vEnd.fromBufferAttribute(positionAttribute, b);
                    const distSq = $0d23c856ce11c301$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    const distance = raycaster.ray.origin.distanceTo(interRay);
                    if (distance < raycaster.near || distance > raycaster.far) continue;
                    intersects.push({
                        distance: distance,
                        // What do we want? intersection point on the ray or on the segment??
                        // point: raycaster.ray.at( distance ),
                        point: interSegment.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            } else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                for(let i = start, l = end - 1; i < l; i += step){
                    vStart.fromBufferAttribute(positionAttribute, i);
                    vEnd.fromBufferAttribute(positionAttribute, i + 1);
                    const distSq = $0d23c856ce11c301$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    const distance = raycaster.ray.origin.distanceTo(interRay);
                    if (distance < raycaster.near || distance > raycaster.far) continue;
                    intersects.push({
                        distance: distance,
                        // What do we want? intersection point on the ray or on the segment??
                        // point: raycaster.ray.at( distance ),
                        point: interSegment.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            }
        } else if (geometry.isGeometry) console.error("THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error("THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
}
$0d23c856ce11c301$export$17d680238e50603e.prototype.isLine = true;
const $0d23c856ce11c301$var$_start = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_end = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$ff1ed10fedfdd604 extends $0d23c856ce11c301$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.type = "LineSegments";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [];
                for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                    $0d23c856ce11c301$var$_start.fromBufferAttribute(positionAttribute, i);
                    $0d23c856ce11c301$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                    lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                    lineDistances[i + 1] = lineDistances[i] + $0d23c856ce11c301$var$_start.distanceTo($0d23c856ce11c301$var$_end);
                }
                geometry.setAttribute("lineDistance", new $0d23c856ce11c301$export$cbe7a62641830ebd(lineDistances, 1));
            } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        } else if (geometry.isGeometry) console.error("THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        return this;
    }
}
$0d23c856ce11c301$export$ff1ed10fedfdd604.prototype.isLineSegments = true;
class $0d23c856ce11c301$export$f85a24d745e4f17d extends $0d23c856ce11c301$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.type = "LineLoop";
    }
}
$0d23c856ce11c301$export$f85a24d745e4f17d.prototype.isLineLoop = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  size: <float>,
 *  sizeAttenuation: <bool>
 *
 *  morphTargets: <bool>
 * }
 */ class $0d23c856ce11c301$export$a178c45366ce5d6b extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "PointsMaterial";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.morphTargets = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.morphTargets = source.morphTargets;
        return this;
    }
}
$0d23c856ce11c301$export$a178c45366ce5d6b.prototype.isPointsMaterial = true;
const $0d23c856ce11c301$var$_inverseMatrix = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_ray = /*@__PURE__*/ new $0d23c856ce11c301$export$a186db52eed6d40e();
const $0d23c856ce11c301$var$_sphere = /*@__PURE__*/ new $0d23c856ce11c301$export$805e8b72413ccaba();
const $0d23c856ce11c301$var$_position$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$1c787534cb11aa3e extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(geometry = new $0d23c856ce11c301$export$b7be63a67df8959(), material = new $0d23c856ce11c301$export$a178c45366ce5d6b()){
        super();
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source) {
        super.copy(source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0d23c856ce11c301$var$_sphere.copy(geometry.boundingSphere);
        $0d23c856ce11c301$var$_sphere.applyMatrix4(matrixWorld);
        $0d23c856ce11c301$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($0d23c856ce11c301$var$_sphere) === false) return;
        //
        $0d23c856ce11c301$var$_inverseMatrix.copy(matrixWorld).invert();
        $0d23c856ce11c301$var$_ray.copy(raycaster.ray).applyMatrix4($0d23c856ce11c301$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i++){
                    const a = index.getX(i);
                    $0d23c856ce11c301$var$_position$2.fromBufferAttribute(positionAttribute, a);
                    $0d23c856ce11c301$var$testPoint($0d23c856ce11c301$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
                }
            } else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                for(let i = start, l = end; i < l; i++){
                    $0d23c856ce11c301$var$_position$2.fromBufferAttribute(positionAttribute, i);
                    $0d23c856ce11c301$var$testPoint($0d23c856ce11c301$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
                }
            }
        } else console.error("THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error("THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
}
$0d23c856ce11c301$export$1c787534cb11aa3e.prototype.isPoints = true;
function $0d23c856ce11c301$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $0d23c856ce11c301$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $0d23c856ce11c301$export$64b5c384219d3699();
        $0d23c856ce11c301$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $0d23c856ce11c301$export$6e09d1edf8d5a25c extends $0d23c856ce11c301$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.format = format !== undefined ? format : $0d23c856ce11c301$export$7c67423a5ee6f5eb;
        this.minFilter = minFilter !== undefined ? minFilter : $0d23c856ce11c301$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $0d23c856ce11c301$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
$0d23c856ce11c301$export$6e09d1edf8d5a25c.prototype.isVideoTexture = true;
class $0d23c856ce11c301$export$3466bac9141a5cc4 extends $0d23c856ce11c301$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
$0d23c856ce11c301$export$3466bac9141a5cc4.prototype.isCompressedTexture = true;
class $0d23c856ce11c301$export$f7189e49152d1c13 extends $0d23c856ce11c301$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.needsUpdate = true;
    }
}
$0d23c856ce11c301$export$f7189e49152d1c13.prototype.isCanvasTexture = true;
class $0d23c856ce11c301$export$fc830aa069cc8c2f extends $0d23c856ce11c301$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $0d23c856ce11c301$export$c1b6b5136be58045;
        if (format !== $0d23c856ce11c301$export$c1b6b5136be58045 && format !== $0d23c856ce11c301$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $0d23c856ce11c301$export$c1b6b5136be58045) type = $0d23c856ce11c301$export$c63dc51868b06a9d;
        if (type === undefined && format === $0d23c856ce11c301$export$1e113ac2d0905829) type = $0d23c856ce11c301$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $0d23c856ce11c301$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $0d23c856ce11c301$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
    }
}
$0d23c856ce11c301$export$fc830aa069cc8c2f.prototype.isDepthTexture = true;
class $0d23c856ce11c301$export$3f74fe60decf7462 extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 8, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
        const uv = new $0d23c856ce11c301$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$3f74fe60decf7462(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $0d23c856ce11c301$export$d4345c83207d7c68 extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $0d23c856ce11c301$export$64b5c384219d3699();
            const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $0d23c856ce11c301$export$c977b3e384af9ae1();
            const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$d4345c83207d7c68(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $0d23c856ce11c301$export$59d971120dc8b6e7 extends $0d23c856ce11c301$export$d4345c83207d7c68 {
    constructor(radius = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$59d971120dc8b6e7(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $0d23c856ce11c301$export$38789b531813345c extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(vertices, indices, radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $0d23c856ce11c301$export$64b5c384219d3699();
            const b = new $0d23c856ce11c301$export$64b5c384219d3699();
            const c = new $0d23c856ce11c301$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivison with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $0d23c856ce11c301$export$64b5c384219d3699();
            const b = new $0d23c856ce11c301$export$64b5c384219d3699();
            const c = new $0d23c856ce11c301$export$64b5c384219d3699();
            const centroid = new $0d23c856ce11c301$export$64b5c384219d3699();
            const uvA = new $0d23c856ce11c301$export$c977b3e384af9ae1();
            const uvB = new $0d23c856ce11c301$export$c977b3e384af9ae1();
            const uvC = new $0d23c856ce11c301$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$38789b531813345c(data.vertices, data.indices, data.radius, data.details);
    }
}
class $0d23c856ce11c301$export$37cd4e52cce48c4c extends $0d23c856ce11c301$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$37cd4e52cce48c4c(data.radius, data.detail);
    }
}
const $0d23c856ce11c301$var$_v0 = new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_v1$1 = new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_normal = new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_triangle = new $0d23c856ce11c301$export$5a465592bfe74b48();
class $0d23c856ce11c301$export$4730b1542707547f extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(geometry, thresholdAngle){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            thresholdAngle: thresholdAngle
        };
        thresholdAngle = thresholdAngle !== undefined ? thresholdAngle : 1;
        if (geometry.isGeometry === true) {
            console.error("THREE.EdgesGeometry no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
            return;
        }
        const precisionPoints = 4;
        const precision = Math.pow(10, precisionPoints);
        const thresholdDot = Math.cos($0d23c856ce11c301$var$DEG2RAD * thresholdAngle);
        const indexAttr = geometry.getIndex();
        const positionAttr = geometry.getAttribute("position");
        const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
        const indexArr = [
            0,
            0,
            0
        ];
        const vertKeys = [
            "a",
            "b",
            "c"
        ];
        const hashes = new Array(3);
        const edgeData = {};
        const vertices = [];
        for(let i = 0; i < indexCount; i += 3){
            if (indexAttr) {
                indexArr[0] = indexAttr.getX(i);
                indexArr[1] = indexAttr.getX(i + 1);
                indexArr[2] = indexAttr.getX(i + 2);
            } else {
                indexArr[0] = i;
                indexArr[1] = i + 1;
                indexArr[2] = i + 2;
            }
            const { a: a, b: b, c: c } = $0d23c856ce11c301$var$_triangle;
            a.fromBufferAttribute(positionAttr, indexArr[0]);
            b.fromBufferAttribute(positionAttr, indexArr[1]);
            c.fromBufferAttribute(positionAttr, indexArr[2]);
            $0d23c856ce11c301$var$_triangle.getNormal($0d23c856ce11c301$var$_normal);
            // create hashes for the edge from the vertices
            hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
            hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
            hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
            // skip degenerate triangles
            if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
            // iterate over every edge
            for(let j = 0; j < 3; j++){
                // get the first and next vertex making up the edge
                const jNext = (j + 1) % 3;
                const vecHash0 = hashes[j];
                const vecHash1 = hashes[jNext];
                const v0 = $0d23c856ce11c301$var$_triangle[vertKeys[j]];
                const v1 = $0d23c856ce11c301$var$_triangle[vertKeys[jNext]];
                const hash = `${vecHash0}_${vecHash1}`;
                const reverseHash = `${vecHash1}_${vecHash0}`;
                if (reverseHash in edgeData && edgeData[reverseHash]) {
                    // if we found a sibling edge add it into the vertex array if
                    // it meets the angle threshold and delete the edge from the map.
                    if ($0d23c856ce11c301$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                        vertices.push(v0.x, v0.y, v0.z);
                        vertices.push(v1.x, v1.y, v1.z);
                    }
                    edgeData[reverseHash] = null;
                } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                edgeData[hash] = {
                    index0: indexArr[j],
                    index1: indexArr[jNext],
                    normal: $0d23c856ce11c301$var$_normal.clone()
                };
            }
        }
        // iterate over all remaining, unmatched edges and add them to the vertex array
        for(const key in edgeData)if (edgeData[key]) {
            const { index0: index0, index1: index1 } = edgeData[key];
            $0d23c856ce11c301$var$_v0.fromBufferAttribute(positionAttr, index0);
            $0d23c856ce11c301$var$_v1$1.fromBufferAttribute(positionAttr, index1);
            vertices.push($0d23c856ce11c301$var$_v0.x, $0d23c856ce11c301$var$_v0.y, $0d23c856ce11c301$var$_v0.z);
            vertices.push($0d23c856ce11c301$var$_v1$1.x, $0d23c856ce11c301$var$_v1$1.y, $0d23c856ce11c301$var$_v1$1.z);
        }
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $0d23c856ce11c301$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $0d23c856ce11c301$export$c977b3e384af9ae1() : new $0d23c856ce11c301$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $0d23c856ce11c301$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $0d23c856ce11c301$export$64b5c384219d3699();
        const mat = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $0d23c856ce11c301$export$64b5c384219d3699());
            tangents[i].normalize();
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $0d23c856ce11c301$export$64b5c384219d3699();
        binormals[0] = new $0d23c856ce11c301$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($0d23c856ce11c301$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($0d23c856ce11c301$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $0d23c856ce11c301$export$3f87a931616cde04 extends $0d23c856ce11c301$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $0d23c856ce11c301$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
$0d23c856ce11c301$export$3f87a931616cde04.prototype.isEllipseCurve = true;
class $0d23c856ce11c301$export$b1eedc9aab6300e8 extends $0d23c856ce11c301$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.type = "ArcCurve";
    }
}
$0d23c856ce11c301$export$b1eedc9aab6300e8.prototype.isArcCurve = true;
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $0d23c856ce11c301$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $0d23c856ce11c301$var$tmp = new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$px = new $0d23c856ce11c301$var$CubicPoly(), $0d23c856ce11c301$var$py = new $0d23c856ce11c301$var$CubicPoly(), $0d23c856ce11c301$var$pz = new $0d23c856ce11c301$var$CubicPoly();
class $0d23c856ce11c301$export$b9146b27c24b744c extends $0d23c856ce11c301$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $0d23c856ce11c301$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $0d23c856ce11c301$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $0d23c856ce11c301$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $0d23c856ce11c301$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $0d23c856ce11c301$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $0d23c856ce11c301$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $0d23c856ce11c301$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $0d23c856ce11c301$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $0d23c856ce11c301$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $0d23c856ce11c301$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $0d23c856ce11c301$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($0d23c856ce11c301$var$px.calc(weight), $0d23c856ce11c301$var$py.calc(weight), $0d23c856ce11c301$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
$0d23c856ce11c301$export$b9146b27c24b744c.prototype.isCatmullRomCurve3 = true;
/**
 * Bezier Curves formulas obtained from
 * http://en.wikipedia.org/wiki/Bézier_curve
 */ function $0d23c856ce11c301$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $0d23c856ce11c301$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $0d23c856ce11c301$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $0d23c856ce11c301$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $0d23c856ce11c301$var$QuadraticBezier(t, p0, p1, p2) {
    return $0d23c856ce11c301$var$QuadraticBezierP0(t, p0) + $0d23c856ce11c301$var$QuadraticBezierP1(t, p1) + $0d23c856ce11c301$var$QuadraticBezierP2(t, p2);
}
//
function $0d23c856ce11c301$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $0d23c856ce11c301$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $0d23c856ce11c301$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $0d23c856ce11c301$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $0d23c856ce11c301$var$CubicBezier(t, p0, p1, p2, p3) {
    return $0d23c856ce11c301$var$CubicBezierP0(t, p0) + $0d23c856ce11c301$var$CubicBezierP1(t, p1) + $0d23c856ce11c301$var$CubicBezierP2(t, p2) + $0d23c856ce11c301$var$CubicBezierP3(t, p3);
}
class $0d23c856ce11c301$export$e36650d36468bb39 extends $0d23c856ce11c301$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0d23c856ce11c301$export$c977b3e384af9ae1(), v1 = new $0d23c856ce11c301$export$c977b3e384af9ae1(), v2 = new $0d23c856ce11c301$export$c977b3e384af9ae1(), v3 = new $0d23c856ce11c301$export$c977b3e384af9ae1()){
        super();
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $0d23c856ce11c301$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($0d23c856ce11c301$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $0d23c856ce11c301$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
$0d23c856ce11c301$export$e36650d36468bb39.prototype.isCubicBezierCurve = true;
class $0d23c856ce11c301$export$13d5f1c9525f246c extends $0d23c856ce11c301$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0d23c856ce11c301$export$64b5c384219d3699(), v1 = new $0d23c856ce11c301$export$64b5c384219d3699(), v2 = new $0d23c856ce11c301$export$64b5c384219d3699(), v3 = new $0d23c856ce11c301$export$64b5c384219d3699()){
        super();
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $0d23c856ce11c301$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($0d23c856ce11c301$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $0d23c856ce11c301$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $0d23c856ce11c301$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
$0d23c856ce11c301$export$13d5f1c9525f246c.prototype.isCubicBezierCurve3 = true;
class $0d23c856ce11c301$export$ab2e07e76531a47e extends $0d23c856ce11c301$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $0d23c856ce11c301$export$c977b3e384af9ae1(), v2 = new $0d23c856ce11c301$export$c977b3e384af9ae1()){
        super();
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0d23c856ce11c301$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget) {
        const tangent = optionalTarget || new $0d23c856ce11c301$export$c977b3e384af9ae1();
        tangent.copy(this.v2).sub(this.v1).normalize();
        return tangent;
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
$0d23c856ce11c301$export$ab2e07e76531a47e.prototype.isLineCurve = true;
class $0d23c856ce11c301$export$1fdfd9d9cf487600 extends $0d23c856ce11c301$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $0d23c856ce11c301$export$64b5c384219d3699(), v2 = new $0d23c856ce11c301$export$64b5c384219d3699()){
        super();
        this.type = "LineCurve3";
        this.isLineCurve3 = true;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0d23c856ce11c301$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $0d23c856ce11c301$export$5938c4ee491a43ad extends $0d23c856ce11c301$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0d23c856ce11c301$export$c977b3e384af9ae1(), v1 = new $0d23c856ce11c301$export$c977b3e384af9ae1(), v2 = new $0d23c856ce11c301$export$c977b3e384af9ae1()){
        super();
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0d23c856ce11c301$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($0d23c856ce11c301$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $0d23c856ce11c301$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
$0d23c856ce11c301$export$5938c4ee491a43ad.prototype.isQuadraticBezierCurve = true;
class $0d23c856ce11c301$export$bf3f4c7e459f90fc extends $0d23c856ce11c301$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0d23c856ce11c301$export$64b5c384219d3699(), v1 = new $0d23c856ce11c301$export$64b5c384219d3699(), v2 = new $0d23c856ce11c301$export$64b5c384219d3699()){
        super();
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0d23c856ce11c301$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($0d23c856ce11c301$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $0d23c856ce11c301$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $0d23c856ce11c301$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
$0d23c856ce11c301$export$bf3f4c7e459f90fc.prototype.isQuadraticBezierCurve3 = true;
class $0d23c856ce11c301$export$d3bdd77da77afc1b extends $0d23c856ce11c301$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.type = "SplineCurve";
        this.points = points;
    }
    getPoint(t, optionalTarget = new $0d23c856ce11c301$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($0d23c856ce11c301$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $0d23c856ce11c301$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $0d23c856ce11c301$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
$0d23c856ce11c301$export$d3bdd77da77afc1b.prototype.isSplineCurve = true;
var $0d23c856ce11c301$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $0d23c856ce11c301$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $0d23c856ce11c301$export$b9146b27c24b744c,
    CubicBezierCurve: $0d23c856ce11c301$export$e36650d36468bb39,
    CubicBezierCurve3: $0d23c856ce11c301$export$13d5f1c9525f246c,
    EllipseCurve: $0d23c856ce11c301$export$3f87a931616cde04,
    LineCurve: $0d23c856ce11c301$export$ab2e07e76531a47e,
    LineCurve3: $0d23c856ce11c301$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $0d23c856ce11c301$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $0d23c856ce11c301$export$bf3f4c7e459f90fc,
    SplineCurve: $0d23c856ce11c301$export$d3bdd77da77afc1b
});
/**
 * Port from https://github.com/mapbox/earcut (v2.2.2)
 */ const $0d23c856ce11c301$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $0d23c856ce11c301$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $0d23c856ce11c301$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 1 / invSize : 0;
        }
        $0d23c856ce11c301$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $0d23c856ce11c301$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $0d23c856ce11c301$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $0d23c856ce11c301$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $0d23c856ce11c301$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $0d23c856ce11c301$var$equals(last, last.next)) {
        $0d23c856ce11c301$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $0d23c856ce11c301$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($0d23c856ce11c301$var$equals(p, p.next) || $0d23c856ce11c301$var$area(p.prev, p, p.next) === 0)) {
            $0d23c856ce11c301$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $0d23c856ce11c301$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $0d23c856ce11c301$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $0d23c856ce11c301$var$isEarHashed(ear, minX, minY, invSize) : $0d23c856ce11c301$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            $0d23c856ce11c301$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $0d23c856ce11c301$var$earcutLinked($0d23c856ce11c301$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $0d23c856ce11c301$var$cureLocalIntersections($0d23c856ce11c301$var$filterPoints(ear), triangles, dim);
                $0d23c856ce11c301$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $0d23c856ce11c301$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $0d23c856ce11c301$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($0d23c856ce11c301$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    let p = ear.next.next;
    while(p !== ear.prev){
        if ($0d23c856ce11c301$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $0d23c856ce11c301$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $0d23c856ce11c301$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($0d23c856ce11c301$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // triangle bbox; min & max are calculated like this for speed
    const minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    // z-order range for the current triangle bbox;
    const minZ = $0d23c856ce11c301$var$zOrder(minTX, minTY, minX, minY, invSize), maxZ = $0d23c856ce11c301$var$zOrder(maxTX, maxTY, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && $0d23c856ce11c301$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $0d23c856ce11c301$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && $0d23c856ce11c301$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $0d23c856ce11c301$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && $0d23c856ce11c301$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $0d23c856ce11c301$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n !== ear.prev && n !== ear.next && $0d23c856ce11c301$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $0d23c856ce11c301$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $0d23c856ce11c301$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$0d23c856ce11c301$var$equals(a, b) && $0d23c856ce11c301$var$intersects(a, p, p.next, b) && $0d23c856ce11c301$var$locallyInside(a, b) && $0d23c856ce11c301$var$locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            // remove two nodes involved
            $0d23c856ce11c301$var$removeNode(p);
            $0d23c856ce11c301$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $0d23c856ce11c301$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $0d23c856ce11c301$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $0d23c856ce11c301$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $0d23c856ce11c301$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $0d23c856ce11c301$var$filterPoints(a, a.next);
                c = $0d23c856ce11c301$var$filterPoints(c, c.next);
                // run earcut on each half
                $0d23c856ce11c301$var$earcutLinked(a, triangles, dim, minX, minY, invSize);
                $0d23c856ce11c301$var$earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $0d23c856ce11c301$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $0d23c856ce11c301$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($0d23c856ce11c301$var$getLeftmost(list));
    }
    queue.sort($0d23c856ce11c301$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++){
        $0d23c856ce11c301$var$eliminateHole(queue[i], outerNode);
        outerNode = $0d23c856ce11c301$var$filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function $0d23c856ce11c301$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $0d23c856ce11c301$var$eliminateHole(hole, outerNode) {
    outerNode = $0d23c856ce11c301$var$findHoleBridge(hole, outerNode);
    if (outerNode) {
        const b = $0d23c856ce11c301$var$splitPolygon(outerNode, hole);
        // filter collinear points around the cuts
        $0d23c856ce11c301$var$filterPoints(outerNode, outerNode.next);
        $0d23c856ce11c301$var$filterPoints(b, b.next);
    }
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $0d23c856ce11c301$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $0d23c856ce11c301$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($0d23c856ce11c301$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $0d23c856ce11c301$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $0d23c856ce11c301$var$sectorContainsSector(m, p) {
    return $0d23c856ce11c301$var$area(m.prev, m, p.prev) < 0 && $0d23c856ce11c301$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $0d23c856ce11c301$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === null) p.z = $0d23c856ce11c301$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $0d23c856ce11c301$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $0d23c856ce11c301$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $0d23c856ce11c301$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $0d23c856ce11c301$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $0d23c856ce11c301$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $0d23c856ce11c301$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$0d23c856ce11c301$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($0d23c856ce11c301$var$locallyInside(a, b) && $0d23c856ce11c301$var$locallyInside(b, a) && $0d23c856ce11c301$var$middleInside(a, b) && // locally visible
    ($0d23c856ce11c301$var$area(a.prev, a, b.prev) || $0d23c856ce11c301$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $0d23c856ce11c301$var$equals(a, b) && $0d23c856ce11c301$var$area(a.prev, a, a.next) > 0 && $0d23c856ce11c301$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $0d23c856ce11c301$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $0d23c856ce11c301$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $0d23c856ce11c301$var$intersects(p1, q1, p2, q2) {
    const o1 = $0d23c856ce11c301$var$sign($0d23c856ce11c301$var$area(p1, q1, p2));
    const o2 = $0d23c856ce11c301$var$sign($0d23c856ce11c301$var$area(p1, q1, q2));
    const o3 = $0d23c856ce11c301$var$sign($0d23c856ce11c301$var$area(p2, q2, p1));
    const o4 = $0d23c856ce11c301$var$sign($0d23c856ce11c301$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $0d23c856ce11c301$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $0d23c856ce11c301$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $0d23c856ce11c301$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $0d23c856ce11c301$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $0d23c856ce11c301$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $0d23c856ce11c301$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $0d23c856ce11c301$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $0d23c856ce11c301$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $0d23c856ce11c301$var$locallyInside(a, b) {
    return $0d23c856ce11c301$var$area(a.prev, a, a.next) < 0 ? $0d23c856ce11c301$var$area(a, b, a.next) >= 0 && $0d23c856ce11c301$var$area(a, a.prev, b) >= 0 : $0d23c856ce11c301$var$area(a, b, a.prev) < 0 || $0d23c856ce11c301$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $0d23c856ce11c301$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $0d23c856ce11c301$var$splitPolygon(a, b) {
    const a2 = new $0d23c856ce11c301$var$Node(a.i, a.x, a.y), b2 = new $0d23c856ce11c301$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $0d23c856ce11c301$var$insertNode(i, x, y, last) {
    const p = new $0d23c856ce11c301$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $0d23c856ce11c301$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $0d23c856ce11c301$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = null;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $0d23c856ce11c301$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $0d23c856ce11c301$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $0d23c856ce11c301$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $0d23c856ce11c301$var$removeDupEndPts(contour);
        $0d23c856ce11c301$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($0d23c856ce11c301$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $0d23c856ce11c301$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $0d23c856ce11c301$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $0d23c856ce11c301$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $0d23c856ce11c301$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $0d23c856ce11c301$export$91836d01b9f75a58 extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(shapes, options){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            let depth = options.depth !== undefined ? options.depth : 100;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $0d23c856ce11c301$var$WorldUVGenerator;
            // deprecated options
            if (options.amount !== undefined) {
                console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth.");
                depth = options.amount;
            }
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $0d23c856ce11c301$export$64b5c384219d3699();
                normal = new $0d23c856ce11c301$export$64b5c384219d3699();
                position2 = new $0d23c856ce11c301$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$0d23c856ce11c301$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($0d23c856ce11c301$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $0d23c856ce11c301$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return vec.clone().multiplyScalar(size).add(pt);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $0d23c856ce11c301$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $0d23c856ce11c301$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $0d23c856ce11c301$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $0d23c856ce11c301$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $0d23c856ce11c301$export$91836d01b9f75a58(geometryShapes, data.options);
    }
}
const $0d23c856ce11c301$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $0d23c856ce11c301$export$c977b3e384af9ae1(a_x, a_y),
            new $0d23c856ce11c301$export$c977b3e384af9ae1(b_x, b_y),
            new $0d23c856ce11c301$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $0d23c856ce11c301$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $0d23c856ce11c301$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $0d23c856ce11c301$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $0d23c856ce11c301$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $0d23c856ce11c301$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $0d23c856ce11c301$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $0d23c856ce11c301$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $0d23c856ce11c301$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $0d23c856ce11c301$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $0d23c856ce11c301$export$731fd4feef063ea2 extends $0d23c856ce11c301$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$731fd4feef063ea2(data.radius, data.detail);
    }
}
class $0d23c856ce11c301$export$dc3e1273c1dd9240 extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(points, segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $0d23c856ce11c301$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
        const uv = new $0d23c856ce11c301$export$c977b3e384af9ae1();
        // generate vertices and uvs
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
        // generate normals
        this.computeVertexNormals();
        // if the geometry is closed, we need to average the normals along the seam.
        // because the corresponding vertices are identical (but still have different UVs).
        if (phiLength === Math.PI * 2) {
            const normals = this.attributes.normal.array;
            const n1 = new $0d23c856ce11c301$export$64b5c384219d3699();
            const n2 = new $0d23c856ce11c301$export$64b5c384219d3699();
            const n = new $0d23c856ce11c301$export$64b5c384219d3699();
            // this is the buffer offset for the last line of vertices
            const base = segments * points.length * 3;
            for(let i = 0, j = 0; i < points.length; i++, j += 3){
                // select the normal of the vertex in the first line
                n1.x = normals[j + 0];
                n1.y = normals[j + 1];
                n1.z = normals[j + 2];
                // select the normal of the vertex in the last line
                n2.x = normals[base + j + 0];
                n2.y = normals[base + j + 1];
                n2.z = normals[base + j + 2];
                // average normals
                n.addVectors(n1, n2).normalize();
                // assign the new values to both normals
                normals[j + 0] = normals[base + j + 0] = n.x;
                normals[j + 1] = normals[base + j + 1] = n.y;
                normals[j + 2] = normals[base + j + 2] = n.z;
            }
        }
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$dc3e1273c1dd9240(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $0d23c856ce11c301$export$8e05fc91596f4752 extends $0d23c856ce11c301$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$8e05fc91596f4752(data.radius, data.detail);
    }
}
/**
 * Parametric Surfaces Geometry
 * based on the brilliant article by @prideout https://prideout.net/blog/old/blog/index.html@p=44.html
 */ class $0d23c856ce11c301$export$c56b5b5c6f0a7fff extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(func, slices, stacks){
        super();
        this.type = "ParametricGeometry";
        this.parameters = {
            func: func,
            slices: slices,
            stacks: stacks
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        const EPS = 0.00001;
        const normal = new $0d23c856ce11c301$export$64b5c384219d3699();
        const p0 = new $0d23c856ce11c301$export$64b5c384219d3699(), p1 = new $0d23c856ce11c301$export$64b5c384219d3699();
        const pu = new $0d23c856ce11c301$export$64b5c384219d3699(), pv = new $0d23c856ce11c301$export$64b5c384219d3699();
        if (func.length < 3) console.error("THREE.ParametricGeometry: Function must now modify a Vector3 as third parameter.");
        // generate vertices, normals and uvs
        const sliceCount = slices + 1;
        for(let i = 0; i <= stacks; i++){
            const v = i / stacks;
            for(let j = 0; j <= slices; j++){
                const u = j / slices;
                // vertex
                func(u, v, p0);
                vertices.push(p0.x, p0.y, p0.z);
                // normal
                // approximate tangent vectors via finite differences
                if (u - EPS >= 0) {
                    func(u - EPS, v, p1);
                    pu.subVectors(p0, p1);
                } else {
                    func(u + EPS, v, p1);
                    pu.subVectors(p1, p0);
                }
                if (v - EPS >= 0) {
                    func(u, v - EPS, p1);
                    pv.subVectors(p0, p1);
                } else {
                    func(u, v + EPS, p1);
                    pv.subVectors(p1, p0);
                }
                // cross product of tangent vectors returns surface normal
                normal.crossVectors(pu, pv).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u, v);
            }
        }
        // generate indices
        for(let i = 0; i < stacks; i++)for(let j = 0; j < slices; j++){
            const a = i * sliceCount + j;
            const b = i * sliceCount + j + 1;
            const c = (i + 1) * sliceCount + j + 1;
            const d = (i + 1) * sliceCount + j;
            // faces one and two
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
    }
}
class $0d23c856ce11c301$export$ee8b85b34b7d9cad extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 8, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
        const uv = new $0d23c856ce11c301$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$ee8b85b34b7d9cad(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $0d23c856ce11c301$export$233afc324766bed8 extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(shapes, curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($0d23c856ce11c301$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($0d23c856ce11c301$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $0d23c856ce11c301$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // incides
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $0d23c856ce11c301$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $0d23c856ce11c301$export$233afc324766bed8(geometryShapes, data.curveSegments);
    }
}
function $0d23c856ce11c301$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $0d23c856ce11c301$export$d5d06a966fec4192 extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 8, heightSegments = 6, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
        const normal = new $0d23c856ce11c301$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy == 0 && thetaStart == 0) uOffset = 0.5 / widthSegments;
            else if (iy == heightSegments && thetaEnd == Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$d5d06a966fec4192(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $0d23c856ce11c301$export$369e08f62a796c65 extends $0d23c856ce11c301$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$369e08f62a796c65(data.radius, data.detail);
    }
}
/**
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  height: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float>, // how far from text outline (including bevelOffset) is bevel
 *  bevelOffset: <float> // how far from text outline does bevel start
 * }
 */ class $0d23c856ce11c301$export$89b83bbad46fe613 extends $0d23c856ce11c301$export$91836d01b9f75a58 {
    constructor(text, parameters = {}){
        const font = parameters.font;
        if (!(font && font.isFont)) {
            console.error("THREE.TextGeometry: font parameter is not an instance of THREE.Font.");
            return new $0d23c856ce11c301$export$b7be63a67df8959();
        }
        const shapes = font.generateShapes(text, parameters.size);
        // translate parameters to ExtrudeGeometry API
        parameters.depth = parameters.height !== undefined ? parameters.height : 50;
        // defaults
        if (parameters.bevelThickness === undefined) parameters.bevelThickness = 10;
        if (parameters.bevelSize === undefined) parameters.bevelSize = 8;
        if (parameters.bevelEnabled === undefined) parameters.bevelEnabled = false;
        super(shapes, parameters);
        this.type = "TextGeometry";
    }
}
class $0d23c856ce11c301$export$19d55f905fa4f2cb extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $0d23c856ce11c301$export$64b5c384219d3699();
        const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
        const normal = new $0d23c856ce11c301$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$19d55f905fa4f2cb(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $0d23c856ce11c301$export$2b32466f4274fe5c extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
        const normal = new $0d23c856ce11c301$export$64b5c384219d3699();
        const P1 = new $0d23c856ce11c301$export$64b5c384219d3699();
        const P2 = new $0d23c856ce11c301$export$64b5c384219d3699();
        const B = new $0d23c856ce11c301$export$64b5c384219d3699();
        const T = new $0d23c856ce11c301$export$64b5c384219d3699();
        const N = new $0d23c856ce11c301$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segement
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectos, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    static fromJSON(data) {
        return new $0d23c856ce11c301$export$2b32466f4274fe5c(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $0d23c856ce11c301$export$d97a193ce44e691b extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(path, tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
        const normal = new $0d23c856ce11c301$export$64b5c384219d3699();
        const uv = new $0d23c856ce11c301$export$c977b3e384af9ae1();
        let P = new $0d23c856ce11c301$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d23c856ce11c301$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d23c856ce11c301$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $0d23c856ce11c301$export$d97a193ce44e691b(new $0d23c856ce11c301$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $0d23c856ce11c301$export$4b739da06d24892b extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(geometry){
        super();
        this.type = "WireframeGeometry";
        if (geometry.isGeometry === true) {
            console.error("THREE.WireframeGeometry no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
            return;
        }
        // buffer
        const vertices = [];
        // helper variables
        const edge = [
            0,
            0
        ], edges = {};
        const vertex = new $0d23c856ce11c301$export$64b5c384219d3699();
        if (geometry.index !== null) {
            // indexed BufferGeometry
            const position = geometry.attributes.position;
            const indices = geometry.index;
            let groups = geometry.groups;
            if (groups.length === 0) groups = [
                {
                    start: 0,
                    count: indices.count,
                    materialIndex: 0
                }
            ];
            // create a data structure that contains all eges without duplicates
            for(let o = 0, ol = groups.length; o < ol; ++o){
                const group = groups[o];
                const start = group.start;
                const count = group.count;
                for(let i = start, l = start + count; i < l; i += 3)for(let j = 0; j < 3; j++){
                    const edge1 = indices.getX(i + j);
                    const edge2 = indices.getX(i + (j + 1) % 3);
                    edge[0] = Math.min(edge1, edge2); // sorting prevents duplicates
                    edge[1] = Math.max(edge1, edge2);
                    const key = edge[0] + "," + edge[1];
                    if (edges[key] === undefined) edges[key] = {
                        index1: edge[0],
                        index2: edge[1]
                    };
                }
            }
            // generate vertices
            for(const key in edges){
                const e = edges[key];
                vertex.fromBufferAttribute(position, e.index1);
                vertices.push(vertex.x, vertex.y, vertex.z);
                vertex.fromBufferAttribute(position, e.index2);
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        } else {
            // non-indexed BufferGeometry
            const position = geometry.attributes.position;
            for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                // three edges per triangle, an edge is represented as (index1, index2)
                // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                const index1 = 3 * i + j;
                vertex.fromBufferAttribute(position, index1);
                vertices.push(vertex.x, vertex.y, vertex.z);
                const index2 = 3 * i + (j + 1) % 3;
                vertex.fromBufferAttribute(position, index2);
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        // build geometry
        this.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
    }
}
var $0d23c856ce11c301$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $0d23c856ce11c301$export$ab3456a079aa7d80,
    BoxBufferGeometry: $0d23c856ce11c301$export$ab3456a079aa7d80,
    CircleGeometry: $0d23c856ce11c301$export$3f74fe60decf7462,
    CircleBufferGeometry: $0d23c856ce11c301$export$3f74fe60decf7462,
    ConeGeometry: $0d23c856ce11c301$export$59d971120dc8b6e7,
    ConeBufferGeometry: $0d23c856ce11c301$export$59d971120dc8b6e7,
    CylinderGeometry: $0d23c856ce11c301$export$d4345c83207d7c68,
    CylinderBufferGeometry: $0d23c856ce11c301$export$d4345c83207d7c68,
    DodecahedronGeometry: $0d23c856ce11c301$export$37cd4e52cce48c4c,
    DodecahedronBufferGeometry: $0d23c856ce11c301$export$37cd4e52cce48c4c,
    EdgesGeometry: $0d23c856ce11c301$export$4730b1542707547f,
    ExtrudeGeometry: $0d23c856ce11c301$export$91836d01b9f75a58,
    ExtrudeBufferGeometry: $0d23c856ce11c301$export$91836d01b9f75a58,
    IcosahedronGeometry: $0d23c856ce11c301$export$731fd4feef063ea2,
    IcosahedronBufferGeometry: $0d23c856ce11c301$export$731fd4feef063ea2,
    LatheGeometry: $0d23c856ce11c301$export$dc3e1273c1dd9240,
    LatheBufferGeometry: $0d23c856ce11c301$export$dc3e1273c1dd9240,
    OctahedronGeometry: $0d23c856ce11c301$export$8e05fc91596f4752,
    OctahedronBufferGeometry: $0d23c856ce11c301$export$8e05fc91596f4752,
    ParametricGeometry: $0d23c856ce11c301$export$c56b5b5c6f0a7fff,
    ParametricBufferGeometry: $0d23c856ce11c301$export$c56b5b5c6f0a7fff,
    PlaneGeometry: $0d23c856ce11c301$export$e789a11a194ca4e0,
    PlaneBufferGeometry: $0d23c856ce11c301$export$e789a11a194ca4e0,
    PolyhedronGeometry: $0d23c856ce11c301$export$38789b531813345c,
    PolyhedronBufferGeometry: $0d23c856ce11c301$export$38789b531813345c,
    RingGeometry: $0d23c856ce11c301$export$ee8b85b34b7d9cad,
    RingBufferGeometry: $0d23c856ce11c301$export$ee8b85b34b7d9cad,
    ShapeGeometry: $0d23c856ce11c301$export$233afc324766bed8,
    ShapeBufferGeometry: $0d23c856ce11c301$export$233afc324766bed8,
    SphereGeometry: $0d23c856ce11c301$export$d5d06a966fec4192,
    SphereBufferGeometry: $0d23c856ce11c301$export$d5d06a966fec4192,
    TetrahedronGeometry: $0d23c856ce11c301$export$369e08f62a796c65,
    TetrahedronBufferGeometry: $0d23c856ce11c301$export$369e08f62a796c65,
    TextGeometry: $0d23c856ce11c301$export$89b83bbad46fe613,
    TextBufferGeometry: $0d23c856ce11c301$export$89b83bbad46fe613,
    TorusGeometry: $0d23c856ce11c301$export$19d55f905fa4f2cb,
    TorusBufferGeometry: $0d23c856ce11c301$export$19d55f905fa4f2cb,
    TorusKnotGeometry: $0d23c856ce11c301$export$2b32466f4274fe5c,
    TorusKnotBufferGeometry: $0d23c856ce11c301$export$2b32466f4274fe5c,
    TubeGeometry: $0d23c856ce11c301$export$d97a193ce44e691b,
    TubeBufferGeometry: $0d23c856ce11c301$export$d97a193ce44e691b,
    WireframeGeometry: $0d23c856ce11c301$export$4b739da06d24892b
});
/**
 * parameters = {
 *  color: <THREE.Color>
 * }
 */ class $0d23c856ce11c301$export$e8564da406055a3 extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "ShadowMaterial";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        return this;
    }
}
$0d23c856ce11c301$export$e8564da406055a3.prototype.isShadowMaterial = true;
class $0d23c856ce11c301$export$21c421a2e1df9d22 extends $0d23c856ce11c301$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.type = "RawShaderMaterial";
    }
}
$0d23c856ce11c301$export$21c421a2e1df9d22.prototype.isRawShaderMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  roughness: <float>,
 *  metalness: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  roughnessMap: new THREE.Texture( <Image> ),
 *
 *  metalnessMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  envMapIntensity: <float>
 *
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *  flatShading: <bool>
 * }
 */ class $0d23c856ce11c301$export$f2980790215acccd extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0d23c856ce11c301$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0d23c856ce11c301$export$2852a58ebdac27b8;
        this.normalScale = new $0d23c856ce11c301$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.morphTargets = false;
        this.morphNormals = false;
        this.flatShading = false;
        this.vertexTangents = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.flatShading = source.flatShading;
        this.vertexTangents = source.vertexTangents;
        return this;
    }
}
$0d23c856ce11c301$export$f2980790215acccd.prototype.isMeshStandardMaterial = true;
/**
 * parameters = {
 *  clearcoat: <float>,
 *  clearcoatMap: new THREE.Texture( <Image> ),
 *  clearcoatRoughness: <float>,
 *  clearcoatRoughnessMap: new THREE.Texture( <Image> ),
 *  clearcoatNormalScale: <Vector2>,
 *  clearcoatNormalMap: new THREE.Texture( <Image> ),
 *
 *  reflectivity: <float>,
 *  ior: <float>,
 *
 *  sheen: <Color>,
 *
 *  transmission: <float>,
 *  transmissionMap: new THREE.Texture( <Image> ),
 *
 *  thickness: <float>,
 *  thicknessMap: new THREE.Texture( <Image> ),
 *  attenuationDistance: <float>,
 *  attenuationColor: <Color>
 * }
 */ class $0d23c856ce11c301$export$28d04986c4269c9f extends $0d23c856ce11c301$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.clearcoat = 0.0;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $0d23c856ce11c301$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.reflectivity = 0.5; // maps to F0 = 0.04
        Object.defineProperty(this, "ior", {
            get: function() {
                return (1 + 0.4 * this.reflectivity) / (1 - 0.4 * this.reflectivity);
            },
            set: function(ior) {
                this.reflectivity = $0d23c856ce11c301$var$clamp(2.5 * (ior - 1) / (ior + 1), 0, 1);
            }
        });
        this.sheen = null; // null will disable sheen bsdf
        this.transmission = 0.0;
        this.transmissionMap = null;
        this.thickness = 0.01;
        this.thicknessMap = null;
        this.attenuationDistance = 0.0;
        this.attenuationColor = new $0d23c856ce11c301$export$892596cec99bc70e(1, 1, 1);
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.reflectivity = source.reflectivity;
        if (source.sheen) this.sheen = (this.sheen || new $0d23c856ce11c301$export$892596cec99bc70e()).copy(source.sheen);
        else this.sheen = null;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        return this;
    }
}
$0d23c856ce11c301$export$28d04986c4269c9f.prototype.isMeshPhysicalMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  specular: <hex>,
 *  shininess: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.MultiplyOperation,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *  flatShading: <bool>
 * }
 */ class $0d23c856ce11c301$export$24c72f71cbaf0678 extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshPhongMaterial";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $0d23c856ce11c301$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0d23c856ce11c301$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0d23c856ce11c301$export$2852a58ebdac27b8;
        this.normalScale = new $0d23c856ce11c301$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $0d23c856ce11c301$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.morphTargets = false;
        this.morphNormals = false;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.flatShading = source.flatShading;
        return this;
    }
}
$0d23c856ce11c301$export$24c72f71cbaf0678.prototype.isMeshPhongMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *
 *  map: new THREE.Texture( <Image> ),
 *  gradientMap: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ class $0d23c856ce11c301$export$df893cf97e765622 extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0d23c856ce11c301$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0d23c856ce11c301$export$2852a58ebdac27b8;
        this.normalScale = new $0d23c856ce11c301$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.morphTargets = false;
        this.morphNormals = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        return this;
    }
}
$0d23c856ce11c301$export$df893cf97e765622.prototype.isMeshToonMaterial = true;
/**
 * parameters = {
 *  opacity: <float>,
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *  flatShading: <bool>
 * }
 */ class $0d23c856ce11c301$export$bfe8c0a091f41ae7 extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0d23c856ce11c301$export$2852a58ebdac27b8;
        this.normalScale = new $0d23c856ce11c301$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false;
        this.morphTargets = false;
        this.morphNormals = false;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.flatShading = source.flatShading;
        return this;
    }
}
$0d23c856ce11c301$export$bfe8c0a091f41ae7.prototype.isMeshNormalMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ class $0d23c856ce11c301$export$5023a9a8114806b8 extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshLambertMaterial";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0d23c856ce11c301$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $0d23c856ce11c301$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.morphTargets = false;
        this.morphNormals = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        return this;
    }
}
$0d23c856ce11c301$export$5023a9a8114806b8.prototype.isMeshLambertMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  matcap: new THREE.Texture( <Image> ),
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 *
 *  flatShading: <bool>
 * }
 */ class $0d23c856ce11c301$export$6f5fef6235ec12ee extends $0d23c856ce11c301$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0d23c856ce11c301$export$2852a58ebdac27b8;
        this.normalScale = new $0d23c856ce11c301$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.morphTargets = false;
        this.morphNormals = false;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.flatShading = source.flatShading;
        return this;
    }
}
$0d23c856ce11c301$export$6f5fef6235ec12ee.prototype.isMeshMatcapMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *
 *  scale: <float>,
 *  dashSize: <float>,
 *  gapSize: <float>
 * }
 */ class $0d23c856ce11c301$export$327886a3efaeaebe extends $0d23c856ce11c301$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
$0d23c856ce11c301$export$327886a3efaeaebe.prototype.isLineDashedMaterial = true;
var $0d23c856ce11c301$var$Materials = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ShadowMaterial: $0d23c856ce11c301$export$e8564da406055a3,
    SpriteMaterial: $0d23c856ce11c301$export$5ec7dd1c6994bf8e,
    RawShaderMaterial: $0d23c856ce11c301$export$21c421a2e1df9d22,
    ShaderMaterial: $0d23c856ce11c301$export$83c7d75d550a8b0d,
    PointsMaterial: $0d23c856ce11c301$export$a178c45366ce5d6b,
    MeshPhysicalMaterial: $0d23c856ce11c301$export$28d04986c4269c9f,
    MeshStandardMaterial: $0d23c856ce11c301$export$f2980790215acccd,
    MeshPhongMaterial: $0d23c856ce11c301$export$24c72f71cbaf0678,
    MeshToonMaterial: $0d23c856ce11c301$export$df893cf97e765622,
    MeshNormalMaterial: $0d23c856ce11c301$export$bfe8c0a091f41ae7,
    MeshLambertMaterial: $0d23c856ce11c301$export$5023a9a8114806b8,
    MeshDepthMaterial: $0d23c856ce11c301$export$2698c22ec13825db,
    MeshDistanceMaterial: $0d23c856ce11c301$export$33e187ed002f2a19,
    MeshBasicMaterial: $0d23c856ce11c301$export$55cbcc9b622fe1f5,
    MeshMatcapMaterial: $0d23c856ce11c301$export$6f5fef6235ec12ee,
    LineDashedMaterial: $0d23c856ce11c301$export$327886a3efaeaebe,
    LineBasicMaterial: $0d23c856ce11c301$export$fbaaa33907730a0c,
    Material: $0d23c856ce11c301$export$a2d8b23205c25948
});
const $0d23c856ce11c301$export$7ee8caa573e71ad1 = {
    // same as Array.prototype.slice, but also works on typed arrays
    arraySlice: function(array, from, to) {
        if ($0d23c856ce11c301$export$7ee8caa573e71ad1.isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
        // but array.subarray(from) or array.subarray(from, len) is correct
        return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
        return array.slice(from, to);
    },
    // converts an array to a specific type
    convertArray: function(array, type, forceClone) {
        if (!array || // let 'undefined' and 'null' pass
        !forceClone && array.constructor === type) return array;
        if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
        return Array.prototype.slice.call(array); // create Array
    },
    isTypedArray: function(object) {
        return ArrayBuffer.isView(object) && !(object instanceof DataView);
    },
    // returns an array by which times and values can be sorted
    getKeyframeOrder: function(times) {
        function compareTime(i, j) {
            return times[i] - times[j];
        }
        const n = times.length;
        const result = new Array(n);
        for(let i = 0; i !== n; ++i)result[i] = i;
        result.sort(compareTime);
        return result;
    },
    // uses the array previously returned by 'getKeyframeOrder' to sort data
    sortedArray: function(values, stride, order) {
        const nValues = values.length;
        const result = new values.constructor(nValues);
        for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
            const srcOffset = order[i] * stride;
            for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
        }
        return result;
    },
    // function for parsing AOS keyframe formats
    flattenJSON: function(jsonKeys, times, values, valuePropertyName) {
        let i = 1, key = jsonKeys[0];
        while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
        if (key === undefined) return; // no data
        let value = key[valuePropertyName];
        if (value === undefined) return; // no data
        if (Array.isArray(value)) do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push.apply(values, value); // push all elements
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else if (value.toArray !== undefined) // ...assume THREE.Math-ish
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                value.toArray(values, values.length);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else // otherwise push as-is
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push(value);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
    },
    subclip: function(sourceClip, name, startFrame, endFrame, fps = 30) {
        const clip = sourceClip.clone();
        clip.name = name;
        const tracks = [];
        for(let i = 0; i < clip.tracks.length; ++i){
            const track = clip.tracks[i];
            const valueSize = track.getValueSize();
            const times = [];
            const values = [];
            for(let j = 0; j < track.times.length; ++j){
                const frame = track.times[j] * fps;
                if (frame < startFrame || frame >= endFrame) continue;
                times.push(track.times[j]);
                for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
            }
            if (times.length === 0) continue;
            track.times = $0d23c856ce11c301$export$7ee8caa573e71ad1.convertArray(times, track.times.constructor);
            track.values = $0d23c856ce11c301$export$7ee8caa573e71ad1.convertArray(values, track.values.constructor);
            tracks.push(track);
        }
        clip.tracks = tracks;
        // find minimum .times value across all tracks in the trimmed clip
        let minStartTime = Infinity;
        for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
        // shift all tracks such that clip begins at t=0
        for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
        clip.resetDuration();
        return clip;
    },
    makeClipAdditive: function(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        if (fps <= 0) fps = 30;
        const numTracks = referenceClip.tracks.length;
        const referenceTime = referenceFrame / fps;
        // Make each track's values relative to the values at the reference frame
        for(let i = 0; i < numTracks; ++i){
            const referenceTrack = referenceClip.tracks[i];
            const referenceTrackType = referenceTrack.ValueTypeName;
            // Skip this track if it's non-numeric
            if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
            // Find the track in the target clip whose name and type matches the reference track
            const targetTrack = targetClip.tracks.find(function(track) {
                return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
            });
            if (targetTrack === undefined) continue;
            let referenceOffset = 0;
            const referenceValueSize = referenceTrack.getValueSize();
            if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
            let targetOffset = 0;
            const targetValueSize = targetTrack.getValueSize();
            if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
            const lastIndex = referenceTrack.times.length - 1;
            let referenceValue;
            // Find the value to subtract out of the track
            if (referenceTime <= referenceTrack.times[0]) {
                // Reference frame is earlier than the first keyframe, so just use the first keyframe
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                referenceValue = $0d23c856ce11c301$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else if (referenceTime >= referenceTrack.times[lastIndex]) {
                // Reference frame is after the last keyframe, so just use the last keyframe
                const startIndex = lastIndex * referenceValueSize + referenceOffset;
                const endIndex = startIndex + referenceValueSize - referenceOffset;
                referenceValue = $0d23c856ce11c301$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else {
                // Interpolate to the reference value
                const interpolant = referenceTrack.createInterpolant();
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                interpolant.evaluate(referenceTime);
                referenceValue = $0d23c856ce11c301$export$7ee8caa573e71ad1.arraySlice(interpolant.resultBuffer, startIndex, endIndex);
            }
            // Conjugate the quaternion
            if (referenceTrackType === "quaternion") {
                const referenceQuat = new $0d23c856ce11c301$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
                referenceQuat.toArray(referenceValue);
            }
            // Subtract the reference value from all of the track values
            const numTimes = targetTrack.times.length;
            for(let j = 0; j < numTimes; ++j){
                const valueStart = j * targetValueSize + targetOffset;
                if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
                $0d23c856ce11c301$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
                else {
                    const valueEnd = targetValueSize - targetOffset * 2;
                    // Subtract each value for all other numeric track types
                    for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
                }
            }
        }
        targetClip.blendMode = $0d23c856ce11c301$export$d875e029ef558d3;
        return targetClip;
    }
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $0d23c856ce11c301$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.afterEnd_(i1 - 1, t, t0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.beforeStart_(0, t, t1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.beforeStart_(0, t, t1);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.afterEnd_(i1 - 1, t0, t);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
// ALIAS DEFINITIONS
$0d23c856ce11c301$export$b558baee9c0f72d3.prototype.beforeStart_ = $0d23c856ce11c301$export$b558baee9c0f72d3.prototype.copySampleValue_;
$0d23c856ce11c301$export$b558baee9c0f72d3.prototype.afterEnd_ = $0d23c856ce11c301$export$b558baee9c0f72d3.prototype.copySampleValue_;
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $0d23c856ce11c301$export$3646682e7a3959 extends $0d23c856ce11c301$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $0d23c856ce11c301$export$7f795934b84ab523,
            endingEnd: $0d23c856ce11c301$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $0d23c856ce11c301$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $0d23c856ce11c301$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $0d23c856ce11c301$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $0d23c856ce11c301$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $0d23c856ce11c301$export$a8e6009059f51e1a extends $0d23c856ce11c301$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceeding
 * the parameter.
 */ class $0d23c856ce11c301$export$fb9758ef7ef8d5cc extends $0d23c856ce11c301$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $0d23c856ce11c301$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $0d23c856ce11c301$export$7ee8caa573e71ad1.convertArray(times, this.TimeBufferType);
        this.values = $0d23c856ce11c301$export$7ee8caa573e71ad1.convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $0d23c856ce11c301$export$7ee8caa573e71ad1.convertArray(track.times, Array),
                "values": $0d23c856ce11c301$export$7ee8caa573e71ad1.convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $0d23c856ce11c301$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $0d23c856ce11c301$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $0d23c856ce11c301$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $0d23c856ce11c301$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $0d23c856ce11c301$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $0d23c856ce11c301$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $0d23c856ce11c301$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $0d23c856ce11c301$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $0d23c856ce11c301$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $0d23c856ce11c301$export$7ee8caa573e71ad1.arraySlice(times, from, to);
            this.values = $0d23c856ce11c301$export$7ee8caa573e71ad1.arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($0d23c856ce11c301$export$7ee8caa573e71ad1.isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $0d23c856ce11c301$export$7ee8caa573e71ad1.arraySlice(this.times), values = $0d23c856ce11c301$export$7ee8caa573e71ad1.arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $0d23c856ce11c301$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $0d23c856ce11c301$export$7ee8caa573e71ad1.arraySlice(times, 0, writeIndex);
            this.values = $0d23c856ce11c301$export$7ee8caa573e71ad1.arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $0d23c856ce11c301$export$7ee8caa573e71ad1.arraySlice(this.times, 0);
        const values = $0d23c856ce11c301$export$7ee8caa573e71ad1.arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$0d23c856ce11c301$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$0d23c856ce11c301$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$0d23c856ce11c301$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $0d23c856ce11c301$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $0d23c856ce11c301$export$d3a344b98cf0b775 extends $0d23c856ce11c301$export$b0e479f45b7006d6 {
}
$0d23c856ce11c301$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$0d23c856ce11c301$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$0d23c856ce11c301$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $0d23c856ce11c301$export$995b32462a65e855;
$0d23c856ce11c301$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$0d23c856ce11c301$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $0d23c856ce11c301$export$83444c5d885347d8 extends $0d23c856ce11c301$export$b0e479f45b7006d6 {
}
$0d23c856ce11c301$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $0d23c856ce11c301$export$d45f0d1a4d9a9314 extends $0d23c856ce11c301$export$b0e479f45b7006d6 {
}
$0d23c856ce11c301$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $0d23c856ce11c301$export$2db1cfb7923d931e extends $0d23c856ce11c301$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$0d23c856ce11c301$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $0d23c856ce11c301$export$b8043f12b5aafbd7 extends $0d23c856ce11c301$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $0d23c856ce11c301$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$0d23c856ce11c301$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
$0d23c856ce11c301$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $0d23c856ce11c301$export$30fac1aace31cf4d;
$0d23c856ce11c301$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $0d23c856ce11c301$export$6ce41d4f3a8df9cd extends $0d23c856ce11c301$export$b0e479f45b7006d6 {
}
$0d23c856ce11c301$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$0d23c856ce11c301$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$0d23c856ce11c301$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $0d23c856ce11c301$export$995b32462a65e855;
$0d23c856ce11c301$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$0d23c856ce11c301$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $0d23c856ce11c301$export$5ce2dcb4cc9f2bff extends $0d23c856ce11c301$export$b0e479f45b7006d6 {
}
$0d23c856ce11c301$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $0d23c856ce11c301$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $0d23c856ce11c301$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $0d23c856ce11c301$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($0d23c856ce11c301$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($0d23c856ce11c301$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $0d23c856ce11c301$export$7ee8caa573e71ad1.getKeyframeOrder(times);
            times = $0d23c856ce11c301$export$7ee8caa573e71ad1.sortedArray(times, 1, order);
            values = $0d23c856ce11c301$export$7ee8caa573e71ad1.sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $0d23c856ce11c301$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $0d23c856ce11c301$export$7ee8caa573e71ad1.flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $0d23c856ce11c301$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * (fps || 1.0);
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($0d23c856ce11c301$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($0d23c856ce11c301$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($0d23c856ce11c301$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $0d23c856ce11c301$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $0d23c856ce11c301$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $0d23c856ce11c301$export$5ce2dcb4cc9f2bff;
        case "color":
            return $0d23c856ce11c301$export$83444c5d885347d8;
        case "quaternion":
            return $0d23c856ce11c301$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $0d23c856ce11c301$export$d3a344b98cf0b775;
        case "string":
            return $0d23c856ce11c301$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $0d23c856ce11c301$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $0d23c856ce11c301$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $0d23c856ce11c301$export$7ee8caa573e71ad1.flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $0d23c856ce11c301$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $0d23c856ce11c301$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $0d23c856ce11c301$export$b033c3f9a95c6a16 = new $0d23c856ce11c301$export$99cc795e99919eed();
class $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $0d23c856ce11c301$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
const $0d23c856ce11c301$var$loading = {};
class $0d23c856ce11c301$export$98435a25b5cf7b2b extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $0d23c856ce11c301$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($0d23c856ce11c301$var$loading[url] !== undefined) {
            $0d23c856ce11c301$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Check for data: URI
        const dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
        const dataUriRegexResult = url.match(dataUriRegex);
        let request;
        // Safari can not handle Data URIs through XMLHttpRequest so process manually
        if (dataUriRegexResult) {
            const mimeType = dataUriRegexResult[1];
            const isBase64 = !!dataUriRegexResult[2];
            let data = dataUriRegexResult[3];
            data = decodeURIComponent(data);
            if (isBase64) data = atob(data);
            try {
                let response;
                const responseType = (this.responseType || "").toLowerCase();
                switch(responseType){
                    case "arraybuffer":
                    case "blob":
                        const view = new Uint8Array(data.length);
                        for(let i = 0; i < data.length; i++)view[i] = data.charCodeAt(i);
                        if (responseType === "blob") response = new Blob([
                            view.buffer
                        ], {
                            type: mimeType
                        });
                        else response = view.buffer;
                        break;
                    case "document":
                        const parser = new DOMParser();
                        response = parser.parseFromString(data, mimeType);
                        break;
                    case "json":
                        response = JSON.parse(data);
                        break;
                    default:
                        response = data;
                        break;
                }
                // Wait for next browser tick like standard XMLHttpRequest event dispatching does
                setTimeout(function() {
                    if (onLoad) onLoad(response);
                    scope.manager.itemEnd(url);
                }, 0);
            } catch (error) {
                // Wait for next browser tick like standard XMLHttpRequest event dispatching does
                setTimeout(function() {
                    if (onError) onError(error);
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                }, 0);
            }
        } else {
            // Initialise array for duplicate requests
            $0d23c856ce11c301$var$loading[url] = [];
            $0d23c856ce11c301$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            request = new XMLHttpRequest();
            request.open("GET", url, true);
            request.addEventListener("load", function(event) {
                const response = this.response;
                const callbacks = $0d23c856ce11c301$var$loading[url];
                delete $0d23c856ce11c301$var$loading[url];
                if (this.status === 200 || this.status === 0) {
                    // Some browsers return HTTP Status 0 when using non-http protocol
                    // e.g. 'file://' or 'data://'. Handle as success.
                    if (this.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                    // Add to cache only on HTTP success, so that we do not cache
                    // error response bodies as proper responses to requests.
                    $0d23c856ce11c301$export$94affb487e701bf2.add(url, response);
                    for(let i = 0, il = callbacks.length; i < il; i++){
                        const callback = callbacks[i];
                        if (callback.onLoad) callback.onLoad(response);
                    }
                    scope.manager.itemEnd(url);
                } else {
                    for(let i = 0, il = callbacks.length; i < il; i++){
                        const callback = callbacks[i];
                        if (callback.onError) callback.onError(event);
                    }
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                }
            }, false);
            request.addEventListener("progress", function(event) {
                const callbacks = $0d23c856ce11c301$var$loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onProgress) callback.onProgress(event);
                }
            }, false);
            request.addEventListener("error", function(event) {
                const callbacks = $0d23c856ce11c301$var$loading[url];
                delete $0d23c856ce11c301$var$loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onError) callback.onError(event);
                }
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            }, false);
            request.addEventListener("abort", function(event) {
                const callbacks = $0d23c856ce11c301$var$loading[url];
                delete $0d23c856ce11c301$var$loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onError) callback.onError(event);
                }
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            }, false);
            if (this.responseType !== undefined) request.responseType = this.responseType;
            if (this.withCredentials !== undefined) request.withCredentials = this.withCredentials;
            if (request.overrideMimeType) request.overrideMimeType(this.mimeType !== undefined ? this.mimeType : "text/plain");
            for(const header in this.requestHeader)request.setRequestHeader(header, this.requestHeader[header]);
            request.send(null);
        }
        scope.manager.itemStart(url);
        return request;
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $0d23c856ce11c301$export$29711c7e14f61db extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0d23c856ce11c301$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $0d23c856ce11c301$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $0d23c856ce11c301$export$bd73ce947a280350 extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $0d23c856ce11c301$export$3466bac9141a5cc4();
        const loader = new $0d23c856ce11c301$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $0d23c856ce11c301$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $0d23c856ce11c301$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $0d23c856ce11c301$export$8905ce1c7a2464a1 extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $0d23c856ce11c301$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = document.createElementNS("http://www.w3.org/1999/xhtml", "img");
        function onImageLoad() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
            $0d23c856ce11c301$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.substr(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $0d23c856ce11c301$export$2ec114afc2cf6308 extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $0d23c856ce11c301$export$ee2e5a18258a4049();
        const loader = new $0d23c856ce11c301$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $0d23c856ce11c301$export$792d8a18f2c55855 extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $0d23c856ce11c301$export$b691f601014eabe1();
        const loader = new $0d23c856ce11c301$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $0d23c856ce11c301$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $0d23c856ce11c301$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $0d23c856ce11c301$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $0d23c856ce11c301$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $0d23c856ce11c301$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $0d23c856ce11c301$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $0d23c856ce11c301$export$fd1bfc71f64c538c extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $0d23c856ce11c301$export$5431306cf43de24a();
        const loader = new $0d23c856ce11c301$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            // JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
            const isJPEG = url.search(/\.jpe?g($|\?)/i) > 0 || url.search(/^data\:image\/jpeg/) === 0;
            texture.format = isJPEG ? $0d23c856ce11c301$export$7c67423a5ee6f5eb : $0d23c856ce11c301$export$3f8bb04b555a363c;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $0d23c856ce11c301$export$4aaf9b66af1bbf2c extends $0d23c856ce11c301$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $0d23c856ce11c301$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve && curve.isEllipseCurve ? divisions * 2 : curve && (curve.isLineCurve || curve.isLineCurve3) ? 1 : curve && curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $0d23c856ce11c301$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $0d23c856ce11c301$export$4b2950bdac9b6ee9 extends $0d23c856ce11c301$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $0d23c856ce11c301$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $0d23c856ce11c301$export$ab2e07e76531a47e(this.currentPoint.clone(), new $0d23c856ce11c301$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $0d23c856ce11c301$export$5938c4ee491a43ad(this.currentPoint.clone(), new $0d23c856ce11c301$export$c977b3e384af9ae1(aCPx, aCPy), new $0d23c856ce11c301$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $0d23c856ce11c301$export$e36650d36468bb39(this.currentPoint.clone(), new $0d23c856ce11c301$export$c977b3e384af9ae1(aCP1x, aCP1y), new $0d23c856ce11c301$export$c977b3e384af9ae1(aCP2x, aCP2y), new $0d23c856ce11c301$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $0d23c856ce11c301$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $0d23c856ce11c301$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $0d23c856ce11c301$export$6428a7f2611ef1fa extends $0d23c856ce11c301$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $0d23c856ce11c301$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $0d23c856ce11c301$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
class $0d23c856ce11c301$export$6ecadb6ed240d696 extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.type = "Light";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
$0d23c856ce11c301$export$6ecadb6ed240d696.prototype.isLight = true;
class $0d23c856ce11c301$export$8d474f55edbb9624 extends $0d23c856ce11c301$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.type = "HemisphereLight";
        this.position.copy($0d23c856ce11c301$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.groundColor = new $0d23c856ce11c301$export$892596cec99bc70e(groundColor);
    }
    copy(source) {
        $0d23c856ce11c301$export$6ecadb6ed240d696.prototype.copy.call(this, source);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
$0d23c856ce11c301$export$8d474f55edbb9624.prototype.isHemisphereLight = true;
const $0d23c856ce11c301$var$_projScreenMatrix$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_lightPositionWorld$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_lookTarget$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.mapSize = new $0d23c856ce11c301$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $0d23c856ce11c301$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $0d23c856ce11c301$export$35efe6f4c85463d2();
        this._frameExtents = new $0d23c856ce11c301$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $0d23c856ce11c301$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $0d23c856ce11c301$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($0d23c856ce11c301$var$_lightPositionWorld$1);
        $0d23c856ce11c301$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($0d23c856ce11c301$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $0d23c856ce11c301$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($0d23c856ce11c301$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply(shadowCamera.projectionMatrix);
        shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $0d23c856ce11c301$var$SpotLightShadow extends $0d23c856ce11c301$var$LightShadow {
    constructor(){
        super(new $0d23c856ce11c301$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $0d23c856ce11c301$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
$0d23c856ce11c301$var$SpotLightShadow.prototype.isSpotLightShadow = true;
class $0d23c856ce11c301$export$81495cbb73897362 extends $0d23c856ce11c301$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 1){
        super(color, intensity);
        this.type = "SpotLight";
        this.position.copy($0d23c856ce11c301$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $0d23c856ce11c301$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $0d23c856ce11c301$var$SpotLightShadow();
    }
    get power() {
        // intensity = power per solid angle.
        // ref: equation (17) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
        return this.intensity * Math.PI;
    }
    set power(power) {
        // intensity = power per solid angle.
        // ref: equation (17) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
$0d23c856ce11c301$export$81495cbb73897362.prototype.isSpotLight = true;
const $0d23c856ce11c301$var$_projScreenMatrix = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_lightPositionWorld = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_lookTarget = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$var$PointLightShadow extends $0d23c856ce11c301$var$LightShadow {
    constructor(){
        super(new $0d23c856ce11c301$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this._frameExtents = new $0d23c856ce11c301$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $0d23c856ce11c301$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $0d23c856ce11c301$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $0d23c856ce11c301$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $0d23c856ce11c301$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $0d23c856ce11c301$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $0d23c856ce11c301$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $0d23c856ce11c301$export$64b5c384219d3699(1, 0, 0),
            new $0d23c856ce11c301$export$64b5c384219d3699(-1, 0, 0),
            new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, 1),
            new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, -1),
            new $0d23c856ce11c301$export$64b5c384219d3699(0, 1, 0),
            new $0d23c856ce11c301$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $0d23c856ce11c301$export$64b5c384219d3699(0, 1, 0),
            new $0d23c856ce11c301$export$64b5c384219d3699(0, 1, 0),
            new $0d23c856ce11c301$export$64b5c384219d3699(0, 1, 0),
            new $0d23c856ce11c301$export$64b5c384219d3699(0, 1, 0),
            new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, 1),
            new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $0d23c856ce11c301$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($0d23c856ce11c301$var$_lightPositionWorld);
        $0d23c856ce11c301$var$_lookTarget.copy(camera.position);
        $0d23c856ce11c301$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($0d23c856ce11c301$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$0d23c856ce11c301$var$_lightPositionWorld.x, -$0d23c856ce11c301$var$_lightPositionWorld.y, -$0d23c856ce11c301$var$_lightPositionWorld.z);
        $0d23c856ce11c301$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($0d23c856ce11c301$var$_projScreenMatrix);
    }
}
$0d23c856ce11c301$var$PointLightShadow.prototype.isPointLightShadow = true;
class $0d23c856ce11c301$export$4c9c1cb3f0b6f455 extends $0d23c856ce11c301$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 1){
        super(color, intensity);
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $0d23c856ce11c301$var$PointLightShadow();
    }
    get power() {
        // intensity = power per solid angle.
        // ref: equation (15) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // intensity = power per solid angle.
        // ref: equation (15) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
$0d23c856ce11c301$export$4c9c1cb3f0b6f455.prototype.isPointLight = true;
class $0d23c856ce11c301$export$9ebf355ee4ed261b extends $0d23c856ce11c301$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
$0d23c856ce11c301$export$9ebf355ee4ed261b.prototype.isOrthographicCamera = true;
class $0d23c856ce11c301$var$DirectionalLightShadow extends $0d23c856ce11c301$var$LightShadow {
    constructor(){
        super(new $0d23c856ce11c301$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
    }
}
$0d23c856ce11c301$var$DirectionalLightShadow.prototype.isDirectionalLightShadow = true;
class $0d23c856ce11c301$export$3fea33cc9972c868 extends $0d23c856ce11c301$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.type = "DirectionalLight";
        this.position.copy($0d23c856ce11c301$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $0d23c856ce11c301$export$e4dd07dff30cc924();
        this.shadow = new $0d23c856ce11c301$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
$0d23c856ce11c301$export$3fea33cc9972c868.prototype.isDirectionalLight = true;
class $0d23c856ce11c301$export$af279bfef9ec2c96 extends $0d23c856ce11c301$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.type = "AmbientLight";
    }
}
$0d23c856ce11c301$export$af279bfef9ec2c96.prototype.isAmbientLight = true;
class $0d23c856ce11c301$export$61db2d908bbd2429 extends $0d23c856ce11c301$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
$0d23c856ce11c301$export$61db2d908bbd2429.prototype.isRectAreaLight = true;
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $0d23c856ce11c301$export$ba61ce607e1f405a {
    constructor(){
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $0d23c856ce11c301$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
$0d23c856ce11c301$export$ba61ce607e1f405a.prototype.isSphericalHarmonics3 = true;
class $0d23c856ce11c301$export$e7ef036e309b38d2 extends $0d23c856ce11c301$export$6ecadb6ed240d696 {
    constructor(sh = new $0d23c856ce11c301$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
$0d23c856ce11c301$export$e7ef036e309b38d2.prototype.isLightProbe = true;
class $0d23c856ce11c301$export$3bd6d323353dcf96 extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0d23c856ce11c301$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = new $0d23c856ce11c301$var$Materials[json.type]();
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = new $0d23c856ce11c301$export$892596cec99bc70e().setHex(json.sheen);
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.morphTargets !== undefined) material.morphTargets = json.morphTargets;
        if (json.morphNormals !== undefined) material.morphNormals = json.morphNormals;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.vertexTangents !== undefined) material.vertexTangents = json.vertexTangents;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $0d23c856ce11c301$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $0d23c856ce11c301$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $0d23c856ce11c301$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $0d23c856ce11c301$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $0d23c856ce11c301$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        // Deprecated
        if (json.shading !== undefined) material.flatShading = json.shading === 1; // THREE.FlatShading
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $0d23c856ce11c301$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $0d23c856ce11c301$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
}
class $0d23c856ce11c301$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.substr(0, index + 1);
    }
}
class $0d23c856ce11c301$export$231f009cbe414146 extends $0d23c856ce11c301$export$b7be63a67df8959 {
    constructor(){
        super();
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const data = super.toJSON(this);
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
$0d23c856ce11c301$export$231f009cbe414146.prototype.isInstancedBufferGeometry = true;
class $0d23c856ce11c301$export$32ea87a8b54d744a extends $0d23c856ce11c301$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        if (typeof normalized === "number") {
            meshPerAttribute = normalized;
            normalized = false;
            console.error("THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.");
        }
        super(array, itemSize, normalized);
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
$0d23c856ce11c301$export$32ea87a8b54d744a.prototype.isInstancedBufferAttribute = true;
class $0d23c856ce11c301$export$dc275bb96327833a extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0d23c856ce11c301$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $0d23c856ce11c301$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $0d23c856ce11c301$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $0d23c856ce11c301$export$231f009cbe414146() : new $0d23c856ce11c301$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $0d23c856ce11c301$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $0d23c856ce11c301$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $0d23c856ce11c301$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $0d23c856ce11c301$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $0d23c856ce11c301$export$32ea87a8b54d744a : $0d23c856ce11c301$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $0d23c856ce11c301$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $0d23c856ce11c301$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $0d23c856ce11c301$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $0d23c856ce11c301$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $0d23c856ce11c301$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $0d23c856ce11c301$export$40110c8505c5ad19 extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $0d23c856ce11c301$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $0d23c856ce11c301$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $0d23c856ce11c301$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $0d23c856ce11c301$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid] instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $0d23c856ce11c301$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $0d23c856ce11c301$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $0d23c856ce11c301$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    case "Geometry":
                        console.error("THREE.ObjectLoader: The legacy Geometry type is no longer supported.");
                        break;
                    default:
                        if (data.type in $0d23c856ce11c301$var$Geometries) geometry = $0d23c856ce11c301$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (geometry.isBufferGeometry === true && data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $0d23c856ce11c301$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (data.type === "MultiMaterial") {
                    // Deprecated
                    const array = [];
                    for(let j = 0; j < data.materials.length; j++){
                        const material = data.materials[j];
                        if (cache[material.uuid] === undefined) cache[material.uuid] = loader.parse(material);
                        array.push(cache[material.uuid]);
                    }
                    materials[data.uuid] = array;
                } else {
                    if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                    materials[data.uuid] = cache[data.uuid];
                }
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $0d23c856ce11c301$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $0d23c856ce11c301$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $0d23c856ce11c301$export$99cc795e99919eed(onLoad);
            loader = new $0d23c856ce11c301$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    images[image.uuid] = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) images[image.uuid].push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            images[image.uuid].push(new $0d23c856ce11c301$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    if (deserializedImage !== null) images[image.uuid] = deserializedImage;
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $0d23c856ce11c301$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $0d23c856ce11c301$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    images[image.uuid] = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) images[image.uuid].push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            images[image.uuid].push(new $0d23c856ce11c301$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    if (deserializedImage !== null) images[image.uuid] = deserializedImage;
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            let texture;
            const image = images[data.image];
            if (Array.isArray(image)) {
                texture = new $0d23c856ce11c301$export$ee2e5a18258a4049(image);
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $0d23c856ce11c301$export$b691f601014eabe1(image.data, image.width, image.height);
                else texture = new $0d23c856ce11c301$export$5431306cf43de24a(image);
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $0d23c856ce11c301$var$TEXTURE_MAPPING);
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $0d23c856ce11c301$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $0d23c856ce11c301$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.type !== undefined) texture.type = data.type;
            if (data.encoding !== undefined) texture.encoding = data.encoding;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $0d23c856ce11c301$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $0d23c856ce11c301$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $0d23c856ce11c301$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $0d23c856ce11c301$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $0d23c856ce11c301$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $0d23c856ce11c301$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                break;
            case "PerspectiveCamera":
                object = new $0d23c856ce11c301$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $0d23c856ce11c301$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $0d23c856ce11c301$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $0d23c856ce11c301$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case "PointLight":
                object = new $0d23c856ce11c301$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $0d23c856ce11c301$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $0d23c856ce11c301$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case "HemisphereLight":
                object = new $0d23c856ce11c301$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $0d23c856ce11c301$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $0d23c856ce11c301$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $0d23c856ce11c301$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $0d23c856ce11c301$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $0d23c856ce11c301$export$8dea267bd6bde117(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $0d23c856ce11c301$export$8dea267bd6bde117(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "LOD":
                object = new $0d23c856ce11c301$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $0d23c856ce11c301$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $0d23c856ce11c301$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $0d23c856ce11c301$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $0d23c856ce11c301$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $0d23c856ce11c301$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $0d23c856ce11c301$export$b127726e56765aa4();
                break;
            default:
                object = new $0d23c856ce11c301$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    /* DEPRECATED */ setTexturePath(value) {
        console.warn("THREE.ObjectLoader: .setTexturePath() has been renamed to .setResourcePath().");
        return this.setResourcePath(value);
    }
}
const $0d23c856ce11c301$var$TEXTURE_MAPPING = {
    UVMapping: $0d23c856ce11c301$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $0d23c856ce11c301$export$8759762a6477f2c4,
    CubeRefractionMapping: $0d23c856ce11c301$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $0d23c856ce11c301$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $0d23c856ce11c301$export$ee99d97d46898098,
    CubeUVReflectionMapping: $0d23c856ce11c301$export$dbf3e70ff37af79,
    CubeUVRefractionMapping: $0d23c856ce11c301$export$76a9f4355364345c
};
const $0d23c856ce11c301$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $0d23c856ce11c301$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $0d23c856ce11c301$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $0d23c856ce11c301$export$c7e7c00b14f51a4f
};
const $0d23c856ce11c301$var$TEXTURE_FILTER = {
    NearestFilter: $0d23c856ce11c301$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $0d23c856ce11c301$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $0d23c856ce11c301$export$d2327c1afe5bfdf2,
    LinearFilter: $0d23c856ce11c301$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $0d23c856ce11c301$export$19a719f377145a13,
    LinearMipmapLinearFilter: $0d23c856ce11c301$export$5d8599b6a933fb1b
};
class $0d23c856ce11c301$export$52286b55c4a9b51f extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $0d23c856ce11c301$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $0d23c856ce11c301$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
$0d23c856ce11c301$export$52286b55c4a9b51f.prototype.isImageBitmapLoader = true;
class $0d23c856ce11c301$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath";
        this.color = new $0d23c856ce11c301$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $0d23c856ce11c301$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW, noHoles) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $0d23c856ce11c301$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $0d23c856ce11c301$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        if (noHoles === true) return toShapesNoHoles(subPaths);
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $0d23c856ce11c301$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $0d23c856ce11c301$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            const toChange = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange.push({
                            froms: sIdx,
                            tos: s2Idx,
                            hole: hIdx
                        });
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            // console.log("ambiguous: ", ambiguous);
            if (toChange.length > 0) // console.log("to change: ", toChange);
            {
                if (!ambiguous) newShapeHoles = betterShapeHoles;
            }
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
class $0d23c856ce11c301$export$89abf52a030e56ee {
    constructor(data){
        this.type = "Font";
        this.data = data;
    }
    generateShapes(text, size = 100) {
        const shapes = [];
        const paths = $0d23c856ce11c301$var$createPaths(text, size, this.data);
        for(let p = 0, pl = paths.length; p < pl; p++)Array.prototype.push.apply(shapes, paths[p].toShapes());
        return shapes;
    }
}
function $0d23c856ce11c301$var$createPaths(text, size, data) {
    const chars = Array.from(text);
    const scale = size / data.resolution;
    const line_height = (data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness) * scale;
    const paths = [];
    let offsetX = 0, offsetY = 0;
    for(let i = 0; i < chars.length; i++){
        const char = chars[i];
        if (char === "\n") {
            offsetX = 0;
            offsetY -= line_height;
        } else {
            const ret = $0d23c856ce11c301$var$createPath(char, scale, offsetX, offsetY, data);
            offsetX += ret.offsetX;
            paths.push(ret.path);
        }
    }
    return paths;
}
function $0d23c856ce11c301$var$createPath(char, scale, offsetX, offsetY, data) {
    const glyph = data.glyphs[char] || data.glyphs["?"];
    if (!glyph) {
        console.error('THREE.Font: character "' + char + '" does not exists in font family ' + data.familyName + ".");
        return;
    }
    const path = new $0d23c856ce11c301$export$148534a3c727230b();
    let x, y, cpx, cpy, cpx1, cpy1, cpx2, cpy2;
    if (glyph.o) {
        const outline = glyph._cachedOutline || (glyph._cachedOutline = glyph.o.split(" "));
        for(let i = 0, l = outline.length; i < l;){
            const action = outline[i++];
            switch(action){
                case "m":
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.moveTo(x, y);
                    break;
                case "l":
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.lineTo(x, y);
                    break;
                case "q":
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    path.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
                    break;
                case "b":
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    cpx2 = outline[i++] * scale + offsetX;
                    cpy2 = outline[i++] * scale + offsetY;
                    path.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
                    break;
            }
        }
    }
    return {
        offsetX: glyph.ha * scale,
        path: path
    };
}
$0d23c856ce11c301$export$89abf52a030e56ee.prototype.isFont = true;
class $0d23c856ce11c301$export$812303d6cad736b3 extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0d23c856ce11c301$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            let json;
            try {
                json = JSON.parse(text);
            } catch (e) {
                console.warn("THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.");
                json = JSON.parse(text.substring(65, text.length - 2));
            }
            const font = scope.parse(json);
            if (onLoad) onLoad(font);
        }, onProgress, onError);
    }
    parse(json) {
        return new $0d23c856ce11c301$export$89abf52a030e56ee(json);
    }
}
let $0d23c856ce11c301$var$_context;
const $0d23c856ce11c301$export$fcbc63750ec2a81f = {
    getContext: function() {
        if ($0d23c856ce11c301$var$_context === undefined) $0d23c856ce11c301$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $0d23c856ce11c301$var$_context;
    },
    setContext: function(value) {
        $0d23c856ce11c301$var$_context = value;
    }
};
class $0d23c856ce11c301$export$d8d5fccfbf47714e extends $0d23c856ce11c301$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0d23c856ce11c301$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $0d23c856ce11c301$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                });
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
}
class $0d23c856ce11c301$export$2f22dadc8bc42820 extends $0d23c856ce11c301$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        const color1 = new $0d23c856ce11c301$export$892596cec99bc70e().set(skyColor);
        const color2 = new $0d23c856ce11c301$export$892596cec99bc70e().set(groundColor);
        const sky = new $0d23c856ce11c301$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $0d23c856ce11c301$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
$0d23c856ce11c301$export$2f22dadc8bc42820.prototype.isHemisphereLightProbe = true;
class $0d23c856ce11c301$export$afe310a21c86023d extends $0d23c856ce11c301$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        const color1 = new $0d23c856ce11c301$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
$0d23c856ce11c301$export$afe310a21c86023d.prototype.isAmbientLightProbe = true;
const $0d23c856ce11c301$var$_eyeRight = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_eyeLeft = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
class $0d23c856ce11c301$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $0d23c856ce11c301$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $0d23c856ce11c301$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            const projectionMatrix = camera.projectionMatrix.clone();
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($0d23c856ce11c301$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $0d23c856ce11c301$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $0d23c856ce11c301$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy(projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy(projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($0d23c856ce11c301$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($0d23c856ce11c301$var$_eyeRight);
    }
}
class $0d23c856ce11c301$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $0d23c856ce11c301$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $0d23c856ce11c301$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $0d23c856ce11c301$var$now() {
    return (typeof performance === "undefined" ? Date : performance).now(); // see #10732
}
const $0d23c856ce11c301$var$_position$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_quaternion$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$23d6a54f0bbc85a3();
const $0d23c856ce11c301$var$_scale$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_orientation$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$8a1b810c6fde8951 extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $0d23c856ce11c301$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $0d23c856ce11c301$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($0d23c856ce11c301$var$_position$1, $0d23c856ce11c301$var$_quaternion$1, $0d23c856ce11c301$var$_scale$1);
        $0d23c856ce11c301$var$_orientation$1.set(0, 0, -1).applyQuaternion($0d23c856ce11c301$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($0d23c856ce11c301$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($0d23c856ce11c301$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($0d23c856ce11c301$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($0d23c856ce11c301$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($0d23c856ce11c301$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($0d23c856ce11c301$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($0d23c856ce11c301$var$_position$1.x, $0d23c856ce11c301$var$_position$1.y, $0d23c856ce11c301$var$_position$1.z);
            listener.setOrientation($0d23c856ce11c301$var$_orientation$1.x, $0d23c856ce11c301$var$_orientation$1.y, $0d23c856ce11c301$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $0d23c856ce11c301$export$153755f98d9861de extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        this.source.stop();
        this.source.onended = null;
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $0d23c856ce11c301$var$_position = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_quaternion = /*@__PURE__*/ new $0d23c856ce11c301$export$23d6a54f0bbc85a3();
const $0d23c856ce11c301$var$_scale = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_orientation = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$4b3e397ef1832507 extends $0d23c856ce11c301$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($0d23c856ce11c301$var$_position, $0d23c856ce11c301$var$_quaternion, $0d23c856ce11c301$var$_scale);
        $0d23c856ce11c301$var$_orientation.set(0, 0, 1).applyQuaternion($0d23c856ce11c301$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($0d23c856ce11c301$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($0d23c856ce11c301$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($0d23c856ce11c301$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($0d23c856ce11c301$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($0d23c856ce11c301$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($0d23c856ce11c301$var$_orientation.z, endTime);
        } else {
            panner.setPosition($0d23c856ce11c301$var$_position.x, $0d23c856ce11c301$var$_position.y, $0d23c856ce11c301$var$_position.z);
            panner.setOrientation($0d23c856ce11c301$var$_orientation.x, $0d23c856ce11c301$var$_orientation.y, $0d23c856ce11c301$var$_orientation.z);
        }
    }
}
class $0d23c856ce11c301$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $0d23c856ce11c301$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $0d23c856ce11c301$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $0d23c856ce11c301$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $0d23c856ce11c301$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $0d23c856ce11c301$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $0d23c856ce11c301$var$_reservedRe = new RegExp("[" + $0d23c856ce11c301$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $0d23c856ce11c301$var$_wordChar = "[^" + $0d23c856ce11c301$var$_RESERVED_CHARS_RE + "]";
const $0d23c856ce11c301$var$_wordCharOrDot = "[^" + $0d23c856ce11c301$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $0d23c856ce11c301$var$_directoryRe = /((?:WC+[\/:])*)/.source.replace("WC", $0d23c856ce11c301$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $0d23c856ce11c301$var$_nodeRe = /(WCOD+)?/.source.replace("WCOD", $0d23c856ce11c301$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $0d23c856ce11c301$var$_objectRe = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $0d23c856ce11c301$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $0d23c856ce11c301$var$_propertyRe = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $0d23c856ce11c301$var$_wordChar);
const $0d23c856ce11c301$var$_trackRe = new RegExp("^" + $0d23c856ce11c301$var$_directoryRe + $0d23c856ce11c301$var$_nodeRe + $0d23c856ce11c301$var$_objectRe + $0d23c856ce11c301$var$_propertyRe + "$");
const $0d23c856ce11c301$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones"
];
class $0d23c856ce11c301$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $0d23c856ce11c301$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $0d23c856ce11c301$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $0d23c856ce11c301$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $0d23c856ce11c301$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $0d23c856ce11c301$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $0d23c856ce11c301$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($0d23c856ce11c301$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $0d23c856ce11c301$var$_trackRe.exec(trackName);
        if (!matches) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($0d23c856ce11c301$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (!nodeName || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.node[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $0d23c856ce11c301$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (targetObject.geometry.isBufferGeometry) {
                    if (!targetObject.geometry.morphAttributes) {
                        console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                        return;
                    }
                    if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
                } else {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.", this);
                    return;
                }
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$0d23c856ce11c301$export$7bf70fcf9f891893.Composite = $0d23c856ce11c301$var$Composite;
$0d23c856ce11c301$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$0d23c856ce11c301$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$0d23c856ce11c301$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._getValue_direct,
    $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._getValue_array,
    $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$0d23c856ce11c301$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_direct,
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_array,
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $0d23c856ce11c301$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $0d23c856ce11c301$export$30619c2afd3f34db {
    constructor(){
        this.uuid = $0d23c856ce11c301$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $0d23c856ce11c301$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $0d23c856ce11c301$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $0d23c856ce11c301$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
$0d23c856ce11c301$export$30619c2afd3f34db.prototype.isAnimationObjectGroup = true;
class $0d23c856ce11c301$var$AnimationAction {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $0d23c856ce11c301$export$7f795934b84ab523,
            endingEnd: $0d23c856ce11c301$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $0d23c856ce11c301$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) return; // yet to come / don't decide when delta = 0
            // start
            this._startTime = null; // unschedule
            deltaTime = timeDirection * timeRunning;
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $0d23c856ce11c301$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $0d23c856ce11c301$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $0d23c856ce11c301$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $0d23c856ce11c301$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $0d23c856ce11c301$export$24a4ccb5099273b5;
            settings.endingEnd = $0d23c856ce11c301$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $0d23c856ce11c301$export$24a4ccb5099273b5 : $0d23c856ce11c301$export$7f795934b84ab523;
            else settings.endingStart = $0d23c856ce11c301$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $0d23c856ce11c301$export$24a4ccb5099273b5 : $0d23c856ce11c301$export$7f795934b84ab523;
            else settings.endingEnd = $0d23c856ce11c301$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
class $0d23c856ce11c301$export$fbd77e5aefaa0102 extends $0d23c856ce11c301$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) bindings[i] = binding;
            else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $0d23c856ce11c301$export$dfe0af1ca1acb78a($0d23c856ce11c301$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $0d23c856ce11c301$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $0d23c856ce11c301$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $0d23c856ce11c301$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $0d23c856ce11c301$var$AnimationAction(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $0d23c856ce11c301$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
$0d23c856ce11c301$export$fbd77e5aefaa0102.prototype._controlInterpolantsResultBuffer = new Float32Array(1);
class $0d23c856ce11c301$export$2947cebfe91c02f8 {
    constructor(value){
        if (typeof value === "string") {
            console.warn("THREE.Uniform: Type parameter is no longer needed.");
            value = arguments[1];
        }
        this.value = value;
    }
    clone() {
        return new $0d23c856ce11c301$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
class $0d23c856ce11c301$export$25ec0e1af1389358 extends $0d23c856ce11c301$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
$0d23c856ce11c301$export$25ec0e1af1389358.prototype.isInstancedInterleavedBuffer = true;
class $0d23c856ce11c301$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
$0d23c856ce11c301$export$6b7339ae8dbddf73.prototype.isGLBufferAttribute = true;
class $0d23c856ce11c301$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $0d23c856ce11c301$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $0d23c856ce11c301$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera && camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera && camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    intersectObject(object, recursive = false, intersects = []) {
        $0d23c856ce11c301$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($0d23c856ce11c301$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = false, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$0d23c856ce11c301$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($0d23c856ce11c301$var$ascSort);
        return intersects;
    }
}
function $0d23c856ce11c301$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $0d23c856ce11c301$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$0d23c856ce11c301$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $0d23c856ce11c301$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be betwee EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($0d23c856ce11c301$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $0d23c856ce11c301$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0d23c856ce11c301$var$_vector$4 = /*@__PURE__*/ new $0d23c856ce11c301$export$c977b3e384af9ae1();
class $0d23c856ce11c301$export$60f553fa130f08b0 {
    constructor(min = new $0d23c856ce11c301$export$c977b3e384af9ae1(Infinity, Infinity), max = new $0d23c856ce11c301$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $0d23c856ce11c301$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $0d23c856ce11c301$var$_vector$4.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
$0d23c856ce11c301$export$60f553fa130f08b0.prototype.isBox2 = true;
const $0d23c856ce11c301$var$_startP = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_startEnd = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$e0ba6359f1954fd3 {
    constructor(start = new $0d23c856ce11c301$export$64b5c384219d3699(), end = new $0d23c856ce11c301$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $0d23c856ce11c301$var$_startP.subVectors(point, this.start);
        $0d23c856ce11c301$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $0d23c856ce11c301$var$_startEnd.dot($0d23c856ce11c301$var$_startEnd);
        const startEnd_startP = $0d23c856ce11c301$var$_startEnd.dot($0d23c856ce11c301$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $0d23c856ce11c301$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $0d23c856ce11c301$export$960665a8431ecff6 extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.material = material;
        this.render = function() {};
        this.hasPositions = false;
        this.hasNormals = false;
        this.hasColors = false;
        this.hasUvs = false;
        this.positionArray = null;
        this.normalArray = null;
        this.colorArray = null;
        this.uvArray = null;
        this.count = 0;
    }
}
$0d23c856ce11c301$export$960665a8431ecff6.prototype.isImmediateRenderObject = true;
const $0d23c856ce11c301$var$_vector$3 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$4b14638ffdd81e68 extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(positions, 3));
        const material = new $0d23c856ce11c301$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $0d23c856ce11c301$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateMatrixWorld();
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $0d23c856ce11c301$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($0d23c856ce11c301$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $0d23c856ce11c301$var$_vector$2 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_boneMatrix = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
const $0d23c856ce11c301$var$_matrixWorldInv = /*@__PURE__*/ new $0d23c856ce11c301$export$2ae72fc923e5eb5();
class $0d23c856ce11c301$export$5277df3c9e732259 extends $0d23c856ce11c301$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $0d23c856ce11c301$var$getBoneList(object);
        const geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $0d23c856ce11c301$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $0d23c856ce11c301$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0d23c856ce11c301$export$cbe7a62641830ebd(colors, 3));
        const material = new $0d23c856ce11c301$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.type = "SkeletonHelper";
        this.isSkeletonHelper = true;
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $0d23c856ce11c301$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $0d23c856ce11c301$var$_boneMatrix.multiplyMatrices($0d23c856ce11c301$var$_matrixWorldInv, bone.matrixWorld);
                $0d23c856ce11c301$var$_vector$2.setFromMatrixPosition($0d23c856ce11c301$var$_boneMatrix);
                position.setXYZ(j, $0d23c856ce11c301$var$_vector$2.x, $0d23c856ce11c301$var$_vector$2.y, $0d23c856ce11c301$var$_vector$2.z);
                $0d23c856ce11c301$var$_boneMatrix.multiplyMatrices($0d23c856ce11c301$var$_matrixWorldInv, bone.parent.matrixWorld);
                $0d23c856ce11c301$var$_vector$2.setFromMatrixPosition($0d23c856ce11c301$var$_boneMatrix);
                position.setXYZ(j + 1, $0d23c856ce11c301$var$_vector$2.x, $0d23c856ce11c301$var$_vector$2.y, $0d23c856ce11c301$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
}
function $0d23c856ce11c301$var$getBoneList(object) {
    const boneList = [];
    if (object && object.isBone) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $0d23c856ce11c301$var$getBoneList(object.children[i]));
    return boneList;
}
class $0d23c856ce11c301$export$9a9291685b9e4023 extends $0d23c856ce11c301$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $0d23c856ce11c301$export$d5d06a966fec4192(sphereSize, 4, 2);
        const material = new $0d23c856ce11c301$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.light.updateMatrixWorld();
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronBufferGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $0d23c856ce11c301$var$_vector$1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_color1 = /*@__PURE__*/ new $0d23c856ce11c301$export$892596cec99bc70e();
const $0d23c856ce11c301$var$_color2 = /*@__PURE__*/ new $0d23c856ce11c301$export$892596cec99bc70e();
class $0d23c856ce11c301$export$8dca15f13f4f8172 extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $0d23c856ce11c301$export$8e05fc91596f4752(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $0d23c856ce11c301$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $0d23c856ce11c301$export$8dea267bd6bde117(colors, 3));
        this.add(new $0d23c856ce11c301$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $0d23c856ce11c301$var$_color1.copy(this.light.color);
            $0d23c856ce11c301$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $0d23c856ce11c301$var$_color1 : $0d23c856ce11c301$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        mesh.lookAt($0d23c856ce11c301$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $0d23c856ce11c301$export$3875d39926561055 extends $0d23c856ce11c301$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $0d23c856ce11c301$export$892596cec99bc70e(color1);
        color2 = new $0d23c856ce11c301$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0d23c856ce11c301$export$cbe7a62641830ebd(colors, 3));
        const material = new $0d23c856ce11c301$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
}
class $0d23c856ce11c301$export$361430a10f533cd3 extends $0d23c856ce11c301$export$ff1ed10fedfdd604 {
    constructor(radius = 10, radials = 16, circles = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $0d23c856ce11c301$export$892596cec99bc70e(color1);
        color2 = new $0d23c856ce11c301$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the radials
        for(let i = 0; i <= radials; i++){
            const v = i / radials * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the circles
        for(let i = 0; i <= circles; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / circles * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0d23c856ce11c301$export$cbe7a62641830ebd(colors, 3));
        const material = new $0d23c856ce11c301$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
}
const $0d23c856ce11c301$var$_v1 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_v2 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_v3 = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
class $0d23c856ce11c301$export$f8e434dc14203e7d extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        if (size === undefined) size = 1;
        let geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $0d23c856ce11c301$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $0d23c856ce11c301$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $0d23c856ce11c301$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        $0d23c856ce11c301$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $0d23c856ce11c301$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $0d23c856ce11c301$var$_v3.subVectors($0d23c856ce11c301$var$_v2, $0d23c856ce11c301$var$_v1);
        this.lightPlane.lookAt($0d23c856ce11c301$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($0d23c856ce11c301$var$_v2);
        this.targetLine.scale.z = $0d23c856ce11c301$var$_v3.length();
    }
}
const $0d23c856ce11c301$var$_vector = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
const $0d23c856ce11c301$var$_camera = /*@__PURE__*/ new $0d23c856ce11c301$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
 */ class $0d23c856ce11c301$export$ed8e93f853cd795 extends $0d23c856ce11c301$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
        const material = new $0d23c856ce11c301$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // colors
        const colorFrustum = new $0d23c856ce11c301$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $0d23c856ce11c301$export$892596cec99bc70e(0xff0000);
        const colorUp = new $0d23c856ce11c301$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $0d23c856ce11c301$export$892596cec99bc70e(0xffffff);
        const colorCross = new $0d23c856ce11c301$export$892596cec99bc70e(0x333333);
        // near
        addLine("n1", "n2", colorFrustum);
        addLine("n2", "n4", colorFrustum);
        addLine("n4", "n3", colorFrustum);
        addLine("n3", "n1", colorFrustum);
        // far
        addLine("f1", "f2", colorFrustum);
        addLine("f2", "f4", colorFrustum);
        addLine("f4", "f3", colorFrustum);
        addLine("f3", "f1", colorFrustum);
        // sides
        addLine("n1", "f1", colorFrustum);
        addLine("n2", "f2", colorFrustum);
        addLine("n3", "f3", colorFrustum);
        addLine("n4", "f4", colorFrustum);
        // cone
        addLine("p", "n1", colorCone);
        addLine("p", "n2", colorCone);
        addLine("p", "n3", colorCone);
        addLine("p", "n4", colorCone);
        // up
        addLine("u1", "u2", colorUp);
        addLine("u2", "u3", colorUp);
        addLine("u3", "u1", colorUp);
        // target
        addLine("c", "t", colorTarget);
        addLine("p", "c", colorCross);
        // cross
        addLine("cn1", "cn2", colorCross);
        addLine("cn3", "cn4", colorCross);
        addLine("cf1", "cf2", colorCross);
        addLine("cf3", "cf4", colorCross);
        function addLine(a, b, color) {
            addPoint(a, color);
            addPoint(b, color);
        }
        function addPoint(id, color) {
            vertices.push(0, 0, 0);
            colors.push(color.r, color.g, color.b);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0d23c856ce11c301$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $0d23c856ce11c301$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $0d23c856ce11c301$var$setPoint("c", pointMap, geometry, $0d23c856ce11c301$var$_camera, 0, 0, -1);
        $0d23c856ce11c301$var$setPoint("t", pointMap, geometry, $0d23c856ce11c301$var$_camera, 0, 0, 1);
        // near
        $0d23c856ce11c301$var$setPoint("n1", pointMap, geometry, $0d23c856ce11c301$var$_camera, -w, -h, -1);
        $0d23c856ce11c301$var$setPoint("n2", pointMap, geometry, $0d23c856ce11c301$var$_camera, w, -h, -1);
        $0d23c856ce11c301$var$setPoint("n3", pointMap, geometry, $0d23c856ce11c301$var$_camera, -w, h, -1);
        $0d23c856ce11c301$var$setPoint("n4", pointMap, geometry, $0d23c856ce11c301$var$_camera, w, h, -1);
        // far
        $0d23c856ce11c301$var$setPoint("f1", pointMap, geometry, $0d23c856ce11c301$var$_camera, -w, -h, 1);
        $0d23c856ce11c301$var$setPoint("f2", pointMap, geometry, $0d23c856ce11c301$var$_camera, w, -h, 1);
        $0d23c856ce11c301$var$setPoint("f3", pointMap, geometry, $0d23c856ce11c301$var$_camera, -w, h, 1);
        $0d23c856ce11c301$var$setPoint("f4", pointMap, geometry, $0d23c856ce11c301$var$_camera, w, h, 1);
        // up
        $0d23c856ce11c301$var$setPoint("u1", pointMap, geometry, $0d23c856ce11c301$var$_camera, w * 0.7, h * 1.1, -1);
        $0d23c856ce11c301$var$setPoint("u2", pointMap, geometry, $0d23c856ce11c301$var$_camera, -w * 0.7, h * 1.1, -1);
        $0d23c856ce11c301$var$setPoint("u3", pointMap, geometry, $0d23c856ce11c301$var$_camera, 0, h * 2, -1);
        // cross
        $0d23c856ce11c301$var$setPoint("cf1", pointMap, geometry, $0d23c856ce11c301$var$_camera, -w, 0, 1);
        $0d23c856ce11c301$var$setPoint("cf2", pointMap, geometry, $0d23c856ce11c301$var$_camera, w, 0, 1);
        $0d23c856ce11c301$var$setPoint("cf3", pointMap, geometry, $0d23c856ce11c301$var$_camera, 0, -h, 1);
        $0d23c856ce11c301$var$setPoint("cf4", pointMap, geometry, $0d23c856ce11c301$var$_camera, 0, h, 1);
        $0d23c856ce11c301$var$setPoint("cn1", pointMap, geometry, $0d23c856ce11c301$var$_camera, -w, 0, -1);
        $0d23c856ce11c301$var$setPoint("cn2", pointMap, geometry, $0d23c856ce11c301$var$_camera, w, 0, -1);
        $0d23c856ce11c301$var$setPoint("cn3", pointMap, geometry, $0d23c856ce11c301$var$_camera, 0, -h, -1);
        $0d23c856ce11c301$var$setPoint("cn4", pointMap, geometry, $0d23c856ce11c301$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $0d23c856ce11c301$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $0d23c856ce11c301$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $0d23c856ce11c301$var$_vector.x, $0d23c856ce11c301$var$_vector.y, $0d23c856ce11c301$var$_vector.z);
    }
}
const $0d23c856ce11c301$var$_box = /*@__PURE__*/ new $0d23c856ce11c301$export$6f7d5a9418ab2aa3();
class $0d23c856ce11c301$export$38a664cc862a6a9d extends $0d23c856ce11c301$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
        geometry.setIndex(new $0d23c856ce11c301$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $0d23c856ce11c301$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $0d23c856ce11c301$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $0d23c856ce11c301$var$_box.setFromObject(this.object);
        if ($0d23c856ce11c301$var$_box.isEmpty()) return;
        const min = $0d23c856ce11c301$var$_box.min;
        const max = $0d23c856ce11c301$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source) {
        $0d23c856ce11c301$export$ff1ed10fedfdd604.prototype.copy.call(this, source);
        this.object = source.object;
        return this;
    }
}
class $0d23c856ce11c301$export$ce39f4bb96c9a290 extends $0d23c856ce11c301$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
        geometry.setIndex(new $0d23c856ce11c301$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $0d23c856ce11c301$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
}
class $0d23c856ce11c301$export$a34fe8156c66e5d7 extends $0d23c856ce11c301$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            0,
            0,
            1,
            0,
            0,
            0
        ];
        const geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $0d23c856ce11c301$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1
        ];
        const geometry2 = new $0d23c856ce11c301$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $0d23c856ce11c301$export$e176487c05830cc5(geometry2, new $0d23c856ce11c301$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        let scale = -this.plane.constant;
        if (Math.abs(scale) < 1e-8) scale = 1e-8; // sign does not matter
        this.scale.set(0.5 * this.size, 0.5 * this.size, scale);
        this.children[0].material.side = scale < 0 ? $0d23c856ce11c301$export$d9f0486e75b5ace : $0d23c856ce11c301$export$2ede184fc2998901; // renderer flips side when determinant < 0; flipping not wanted here
        this.lookAt(this.plane.normal);
        super.updateMatrixWorld(force);
    }
}
const $0d23c856ce11c301$var$_axis = /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699();
let $0d23c856ce11c301$var$_lineGeometry, $0d23c856ce11c301$var$_coneGeometry;
class $0d23c856ce11c301$export$a3008e7bd8d2cbe7 extends $0d23c856ce11c301$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, 1), origin = new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($0d23c856ce11c301$var$_lineGeometry === undefined) {
            $0d23c856ce11c301$var$_lineGeometry = new $0d23c856ce11c301$export$b7be63a67df8959();
            $0d23c856ce11c301$var$_lineGeometry.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $0d23c856ce11c301$var$_coneGeometry = new $0d23c856ce11c301$export$d4345c83207d7c68(0, 0.5, 1, 5, 1);
            $0d23c856ce11c301$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $0d23c856ce11c301$export$17d680238e50603e($0d23c856ce11c301$var$_lineGeometry, new $0d23c856ce11c301$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $0d23c856ce11c301$export$e176487c05830cc5($0d23c856ce11c301$var$_coneGeometry, new $0d23c856ce11c301$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $0d23c856ce11c301$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($0d23c856ce11c301$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
}
class $0d23c856ce11c301$export$6c8303f35b8578fd extends $0d23c856ce11c301$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $0d23c856ce11c301$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d23c856ce11c301$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0d23c856ce11c301$export$cbe7a62641830ebd(colors, 3));
        const material = new $0d23c856ce11c301$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $0d23c856ce11c301$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $0d23c856ce11c301$var$_floatView = new Float32Array(1);
const $0d23c856ce11c301$var$_int32View = new Int32Array($0d23c856ce11c301$var$_floatView.buffer);
class $0d23c856ce11c301$export$11ce8b759162cc80 {
    // Converts float32 to float16 (stored as uint16 value).
    static toHalfFloat(val) {
        // Source: http://gamedev.stackexchange.com/questions/17326/conversion-of-a-number-from-single-precision-floating-point-representation-to-a/17410#17410
        /* This method is faster than the OpenEXR implementation (very often
		* used, eg. in Ogre), with the additional benefit of rounding, inspired
		* by James Tursa?s half-precision code. */ $0d23c856ce11c301$var$_floatView[0] = val;
        const x = $0d23c856ce11c301$var$_int32View[0];
        let bits = x >> 16 & 0x8000; /* Get the sign */ 
        let m = x >> 12 & 0x07ff; /* Keep one extra bit for rounding */ 
        const e = x >> 23 & 0xff; /* Using int is faster here */ 
        /* If zero, or denormal, or exponent underflows too much for a denormal
			* half, return signed zero. */ if (e < 103) return bits;
        /* If NaN, return NaN. If Inf or exponent overflow, return Inf. */ if (e > 142) {
            bits |= 0x7c00;
            /* If exponent was 0xff and one mantissa bit was set, it means NaN,
						* not Inf, so make sure we set one mantissa bit too. */ bits |= (e == 255 ? 0 : 1) && x & 0x007fffff;
            return bits;
        }
        /* If exponent underflows but not too much, return a denormal */ if (e < 113) {
            m |= 0x0800;
            /* Extra rounding may overflow and set mantissa to 0 and exponent
				* to 1, which is OK. */ bits |= (m >> 114 - e) + (m >> 113 - e & 1);
            return bits;
        }
        bits |= e - 112 << 10 | m >> 1;
        /* Extra rounding. An overflow will set mantissa to 0 and increment
			* the exponent, which is OK. */ bits += m & 1;
        return bits;
    }
}
const $0d23c856ce11c301$var$LOD_MIN = 4;
const $0d23c856ce11c301$var$LOD_MAX = 8;
const $0d23c856ce11c301$var$SIZE_MAX = Math.pow(2, $0d23c856ce11c301$var$LOD_MAX);
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $0d23c856ce11c301$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
const $0d23c856ce11c301$var$TOTAL_LODS = $0d23c856ce11c301$var$LOD_MAX - $0d23c856ce11c301$var$LOD_MIN + 1 + $0d23c856ce11c301$var$EXTRA_LOD_SIGMA.length;
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $0d23c856ce11c301$var$MAX_SAMPLES = 20;
const $0d23c856ce11c301$var$ENCODINGS = {
    [$0d23c856ce11c301$export$7207336e4151a112]: 0,
    [$0d23c856ce11c301$export$f32388edbb32674]: 1,
    [$0d23c856ce11c301$export$3be4c466a12b5dcf]: 2,
    [$0d23c856ce11c301$export$2c4bdfd76b188654]: 3,
    [$0d23c856ce11c301$export$48a0051d6a5a9b9]: 4,
    [$0d23c856ce11c301$export$ca2f89b13b49d951]: 5,
    [$0d23c856ce11c301$export$eaab32c1bcea1817]: 6
};
const $0d23c856ce11c301$var$backgroundMaterial = new $0d23c856ce11c301$export$55cbcc9b622fe1f5({
    side: $0d23c856ce11c301$export$d9f0486e75b5ace,
    depthWrite: false,
    depthTest: false
});
const $0d23c856ce11c301$var$backgroundBox = new $0d23c856ce11c301$export$e176487c05830cc5(new $0d23c856ce11c301$export$ab3456a079aa7d80(), $0d23c856ce11c301$var$backgroundMaterial);
const $0d23c856ce11c301$var$_flatCamera = /*@__PURE__*/ new $0d23c856ce11c301$export$9ebf355ee4ed261b();
const { _lodPlanes: $0d23c856ce11c301$var$_lodPlanes, _sizeLods: $0d23c856ce11c301$var$_sizeLods, _sigmas: $0d23c856ce11c301$var$_sigmas } = /*@__PURE__*/ $0d23c856ce11c301$var$_createPlanes();
const $0d23c856ce11c301$var$_clearColor = /*@__PURE__*/ new $0d23c856ce11c301$export$892596cec99bc70e();
let $0d23c856ce11c301$var$_oldTarget = null;
// Golden Ratio
const $0d23c856ce11c301$var$PHI = (1 + Math.sqrt(5)) / 2;
const $0d23c856ce11c301$var$INV_PHI = 1 / $0d23c856ce11c301$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $0d23c856ce11c301$var$_axisDirections = [
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(0, $0d23c856ce11c301$var$PHI, $0d23c856ce11c301$var$INV_PHI),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(0, $0d23c856ce11c301$var$PHI, -$0d23c856ce11c301$var$INV_PHI),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699($0d23c856ce11c301$var$INV_PHI, 0, $0d23c856ce11c301$var$PHI),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(-$0d23c856ce11c301$var$INV_PHI, 0, $0d23c856ce11c301$var$PHI),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699($0d23c856ce11c301$var$PHI, $0d23c856ce11c301$var$INV_PHI, 0),
    /*@__PURE__*/ new $0d23c856ce11c301$export$64b5c384219d3699(-$0d23c856ce11c301$var$PHI, $0d23c856ce11c301$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ function $0d23c856ce11c301$var$convertLinearToRGBE(color) {
    const maxComponent = Math.max(color.r, color.g, color.b);
    const fExp = Math.min(Math.max(Math.ceil(Math.log2(maxComponent)), -128), 127.0);
    color.multiplyScalar(Math.pow(2.0, -fExp));
    const alpha = (fExp + 128.0) / 255.0;
    return alpha;
}
class $0d23c856ce11c301$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._blurMaterial = $0d23c856ce11c301$var$_getBlurShader($0d23c856ce11c301$var$MAX_SAMPLES);
        this._equirectShader = null;
        this._cubemapShader = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $0d23c856ce11c301$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = this._allocateTargets();
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * (RGBFormat) or HDR (RGBEFormat). The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular) {
        return this._fromTexture(equirectangular);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * (RGBFormat) or HDR (RGBEFormat). The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap) {
        return this._fromTexture(cubemap);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapShader === null) {
            this._cubemapShader = $0d23c856ce11c301$var$_getCubemapShader();
            this._compileMaterial(this._cubemapShader);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectShader === null) {
            this._equirectShader = $0d23c856ce11c301$var$_getEquirectShader();
            this._compileMaterial(this._equirectShader);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._blurMaterial.dispose();
        if (this._cubemapShader !== null) this._cubemapShader.dispose();
        if (this._equirectShader !== null) this._equirectShader.dispose();
        for(let i = 0; i < $0d23c856ce11c301$var$_lodPlanes.length; i++)$0d23c856ce11c301$var$_lodPlanes[i].dispose();
    }
    // private interface
    _cleanup(outputTarget) {
        this._pingPongRenderTarget.dispose();
        this._renderer.setRenderTarget($0d23c856ce11c301$var$_oldTarget);
        outputTarget.scissorTest = false;
        $0d23c856ce11c301$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture) {
        $0d23c856ce11c301$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = this._allocateTargets(texture);
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets(texture) {
        const params = {
            magFilter: $0d23c856ce11c301$export$727aa5ec3fe39bf0,
            minFilter: $0d23c856ce11c301$export$727aa5ec3fe39bf0,
            generateMipmaps: false,
            type: $0d23c856ce11c301$export$2e8ce08d3f6f5e10,
            format: $0d23c856ce11c301$export$7f419e36e2229a1d,
            encoding: $0d23c856ce11c301$var$_isLDR(texture) ? texture.encoding : $0d23c856ce11c301$export$3be4c466a12b5dcf,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $0d23c856ce11c301$var$_createRenderTarget(params);
        cubeUVRenderTarget.depthBuffer = texture ? false : true;
        this._pingPongRenderTarget = $0d23c856ce11c301$var$_createRenderTarget(params);
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $0d23c856ce11c301$export$e176487c05830cc5($0d23c856ce11c301$var$_lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $0d23c856ce11c301$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $0d23c856ce11c301$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const outputEncoding = renderer.outputEncoding;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($0d23c856ce11c301$var$_clearColor);
        renderer.toneMapping = $0d23c856ce11c301$export$9fcb6b4294603b2;
        renderer.outputEncoding = $0d23c856ce11c301$export$7207336e4151a112;
        renderer.autoClear = false;
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                $0d23c856ce11c301$var$backgroundMaterial.color.copy(background).convertSRGBToLinear();
                scene.background = null;
                const alpha = $0d23c856ce11c301$var$convertLinearToRGBE($0d23c856ce11c301$var$backgroundMaterial.color);
                $0d23c856ce11c301$var$backgroundMaterial.opacity = alpha;
                useSolidColor = true;
            }
        } else {
            $0d23c856ce11c301$var$backgroundMaterial.color.copy($0d23c856ce11c301$var$_clearColor).convertSRGBToLinear();
            const alpha = $0d23c856ce11c301$var$convertLinearToRGBE($0d23c856ce11c301$var$backgroundMaterial.color);
            $0d23c856ce11c301$var$backgroundMaterial.opacity = alpha;
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col == 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col == 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            $0d23c856ce11c301$var$_setViewport(cubeUVRenderTarget, col * $0d23c856ce11c301$var$SIZE_MAX, i > 2 ? $0d23c856ce11c301$var$SIZE_MAX : 0, $0d23c856ce11c301$var$SIZE_MAX, $0d23c856ce11c301$var$SIZE_MAX);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render($0d23c856ce11c301$var$backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        renderer.toneMapping = toneMapping;
        renderer.outputEncoding = outputEncoding;
        renderer.autoClear = originalAutoClear;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        if (texture.isCubeTexture) {
            if (this._cubemapShader == null) this._cubemapShader = $0d23c856ce11c301$var$_getCubemapShader();
        } else if (this._equirectShader == null) this._equirectShader = $0d23c856ce11c301$var$_getEquirectShader();
        const material = texture.isCubeTexture ? this._cubemapShader : this._equirectShader;
        const mesh = new $0d23c856ce11c301$export$e176487c05830cc5($0d23c856ce11c301$var$_lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        if (!texture.isCubeTexture) uniforms["texelSize"].value.set(1.0 / texture.image.width, 1.0 / texture.image.height);
        uniforms["inputEncoding"].value = $0d23c856ce11c301$var$ENCODINGS[texture.encoding];
        uniforms["outputEncoding"].value = $0d23c856ce11c301$var$ENCODINGS[cubeUVRenderTarget.texture.encoding];
        $0d23c856ce11c301$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * $0d23c856ce11c301$var$SIZE_MAX, 2 * $0d23c856ce11c301$var$SIZE_MAX);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $0d23c856ce11c301$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < $0d23c856ce11c301$var$TOTAL_LODS; i++){
            const sigma = Math.sqrt($0d23c856ce11c301$var$_sigmas[i] * $0d23c856ce11c301$var$_sigmas[i] - $0d23c856ce11c301$var$_sigmas[i - 1] * $0d23c856ce11c301$var$_sigmas[i - 1]);
            const poleAxis = $0d23c856ce11c301$var$_axisDirections[(i - 1) % $0d23c856ce11c301$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $0d23c856ce11c301$export$e176487c05830cc5($0d23c856ce11c301$var$_lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = $0d23c856ce11c301$var$_sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $0d23c856ce11c301$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $0d23c856ce11c301$var$MAX_SAMPLES;
        if (samples > $0d23c856ce11c301$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$0d23c856ce11c301$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $0d23c856ce11c301$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i == 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = $0d23c856ce11c301$var$LOD_MAX - lodIn;
        blurUniforms["inputEncoding"].value = $0d23c856ce11c301$var$ENCODINGS[targetIn.texture.encoding];
        blurUniforms["outputEncoding"].value = $0d23c856ce11c301$var$ENCODINGS[targetIn.texture.encoding];
        const outputSize = $0d23c856ce11c301$var$_sizeLods[lodOut];
        const x = 3 * Math.max(0, $0d23c856ce11c301$var$SIZE_MAX - 2 * outputSize);
        const y = (lodOut === 0 ? 0 : 2 * $0d23c856ce11c301$var$SIZE_MAX) + 2 * outputSize * (lodOut > $0d23c856ce11c301$var$LOD_MAX - $0d23c856ce11c301$var$LOD_MIN ? lodOut - $0d23c856ce11c301$var$LOD_MAX + $0d23c856ce11c301$var$LOD_MIN : 0);
        $0d23c856ce11c301$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $0d23c856ce11c301$var$_flatCamera);
    }
}
function $0d23c856ce11c301$var$_isLDR(texture) {
    if (texture === undefined || texture.type !== $0d23c856ce11c301$export$2e8ce08d3f6f5e10) return false;
    return texture.encoding === $0d23c856ce11c301$export$7207336e4151a112 || texture.encoding === $0d23c856ce11c301$export$f32388edbb32674 || texture.encoding === $0d23c856ce11c301$export$eaab32c1bcea1817;
}
function $0d23c856ce11c301$var$_createPlanes() {
    const _lodPlanes = [];
    const _sizeLods = [];
    const _sigmas = [];
    let lod = $0d23c856ce11c301$var$LOD_MAX;
    for(let i = 0; i < $0d23c856ce11c301$var$TOTAL_LODS; i++){
        const sizeLod = Math.pow(2, lod);
        _sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > $0d23c856ce11c301$var$LOD_MAX - $0d23c856ce11c301$var$LOD_MIN) sigma = $0d23c856ce11c301$var$EXTRA_LOD_SIGMA[i - $0d23c856ce11c301$var$LOD_MAX + $0d23c856ce11c301$var$LOD_MIN - 1];
        else if (i == 0) sigma = 0;
        _sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 1);
        const min = -texelSize / 2;
        const max = 1 + texelSize / 2;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $0d23c856ce11c301$export$b7be63a67df8959();
        planes.setAttribute("position", new $0d23c856ce11c301$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $0d23c856ce11c301$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $0d23c856ce11c301$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        _lodPlanes.push(planes);
        if (lod > $0d23c856ce11c301$var$LOD_MIN) lod--;
    }
    return {
        _lodPlanes: _lodPlanes,
        _sizeLods: _sizeLods,
        _sigmas: _sigmas
    };
}
function $0d23c856ce11c301$var$_createRenderTarget(params) {
    const cubeUVRenderTarget = new $0d23c856ce11c301$export$3c052beb2e51e23f(3 * $0d23c856ce11c301$var$SIZE_MAX, 3 * $0d23c856ce11c301$var$SIZE_MAX, params);
    cubeUVRenderTarget.texture.mapping = $0d23c856ce11c301$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $0d23c856ce11c301$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $0d23c856ce11c301$var$_getBlurShader(maxSamples) {
    const weights = new Float32Array(maxSamples);
    const poleAxis = new $0d23c856ce11c301$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $0d23c856ce11c301$export$21c421a2e1df9d22({
        name: "SphericalGaussianBlur",
        defines: {
            "n": maxSamples
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            },
            "inputEncoding": {
                value: $0d23c856ce11c301$var$ENCODINGS[$0d23c856ce11c301$export$7207336e4151a112]
            },
            "outputEncoding": {
                value: $0d23c856ce11c301$var$ENCODINGS[$0d23c856ce11c301$export$7207336e4151a112]
            }
        },
        vertexShader: $0d23c856ce11c301$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			${$0d23c856ce11c301$var$_getEncodings()}

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: $0d23c856ce11c301$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $0d23c856ce11c301$var$_getEquirectShader() {
    const texelSize = new $0d23c856ce11c301$export$c977b3e384af9ae1(1, 1);
    const shaderMaterial = new $0d23c856ce11c301$export$21c421a2e1df9d22({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "texelSize": {
                value: texelSize
            },
            "inputEncoding": {
                value: $0d23c856ce11c301$var$ENCODINGS[$0d23c856ce11c301$export$7207336e4151a112]
            },
            "outputEncoding": {
                value: $0d23c856ce11c301$var$ENCODINGS[$0d23c856ce11c301$export$7207336e4151a112]
            }
        },
        vertexShader: $0d23c856ce11c301$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform vec2 texelSize;

			${$0d23c856ce11c301$var$_getEncodings()}

			#include <common>

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				vec2 f = fract( uv / texelSize - 0.5 );
				uv -= f * texelSize;
				vec3 tl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.x += texelSize.x;
				vec3 tr = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.y += texelSize.y;
				vec3 br = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.x -= texelSize.x;
				vec3 bl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;

				vec3 tm = mix( tl, tr, f.x );
				vec3 bm = mix( bl, br, f.x );
				gl_FragColor.rgb = mix( tm, bm, f.y );

				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: $0d23c856ce11c301$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $0d23c856ce11c301$var$_getCubemapShader() {
    const shaderMaterial = new $0d23c856ce11c301$export$21c421a2e1df9d22({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "inputEncoding": {
                value: $0d23c856ce11c301$var$ENCODINGS[$0d23c856ce11c301$export$7207336e4151a112]
            },
            "outputEncoding": {
                value: $0d23c856ce11c301$var$ENCODINGS[$0d23c856ce11c301$export$7207336e4151a112]
            }
        },
        vertexShader: $0d23c856ce11c301$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			${$0d23c856ce11c301$var$_getEncodings()}

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb = envMapTexelToLinear( textureCube( envMap, vec3( - vOutputDirection.x, vOutputDirection.yz ) ) ).rgb;
				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: $0d23c856ce11c301$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $0d23c856ce11c301$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute vec3 position;
		attribute vec2 uv;
		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $0d23c856ce11c301$var$_getEncodings() {
    return /* glsl */ `

		uniform int inputEncoding;
		uniform int outputEncoding;

		#include <encodings_pars_fragment>

		vec4 inputTexelToLinear( vec4 value ) {

			if ( inputEncoding == 0 ) {

				return value;

			} else if ( inputEncoding == 1 ) {

				return sRGBToLinear( value );

			} else if ( inputEncoding == 2 ) {

				return RGBEToLinear( value );

			} else if ( inputEncoding == 3 ) {

				return RGBMToLinear( value, 7.0 );

			} else if ( inputEncoding == 4 ) {

				return RGBMToLinear( value, 16.0 );

			} else if ( inputEncoding == 5 ) {

				return RGBDToLinear( value, 256.0 );

			} else {

				return GammaToLinear( value, 2.2 );

			}

		}

		vec4 linearToOutputTexel( vec4 value ) {

			if ( outputEncoding == 0 ) {

				return value;

			} else if ( outputEncoding == 1 ) {

				return LinearTosRGB( value );

			} else if ( outputEncoding == 2 ) {

				return LinearToRGBE( value );

			} else if ( outputEncoding == 3 ) {

				return LinearToRGBM( value, 7.0 );

			} else if ( outputEncoding == 4 ) {

				return LinearToRGBM( value, 16.0 );

			} else if ( outputEncoding == 5 ) {

				return LinearToRGBD( value, 256.0 );

			} else {

				return LinearToGamma( value, 2.2 );

			}

		}

		vec4 envMapTexelToLinear( vec4 color ) {

			return inputTexelToLinear( color );

		}
	`;
}
const $0d23c856ce11c301$export$195910b613d3dbcb = 0;
const $0d23c856ce11c301$export$c8a71586e494fb81 = 1;
const $0d23c856ce11c301$export$1a5c46edbdc9a5b7 = 0;
const $0d23c856ce11c301$export$617e978cc3201d85 = 1;
const $0d23c856ce11c301$export$969ede3d37172881 = 2;
function $0d23c856ce11c301$export$8f0d8c869214e38a(materials) {
    console.warn("THREE.MeshFaceMaterial has been removed. Use an Array instead.");
    return materials;
}
function $0d23c856ce11c301$export$4f1842f7cdf61f78(materials = []) {
    console.warn("THREE.MultiMaterial has been removed. Use an Array instead.");
    materials.isMultiMaterial = true;
    materials.materials = materials;
    materials.clone = function() {
        return materials.slice();
    };
    return materials;
}
function $0d23c856ce11c301$export$5c812f854e08d33d(geometry, material) {
    console.warn("THREE.PointCloud has been renamed to THREE.Points.");
    return new $0d23c856ce11c301$export$1c787534cb11aa3e(geometry, material);
}
function $0d23c856ce11c301$export$c36c68baa13912a5(material) {
    console.warn("THREE.Particle has been renamed to THREE.Sprite.");
    return new $0d23c856ce11c301$export$3075603db8e6204c(material);
}
function $0d23c856ce11c301$export$f219b6a0e4bb0b6d(geometry, material) {
    console.warn("THREE.ParticleSystem has been renamed to THREE.Points.");
    return new $0d23c856ce11c301$export$1c787534cb11aa3e(geometry, material);
}
function $0d23c856ce11c301$export$29121d9ccd2f757a(parameters) {
    console.warn("THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.");
    return new $0d23c856ce11c301$export$a178c45366ce5d6b(parameters);
}
function $0d23c856ce11c301$export$ffa02580217a1c8(parameters) {
    console.warn("THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.");
    return new $0d23c856ce11c301$export$a178c45366ce5d6b(parameters);
}
function $0d23c856ce11c301$export$cb1306c614c86e6b(parameters) {
    console.warn("THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.");
    return new $0d23c856ce11c301$export$a178c45366ce5d6b(parameters);
}
function $0d23c856ce11c301$export$3e8a3cc8713efbec(x, y, z) {
    console.warn("THREE.Vertex has been removed. Use THREE.Vector3 instead.");
    return new $0d23c856ce11c301$export$64b5c384219d3699(x, y, z);
}
//
function $0d23c856ce11c301$export$189ab5ea9d161e81(array, itemSize) {
    console.warn("THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setUsage( THREE.DynamicDrawUsage ) instead.");
    return new $0d23c856ce11c301$export$8dea267bd6bde117(array, itemSize).setUsage($0d23c856ce11c301$export$8505d14ac8546ca);
}
function $0d23c856ce11c301$export$e0ae4f0a1804ea11(array, itemSize) {
    console.warn("THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.");
    return new $0d23c856ce11c301$export$f9ff2d6a20248cbf(array, itemSize);
}
function $0d23c856ce11c301$export$a0d192e03a5b32f5(array, itemSize) {
    console.warn("THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.");
    return new $0d23c856ce11c301$export$cacc90cf35d11cdd(array, itemSize);
}
function $0d23c856ce11c301$export$8ca743ab36552bfa(array, itemSize) {
    console.warn("THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.");
    return new $0d23c856ce11c301$export$baaa85a1a812c157(array, itemSize);
}
function $0d23c856ce11c301$export$5d9757676aad9dab(array, itemSize) {
    console.warn("THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.");
    return new $0d23c856ce11c301$export$2b755a102ccdcefe(array, itemSize);
}
function $0d23c856ce11c301$export$ed102ffd14092320(array, itemSize) {
    console.warn("THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.");
    return new $0d23c856ce11c301$export$640a853f68025f2e(array, itemSize);
}
function $0d23c856ce11c301$export$6acc479034658f15(array, itemSize) {
    console.warn("THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.");
    return new $0d23c856ce11c301$export$46b369aed2968a0a(array, itemSize);
}
function $0d23c856ce11c301$export$53474877d6e539b9(array, itemSize) {
    console.warn("THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.");
    return new $0d23c856ce11c301$export$7eb8c9fa25cd5bd6(array, itemSize);
}
function $0d23c856ce11c301$export$377af6eadc8006c3(array, itemSize) {
    console.warn("THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.");
    return new $0d23c856ce11c301$export$cbe7a62641830ebd(array, itemSize);
}
function $0d23c856ce11c301$export$b9212d1a67b6f081(array, itemSize) {
    console.warn("THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.");
    return new $0d23c856ce11c301$export$9e0ade74842adbb8(array, itemSize);
}
//
$0d23c856ce11c301$export$b0e83c3ef8d2db1.create = function(construct, getPoint) {
    console.log("THREE.Curve.create() has been deprecated");
    construct.prototype = Object.create($0d23c856ce11c301$export$b0e83c3ef8d2db1.prototype);
    construct.prototype.constructor = construct;
    construct.prototype.getPoint = getPoint;
    return construct;
};
//
$0d23c856ce11c301$export$4b2950bdac9b6ee9.prototype.fromPoints = function(points) {
    console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints().");
    return this.setFromPoints(points);
};
//
function $0d23c856ce11c301$export$46c1eaab6b8d1e23(size) {
    console.warn("THREE.AxisHelper has been renamed to THREE.AxesHelper.");
    return new $0d23c856ce11c301$export$6c8303f35b8578fd(size);
}
function $0d23c856ce11c301$export$3c24c67720a2146c(object, color) {
    console.warn("THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.");
    return new $0d23c856ce11c301$export$38a664cc862a6a9d(object, color);
}
function $0d23c856ce11c301$export$e341a90264c62d4c(object, hex) {
    console.warn("THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.");
    return new $0d23c856ce11c301$export$ff1ed10fedfdd604(new $0d23c856ce11c301$export$4730b1542707547f(object.geometry), new $0d23c856ce11c301$export$fbaaa33907730a0c({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
$0d23c856ce11c301$export$3875d39926561055.prototype.setColors = function() {
    console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
};
$0d23c856ce11c301$export$5277df3c9e732259.prototype.update = function() {
    console.error("THREE.SkeletonHelper: update() no longer needs to be called.");
};
function $0d23c856ce11c301$export$72d033539c529f13(object, hex) {
    console.warn("THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.");
    return new $0d23c856ce11c301$export$ff1ed10fedfdd604(new $0d23c856ce11c301$export$4b739da06d24892b(object.geometry), new $0d23c856ce11c301$export$fbaaa33907730a0c({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
//
$0d23c856ce11c301$export$3b0d6d7590275603.prototype.extractUrlBase = function(url) {
    console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.");
    return $0d23c856ce11c301$export$b5d2dc08d867e41a.extractUrlBase(url);
};
$0d23c856ce11c301$export$3b0d6d7590275603.Handlers = {
    add: function() {
        console.error("THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.");
    },
    get: function() {
        console.error("THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.");
    }
};
function $0d23c856ce11c301$export$c8b77178c5db4e0d(manager) {
    console.warn("THREE.XHRLoader has been renamed to THREE.FileLoader.");
    return new $0d23c856ce11c301$export$98435a25b5cf7b2b(manager);
}
function $0d23c856ce11c301$export$58c7c1107fc658f9(manager) {
    console.warn("THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.");
    return new $0d23c856ce11c301$export$792d8a18f2c55855(manager);
}
//
$0d23c856ce11c301$export$60f553fa130f08b0.prototype.center = function(optionalTarget) {
    console.warn("THREE.Box2: .center() has been renamed to .getCenter().");
    return this.getCenter(optionalTarget);
};
$0d23c856ce11c301$export$60f553fa130f08b0.prototype.empty = function() {
    console.warn("THREE.Box2: .empty() has been renamed to .isEmpty().");
    return this.isEmpty();
};
$0d23c856ce11c301$export$60f553fa130f08b0.prototype.isIntersectionBox = function(box) {
    console.warn("THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().");
    return this.intersectsBox(box);
};
$0d23c856ce11c301$export$60f553fa130f08b0.prototype.size = function(optionalTarget) {
    console.warn("THREE.Box2: .size() has been renamed to .getSize().");
    return this.getSize(optionalTarget);
};
//
$0d23c856ce11c301$export$6f7d5a9418ab2aa3.prototype.center = function(optionalTarget) {
    console.warn("THREE.Box3: .center() has been renamed to .getCenter().");
    return this.getCenter(optionalTarget);
};
$0d23c856ce11c301$export$6f7d5a9418ab2aa3.prototype.empty = function() {
    console.warn("THREE.Box3: .empty() has been renamed to .isEmpty().");
    return this.isEmpty();
};
$0d23c856ce11c301$export$6f7d5a9418ab2aa3.prototype.isIntersectionBox = function(box) {
    console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().");
    return this.intersectsBox(box);
};
$0d23c856ce11c301$export$6f7d5a9418ab2aa3.prototype.isIntersectionSphere = function(sphere) {
    console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().");
    return this.intersectsSphere(sphere);
};
$0d23c856ce11c301$export$6f7d5a9418ab2aa3.prototype.size = function(optionalTarget) {
    console.warn("THREE.Box3: .size() has been renamed to .getSize().");
    return this.getSize(optionalTarget);
};
//
$0d23c856ce11c301$export$805e8b72413ccaba.prototype.empty = function() {
    console.warn("THREE.Sphere: .empty() has been renamed to .isEmpty().");
    return this.isEmpty();
};
//
$0d23c856ce11c301$export$35efe6f4c85463d2.prototype.setFromMatrix = function(m) {
    console.warn("THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().");
    return this.setFromProjectionMatrix(m);
};
//
$0d23c856ce11c301$export$e0ba6359f1954fd3.prototype.center = function(optionalTarget) {
    console.warn("THREE.Line3: .center() has been renamed to .getCenter().");
    return this.getCenter(optionalTarget);
};
//
$0d23c856ce11c301$export$8ff26dafa08918.prototype.flattenToArrayOffset = function(array, offset) {
    console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
    return this.toArray(array, offset);
};
$0d23c856ce11c301$export$8ff26dafa08918.prototype.multiplyVector3 = function(vector) {
    console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.");
    return vector.applyMatrix3(this);
};
$0d23c856ce11c301$export$8ff26dafa08918.prototype.multiplyVector3Array = function() {
    console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.");
};
$0d23c856ce11c301$export$8ff26dafa08918.prototype.applyToBufferAttribute = function(attribute) {
    console.warn("THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.");
    return attribute.applyMatrix3(this);
};
$0d23c856ce11c301$export$8ff26dafa08918.prototype.applyToVector3Array = function() {
    console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
};
$0d23c856ce11c301$export$8ff26dafa08918.prototype.getInverse = function(matrix) {
    console.warn("THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
    return this.copy(matrix).invert();
};
//
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.extractPosition = function(m) {
    console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().");
    return this.copyPosition(m);
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.flattenToArrayOffset = function(array, offset) {
    console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
    return this.toArray(array, offset);
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.getPosition = function() {
    console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.");
    return new $0d23c856ce11c301$export$64b5c384219d3699().setFromMatrixColumn(this, 3);
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.setRotationFromQuaternion = function(q) {
    console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().");
    return this.makeRotationFromQuaternion(q);
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.multiplyToArray = function() {
    console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.multiplyVector3 = function(vector) {
    console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.");
    return vector.applyMatrix4(this);
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.multiplyVector4 = function(vector) {
    console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.");
    return vector.applyMatrix4(this);
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.multiplyVector3Array = function() {
    console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.");
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.rotateAxis = function(v) {
    console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.");
    v.transformDirection(this);
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.crossVector = function(vector) {
    console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.");
    return vector.applyMatrix4(this);
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.translate = function() {
    console.error("THREE.Matrix4: .translate() has been removed.");
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.rotateX = function() {
    console.error("THREE.Matrix4: .rotateX() has been removed.");
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.rotateY = function() {
    console.error("THREE.Matrix4: .rotateY() has been removed.");
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.rotateZ = function() {
    console.error("THREE.Matrix4: .rotateZ() has been removed.");
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.rotateByAxis = function() {
    console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.applyToBufferAttribute = function(attribute) {
    console.warn("THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.");
    return attribute.applyMatrix4(this);
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.applyToVector3Array = function() {
    console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.makeFrustum = function(left, right, bottom, top, near, far) {
    console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.");
    return this.makePerspective(left, right, top, bottom, near, far);
};
$0d23c856ce11c301$export$2ae72fc923e5eb5.prototype.getInverse = function(matrix) {
    console.warn("THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
    return this.copy(matrix).invert();
};
//
$0d23c856ce11c301$export$7ff5ac152ef991b0.prototype.isIntersectionLine = function(line) {
    console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().");
    return this.intersectsLine(line);
};
//
$0d23c856ce11c301$export$23d6a54f0bbc85a3.prototype.multiplyVector3 = function(vector) {
    console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.");
    return vector.applyQuaternion(this);
};
$0d23c856ce11c301$export$23d6a54f0bbc85a3.prototype.inverse = function() {
    console.warn("THREE.Quaternion: .inverse() has been renamed to invert().");
    return this.invert();
};
//
$0d23c856ce11c301$export$a186db52eed6d40e.prototype.isIntersectionBox = function(box) {
    console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().");
    return this.intersectsBox(box);
};
$0d23c856ce11c301$export$a186db52eed6d40e.prototype.isIntersectionPlane = function(plane) {
    console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().");
    return this.intersectsPlane(plane);
};
$0d23c856ce11c301$export$a186db52eed6d40e.prototype.isIntersectionSphere = function(sphere) {
    console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().");
    return this.intersectsSphere(sphere);
};
//
$0d23c856ce11c301$export$5a465592bfe74b48.prototype.area = function() {
    console.warn("THREE.Triangle: .area() has been renamed to .getArea().");
    return this.getArea();
};
$0d23c856ce11c301$export$5a465592bfe74b48.prototype.barycoordFromPoint = function(point, target) {
    console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
    return this.getBarycoord(point, target);
};
$0d23c856ce11c301$export$5a465592bfe74b48.prototype.midpoint = function(target) {
    console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint().");
    return this.getMidpoint(target);
};
$0d23c856ce11c301$export$5a465592bfe74b48.prototypenormal = function(target) {
    console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
    return this.getNormal(target);
};
$0d23c856ce11c301$export$5a465592bfe74b48.prototype.plane = function(target) {
    console.warn("THREE.Triangle: .plane() has been renamed to .getPlane().");
    return this.getPlane(target);
};
$0d23c856ce11c301$export$5a465592bfe74b48.barycoordFromPoint = function(point, a, b, c, target) {
    console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
    return $0d23c856ce11c301$export$5a465592bfe74b48.getBarycoord(point, a, b, c, target);
};
$0d23c856ce11c301$export$5a465592bfe74b48.normal = function(a, b, c, target) {
    console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
    return $0d23c856ce11c301$export$5a465592bfe74b48.getNormal(a, b, c, target);
};
//
$0d23c856ce11c301$export$6428a7f2611ef1fa.prototype.extractAllPoints = function(divisions) {
    console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.");
    return this.extractPoints(divisions);
};
$0d23c856ce11c301$export$6428a7f2611ef1fa.prototype.extrude = function(options) {
    console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.");
    return new $0d23c856ce11c301$export$91836d01b9f75a58(this, options);
};
$0d23c856ce11c301$export$6428a7f2611ef1fa.prototype.makeGeometry = function(options) {
    console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.");
    return new $0d23c856ce11c301$export$233afc324766bed8(this, options);
};
//
$0d23c856ce11c301$export$c977b3e384af9ae1.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().");
    return this.fromBufferAttribute(attribute, index, offset);
};
$0d23c856ce11c301$export$c977b3e384af9ae1.prototype.distanceToManhattan = function(v) {
    console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
    return this.manhattanDistanceTo(v);
};
$0d23c856ce11c301$export$c977b3e384af9ae1.prototype.lengthManhattan = function() {
    console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().");
    return this.manhattanLength();
};
//
$0d23c856ce11c301$export$64b5c384219d3699.prototype.setEulerFromRotationMatrix = function() {
    console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
};
$0d23c856ce11c301$export$64b5c384219d3699.prototype.setEulerFromQuaternion = function() {
    console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
};
$0d23c856ce11c301$export$64b5c384219d3699.prototype.getPositionFromMatrix = function(m) {
    console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().");
    return this.setFromMatrixPosition(m);
};
$0d23c856ce11c301$export$64b5c384219d3699.prototype.getScaleFromMatrix = function(m) {
    console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().");
    return this.setFromMatrixScale(m);
};
$0d23c856ce11c301$export$64b5c384219d3699.prototype.getColumnFromMatrix = function(index, matrix) {
    console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().");
    return this.setFromMatrixColumn(matrix, index);
};
$0d23c856ce11c301$export$64b5c384219d3699.prototype.applyProjection = function(m) {
    console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.");
    return this.applyMatrix4(m);
};
$0d23c856ce11c301$export$64b5c384219d3699.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().");
    return this.fromBufferAttribute(attribute, index, offset);
};
$0d23c856ce11c301$export$64b5c384219d3699.prototype.distanceToManhattan = function(v) {
    console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
    return this.manhattanDistanceTo(v);
};
$0d23c856ce11c301$export$64b5c384219d3699.prototype.lengthManhattan = function() {
    console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().");
    return this.manhattanLength();
};
//
$0d23c856ce11c301$export$fa7daccca11cdbe3.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().");
    return this.fromBufferAttribute(attribute, index, offset);
};
$0d23c856ce11c301$export$fa7daccca11cdbe3.prototype.lengthManhattan = function() {
    console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().");
    return this.manhattanLength();
};
//
$0d23c856ce11c301$export$e4dd07dff30cc924.prototype.getChildByName = function(name) {
    console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().");
    return this.getObjectByName(name);
};
$0d23c856ce11c301$export$e4dd07dff30cc924.prototype.renderDepth = function() {
    console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
};
$0d23c856ce11c301$export$e4dd07dff30cc924.prototype.translate = function(distance, axis) {
    console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.");
    return this.translateOnAxis(axis, distance);
};
$0d23c856ce11c301$export$e4dd07dff30cc924.prototype.getWorldRotation = function() {
    console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.");
};
$0d23c856ce11c301$export$e4dd07dff30cc924.prototype.applyMatrix = function(matrix) {
    console.warn("THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().");
    return this.applyMatrix4(matrix);
};
Object.defineProperties($0d23c856ce11c301$export$e4dd07dff30cc924.prototype, {
    eulerOrder: {
        get: function() {
            console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
            return this.rotation.order;
        },
        set: function(value) {
            console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
            this.rotation.order = value;
        }
    },
    useQuaternion: {
        get: function() {
            console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
        },
        set: function() {
            console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
        }
    }
});
$0d23c856ce11c301$export$e176487c05830cc5.prototype.setDrawMode = function() {
    console.error("THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
};
Object.defineProperties($0d23c856ce11c301$export$e176487c05830cc5.prototype, {
    drawMode: {
        get: function() {
            console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.");
            return $0d23c856ce11c301$export$4c28c87c2dc84758;
        },
        set: function() {
            console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
        }
    }
});
$0d23c856ce11c301$export$b303577035157ecf.prototype.initBones = function() {
    console.error("THREE.SkinnedMesh: initBones() has been removed.");
};
//
$0d23c856ce11c301$export$74e4ae24825f68d7.prototype.setLens = function(focalLength, filmGauge) {
    console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.");
    if (filmGauge !== undefined) this.filmGauge = filmGauge;
    this.setFocalLength(focalLength);
};
//
Object.defineProperties($0d23c856ce11c301$export$6ecadb6ed240d696.prototype, {
    onlyShadow: {
        set: function() {
            console.warn("THREE.Light: .onlyShadow has been removed.");
        }
    },
    shadowCameraFov: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov.");
            this.shadow.camera.fov = value;
        }
    },
    shadowCameraLeft: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left.");
            this.shadow.camera.left = value;
        }
    },
    shadowCameraRight: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right.");
            this.shadow.camera.right = value;
        }
    },
    shadowCameraTop: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top.");
            this.shadow.camera.top = value;
        }
    },
    shadowCameraBottom: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.");
            this.shadow.camera.bottom = value;
        }
    },
    shadowCameraNear: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near.");
            this.shadow.camera.near = value;
        }
    },
    shadowCameraFar: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far.");
            this.shadow.camera.far = value;
        }
    },
    shadowCameraVisible: {
        set: function() {
            console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
        }
    },
    shadowBias: {
        set: function(value) {
            console.warn("THREE.Light: .shadowBias is now .shadow.bias.");
            this.shadow.bias = value;
        }
    },
    shadowDarkness: {
        set: function() {
            console.warn("THREE.Light: .shadowDarkness has been removed.");
        }
    },
    shadowMapWidth: {
        set: function(value) {
            console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.");
            this.shadow.mapSize.width = value;
        }
    },
    shadowMapHeight: {
        set: function(value) {
            console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.");
            this.shadow.mapSize.height = value;
        }
    }
});
//
Object.defineProperties($0d23c856ce11c301$export$8dea267bd6bde117.prototype, {
    length: {
        get: function() {
            console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead.");
            return this.array.length;
        }
    },
    dynamic: {
        get: function() {
            console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
            return this.usage === $0d23c856ce11c301$export$8505d14ac8546ca;
        },
        set: function() {
            console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
            this.setUsage($0d23c856ce11c301$export$8505d14ac8546ca);
        }
    }
});
$0d23c856ce11c301$export$8dea267bd6bde117.prototype.setDynamic = function(value) {
    console.warn("THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.");
    this.setUsage(value === true ? $0d23c856ce11c301$export$8505d14ac8546ca : $0d23c856ce11c301$export$763e8360f4d7f77d);
    return this;
};
$0d23c856ce11c301$export$8dea267bd6bde117.prototype.copyIndicesArray = function() {
    console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.");
}, $0d23c856ce11c301$export$8dea267bd6bde117.prototype.setArray = function() {
    console.error("THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
//
$0d23c856ce11c301$export$b7be63a67df8959.prototype.addIndex = function(index) {
    console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().");
    this.setIndex(index);
};
$0d23c856ce11c301$export$b7be63a67df8959.prototype.addAttribute = function(name, attribute) {
    console.warn("THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().");
    if (!(attribute && attribute.isBufferAttribute) && !(attribute && attribute.isInterleavedBufferAttribute)) {
        console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).");
        return this.setAttribute(name, new $0d23c856ce11c301$export$8dea267bd6bde117(arguments[1], arguments[2]));
    }
    if (name === "index") {
        console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.");
        this.setIndex(attribute);
        return this;
    }
    return this.setAttribute(name, attribute);
};
$0d23c856ce11c301$export$b7be63a67df8959.prototype.addDrawCall = function(start, count, indexOffset) {
    if (indexOffset !== undefined) console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.");
    console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup().");
    this.addGroup(start, count);
};
$0d23c856ce11c301$export$b7be63a67df8959.prototype.clearDrawCalls = function() {
    console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().");
    this.clearGroups();
};
$0d23c856ce11c301$export$b7be63a67df8959.prototype.computeOffsets = function() {
    console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
};
$0d23c856ce11c301$export$b7be63a67df8959.prototype.removeAttribute = function(name) {
    console.warn("THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().");
    return this.deleteAttribute(name);
};
$0d23c856ce11c301$export$b7be63a67df8959.prototype.applyMatrix = function(matrix) {
    console.warn("THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().");
    return this.applyMatrix4(matrix);
};
Object.defineProperties($0d23c856ce11c301$export$b7be63a67df8959.prototype, {
    drawcalls: {
        get: function() {
            console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups.");
            return this.groups;
        }
    },
    offsets: {
        get: function() {
            console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups.");
            return this.groups;
        }
    }
});
$0d23c856ce11c301$export$3d5cd879f108f53f.prototype.setDynamic = function(value) {
    console.warn("THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead.");
    this.setUsage(value === true ? $0d23c856ce11c301$export$8505d14ac8546ca : $0d23c856ce11c301$export$763e8360f4d7f77d);
    return this;
};
$0d23c856ce11c301$export$3d5cd879f108f53f.prototype.setArray = function() {
    console.error("THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
//
$0d23c856ce11c301$export$91836d01b9f75a58.prototype.getArrays = function() {
    console.error("THREE.ExtrudeGeometry: .getArrays() has been removed.");
};
$0d23c856ce11c301$export$91836d01b9f75a58.prototype.addShapeList = function() {
    console.error("THREE.ExtrudeGeometry: .addShapeList() has been removed.");
};
$0d23c856ce11c301$export$91836d01b9f75a58.prototype.addShape = function() {
    console.error("THREE.ExtrudeGeometry: .addShape() has been removed.");
};
//
$0d23c856ce11c301$export$38af1803e3442a7f.prototype.dispose = function() {
    console.error("THREE.Scene: .dispose() has been removed.");
};
//
$0d23c856ce11c301$export$2947cebfe91c02f8.prototype.onUpdate = function() {
    console.warn("THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.");
    return this;
};
//
Object.defineProperties($0d23c856ce11c301$export$a2d8b23205c25948.prototype, {
    wrapAround: {
        get: function() {
            console.warn("THREE.Material: .wrapAround has been removed.");
        },
        set: function() {
            console.warn("THREE.Material: .wrapAround has been removed.");
        }
    },
    overdraw: {
        get: function() {
            console.warn("THREE.Material: .overdraw has been removed.");
        },
        set: function() {
            console.warn("THREE.Material: .overdraw has been removed.");
        }
    },
    wrapRGB: {
        get: function() {
            console.warn("THREE.Material: .wrapRGB has been removed.");
            return new $0d23c856ce11c301$export$892596cec99bc70e();
        }
    },
    shading: {
        get: function() {
            console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
        },
        set: function(value) {
            console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
            this.flatShading = value === $0d23c856ce11c301$export$a62047d29c96d8ff;
        }
    },
    stencilMask: {
        get: function() {
            console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
            return this.stencilFuncMask;
        },
        set: function(value) {
            console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
            this.stencilFuncMask = value;
        }
    }
});
Object.defineProperties($0d23c856ce11c301$export$83c7d75d550a8b0d.prototype, {
    derivatives: {
        get: function() {
            console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
            return this.extensions.derivatives;
        },
        set: function(value) {
            console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
            this.extensions.derivatives = value;
        }
    }
});
//
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.clearTarget = function(renderTarget, color, depth, stencil) {
    console.warn("THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.");
    this.setRenderTarget(renderTarget);
    this.clear(color, depth, stencil);
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.animate = function(callback) {
    console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop().");
    this.setAnimationLoop(callback);
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.getCurrentRenderTarget = function() {
    console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().");
    return this.getRenderTarget();
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.getMaxAnisotropy = function() {
    console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().");
    return this.capabilities.getMaxAnisotropy();
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.getPrecision = function() {
    console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.");
    return this.capabilities.precision;
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.resetGLState = function() {
    console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset().");
    return this.state.reset();
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.supportsFloatTextures = function() {
    console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' ).");
    return this.extensions.get("OES_texture_float");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.supportsHalfFloatTextures = function() {
    console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' ).");
    return this.extensions.get("OES_texture_half_float");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.supportsStandardDerivatives = function() {
    console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' ).");
    return this.extensions.get("OES_standard_derivatives");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.supportsCompressedTextureS3TC = function() {
    console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' ).");
    return this.extensions.get("WEBGL_compressed_texture_s3tc");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.supportsCompressedTexturePVRTC = function() {
    console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' ).");
    return this.extensions.get("WEBGL_compressed_texture_pvrtc");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.supportsBlendMinMax = function() {
    console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' ).");
    return this.extensions.get("EXT_blend_minmax");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.supportsVertexTextures = function() {
    console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.");
    return this.capabilities.vertexTextures;
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.supportsInstancedArrays = function() {
    console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' ).");
    return this.extensions.get("ANGLE_instanced_arrays");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.enableScissorTest = function(boolean) {
    console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().");
    this.setScissorTest(boolean);
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.initMaterial = function() {
    console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.addPrePlugin = function() {
    console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.addPostPlugin = function() {
    console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.updateShadowMap = function() {
    console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.setFaceCulling = function() {
    console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.allocTextureUnit = function() {
    console.warn("THREE.WebGLRenderer: .allocTextureUnit() has been removed.");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.setTexture = function() {
    console.warn("THREE.WebGLRenderer: .setTexture() has been removed.");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.setTexture2D = function() {
    console.warn("THREE.WebGLRenderer: .setTexture2D() has been removed.");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.setTextureCube = function() {
    console.warn("THREE.WebGLRenderer: .setTextureCube() has been removed.");
};
$0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype.getActiveMipMapLevel = function() {
    console.warn("THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().");
    return this.getActiveMipmapLevel();
};
Object.defineProperties($0d23c856ce11c301$export$f6cc00ef28d7cf97.prototype, {
    shadowMapEnabled: {
        get: function() {
            return this.shadowMap.enabled;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.");
            this.shadowMap.enabled = value;
        }
    },
    shadowMapType: {
        get: function() {
            return this.shadowMap.type;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.");
            this.shadowMap.type = value;
        }
    },
    shadowMapCullFace: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
        }
    },
    context: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.");
            return this.getContext();
        }
    },
    vr: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .vr has been renamed to .xr");
            return this.xr;
        }
    },
    gammaInput: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
            return false;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
        }
    },
    gammaOutput: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
            return false;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
            this.outputEncoding = value === true ? $0d23c856ce11c301$export$f32388edbb32674 : $0d23c856ce11c301$export$7207336e4151a112;
        }
    },
    toneMappingWhitePoint: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
            return 1.0;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
        }
    }
});
Object.defineProperties($0d23c856ce11c301$var$WebGLShadowMap.prototype, {
    cullFace: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
        }
    },
    renderReverseSided: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
        }
    },
    renderSingleSided: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
        }
    }
});
function $0d23c856ce11c301$export$689069929abfa262(width, height, options) {
    console.warn("THREE.WebGLRenderTargetCube( width, height, options ) is now WebGLCubeRenderTarget( size, options ).");
    return new $0d23c856ce11c301$export$ac386671d651941e(width, options);
}
//
Object.defineProperties($0d23c856ce11c301$export$3c052beb2e51e23f.prototype, {
    wrapS: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
            return this.texture.wrapS;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
            this.texture.wrapS = value;
        }
    },
    wrapT: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
            return this.texture.wrapT;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
            this.texture.wrapT = value;
        }
    },
    magFilter: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
            return this.texture.magFilter;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
            this.texture.magFilter = value;
        }
    },
    minFilter: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
            return this.texture.minFilter;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
            this.texture.minFilter = value;
        }
    },
    anisotropy: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
            return this.texture.anisotropy;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
            this.texture.anisotropy = value;
        }
    },
    offset: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
            return this.texture.offset;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
            this.texture.offset = value;
        }
    },
    repeat: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
            return this.texture.repeat;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
            this.texture.repeat = value;
        }
    },
    format: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
            return this.texture.format;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
            this.texture.format = value;
        }
    },
    type: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
            return this.texture.type;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
            this.texture.type = value;
        }
    },
    generateMipmaps: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
            return this.texture.generateMipmaps;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
            this.texture.generateMipmaps = value;
        }
    }
});
//
$0d23c856ce11c301$export$153755f98d9861de.prototype.load = function(file) {
    console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
    const scope = this;
    const audioLoader = new $0d23c856ce11c301$export$d8d5fccfbf47714e();
    audioLoader.load(file, function(buffer) {
        scope.setBuffer(buffer);
    });
    return this;
};
$0d23c856ce11c301$export$d47da1ef3d382827.prototype.getData = function() {
    console.warn("THREE.AudioAnalyser: .getData() is now .getFrequencyData().");
    return this.getFrequencyData();
};
//
$0d23c856ce11c301$export$d0cdd0bd804995de.prototype.updateCubeMap = function(renderer, scene) {
    console.warn("THREE.CubeCamera: .updateCubeMap() is now .update().");
    return this.update(renderer, scene);
};
$0d23c856ce11c301$export$d0cdd0bd804995de.prototype.clear = function(renderer, color, depth, stencil) {
    console.warn("THREE.CubeCamera: .clear() is now .renderTarget.clear().");
    return this.renderTarget.clear(renderer, color, depth, stencil);
};
$0d23c856ce11c301$export$698882cf06df44aa.crossOrigin = undefined;
$0d23c856ce11c301$export$698882cf06df44aa.loadTexture = function(url, mapping, onLoad, onError) {
    console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
    const loader = new $0d23c856ce11c301$export$fd1bfc71f64c538c();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(url, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
$0d23c856ce11c301$export$698882cf06df44aa.loadTextureCube = function(urls, mapping, onLoad, onError) {
    console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
    const loader = new $0d23c856ce11c301$export$2ec114afc2cf6308();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(urls, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
$0d23c856ce11c301$export$698882cf06df44aa.loadCompressedTexture = function() {
    console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
};
$0d23c856ce11c301$export$698882cf06df44aa.loadCompressedTextureCube = function() {
    console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
};
//
function $0d23c856ce11c301$export$7adc20298958481a() {
    console.error("THREE.CanvasRenderer has been removed");
}
//
function $0d23c856ce11c301$export$8e85bca5826c4696() {
    console.error("THREE.JSONLoader has been removed.");
}
//
const $0d23c856ce11c301$export$a8351e0de8b3fd78 = {
    createMultiMaterialObject: function() {
        console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    },
    detach: function() {
        console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    },
    attach: function() {
        console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    }
};
//
function $0d23c856ce11c301$export$3f909fba4d49fe3d() {
    console.error("THREE.LensFlare has been moved to /examples/jsm/objects/Lensflare.js");
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") /* eslint-disable no-undef */ __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $0d23c856ce11c301$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $0d23c856ce11c301$export$3545e07a80636437;
}


/**
 * @author Iker Hurtado
 *
 * @fileoverview File holding the ThreeViewer class
 */ // import * as THREE from '../../lib/three.js'


const $50a2e1805a68d645$var$_changeEvent = {
    type: "change"
};
const $50a2e1805a68d645$var$_startEvent = {
    type: "start"
};
const $50a2e1805a68d645$var$_endEvent = {
    type: "end"
};
class $50a2e1805a68d645$export$18b7f869be764a91 extends (0, $0d23c856ce11c301$export$ec8b666c5fe2c75a) {
    constructor(object, domElement){
        super();
        if (domElement === undefined) console.warn('THREE.TrackballControls: The second parameter "domElement" is now mandatory.');
        if (domElement === document) console.error('THREE.TrackballControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.');
        const scope = this;
        const STATE = {
            NONE: -1,
            ROTATE: 0,
            ZOOM: 1,
            PAN: 2,
            TOUCH_ROTATE: 3,
            TOUCH_ZOOM_PAN: 4
        };
        this.object = object;
        this.domElement = domElement;
        this.domElement.style.touchAction = "none"; // disable touch scroll
        // API
        this.enabled = true;
        this.screen = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        };
        this.rotateSpeed = 1.0;
        this.zoomSpeed = 1.2;
        this.panSpeed = 0.3;
        this.noRotate = false;
        this.noZoom = false;
        this.noPan = false;
        this.staticMoving = false;
        this.dynamicDampingFactor = 0.2;
        this.minDistance = 0;
        this.maxDistance = Infinity;
        this.keys = [
            "KeyA" /*A*/ ,
            "KeyS" /*S*/ ,
            "KeyD" /*D*/ 
        ];
        this.mouseButtons = {
            LEFT: (0, $0d23c856ce11c301$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $0d23c856ce11c301$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $0d23c856ce11c301$export$7177b3e430c2d7ca).PAN
        };
        // internals
        this.target = new (0, $0d23c856ce11c301$export$64b5c384219d3699)();
        const EPS = 0.000001;
        const lastPosition = new (0, $0d23c856ce11c301$export$64b5c384219d3699)();
        let lastZoom = 1;
        let _state = STATE.NONE, _keyState = STATE.NONE, _touchZoomDistanceStart = 0, _touchZoomDistanceEnd = 0, _lastAngle = 0;
        const _eye = new (0, $0d23c856ce11c301$export$64b5c384219d3699)(), _movePrev = new (0, $0d23c856ce11c301$export$c977b3e384af9ae1)(), _moveCurr = new (0, $0d23c856ce11c301$export$c977b3e384af9ae1)(), _lastAxis = new (0, $0d23c856ce11c301$export$64b5c384219d3699)(), _zoomStart = new (0, $0d23c856ce11c301$export$c977b3e384af9ae1)(), _zoomEnd = new (0, $0d23c856ce11c301$export$c977b3e384af9ae1)(), _panStart = new (0, $0d23c856ce11c301$export$c977b3e384af9ae1)(), _panEnd = new (0, $0d23c856ce11c301$export$c977b3e384af9ae1)(), _pointers = [], _pointerPositions = {};
        // for reset
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.up0 = this.object.up.clone();
        this.zoom0 = this.object.zoom;
        // methods
        this.handleResize = function() {
            const box = scope.domElement.getBoundingClientRect();
            // adjustments come from similar code in the jquery offset() function
            const d = scope.domElement.ownerDocument.documentElement;
            scope.screen.left = box.left + window.pageXOffset - d.clientLeft;
            scope.screen.top = box.top + window.pageYOffset - d.clientTop;
            scope.screen.width = box.width;
            scope.screen.height = box.height;
        };
        const getMouseOnScreen = function() {
            const vector = new (0, $0d23c856ce11c301$export$c977b3e384af9ae1)();
            return function getMouseOnScreen(pageX, pageY) {
                vector.set((pageX - scope.screen.left) / scope.screen.width, (pageY - scope.screen.top) / scope.screen.height);
                return vector;
            };
        }();
        const getMouseOnCircle = function() {
            const vector = new (0, $0d23c856ce11c301$export$c977b3e384af9ae1)();
            return function getMouseOnCircle(pageX, pageY) {
                vector.set((pageX - scope.screen.width * 0.5 - scope.screen.left) / (scope.screen.width * 0.5), (scope.screen.height + 2 * (scope.screen.top - pageY)) / scope.screen.width // screen.width intentional
                );
                return vector;
            };
        }();
        this.rotateCamera = function() {
            const axis = new (0, $0d23c856ce11c301$export$64b5c384219d3699)(), quaternion = new (0, $0d23c856ce11c301$export$23d6a54f0bbc85a3)(), eyeDirection = new (0, $0d23c856ce11c301$export$64b5c384219d3699)(), objectUpDirection = new (0, $0d23c856ce11c301$export$64b5c384219d3699)(), objectSidewaysDirection = new (0, $0d23c856ce11c301$export$64b5c384219d3699)(), moveDirection = new (0, $0d23c856ce11c301$export$64b5c384219d3699)();
            return function rotateCamera() {
                moveDirection.set(_moveCurr.x - _movePrev.x, _moveCurr.y - _movePrev.y, 0);
                let angle = moveDirection.length();
                if (angle) {
                    _eye.copy(scope.object.position).sub(scope.target);
                    eyeDirection.copy(_eye).normalize();
                    objectUpDirection.copy(scope.object.up).normalize();
                    objectSidewaysDirection.crossVectors(objectUpDirection, eyeDirection).normalize();
                    objectUpDirection.setLength(_moveCurr.y - _movePrev.y);
                    objectSidewaysDirection.setLength(_moveCurr.x - _movePrev.x);
                    moveDirection.copy(objectUpDirection.add(objectSidewaysDirection));
                    axis.crossVectors(moveDirection, _eye).normalize();
                    angle *= scope.rotateSpeed;
                    quaternion.setFromAxisAngle(axis, angle);
                    _eye.applyQuaternion(quaternion);
                    scope.object.up.applyQuaternion(quaternion);
                    _lastAxis.copy(axis);
                    _lastAngle = angle;
                } else if (!scope.staticMoving && _lastAngle) {
                    _lastAngle *= Math.sqrt(1.0 - scope.dynamicDampingFactor);
                    _eye.copy(scope.object.position).sub(scope.target);
                    quaternion.setFromAxisAngle(_lastAxis, _lastAngle);
                    _eye.applyQuaternion(quaternion);
                    scope.object.up.applyQuaternion(quaternion);
                }
                _movePrev.copy(_moveCurr);
            };
        }();
        this.zoomCamera = function() {
            let factor;
            if (_state === STATE.TOUCH_ZOOM_PAN) {
                factor = _touchZoomDistanceStart / _touchZoomDistanceEnd;
                _touchZoomDistanceStart = _touchZoomDistanceEnd;
                if (scope.object.isPerspectiveCamera) _eye.multiplyScalar(factor);
                else if (scope.object.isOrthographicCamera) {
                    scope.object.zoom *= factor;
                    scope.object.updateProjectionMatrix();
                } else console.warn("THREE.TrackballControls: Unsupported camera type");
            } else {
                factor = 1.0 + (_zoomEnd.y - _zoomStart.y) * scope.zoomSpeed;
                if (factor !== 1.0 && factor > 0.0) {
                    if (scope.object.isPerspectiveCamera) _eye.multiplyScalar(factor);
                    else if (scope.object.isOrthographicCamera) {
                        scope.object.zoom /= factor;
                        scope.object.updateProjectionMatrix();
                    } else console.warn("THREE.TrackballControls: Unsupported camera type");
                }
                if (scope.staticMoving) _zoomStart.copy(_zoomEnd);
                else _zoomStart.y += (_zoomEnd.y - _zoomStart.y) * this.dynamicDampingFactor;
            }
        };
        this.panCamera = function() {
            const mouseChange = new (0, $0d23c856ce11c301$export$c977b3e384af9ae1)(), objectUp = new (0, $0d23c856ce11c301$export$64b5c384219d3699)(), pan = new (0, $0d23c856ce11c301$export$64b5c384219d3699)();
            return function panCamera() {
                mouseChange.copy(_panEnd).sub(_panStart);
                if (mouseChange.lengthSq()) {
                    if (scope.object.isOrthographicCamera) {
                        const scale_x = (scope.object.right - scope.object.left) / scope.object.zoom / scope.domElement.clientWidth;
                        const scale_y = (scope.object.top - scope.object.bottom) / scope.object.zoom / scope.domElement.clientWidth;
                        mouseChange.x *= scale_x;
                        mouseChange.y *= scale_y;
                    }
                    mouseChange.multiplyScalar(_eye.length() * scope.panSpeed);
                    pan.copy(_eye).cross(scope.object.up).setLength(mouseChange.x);
                    pan.add(objectUp.copy(scope.object.up).setLength(mouseChange.y));
                    scope.object.position.add(pan);
                    scope.target.add(pan);
                    if (scope.staticMoving) _panStart.copy(_panEnd);
                    else _panStart.add(mouseChange.subVectors(_panEnd, _panStart).multiplyScalar(scope.dynamicDampingFactor));
                }
            };
        }();
        this.checkDistances = function() {
            if (!scope.noZoom || !scope.noPan) {
                if (_eye.lengthSq() > scope.maxDistance * scope.maxDistance) {
                    scope.object.position.addVectors(scope.target, _eye.setLength(scope.maxDistance));
                    _zoomStart.copy(_zoomEnd);
                }
                if (_eye.lengthSq() < scope.minDistance * scope.minDistance) {
                    scope.object.position.addVectors(scope.target, _eye.setLength(scope.minDistance));
                    _zoomStart.copy(_zoomEnd);
                }
            }
        };
        this.update = function() {
            _eye.subVectors(scope.object.position, scope.target);
            if (!scope.noRotate) scope.rotateCamera();
            if (!scope.noZoom) scope.zoomCamera();
            if (!scope.noPan) scope.panCamera();
            scope.object.position.addVectors(scope.target, _eye);
            if (scope.object.isPerspectiveCamera) {
                scope.checkDistances();
                scope.object.lookAt(scope.target);
                if (lastPosition.distanceToSquared(scope.object.position) > EPS) {
                    scope.dispatchEvent($50a2e1805a68d645$var$_changeEvent);
                    lastPosition.copy(scope.object.position);
                }
            } else if (scope.object.isOrthographicCamera) {
                scope.object.lookAt(scope.target);
                if (lastPosition.distanceToSquared(scope.object.position) > EPS || lastZoom !== scope.object.zoom) {
                    scope.dispatchEvent($50a2e1805a68d645$var$_changeEvent);
                    lastPosition.copy(scope.object.position);
                    lastZoom = scope.object.zoom;
                }
            } else console.warn("THREE.TrackballControls: Unsupported camera type");
        };
        this.reset = function() {
            _state = STATE.NONE;
            _keyState = STATE.NONE;
            scope.target.copy(scope.target0);
            scope.object.position.copy(scope.position0);
            scope.object.up.copy(scope.up0);
            scope.object.zoom = scope.zoom0;
            scope.object.updateProjectionMatrix();
            _eye.subVectors(scope.object.position, scope.target);
            scope.object.lookAt(scope.target);
            scope.dispatchEvent($50a2e1805a68d645$var$_changeEvent);
            lastPosition.copy(scope.object.position);
            lastZoom = scope.object.zoom;
        };
        // listeners
        function onPointerDown(event) {
            if (scope.enabled === false) return;
            if (_pointers.length === 0) {
                scope.domElement.ownerDocument.addEventListener("pointermove", onPointerMove);
                scope.domElement.ownerDocument.addEventListener("pointerup", onPointerUp);
            }
            //
            addPointer(event);
            if (event.pointerType === "touch") onTouchStart(event);
            else onMouseDown(event);
        }
        function onPointerMove(event) {
            if (scope.enabled === false) return;
            if (event.pointerType === "touch") onTouchMove(event);
            else onMouseMove(event);
        }
        function onPointerUp(event) {
            if (scope.enabled === false) return;
            if (event.pointerType === "touch") onTouchEnd(event);
            else onMouseUp();
            //
            removePointer(event);
            if (_pointers.length === 0) {
                scope.domElement.ownerDocument.removeEventListener("pointermove", onPointerMove);
                scope.domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
            }
        }
        function onPointerCancel(event) {
            removePointer(event);
        }
        function keydown(event) {
            if (scope.enabled === false) return;
            window.removeEventListener("keydown", keydown);
            if (_keyState !== STATE.NONE) return;
            else if (event.code === scope.keys[STATE.ROTATE] && !scope.noRotate) _keyState = STATE.ROTATE;
            else if (event.code === scope.keys[STATE.ZOOM] && !scope.noZoom) _keyState = STATE.ZOOM;
            else if (event.code === scope.keys[STATE.PAN] && !scope.noPan) _keyState = STATE.PAN;
        }
        function keyup() {
            if (scope.enabled === false) return;
            _keyState = STATE.NONE;
            window.addEventListener("keydown", keydown);
        }
        function onMouseDown(event) {
            if (_state === STATE.NONE) switch(event.button){
                case scope.mouseButtons.LEFT:
                    _state = STATE.ROTATE;
                    break;
                case scope.mouseButtons.MIDDLE:
                    _state = STATE.ZOOM;
                    break;
                case scope.mouseButtons.RIGHT:
                    _state = STATE.PAN;
                    break;
                default:
                    _state = STATE.NONE;
            }
            const state = _keyState !== STATE.NONE ? _keyState : _state;
            if (state === STATE.ROTATE && !scope.noRotate) {
                _moveCurr.copy(getMouseOnCircle(event.pageX, event.pageY));
                _movePrev.copy(_moveCurr);
            } else if (state === STATE.ZOOM && !scope.noZoom) {
                _zoomStart.copy(getMouseOnScreen(event.pageX, event.pageY));
                _zoomEnd.copy(_zoomStart);
            } else if (state === STATE.PAN && !scope.noPan) {
                _panStart.copy(getMouseOnScreen(event.pageX, event.pageY));
                _panEnd.copy(_panStart);
            }
            scope.domElement.ownerDocument.addEventListener("pointermove", onPointerMove);
            scope.domElement.ownerDocument.addEventListener("pointerup", onPointerUp);
            scope.dispatchEvent($50a2e1805a68d645$var$_startEvent);
        }
        function onMouseMove(event) {
            const state = _keyState !== STATE.NONE ? _keyState : _state;
            if (state === STATE.ROTATE && !scope.noRotate) {
                _movePrev.copy(_moveCurr);
                _moveCurr.copy(getMouseOnCircle(event.pageX, event.pageY));
            } else if (state === STATE.ZOOM && !scope.noZoom) _zoomEnd.copy(getMouseOnScreen(event.pageX, event.pageY));
            else if (state === STATE.PAN && !scope.noPan) _panEnd.copy(getMouseOnScreen(event.pageX, event.pageY));
        }
        function onMouseUp() {
            _state = STATE.NONE;
            scope.domElement.ownerDocument.removeEventListener("pointermove", onPointerMove);
            scope.domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
            scope.dispatchEvent($50a2e1805a68d645$var$_endEvent);
        }
        function onMouseWheel(event) {
            if (scope.enabled === false) return;
            if (scope.noZoom === true) return;
            event.preventDefault();
            switch(event.deltaMode){
                case 2:
                    // Zoom in pages
                    _zoomStart.y -= event.deltaY * 0.025;
                    break;
                case 1:
                    // Zoom in lines
                    _zoomStart.y -= event.deltaY * 0.01;
                    break;
                default:
                    // undefined, 0, assume pixels
                    _zoomStart.y -= event.deltaY * 0.00025;
                    break;
            }
            scope.dispatchEvent($50a2e1805a68d645$var$_startEvent);
            scope.dispatchEvent($50a2e1805a68d645$var$_endEvent);
        }
        function onTouchStart(event) {
            trackPointer(event);
            switch(_pointers.length){
                case 1:
                    _state = STATE.TOUCH_ROTATE;
                    _moveCurr.copy(getMouseOnCircle(_pointers[0].pageX, _pointers[0].pageY));
                    _movePrev.copy(_moveCurr);
                    break;
                default:
                    _state = STATE.TOUCH_ZOOM_PAN;
                    const dx = _pointers[0].pageX - _pointers[1].pageX;
                    const dy = _pointers[0].pageY - _pointers[1].pageY;
                    _touchZoomDistanceEnd = _touchZoomDistanceStart = Math.sqrt(dx * dx + dy * dy);
                    const x = (_pointers[0].pageX + _pointers[1].pageX) / 2;
                    const y = (_pointers[0].pageY + _pointers[1].pageY) / 2;
                    _panStart.copy(getMouseOnScreen(x, y));
                    _panEnd.copy(_panStart);
                    break;
            }
            scope.dispatchEvent($50a2e1805a68d645$var$_startEvent);
        }
        function onTouchMove(event) {
            trackPointer(event);
            switch(_pointers.length){
                case 1:
                    _movePrev.copy(_moveCurr);
                    _moveCurr.copy(getMouseOnCircle(event.pageX, event.pageY));
                    break;
                default:
                    const position = getSecondPointerPosition(event);
                    const dx = event.pageX - position.x;
                    const dy = event.pageY - position.y;
                    _touchZoomDistanceEnd = Math.sqrt(dx * dx + dy * dy);
                    const x = (event.pageX + position.x) / 2;
                    const y = (event.pageY + position.y) / 2;
                    _panEnd.copy(getMouseOnScreen(x, y));
                    break;
            }
        }
        function onTouchEnd(event) {
            switch(_pointers.length){
                case 0:
                    _state = STATE.NONE;
                    break;
                case 1:
                    _state = STATE.TOUCH_ROTATE;
                    _moveCurr.copy(getMouseOnCircle(event.pageX, event.pageY));
                    _movePrev.copy(_moveCurr);
                    break;
            }
            scope.dispatchEvent($50a2e1805a68d645$var$_endEvent);
        }
        function contextmenu(event) {
            if (scope.enabled === false) return;
            event.preventDefault();
        }
        function addPointer(event) {
            _pointers.push(event);
        }
        function removePointer(event) {
            delete _pointerPositions[event.pointerId];
            for(let i = 0; i < _pointers.length; i++)if (_pointers[i].pointerId == event.pointerId) {
                _pointers.splice(i, 1);
                return;
            }
        }
        function trackPointer(event) {
            let position = _pointerPositions[event.pointerId];
            if (position === undefined) {
                position = new (0, $0d23c856ce11c301$export$c977b3e384af9ae1)();
                _pointerPositions[event.pointerId] = position;
            }
            position.set(event.pageX, event.pageY);
        }
        function getSecondPointerPosition(event) {
            const pointer = event.pointerId === _pointers[0].pointerId ? _pointers[1] : _pointers[0];
            return _pointerPositions[pointer.pointerId];
        }
        this.dispose = function() {
            scope.domElement.removeEventListener("contextmenu", contextmenu);
            scope.domElement.removeEventListener("pointerdown", onPointerDown);
            scope.domElement.removeEventListener("pointercancel", onPointerCancel);
            scope.domElement.removeEventListener("wheel", onMouseWheel);
            window.removeEventListener("keydown", keydown);
            window.removeEventListener("keyup", keyup);
        };
        this.domElement.addEventListener("contextmenu", contextmenu);
        this.domElement.addEventListener("pointerdown", onPointerDown);
        this.domElement.addEventListener("pointercancel", onPointerCancel);
        this.domElement.addEventListener("wheel", onMouseWheel, {
            passive: false
        });
        window.addEventListener("keydown", keydown);
        window.addEventListener("keyup", keyup);
        this.handleResize();
        // force an update at start
        this.update();
    }
}


const $e4a79c8070f9e79e$var$MAX_ZOOM = 5;
const $e4a79c8070f9e79e$var$MIN_ZOOM = 0.1;
class $e4a79c8070f9e79e$export$2e2bcd8739ae039 {
    /**
   * @param  {HTMLElement} hostElement HTML element hosting the canvas
   */ constructor(hostElement){
        this.hostElement = hostElement;
        this.cameraWidth = 10.0; // The default "width" of the camera
        // RENDERER SETUP. The "alpha: true" enables to set a background color.
        this.renderer = new (0, $0d23c856ce11c301$export$f6cc00ef28d7cf97)({
            alpha: true,
            antialias: true
        });
        this.params = {
            orthographicCamera: true
        };
        this.renderer.setSize(this.hostElement.clientWidth, this.hostElement.clientHeight);
        this.renderer.setClearColor(0x000000, 0);
        this.hostElement.appendChild(this.renderer.domElement);
        this.renderer.domElement.id = "threejs-canvas";
        // This is set so that multiple scenes can be used, see
        // http://stackoverflow.com/questions/12666570/how-to-change-the-zorder-of-object-with-threejs/12666937#12666937
        this.renderer.autoClear = false;
        this.setupCamera();
        this.setupScenes();
        this.setupControls();
        this.setupLights();
        window.addEventListener("resize", this.onCanvasResize.bind(this), false);
    }
    /**
   * Sets up the camera for the 3D scene
   */ setupCamera() {
        let aspectRatio = this.hostElement.clientWidth / this.hostElement.clientHeight;
        let width = this.cameraWidth;
        let height = width / aspectRatio;
        this.orthographicCamera = new (0, $0d23c856ce11c301$export$9ebf355ee4ed261b)(width / -2, width / 2, height / 2, height / -2, -100, 1000);
        this.orthographicCamera.position.set(0, 0, 100);
        this.perspectiveCamera = new (0, $0d23c856ce11c301$export$74e4ae24825f68d7)(3, aspectRatio, 1, 1000);
        this.perspectiveCamera.position.set(0, 0, 100);
        this.camera = this.orthographicCamera;
    // this.camera.name = "camera";
    // this.camera.position.set( 0, 0, 100 );//this.camera.position.z = 1; // ***TODO The init value is irrelevant but this is needed
    // console.log('this.camera.position',this.camera.position)
    // this.camera.zoom = 1; // zoom = 1 -> 90 pixels/Angstrom, 0.5 -> 45pixel/Angstrom
    //this.camera.rotateX(Math.PI / 2);
    }
    /**
   * Adjusts the zoom to the structure size: if the structure is smaller the zoom is larger
   * @param  {number} distance
   */ adjustZoomToStructSize(distance) {
        let getCanvasDiagonalPixels = ()=>{
            return Math.sqrt(this.hostElement.clientWidth * this.hostElement.clientWidth + this.hostElement.clientHeight * this.hostElement.clientHeight);
        };
        // With the initial camera position (the camera is perpendicular to the XY plane)
        // I could measure the true ratio Angstrom/canvas pixel: zoom = 1 -> 90 pixels/Angstrom
        // With the structure diagonal we can calculate the ratio pixel/Angstrom
        let pixelAngstromWanted = getCanvasDiagonalPixels() / distance;
        //console.log('diagonal pixels',this.bViewer.getPixelProjectionPerXUnit(),
        //  this.bViewer.getCanvasDiagonalPixels(), pixelAngstromWanted)
        // And finally we can guess the right camera zoom (cross multiply)
        this.orthographicCamera.zoom = 0.4 /*factor*/  * (pixelAngstromWanted / 90);
        // Updates the camera projection matrix. Must be called after any change of parameters
        this.orthographicCamera.updateProjectionMatrix();
        this.perspectiveCamera.zoom = 0.4 /*factor*/  * (pixelAngstromWanted / 90);
        // Updates the camera projection matrix. Must be called after any change of parameters
        this.perspectiveCamera.updateProjectionMatrix();
    }
    /**
   * Sets up the mouse controls
   */ setupControls() {
        this.controls = new (0, $50a2e1805a68d645$export$18b7f869be764a91)(this.camera, this.hostElement);
        this.controls.rotateSpeed = 1.2;
        // this.controls.zoomSpeed = 1.2;
        this.controls.panSpeed = 1.0;
        this.controls.zoomSpeed = 1.2; //controls.rotateSpeed, controls.panSpeed = this.panSpeed
        this.controls.staticMoving = true;
        this.controls.keys = [
            "KeyA",
            "KeyS",
            "KeyD"
        ];
    // this.controls.addEventListener('change', e =>{
    // 	// Zoom max and min values.
    // 	if (this.camera.zoom < MIN_ZOOM)
    // 		this.camera.zoom = MIN_ZOOM
    // 	else if (this.camera.zoom > MAX_ZOOM)
    // 		this.camera.zoom = MAX_ZOOM
    //     //this.camera.updateProjectionMatrix()
    // 	this.render()
    // } )
    }
    /**
   * Sets up the scenes
   */ setupScenes() {
        this.mainScene = new (0, $0d23c856ce11c301$export$38af1803e3442a7f)();
        this.infoScene = new (0, $0d23c856ce11c301$export$38af1803e3442a7f)();
    }
    /**
   * Sets up the lights
   */ setupLights() {
        // Key light
        let keyLight = new (0, $0d23c856ce11c301$export$3fea33cc9972c868)(0xffffff, 0.5);
        keyLight.position.set(0, 0, 20);
        this.mainScene.add(keyLight);
        // Fill light
        let fillLight = new (0, $0d23c856ce11c301$export$3fea33cc9972c868)(0xffffff, 0.45);
        fillLight.position.set(10, -10, -20);
        this.mainScene.add(fillLight);
        // White ambient light.
        let ambientLight = new (0, $0d23c856ce11c301$export$af279bfef9ec2c96)(0x404040, 2.1); // soft white light
        this.mainScene.add(ambientLight);
    }
    /**
   * Animates the canvas
   */ _animate() {
        requestAnimationFrame(this._animate.bind(this));
        this.controls.update();
        this.render();
    }
    /**
   * Clears and renders the scenes
   */ render() {
        // this.renderer.clear();
        this.renderer.render(this.mainScene, this.camera);
        // this.renderer.clearDepth()
        this.renderer.render(this.infoScene, this.camera);
    }
    /**
   * Initializes the rendering
   */ init() {
        //var axesHelper = new AxesHelper( 10 );
        //this.mainScene.add( axesHelper );
        // this.render()
        this._animate();
    }
    /**
   * Returns the 2D canvas element coordinates for a given scene 3D point
   * @param  {Vector3} point
   * @return {Vector3}
   */ getCanvasCoordinates(point) {
        let p = point.clone();
        p.project(this.camera);
        p.x = (0.5 + p.x / 2) * this.hostElement.clientWidth;
        p.y = (0.5 - p.y / 2) * this.hostElement.clientHeight;
        p.z = 0;
        //console.log('getCanvasCoordinates', p);
        return p;
    }
    /**
   * Returns the pixel projection per unit
   * @return {float}
   */ getPixelProjectionPerXUnit() {
        let p = new (0, $0d23c856ce11c301$export$64b5c384219d3699)(1, 0, 0);
        p.project(this.camera);
        p.x = p.x / 2 * this.hostElement.clientWidth;
        //console.log('getPixelProjectionPerXUnit', p.x);
        return p.x;
    }
    /**
   * Updates the different renderer elements for new canvas dimensions
   */ onCanvasResize() {
        // This fixes the bug happening when in a workflow the user hits
        // the step 3 (DownloadInputFilesPage) downloads the input files
        // and goes back to the StructureBuilder: the 3D drawing is hidden.
        // The reason is the hostElement dimensions go to zero I don't why
        // at that moment (when the files are downloaded)
        // This happens on chrome and has to do with the way chrome shows
        // the downloaded files (reducing the effective screen area)
        // The fix prevents the StructureViewer from the adaptation to those zero dimensions
        if (this.hostElement.clientWidth === 0) return;
        let aspectRatio = this.hostElement.clientWidth / this.hostElement.clientHeight;
        let width = this.cameraWidth;
        let height = width / aspectRatio;
        this.perspectiveCamera.aspect = aspectRatio;
        this.perspectiveCamera.updateProjectionMatrix();
        this.orthographicCamera.left = -width / 2;
        this.orthographicCamera.right = width / 2;
        this.orthographicCamera.top = height / 2;
        this.orthographicCamera.bottom = -height / 2;
        this.orthographicCamera.updateProjectionMatrix();
        this.renderer.setSize(this.hostElement.clientWidth, this.hostElement.clientHeight);
        // this.infoCanvas.resize()
        this.controls.handleResize();
    // this.render()
    }
    /**
   * Clears the scenes
   */ clearScenes() {
        let mainRootObj = this.mainScene.getObjectByName("structure");
        let bzMainRootObj = this.mainScene.getObjectByName("bz");
        let infoRootObj = this.infoScene.getObjectByName("lattice-parameters");
        let bzInfoRootObj = this.infoScene.getObjectByName("recLattice-parameters");
        //console.log('rootObject', mainRootObj, infoRootObj)
        if (mainRootObj) {
            this.mainScene.remove(mainRootObj);
            this.clearObject(mainRootObj);
        }
        if (infoRootObj) {
            this.infoScene.remove(infoRootObj);
            this.clearObject(infoRootObj);
        }
        if (bzMainRootObj) {
            this.mainScene.remove(bzMainRootObj);
            this.clearObject(bzMainRootObj);
        }
        if (bzInfoRootObj) {
            this.infoScene.remove(bzInfoRootObj);
            this.clearObject(bzInfoRootObj);
        }
    }
    /**
   * Removes a scene object and all its descendants freeing their resources
   * @param  {object} object
   */ clearObject(object) {
        //console.log('clear object', object)
        object.traverse(function(node) {
            if (node.geometry) node.geometry.dispose();
            if (node.material) node.material.dispose();
            if (node.texture) node.texture.dispose();
        });
        while(object.children.length){
            let child = object.children[0];
            object.remove(child);
        }
    }
}


/**
 * @author Iker Hurtado
 *
 * @fileOverview Utility file for the StructureViewer
 */ // import * as THREE from "../../lib/three.js"


function $f880bd393c028d36$export$f8cb66e0391a6d5f(vectors) {
    // units = Angstroms
    let result = [];
    for(let len = vectors.length, i = 0; i < len; ++i){
        let basis_vector = new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(vectors[i]); //.multiplyScalar(1.0e10);
        result.push(basis_vector);
    }
    return result;
}
function $f880bd393c028d36$export$50c66d05bd5d6956(vectors) {
    // units = Angstroms
    let centerVector = vectors[0].clone().add(vectors[1]).add(vectors[2]);
    return centerVector.divideScalar(-2);
}
function $f880bd393c028d36$export$e9b2b121b3b3f66f(center, atoms) {
    let max_distance = 0;
    atoms.forEach((atom)=>{
        let d = $a4310c0d7cebdf93$export$79376507b09a66f(atom.position, center);
        if (d > max_distance) max_distance = d;
    });
    //console.log('getMaxDistance', max_distance)
    return max_distance;
}
function $f880bd393c028d36$export$1ae190fb7acac5ec(atoms) {
    if (atoms.length === 0) throw Error("No atoms");
    let center = [
        0,
        0,
        0
    ];
    atoms.forEach((atom)=>{
        $a4310c0d7cebdf93$export$631162a40b148a0c(center, atom.position);
    });
    return $a4310c0d7cebdf93$export$67275f837d70084d(center, atoms.length);
}
function $f880bd393c028d36$export$2a1e684e74282069(pos1, pos2, radius, nSegments, material) {
    let direction = new $0d23c856ce11c301$export$64b5c384219d3699().subVectors(pos2, pos1);
    let dirLen = direction.length();
    let dirNorm = direction.clone().divideScalar(dirLen);
    let arrow = new $0d23c856ce11c301$export$a3008e7bd8d2cbe7(dirNorm, pos1);
    let edgeGeometry = new $0d23c856ce11c301$export$d4345c83207d7c68(radius, radius, dirLen, nSegments, 1);
    let edge = new $0d23c856ce11c301$export$e176487c05830cc5(edgeGeometry, material);
    edge.rotation.copy(arrow.rotation.clone());
    edge.position.copy(new $0d23c856ce11c301$export$64b5c384219d3699().addVectors(pos1, direction.multiplyScalar(0.5)));
    return edge;
}
function $f880bd393c028d36$export$8f7d98f7c012cca0(pos1, pos2, refLength, color = 0x000000) {
    let direction = new $0d23c856ce11c301$export$64b5c384219d3699().subVectors(pos2, pos1);
    let dirLen = direction.length();
    let dirNorm = direction.clone().divideScalar(dirLen);
    return new $0d23c856ce11c301$export$a3008e7bd8d2cbe7(dirNorm, pos1, dirLen + (refLength + 2) * 0.14, color, (refLength + 2) * 0.1, 0.1 + refLength * 0.025);
}
function $f880bd393c028d36$export$f2839682b8c07f35(label, color, position, minVectorLength) {
    // Configure canvas
    let canvas = document.createElement("canvas");
    const size = 256;
    canvas.width = size;
    canvas.height = size;
    let ctx = canvas.getContext("2d");
    // Draw label
    ctx.fillStyle = color;
    //ctx.fillStyle = "#ffffff";
    ctx.font = "155px Arimo";
    ctx.textAlign = "center";
    //if (stroked) {
    ctx.font = (minVectorLength < 10 ? 18 * minVectorLength : 180) + "px Arimo";
    ctx.lineWidth = minVectorLength < 5 ? 3 : 8;
    ctx.strokeStyle = "#000000";
    ctx.strokeText(label, size / 2, size / 2);
    //}
    ctx.fillText(label, size / 2, size / 2);
    let texture = new $0d23c856ce11c301$export$5431306cf43de24a(canvas);
    texture.needsUpdate = true;
    let sprite = new $0d23c856ce11c301$export$3075603db8e6204c(new $0d23c856ce11c301$export$5ec7dd1c6994bf8e({
        map: texture
    }));
    sprite.position.copy(position);
    sprite.scale.set(1.5, 1.5, 1);
    return sprite;
}



/**
 * @author Iker Hurtado
 *
 * @fileoverview File holding the application level State and constants
 */ /**
 * Specifies the possible changes for events
 * @todo This should be moved to the StructureBuilder module,
 *   the module is not singleton (application level) longer 
 *   so application level change definition doesn't make sense
 * @type {Object}
 */ const $1ad59a1a7edcd764$export$4bef51da9b53f613 = {
    STRUCTURE: {
        SUPERCELL: "structure.supercell",
        LATTICE_VECTORS: "structure.lattVector",
        SURFACE: "structure.surface",
        ATOM: {
            MOVE: "structure.atom.move",
            SPECIES: "structure.atom.species",
            INITMOMENT: "structure.atom.initMoment",
            CONSTRAINT: "structure.atom.constraint",
            CHARGE: "structure.atom.charge",
            ADD: "structure.atom.add",
            REMOVE: "structure.atom.remove"
        }
    }
};
const $1ad59a1a7edcd764$export$ec5856072852bd7f = {
    FHI_AIMS: "FHIaims",
    EXCITING: "Exciting"
};
// Application code state variable
let $1ad59a1a7edcd764$var$code = $1ad59a1a7edcd764$export$ec5856072852bd7f.FHI_AIMS; // Default code // 'Exciting'  
function $1ad59a1a7edcd764$export$9a0a9c75ccef13fb() {
    return $1ad59a1a7edcd764$var$code;
}
function $1ad59a1a7edcd764$export$5aaad33cfc28fe12() {
    return $1ad59a1a7edcd764$var$code === $1ad59a1a7edcd764$export$ec5856072852bd7f.EXCITING;
}
function $1ad59a1a7edcd764$export$fedf157424a060a8(c) {
    if (c === $1ad59a1a7edcd764$export$ec5856072852bd7f.FHI_AIMS || c === $1ad59a1a7edcd764$export$ec5856072852bd7f.EXCITING) {
        $1ad59a1a7edcd764$var$code = c;
        $1ad59a1a7edcd764$var$emitCodeChange($1ad59a1a7edcd764$var$code);
    } else error("Trying to set a wrong code");
}
// Code change listeners
const $1ad59a1a7edcd764$var$codeListeners = [];
function $1ad59a1a7edcd764$export$f9520e6df29a226e(component) {
    $1ad59a1a7edcd764$var$codeListeners.push(component);
}
/**
   * Emits a code change event
   * @param  {string} code
   */ function $1ad59a1a7edcd764$var$emitCodeChange(code) {
    //console.log('codeListeners', codeListeners)
    $1ad59a1a7edcd764$var$codeListeners.forEach((component)=>{
        component.updateForCode(code);
    });
}
// Settings change event listeners
const $1ad59a1a7edcd764$var$settingsListeners = [];
function $1ad59a1a7edcd764$export$b3488c6aaadba6a8(component) {
    $1ad59a1a7edcd764$var$settingsListeners.push(component);
}
function $1ad59a1a7edcd764$export$f558026a994b6051(newSettings) {
    // console.log('emitStructureChange', change)
    $1ad59a1a7edcd764$var$settingsListeners.forEach((component)=>{
        component.updateSettings(newSettings);
    });
}



/**
 * @author Iker Hurtado
 *
 * @overview File holding the InfoCanvas layer
 */ 
/**
 * @author Iker Hurtado
 *
 * @overview This file is a small and convenient 2D drawing library.
 * It uses the canvas browser API.
 * It's meant to be simple, efficient and customizable.
 * The DOS and BS graphs are based on it.
 */ /**
 * The Canvas class represents a html canvas and provides utilities to draw
 * and interact with simple geometrical elements (lines, circles, text, etc) 
 */ class $ecfc9827072e9972$export$2e2bcd8739ae039 {
    /**
   * @param {HTMLElement} hostElement - A DOM element can be given to host the 
   * canvas.
   * @param {string} idOrClass - An id or class for the canvas element
   */ constructor(hostElement, idOrClass){
        this.canvas = document.createElement("canvas");
        this.ctx = this.canvas.getContext("2d");
        // If hostElement -> 
        // it determines the graph size and is updated when it changes
        if (hostElement) {
            this.hostElement = hostElement;
            this.canvas.width = hostElement.clientWidth;
            this.canvas.height = hostElement.clientHeight;
            hostElement.appendChild(this.canvas);
        }
        if (idOrClass !== undefined) {
            if (idOrClass.startsWith("#")) this.canvas.id = idOrClass.substring(1);
            else this.canvas.className = idOrClass.substring(1);
        }
        this.scroll = 0; // Y scroll
        // Data structures
        this.elements = []; // All the elements to draw in the canvas
        // The elements (shapes) can be grouped
        this.groupMap = new Map(); // Map< group: string, elements: Array<Element> >
        this.groupMap.set("root", []); // Init -> the default group root is created
        // Event handling on the drawn elements
        this.beingHovered = undefined; // boolean, pointing to an element or undefined
        this.listenerMap = new Map(); // Map<eventType: string, listener: function>
        // mouse event listeners
        this.CLICK_ON_ELEMENT = "clickOnElement";
        this.HOVER_OVER_ELEMENT = "hoverOverElement";
        this.ENTER_ELEMENT = "enterElement";
        this.LEAVE_ELEMENT = "leaveElement";
        this.canvas.addEventListener("click", (e)=>{
            const element = this.getElement(e);
            if (element) {
                let listener = this.listenerMap.get(this.CLICK_ON_ELEMENT);
                if (listener) listener(element);
                this.clearAndDrawAll();
            }
        });
        this.canvas.addEventListener("mousemove", (e)=>{
            const element = this.getElement(e);
            if (element) {
                // Inside an element
                if (!this.beingHovered && this.cursor) // it comes from outside any element
                this.canvas.style.cursor = this.cursor;
                if (this.beingHovered !== element) {
                    // element change
                    this.beingHovered = element;
                    let listener = this.listenerMap.get(this.ENTER_ELEMENT);
                    if (listener) {
                        listener(element);
                        this.clearAndDrawAll();
                    }
                }
                let listener = this.listenerMap.get(this.HOVER_OVER_ELEMENT);
                if (listener) {
                    listener(element);
                    this.clearAndDrawAll();
                }
            } else // outside any element 
            if (this.beingHovered) {
                // it comes from an element
                if (this.cursor) this.canvas.style.cursor = "default";
                this.beingHovered = undefined;
                let listener = this.listenerMap.get(this.LEAVE_ELEMENT);
                if (listener) listener(element);
                this.clearAndDrawAll();
            }
        });
        // Hit region detection: underlying mechanism to support events on shapes
        this.hitCanvas = document.createElement("canvas");
        // Set the width and height seems necessary
        this.hitCanvas.width = this.canvas.width;
        this.hitCanvas.height = this.canvas.height;
        this.hitCtx = this.hitCanvas.getContext("2d");
        // Map associating an element to a color identifying it (random generation)
        this.hitMap = new Map(); // Map<color<string>, element<HTMLElement>> 
        window.addEventListener("resize", this.resize.bind(this), false);
    }
    /**
  * It returns an element that was hit by a mouse event
  * @param {MouseEvent} e - Event thrown on the element
  * @return {HTMLElement} Element hit by the interaction
  */ getElement(e) {
        const canvasPos = this.getPosition();
        const x = e.clientX - canvasPos.x;
        const y = e.clientY - canvasPos.y;
        const pixel = this.hitCtx.getImageData(x, y, 1, 1).data;
        return this.hitMap.get(`rgb(${pixel[0]},${pixel[1]},${pixel[2]})`);
    }
    /**
   * It returns the position of the canvas element
   * @return {object} X and Y coordinates of the canvas
   */ getPosition() {
        let xPosition = 0, yPosition = 0;
        let el = this.canvas;
        while(el){
            xPosition += el.offsetLeft - el.scrollLeft + el.clientLeft;
            yPosition += el.offsetTop - el.scrollTop + el.clientTop;
            el = el.offsetParent;
        }
        return {
            x: xPosition,
            y: yPosition - this.scroll
        }; // Y axis scroll
    }
    /**
   * It resizes the canvas element to its host element
   */ resize() {
        if (this.hostElement) {
            this.canvas.width = this.hostElement.clientWidth;
            this.canvas.height = this.hostElement.clientHeight;
            this.clearAndDrawAll();
        }
    }
    /**
   * It updates the vertical scroll figure
   * @param {number} scrollY - Current vertical scroll
   */ adaptToScroll(scrollY) {
        this.scroll = scrollY;
    }
    /**
   * It adds a group of elements. It must be explicitly created
   * @param {string} name - Group name (identifier)
   */ addGroup(name) {
        this.groupMap.set(name, []);
    }
    /**
   * It removes the elements belonging to a group
   * @param {string} name - Group name (identifier)
   */ removeGroupElements(name) {
        if (!this.groupMap.has(name)) return;
        this.groupMap.get(name).forEach((e)=>{
            this.elements.splice(this.elements.indexOf(e), 1);
        });
        this.groupMap.delete(name);
        this.groupMap.set(name, []);
    }
    /**
   * It adds a new element (shape) to the canvas
   * @param {string} type - Shape type
   * @param {object} data - Data defining the characteristics of the element
   * @param {string} group - Group name the element will belong to
   * @return {Element} The new element is returned
   */ addElement(type, data, group = "root") {
        let element;
        switch(type){
            case "line":
                element = new $ecfc9827072e9972$var$Line(data);
                break;
            case "polyline":
                element = new $ecfc9827072e9972$var$Polyline(data);
                break;
            case "circle":
                element = new $ecfc9827072e9972$var$Circle(data);
                break;
            case "rectangle":
                element = new $ecfc9827072e9972$var$Rectangle(data);
                break;
            case "text":
                element = new $ecfc9827072e9972$var$Text(data);
                break;
            case "image":
                element = new $ecfc9827072e9972$var$Bitmap(data);
                break;
        }
        // A color working like identifier for the element is generated
        // Caution: the color could repeat with very large number of elements
        const colorKey = getRandomColor();
        element.hitColor = colorKey;
        this.hitMap.set(colorKey, element);
        // The element is added to the general store and to a group
        element.type = type;
        this.groupMap.get(group).push(element);
        this.elements.push(element);
        return element;
        function getRandomColor() {
            const r = Math.round(Math.random() * 255);
            const g = Math.round(Math.random() * 255);
            const b = Math.round(Math.random() * 255);
            return `rgb(${r},${g},${b})`;
        }
    }
    /**
   * It removes an element (shape) from the canvas
   * @param {Element} element - Element to remove
   * @param {string} group - Group name the element belongs to
   */ removeElement(element, group = "root") {
        this.elements.splice(this.elements.indexOf(element), 1);
        let groupElements = this.groupMap.get(group);
        groupElements.splice(groupElements.indexOf(element), 1);
    }
    /**
   * It draws all the canvas elements
   */ drawAll() {
        this.elements.forEach((e)=>{
            e.draw(this.ctx, this.hitCtx);
        });
    }
    /**
   * First it clears the canvas and second it draws all the elements
   */ clearAndDrawAll() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.drawAll();
    }
    /**
   * It draws the elements in a group
   * @param {string} name - Group name
   */ drawGroup(name) {
        this.groupMap.get(name).forEach((e)=>{
            e.draw(this.ctx, this.hitCtx);
        });
    }
    /**
   * It resets the class data structures 
   */ reset() {
        this.elements = []; // All the elements to draw in the canvas
        this.groupMap = new Map();
        this.groupMap.set("root", []);
        this.beingHovered = undefined; // pointing to an element or undefined
        this.listenerMap = new Map();
        this.hitMap = new Map();
    }
    /**
   * It clears the canvas 
   */ clearCanvas() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * It fills the canvas with background color
   * @param {string} color - Color code
   */ fillCanvas(color) {
        this.ctx.save();
        this.ctx.fillStyle = color;
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.restore();
    }
    /**
   * It fills a canvas rectangle with color
   * @param {string} color - Color code
   * @param {number} x - top-left corner X coordinate of the rectangle
   * @param {number} y - top-left corner Y coordinate of the rectangle
   * @param {number} width - rectangle width
   * @param {number} height - rectangle height
   */ fillRect(color, x, y, width, height) {
        this.ctx.save();
        this.ctx.fillStyle = color;
        this.ctx.fillRect(x, y, width, height);
        this.ctx.restore();
    }
    /**
   * It sets an external listener for a type of event on elements
   * @param {string} type - Event type supported
   * @param {function} listener - Listener
   */ setEventListener(type, listener) {
        this.listenerMap.set(type, listener);
    }
    /**
   * It sets a css cursor to be shown when the mouse is hovering an element
   * @param {string} cssCursor - css cursor name
   */ setCursorOnElement(cssCursor) {
        this.cursor = cssCursor;
    }
}
/**
 * The Element class represents a shape on the canvas. It's a base class for 
 * the real elements (lines, circles, text, etc) to be drawn
 */ class $ecfc9827072e9972$var$Element {
    /**
   * @param {object} params - Object defining the shape characteristics 
   */ constructor(params){
        this.style = params.style; // this param is always
    }
    /**
   * This is the method called when the element is effectively drawn.
   * This is the common implementation. In addition, every specific instance can
   * add more code.
   * @param {CanvasRenderingContext2D} ctx - Canvas context
   * @param {CanvasRenderingContext2D} hitCtx - Canvas context for hit region detection
   */ draw(ctx, hitCtx) {
        ctx.save();
        if (this.style) {
            if (this.style.color) ctx.fillStyle = this.style.color;
            if (this.style.strokeColor) ctx.strokeStyle = this.style.strokeColor;
            if (this.style.strokeWidth) ctx.lineWidth = this.style.strokeWidth;
            if (this.style.dash) ctx.setLineDash([
                12,
                15
            ]);
        }
        // In case of stroke it's not used on the hit mask
        hitCtx.fillStyle = this.hitColor;
        // This must be implemented by the specific shape
        this._draw(ctx, hitCtx);
        ctx.restore();
    }
    /**
   * Abstract method that specifically does the drawing
   * @param {CanvasRenderingContext2D} ctx - Canvas context
   * @param {CanvasRenderingContext2D} hitCtx - Canvas context for hit region detection
   */ _draw(ctx, hitCtx) {}
}
/**
 * Simple line on the canvas. 
 * No hit region for lines, they don't respond to events
 */ class $ecfc9827072e9972$var$Line extends $ecfc9827072e9972$var$Element {
    /**
   * @param {object} params - Object defining the shape characteristics 
   */ constructor(params){
        super(params); // Common parameters: param.style
        // shape specific parameters
        this.coors = params.coors;
    }
    /**
   * This is a shape specific method called when the element is drawn.
   * It does the effective drawing
   * @param {CanvasRenderingContext2D} ctx - Canvas context
   * @param {CanvasRenderingContext2D} hitCtx - Canvas context for hit region detection
   */ _draw(ctx, hitCtx) {
        ctx.beginPath();
        ctx.moveTo(this.coors[0], this.coors[1]);
        for(let i = 2; i < this.coors.length;)ctx.lineTo(this.coors[i++], this.coors[i++]);
        ctx.stroke();
    // No hit region for lines
    }
}
/**
 * Polyline on the canvas. 
 * No hit region for polylines, they don't respond to events
 */ class $ecfc9827072e9972$var$Polyline extends $ecfc9827072e9972$var$Element {
    /**
   * @param {object} params - Object defining the shape characteristics 
   */ constructor(params){
        super(params); // Common parameters: param.style
        // shape specific parameters
        this.coors = params.coors;
        this.lines = params.lines;
    }
    /**
   * This is a shape specific method called when the element is drawn.
   * It does the effective drawing
   * @param {CanvasRenderingContext2D} ctx - Canvas context
   * @param {CanvasRenderingContext2D} hitCtx - Canvas context for hit region detection
   */ _draw(ctx, hitCtx) {
        ctx.beginPath();
        this.lines.forEach((line)=>{
            ctx.moveTo(line[0], line[1]);
            for(let i = 2; i < line.length;)ctx.lineTo(line[i++], line[i++]);
        });
        ctx.stroke();
    // No hit region for lines
    }
}
/**
 * Circle on the canvas. 
 */ class $ecfc9827072e9972$var$Circle extends $ecfc9827072e9972$var$Element {
    /**
   * @param {object} params - Object defining the shape characteristics 
   */ constructor(params){
        super(params); // Common parameters: param.style
        // shape specific parameters
        this.coors = params.coors;
        this.r = params.r;
        this.x = params.x;
        this.y = params.y;
    }
    /**
   * This is a shape specific method called when the element is drawn.
   * It does the effective drawing
   * @param {CanvasRenderingContext2D} ctx - Canvas context
   * @param {CanvasRenderingContext2D} hitCtx - Canvas context for hit region detection
   */ _draw(ctx, hitCtx) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.r, 0, 2 * Math.PI, true);
        ctx.closePath();
        ctx.fill();
        if (this.style.strokeColor) ctx.stroke();
        hitCtx.beginPath();
        hitCtx.arc(this.x, this.y, this.r, 0, 2 * Math.PI, true);
        hitCtx.closePath();
        hitCtx.fill();
    }
}
/**
 * Rectangle on the canvas. 
 */ class $ecfc9827072e9972$var$Rectangle extends $ecfc9827072e9972$var$Element {
    /**
   * @param {object} params - Object defining the shape characteristics 
   */ constructor(params){
        super(params); // Common parameters: param.style
        // shape specific parameters
        this.coors = params.coors;
        this.x = params.x;
        this.y = params.y;
        this.w = params.w;
        this.h = params.h;
    }
    /**
   * This is a shape specific method called when the element is drawn.
   * It does the effective drawing
   * @param {CanvasRenderingContext2D} ctx - Canvas context
   * @param {CanvasRenderingContext2D} hitCtx - Canvas context for hit region detection
   */ _draw(ctx, hitCtx) {
        ctx.beginPath();
        ctx.rect(this.x, this.y, this.w, this.h);
        ctx.fill();
        if (this.style.strokeColor) ctx.stroke();
        hitCtx.beginPath();
        hitCtx.rect(this.x, this.y, this.w, this.h);
        hitCtx.fill();
    }
}
/**
 * Text on the canvas. 
 * No hit region, the text doesn't respond to events
 */ class $ecfc9827072e9972$var$Text extends $ecfc9827072e9972$var$Element {
    /**
   * @param {object} params - Object defining the shape characteristics 
   */ constructor(params){
        super(params); // Common parameters: param.style
        // shape specific parameters
        this.coors = params.coors;
        this.text = params.text;
        this.x = params.x;
        this.y = params.y;
        this.boxWidth = undefined;
    }
    /**
   * This is a shape specific method called when the element is drawn.
   * It does the effective drawing
   * @param {CanvasRenderingContext2D} ctx - Canvas context
   * @param {CanvasRenderingContext2D} hitCtx - Canvas context for hit region detection
   */ _draw(ctx, hitCtx) {
        if (this.style) {
            // Text related styles
            if (this.style.font) ctx.font = this.style.font;
            if (this.style.align) ctx.textAlign = this.style.align;
            if (this.style.baseline) ctx.textBaseline = this.style.baseline;
        }
        this.boxWidth = ctx.measureText(this.text);
        if (this.style && this.style.rotation) {
            ctx.translate(this.x, this.y);
            ctx.rotate(this.style.rotation);
            ctx.fillText(this.text, 0, 0);
            ctx.resetTransform();
        } else ctx.fillText(this.text, this.x, this.y);
    }
}
/**
 * Bitmap on the canvas. 
 */ class $ecfc9827072e9972$var$Bitmap extends $ecfc9827072e9972$var$Element {
    /**
   * @param {object} params - Object defining the shape characteristics 
   */ constructor(params){
        super(params); // Common parameters: param.style
        // shape specific parameters
        this.coors = params.coors;
        this.img = params.img;
        this.x = params.x;
        this.y = params.y;
        this.w = params.w;
        this.h = params.h;
    }
    /**
   * This is a shape specific method called when the element is drawn.
   * It does the effective drawing
   * @param {CanvasRenderingContext2D} ctx - Canvas context
   * @param {CanvasRenderingContext2D} hitCtx - Canvas context for hit region detection
   */ draw(ctx, hitCtx) {
        // hitCtx not being used, only for real shapes
        ctx.drawImage(this.img, this.x, this.y, this.w, this.h);
        // The stroke is not used on the hit mask
        hitCtx.beginPath();
        hitCtx.rect(this.x, this.y, this.w, this.h);
        hitCtx.fillStyle = this.hitColor;
        hitCtx.fill();
    }
}


var $511a3383e0112616$exports = {};
$511a3383e0112616$exports = new URL("refresh-icon.009bc1af.png", import.meta.url).toString();


/**
 * @author Iker Hurtado
 *
 * @overview Utility file for the Output Analyzer module
 */ // import * as THREE from "../../lib/three.js"

/**
 * @author Sebastian Kokott, Iker Hurtado
 *
 * @overview File holding the OutputAims class
 */ /**
 * @author Sebastian Kokott,  Iker Hurtado
 *
 * @overview File holding the Output base class
 */ /**
 * Base class modeling a calculation output
 */ class $1b6ef0057aac13f5$export$2e2bcd8739ae039 {
    constructor(){
        // Object storing the output files
        this.files = {
            dos: new Map(),
            absorption: new Map(),
            dielectric: new Map(),
            output: new Map(),
            input: new Map()
        };
        // Set to true when it's filled up
        this.filledUp = false;
        this.inputs = {};
        // this.outputs = {}
        this.results = [];
        this.runTimeChoices = {
            "calculationType": "singlePoint",
            // 'singlePoint','relaxation'
            "spin": "none",
            // 'none','collinear'
            "hasForces": false,
            "isPeriodic": false,
            "hasStress": false,
            "outputLevel": "normal",
            // 'normal', 'MD_light'
            "hasSOC": false,
            "hasHirshfeld": false,
            "hasMulliken": false,
            "hasMBD": false
        };
        this.systemInformation = {
            "nAtoms": 0,
            "formulaUnit": undefined,
            "volume": undefined
        };
        this.controlIn = undefined;
        this.structureIn = undefined;
        this.errors = [];
        this.ksEv = undefined;
        this.workflows = [];
    }
    /**
   * Parses the all the calculation output files
   * @param  {Array<object>} filesData
   */ parseFiles(filesData) {}
    /**
   * Returns if it's filled up
   * @return {Boolean}
   */ isFilledUp() {
        return this.filledUp;
    }
    /**
   * Returns if the calculation is a relaxation
   * @return {boolean}
   */ isRelaxation() {
        return this.runTimeChoices.calculationType === "relaxation";
    }
    /**
   * Parses the main calculation output file.
   * If fileName is not passed in it, looks for the first one
   * @param  {string} fileName
   */ parseOutputFile(fileName) {}
    /**
   * Parses the main calculation output file.
   * @param  {string} fileName
   * @param  {string} fileText
   */ parseFile(fileName, fileText) {}
    /**
   * Returns the structure got from the geometry input file
   * @return {Structure}
   */ getStructure() {
        return this.structureIn;
    }
    /**
   * Returns the DOS data from the first file read
   * @return {object}
   */ getFirstFileDosData() {
        return this.files.dos.size > 0 ? this.files.dos.get(this.files.dos.keys().next().value) : undefined;
    }
    getBsInfo() {}
}






const $0aea1ecd202dfff9$var$floatRegex = /[-+]?[0-9]+[.][0-9]*([eE][-+]?[0-9]+)?/g;


class $0aea1ecd202dfff9$export$2e2bcd8739ae039 extends (0, $1b6ef0057aac13f5$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.inputs = {
            "controlIn": [],
            "geometryIn": []
        };
        this.output = {
            "body": [],
            "finale": []
        };
        this.output = {
            "body": [],
            "finale": []
        };
        // this.filesInOutput = {
        //   'hasControl':false,
        //   'hasGeometry':false,
        //   'hasBody':false,
        // }
        this.noSoc = false;
        this.isGW = false;
        // Band structure
        this.segmentsMap = new Map();
        this.bandNames = []; //  {bandZero: [], bandOne: [], bandThree: []}
    }
    /**
   * Parses the all the calculation output files
   * @param  {Array<object>} filesData
   */ async parseFiles(filesData) {
        // check for archives in the files; if there are, unpack them on the backend and continue as usual
        return new Promise((resolve)=>{
            if (filesData.length === 1 && filesData[0].type.includes("gzip")) prepareWorkflowOutputs(filesData[0]).then((data)=>resolve(this.#parse(data, true)));
            else resolve(this.#parse(filesData, false));
        });
        async function prepareWorkflowOutputs(fileData) {
            const response = await fetch("/upload-workflow", {
                method: "POST",
                body: fileData.content
            });
            if (!response.ok) {
                $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("Unknown server ERROR ");
                return;
            }
            const text = await response.text();
            return JSON.parse(text);
        }
    }
    /** Parses uploaded file data with respect to workflow
   *
   * @param filesData {Object[]} a content of the uploaded files
   * @param isWorkflow {boolean} a flag that is raised in the case of the workflow
   */ #parse(filesData, isWorkflow = false) {
        const path = (parcelRequire("gI0Ov"));
        filesData.forEach((fileData)=>{
            // For every file
            const fileName = fileData.name;
            const isBandFile = isWorkflow ? fileName.includes("/band") : fileName.startsWith("band");
            const isGWBandFile = isWorkflow ? fileName.includes("/GW_band") : fileName.startsWith("GW_band");
            if (isBandFile && fileName.endsWith(".out")) this.bandNames.push(fileName);
            if (isBandFile && fileName.endsWith(".no_soc")) {
                this.bandNames.push(fileName);
                this.noSoc = true;
            }
            if (isGWBandFile && fileName.endsWith(".out")) {
                this.isGW = true;
                this.bandNames.push(fileName);
            }
        });
        console.log(this.bandNames + ": no SOC - " + this.noSoc + ", is GW - " + this.isGW);
        filesData.forEach((fileData)=>{
            // For every file
            const fileName = fileData.name;
            // work with workflows
            let workflowIdx = undefined;
            if (isWorkflow) {
                let workflow = path.dirname(fileName);
                if (!this.workflows.includes(workflow)) this.workflows.push(workflow);
                workflowIdx = this.workflows.indexOf(workflow);
            }
            const isBandFile = isWorkflow ? fileName.includes("/band") : fileName.startsWith("band");
            const isGWBandFile = isWorkflow ? fileName.includes("/GW_band") : fileName.startsWith("GW_band");
            let lines = $4aa0937dc0e8c453$export$f197186eaead7b86(fileData.content); // fileData.content.replace(/[ \t]+/g, ' ').split('\n');
            if (fileName.match(/KS_DOS_total(_tetrahedron)?.dat/g) || fileName.match(/_proj_dos(_tetrahedron)?\.dat(\.no_soc)?/g) || fileName.match(/atom_proj(ected)?_dos(_tetrahedron)?_[A-Z][a-z]?[0-9]{4}\.dat(\.no_soc)?/g)) {
                this.files.dos.set(fileName, getTabulatedDataFHIAims(lines));
                //console.log(this.files.dos)
                this.filledUp = true;
            } else if (fileName.match(/_proj_dos(_tetrahedron)?_spin_(up|dn)\.dat(\.no_soc)?/g)) {
                // Some more sorting is needed for species-projected DOS with spin.
                let altFileName = fileName.replace("_spin_up", "").replace("_spin_dn", "");
                if (this.files.dos.has(altFileName)) {
                    let data = this.files.dos.get(altFileName);
                    let dataNew = getTabulatedDataFHIAims(lines);
                    dataNew.forEach((line, i)=>{
                        if (fileName.includes("spin_up")) data[i][1] = line[1];
                        else data[i][2] = line[1];
                    });
                } else {
                    let data = [];
                    getTabulatedDataFHIAims(lines).forEach((line)=>{
                        if (fileName.includes("spin_up")) data.push([
                            line[0],
                            line[1],
                            0.0
                        ]);
                        else data.push([
                            line[0],
                            0.0,
                            line[1]
                        ]);
                    });
                    // console.log(data);
                    this.files.dos.set(altFileName, data);
                }
                this.filledUp = true;
                this.runTimeChoices.hasSpin = true;
            } else if (fileName.match(/absorption(_soc)?(_Lorentzian)?(_Tetrahedron)?_[0-9].[0-9]{4}(_x_x)?(_y_y)?(_z_z)?.out/g)) {
                this.files.absorption.set(fileName, getTabulatedDataFHIAims(lines));
                // console.log('in if absorption')
                this.filledUp = true;
            } else if (fileName.match(/dielectric_function(_soc)?(_Lorentzian)?(_Tetrahedron)?_[0-9].[0-9]{4}(_x_x)?(_y_y)?(_z_z)?(_x_y)?(_x_z)?(_y_z)?.out/g)) {
                this.files.dielectric.set(fileName, getTabulatedDataFHIAims(lines));
                // console.log('in if absorption')
                this.filledUp = true;
            } else if ((isBandFile || isGWBandFile) && fileName.includes(".out")) {
                addBSFileData(fileName, this.segmentsMap, lines, isGWBandFile, workflowIdx); //, this.bandName)
                this.filledUp = true;
            } else if (fileName.includes("control.in")) {
                this.files.input.set(fileName, fileData.content);
                this.controlIn = lines;
            // this.filledUp = true
            } else if (fileName.includes("geometry.in")) this.files.input.set(fileName, fileData.content);
            else if (fileData.content.includes("Invoking FHI-aims ...")) {
                this.files.output.set(fileName, fileData.content);
                this.filledUp = true;
            }
        });
        return this;
        // inner method functions
        function getTabulatedDataFHIAims(lines) {
            let data = [];
            let l = 0;
            lines.forEach((line)=>{
                if (!line.includes("#") && line.length > 1) {
                    let a = line.trim().split(" ");
                    for(let i = 0; i < a.length; i++)a[i] = parseFloat(a[i]);
                    data.push(a);
                }
                l++;
            });
            return data;
        }
        /**
     *
     * @param fullFileName {string}
     * @param segmentsMap {Map<string, {}>}
     * @param lines
     * @param isGW {boolean}
     * @param index {number}
     */ function addBSFileData(fullFileName, segmentsMap, lines, isGW, index) {
            const path = (parcelRequire("gI0Ov"));
            let fileName = path.basename(fullFileName);
            let segmentNumInd = [
                5,
                8
            ];
            let spinIndexInd = 4;
            // console.log(isGW);
            if (isGW === true) {
                segmentNumInd = [
                    8,
                    11
                ];
                spinIndexInd = 7;
            }
            let segmentNum = fileName.substring(segmentNumInd[0], segmentNumInd[1]);
            let spinIndex = 0;
            if (index === undefined) {
                if (fileName.endsWith(".no_soc")) spinIndex = parseInt(fileName.charAt(spinIndexInd));
                else if (fileName.endsWith(".out")) spinIndex = parseInt(fileName.charAt(spinIndexInd)) - 1;
            } else spinIndex = index;
            let segmentData;
            if (segmentsMap.has(segmentNum)) segmentData = segmentsMap.get(segmentNum);
            else {
                segmentData = {
                    segment_num: parseInt(segmentNum),
                    band_k_points: [],
                    band_energies: [
                        [],
                        [],
                        []
                    ],
                    bsName: [
                        [],
                        [],
                        []
                    ],
                    segmentName: [
                        [],
                        [],
                        []
                    ]
                };
                segmentsMap.set(segmentNum, segmentData);
            }
            let fileNameToken = fileName.substring(0, segmentNumInd[0]) + "***" + fileName.substring(segmentNumInd[1]);
            segmentData.bsName[spinIndex].push(fileNameToken);
            segmentData.segmentName[spinIndex].push(fileName);
            // fill band_k_points only once
            let k_point_flag = undefined;
            if (segmentData.band_k_points.length === 0) k_point_flag = spinIndex;
            lines.forEach((line)=>{
                if (line.length > 1) {
                    let a = line.trim().split(" ");
                    for(let i = 0; i < a.length; i++)a[i] = parseFloat(a[i]);
                    if (spinIndex === k_point_flag) segmentData.band_k_points.push(a.slice(1, 4));
                    segmentData.band_energies[spinIndex].push(a.slice(4).filter((e, i)=>{
                        return i % 2 === 1;
                    }));
                // For the future:a.slice(4).filter( (e, i) => {return i%2 === 0} ) occupation number and is the number of electrons occupying the corresponding state.
                }
            });
        }
    }
    /**
   * Returns an object with all the band structure info to plot it
   * @return {object}
   */ getBsInfo() {
        if (!this.bsInfo) {
            if (this.controlIn) this.bsInfo = this.findLackingSegments(this.controlIn, this.segmentsMap);
            else this.bsInfo = this.findLackingSegments(undefined, this.segmentsMap);
        }
        this.bsInfo.hasSpin = this.runTimeChoices.spin === "collinear";
        this.bsInfo.hasSOC = this.runTimeChoices.hasSOC;
        return this.bsInfo;
    }
    /**
   * Returns an object with all the band structure info to plot it
   * @return {object}
   */ // bandNamesCarrier(){
    //   return this.bandNames
    // }
    /**
   * Parses the main calculation output file.
   * If fileName is not passed in it, looks for the first one
   * @param  {string} fileName
   */ parseOutputFile(fileName) {
        if (this.files.output.size === 0) return;
        let controlInLines = this.controlIn; // It can be undefined
        if (!fileName) fileName = this.files.output.keys().next().value;
        //this.parseFile(fileName)
        const fileText = this.files.output.get(fileName);
        this.parseFile(fileName, fileText);
        if (!controlInLines) controlInLines = this.inputs.controlIn;
        // console.log('controlInLines',controlInLines);
        // Postprocessing the bs data
        this.bsInfo = this.findLackingSegments(controlInLines, this.segmentsMap);
    }
    /**
   * Finds out the band structure lacking segments
   * @param  {Array<string>} controlIn
   * @param  {Map<string, object>} segmentsMap
   * @return {object}
   */ findLackingSegments(controlIn, segmentsMap) {
        let lackingSegments = []; // array storing the lacking segment files
        const bsData = [];
        // The segments labels are added to the BS segment info
        if (controlIn) lackingSegments = addSegmentLabelsToBS(controlIn, segmentsMap);
        // The segment info is sorted and stored by the segment number (coded in file name)
        let segmentNums = [
            ...segmentsMap.keys()
        ].sort();
        segmentNums.forEach((segmentNum)=>bsData.push(segmentsMap.get(segmentNum)));
        // Try to find missing files if there wasn't control.in info
        if (lackingSegments.length === 0) {
            let maxNum = parseInt(segmentNums[segmentNums.length - 1]);
            for(let i = 1; i < maxNum; i++){
                const code = getFileCodeFromNumber(i);
                if (!segmentNums.includes(code)) lackingSegments.push(code);
            }
        }
        return {
            lackingSegments: lackingSegments,
            bsData: bsData
        };
        // inner functions
        function addSegmentLabelsToBS(lines, segmentsMap) {
            let segmentsLabels = [];
            let lackingSegments = [];
            lines.forEach((line)=>{
                let a = line.trim().replace(/[ \t]+/g, " ").split(" ");
                if (a[0] === "output" && a[1] === "band") segmentsLabels.push(a.slice(-2));
            }); //log('segmentsLabels', segmentsLabels)
            for(let i = 0; i < segmentsLabels.length; i++){
                let key = getFileCodeFromNumber(i + 1);
                if (segmentsMap.has(key)) segmentsMap.get(key).band_segm_labels = segmentsLabels[i];
                else lackingSegments.push(key);
            }
            return lackingSegments;
        }
        function getFileCodeFromNumber(n) {
            return n < 10 ? "00" + n : "0" + n;
        }
    }
    /**
   * Parses the main calculation output file.
   * @param  {string} fileName
   * @param  {string} fileText
   */ parseFile(fileName, fileText) {
        // this.parseFileAndInit(fileName, fileText)
        // this.getRunTimeChoices()
        this.normalParser(fileText);
        this.ksEv = this.getKsEv(fileText);
        // console.log(this.errors);
        this.getDataSeries();
        if (this.runTimeChoices.calculationType === "relaxation") this.getRelaxationSeries();
    // this.grepResults()
    }
    /**
   * Gathers and stores the data series for the convergence graph
   */ getDataSeries() {
        // convergence accuracy
        let dataSeries = [];
        this.scfLoops.forEach((loop)=>{
            // console.log(loop.iterations);
            // if (loop.iterations) console.log(loop.iteration);
            let hasIter = loop.iterations ? loop.iterations.length > 0 : false;
            // console.log('hasIter',hasIter);
            if (hasIter) {
                let dataSeriesIteration = {
                    "eigenvalues": {
                        "label": "Change of Eigenvalues",
                        "color": "rgb(0,157,220)",
                        "data": []
                    },
                    "totalEnergy": {
                        "label": "Change of Total Energy",
                        "color": "rgb(242,100,48)",
                        "data": []
                    }
                };
                if (this.runTimeChoices.spin === "collinear") {
                    dataSeriesIteration["chargeDensityUp"] = {
                        "label": "Change of Charge Density",
                        "color": "rgb(42,45,52)",
                        "data": []
                    };
                    dataSeriesIteration["chargeDensityDown"] = {
                        "label": "Change of Spin Density",
                        "color": "rgb(84,45,52)",
                        "data": []
                    };
                } else dataSeriesIteration["chargeDensity"] = {
                    "label": "Change of Charge Density",
                    "color": "rgb(42,45,52)",
                    "data": []
                };
                loop.iterations.forEach((iteration)=>{
                    for (let [key, entry] of Object.entries(dataSeriesIteration))// console.log(key, entry);
                    entry["data"].push(iteration.convergenceAccuracy[key]);
                });
                dataSeries.push(dataSeriesIteration);
            }
        });
        // console.log(dataSeries);
        this.dataSeries = dataSeries;
    }
    /**
   * Gathers and stores the data series for the relaxation graph
   */ getRelaxationSeries() {
        let iters = [], dataI = [], forceI = [], dEnd = 0.0;
        let i = 0;
        this.scfLoops.forEach((loop)=>{
            i += 1;
            if (loop.isConverged) {
                iters.push(i);
                dEnd = loop["finalScfEnergies"]["totalEnergy"];
                dataI.push(loop["finalScfEnergies"]["totalEnergy"]);
                forceI.push(loop["maxForceComponent"]);
            }
        });
        this.relaxationSeries = {
            "labels": iters,
            "energy": {
                "label": "Total Energy",
                "data": dataI.map(function(value) {
                    return Math.abs(value - dEnd);
                }),
                "yAxisID": "yscenergy",
                "fill": false,
                "borderColor": "rgb(42,45,52)",
                "lineTension": 0.1
            },
            "forces": {
                "label": "Maximum Force Component",
                "data": forceI.map(Math.abs),
                "yAxisID": "ymaxforce",
                "fill": false,
                "borderColor": "rgb(0,157,220)",
                "lineTension": 0.1
            }
        };
    }
    /**
   * Returns the structure got from the geometry input file
   * @return {Structure}
   */ getStructure() {
        let geometryInText;
        if (this.inputs.geometryIn.length > 0) geometryInText = (0, $ab6e98e8f37dab02$export$2b060aca926f9411)(this.inputs.geometryIn);
        else if (this.files.input.get("geometry.in")) geometryInText = this.files.input.get("geometry.in");
        // console.log(geometryInText);
        let structure;
        if (geometryInText) structure = $4aa0937dc0e8c453$export$8016125d6df85b19("geometry.in", geometryInText);
        // console.log(structure);
        return structure;
    }
    /**
   * Returns the main quantities of the calculation results to be shown
   * @return {Map<string,object>}
   */ getResultsQuantities() {
        const quantities = new Map();
        // find last converged scf loop
        let lastConverged = -1;
        this.scfLoops.forEach((loop)=>{
            if (loop.isConverged) lastConverged += 1;
        });
        if (lastConverged >= 0) {
            const lastLoop = this.scfLoops[lastConverged];
            // console.log(lastLoop);
            const lastIter = lastLoop["iterations"][lastLoop["iterations"].length - 1];
            quantities.set("Total Energy (eV)", lastLoop.finalScfEnergies.totalEnergy);
            for (const entry of Object.values(lastIter["electronInfo"]))quantities.set(entry.info, entry.value);
            if (this.runTimeChoices.isPeriodic) quantities.set("Cell Volume (&#197;<sup>3</sup>)", (0, $ab6e98e8f37dab02$export$a11cb81344d466f0)(this.structureIn.latVectors));
            if (this.runTimeChoices.calculationType === "relaxation") {
                const finalStructureText = (0, $ab6e98e8f37dab02$export$17ae15ab1332eec2)(lastLoop.structure);
                let href = window.URL.createObjectURL(new Blob([
                    finalStructureText
                ], {
                    type: "text/plain"
                }));
                quantities.set("download-link", href);
            }
        }
        return quantities;
    }
    /**
   * Returns summary calculation information
   * @return {Map<string,object>}
   */ getCalculationInfo() {
        const quantities = new Map();
        // console.log(this.calculationInfo, this.finalTimings, this.memory, this.exitMode);
        let infoObjects = [
            this.calculationInfo,
            this.finalTimings,
            this.memory,
            this.exitMode
        ];
        infoObjects.forEach((infoObject)=>{
            if (infoObject !== undefined) for (const entry of Object.values(infoObject))quantities.set(entry.info, entry.value);
        });
        return quantities;
    }
    /**
   * Returns a map of the input files
   * @return {Map<string,string>}
   */ getInputFilesMap() {
        const inputFilesMap = new Map();
        if (this.inputs.geometryIn.length > 0) inputFilesMap.set("geometry.in", (0, $ab6e98e8f37dab02$export$2b060aca926f9411)(this.inputs.geometryIn));
        if (this.inputs.controlIn.length > 0) inputFilesMap.set("control.in", (0, $ab6e98e8f37dab02$export$2b060aca926f9411)(this.inputs.controlIn));
        this.files.input.forEach((content, name)=>{
            if (!inputFilesMap.has(name)) inputFilesMap.set(name, content);
        });
        return inputFilesMap;
    }
    /**
   * Gathers and stores the calculation runtime choices
   */ getRunTimeChoices() {
        let rtc = this.runTimeChoices;
        this.inputs.controlIn.forEach((line)=>{
            let trim_line = line.trim();
            if (trim_line.indexOf("relax_geometry") === 0) {
                rtc.calculationType = "relaxation";
                rtc.hasForces = true;
            }
            if (trim_line.indexOf("spin") === 0 && trim_line.indexOf("collinear") > 0) rtc.spin = "collinear";
            if (trim_line.indexOf("output_level") === 0 && trim_line.indexOf("MD_light") > 0) rtc.outputLevel = "MD_light";
            if (trim_line.indexOf("k_grid") === 0) rtc.isPeriodic = true;
            if (trim_line.indexOf("relax_unit_cell") === 0) rtc.hasStress = true;
            if (trim_line.indexOf("include_spin_orbit") === 0) rtc.hasSOC = true;
            if (trim_line.indexOf("output") === 0 && trim_line.indexOf("hirshfeld") > 0) rtc.hasHirshfeld = true;
            if (trim_line.indexOf("many_body_dispersion") === 0) rtc.hasMBD = true;
            if (trim_line.indexOf("output") === 0 && trim_line.indexOf("mulliken") > 0) rtc.hasMulliken = true;
        });
    }
    /**
   * @param  {string} fileText
   */ getKsEv(fileText) {
        let ksEv = [];
        let lines = fileText.split("\n");
        let foundKsEv = false;
        let spinCollinear = false;
        let lineLength = 0;
        lines.forEach((line)=>{
            if (line.includes("spin") && line.includes("collinear")) spinCollinear = true;
            if (line.includes("State") && line.includes("Occupation") && line.includes("Eigenvalue") && !spinCollinear) {
                ksEv = [];
                foundKsEv = true;
                lineLength = line.length;
            } else if (spinCollinear && line.includes("Spin-up") && line.includes("eigenvalues:")) ksEv = [];
            if (line.includes("State") && line.includes("Occupation") && line.includes("Eigenvalue") && spinCollinear) {
                foundKsEv = true;
                lineLength = line.length;
            } else if (foundKsEv && line.length > 0) {
                let a = line.trim().split(" ").filter(Number);
                for(let i = 0; i < a.length; i++)a[i] = parseFloat(a[i]);
                //console.log('ksEv')
                //console.log(a[3])
                if (a[3]) ksEv.push([
                    a[0],
                    a[1],
                    a[3]
                ]);
                else if (!a[3]) ksEv.push([
                    a[0],
                    0.000,
                    a[2]
                ]);
            } else if (foundKsEv && line.length === 0) foundKsEv = false;
        });
        return ksEv;
    }
    /**
   * Parses the main output file
   * @param  {string} fileText
   */ normalParser(fileText) {
        function* linesIterator(lines) {
            for(let i in lines)yield lines[i];
        }
        let parseUntil = (regExs, stopRe)=>{
            let lines = [];
            let line = lineIt.next();
            if (line === undefined) return undefined;
            while(!line.done){
                regExs.forEach((re)=>{
                    if (line.value.match(re)) lines.push(line.value);
                });
                if (line.value.match(stopRe)) return lines;
                line = lineIt.next();
            }
            this.errors.push([
                "Reached end of file before finding",
                stopRe.toString()
            ]);
            return undefined; // Should only happen if we stop before
        };
        let waitFor = (waitRe)=>{
            let line = lineIt.next();
            if (line === undefined) return undefined;
            while(!line.done){
                if (line.value.match(waitRe)) return line;
                line = lineIt.next();
            }
            this.errors.push([
                "Did not find the following expression",
                waitRe.toString()
            ]);
            return undefined;
        };
        let checkForUntil = (checkRe, stopRe)=>{
            let line = lineIt.next();
            // console.log(line);
            while(!line.done){
                if (line.value.match(checkRe)) return true;
                else if (line.value.match(stopRe)) return false;
                line = lineIt.next();
            }
            this.errors.push([
                "Reached end of file before finding",
                stopRe.toString()
            ]);
            return undefined;
        };
        let matchNextLine = (regex)=>{
            let line = lineIt.next();
            return line.value.match(regex);
        };
        let getLinesInBetween = (startRe, stopRe)=>{
            let lines = [];
            waitFor(startRe);
            let line = lineIt.next();
            if (line === undefined) return undefined;
            while(!line.done){
                if (line.value.match(stopRe)) return lines;
                lines.push(line.value);
                line = lineIt.next();
            }
            this.errors.push([
                "Reached end of file before finding",
                stopRe
            ]);
            return lines; // Should only happen if we stop before
        };
        function parseSCFEnergies() {
            let energyRegex = [
                [
                    /Sum of eigenvalues/g,
                    "sumEigenvalues"
                ],
                [
                    /XC energy correct/g,
                    "XCenergyCorrection"
                ],
                [
                    /XC potential correct/g,
                    "XCpotentialCorrection"
                ],
                [
                    /Free-atom electrostatic energy/g,
                    "freeAtomElStat"
                ],
                [
                    /Hartree energy correct/g,
                    "hartreeEnergyCorrection"
                ],
                [
                    /Entropy correct/g,
                    "entropyCorrection"
                ],
                [
                    /Total energy\s/g,
                    "totalEnergy"
                ],
                [
                    /Total energy, T\s/g,
                    "totalEnergyCorrected"
                ]
            ];
            let scfEnergies = {};
            let line = waitFor(/Total energy components:/g);
            if (line === undefined) return undefined;
            energyRegex.forEach((re)=>{
                line = waitFor(re[0]);
                let reMatch;
                if (line) {
                    let m = line.value.match($0aea1ecd202dfff9$var$floatRegex);
                    if (m && m.length === 2) {
                        reMatch = m[1];
                        scfEnergies[re[1]] = parseFloat(reMatch);
                    }
                }
            });
            if (Object.keys(scfEnergies).length === 8) return {
                "scfEnergies": scfEnergies
            };
            else return undefined;
        }
        function parseConvAcc(runTimeChoices) {
            let convAcc = {};
            let line = waitFor(/Self-consistency convergence accuracy:/g);
            if (line === undefined) return undefined;
            line = waitFor(/\| Change of charge/g);
            if (runTimeChoices.spin === "collinear") {
                convAcc["chargeDensityUp"] = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex)[0]);
                convAcc["chargeDensityDown"] = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex)[1]);
            } else convAcc["chargeDensity"] = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            line = waitFor(/\| Change of sum of eigenvalues/g);
            convAcc["eigenvalues"] = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            line = waitFor(/\| Change of total energy/g);
            convAcc["totalEnergy"] = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            return {
                "convergenceAccuracy": convAcc
            };
        }
        function getElectronInfo(runTimeChoices) {
            let electronInfo = {};
            if (runTimeChoices.outputLevel === "normal") {
                let line = waitFor(/\| Chemical potential/g);
                if (line === undefined) return undefined;
                electronInfo["fermiEnergy"] = {
                    "value": parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex)),
                    "info": "Fermi Energy (eV)"
                };
            }
            let line = waitFor(/Highest occupied state|Reaching maximum number/g);
            if (line === undefined) return undefined;
            if (line.value.includes("Reached maximum number")) return {};
            let state = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            line = waitFor(/\| Occupation number:/g);
            if (line === undefined) return undefined;
            let occNumber = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            electronInfo["highestOccState"] = {
                "value": state,
                "info": "Highest occupied state (eV)",
                "occNumber": occNumber
            };
            line = waitFor(/Lowest unoccupied state/g);
            if (line === undefined) return undefined;
            state = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            line = waitFor(/\| Occupation number:/g);
            occNumber = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            electronInfo["lowestUnOccState"] = {
                "value": state,
                "info": "Lowest unoccupied state (eV)",
                "occNumber": occNumber
            };
            line = waitFor(/verall HOMO-LUMO gap:/g);
            if (line === undefined) return undefined;
            let gap = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            electronInfo["gap"] = {
                "value": gap,
                "info": "Estimated HOMO-LUMO gap (eV)"
            };
            return {
                "electronInfo": electronInfo
            };
        }
        function getIteration(runTimeChoices) {
            let iteration = {};
            let isConverged = false;
            let line = waitFor("Begin self-consistency iteration|SELF-CONSISTENCY CYCLE DID NOT CONVERGE");
            if (line === undefined) return [
                undefined,
                undefined
            ];
            if (line.value.indexOf("DID NOT CONVERGE") > 0) return [
                false,
                undefined
            ];
            if (line.value) {
                let electronInfo = getElectronInfo(runTimeChoices);
                let scfEnergies = parseSCFEnergies();
                let convAcc = parseConvAcc(runTimeChoices);
                if (electronInfo === undefined || scfEnergies === undefined || convAcc === undefined) iteration = undefined;
                else iteration = {
                    ...scfEnergies,
                    ...convAcc,
                    ...electronInfo
                };
                isConverged = checkForUntil("Self-consistency cycle converged", "End self-consistency iteration");
            }
            return [
                isConverged,
                iteration
            ];
        }
        function getScfCycle(runTimeChoices) {
            let scfCycle = {
                "structure": currentGeometry,
                //Object.assign({},currentGeometry),
                "iterations": [],
                "isConverged": false
            };
            let isConverged = false;
            let iteration = {};
            while(!isConverged && isConverged === false){
                [isConverged, iteration] = getIteration(runTimeChoices);
                if (iteration) scfCycle["iterations"].push(iteration);
                else return scfCycle;
            }
            scfCycle["isConverged"] = isConverged === undefined ? false : isConverged;
            return scfCycle;
        }
        function getScfCycleMDLight(runTimeChoices) {
            let scfCycle = {
                "structure": currentGeometry,
                //Object.assign({},currentGeometry),
                "iterations": [],
                "isConverged": false
            };
            let isEnd = false;
            let iter = -1;
            let line = waitFor(/Convergence:/g);
            if (line === undefined) return [
                undefined,
                undefined
            ];
            while(!isEnd){
                // console.log("Calling getIteration");
                let m = matchNextLine($0aea1ecd202dfff9$var$floatRegex);
                // console.log(m);
                if (m) {
                    let iteration = {};
                    if (runTimeChoices.spin === "collinear" && m.length >= 5) {
                        iteration["convergenceAccuracy"] = {
                            "chargeDensityUp": m[1],
                            "chargeDensityDown": m[2],
                            "eigenvalues": m[3],
                            "totalEnergy": m[4]
                        };
                        scfCycle.iterations.push(iteration);
                        iter += 1;
                    } else if (runTimeChoices.spin === "none" && m.length >= 4) {
                        // console.log(m,m.length);
                        iteration["convergenceAccuracy"] = {
                            "chargeDensity": m[1],
                            "eigenvalues": m[2],
                            "totalEnergy": m[3]
                        };
                        scfCycle.iterations.push(iteration);
                        iter += 1;
                    } else isEnd = true; // Something went wrong
                } else isEnd = true;
            }
            let scfEnergies = parseSCFEnergies();
            scfCycle.iterations[iter]["scfEnergies"] = scfEnergies["scfEnergies"];
            let electronInfo = getElectronInfo(runTimeChoices);
            scfCycle.iterations[iter]["electronInfo"] = electronInfo["electronInfo"];
            let isConverged = checkForUntil("Self-consistency cycle converged", "End self-consistency iteration|Reaching maximum number of scf iterations");
            scfCycle["isConverged"] = isConverged === undefined ? false : isConverged;
            return scfCycle;
        }
        function getGeoFromLines(geoLines) {
            let geo = new (0, $495a3b82f25facb5$export$2e2bcd8739ae039)();
            let hasCartesian = false;
            // console.log(geoLines.length);
            geoLines.forEach((line)=>{
                // console.log(line)
                if (line.match(/^[\s\t]*atom[\s\t]+/g)) {
                    let [_, __, x, y, z, species] = line.split(/[\s\t]+/);
                    geo.addAtomData([
                        parseFloat(x),
                        parseFloat(y),
                        parseFloat(z)
                    ], species.trim());
                    hasCartesian = true;
                } else if (line.match(/^[\s\t]*atom_frac[\s\t]+/g) && !hasCartesian) {
                    let [_, __, x, y, z, species] = line.split(/[\s\t]+/);
                    geo.addAtomData([
                        parseFloat(x),
                        parseFloat(y),
                        parseFloat(z)
                    ], species.trim(), true);
                } else if (line.match(/^[\s\t]*lattice_vector[\s\t]+/g)) {
                    if (geo.latVectors === undefined) geo.latVectors = [];
                    let [_, __, x, y, z] = line.split(/[\s\t]+/);
                    geo.latVectors.push([
                        parseFloat(x),
                        parseFloat(y),
                        parseFloat(z)
                    ]);
                }
            });
            // console.log(geo);
            return geo;
        }
        let getInitialGeometry = ()=>{
            let geoLines = this.inputs.geometryIn;
            let geo = getGeoFromLines(geoLines);
            this.systemInformation.nAtoms = geo.atoms.length;
            this.systemInformation.formulaUnit = getFormulaUnit(geo);
            return geo;
        };
        let getFormulaUnit = (structure)=>{
            let species = {};
            structure.atoms.forEach((atom)=>{
                let sp = atom.species;
                species[sp] === undefined ? species[sp] = 1 : ++species[sp];
            });
            let formulaUnit = ""; // formula unit
            for(let key in species){
                let num = species[key];
                formulaUnit += num === 1 ? key : key + num.toString();
            }
            return formulaUnit;
        };
        let parseUpdatedGeo = ()=>{
            const oldGeo = currentGeometry;
            let line = waitFor(/Geometry optimization: Attempting to predict improved coordinates\./g);
            if (line === undefined) return undefined;
            line = waitFor(/Maximum force component/g);
            const maxForceComponent = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            line = waitFor(/Present geometry is/g);
            if (line.value.includes("not yet converged.")) {
                line = waitFor(/Updated atomic structure:/g);
                if (line === undefined) return undefined;
                let geoLines = parseUntil([
                    /atom\s+/g,
                    /lattice_vector\s+/g
                ], /---------/g);
                // console.log(geoLines);
                return {
                    force: maxForceComponent,
                    geo: getGeoFromLines(geoLines)
                };
            } else {
                line = waitFor(/Final atomic structure:/g);
                if (line === undefined) return undefined;
                // line = lineIt.next()
                // this.finalGeoLines = parseUntil([/atom\s+/g,/lattice_vector\s+/g],/---------/g)
                return {
                    force: maxForceComponent,
                    geo: oldGeo
                };
            }
        };
        function getMullikenPop(soc = false) {
            let line;
            let mullikenCharge = {};
            if (soc) {
                line = waitFor(/Performing scalar-relativistic Mulliken charge analysis/g);
                if (line === undefined) return undefined;
                mullikenCharge["sr"] = readMulliken();
                line = waitFor(/Performing spin-orbit-coupled Mulliken charge analysis/g);
                if (line === undefined) return undefined;
                mullikenCharge["soc"] = readMulliken();
            } else {
                line = waitFor(/Performing Mulliken charge analysis on all atoms/g);
                if (line === undefined) return undefined;
                mullikenCharge["simple"] = readMulliken();
            }
            return mullikenCharge;
        }
        let readMulliken = ()=>{
            let charge = [];
            waitFor(/\| *atom/g);
            let line = lineIt.next();
            // read next nAtoms lines
            for(let i = 0; i < this.systemInformation.nAtoms; i++){
                let match = line.value.match($0aea1ecd202dfff9$var$floatRegex);
                charge.push(parseFloat(match[1]));
                line = lineIt.next();
            }
            return charge;
        };
        let getHirshfeldPop = ()=>{
            let hirshfeldCharge = [];
            waitFor(/Performing Hirshfeld analysis/g);
            for(let i = 0; i < this.systemInformation.nAtoms; i++){
                let line = waitFor(/Hirshfeld charge/g);
                if (line === undefined) return undefined;
                hirshfeldCharge.push(parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex)));
            }
            return hirshfeldCharge;
        };
        let getFinalScfEnergiesForces = ()=>{
            let finalEnergies = {};
            let forces = [];
            let maxForceComponent = undefined;
            let line = waitFor(/Energy and forces in a compact form/g);
            if (line === undefined) return undefined;
            line = lineIt.next();
            finalEnergies["totalEnergy"] = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            line = lineIt.next();
            finalEnergies["totalEnergyCorrected"] = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            line = lineIt.next();
            finalEnergies["electronicFreeEnergy"] = parseFloat(line.value.match($0aea1ecd202dfff9$var$floatRegex));
            // console.log(this.runTimeChoices.hasForces);
            // console.log(line);
            if (this.runTimeChoices.hasForces) {
                line = waitFor(/Total atomic forces/g);
                // console.log(line);
                // console.log(this.systemInformation.nAtoms);
                for(let i = 0; i < this.systemInformation.nAtoms; i++){
                    line = lineIt.next();
                    // console.log(line);
                    if (line === undefined) return undefined;
                    let force = line.value.match($0aea1ecd202dfff9$var$floatRegex).map(Number);
                    forces.push(force);
                }
                maxForceComponent = getMaxForceComponent(forces);
            }
            return {
                "finalScfEnergies": finalEnergies,
                "forces": forces,
                "maxForceComponent": maxForceComponent
            };
        };
        function getMaxForceComponent(forces) {
            let maxForceComponent = 0.0;
            forces.forEach((force)=>{
                let absForces = force.map(Math.abs);
                // console.log(absForces);
                maxForceComponent = Math.max(...absForces, maxForceComponent);
            });
            return maxForceComponent;
        }
        let getScfLoops = ()=>{
            let scfLoops = [];
            let isLeaving = false;
            let isStarting = false;
            while(!isLeaving){
                isStarting = checkForUntil("Begin self-consistency loop", "Leaving FHI-aims");
                if (isStarting) {
                    let scfCycle = {
                        isConverged: false
                    };
                    if (this.runTimeChoices.outputLevel === "normal") scfCycle = getScfCycle(this.runTimeChoices);
                    else if (this.runTimeChoices.outputLevel === "MD_light") scfCycle = getScfCycleMDLight(this.runTimeChoices);
                    // Many-body dispersion implies Hirshfeld analysis
                    // if (this.runTimeChoices.hasMBD) this.hirshfeld = getHirshfeldPop()
                    let finalScfEnergiesForces = {};
                    if (scfCycle.isConverged) finalScfEnergiesForces = getFinalScfEnergiesForces();
                    scfLoops.push({
                        ...finalScfEnergiesForces,
                        ...scfCycle
                    });
                    if (this.runTimeChoices.calculationType === "relaxation") {
                        const geoObj = parseUpdatedGeo();
                        if (geoObj !== undefined) {
                            currentGeometry = geoObj.geo;
                            scfLoops.at(-1).maxForceComponent = geoObj.force;
                        }
                    }
                    if (this.runTimeChoices.hasSOC) {
                        // first Hirshfeld, then Mulliken (SR+SOC)
                        if (this.runTimeChoices.hasHirshfeld) this.hirshfeld = getHirshfeldPop();
                        if (this.runTimeChoices.hasMulliken) this.mulliken = getMullikenPop(true);
                    } else {
                        if (this.runTimeChoices.hasMulliken) this.mulliken = getMullikenPop();
                        if (this.runTimeChoices.hasHirshfeld) this.hirshfeld = getHirshfeldPop();
                    }
                } else if (isStarting === undefined) return scfLoops;
                else isLeaving = true;
            }
            return scfLoops;
        };
        let getInput = (start, stop)=>{
            let cLines = getLinesInBetween(start, stop);
            cLines.splice(0, 5); // remove the first six lines
            cLines.pop(); // remove the 2 last lines
            cLines.pop();
            // console.log(cLines)
            return cLines;
        };
        let getCalculationInfo = ()=>{
            let calculationInfo = {};
            let calculationInfoRegExs = [
                [
                    "codeVersion",
                    "Code Version",
                    /FHI-aims version\s+:\s+([0-9]+)/
                ],
                [
                    "commitNumber",
                    "Commit Number",
                    /Commit number\s+:\s+([0-9,a-z]*)/
                ],
                [
                    "numberOfTasks",
                    "Number of Tasks",
                    /Using\s+([0-9]*)\s+parallel tasks\./
                ]
            ];
            let line = lineIt.next();
            while(!line.done){
                if (line.value.match("Obtaining array dimensions for all initial allocations:")) return calculationInfo;
                calculationInfoRegExs.forEach((re)=>{
                    let m = line.value.match(re[2]);
                    if (m) calculationInfo[re[0]] = {
                        "value": m[1],
                        "info": re[1]
                    };
                });
                line = lineIt.next();
            }
            return undefined;
        };
        let getFinalTimings = ()=>{
            let finalTimings = {};
            let line = waitFor(" Total time  ");
            if (line === undefined) return undefined;
            finalTimings["totalTime"] = {
                "value": line.value.match($0aea1ecd202dfff9$var$floatRegex)[1],
                "info": "Total Time"
            };
            return finalTimings;
        };
        let getMemory = ()=>{
            let memory = {};
            let line = waitFor("   Maximum");
            if (line === undefined) return undefined;
            let m = line.value.match($0aea1ecd202dfff9$var$floatRegex);
            memory["peakMemory"] = {
                "value": m,
                "info": "Peak memory among tasks (MB)"
            };
            m = waitFor("   Maximum").value.match($0aea1ecd202dfff9$var$floatRegex);
            memory["largestArray"] = {
                "value": m,
                "info": "Largest tracked array allocation (MB)"
            };
            return memory;
        };
        let getExitMode = ()=>{
            let exitMode = {};
            let line = waitFor(" Have a nice day");
            let value;
            if (line === undefined) value = "no";
            else value = line.value ? "yes" : "no";
            exitMode["exitMode"] = {
                "value": value,
                "info": "Calculation exited regularly"
            };
            return exitMode;
        };
        let lines = fileText.split("\n");
        let lineIt = linesIterator(lines);
        this.calculationInfo = getCalculationInfo();
        this.inputs.controlIn = getInput(/^\s+Parsing control\.in/gm, /^\s+Completed first pass over input file control\.in \./gm);
        this.getRunTimeChoices();
        this.inputs.geometryIn = getInput(/^\s+Parsing geometry\.in/gm, /^\s+Completed first pass over input file geometry\.in \./gm);
        this.structureIn = getInitialGeometry();
        let currentGeometry = this.structureIn;
        this.mulliken = undefined;
        this.hirshfeld = undefined;
        this.scfLoops = getScfLoops();
        this.finalTimings = getFinalTimings();
        this.memory = getMemory();
        this.exitMode = getExitMode();
    }
}


/**
 * @author Sebastian Kokott, Iker Hurtado
 *
 * @fileoverview File holding the OutputExciting class
 */ 



const $216ae713c7b2a163$var$HARTREE = 27.211386245988;
const $216ae713c7b2a163$var$BOHR = 0.529177249;
const $216ae713c7b2a163$var$floatRegex = /[-+]?[0-9]+[.][0-9]*([eE][-+]?[0-9]+)?/g;
const $216ae713c7b2a163$var$parseFloat2AA = (floatString)=>{
    return $216ae713c7b2a163$var$BOHR * parseFloat(floatString);
};
const $216ae713c7b2a163$var$parseFloat2eV = (floatString)=>{
    return $216ae713c7b2a163$var$HARTREE * parseFloat(floatString);
};
class $216ae713c7b2a163$export$2e2bcd8739ae039 extends (0, $1b6ef0057aac13f5$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.inputs = {
            "InputXML": []
        };
        this.structureIn = new (0, $495a3b82f25facb5$export$2e2bcd8739ae039)();
        this.structureIn.latVectors = [];
        this.systemInformation = {
            "formulaUnit": "",
            "nAtoms": 0
        };
        this.output = {
            "preamble": [],
            "initialization": [],
            "groundstate": [],
            "finale": []
        };
    }
    /**
   * Parses the all the calculation output files
   * @param  {Array<object>} filesData
   */ parseFiles(filesData) {
        this.bsData = [];
        filesData.forEach((fileData)=>{
            // For every file
            if ([
                "application/gzip",
                "application/x-gzip"
            ].includes(fileData.type)) {
                console.log("Workflow output for Exciting is not yet implemented");
                return;
            }
            const fileName = fileData.name;
            let lines = $4aa0937dc0e8c453$export$f197186eaead7b86(fileData.content); // fileData.content.replace(/[ \t]+/g, ' ').split('\n');
            if (fileName === "dos.xml") {
                this.files.dos.set(fileName, getDOSDataExciting(fileData.content));
                this.filledUp = true;
            } else if (fileName === "bandstructure.xml") {
                this.bsData = getBSDataExciting(fileData.content);
                this.filledUp = true;
            } else if (fileName === "INFO.OUT") {
                this.files.output.set(fileName, fileData.content);
                this.filledUp = true;
            } else if (fileName === "input.xml") this.files.input.set(fileName, fileData.content);
        });
        // method internal functions
        function getDOSDataExciting(xmlText) {
            let dosDataDom = new DOMParser().parseFromString(xmlText, "application/xml");
            let data = [];
            for (let node of dosDataDom.children[0].children){
                //log('node', node.tagName)
                if (node.tagName === "totaldos") for (let pointNode of node.children[0].children)data.push([
                    $216ae713c7b2a163$var$HARTREE * parseFloat(pointNode.getAttribute("e")),
                    parseFloat(pointNode.getAttribute("dos"))
                ]);
            }
            return data;
        }
        function getBSDataExciting(xmlText) {
            let dosDataDom = new DOMParser().parseFromString(xmlText, "application/xml");
            let bands = [], vertexes = [];
            for (let node of dosDataDom.children[0].children){
                if (node.tagName === "band") {
                    let bandPoints = [];
                    for (let pointNode of node.children)bandPoints.push([
                        parseFloat(pointNode.getAttribute("distance")),
                        parseFloat(pointNode.getAttribute("eval"))
                    ]);
                    bands.push(bandPoints);
                } else if (node.tagName === "vertex") {
                    let coords = node.getAttribute("coord").replace(/[ \t]+/g, " ").split(" ").map((c)=>parseFloat(c));
                    vertexes.push({
                        distance: parseFloat(node.getAttribute("distance")),
                        label: node.getAttribute("label"),
                        coords: coords
                    });
                }
            }
            // The Exciting bandstrcuture format is turned into a one based on segments
            let segments = [];
            let kpointIndex = 0;
            let currentDistance;
            for(let i = 1; i < vertexes.length; i++){
                // For very segment
                let segment = {
                    segment_num: i,
                    // starts with 1
                    band_energies: [
                        [],
                        [],
                        []
                    ],
                    // [spin1] and [spin2] and [SOC]
                    band_k_points: [],
                    band_segm_labels: [
                        vertexes[i - 1].label,
                        vertexes[i].label
                    ],
                    bsName: [
                        "bandstructure.xml"
                    ],
                    segmentName: [
                        "Segment Number " + i
                    ]
                };
                currentDistance = vertexes[i - 1].distance;
                const segmentLength = vertexes[i].distance - vertexes[i - 1].distance;
                while(currentDistance <= vertexes[i].distance){
                    // For every kpoint
                    currentDistance = bands[0][kpointIndex][0];
                    let distanceFromSegmentInit = currentDistance - vertexes[i - 1].distance;
                    let kpointCoords = getKpointCoords(vertexes, i, distanceFromSegmentInit / segmentLength);
                    //log('kpoint', kpointIndex, currentDistance, distanceFromSegmentInit, kpointCoords)
                    segment.band_k_points.push(kpointCoords);
                    //segment.band_energies[0]/*spin1*/.push(bands[0][kpointIndex][1])
                    let energies = [];
                    bands.forEach((bandPoints)=>{
                        energies.push($216ae713c7b2a163$var$HARTREE * bandPoints[kpointIndex][1]); // the energy of every band for that kpoint is added
                    });
                    segment.band_energies[0]/*spin1*/ .push(energies);
                    if (currentDistance === vertexes[i].distance) break;
                    else kpointIndex++;
                }
                segments.push(segment);
            }
            //log('bandstructure segments', segments)
            return segments;
        }
        function getKpointCoords(vertexes, index, distPerUnit) {
            let coords = [];
            for(let i = 0; i < 3; i++)coords.push(vertexes[index - 1].coords[i] + (vertexes[index].coords[i] - vertexes[index - 1].coords[i]) * distPerUnit);
            return coords;
        }
    }
    /**
   * Returns an object with all the band structure info to plot it
   * @return {object}
   */ getBsInfo() {
        return {
            bsData: this.bsData,
            lackingSegments: []
        };
    }
    // getResultsQuantities(){
    //     const quantities = new Map()
    //     let lastIter = this.results.length-1
    //     const lastEl = this.results[lastIter]['scfConvergence'][4].length -1
    //
    //     quantities.set('Total Energy (eV)', this.results[lastIter].scEnergy[0] )
    //     quantities.set('Estimated HOMO-LUMO gap (eV)', this.results[lastIter]['scfConvergence'][4][lastEl]*HARTREE )
    //
    //     return quantities
    // }
    /**
   * Gathers and stores the data series for the relaxation graph
   */ getRelaxationSeries() {
        let iters = [], dataI = [], forceI = [], dEnd = 0.0, evI = [];
        let i = 0;
        this.scfLoops.forEach((loop)=>{
            i += 1;
            if (loop.isConverged) {
                iters.push(i);
                dEnd = loop["finalScfEnergies"]["totalEnergy"];
                dataI.push(loop["finalScfEnergies"]["totalEnergy"]);
                forceI.push(loop["maxForceComponent"]);
            }
        });
        this.relaxationSeries = {
            "labels": iters,
            "energy": {
                "label": "Total Energy",
                "data": dataI.map(function(value) {
                    return Math.abs(value - dEnd);
                }),
                "yAxisID": "yscenergy",
                "fill": false,
                "borderColor": "rgb(42,45,52)",
                "lineTension": 0.1
            },
            "forces": {
                "label": "Maximum Force Component",
                "data": forceI.map(Math.abs),
                "yAxisID": "ymaxforce",
                "fill": false,
                "borderColor": "rgb(0,157,220)",
                "lineTension": 0.1
            }
        };
    }
    /**
   * Gathers and stores the data series for the convergence graph
   */ getDataSeries() {
        // convergence accuracy
        let dataSeries = [];
        this.scfLoops.forEach((loop)=>{
            // console.log(loop.iterations);
            // if (loop.iterations) console.log(loop.iteration);
            let hasIter = loop.iterations ? loop.iterations.length > 0 : false;
            // console.log('hasIter',hasIter);
            if (hasIter) {
                let dataSeriesIteration = {
                    "effectivePotential": {
                        "label": "Change of effective Potential",
                        "color": "rgb(0,157,220)",
                        "data": []
                    },
                    "totalEnergy": {
                        "label": "Change of Total Energy",
                        "color": "rgb(242,100,48)",
                        "data": []
                    },
                    "chargeDistance": {
                        "label": "Charge Distance",
                        "color": "rgb(42,45,52)",
                        "data": []
                    }
                };
                if (this.runTimeChoices.hasForces) dataSeriesIteration["forces"] = {
                    "label": "Forces",
                    "color": "rgb(42,45,104)",
                    "data": []
                };
                // if (this.runTimeChoices.spin == 'collinear') {
                //   dataSeriesIteration['chargeDensityUp'] = {'label': 'Change of Density (Up)', 'color':'rgb(42,45,52)', 'data':[]}
                //   dataSeriesIteration['chargeDensityDown'] = {'label': 'Change of Density (Down)', 'color':'rgb(84,45,52)', 'data':[]}
                // } else {
                //   dataSeriesIteration['chargeDensity'] = {'label': 'Change of Density', 'color':'rgb(42,45,52)', 'data':[]}
                // }
                loop.iterations.forEach((iteration)=>{
                    for (let [key, entry] of Object.entries(dataSeriesIteration))// console.log(key, entry);
                    if (iteration.convergenceAccuracy) entry["data"].push(iteration.convergenceAccuracy[key]);
                });
                dataSeries.push(dataSeriesIteration);
            }
        });
        // console.log(dataSeries);
        this.dataSeries = dataSeries;
    }
    /**
   * Returns the main quantities of the calculation results to be shown
   * @return {Map<string,float>}
   */ getResultsQuantities() {
        const quantities = new Map();
        // find last converged scf loop
        let lastConverged = -1;
        // console.log(this.scfLoops);
        this.scfLoops.forEach((loop)=>{
            if (loop.isConverged) lastConverged += 1;
        });
        if (lastConverged >= 0) {
            const lastLoop = this.scfLoops[lastConverged];
            // console.log(lastLoop);
            quantities.set("Total Energy (eV)", lastLoop.finalScfEnergies.totalEnergy);
            if (this.runTimeChoices.calculationType !== "relaxation") {
                const lastIter = lastLoop["iterations"][lastLoop["iterations"].length - 1];
                for (let [key, entry] of Object.entries(lastIter["electronInfo"]))quantities.set(entry.info, entry.value);
            }
            if (this.runTimeChoices.isPeriodic) quantities.set("Cell Volume (&#197;<sup>3</sup>)", (0, $ab6e98e8f37dab02$export$a11cb81344d466f0)(this.structureIn.latVectors));
            if (this.runTimeChoices.calculationType == "relaxation") {
                const finalStructureText = (0, $ab6e98e8f37dab02$export$17ae15ab1332eec2)(lastLoop.structure);
                let href = window.URL.createObjectURL(new Blob([
                    finalStructureText
                ], {
                    type: "text/plain"
                }));
                quantities.set("download-link", href);
            }
        }
        return quantities;
    }
    /**
   * Returns summary calculation information
   * @return {Map<string,object>}
   */ getCalculationInfo() {
        const quantities = new Map();
        // console.log(this.calculationInfo, this.finalTimings, this.memory, this.exitMode);
        let infoObjects = [
            this.calculationInfo,
            this.finalTimings,
            this.exitMode
        ];
        infoObjects.forEach((infoObject)=>{
            if (infoObject !== undefined) for (let [key, entry] of Object.entries(infoObject))quantities.set(entry.info, entry.value);
        });
        return quantities;
    }
    /**
   * Returns a map of the input files
   * @return {Map<string,string>}
   */ getInputFilesMap() {
        return this.files.input;
    }
    /**
   * Parses the main calculation output file.
   * If fineName is not passed in it's looks for the first one
   * @param  {string} fileName
   */ parseOutputFile(fileName) {
        if (this.files.output.size === 0) return;
        if (!fileName) fileName = this.files.output.keys().next().value;
        const fileText = this.files.output.get(fileName);
        this.parseFile(fileName, fileText);
    }
    /**
   * Parses the main calculation output file.
   * @param  {string} fileName
   * @param  {string} fileText
   */ parseFile(fileName, fileText) {
        this.normalParser(fileName, fileText);
        // this.parseFileAndInit(fileName, fileText)
        // this.grepGeometryFromOutput()
        this.getSystemInformation();
        this.getDataSeries();
        if (this.runTimeChoices.calculationType === "relaxation") this.getRelaxationSeries();
    // this.grepResults()
    }
    // parseFileAndInit(filename, fileText){
    //
    //   this.filename = filename
    //
    //   let isPreamble = true
    //   let isInitialization = false
    //   let isGroundstate= false
    //   let isFinale = false
    //   let lines = fileText.split('\n')
    //
    //   lines.forEach(o => {
    //     if (o.indexOf(' Starting initialization')>=0 ) {
    //       isPreamble = false
    //       isInitialization = true
    //     }
    //     if (o.indexOf(' Ending initialization')>=0) {isInitialization = false}
    //     if (o.indexOf('Groundstate module started')>=0) {isGroundstate = true}
    //     if (o.indexOf('Groundstate module stopped')>=0) {isGroundstate = false}
    //
    //     if (isPreamble) {this.output.preamble.push(o)}
    //     if (isInitialization) {this.output.initialization.push(o)}
    //     if (isGroundstate) {this.output.groundstate.push(o)}
    //
    //   })
    // }
    // grepGeometryFromOutput(){
    //   //This is really ugly here, but a fast hack to make the output analyzer working for Exciting.
    //   function *linesIterator(body) {
    //     for (line in body) {yield body[line]}
    //   }
    //   let lines = linesIterator(this.output.initialization)
    //   let linIt = lines.next()
    //   let line = linIt.value
    //   let isFinished = linIt.done
    //   let notEmpty = false
    //
    //   let currentSpecies = ''
    //   while (!isFinished) {
    //     if (line.indexOf(' Species :')>=0) {
    //       //console.log(line.split(/(\s+)/))
    //       currentSpecies = line.split(/(\s+)/)[8].replace(/[()]/g, '')
    //       //console.log(currentSpecies)
    //     }
    //     if (line.indexOf(' Lattice vectors (cartesian) :')>=0) {
    //       notEmpty = true
    //       while(notEmpty) {
    //         linIt = lines.next()
    //         line = linIt.value
    //         let ls = line.split(/(\s+)/)
    //         if (ls[1]!=' '){
    //           let latVect = [parseFloat(ls[2])*this.bohr,parseFloat(ls[4])*this.bohr,parseFloat(ls[6])*this.bohr]
    //           //console.log('LS',latVect)
    //           this.structureIn.latVectors.push(latVect)
    //         }else {notEmpty =false}
    //       }
    //     }
    //     if (line.indexOf('  atomic positions (lattice) :')>=0) {
    //       notEmpty = true
    //       while(notEmpty) {
    //         linIt = lines.next()
    //         line = linIt.value
    //         let ls = line.split(/(\s+)/)
    //         if (ls[1]!=' '){
    //           let relPos = [parseFloat(ls[6]),parseFloat(ls[8]),parseFloat(ls[10])]
    //           //console.log(relPos)
    //           this.structureIn.addAtomData(relPos,currentSpecies,true)
    //         }else {notEmpty =false}
    //       }
    //     }
    //     if (line.indexOf('  atomic positions (cartesian) :')>=0) {
    //       notEmpty = true
    //       while(notEmpty) {
    //         linIt = lines.next()
    //         line = linIt.value
    //         let ls = line.split(/(\s+)/)
    //         if (ls[1]!=' '){
    //           let relPos = [parseFloat(ls[6])*this.bohr,parseFloat(ls[8])*this.bohr,parseFloat(ls[10])*this.bohr]
    //           //console.log(relPos)
    //           this.structureIn.addAtomData(relPos,currentSpecies,false)
    //         }else {notEmpty =false}
    //       }
    //     }
    //
    //     linIt = lines.next()
    //     line = linIt.value
    //     isFinished = linIt.done
    //   }
    // }
    /**
   * Fills the basic system information
   */ getSystemInformation() {
        let nAtoms = this.structureIn.atoms.length;
        let species = {};
        this.structureIn.atoms.forEach((a)=>{
            let sp = a.species;
            species[sp] === undefined ? species[sp] = 1 : ++species[sp];
        });
        let formulaUnit = ""; // formula unit
        for(let key in species){
            let num = species[key];
            formulaUnit += num === 1 ? key : key + num.toString();
        }
        this.systemInformation.nAtoms = nAtoms;
        this.systemInformation.formulaUnit = formulaUnit;
    }
    /**
   * Parses the main output file
   * @param  {string} fileName
   * @param  {string} fileText
   */ normalParser(fileName, fileText) {
        function* linesIterator(body) {
            for(let line in body)yield body[line];
        }
        let parseUntil = (regexs, stopRe)=>{
            let lines = [];
            let line = lineIt.next();
            if (line === undefined) return undefined;
            while(!line.done){
                regexs.forEach((re)=>{
                    if (line.value.match(re)) lines.push(line.value);
                });
                if (line.value.match(stopRe)) return lines;
                line = lineIt.next();
            }
            this.errors.push([
                "Reached end of file before finding",
                stopRe.toString()
            ]);
            return undefined; // Should only happe if we stop before
        };
        let waitFor = (waitRe)=>{
            let line = lineIt.next();
            if (line === undefined) return undefined;
            while(!line.done){
                if (line.value.match(waitRe)) return line;
                line = lineIt.next();
            }
            this.errors.push([
                "Did not find the following expression",
                waitRe.toString()
            ]);
            return undefined;
        };
        let checkForUntil = (checkRe, stopRe)=>{
            let line = lineIt.next();
            // console.log(line);
            while(!line.done){
                if (line.value.match(checkRe)) return true;
                else if (line.value.match(stopRe)) return false;
                line = lineIt.next();
            }
            this.errors.push([
                "Reached end of file before finding",
                stopRe.toString()
            ]);
            return undefined;
        };
        let matchNextLine = (regex)=>{
            let line = lineIt.next();
            // console.log(line.value.match(regex));
            return line.value.match(regex);
        };
        let getLinesInBetween = (startRe, stopRe)=>{
            let lines = [];
            let line = waitFor(startRe);
            line = lineIt.next();
            if (!line) return undefined;
            while(!line.done){
                if (line.value.match(stopRe)) return lines;
                lines.push(line.value);
                line = lineIt.next();
            }
            this.errors.push([
                "Reached end of file before finding",
                stopRe
            ]);
            return undefined; // Should only happe if we stop before
        };
        function getCalculationInfo() {
            let line = waitFor(/\sEXCITING/g);
            if (line === undefined) return undefined;
            let version = line.value.split(/\s+/)[2];
            line = waitFor(/version hash id/g);
            let hashId = line.value.split(/\s+/)[4];
            // console.log(version, hashId);
            return {
                "version": {
                    "value": version,
                    "info": "Version"
                },
                "hashID": {
                    "value": hashId.slice(0, 9),
                    "info": "Hash Id"
                }
            };
        }
        let getCalculationType = ()=>{
            let rtc = this.runTimeChoices;
            rtc.isPeriodic = true;
            let lines = parseUntil([
                /Ground-state run/g,
                /Structural optimisation/g
            ], /Starting initialization/g);
            if (lines === undefined) return;
            if (lines[0].match(/Ground-state run/g)) rtc.calculationType = "singlePoint";
            else if (lines[0].match(/Structural optimisation/g)) rtc.calculationType = "relaxation";
            if (rtc.calculationType === "relaxation") rtc.hasForces = true;
        };
        let parseInitialization = ()=>{
            let line = waitFor(/\s+Lattice vectors/g);
            // console.log(line);
            let initStructure = new (0, $495a3b82f25facb5$export$2e2bcd8739ae039)();
            // console.log(initStructure);
            initStructure.latVectors = [];
            initStructure.latVectors.push(matchNextLine($216ae713c7b2a163$var$floatRegex).map($216ae713c7b2a163$var$parseFloat2AA));
            initStructure.latVectors.push(matchNextLine($216ae713c7b2a163$var$floatRegex).map($216ae713c7b2a163$var$parseFloat2AA));
            initStructure.latVectors.push(matchNextLine($216ae713c7b2a163$var$floatRegex).map($216ae713c7b2a163$var$parseFloat2AA));
            // console.log(initStructure);
            let lines = getLinesInBetween(/Brillouin zone volume/g, /Total number of atoms per unit cell/g);
            let isPositionBlock = false;
            let isFract = false;
            let species = "";
            // console.log(lines);
            lines.forEach((line)=>{
                if (line.match(/Species\s/g)) species = line.match(/\((.*)\)/)[1];
                if (line.match(/atomic positions/g) && !isPositionBlock) {
                    isFract = line.match(/\(([^)]+)\)/)[1] === "lattice";
                    isPositionBlock = true;
                // console.log(isPositionBlock);
                } else if (isPositionBlock) {
                    // console.log(line);
                    let position = line.match($216ae713c7b2a163$var$floatRegex);
                    if (position) {
                        if (isFract) initStructure.addAtomData(position.map(parseFloat), species.trim(), isFract);
                        else initStructure.addAtomData(position.map($216ae713c7b2a163$var$parseFloat2AA), species.trim(), isFract);
                    } else isPositionBlock = false;
                }
            });
            // console.log(initStructure);
            this.structureIn = initStructure;
            currentStructure = initStructure;
            line = waitFor("Spin treatment");
            if (!line) return undefined;
            else {
                let spin = line.value.split(/\s+/)[4];
                if (spin === "spin-unpolarised") this.runTimeChoices.spin = "none";
                if (spin === "spin-polarised") this.runTimeChoices.spin = "collinear";
            }
            line = waitFor("Ending initialization");
            if (!line) return undefined;
        };
        function getScfLoops(runTimeChoices) {
            // Parse first SCF loop (usually output level normal)
            let scfLoops = [];
            let line = waitFor("Self-consistent loop started");
            if (!line) return undefined;
            // console.log(line.value);
            let [isConverged, iterations] = getIterations(runTimeChoices);
            // console.log(isConverged, iterations);
            let firstScfLoop = {
                "isConverged": isConverged,
                "iterations": iterations,
                "structure": currentStructure,
                "finalScfEnergies": {}
            };
            if (!isConverged) return [
                firstScfLoop
            ];
            let lastIteration = getLastIteration();
            if (!lastIteration) return [
                firstScfLoop
            ];
            firstScfLoop.iterations.push(lastIteration);
            // console.log(lastIteration);
            firstScfLoop["finalScfEnergies"]["totalEnergy"] = lastIteration.scfEnergies.totalEnergy;
            // console.log(firstScfLoop);
            if (runTimeChoices.calculationType === "relaxation") {
                line = waitFor(/Maximum force magnitude/g);
                if (!line) return [
                    firstScfLoop
                ];
                firstScfLoop["maxForceComponent"] = parseFloat(line.value.match($216ae713c7b2a163$var$floatRegex)[0]) * $216ae713c7b2a163$var$HARTREE / $216ae713c7b2a163$var$BOHR;
            }
            scfLoops.push(firstScfLoop);
            // console.log(runTimeChoices.calculationType);
            if (runTimeChoices.calculationType === "relaxation") {
                let [isConverged, relaxationScfLoops] = getRelaxationScfLoops();
                // console.log(relaxationScfLoops);
                scfLoops = [
                    firstScfLoop,
                    ...relaxationScfLoops
                ];
            }
            return scfLoops;
        }
        function getRelaxationScfLoops() {
            let relaxationScfLoops = [];
            let isNotConverged = true;
            while(isNotConverged){
                isNotConverged = checkForUntil(/Optimization step/g, /Force convergence target achieved/g);
                if (isNotConverged === false) // console.log('I am here!!!!!!');
                return [
                    isNotConverged,
                    relaxationScfLoops
                ];
                else if (isNotConverged === undefined) // console.log('I am here1!!!!!!');
                return [
                    false,
                    relaxationScfLoops
                ];
                else {
                    let optimizationStep = getOptimizationStep();
                    if (!optimizationStep) return [
                        false,
                        relaxationScfLoops
                    ];
                    relaxationScfLoops.push(optimizationStep);
                }
            }
        }
        function getOptimizationStep() {
            let optimizationStep = {
                "finalScfEnergies": {},
                "maxForceComponent": undefined
            };
            let line = waitFor(/Maximum force magnitude/g);
            if (!line) return undefined;
            optimizationStep["maxForceComponent"] = parseFloat(line.value.match($216ae713c7b2a163$var$floatRegex)[0]) * $216ae713c7b2a163$var$HARTREE / $216ae713c7b2a163$var$BOHR;
            line = waitFor(/Total energy at this optimization step/g);
            if (!line) return undefined;
            optimizationStep["finalScfEnergies"]["totalEnergy"] = $216ae713c7b2a163$var$parseFloat2eV(line.value.match($216ae713c7b2a163$var$floatRegex));
            let lines = getLinesInBetween(/Atomic positions at this step/g, /Total atomic forces/g);
            if (!lines) return undefined;
            // console.log(lines);
            let updatedStructure = new (0, $495a3b82f25facb5$export$2e2bcd8739ae039)();
            updatedStructure.latVectors = currentStructure.latVectors;
            lines.forEach((line)=>{
                if (line.includes("atom")) {
                    let position = line.match($216ae713c7b2a163$var$floatRegex);
                    let species = line.split(/\s+/).filter((i)=>i)[2];
                    // console.log(position,species);
                    updatedStructure.addAtomData(position.map(parseFloat), species.trim(), true);
                }
            });
            optimizationStep["structure"] = updatedStructure;
            optimizationStep["isConverged"] = true;
            return optimizationStep;
        }
        function getIterations(runTimeChoices) {
            let iterations = [];
            let isNotConverged = true;
            while(isNotConverged){
                isNotConverged = checkForUntil(/SCF iteration number/g, /Convergence targets achieved\./g);
                // console.log('getIteration isConverged',isNotConverged);
                if (isNotConverged === false) return [
                    true,
                    iterations
                ];
                else if (isNotConverged === undefined) return [
                    false,
                    iterations
                ];
                else {
                    let iteration = getIteration(runTimeChoices);
                    // console.log(iteration);
                    if (!iteration) return [
                        false,
                        iterations
                    ];
                    iterations.push(iteration);
                }
            }
        }
        function getIteration(runTimeChoices) {
            let iteration = {};
            iteration["scfEnergies"] = {};
            iteration["electronInfo"] = {};
            let line = waitFor(/Total energy/g);
            if (!line) return undefined;
            iteration["scfEnergies"]["totalEnergy"] = $216ae713c7b2a163$var$parseFloat2eV(line.value.match($216ae713c7b2a163$var$floatRegex));
            // console.log(iteration);
            line = waitFor(/Fermi energy/g);
            if (!line) return undefined;
            iteration["electronInfo"]["fermiEnergy"] = {
                "value": $216ae713c7b2a163$var$parseFloat2eV(line.value.match($216ae713c7b2a163$var$floatRegex)),
                "info": "Fermi Energy (eV)"
            };
            // console.log(iteration);
            let convAcc = getConvAcc(runTimeChoices);
            if (!convAcc) return undefined;
            iteration["convergenceAccuracy"] = convAcc;
            // console.log(iteration);
            return iteration;
        }
        function getLastIteration() {
            let iteration = {};
            iteration["scfEnergies"] = {};
            iteration["electronInfo"] = {};
            let line = waitFor(/Total energy/g);
            if (!line) return undefined;
            iteration["scfEnergies"]["totalEnergy"] = $216ae713c7b2a163$var$parseFloat2eV(line.value.match($216ae713c7b2a163$var$floatRegex));
            // console.log(iteration);
            line = waitFor(/Fermi energy/g);
            if (!line) return undefined;
            iteration["electronInfo"]["fermiEnergy"] = {
                "value": $216ae713c7b2a163$var$parseFloat2eV(line.value.match($216ae713c7b2a163$var$floatRegex)),
                "info": "Fermi Energy (eV)"
            };
            line = waitFor(/Estimated fundamental gap/g);
            if (!line) return undefined;
            iteration["electronInfo"]["gap"] = {
                "value": $216ae713c7b2a163$var$parseFloat2eV(line.value.match($216ae713c7b2a163$var$floatRegex)),
                "info": "Estimated fundamental gap (eV)"
            };
            return iteration;
        }
        function getConvAcc(runTimeChoices) {
            let convAcc = {};
            let line = waitFor(/RMS change in effective potential/g);
            if (!line) return undefined;
            convAcc["effectivePotential"] = line.value.match($216ae713c7b2a163$var$floatRegex)[0];
            line = waitFor(/Absolute change in total energy/g);
            if (!line) return undefined;
            convAcc["totalEnergy"] = line.value.match($216ae713c7b2a163$var$floatRegex)[0];
            line = waitFor(/Charge distance/g);
            if (!line) return undefined;
            convAcc["chargeDistance"] = line.value.match($216ae713c7b2a163$var$floatRegex)[0];
            if (runTimeChoices.hasForces) {
                line = waitFor(/Abs. change in max-nonIBS-force/g);
                if (!line) return undefined;
                convAcc["forces"] = line.value.match($216ae713c7b2a163$var$floatRegex)[0];
            }
            return convAcc;
        }
        let getFinalTimings = ()=>{
            let finalTimings = {};
            let line = waitFor(/Total time spent/g);
            // console.log(line);
            if (!line) return undefined;
            finalTimings["totalTime"] = {
                "value": parseFloat(line.value.match($216ae713c7b2a163$var$floatRegex)),
                "info": "Total Time (s)"
            };
            return finalTimings;
        };
        let getExitMode = ()=>{
            let exitMode = {};
            let line = waitFor(/EXCITING.*stopped/g);
            // console.log(line);
            let value;
            if (line === undefined) value = "no";
            else value = line.value ? "yes" : "no";
            exitMode["exitMode"] = {
                "value": value,
                "info": "Calculation exited regularly"
            };
            return exitMode;
        };
        let currentStructure;
        let lines = fileText.split("\n");
        let lineIt = linesIterator(lines);
        this.calculationInfo = getCalculationInfo();
        // console.log(this.calculationInfo);
        getCalculationType();
        parseInitialization();
        this.scfLoops = getScfLoops(this.runTimeChoices);
        // console.log(lineIt.next());
        // console.log(this.scfLoops);
        this.finalTimings = getFinalTimings();
        // console.log(this.finalTimings);
        this.exitMode = getExitMode();
    }
}



// Global utility functions
window.showElement = (element, show = true)=>{
    element.style.display = show ? "" : "none";
};
window.log = (...msg)=>{
    console.log(...msg);
};
window.error = (...msg)=>{
    console.error(...msg);
};
window.onerror = function(message, url, line, col, error) {
    $6ff060c6e60f738f$export$b8d0bb2aa0adefe5(`${message}\n At ${line}:${col} of ${url}`);
};
async function $ab6e98e8f37dab02$export$7b2a59254a5000b2(filesData) {
    let outputAims = new (0, $0aea1ecd202dfff9$export$2e2bcd8739ae039)();
    let outputExciting = new (0, $216ae713c7b2a163$export$2e2bcd8739ae039)();
    outputExciting.parseFiles(filesData);
    if (outputExciting.isFilledUp()) return outputExciting;
    return new Promise((resolve)=>{
        outputAims.parseFiles(filesData).then((output)=>{
            if (output.isFilledUp()) resolve(output);
        });
    });
}
function $ab6e98e8f37dab02$export$17ae15ab1332eec2(structure) {
    let text = "";
    let latticeVectors = structure.latVectors;
    if (latticeVectors) latticeVectors.forEach((v)=>{
        text += "lattice_vector " + v.join(" ") + "\n";
    });
    structure.atoms.forEach((atom)=>{
        text += `atom ${atom.position.join(" ")} ${atom.species}\n`;
    });
    return text;
}
function $ab6e98e8f37dab02$export$2b060aca926f9411(lines) {
    let controlInText = "";
    lines.forEach((line)=>{
        controlInText += line + "\n";
    });
    return controlInText;
}
function $ab6e98e8f37dab02$export$a11cb81344d466f0(vectors) {
    // units = Angstroms
    let v0 = new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(vectors[0]);
    let v1 = new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(vectors[1]);
    let v2 = new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(vectors[2]);
    return Math.abs(v0.cross(v1).dot(v2));
}
function $ab6e98e8f37dab02$export$770bce1690f63f17(broad, x, x0) {
    return 1.0 / (broad * Math.sqrt(2 * Math.PI)) * Math.exp(-0.5 * (x - x0) ** 2 / broad ** 2);
}
function $ab6e98e8f37dab02$export$133463a98c8c6308(quantities, valuesAsNumbers = true) {
    let html = "";
    quantities.forEach((quantity, label)=>{
        if (label === "download-link") html += `<tr> <td><a class="f-geometry-download-link" download="geometry.in"
               href="${quantity}" >Download final geometry </a></td></tr>`;
        else html += `<tr> <td>${label}</td> <td>${valuesAsNumbers ? quantity.toFixed(5) : quantity}</td> </tr>`;
    });
    return html;
}
// cool-warm colormap from MPL
let $ab6e98e8f37dab02$var$colors = [
    [
        0.2481,
        0.326,
        0.7777
    ],
    [
        0.3992,
        0.5285,
        0.9285
    ],
    [
        0.5652,
        0.6994,
        0.9966
    ],
    [
        0.729,
        0.8175,
        0.9732
    ],
    [
        0.8674,
        0.8644,
        0.8626
    ],
    [
        0.9582,
        0.7712,
        0.6803
    ],
    [
        0.9594,
        0.6103,
        0.4894
    ],
    [
        0.8771,
        0.3946,
        0.3117
    ],
    [
        0.7233,
        0.0689,
        0.163
    ]
];
const $ab6e98e8f37dab02$var$colorSpace = $ab6e98e8f37dab02$var$colors.length - 1;
const $ab6e98e8f37dab02$var$rgb = (r, g, b)=>`rgb(${r},${g},${b})`;
function $ab6e98e8f37dab02$var$color(x) {
    if (x < 0 || x > 1) return undefined;
    if (x === 0.) return $ab6e98e8f37dab02$var$rgb(...$ab6e98e8f37dab02$var$colors[0].map((i)=>Math.round(i * 255)));
    if (x === 1.) return $ab6e98e8f37dab02$var$rgb(...$ab6e98e8f37dab02$var$colors[$ab6e98e8f37dab02$var$colorSpace].map((i)=>Math.round(i * 255)));
    let lo = Math.floor(x * $ab6e98e8f37dab02$var$colorSpace);
    let hi = Math.ceil(x * $ab6e98e8f37dab02$var$colorSpace);
    let r = Math.round(((hi - x * $ab6e98e8f37dab02$var$colorSpace) * $ab6e98e8f37dab02$var$colors[lo][0] + (x * $ab6e98e8f37dab02$var$colorSpace - lo) * $ab6e98e8f37dab02$var$colors[hi][0]) * 255);
    let g = Math.round(((hi - x * $ab6e98e8f37dab02$var$colorSpace) * $ab6e98e8f37dab02$var$colors[lo][1] + (x * $ab6e98e8f37dab02$var$colorSpace - lo) * $ab6e98e8f37dab02$var$colors[hi][1]) * 255);
    let b = Math.round(((hi - x * $ab6e98e8f37dab02$var$colorSpace) * $ab6e98e8f37dab02$var$colors[lo][2] + (x * $ab6e98e8f37dab02$var$colorSpace - lo) * $ab6e98e8f37dab02$var$colors[hi][2]) * 255);
    return $ab6e98e8f37dab02$var$rgb(r, g, b);
}
function $ab6e98e8f37dab02$export$1c5b3f2362e3e603(x, aroundZero = false) {
    let absMax = Math.max(...x.map((i)=>Math.abs(i)));
    let hi = aroundZero ? absMax : Math.max(...x);
    let lo = aroundZero ? -absMax : Math.min(...x);
    console.log(lo, hi);
    return x.map((i)=>$ab6e98e8f37dab02$var$color((i - lo) / (hi - lo)));
}
function $ab6e98e8f37dab02$export$6969335ea1e4e77c(target, update) {
    // for each key/value pair in update object
    for (const [key, value] of Object.entries(update)){
        // if target has the relevant key and
        // the type in target and update is the same
        // update value if string, number or boolean
        if ([
            "string",
            "number",
            "boolean"
        ].includes(typeof value) || Array.isArray(value)) target[key] = value;
        else // if type is object then go one level deeper
        if (typeof value === "object") $ab6e98e8f37dab02$export$6969335ea1e4e77c(target[key], value);
    }
    return target;
}
function $ab6e98e8f37dab02$export$9cb09a71b7d66923(arr) {
    return arr[0].map((col, j)=>arr.map((row)=>row[j]));
}


class $ad3342556a4c2c46$export$2e2bcd8739ae039 {
    /**
   * @param  {HTMLElement}  hostElement HTML element hosting the canvas
   * @param  {boolean} editable StructureViewer mode view 
   *   editable/advantage (false) or simple (true)
   * @param  {State} moduleState 
   *   Object representing the state of the Structure builder module
   */ constructor(hostElement, editable, moduleState){
        this.hostElement = hostElement;
        this.editable = editable;
        this.c = new (0, $ecfc9827072e9972$export$2e2bcd8739ae039)(this.hostElement, ".info-canvas");
        this.canvas = this.c.canvas;
        // Legend object
        this.legend = new $ad3342556a4c2c46$var$AtomLegend(this.c, this.editable, moduleState);
        // Selected atom info area
        this.c.addGroup("atomInfo");
        // Distance, Angle, Torsion info area
        this.c.addGroup("datInfo");
    }
    /**
   * Returns the position of the canvas element
   * @return {object} X and Y coordinates of the canvas
   */ getCanvasPosition() {
        return this.c.getPosition();
    }
    /**
   * Updates the vertical scroll figure
   * @param {int} scrollY - Current vertical scroll
   */ adaptToScroll(scrollY) {
        this.c.adaptToScroll(scrollY);
    }
    /**
   * Clears the canvas 
   */ clear() {
        this.c.clearCanvas();
    }
    /**
   * Generates the structure atoms legend 
   * @param  {Array<object>} atoms
   */ createAtomsLegend(atoms) {
        this.legend.setAtomsData(atoms);
    }
    /**
   * Shows the basic atom information
   * @param  {int} i Atom index
   * @param  {string} species 
   * @param  {Array<number>} coors
   */ showAtomInfo(i, species, coors) {
        //console.log('showAtomInfo',pos)
        const x = this.canvas.width - 280; //this.canvas.width/2// this.canvas.width- 420
        const y = 36;
        this.clearSelectedAtomArea();
        const style = {
            color: (0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesColor(species),
            strokeColor: "#444"
        };
        this.c.addElement("circle", {
            x: x + 10,
            y: y - 7,
            r: 8,
            style: style
        }, "atomInfo");
        const coorsText = coors[0].toFixed(5) + " " + coors[1].toFixed(5) + " " + coors[2].toFixed(5);
        const font = "14px Roboto";
        const text = this.c.addElement("text", {
            text: "#" + (i + 1) + " atom  " + coorsText + "  " + species,
            x: x + 25,
            y: y,
            style: {
                font: font
            }
        }, "atomInfo"); //addText( { text: '#'+(i+1)+' atom  '+coorsText+'  '+species, x: x+30, y: y-3, font: font } , 'atomInfo')
        text.style.color = "#444";
        this.c.clearAndDrawAll();
    }
    /**
   * Clears the canvas area showing the atom information
   */ clearSelectedAtomArea() {
        this.c.removeGroupElements("atomInfo");
        this.c.clearAndDrawAll();
    }
    /**
   * Shows the Distance, Angle, Torsion info 
   * @param  {string} info
   */ showDATAtomsInfo(info) {
        //console.log('showDATAtomsInfo',pos)
        const x = this.canvas.width - 280;
        const y = 58;
        this.clearDATAtomsArea();
        const font = (info.startsWith("Torsion angle") ? 11 : 12) + "px Roboto";
        const text = this.c.addElement("text", {
            text: info,
            x: x + 20,
            y: y - 4,
            style: {
                font: font
            }
        }, "datInfo");
        text.style.color = "#444";
        this.c.clearAndDrawAll();
    }
    /**
   * Clears the Distance, Angle, Torsion info area
   */ clearDATAtomsArea() {
        this.c.removeGroupElements("datInfo");
        this.c.clearAndDrawAll();
    }
}
/**
 * Structure atom legend UI layer
 */ class $ad3342556a4c2c46$var$AtomLegend {
    /**
   * @param  {Canvas}  canvas
   * @param  {boolean}  editable StructureViewer mode
   * @param  {State} moduleState 
   *   Object representing the state of the Structure builder module
   */ constructor(canvas, editable, moduleState){
        this.moduleState = moduleState;
        this.canvas = canvas;
        this.editable = editable;
        this.legendSpecies = undefined; // Map (species, { canvasElement, initColor})
        this.LEGEND_INFO_AREA = {
            x: 0,
            y: editable ? 100 : 200,
            w: 200,
            h: 500
        };
        this.canvas.addGroup("legend");
        this.currentSpeciesCircle = undefined;
        this.currentTooltip = undefined;
        if (!editable) {
            // Editable mode
            this.canvas.setCursorOnElement("pointer");
            this.colorInput = document.createElement("input");
            // TODO: remove or maintain this change
            this.colorInput.style.display = "none";
            this.canvas.canvas.appendChild(this.colorInput);
            this.colorInput.type = "color";
            this.colorInput.addEventListener("input", (e)=>{
                this.currentSpeciesCircle.style.color = e.target.value; // input color code
                this.canvas.clearAndDrawAll();
                this.moduleState.changeSpeciesColor(this.currentSpeciesCircle.species, e.target.value);
            });
            this.canvas.setEventListener(this.canvas.ENTER_ELEMENT, (element)=>{
                const X_MARGIN = this.editable ? 10 : 20;
                const props = {
                    x: X_MARGIN - 10,
                    y: this.LEGEND_INFO_AREA.y,
                    style: {
                        font: "12px Roboto"
                    }
                };
                if (element.type === "circle") props.text = "Click to change color";
                else props.text = "Reset the species colors"; // reset button
                this.currentTooltip = this.canvas.addElement("text", props, "legend");
            });
            this.canvas.setEventListener(this.canvas.LEAVE_ELEMENT, (_)=>{
                this.canvas.removeElement(this.currentTooltip, "legend");
            });
            this.canvas.setEventListener(this.canvas.CLICK_ON_ELEMENT, (element)=>{
                if (element.type === "circle") {
                    this.colorInput.value = element.style.color;
                    // log('Circle event',element.style.color, this.colorInput.parentElement )
                    this.colorInput.dispatchEvent(new MouseEvent("click"));
                    this.currentSpeciesCircle = element;
                } else // reset button
                this.legendSpecies.forEach((data, species)=>{
                    data.element.style.color = data.initColor;
                    this.moduleState.changeSpeciesColor(species, data.initColor);
                    this.canvas.clearAndDrawAll();
                });
            });
        }
    }
    /**
   * Sets the atoms information
   * @param atoms {Array<object>}
   */ setAtomsData(atoms) {
        this.legendSpecies = new Map();
        atoms.forEach((atom)=>{
            if (atom !== undefined && !this.legendSpecies.has(atom.species)) this.legendSpecies.set(atom.species, {
                element: undefined,
                initColor: undefined
            });
        });
        const Y_MARGIN = this.LEGEND_INFO_AREA.y;
        const Y_SEPARATION = this.editable ? 21 : 27;
        const X_MARGIN = this.editable ? 10 : 20;
        const CIRCLE_RADIUS = this.editable ? 7 : 10;
        this.canvas.removeGroupElements("legend"); // Reset the previous elements
        let i = 0;
        this.legendSpecies.forEach((data, species)=>{
            const style = {
                color: (0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesColor(species),
                strokeColor: "#444"
            };
            let circle = this.canvas.addElement("circle", {
                x: X_MARGIN,
                y: Y_MARGIN + Y_SEPARATION * i + 24,
                r: CIRCLE_RADIUS,
                style: style
            }, "legend");
            circle.species = species; // adhoc property
            data.initColor = circle.style.color;
            data.element = circle;
            const font = (this.editable ? "15px" : "18px") + " Roboto";
            const xValue = X_MARGIN + (this.editable ? 16 : 20);
            const yValue = Y_MARGIN + Y_SEPARATION * i + 27;
            const text = this.canvas.addElement("text", {
                text: species,
                x: xValue,
                y: yValue,
                style: {
                    font: font,
                    baseline: "middle"
                }
            }, "legend");
            text.style.color = "#444";
            i++;
        });
        if (!this.editable) {
            const BUTTON_WIDTH = 25;
            const yValue = Y_MARGIN + Y_SEPARATION * this.legendSpecies.size + 30 - BUTTON_WIDTH / 2;
            const xValue = X_MARGIN - BUTTON_WIDTH / 2 + 12;
            const myImage = new Image();
            myImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($511a3383e0112616$exports)));
            myImage.addEventListener("load", (_)=>{
                this.canvas.addElement("image", {
                    img: myImage,
                    x: xValue,
                    y: yValue,
                    w: BUTTON_WIDTH,
                    h: BUTTON_WIDTH
                }, "legend");
                this.canvas.clearAndDrawAll();
            });
        }
        this.canvas.clearAndDrawAll();
    }
    /**
   * Sets a color bar for the legend
   * @param values {number[]} an array of values
   * @param aroundZero {boolean} if 0. lies in the middle of color bar
   */ setColorBar(values, aroundZero) {
        const Y_MARGIN = this.LEGEND_INFO_AREA.y;
        const Y_SEPARATION = 24;
        const X_MARGIN = 20;
        const SQUARE_SIDE = 14;
        this.canvas.removeGroupElements("legend"); // Reset the previous elements
        const absMax = Math.max(...values.map((x)=>Math.abs(x)));
        const lo = aroundZero ? -absMax : Math.min(...values);
        const hi = aroundZero ? absMax : Math.max(...values);
        let nDigits = Math.ceil(-Math.log10(hi - lo)) + 1;
        if (nDigits < 0) nDigits = 0;
        let colorBarValues = [
            0.,
            0.1,
            0.3,
            0.5,
            0.7,
            0.9,
            1.
        ];
        colorBarValues = colorBarValues.map((x, i)=>i !== 0 && i !== colorBarValues.length - 1 ? +(lo + x * (hi - lo)).toFixed(nDigits) : lo + x * (hi - lo));
        const colors = (0, $ab6e98e8f37dab02$export$1c5b3f2362e3e603)(colorBarValues, true);
        for(let i = 0; i < colors.length; i++){
            const style = {
                color: colors[i],
                strokeColor: "#444"
            };
            this.canvas.addElement("rectangle", {
                x: X_MARGIN,
                y: Y_MARGIN + Y_SEPARATION * i,
                w: SQUARE_SIDE,
                h: SQUARE_SIDE,
                style: style
            }, "legend");
            const font = "14px Roboto";
            const xValue = X_MARGIN + 20;
            const yValue = Y_MARGIN + Y_SEPARATION * i + 7;
            const text = this.canvas.addElement("text", {
                text: colorBarValues[i],
                x: xValue,
                y: yValue,
                style: {
                    font: font,
                    baseline: "middle"
                }
            }, "legend");
            text.style.color = "#444";
        }
        this.canvas.clearAndDrawAll();
    }
}


/**
 * @author Iker Hurtado
 *
 * @fileoverview File holding AtomSelector utility
 */ // import * as THREE from '../../lib/three.js'



class $dfce7e031458e840$export$2e2bcd8739ae039 {
    /**
   * @param  {ThreeViewer} threeViewer
   * @param  {InfoCanvas} infoCanvas
   * @param  {State} moduleState
   *   Object representing the state of the Structure builder module
   */ constructor(threeViewer, infoCanvas, moduleState){
        this.moduleState = moduleState;
        this.viewer = threeViewer;
        this.infoCanvas = infoCanvas;
        const canvas = infoCanvas.canvas; //renderer.domElement
        this.camera = threeViewer.camera;
        this.raycaster = new $0d23c856ce11c301$export$8b7aaceff00bd2f();
        // These are set up externally when the Viewer is initilizated with data
        this.atoms; // atom meshes
        this.structure; // structure data
        // Hovering related variables
        this.hoverAtom = null;
        this.keypressed = null;
        // Selection related variables
        this.selAtoms = [];
        // Dragging related variables
        this.draggingEnabled = false;
        this.dragging = false; // The dragging is happening at the moment
        this.dragStart = null;
        this.draggingAtomStartPos = null;
        this.draggingAtom = null;
        this.draggingAtomIndex = null;
        this.mouse = new $0d23c856ce11c301$export$c977b3e384af9ae1();
        canvas.addEventListener("pointermove", (e)=>{
            let canvasPos = this.infoCanvas.getCanvasPosition(); //  this.infoCanvas.position
            this.mouse.x = (e.clientX - canvasPos.x) / canvas.width * 2 - 1;
            this.mouse.y = -((e.clientY - canvasPos.y) / canvas.height) * 2 + 1;
            //console.log('Mousemove', this.mouse, canvasPos)
            // if (this.checkIntersection()) this.viewer.render()
            this.checkIntersection();
            if (this.draggingEnabled && this.dragging) {
                // An atom is being dragging
                let mouseChange = this.mouse.clone().sub(this.dragStart);
                const scale_x = (this.camera.right - this.camera.left) / this.camera.zoom;
                const scale_y = (this.camera.top - this.camera.bottom) / this.camera.zoom;
                mouseChange.x *= scale_x;
                mouseChange.y *= scale_y;
                let inc = new $0d23c856ce11c301$export$64b5c384219d3699(mouseChange.x / 2, mouseChange.y / 2, 0); // Increase in real coordinates (amstrongs)
                inc = this.camera.localToWorld(inc); // Converts the vector from local (camera) space to world space -> The movement is happening in a perpendicular plain to the camera
                inc.sub(this.camera.position); // The position of the camaera has to be substructed
                let newPos = inc.clone().add(this.draggingAtomStartPos);
                //console.log('mousemove', this.camera.position, inc, newPos )
                this.draggingAtom.position.copy(newPos);
                this.viewer.render();
                // The selected atom info area is cleared while displacing
                this.infoCanvas.clearSelectedAtomArea(); // this.viewer.infoCanvas.clearSelectedAtomArea()
            }
        }, false);
        document.addEventListener("keydown", (e)=>{
            this.keypressed = e.keyCode;
        });
        document.addEventListener("keyup", (e)=>{
            this.keypressed = null;
        });
        // Atoms selection
        canvas.addEventListener("click", (e)=>{
            // console.log('click', this.hoverAtom, e)
            // SK: Add atom removal
            if (this.draggingEnabled && this.keypressed === 68 && this.hoverAtom) {
                this.moduleState.removeAtom(this.atoms.children.indexOf(this.hoverAtom));
                this.hoverAtom = null;
            }
            if (this.hoverAtom === null) return;
            // The click is on an atom
            // Shift key is needed to select atoms
            if (e.shiftKey && this.selAtoms.indexOf(this.hoverAtom) < 0) {
                this.selAtoms.push(this.hoverAtom);
                this.highlightAtomMesh(this.hoverAtom, true);
            }
            // calculateFromSelection
            this.infoCanvas.clearDATAtomsArea();
            if (this.selAtoms.length >= 2 && this.selAtoms.length <= 4) {
                const atoms = this.structure.atoms; //State.getStructure().atoms
                const p1Index = this.atoms.children.indexOf(this.selAtoms[0]);
                const p2Index = this.atoms.children.indexOf(this.selAtoms[1]);
                const p1 = atoms[p1Index].position;
                const p2 = atoms[p2Index].position;
                //console.log('DDDDD',  p1, p2)
                if (this.selAtoms.length === 2) {
                    // distance
                    let d = (0, $a4310c0d7cebdf93$export$79376507b09a66f)(p1, p2);
                    this.infoCanvas.showDATAtomsInfo("Distance (atom#" + (p1Index + 1) + " - atom#" + (p2Index + 1) + "): " + d.toFixed(5) + "\xc5");
                } else if (this.selAtoms.length === 3) {
                    // angle
                    const p3Index = this.atoms.children.indexOf(this.selAtoms[2]);
                    const p3 = atoms[p3Index].position;
                    this.infoCanvas.showDATAtomsInfo("Angle (atom#" + (p1Index + 1) + " - atom#" + (p2Index + 1) + " - atom#" + (p3Index + 1) + "): " + (0, $a4310c0d7cebdf93$export$b363da9ded343252)(p1, p2, p3).toFixed(5) + "\xba");
                } else if (this.selAtoms.length === 4) {
                    // angle
                    const p3Index = this.atoms.children.indexOf(this.selAtoms[2]);
                    const p3 = atoms[p3Index].position;
                    const p4Index = this.atoms.children.indexOf(this.selAtoms[3]);
                    const p4 = atoms[p4Index].position;
                    this.infoCanvas.showDATAtomsInfo("Torsion angle (atoms: #" + (p1Index + 1) + " - #" + (p2Index + 1) + " - #" + (p3Index + 1) + " - #" + (p4Index + 1) + "): " + (0, $a4310c0d7cebdf93$export$4abdd6f44ae3d57a)(p1, p2, p3, p4).toFixed(5) + "\xba");
                //'Torsion angle (atom#'+(p1Index+1)+' - #atom'+(p2Index+1)+' - atom#'+(p3Index+1)+' - atom#'+(p4Index+1)+'): '+getTorsionAngle(p1, p2, p3, p4).toFixed(5)+'º')
                }
            }
        });
        // Cancel the selection
        canvas.addEventListener("contextmenu", (e)=>{
            if (this.selAtoms.length > 0) {
                let tempSelAtom = this.selAtoms;
                // the highlightAtom() needs to have the this.selAtoms updated
                this.selAtoms = [];
                tempSelAtom.forEach((atom)=>{
                    this.highlightAtomMesh(atom, false);
                });
                this.infoCanvas.clearDATAtomsArea();
            }
        });
        // Dragging
        canvas.addEventListener("pointerdown", (e)=>{
            // console.log('pointerdown',  this.hoverAtom)
            if (this.draggingEnabled && this.hoverAtom !== null && this.keypressed === null) {
                // mouse on an atom
                this.dragging = true;
                this.dragStart = this.mouse.clone();
                this.draggingAtomStartPos = this.hoverAtom.position.clone();
                this.draggingAtom = this.hoverAtom;
                this.viewer.controls.noRotate = true;
            }
        }, false);
        canvas.addEventListener("pointerup", (e)=>{
            // the dragging atom is released
            if (this.draggingEnabled && this.dragging) {
                this.dragging = false;
                this.dragStart = null;
                const atomIndex = this.atoms.children.indexOf(this.draggingAtom);
                //this.atomDisplacementListener(atomIndex, this.draggingAtom.position)
                this.moduleState.updateAtomPosition(atomIndex, this.draggingAtom.position.toArray(), false);
                this.draggingAtom = null;
                this.viewer.controls.noRotate = false;
                // The selected atom info area is shown again with the new position data
                this.atomHitListener(atomIndex); // this.atomReleaseListener(atomIndex)
            }
        }, false);
    }
    /**
   * Enabled the atom displacement user interaction
   * @param  {boolean}
   */ enableAtomDisplacement(dragging) {
        this.draggingEnabled = dragging;
    }
    /**
   * Checks if there is mouse pointer intersects an atom
   * @return {boolean}
   */ checkIntersection() {
        let change = false;
        if (this.atoms !== undefined) {
            // update the picking ray with the camera and mouse position
            // convenience method to set the raycaster origin and direction
            this.raycaster.setFromCamera(this.mouse, this.camera); // this.raycaster.ray
            // calculate objects intersecting the picking ray
            let intersects = this.raycaster.intersectObjects(this.atoms.children);
            //if (intersects.length > 0) console.log('intersects', intersects,this.raycaster)// atoms.children)
            // If the mouse pointer is on one (or more) atoms &&
            // that atom (the first) is different from the previous one (continuous hovering)
            if (intersects.length > 0 && this.hoverAtom !== intersects[0].object) {
                // if (this.hoverAtom !== null)
                //     this.highlightAtomMesh(this.hoverAtom, false)//changeColor(this.hoverAtom, 0.3)
                this.hoverAtom = intersects[0].object;
                change = true;
                //console.log('intersects', )
                const atomIndex = this.atoms.children.indexOf(this.hoverAtom);
                // this.highlightAtomMesh(this.hoverAtom, true)//changeColor(this.hoverAtom, -0.3)
                //this.viewer.infoCanvas.showAtomInfo()
                this.atomHitListener(atomIndex);
            // If no mouse pointer is on an atom && there was a previous hovered, this is set to normal
            } else if (intersects.length === 0 && this.hoverAtom !== null) {
                // this.highlightAtomMesh(this.hoverAtom, false)//changeColor(this.hoverAtom, 0.3)
                this.hoverAtom = null;
                change = true;
                this.infoCanvas.clearSelectedAtomArea();
            }
        // Two more circunstances
        // No mouse pointer on an atom && no atom hovered in the previous step -> Do nothing
        // Mouse pointer on an atom && that atom is the previously hovered -> Do nothing
        }
        return change;
    }
    /**
    * Sets a listener that will be called when the mouse pointer hits
    * an atom. The hit atom index will be passed in
    * @param {function} listener
    */ setAtomHitListener(listener) {
        this.atomHitListener = listener;
    }
    /**
   * Highligths an atom mesh
   * @param  {object} atom Atom object to highlight
   * @param  {boolean} on
   *   If true the atom is highlighted if false it's toned-down
   */ highlightAtomMesh(atom, on) {
        const atomIndex = this.atoms.children.indexOf(atom);
        if (atomIndex < 0) return;
        else this.highlightAtom(atomIndex, on);
    }
    /**
   * Highligths an atom mesh
   * @param  {int} atomIndex Index of atom to highlight
   * @param  {boolean} on
   *   If true the atom is highlighted if false it's toned-down
   */ highlightAtom(atomIndex, on) {
        //console.log('highlightAtom', this.atoms,atomIndex, on)
        const atom = this.atoms.children[atomIndex];
        if (atom === undefined || this.selAtoms.indexOf(atom) >= 0) return;
        let color = new $0d23c856ce11c301$export$892596cec99bc70e((0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesColor(this.structure.atoms[atomIndex].species)); // State.getStructure().atoms[atomIndex].species))
        if (on) {
            color.r -= 0.4;
            color.g -= 0.4;
            color.b -= 0.4;
        }
        atom.material.color = color;
        this.viewer.render();
    }
}


/**
 * @author Iker Hurtado
 *
 * @fileoverview File holding the ViewOptionsDropDown UI component
 */ /**
 * @author Iker Hurtado
 *
 * @fileoverview DropDownMenu is an UI component implementing a drop-down menu
 * base class
 */ 
class $cb4961254c9228c8$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param {string} label - Text of the drop-down button
   */ constructor(label){
        super("div", ".DropDownMenu");
        this.setHTML(`
        <div>
          <button>${label}</button>
          <ul> </ul> 
        </div>
        
    `);
        this.container = this.getElement("ul");
    }
    /**
   * Init the drop-down with simple text items
   * @param {Array<string>} labels - items texts
   */ setValues(labels) {
        let html = "";
        labels.forEach((label)=>{
            html += "<li>" + label + "</li>";
        });
        this.container.innerHTML = html;
    }
}


class $d0f2ff312a753924$export$2e2bcd8739ae039 extends (0, $cb4961254c9228c8$export$2e2bcd8739ae039) {
    constructor(){
        super("View options");
        this.defaultValues = [];
        this.onlyShowIfPeriodic = [];
        this.UNIT_CELL_OPTION = "show-unit-cell";
        this.LATTICE_VECTORS_OPTION = "show-lattice-vectors-parameters";
        this.BONDS_OPTION = "show-bonds";
        this.BONDS_BOUNDARIES_OPTION = "show-bonds-across-boundaries";
        this.ATOMS_DUPLICATED_OPTION = "show-atoms-duplicated";
        this.WRAP_ATOMS_OPTION = "wrap-atoms-into-cell";
        this.ORTHOGRAPHIC_CAMERA = "orthographic-camera";
        this.addOption(this.ORTHOGRAPHIC_CAMERA, "Orthographic Camera", true, false);
        this.addOption(this.UNIT_CELL_OPTION, "Show unit cell", true, true);
        this.addOption(this.LATTICE_VECTORS_OPTION, "Show lattice vectors and parameters", true, true);
        this.addOption(this.BONDS_OPTION, "Show bonds", true, false);
        this.addOption(this.BONDS_BOUNDARIES_OPTION, "Bonds across boundaries", false, true);
        this.addOption(this.ATOMS_DUPLICATED_OPTION, "Duplicate atoms on cell borders", false, true);
        this.addOption(this.WRAP_ATOMS_OPTION, "Wrap atoms into cell", false, true);
    }
    /**
   * Adds a new option (as a checkbox)
   * @param {string} name Option identificator
   * @param {string} label Label being shown
   * @param {boolean} defaultValue If checked by default
   * @param {boolean} onlyShowIfPeriodic Only shown for periodic structures
   */ addOption(name, label, defaultValue, onlyShowIfPeriodic) {
        this.container.innerHTML += `<li><input type="checkbox" name="${name}" } >${label}</li>`;
        // ${defaultValue ? 'checked' : ''
        this.defaultValues.push(defaultValue);
        this.onlyShowIfPeriodic.push(onlyShowIfPeriodic);
    }
    /**
   * Resets the component, the option checkboxes
   * @param  {boolean} If eriodic structure
   */ reset(periodic, orthographicCamera) {
        let checkboxes = this.getElements("input");
        // console.log(checkboxes);
        this.options = this.getElements("li");
        for(let i = 0; i < checkboxes.length; i++){
            checkboxes[i].checked = this.defaultValues[i];
            this.options[i].style.display = !periodic && this.onlyShowIfPeriodic[i] ? "none" : "block";
        }
        checkboxes[0].checked = orthographicCamera;
    //console.log('this.checkboxes', checkboxes)
    }
    /**
   * Returns the bonds across option HTML element
   * @return {HTMLElement}
   */ getBondsAcrossOptionElement() {
        return this.getElement('input[name="' + this.BONDS_BOUNDARIES_OPTION + '"]').parentNode;
    }
    /**
   * If the bonds across option is checked or not
   * @return {boolean}
   */ isBondsAcrossOptionChecked() {
        return this.getElement('input[name="' + this.BONDS_BOUNDARIES_OPTION + '"]').checked;
    }
    /**
   * If the bonds option is checked or not
   * @return {boolean}
   */ isBondsOptionChecked() {
        return this.getElement('input[name="' + this.BONDS_OPTION + '"]').checked;
    }
    // isOrthographicCameraChecked(){
    //   return this.getElement('input[name="'+this.ORTHOGRAPHIC_CAMERA+'"]').checked
    // }
    /**
   * If an option is checked or not
   * @param {string} option Option identificator
   * @return {boolean}
   */ isOptionChecked(option) {
        return this.getElement('input[name="' + option + '"]').checked;
    }
    /**
   * Sets the listener that will be called when a checkbox is clicked
   * @param {function} listener 
   */ setCheckListener(listener) {
        this.container.addEventListener("click", listener);
    }
}


/**
 * @author Iker Hurtado
 *
 * @fileoverview File holding the Switch UI component
 */ 
class $d773fc3765656ebc$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param {string} label
   */ constructor(label){
        super("div", ".Switch");
        this.on = false;
        this.e.textContent = "OFF";
        this.setHTML(`
      <span class="switch">OFF</span>
      <span class="label">&nbsp;${label}</span>  
    `);
        const switchButton = this.getElement(".switch");
        this.e.addEventListener("click", (e)=>{
            const hasChanged = this.listener(!this.on);
            if (hasChanged) {
                this.on = !this.on;
                switchButton.className = "switch" + (this.on ? " switch-on" : "");
                switchButton.textContent = this.on ? "ON" : "OFF";
            }
        });
    }
    /**
   * Sets the listener that will be called when the button is switched
   * A boolean parameter will be passed in, true if the switch is 
   * getting on, false ptherwise
   * @param {function} listener 
   */ setListener(listener) {
        this.listener = listener;
    }
    switchOff() {
        const switchButton = this.getElement(".switch");
        this.on = false;
        switchButton.className = "switch";
        switchButton.textContent = "OFF";
    }
}



/**
 * @author Iker Hurtado
 *
 * @overview File holding the ScreenshotTaker UI component
 */ var $ca1a8033d79614e0$exports = {};
$ca1a8033d79614e0$exports = new URL("screenshot-icon.5e549a92.png", import.meta.url).toString();


class $a4e45eea12196606$export$2e2bcd8739ae039 {
    /**
   * @param {string} label Screenshot identifier (it appears in the download file name)
   * @param {string} text (optional) text next to the icon
   * @param {int} iconHeight (optional) Icon height in pixels
   */ constructor(label, text, iconHeight){
        // UI creation
        this.e = document.createElement("div");
        this.e.setAttribute("class", "ScreenshotTaker");
        this.e.innerHTML = `
            <a download="${label}_screenshot.png" href=""  >
                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($ca1a8033d79614e0$exports))}" ${iconHeight ? "height=" + iconHeight + "px" : ""} alt="Screenshot"/></a>
            ${text ? text : ""}
        `;
        // UI interaction
        this.e.querySelector("img").addEventListener("click", (_)=>{
            this.screenshotListener(this.e.querySelector("a")); //.href = canvasElement.toDataURL()
        });
    }
    /**
   * Set the listener that will be called when the button is clicked
   * A link element will be passed in to the listener in order to be 
   * assigned a data URL object with the image
   * @param {function} listener 
   */ setScreenshotListener(listener) {
        this.screenshotListener = listener;
    }
}


var $858f4a151fada8c9$exports = {};
$858f4a151fada8c9$exports = new URL("undo-icon.b172f9dc.png", import.meta.url).toString();


var $a269649bd3f50021$exports = {};
$a269649bd3f50021$exports = new URL("redo-icon.691e2ad6.png", import.meta.url).toString();


var $f744828feee63c94$exports = {};
$f744828feee63c94$exports = new URL("play-icon.1244da64.png", import.meta.url).toString();


var $929a167c8a879cbe$exports = {};
$929a167c8a879cbe$exports = new URL("pause-icon.6262a893.png", import.meta.url).toString();



const $a197da9598f0bd1e$var$CELL_BASIS_COLORS = [
    "#C52929",
    "#47A823",
    "#3B5796"
];
const $a197da9598f0bd1e$var$BOND_FACTOR = 1.2; // this factor multiplies the theoretical atoms radius addition
const $a197da9598f0bd1e$var$DUPLICATE_ATOMS_DEFAULT = false;
const $a197da9598f0bd1e$var$nSegments = 10;
class $a197da9598f0bd1e$export$2e2bcd8739ae039 {
    /**
      * @param  {HTMLElement}  hostElement HTML element hosting the canvas
      * @param  {boolean} editable StructureViewer mode
      *   editable/advantage (false) or simple (true)
      * @param  {State | undefined} state
      *   Object representing the state of the Structure builder module
      */ constructor(hostElement, editable = false, state){
        // we need to know the coordinate mode:
        // cartesian or fractional in order to represent them in numbers
        this.editable = editable;
        this.fractionalMode = false;
        this.hostElement = hostElement;
        this.threeViewer = new (0, $e4a79c8070f9e79e$export$2e2bcd8739ae039)(hostElement);
        this.threeViewer.init();
        this.infoCanvas = new (0, $ad3342556a4c2c46$export$2e2bcd8739ae039)(hostElement, !editable, state);
        window.addEventListener("scroll", (_)=>{
            this.infoCanvas.adaptToScroll(window.scrollY);
        }, false);
        if (this.editable) {
            this.atomSelector = new (0, $dfce7e031458e840$export$2e2bcd8739ae039)(this.threeViewer, this.infoCanvas, state);
            const wrapperBox = new (0, $175b311ee190559c$export$2e2bcd8739ae039)("div", ".structure-edit-controls-box");
            this.atomDisplSwitch = new (0, $d773fc3765656ebc$export$2e2bcd8739ae039)("Edit structure");
            wrapperBox.e.appendChild(this.atomDisplSwitch.e);
            this.atomDisplSwitch.setListener((on)=>{
                if (this.threeViewer.params.orthographicCamera) {
                    this.atomSelector.enableAtomDisplacement(on);
                    return true;
                } else return false;
            });
            if (state) {
                this.undoRedoComp = new $a197da9598f0bd1e$var$UndoRedoComponent(state);
                wrapperBox.e.appendChild(this.undoRedoComp.e);
            }
            this.hostElement.appendChild(wrapperBox.e);
        }
        this.createViewingControls();
        this.screenTaker = new (0, $a4e45eea12196606$export$2e2bcd8739ae039)("structure");
        this.screenTaker.e.style = "margin-top: 3px; padding-left: 30px";
        this.screenTaker.setScreenshotListener((linkElement)=>{
            this.threeViewer.render();
            linkElement.href = this.threeViewer.renderer.domElement.toDataURL();
        // this.threeViewer.render()
        });
        this.viewerControls.appendChild(this.screenTaker.e);
        this.editable;
    }
    /**
   * Resets the viewer
   */ reset() {
        this.threeViewer.clearScenes();
        // Clear canvas context
        this.infoCanvas.clear();
        this.threeViewer.render();
    }
    /**
   * Updates the component to a fractional change in the module
   * Listener for the 'update fractional' module level event
   * @param {boolean} fract
   */ updateFractional(fract) {
        this.fractionalMode = fract;
    }
    /**
  * Updates the component to a atom species change
  * Listener for the 'change species' module level event
  * @param {string} species
  * @param {string} color Color code
  */ changeSpeciesColor(species, color) {
        const atoms = this.structure.atoms;
        for(let i = 0; i < atoms.length; i++)if (atoms[i].species === species) this.atoms.children[i].material.color.set((0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesColor(species));
        if (this.duplicateAtoms) this.recalculateDuplicateAtoms(atoms);
    }
    /**
  * Updates the component to an atom change
  * @param {number[]} values Numeric values according to which the coloring takes place
  */ changeAtomsColors(values) {
        const atoms = this.structure.atoms;
        const bySpecies = values === undefined;
        const colorStrings = bySpecies ? atoms.map((atom)=>(0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesColor(atom.species)) : (0, $ab6e98e8f37dab02$export$1c5b3f2362e3e603)(values, true);
        if (bySpecies) this.infoCanvas.legend.setAtomsData(atoms);
        else this.infoCanvas.legend.setColorBar(values, true);
        for(let i = 0; i < atoms.length; i++)this.atoms.children[i].material.color.set(colorStrings[i]);
    }
    /**
  * Updates the component to a new structure
  * Listener for the 'new structure' module level event
  * @param {Structure} structure
  * @param {boolean} reset
  */ setNewStructure(structure, reset = true) {
        // console.log('this.threeViewer.camera.position',this.threeViewer.camera.position)
        if (this.animationTimer !== undefined) clearInterval(this.animationTimer);
        this.threeViewer.clearScenes();
        // Clear canvas context
        this.infoCanvas.clear();
        if (this.animationControl !== undefined) {
            this.hostElement.removeChild(this.animationControl.e);
            this.animationControl = undefined;
        }
        this.setupVisualization(structure, reset);
        this.threeViewer.render();
    }
    selectStructure(structure) {
        // Don't use setNewStructure. Future Basti: Do it manually and save the scene settings.
        this.setNewStructure(structure, false);
        this.undoRedoComp.update();
    }
    /**
   * Updates the component to a structure change
   * Listener for the 'update structure' module level event
   * @param {Structure} structure
   * @param {object} change
   */ updateStructure(structure, change) {
        // console.log('StructureViewer updateStructure', change, structure)
        if (change === undefined || change.type === (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.LATTICE_VECTORS) {
            // General case
            this.threeViewer.clearScenes();
            // Clear canvas context
            this.infoCanvas.clear();
            this.setupVisualization(structure, false);
        } else {
            // Atoms update
            const atoms = structure.atoms;
            let atom = atoms[change.atomIndex];
            let atomMesh = this.atoms.children[change.atomIndex];
            //console.log('updateStructure', change)
            if (change.type === (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.SPECIES) {
                // Atom change (movement or species change)
                let { radius: radius, color: color } = (0, $e64b414b86723191$export$e2a301f55f143803).getRadiusAndColor(atom.species);
                atomMesh.material.color = new $0d23c856ce11c301$export$892596cec99bc70e(color);
                atomMesh.geometry = new $0d23c856ce11c301$export$d5d06a966fec4192(radius, 2 * $a197da9598f0bd1e$var$nSegments, $a197da9598f0bd1e$var$nSegments);
            } else if (change.type === (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.INITMOMENT) ;
            else if (change.type === (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.CONSTRAINT) {
                let atomMeshAdd = this.getMesh(atom.species, false, atom.constraint);
                atomMeshAdd.position.fromArray(atom.position);
                this.atoms.children.splice(change.atomIndex, 1, atomMeshAdd);
                atomMeshAdd.parent = this.atoms;
            } else if (change.type === (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.MOVE) atomMesh.position.fromArray(atom.position);
            else if (change.type === (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.ADD) {
                // Atom creation
                // The atom is already created on the structure atoms array and the index is known
                let atomMeshAdd = this.getMesh(atom.species, false, atom.constraint); // species undefined for that case of a new atom in the structure
                atomMeshAdd.position.fromArray(atom.position);
                this.atoms.children.splice(change.atomIndex, 0, atomMeshAdd);
                atomMeshAdd.parent = this.atoms;
            } else if (change.type === (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.REMOVE) // Atom removal
            this.atoms.remove(atomMesh);
            this.recalculateBonds(atoms);
            if (this.periodic) this.recalculateDuplicateAtoms(atoms); //**** No tested , this.duplicateAtoms)
            //update the legend
            this.infoCanvas.createAtomsLegend(atoms);
        }
        this.threeViewer.render();
    }
    /**
   * Sets up the visualization with a new structure
   * @param  {Structure} data
   * @param  {boolean} resetZoom If the camera zoom has to be reseted
   * @returns {boolean} True if everything was right
   */ setupVisualization(data, resetZoom = true) {
        this.structure = data;
        const atomNum = this.structure.atoms.length;
        const DEFAULT_ZOOM_DISTANCE = 20;
        this.periodic = this.structure.isAPeriodicSystem();
        this.basisVectors = undefined;
        if (this.periodic) this.basisVectors = $f880bd393c028d36$export$f8cb66e0391a6d5f(this.structure.latVectors);
        this.root = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        this.root.name = "structure";
        this.threeViewer.mainScene.add(this.root);
        // Set position and adjust the zoom to the structure size: if the structure is smaller the zoom is larger
        if (this.periodic) {
            this.root.position.copy($f880bd393c028d36$export$50c66d05bd5d6956(this.basisVectors));
            if (resetZoom) {
                let diagonal = this.basisVectors[0].clone().add(this.basisVectors[1]).add(this.basisVectors[2]);
                const factor = this.threeViewer.hostElement.clientWidth / 820 - 0.15;
                this.threeViewer.adjustZoomToStructSize(diagonal.length() * factor); //this.editable ?  diagonal.length() : diagonal.length()*0.4 )
            }
        } else // non-periodic
        if (atomNum === 0) {
            // No atoms
            this.root.position.copy(new $0d23c856ce11c301$export$64b5c384219d3699());
            if (resetZoom) this.threeViewer.adjustZoomToStructSize(DEFAULT_ZOOM_DISTANCE);
        } else {
            // One or more atoms
            const center = $f880bd393c028d36$export$1ae190fb7acac5ec(this.structure.atoms);
            this.root.position.copy(new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(center).negate());
            if (resetZoom) {
                if (atomNum === 1) this.threeViewer.adjustZoomToStructSize(DEFAULT_ZOOM_DISTANCE);
                else {
                    const maxDistance = $f880bd393c028d36$export$e9b2b121b3b3f66f(center, this.structure.atoms);
                    //console.log('maxDistance',center, maxDistance)
                    const factor = maxDistance < 2 ? 4 : 2;
                    this.threeViewer.adjustZoomToStructSize(maxDistance * factor);
                }
            }
        }
        //console.log('this.root.position',this.root.position)
        //setInitialRotation(this.root);
        this.infoCanvas.createAtomsLegend(this.structure.atoms);
        const [regularAtoms, duplicateAtoms] = this.createAtoms(this.structure.atoms);
        this.root.add(this.atoms = regularAtoms);
        // duplicate atoms are added only for periodic systems
        if (this.periodic) {
            this.root.add(this.duplicateAtoms = duplicateAtoms);
            this.duplicateAtoms.visible = $a197da9598f0bd1e$var$DUPLICATE_ATOMS_DEFAULT;
        }
        // duplicate bonds across the cell boundaries. This is an array to store them
        // Only being used for periodic systems
        // In order to be represented they are part of the this.bonds group and created by the regular createBond() method
        this.acrossBonds = [];
        this.bonds = this.createBonds(this.structure.atoms);
        //console.log('this.bonds', this.bonds)
        this.root.add(this.bonds);
        if (this.periodic) {
            this.convCell = this.createCell(0x000000, 1.5);
            this.root.add(this.convCell);
            this.latticeVectors = this.createLatticeVectors();
            this.root.add(this.latticeVectors);
            this.latticeParamsLabels = this.createLatticeParamsLabels();
            this.latticeParamsLabels.name = "lattice-parameters";
            this.latticeParamsLabels.position.copy($f880bd393c028d36$export$50c66d05bd5d6956(this.basisVectors));
            //setInitialRotation(this.latticeParamsLabels);
            this.threeViewer.infoScene.add(this.latticeParamsLabels);
        }
        // console.log('this.root', this.root)
        if (this.editable) {
            // We need atom meshes and structure references in the atomSelector class to detect the mouse on them
            this.atomSelector.atoms = this.atoms; //this.threeViewer.setAtoms(this.atoms)
            this.atomSelector.structure = this.structure;
            this.atomSelector.setAtomHitListener((i)=>{
                const coors = this.fractionalMode ? this.structure.getAtomFractPosition(i) : this.structure.atoms[i].position;
                this.infoCanvas.showAtomInfo(i, this.structure.atoms[i].species, coors);
            });
        }
        // Init viewing options
        this.viewOptionsDropdown.reset(this.periodic, this.threeViewer.params.orthographicCamera);
        return true;
    }
    /**
   * Sets a new structure animation up
   * @param structures {Array<Structure>}
   */ setNewAnimation(structures) {
        let lastFrame = structures.length - 1;
        this.setNewStructure(structures[lastFrame]);
        //console.log('ATOMS', structures[lastFrame], this.atoms)
        if (this.animationControl === undefined) {
            this.animationControl = new $a197da9598f0bd1e$var$AnimationControl(this.threeViewer);
            this.hostElement.appendChild(this.animationControl.e);
        }
        this.animationControl.setFrameNumber(structures.length);
        this.animationControl.setFrame(lastFrame);
        const atomMeshes = this.atoms.children;
        let frame = 0;
        this.animationTimer = setInterval(()=>{
            if (!this.animationControl.running) return;
            // the this.structure represents the current structure being repressented.
            // This is necessary for some methods (e.g.recalculateDuplicateAtoms )
            this.structure = structures[frame];
            if (this.periodic) {
                this.basisVectors = $f880bd393c028d36$export$f8cb66e0391a6d5f(structures[frame].latVectors);
                this.root.position.copy($f880bd393c028d36$export$50c66d05bd5d6956(this.basisVectors));
                // Cell update
                this.root.remove(this.convCell);
                if (this.viewOptionsDropdown.isOptionChecked(this.viewOptionsDropdown.UNIT_CELL_OPTION)) {
                    this.convCell = this.createCell(0x000000, 1.5);
                    this.root.add(this.convCell);
                }
                // Lattice vectors update
                this.root.remove(this.latticeVectors);
                this.threeViewer.infoScene.remove(this.latticeParamsLabels);
                if (this.viewOptionsDropdown.isOptionChecked(this.viewOptionsDropdown.LATTICE_VECTORS_OPTION)) {
                    this.latticeVectors = this.createLatticeVectors();
                    this.root.add(this.latticeVectors);
                    this.latticeParamsLabels = this.createLatticeParamsLabels();
                    this.latticeParamsLabels.name = "lattice-parameters";
                    this.latticeParamsLabels.position.copy($f880bd393c028d36$export$50c66d05bd5d6956(this.basisVectors));
                    this.threeViewer.infoScene.add(this.latticeParamsLabels);
                }
            } else {
                // Non periodic
                let center = $f880bd393c028d36$export$1ae190fb7acac5ec(structures[frame].atoms);
                this.root.position.copy(new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(center).negate());
            }
            // Atoms update
            for(let i = 0; i < atomMeshes.length; i++)atomMeshes[i].position.fromArray(structures[frame].atoms[i].position);
            if (this.periodic) this.recalculateDuplicateAtoms(structures[frame].atoms);
            // Bonds update
            this.root.remove(this.bonds);
            this.bonds = this.createBonds(structures[frame].atoms);
            // *** This could be optimized changing all bond ends
            this.root.add(this.bonds);
            // this.acrossBonds are included into this.bonds
            this.threeViewer.render();
            this.animationControl.setFrame(frame);
            frame++;
            //console.log('Structure frame', frame)
            if (frame > lastFrame) frame = 0;
        }, 400);
    }
    /**
   * Creates the dropdown controling the scene visualization elements
   */ createViewingControls() {
        this.viewerControls = document.createElement("div");
        this.hostElement.appendChild(this.viewerControls);
        this.viewerControls.className = "viewing-controls";
        this.viewOptionsDropdown = new (0, $d0f2ff312a753924$export$2e2bcd8739ae039)(); //this)
        this.viewerControls.appendChild(this.viewOptionsDropdown.e);
        this.viewOptionsDropdown.setCheckListener((e)=>{
            //console.log('setCheckListener e', e.target.name)
            if (e.target.name === this.viewOptionsDropdown.ATOMS_DUPLICATED_OPTION) this.duplicateAtoms.visible = e.target.checked;
            else if (e.target.name === this.viewOptionsDropdown.BONDS_OPTION) {
                this.viewOptionsDropdown.getBondsAcrossOptionElement().style.display = e.target.checked && this.periodic ? "block" : "none";
                this.bonds.visible = e.target.checked;
                console.log("this.root", this.bonds, this.bonds.visible);
            //this.root.visible = e.target.checked
            } else if (e.target.name === this.viewOptionsDropdown.BONDS_BOUNDARIES_OPTION) this.acrossBonds.forEach((b)=>b.visible = e.target.checked);
            else if (e.target.name === this.viewOptionsDropdown.UNIT_CELL_OPTION) this.convCell.visible = e.target.checked;
            else if (e.target.name === this.viewOptionsDropdown.LATTICE_VECTORS_OPTION) {
                this.latticeVectors.visible = e.target.checked;
                this.latticeParamsLabels.visible = e.target.checked;
            } else if (e.target.name === this.viewOptionsDropdown.ORTHOGRAPHIC_CAMERA) {
                this.threeViewer.params.orthographicCamera = e.target.checked;
                this.atomDisplSwitch.switchOff();
                this.atomSelector.enableAtomDisplacement(false);
                this.threeViewer.camera = e.target.checked ? this.threeViewer.orthographicCamera : this.threeViewer.perspectiveCamera;
                this.atomSelector.camera = this.threeViewer.camera;
                this.threeViewer.controls.dispose();
                this.threeViewer.setupControls();
            // this.updateStructure(this.structure)
            } else {
                // wrap-atoms-into-cell
                let atomsData = this.structure.atoms;
                // Change the atoms positions
                for(let i = 0; i < atomsData.length; i++)this.atoms.children[i].position.fromArray(e.target.checked ? twoModOneAndGetCartesians(this.structure, i) : atomsData[i].position);
                // Update the bonds
                if (e.target.checked) atomsData = getWrappedAtomsData(this.structure);
                this.recalculateBonds(atomsData);
            }
            this.threeViewer.render();
        });
        function twoModOneAndGetCartesians(structureData, i) {
            const v = structureData.getAtomFractPosition(i);
            let newFractCoors = [
                (v[0] % 1 + 1) % 1,
                (v[1] % 1 + 1) % 1,
                (v[2] % 1 + 1) % 1
            ];
            return structureData.getCartesianCoordinates(newFractCoors);
        }
        function getWrappedAtomsData(structureData) {
            const atomsData = structureData.atoms;
            let atomsDataForNewBonds = [];
            //console.log(atomsData.length, this.atoms.children.length)
            for(let i = 0; i < atomsData.length; i++)// Data for the creation of new bonds
            atomsDataForNewBonds.push({
                "position": twoModOneAndGetCartesians(structureData, i),
                "species": atomsData[i].species
            });
            return atomsDataForNewBonds;
        }
    }
    /**
   * Recalculates the bonds for new atom positions
   * @param  {Array<object>} atomsData
   */ recalculateBonds(atomsData) {
        this.root.remove(this.bonds);
        this.threeViewer.clearObject(this.bonds);
        this.bonds = this.createBonds(atomsData, this.periodic);
        this.root.add(this.bonds);
        this.bonds.visible = this.viewOptionsDropdown.isBondsOptionChecked();
        // If the bonds across checkbox is checked these bonds have to be set visible (created not visible)
        if (this.viewOptionsDropdown.isBondsAcrossOptionChecked()) this.acrossBonds.forEach((b)=>b.visible = true);
    }
    /**
   * Creates the cell box
   * @param  {string} color
   * @param  {int} linewidth
   */ createCell(color, linewidth) {
        const basisVectors = this.basisVectors;
        let origin = new $0d23c856ce11c301$export$64b5c384219d3699(); // 0,0,0 point
        let cell = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4(); // holding the cell lines
        let lineMaterial = new $0d23c856ce11c301$export$fbaaa33907730a0c({
            color: color,
            linewidth: linewidth
        });
        // Draws two lines per basis vector to complete the cube (cell)
        // The first line is compound of 3 segments and the second of 1
        // 3+1 = 4 segments (cube edges) x 3 basis vectors = 12 total cube edges
        for(let len = basisVectors.length, i = 0; i < len; ++i){
            const basisVector = basisVectors[i].clone();
            // Forms the first line (3 segments) geometry
            let thirdPoint = basisVectors[(i + 1) % len].clone().add(basisVector);
            let fourthPoint = basisVectors[(i + 2) % len].clone().add(thirdPoint);
            // lineGeometry.vertices.push(origin, basisVector, thirdPoint, fourthPoint);
            let lineGeometry = new $0d23c856ce11c301$export$b7be63a67df8959().setFromPoints([
                origin,
                basisVector,
                thirdPoint,
                fourthPoint
            ]);
            cell.add(new $0d23c856ce11c301$export$17d680238e50603e(lineGeometry, lineMaterial));
            // lineGeometry.computeLineDistances();
            // Forms the second line (1 segment) geometry
            // let lineGeometry2 = new THREE.Geometry();
            // lineGeometry2.vertices.push(basisVector,
            // basisVector.clone().add(basisVectors[(i === 0 ? 2 : i-1)]));
            let lineGeometry2 = new $0d23c856ce11c301$export$b7be63a67df8959().setFromPoints([
                basisVector,
                basisVector.clone().add(basisVectors[i === 0 ? 2 : i - 1])
            ]);
            cell.add(new $0d23c856ce11c301$export$17d680238e50603e(lineGeometry2, lineMaterial));
        //console.log('cell created:',cell);
        }
        return cell;
    }
    /**
   * Create the atom meshes, both the regular atoms and the duplicate ones
   * @param  {Array<Array<object>>} atomsData
   */ createAtoms(atomsData) {
        let atoms = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        atoms.name = "atoms";
        let duplAtoms = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        // Code snippet for instanced atom meshes:
        // let species = {}
        // atomsData.forEach((atom,iAtom) => {
        // 	if (species[atom.species]){
        // 		species[atom.species].push(iAtom)
        // 	} else {
        // 		species[atom.species] = [iAtom]
        // 	}
        // })
        // console.log(species);
        // for (let [key,value] of Object.entries(species)){
        // 	const {radius, color} = Conf.getRadiusAndColor(key)
        // 	const matProps = { color: color }
        // 	const geometry = new THREE.IcosahedronGeometry( radius, 2 )//THREE.SphereBufferGeometry(radius, 2*nSegments, nSegments)
        // 	const material = new THREE.MeshLambertMaterial(matProps)
        // 	const matrix = new THREE.Matrix4();
        // 	let mesh = new THREE.InstancedMesh( geometry, material, value.length )
        // 	value.forEach((ind,i) => {
        // 		matrix.setPosition(atomsData[ind].position[0],atomsData[ind].position[1],atomsData[ind].position[2])
        // 		mesh.setMatrixAt( i, matrix )
        // 	})
        // 	atoms.add(mesh)
        // }
        for(let i = 0; i < atomsData.length; i++){
            const atomData = atomsData[i];
            // const elementIndex = (atomData.species === undefined ? -1 : Conf.ELEMENT_NAMES.indexOf(atomData.species))
            let atomMesh = this.getMesh(atomData.species, false, atomData.constraint); //, atomsData.length)
            atomMesh.position.copy(new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(atomData.position));
            atoms.add(atomMesh);
            if (this.periodic && this.structure !== undefined) this.calculateDuplicateAtom(atomData, duplAtoms);
        } // for
        return [
            atoms,
            duplAtoms
        ];
    }
    /**
   * Recalculates the duplicate atoms
   * @param  {Array<object>} atomsData
   */ recalculateDuplicateAtoms(atomsData) {
        // *** release old duplicate atoms memory
        this.threeViewer.clearObject(this.duplicateAtoms);
        for(let i = 0; i < atomsData.length; i++){
            const atomData = atomsData[i];
            this.calculateDuplicateAtom(atomData, this.duplicateAtoms);
        }
    }
    /**
   * Calculates the duplicate atoms
   * @param  {Array<object>} atomData
   * @param  {Array<object>} duplAtoms Array to be populated with the new atoms
   */ calculateDuplicateAtom(atomData, duplAtoms) {
        // If the atom sits on the cell surface, add the mirror images
        const fractPos = this.structure.getFractionalCoordinates(atomData.position);
        let xZero = almostZero(fractPos[0]);
        let yZero = almostZero(fractPos[1]);
        let zZero = almostZero(fractPos[2]);
        if (xZero && yZero && zZero) // Duplicate (x7) the atom at the 0,0,0 position
        this.duplicateAtomsMethod(duplAtoms, atomData.species, fractPos, [
            [
                1,
                0,
                0
            ],
            [
                0,
                1,
                0
            ],
            [
                0,
                0,
                1
            ],
            [
                1,
                1,
                0
            ],
            [
                0,
                1,
                1
            ],
            [
                1,
                0,
                1
            ],
            [
                1,
                1,
                1
            ]
        ]);
        else if (xZero && yZero && fractPos[2] > 0) // Duplicate (x3) the atoms along the z axis
        this.duplicateAtomsMethod(duplAtoms, atomData.species, fractPos, [
            [
                1,
                0,
                0
            ],
            [
                0,
                1,
                0
            ],
            [
                1,
                1,
                0
            ]
        ]);
        else if (fractPos[0] > 0 && yZero && zZero) // Duplicate (x3) the atoms along the x axis
        this.duplicateAtomsMethod(duplAtoms, atomData.species, fractPos, [
            [
                0,
                1,
                0
            ],
            [
                0,
                0,
                1
            ],
            [
                0,
                1,
                1
            ]
        ]);
        else if (xZero && fractPos[1] > 0 && zZero) // Duplicate (x3) the atoms along the y axis
        this.duplicateAtomsMethod(duplAtoms, atomData.species, fractPos, [
            [
                1,
                0,
                0
            ],
            [
                0,
                0,
                1
            ],
            [
                1,
                0,
                1
            ]
        ]);
        else if (xZero && fractPos[1] > 0 && fractPos[2] > 0) // Duplicate (x1) the atoms on the YZ plane
        this.duplicateAtomsMethod(duplAtoms, atomData.species, fractPos, [
            [
                1,
                0,
                0
            ]
        ]);
        else if (fractPos[0] > 0 && yZero && fractPos[2] > 0) // Duplicate (x1) the atoms on the XZ plane
        this.duplicateAtomsMethod(duplAtoms, atomData.species, fractPos, [
            [
                0,
                1,
                0
            ]
        ]);
        else if (fractPos[0] > 0 && fractPos[1] > 0 && zZero) // Duplicate (x1) the atoms on the XY plane
        this.duplicateAtomsMethod(duplAtoms, atomData.species, fractPos, [
            [
                0,
                0,
                1
            ]
        ]);
        function almostZero(value) {
            return value === 0;
        }
    }
    /**
   * Returns an atom mesh
   * @param  {string} species
   * @param  {boolean} transparent
   * @param  {boolean} constraint
   * @return {THREE.Mesh}
   */ getMesh(species, transparent, constraint) {
        let { radius: radius, color: color } = (0, $e64b414b86723191$export$e2a301f55f143803).getRadiusAndColor(species);
        //const nSegments = 18 // 5 + Math.ceil(15*(1 - numAtoms/2500)*radius)//
        let matProps = {
            color: color
        };
        if (transparent) {
            matProps.transparent = true;
            matProps.opacity = 0.6;
        }
        return new $0d23c856ce11c301$export$e176487c05830cc5(new $0d23c856ce11c301$export$d5d06a966fec4192(radius, 2 * $a197da9598f0bd1e$var$nSegments, $a197da9598f0bd1e$var$nSegments), constraint ? new $0d23c856ce11c301$export$55cbcc9b622fe1f5(matProps) : new $0d23c856ce11c301$export$5023a9a8114806b8(matProps));
    }
    /**
   * Duplicates atoms for a species based on plains and axes
   * and adds them to an array
   * @param  {Array<object>} atoms Array to be populated with the new atoms
   * @param  {int} elementIndex Species index
   * @param  {Array<float>} fractPosition
   * @param  {Array<Array<int>>} shifts Places for the atom to be duplicated
   */ duplicateAtomsMethod(atoms, elementIndex, fractPosition, shifts) {
        shifts.forEach((shift)=>{
            let fractFinalPos = $a4310c0d7cebdf93$export$24b4d95b6fbb3080(fractPosition, shift);
            const finalPos = this.structure.getCartesianCoordinates(fractFinalPos);
            //console.log('duplicateAtoms', structureData.atoms.length)
            let nMesh = this.getMesh(elementIndex, true, false); //, structureData.atoms.length)
            nMesh.position.copy(new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(finalPos));
            atoms.add(nMesh);
        });
    }
    createBonds(atomsData) {
        const corners = iterProduct([
            -1,
            1,
            0
        ], 3);
        let cornersNoZero = [];
        corners.forEach((corner)=>{
            if (corner[0] !== 0 || corner[1] !== 0 || corner[2] !== 0) cornersNoZero.push(corner);
        });
        let basisMatrix;
        let basisMatrix_inv;
        let maxBondRadius = 0;
        let binNumbers;
        let faceDist;
        let species = new Set(atomsData.map((atom)=>atom.species));
        species.forEach((s)=>{
            maxBondRadius = Math.max(maxBondRadius, (0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesRadius(s));
        });
        maxBondRadius *= 2;
        if (this.periodic) {
            basisMatrix = this.basisVectors.map((v)=>[
                    v.x,
                    v.y,
                    v.z
                ]);
            basisMatrix_inv = $a4310c0d7cebdf93$export$a48d4501dfd597fa(basisMatrix);
            let basisMatrix_inv_T = $a4310c0d7cebdf93$export$271d2f969e55c97(basisMatrix_inv);
            faceDist = basisMatrix_inv_T.map((v)=>{
                let norm = $a4310c0d7cebdf93$export$79376507b09a66f(v, [
                    0,
                    0,
                    0
                ]);
                return norm > 0 ? 1 / norm : 1;
            });
            binNumbers = faceDist.map((d)=>Math.max(parseInt(d / maxBondRadius), 1));
        } else binNumbers = [
            1,
            1,
            1
        ];
        console.log("maxBondRadius", maxBondRadius);
        let binFracs = [
            1.0 / binNumbers[0],
            1.0 / binNumbers[1],
            1.0 / binNumbers[2]
        ];
        // console.log("binFracs",binFracs);
        let bins = new Map();
        let binNeighbors = new Map();
        let outsideBin = []; // Collecting all atoms that are outside the unit cell.
        for(let i = 0; i < binNumbers[0]; i++){
            for(let j = 0; j < binNumbers[1]; j++)for(let k = 0; k < binNumbers[2]; k++){
                // console.log(currentIndex,diffIndex);
                let i_bin = [
                    i,
                    j,
                    k
                ].join(",");
                bins.set(i_bin, []);
                let neighborBin = [];
                if (this.periodic) cornersNoZero.forEach((corner)=>{
                    // console.log("corner,diffIndex",corner,diffIndex,cornersNoZero.length);
                    if (k > 0 && corner[2] < 0 && corner[0] === 0 && corner[1] === 0 || k > 0 && j > 0 && corner[1] < 0 && corner[0] === 0 || k > 0 && j > 0 && k > 0 && corner[0] < 0) ;
                    else {
                        // console.log("I am in");
                        let n = [
                            i + corner[0],
                            j + corner[1],
                            k + corner[2]
                        ];
                        neighborBin.push(n.join(","));
                    }
                });
                else // not periodic! no neighbors
                neighborBin = [];
                binNeighbors.set(i_bin, neighborBin);
            }
        }
        if (this.periodic) atomsData.forEach((atom)=>{
            let x = vectorDotMatrix(atom.position, basisMatrix_inv);
            x = x.map((x)=>parseFloat(x.toFixed(12))); // We need some float cleaning
            // let iAmDetected = false
            if (x.some((i)=>i >= 1 || i < 0)) {
                console.log("I am outside");
                outsideBin.push(atom);
                return;
            }
            let i = Math.floor(x[0] / binFracs[0]);
            let j = Math.floor(x[1] / binFracs[1]);
            let k = Math.floor(x[2] / binFracs[2]);
            console.log(i, j, k);
            bins.get([
                i,
                j,
                k
            ].join(",")).push(atom);
        });
        else // Non-periodic: put all atoms in one bin
        bins.get("0,0,0").push(...atomsData);
        // console.log(binFracs);
        // console.log(binNeighbors);
        // console.log("bins", bins);
        if (this.bondMaterial === undefined) this.bondMaterial = new $0d23c856ce11c301$export$5023a9a8114806b8({
            color: 0xFFFFFF
        });
        const tooCloseMaterial = new $0d23c856ce11c301$export$5023a9a8114806b8({
            color: 0xFF0000
        });
        let bonds = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        bonds.name = "bonds";
        bins.forEach((bin, iBin)=>{
            // console.log(bin);
            for(let i_atom_1 = 0; i_atom_1 < bin.length; ++i_atom_1){
                let pos1 = bin[i_atom_1].position;
                let r1 = bin[i_atom_1].radius;
                for(let i_atom_2 = i_atom_1 + 1; i_atom_2 < bin.length; ++i_atom_2){
                    // Intra-bin bonds
                    let pos2 = bin[i_atom_2].position;
                    let r2 = bin[i_atom_2].radius;
                    let v = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(pos1, pos2); // i-j in cartesian coodinates
                    const minAtomsSep = (r1 + r2) * $a197da9598f0bd1e$var$BOND_FACTOR;
                    const minAtomsDist = 0.6 * minAtomsSep;
                    let vnorm = Math.sqrt(v[0] ** 2 + v[1] ** 2 + v[2] ** 2);
                    // console.log(i_atom_1,i_atom_2,vnorm,minAtomsSep);
                    if (vnorm < minAtomsSep && vnorm > 1e-8) {
                        // If the atom in the cell is near
                        //let bondEndPos = mathlib.addArrays(pos2, mathlib.multiplyScalar(unitVector, RADIUS_FACTOR*r2))
                        if (vnorm > minAtomsDist) bonds.add(createBondMesh(pos1, pos2, this.bondMaterial)); // bondEndPos))
                        else bonds.add(createBondMesh(pos1, pos2, tooCloseMaterial, 0.15));
                    }
                }
                binNeighbors.get(iBin).forEach((iBinNeighbor)=>{
                    // console.log(iBinNeighbor, iBinNeighbor.split(',').map(x=>parseInt(x)));
                    let indices = iBinNeighbor.split(",").map((x)=>parseInt(x));
                    // console.log(indices);
                    if (indices.some((x)=>x < 0) || indices.some((x, i)=>x >= binNumbers[i])) {
                        // bonds from bins across boundaries
                        let shiftVector = [
                            0,
                            0,
                            0
                        ];
                        let realIndices = indices.map((ind, iInd)=>{
                            if (ind === -1) {
                                shiftVector = $a4310c0d7cebdf93$export$e16d8520af44a096(shiftVector, $a4310c0d7cebdf93$export$c697bed75648cdb7(basisMatrix[iInd], -1));
                                return ind + binNumbers[iInd];
                            } else if (ind === binNumbers[iInd]) {
                                shiftVector = $a4310c0d7cebdf93$export$e16d8520af44a096(shiftVector, basisMatrix[iInd]);
                                return 0;
                            } else return ind;
                        });
                        // console.log("shiftVector,realIndices",shiftVector,realIndices);
                        let binNeighborAtoms = bins.get(realIndices.join(","));
                        for(let i_atom_N = 0; i_atom_N < binNeighborAtoms.length; ++i_atom_N){
                            let pos2 = binNeighborAtoms[i_atom_N].position;
                            let r2 = (0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesRadius(binNeighborAtoms[i_atom_N].species);
                            let v2 = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3($a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(pos1, pos2), shiftVector);
                            const minAtomsSep = (r1 + r2) * $a197da9598f0bd1e$var$BOND_FACTOR;
                            const minAtomsDist = 0.6 * minAtomsSep;
                            let vnorm2 = Math.sqrt(v2[0] ** 2 + v2[1] ** 2 + v2[2] ** 2);
                            if (vnorm2 < minAtomsSep && vnorm2 > 1e-8) {
                                let altPos2 = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(pos1, $a4310c0d7cebdf93$export$67275f837d70084d(v2, 1.25));
                                let pos2PlusBondv = $a4310c0d7cebdf93$export$e16d8520af44a096(pos2, $a4310c0d7cebdf93$export$67275f837d70084d(v2, 1.25));
                                if (vnorm2 > minAtomsDist) {
                                    // First stick creation (one side of the cell)
                                    bonds.add(createAcrossBoundaryBondMesh(pos1, altPos2, this.acrossBonds, this.bondMaterial));
                                    // Second stick creation: in this case (bonds across the cell boundary) the bond has to be duplicated
                                    // The corresponding atoms of the pair are separated and far in the cell, so both need a different bond representation
                                    bonds.add(createAcrossBoundaryBondMesh(pos2, pos2PlusBondv, this.acrossBonds, this.bondMaterial));
                                } else {
                                    bonds.add(createAcrossBoundaryBondMesh(pos1, altPos2, this.acrossBonds, tooCloseMaterial, 0.15));
                                    bonds.add(createAcrossBoundaryBondMesh(pos2, pos2PlusBondv, this.acrossBonds, tooCloseMaterial, 0.15));
                                }
                            }
                        }
                    // return
                    } else {
                        // Normal case: no bins across boundaries
                        let binNeighborAtoms = bins.get(iBinNeighbor);
                        // console.log(iBinNeighbor,binNeighborAtoms);
                        for(let i_atom_N = 0; i_atom_N < binNeighborAtoms.length; ++i_atom_N){
                            // Inter-bin bonds
                            let pos2 = binNeighborAtoms[i_atom_N].position;
                            let r2 = (0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesRadius(binNeighborAtoms[i_atom_N].species);
                            let v = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(pos1, pos2); // i-j in cartesian coodinates
                            const minAtomsSep = (r1 + r2) * $a197da9598f0bd1e$var$BOND_FACTOR;
                            const minAtomsDist = 0.6 * minAtomsSep;
                            let vnorm = Math.sqrt(v[0] ** 2 + v[1] ** 2 + v[2] ** 2);
                            if (vnorm < minAtomsSep && vnorm > 1e-8) {
                                // If the atom in the cell is near
                                //let bondEndPos = mathlib.addArrays(pos2, mathlib.multiplyScalar(unitVector, RADIUS_FACTOR*r2))
                                if (vnorm > minAtomsDist) bonds.add(createBondMesh(pos1, pos2, this.bondMaterial)); // bondEndPos))
                                else bonds.add(createBondMesh(pos1, pos2, tooCloseMaterial, 0.15));
                            }
                        }
                    }
                });
            }
        });
        outsideBin.forEach((atom)=>{
            let pos1 = atom.position;
            let r1 = (0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesRadius(atom.species);
            for(let i_atom_2 = 0; i_atom_2 < atomsData.length; ++i_atom_2){
                let pos2 = atomsData[i_atom_2].position;
                let r2 = (0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesRadius(atomsData[i_atom_2].species);
                let v = $a4310c0d7cebdf93$export$4e2d2ead65e5f7e3(pos1, pos2); // i-j in cartesian coodinates
                const minAtomsSep = (r1 + r2) * $a197da9598f0bd1e$var$BOND_FACTOR;
                const minAtomsDist = 0.6 * minAtomsSep;
                let vnorm = Math.sqrt(v[0] ** 2 + v[1] ** 2 + v[2] ** 2);
                if (vnorm < minAtomsSep && vnorm > 1e-8) {
                    // If the atom in the cell is near
                    //let bondEndPos = mathlib.addArrays(pos2, mathlib.multiplyScalar(unitVector, RADIUS_FACTOR*r2))
                    if (vnorm > minAtomsDist) bonds.add(createBondMesh(pos1, pos2, this.bondMaterial)); // bondEndPos))
                    else bonds.add(createBondMesh(pos1, pos2, tooCloseMaterial, 0.15));
                }
            }
        });
        return bonds;
        function vectorDotMatrix(A, B) {
            //*** Move to the math.js module
            let result = [
                0.,
                0.,
                0.
            ];
            result[0] = A[0] * B[0][0] + A[1] * B[1][0] + A[2] * B[2][0];
            result[1] = A[0] * B[0][1] + A[1] * B[1][1] + A[2] * B[2][1];
            result[2] = A[0] * B[0][2] + A[1] * B[1][2] + A[2] * B[2][2];
            return result;
        }
        function createBondMesh(startPos, endPos, material, rad = 0.05) {
            return $f880bd393c028d36$export$2a1e684e74282069(new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(startPos), new $0d23c856ce11c301$export$64b5c384219d3699().fromArray(endPos), rad, 5, material); //new THREE.MeshPhongMaterial({ color: 0xFFFFFF }) )
        }
        function createAcrossBoundaryBondMesh(startPos, endPos, acrossBonds, material, rad = 0.05) {
            let bondMesh = createBondMesh(startPos, endPos, material, rad);
            bondMesh.visible = false;
            acrossBonds.push(bondMesh);
            return bondMesh;
        }
        function iterProduct(array, repeat = 1) {
            let args = Array(repeat).fill(array);
            return args.reduce((accumulator, value)=>{
                let tmp = [];
                accumulator.forEach((a0)=>{
                    value.forEach((a1)=>{
                        tmp.push(a0.concat(a1));
                    });
                });
                return tmp;
            }, [
                []
            ]);
        }
    }
    /**
   * Creates the lattice vectors meshes
   * @return {THREE.Group}
   */ createLatticeVectors() {
        let latticeVectors = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        const origin = new $0d23c856ce11c301$export$64b5c384219d3699();
        let minVectorLength = Math.min(this.basisVectors[0].length(), this.basisVectors[1].length(), this.basisVectors[2].length());
        // console.log('minVectorLength', minVectorLength)
        for(let basisIndex = 0; basisIndex < 3; ++basisIndex){
            const color = $a197da9598f0bd1e$var$CELL_BASIS_COLORS[basisIndex];
            const basisVector = this.basisVectors[basisIndex].clone();
            // Add basis vector colored line
            const vectorMaterial = new $0d23c856ce11c301$export$55cbcc9b622fe1f5({
                color: color,
                transparent: true,
                opacity: 0.8
            });
            const radius = minVectorLength > 20 ? 0.2 : minVectorLength * 0.01;
            let basisVectorMesh = $f880bd393c028d36$export$2a1e684e74282069(origin, basisVector, radius, 10, vectorMaterial);
            latticeVectors.add(basisVectorMesh);
            // Add an arrow following the basis vector direction
            let arrowMesh = $f880bd393c028d36$export$8f7d98f7c012cca0(origin, basisVector, minVectorLength);
            latticeVectors.add(arrowMesh);
        }
        return latticeVectors;
    }
    /**
   * Creates and returns the lattice parameters labels
   * @return {THREE.Group}
   */ createLatticeParamsLabels() {
        let latticeParams = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        // const origin = new THREE.Vector3();
        const labels = [
            "a",
            "b",
            "c"
        ];
        const angleLabels = [
            "\u03B3",
            "\u03B1",
            "\u03B2"
        ];
        const minVectorLength = Math.min(this.basisVectors[0].length(), this.basisVectors[1].length(), this.basisVectors[2].length());
        for(let basisIndex = 0; basisIndex < 3; ++basisIndex){
            const color = $a197da9598f0bd1e$var$CELL_BASIS_COLORS[basisIndex];
            const basisVector = this.basisVectors[basisIndex].clone();
            const nextBasisVector = this.basisVectors[(basisIndex + 1) % 3].clone();
            let labelPos = basisVector.clone().normalize().multiplyScalar(basisVector.length() + (minVectorLength + 2) * 0.14 + 0.4);
            let vectorLabelSprite = $f880bd393c028d36$export$f2839682b8c07f35(labels[basisIndex], color, labelPos, minVectorLength);
            latticeParams.add(vectorLabelSprite);
            //this.axisLabels.push(axisLabel);
            let angleLabelPos = basisVector.clone().add(nextBasisVector).multiplyScalar(0.15);
            let angleLabelSprite = $f880bd393c028d36$export$f2839682b8c07f35(angleLabels[basisIndex], "#FFFFFF", angleLabelPos, minVectorLength);
            latticeParams.add(angleLabelSprite);
        // let radius = Math.max(Math.min(0.18*basisVector.length(), 0.18*nextBasisVector.length()), 1);
        // let angle = basisVector.angleTo(nextBasisVector);
        // let points = new THREE.EllipseCurve(0, 0, radius, radius, 0, angle, false).getPoints(20);
        // let arcGeometry = new THREE.BufferGeometry().setFromPoints( points );
        //arcGeometry.computeLineDistances();
        // let arcMesh = new THREE.Line(arcGeometry, new THREE.LineBasicMaterial( { color : 0x606060 } ));
        // First rotate the arc so that it's x-axis points towards the
        // first basis vector that defines the arc
        // let xAxis = new THREE.Vector3(1, 0, 0);
        // let quaternion = new THREE.Quaternion().setFromUnitVectors(xAxis, basisVector.clone().normalize());
        // arcMesh.quaternion = quaternion;
        // Then rotate the arc along it's x axis so that the xy-plane
        // coincides with the plane defined by the the two basis vectors
        // that define the plane.
        // console.log(points);
        // let lastArcPointLocal = points[points.length-1];
        // arcMesh.updateMatrixWorld(); // The positions are not otherwise updated properly
        // let lastArcPointWorld = arcMesh.localToWorld(lastArcPointLocal.clone());
        // The angle direction is defined by the first basis vector
        //let axis = basisVec1;
        // let normal = new THREE.Vector3().crossVectors(basisVector, nextBasisVector);
        // let arcNormal = new THREE.Vector3().crossVectors(basisVector, lastArcPointWorld);
        // let planeAngle = normal.angleTo(arcNormal);
        // let planeCross = new THREE.Vector3().crossVectors(nextBasisVector, lastArcPointWorld);
        // let directionValue = planeCross.dot(basisVector);
        // if (directionValue > 0)     planeAngle = -planeAngle;
        // arcMesh.rotateX(planeAngle);
        // latticeParams.add(arcMesh);
        }
        return latticeParams;
    }
    /**
      * Highligths an atom
      * @param  {int} atomIndex Index of atom to highlight
      * @param  {boolean} on
      *   If true the atom is highlighted if false it's toned-down
      */ highlightAtom(atomIndex, on) {
        this.atomSelector.highlightAtom(atomIndex, on);
    }
}
/**
 * Undo/redo functionality UI component. HTML layer on the canvas
 */ class $a197da9598f0bd1e$var$UndoRedoComponent {
    /**
   * @param provider {State} Undo/redo functionality provider
   */ constructor(provider){
        this.provider = provider;
        // UI creation
        this.e = document.createElement("div");
        this.e.setAttribute("class", "UndoRedoComponent");
        this.e.innerHTML = `
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($858f4a151fada8c9$exports))}" width="30px"  alt="Undo"/>
            <span> 0/0 </span>
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($a269649bd3f50021$exports))}" width="30px" alt="Redo"/>
        `;
        // UI interaction
        let buttons = this.e.querySelectorAll("img");
        buttons[0].addEventListener("click", (_)=>{
            this.provider.undo();
        });
        buttons[1].addEventListener("click", (_)=>{
            this.provider.redo();
        });
        const indexElement = this.e.querySelector("span");
        this.provider.setUndoRedoListener((index, listLength)=>{
            indexElement.innerHTML = index + "/" + listLength;
        });
    }
    update() {
        this.provider.undoRedoListener(this.provider.undoIndex + 1, this.provider.changeList.length);
    }
}
/**
 * Structure animation control UI component. HTML layer on the canvas
 */ class $a197da9598f0bd1e$var$AnimationControl extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(threeViewer){
        super("div", ".AnimationControl");
        this.threeViewer = threeViewer;
        this.running = false;
        // UI creation
        this.frameLabel = document.createElement("span");
        this.e.appendChild(this.frameLabel);
        this.button = document.createElement("img");
        this.button.src = (0, (/*@__PURE__*/$parcel$interopDefault($f744828feee63c94$exports)));
        this.e.appendChild(this.button);
        // UI interaction
        this.button.addEventListener("click", (_)=>{
            this.running = !this.running;
            this.button.src = this.running ? (0, (/*@__PURE__*/$parcel$interopDefault($929a167c8a879cbe$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($f744828feee63c94$exports)));
        });
    }
    /**
   * Sets the animation frame number
   * @param {int} frameNum
   */ setFrameNumber(frameNum) {
        this.lastFrame = frameNum - 1;
    }
    /**
   * Sets the current frame
   * @param {int} frame
   */ setFrame(frame) {
        this.frameLabel.textContent = frame + "/" + this.lastFrame;
    }
}


/**
 * @author Iker Hurtado
 *
 * @overview File holding the module State class
 */ 


/**
 * @author Andrey Sobolev <sobolev@fhi.mpg.de>
 *
 * @overview File holding the class describing undoable changes to the Structure
 */ 
class $6bb38ef6a79206a1$export$2e2bcd8739ae039 {
    /**
   * A class representing changes to structure
   * @param state {State}
   * @param changeType {string|undef}
   * @param atomIndex {number|undef}
   * @param detail {Object|undef}
   * @param setChange {boolean} if there's a need to register for undo possibility
   */ constructor(state, changeType, atomIndex, detail, setChange = true){
        this.state = state;
        this.steps = [];
        // atomIndex, detail can be undefined/null, e.g. when adding atoms
        if (changeType !== null) this.addStep(changeType, atomIndex, detail);
        if (setChange) this.state.addChange(this);
        this.done = false;
    }
    addStep(changeType, atomIndex, detail) {
        this.steps.push(new $6bb38ef6a79206a1$var$ChangeStep(this.state, changeType, atomIndex, detail));
    }
    do() {
        if (!this.done) this.steps.forEach((s)=>s.run());
        this.done = true;
    }
    undo() {
        if (this.done) this.steps.slice().reverse().forEach((s)=>s.run(true));
        this.done = false;
    }
}
class $6bb38ef6a79206a1$var$ChangeStep {
    constructor(state, changeType, atomIndex, detail){
        this.state = state;
        this.type = changeType;
        this.atom = atomIndex;
        this.detail = detail !== undefined ? detail : [
            undefined,
            undefined
        ];
    }
    run(undo = false) {
        const res = undo ? this.detail[0] : this.detail[1];
        switch(this.type){
            case (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.SUPERCELL:
                this.state.setStructure(this.detail.update[1], false);
                break;
            case (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.SPECIES:
                this.state.structure.updateAtomSpecies(this.atom, res);
                this.state.emitStructureChange({
                    type: (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.SPECIES,
                    atomIndex: this.atom
                });
                break;
            case (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.INITMOMENT:
                this.state.structure.updateAtomInitMoment(this.atom, res);
                this.state.emitStructureChange({
                    type: (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.INITMOMENT,
                    atomIndex: this.atom
                });
                break;
            case (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.CHARGE:
                this.state.structure.updateAtomCharge(this.atom, res);
                this.state.emitStructureChange({
                    type: (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.CHARGE,
                    atomIndex: this.atom
                });
                break;
            case (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.CONSTRAINT:
                this.state.structure.updateAtomConstraint(this.atom, res);
                this.state.emitStructureChange({
                    type: (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.CONSTRAINT,
                    atomIndex: this.atom
                });
                break;
            case (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.MOVE:
                this.state.structure.updateAtomPosition(this.atom, res);
                this.state.emitStructureChange({
                    type: (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.MOVE,
                    atomIndex: this.atom
                });
                break;
            case (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.ADD:
                const isNewAtom = this.atom === undefined;
                if (isNewAtom) this.atom = this.state.structure.addUndefinedAtom();
                else {
                    // that is undoing the remove atom change
                    const data = this.detail[2];
                    this.state.structure.addAtomData(data.position, data.species, false, data.initMoment, data.constraint, data.charge, this.atom);
                }
                this.state.emitStructureChange({
                    type: (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.ADD,
                    atomIndex: this.atom
                });
                // change the type to atom.remove for undo; add the atomic number to result
                this.type = (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.REMOVE;
                this.detail[0] = this.atom;
                break;
            case (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.REMOVE:
                this.state.structure.atoms.splice(this.atom, 1);
                this.state.emitStructureChange({
                    type: (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.REMOVE,
                    atomIndex: this.atom
                });
                // change the type for undoing
                this.type = (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.ADD;
                break;
            case (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.LATTICE_VECTORS:
                const vectors = res;
                const scaleAtomsPositions = this.detail[2];
                this.state.setFractional(false);
                if (vectors === undefined) // remove lattice vectors
                this.state.structure.removeLatticeVectors();
                else this.state.structure.updateLatticeVectors(vectors, scaleAtomsPositions);
                this.state.emitStructureChange({
                    type: (0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.LATTICE_VECTORS
                });
                break;
        }
    }
}


class $54ed6027fe36a069$export$2e2bcd8739ae039 {
    constructor(){
        // Fractional state and listener
        this.fractional = false; //  fractional coordinates
        this.fractionalListeners = [];
        // Structure state and listeners
        this.structure = undefined;
        this.structureIDcounter = -1;
        this.structureID = -1;
        this.structureStates = {};
        this.structureListeners = [];
        this.atomHighlightListeners = [];
        this.speciesColorListeners = [];
        // Undo/redo system
        this.changeList = [];
        this.undoIndex = -1; // Points to the last element
        this.undoRedoListener = undefined;
    }
    // Fractional state - Atoms data can be shown in fractional or cartesian coordinates
    /**
   * Returns the if the view is in fractional (true) or cartesian (false)
   * @return {boolean}
   */ getFractional() {
        return this.fractional;
    }
    /**
   * Sets the fractional state and emits the corresponding event
   * @param fractional {boolean}
   */ setFractional(fractional) {
        this.fractional = fractional;
        this.fractionalListeners.forEach((component)=>{
            // console.log('component',component)
            component.updateFractional(this.fractional);
        });
    }
    /**
   * Change factory method. Could be possibly given an atomic change
   * @param changeType {string} a type of change as given in the root State
   * @param atomIndex {int}
   * @param detail {Object}
   * @param setChange {boolean}
   * @returns {Change}
   */ change(changeType, atomIndex, detail, setChange = true) {
        return new (0, $6bb38ef6a79206a1$export$2e2bcd8739ae039)(this, changeType, atomIndex, detail, setChange);
    }
    // Structure state - Data of the current structure being shown
    /**
   * Returns the current structure
   * @return {Structure}
   */ getStructure() {
        return this.structure;
    }
    /**
   * Returns a structure atom position in fractional or cartesian
   * coordinates depending on the fractional state
   * @param  {int} i Atom index in the structure
   * @return {number[]}
   */ getAtomPosition(i) {
        return this.fractional ? this.structure.getAtomFractPosition(i) : this.structure.atoms[i].position;
    }
    /**
   * Sets a new structure in the state and a new structure event is emitted.
   * The undo/redo is reset (default)
   * @param {Structure} s
   * @param {boolean} undoRedoReset
   */ setStructure(s, undoRedoReset = true) {
        this.saveOldState();
        this.structure = s;
        this.structureIDcounter += 1;
        this.structureID = this.structureIDcounter;
        this.structure.id = this.structureIDcounter;
        this.structureStates[this.structureID] = {
            "structure": this.structure,
            "undoIndex": this.undoIndex,
            "changeList": this.changeList
        };
        if (undoRedoReset) this.resetUndoRedo(); // regular behavior
        if (!this.structure.isAPeriodicSystem()) this.setFractional(false);
        this.emitNewStructure();
    // console.log('this.structureStates',this.structureStates)
    }
    saveOldState() {
        // console.log('saveOldState:ID',this.structureID)
        if (this.structureID >= 0) this.structureStates[this.structureID] = {
            "structure": this.structure,
            "undoIndex": this.undoIndex,
            "changeList": this.changeList
        };
    }
    selectStructure(structureID, save = true) {
        if (save) this.saveOldState();
        let selected = this.structureStates[structureID];
        // console.log('Huhu', this.structureStates)
        this.structure = selected.structure;
        this.undoIndex = selected.undoIndex;
        this.changeList = selected.changeList;
        this.structureID = structureID;
        this.emitNewSelection();
    }
    /**
   * Resets the state structure and a new structure event is emitted.
   */ resetStructure() {
        this.structure.reset();
        this.structure.fileSource = "New Structure";
        this.resetUndoRedo();
        if (!this.structure.isAPeriodicSystem()) this.setFractional(false);
        this.emitNewStructure();
    }
    /**
   * Transforms the structure in a supercell of it.
   * A new structure event is emitted
   * @param  {Array<string>} dimArray Array specifying the multiplication of the axes
   * @param  {boolean} setChange If the change (undo/redo) will be registered
   * @return {boolean} Returns true if everything was ok
   */ repeatStructure(dimArray, setChange = false) {
        // multiply? structure
        let supercell = (0, $4aa0937dc0e8c453$export$243c5baa3df6570a)(dimArray, this.structure);
        if (supercell.atoms.length < 30000) {
            if (setChange) this.change((0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.SUPERCELL, undefined, [
                this.structure,
                supercell
            ]).do();
            else this.setStructure(supercell, true);
            return true;
        } else return false;
    }
    /**
  * Makes the slab of the structure.
  * A new structure event is emitted
  * @param  {Object} slabData a dict of slab generation data
  * @param  {boolean} setChange If the change (undo/redo) will be registered
  * @return {boolean} Returns true if everything was ok
  */ async makeSlab(slabData, setChange = false) {
        let slab = await (0, $4aa0937dc0e8c453$export$2f07aec45252693a)(slabData, this.structure);
        if (slab.atoms.length < 30000) {
            if (setChange) this.change((0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.SURFACE, undefined, [
                this.structure,
                slab
            ]).do();
            this.setStructure(slab, true);
            return true;
        } else return false;
    }
    /**
   * Updates the structure lattice
   * A structure change event is emitted
   * @param  {number[][]} vectors
   * @param  {boolean} scaleAtomsPosition
   *   If true the atoms positions will scale with the new lattice vectors
   * @param  {boolean} _setChange If the change (undo/redo) will be registered
   */ updateLatticeVectors(vectors, scaleAtomsPosition = false, _setChange = true) {
        // vectors === undefined means  lattice vectors are removed from the structure
        this.change((0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.LATTICE_VECTORS, undefined, [
            this.structure.latVectors,
            vectors,
            scaleAtomsPosition
        ]).do();
    }
    /**
   * Updates an atom species. A structure change event is emitted
   * @param  {int} atomIndex
   * @param  {string} species
   * @param  {boolean} _setChange If the change (undo/redo) will be registered
   */ updateAtomSpecies(atomIndex, species, _setChange = true) {
        let update = [
            this.structure.atoms[atomIndex].species,
            species
        ];
        this.change((0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.SPECIES, atomIndex, update).do();
    }
    /**
   * Updates an atom initial moment. A structure change event is emitted
   * @param  {int} atomIndex
   * @param  {float} initMoment
   * @param  {boolean} _setChange If the change (undo/redo) will be registered
   */ updateAtomInitMoment(atomIndex, initMoment, _setChange = true) {
        let update = [
            this.structure.atoms[atomIndex].initMoment,
            initMoment
        ];
        this.change((0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.INITMOMENT, atomIndex, update).do();
    }
    /**
   * Updates an atom initial charge. A structure change event is emitted
   * @param  {int} atomIndex
   * @param  {float} charge
   * @param  {boolean} _setChange If the change (undo/redo) will be registered
   */ updateAtomCharge(atomIndex, charge, _setChange = true) {
        let update = [
            this.structure.atoms[atomIndex].charge,
            charge
        ];
        this.change((0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.CHARGE, atomIndex, update).do();
    }
    /**
   * Updates an atom constraint. A structure change event is emitted
   * @param  {int} atomIndex
   * @param  {boolean} constraint
   * @param  {boolean} _setChange If the change (undo/redo) will be registered
   */ updateAtomConstraint(atomIndex, constraint, _setChange = true) {
        let update = [
            this.structure.atoms[atomIndex].constraint,
            constraint
        ];
        this.change((0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.CONSTRAINT, atomIndex, update).do();
    }
    /**
   * Updates an atom position. A structure change event is emitted
   * @param  {int} atomIndex
   * @param  {number[]} values
   * @param  {boolean} isFractional If the position is specified in
   *   fractional coordinates (true) or cartesian (false)
   */ updateAtomPosition(atomIndex, values, isFractional) {
        const f = isFractional === undefined ? this.fractional : isFractional;
        // change addition
        let newPosition = f ? this.structure.getCartesianCoordinates(values) : values;
        // Using slice() in order to generate anew array, not a reference
        let update = [
            this.structure.atoms[atomIndex].position.slice(),
            newPosition
        ];
        this.change((0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.MOVE, atomIndex, update).do();
    }
    // /**
    //  * Updates an atom position but the change (undo/redo) will not be registered.
    //  * A structure change event is emitted
    //  * @param  {int} atomIndex
    //  * @param  {Array<float>} values
    //  */
    // updateAtomPositionNoChange(atomIndex, values){
    //   this.structure.updateAtomPosition(atomIndex, values, false)
    //   this.emitStructureChange({type: CHANGE.STRUCTURE.ATOM.MOVE, atomIndex: atomIndex})
    // }
    /**
   * Adds an undefined atom to the structure.
   * A structure change event is emitted
   * @param  {boolean} _setChange If the change (undo/redo) will be registered
   */ addUndefinedAtom(_setChange = true) {
        this.change((0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.ADD).do();
    }
    /**
   * Removes and atom from the structure. A structure change event is emitted
   * @param  {int} atomIndex
   * @param  {boolean} _setChange If the change (undo/redo) will be registered
   */ removeAtom(atomIndex, _setChange = true) {
        //
        this.change((0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.REMOVE, atomIndex, [
            undefined,
            atomIndex,
            this.structure.atoms[atomIndex]
        ]).do();
    }
    // Species color change - The species showing color can be changed
    /**
   * Changes the color of a species. A species color change event is emitted
   * @param  {string} species
   * @param  {string} color Color code
   */ changeSpeciesColor(species, color) {
        // Update the species color in Conf.js
        (0, $e64b414b86723191$export$e2a301f55f143803).setSpeciesColor(species, color);
        //console.log('changeSpeciesColor', species, color)
        this.speciesColorListeners.forEach((component)=>{
            component.changeSpeciesColor(species, color);
        });
    }
    // Subscriptions and event emission
    /**
   * Subscribes a component to the main module events:
   * structure, fractional and species color
   * @param  component {*}
   */ subscribeToAll(component) {
        this.structureListeners.push(component);
        this.fractionalListeners.push(component);
        this.speciesColorListeners.push(component);
    }
    /**
   * Subscribes a component to the structure events:
   * @param  component {UIComponent}
   */ subscribeToStructure(component) {
        this.structureListeners.push(component);
    }
    // /**
    //  * Subscribes a component to the species color event:
    //  * @param  component {UIComponent}
    //  */
    // subscribeToSpeciesColorChange( component ){
    //   this.speciesColorListeners.push(component)
    // }
    /**
   * Emits a structure change event
   * @param  {object} change
   */ emitStructureChange(change) {
        // console.log('emitStructureChange', change)
        this.structureListeners.forEach((component)=>{
            component.updateStructure(this.structure, change);
        });
    }
    /**
   * Emits a new structure event
   */ emitNewStructure() {
        this.structureListeners.forEach((component)=>{
            // console.log('emitNewStructure',  component, component.constructor.name)
            component.setNewStructure(this.structure);
        });
    }
    emitNewSelection() {
        this.structureListeners.forEach((component)=>{
            // console.log('emitNewSelection',  component, this.structure)
            component.selectStructure(this.structure);
        });
    }
    /**
   * Subscribes a component to the atom highlight event:
   * @param  component {UIComponent}
   */ subscribeToAtomHighlight(component) {
        this.atomHighlightListeners.push(component);
    }
    /**
   * Commands an atom highlight event
   * @param  {object} atomIndex
   * @param  {boolean} on
   */ highlightAtom(atomIndex, on = true) {
        this.emitHighlightAtom(atomIndex, on);
    }
    /**
   * Emits an atom highlight event
   * @param  {object} atomIndex
   * @param  {boolean} on
   */ emitHighlightAtom(atomIndex, on) {
        this.atomHighlightListeners.forEach((component)=>{
            //console.log('emitStructureChange ',  component)
            component.highlightAtom(atomIndex, on);
        });
    }
    // Undo/redo functionality section
    /**
   * Adds a change to the undo/redo list and move the pointer
   * @param change {Change}  change instance
   */ addChange(change) {
        // Check if the index is not pointing to the last change
        if (this.undoIndex < this.changeList.length - 1) this.changeList.length = this.undoIndex + 1;
        this.changeList.push(change);
        this.undoIndex++; // Pointing to the last element
        this.undoRedoListener(this.undoIndex + 1, this.changeList.length);
    //console.log('addChange:', this.changeList, this.undoIndex)
    }
    /**
   * Resets the undo/redo system
   */ resetUndoRedo() {
        this.changeList = [];
        this.undoIndex = -1;
        this.undoRedoListener(this.undoIndex + 1, this.changeList.length);
    }
    /**
   * Performs an undo operation: update the undo/redo list
   * and carries out the appropriate operation on the structure state
   */ undo() {
        //console.log('this.undoIndex:', this.undoIndex)
        if (this.undoIndex < 0) return;
        let change = this.changeList[this.undoIndex];
        change.undo();
        this.undoIndex--;
        this.undoRedoListener(this.undoIndex + 1, this.changeList.length);
    }
    /**
   * Performs a redo operation: update the undo/redo list
   * and carries out the appropriate operation on the structure state
   */ redo() {
        //console.log('redoIndex:', this.undoIndex)
        if (this.undoIndex === this.changeList.length - 1) return;
        else {
            this.undoIndex++;
            this.undoRedoListener(this.undoIndex + 1, this.changeList.length);
        }
        let change = this.changeList[this.undoIndex];
        change.do();
    }
    /**
   * Sets the listener that will be called when an undo/redo operation
   * is carried out
   * @param {function} listener
   */ setUndoRedoListener(listener) {
        this.undoRedoListener = listener;
    }
}



/**
 * @author Iker Hurtado
 *
 * @fileOverview File holding the CoordinatesField UI component
 */ 

class $1c3e958c767e186d$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("div", ".coordinates-field");
        this.setHTML(`
        <input type="text" class="coor-value" /> 
        <input type="text" class="coor-value" /> 
        <input type="text" class="coor-value" /> 
    `);
        this.fields = this.getElements("input");
        this.fields.forEach((f)=>f.addEventListener("change", changeEventHandler));
        const classInstance = this;
        // function inputEventHandler(e){
        //   // The value is not parsed therefore accepted
        //   if (e.target.value === '-' || e.target.value === '.' ) return
        //   const value = parseFloat(e.target.value)
        //   //console.log('input event',e.target.value, value,isNaN(value))
        //   if (isNaN(value)) e.target.value = ''
        // }
        function changeEventHandler(e) {
            //**** Try this syntax: this.changeEventHandler = (val) => {
            const value = parseFloat(e.target.value);
            if (isNaN(value)) e.target.value = "0";
            // e.target.value = value.toFixed(5) -> It's not necessary because 
            // the event modifies the structure and that change comes down to the component
            if (classInstance.changeListener !== undefined) classInstance.changeListener(classInstance.getValues());
        }
    }
    /**
   * Returns the set of values
   * @return {number[]}
   */ getValues() {
        return [
            parseFloat(this.fields[0].value),
            parseFloat(this.fields[1].value),
            parseFloat(this.fields[2].value)
        ];
    }
    /**
   * Sets the set of values
   * @param {number[]} coors
   */ setValues(coors) {
        for(let i = 0; i < this.fields.length; i++)this.fields[i].value = coors[i].toFixed((0, $e64b414b86723191$export$e2a301f55f143803).settings.decimalDigits);
    }
    /**
   * Updates the text inputs number of decimals showing
   */ updateDecimals() {
        for(let i = 0; i < this.fields.length; i++)this.fields[i].value = parseFloat(this.fields[i].value).toFixed((0, $e64b414b86723191$export$e2a301f55f143803).settings.decimalDigits);
    }
    /**
   * Sets the listener that will be called when any coordinate is changed
   * The coordinates values will be passed in
   * @param {function} listener 
   */ setChangeListener(listener) {
        this.changeListener = listener;
    }
}


/**
 * @author Iker Hurtado, Sebastian Kokott
 *
 * @fileoverview File holding the SupercellField UI component
 */ 

class $d8b52173239764ac$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("span", ".SupercellField");
        this.setHTML(`
        <div>
        <input type="text" class="sc-value" />
        <input type="text" class="sc-value" />
        <input type="text" class="sc-value" />
        </div>
        <div class="supercell-row">
        <input type="text" class="sc-value matrix" style="display:none"/>
        <input type="text" class="sc-value matrix" style="display:none"/>
        <input type="text" class="sc-value matrix" style="display:none"/>
        </div>
        <div class="supercell-row">
        <input type="text" class="sc-value matrix" style="display:none"/>
        <input type="text" class="sc-value matrix" style="display:none"/>
        <input type="text" class="sc-value matrix" style="display:none"/>
        </div>
        <div class="supercell-matrix-checkbox">
             <input type="checkbox" class="isMatrix" onclick="">Use Supercell Matrix
        </div>
        <div class="create-button-div">
          <button class="create-button">Create Supercell</button>
        </div>
    `);
        let showFields = (e)=>{
            let fields = this.getElements("input.matrix");
            if (e.target.checked) fields.forEach((f)=>{
                f.style = "";
            });
            else fields.forEach((f)=>{
                f.style.display = "none";
            });
        };
        this.fields = this.getElements("input.sc-value"); //e.querySelectorAll('input');
        // console.log('this.fields',this.fields)
        this.fields.forEach((f)=>f.addEventListener("input", (0, $4aa0937dc0e8c453$export$68e9a3393520dd2e)));
        this.fields.forEach((f)=>f.addEventListener("blur", (0, $4aa0937dc0e8c453$export$7800b12359c7379e)));
        this.isMatrix = this.getElement(".isMatrix");
        this.isMatrix.addEventListener("change", showFields);
    }
    /**
   * Returns the values, one per dimension
   * @return {number[]}
   */ getValues() {
        let a = [];
        this.fields.forEach((f)=>{
            if (f.style.display !== "none") {
                if (f.value === "") a.push(0);
                else a.push(parseInt(f.value));
            }
        });
        return a;
    }
    /**
   * Sets the values, one per dimension
   * @param {number} value
   */ setValues(value) {
        for(let i = 0; i < this.fields.length; i++)this.fields[i].value = value;
    }
}


/**
 * @author Iker Hurtado
 *
 * @fileOverview File holding the BasisAtoms UI component
 */ 


var $32555fd85b2a29ef$exports = {};
$32555fd85b2a29ef$exports = new URL("binicon.f413c360.png", import.meta.url).toString();


var $a4dce173ac6e0d02$exports = {};
$a4dce173ac6e0d02$exports = new URL("prev-arrow-white-icon.843aaffe.png", import.meta.url).toString();


var $96ee8327d03b4521$exports = {};
$96ee8327d03b4521$exports = new URL("next-arrow-white-icon.78989721.png", import.meta.url).toString();



const $96fc1647f4af9dc5$var$ROW_NUMBER = 10;
class $96fc1647f4af9dc5$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param  {State} moduleState
   *   Object representing the state of the Structure builder module
   */ constructor(moduleState){
        super("div", "#BasisAtoms");
        // component state
        this.page = 1;
        this.pagesNum = 1;
        this.moduleState = moduleState;
        this.setHTML(`

    		<div id="atom-selector">
    			<button class="prev-page">
    			  <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($a4dce173ac6e0d02$exports)))}" height="16px" style="vertical-align: middle;" alt="Prev page">
    			</button>
    			<span class="current-page-label" style="font-size: 1.2em; vertical-align: middle;"></span>
    			<button class="next-page">
    			  <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($96ee8327d03b4521$exports)))}" height="16px" style="vertical-align: middle;" alt="Next page">
    			</button>
    			<!--<button class="next-page"> &gt; </button> -->
    		</div>
				<div id="NewRowButton" style="display:flex; justify-content:center">
					<div id="coordinates-switch">
						<input type="checkbox" >Fractional coordinates
					</div>
					<div style="display:inline-block; text-align:center">
						<button id="new-atom-button">New atom</button>
						<button id="constrain-button">Constrain all atoms</button>
					</div>
				</div>
				<div class="" style="margin-left:30px; font-size:14px;font-weight:lighter">Click on the species color to specify more atomic properties (e.g. initial moment).<br></div>
    		<div class="div-table AtomsBlock">
					<div class="div-table-row header">
						<div class="div-table-col atom-order">&nbsp;</div>
						<div class="div-table-col vector">All numbers in units of \xc5</div>
						<div class="div-table-col species">&nbsp;</div>
						<div class="div-table-col options">Options</div>
					</div>
				</div>
    	`);
        const prevButton = this.getElement("button.prev-page");
        const nextButton = this.getElement("button.next-page");
        prevButton.addEventListener("click", (_)=>{
            if (this.page > 1) {
                this.page--;
                this.update();
            }
        });
        nextButton.addEventListener("click", (_)=>{
            let atoms = this.moduleState.getStructure().atoms;
            if (atoms.length >= this.page * 10 + 1) {
                this.page++;
                this.update();
            }
        });
        this.currentPageLabel = this.getElement(".current-page-label");
        this.units = this.getElement(".header .vector");
        this.fractCheckbox = this.getElement("#coordinates-switch input");
        this.fractCheckbox.addEventListener("click", (e)=>{
            this.moduleState.setFractional(e.target.checked);
            this.units.innerHTML = e.target.checked ? "&nbsp;" : "All numbers in units of \xc5";
        });
        this.button = this.getElement("#new-atom-button");
        this.button.addEventListener("click", (_)=>{
            this.moduleState.addUndefinedAtom();
            this.page = this.pagesNum;
            this.update();
        });
        this.button = this.getElement("#constrain-button");
        this.button.addEventListener("click", (_)=>{
            const nAtoms = this.moduleState.getStructure().atoms.length;
            const isConstrained = this.button.textContent.includes("Release");
            let change = this.moduleState.change();
            for(let i = 0; i < nAtoms; i++)if (this.moduleState.structure.atoms[i].constraint === isConstrained) change.addStep((0, $1ad59a1a7edcd764$export$4bef51da9b53f613).STRUCTURE.ATOM.CONSTRAINT, i, [
                isConstrained,
                !isConstrained
            ]);
            change.do();
            this.button.textContent = (isConstrained ? "Constrain" : "Release") + " all atoms";
            this.update();
        });
        this.atomRows = [];
        this.tooltip = new $96fc1647f4af9dc5$var$AtomRowTooltip(this.moduleState); // hidden initially
        this.tooltip.e.style.visibility = "hidden";
        const atomsBlockEl = this.getElement(".AtomsBlock");
        for(let i = 0; i < $96fc1647f4af9dc5$var$ROW_NUMBER; i++){
            const row = new $96fc1647f4af9dc5$var$AtomRow(this.tooltip, this.moduleState);
            this.atomRows.push(row);
            atomsBlockEl.appendChild(row.e);
            row.e.addEventListener("mouseenter", (_)=>{
                this.moduleState.highlightAtom((this.page - 1) * $96fc1647f4af9dc5$var$ROW_NUMBER + i);
            });
            row.e.addEventListener("mouseleave", (_)=>{
                this.moduleState.highlightAtom((this.page - 1) * $96fc1647f4af9dc5$var$ROW_NUMBER + i, false);
            });
        }
    }
    /**
  * Updates the component to a new structure
  * Listener for the 'new structure' module level event
  * @param {Structure} structure
  */ setNewStructure(structure) {
        this.page = 1;
        this.updateStructure(structure);
    }
    selectStructure(structure) {
        this.setNewStructure(structure);
    }
    /**
  * Updates the component to a structure change
  * Listener for the 'update structure' module level event
  * @param {Structure} _structure
  * @param {object} _change
  */ updateStructure(_structure, _change) {
        // console.log('BasisAtoms.updateStructure', change)
        let atoms = this.moduleState.getStructure().atoms;
        this.pagesNum = Math.ceil(atoms.length / $96fc1647f4af9dc5$var$ROW_NUMBER);
        // When the first atmos is created the page has to be set to 1
        if (this.pagesNum > 0 && this.page === 0) this.page = 1;
        // keep the this.page state if it's not bigger than the page number (the number of atoms could change)
        if (this.page > this.pagesNum) this.page = this.pagesNum;
        this.update();
    }
    /**
  * Updates the component to a fractional change in the module
  * Listener for the 'update fractional' module level event
  * @param {boolean} _fractional
  */ updateFractional(_fractional) {
        this.update();
    }
    /**
  * Updates the component to an atom species change
  * Listener for the 'change species' module level event
  * @param {string} _species
  * @param {string} _color Color code
  */ changeSpeciesColor(_species, _color) {
        this.update();
    }
    /**
   * Updates the component looking at the data model
   */ update() {
        this.getElement("#atom-selector").style.display = this.pagesNum > 1 ? "block" : "none";
        this.currentPageLabel.innerHTML = this.page + "/" + this.pagesNum;
        const periodic = this.moduleState.getStructure().isAPeriodicSystem();
        this.getElement("#coordinates-switch").style.display = periodic ? "flex" : "none";
        this.fractCheckbox.checked = this.moduleState.getFractional();
        let atoms = this.moduleState.getStructure().atoms;
        if (atoms.length === 0) {
            // exceptional case
            for(let i = 0; i < $96fc1647f4af9dc5$var$ROW_NUMBER; i++)this.atomRows[i].e.style.display = "none";
            return;
        }
        const initIndex = (this.page - 1) * $96fc1647f4af9dc5$var$ROW_NUMBER;
        for(let i = 0; i < $96fc1647f4af9dc5$var$ROW_NUMBER; i++){
            let atomsIndex = initIndex + i;
            if (atomsIndex < atoms.length) {
                this.atomRows[i].setValues(atomsIndex, atoms[atomsIndex]);
                this.atomRows[i].e.style.display = "flex"; //visibility = 'visible'
            } else this.atomRows[i].e.style.display = "none"; //visibility = 'hidden'
        }
    }
}
/**
 * Tooltip showing extra info about the atom. It's editable.
 * The atom constraint and initial moment can be changed
 */ class $96fc1647f4af9dc5$var$AtomRowTooltip extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
  * @param  {State} moduleState
  *   Object representing the state of the Structure builder module
  */ constructor(moduleState){
        super("div", ".AtomRowTooltip");
        this.setHTML(`<table>
      <tr> <td style="text-align: center"><input type="checkbox" class="constraint" /> </td><td>Constrain Atom</td></tr>
      <tr> <td style="text-align: center"> <input type="text" class="init-moment" /></td><td>Initial Moment</td></tr>
			<tr> <td style="text-align: center"> <input type="text" class="charge" /></td><td>Initial Charge</td></tr>
      <tr> <td class="close-button" colspan="2" style="text-align: center; font-size: smaller"> CLOSE</td></tr>
	  </table>
    `);
        this.moduleState = moduleState;
        this.constraintCB = this.getElement(".constraint");
        this.constraintCB.addEventListener("change", (_)=>{
            //console.log('constraint',constraint)
            this.moduleState.updateAtomConstraint(this.atomIndex, this.constraintCB.checked);
        });
        this.initMomentField = this.getElement(".init-moment");
        this.initMomentField.addEventListener("change", (_)=>{
            let initMoment = this.initMomentField.value === "" ? undefined : this.initMomentField.value;
            this.moduleState.updateAtomInitMoment(this.atomIndex, initMoment);
        });
        this.chargeField = this.getElement(".charge");
        this.chargeField.addEventListener("change", (_)=>{
            let charge = this.chargeField.value === "" ? undefined : this.chargeField.value;
            this.moduleState.updateAtomCharge(this.atomIndex, charge);
        });
        this.getElement(".close-button").addEventListener("click", (_)=>{
            this.e.style.visibility = "hidden";
        });
    }
    /**
   * Sets the atom index in the structure in order to
   * show/edit it
   * @param {int} index
   */ setAtomIndex(index) {
        this.atomIndex = index;
    }
    // /**
    //  * Returns true if either the constraint or the init moment are filled
    //  * @return {boolean}
    //  */
    // isMomentOrConstraintSet(){
    // 	return (this.initMomentField.value !== '' || this.constraintCB.checked || this.chargeField.value !== '')
    // }
    /**
   * Resets the atom constraint and init moment
   * @param  {string} moment
   * @param  {boolean} constraint
  * @param  {string} charge
   */ reset(moment = "", constraint = false, charge = "") {
        this.constraintCB.checked = constraint;
        this.initMomentField.value = moment;
        this.chargeField.value = charge;
    }
}
/**
 * Editable atom row
 */ class $96fc1647f4af9dc5$var$AtomRow extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param {AtomRowTooltip} tooltip Row tooltip component
   * @param  {State} moduleState
   *   Object representing the state of the Structure builder module
   */ constructor(tooltip, moduleState){
        super("div", ".div-table-row");
        this.setHTML(`
	      <div class="div-table-col atom-order"></div>
	      <div class="div-table-col vector">
	      	<span class="lattice-vector-wrapper"></span>
				</div>
	      <div class="div-table-col species">
	      	<input type="text" class="species-value" />
		  	</div>
		  	<div class="div-table-col options">
					<span style="position: relative" class="species-circle">
						<canvas width="18" height="19" ></canvas>
					</span>
		  		<img class="img-button" src="${(0, (/*@__PURE__*/$parcel$interopDefault($32555fd85b2a29ef$exports)))}" alt="Delete">
		  	</div>
	    `);
        this.ctx = this.getElement(".species-circle canvas").getContext("2d");
        this.tooltip = tooltip;
        this.moduleState = moduleState;
        this.coorsField = new (0, $1c3e958c767e186d$export$2e2bcd8739ae039)();
        this.getElement(".lattice-vector-wrapper").appendChild(this.coorsField.e);
        this.coorsField.setChangeListener((_)=>{
            this.moduleState.updateAtomPosition(this.atomIndex, this.coorsField.getValues(), undefined);
        });
        this.speciesField = this.getElement(".species-value");
        this.speciesField.addEventListener("change", (_)=>{
            let species = this.speciesField.value === "" ? undefined : this.speciesField.value;
            this.moduleState.updateAtomSpecies(this.atomIndex, species);
        });
        this.speciesCircle = this.getElement(".species-circle canvas");
        this.getElement(".species-circle").appendChild(this.tooltip.e);
        this.speciesCircle.addEventListener("click", (_)=>{
            this.speciesCircle.parentElement.appendChild(this.tooltip.e);
            this.tooltip.e.style.visibility = "visible";
            this.tooltip.reset(this.initMomentValue, this.constraintChecked, this.chargeValue);
            this.tooltip.setAtomIndex(this.atomIndex);
        });
        this.getElement(".img-button").addEventListener("click", (_)=>{
            this.moduleState.removeAtom(this.atomIndex);
            // The next atom falls into this index and needs to be highlighted (the mouse pointer is on its row)
            this.moduleState.highlightAtom(this.atomIndex); // If it was the last no one is highlighted
        });
    }
    /**
   * Sets the atom values into the row fields
   * @param {int} index Atom index in the structure
   * @param {object} atom
   */ setValues(index, atom) {
        this.atomIndex = index;
        this.getElement(".atom-order").textContent = index + 1 + ".";
        this.coorsField.setValues(this.moduleState.getAtomPosition(index));
        this.speciesField.value = atom.species === undefined ? "" : atom.species;
        this.initMomentValue = atom.initMoment === undefined ? "" : atom.initMoment.toString();
        this.chargeValue = atom.charge === undefined ? "" : atom.charge.toString();
        this.constraintChecked = atom.constraint;
        this.drawCircle(atom.species, this.constraintChecked || this.initMomentValue !== "" && this.initMomentValue !== "0" || this.chargeValue !== "" && this.chargeValue !== "0");
    }
    /**
   * Draws the circle representing the species
   * @param  {string} species
   * @param  {boolean} triangle
   */ drawCircle(species, triangle = false) {
        this.ctx.clearRect(0, 0, 18, 19);
        this.ctx.beginPath();
        if (species === undefined) this.ctx.fillStyle = "black";
        else this.ctx.fillStyle = (0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesColor(species);
        this.ctx.arc(9, 10, 8, 0, 2 * Math.PI, true);
        this.ctx.fill();
        if (this.ctx.fillStyle.indexOf("ffff") > 0) {
            // IF clear color outline is drawn
            this.ctx.lineWidth = 0.5;
            this.ctx.strokeStyle = "#000";
            this.ctx.stroke();
        }
        this.ctx.lineWidth = 1.5;
        this.ctx.strokeStyle = "#777";
        this.ctx.stroke();
        if (triangle) this.drawTriangle();
    }
    /**
   * Draws a triangle
   */ drawTriangle() {
        this.ctx.beginPath();
        this.ctx.moveTo(0, 0);
        this.ctx.lineTo(0, 5);
        this.ctx.lineTo(5, 0);
        this.ctx.closePath();
        this.ctx.fillStyle = "#777";
        this.ctx.fill();
    }
}


/**
 * @author Andrey Sobolev
 *
 * @fileOverview File holding the SurfaceConstructionField UI component
*/ 
var $729955f814b389dc$exports = {};
$729955f814b389dc$exports = new URL("help-icon.1cb874a1.png", import.meta.url).toString();



class $9ba54ea4602938b1$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("span", ".SurfaceConstructionField");
        this.setHTML(`
      <div class="surface-input-div">Miller indices:
        <input type="text" class="miller" />
        <input type="text" class="miller" />
        <input type="text" class="miller" />
      </div>
      <div class="surface-input-div">Number of atomic layers:
        <input type="text" class="number-of-layers" />
      </div>
      <div class="surface-input-div">Vacuum thickness:
        <input type="text" class="vacuum-layer" /> \xc5  
        <img class="help-button" src="${(0, (/*@__PURE__*/$parcel$interopDefault($729955f814b389dc$exports)))}" width="16" alt="Help"/>
        <div class="button-explanation">
          In FHI-aims you may easily use a relatively large vacuum thickness of 50 A\u{30A} or more without a noticeable 
          performance impact. 
        </div>
      </div>
      <div class="create-button-div">
       <button class="create-button">Create Slab</button>
      </div>
      <div class="termination-div" style="display:none">
        <div class="surface-input-div">Top layer:
          <select id="top-layer">
          </select>
        </div>
        <div class="surface-input-div">Bottom layer:
          <select id="bottom-layer">
          </select>
        </div>
        <div class="terminate-button-div">
          <button class="terminate-button">Terminate Slab</button>
        </div>
      </div>

    `);
        this.miller = this.getElements("input.miller");
        this.miller.forEach((f)=>f.addEventListener("input", (0, $4aa0937dc0e8c453$export$68e9a3393520dd2e)));
        this.miller.forEach((f)=>f.addEventListener("blur", (0, $4aa0937dc0e8c453$export$7800b12359c7379e)));
        this.layers = this.getElement("input.number-of-layers");
        this.layers.addEventListener("input", (0, $4aa0937dc0e8c453$export$68e9a3393520dd2e));
        this.layers.addEventListener("blur", (0, $4aa0937dc0e8c453$export$7800b12359c7379e));
        this.vacuum = this.getElement("input.vacuum-layer");
        this.vacuum.addEventListener("input", (0, $4aa0937dc0e8c453$export$f047cd856756950a));
        this.vacuum.addEventListener("blur", (0, $4aa0937dc0e8c453$export$3a461cfe4e90e4ad));
        this.top_select = this.getElement("#top-layer");
        this.bottom_select = this.getElement("#bottom-layer");
    }
    showTermination(fileName) {
        let f = this.getElement("div.termination-div");
        if (f.style.display === "none" && fileName.includes("slab")) f.setAttribute("style", "");
        else f.style.display = "none";
    }
    /**
   * Populates slab termination boxes
   * @param terminations {(string|number)[][]} an array with terminations
   */ populateTerminationBoxes(terminations) {
        const n = terminations.length;
        getUniqueTerminations(terminations).forEach((el)=>this.bottom_select.add(new Option(el[0], el[1])));
        getUniqueTerminations(terminations.slice().reverse()).forEach((el)=>this.top_select.add(new Option(el[0], n - 1 - el[1])));
        function getUniqueTerminations(terms) {
            let layer_idxs = [];
            let res = [];
            terms.forEach((el, idx)=>{
                if (!layer_idxs.includes(el[1])) {
                    layer_idxs.push(el[1]);
                    res.push([
                        el[0],
                        idx
                    ]);
                }
            });
            return res;
        }
    }
    /**
  * Returns the surface creation data
  * @returns {Object} A dict containing the data needed to create the surface 
  */ getCreationValues() {
        let res = {};
        let m_idx = [];
        this.miller.forEach((f)=>{
            if (f.value === "") m_idx.push(0);
            else m_idx.push(parseInt(f.value));
        });
        res["miller"] = m_idx;
        res["layers"] = this.layers.value !== "" ? parseInt(this.layers.value) : 0;
        res["vacuum"] = this.vacuum.value !== "" ? parseInt(this.vacuum.value) : 0;
        return res;
    }
    getTermValues() {
        return [
            this.bottom_select.value,
            this.top_select.value
        ];
    }
    /**
   * Clears the field values
   */ clearValues() {
        this.miller.forEach((f)=>f.value = "");
        this.layers.value = "";
        this.vacuum.value = "";
        const L = this.bottom_select.options.length - 1;
        for(let i = L; i >= 0; i--){
            this.bottom_select.remove(i);
            this.top_select.remove(i);
        }
    }
}






/**
* @author Sebastian Kokott
*
* @fileOverview File holding the Structure Info UI component
*/ 


class $6307f518240c06cd$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(moduleState){
        super("span", ".StructureInfoField");
        this.moduleState = moduleState; // We might need this to update the info panel later on...
        this.symThresRowHTML = `
      <td>Symmetry threshold</td>
      <td><input id="thresh-input" type="text" style="width:30%;"/>&nbsp;\xc5 &nbsp;
      <button id="thresh-button" style="width:40%;">Apply</button></td>
    `;
        this.setHTML(`
        <div class="StructureInfo">
          <table>
          <tr>${this.symThresRowHTML}</tr>
          </table>
        </div>
    `);
        let threshEl = this.getElement("#thresh-input");
        threshEl.value = (0, $e64b414b86723191$export$e2a301f55f143803).settings.symmetryThreshold;
        let button = this.getElement("#thresh-button");
        button.addEventListener("click", (_)=>{
            (0, $e64b414b86723191$export$e2a301f55f143803).settings.symmetryThreshold = threshEl.value;
            $1ad59a1a7edcd764$export$f558026a994b6051((0, $e64b414b86723191$export$e2a301f55f143803).settings);
        });
    }
    setNewStructure(structure) {
        if (structure.structureInfo === undefined) structure.structureInfo = {};
        this.updateStructureInfo();
    }
    selectStructure(_structure) {
        this.updateStructureInfo();
    }
    updateTable(structureInfo) {
        let table = this.getElement("table");
        table.innerHTML = "";
        if (structureInfo !== undefined) for (const [_, value] of Object.entries(structureInfo)){
            if (value.info_str.includes("Symmetry")) continue;
            let tr = document.createElement("tr");
            let td1 = document.createElement("td");
            td1.innerHTML = value.info_str;
            let td2 = document.createElement("td");
            if (Array.isArray(value.value)) td2.innerHTML = value.value.join(", ");
            else td2.innerHTML = value.value;
            tr.appendChild(td1);
            tr.appendChild(td2);
            table.appendChild(tr);
        }
        let tr = document.createElement("tr");
        tr.innerHTML = this.symThresRowHTML;
        table.appendChild(tr);
        let threshEl = this.getElement("#thresh-input");
        threshEl.value = (0, $e64b414b86723191$export$e2a301f55f143803).settings.symmetryThreshold;
        let button = this.getElement("#thresh-button");
        button.addEventListener("click", (_)=>{
            (0, $e64b414b86723191$export$e2a301f55f143803).settings.symmetryThreshold = threshEl.value;
            $1ad59a1a7edcd764$export$f558026a994b6051((0, $e64b414b86723191$export$e2a301f55f143803).settings);
        });
    }
    updateStructure() {
        this.updateStructureInfo();
    }
    updateStructureInfo() {
        let structure = this.moduleState.getStructure();
        structure.updateInfo().then(()=>this.updateTable(structure.structureInfo));
    }
    updateSettings() {
        this.updateStructureInfo();
    }
}




class $e20fc17338b77793$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param  {State} moduleState
   *   Object representing the state of the Structure builder module
   */ constructor(moduleState){
        super("div", "#StructureSelector");
        this.moduleState = moduleState;
        this.setHTML(`
      <div class="structure-bar">
        <span class="structures"></span>
        <span class="add-new-structure"></span>
      </div>
    `);
        let newStructure = ()=>{
            // console.log('Hello World')
            let s = new (0, $495a3b82f25facb5$export$2e2bcd8739ae039)();
            // console.log(this.moduleState.structureID)
            let id = this.moduleState.structureID + 1;
            // console.log('check here', id)
            s.fileSource = "New Structure " + id;
            this.moduleState.setStructure(s);
        // console.log('check here',this.moduleState.structureStates)
        };
        let addSpan = document.createElement("span");
        addSpan.innerHTML = "+";
        addSpan.classList.add("addon-box");
        addSpan.classList.add("add");
        addSpan.addEventListener("click", newStructure);
        this.getElement(".add-new-structure").appendChild(addSpan);
    }
    setNewStructure(structure) {
        let selectStructure = (e)=>{
            let id = e.target.value;
            // console.log(e.target.parentElement);
            this.setSelection(e.target.parentElement);
            // console.log("selectr structure", e.target.value)
            this.moduleState.selectStructure(id);
        };
        let removeStructure = (e)=>{
            let keys = Object.keys(this.moduleState.structureStates);
            // console.log(keys)
            if (keys.length > 1) {
                let id = e.target.value;
                let removeSpan = document.getElementById("structureSelector" + id).parentElement;
                let hasClass = removeSpan.classList.contains("structure-selected");
                delete this.moduleState.structureStates[id];
                keys = Object.keys(this.moduleState.structureStates);
                // console.log(this.moduleState.structureStates)
                let nextID = parseInt(keys.pop());
                if (hasClass) {
                    let nextSpan = document.getElementById("structureSelector" + nextID);
                    this.setSelection(nextSpan.parentElement);
                }
                this.moduleState.selectStructure(nextID, false);
            } else this.moduleState.resetStructure();
            // console.log(nextID)
            // console.log(parent)
            e.target.parentElement.remove();
        };
        let span = document.createElement("span");
        span.classList.add("structureSelector");
        span.classList.add("addon-box");
        let selectSpan = document.createElement("span");
        selectSpan.innerText = structure.fileSource;
        selectSpan.value = this.moduleState.structureID;
        selectSpan.id = "structureSelector" + this.moduleState.structureID;
        selectSpan.addEventListener("click", selectStructure);
        span.appendChild(selectSpan);
        let removeSpan = document.createElement("span");
        removeSpan.innerHTML = "&times";
        removeSpan.value = this.moduleState.structureID;
        removeSpan.classList.add("remove");
        removeSpan.addEventListener("click", removeStructure);
        span.appendChild(removeSpan);
        this.getElement(".structures").appendChild(span);
        this.setSelection(span);
    }
    setSelection(DOMelement) {
        let list = [
            ...DOMelement.parentElement.children
        ];
        // console.log(list);
        list.forEach((child)=>{
            child.classList.remove("structure-selected");
        });
        DOMelement.classList.add("structure-selected");
    }
    updateStructure(structure, change) {}
    selectStructure() {}
}


/**
* @author Sebastian Kokott
*
* @fileOverview File holding the Structure Info UI component
*/ 



class $797427dcddf8f609$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(moduleState){
        super("span", ".Primitive");
        let primitiveHandler = ()=>{
            this.getCell("primitive").then();
        };
        let conventionalHandler = ()=>{
            this.getCell("conventional").then();
        };
        this.moduleState = moduleState; // We might need this to update the info panel later on...
        this.setHTML(`
      <span class="regular-view">
        <span class="addon-box">
          <span class="addon primitive" >Primitive Cell</span>
        </span>
        <span class="addon-box">
          <span class="addon conventional" >Conventional Cell</span>
        </span>
      </span>
    `);
        this.primitiveButton = this.getElement(".primitive");
        this.primitiveButton.addEventListener("click", primitiveHandler);
        this.conventionalButton = this.getElement(".conventional");
        this.conventionalButton.addEventListener("click", conventionalHandler);
    }
    /**
   * Returns a standardized cell
   * @param which {string}
   * @return {Promise<void>}
   */ async getCell(which) {
        let structure = this.moduleState.getStructure();
        // console.log(structure, !structure.atoms.length)
        if (!structure.atoms.length) return;
        let sendStructure = {
            cell: structure.latVectors,
            positions: structure.atoms,
            symThresh: (0, $e64b414b86723191$export$e2a301f55f143803).settings.symmetryThreshold,
            fileName: structure.fileSource
        };
        let isPrimitive = undefined;
        if (which === "primitive") isPrimitive = true;
        else if (which === "conventional") isPrimitive = false;
        else return;
        sendStructure["is_primitive"] = isPrimitive;
        let response = await fetch("/get-standard-cell", {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(sendStructure)
        });
        if (!response.ok) {
            $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("Unknown server ERROR ");
            return;
        }
        const text = await response.text();
        // console.log(text)
        // console.log(structureData)"ErrorIsAlreadyPrimitive"
        if (text === "ErrorIsAlreadyPrimitive") {
            $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("The input structure is already a primitive unit cell.");
            return;
        } else if (text === "ErrorIsAlreadyConventional") {
            $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("The input structure is already a conventional unit cell.");
            return;
        }
        const primitive = JSON.parse(text);
        this.moduleState.setStructure($4aa0937dc0e8c453$export$9fb63025ff3998e0(primitive));
    }
    updateStructure(structure, _change) {
        const isPeriodic = structure.isAPeriodicSystem();
        // console.log(isPeriodic);
        this.getElement(".regular-view").style.display = isPeriodic ? "inline-block" : "none";
    }
    selectStructure(structure) {
        this.updateStructure(structure, undefined);
    }
    setNewStructure(structure) {
        this.updateStructure(structure, undefined);
    }
}


/**
 * @author Sebastian Kokott
 *
 * @fileOverview Brillouin zone viewer
 */ 


/**
 * Ported from: https://github.com/maurizzzio/quickhull3d/ by Mauricio Poppe (https://github.com/maurizzzio)
 */ const $20a834962c536e9e$var$Visible = 0;
const $20a834962c536e9e$var$Deleted = 1;
const $20a834962c536e9e$var$_v1 = new (0, $0d23c856ce11c301$export$64b5c384219d3699)();
const $20a834962c536e9e$var$_line3 = new (0, $0d23c856ce11c301$export$e0ba6359f1954fd3)();
const $20a834962c536e9e$var$_plane = new (0, $0d23c856ce11c301$export$7ff5ac152ef991b0)();
const $20a834962c536e9e$var$_closestPoint = new (0, $0d23c856ce11c301$export$64b5c384219d3699)();
const $20a834962c536e9e$var$_triangle = new (0, $0d23c856ce11c301$export$5a465592bfe74b48)();
class $20a834962c536e9e$export$2062365927816f76 {
    constructor(){
        this.tolerance = -1;
        this.faces = []; // the generated faces of the convex hull
        this.newFaces = []; // this array holds the faces that are generated within a single iteration
        // the vertex lists work as follows:
        //
        // let 'a' and 'b' be 'Face' instances
        // let 'v' be points wrapped as instance of 'Vertex'
        //
        //     [v, v, ..., v, v, v, ...]
        //      ^             ^
        //      |             |
        //  a.outside     b.outside
        //
        this.assigned = new $20a834962c536e9e$var$VertexList();
        this.unassigned = new $20a834962c536e9e$var$VertexList();
        this.vertices = []; // vertices of the hull (internal representation of given geometry data)
    }
    setFromPoints(points) {
        if (Array.isArray(points) !== true) console.error("THREE.ConvexHull: Points parameter is not an array.");
        if (points.length < 4) console.error("THREE.ConvexHull: The algorithm needs at least four points.");
        this.makeEmpty();
        for(let i = 0, l = points.length; i < l; i++)this.vertices.push(new $20a834962c536e9e$var$VertexNode(points[i]));
        this.compute();
        return this;
    }
    setFromObject(object) {
        const points = [];
        object.updateMatrixWorld(true);
        object.traverse(function(node) {
            const geometry = node.geometry;
            if (geometry !== undefined) {
                if (geometry.isGeometry) {
                    console.error("THREE.ConvexHull no longer supports Geometry. Use THREE.BufferGeometry instead.");
                    return;
                } else if (geometry.isBufferGeometry) {
                    const attribute = geometry.attributes.position;
                    if (attribute !== undefined) for(let i = 0, l = attribute.count; i < l; i++){
                        const point = new (0, $0d23c856ce11c301$export$64b5c384219d3699)();
                        point.fromBufferAttribute(attribute, i).applyMatrix4(node.matrixWorld);
                        points.push(point);
                    }
                }
            }
        });
        return this.setFromPoints(points);
    }
    containsPoint(point) {
        const faces = this.faces;
        for(let i = 0, l = faces.length; i < l; i++){
            const face = faces[i];
            // compute signed distance and check on what half space the point lies
            if (face.distanceToPoint(point) > this.tolerance) return false;
        }
        return true;
    }
    intersectRay(ray, target) {
        // based on "Fast Ray-Convex Polyhedron Intersection"  by Eric Haines, GRAPHICS GEMS II
        const faces = this.faces;
        let tNear = -Infinity;
        let tFar = Infinity;
        for(let i = 0, l = faces.length; i < l; i++){
            const face = faces[i];
            // interpret faces as planes for the further computation
            const vN = face.distanceToPoint(ray.origin);
            const vD = face.normal.dot(ray.direction);
            // if the origin is on the positive side of a plane (so the plane can "see" the origin) and
            // the ray is turned away or parallel to the plane, there is no intersection
            if (vN > 0 && vD >= 0) return null;
            // compute the distance from the ray’s origin to the intersection with the plane
            const t = vD !== 0 ? -vN / vD : 0;
            // only proceed if the distance is positive. a negative distance means the intersection point
            // lies "behind" the origin
            if (t <= 0) continue;
            // now categorized plane as front-facing or back-facing
            if (vD > 0) //  plane faces away from the ray, so this plane is a back-face
            tFar = Math.min(t, tFar);
            else // front-face
            tNear = Math.max(t, tNear);
            if (tNear > tFar) // if tNear ever is greater than tFar, the ray must miss the convex hull
            return null;
        }
        // evaluate intersection point
        // always try tNear first since its the closer intersection point
        if (tNear !== -Infinity) ray.at(tNear, target);
        else ray.at(tFar, target);
        return target;
    }
    intersectsRay(ray) {
        return this.intersectRay(ray, $20a834962c536e9e$var$_v1) !== null;
    }
    makeEmpty() {
        this.faces = [];
        this.vertices = [];
        return this;
    }
    // Adds a vertex to the 'assigned' list of vertices and assigns it to the given face
    addVertexToFace(vertex, face) {
        vertex.face = face;
        if (face.outside === null) this.assigned.append(vertex);
        else this.assigned.insertBefore(face.outside, vertex);
        face.outside = vertex;
        return this;
    }
    // Removes a vertex from the 'assigned' list of vertices and from the given face
    removeVertexFromFace(vertex, face) {
        if (vertex === face.outside) {
            // fix face.outside link
            if (vertex.next !== null && vertex.next.face === face) // face has at least 2 outside vertices, move the 'outside' reference
            face.outside = vertex.next;
            else // vertex was the only outside vertex that face had
            face.outside = null;
        }
        this.assigned.remove(vertex);
        return this;
    }
    // Removes all the visible vertices that a given face is able to see which are stored in the 'assigned' vertext list
    removeAllVerticesFromFace(face) {
        if (face.outside !== null) {
            // reference to the first and last vertex of this face
            const start = face.outside;
            let end = face.outside;
            while(end.next !== null && end.next.face === face)end = end.next;
            this.assigned.removeSubList(start, end);
            // fix references
            start.prev = end.next = null;
            face.outside = null;
            return start;
        }
    }
    // Removes all the visible vertices that 'face' is able to see
    deleteFaceVertices(face, absorbingFace) {
        const faceVertices = this.removeAllVerticesFromFace(face);
        if (faceVertices !== undefined) {
            if (absorbingFace === undefined) // mark the vertices to be reassigned to some other face
            this.unassigned.appendChain(faceVertices);
            else {
                // if there's an absorbing face try to assign as many vertices as possible to it
                let vertex = faceVertices;
                do {
                    // we need to buffer the subsequent vertex at this point because the 'vertex.next' reference
                    // will be changed by upcoming method calls
                    const nextVertex = vertex.next;
                    const distance = absorbingFace.distanceToPoint(vertex.point);
                    // check if 'vertex' is able to see 'absorbingFace'
                    if (distance > this.tolerance) this.addVertexToFace(vertex, absorbingFace);
                    else this.unassigned.append(vertex);
                    // now assign next vertex
                    vertex = nextVertex;
                }while (vertex !== null);
            }
        }
        return this;
    }
    // Reassigns as many vertices as possible from the unassigned list to the new faces
    resolveUnassignedPoints(newFaces) {
        if (this.unassigned.isEmpty() === false) {
            let vertex = this.unassigned.first();
            do {
                // buffer 'next' reference, see .deleteFaceVertices()
                const nextVertex = vertex.next;
                let maxDistance = this.tolerance;
                let maxFace = null;
                for(let i = 0; i < newFaces.length; i++){
                    const face = newFaces[i];
                    if (face.mark === $20a834962c536e9e$var$Visible) {
                        const distance = face.distanceToPoint(vertex.point);
                        if (distance > maxDistance) {
                            maxDistance = distance;
                            maxFace = face;
                        }
                        if (maxDistance > 1000 * this.tolerance) break;
                    }
                }
                // 'maxFace' can be null e.g. if there are identical vertices
                if (maxFace !== null) this.addVertexToFace(vertex, maxFace);
                vertex = nextVertex;
            }while (vertex !== null);
        }
        return this;
    }
    // Computes the extremes of a simplex which will be the initial hull
    computeExtremes() {
        const min = new (0, $0d23c856ce11c301$export$64b5c384219d3699)();
        const max = new (0, $0d23c856ce11c301$export$64b5c384219d3699)();
        const minVertices = [];
        const maxVertices = [];
        // initially assume that the first vertex is the min/max
        for(let i = 0; i < 3; i++)minVertices[i] = maxVertices[i] = this.vertices[0];
        min.copy(this.vertices[0].point);
        max.copy(this.vertices[0].point);
        // compute the min/max vertex on all six directions
        for(let i = 0, l = this.vertices.length; i < l; i++){
            const vertex = this.vertices[i];
            const point = vertex.point;
            // update the min coordinates
            for(let j = 0; j < 3; j++)if (point.getComponent(j) < min.getComponent(j)) {
                min.setComponent(j, point.getComponent(j));
                minVertices[j] = vertex;
            }
            // update the max coordinates
            for(let j = 0; j < 3; j++)if (point.getComponent(j) > max.getComponent(j)) {
                max.setComponent(j, point.getComponent(j));
                maxVertices[j] = vertex;
            }
        }
        // use min/max vectors to compute an optimal epsilon
        this.tolerance = 3 * Number.EPSILON * (Math.max(Math.abs(min.x), Math.abs(max.x)) + Math.max(Math.abs(min.y), Math.abs(max.y)) + Math.max(Math.abs(min.z), Math.abs(max.z)));
        return {
            min: minVertices,
            max: maxVertices
        };
    }
    // Computes the initial simplex assigning to its faces all the points
    // that are candidates to form part of the hull
    computeInitialHull() {
        const vertices = this.vertices;
        const extremes = this.computeExtremes();
        const min = extremes.min;
        const max = extremes.max;
        // 1. Find the two vertices 'v0' and 'v1' with the greatest 1d separation
        // (max.x - min.x)
        // (max.y - min.y)
        // (max.z - min.z)
        let maxDistance = 0;
        let index = 0;
        for(let i = 0; i < 3; i++){
            const distance = max[i].point.getComponent(i) - min[i].point.getComponent(i);
            if (distance > maxDistance) {
                maxDistance = distance;
                index = i;
            }
        }
        const v0 = min[index];
        const v1 = max[index];
        let v2;
        let v3;
        // 2. The next vertex 'v2' is the one farthest to the line formed by 'v0' and 'v1'
        maxDistance = 0;
        $20a834962c536e9e$var$_line3.set(v0.point, v1.point);
        for(let i = 0, l = this.vertices.length; i < l; i++){
            const vertex = vertices[i];
            if (vertex !== v0 && vertex !== v1) {
                $20a834962c536e9e$var$_line3.closestPointToPoint(vertex.point, true, $20a834962c536e9e$var$_closestPoint);
                const distance = $20a834962c536e9e$var$_closestPoint.distanceToSquared(vertex.point);
                if (distance > maxDistance) {
                    maxDistance = distance;
                    v2 = vertex;
                }
            }
        }
        // 3. The next vertex 'v3' is the one farthest to the plane 'v0', 'v1', 'v2'
        maxDistance = -1;
        $20a834962c536e9e$var$_plane.setFromCoplanarPoints(v0.point, v1.point, v2.point);
        for(let i = 0, l = this.vertices.length; i < l; i++){
            const vertex = vertices[i];
            if (vertex !== v0 && vertex !== v1 && vertex !== v2) {
                const distance = Math.abs($20a834962c536e9e$var$_plane.distanceToPoint(vertex.point));
                if (distance > maxDistance) {
                    maxDistance = distance;
                    v3 = vertex;
                }
            }
        }
        const faces = [];
        if ($20a834962c536e9e$var$_plane.distanceToPoint(v3.point) < 0) {
            // the face is not able to see the point so 'plane.normal' is pointing outside the tetrahedron
            faces.push($20a834962c536e9e$var$Face.create(v0, v1, v2), $20a834962c536e9e$var$Face.create(v3, v1, v0), $20a834962c536e9e$var$Face.create(v3, v2, v1), $20a834962c536e9e$var$Face.create(v3, v0, v2));
            // set the twin edge
            for(let i = 0; i < 3; i++){
                const j = (i + 1) % 3;
                // join face[ i ] i > 0, with the first face
                faces[i + 1].getEdge(2).setTwin(faces[0].getEdge(j));
                // join face[ i ] with face[ i + 1 ], 1 <= i <= 3
                faces[i + 1].getEdge(1).setTwin(faces[j + 1].getEdge(0));
            }
        } else {
            // the face is able to see the point so 'plane.normal' is pointing inside the tetrahedron
            faces.push($20a834962c536e9e$var$Face.create(v0, v2, v1), $20a834962c536e9e$var$Face.create(v3, v0, v1), $20a834962c536e9e$var$Face.create(v3, v1, v2), $20a834962c536e9e$var$Face.create(v3, v2, v0));
            // set the twin edge
            for(let i = 0; i < 3; i++){
                const j = (i + 1) % 3;
                // join face[ i ] i > 0, with the first face
                faces[i + 1].getEdge(2).setTwin(faces[0].getEdge((3 - i) % 3));
                // join face[ i ] with face[ i + 1 ]
                faces[i + 1].getEdge(0).setTwin(faces[j + 1].getEdge(1));
            }
        }
        // the initial hull is the tetrahedron
        for(let i = 0; i < 4; i++)this.faces.push(faces[i]);
        // initial assignment of vertices to the faces of the tetrahedron
        for(let i = 0, l = vertices.length; i < l; i++){
            const vertex = vertices[i];
            if (vertex !== v0 && vertex !== v1 && vertex !== v2 && vertex !== v3) {
                maxDistance = this.tolerance;
                let maxFace = null;
                for(let j = 0; j < 4; j++){
                    const distance = this.faces[j].distanceToPoint(vertex.point);
                    if (distance > maxDistance) {
                        maxDistance = distance;
                        maxFace = this.faces[j];
                    }
                }
                if (maxFace !== null) this.addVertexToFace(vertex, maxFace);
            }
        }
        return this;
    }
    // Removes inactive faces
    reindexFaces() {
        const activeFaces = [];
        for(let i = 0; i < this.faces.length; i++){
            const face = this.faces[i];
            if (face.mark === $20a834962c536e9e$var$Visible) activeFaces.push(face);
        }
        this.faces = activeFaces;
        return this;
    }
    // Finds the next vertex to create faces with the current hull
    nextVertexToAdd() {
        // if the 'assigned' list of vertices is empty, no vertices are left. return with 'undefined'
        if (this.assigned.isEmpty() === false) {
            let eyeVertex, maxDistance = 0;
            // grap the first available face and start with the first visible vertex of that face
            const eyeFace = this.assigned.first().face;
            let vertex = eyeFace.outside;
            // now calculate the farthest vertex that face can see
            do {
                const distance = eyeFace.distanceToPoint(vertex.point);
                if (distance > maxDistance) {
                    maxDistance = distance;
                    eyeVertex = vertex;
                }
                vertex = vertex.next;
            }while (vertex !== null && vertex.face === eyeFace);
            return eyeVertex;
        }
    }
    // Computes a chain of half edges in CCW order called the 'horizon'.
    // For an edge to be part of the horizon it must join a face that can see
    // 'eyePoint' and a face that cannot see 'eyePoint'.
    computeHorizon(eyePoint, crossEdge, face, horizon) {
        // moves face's vertices to the 'unassigned' vertex list
        this.deleteFaceVertices(face);
        face.mark = $20a834962c536e9e$var$Deleted;
        let edge;
        if (crossEdge === null) edge = crossEdge = face.getEdge(0);
        else // start from the next edge since 'crossEdge' was already analyzed
        // (actually 'crossEdge.twin' was the edge who called this method recursively)
        edge = crossEdge.next;
        do {
            const twinEdge = edge.twin;
            const oppositeFace = twinEdge.face;
            if (oppositeFace.mark === $20a834962c536e9e$var$Visible) {
                if (oppositeFace.distanceToPoint(eyePoint) > this.tolerance) // the opposite face can see the vertex, so proceed with next edge
                this.computeHorizon(eyePoint, twinEdge, oppositeFace, horizon);
                else // the opposite face can't see the vertex, so this edge is part of the horizon
                horizon.push(edge);
            }
            edge = edge.next;
        }while (edge !== crossEdge);
        return this;
    }
    // Creates a face with the vertices 'eyeVertex.point', 'horizonEdge.tail' and 'horizonEdge.head' in CCW order
    addAdjoiningFace(eyeVertex, horizonEdge) {
        // all the half edges are created in ccw order thus the face is always pointing outside the hull
        const face = $20a834962c536e9e$var$Face.create(eyeVertex, horizonEdge.tail(), horizonEdge.head());
        this.faces.push(face);
        // join face.getEdge( - 1 ) with the horizon's opposite edge face.getEdge( - 1 ) = face.getEdge( 2 )
        face.getEdge(-1).setTwin(horizonEdge.twin);
        return face.getEdge(0); // the half edge whose vertex is the eyeVertex
    }
    //  Adds 'horizon.length' faces to the hull, each face will be linked with the
    //  horizon opposite face and the face on the left/right
    addNewFaces(eyeVertex, horizon) {
        this.newFaces = [];
        let firstSideEdge = null;
        let previousSideEdge = null;
        for(let i = 0; i < horizon.length; i++){
            const horizonEdge = horizon[i];
            // returns the right side edge
            const sideEdge = this.addAdjoiningFace(eyeVertex, horizonEdge);
            if (firstSideEdge === null) firstSideEdge = sideEdge;
            else // joins face.getEdge( 1 ) with previousFace.getEdge( 0 )
            sideEdge.next.setTwin(previousSideEdge);
            this.newFaces.push(sideEdge.face);
            previousSideEdge = sideEdge;
        }
        // perform final join of new faces
        firstSideEdge.next.setTwin(previousSideEdge);
        return this;
    }
    // Adds a vertex to the hull
    addVertexToHull(eyeVertex) {
        const horizon = [];
        this.unassigned.clear();
        // remove 'eyeVertex' from 'eyeVertex.face' so that it can't be added to the 'unassigned' vertex list
        this.removeVertexFromFace(eyeVertex, eyeVertex.face);
        this.computeHorizon(eyeVertex.point, null, eyeVertex.face, horizon);
        this.addNewFaces(eyeVertex, horizon);
        // reassign 'unassigned' vertices to the new faces
        this.resolveUnassignedPoints(this.newFaces);
        return this;
    }
    cleanup() {
        this.assigned.clear();
        this.unassigned.clear();
        this.newFaces = [];
        return this;
    }
    compute() {
        let vertex;
        this.computeInitialHull();
        // add all available vertices gradually to the hull
        while((vertex = this.nextVertexToAdd()) !== undefined)this.addVertexToHull(vertex);
        this.reindexFaces();
        this.cleanup();
        return this;
    }
}
//
class $20a834962c536e9e$var$Face {
    constructor(){
        this.normal = new (0, $0d23c856ce11c301$export$64b5c384219d3699)();
        this.midpoint = new (0, $0d23c856ce11c301$export$64b5c384219d3699)();
        this.area = 0;
        this.constant = 0; // signed distance from face to the origin
        this.outside = null; // reference to a vertex in a vertex list this face can see
        this.mark = $20a834962c536e9e$var$Visible;
        this.edge = null;
    }
    static create(a, b, c) {
        const face = new $20a834962c536e9e$var$Face();
        const e0 = new $20a834962c536e9e$var$HalfEdge(a, face);
        const e1 = new $20a834962c536e9e$var$HalfEdge(b, face);
        const e2 = new $20a834962c536e9e$var$HalfEdge(c, face);
        // join edges
        e0.next = e2.prev = e1;
        e1.next = e0.prev = e2;
        e2.next = e1.prev = e0;
        // main half edge reference
        face.edge = e0;
        return face.compute();
    }
    getEdge(i) {
        let edge = this.edge;
        while(i > 0){
            edge = edge.next;
            i--;
        }
        while(i < 0){
            edge = edge.prev;
            i++;
        }
        return edge;
    }
    compute() {
        const a = this.edge.tail();
        const b = this.edge.head();
        const c = this.edge.next.head();
        $20a834962c536e9e$var$_triangle.set(a.point, b.point, c.point);
        $20a834962c536e9e$var$_triangle.getNormal(this.normal);
        $20a834962c536e9e$var$_triangle.getMidpoint(this.midpoint);
        this.area = $20a834962c536e9e$var$_triangle.getArea();
        this.constant = this.normal.dot(this.midpoint);
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) - this.constant;
    }
}
// Entity for a Doubly-Connected Edge List (DCEL).
class $20a834962c536e9e$var$HalfEdge {
    constructor(vertex, face){
        this.vertex = vertex;
        this.prev = null;
        this.next = null;
        this.twin = null;
        this.face = face;
    }
    head() {
        return this.vertex;
    }
    tail() {
        return this.prev ? this.prev.vertex : null;
    }
    length() {
        const head = this.head();
        const tail = this.tail();
        if (tail !== null) return tail.point.distanceTo(head.point);
        return -1;
    }
    lengthSquared() {
        const head = this.head();
        const tail = this.tail();
        if (tail !== null) return tail.point.distanceToSquared(head.point);
        return -1;
    }
    setTwin(edge) {
        this.twin = edge;
        edge.twin = this;
        return this;
    }
}
// A vertex as a double linked list node.
class $20a834962c536e9e$var$VertexNode {
    constructor(point){
        this.point = point;
        this.prev = null;
        this.next = null;
        this.face = null; // the face that is able to see this vertex
    }
}
// A double linked list that contains vertex nodes.
class $20a834962c536e9e$var$VertexList {
    constructor(){
        this.head = null;
        this.tail = null;
    }
    first() {
        return this.head;
    }
    last() {
        return this.tail;
    }
    clear() {
        this.head = this.tail = null;
        return this;
    }
    // Inserts a vertex before the target vertex
    insertBefore(target, vertex) {
        vertex.prev = target.prev;
        vertex.next = target;
        if (vertex.prev === null) this.head = vertex;
        else vertex.prev.next = vertex;
        target.prev = vertex;
        return this;
    }
    // Inserts a vertex after the target vertex
    insertAfter(target, vertex) {
        vertex.prev = target;
        vertex.next = target.next;
        if (vertex.next === null) this.tail = vertex;
        else vertex.next.prev = vertex;
        target.next = vertex;
        return this;
    }
    // Appends a vertex to the end of the linked list
    append(vertex) {
        if (this.head === null) this.head = vertex;
        else this.tail.next = vertex;
        vertex.prev = this.tail;
        vertex.next = null; // the tail has no subsequent vertex
        this.tail = vertex;
        return this;
    }
    // Appends a chain of vertices where 'vertex' is the head.
    appendChain(vertex) {
        if (this.head === null) this.head = vertex;
        else this.tail.next = vertex;
        vertex.prev = this.tail;
        // ensure that the 'tail' reference points to the last vertex of the chain
        while(vertex.next !== null)vertex = vertex.next;
        this.tail = vertex;
        return this;
    }
    // Removes a vertex from the linked list
    remove(vertex) {
        if (vertex.prev === null) this.head = vertex.next;
        else vertex.prev.next = vertex.next;
        if (vertex.next === null) this.tail = vertex.prev;
        else vertex.next.prev = vertex.prev;
        return this;
    }
    // Removes a list of vertices whose 'head' is 'a' and whose 'tail' is b
    removeSubList(a, b) {
        if (a.prev === null) this.head = b.next;
        else a.prev.next = b.next;
        if (b.next === null) this.tail = a.prev;
        else b.next.prev = a.prev;
        return this;
    }
    isEmpty() {
        return this.head === null;
    }
}


class $1b1ca1552d0f471d$export$7af97143bfc37a8f extends (0, $0d23c856ce11c301$export$b7be63a67df8959) {
    constructor(points){
        super();
        // buffers
        const vertices = [];
        const normals = [];
        if ((0, $20a834962c536e9e$export$2062365927816f76) === undefined) console.error("THREE.ConvexBufferGeometry: ConvexBufferGeometry relies on ConvexHull");
        const convexHull = new (0, $20a834962c536e9e$export$2062365927816f76)().setFromPoints(points);
        // generate vertices and normals
        const faces = convexHull.faces;
        for(let i = 0; i < faces.length; i++){
            const face = faces[i];
            let edge = face.edge;
            // we move along a doubly-connected edge list to access all face points (see HalfEdge docs)
            do {
                const point = edge.head().point;
                vertices.push(point.x, point.y, point.z);
                normals.push(face.normal.x, face.normal.y, face.normal.z);
                edge = edge.next;
            }while (edge !== face.edge);
        }
        // build geometry
        this.setAttribute("position", new (0, $0d23c856ce11c301$export$cbe7a62641830ebd)(vertices, 3));
        this.setAttribute("normal", new (0, $0d23c856ce11c301$export$cbe7a62641830ebd)(normals, 3));
    }
}






/**
 * @author Iker Hurtado
 *
 * @fileoverview File holding the ViewOptionsDropDown UI component
 */ 
class $de574a32c8fefb66$export$2e2bcd8739ae039 extends (0, $cb4961254c9228c8$export$2e2bcd8739ae039) {
    constructor(){
        super("View options");
        this.defaultValues = [];
        this.REC_UNIT_CELL_OPTION = "show-rec-unit-cell";
        this.REC_CART_AXES_OPTION = "show-rec-lattice-vectors-parameters";
        this.REC_LATTICE_AXES_OPTION = "show-lattice-vectors-parameters";
        this.addOption(this.REC_UNIT_CELL_OPTION, "Show reciprocal cell", true);
        this.addOption(this.REC_CART_AXES_OPTION, "Show Cartesian axes", true);
        this.addOption(this.REC_LATTICE_AXES_OPTION, "Show reciprocal axes", true);
    }
    /**
   * Adds a new option (as a checkbox)
   * @param {string} name Option identificator
   * @param {string} label Label being shown
   * @param {boolean} defaultValue If checked by default
   * @param {boolean} onlyShowIfPeriodic Only shown for periodic structures
   */ addOption(name, label, defaultValue) {
        this.container.innerHTML += `<li><input type="checkbox" name="${name}" } >${label}</li>`;
        // ${defaultValue ? 'checked' : ''
        this.defaultValues.push(defaultValue);
    }
    reset() {
        let checkboxes = this.getElements("input");
        this.options = this.getElements("li");
        for(let i = 0; i < checkboxes.length; i++)checkboxes[i].checked = this.defaultValues[i];
    //console.log('this.checkboxes', checkboxes)
    }
    /**
   * If an option is checked or not
   * @param {string} option Option identificator
   * @return {boolean}
   */ isOptionChecked(option) {
        return this.getElement('input[name="' + option + '"]').checked;
    }
    /**
   * Sets the listener that will be called when a checkbox is clicked
   * @param {function} listener
   */ setCheckListener(listener) {
        this.container.addEventListener("click", listener);
    }
}



const $d0456dc84d1a72e5$var$CELL_BASIS_COLORS = [
    "#C52929",
    "#47A823",
    "#3B5796"
];
class $d0456dc84d1a72e5$export$2e2bcd8739ae039 {
    constructor(hostElement){
        this.hostElement = hostElement;
        this.heading = document.createElement("div");
        this.heading.innerHTML = "<h2>Brillouin Zone Viewer</h2>";
        // this.heading.style.position = 'absolute'
        this.heading.style.width = "100%";
        this.heading.style.boxSizing = "content-box";
        this.heading.style.textAlign = "center";
        this.hostElement.appendChild(this.heading);
        this.threeViewer = new (0, $e4a79c8070f9e79e$export$2e2bcd8739ae039)(hostElement);
        this.threeViewer.init();
        this.createViewingControls();
        this.screenTaker = new (0, $a4e45eea12196606$export$2e2bcd8739ae039)("bz");
        this.screenTaker.e.style.marginTop = "3px";
        this.screenTaker.e.style.paddingLeft = "30px";
        this.screenTaker.setScreenshotListener((linkElement)=>{
            this.threeViewer.render();
            linkElement.href = this.threeViewer.renderer.domElement.toDataURL();
            this.threeViewer.render();
        });
        this.viewerControls.appendChild(this.screenTaker.e);
    }
    setNewStructure(structure, reset = true, paths) {
        if (!structure.isAPeriodicSystem()) this.hostElement.style.display = "none";
        else {
            this.hostElement.style.display = "block";
            this.threeViewer.clearScenes();
            // Clear canvas context
            this.setupVisualization(structure.latVectors, reset, paths);
        }
    // console.log('this.threeViewer.camera.position',this.threeViewer.camera.position)
    }
    selectStructure(structure) {
        this.setNewStructure(structure);
    }
    updateStructure(structure) {
        this.setNewStructure(structure);
    }
    async setupVisualization(data, resetZoom = true, paths) {
        let recCell = [];
        (0, $a4310c0d7cebdf93$export$271d2f969e55c97)((0, $a4310c0d7cebdf93$export$a48d4501dfd597fa)(data)).forEach((v)=>{
            recCell.push((0, $a4310c0d7cebdf93$export$c697bed75648cdb7)(v, 2.0 * Math.PI));
        });
        this.recCell = $f880bd393c028d36$export$f8cb66e0391a6d5f(recCell);
        // console.log('this.recCell',this.recCell);
        this.root = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        this.root.name = "bz"; //'structure'
        this.threeViewer.mainScene.add(this.root);
        // console.log(this.recCell);
        // Set position and adjust the zoom to the structure size: if the structure is smaller the zoom is larger
        this.root.position.copy(new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, 0));
        if (resetZoom) {
            let diagonal = this.recCell[0].clone().add(this.recCell[1]).add(this.recCell[2]);
            const factor = this.threeViewer.hostElement.clientWidth / 820 + 0.2;
            console.log("factor", factor);
            this.threeViewer.adjustZoomToStructSize(diagonal.length() * factor); //this.editable ?  diagonal.length() : diagonal.length()*0.4 )
        }
        // this.bz = new THREE.Geometry()
        this.latticeVectors = this.createLatticeVectors(this.recCell);
        this.recCartAxes = this.createRecCartAxes();
        // this.recCartAxes.visible = false
        this.root.add(this.latticeVectors);
        this.root.add(this.recCartAxes);
        // this.bz_vertices = this.request_bz_vertices(recCell)
        let bz_vertices = await this.request_bz_vertices(recCell);
        this.createBZ(bz_vertices.vertices);
        // console.log(paths);
        if (paths) this.createPath(paths);
        else this.createPath(bz_vertices.path);
        this.recUnitCell = this.createCell(0x000000, 1.5);
        // this.recUnitCell.visible = false
        this.root.add(this.recUnitCell);
        this.latticeParamsLabels = this.createLatticeParamsLabels();
        this.latticeParamsLabels.name = "recLattice-parameters";
        this.latticeParamsLabels.position.copy(new $0d23c856ce11c301$export$64b5c384219d3699(0, 0, 0));
        this.threeViewer.infoScene.add(this.latticeParamsLabels);
        this.threeViewer.render();
        this.viewOptionsDropdown.reset();
        return true;
    }
    async request_bz_vertices(recCell) {
        let response = await fetch("/get-bz-vertices", {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(recCell)
        });
        if (response.ok) {
            // File or server controlled errors
            // It's needed to get the text because of the FileNotFoundError checking
            let vertices = await response.text(); //await response.arrayBuffer()
            return JSON.parse(vertices);
        } else // Unknown server ERROR
        $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("Unknown server ERROR ");
    }
    createBZ(bz_vertices) {
        let lineMaterial = new $0d23c856ce11c301$export$fbaaa33907730a0c({
            color: 0x000000,
            linewidth: 1.5
        });
        let bzPoints = [];
        this.bzLines = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        bz_vertices.forEach((face)=>{
            let linePoints = [];
            let first;
            face.forEach((v, iv)=>{
                bzPoints.push(new $0d23c856ce11c301$export$64b5c384219d3699(...v));
                if (iv === 0) first = new $0d23c856ce11c301$export$64b5c384219d3699(...v);
                linePoints.push(new $0d23c856ce11c301$export$64b5c384219d3699(...v));
            });
            linePoints.push(first);
            let lineGeometry = new $0d23c856ce11c301$export$b7be63a67df8959().setFromPoints(linePoints);
            this.bzLines.add(new $0d23c856ce11c301$export$17d680238e50603e(lineGeometry, lineMaterial));
        });
        this.geometry = new $0d23c856ce11c301$export$e176487c05830cc5(new (0, $1b1ca1552d0f471d$export$7af97143bfc37a8f)(bzPoints), new $0d23c856ce11c301$export$24c72f71cbaf0678({
            color: "#80d1e3",
            transparent: true,
            opacity: 0.2,
            side: $0d23c856ce11c301$export$3b296b6f144d5b03,
            depthWrite: false,
            depthTest: true
        }));
        this.root.add(this.bzLines);
        this.root.add(this.geometry);
    }
    createPath(bzPath) {
        const minVectorLength = Math.min(this.recCell[0].length(), this.recCell[1].length(), this.recCell[2].length());
        const labelSize = 2.5 * minVectorLength;
        this.bzPath = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        let lineMaterial = new $0d23c856ce11c301$export$fbaaa33907730a0c({
            color: 0xD64D28,
            linewidth: 10.0
        });
        let myLabels = [];
        bzPath.forEach((path)=>{
            let linePoints = [];
            // console.log(path)
            // Create Path
            path[1].forEach((fracPoint, i)=>{
                let point = new $0d23c856ce11c301$export$64b5c384219d3699(0.0, 0.0, 0.0);
                fracPoint.forEach((comp, i)=>{
                    // console.log(this.recCell[i],comp);
                    point.add(this.recCell[i].clone().multiplyScalar(comp));
                });
                let label = path[0][i];
                if (!myLabels.some((l)=>l === label)) {
                    if (label === "G" || label.toLowerCase() === "gamma") label = "\u0393";
                    let labelPos = point.clone().add(new $0d23c856ce11c301$export$64b5c384219d3699(0.05, 0.05, 0.05));
                    let threeLabel = this.createLabel(label, 0x000000, labelPos, labelSize);
                    this.bzPath.add(threeLabel);
                }
                // console.log('point',point);
                linePoints.push(point);
            });
            // console.log(lineGeometry.vertices);
            this.bzPath.add(new $0d23c856ce11c301$export$17d680238e50603e(new $0d23c856ce11c301$export$b7be63a67df8959().setFromPoints(linePoints), lineMaterial));
        });
        this.root.add(this.bzPath);
    }
    getHTMLBandPath(paths) {
        let table = document.createElement("table");
        table.classList.add("band-path-table");
        paths.forEach((path, j)=>{
            let headerTr = document.createElement("tr");
            let pathTh = document.createElement("th");
            pathTh.colSpan = 2;
            pathTh.style.textAlign = "left";
            pathTh.style.padding = "8px 0 4px 0";
            pathTh.innerHTML = `Path ${j + 1}: ` + path[0].join("-");
            headerTr.appendChild(pathTh);
            table.appendChild(headerTr);
            path[1].forEach((segment, i)=>{
                let segmentTr = document.createElement("tr");
                let labelTd = document.createElement("td");
                labelTd.innerHTML = path[0][i];
                let pointTd = document.createElement("td");
                pointTd.innerHTML = "[" + segment.join() + "]";
                segmentTr.appendChild(labelTd);
                segmentTr.appendChild(pointTd);
                table.appendChild(segmentTr);
            });
        });
        return table;
    }
    createLatticeVectors(basisVectors) {
        let latticeVectors = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        const origin = new $0d23c856ce11c301$export$64b5c384219d3699();
        let minVectorLength = Math.min(basisVectors[0].length(), basisVectors[1].length(), basisVectors[2].length());
        // console.log('minVectorLength', minVectorLength)
        for(let basisIndex = 0; basisIndex < 3; ++basisIndex){
            const color = $d0456dc84d1a72e5$var$CELL_BASIS_COLORS[basisIndex];
            const basisVector = basisVectors[basisIndex].clone();
            // Add basis vector colored line
            const vectorMaterial = new $0d23c856ce11c301$export$55cbcc9b622fe1f5({
                color: color
            });
            const radius = minVectorLength > 20 ? 0.2 : minVectorLength * 0.01;
            let basisVectorMesh = $f880bd393c028d36$export$2a1e684e74282069(basisVector.clone().multiplyScalar(0.5), basisVector, radius, 10, vectorMaterial);
            latticeVectors.add(basisVectorMesh);
            // Add an arrow following the basis vector direction
            let arrowMesh = $f880bd393c028d36$export$8f7d98f7c012cca0(origin, basisVector, minVectorLength);
            latticeVectors.add(arrowMesh);
        }
        return latticeVectors;
    }
    createLabel(label, color, position, minVectorLength) {
        // Configure canvas
        let canvas = document.createElement("canvas");
        const size = 512;
        canvas.width = size;
        canvas.height = size;
        let ctx = canvas.getContext("2d");
        // Draw label
        ctx.fillStyle = color;
        ctx.textAlign = "center";
        ctx.font = 15 * minVectorLength + "px Arimo";
        ctx.lineWidth = 0.5; //(minVectorLength < 5 ? 3 : 8)
        ctx.strokeStyle = "#000000";
        ctx.strokeText(label, size / 2, size / 2);
        ctx.fillText(label, size / 2, size / 2);
        let texture = new $0d23c856ce11c301$export$5431306cf43de24a(canvas);
        texture.needsUpdate = true;
        let sprite = new $0d23c856ce11c301$export$3075603db8e6204c(new $0d23c856ce11c301$export$5ec7dd1c6994bf8e({
            map: texture,
            transparent: true,
            opacity: 0.9,
            depthWrite: false,
            depthTest: true
        }));
        sprite.position.copy(position);
        sprite.scale.set(2, 2, 1);
        return sprite;
    }
    createViewingControls() {
        this.viewerControls = document.createElement("div");
        // this.viewerControls.appendChild(this.heading)
        this.hostElement.appendChild(this.viewerControls);
        this.viewerControls.className = "viewing-controls";
        this.viewOptionsDropdown = new (0, $de574a32c8fefb66$export$2e2bcd8739ae039)(); //this)
        this.viewerControls.appendChild(this.viewOptionsDropdown.e);
        this.viewOptionsDropdown.setCheckListener((e)=>{
            //console.log('setCheckListener e', e.target.name)
            if (e.target.name === this.viewOptionsDropdown.REC_UNIT_CELL_OPTION) {
                this.recUnitCell.visible = e.target.checked;
                console.log("REC_UNIT_CELL_OPTION");
            } else if (e.target.name === this.viewOptionsDropdown.REC_CART_AXES_OPTION) {
                this.recCartAxes.visible = e.target.checked;
                console.log("REC_CART_AXES_OPTION");
            // console.log('this.root', this.bonds, this.bonds.visible)
            } else if (e.target.name === this.viewOptionsDropdown.REC_LATTICE_AXES_OPTION) {
                this.latticeVectors.visible = e.target.checked;
                this.latticeParamsLabels.visible = e.target.checked;
                console.log("REC_LATTICE_AXES_OPTION");
            }
            this.threeViewer.render();
        });
    }
    createRecCartAxes() {
        let latticeVectors = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        const origin = new $0d23c856ce11c301$export$64b5c384219d3699();
        const labels = [
            "x*",
            "y*",
            "z*"
        ];
        const minVectorLength = Math.min(this.recCell[0].length(), this.recCell[1].length(), this.recCell[2].length());
        const labelSize = 2.5 * minVectorLength;
        // console.log('minVectorLength', minVectorLength)
        const cartL = minVectorLength / 4;
        const cartAxes = [
            [
                cartL,
                0,
                0
            ],
            [
                0,
                cartL,
                0
            ],
            [
                0,
                0,
                cartL
            ]
        ];
        for(let basisIndex = 0; basisIndex < 3; ++basisIndex){
            const color = 0x585858;
            // console.log(...cartAxes[basisIndex]);
            const basisVector = new $0d23c856ce11c301$export$64b5c384219d3699(...cartAxes[basisIndex]);
            let labelPos = basisVector.clone().normalize().multiplyScalar(basisVector.length() * 1.1 + (cartL + 3) * 0.1);
            let vectorLabelSprite = this.createLabel(labels[basisIndex], color, labelPos, labelSize);
            let arrowMesh = $f880bd393c028d36$export$8f7d98f7c012cca0(origin, basisVector, cartL, color);
            latticeVectors.add(vectorLabelSprite);
            latticeVectors.add(arrowMesh);
        }
        return latticeVectors;
    }
    createLatticeParamsLabels() {
        let latticeParams = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4();
        const labels = [
            "a*",
            "b*",
            "c*"
        ];
        const minVectorLength = Math.min(this.recCell[0].length(), this.recCell[1].length(), this.recCell[2].length());
        const labelSize = 2.5 * minVectorLength;
        for(let basisIndex = 0; basisIndex < 3; ++basisIndex){
            const color = $d0456dc84d1a72e5$var$CELL_BASIS_COLORS[basisIndex];
            const basisVector = this.recCell[basisIndex].clone();
            // const nextBasisVector = this.recCell[(basisIndex+1)%3].clone();
            let labelPos = basisVector.clone().normalize().multiplyScalar(basisVector.length() + (minVectorLength + 3) * 0.1 + 0.1);
            let vectorLabelSprite = this.createLabel(labels[basisIndex], color, labelPos, labelSize);
            latticeParams.add(vectorLabelSprite);
        }
        return latticeParams;
    }
    /**
   * Creates the cell box
   * @param  {number} color
   * @param  {int} linewidth
   */ createCell(color, linewidth) {
        const basisVectors = this.recCell;
        let origin = new $0d23c856ce11c301$export$64b5c384219d3699(); // 0,0,0 point
        let cell = new $0d23c856ce11c301$export$eb2fcfdbd7ba97d4(); // holding the cell lines
        let lineMaterial = new $0d23c856ce11c301$export$fbaaa33907730a0c({
            color: color,
            linewidth: linewidth
        });
        // Draws two lines per basis vector to complete the cube (cell)
        // The first line is compound of 3 segments and the second of 1
        // 3+1 = 4 segments (cube edges) x 3 basis vectors = 12 total cube edges
        for(let len = basisVectors.length, i = 0; i < len; ++i){
            const basisVector = basisVectors[i].clone();
            // Forms the first line (3 segments) geometry
            // let lineGeometry = new THREE.Geometry();
            let thirdPoint = basisVectors[(i + 1) % len].clone().add(basisVector);
            let fourthPoint = basisVectors[(i + 2) % len].clone().add(thirdPoint);
            // lineGeometry.vertices.push(origin, basisVector, thirdPoint, fourthPoint);
            let lineGeometry = new $0d23c856ce11c301$export$b7be63a67df8959().setFromPoints([
                origin,
                basisVector,
                thirdPoint,
                fourthPoint
            ]);
            cell.add(new $0d23c856ce11c301$export$17d680238e50603e(lineGeometry, lineMaterial));
            // lineGeometry.computeLineDistances();
            // Forms the second line (1 segment) geometry
            // let lineGeometry2 = new THREE.Geometry();
            // lineGeometry2.vertices.push(basisVector,
            // basisVector.clone().add(basisVectors[(i === 0 ? 2 : i-1)]));
            cell.add(new $0d23c856ce11c301$export$17d680238e50603e(new $0d23c856ce11c301$export$b7be63a67df8959().setFromPoints([
                basisVector,
                basisVector.clone().add(basisVectors[i === 0 ? 2 : i - 1])
            ]), lineMaterial));
        //console.log('cell created:',cell);
        }
        return cell;
    }
    getBandPath(bsData) {
        let paths = [];
        let path = [
            [],
            []
        ];
        let endPair = undefined;
        bsData.forEach((segment)=>{
            let start = segment["band_k_points"][0];
            let end = segment["band_k_points"][segment["band_k_points"].length - 1];
            let isNextPath = endPair && !start.every((value, index)=>value === endPair[1][index]);
            if (isNextPath) {
                path[0].push(endPair[0]);
                path[1].push(endPair[1]);
                paths.push(path.slice());
                path = [
                    [],
                    []
                ];
            }
            let labels = segment["band_segm_labels"];
            path[0].push(labels ? isGamma(labels[0]) : "?");
            path[1].push(start);
            endPair = [
                labels ? isGamma(labels[1]) : "?",
                end
            ];
        });
        path[0].push(endPair[0]);
        path[1].push(endPair[1]);
        paths.push(path);
        // console.log(paths)
        return paths;
        function isGamma(string) {
            if (string === "G" || string.toLowerCase() === "gamma") return "\u0393";
            else return string;
        }
    }
}



var $1c7ea71d7b8285c9$exports = {};
$1c7ea71d7b8285c9$exports = new URL("collapsible-icon.a6e3afbe.png", import.meta.url).toString();


class $b17664ddee69cf4f$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param  {string} className Component class name
   */ constructor(className){
        //
        super("div", ".Accordion" + (className === undefined ? "" : " " + className));
        this.ROTATE_STYLE = "transform: rotate(180deg)";
        this.sectionHeaders = [];
        this.sectionContents = [];
    }
    /**
   * Resets the component. Remove everything
   */ reset() {
        this.sectionHeaders = [];
        this.sectionContents = [];
        this.setHTML("");
    }
    /**
   * Sets a section in accordeon
   * @param {string} name
   * @param {HTMLElement} element
   */ setSection(name, element) {
        let sectionHeader = this.addElement("div", name + ` <img src="${0, (/*@__PURE__*/$parcel$interopDefault($1c7ea71d7b8285c9$exports))}"  alt="collapse"/> `);
        let icon = sectionHeader.querySelector("img");
        sectionHeader.className = "sectionHeader";
        this.sectionHeaders.push(sectionHeader);
        sectionHeader.addEventListener("click", (_)=>{
            this.foldSection(this.sectionHeaders.indexOf(sectionHeader));
        });
        let sectionContent = this.addElement("div");
        sectionContent.className = "sectionContent";
        sectionContent.appendChild(element);
        this.sectionContents.push(sectionContent);
        // if (this.sectionContents.length > 1){
        //   sectionContent.style.display = 'none'
        // }else
        icon.style = this.ROTATE_STYLE;
    //this.e.appendChild(element)
    }
    /**
   * Folds or unfolds the section depending on its current state
   * @param  n{int} section index
   */ foldSection(n) {
        //
        let content = this.sectionContents[n];
        let folded = content.style.display === "none";
        content.style.display = folded ? "block" : "none";
        this.sectionHeaders[n].querySelector("img").style = folded ? this.ROTATE_STYLE : "";
    }
    isSectionFolded(n) {
        let content = this.sectionContents[n];
        return content.style.display === "none";
    }
    /**
   * Completely hides the section
   * @param  n{int} section index
   */ hideSection(n) {
        //
        let header = this.sectionHeaders[n];
        let content = this.sectionContents[n];
        header.style.display = "none";
        content.style.display = "none";
    }
    /**
  * Shows the hidden section
  * @param  n{int} section index
  */ showSection(n) {
        //
        let header = this.sectionHeaders[n];
        let content = this.sectionContents[n];
        header.style.display = "flex";
        content.style.display = "block";
    }
}


const $5394a2fd932d6e8f$var$DEFAULT_MODE = "default";
// const IMPORT_MODE = 'import'
// const EXPORT_MODE = 'export'
// const RESET_MODE = 'reset'
const $5394a2fd932d6e8f$var$STRUCT_TOO_BIG_MSG = "Repeat operation not performed: the resulting structure is too big";
const $5394a2fd932d6e8f$var$SURFACE_GENERATION_ERROR_MSG = "The slab cannot be built from the provided data";
const $5394a2fd932d6e8f$var$ONLY_FOR_PERIODIC_MSG = "This functionality is only supported for periodic structures!";
class $5394a2fd932d6e8f$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("div", ".StructureBuilderMod");
        this.setHTML(`
				<div class="structure-viewer-info">

					<div class="StructureSelector-ph"> </div>

        	<div class="StructureViewer"> </div>

          <div class="shortcuts-box">
						<table>
								<tr> <td>Undo/Redo</td> <td>Ctrl+Z / Ctrl+Y</td> </tr>

								<tr> <td class="shortcuts-title" colspan="2"><b>Structure modification</b> (<i>Edit structure</i> button ON)</td> </tr>
								<tr> <td>Move Atom</td> <td>Atom dragging (mouse)</td> </tr>
								<tr> <td>Delete Atom</td> <td>D + Click on atom</td> </tr>

						</table>
						<table>
							<tr> <td class="shortcuts-title" colspan="2"><b>Atoms selection and measurements</b></td> </tr>
							<tr> <td>Atom Distance</td> <td>Shift + Click on two atoms</td> </tr>
							<tr> <td>Atom Angle</td> <td>Shift + Click on three atoms</td> </tr>
							<tr> <td>Torsion Angle </td> <td>Shift + Click on four atoms</td> </tr>
						</table>
					</div>

					<div class="BZViewer"></div>

				</div>

        <div class="right-side-panel">

          <button class='top-right-btn'> Import </button>
          <button class='top-right-btn'> Export </button>
          <!--button class="top-right-btn"> Reset </button-->
					<div class="Accordion-ph"> </div>

          <!--div class="LatticeVectors-ph"></div-->

					<div class="LatticeOperations"></div>

          <div class="BasisAtoms-ph"></div>

        </div>
      `);
        // state
        this.structure = new (0, $495a3b82f25facb5$export$2e2bcd8739ae039)();
        this.editable = true;
        this.mode = $5394a2fd932d6e8f$var$DEFAULT_MODE;
        this.state = new (0, $54ed6027fe36a069$export$2e2bcd8739ae039)();
        this.importerBox = new $5394a2fd932d6e8f$var$GeometryImporter(this.state);
        this.exporterBox = new $5394a2fd932d6e8f$var$Exporter();
        // this.resetPanel = new ResetPanel(this.state)
        const buttons = this.getElements(".top-right-btn");
        // Import button
        buttons[0].addEventListener("click", (_)=>{
            $9d993874406c4873$export$a778490beb6e83b8(this.importerBox.e);
            $9d993874406c4873$export$d7e8d4d4450c819c(true);
        });
        // Export button
        buttons[1].addEventListener("click", (_)=>{
            $9d993874406c4873$export$a778490beb6e83b8(this.exporterBox.e);
            $9d993874406c4873$export$d7e8d4d4450c819c(true);
        });
        // Reset button
        // buttons[2].addEventListener( 'click', e => {
        //   ModalPopup.setModalComponent(this.resetPanel.e)
        //   ModalPopup.showModal(true)
        // })
        this.accordion = new (0, $b17664ddee69cf4f$export$2e2bcd8739ae039)("structure-builder-side");
        this.getElement(".Accordion-ph").appendChild(this.accordion.e);
        this.lattVectors = new $5394a2fd932d6e8f$var$LatticeVectors(this.state);
        this.accordion.setSection("Lattice Vectors", this.lattVectors.e);
        this.state.subscribeToStructure(this.lattVectors);
        this.basisAtoms = new (0, $96fc1647f4af9dc5$export$2e2bcd8739ae039)(this.state);
        this.accordion.setSection("Atomic Positions", this.basisAtoms.e);
        this.state.subscribeToAll(this.basisAtoms);
        this.structureInfo = new (0, $6307f518240c06cd$export$2e2bcd8739ae039)(this.state);
        this.accordion.setSection("Structure Info", this.structureInfo.e);
        this.state.subscribeToStructure(this.structureInfo);
        this.accordion.foldSection(2);
        this.scell = new $5394a2fd932d6e8f$var$Supercell(this.state);
        this.accordion.setSection("Supercell", this.scell.e);
        this.state.subscribeToStructure(this.scell);
        this.accordion.foldSection(3);
        this.primitive = new (0, $797427dcddf8f609$export$2e2bcd8739ae039)(this.state);
        this.accordion.setSection("Standardized Cells", this.primitive.e);
        this.state.subscribeToStructure(this.primitive);
        this.accordion.foldSection(4);
        this.surfacePrep = new $5394a2fd932d6e8f$var$Surface(this.state);
        this.accordion.setSection("Surface (Slab) Construction", this.surfacePrep.e);
        this.state.subscribeToStructure(this.surfacePrep);
        this.accordion.foldSection(5);
        // this.collapsible.content.appendChild(this.structureInfo.e)
        // this.getElement('.Collapsible').appendChild(this.collapsible.e)
        // this.getElement('.Structure-Info').appendChild(this.structureInfo.e)
        this.structureSelector = new (0, $e20fc17338b77793$export$2e2bcd8739ae039)(this.state);
        this.getElement(".StructureSelector-ph").appendChild(this.structureSelector.e);
        this.state.subscribeToStructure(this.structureSelector);
        this.state.subscribeToStructure(this);
    // let hide = () => {
    // 	let table = this.getElement('table')
    // 	if (table.style.display === 'none') {
    // 	  table.style.display	= 'block'
    // 	} else {
    // 		table.style.display = 'none'
    // 	}
    // }
    // let shButton = this.getElement('span.addon')
    // console.log(shButton)
    // shButton.addEventListener('click',hide)
    }
    /**
   * Module initialization method.
   * Sets up the structure viewer and loads the initial structure
   */ init() {
        this.viewer = new (0, $a197da9598f0bd1e$export$2e2bcd8739ae039)(this.getElement(".StructureViewer"), true, this.state);
        this.bzviewer = new (0, $d0456dc84d1a72e5$export$2e2bcd8739ae039)(this.getElement(".BZViewer"));
        this.state.subscribeToAll(this.viewer);
        this.state.subscribeToStructure(this.bzviewer);
        this.state.subscribeToAtomHighlight(this.viewer);
        $4aa0937dc0e8c453$export$9d26f8f2be82424f("CdSrTa.in", "text", (text)=>{
            // This unifies the file load for the initialization.
            let file = new File([
                text
            ], "CdSrTa.in", {
                type: "text/plain"
            });
            this.importerBox.sendGeometryToParse(file, "CdSrTa.in").then();
        // this.state.setStructure(util.getStructureFromFileContent('CdSrTa.in', text))
        // processUrlHash() No URL params support at the beginning (without changing the URL fragment)
        }).then();
        document.addEventListener("keydown", (e)=>{
            if (e.code === "KeyZ" && (e.ctrlKey || e.metaKey)) {
                e.preventDefault();
                this.state.undo();
            } else if (e.code === "KeyY" && (e.ctrlKey || e.metaKey)) {
                e.preventDefault();
                this.state.redo();
            }
        });
    }
    /**
   * Processes the URL fragment for this module
   * @param  {string} fragment
   */ processUrlFragment(fragment) {
        if (fragment.startsWith("repeat")) {
            if (!this.state.getStructure().isAPeriodicSystem()) {
                $6ff060c6e60f738f$export$b8d0bb2aa0adefe5($5394a2fd932d6e8f$var$ONLY_FOR_PERIODIC_MSG);
                return;
            }
            let supercellDim = fragment.substring(fragment.indexOf(":") + 1);
            const dimArray = supercellDim.split(":");
            if (!this.state.repeatStructure(dimArray)) $6ff060c6e60f738f$export$b8d0bb2aa0adefe5($5394a2fd932d6e8f$var$STRUCT_TOO_BIG_MSG);
        }
    }
    /**
   * Updates the component to a new structure
   * Listener for the 'new structure' module level event
   * @param {Structure} structure
   */ setNewStructure(structure) {
        log("setNewStructure", structure, structure.fileSource);
        // let status
        // if (structure.fileSource === undefined)
        //   status = 'New Structure'
        // else
        //   status = (structure.fileSource === '' ? 'No file name' :
        //     'FILE NAME: '+structure.fileSource)
        // let h1 = this.statusLabel.getElementsByClassName('h1-title')
        // console.log(h1)
        // h1[0].innerHTML= status
        this.exporterBox.updateFilesData(structure);
    }
    selectStructure(structure) {
        this.setNewStructure(structure);
    }
    /**
   * Updates the component to a structure change
   * Listener for the 'update structure' module level event
   * @param {Structure} structure
   * @param {object} _change
   */ updateStructure(structure, _change) {
        this.exporterBox.updateFilesData(structure);
    }
    /**
   * Returns the current structure in the module state
   * @return {Structure}
   */ getCurrentStructure() {
        return this.state.getStructure();
    }
    /**
   * Updates the component for a code change (application level event)
   * @param  {string} _code
   */ updateForCode(_code) {
        this.exporterBox.updateFilesData(this.state.getStructure());
    }
    /**
   * Updates the component for a setting change (application level event)
   * @param  {object} _newSettings
   */ updateSettings(_newSettings) {
        //log('SBM updateSettings', newSettings)
        this.structureInfo.updateStructureInfo();
        this.lattVectors.updateVectorsDecimals();
        this.basisAtoms.update();
    }
}
/**
 * Structure geometry importer UI component
 */ class $5394a2fd932d6e8f$var$GeometryImporter extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param  {State} moduleState
   *   Object representing the state of the Structure builder module
   */ constructor(moduleState){
        super("span", ".GeometryImporter");
        // file format supported
        let isAdvancedUpload = function() {
            let div = document.createElement("div");
            return ("draggable" in div || "ondragstart" in div && "ondrop" in div) && "FormData" in window && "FileReader" in window;
        }();
        this.setHTML(`
				<form class="box" method="post" action="" enctype="multipart/form-data">
					<div class="box__input">
						<input class="box__file" type="file" name="files[]" id="file" data-multiple-caption="{count} files selected" multiple /><br>
						<label for="file"><strong>Choose a file</strong><span class="box__dragndrop"> or drag it here</span>.</label>
					</div>
					<div class="box__uploading">Uploading&hellip;</div>
				</form>
    `);
        this.moduleState = moduleState;
        let form = this.getElement(".box");
        if (isAdvancedUpload) form.classList.add("has-advanced-upload");
        if (isAdvancedUpload) {
            [
                "drag",
                "dragstart",
                "dragend",
                "dragover",
                "dragenter",
                "dragleave",
                "drop"
            ].forEach((eventName)=>{
                form.addEventListener(eventName, (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                }, false);
            });
            [
                "dragover",
                "dragenter"
            ].forEach((eventName)=>{
                form.addEventListener(eventName, (_)=>{
                    form.classList.add("is-dragover");
                });
            });
            [
                "dragleave",
                "dragend",
                "drop"
            ].forEach((eventName)=>{
                form.addEventListener(eventName, (_)=>{
                    form.classList.remove("is-dragover");
                });
            });
            form.addEventListener("drop", (e)=>{
                let dt = e.dataTransfer;
                let files = dt.files;
                this.uploadFiles([
                    ...files
                ]);
            // this.uploadFile(files[0])
            // this.sendGeometryToParse(files[0])
            }, false);
        }
        // Main event: a file to be uploaded is selected
        this.fileInput = this.getElement("input");
        this.fileInput.addEventListener("change", (e)=>{
            let files = e.target.files;
            this.uploadFiles([
                ...files
            ]);
        // ([...files]).forEach(file => {
        // 	console.log(file)
        // 	this.uploadFiles(files)
        // });
        }, false);
    /* The parsing could be done on the client for the .in files in aq more efficient way
        this.getElement('#Importer').addEventListener( 'change', e => {
          let file = e.target.files[0]
          let reader = new FileReader()
          // when the file is read it triggers the onload event above.
          reader.readAsText(file)
          reader.addEventListener('load', e => {
            State.setStructure(getStructureFromFileContent(file.name, e.target.result))
          })
        })
        */ }
    uploadFiles(files) {
        const FILE_EXTENSIONS = new Map([
            [
                "in",
                "FHI-aims"
            ],
            [
                "pwi",
                "Quantum Espresso"
            ],
            [
                "cif",
                "CIF-file"
            ],
            [
                "xyz",
                "XYZ-file"
            ]
        ]);
        const FILE_NAMES = new Map([
            [
                "input.xml",
                "exciting"
            ],
            [
                "POSCAR",
                "VASP"
            ]
        ]);
        let promises = [];
        let ib = 0;
        files.forEach((file)=>{
            promises.push(new Promise((resolve)=>{
                // Button creation
                let fileExt;
                if (file.name.includes(".")) fileExt = file.name.substring(file.name.lastIndexOf(".") + 1);
                if (!FILE_NAMES.has(file.name) && !new Set([
                    ...FILE_EXTENSIONS.keys(),
                    "next_step"
                ]).has(fileExt)) {
                    ib++;
                    const extChooser = new (0, $175b311ee190559c$export$2e2bcd8739ae039)("div", ".extensionChooser");
                    let html = `<div>The <b>file extension</b> for ${file.name} is <b>not valid</b>.` + 'The below geometry types are supported, please, choose one:</div> <div class="radios-ph">';
                    FILE_EXTENSIONS.forEach((value, key)=>{
                        html += `<input type="radio" name="file-extension" id="${value}" value="${key}"> ${value} <br>`;
                    });
                    FILE_NAMES.forEach((value, key)=>{
                        html += `<input type="radio" name="file-extension" id="${value}" value="${key}"> ${value} <br>`;
                    });
                    html += `</div>  <div class="button-ph"><button class="button${ib}">Done</button></div>`;
                    extChooser.setHTML(html);
                    const button = extChooser.getElement(".button" + ib);
                    button.addEventListener("click", (buttonEvent)=>{
                        let result;
                        let value = extChooser.e.querySelector("input:checked").value;
                        if (FILE_EXTENSIONS.has(value)) result = file.name + "." + value;
                        else result = value;
                        buttonEvent.target.parentElement.parentElement.remove();
                        resolve(result);
                    });
                    let addMP = ib !== 1;
                    $9d993874406c4873$export$a778490beb6e83b8(extChooser.e, addMP);
                // ModalPopup.showModal()
                } else resolve(file.name);
            }));
        });
        // console.log(promises)
        Promise.all(promises).then((names)=>{
            // console.log(names)
            $9d993874406c4873$export$af4939467128bcd0();
            for(let i = 0; i < names.length; i++){
                let file = files[i];
                this.sendGeometryToParse(file, names[i]).then();
            }
        });
    }
    /**
   * Sends the geometry file to parse into the server side
   * @param  {File} file File data
   * @param  {string} fileName
   */ async sendGeometryToParse(file, fileName) {
        let formData = new FormData();
        // let fName = (fileName === undefined ? file.name : fileName)
        // console.log('sendGeometryToParse',file)
        formData.set("file", file, fileName);
        let response = await fetch("/parse-geometry-file", {
            method: "POST",
            body: formData // multipart/form-data
        });
        if (!response.ok) {
            this.fileInput.value = "";
            return;
        }
        const text = await response.text();
        if (text.includes("ErrorParsingGeometryFile")) {
            this.fileInput.value = "";
            $6ff060c6e60f738f$export$b8d0bb2aa0adefe5(`${file.name} parsing: something went wrong. Backend error is given below<br>${text}`);
            return;
        }
        // console.log(text)
        const structureData = JSON.parse(text);
        this.moduleState.setStructure($4aa0937dc0e8c453$export$9fb63025ff3998e0(structureData));
    // ModalPopup.hideModal()
    }
}
/**
 * Structure geometry exporter UI component
 */ class $5394a2fd932d6e8f$var$Exporter extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("span", "");
        this.setHTML(`
        <div class="explanation" style="line-height: 180%;">You can export the structure data as a file:
        <br>
        <a class="download-link"  href=""> </a> <span>(cartesian)</span>
        <br>
        <span class="fract-line">
          <a class="download-link" href=""> </a> <span>(fractional)</span>
        </span>
        </div>
    `);
    }
    /**
   * Updates the file data in the download links
   * @param  {Structure} structure
   */ updateFilesData(structure) {
        const filesData = $4aa0937dc0e8c453$export$79b11872a16bdbeb(structure, !$1ad59a1a7edcd764$export$5aaad33cfc28fe12());
        let i = 0;
        this.getElements("a").forEach((aElement)=>{
            const fileName = $1ad59a1a7edcd764$export$5aaad33cfc28fe12() ? "input.xml" : "geometry.in";
            aElement.setAttribute("download", fileName);
            aElement.innerHTML = fileName;
            this.getElement(".fract-line").style.display = filesData[i] === undefined ? "none" : "inline";
            aElement.href = filesData[i++];
        });
    }
}
// /**
//  * Simple panel warning the user before the structure reset
//  */
// class ResetPanel extends UIComponent{
//
//   /**
//    * @param  {State} moduleState
//    *   Object representing the state of the Structure builder module
//    */
//   constructor(moduleState){
//     super('span')//this.e = document.createElement('span')
//
//     this.setHTML(`
//         Are you sure you want to reset the structure data? <br><br>
//         <div style="text-align: center"><button>Confirm</button><div>
//     `)
//     // Reset structure
//     this.getElement('button').addEventListener( 'click', _ => {
//       moduleState.resetStructure()
//       ModalPopup.hideModal()
//     })
//   }
//
// }
/**
 * UI panel showing the structure lattice vectors
 */ class $5394a2fd932d6e8f$var$LatticeVectors extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param  {State} moduleState
   *   Object representing the state of the Structure builder module
   */ constructor(moduleState){
        super("div", "#LatticeVectors");
        this.setHTML(`
      <div class="div-table regular-view">
        <div class="div-table-row header">
          <div class="div-table-col atom-order"></div>
          <div class="div-table-col vector">All numbers in units of &#197;</div>
          <div class="div-table-col">Constraint</div>
        </div>
        <div class="div-table-row">
          <div class="div-table-col atom-order" style="font-weight:bolder">a:</div>           
          <div class="div-table-col vector"><span class="lattice-vector-wrapper"></span> </div>
          <div class="div-table-col"><input type="checkbox" class="constraint" disabled/></div>
        </div>
        <div class="div-table-row">
          <div class="div-table-col atom-order" style="font-weight:bolder">b:</div>           
          <div class="div-table-col vector"><span class="lattice-vector-wrapper"></span> </div>
          <div class="div-table-col"><input type="checkbox" class="constraint" disabled/></div>
        </div>
        <div class="div-table-row">
          <div class="div-table-col atom-order" style="font-weight:bolder">c:</div>           
          <div class="div-table-col vector"><span class="lattice-vector-wrapper"></span> </div>
          <div class="div-table-col"><input type="checkbox" class="constraint" disabled/></div>
        </div>
        <div class="lattice-scale-checkbox">
          <input type="checkbox" checked >Scale atom positions with lattice vectors
        </div>
				<div class="lattice-scale-checkbox">
					<img class="img-button" src="${(0, (/*@__PURE__*/$parcel$interopDefault($32555fd85b2a29ef$exports)))}" width="11px" alt="Remove"/> Remove lattice vectors
				</div>
      </div>
      <div class="hidden-view" style="padding-top:10px">
        <button class="add-lattice-vectors">Add lattice vectors</button>
      </div>
    `);
        this.moduleState = moduleState;
        // Add lattice vectors button
        this.getElement(".add-lattice-vectors").addEventListener("click", (_)=>{
            this.moduleState.updateLatticeVectors([
                [
                    10,
                    0,
                    0
                ],
                [
                    0,
                    10,
                    0
                ],
                [
                    0,
                    0,
                    10
                ]
            ]);
        });
        // Remove lattice vectors button
        this.getElement(".img-button").addEventListener("click", (_)=>{
            // Remove lattice vectors
            this.moduleState.updateLatticeVectors(undefined);
        });
        this.vectorFields = [];
        const vectorElements = this.getElements(".lattice-vector-wrapper");
        vectorElements.forEach((vElement)=>{
            const newField = new (0, $1c3e958c767e186d$export$2e2bcd8739ae039)();
            this.vectorFields.push(newField);
            vElement.appendChild(newField.e);
            newField.setChangeListener(vectorChangeHandler);
        });
        const classInstance = this;
        function vectorChangeHandler(_coords) {
            const vectors = [];
            classInstance.vectorFields.forEach((f)=>{
                vectors.push(f.getValues());
            });
            // If the lattice vectors are valid (all of them different from a zero vector)
            if (noZeroVector(vectors)) classInstance.moduleState.updateLatticeVectors(vectors, classInstance.checkbox.checked);
        }
        function noZeroVector(vectors) {
            return !isZero(vectors[0]) && !isZero(vectors[1]) && !isZero(vectors[2]);
            function isZero(a) {
                return a[0] === 0 && a[1] === 0 && a[2] === 0;
            }
        }
        this.checkbox = this.getElement(".lattice-scale-checkbox input");
    }
    /**
   * Updates the component to a structure change
   * Listener for the 'update structure' module level event
   * @param {Structure} structure
   * @param {object} _change
   */ updateStructure(structure, _change) {
        //console.log('LAT  updateStructure',structure.latVectors, this.vectorFields);
        const isPeriodic = structure.isAPeriodicSystem();
        this.getElement(".regular-view").style.display = isPeriodic ? "block" : "none";
        this.getElement(".hidden-view").style.display = isPeriodic ? "none" : "block";
        if (isPeriodic) {
            const vectors = structure.latVectors;
            for(let i = 0; i < this.vectorFields.length; i++)this.vectorFields[i].setValues(vectors[i]);
        }
    }
    /**
   * Updates the component to a new structure
   * Listener for the 'new structure' module level event
   * @param {Structure} structure
   */ setNewStructure(structure) {
        this.updateStructure(structure);
    }
    selectStructure(structure) {
        this.updateStructure(structure);
    }
    /**
   * Updates the vector number of decimals
   */ updateVectorsDecimals() {
        this.vectorFields.forEach((vField)=>{
            vField.updateDecimals();
        });
    }
}
/**
 * UI panel enabling the supercell feature
 */ class $5394a2fd932d6e8f$var$Supercell extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param  {State} moduleState
   *   Object representing the state of the Structure builder module
   */ constructor(moduleState){
        super("span", "#Supercell");
        this.setHTML(`
			<div class="regular-view">
          <div class="supercell"> <span class="SupercellField-box"></span></div>
			</div>
    `);
        this.moduleState = moduleState;
        const supercellElement = this.getElement(".SupercellField-box");
        const newField = new (0, $d8b52173239764ac$export$2e2bcd8739ae039)();
        this.supercellFields = newField;
        supercellElement.appendChild(newField.e);
        let scButton = this.getElement(".create-button");
        // console.log(scButton)
        scButton.addEventListener("click", scChangeHandler);
        const classInstance = this;
        function scChangeHandler() {
            const scNums = [];
            scNums.push(classInstance.supercellFields.getValues());
            // If the lattice vectors are valid (all of them different from a zero vector)
            if (isValidSC(scNums[0])) {
                classInstance.supercellFields.setValues([]);
                if (!classInstance.moduleState.repeatStructure(scNums[0])) // scNums[0] = supercellDim
                $6ff060c6e60f738f$export$b8d0bb2aa0adefe5($5394a2fd932d6e8f$var$STRUCT_TOO_BIG_MSG);
            }
        }
        function isValidSC(scNums) {
            let isValid = true;
            if (scNums.length === 9) ;
            else scNums.forEach((num)=>{
                isValid = isValid && num > 0;
            });
            return isValid;
        // scNums[0][0] > 0 && scNums[0][1] > 0 && scNums[0][2] > 0
        }
    }
    /**
   * Updates the component to a structure change
   * Listener for the 'update structure' module level event
   * @param {Structure} structure
   * @param {object} _change
   */ updateStructure(structure, _change) {
        //console.log('LAT  updateStructure',structure.latVectors, this.vectorFields);
        const isPeriodic = structure.isAPeriodicSystem();
        this.getElement(".regular-view").style.display = isPeriodic ? "inline-block" : "none";
    }
    /**
   * Updates the component to a new structure
   * Listener for the 'new structure' module level event
   * @param {Structure} structure
   */ setNewStructure(structure) {
        this.updateStructure(structure);
    }
    selectStructure(structure) {
        this.updateStructure(structure);
    }
} // class Supercell
/**
 * UI panel enabling the surface construction feature
 */ class $5394a2fd932d6e8f$var$Surface extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param  {State} moduleState
   *   Object representing the state of the Structure builder module
   */ constructor(moduleState){
        super("span", "#Surface");
        this.setHTML(`
			<div class="regular-view">
          <div class="surface"> <span class="SurfaceConstructionField-box"></span></div>
			</div>
    `);
        this.moduleState = moduleState;
        const surfaceElement = this.getElement(".SurfaceConstructionField-box");
        const newField = new (0, $9ba54ea4602938b1$export$2e2bcd8739ae039)();
        this.surfaceField = newField;
        surfaceElement.appendChild(newField.e);
        let sfButton = this.getElement(".create-button");
        sfButton.addEventListener("click", sfChangeHandler);
        let termButton = this.getElement(".terminate-button");
        termButton.addEventListener("click", sfTerminate);
        const classInstance = this;
        function sfChangeHandler() {
            const sfData = classInstance.surfaceField.getCreationValues();
            if (isValid(sfData)) {
                classInstance.surfaceField.clearValues();
                classInstance.moduleState.makeSlab(sfData);
            } else $6ff060c6e60f738f$export$b8d0bb2aa0adefe5($5394a2fd932d6e8f$var$SURFACE_GENERATION_ERROR_MSG);
        }
        function sfTerminate() {
            const termData = classInstance.surfaceField.getTermValues();
            if (termData[0] < termData[1]) classInstance.moduleState.makeSlab({
                "terminations": termData
            });
            else $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("Empty slab with this input");
        }
        function isValid(sfData) {
            let isValid = true;
            isValid = isValid && sfData["miller"].reduce((a, b)=>a + b, 0) > 0;
            isValid = isValid && sfData["layers"] > 0;
            isValid = isValid && sfData["vacuum"] > 0;
            return isValid;
        }
    }
    /**
   * Updates the component to a structure change
   * Listener for the 'update structure' module level event
   * @param {Structure} structure
   * @param {object} _change
   */ updateStructure(structure, _change) {
        this.surfaceField.showTermination(structure.fileSource);
        this.surfaceField.clearValues();
        if (typeof structure.extraData == "object" && "terminations" in structure.extraData) this.surfaceField.populateTerminationBoxes(structure.extraData["terminations"]);
    }
    /**
   * Updates the component to a new structure
   * Listener for the 'new structure' module level event
   * @param {Structure} structure
   */ setNewStructure(structure) {
        this.updateStructure(structure);
    }
    selectStructure(structure) {
        this.updateStructure(structure);
    }
} // class Surface


/**
 * @author Iker Hurtado, Sebastian Kokott, Andrey Sobolev
 *
 * @fileOverview File holding the OutputAnalyzerMod class and module
 */ 
/**
 * @author Iker Hurtado
 *
 * @overview FileImporter is a UI component that allows to import files
 * to the application
 */ 
class $d4667050cb9a5b91$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param {string} text - Text next to the import control
   * @param {boolean} multiple - It enables the multiple selection of files
   */ constructor(text, multiple = false){
        super("span", ".FileImporter");
        this.setHTML(text + ` <input type="file"  ${multiple ? "multiple" : ""} >`);
        this.input = this.getElement("input");
        this.input.addEventListener("change", (e)=>{
            this.listener(e.target.files);
        });
    }
    /**
   * It enables to switch between file and directory selection modes.
   * On the directory mode all the files inside the directory will be imported
   * @param {boolean} directory - If true the directory selection is selected
   */ setDirectoryMode(directory) {
        if (directory) this.input.setAttribute("webkitdirectory", "");
        else this.input.removeAttribute("webkitdirectory");
    }
    /**
   * It sets up a listener that will be called when a new set of files 
   * is selected
   * @param {function} listener - Listener
   */ setImportListener(listener) {
        this.listener = listener;
    }
}







var $71de690891678265$exports = {};
$71de690891678265$exports = new URL("download-icon.2bc7be26.png", import.meta.url).toString();


/**
 * @author Andrey Sobolev
 *
 * @fileOverview File holding the Bands and Density of states dashboard based on Plotly.js
 */ /**
 * @author Andrey Sobolev
 *
 * @fileOverview File holding the Dashboard class (one or several graphs with common controls) based on Plotly.js
 */ /**
 * @author Andrey Sobolev
 *
 * @fileOverview File holding the InteractiveGraph class based on plotly.js
 */ var $0ae81143a7e218db$exports = {};
/**
* plotly.js (basic - minified) v2.26.1
* Copyright 2012-2023, Plotly, Inc.
* All rights reserved.
* Licensed under the MIT license
*/ /*! For license information please see plotly-basic.min.js.LICENSE.txt */ !function(e, t) {
    $0ae81143a7e218db$exports = t();
}(self, function() {
    return function() {
        var e = {
            8847: function(e, t, r) {
                "use strict";
                var n = r(1828), a = {
                    "X,X div": 'direction:ltr;font-family:"Open Sans",verdana,arial,sans-serif;margin:0;padding:0;',
                    "X input,X button": 'font-family:"Open Sans",verdana,arial,sans-serif;',
                    "X input:focus,X button:focus": "outline:none;",
                    "X a": "text-decoration:none;",
                    "X a:hover": "text-decoration:none;",
                    "X .crisp": "shape-rendering:crispEdges;",
                    "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
                    "X svg": "overflow:hidden;",
                    "X svg a": "fill:#447adb;",
                    "X svg a:hover": "fill:#3c6dc5;",
                    "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
                    "X .main-svg .draglayer": "pointer-events:all;",
                    "X .cursor-default": "cursor:default;",
                    "X .cursor-pointer": "cursor:pointer;",
                    "X .cursor-crosshair": "cursor:crosshair;",
                    "X .cursor-move": "cursor:move;",
                    "X .cursor-col-resize": "cursor:col-resize;",
                    "X .cursor-row-resize": "cursor:row-resize;",
                    "X .cursor-ns-resize": "cursor:ns-resize;",
                    "X .cursor-ew-resize": "cursor:ew-resize;",
                    "X .cursor-sw-resize": "cursor:sw-resize;",
                    "X .cursor-s-resize": "cursor:s-resize;",
                    "X .cursor-se-resize": "cursor:se-resize;",
                    "X .cursor-w-resize": "cursor:w-resize;",
                    "X .cursor-e-resize": "cursor:e-resize;",
                    "X .cursor-nw-resize": "cursor:nw-resize;",
                    "X .cursor-n-resize": "cursor:n-resize;",
                    "X .cursor-ne-resize": "cursor:ne-resize;",
                    "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
                    "X .modebar": "position:absolute;top:2px;right:2px;",
                    "X .ease-bg": "-webkit-transition:background-color .3s ease 0s;-moz-transition:background-color .3s ease 0s;-ms-transition:background-color .3s ease 0s;-o-transition:background-color .3s ease 0s;transition:background-color .3s ease 0s;",
                    "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity .3s ease 0s;-moz-transition:opacity .3s ease 0s;-ms-transition:opacity .3s ease 0s;-o-transition:opacity .3s ease 0s;transition:opacity .3s ease 0s;",
                    "X:hover .modebar--hover .modebar-group": "opacity:1;",
                    "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
                    "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
                    "X .modebar-btn svg": "position:relative;top:2px;",
                    "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
                    "X .modebar.vertical svg": "top:-1px;",
                    "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
                    "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
                    "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
                    "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
                    "X [data-title]:before": 'content:"";position:absolute;background:rgba(0,0,0,0);border:6px solid rgba(0,0,0,0);z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;',
                    "X [data-title]:after": "content:attr(data-title);background:#69738a;color:#fff;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
                    "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
                    "X .vertical [data-title]:before": "border:6px solid rgba(0,0,0,0);border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
                    Y: 'font-family:"Open Sans",verdana,arial,sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;',
                    "Y p": "margin:0;",
                    "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
                    "Y .notifier-close": "color:#fff;opacity:.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
                    "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
                };
                for(var i in a){
                    var o = i.replace(/^,/, " ,").replace(/X/g, ".js-plotly-plot .plotly").replace(/Y/g, ".plotly-notifier");
                    n.addStyleRule(o, a[i]);
                }
            },
            8222: function(e, t, r) {
                "use strict";
                e.exports = r(2887);
            },
            7206: function(e, t, r) {
                "use strict";
                e.exports = r(822);
            },
            9509: function(e, t, r) {
                "use strict";
                e.exports = r(2201);
            },
            9548: function(e, t, r) {
                "use strict";
                e.exports = r(8729);
            },
            1039: function(e, t, r) {
                "use strict";
                e.exports = r(4382);
            },
            4296: function(e, t, r) {
                "use strict";
                e.exports = r(3102);
            },
            2576: function(e, t, r) {
                "use strict";
                var n = r(9548);
                n.register([
                    r(7206),
                    r(4201),
                    r(8222),
                    r(1039),
                    r(4296),
                    r(6398),
                    r(9509)
                ]), e.exports = n;
            },
            4201: function(e, t, r) {
                "use strict";
                e.exports = r(8810);
            },
            6398: function(e, t, r) {
                "use strict";
                e.exports = r(2275);
            },
            2884: function(e) {
                "use strict";
                e.exports = [
                    {
                        path: "",
                        backoff: 0
                    },
                    {
                        path: "M-2.4,-3V3L0.6,0Z",
                        backoff: .6
                    },
                    {
                        path: "M-3.7,-2.5V2.5L1.3,0Z",
                        backoff: 1.3
                    },
                    {
                        path: "M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z",
                        backoff: 1.55
                    },
                    {
                        path: "M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z",
                        backoff: 1.6
                    },
                    {
                        path: "M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z",
                        backoff: 2
                    },
                    {
                        path: "M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z",
                        backoff: 0,
                        noRotate: !0
                    },
                    {
                        path: "M2,2V-2H-2V2Z",
                        backoff: 0,
                        noRotate: !0
                    }
                ];
            },
            215: function(e, t, r) {
                "use strict";
                var n = r(2884), a = r(1940), i = r(5555), o = r(4467).templatedArray;
                r(4695), e.exports = o("annotation", {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc+arraydraw"
                    },
                    text: {
                        valType: "string",
                        editType: "calc+arraydraw"
                    },
                    textangle: {
                        valType: "angle",
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    font: a({
                        editType: "calc+arraydraw",
                        colorEditType: "arraydraw"
                    }),
                    width: {
                        valType: "number",
                        min: 1,
                        dflt: null,
                        editType: "calc+arraydraw"
                    },
                    height: {
                        valType: "number",
                        min: 1,
                        dflt: null,
                        editType: "calc+arraydraw"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    align: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "center",
                        editType: "arraydraw"
                    },
                    valign: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "middle",
                        editType: "arraydraw"
                    },
                    bgcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "arraydraw"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "arraydraw"
                    },
                    borderpad: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    showarrow: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc+arraydraw"
                    },
                    arrowcolor: {
                        valType: "color",
                        editType: "arraydraw"
                    },
                    arrowhead: {
                        valType: "integer",
                        min: 0,
                        max: n.length,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    startarrowhead: {
                        valType: "integer",
                        min: 0,
                        max: n.length,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    arrowside: {
                        valType: "flaglist",
                        flags: [
                            "end",
                            "start"
                        ],
                        extras: [
                            "none"
                        ],
                        dflt: "end",
                        editType: "arraydraw"
                    },
                    arrowsize: {
                        valType: "number",
                        min: .3,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    startarrowsize: {
                        valType: "number",
                        min: .3,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    arrowwidth: {
                        valType: "number",
                        min: .1,
                        editType: "calc+arraydraw"
                    },
                    standoff: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    startstandoff: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    ax: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    ay: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    axref: {
                        valType: "enumerated",
                        dflt: "pixel",
                        values: [
                            "pixel",
                            i.idRegex.x.toString()
                        ],
                        editType: "calc"
                    },
                    ayref: {
                        valType: "enumerated",
                        dflt: "pixel",
                        values: [
                            "pixel",
                            i.idRegex.y.toString()
                        ],
                        editType: "calc"
                    },
                    xref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            i.idRegex.x.toString()
                        ],
                        editType: "calc"
                    },
                    x: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "auto",
                        editType: "calc+arraydraw"
                    },
                    xshift: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    yref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            i.idRegex.y.toString()
                        ],
                        editType: "calc"
                    },
                    y: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "auto",
                        editType: "calc+arraydraw"
                    },
                    yshift: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    clicktoshow: {
                        valType: "enumerated",
                        values: [
                            !1,
                            "onoff",
                            "onout"
                        ],
                        dflt: !1,
                        editType: "arraydraw"
                    },
                    xclick: {
                        valType: "any",
                        editType: "arraydraw"
                    },
                    yclick: {
                        valType: "any",
                        editType: "arraydraw"
                    },
                    hovertext: {
                        valType: "string",
                        editType: "arraydraw"
                    },
                    hoverlabel: {
                        bgcolor: {
                            valType: "color",
                            editType: "arraydraw"
                        },
                        bordercolor: {
                            valType: "color",
                            editType: "arraydraw"
                        },
                        font: a({
                            editType: "arraydraw"
                        }),
                        editType: "arraydraw"
                    },
                    captureevents: {
                        valType: "boolean",
                        editType: "arraydraw"
                    },
                    editType: "calc",
                    _deprecated: {
                        ref: {
                            valType: "string",
                            editType: "calc"
                        }
                    }
                });
            },
            3749: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(9298), i = r(2605).draw;
                function o(e) {
                    var t = e._fullLayout;
                    n.filterVisible(t.annotations).forEach(function(t) {
                        var r = a.getFromId(e, t.xref), n = a.getFromId(e, t.yref), i = a.getRefType(t.xref), o = a.getRefType(t.yref);
                        t._extremes = {}, "range" === i && l(t, r), "range" === o && l(t, n);
                    });
                }
                function l(e, t) {
                    var r, n = t._id, i = n.charAt(0), o = e[i], l = e["a" + i], s = e[i + "ref"], c = e["a" + i + "ref"], u = e["_" + i + "padplus"], f = e["_" + i + "padminus"], d = {
                        x: 1,
                        y: -1
                    }[i] * e[i + "shift"], h = 3 * e.arrowsize * e.arrowwidth || 0, p = h + d, v = h - d, g = 3 * e.startarrowsize * e.arrowwidth || 0, y = g + d, m = g - d;
                    if (c === s) {
                        var x = a.findExtremes(t, [
                            t.r2c(o)
                        ], {
                            ppadplus: p,
                            ppadminus: v
                        }), b = a.findExtremes(t, [
                            t.r2c(l)
                        ], {
                            ppadplus: Math.max(u, y),
                            ppadminus: Math.max(f, m)
                        });
                        r = {
                            min: [
                                x.min[0],
                                b.min[0]
                            ],
                            max: [
                                x.max[0],
                                b.max[0]
                            ]
                        };
                    } else y = l ? y + l : y, m = l ? m - l : m, r = a.findExtremes(t, [
                        t.r2c(o)
                    ], {
                        ppadplus: Math.max(u, p, y),
                        ppadminus: Math.max(f, v, m)
                    });
                    e._extremes[n] = r;
                }
                e.exports = function(e) {
                    var t = e._fullLayout;
                    if (n.filterVisible(t.annotations).length && e._fullData.length) return n.syncOrAsync([
                        i,
                        o
                    ], e);
                };
            },
            4317: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(3972), i = r(4467).arrayEditor;
                function o(e, t) {
                    var r, n, a, i, o, s, c, u = e._fullLayout.annotations, f = [], d = [], h = [], p = (t || []).length;
                    for(r = 0; r < u.length; r++)if (i = (a = u[r]).clicktoshow) {
                        for(n = 0; n < p; n++)if (s = (o = t[n]).xaxis, c = o.yaxis, s._id === a.xref && c._id === a.yref && s.d2r(o.x) === l(a._xclick, s) && c.d2r(o.y) === l(a._yclick, c)) {
                            (a.visible ? "onout" === i ? d : h : f).push(r);
                            break;
                        }
                        n === p && a.visible && "onout" === i && d.push(r);
                    }
                    return {
                        on: f,
                        off: d,
                        explicitOff: h
                    };
                }
                function l(e, t) {
                    return "log" === t.type ? t.l2r(e) : t.d2r(e);
                }
                e.exports = {
                    hasClickToShow: function(e, t) {
                        var r = o(e, t);
                        return r.on.length > 0 || r.explicitOff.length > 0;
                    },
                    onClick: function(e, t) {
                        var r, l, s = o(e, t), c = s.on, u = s.off.concat(s.explicitOff), f = {}, d = e._fullLayout.annotations;
                        if (c.length || u.length) {
                            for(r = 0; r < c.length; r++)(l = i(e.layout, "annotations", d[c[r]])).modifyItem("visible", !0), n.extendFlat(f, l.getUpdateObj());
                            for(r = 0; r < u.length; r++)(l = i(e.layout, "annotations", d[u[r]])).modifyItem("visible", !1), n.extendFlat(f, l.getUpdateObj());
                            return a.call("update", e, {}, f);
                        }
                    }
                };
            },
            5625: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(7901);
                e.exports = function(e, t, r, i) {
                    i("opacity");
                    var o = i("bgcolor"), l = i("bordercolor"), s = a.opacity(l);
                    i("borderpad");
                    var c = i("borderwidth"), u = i("showarrow");
                    if (i("text", u ? " " : r._dfltTitle.annotation), i("textangle"), n.coerceFont(i, "font", r.font), i("width"), i("align"), i("height") && i("valign"), u) {
                        var f, d, h = i("arrowside");
                        -1 !== h.indexOf("end") && (f = i("arrowhead"), d = i("arrowsize")), -1 !== h.indexOf("start") && (i("startarrowhead", f), i("startarrowsize", d)), i("arrowcolor", s ? t.bordercolor : a.defaultLine), i("arrowwidth", 2 * (s && c || 1)), i("standoff"), i("startstandoff");
                    }
                    var p = i("hovertext"), v = r.hoverlabel || {};
                    if (p) {
                        var g = i("hoverlabel.bgcolor", v.bgcolor || (a.opacity(o) ? a.rgb(o) : a.defaultLine)), y = i("hoverlabel.bordercolor", v.bordercolor || a.contrast(g));
                        n.coerceFont(i, "hoverlabel.font", {
                            family: v.font.family,
                            size: v.font.size,
                            color: v.font.color || y
                        });
                    }
                    i("captureevents", !!p);
                };
            },
            4128: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(8163);
                e.exports = function(e, t, r, i) {
                    t = t || {};
                    var o = "log" === r && "linear" === t.type, l = "linear" === r && "log" === t.type;
                    if (o || l) for(var s, c, u = e._fullLayout.annotations, f = t._id.charAt(0), d = 0; d < u.length; d++)s = u[d], c = "annotations[" + d + "].", s[f + "ref"] === t._id && h(f), s["a" + f + "ref"] === t._id && h("a" + f);
                    function h(e) {
                        var r = s[e], l = null;
                        l = o ? a(r, t.range) : Math.pow(10, r), n(l) || (l = null), i(c + e, l);
                    }
                };
            },
            4046: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(9298), i = r(5501), o = r(5625), l = r(215);
                function s(e, t, r) {
                    function i(r, a) {
                        return n.coerce(e, t, l, r, a);
                    }
                    var s = i("visible"), c = i("clicktoshow");
                    if (s || c) {
                        o(e, t, r, i);
                        for(var u = t.showarrow, f = [
                            "x",
                            "y"
                        ], d = [
                            -10,
                            -30
                        ], h = {
                            _fullLayout: r
                        }, p = 0; p < 2; p++){
                            var v = f[p], g = a.coerceRef(e, t, h, v, "", "paper");
                            if ("paper" !== g && a.getFromId(h, g)._annIndices.push(t._index), a.coercePosition(t, h, i, g, v, .5), u) {
                                var y = "a" + v, m = a.coerceRef(e, t, h, y, "pixel", [
                                    "pixel",
                                    "paper"
                                ]);
                                "pixel" !== m && m !== g && (m = t[y] = "pixel");
                                var x = "pixel" === m ? d[p] : .4;
                                a.coercePosition(t, h, i, m, y, x);
                            }
                            i(v + "anchor"), i(v + "shift");
                        }
                        if (n.noneOrAll(e, t, [
                            "x",
                            "y"
                        ]), u && n.noneOrAll(e, t, [
                            "ax",
                            "ay"
                        ]), c) {
                            var b = i("xclick"), _ = i("yclick");
                            t._xclick = void 0 === b ? t.x : a.cleanPosition(b, h, t.xref), t._yclick = void 0 === _ ? t.y : a.cleanPosition(_, h, t.yref);
                        }
                    }
                }
                e.exports = function(e, t) {
                    i(e, t, {
                        name: "annotations",
                        handleItemDefaults: s
                    });
                };
            },
            2605: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(3972), i = r(4875), o = r(1828), l = o.strTranslate, s = r(9298), c = r(7901), u = r(1424), f = r(211), d = r(3893), h = r(6964), p = r(8569), v = r(4467).arrayEditor, g = r(3011);
                function y(e, t) {
                    var r = e._fullLayout.annotations[t] || {}, n = s.getFromId(e, r.xref), a = s.getFromId(e, r.yref);
                    n && n.setScale(), a && a.setScale(), x(e, r, t, !1, n, a);
                }
                function m(e, t, r, n, a) {
                    var i = a[r], o = a[r + "ref"], l = -1 !== r.indexOf("y"), c = "domain" === s.getRefType(o), u = l ? n.h : n.w;
                    return e ? c ? i + (l ? -t : t) / e._length : e.p2r(e.r2p(i) + t) : i + (l ? -t : t) / u;
                }
                function x(e, t, r, i, y, x) {
                    var b, _, w = e._fullLayout, T = e._fullLayout._size, M = e._context.edits;
                    i ? (b = "annotation-" + i, _ = i + ".annotations") : (b = "annotation", _ = "annotations");
                    var k = v(e.layout, _, t), A = k.modifyBase, L = k.modifyItem, S = k.getUpdateObj;
                    w._infolayer.selectAll("." + b + '[data-index="' + r + '"]').remove();
                    var D = "clip" + w._uid + "_ann" + r;
                    if (t._input && !1 !== t.visible) {
                        var O = {
                            x: {},
                            y: {}
                        }, C = +t.textangle || 0, P = w._infolayer.append("g").classed(b, !0).attr("data-index", String(r)).style("opacity", t.opacity), I = P.append("g").classed("annotation-text-g", !0), R = M[t.showarrow ? "annotationTail" : "annotationPosition"], z = t.captureevents || M.annotationText || R, N = I.append("g").style("pointer-events", z ? "all" : null).call(h, "pointer").on("click", function() {
                            e._dragging = !1, e.emit("plotly_clickannotation", G(n.event));
                        });
                        t.hovertext && N.on("mouseover", function() {
                            var r = t.hoverlabel, n = r.font, a = this.getBoundingClientRect(), i = e.getBoundingClientRect();
                            f.loneHover({
                                x0: a.left - i.left,
                                x1: a.right - i.left,
                                y: (a.top + a.bottom) / 2 - i.top,
                                text: t.hovertext,
                                color: r.bgcolor,
                                borderColor: r.bordercolor,
                                fontFamily: n.family,
                                fontSize: n.size,
                                fontColor: n.color
                            }, {
                                container: w._hoverlayer.node(),
                                outerContainer: w._paper.node(),
                                gd: e
                            });
                        }).on("mouseout", function() {
                            f.loneUnhover(w._hoverlayer.node());
                        });
                        var F = t.borderwidth, E = t.borderpad, H = F + E, j = N.append("rect").attr("class", "bg").style("stroke-width", F + "px").call(c.stroke, t.bordercolor).call(c.fill, t.bgcolor), B = t.width || t.height, Y = w._topclips.selectAll("#" + D).data(B ? [
                            0
                        ] : []);
                        Y.enter().append("clipPath").classed("annclip", !0).attr("id", D).append("rect"), Y.exit().remove();
                        var V = t.font, U = w._meta ? o.templateString(t.text, w._meta) : t.text, q = N.append("text").classed("annotation-text", !0).text(U);
                        M.annotationText ? q.call(d.makeEditable, {
                            delegate: N,
                            gd: e
                        }).call(Z).on("edit", function(r) {
                            t.text = r, this.call(Z), L("text", r), y && y.autorange && A(y._name + ".autorange", !0), x && x.autorange && A(x._name + ".autorange", !0), a.call("_guiRelayout", e, S());
                        }) : q.call(Z);
                    } else n.selectAll("#" + D).remove();
                    function G(e) {
                        var n = {
                            index: r,
                            annotation: t._input,
                            fullAnnotation: t,
                            event: e
                        };
                        return i && (n.subplotId = i), n;
                    }
                    function Z(r) {
                        return r.call(u.font, V).attr({
                            "text-anchor": {
                                left: "start",
                                right: "end"
                            }[t.align] || "middle"
                        }), d.convertToTspans(r, e, W), r;
                    }
                    function W() {
                        var r = q.selectAll("a");
                        1 === r.size() && r.text() === q.text() && N.insert("a", ":first-child").attr({
                            "xlink:xlink:href": r.attr("xlink:href"),
                            "xlink:xlink:show": r.attr("xlink:show")
                        }).style({
                            cursor: "pointer"
                        }).node().appendChild(j.node());
                        var n = N.select(".annotation-text-math-group"), f = !n.empty(), v = u.bBox((f ? n : q).node()), b = v.width, _ = v.height, k = t.width || b, z = t.height || _, E = Math.round(k + 2 * H), V = Math.round(z + 2 * H);
                        function U(e, t) {
                            return "auto" === t && (t = e < 1 / 3 ? "left" : e > 2 / 3 ? "right" : "center"), ({
                                center: 0,
                                middle: 0,
                                left: .5,
                                bottom: -0.5,
                                right: -0.5,
                                top: .5
                            })[t];
                        }
                        for(var Z = !1, W = [
                            "x",
                            "y"
                        ], X = 0; X < W.length; X++){
                            var J, K, Q, $, ee, te = W[X], re = t[te + "ref"] || te, ne = t["a" + te + "ref"], ae = {
                                x: y,
                                y: x
                            }[te], ie = (C + ("x" === te ? 0 : -90)) * Math.PI / 180, oe = E * Math.cos(ie), le = V * Math.sin(ie), se = Math.abs(oe) + Math.abs(le), ce = t[te + "anchor"], ue = t[te + "shift"] * ("x" === te ? 1 : -1), fe = O[te], de = s.getRefType(re);
                            if (ae && "domain" !== de) {
                                var he = ae.r2fraction(t[te]);
                                (he < 0 || he > 1) && (ne === re ? ((he = ae.r2fraction(t["a" + te])) < 0 || he > 1) && (Z = !0) : Z = !0), J = ae._offset + ae.r2p(t[te]), $ = .5;
                            } else {
                                var pe = "domain" === de;
                                "x" === te ? (Q = t[te], J = pe ? ae._offset + ae._length * Q : J = T.l + T.w * Q) : (Q = 1 - t[te], J = pe ? ae._offset + ae._length * Q : J = T.t + T.h * Q), $ = t.showarrow ? .5 : Q;
                            }
                            if (t.showarrow) {
                                fe.head = J;
                                var ve = t["a" + te];
                                if (ee = oe * U(.5, t.xanchor) - le * U(.5, t.yanchor), ne === re) {
                                    var ge = s.getRefType(ne);
                                    "domain" === ge ? ("y" === te && (ve = 1 - ve), fe.tail = ae._offset + ae._length * ve) : "paper" === ge ? "y" === te ? (ve = 1 - ve, fe.tail = T.t + T.h * ve) : fe.tail = T.l + T.w * ve : fe.tail = ae._offset + ae.r2p(ve), K = ee;
                                } else fe.tail = J + ve, K = ee + ve;
                                fe.text = fe.tail + ee;
                                var ye = w["x" === te ? "width" : "height"];
                                if ("paper" === re && (fe.head = o.constrain(fe.head, 1, ye - 1)), "pixel" === ne) {
                                    var me = -Math.max(fe.tail - 3, fe.text), xe = Math.min(fe.tail + 3, fe.text) - ye;
                                    me > 0 ? (fe.tail += me, fe.text += me) : xe > 0 && (fe.tail -= xe, fe.text -= xe);
                                }
                                fe.tail += ue, fe.head += ue;
                            } else K = ee = se * U($, ce), fe.text = J + ee;
                            fe.text += ue, ee += ue, K += ue, t["_" + te + "padplus"] = se / 2 + K, t["_" + te + "padminus"] = se / 2 - K, t["_" + te + "size"] = se, t["_" + te + "shift"] = ee;
                        }
                        if (Z) N.remove();
                        else {
                            var be = 0, _e = 0;
                            if ("left" !== t.align && (be = (k - b) * ("center" === t.align ? .5 : 1)), "top" !== t.valign && (_e = (z - _) * ("middle" === t.valign ? .5 : 1)), f) n.select("svg").attr({
                                x: H + be - 1,
                                y: H + _e
                            }).call(u.setClipUrl, B ? D : null, e);
                            else {
                                var we = H + _e - v.top, Te = H + be - v.left;
                                q.call(d.positionText, Te, we).call(u.setClipUrl, B ? D : null, e);
                            }
                            Y.select("rect").call(u.setRect, H, H, k, z), j.call(u.setRect, F / 2, F / 2, E - F, V - F), N.call(u.setTranslate, Math.round(O.x.text - E / 2), Math.round(O.y.text - V / 2)), I.attr({
                                transform: "rotate(" + C + "," + O.x.text + "," + O.y.text + ")"
                            });
                            var Me, ke = function(r, n) {
                                P.selectAll(".annotation-arrow-g").remove();
                                var s = O.x.head, f = O.y.head, d = O.x.tail + r, h = O.y.tail + n, v = O.x.text + r, b = O.y.text + n, _ = o.rotationXYMatrix(C, v, b), w = o.apply2DTransform(_), k = o.apply2DTransform2(_), D = +j.attr("width"), R = +j.attr("height"), z = v - .5 * D, F = z + D, E = b - .5 * R, H = E + R, B = [
                                    [
                                        z,
                                        E,
                                        z,
                                        H
                                    ],
                                    [
                                        z,
                                        H,
                                        F,
                                        H
                                    ],
                                    [
                                        F,
                                        H,
                                        F,
                                        E
                                    ],
                                    [
                                        F,
                                        E,
                                        z,
                                        E
                                    ]
                                ].map(k);
                                if (!B.reduce(function(e, t) {
                                    return e ^ !!o.segmentsIntersect(s, f, s + 1e6, f + 1e6, t[0], t[1], t[2], t[3]);
                                }, !1)) {
                                    B.forEach(function(e) {
                                        var t = o.segmentsIntersect(d, h, s, f, e[0], e[1], e[2], e[3]);
                                        t && (d = t.x, h = t.y);
                                    });
                                    var Y = t.arrowwidth, V = t.arrowcolor, U = t.arrowside, q = P.append("g").style({
                                        opacity: c.opacity(V)
                                    }).classed("annotation-arrow-g", !0), G = q.append("path").attr("d", "M" + d + "," + h + "L" + s + "," + f).style("stroke-width", Y + "px").call(c.stroke, c.rgb(V));
                                    if (g(G, U, t), M.annotationPosition && G.node().parentNode && !i) {
                                        var Z = s, W = f;
                                        if (t.standoff) {
                                            var X = Math.sqrt(Math.pow(s - d, 2) + Math.pow(f - h, 2));
                                            Z += t.standoff * (d - s) / X, W += t.standoff * (h - f) / X;
                                        }
                                        var J, K, Q = q.append("path").classed("annotation-arrow", !0).classed("anndrag", !0).classed("cursor-move", !0).attr({
                                            d: "M3,3H-3V-3H3ZM0,0L" + (d - Z) + "," + (h - W),
                                            transform: l(Z, W)
                                        }).style("stroke-width", Y + 6 + "px").call(c.stroke, "rgba(0,0,0,0)").call(c.fill, "rgba(0,0,0,0)");
                                        p.init({
                                            element: Q.node(),
                                            gd: e,
                                            prepFn: function() {
                                                var e = u.getTranslate(N);
                                                J = e.x, K = e.y, y && y.autorange && A(y._name + ".autorange", !0), x && x.autorange && A(x._name + ".autorange", !0);
                                            },
                                            moveFn: function(e, r) {
                                                var n = w(J, K), a = n[0] + e, i = n[1] + r;
                                                N.call(u.setTranslate, a, i), L("x", m(y, e, "x", T, t)), L("y", m(x, r, "y", T, t)), t.axref === t.xref && L("ax", m(y, e, "ax", T, t)), t.ayref === t.yref && L("ay", m(x, r, "ay", T, t)), q.attr("transform", l(e, r)), I.attr({
                                                    transform: "rotate(" + C + "," + a + "," + i + ")"
                                                });
                                            },
                                            doneFn: function() {
                                                a.call("_guiRelayout", e, S());
                                                var t = document.querySelector(".js-notes-box-panel");
                                                t && t.redraw(t.selectedObj);
                                            }
                                        });
                                    }
                                }
                            };
                            t.showarrow && ke(0, 0), R && p.init({
                                element: N.node(),
                                gd: e,
                                prepFn: function() {
                                    Me = I.attr("transform");
                                },
                                moveFn: function(e, r) {
                                    var n = "pointer";
                                    if (t.showarrow) t.axref === t.xref ? L("ax", m(y, e, "ax", T, t)) : L("ax", t.ax + e), t.ayref === t.yref ? L("ay", m(x, r, "ay", T.w, t)) : L("ay", t.ay + r), ke(e, r);
                                    else {
                                        if (i) return;
                                        var a, o;
                                        if (y) a = m(y, e, "x", T, t);
                                        else {
                                            var s = t._xsize / T.w, c = t.x + (t._xshift - t.xshift) / T.w - s / 2;
                                            a = p.align(c + e / T.w, s, 0, 1, t.xanchor);
                                        }
                                        if (x) o = m(x, r, "y", T, t);
                                        else {
                                            var u = t._ysize / T.h, f = t.y - (t._yshift + t.yshift) / T.h - u / 2;
                                            o = p.align(f - r / T.h, u, 0, 1, t.yanchor);
                                        }
                                        L("x", a), L("y", o), y && x || (n = p.getCursor(y ? .5 : a, x ? .5 : o, t.xanchor, t.yanchor));
                                    }
                                    I.attr({
                                        transform: l(e, r) + Me
                                    }), h(N, n);
                                },
                                clickFn: function(r, n) {
                                    t.captureevents && e.emit("plotly_clickannotation", G(n));
                                },
                                doneFn: function() {
                                    h(N), a.call("_guiRelayout", e, S());
                                    var t = document.querySelector(".js-notes-box-panel");
                                    t && t.redraw(t.selectedObj);
                                }
                            });
                        }
                    }
                }
                e.exports = {
                    draw: function(e) {
                        var t = e._fullLayout;
                        t._infolayer.selectAll(".annotation").remove();
                        for(var r = 0; r < t.annotations.length; r++)t.annotations[r].visible && y(e, r);
                        return i.previousPromises(e);
                    },
                    drawOne: y,
                    drawRaw: x
                };
            },
            3011: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(7901), i = r(2884), o = r(1828), l = o.strScale, s = o.strRotate, c = o.strTranslate;
                e.exports = function(e, t, r) {
                    var o, u, f, d, h = e.node(), p = i[r.arrowhead || 0], v = i[r.startarrowhead || 0], g = (r.arrowwidth || 1) * (r.arrowsize || 1), y = (r.arrowwidth || 1) * (r.startarrowsize || 1), m = t.indexOf("start") >= 0, x = t.indexOf("end") >= 0, b = p.backoff * g + r.standoff, _ = v.backoff * y + r.startstandoff;
                    if ("line" === h.nodeName) {
                        o = {
                            x: +e.attr("x1"),
                            y: +e.attr("y1")
                        }, u = {
                            x: +e.attr("x2"),
                            y: +e.attr("y2")
                        };
                        var w = o.x - u.x, T = o.y - u.y;
                        if (d = (f = Math.atan2(T, w)) + Math.PI, b && _ && b + _ > Math.sqrt(w * w + T * T)) return void R();
                        if (b) {
                            if (b * b > w * w + T * T) return void R();
                            var M = b * Math.cos(f), k = b * Math.sin(f);
                            u.x += M, u.y += k, e.attr({
                                x2: u.x,
                                y2: u.y
                            });
                        }
                        if (_) {
                            if (_ * _ > w * w + T * T) return void R();
                            var A = _ * Math.cos(f), L = _ * Math.sin(f);
                            o.x -= A, o.y -= L, e.attr({
                                x1: o.x,
                                y1: o.y
                            });
                        }
                    } else if ("path" === h.nodeName) {
                        var S = h.getTotalLength(), D = "";
                        if (S < b + _) return void R();
                        var O = h.getPointAtLength(0), C = h.getPointAtLength(.1);
                        f = Math.atan2(O.y - C.y, O.x - C.x), o = h.getPointAtLength(Math.min(_, S)), D = "0px," + _ + "px,";
                        var P = h.getPointAtLength(S), I = h.getPointAtLength(S - .1);
                        d = Math.atan2(P.y - I.y, P.x - I.x), u = h.getPointAtLength(Math.max(0, S - b)), D += S - (D ? _ + b : b) + "px," + S + "px", e.style("stroke-dasharray", D);
                    }
                    function R() {
                        e.style("stroke-dasharray", "0px,100px");
                    }
                    function z(t, i, o, u) {
                        t.path && (t.noRotate && (o = 0), n.select(h.parentNode).append("path").attr({
                            class: e.attr("class"),
                            d: t.path,
                            transform: c(i.x, i.y) + s(180 * o / Math.PI) + l(u)
                        }).style({
                            fill: a.rgb(r.arrowcolor),
                            "stroke-width": 0
                        }));
                    }
                    m && z(v, o, f, y), x && z(p, u, d, g);
                };
            },
            2745: function(e, t, r) {
                "use strict";
                var n = r(2605), a = r(4317);
                e.exports = {
                    moduleType: "component",
                    name: "annotations",
                    layoutAttributes: r(215),
                    supplyLayoutDefaults: r(4046),
                    includeBasePlot: r(6325)("annotations"),
                    calcAutorange: r(3749),
                    draw: n.draw,
                    drawOne: n.drawOne,
                    drawRaw: n.drawRaw,
                    hasClickToShow: a.hasClickToShow,
                    onClick: a.onClick,
                    convertCoords: r(4128)
                };
            },
            6997: function(e, t, r) {
                "use strict";
                var n = r(215), a = r(962).overrideAll, i = r(4467).templatedArray;
                e.exports = a(i("annotation", {
                    visible: n.visible,
                    x: {
                        valType: "any"
                    },
                    y: {
                        valType: "any"
                    },
                    z: {
                        valType: "any"
                    },
                    ax: {
                        valType: "number"
                    },
                    ay: {
                        valType: "number"
                    },
                    xanchor: n.xanchor,
                    xshift: n.xshift,
                    yanchor: n.yanchor,
                    yshift: n.yshift,
                    text: n.text,
                    textangle: n.textangle,
                    font: n.font,
                    width: n.width,
                    height: n.height,
                    opacity: n.opacity,
                    align: n.align,
                    valign: n.valign,
                    bgcolor: n.bgcolor,
                    bordercolor: n.bordercolor,
                    borderpad: n.borderpad,
                    borderwidth: n.borderwidth,
                    showarrow: n.showarrow,
                    arrowcolor: n.arrowcolor,
                    arrowhead: n.arrowhead,
                    startarrowhead: n.startarrowhead,
                    arrowside: n.arrowside,
                    arrowsize: n.arrowsize,
                    startarrowsize: n.startarrowsize,
                    arrowwidth: n.arrowwidth,
                    standoff: n.standoff,
                    startstandoff: n.startstandoff,
                    hovertext: n.hovertext,
                    hoverlabel: n.hoverlabel,
                    captureevents: n.captureevents
                }), "calc", "from-root");
            },
            5485: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(9298);
                function i(e, t) {
                    var r = t.fullSceneLayout.domain, i = t.fullLayout._size, o = {
                        pdata: null,
                        type: "linear",
                        autorange: !1,
                        range: [
                            -1 / 0,
                            1 / 0
                        ]
                    };
                    e._xa = {}, n.extendFlat(e._xa, o), a.setConvert(e._xa), e._xa._offset = i.l + r.x[0] * i.w, e._xa.l2p = function() {
                        return .5 * (1 + e._pdata[0] / e._pdata[3]) * i.w * (r.x[1] - r.x[0]);
                    }, e._ya = {}, n.extendFlat(e._ya, o), a.setConvert(e._ya), e._ya._offset = i.t + (1 - r.y[1]) * i.h, e._ya.l2p = function() {
                        return .5 * (1 - e._pdata[1] / e._pdata[3]) * i.h * (r.y[1] - r.y[0]);
                    };
                }
                e.exports = function(e) {
                    for(var t = e.fullSceneLayout.annotations, r = 0; r < t.length; r++)i(t[r], e);
                    e.fullLayout._infolayer.selectAll(".annotation-" + e.id).remove();
                };
            },
            226: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(9298), i = r(5501), o = r(5625), l = r(6997);
                function s(e, t, r, i) {
                    function s(r, a) {
                        return n.coerce(e, t, l, r, a);
                    }
                    function c(e) {
                        var n = e + "axis", i = {
                            _fullLayout: {}
                        };
                        return i._fullLayout[n] = r[n], a.coercePosition(t, i, s, e, e, .5);
                    }
                    s("visible") && (o(e, t, i.fullLayout, s), c("x"), c("y"), c("z"), n.noneOrAll(e, t, [
                        "x",
                        "y",
                        "z"
                    ]), t.xref = "x", t.yref = "y", t.zref = "z", s("xanchor"), s("yanchor"), s("xshift"), s("yshift"), t.showarrow && (t.axref = "pixel", t.ayref = "pixel", s("ax", -10), s("ay", -30), n.noneOrAll(e, t, [
                        "ax",
                        "ay"
                    ])));
                }
                e.exports = function(e, t, r) {
                    i(e, t, {
                        name: "annotations",
                        handleItemDefaults: s,
                        fullLayout: r.fullLayout
                    });
                };
            },
            2188: function(e, t, r) {
                "use strict";
                var n = r(2605).drawRaw, a = r(3538), i = [
                    "x",
                    "y",
                    "z"
                ];
                e.exports = function(e) {
                    for(var t = e.fullSceneLayout, r = e.dataScale, o = t.annotations, l = 0; l < o.length; l++){
                        for(var s = o[l], c = !1, u = 0; u < 3; u++){
                            var f = i[u], d = s[f], h = t[f + "axis"].r2fraction(d);
                            if (h < 0 || h > 1) {
                                c = !0;
                                break;
                            }
                        }
                        c ? e.fullLayout._infolayer.select(".annotation-" + e.id + '[data-index="' + l + '"]').remove() : (s._pdata = a(e.glplot.cameraParams, [
                            t.xaxis.r2l(s.x) * r[0],
                            t.yaxis.r2l(s.y) * r[1],
                            t.zaxis.r2l(s.z) * r[2]
                        ]), n(e.graphDiv, s, l, e.id, s._xa, s._ya));
                    }
                };
            },
            2468: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(1828);
                e.exports = {
                    moduleType: "component",
                    name: "annotations3d",
                    schema: {
                        subplots: {
                            scene: {
                                annotations: r(6997)
                            }
                        }
                    },
                    layoutAttributes: r(6997),
                    handleDefaults: r(226),
                    includeBasePlot: function(e, t) {
                        var r = n.subplotsRegistry.gl3d;
                        if (r) for(var i = r.attrRegex, o = Object.keys(e), l = 0; l < o.length; l++){
                            var s = o[l];
                            i.test(s) && (e[s].annotations || []).length && (a.pushUnique(t._basePlotModules, r), a.pushUnique(t._subplots.gl3d, s));
                        }
                    },
                    convert: r(5485),
                    draw: r(2188)
                };
            },
            7561: function(e, t, r) {
                "use strict";
                e.exports = r(3489), r(4338), r(3961), r(8751), r(6825), r(7715), r(9384), r(3805), r(8874), r(3290), r(9108), r(5422), r(4320), r(1320), r(1367), r(1457);
            },
            2201: function(e, t, r) {
                "use strict";
                var n = r(7561), a = r(1828), i = r(606), o = i.EPOCHJD, l = i.ONEDAY, s = {
                    valType: "enumerated",
                    values: a.sortObjectKeys(n.calendars),
                    editType: "calc",
                    dflt: "gregorian"
                }, c = function(e, t, r, n) {
                    var i = {};
                    return i[r] = s, a.coerce(e, t, i, r, n);
                }, u = "##", f = {
                    d: {
                        0: "dd",
                        "-": "d"
                    },
                    e: {
                        0: "d",
                        "-": "d"
                    },
                    a: {
                        0: "D",
                        "-": "D"
                    },
                    A: {
                        0: "DD",
                        "-": "DD"
                    },
                    j: {
                        0: "oo",
                        "-": "o"
                    },
                    W: {
                        0: "ww",
                        "-": "w"
                    },
                    m: {
                        0: "mm",
                        "-": "m"
                    },
                    b: {
                        0: "M",
                        "-": "M"
                    },
                    B: {
                        0: "MM",
                        "-": "MM"
                    },
                    y: {
                        0: "yy",
                        "-": "yy"
                    },
                    Y: {
                        0: "yyyy",
                        "-": "yyyy"
                    },
                    U: u,
                    w: u,
                    c: {
                        0: "D M d %X yyyy",
                        "-": "D M d %X yyyy"
                    },
                    x: {
                        0: "mm/dd/yyyy",
                        "-": "mm/dd/yyyy"
                    }
                }, d = {};
                function h(e) {
                    var t = d[e];
                    return t || (d[e] = n.instance(e));
                }
                function p(e) {
                    return a.extendFlat({}, s, {
                        description: e
                    });
                }
                function v(e) {
                    return "Sets the calendar system to use with `" + e + "` date data.";
                }
                var g = {
                    xcalendar: p(v("x"))
                }, y = a.extendFlat({}, g, {
                    ycalendar: p(v("y"))
                }), m = a.extendFlat({}, y, {
                    zcalendar: p(v("z"))
                }), x = p([
                    "Sets the calendar system to use for `range` and `tick0`",
                    "if this is a date axis. This does not set the calendar for",
                    "interpreting data on this axis, that's specified in the trace",
                    "or via the global `layout.calendar`"
                ].join(" "));
                e.exports = {
                    moduleType: "component",
                    name: "calendars",
                    schema: {
                        traces: {
                            scatter: y,
                            bar: y,
                            box: y,
                            heatmap: y,
                            contour: y,
                            histogram: y,
                            histogram2d: y,
                            histogram2dcontour: y,
                            scatter3d: m,
                            surface: m,
                            mesh3d: m,
                            scattergl: y,
                            ohlc: g,
                            candlestick: g
                        },
                        layout: {
                            calendar: p([
                                "Sets the default calendar system to use for interpreting and",
                                "displaying dates throughout the plot."
                            ].join(" "))
                        },
                        subplots: {
                            xaxis: {
                                calendar: x
                            },
                            yaxis: {
                                calendar: x
                            },
                            scene: {
                                xaxis: {
                                    calendar: x
                                },
                                yaxis: {
                                    calendar: x
                                },
                                zaxis: {
                                    calendar: x
                                }
                            },
                            polar: {
                                radialaxis: {
                                    calendar: x
                                }
                            }
                        },
                        transforms: {
                            filter: {
                                valuecalendar: p([
                                    "WARNING: All transforms are deprecated and may be removed from the API in next major version.",
                                    "Sets the calendar system to use for `value`, if it is a date."
                                ].join(" ")),
                                targetcalendar: p([
                                    "WARNING: All transforms are deprecated and may be removed from the API in next major version.",
                                    "Sets the calendar system to use for `target`, if it is an",
                                    "array of dates. If `target` is a string (eg *x*) we use the",
                                    "corresponding trace attribute (eg `xcalendar`) if it exists,",
                                    "even if `targetcalendar` is provided."
                                ].join(" "))
                            }
                        }
                    },
                    layoutAttributes: s,
                    handleDefaults: c,
                    handleTraceDefaults: function(e, t, r, n) {
                        for(var a = 0; a < r.length; a++)c(e, t, r[a] + "calendar", n.calendar);
                    },
                    CANONICAL_SUNDAY: {
                        chinese: "2000-01-02",
                        coptic: "2000-01-03",
                        discworld: "2000-01-03",
                        ethiopian: "2000-01-05",
                        hebrew: "5000-01-01",
                        islamic: "1000-01-02",
                        julian: "2000-01-03",
                        mayan: "5000-01-01",
                        nanakshahi: "1000-01-05",
                        nepali: "2000-01-05",
                        persian: "1000-01-01",
                        jalali: "1000-01-01",
                        taiwan: "1000-01-04",
                        thai: "2000-01-04",
                        ummalqura: "1400-01-06"
                    },
                    CANONICAL_TICK: {
                        chinese: "2000-01-01",
                        coptic: "2000-01-01",
                        discworld: "2000-01-01",
                        ethiopian: "2000-01-01",
                        hebrew: "5000-01-01",
                        islamic: "1000-01-01",
                        julian: "2000-01-01",
                        mayan: "5000-01-01",
                        nanakshahi: "1000-01-01",
                        nepali: "2000-01-01",
                        persian: "1000-01-01",
                        jalali: "1000-01-01",
                        taiwan: "1000-01-01",
                        thai: "2000-01-01",
                        ummalqura: "1400-01-01"
                    },
                    DFLTRANGE: {
                        chinese: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        coptic: [
                            "1700-01-01",
                            "1701-01-01"
                        ],
                        discworld: [
                            "1800-01-01",
                            "1801-01-01"
                        ],
                        ethiopian: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        hebrew: [
                            "5700-01-01",
                            "5701-01-01"
                        ],
                        islamic: [
                            "1400-01-01",
                            "1401-01-01"
                        ],
                        julian: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        mayan: [
                            "5200-01-01",
                            "5201-01-01"
                        ],
                        nanakshahi: [
                            "0500-01-01",
                            "0501-01-01"
                        ],
                        nepali: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        persian: [
                            "1400-01-01",
                            "1401-01-01"
                        ],
                        jalali: [
                            "1400-01-01",
                            "1401-01-01"
                        ],
                        taiwan: [
                            "0100-01-01",
                            "0101-01-01"
                        ],
                        thai: [
                            "2500-01-01",
                            "2501-01-01"
                        ],
                        ummalqura: [
                            "1400-01-01",
                            "1401-01-01"
                        ]
                    },
                    getCal: h,
                    worldCalFmt: function(e, t, r) {
                        for(var n, a, i, s, c, d = Math.floor((t + .05) / l) + o, p = h(r).fromJD(d), v = 0; -1 !== (v = e.indexOf("%", v));)"0" === (n = e.charAt(v + 1)) || "-" === n || "_" === n ? (i = 3, a = e.charAt(v + 2), "_" === n && (n = "-")) : (a = n, n = "0", i = 2), (s = f[a]) ? (c = s === u ? u : p.formatDate(s[n]), e = e.substr(0, v) + c + e.substr(v + i), v += c.length) : v += i;
                        return e;
                    }
                };
            },
            2399: function(e, t) {
                "use strict";
                t.defaults = [
                    "#1f77b4",
                    "#ff7f0e",
                    "#2ca02c",
                    "#d62728",
                    "#9467bd",
                    "#8c564b",
                    "#e377c2",
                    "#7f7f7f",
                    "#bcbd22",
                    "#17becf"
                ], t.defaultLine = "#444", t.lightLine = "#eee", t.background = "#fff", t.borderLine = "#BEC8D9", t.lightFraction = 1e3 / 11;
            },
            7901: function(e, t, r) {
                "use strict";
                var n = r(4267), a = r(2770), i = r(3627).isTypedArray, o = e.exports = {}, l = r(2399);
                o.defaults = l.defaults;
                var s = o.defaultLine = l.defaultLine;
                o.lightLine = l.lightLine;
                var c = o.background = l.background;
                function u(e) {
                    if (a(e) || "string" != typeof e) return e;
                    var t = e.trim();
                    if ("rgb" !== t.substr(0, 3)) return e;
                    var r = t.match(/^rgba?\s*\(([^()]*)\)$/);
                    if (!r) return e;
                    var n = r[1].trim().split(/\s*[\s,]\s*/), i = "a" === t.charAt(3) && 4 === n.length;
                    if (!i && 3 !== n.length) return e;
                    for(var o = 0; o < n.length; o++){
                        if (!n[o].length) return e;
                        if (n[o] = Number(n[o]), !(n[o] >= 0)) return e;
                        if (3 === o) n[o] > 1 && (n[o] = 1);
                        else if (n[o] >= 1) return e;
                    }
                    var l = Math.round(255 * n[0]) + ", " + Math.round(255 * n[1]) + ", " + Math.round(255 * n[2]);
                    return i ? "rgba(" + l + ", " + n[3] + ")" : "rgb(" + l + ")";
                }
                o.tinyRGB = function(e) {
                    var t = e.toRgb();
                    return "rgb(" + Math.round(t.r) + ", " + Math.round(t.g) + ", " + Math.round(t.b) + ")";
                }, o.rgb = function(e) {
                    return o.tinyRGB(n(e));
                }, o.opacity = function(e) {
                    return e ? n(e).getAlpha() : 0;
                }, o.addOpacity = function(e, t) {
                    var r = n(e).toRgb();
                    return "rgba(" + Math.round(r.r) + ", " + Math.round(r.g) + ", " + Math.round(r.b) + ", " + t + ")";
                }, o.combine = function(e, t) {
                    var r = n(e).toRgb();
                    if (1 === r.a) return n(e).toRgbString();
                    var a = n(t || c).toRgb(), i = 1 === a.a ? a : {
                        r: 255 * (1 - a.a) + a.r * a.a,
                        g: 255 * (1 - a.a) + a.g * a.a,
                        b: 255 * (1 - a.a) + a.b * a.a
                    }, o = {
                        r: i.r * (1 - r.a) + r.r * r.a,
                        g: i.g * (1 - r.a) + r.g * r.a,
                        b: i.b * (1 - r.a) + r.b * r.a
                    };
                    return n(o).toRgbString();
                }, o.contrast = function(e, t, r) {
                    var a = n(e);
                    return 1 !== a.getAlpha() && (a = n(o.combine(e, c))), (a.isDark() ? t ? a.lighten(t) : c : r ? a.darken(r) : s).toString();
                }, o.stroke = function(e, t) {
                    var r = n(t);
                    e.style({
                        stroke: o.tinyRGB(r),
                        "stroke-opacity": r.getAlpha()
                    });
                }, o.fill = function(e, t) {
                    var r = n(t);
                    e.style({
                        fill: o.tinyRGB(r),
                        "fill-opacity": r.getAlpha()
                    });
                }, o.clean = function(e) {
                    if (e && "object" == typeof e) {
                        var t, r, n, a, l = Object.keys(e);
                        for(t = 0; t < l.length; t++)if (a = e[n = l[t]], "color" === n.substr(n.length - 5)) {
                            if (Array.isArray(a)) for(r = 0; r < a.length; r++)a[r] = u(a[r]);
                            else e[n] = u(a);
                        } else if ("colorscale" === n.substr(n.length - 10) && Array.isArray(a)) for(r = 0; r < a.length; r++)Array.isArray(a[r]) && (a[r][1] = u(a[r][1]));
                        else if (Array.isArray(a)) {
                            var s = a[0];
                            if (!Array.isArray(s) && s && "object" == typeof s) for(r = 0; r < a.length; r++)o.clean(a[r]);
                        } else a && "object" == typeof a && !i(a) && o.clean(a);
                    }
                };
            },
            3583: function(e, t, r) {
                "use strict";
                var n = r(3838), a = r(1940), i = r(1426).extendFlat, o = r(962).overrideAll;
                e.exports = o({
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "h",
                            "v"
                        ],
                        dflt: "v"
                    },
                    thicknessmode: {
                        valType: "enumerated",
                        values: [
                            "fraction",
                            "pixels"
                        ],
                        dflt: "pixels"
                    },
                    thickness: {
                        valType: "number",
                        min: 0,
                        dflt: 30
                    },
                    lenmode: {
                        valType: "enumerated",
                        values: [
                            "fraction",
                            "pixels"
                        ],
                        dflt: "fraction"
                    },
                    len: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    x: {
                        valType: "number"
                    },
                    xref: {
                        valType: "enumerated",
                        dflt: "paper",
                        values: [
                            "container",
                            "paper"
                        ],
                        editType: "layoutstyle"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ]
                    },
                    xpad: {
                        valType: "number",
                        min: 0,
                        dflt: 10
                    },
                    y: {
                        valType: "number"
                    },
                    yref: {
                        valType: "enumerated",
                        dflt: "paper",
                        values: [
                            "container",
                            "paper"
                        ],
                        editType: "layoutstyle"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ]
                    },
                    ypad: {
                        valType: "number",
                        min: 0,
                        dflt: 10
                    },
                    outlinecolor: n.linecolor,
                    outlinewidth: n.linewidth,
                    bordercolor: n.linecolor,
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 0
                    },
                    bgcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)"
                    },
                    tickmode: n.minor.tickmode,
                    nticks: n.nticks,
                    tick0: n.tick0,
                    dtick: n.dtick,
                    tickvals: n.tickvals,
                    ticktext: n.ticktext,
                    ticks: i({}, n.ticks, {
                        dflt: ""
                    }),
                    ticklabeloverflow: i({}, n.ticklabeloverflow, {}),
                    ticklabelposition: {
                        valType: "enumerated",
                        values: [
                            "outside",
                            "inside",
                            "outside top",
                            "inside top",
                            "outside left",
                            "inside left",
                            "outside right",
                            "inside right",
                            "outside bottom",
                            "inside bottom"
                        ],
                        dflt: "outside"
                    },
                    ticklen: n.ticklen,
                    tickwidth: n.tickwidth,
                    tickcolor: n.tickcolor,
                    ticklabelstep: n.ticklabelstep,
                    showticklabels: n.showticklabels,
                    labelalias: n.labelalias,
                    tickfont: a({}),
                    tickangle: n.tickangle,
                    tickformat: n.tickformat,
                    tickformatstops: n.tickformatstops,
                    tickprefix: n.tickprefix,
                    showtickprefix: n.showtickprefix,
                    ticksuffix: n.ticksuffix,
                    showticksuffix: n.showticksuffix,
                    separatethousands: n.separatethousands,
                    exponentformat: n.exponentformat,
                    minexponent: n.minexponent,
                    showexponent: n.showexponent,
                    title: {
                        text: {
                            valType: "string"
                        },
                        font: a({}),
                        side: {
                            valType: "enumerated",
                            values: [
                                "right",
                                "top",
                                "bottom"
                            ]
                        }
                    },
                    _deprecated: {
                        title: {
                            valType: "string"
                        },
                        titlefont: a({}),
                        titleside: {
                            valType: "enumerated",
                            values: [
                                "right",
                                "top",
                                "bottom"
                            ],
                            dflt: "top"
                        }
                    }
                }, "colorbars", "from-root");
            },
            939: function(e) {
                "use strict";
                e.exports = {
                    cn: {
                        colorbar: "colorbar",
                        cbbg: "cbbg",
                        cbfill: "cbfill",
                        cbfills: "cbfills",
                        cbline: "cbline",
                        cblines: "cblines",
                        cbaxis: "cbaxis",
                        cbtitleunshift: "cbtitleunshift",
                        cbtitle: "cbtitle",
                        cboutline: "cboutline",
                        crisp: "crisp",
                        jsPlaceholder: "js-placeholder"
                    }
                };
            },
            2499: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(4467), i = r(6218), o = r(8701), l = r(6115), s = r(9426), c = r(3583);
                e.exports = function(e, t, r) {
                    var u = a.newContainer(t, "colorbar"), f = e.colorbar || {};
                    function d(e, t) {
                        return n.coerce(f, u, c, e, t);
                    }
                    var h = r.margin || {
                        t: 0,
                        b: 0,
                        l: 0,
                        r: 0
                    }, p = r.width - h.l - h.r, v = r.height - h.t - h.b, g = "v" === d("orientation"), y = d("thicknessmode");
                    d("thickness", "fraction" === y ? 30 / (g ? p : v) : 30);
                    var m = d("lenmode");
                    d("len", "fraction" === m ? 1 : g ? v : p);
                    var x, b, _, w = "paper" === d("yref"), T = "paper" === d("xref"), M = "left";
                    g ? (_ = "middle", M = T ? "left" : "right", x = T ? 1.02 : 1, b = .5) : (_ = w ? "bottom" : "top", M = "center", x = .5, b = w ? 1.02 : 1), n.coerce(f, u, {
                        x: {
                            valType: "number",
                            min: T ? -2 : 0,
                            max: T ? 3 : 1,
                            dflt: x
                        }
                    }, "x"), n.coerce(f, u, {
                        y: {
                            valType: "number",
                            min: w ? -2 : 0,
                            max: w ? 3 : 1,
                            dflt: b
                        }
                    }, "y"), d("xanchor", M), d("xpad"), d("yanchor", _), d("ypad"), n.noneOrAll(f, u, [
                        "x",
                        "y"
                    ]), d("outlinecolor"), d("outlinewidth"), d("bordercolor"), d("borderwidth"), d("bgcolor");
                    var k = n.coerce(f, u, {
                        ticklabelposition: {
                            valType: "enumerated",
                            dflt: "outside",
                            values: g ? [
                                "outside",
                                "inside",
                                "outside top",
                                "inside top",
                                "outside bottom",
                                "inside bottom"
                            ] : [
                                "outside",
                                "inside",
                                "outside left",
                                "inside left",
                                "outside right",
                                "inside right"
                            ]
                        }
                    }, "ticklabelposition");
                    d("ticklabeloverflow", -1 !== k.indexOf("inside") ? "hide past domain" : "hide past div"), i(f, u, d, "linear");
                    var A = r.font, L = {
                        outerTicks: !1,
                        font: A
                    };
                    -1 !== k.indexOf("inside") && (L.bgColor = "black"), s(f, u, d, "linear", L), l(f, u, d, "linear", L), o(f, u, d, "linear", L), d("title.text", r._dfltTitle.colorbar);
                    var S = u.showticklabels ? u.tickfont : A, D = n.extendFlat({}, S, {
                        color: A.color,
                        size: n.bigFont(S.size)
                    });
                    n.coerceFont(d, "title.font", D), d("title.side", g ? "top" : "right");
                };
            },
            8981: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(4267), i = r(4875), o = r(3972), l = r(9298), s = r(8569), c = r(1828), u = c.strTranslate, f = r(1426).extendFlat, d = r(6964), h = r(1424), p = r(7901), v = r(2998), g = r(3893), y = r(2869).flipScale, m = r(1453), x = r(2830), b = r(3838), _ = r(8783), w = _.LINE_SPACING, T = _.FROM_TL, M = _.FROM_BR, k = r(939).cn;
                e.exports = {
                    draw: function(e) {
                        var t = e._fullLayout._infolayer.selectAll("g." + k.colorbar).data(function(e) {
                            var t, r, n, a, i = e._fullLayout, o = e.calcdata, l = [];
                            function s(e) {
                                return f(e, {
                                    _fillcolor: null,
                                    _line: {
                                        color: null,
                                        width: null,
                                        dash: null
                                    },
                                    _levels: {
                                        start: null,
                                        end: null,
                                        size: null
                                    },
                                    _filllevels: null,
                                    _fillgradient: null,
                                    _zrange: null
                                });
                            }
                            function c() {
                                "function" == typeof a.calc ? a.calc(e, n, t) : (t._fillgradient = r.reversescale ? y(r.colorscale) : r.colorscale, t._zrange = [
                                    r[a.min],
                                    r[a.max]
                                ]);
                            }
                            for(var u = 0; u < o.length; u++){
                                var d = o[u];
                                if ((n = d[0].trace)._module) {
                                    var h = n._module.colorbar;
                                    if (!0 === n.visible && h) for(var p = Array.isArray(h), v = p ? h : [
                                        h
                                    ], g = 0; g < v.length; g++){
                                        var m = (a = v[g]).container;
                                        (r = m ? n[m] : n) && r.showscale && ((t = s(r.colorbar))._id = "cb" + n.uid + (p && m ? "-" + m : ""), t._traceIndex = n.index, t._propPrefix = (m ? m + "." : "") + "colorbar.", t._meta = n._meta, c(), l.push(t));
                                    }
                                }
                            }
                            for(var x in i._colorAxes)if ((r = i[x]).showscale) {
                                var b = i._colorAxes[x];
                                (t = s(r.colorbar))._id = "cb" + x, t._propPrefix = x + ".colorbar.", t._meta = i._meta, a = {
                                    min: "cmin",
                                    max: "cmax"
                                }, "heatmap" !== b[0] && (n = b[1], a.calc = n._module.colorbar.calc), c(), l.push(t);
                            }
                            return l;
                        }(e), function(e) {
                            return e._id;
                        });
                        t.enter().append("g").attr("class", function(e) {
                            return e._id;
                        }).classed(k.colorbar, !0), t.each(function(t) {
                            var r = n.select(this);
                            c.ensureSingle(r, "rect", k.cbbg), c.ensureSingle(r, "g", k.cbfills), c.ensureSingle(r, "g", k.cblines), c.ensureSingle(r, "g", k.cbaxis, function(e) {
                                e.classed(k.crisp, !0);
                            }), c.ensureSingle(r, "g", k.cbtitleunshift, function(e) {
                                e.append("g").classed(k.cbtitle, !0);
                            }), c.ensureSingle(r, "rect", k.cboutline);
                            var y = function(e, t, r) {
                                var o = "v" === t.orientation, s = t.len, d = t.lenmode, y = t.thickness, _ = t.thicknessmode, A = t.outlinewidth, L = t.borderwidth, S = t.bgcolor, D = t.xanchor, O = t.yanchor, C = t.xpad, P = t.ypad, I = t.x, R = o ? t.y : 1 - t.y, z = "paper" === t.yref, N = "paper" === t.xref, F = r._fullLayout, E = F._size, H = t._fillcolor, j = t._line, B = t.title, Y = B.side, V = t._zrange || n.extent(("function" == typeof H ? H : j.color).domain()), U = "function" == typeof j.color ? j.color : function() {
                                    return j.color;
                                }, q = "function" == typeof H ? H : function() {
                                    return H;
                                }, G = t._levels, Z = function(e, t, r) {
                                    var n, a, i = t._levels, o = [], l = [], s = i.end + i.size / 100, c = i.size, u = 1.001 * r[0] - .001 * r[1], f = 1.001 * r[1] - .001 * r[0];
                                    for(a = 0; a < 1e5 && (n = i.start + a * c, !(c > 0 ? n >= s : n <= s)); a++)n > u && n < f && o.push(n);
                                    if (t._fillgradient) l = [
                                        0
                                    ];
                                    else if ("function" == typeof t._fillcolor) {
                                        var d = t._filllevels;
                                        if (d) for(s = d.end + d.size / 100, c = d.size, a = 0; a < 1e5 && (n = d.start + a * c, !(c > 0 ? n >= s : n <= s)); a++)n > r[0] && n < r[1] && l.push(n);
                                        else (l = o.map(function(e) {
                                            return e - i.size / 2;
                                        })).push(l[l.length - 1] + i.size);
                                    } else t._fillcolor && "string" == typeof t._fillcolor && (l = [
                                        0
                                    ]);
                                    return i.size < 0 && (o.reverse(), l.reverse()), {
                                        line: o,
                                        fill: l
                                    };
                                }(0, t, V), W = Z.fill, X = Z.line, J = Math.round(y * ("fraction" === _ ? o ? E.w : E.h : 1)), K = J / (o ? E.w : E.h), Q = Math.round(s * ("fraction" === d ? o ? E.h : E.w : 1)), $ = Q / (o ? E.h : E.w), ee = N ? E.w : r._fullLayout.width, te = z ? E.h : r._fullLayout.height, re = Math.round(o ? I * ee + C : R * te + P), ne = {
                                    center: .5,
                                    right: 1
                                }[D] || 0, ae = {
                                    top: 1,
                                    middle: .5
                                }[O] || 0, ie = o ? I - ne * K : R - ae * K, oe = o ? R - ae * $ : I - ne * $, le = Math.round(o ? te * (1 - oe) : ee * oe);
                                t._lenFrac = $, t._thickFrac = K, t._uFrac = ie, t._vFrac = oe;
                                var se = t._axis = function(e, t, r) {
                                    var n = e._fullLayout, a = "v" === t.orientation, i = {
                                        type: "linear",
                                        range: r,
                                        tickmode: t.tickmode,
                                        nticks: t.nticks,
                                        tick0: t.tick0,
                                        dtick: t.dtick,
                                        tickvals: t.tickvals,
                                        ticktext: t.ticktext,
                                        ticks: t.ticks,
                                        ticklen: t.ticklen,
                                        tickwidth: t.tickwidth,
                                        tickcolor: t.tickcolor,
                                        showticklabels: t.showticklabels,
                                        labelalias: t.labelalias,
                                        ticklabelposition: t.ticklabelposition,
                                        ticklabeloverflow: t.ticklabeloverflow,
                                        ticklabelstep: t.ticklabelstep,
                                        tickfont: t.tickfont,
                                        tickangle: t.tickangle,
                                        tickformat: t.tickformat,
                                        exponentformat: t.exponentformat,
                                        minexponent: t.minexponent,
                                        separatethousands: t.separatethousands,
                                        showexponent: t.showexponent,
                                        showtickprefix: t.showtickprefix,
                                        tickprefix: t.tickprefix,
                                        showticksuffix: t.showticksuffix,
                                        ticksuffix: t.ticksuffix,
                                        title: t.title,
                                        showline: !0,
                                        anchor: "free",
                                        side: a ? "right" : "bottom",
                                        position: 1
                                    }, o = a ? "y" : "x", l = {
                                        type: "linear",
                                        _id: o + t._id
                                    }, s = {
                                        letter: o,
                                        font: n.font,
                                        noHover: !0,
                                        noTickson: !0,
                                        noTicklabelmode: !0,
                                        calendar: n.calendar
                                    };
                                    function u(e, t) {
                                        return c.coerce(i, l, b, e, t);
                                    }
                                    return m(i, l, u, s, n), x(i, l, u, s), l;
                                }(r, t, V);
                                se.position = K + (o ? I + C / E.w : R + P / E.h);
                                var ce = -1 !== [
                                    "top",
                                    "bottom"
                                ].indexOf(Y);
                                if (o && ce && (se.title.side = Y, se.titlex = I + C / E.w, se.titley = oe + ("top" === B.side ? $ - P / E.h : P / E.h)), o || ce || (se.title.side = Y, se.titley = R + P / E.h, se.titlex = oe + C / E.w), j.color && "auto" === t.tickmode) {
                                    se.tickmode = "linear", se.tick0 = G.start;
                                    var ue = G.size, fe = c.constrain(Q / 50, 4, 15) + 1, de = (V[1] - V[0]) / ((t.nticks || fe) * ue);
                                    if (de > 1) {
                                        var he = Math.pow(10, Math.floor(Math.log(de) / Math.LN10));
                                        ue *= he * c.roundUp(de / he, [
                                            2,
                                            5,
                                            10
                                        ]), (Math.abs(G.start) / G.size + 1e-6) % 1 < 2e-6 && (se.tick0 = 0);
                                    }
                                    se.dtick = ue;
                                }
                                se.domain = o ? [
                                    oe + P / E.h,
                                    oe + $ - P / E.h
                                ] : [
                                    oe + C / E.w,
                                    oe + $ - C / E.w
                                ], se.setScale(), e.attr("transform", u(Math.round(E.l), Math.round(E.t)));
                                var pe, ve = e.select("." + k.cbtitleunshift).attr("transform", u(-Math.round(E.l), -Math.round(E.t))), ge = se.ticklabelposition, ye = se.title.font.size, me = e.select("." + k.cbaxis), xe = 0, be = 0;
                                function _e(n, a) {
                                    var i = {
                                        propContainer: se,
                                        propName: t._propPrefix + "title",
                                        traceIndex: t._traceIndex,
                                        _meta: t._meta,
                                        placeholder: F._dfltTitle.colorbar,
                                        containerGroup: e.select("." + k.cbtitle)
                                    }, o = "h" === n.charAt(0) ? n.substr(1) : "h" + n;
                                    e.selectAll("." + o + ",." + o + "-math-group").remove(), v.draw(r, n, f(i, a || {}));
                                }
                                return c.syncOrAsync([
                                    i.previousPromises,
                                    function() {
                                        var e, t;
                                        (o && ce || !o && !ce) && ("top" === Y && (e = C + E.l + ee * I, t = P + E.t + te * (1 - oe - $) + 3 + .75 * ye), "bottom" === Y && (e = C + E.l + ee * I, t = P + E.t + te * (1 - oe) - 3 - .25 * ye), "right" === Y && (t = P + E.t + te * R + 3 + .75 * ye, e = C + E.l + ee * oe), _e(se._id + "title", {
                                            attributes: {
                                                x: e,
                                                y: t,
                                                "text-anchor": o ? "start" : "middle"
                                            }
                                        }));
                                    },
                                    function() {
                                        if (!o && !ce || o && ce) {
                                            var i, s = e.select("." + k.cbtitle), f = s.select("text"), d = [
                                                -A / 2,
                                                A / 2
                                            ], p = s.select(".h" + se._id + "title-math-group").node(), v = 15.6;
                                            if (f.node() && (v = parseInt(f.node().style.fontSize, 10) * w), p ? (i = h.bBox(p), be = i.width, (xe = i.height) > v && (d[1] -= (xe - v) / 2)) : f.node() && !f.classed(k.jsPlaceholder) && (i = h.bBox(f.node()), be = i.width, xe = i.height), o) {
                                                if (xe) {
                                                    if (xe += 5, "top" === Y) se.domain[1] -= xe / E.h, d[1] *= -1;
                                                    else {
                                                        se.domain[0] += xe / E.h;
                                                        var y = g.lineCount(f);
                                                        d[1] += (1 - y) * v;
                                                    }
                                                    s.attr("transform", u(d[0], d[1])), se.setScale();
                                                }
                                            } else be && ("right" === Y && (se.domain[0] += (be + ye / 2) / E.w), s.attr("transform", u(d[0], d[1])), se.setScale());
                                        }
                                        e.selectAll("." + k.cbfills + ",." + k.cblines).attr("transform", o ? u(0, Math.round(E.h * (1 - se.domain[1]))) : u(Math.round(E.w * se.domain[0]), 0)), me.attr("transform", o ? u(0, Math.round(-E.t)) : u(Math.round(-E.l), 0));
                                        var m = e.select("." + k.cbfills).selectAll("rect." + k.cbfill).attr("style", "").data(W);
                                        m.enter().append("rect").classed(k.cbfill, !0).attr("style", ""), m.exit().remove();
                                        var x = V.map(se.c2p).map(Math.round).sort(function(e, t) {
                                            return e - t;
                                        });
                                        m.each(function(e, i) {
                                            var l = [
                                                0 === i ? V[0] : (W[i] + W[i - 1]) / 2,
                                                i === W.length - 1 ? V[1] : (W[i] + W[i + 1]) / 2
                                            ].map(se.c2p).map(Math.round);
                                            o && (l[1] = c.constrain(l[1] + (l[1] > l[0]) ? 1 : -1, x[0], x[1]));
                                            var s = n.select(this).attr(o ? "x" : "y", re).attr(o ? "y" : "x", n.min(l)).attr(o ? "width" : "height", Math.max(J, 2)).attr(o ? "height" : "width", Math.max(n.max(l) - n.min(l), 2));
                                            if (t._fillgradient) h.gradient(s, r, t._id, o ? "vertical" : "horizontalreversed", t._fillgradient, "fill");
                                            else {
                                                var u = q(e).replace("e-", "");
                                                s.attr("fill", a(u).toHexString());
                                            }
                                        });
                                        var b = e.select("." + k.cblines).selectAll("path." + k.cbline).data(j.color && j.width ? X : []);
                                        b.enter().append("path").classed(k.cbline, !0), b.exit().remove(), b.each(function(e) {
                                            var t = re, r = Math.round(se.c2p(e)) + j.width / 2 % 1;
                                            n.select(this).attr("d", "M" + (o ? t + "," + r : r + "," + t) + (o ? "h" : "v") + J).call(h.lineGroupStyle, j.width, U(e), j.dash);
                                        }), me.selectAll("g." + se._id + "tick,path").remove();
                                        var _ = re + J + (A || 0) / 2 - ("outside" === t.ticks ? 1 : 0), T = l.calcTicks(se), M = l.getTickSigns(se)[2];
                                        return l.drawTicks(r, se, {
                                            vals: "inside" === se.ticks ? l.clipEnds(se, T) : T,
                                            layer: me,
                                            path: l.makeTickPath(se, _, M),
                                            transFn: l.makeTransTickFn(se)
                                        }), l.drawLabels(r, se, {
                                            vals: T,
                                            layer: me,
                                            transFn: l.makeTransTickLabelFn(se),
                                            labelFns: l.makeLabelFns(se, _)
                                        });
                                    },
                                    function() {
                                        if (o && !ce || !o && ce) {
                                            var e, a, i = se.position || 0, l = se._offset + se._length / 2;
                                            if ("right" === Y) a = l, e = E.l + ee * i + 10 + ye * (se.showticklabels ? 1 : .5);
                                            else if (e = l, "bottom" === Y && (a = E.t + te * i + 10 + (-1 === ge.indexOf("inside") ? se.tickfont.size : 0) + ("intside" !== se.ticks && t.ticklen || 0)), "top" === Y) {
                                                var s = B.text.split("<br>").length;
                                                a = E.t + te * i + 10 - J - w * ye * s;
                                            }
                                            _e((o ? "h" : "v") + se._id + "title", {
                                                avoid: {
                                                    selection: n.select(r).selectAll("g." + se._id + "tick"),
                                                    side: Y,
                                                    offsetTop: o ? 0 : E.t,
                                                    offsetLeft: o ? E.l : 0,
                                                    maxShift: o ? F.width : F.height
                                                },
                                                attributes: {
                                                    x: e,
                                                    y: a,
                                                    "text-anchor": "middle"
                                                },
                                                transform: {
                                                    rotate: o ? -90 : 0,
                                                    offset: 0
                                                }
                                            });
                                        }
                                    },
                                    i.previousPromises,
                                    function() {
                                        var n, l = J + A / 2;
                                        -1 === ge.indexOf("inside") && (n = h.bBox(me.node()), l += o ? n.width : n.height), pe = ve.select("text");
                                        var c = 0, f = o && "top" === Y, v = !o && "right" === Y, g = 0;
                                        if (pe.node() && !pe.classed(k.jsPlaceholder)) {
                                            var m, x = ve.select(".h" + se._id + "title-math-group").node();
                                            x && (o && ce || !o && !ce) ? (c = (n = h.bBox(x)).width, m = n.height) : (c = (n = h.bBox(ve.node())).right - E.l - (o ? re : le), m = n.bottom - E.t - (o ? le : re), o || "top" !== Y || (l += n.height, g = n.height)), v && (pe.attr("transform", u(c / 2 + ye / 2, 0)), c *= 2), l = Math.max(l, o ? c : m);
                                        }
                                        var b = 2 * (o ? C : P) + l + L + A / 2, w = 0;
                                        !o && B.text && "bottom" === O && R <= 0 && (b += w = b / 2, g += w), F._hColorbarMoveTitle = w, F._hColorbarMoveCBTitle = g;
                                        var H = L + A, j = (o ? re : le) - H / 2 - (o ? C : 0), V = (o ? le : re) - (o ? Q : P + g - w);
                                        e.select("." + k.cbbg).attr("x", j).attr("y", V).attr(o ? "width" : "height", Math.max(b - w, 2)).attr(o ? "height" : "width", Math.max(Q + H, 2)).call(p.fill, S).call(p.stroke, t.bordercolor).style("stroke-width", L);
                                        var U = v ? Math.max(c - 10, 0) : 0;
                                        e.selectAll("." + k.cboutline).attr("x", (o ? re : le + C) + U).attr("y", (o ? le + P - Q : re) + (f ? xe : 0)).attr(o ? "width" : "height", Math.max(J, 2)).attr(o ? "height" : "width", Math.max(Q - (o ? 2 * P + xe : 2 * C + U), 2)).call(p.stroke, t.outlinecolor).style({
                                            fill: "none",
                                            "stroke-width": A
                                        });
                                        var q = o ? ne * b : 0, G = o ? 0 : (1 - ae) * b - g;
                                        if (q = N ? E.l - q : -q, G = z ? E.t - G : -G, e.attr("transform", u(q, G)), !o && (L || a(S).getAlpha() && !a.equals(F.paper_bgcolor, S))) {
                                            var Z = me.selectAll("text"), W = Z[0].length, X = e.select("." + k.cbbg).node(), K = h.bBox(X), $ = h.getTranslate(e);
                                            Z.each(function(e, t) {
                                                var r = W - 1;
                                                if (0 === t || t === r) {
                                                    var n, a = h.bBox(this), i = h.getTranslate(this);
                                                    if (t === r) {
                                                        var o = a.right + i.x;
                                                        (n = K.right + $.x + le - L - 2 + I - o) > 0 && (n = 0);
                                                    } else if (0 === t) {
                                                        var l = a.left + i.x;
                                                        (n = K.left + $.x + le + L + 2 - l) < 0 && (n = 0);
                                                    }
                                                    n && (W < 3 ? this.setAttribute("transform", "translate(" + n + ",0) " + this.getAttribute("transform")) : this.setAttribute("visibility", "hidden"));
                                                }
                                            });
                                        }
                                        var ee = {}, te = T[D], ie = M[D], oe = T[O], ue = M[O], fe = b - J;
                                        o ? ("pixels" === d ? (ee.y = R, ee.t = Q * oe, ee.b = Q * ue) : (ee.t = ee.b = 0, ee.yt = R + s * oe, ee.yb = R - s * ue), "pixels" === _ ? (ee.x = I, ee.l = b * te, ee.r = b * ie) : (ee.l = fe * te, ee.r = fe * ie, ee.xl = I - y * te, ee.xr = I + y * ie)) : ("pixels" === d ? (ee.x = I, ee.l = Q * te, ee.r = Q * ie) : (ee.l = ee.r = 0, ee.xl = I + s * te, ee.xr = I - s * ie), "pixels" === _ ? (ee.y = 1 - R, ee.t = b * oe, ee.b = b * ue) : (ee.t = fe * oe, ee.b = fe * ue, ee.yt = R - y * oe, ee.yb = R + y * ue));
                                        var de = t.y < .5 ? "b" : "t", he = t.x < .5 ? "l" : "r";
                                        r._fullLayout._reservedMargin[t._id] = {};
                                        var be = {
                                            r: F.width - j - q,
                                            l: j + ee.r,
                                            b: F.height - V - G,
                                            t: V + ee.b
                                        };
                                        N && z ? i.autoMargin(r, t._id, ee) : N ? r._fullLayout._reservedMargin[t._id][de] = be[de] : z || o ? r._fullLayout._reservedMargin[t._id][he] = be[he] : r._fullLayout._reservedMargin[t._id][de] = be[de];
                                    }
                                ], r);
                            }(r, t, e);
                            y && y.then && (e._promises || []).push(y), e._context.edits.colorbarPosition && function(e, t, r) {
                                var n, a, i, l = "v" === t.orientation, c = r._fullLayout._size;
                                s.init({
                                    element: e.node(),
                                    gd: r,
                                    prepFn: function() {
                                        n = e.attr("transform"), d(e);
                                    },
                                    moveFn: function(r, o) {
                                        e.attr("transform", n + u(r, o)), a = s.align((l ? t._uFrac : t._vFrac) + r / c.w, l ? t._thickFrac : t._lenFrac, 0, 1, t.xanchor), i = s.align((l ? t._vFrac : 1 - t._uFrac) - o / c.h, l ? t._lenFrac : t._thickFrac, 0, 1, t.yanchor);
                                        var f = s.getCursor(a, i, t.xanchor, t.yanchor);
                                        d(e, f);
                                    },
                                    doneFn: function() {
                                        if (d(e), void 0 !== a && void 0 !== i) {
                                            var n = {};
                                            n[t._propPrefix + "x"] = a, n[t._propPrefix + "y"] = i, void 0 !== t._traceIndex ? o.call("_guiRestyle", r, n, t._traceIndex) : o.call("_guiRelayout", r, n);
                                        }
                                    }
                                });
                            }(r, t, e);
                        }), t.exit().each(function(t) {
                            i.autoMargin(e, t._id);
                        }).remove(), t.order();
                    }
                };
            },
            6228: function(e, t, r) {
                "use strict";
                var n = r(1828);
                e.exports = function(e) {
                    return n.isPlainObject(e.colorbar);
                };
            },
            2311: function(e, t, r) {
                "use strict";
                e.exports = {
                    moduleType: "component",
                    name: "colorbar",
                    attributes: r(3583),
                    supplyDefaults: r(2499),
                    draw: r(8981).draw,
                    hasColorbar: r(6228)
                };
            },
            693: function(e, t, r) {
                "use strict";
                var n = r(3583), a = r(587).counter, i = r(8607), o = r(3282).scales;
                function l(e) {
                    return "`" + e + "`";
                }
                i(o), e.exports = function(e, t) {
                    e = e || "";
                    var r, i = (t = t || {}).cLetter || "c", s = ("onlyIfNumerical" in t ? t.onlyIfNumerical : Boolean(e), "noScale" in t ? t.noScale : "marker.line" === e), c = "showScaleDflt" in t ? t.showScaleDflt : "z" === i, u = "string" == typeof t.colorscaleDflt ? o[t.colorscaleDflt] : null, f = t.editTypeOverride || "", d = e ? e + "." : "";
                    "colorAttr" in t ? (r = t.colorAttr, t.colorAttr) : l(d + (r = ({
                        z: "z",
                        c: "color"
                    })[i]));
                    var h = i + "auto", p = i + "min", v = i + "max", g = i + "mid", y = (l(d + h), l(d + p), l(d + v), {});
                    y[p] = y[v] = void 0;
                    var m = {};
                    m[h] = !1;
                    var x = {};
                    return "color" === r && (x.color = {
                        valType: "color",
                        arrayOk: !0,
                        editType: f || "style"
                    }, t.anim && (x.color.anim = !0)), x[h] = {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc",
                        impliedEdits: y
                    }, x[p] = {
                        valType: "number",
                        dflt: null,
                        editType: f || "plot",
                        impliedEdits: m
                    }, x[v] = {
                        valType: "number",
                        dflt: null,
                        editType: f || "plot",
                        impliedEdits: m
                    }, x[g] = {
                        valType: "number",
                        dflt: null,
                        editType: "calc",
                        impliedEdits: y
                    }, x.colorscale = {
                        valType: "colorscale",
                        editType: "calc",
                        dflt: u,
                        impliedEdits: {
                            autocolorscale: !1
                        }
                    }, x.autocolorscale = {
                        valType: "boolean",
                        dflt: !1 !== t.autoColorDflt,
                        editType: "calc",
                        impliedEdits: {
                            colorscale: void 0
                        }
                    }, x.reversescale = {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    }, s || (x.showscale = {
                        valType: "boolean",
                        dflt: c,
                        editType: "calc"
                    }, x.colorbar = n), t.noColorAxis || (x.coloraxis = {
                        valType: "subplotid",
                        regex: a("coloraxis"),
                        dflt: null,
                        editType: "calc"
                    }), x;
                };
            },
            8803: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(1828), i = r(2869).extractOpts;
                e.exports = function(e, t, r) {
                    var o, l = e._fullLayout, s = r.vals, c = r.containerStr, u = c ? a.nestedProperty(t, c).get() : t, f = i(u), d = !1 !== f.auto, h = f.min, p = f.max, v = f.mid, g = function() {
                        return a.aggNums(Math.min, null, s);
                    }, y = function() {
                        return a.aggNums(Math.max, null, s);
                    };
                    void 0 === h ? h = g() : d && (h = u._colorAx && n(h) ? Math.min(h, g()) : g()), void 0 === p ? p = y() : d && (p = u._colorAx && n(p) ? Math.max(p, y()) : y()), d && void 0 !== v && (p - v > v - h ? h = v - (p - v) : p - v < v - h && (p = v + (v - h))), h === p && (h -= .5, p += .5), f._sync("min", h), f._sync("max", p), f.autocolorscale && (o = h * p < 0 ? l.colorscale.diverging : h >= 0 ? l.colorscale.sequential : l.colorscale.sequentialminus, f._sync("colorscale", o));
                };
            },
            3046: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(2869).hasColorscale, i = r(2869).extractOpts;
                e.exports = function(e, t) {
                    function r(e, t) {
                        var r = e["_" + t];
                        void 0 !== r && (e[t] = r);
                    }
                    function o(e, a) {
                        var o = a.container ? n.nestedProperty(e, a.container).get() : e;
                        if (o) {
                            if (o.coloraxis) o._colorAx = t[o.coloraxis];
                            else {
                                var l = i(o), s = l.auto;
                                (s || void 0 === l.min) && r(o, a.min), (s || void 0 === l.max) && r(o, a.max), l.autocolorscale && r(o, "colorscale");
                            }
                        }
                    }
                    for(var l = 0; l < e.length; l++){
                        var s = e[l], c = s._module.colorbar;
                        if (c) {
                            if (Array.isArray(c)) for(var u = 0; u < c.length; u++)o(s, c[u]);
                            else o(s, c);
                        }
                        a(s, "marker.line") && o(s, {
                            container: "marker.line",
                            min: "cmin",
                            max: "cmax"
                        });
                    }
                    for(var f in t._colorAxes)o(t[f], {
                        min: "cmin",
                        max: "cmax"
                    });
                };
            },
            1586: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(1828), i = r(6228), o = r(2499), l = r(3282).isValid, s = r(3972).traceIs;
                function c(e, t) {
                    var r = t.slice(0, t.length - 1);
                    return t ? a.nestedProperty(e, r).get() || {} : e;
                }
                e.exports = function e(t, r, u, f, d) {
                    var h = d.prefix, p = d.cLetter, v = "_module" in r, g = c(t, h), y = c(r, h), m = c(r._template || {}, h) || {}, x = function() {
                        return delete t.coloraxis, delete r.coloraxis, e(t, r, u, f, d);
                    };
                    if (v) {
                        var b = u._colorAxes || {}, _ = f(h + "coloraxis");
                        if (_) {
                            var w = s(r, "contour") && a.nestedProperty(r, "contours.coloring").get() || "heatmap", T = b[_];
                            return void (T ? (T[2].push(x), T[0] !== w && (T[0] = !1, a.warn([
                                "Ignoring coloraxis:",
                                _,
                                "setting",
                                "as it is linked to incompatible colorscales."
                            ].join(" ")))) : b[_] = [
                                w,
                                r,
                                [
                                    x
                                ]
                            ]);
                        }
                    }
                    var M = g[p + "min"], k = g[p + "max"], A = n(M) && n(k) && M < k;
                    f(h + p + "auto", !A) ? f(h + p + "mid") : (f(h + p + "min"), f(h + p + "max"));
                    var L, S, D = g.colorscale, O = m.colorscale;
                    void 0 !== D && (L = !l(D)), void 0 !== O && (L = !l(O)), f(h + "autocolorscale", L), f(h + "colorscale"), f(h + "reversescale"), "marker.line." !== h && (h && v && (S = i(g)), f(h + "showscale", S) && (h && m && (y._template = m), o(g, y, u)));
                };
            },
            2869: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(4267), i = r(2770), o = r(1828), l = r(7901), s = r(3282).isValid, c = [
                    "showscale",
                    "autocolorscale",
                    "colorscale",
                    "reversescale",
                    "colorbar"
                ], u = [
                    "min",
                    "max",
                    "mid",
                    "auto"
                ];
                function f(e) {
                    var t, r, n, a = e._colorAx, i = a || e, o = {};
                    for(r = 0; r < c.length; r++)o[n = c[r]] = i[n];
                    if (a) for(t = "c", r = 0; r < u.length; r++)o[n = u[r]] = i["c" + n];
                    else {
                        var l;
                        for(r = 0; r < u.length; r++)((l = "c" + (n = u[r])) in i || (l = "z" + n) in i) && (o[n] = i[l]);
                        t = l.charAt(0);
                    }
                    return o._sync = function(e, r) {
                        var n = -1 !== u.indexOf(e) ? t + e : e;
                        i[n] = i["_" + n] = r;
                    }, o;
                }
                function d(e) {
                    for(var t = f(e), r = t.min, n = t.max, a = t.reversescale ? h(t.colorscale) : t.colorscale, i = a.length, o = new Array(i), l = new Array(i), s = 0; s < i; s++){
                        var c = a[s];
                        o[s] = r + c[0] * (n - r), l[s] = c[1];
                    }
                    return {
                        domain: o,
                        range: l
                    };
                }
                function h(e) {
                    for(var t = e.length, r = new Array(t), n = t - 1, a = 0; n >= 0; n--, a++){
                        var i = e[n];
                        r[a] = [
                            1 - i[0],
                            i[1]
                        ];
                    }
                    return r;
                }
                function p(e, t) {
                    t = t || {};
                    for(var r = e.domain, o = e.range, s = o.length, c = new Array(s), u = 0; u < s; u++){
                        var f = a(o[u]).toRgb();
                        c[u] = [
                            f.r,
                            f.g,
                            f.b,
                            f.a
                        ];
                    }
                    var d, h = n.scale.linear().domain(r).range(c).clamp(!0), p = t.noNumericCheck, g = t.returnArray;
                    return (d = p && g ? h : p ? function(e) {
                        return v(h(e));
                    } : g ? function(e) {
                        return i(e) ? h(e) : a(e).isValid() ? e : l.defaultLine;
                    } : function(e) {
                        return i(e) ? v(h(e)) : a(e).isValid() ? e : l.defaultLine;
                    }).domain = h.domain, d.range = function() {
                        return o;
                    }, d;
                }
                function v(e) {
                    var t = {
                        r: e[0],
                        g: e[1],
                        b: e[2],
                        a: e[3]
                    };
                    return a(t).toRgbString();
                }
                e.exports = {
                    hasColorscale: function(e, t, r) {
                        var n = t ? o.nestedProperty(e, t).get() || {} : e, a = n[r || "color"], l = !1;
                        if (o.isArrayOrTypedArray(a)) {
                            for(var c = 0; c < a.length; c++)if (i(a[c])) {
                                l = !0;
                                break;
                            }
                        }
                        return o.isPlainObject(n) && (l || !0 === n.showscale || i(n.cmin) && i(n.cmax) || s(n.colorscale) || o.isPlainObject(n.colorbar));
                    },
                    extractOpts: f,
                    extractScale: d,
                    flipScale: h,
                    makeColorScaleFunc: p,
                    makeColorScaleFuncFromTrace: function(e, t) {
                        return p(d(e), t);
                    }
                };
            },
            1081: function(e, t, r) {
                "use strict";
                var n = r(3282), a = r(2869);
                e.exports = {
                    moduleType: "component",
                    name: "colorscale",
                    attributes: r(693),
                    layoutAttributes: r(2673),
                    supplyLayoutDefaults: r(959),
                    handleDefaults: r(1586),
                    crossTraceDefaults: r(3046),
                    calc: r(8803),
                    scales: n.scales,
                    defaultScale: n.defaultScale,
                    getScale: n.get,
                    isValidScale: n.isValid,
                    hasColorscale: a.hasColorscale,
                    extractOpts: a.extractOpts,
                    extractScale: a.extractScale,
                    flipScale: a.flipScale,
                    makeColorScaleFunc: a.makeColorScaleFunc,
                    makeColorScaleFuncFromTrace: a.makeColorScaleFuncFromTrace
                };
            },
            2673: function(e, t, r) {
                "use strict";
                var n = r(1426).extendFlat, a = r(693), i = r(3282).scales;
                e.exports = {
                    editType: "calc",
                    colorscale: {
                        editType: "calc",
                        sequential: {
                            valType: "colorscale",
                            dflt: i.Reds,
                            editType: "calc"
                        },
                        sequentialminus: {
                            valType: "colorscale",
                            dflt: i.Blues,
                            editType: "calc"
                        },
                        diverging: {
                            valType: "colorscale",
                            dflt: i.RdBu,
                            editType: "calc"
                        }
                    },
                    coloraxis: n({
                        _isSubplotObj: !0,
                        editType: "calc"
                    }, a("", {
                        colorAttr: "corresponding trace color array(s)",
                        noColorAxis: !0,
                        showScaleDflt: !0
                    }))
                };
            },
            959: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(4467), i = r(2673), o = r(1586);
                e.exports = function(e, t) {
                    function r(r, a) {
                        return n.coerce(e, t, i, r, a);
                    }
                    r("colorscale.sequential"), r("colorscale.sequentialminus"), r("colorscale.diverging");
                    var l, s, c = t._colorAxes;
                    function u(e, t) {
                        return n.coerce(l, s, i.coloraxis, e, t);
                    }
                    for(var f in c){
                        var d = c[f];
                        if (d[0]) l = e[f] || {}, (s = a.newContainer(t, f, "coloraxis"))._name = f, o(l, s, t, u, {
                            prefix: "",
                            cLetter: "c"
                        });
                        else {
                            for(var h = 0; h < d[2].length; h++)d[2][h]();
                            delete t._colorAxes[f];
                        }
                    }
                };
            },
            3282: function(e, t, r) {
                "use strict";
                var n = r(4267), a = {
                    Greys: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            1,
                            "rgb(255,255,255)"
                        ]
                    ],
                    YlGnBu: [
                        [
                            0,
                            "rgb(8,29,88)"
                        ],
                        [
                            .125,
                            "rgb(37,52,148)"
                        ],
                        [
                            .25,
                            "rgb(34,94,168)"
                        ],
                        [
                            .375,
                            "rgb(29,145,192)"
                        ],
                        [
                            .5,
                            "rgb(65,182,196)"
                        ],
                        [
                            .625,
                            "rgb(127,205,187)"
                        ],
                        [
                            .75,
                            "rgb(199,233,180)"
                        ],
                        [
                            .875,
                            "rgb(237,248,217)"
                        ],
                        [
                            1,
                            "rgb(255,255,217)"
                        ]
                    ],
                    Greens: [
                        [
                            0,
                            "rgb(0,68,27)"
                        ],
                        [
                            .125,
                            "rgb(0,109,44)"
                        ],
                        [
                            .25,
                            "rgb(35,139,69)"
                        ],
                        [
                            .375,
                            "rgb(65,171,93)"
                        ],
                        [
                            .5,
                            "rgb(116,196,118)"
                        ],
                        [
                            .625,
                            "rgb(161,217,155)"
                        ],
                        [
                            .75,
                            "rgb(199,233,192)"
                        ],
                        [
                            .875,
                            "rgb(229,245,224)"
                        ],
                        [
                            1,
                            "rgb(247,252,245)"
                        ]
                    ],
                    YlOrRd: [
                        [
                            0,
                            "rgb(128,0,38)"
                        ],
                        [
                            .125,
                            "rgb(189,0,38)"
                        ],
                        [
                            .25,
                            "rgb(227,26,28)"
                        ],
                        [
                            .375,
                            "rgb(252,78,42)"
                        ],
                        [
                            .5,
                            "rgb(253,141,60)"
                        ],
                        [
                            .625,
                            "rgb(254,178,76)"
                        ],
                        [
                            .75,
                            "rgb(254,217,118)"
                        ],
                        [
                            .875,
                            "rgb(255,237,160)"
                        ],
                        [
                            1,
                            "rgb(255,255,204)"
                        ]
                    ],
                    Bluered: [
                        [
                            0,
                            "rgb(0,0,255)"
                        ],
                        [
                            1,
                            "rgb(255,0,0)"
                        ]
                    ],
                    RdBu: [
                        [
                            0,
                            "rgb(5,10,172)"
                        ],
                        [
                            .35,
                            "rgb(106,137,247)"
                        ],
                        [
                            .5,
                            "rgb(190,190,190)"
                        ],
                        [
                            .6,
                            "rgb(220,170,132)"
                        ],
                        [
                            .7,
                            "rgb(230,145,90)"
                        ],
                        [
                            1,
                            "rgb(178,10,28)"
                        ]
                    ],
                    Reds: [
                        [
                            0,
                            "rgb(220,220,220)"
                        ],
                        [
                            .2,
                            "rgb(245,195,157)"
                        ],
                        [
                            .4,
                            "rgb(245,160,105)"
                        ],
                        [
                            1,
                            "rgb(178,10,28)"
                        ]
                    ],
                    Blues: [
                        [
                            0,
                            "rgb(5,10,172)"
                        ],
                        [
                            .35,
                            "rgb(40,60,190)"
                        ],
                        [
                            .5,
                            "rgb(70,100,245)"
                        ],
                        [
                            .6,
                            "rgb(90,120,245)"
                        ],
                        [
                            .7,
                            "rgb(106,137,247)"
                        ],
                        [
                            1,
                            "rgb(220,220,220)"
                        ]
                    ],
                    Picnic: [
                        [
                            0,
                            "rgb(0,0,255)"
                        ],
                        [
                            .1,
                            "rgb(51,153,255)"
                        ],
                        [
                            .2,
                            "rgb(102,204,255)"
                        ],
                        [
                            .3,
                            "rgb(153,204,255)"
                        ],
                        [
                            .4,
                            "rgb(204,204,255)"
                        ],
                        [
                            .5,
                            "rgb(255,255,255)"
                        ],
                        [
                            .6,
                            "rgb(255,204,255)"
                        ],
                        [
                            .7,
                            "rgb(255,153,255)"
                        ],
                        [
                            .8,
                            "rgb(255,102,204)"
                        ],
                        [
                            .9,
                            "rgb(255,102,102)"
                        ],
                        [
                            1,
                            "rgb(255,0,0)"
                        ]
                    ],
                    Rainbow: [
                        [
                            0,
                            "rgb(150,0,90)"
                        ],
                        [
                            .125,
                            "rgb(0,0,200)"
                        ],
                        [
                            .25,
                            "rgb(0,25,255)"
                        ],
                        [
                            .375,
                            "rgb(0,152,255)"
                        ],
                        [
                            .5,
                            "rgb(44,255,150)"
                        ],
                        [
                            .625,
                            "rgb(151,255,0)"
                        ],
                        [
                            .75,
                            "rgb(255,234,0)"
                        ],
                        [
                            .875,
                            "rgb(255,111,0)"
                        ],
                        [
                            1,
                            "rgb(255,0,0)"
                        ]
                    ],
                    Portland: [
                        [
                            0,
                            "rgb(12,51,131)"
                        ],
                        [
                            .25,
                            "rgb(10,136,186)"
                        ],
                        [
                            .5,
                            "rgb(242,211,56)"
                        ],
                        [
                            .75,
                            "rgb(242,143,56)"
                        ],
                        [
                            1,
                            "rgb(217,30,30)"
                        ]
                    ],
                    Jet: [
                        [
                            0,
                            "rgb(0,0,131)"
                        ],
                        [
                            .125,
                            "rgb(0,60,170)"
                        ],
                        [
                            .375,
                            "rgb(5,255,255)"
                        ],
                        [
                            .625,
                            "rgb(255,255,0)"
                        ],
                        [
                            .875,
                            "rgb(250,0,0)"
                        ],
                        [
                            1,
                            "rgb(128,0,0)"
                        ]
                    ],
                    Hot: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            .3,
                            "rgb(230,0,0)"
                        ],
                        [
                            .6,
                            "rgb(255,210,0)"
                        ],
                        [
                            1,
                            "rgb(255,255,255)"
                        ]
                    ],
                    Blackbody: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            .2,
                            "rgb(230,0,0)"
                        ],
                        [
                            .4,
                            "rgb(230,210,0)"
                        ],
                        [
                            .7,
                            "rgb(255,255,255)"
                        ],
                        [
                            1,
                            "rgb(160,200,255)"
                        ]
                    ],
                    Earth: [
                        [
                            0,
                            "rgb(0,0,130)"
                        ],
                        [
                            .1,
                            "rgb(0,180,180)"
                        ],
                        [
                            .2,
                            "rgb(40,210,40)"
                        ],
                        [
                            .4,
                            "rgb(230,230,50)"
                        ],
                        [
                            .6,
                            "rgb(120,70,20)"
                        ],
                        [
                            1,
                            "rgb(255,255,255)"
                        ]
                    ],
                    Electric: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            .15,
                            "rgb(30,0,100)"
                        ],
                        [
                            .4,
                            "rgb(120,0,100)"
                        ],
                        [
                            .6,
                            "rgb(160,90,0)"
                        ],
                        [
                            .8,
                            "rgb(230,200,0)"
                        ],
                        [
                            1,
                            "rgb(255,250,220)"
                        ]
                    ],
                    Viridis: [
                        [
                            0,
                            "#440154"
                        ],
                        [
                            .06274509803921569,
                            "#48186a"
                        ],
                        [
                            .12549019607843137,
                            "#472d7b"
                        ],
                        [
                            .18823529411764706,
                            "#424086"
                        ],
                        [
                            .25098039215686274,
                            "#3b528b"
                        ],
                        [
                            .3137254901960784,
                            "#33638d"
                        ],
                        [
                            .3764705882352941,
                            "#2c728e"
                        ],
                        [
                            .4392156862745098,
                            "#26828e"
                        ],
                        [
                            .5019607843137255,
                            "#21918c"
                        ],
                        [
                            .5647058823529412,
                            "#1fa088"
                        ],
                        [
                            .6274509803921569,
                            "#28ae80"
                        ],
                        [
                            .6901960784313725,
                            "#3fbc73"
                        ],
                        [
                            .7529411764705882,
                            "#5ec962"
                        ],
                        [
                            .8156862745098039,
                            "#84d44b"
                        ],
                        [
                            .8784313725490196,
                            "#addc30"
                        ],
                        [
                            .9411764705882353,
                            "#d8e219"
                        ],
                        [
                            1,
                            "#fde725"
                        ]
                    ],
                    Cividis: [
                        [
                            0,
                            "rgb(0,32,76)"
                        ],
                        [
                            .058824,
                            "rgb(0,42,102)"
                        ],
                        [
                            .117647,
                            "rgb(0,52,110)"
                        ],
                        [
                            .176471,
                            "rgb(39,63,108)"
                        ],
                        [
                            .235294,
                            "rgb(60,74,107)"
                        ],
                        [
                            .294118,
                            "rgb(76,85,107)"
                        ],
                        [
                            .352941,
                            "rgb(91,95,109)"
                        ],
                        [
                            .411765,
                            "rgb(104,106,112)"
                        ],
                        [
                            .470588,
                            "rgb(117,117,117)"
                        ],
                        [
                            .529412,
                            "rgb(131,129,120)"
                        ],
                        [
                            .588235,
                            "rgb(146,140,120)"
                        ],
                        [
                            .647059,
                            "rgb(161,152,118)"
                        ],
                        [
                            .705882,
                            "rgb(176,165,114)"
                        ],
                        [
                            .764706,
                            "rgb(192,177,109)"
                        ],
                        [
                            .823529,
                            "rgb(209,191,102)"
                        ],
                        [
                            .882353,
                            "rgb(225,204,92)"
                        ],
                        [
                            .941176,
                            "rgb(243,219,79)"
                        ],
                        [
                            1,
                            "rgb(255,233,69)"
                        ]
                    ]
                }, i = a.RdBu;
                function o(e) {
                    var t = 0;
                    if (!Array.isArray(e) || e.length < 2) return !1;
                    if (!e[0] || !e[e.length - 1]) return !1;
                    if (0 != +e[0][0] || 1 != +e[e.length - 1][0]) return !1;
                    for(var r = 0; r < e.length; r++){
                        var a = e[r];
                        if (2 !== a.length || +a[0] < t || !n(a[1]).isValid()) return !1;
                        t = +a[0];
                    }
                    return !0;
                }
                e.exports = {
                    scales: a,
                    defaultScale: i,
                    get: function(e, t) {
                        if (t || (t = i), !e) return t;
                        function r() {
                            try {
                                e = a[e] || JSON.parse(e);
                            } catch (r) {
                                e = t;
                            }
                        }
                        return "string" == typeof e && (r(), "string" == typeof e && r()), o(e) ? e : t;
                    },
                    isValid: function(e) {
                        return void 0 !== a[e] || o(e);
                    }
                };
            },
            2807: function(e) {
                "use strict";
                e.exports = function(e, t, r, n, a) {
                    var i = (e - r) / (n - r), o = i + t / (n - r), l = (i + o) / 2;
                    return "left" === a || "bottom" === a ? i : "center" === a || "middle" === a ? l : "right" === a || "top" === a ? o : i < 2 / 3 - l ? i : o > 4 / 3 - l ? o : l;
                };
            },
            461: function(e, t, r) {
                "use strict";
                var n = r(1828), a = [
                    [
                        "sw-resize",
                        "s-resize",
                        "se-resize"
                    ],
                    [
                        "w-resize",
                        "move",
                        "e-resize"
                    ],
                    [
                        "nw-resize",
                        "n-resize",
                        "ne-resize"
                    ]
                ];
                e.exports = function(e, t, r, i) {
                    return e = "left" === r ? 0 : "center" === r ? 1 : "right" === r ? 2 : n.constrain(Math.floor(3 * e), 0, 2), t = "bottom" === i ? 0 : "middle" === i ? 1 : "top" === i ? 2 : n.constrain(Math.floor(3 * t), 0, 2), a[t][e];
                };
            },
            4505: function(e, t) {
                "use strict";
                t.selectMode = function(e) {
                    return "lasso" === e || "select" === e;
                }, t.drawMode = function(e) {
                    return "drawclosedpath" === e || "drawopenpath" === e || "drawline" === e || "drawrect" === e || "drawcircle" === e;
                }, t.openMode = function(e) {
                    return "drawline" === e || "drawopenpath" === e;
                }, t.rectMode = function(e) {
                    return "select" === e || "drawline" === e || "drawrect" === e || "drawcircle" === e;
                }, t.freeMode = function(e) {
                    return "lasso" === e || "drawclosedpath" === e || "drawopenpath" === e;
                }, t.selectingOrDrawing = function(e) {
                    return t.freeMode(e) || t.rectMode(e);
                };
            },
            8569: function(e, t, r) {
                "use strict";
                var n = r(8956), a = r(7035), i = r(8520), o = r(1828).removeElement, l = r(5555), s = e.exports = {};
                s.align = r(2807), s.getCursor = r(461);
                var c = r(6041);
                function u() {
                    var e = document.createElement("div");
                    e.className = "dragcover";
                    var t = e.style;
                    return t.position = "fixed", t.left = 0, t.right = 0, t.top = 0, t.bottom = 0, t.zIndex = 999999999, t.background = "none", document.body.appendChild(e), e;
                }
                function f(e) {
                    return n(e.changedTouches ? e.changedTouches[0] : e, document.body);
                }
                s.unhover = c.wrapped, s.unhoverRaw = c.raw, s.init = function(e) {
                    var t, r, n, c, d, h, p, v, g = e.gd, y = 1, m = g._context.doubleClickDelay, x = e.element;
                    g._mouseDownTime || (g._mouseDownTime = 0), x.style.pointerEvents = "all", x.onmousedown = _, i ? (x._ontouchstart && x.removeEventListener("touchstart", x._ontouchstart), x._ontouchstart = _, x.addEventListener("touchstart", _, {
                        passive: !1
                    })) : x.ontouchstart = _;
                    var b = e.clampFn || function(e, t, r) {
                        return Math.abs(e) < r && (e = 0), Math.abs(t) < r && (t = 0), [
                            e,
                            t
                        ];
                    };
                    function _(i) {
                        g._dragged = !1, g._dragging = !0;
                        var o = f(i);
                        t = o[0], r = o[1], p = i.target, h = i, v = 2 === i.buttons || i.ctrlKey, void 0 === i.clientX && void 0 === i.clientY && (i.clientX = t, i.clientY = r), (n = (new Date).getTime()) - g._mouseDownTime < m ? y += 1 : (y = 1, g._mouseDownTime = n), e.prepFn && e.prepFn(i, t, r), a && !v ? (d = u()).style.cursor = window.getComputedStyle(x).cursor : a || (d = document, c = window.getComputedStyle(document.documentElement).cursor, document.documentElement.style.cursor = window.getComputedStyle(x).cursor), document.addEventListener("mouseup", T), document.addEventListener("touchend", T), !1 !== e.dragmode && (i.preventDefault(), document.addEventListener("mousemove", w), document.addEventListener("touchmove", w, {
                            passive: !1
                        }));
                    }
                    function w(n) {
                        n.preventDefault();
                        var a = f(n), i = e.minDrag || l.MINDRAG, o = b(a[0] - t, a[1] - r, i), c = o[0], u = o[1];
                        (c || u) && (g._dragged = !0, s.unhover(g, n)), g._dragged && e.moveFn && !v && (g._dragdata = {
                            element: x,
                            dx: c,
                            dy: u
                        }, e.moveFn(c, u));
                    }
                    function T(t) {
                        if (delete g._dragdata, !1 !== e.dragmode && (t.preventDefault(), document.removeEventListener("mousemove", w), document.removeEventListener("touchmove", w)), document.removeEventListener("mouseup", T), document.removeEventListener("touchend", T), a ? o(d) : c && (d.documentElement.style.cursor = c, c = null), g._dragging) {
                            if (g._dragging = !1, (new Date).getTime() - g._mouseDownTime > m && (y = Math.max(y - 1, 1)), g._dragged) e.doneFn && e.doneFn();
                            else if (e.clickFn && e.clickFn(y, h), !v) {
                                var r;
                                try {
                                    r = new MouseEvent("click", t);
                                } catch (e) {
                                    var n = f(t);
                                    (r = document.createEvent("MouseEvents")).initMouseEvent("click", t.bubbles, t.cancelable, t.view, t.detail, t.screenX, t.screenY, n[0], n[1], t.ctrlKey, t.altKey, t.shiftKey, t.metaKey, t.button, t.relatedTarget);
                                }
                                p.dispatchEvent(r);
                            }
                            g._dragging = !1, g._dragged = !1;
                        } else g._dragged = !1;
                    }
                }, s.coverSlip = u;
            },
            6041: function(e, t, r) {
                "use strict";
                var n = r(1086), a = r(9990), i = r(4401).getGraphDiv, o = r(6675), l = e.exports = {};
                l.wrapped = function(e, t, r) {
                    (e = i(e))._fullLayout && a.clear(e._fullLayout._uid + o.HOVERID), l.raw(e, t, r);
                }, l.raw = function(e, t) {
                    var r = e._fullLayout, a = e._hoverdata;
                    t || (t = {}), t.target && !e._dragged && !1 === n.triggerHandler(e, "plotly_beforehover", t) || (r._hoverlayer.selectAll("g").remove(), r._hoverlayer.selectAll("line").remove(), r._hoverlayer.selectAll("circle").remove(), e._hoverdata = void 0, t.target && a && e.emit("plotly_unhover", {
                        event: t,
                        points: a
                    }));
                };
            },
            9952: function(e, t) {
                "use strict";
                t.P = {
                    valType: "string",
                    values: [
                        "solid",
                        "dot",
                        "dash",
                        "longdash",
                        "dashdot",
                        "longdashdot"
                    ],
                    dflt: "solid",
                    editType: "style"
                }, t.u = {
                    shape: {
                        valType: "enumerated",
                        values: [
                            "",
                            "/",
                            "\\",
                            "x",
                            "-",
                            "|",
                            "+",
                            "."
                        ],
                        dflt: "",
                        arrayOk: !0,
                        editType: "style"
                    },
                    fillmode: {
                        valType: "enumerated",
                        values: [
                            "replace",
                            "overlay"
                        ],
                        dflt: "replace",
                        editType: "style"
                    },
                    bgcolor: {
                        valType: "color",
                        arrayOk: !0,
                        editType: "style"
                    },
                    fgcolor: {
                        valType: "color",
                        arrayOk: !0,
                        editType: "style"
                    },
                    fgopacity: {
                        valType: "number",
                        editType: "style",
                        min: 0,
                        max: 1
                    },
                    size: {
                        valType: "number",
                        min: 0,
                        dflt: 8,
                        arrayOk: !0,
                        editType: "style"
                    },
                    solidity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .3,
                        arrayOk: !0,
                        editType: "style"
                    },
                    editType: "style"
                };
            },
            1424: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(1828), i = a.numberFormat, o = r(2770), l = r(4267), s = r(3972), c = r(7901), u = r(1081), f = a.strTranslate, d = r(3893), h = r(7922), p = r(8783).LINE_SPACING, v = r(7822).DESELECTDIM, g = r(4098), y = r(9984), m = r(3469).appendArrayPointValue, x = e.exports = {};
                function b(e, t, r) {
                    var n = t.fillpattern, a = n && x.getPatternAttr(n.shape, 0, "");
                    if (a) {
                        var i = x.getPatternAttr(n.bgcolor, 0, null), o = x.getPatternAttr(n.fgcolor, 0, null), l = n.fgopacity, s = x.getPatternAttr(n.size, 0, 8), u = x.getPatternAttr(n.solidity, 0, .3), f = t.uid;
                        x.pattern(e, "point", r, f, a, s, u, void 0, n.fillmode, i, o, l);
                    } else t.fillcolor && e.call(c.fill, t.fillcolor);
                }
                x.font = function(e, t, r, n) {
                    a.isPlainObject(t) && (n = t.color, r = t.size, t = t.family), t && e.style("font-family", t), r + 1 && e.style("font-size", r + "px"), n && e.call(c.fill, n);
                }, x.setPosition = function(e, t, r) {
                    e.attr("x", t).attr("y", r);
                }, x.setSize = function(e, t, r) {
                    e.attr("width", t).attr("height", r);
                }, x.setRect = function(e, t, r, n, a) {
                    e.call(x.setPosition, t, r).call(x.setSize, n, a);
                }, x.translatePoint = function(e, t, r, n) {
                    var a = r.c2p(e.x), i = n.c2p(e.y);
                    return !!(o(a) && o(i) && t.node()) && ("text" === t.node().nodeName ? t.attr("x", a).attr("y", i) : t.attr("transform", f(a, i)), !0);
                }, x.translatePoints = function(e, t, r) {
                    e.each(function(e) {
                        var a = n.select(this);
                        x.translatePoint(e, a, t, r);
                    });
                }, x.hideOutsideRangePoint = function(e, t, r, n, a, i) {
                    t.attr("display", r.isPtWithinRange(e, a) && n.isPtWithinRange(e, i) ? null : "none");
                }, x.hideOutsideRangePoints = function(e, t) {
                    if (t._hasClipOnAxisFalse) {
                        var r = t.xaxis, a = t.yaxis;
                        e.each(function(t) {
                            var i = t[0].trace, o = i.xcalendar, l = i.ycalendar, c = s.traceIs(i, "bar-like") ? ".bartext" : ".point,.textpoint";
                            e.selectAll(c).each(function(e) {
                                x.hideOutsideRangePoint(e, n.select(this), r, a, o, l);
                            });
                        });
                    }
                }, x.crispRound = function(e, t, r) {
                    return t && o(t) ? e._context.staticPlot ? t : t < 1 ? 1 : Math.round(t) : r || 0;
                }, x.singleLineStyle = function(e, t, r, n, a) {
                    t.style("fill", "none");
                    var i = (((e || [])[0] || {}).trace || {}).line || {}, o = r || i.width || 0, l = a || i.dash || "";
                    c.stroke(t, n || i.color), x.dashLine(t, l, o);
                }, x.lineGroupStyle = function(e, t, r, a) {
                    e.style("fill", "none").each(function(e) {
                        var i = (((e || [])[0] || {}).trace || {}).line || {}, o = t || i.width || 0, l = a || i.dash || "";
                        n.select(this).call(c.stroke, r || i.color).call(x.dashLine, l, o);
                    });
                }, x.dashLine = function(e, t, r) {
                    r = +r || 0, t = x.dashStyle(t, r), e.style({
                        "stroke-dasharray": t,
                        "stroke-width": r + "px"
                    });
                }, x.dashStyle = function(e, t) {
                    t = +t || 1;
                    var r = Math.max(t, 3);
                    return "solid" === e ? e = "" : "dot" === e ? e = r + "px," + r + "px" : "dash" === e ? e = 3 * r + "px," + 3 * r + "px" : "longdash" === e ? e = 5 * r + "px," + 5 * r + "px" : "dashdot" === e ? e = 3 * r + "px," + r + "px," + r + "px," + r + "px" : "longdashdot" === e && (e = 5 * r + "px," + 2 * r + "px," + r + "px," + 2 * r + "px"), e;
                }, x.singleFillStyle = function(e, t) {
                    var r = n.select(e.node());
                    b(e, ((r.data()[0] || [])[0] || {}).trace || {}, t);
                }, x.fillGroupStyle = function(e, t) {
                    e.style("stroke-width", 0).each(function(e) {
                        var r = n.select(this);
                        e[0].trace && b(r, e[0].trace, t);
                    });
                };
                var _ = r(998);
                x.symbolNames = [], x.symbolFuncs = [], x.symbolBackOffs = [], x.symbolNeedLines = {}, x.symbolNoDot = {}, x.symbolNoFill = {}, x.symbolList = [], Object.keys(_).forEach(function(e) {
                    var t = _[e], r = t.n;
                    x.symbolList.push(r, String(r), e, r + 100, String(r + 100), e + "-open"), x.symbolNames[r] = e, x.symbolFuncs[r] = t.f, x.symbolBackOffs[r] = t.backoff || 0, t.needLine && (x.symbolNeedLines[r] = !0), t.noDot ? x.symbolNoDot[r] = !0 : x.symbolList.push(r + 200, String(r + 200), e + "-dot", r + 300, String(r + 300), e + "-open-dot"), t.noFill && (x.symbolNoFill[r] = !0);
                });
                var w = x.symbolNames.length;
                function T(e, t, r, n) {
                    var a = e % 100;
                    return x.symbolFuncs[a](t, r, n) + (e >= 200 ? "M0,0.5L0.5,0L0,-0.5L-0.5,0Z" : "");
                }
                x.symbolNumber = function(e) {
                    if (o(e)) e = +e;
                    else if ("string" == typeof e) {
                        var t = 0;
                        e.indexOf("-open") > 0 && (t = 100, e = e.replace("-open", "")), e.indexOf("-dot") > 0 && (t += 200, e = e.replace("-dot", "")), (e = x.symbolNames.indexOf(e)) >= 0 && (e += t);
                    }
                    return e % 100 >= w || e >= 400 ? 0 : Math.floor(Math.max(e, 0));
                };
                var M = {
                    x1: 1,
                    x2: 0,
                    y1: 0,
                    y2: 0
                }, k = {
                    x1: 0,
                    x2: 0,
                    y1: 1,
                    y2: 0
                }, A = i("~f"), L = {
                    radial: {
                        node: "radialGradient"
                    },
                    radialreversed: {
                        node: "radialGradient",
                        reversed: !0
                    },
                    horizontal: {
                        node: "linearGradient",
                        attrs: M
                    },
                    horizontalreversed: {
                        node: "linearGradient",
                        attrs: M,
                        reversed: !0
                    },
                    vertical: {
                        node: "linearGradient",
                        attrs: k
                    },
                    verticalreversed: {
                        node: "linearGradient",
                        attrs: k,
                        reversed: !0
                    }
                };
                x.gradient = function(e, t, r, i, o, s) {
                    for(var u = o.length, f = L[i], d = new Array(u), h = 0; h < u; h++)f.reversed ? d[u - 1 - h] = [
                        A(100 * (1 - o[h][0])),
                        o[h][1]
                    ] : d[h] = [
                        A(100 * o[h][0]),
                        o[h][1]
                    ];
                    var p = t._fullLayout, v = "g" + p._uid + "-" + r, g = p._defs.select(".gradients").selectAll("#" + v).data([
                        i + d.join(";")
                    ], a.identity);
                    g.exit().remove(), g.enter().append(f.node).each(function() {
                        var e = n.select(this);
                        f.attrs && e.attr(f.attrs), e.attr("id", v);
                        var t = e.selectAll("stop").data(d);
                        t.exit().remove(), t.enter().append("stop"), t.each(function(e) {
                            var t = l(e[1]);
                            n.select(this).attr({
                                offset: e[0] + "%",
                                "stop-color": c.tinyRGB(t),
                                "stop-opacity": t.getAlpha()
                            });
                        });
                    }), e.style(s, Y(v, t)).style(s + "-opacity", null), e.classed("gradient_filled", !0);
                }, x.pattern = function(e, t, r, i, o, s, u, f, d, h, p, v) {
                    var g = "legend" === t;
                    f && ("overlay" === d ? (h = f, p = c.contrast(h)) : (h = void 0, p = f));
                    var y, m, x, b, _, w, T, M, k, A = r._fullLayout, L = "p" + A._uid + "-" + i, S = {}, D = l(p), O = c.tinyRGB(D), C = v * D.getAlpha();
                    switch(o){
                        case "/":
                            y = s * Math.sqrt(2), m = s * Math.sqrt(2), w = "path", S = {
                                d: x = "M-" + y / 4 + "," + m / 4 + "l" + y / 2 + ",-" + m / 2 + "M0," + m + "L" + y + ",0M" + y / 4 * 3 + "," + m / 4 * 5 + "l" + y / 2 + ",-" + m / 2,
                                opacity: C,
                                stroke: O,
                                "stroke-width": (b = u * s) + "px"
                            };
                            break;
                        case "\\":
                            y = s * Math.sqrt(2), m = s * Math.sqrt(2), w = "path", S = {
                                d: x = "M" + y / 4 * 3 + ",-" + m / 4 + "l" + y / 2 + "," + m / 2 + "M0,0L" + y + "," + m + "M-" + y / 4 + "," + m / 4 * 3 + "l" + y / 2 + "," + m / 2,
                                opacity: C,
                                stroke: O,
                                "stroke-width": (b = u * s) + "px"
                            };
                            break;
                        case "x":
                            y = s * Math.sqrt(2), m = s * Math.sqrt(2), x = "M-" + y / 4 + "," + m / 4 + "l" + y / 2 + ",-" + m / 2 + "M0," + m + "L" + y + ",0M" + y / 4 * 3 + "," + m / 4 * 5 + "l" + y / 2 + ",-" + m / 2 + "M" + y / 4 * 3 + ",-" + m / 4 + "l" + y / 2 + "," + m / 2 + "M0,0L" + y + "," + m + "M-" + y / 4 + "," + m / 4 * 3 + "l" + y / 2 + "," + m / 2, b = s - s * Math.sqrt(1 - u), w = "path", S = {
                                d: x,
                                opacity: C,
                                stroke: O,
                                "stroke-width": b + "px"
                            };
                            break;
                        case "|":
                            w = "path", w = "path", S = {
                                d: x = "M" + (y = s) / 2 + ",0L" + y / 2 + "," + (m = s),
                                opacity: C,
                                stroke: O,
                                "stroke-width": (b = u * s) + "px"
                            };
                            break;
                        case "-":
                            w = "path", w = "path", S = {
                                d: x = "M0," + (m = s) / 2 + "L" + (y = s) + "," + m / 2,
                                opacity: C,
                                stroke: O,
                                "stroke-width": (b = u * s) + "px"
                            };
                            break;
                        case "+":
                            w = "path", x = "M" + (y = s) / 2 + ",0L" + y / 2 + "," + (m = s) + "M0," + m / 2 + "L" + y + "," + m / 2, b = s - s * Math.sqrt(1 - u), w = "path", S = {
                                d: x,
                                opacity: C,
                                stroke: O,
                                "stroke-width": b + "px"
                            };
                            break;
                        case ".":
                            y = s, m = s, u < Math.PI / 4 ? _ = Math.sqrt(u * s * s / Math.PI) : (T = u, M = Math.PI / 4, _ = (k = s / 2) + (s / Math.sqrt(2) - k) * (T - M) / (1 - M)), w = "circle", S = {
                                cx: y / 2,
                                cy: m / 2,
                                r: _,
                                opacity: C,
                                fill: O
                            };
                    }
                    var P = [
                        o || "noSh",
                        h || "noBg",
                        p || "noFg",
                        s,
                        u
                    ].join(";"), I = A._defs.select(".patterns").selectAll("#" + L).data([
                        P
                    ], a.identity);
                    I.exit().remove(), I.enter().append("pattern").each(function() {
                        var e = n.select(this);
                        if (e.attr({
                            id: L,
                            width: y + "px",
                            height: m + "px",
                            patternUnits: "userSpaceOnUse",
                            patternTransform: g ? "scale(0.8)" : ""
                        }), h) {
                            var t = l(h), r = c.tinyRGB(t), a = t.getAlpha(), i = e.selectAll("rect").data([
                                0
                            ]);
                            i.exit().remove(), i.enter().append("rect").attr({
                                width: y + "px",
                                height: m + "px",
                                fill: r,
                                "fill-opacity": a
                            });
                        }
                        var o = e.selectAll(w).data([
                            0
                        ]);
                        o.exit().remove(), o.enter().append(w).attr(S);
                    }), e.style("fill", Y(L, r)).style("fill-opacity", null), e.classed("pattern_filled", !0);
                }, x.initGradients = function(e) {
                    var t = e._fullLayout;
                    a.ensureSingle(t._defs, "g", "gradients").selectAll("linearGradient,radialGradient").remove(), n.select(e).selectAll(".gradient_filled").classed("gradient_filled", !1);
                }, x.initPatterns = function(e) {
                    var t = e._fullLayout;
                    a.ensureSingle(t._defs, "g", "patterns").selectAll("pattern").remove(), n.select(e).selectAll(".pattern_filled").classed("pattern_filled", !1);
                }, x.getPatternAttr = function(e, t, r) {
                    return e && a.isArrayOrTypedArray(e) ? t < e.length ? e[t] : r : e;
                }, x.pointStyle = function(e, t, r, a) {
                    if (e.size()) {
                        var i = x.makePointStyleFns(t);
                        e.each(function(e) {
                            x.singlePointStyle(e, n.select(this), t, i, r, a);
                        });
                    }
                }, x.singlePointStyle = function(e, t, r, n, i, o) {
                    var l = r.marker, s = l.line;
                    if (o && o.i >= 0 && void 0 === e.i && (e.i = o.i), t.style("opacity", n.selectedOpacityFn ? n.selectedOpacityFn(e) : void 0 === e.mo ? l.opacity : e.mo), n.ms2mrc) {
                        var u;
                        u = "various" === e.ms || "various" === l.size ? 3 : n.ms2mrc(e.ms), e.mrc = u, n.selectedSizeFn && (u = e.mrc = n.selectedSizeFn(e));
                        var f = x.symbolNumber(e.mx || l.symbol) || 0;
                        e.om = f % 200 >= 100;
                        var d = re(e, r), h = q(e, r);
                        t.attr("d", T(f, u, d, h));
                    }
                    var p, v, g, y = !1;
                    if (e.so) g = s.outlierwidth, v = s.outliercolor, p = l.outliercolor;
                    else {
                        var m = (s || {}).width;
                        g = (e.mlw + 1 || m + 1 || (e.trace ? (e.trace.marker.line || {}).width : 0) + 1) - 1 || 0, v = "mlc" in e ? e.mlcc = n.lineScale(e.mlc) : a.isArrayOrTypedArray(s.color) ? c.defaultLine : s.color, a.isArrayOrTypedArray(l.color) && (p = c.defaultLine, y = !0), p = "mc" in e ? e.mcc = n.markerScale(e.mc) : l.color || l.colors || "rgba(0,0,0,0)", n.selectedColorFn && (p = n.selectedColorFn(e));
                    }
                    if (e.om) t.call(c.stroke, p).style({
                        "stroke-width": (g || 1) + "px",
                        fill: "none"
                    });
                    else {
                        t.style("stroke-width", (e.isBlank ? 0 : g) + "px");
                        var b = l.gradient, _ = e.mgt;
                        _ ? y = !0 : _ = b && b.type, a.isArrayOrTypedArray(_) && (_ = _[0], L[_] || (_ = 0));
                        var w = l.pattern, M = w && x.getPatternAttr(w.shape, e.i, "");
                        if (_ && "none" !== _) {
                            var k = e.mgc;
                            k ? y = !0 : k = b.color;
                            var A = r.uid;
                            y && (A += "-" + e.i), x.gradient(t, i, A, _, [
                                [
                                    0,
                                    k
                                ],
                                [
                                    1,
                                    p
                                ]
                            ], "fill");
                        } else if (M) {
                            var S = !1, D = w.fgcolor;
                            !D && o && o.color && (D = o.color, S = !0);
                            var O = x.getPatternAttr(D, e.i, o && o.color || null), C = x.getPatternAttr(w.bgcolor, e.i, null), P = w.fgopacity, I = x.getPatternAttr(w.size, e.i, 8), R = x.getPatternAttr(w.solidity, e.i, .3);
                            S = S || e.mcc || a.isArrayOrTypedArray(w.shape) || a.isArrayOrTypedArray(w.bgcolor) || a.isArrayOrTypedArray(w.fgcolor) || a.isArrayOrTypedArray(w.size) || a.isArrayOrTypedArray(w.solidity);
                            var z = r.uid;
                            S && (z += "-" + e.i), x.pattern(t, "point", i, z, M, I, R, e.mcc, w.fillmode, C, O, P);
                        } else a.isArrayOrTypedArray(p) ? c.fill(t, p[e.i]) : c.fill(t, p);
                        g && c.stroke(t, v);
                    }
                }, x.makePointStyleFns = function(e) {
                    var t = {}, r = e.marker;
                    return t.markerScale = x.tryColorscale(r, ""), t.lineScale = x.tryColorscale(r, "line"), s.traceIs(e, "symbols") && (t.ms2mrc = g.isBubble(e) ? y(e) : function() {
                        return (r.size || 6) / 2;
                    }), e.selectedpoints && a.extendFlat(t, x.makeSelectedPointStyleFns(e)), t;
                }, x.makeSelectedPointStyleFns = function(e) {
                    var t = {}, r = e.selected || {}, n = e.unselected || {}, i = e.marker || {}, o = r.marker || {}, l = n.marker || {}, c = i.opacity, u = o.opacity, f = l.opacity, d = void 0 !== u, h = void 0 !== f;
                    (a.isArrayOrTypedArray(c) || d || h) && (t.selectedOpacityFn = function(e) {
                        var t = void 0 === e.mo ? i.opacity : e.mo;
                        return e.selected ? d ? u : t : h ? f : v * t;
                    });
                    var p = i.color, g = o.color, y = l.color;
                    (g || y) && (t.selectedColorFn = function(e) {
                        var t = e.mcc || p;
                        return e.selected ? g || t : y || t;
                    });
                    var m = i.size, x = o.size, b = l.size, _ = void 0 !== x, w = void 0 !== b;
                    return s.traceIs(e, "symbols") && (_ || w) && (t.selectedSizeFn = function(e) {
                        var t = e.mrc || m / 2;
                        return e.selected ? _ ? x / 2 : t : w ? b / 2 : t;
                    }), t;
                }, x.makeSelectedTextStyleFns = function(e) {
                    var t = {}, r = e.selected || {}, n = e.unselected || {}, a = e.textfont || {}, i = r.textfont || {}, o = n.textfont || {}, l = a.color, s = i.color, u = o.color;
                    return t.selectedTextColorFn = function(e) {
                        var t = e.tc || l;
                        return e.selected ? s || t : u || (s ? t : c.addOpacity(t, v));
                    }, t;
                }, x.selectedPointStyle = function(e, t) {
                    if (e.size() && t.selectedpoints) {
                        var r = x.makeSelectedPointStyleFns(t), a = t.marker || {}, i = [];
                        r.selectedOpacityFn && i.push(function(e, t) {
                            e.style("opacity", r.selectedOpacityFn(t));
                        }), r.selectedColorFn && i.push(function(e, t) {
                            c.fill(e, r.selectedColorFn(t));
                        }), r.selectedSizeFn && i.push(function(e, n) {
                            var i = n.mx || a.symbol || 0, o = r.selectedSizeFn(n);
                            e.attr("d", T(x.symbolNumber(i), o, re(n, t), q(n, t))), n.mrc2 = o;
                        }), i.length && e.each(function(e) {
                            for(var t = n.select(this), r = 0; r < i.length; r++)i[r](t, e);
                        });
                    }
                }, x.tryColorscale = function(e, t) {
                    var r = t ? a.nestedProperty(e, t).get() : e;
                    if (r) {
                        var n = r.color;
                        if ((r.colorscale || r._colorAx) && a.isArrayOrTypedArray(n)) return u.makeColorScaleFuncFromTrace(r);
                    }
                    return a.identity;
                };
                var S, D, O = {
                    start: 1,
                    end: -1,
                    middle: 0,
                    bottom: 1,
                    top: -1
                };
                function C(e, t, r, a, i) {
                    var o = n.select(e.node().parentNode), l = -1 !== t.indexOf("top") ? "top" : -1 !== t.indexOf("bottom") ? "bottom" : "middle", s = -1 !== t.indexOf("left") ? "end" : -1 !== t.indexOf("right") ? "start" : "middle", c = a ? a / .8 + 1 : 0, u = (d.lineCount(e) - 1) * p + 1, h = O[s] * c, v = .75 * r + O[l] * c + (O[l] - 1) * u * r / 2;
                    e.attr("text-anchor", s), i || o.attr("transform", f(h, v));
                }
                function P(e, t) {
                    var r = e.ts || t.textfont.size;
                    return o(r) && r > 0 ? r : 0;
                }
                function I(e, t, r) {
                    return r && (e = H(e)), t ? z(e[1]) : R(e[0]);
                }
                function R(e) {
                    var t = n.round(e, 2);
                    return S = t, t;
                }
                function z(e) {
                    var t = n.round(e, 2);
                    return D = t, t;
                }
                function N(e, t, r, n) {
                    var a = e[0] - t[0], i = e[1] - t[1], o = r[0] - t[0], l = r[1] - t[1], s = Math.pow(a * a + i * i, .25), c = Math.pow(o * o + l * l, .25), u = (c * c * a - s * s * o) * n, f = (c * c * i - s * s * l) * n, d = 3 * c * (s + c), h = 3 * s * (s + c);
                    return [
                        [
                            R(t[0] + (d && u / d)),
                            z(t[1] + (d && f / d))
                        ],
                        [
                            R(t[0] - (h && u / h)),
                            z(t[1] - (h && f / h))
                        ]
                    ];
                }
                x.textPointStyle = function(e, t, r) {
                    if (e.size()) {
                        var i;
                        if (t.selectedpoints) {
                            var o = x.makeSelectedTextStyleFns(t);
                            i = o.selectedTextColorFn;
                        }
                        var l = t.texttemplate, s = r._fullLayout;
                        e.each(function(e) {
                            var o = n.select(this), c = l ? a.extractOption(e, t, "txt", "texttemplate") : a.extractOption(e, t, "tx", "text");
                            if (c || 0 === c) {
                                if (l) {
                                    var u = t._module.formatLabels, f = u ? u(e, t, s) : {}, h = {};
                                    m(h, t, e.i);
                                    var p = t._meta || {};
                                    c = a.texttemplateString(c, f, s._d3locale, h, e, p);
                                }
                                var v = e.tp || t.textposition, g = P(e, t), y = i ? i(e) : e.tc || t.textfont.color;
                                o.call(x.font, e.tf || t.textfont.family, g, y).text(c).call(d.convertToTspans, r).call(C, v, g, e.mrc);
                            } else o.remove();
                        });
                    }
                }, x.selectedTextStyle = function(e, t) {
                    if (e.size() && t.selectedpoints) {
                        var r = x.makeSelectedTextStyleFns(t);
                        e.each(function(e) {
                            var a = n.select(this), i = r.selectedTextColorFn(e), o = e.tp || t.textposition, l = P(e, t);
                            c.fill(a, i);
                            var u = s.traceIs(t, "bar-like");
                            C(a, o, l, e.mrc2 || e.mrc, u);
                        });
                    }
                }, x.smoothopen = function(e, t) {
                    if (e.length < 3) return "M" + e.join("L");
                    var r, n = "M" + e[0], a = [];
                    for(r = 1; r < e.length - 1; r++)a.push(N(e[r - 1], e[r], e[r + 1], t));
                    for(n += "Q" + a[0][0] + " " + e[1], r = 2; r < e.length - 1; r++)n += "C" + a[r - 2][1] + " " + a[r - 1][0] + " " + e[r];
                    return n + "Q" + a[e.length - 3][1] + " " + e[e.length - 1];
                }, x.smoothclosed = function(e, t) {
                    if (e.length < 3) return "M" + e.join("L") + "Z";
                    var r, n = "M" + e[0], a = e.length - 1, i = [
                        N(e[a], e[0], e[1], t)
                    ];
                    for(r = 1; r < a; r++)i.push(N(e[r - 1], e[r], e[r + 1], t));
                    for(i.push(N(e[a - 1], e[a], e[0], t)), r = 1; r <= a; r++)n += "C" + i[r - 1][1] + " " + i[r][0] + " " + e[r];
                    return n + "C" + i[a][1] + " " + i[0][0] + " " + e[0] + "Z";
                };
                var F = {
                    hv: function(e, t, r) {
                        return "H" + R(t[0]) + "V" + I(t, 1, r);
                    },
                    vh: function(e, t, r) {
                        return "V" + z(t[1]) + "H" + I(t, 0, r);
                    },
                    hvh: function(e, t, r) {
                        return "H" + R((e[0] + t[0]) / 2) + "V" + z(t[1]) + "H" + I(t, 0, r);
                    },
                    vhv: function(e, t, r) {
                        return "V" + z((e[1] + t[1]) / 2) + "H" + R(t[0]) + "V" + I(t, 1, r);
                    }
                }, E = function(e, t, r) {
                    return "L" + I(t, 0, r) + "," + I(t, 1, r);
                };
                function H(e, t) {
                    var r = e.backoff, n = e.trace, i = e.d, o = e.i;
                    if (r && n && n.marker && n.marker.angle % 360 == 0 && n.line && "spline" !== n.line.shape) {
                        var l = a.isArrayOrTypedArray(r), s = e, c = t ? t[0] : S || 0, u = t ? t[1] : D || 0, f = s[0], d = s[1], h = f - c, p = d - u, v = Math.atan2(p, h), g = l ? r[o] : r;
                        if ("auto" === g) {
                            var y = s.i;
                            "scatter" === n.type && y--;
                            var m = s.marker, b = m.symbol;
                            a.isArrayOrTypedArray(b) && (b = b[y]);
                            var _ = m.size;
                            a.isArrayOrTypedArray(_) && (_ = _[y]), g = m ? x.symbolBackOffs[x.symbolNumber(b)] * _ : 0, g += x.getMarkerStandoff(i[y], n) || 0;
                        }
                        var w = f - g * Math.cos(v), T = d - g * Math.sin(v);
                        (w <= f && w >= c || w >= f && w <= c) && (T <= d && T >= u || T >= d && T <= u) && (e = [
                            w,
                            T
                        ]);
                    }
                    return e;
                }
                x.steps = function(e) {
                    var t = F[e] || E;
                    return function(e) {
                        for(var r = "M" + R(e[0][0]) + "," + z(e[0][1]), n = e.length, a = 1; a < n; a++)r += t(e[a - 1], e[a], a === n - 1);
                        return r;
                    };
                }, x.applyBackoff = H, x.makeTester = function() {
                    var e = a.ensureSingleById(n.select("body"), "svg", "js-plotly-tester", function(e) {
                        e.attr(h.svgAttrs).style({
                            position: "absolute",
                            left: "-10000px",
                            top: "-10000px",
                            width: "9000px",
                            height: "9000px",
                            "z-index": "1"
                        });
                    }), t = a.ensureSingle(e, "path", "js-reference-point", function(e) {
                        e.attr("d", "M0,0H1V1H0Z").style({
                            "stroke-width": 0,
                            fill: "black"
                        });
                    });
                    x.tester = e, x.testref = t;
                }, x.savedBBoxes = {};
                var j = 0;
                function B(e) {
                    var t = e.getAttribute("data-unformatted");
                    if (null !== t) return t + e.getAttribute("data-math") + e.getAttribute("text-anchor") + e.getAttribute("style");
                }
                function Y(e, t) {
                    if (!e) return null;
                    var r = t._context, n = r._exportedPlot ? "" : r._baseUrl || "";
                    return n ? "url('" + n + "#" + e + "')" : "url(#" + e + ")";
                }
                x.bBox = function(e, t, r) {
                    var i, o, l;
                    if (r || (r = B(e)), r) {
                        if (i = x.savedBBoxes[r]) return a.extendFlat({}, i);
                    } else if (1 === e.childNodes.length) {
                        var s = e.childNodes[0];
                        if (r = B(s)) {
                            var c = +s.getAttribute("x") || 0, u = +s.getAttribute("y") || 0, f = s.getAttribute("transform");
                            if (!f) {
                                var h = x.bBox(s, !1, r);
                                return c && (h.left += c, h.right += c), u && (h.top += u, h.bottom += u), h;
                            }
                            if (r += "~" + c + "~" + u + "~" + f, i = x.savedBBoxes[r]) return a.extendFlat({}, i);
                        }
                    }
                    t ? o = e : (l = x.tester.node(), o = e.cloneNode(!0), l.appendChild(o)), n.select(o).attr("transform", null).call(d.positionText, 0, 0);
                    var p = o.getBoundingClientRect(), v = x.testref.node().getBoundingClientRect();
                    t || l.removeChild(o);
                    var g = {
                        height: p.height,
                        width: p.width,
                        left: p.left - v.left,
                        top: p.top - v.top,
                        right: p.right - v.left,
                        bottom: p.bottom - v.top
                    };
                    return j >= 1e4 && (x.savedBBoxes = {}, j = 0), r && (x.savedBBoxes[r] = g), j++, a.extendFlat({}, g);
                }, x.setClipUrl = function(e, t, r) {
                    e.attr("clip-path", Y(t, r));
                }, x.getTranslate = function(e) {
                    var t = (e[e.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/, function(e, t, r) {
                        return [
                            t,
                            r
                        ].join(" ");
                    }).split(" ");
                    return {
                        x: +t[0] || 0,
                        y: +t[1] || 0
                    };
                }, x.setTranslate = function(e, t, r) {
                    var n = e.attr ? "attr" : "getAttribute", a = e.attr ? "attr" : "setAttribute", i = e[n]("transform") || "";
                    return t = t || 0, r = r || 0, i = i.replace(/(\btranslate\(.*?\);?)/, "").trim(), i = (i += f(t, r)).trim(), e[a]("transform", i), i;
                }, x.getScale = function(e) {
                    var t = (e[e.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/, function(e, t, r) {
                        return [
                            t,
                            r
                        ].join(" ");
                    }).split(" ");
                    return {
                        x: +t[0] || 1,
                        y: +t[1] || 1
                    };
                }, x.setScale = function(e, t, r) {
                    var n = e.attr ? "attr" : "getAttribute", a = e.attr ? "attr" : "setAttribute", i = e[n]("transform") || "";
                    return t = t || 1, r = r || 1, i = i.replace(/(\bscale\(.*?\);?)/, "").trim(), i = (i += "scale(" + t + "," + r + ")").trim(), e[a]("transform", i), i;
                };
                var V = /\s*sc.*/;
                x.setPointGroupScale = function(e, t, r) {
                    if (t = t || 1, r = r || 1, e) {
                        var n = 1 === t && 1 === r ? "" : "scale(" + t + "," + r + ")";
                        e.each(function() {
                            var e = (this.getAttribute("transform") || "").replace(V, "");
                            e = (e += n).trim(), this.setAttribute("transform", e);
                        });
                    }
                };
                var U = /translate\([^)]*\)\s*$/;
                function q(e, t) {
                    var r;
                    return e && (r = e.mf), void 0 === r && (r = t.marker && t.marker.standoff || 0), t._geo || t._xA ? r : -r;
                }
                x.setTextPointsScale = function(e, t, r) {
                    e && e.each(function() {
                        var e, a = n.select(this), i = a.select("text");
                        if (i.node()) {
                            var o = parseFloat(i.attr("x") || 0), l = parseFloat(i.attr("y") || 0), s = (a.attr("transform") || "").match(U);
                            e = 1 === t && 1 === r ? [] : [
                                f(o, l),
                                "scale(" + t + "," + r + ")",
                                f(-o, -l)
                            ], s && e.push(s), a.attr("transform", e.join(""));
                        }
                    });
                }, x.getMarkerStandoff = q;
                var G, Z, W, X, J, K, Q = Math.atan2, $ = Math.cos, ee = Math.sin;
                function te(e, t) {
                    var r = t[0], n = t[1];
                    return [
                        r * $(e) - n * ee(e),
                        r * ee(e) + n * $(e)
                    ];
                }
                function re(e, t) {
                    var r, n, a = e.ma;
                    void 0 === a && (a = t.marker.angle || 0);
                    var i = t.marker.angleref;
                    if ("previous" === i || "north" === i) {
                        if (t._geo) {
                            var l = t._geo.project(e.lonlat);
                            r = l[0], n = l[1];
                        } else {
                            var s = t._xA, c = t._yA;
                            if (!s || !c) return 90;
                            r = s.c2p(e.x), n = c.c2p(e.y);
                        }
                        if (t._geo) {
                            var u, f = e.lonlat[0], d = e.lonlat[1], h = t._geo.project([
                                f,
                                d + 1e-5
                            ]), p = t._geo.project([
                                f + 1e-5,
                                d
                            ]), v = Q(p[1] - n, p[0] - r), g = Q(h[1] - n, h[0] - r);
                            if ("north" === i) u = a / 180 * Math.PI;
                            else if ("previous" === i) {
                                var y = f / 180 * Math.PI, m = d / 180 * Math.PI, x = G / 180 * Math.PI, b = Z / 180 * Math.PI, _ = x - y, w = $(b) * ee(_), T = ee(b) * $(m) - $(b) * ee(m) * $(_);
                                u = -Q(w, T) - Math.PI, G = f, Z = d;
                            }
                            var M = te(v, [
                                $(u),
                                0
                            ]), k = te(g, [
                                ee(u),
                                0
                            ]);
                            a = Q(M[1] + k[1], M[0] + k[0]) / Math.PI * 180, "previous" !== i || K === t.uid && e.i === J + 1 || (a = null);
                        }
                        if ("previous" === i && !t._geo) {
                            if (K === t.uid && e.i === J + 1 && o(r) && o(n)) {
                                var A = r - W, L = n - X, S = t.line && t.line.shape || "", D = S.slice(S.length - 1);
                                "h" === D && (L = 0), "v" === D && (A = 0), a += Q(L, A) / Math.PI * 180 + 90;
                            } else a = null;
                        }
                    }
                    return W = r, X = n, J = e.i, K = t.uid, a;
                }
                x.getMarkerAngle = re;
            },
            998: function(e, t, r) {
                "use strict";
                var n, a, i, o, l = r(5616), s = r(9898).round, c = "M0,0Z", u = Math.sqrt(2), f = Math.sqrt(3), d = Math.PI, h = Math.cos, p = Math.sin;
                function v(e) {
                    return null === e;
                }
                function g(e, t, r) {
                    if (!(e && e % 360 != 0 || t)) return r;
                    if (i === e && o === t && n === r) return a;
                    function s(e, r) {
                        var n = h(e), a = p(e), i = r[0], o = r[1] + (t || 0);
                        return [
                            i * n - o * a,
                            i * a + o * n
                        ];
                    }
                    i = e, o = t, n = r;
                    for(var c = e / 180 * d, u = 0, f = 0, v = l(r), g = "", y = 0; y < v.length; y++){
                        var m = v[y], x = m[0], b = u, _ = f;
                        if ("M" === x || "L" === x) u = +m[1], f = +m[2];
                        else if ("m" === x || "l" === x) u += +m[1], f += +m[2];
                        else if ("H" === x) u = +m[1];
                        else if ("h" === x) u += +m[1];
                        else if ("V" === x) f = +m[1];
                        else if ("v" === x) f += +m[1];
                        else if ("A" === x) {
                            u = +m[1], f = +m[2];
                            var w = s(c, [
                                +m[6],
                                +m[7]
                            ]);
                            m[6] = w[0], m[7] = w[1], m[3] = +m[3] + e;
                        }
                        "H" !== x && "V" !== x || (x = "L"), "h" !== x && "v" !== x || (x = "l"), "m" !== x && "l" !== x || (u -= b, f -= _);
                        var T = s(c, [
                            u,
                            f
                        ]);
                        "H" !== x && "V" !== x || (x = "L"), "M" !== x && "L" !== x && "m" !== x && "l" !== x || (m[1] = T[0], m[2] = T[1]), m[0] = x, g += m[0] + m.slice(1).join(",");
                    }
                    return a = g, g;
                }
                e.exports = {
                    circle: {
                        n: 0,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2), a = "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z";
                            return r ? g(t, r, a) : a;
                        }
                    },
                    square: {
                        n: 1,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
                        }
                    },
                    diamond: {
                        n: 2,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.3 * e, 2);
                            return g(t, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "Z");
                        }
                    },
                    cross: {
                        n: 3,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(.4 * e, 2), a = s(1.2 * e, 2);
                            return g(t, r, "M" + a + "," + n + "H" + n + "V" + a + "H-" + n + "V" + n + "H-" + a + "V-" + n + "H-" + n + "V-" + a + "H" + n + "V-" + n + "H" + a + "Z");
                        }
                    },
                    x: {
                        n: 4,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(.8 * e / u, 2), a = "l" + n + "," + n, i = "l" + n + ",-" + n, o = "l-" + n + ",-" + n, l = "l-" + n + "," + n;
                            return g(t, r, "M0," + n + a + i + o + i + o + l + o + l + a + l + a + "Z");
                        }
                    },
                    "triangle-up": {
                        n: 5,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(2 * e / f, 2);
                            return g(t, r, "M-" + n + "," + s(e / 2, 2) + "H" + n + "L0,-" + s(e, 2) + "Z");
                        }
                    },
                    "triangle-down": {
                        n: 6,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(2 * e / f, 2);
                            return g(t, r, "M-" + n + ",-" + s(e / 2, 2) + "H" + n + "L0," + s(e, 2) + "Z");
                        }
                    },
                    "triangle-left": {
                        n: 7,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(2 * e / f, 2);
                            return g(t, r, "M" + s(e / 2, 2) + ",-" + n + "V" + n + "L-" + s(e, 2) + ",0Z");
                        }
                    },
                    "triangle-right": {
                        n: 8,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(2 * e / f, 2);
                            return g(t, r, "M-" + s(e / 2, 2) + ",-" + n + "V" + n + "L" + s(e, 2) + ",0Z");
                        }
                    },
                    "triangle-ne": {
                        n: 9,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(.6 * e, 2), a = s(1.2 * e, 2);
                            return g(t, r, "M-" + a + ",-" + n + "H" + n + "V" + a + "Z");
                        }
                    },
                    "triangle-se": {
                        n: 10,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(.6 * e, 2), a = s(1.2 * e, 2);
                            return g(t, r, "M" + n + ",-" + a + "V" + n + "H-" + a + "Z");
                        }
                    },
                    "triangle-sw": {
                        n: 11,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(.6 * e, 2), a = s(1.2 * e, 2);
                            return g(t, r, "M" + a + "," + n + "H-" + n + "V-" + a + "Z");
                        }
                    },
                    "triangle-nw": {
                        n: 12,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(.6 * e, 2), a = s(1.2 * e, 2);
                            return g(t, r, "M-" + n + "," + a + "V-" + n + "H" + a + "Z");
                        }
                    },
                    pentagon: {
                        n: 13,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(.951 * e, 2), a = s(.588 * e, 2), i = s(-e, 2), o = s(-0.309 * e, 2);
                            return g(t, r, "M" + n + "," + o + "L" + a + "," + s(.809 * e, 2) + "H-" + a + "L-" + n + "," + o + "L0," + i + "Z");
                        }
                    },
                    hexagon: {
                        n: 14,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2), a = s(e / 2, 2), i = s(e * f / 2, 2);
                            return g(t, r, "M" + i + ",-" + a + "V" + a + "L0," + n + "L-" + i + "," + a + "V-" + a + "L0,-" + n + "Z");
                        }
                    },
                    hexagon2: {
                        n: 15,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2), a = s(e / 2, 2), i = s(e * f / 2, 2);
                            return g(t, r, "M-" + a + "," + i + "H" + a + "L" + n + ",0L" + a + ",-" + i + "H-" + a + "L-" + n + ",0Z");
                        }
                    },
                    octagon: {
                        n: 16,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(.924 * e, 2), a = s(.383 * e, 2);
                            return g(t, r, "M-" + a + ",-" + n + "H" + a + "L" + n + ",-" + a + "V" + a + "L" + a + "," + n + "H-" + a + "L-" + n + "," + a + "V-" + a + "Z");
                        }
                    },
                    star: {
                        n: 17,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = 1.4 * e, a = s(.225 * n, 2), i = s(.951 * n, 2), o = s(.363 * n, 2), l = s(.588 * n, 2), u = s(-n, 2), f = s(-0.309 * n, 2), d = s(.118 * n, 2), h = s(.809 * n, 2);
                            return g(t, r, "M" + a + "," + f + "H" + i + "L" + o + "," + d + "L" + l + "," + h + "L0," + s(.382 * n, 2) + "L-" + l + "," + h + "L-" + o + "," + d + "L-" + i + "," + f + "H-" + a + "L0," + u + "Z");
                        }
                    },
                    hexagram: {
                        n: 18,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(.66 * e, 2), a = s(.38 * e, 2), i = s(.76 * e, 2);
                            return g(t, r, "M-" + i + ",0l-" + a + ",-" + n + "h" + i + "l" + a + ",-" + n + "l" + a + "," + n + "h" + i + "l-" + a + "," + n + "l" + a + "," + n + "h-" + i + "l-" + a + "," + n + "l-" + a + ",-" + n + "h-" + i + "Z");
                        }
                    },
                    "star-triangle-up": {
                        n: 19,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e * f * .8, 2), a = s(.8 * e, 2), i = s(1.6 * e, 2), o = s(4 * e, 2), l = "A " + o + "," + o + " 0 0 1 ";
                            return g(t, r, "M-" + n + "," + a + l + n + "," + a + l + "0,-" + i + l + "-" + n + "," + a + "Z");
                        }
                    },
                    "star-triangle-down": {
                        n: 20,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e * f * .8, 2), a = s(.8 * e, 2), i = s(1.6 * e, 2), o = s(4 * e, 2), l = "A " + o + "," + o + " 0 0 1 ";
                            return g(t, r, "M" + n + ",-" + a + l + "-" + n + ",-" + a + l + "0," + i + l + n + ",-" + a + "Z");
                        }
                    },
                    "star-square": {
                        n: 21,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.1 * e, 2), a = s(2 * e, 2), i = "A " + a + "," + a + " 0 0 1 ";
                            return g(t, r, "M-" + n + ",-" + n + i + "-" + n + "," + n + i + n + "," + n + i + n + ",-" + n + i + "-" + n + ",-" + n + "Z");
                        }
                    },
                    "star-diamond": {
                        n: 22,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.4 * e, 2), a = s(1.9 * e, 2), i = "A " + a + "," + a + " 0 0 1 ";
                            return g(t, r, "M-" + n + ",0" + i + "0," + n + i + n + ",0" + i + "0,-" + n + i + "-" + n + ",0Z");
                        }
                    },
                    "diamond-tall": {
                        n: 23,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(.7 * e, 2), a = s(1.4 * e, 2);
                            return g(t, r, "M0," + a + "L" + n + ",0L0,-" + a + "L-" + n + ",0Z");
                        }
                    },
                    "diamond-wide": {
                        n: 24,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.4 * e, 2), a = s(.7 * e, 2);
                            return g(t, r, "M0," + a + "L" + n + ",0L0,-" + a + "L-" + n + ",0Z");
                        }
                    },
                    hourglass: {
                        n: 25,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M" + n + "," + n + "H-" + n + "L" + n + ",-" + n + "H-" + n + "Z");
                        },
                        noDot: !0
                    },
                    bowtie: {
                        n: 26,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M" + n + "," + n + "V-" + n + "L-" + n + "," + n + "V-" + n + "Z");
                        },
                        noDot: !0
                    },
                    "circle-cross": {
                        n: 27,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "circle-x": {
                        n: 28,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2), a = s(e / u, 2);
                            return g(t, r, "M" + a + "," + a + "L-" + a + ",-" + a + "M" + a + ",-" + a + "L-" + a + "," + a + "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "square-cross": {
                        n: 29,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "square-x": {
                        n: 30,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n + "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "diamond-cross": {
                        n: 31,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.3 * e, 2);
                            return g(t, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "ZM0,-" + n + "V" + n + "M-" + n + ",0H" + n);
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "diamond-x": {
                        n: 32,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.3 * e, 2), a = s(.65 * e, 2);
                            return g(t, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "ZM-" + a + ",-" + a + "L" + a + "," + a + "M-" + a + "," + a + "L" + a + ",-" + a);
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "cross-thin": {
                        n: 33,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.4 * e, 2);
                            return g(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "x-thin": {
                        n: 34,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    asterisk: {
                        n: 35,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.2 * e, 2), a = s(.85 * e, 2);
                            return g(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + a + "," + a + "L-" + a + ",-" + a + "M" + a + ",-" + a + "L-" + a + "," + a);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    hash: {
                        n: 36,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e / 2, 2), a = s(e, 2);
                            return g(t, r, "M" + n + "," + a + "V-" + a + "M" + (n - a) + ",-" + a + "V" + a + "M" + a + "," + n + "H-" + a + "M-" + a + "," + (n - a) + "H" + a);
                        },
                        needLine: !0,
                        noFill: !0
                    },
                    "y-up": {
                        n: 37,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.2 * e, 2), a = s(1.6 * e, 2), i = s(.8 * e, 2);
                            return g(t, r, "M-" + n + "," + i + "L0,0M" + n + "," + i + "L0,0M0,-" + a + "L0,0");
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "y-down": {
                        n: 38,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.2 * e, 2), a = s(1.6 * e, 2), i = s(.8 * e, 2);
                            return g(t, r, "M-" + n + ",-" + i + "L0,0M" + n + ",-" + i + "L0,0M0," + a + "L0,0");
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "y-left": {
                        n: 39,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.2 * e, 2), a = s(1.6 * e, 2), i = s(.8 * e, 2);
                            return g(t, r, "M" + i + "," + n + "L0,0M" + i + ",-" + n + "L0,0M-" + a + ",0L0,0");
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "y-right": {
                        n: 40,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.2 * e, 2), a = s(1.6 * e, 2), i = s(.8 * e, 2);
                            return g(t, r, "M-" + i + "," + n + "L0,0M-" + i + ",-" + n + "L0,0M" + a + ",0L0,0");
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-ew": {
                        n: 41,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.4 * e, 2);
                            return g(t, r, "M" + n + ",0H-" + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-ns": {
                        n: 42,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(1.4 * e, 2);
                            return g(t, r, "M0," + n + "V-" + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-ne": {
                        n: 43,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M" + n + ",-" + n + "L-" + n + "," + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-nw": {
                        n: 44,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M" + n + "," + n + "L-" + n + ",-" + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "arrow-up": {
                        n: 45,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M0,0L-" + n + "," + s(2 * e, 2) + "H" + n + "Z");
                        },
                        backoff: 1,
                        noDot: !0
                    },
                    "arrow-down": {
                        n: 46,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M0,0L-" + n + ",-" + s(2 * e, 2) + "H" + n + "Z");
                        },
                        noDot: !0
                    },
                    "arrow-left": {
                        n: 47,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(2 * e, 2), a = s(e, 2);
                            return g(t, r, "M0,0L" + n + ",-" + a + "V" + a + "Z");
                        },
                        noDot: !0
                    },
                    "arrow-right": {
                        n: 48,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(2 * e, 2), a = s(e, 2);
                            return g(t, r, "M0,0L-" + n + ",-" + a + "V" + a + "Z");
                        },
                        noDot: !0
                    },
                    "arrow-bar-up": {
                        n: 49,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M-" + n + ",0H" + n + "M0,0L-" + n + "," + s(2 * e, 2) + "H" + n + "Z");
                        },
                        backoff: 1,
                        needLine: !0,
                        noDot: !0
                    },
                    "arrow-bar-down": {
                        n: 50,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(e, 2);
                            return g(t, r, "M-" + n + ",0H" + n + "M0,0L-" + n + ",-" + s(2 * e, 2) + "H" + n + "Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "arrow-bar-left": {
                        n: 51,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(2 * e, 2), a = s(e, 2);
                            return g(t, r, "M0,-" + a + "V" + a + "M0,0L" + n + ",-" + a + "V" + a + "Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "arrow-bar-right": {
                        n: 52,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = s(2 * e, 2), a = s(e, 2);
                            return g(t, r, "M0,-" + a + "V" + a + "M0,0L-" + n + ",-" + a + "V" + a + "Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    arrow: {
                        n: 53,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = d / 2.5, a = 2 * e * h(n), i = 2 * e * p(n);
                            return g(t, r, "M0,0L" + -a + "," + i + "L" + a + "," + i + "Z");
                        },
                        backoff: .9,
                        noDot: !0
                    },
                    "arrow-wide": {
                        n: 54,
                        f: function(e, t, r) {
                            if (v(t)) return c;
                            var n = d / 4, a = 2 * e * h(n), i = 2 * e * p(n);
                            return g(t, r, "M0,0L" + -a + "," + i + "A " + 2 * e + "," + 2 * e + " 0 0 1 " + a + "," + i + "Z");
                        },
                        backoff: .4,
                        noDot: !0
                    }
                };
            },
            5673: function(e) {
                "use strict";
                e.exports = {
                    visible: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "percent",
                            "constant",
                            "sqrt",
                            "data"
                        ],
                        editType: "calc"
                    },
                    symmetric: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    array: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    arrayminus: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    value: {
                        valType: "number",
                        min: 0,
                        dflt: 10,
                        editType: "calc"
                    },
                    valueminus: {
                        valType: "number",
                        min: 0,
                        dflt: 10,
                        editType: "calc"
                    },
                    traceref: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "style"
                    },
                    tracerefminus: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "style"
                    },
                    copy_ystyle: {
                        valType: "boolean",
                        editType: "plot"
                    },
                    copy_zstyle: {
                        valType: "boolean",
                        editType: "style"
                    },
                    color: {
                        valType: "color",
                        editType: "style"
                    },
                    thickness: {
                        valType: "number",
                        min: 0,
                        dflt: 2,
                        editType: "style"
                    },
                    width: {
                        valType: "number",
                        min: 0,
                        editType: "plot"
                    },
                    editType: "calc",
                    _deprecated: {
                        opacity: {
                            valType: "number",
                            editType: "style"
                        }
                    }
                };
            },
            4532: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(3972), i = r(9298), o = r(1828), l = r(5827);
                function s(e, t, r, a) {
                    var s = t["error_" + a] || {}, c = [];
                    if (s.visible && -1 !== [
                        "linear",
                        "log"
                    ].indexOf(r.type)) {
                        for(var u = l(s), f = 0; f < e.length; f++){
                            var d = e[f], h = d.i;
                            if (void 0 === h) h = f;
                            else if (null === h) continue;
                            var p = d[a];
                            if (n(r.c2l(p))) {
                                var v = u(p, h);
                                if (n(v[0]) && n(v[1])) {
                                    var g = d[a + "s"] = p - v[0], y = d[a + "h"] = p + v[1];
                                    c.push(g, y);
                                }
                            }
                        }
                        var m = r._id, x = t._extremes[m], b = i.findExtremes(r, c, o.extendFlat({
                            tozero: x.opts.tozero
                        }, {
                            padded: !0
                        }));
                        x.min = x.min.concat(b.min), x.max = x.max.concat(b.max);
                    }
                }
                e.exports = function(e) {
                    for(var t = e.calcdata, r = 0; r < t.length; r++){
                        var n = t[r], o = n[0].trace;
                        if (!0 === o.visible && a.traceIs(o, "errorBarsOK")) {
                            var l = i.getFromId(e, o.xaxis), c = i.getFromId(e, o.yaxis);
                            s(n, o, l, "x"), s(n, o, c, "y");
                        }
                    }
                };
            },
            5827: function(e) {
                "use strict";
                function t(e, t) {
                    return "percent" === e ? function(e) {
                        return Math.abs(e * t / 100);
                    } : "constant" === e ? function() {
                        return Math.abs(t);
                    } : "sqrt" === e ? function(e) {
                        return Math.sqrt(Math.abs(e));
                    } : void 0;
                }
                e.exports = function(e) {
                    var r = e.type, n = e.symmetric;
                    if ("data" === r) {
                        var a = e.array || [];
                        if (n) return function(e, t) {
                            var r = +a[t];
                            return [
                                r,
                                r
                            ];
                        };
                        var i = e.arrayminus || [];
                        return function(e, t) {
                            var r = +a[t], n = +i[t];
                            return isNaN(r) && isNaN(n) ? [
                                NaN,
                                NaN
                            ] : [
                                n || 0,
                                r || 0
                            ];
                        };
                    }
                    var o = t(r, e.value), l = t(r, e.valueminus);
                    return n || void 0 === e.valueminus ? function(e) {
                        var t = o(e);
                        return [
                            t,
                            t
                        ];
                    } : function(e) {
                        return [
                            l(e),
                            o(e)
                        ];
                    };
                };
            },
            7587: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(3972), i = r(1828), o = r(4467), l = r(5673);
                e.exports = function(e, t, r, s) {
                    var c = "error_" + s.axis, u = o.newContainer(t, c), f = e[c] || {};
                    function d(e, t) {
                        return i.coerce(f, u, l, e, t);
                    }
                    if (!1 !== d("visible", void 0 !== f.array || void 0 !== f.value || "sqrt" === f.type)) {
                        var h = d("type", "array" in f ? "data" : "percent"), p = !0;
                        "sqrt" !== h && (p = d("symmetric", !(("data" === h ? "arrayminus" : "valueminus") in f))), "data" === h ? (d("array"), d("traceref"), p || (d("arrayminus"), d("tracerefminus"))) : "percent" !== h && "constant" !== h || (d("value"), p || d("valueminus"));
                        var v = "copy_" + s.inherit + "style";
                        s.inherit && (t["error_" + s.inherit] || {}).visible && d(v, !(f.color || n(f.thickness) || n(f.width))), s.inherit && u[v] || (d("color", r), d("thickness"), d("width", a.traceIs(t, "gl3d") ? 0 : 4));
                    }
                };
            },
            7369: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(962).overrideAll, i = r(5673), o = {
                    error_x: n.extendFlat({}, i),
                    error_y: n.extendFlat({}, i)
                };
                delete o.error_x.copy_zstyle, delete o.error_y.copy_zstyle, delete o.error_y.copy_ystyle;
                var l = {
                    error_x: n.extendFlat({}, i),
                    error_y: n.extendFlat({}, i),
                    error_z: n.extendFlat({}, i)
                };
                delete l.error_x.copy_ystyle, delete l.error_y.copy_ystyle, delete l.error_z.copy_ystyle, delete l.error_z.copy_zstyle, e.exports = {
                    moduleType: "component",
                    name: "errorbars",
                    schema: {
                        traces: {
                            scatter: o,
                            bar: o,
                            histogram: o,
                            scatter3d: a(l, "calc", "nested"),
                            scattergl: a(o, "calc", "nested")
                        }
                    },
                    supplyDefaults: r(7587),
                    calc: r(4532),
                    makeComputeError: r(5827),
                    plot: r(9398),
                    style: r(2662),
                    hoverInfo: function(e, t, r) {
                        (t.error_y || {}).visible && (r.yerr = e.yh - e.y, t.error_y.symmetric || (r.yerrneg = e.y - e.ys)), (t.error_x || {}).visible && (r.xerr = e.xh - e.x, t.error_x.symmetric || (r.xerrneg = e.x - e.xs));
                    }
                };
            },
            9398: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(2770), i = r(1424), o = r(4098);
                e.exports = function(e, t, r, l) {
                    var s = r.xaxis, c = r.yaxis, u = l && l.duration > 0, f = e._context.staticPlot;
                    t.each(function(t) {
                        var d, h = t[0].trace, p = h.error_x || {}, v = h.error_y || {};
                        h.ids && (d = function(e) {
                            return e.id;
                        });
                        var g = o.hasMarkers(h) && h.marker.maxdisplayed > 0;
                        v.visible || p.visible || (t = []);
                        var y = n.select(this).selectAll("g.errorbar").data(t, d);
                        if (y.exit().remove(), t.length) {
                            p.visible || y.selectAll("path.xerror").remove(), v.visible || y.selectAll("path.yerror").remove(), y.style("opacity", 1);
                            var m = y.enter().append("g").classed("errorbar", !0);
                            u && m.style("opacity", 0).transition().duration(l.duration).style("opacity", 1), i.setClipUrl(y, r.layerClipId, e), y.each(function(e) {
                                var t = n.select(this), r = function(e, t, r) {
                                    var n = {
                                        x: t.c2p(e.x),
                                        y: r.c2p(e.y)
                                    };
                                    return void 0 !== e.yh && (n.yh = r.c2p(e.yh), n.ys = r.c2p(e.ys), a(n.ys) || (n.noYS = !0, n.ys = r.c2p(e.ys, !0))), void 0 !== e.xh && (n.xh = t.c2p(e.xh), n.xs = t.c2p(e.xs), a(n.xs) || (n.noXS = !0, n.xs = t.c2p(e.xs, !0))), n;
                                }(e, s, c);
                                if (!g || e.vis) {
                                    var i, o = t.select("path.yerror");
                                    if (v.visible && a(r.x) && a(r.yh) && a(r.ys)) {
                                        var d = v.width;
                                        i = "M" + (r.x - d) + "," + r.yh + "h" + 2 * d + "m-" + d + ",0V" + r.ys, r.noYS || (i += "m-" + d + ",0h" + 2 * d), o.size() ? u && (o = o.transition().duration(l.duration).ease(l.easing)) : o = t.append("path").style("vector-effect", f ? "none" : "non-scaling-stroke").classed("yerror", !0), o.attr("d", i);
                                    } else o.remove();
                                    var h = t.select("path.xerror");
                                    if (p.visible && a(r.y) && a(r.xh) && a(r.xs)) {
                                        var y = (p.copy_ystyle ? v : p).width;
                                        i = "M" + r.xh + "," + (r.y - y) + "v" + 2 * y + "m0,-" + y + "H" + r.xs, r.noXS || (i += "m0,-" + y + "v" + 2 * y), h.size() ? u && (h = h.transition().duration(l.duration).ease(l.easing)) : h = t.append("path").style("vector-effect", f ? "none" : "non-scaling-stroke").classed("xerror", !0), h.attr("d", i);
                                    } else h.remove();
                                }
                            });
                        }
                    });
                };
            },
            2662: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(7901);
                e.exports = function(e) {
                    e.each(function(e) {
                        var t = e[0].trace, r = t.error_y || {}, i = t.error_x || {}, o = n.select(this);
                        o.selectAll("path.yerror").style("stroke-width", r.thickness + "px").call(a.stroke, r.color), i.copy_ystyle && (i = r), o.selectAll("path.xerror").style("stroke-width", i.thickness + "px").call(a.stroke, i.color);
                    });
                };
            },
            7914: function(e, t, r) {
                "use strict";
                var n = r(1940), a = r(528).hoverlabel, i = r(1426).extendFlat;
                e.exports = {
                    hoverlabel: {
                        bgcolor: i({}, a.bgcolor, {
                            arrayOk: !0
                        }),
                        bordercolor: i({}, a.bordercolor, {
                            arrayOk: !0
                        }),
                        font: n({
                            arrayOk: !0,
                            editType: "none"
                        }),
                        align: i({}, a.align, {
                            arrayOk: !0
                        }),
                        namelength: i({}, a.namelength, {
                            arrayOk: !0
                        }),
                        editType: "none"
                    }
                };
            },
            732: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(3972);
                function i(e, t, r, a) {
                    a = a || n.identity, Array.isArray(e) && (t[0][r] = a(e));
                }
                e.exports = function(e) {
                    var t = e.calcdata, r = e._fullLayout;
                    function o(e) {
                        return function(t) {
                            return n.coerceHoverinfo({
                                hoverinfo: t
                            }, {
                                _module: e._module
                            }, r);
                        };
                    }
                    for(var l = 0; l < t.length; l++){
                        var s = t[l], c = s[0].trace;
                        if (!a.traceIs(c, "pie-like")) {
                            var u = a.traceIs(c, "2dMap") ? i : n.fillArray;
                            u(c.hoverinfo, s, "hi", o(c)), c.hovertemplate && u(c.hovertemplate, s, "ht"), c.hoverlabel && (u(c.hoverlabel.bgcolor, s, "hbg"), u(c.hoverlabel.bordercolor, s, "hbc"), u(c.hoverlabel.font.size, s, "hts"), u(c.hoverlabel.font.color, s, "htc"), u(c.hoverlabel.font.family, s, "htf"), u(c.hoverlabel.namelength, s, "hnl"), u(c.hoverlabel.align, s, "hta"));
                        }
                    }
                };
            },
            5914: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(8335).hover;
                e.exports = function(e, t, r) {
                    var i = n.getComponentMethod("annotations", "onClick")(e, e._hoverdata);
                    function o() {
                        e.emit("plotly_click", {
                            points: e._hoverdata,
                            event: t
                        });
                    }
                    void 0 !== r && a(e, t, r, !0), e._hoverdata && t && t.target && (i && i.then ? i.then(o) : o(), t.stopImmediatePropagation && t.stopImmediatePropagation());
                };
            },
            6675: function(e) {
                "use strict";
                e.exports = {
                    YANGLE: 60,
                    HOVERARROWSIZE: 6,
                    HOVERTEXTPAD: 3,
                    HOVERFONTSIZE: 13,
                    HOVERFONT: "Arial, sans-serif",
                    HOVERMINTIME: 50,
                    HOVERID: "-hover"
                };
            },
            4268: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(7914), i = r(8048);
                e.exports = function(e, t, r, o) {
                    var l = n.extendFlat({}, o.hoverlabel);
                    t.hovertemplate && (l.namelength = -1), i(e, t, function(r, i) {
                        return n.coerce(e, t, a, r, i);
                    }, l);
                };
            },
            3469: function(e, t, r) {
                "use strict";
                var n = r(1828);
                t.getSubplot = function(e) {
                    return e.subplot || e.xaxis + e.yaxis || e.geo;
                }, t.isTraceInSubplots = function(e, r) {
                    if ("splom" === e.type) {
                        for(var n = e.xaxes || [], a = e.yaxes || [], i = 0; i < n.length; i++)for(var o = 0; o < a.length; o++)if (-1 !== r.indexOf(n[i] + a[o])) return !0;
                        return !1;
                    }
                    return -1 !== r.indexOf(t.getSubplot(e));
                }, t.flat = function(e, t) {
                    for(var r = new Array(e.length), n = 0; n < e.length; n++)r[n] = t;
                    return r;
                }, t.p2c = function(e, t) {
                    for(var r = new Array(e.length), n = 0; n < e.length; n++)r[n] = e[n].p2c(t);
                    return r;
                }, t.getDistanceFunction = function(e, r, n, a) {
                    return "closest" === e ? a || t.quadrature(r, n) : "x" === e.charAt(0) ? r : n;
                }, t.getClosest = function(e, t, r) {
                    if (!1 !== r.index) r.index >= 0 && r.index < e.length ? r.distance = 0 : r.index = !1;
                    else for(var n = 0; n < e.length; n++){
                        var a = t(e[n]);
                        a <= r.distance && (r.index = n, r.distance = a);
                    }
                    return r;
                }, t.inbox = function(e, t, r) {
                    return e * t < 0 || 0 === e ? r : 1 / 0;
                }, t.quadrature = function(e, t) {
                    return function(r) {
                        var n = e(r), a = t(r);
                        return Math.sqrt(n * n + a * a);
                    };
                }, t.makeEventData = function(e, r, n) {
                    var a = "index" in e ? e.index : e.pointNumber, i = {
                        data: r._input,
                        fullData: r,
                        curveNumber: r.index,
                        pointNumber: a
                    };
                    if (r._indexToPoints) {
                        var o = r._indexToPoints[a];
                        1 === o.length ? i.pointIndex = o[0] : i.pointIndices = o;
                    } else i.pointIndex = a;
                    return r._module.eventData ? i = r._module.eventData(i, e, r, n, a) : ("xVal" in e ? i.x = e.xVal : "x" in e && (i.x = e.x), "yVal" in e ? i.y = e.yVal : "y" in e && (i.y = e.y), e.xa && (i.xaxis = e.xa), e.ya && (i.yaxis = e.ya), void 0 !== e.zLabelVal && (i.z = e.zLabelVal)), t.appendArrayPointValue(i, r, a), i;
                }, t.appendArrayPointValue = function(e, t, r) {
                    var a = t._arrayAttrs;
                    if (a) for(var l = 0; l < a.length; l++){
                        var s = a[l], c = i(s);
                        if (void 0 === e[c]) {
                            var u = o(n.nestedProperty(t, s).get(), r);
                            void 0 !== u && (e[c] = u);
                        }
                    }
                }, t.appendArrayMultiPointValues = function(e, t, r) {
                    var a = t._arrayAttrs;
                    if (a) for(var l = 0; l < a.length; l++){
                        var s = a[l], c = i(s);
                        if (void 0 === e[c]) {
                            for(var u = n.nestedProperty(t, s).get(), f = new Array(r.length), d = 0; d < r.length; d++)f[d] = o(u, r[d]);
                            e[c] = f;
                        }
                    }
                };
                var a = {
                    ids: "id",
                    locations: "location",
                    labels: "label",
                    values: "value",
                    "marker.colors": "color",
                    parents: "parent"
                };
                function i(e) {
                    return a[e] || e;
                }
                function o(e, t) {
                    return Array.isArray(t) ? Array.isArray(e) && Array.isArray(e[t[0]]) ? e[t[0]][t[1]] : void 0 : e[t];
                }
                var l = {
                    x: !0,
                    y: !0
                }, s = {
                    "x unified": !0,
                    "y unified": !0
                };
                t.isUnifiedHover = function(e) {
                    return "string" == typeof e && !!s[e];
                }, t.isXYhover = function(e) {
                    return "string" == typeof e && !!l[e];
                };
            },
            8335: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(2770), i = r(4267), o = r(1828), l = o.strTranslate, s = o.strRotate, c = r(1086), u = r(3893), f = r(9918), d = r(1424), h = r(7901), p = r(8569), v = r(9298), g = r(3972), y = r(3469), m = r(6675), x = r(9017), b = r(3969), _ = m.YANGLE, w = Math.PI * _ / 180, T = 1 / Math.sin(w), M = Math.cos(w), k = Math.sin(w), A = m.HOVERARROWSIZE, L = m.HOVERTEXTPAD, S = {
                    box: !0,
                    ohlc: !0,
                    violin: !0,
                    candlestick: !0
                }, D = {
                    scatter: !0,
                    scattergl: !0,
                    splom: !0
                };
                function O(e) {
                    return [
                        e.trace.index,
                        e.index,
                        e.x0,
                        e.y0,
                        e.name,
                        e.attr,
                        e.xa ? e.xa._id : "",
                        e.ya ? e.ya._id : ""
                    ].join(",");
                }
                t.hover = function(e, t, r, i) {
                    e = o.getGraphDiv(e);
                    var l = t.target;
                    o.throttle(e._fullLayout._uid + m.HOVERID, m.HOVERMINTIME, function() {
                        !function(e, t, r, i, l) {
                            r || (r = "xy");
                            var s = Array.isArray(r) ? r : [
                                r
                            ], u = e._fullLayout, d = u._plots || [], v = d[r], m = u._has("cartesian");
                            if (v) {
                                var x = v.overlays.map(function(e) {
                                    return e.id;
                                });
                                s = s.concat(x);
                            }
                            for(var b = s.length, _ = new Array(b), w = new Array(b), M = !1, k = 0; k < b; k++){
                                var L = s[k];
                                if (d[L]) M = !0, _[k] = d[L].xaxis, w[k] = d[L].yaxis;
                                else {
                                    if (!u[L] || !u[L]._subplot) return void o.warn("Unrecognized subplot: " + L);
                                    var C = u[L]._subplot;
                                    _[k] = C.xaxis, w[k] = C.yaxis;
                                }
                            }
                            var I = t.hovermode || u.hovermode;
                            if (I && !M && (I = "closest"), -1 === [
                                "x",
                                "y",
                                "closest",
                                "x unified",
                                "y unified"
                            ].indexOf(I) || !e.calcdata || e.querySelector(".zoombox") || e._dragging) return p.unhoverRaw(e, t);
                            var H = u.hoverdistance;
                            -1 === H && (H = 1 / 0);
                            var V = u.spikedistance;
                            -1 === V && (V = 1 / 0);
                            var U, q, G, Z, W, X, J, K, Q, $, ee, te, re, ne = [], ae = [], ie = {
                                hLinePoint: null,
                                vLinePoint: null
                            }, oe = !1;
                            if (Array.isArray(t)) for(I = "array", G = 0; G < t.length; G++)(W = e.calcdata[t[G].curveNumber || 0]) && (X = W[0].trace, "skip" !== W[0].trace.hoverinfo && (ae.push(W), "h" === X.orientation && (oe = !0)));
                            else {
                                for(Z = 0; Z < e.calcdata.length; Z++)W = e.calcdata[Z], "skip" !== (X = W[0].trace).hoverinfo && y.isTraceInSubplots(X, s) && (ae.push(W), "h" === X.orientation && (oe = !0));
                                var le, se;
                                if (l) {
                                    if (!1 === c.triggerHandler(e, "plotly_beforehover", t)) return;
                                    var ce = l.getBoundingClientRect();
                                    le = t.clientX - ce.left, se = t.clientY - ce.top, u._calcInverseTransform(e);
                                    var ue = o.apply3DTransform(u._invTransform)(le, se);
                                    if (le = ue[0], se = ue[1], le < 0 || le > _[0]._length || se < 0 || se > w[0]._length) return p.unhoverRaw(e, t);
                                } else le = "xpx" in t ? t.xpx : _[0]._length / 2, se = "ypx" in t ? t.ypx : w[0]._length / 2;
                                if (t.pointerX = le + _[0]._offset, t.pointerY = se + w[0]._offset, U = "xval" in t ? y.flat(s, t.xval) : y.p2c(_, le), q = "yval" in t ? y.flat(s, t.yval) : y.p2c(w, se), !a(U[0]) || !a(q[0])) return o.warn("Fx.hover failed", t, e), p.unhoverRaw(e, t);
                            }
                            var fe = 1 / 0;
                            function de(e, r) {
                                for(Z = 0; Z < ae.length; Z++)if ((W = ae[Z]) && W[0] && W[0].trace && !0 === (X = W[0].trace).visible && 0 !== X._length && -1 === [
                                    "carpet",
                                    "contourcarpet"
                                ].indexOf(X._module.name)) {
                                    if ("splom" === X.type ? J = s[K = 0] : (J = y.getSubplot(X), K = s.indexOf(J)), Q = I, y.isUnifiedHover(Q) && (Q = Q.charAt(0)), te = {
                                        cd: W,
                                        trace: X,
                                        xa: _[K],
                                        ya: w[K],
                                        maxHoverDistance: H,
                                        maxSpikeDistance: V,
                                        index: !1,
                                        distance: Math.min(fe, H),
                                        spikeDistance: 1 / 0,
                                        xSpike: void 0,
                                        ySpike: void 0,
                                        color: h.defaultLine,
                                        name: X.name,
                                        x0: void 0,
                                        x1: void 0,
                                        y0: void 0,
                                        y1: void 0,
                                        xLabelVal: void 0,
                                        yLabelVal: void 0,
                                        zLabelVal: void 0,
                                        text: void 0
                                    }, u[J] && (te.subplot = u[J]._subplot), u._splomScenes && u._splomScenes[X.uid] && (te.scene = u._splomScenes[X.uid]), re = ne.length, "array" === Q) {
                                        var n = t[Z];
                                        "pointNumber" in n ? (te.index = n.pointNumber, Q = "closest") : (Q = "", "xval" in n && ($ = n.xval, Q = "x"), "yval" in n && (ee = n.yval, Q = Q ? "closest" : "y"));
                                    } else void 0 !== e && void 0 !== r ? ($ = e, ee = r) : ($ = U[K], ee = q[K]);
                                    if (0 !== H) {
                                        if (X._module && X._module.hoverPoints) {
                                            var i = X._module.hoverPoints(te, $, ee, Q, {
                                                finiteRange: !0,
                                                hoverLayer: u._hoverlayer
                                            });
                                            if (i) for(var l, c = 0; c < i.length; c++)l = i[c], a(l.x0) && a(l.y0) && ne.push(N(l, I));
                                        } else o.log("Unrecognized trace type in hover:", X);
                                    }
                                    if ("closest" === I && ne.length > re && (ne.splice(0, re), fe = ne[0].distance), m && 0 !== V && 0 === ne.length) {
                                        te.distance = V, te.index = !1;
                                        var f = X._module.hoverPoints(te, $, ee, "closest", {
                                            hoverLayer: u._hoverlayer
                                        });
                                        if (f && (f = f.filter(function(e) {
                                            return e.spikeDistance <= V;
                                        })), f && f.length) {
                                            var d, p = f.filter(function(e) {
                                                return e.xa.showspikes && "hovered data" !== e.xa.spikesnap;
                                            });
                                            if (p.length) {
                                                var v = p[0];
                                                a(v.x0) && a(v.y0) && (d = pe(v), (!ie.vLinePoint || ie.vLinePoint.spikeDistance > d.spikeDistance) && (ie.vLinePoint = d));
                                            }
                                            var g = f.filter(function(e) {
                                                return e.ya.showspikes && "hovered data" !== e.ya.spikesnap;
                                            });
                                            if (g.length) {
                                                var x = g[0];
                                                a(x.x0) && a(x.y0) && (d = pe(x), (!ie.hLinePoint || ie.hLinePoint.spikeDistance > d.spikeDistance) && (ie.hLinePoint = d));
                                            }
                                        }
                                    }
                                }
                            }
                            function he(e, t, r) {
                                for(var n, a = null, i = 1 / 0, o = 0; o < e.length; o++)n = e[o].spikeDistance, r && 0 === o && (n = -1 / 0), n <= i && n <= t && (a = e[o], i = n);
                                return a;
                            }
                            function pe(e) {
                                return e ? {
                                    xa: e.xa,
                                    ya: e.ya,
                                    x: void 0 !== e.xSpike ? e.xSpike : (e.x0 + e.x1) / 2,
                                    y: void 0 !== e.ySpike ? e.ySpike : (e.y0 + e.y1) / 2,
                                    distance: e.distance,
                                    spikeDistance: e.spikeDistance,
                                    curveNumber: e.trace.index,
                                    color: e.color,
                                    pointNumber: e.index
                                } : null;
                            }
                            de();
                            var ve = {
                                fullLayout: u,
                                container: u._hoverlayer,
                                event: t
                            }, ge = e._spikepoints, ye = {
                                vLinePoint: ie.vLinePoint,
                                hLinePoint: ie.hLinePoint
                            };
                            e._spikepoints = ye;
                            var me = function() {
                                ne.sort(function(e, t) {
                                    return e.distance - t.distance;
                                }), ne = function(e, t) {
                                    for(var r = t.charAt(0), n = [], a = [], i = [], o = 0; o < e.length; o++){
                                        var l = e[o];
                                        g.traceIs(l.trace, "bar-like") || g.traceIs(l.trace, "box-violin") ? i.push(l) : l.trace[r + "period"] ? a.push(l) : n.push(l);
                                    }
                                    return n.concat(a).concat(i);
                                }(ne, I);
                            };
                            me();
                            var xe = I.charAt(0), be = ("x" === xe || "y" === xe) && ne[0] && D[ne[0].trace.type];
                            if (m && 0 !== V && 0 !== ne.length) {
                                var _e = he(ne.filter(function(e) {
                                    return e.ya.showspikes;
                                }), V, be);
                                ie.hLinePoint = pe(_e);
                                var we = he(ne.filter(function(e) {
                                    return e.xa.showspikes;
                                }), V, be);
                                ie.vLinePoint = pe(we);
                            }
                            if (0 === ne.length) {
                                var Te = p.unhoverRaw(e, t);
                                return !m || null === ie.hLinePoint && null === ie.vLinePoint || E(ge) && F(e, ie, ve), Te;
                            }
                            if (m && E(ge) && F(e, ie, ve), y.isXYhover(Q) && 0 !== ne[0].length && "splom" !== ne[0].trace.type) {
                                var Me = ne[0], ke = (ne = S[Me.trace.type] ? ne.filter(function(e) {
                                    return e.trace.index === Me.trace.index;
                                }) : [
                                    Me
                                ]).length;
                                de(j("x", Me, u), j("y", Me, u));
                                var Ae, Le = [], Se = {}, De = 0, Oe = function(e) {
                                    var t = S[e.trace.type] ? O(e) : e.trace.index;
                                    if (Se[t]) {
                                        var r = Se[t] - 1, n = Le[r];
                                        r > 0 && Math.abs(e.distance) < Math.abs(n.distance) && (Le[r] = e);
                                    } else De++, Se[t] = De, Le.push(e);
                                };
                                for(Ae = 0; Ae < ke; Ae++)Oe(ne[Ae]);
                                for(Ae = ne.length - 1; Ae > ke - 1; Ae--)Oe(ne[Ae]);
                                ne = Le, me();
                            }
                            var Ce = e._hoverdata, Pe = [], Ie = B(e), Re = Y(e);
                            for(G = 0; G < ne.length; G++){
                                var ze = ne[G], Ne = y.makeEventData(ze, ze.trace, ze.cd);
                                if (!1 !== ze.hovertemplate) {
                                    var Fe = !1;
                                    ze.cd[ze.index] && ze.cd[ze.index].ht && (Fe = ze.cd[ze.index].ht), ze.hovertemplate = Fe || ze.trace.hovertemplate || !1;
                                }
                                if (ze.xa && ze.ya) {
                                    var Ee = ze.x0 + ze.xa._offset, He = ze.x1 + ze.xa._offset, je = ze.y0 + ze.ya._offset, Be = ze.y1 + ze.ya._offset, Ye = Math.min(Ee, He), Ve = Math.max(Ee, He), Ue = Math.min(je, Be), qe = Math.max(je, Be);
                                    Ne.bbox = {
                                        x0: Ye + Re,
                                        x1: Ve + Re,
                                        y0: Ue + Ie,
                                        y1: qe + Ie
                                    };
                                }
                                ze.eventData = [
                                    Ne
                                ], Pe.push(Ne);
                            }
                            e._hoverdata = Pe;
                            var Ge = "y" === I && (ae.length > 1 || ne.length > 1) || "closest" === I && oe && ne.length > 1, Ze = h.combine(u.plot_bgcolor || h.background, u.paper_bgcolor), We = P(ne, {
                                gd: e,
                                hovermode: I,
                                rotateLabels: Ge,
                                bgColor: Ze,
                                container: u._hoverlayer,
                                outerContainer: u._paper.node(),
                                commonLabelOpts: u.hoverlabel,
                                hoverdistance: u.hoverdistance
                            }), Xe = We.hoverLabels;
                            if (y.isUnifiedHover(I) || (function(e, t, r, n) {
                                var a, i, o, l, s, c, u, f = t ? "xa" : "ya", d = t ? "ya" : "xa", h = 0, p = 1, v = e.size(), g = new Array(v), y = 0, m = n.minX, x = n.maxX, b = n.minY, _ = n.maxY, w = function(e) {
                                    return e * r._invScaleX;
                                }, M = function(e) {
                                    return e * r._invScaleY;
                                };
                                function k(e) {
                                    var t = e[0], r = e[e.length - 1];
                                    if (i = t.pmin - t.pos - t.dp + t.size, o = r.pos + r.dp + r.size - t.pmax, i > .01) {
                                        for(s = e.length - 1; s >= 0; s--)e[s].dp += i;
                                        a = !1;
                                    }
                                    if (!(o < .01)) {
                                        if (i < -0.01) {
                                            for(s = e.length - 1; s >= 0; s--)e[s].dp -= o;
                                            a = !1;
                                        }
                                        if (a) {
                                            var n = 0;
                                            for(l = 0; l < e.length; l++)(c = e[l]).pos + c.dp + c.size > t.pmax && n++;
                                            for(l = e.length - 1; l >= 0 && !(n <= 0); l--)(c = e[l]).pos > t.pmax - 1 && (c.del = !0, n--);
                                            for(l = 0; l < e.length && !(n <= 0); l++)if ((c = e[l]).pos < t.pmin + 1) for(c.del = !0, n--, o = 2 * c.size, s = e.length - 1; s >= 0; s--)e[s].dp -= o;
                                            for(l = e.length - 1; l >= 0 && !(n <= 0); l--)(c = e[l]).pos + c.dp + c.size > t.pmax && (c.del = !0, n--);
                                        }
                                    }
                                }
                                for(e.each(function(e) {
                                    var n = e[f], a = e[d], i = "x" === n._id.charAt(0), o = n.range;
                                    0 === y && o && o[0] > o[1] !== i && (p = -1);
                                    var l = 0, s = i ? r.width : r.height;
                                    if ("x" === r.hovermode || "y" === r.hovermode) {
                                        var c, u, h = R(e, t), v = e.anchor, k = "end" === v ? -1 : 1;
                                        if ("middle" === v) u = (c = e.crossPos + (i ? M(h.y - e.by / 2) : w(e.bx / 2 + e.tx2width / 2))) + (i ? M(e.by) : w(e.bx));
                                        else if (i) u = (c = e.crossPos + M(A + h.y) - M(e.by / 2 - A)) + M(e.by);
                                        else {
                                            var L = w(k * A + h.x), S = L + w(k * e.bx);
                                            c = e.crossPos + Math.min(L, S), u = e.crossPos + Math.max(L, S);
                                        }
                                        i ? void 0 !== b && void 0 !== _ && Math.min(u, _) - Math.max(c, b) > 1 && ("left" === a.side ? (l = a._mainLinePosition, s = r.width) : s = a._mainLinePosition) : void 0 !== m && void 0 !== x && Math.min(u, x) - Math.max(c, m) > 1 && ("top" === a.side ? (l = a._mainLinePosition, s = r.height) : s = a._mainLinePosition);
                                    }
                                    g[y++] = [
                                        {
                                            datum: e,
                                            traceIndex: e.trace.index,
                                            dp: 0,
                                            pos: e.pos,
                                            posref: e.posref,
                                            size: e.by * (i ? T : 1) / 2,
                                            pmin: l,
                                            pmax: s
                                        }
                                    ];
                                }), g.sort(function(e, t) {
                                    return e[0].posref - t[0].posref || p * (t[0].traceIndex - e[0].traceIndex);
                                }); !a && h <= v;){
                                    for(h++, a = !0, l = 0; l < g.length - 1;){
                                        var L = g[l], S = g[l + 1], D = L[L.length - 1], O = S[0];
                                        if ((i = D.pos + D.dp + D.size - O.pos - O.dp + O.size) > .01 && D.pmin === O.pmin && D.pmax === O.pmax) {
                                            for(s = S.length - 1; s >= 0; s--)S[s].dp += i;
                                            for(L.push.apply(L, S), g.splice(l + 1, 1), u = 0, s = L.length - 1; s >= 0; s--)u += L[s].dp;
                                            for(o = u / L.length, s = L.length - 1; s >= 0; s--)L[s].dp -= o;
                                            a = !1;
                                        } else l++;
                                    }
                                    g.forEach(k);
                                }
                                for(l = g.length - 1; l >= 0; l--){
                                    var C = g[l];
                                    for(s = C.length - 1; s >= 0; s--){
                                        var P = C[s], I = P.datum;
                                        I.offset = P.dp, I.del = P.del;
                                    }
                                }
                            }(Xe, Ge, u, We.commonLabelBoundingBox), z(Xe, Ge, u._invScaleX, u._invScaleY)), l && l.tagName) {
                                var Je = g.getComponentMethod("annotations", "hasClickToShow")(e, Pe);
                                f(n.select(l), Je ? "pointer" : "");
                            }
                            l && !i && function(e, t, r) {
                                if (!r || r.length !== e._hoverdata.length) return !0;
                                for(var n = r.length - 1; n >= 0; n--){
                                    var a = r[n], i = e._hoverdata[n];
                                    if (a.curveNumber !== i.curveNumber || String(a.pointNumber) !== String(i.pointNumber) || String(a.pointNumbers) !== String(i.pointNumbers)) return !0;
                                }
                                return !1;
                            }(e, 0, Ce) && (Ce && e.emit("plotly_unhover", {
                                event: t,
                                points: Ce
                            }), e.emit("plotly_hover", {
                                event: t,
                                points: e._hoverdata,
                                xaxes: _,
                                yaxes: w,
                                xvals: U,
                                yvals: q
                            }));
                        }(e, t, r, i, l);
                    });
                }, t.loneHover = function(e, t) {
                    var r = !0;
                    Array.isArray(e) || (r = !1, e = [
                        e
                    ]);
                    var a = t.gd, i = B(a), o = Y(a), l = P(e.map(function(e) {
                        var r = e._x0 || e.x0 || e.x || 0, n = e._x1 || e.x1 || e.x || 0, l = e._y0 || e.y0 || e.y || 0, s = e._y1 || e.y1 || e.y || 0, c = e.eventData;
                        if (c) {
                            var u = Math.min(r, n), f = Math.max(r, n), d = Math.min(l, s), p = Math.max(l, s), v = e.trace;
                            if (g.traceIs(v, "gl3d")) {
                                var y = a._fullLayout[v.scene]._scene.container, m = y.offsetLeft, x = y.offsetTop;
                                u += m, f += m, d += x, p += x;
                            }
                            c.bbox = {
                                x0: u + o,
                                x1: f + o,
                                y0: d + i,
                                y1: p + i
                            }, t.inOut_bbox && t.inOut_bbox.push(c.bbox);
                        } else c = !1;
                        return {
                            color: e.color || h.defaultLine,
                            x0: e.x0 || e.x || 0,
                            x1: e.x1 || e.x || 0,
                            y0: e.y0 || e.y || 0,
                            y1: e.y1 || e.y || 0,
                            xLabel: e.xLabel,
                            yLabel: e.yLabel,
                            zLabel: e.zLabel,
                            text: e.text,
                            name: e.name,
                            idealAlign: e.idealAlign,
                            borderColor: e.borderColor,
                            fontFamily: e.fontFamily,
                            fontSize: e.fontSize,
                            fontColor: e.fontColor,
                            nameLength: e.nameLength,
                            textAlign: e.textAlign,
                            trace: e.trace || {
                                index: 0,
                                hoverinfo: ""
                            },
                            xa: {
                                _offset: 0
                            },
                            ya: {
                                _offset: 0
                            },
                            index: 0,
                            hovertemplate: e.hovertemplate || !1,
                            hovertemplateLabels: e.hovertemplateLabels || !1,
                            eventData: c
                        };
                    }), {
                        gd: a,
                        hovermode: "closest",
                        rotateLabels: !1,
                        bgColor: t.bgColor || h.background,
                        container: n.select(t.container),
                        outerContainer: t.outerContainer || t.container
                    }).hoverLabels, s = 0, c = 0;
                    return l.sort(function(e, t) {
                        return e.y0 - t.y0;
                    }).each(function(e, r) {
                        var n = e.y0 - e.by / 2;
                        e.offset = n - 5 < s ? s - n + 5 : 0, s = n + e.by + e.offset, r === t.anchorIndex && (c = e.offset);
                    }).each(function(e) {
                        e.offset -= c;
                    }), z(l, !1, a._fullLayout._invScaleX, a._fullLayout._invScaleY), r ? l : l.node();
                };
                var C = /<extra>([\s\S]*)<\/extra>/;
                function P(e, t) {
                    var r = t.gd, a = r._fullLayout, i = t.hovermode, c = t.rotateLabels, f = t.bgColor, p = t.container, v = t.outerContainer, w = t.commonLabelOpts || {};
                    if (0 === e.length) return [
                        []
                    ];
                    var T = t.fontFamily || m.HOVERFONT, M = t.fontSize || m.HOVERFONTSIZE, k = e[0], S = k.xa, D = k.ya, C = i.charAt(0), P = C + "Label", R = k[P];
                    if (void 0 === R && "multicategory" === S.type) for(var z = 0; z < e.length && void 0 === (R = e[z][P]); z++);
                    var N = V(r, v), F = N.top, E = N.width, H = N.height, j = void 0 !== R && k.distance <= t.hoverdistance && ("x" === i || "y" === i);
                    if (j) {
                        var B, Y, U = !0;
                        for(B = 0; B < e.length; B++)if (U && void 0 === e[B].zLabel && (U = !1), Y = e[B].hoverinfo || e[B].trace.hoverinfo) {
                            var q = Array.isArray(Y) ? Y : Y.split("+");
                            if (-1 === q.indexOf("all") && -1 === q.indexOf(i)) {
                                j = !1;
                                break;
                            }
                        }
                        U && (j = !1);
                    }
                    var G = p.selectAll("g.axistext").data(j ? [
                        0
                    ] : []);
                    G.enter().append("g").classed("axistext", !0), G.exit().remove();
                    var Z = {
                        minX: 0,
                        maxX: 0,
                        minY: 0,
                        maxY: 0
                    };
                    if (G.each(function() {
                        var e = n.select(this), t = o.ensureSingle(e, "path", "", function(e) {
                            e.style({
                                "stroke-width": "1px"
                            });
                        }), s = o.ensureSingle(e, "text", "", function(e) {
                            e.attr("data-notex", 1);
                        }), c = w.bgcolor || h.defaultLine, f = w.bordercolor || h.contrast(c), p = h.contrast(c), v = {
                            family: w.font.family || T,
                            size: w.font.size || M,
                            color: w.font.color || p
                        };
                        t.style({
                            fill: c,
                            stroke: f
                        }), s.text(R).call(d.font, v).call(u.positionText, 0, 0).call(u.convertToTspans, r), e.attr("transform", "");
                        var g, y, m = V(r, s.node());
                        if ("x" === i) {
                            var x = "top" === S.side ? "-" : "";
                            s.attr("text-anchor", "middle").call(u.positionText, 0, "top" === S.side ? F - m.bottom - A - L : F - m.top + A + L), g = S._offset + (k.x0 + k.x1) / 2, y = D._offset + ("top" === S.side ? 0 : D._length);
                            var b = m.width / 2 + L;
                            g < b ? (g = b, t.attr("d", "M-" + (b - A) + ",0L-" + (b - 2 * A) + "," + x + A + "H" + b + "v" + x + (2 * L + m.height) + "H-" + b + "V" + x + A + "Z")) : g > a.width - b ? (g = a.width - b, t.attr("d", "M" + (b - A) + ",0L" + b + "," + x + A + "v" + x + (2 * L + m.height) + "H-" + b + "V" + x + A + "H" + (b - 2 * A) + "Z")) : t.attr("d", "M0,0L" + A + "," + x + A + "H" + b + "v" + x + (2 * L + m.height) + "H-" + b + "V" + x + A + "H-" + A + "Z"), Z.minX = g - b, Z.maxX = g + b, "top" === S.side ? (Z.minY = y - (2 * L + m.height), Z.maxY = y - L) : (Z.minY = y + L, Z.maxY = y + (2 * L + m.height));
                        } else {
                            var _, O, C;
                            "right" === D.side ? (_ = "start", O = 1, C = "", g = S._offset + S._length) : (_ = "end", O = -1, C = "-", g = S._offset), y = D._offset + (k.y0 + k.y1) / 2, s.attr("text-anchor", _), t.attr("d", "M0,0L" + C + A + "," + A + "V" + (L + m.height / 2) + "h" + C + (2 * L + m.width) + "V-" + (L + m.height / 2) + "H" + C + A + "V-" + A + "Z"), Z.minY = y - (L + m.height / 2), Z.maxY = y + (L + m.height / 2), "right" === D.side ? (Z.minX = g + A, Z.maxX = g + A + (2 * L + m.width)) : (Z.minX = g - A - (2 * L + m.width), Z.maxX = g - A);
                            var P, I = m.height / 2, z = F - m.top - I, N = "clip" + a._uid + "commonlabel" + D._id;
                            if (g < m.width + 2 * L + A) {
                                P = "M-" + (A + L) + "-" + I + "h-" + (m.width - L) + "V" + I + "h" + (m.width - L) + "Z";
                                var E = m.width - g + L;
                                u.positionText(s, E, z), "end" === _ && s.selectAll("tspan").each(function() {
                                    var e = n.select(this), t = d.tester.append("text").text(e.text()).call(d.font, v), a = V(r, t.node());
                                    Math.round(a.width) < Math.round(m.width) && e.attr("x", E - a.width), t.remove();
                                });
                            } else u.positionText(s, O * (L + A), z), P = null;
                            var H = a._topclips.selectAll("#" + N).data(P ? [
                                0
                            ] : []);
                            H.enter().append("clipPath").attr("id", N).append("path"), H.exit().remove(), H.select("path").attr("d", P), d.setClipUrl(s, P ? N : null, r);
                        }
                        e.attr("transform", l(g, y));
                    }), y.isUnifiedHover(i)) {
                        p.selectAll("g.hovertext").remove();
                        var W = e.filter(function(e) {
                            return "none" !== e.hoverinfo;
                        });
                        if (0 === W.length) return [];
                        var X = a.hoverlabel, J = X.font, K = {
                            showlegend: !0,
                            legend: {
                                title: {
                                    text: R,
                                    font: J
                                },
                                font: J,
                                bgcolor: X.bgcolor,
                                bordercolor: X.bordercolor,
                                borderwidth: 1,
                                tracegroupgap: 7,
                                traceorder: a.legend ? a.legend.traceorder : void 0,
                                orientation: "v"
                            }
                        }, Q = {
                            font: J
                        };
                        x(K, Q, r._fullData);
                        var $ = Q.legend;
                        $.entries = [];
                        for(var ee = 0; ee < W.length; ee++){
                            var te = W[ee];
                            if ("none" !== te.hoverinfo) {
                                var re = I(te, !0, i, a, R), ne = re[0], ae = re[1];
                                te.name = ae, te.text = "" !== ae ? ae + " : " + ne : ne;
                                var ie = te.cd[te.index];
                                ie && (ie.mc && (te.mc = ie.mc), ie.mcc && (te.mc = ie.mcc), ie.mlc && (te.mlc = ie.mlc), ie.mlcc && (te.mlc = ie.mlcc), ie.mlw && (te.mlw = ie.mlw), ie.mrc && (te.mrc = ie.mrc), ie.dir && (te.dir = ie.dir)), te._distinct = !0, $.entries.push([
                                    te
                                ]);
                            }
                        }
                        $.entries.sort(function(e, t) {
                            return e[0].trace.index - t[0].trace.index;
                        }), $.layer = p, $._inHover = !0, $._groupTitleFont = X.grouptitlefont, b(r, $);
                        var oe, le, se, ce, ue = p.select("g.legend"), fe = V(r, ue.node()), de = fe.width + 2 * L, he = fe.height + 2 * L, pe = W[0], ve = (pe.x0 + pe.x1) / 2, ge = (pe.y0 + pe.y1) / 2, ye = !(g.traceIs(pe.trace, "bar-like") || g.traceIs(pe.trace, "box-violin"));
                        "y" === C ? ye ? (le = ge - L, oe = ge + L) : (le = Math.min.apply(null, W.map(function(e) {
                            return Math.min(e.y0, e.y1);
                        })), oe = Math.max.apply(null, W.map(function(e) {
                            return Math.max(e.y0, e.y1);
                        }))) : le = oe = o.mean(W.map(function(e) {
                            return (e.y0 + e.y1) / 2;
                        })) - he / 2, "x" === C ? ye ? (se = ve + L, ce = ve - L) : (se = Math.max.apply(null, W.map(function(e) {
                            return Math.max(e.x0, e.x1);
                        })), ce = Math.min.apply(null, W.map(function(e) {
                            return Math.min(e.x0, e.x1);
                        }))) : se = ce = o.mean(W.map(function(e) {
                            return (e.x0 + e.x1) / 2;
                        })) - de / 2;
                        var me, xe, be = S._offset, _e = D._offset;
                        return ce += be - de, le += _e - he, me = (se += be) + de < E && se >= 0 ? se : ce + de < E && ce >= 0 ? ce : be + de < E ? be : se - ve < ve - ce + de ? E - de : 0, me += L, xe = (oe += _e) + he < H && oe >= 0 ? oe : le + he < H && le >= 0 ? le : _e + he < H ? _e : oe - ge < ge - le + he ? H - he : 0, xe += L, ue.attr("transform", l(me - 1, xe - 1)), ue;
                    }
                    var we = p.selectAll("g.hovertext").data(e, function(e) {
                        return O(e);
                    });
                    return we.enter().append("g").classed("hovertext", !0).each(function() {
                        var e = n.select(this);
                        e.append("rect").call(h.fill, h.addOpacity(f, .8)), e.append("text").classed("name", !0), e.append("path").style("stroke-width", "1px"), e.append("text").classed("nums", !0).call(d.font, T, M);
                    }), we.exit().remove(), we.each(function(e) {
                        var t = n.select(this).attr("transform", ""), o = e.color;
                        Array.isArray(o) && (o = o[e.eventData[0].pointNumber]);
                        var p = e.bgcolor || o, v = h.combine(h.opacity(p) ? p : h.defaultLine, f), g = h.combine(h.opacity(o) ? o : h.defaultLine, f), y = e.borderColor || h.contrast(v), m = I(e, j, i, a, R, t), x = m[0], b = m[1], w = t.select("text.nums").call(d.font, e.fontFamily || T, e.fontSize || M, e.fontColor || y).text(x).attr("data-notex", 1).call(u.positionText, 0, 0).call(u.convertToTspans, r), k = t.select("text.name"), S = 0, D = 0;
                        if (b && b !== x) {
                            k.call(d.font, e.fontFamily || T, e.fontSize || M, g).text(b).attr("data-notex", 1).call(u.positionText, 0, 0).call(u.convertToTspans, r);
                            var O = V(r, k.node());
                            S = O.width + 2 * L, D = O.height + 2 * L;
                        } else k.remove(), t.select("rect").remove();
                        t.select("path").style({
                            fill: v,
                            stroke: y
                        });
                        var C = e.xa._offset + (e.x0 + e.x1) / 2, P = e.ya._offset + (e.y0 + e.y1) / 2, z = Math.abs(e.x1 - e.x0), N = Math.abs(e.y1 - e.y0), B = V(r, w.node()), Y = B.width / a._invScaleX, U = B.height / a._invScaleY;
                        e.ty0 = (F - B.top) / a._invScaleY, e.bx = Y + 2 * L, e.by = Math.max(U + 2 * L, D), e.anchor = "start", e.txwidth = Y, e.tx2width = S, e.offset = 0;
                        var q, G, Z = (Y + A + L + S) * a._invScaleX;
                        if (c) e.pos = C, q = P + N / 2 + Z <= H, G = P - N / 2 - Z >= 0, "top" !== e.idealAlign && q || !G ? q ? (P += N / 2, e.anchor = "start") : e.anchor = "middle" : (P -= N / 2, e.anchor = "end"), e.crossPos = P;
                        else {
                            if (e.pos = P, q = C + z / 2 + Z <= E, G = C - z / 2 - Z >= 0, "left" !== e.idealAlign && q || !G) {
                                if (q) C += z / 2, e.anchor = "start";
                                else {
                                    e.anchor = "middle";
                                    var W = Z / 2, X = C + W - E, J = C - W;
                                    X > 0 && (C -= X), J < 0 && (C += -J);
                                }
                            } else C -= z / 2, e.anchor = "end";
                            e.crossPos = C;
                        }
                        w.attr("text-anchor", e.anchor), S && k.attr("text-anchor", e.anchor), t.attr("transform", l(C, P) + (c ? s(_) : ""));
                    }), {
                        hoverLabels: we,
                        commonLabelBoundingBox: Z
                    };
                }
                function I(e, t, r, n, a, i) {
                    var l = "", s = "";
                    void 0 !== e.nameOverride && (e.name = e.nameOverride), e.name && (e.trace._meta && (e.name = o.templateString(e.name, e.trace._meta)), l = H(e.name, e.nameLength));
                    var c = r.charAt(0), u = "x" === c ? "y" : "x";
                    void 0 !== e.zLabel ? (void 0 !== e.xLabel && (s += "x: " + e.xLabel + "<br>"), void 0 !== e.yLabel && (s += "y: " + e.yLabel + "<br>"), "choropleth" !== e.trace.type && "choroplethmapbox" !== e.trace.type && (s += (s ? "z: " : "") + e.zLabel)) : t && e[c + "Label"] === a ? s = e[u + "Label"] || "" : void 0 === e.xLabel ? void 0 !== e.yLabel && "scattercarpet" !== e.trace.type && (s = e.yLabel) : s = void 0 === e.yLabel ? e.xLabel : "(" + e.xLabel + ", " + e.yLabel + ")", !e.text && 0 !== e.text || Array.isArray(e.text) || (s += (s ? "<br>" : "") + e.text), void 0 !== e.extraText && (s += (s ? "<br>" : "") + e.extraText), i && "" === s && !e.hovertemplate && ("" === l && i.remove(), s = l);
                    var f = e.hovertemplate || !1;
                    if (f) {
                        var d = e.hovertemplateLabels || e;
                        e[c + "Label"] !== a && (d[c + "other"] = d[c + "Val"], d[c + "otherLabel"] = d[c + "Label"]), s = (s = o.hovertemplateString(f, d, n._d3locale, e.eventData[0] || {}, e.trace._meta)).replace(C, function(t, r) {
                            return l = H(r, e.nameLength), "";
                        });
                    }
                    return [
                        s,
                        l
                    ];
                }
                function R(e, t) {
                    var r = 0, n = e.offset;
                    return t && (n *= -k, r = e.offset * M), {
                        x: r,
                        y: n
                    };
                }
                function z(e, t, r, a) {
                    var i = function(e) {
                        return e * r;
                    }, o = function(e) {
                        return e * a;
                    };
                    e.each(function(e) {
                        var r = n.select(this);
                        if (e.del) return r.remove();
                        var a, l, s, c, f = r.select("text.nums"), h = e.anchor, p = "end" === h ? -1 : 1, v = (c = (s = (l = ({
                            start: 1,
                            end: -1,
                            middle: 0
                        })[(a = e).anchor]) * (A + L)) + l * (a.txwidth + L), "middle" === a.anchor && (s -= a.tx2width / 2, c += a.txwidth / 2 + L), {
                            alignShift: l,
                            textShiftX: s,
                            text2ShiftX: c
                        }), g = R(e, t), y = g.x, m = g.y, x = "middle" === h;
                        r.select("path").attr("d", x ? "M-" + i(e.bx / 2 + e.tx2width / 2) + "," + o(m - e.by / 2) + "h" + i(e.bx) + "v" + o(e.by) + "h-" + i(e.bx) + "Z" : "M0,0L" + i(p * A + y) + "," + o(A + m) + "v" + o(e.by / 2 - A) + "h" + i(p * e.bx) + "v-" + o(e.by) + "H" + i(p * A + y) + "V" + o(m - A) + "Z");
                        var b = y + v.textShiftX, _ = m + e.ty0 - e.by / 2 + L, w = e.textAlign || "auto";
                        "auto" !== w && ("left" === w && "start" !== h ? (f.attr("text-anchor", "start"), b = x ? -e.bx / 2 - e.tx2width / 2 + L : -e.bx - L) : "right" === w && "end" !== h && (f.attr("text-anchor", "end"), b = x ? e.bx / 2 - e.tx2width / 2 - L : e.bx + L)), f.call(u.positionText, i(b), o(_)), e.tx2width && (r.select("text.name").call(u.positionText, i(v.text2ShiftX + v.alignShift * L + y), o(m + e.ty0 - e.by / 2 + L)), r.select("rect").call(d.setRect, i(v.text2ShiftX + (v.alignShift - 1) * e.tx2width / 2 + y), o(m - e.by / 2 - 1), i(e.tx2width), o(e.by + 2)));
                    });
                }
                function N(e, t) {
                    var r = e.index, n = e.trace || {}, i = e.cd[0], l = e.cd[r] || {};
                    function s(e) {
                        return e || a(e) && 0 === e;
                    }
                    var c = Array.isArray(r) ? function(e, t) {
                        var a = o.castOption(i, r, e);
                        return s(a) ? a : o.extractOption({}, n, "", t);
                    } : function(e, t) {
                        return o.extractOption(l, n, e, t);
                    };
                    function u(t, r, n) {
                        var a = c(r, n);
                        s(a) && (e[t] = a);
                    }
                    if (u("hoverinfo", "hi", "hoverinfo"), u("bgcolor", "hbg", "hoverlabel.bgcolor"), u("borderColor", "hbc", "hoverlabel.bordercolor"), u("fontFamily", "htf", "hoverlabel.font.family"), u("fontSize", "hts", "hoverlabel.font.size"), u("fontColor", "htc", "hoverlabel.font.color"), u("nameLength", "hnl", "hoverlabel.namelength"), u("textAlign", "hta", "hoverlabel.align"), e.posref = "y" === t || "closest" === t && "h" === n.orientation ? e.xa._offset + (e.x0 + e.x1) / 2 : e.ya._offset + (e.y0 + e.y1) / 2, e.x0 = o.constrain(e.x0, 0, e.xa._length), e.x1 = o.constrain(e.x1, 0, e.xa._length), e.y0 = o.constrain(e.y0, 0, e.ya._length), e.y1 = o.constrain(e.y1, 0, e.ya._length), void 0 !== e.xLabelVal && (e.xLabel = "xLabel" in e ? e.xLabel : v.hoverLabelText(e.xa, e.xLabelVal, n.xhoverformat), e.xVal = e.xa.c2d(e.xLabelVal)), void 0 !== e.yLabelVal && (e.yLabel = "yLabel" in e ? e.yLabel : v.hoverLabelText(e.ya, e.yLabelVal, n.yhoverformat), e.yVal = e.ya.c2d(e.yLabelVal)), void 0 !== e.zLabelVal && void 0 === e.zLabel && (e.zLabel = String(e.zLabelVal)), !(isNaN(e.xerr) || "log" === e.xa.type && e.xerr <= 0)) {
                        var f = v.tickText(e.xa, e.xa.c2l(e.xerr), "hover").text;
                        void 0 !== e.xerrneg ? e.xLabel += " +" + f + " / -" + v.tickText(e.xa, e.xa.c2l(e.xerrneg), "hover").text : e.xLabel += " \xb1 " + f, "x" === t && (e.distance += 1);
                    }
                    if (!(isNaN(e.yerr) || "log" === e.ya.type && e.yerr <= 0)) {
                        var d = v.tickText(e.ya, e.ya.c2l(e.yerr), "hover").text;
                        void 0 !== e.yerrneg ? e.yLabel += " +" + d + " / -" + v.tickText(e.ya, e.ya.c2l(e.yerrneg), "hover").text : e.yLabel += " \xb1 " + d, "y" === t && (e.distance += 1);
                    }
                    var h = e.hoverinfo || e.trace.hoverinfo;
                    return h && "all" !== h && (-1 === (h = Array.isArray(h) ? h : h.split("+")).indexOf("x") && (e.xLabel = void 0), -1 === h.indexOf("y") && (e.yLabel = void 0), -1 === h.indexOf("z") && (e.zLabel = void 0), -1 === h.indexOf("text") && (e.text = void 0), -1 === h.indexOf("name") && (e.name = void 0)), e;
                }
                function F(e, t, r) {
                    var n, a, o = r.container, l = r.fullLayout, s = l._size, c = r.event, u = !!t.hLinePoint, f = !!t.vLinePoint;
                    if (o.selectAll(".spikeline").remove(), f || u) {
                        var p = h.combine(l.plot_bgcolor, l.paper_bgcolor);
                        if (u) {
                            var g, y, m = t.hLinePoint;
                            n = m && m.xa, "cursor" === (a = m && m.ya).spikesnap ? (g = c.pointerX, y = c.pointerY) : (g = n._offset + m.x, y = a._offset + m.y);
                            var x, b, _ = i.readability(m.color, p) < 1.5 ? h.contrast(p) : m.color, w = a.spikemode, T = a.spikethickness, M = a.spikecolor || _, k = v.getPxPosition(e, a);
                            if (-1 !== w.indexOf("toaxis") || -1 !== w.indexOf("across")) {
                                if (-1 !== w.indexOf("toaxis") && (x = k, b = g), -1 !== w.indexOf("across")) {
                                    var A = a._counterDomainMin, L = a._counterDomainMax;
                                    "free" === a.anchor && (A = Math.min(A, a.position), L = Math.max(L, a.position)), x = s.l + A * s.w, b = s.l + L * s.w;
                                }
                                o.insert("line", ":first-child").attr({
                                    x1: x,
                                    x2: b,
                                    y1: y,
                                    y2: y,
                                    "stroke-width": T,
                                    stroke: M,
                                    "stroke-dasharray": d.dashStyle(a.spikedash, T)
                                }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                                    x1: x,
                                    x2: b,
                                    y1: y,
                                    y2: y,
                                    "stroke-width": T + 2,
                                    stroke: p
                                }).classed("spikeline", !0).classed("crisp", !0);
                            }
                            -1 !== w.indexOf("marker") && o.insert("circle", ":first-child").attr({
                                cx: k + ("right" !== a.side ? T : -T),
                                cy: y,
                                r: T,
                                fill: M
                            }).classed("spikeline", !0);
                        }
                        if (f) {
                            var S, D, O = t.vLinePoint;
                            n = O && O.xa, a = O && O.ya, "cursor" === n.spikesnap ? (S = c.pointerX, D = c.pointerY) : (S = n._offset + O.x, D = a._offset + O.y);
                            var C, P, I = i.readability(O.color, p) < 1.5 ? h.contrast(p) : O.color, R = n.spikemode, z = n.spikethickness, N = n.spikecolor || I, F = v.getPxPosition(e, n);
                            if (-1 !== R.indexOf("toaxis") || -1 !== R.indexOf("across")) {
                                if (-1 !== R.indexOf("toaxis") && (C = F, P = D), -1 !== R.indexOf("across")) {
                                    var E = n._counterDomainMin, H = n._counterDomainMax;
                                    "free" === n.anchor && (E = Math.min(E, n.position), H = Math.max(H, n.position)), C = s.t + (1 - H) * s.h, P = s.t + (1 - E) * s.h;
                                }
                                o.insert("line", ":first-child").attr({
                                    x1: S,
                                    x2: S,
                                    y1: C,
                                    y2: P,
                                    "stroke-width": z,
                                    stroke: N,
                                    "stroke-dasharray": d.dashStyle(n.spikedash, z)
                                }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                                    x1: S,
                                    x2: S,
                                    y1: C,
                                    y2: P,
                                    "stroke-width": z + 2,
                                    stroke: p
                                }).classed("spikeline", !0).classed("crisp", !0);
                            }
                            -1 !== R.indexOf("marker") && o.insert("circle", ":first-child").attr({
                                cx: S,
                                cy: F - ("top" !== n.side ? z : -z),
                                r: z,
                                fill: N
                            }).classed("spikeline", !0);
                        }
                    }
                }
                function E(e, t) {
                    return !t || t.vLinePoint !== e._spikepoints.vLinePoint || t.hLinePoint !== e._spikepoints.hLinePoint;
                }
                function H(e, t) {
                    return u.plainText(e || "", {
                        len: t,
                        allowedTags: [
                            "br",
                            "sub",
                            "sup",
                            "b",
                            "i",
                            "em"
                        ]
                    });
                }
                function j(e, t, r) {
                    var n = t[e + "a"], a = t[e + "Val"], i = t.cd[0];
                    if ("category" === n.type || "multicategory" === n.type) a = n._categoriesMap[a];
                    else if ("date" === n.type) {
                        var o = t.trace[e + "periodalignment"];
                        if (o) {
                            var l = t.cd[t.index], s = l[e + "Start"];
                            void 0 === s && (s = l[e]);
                            var c = l[e + "End"];
                            void 0 === c && (c = l[e]);
                            var u = c - s;
                            "end" === o ? a += u : "middle" === o && (a += u / 2);
                        }
                        a = n.d2c(a);
                    }
                    return i && i.t && i.t.posLetter === n._id && ("group" !== r.boxmode && "group" !== r.violinmode || (a += i.t.dPos)), a;
                }
                function B(e) {
                    return e.offsetTop + e.clientTop;
                }
                function Y(e) {
                    return e.offsetLeft + e.clientLeft;
                }
                function V(e, t) {
                    var r = e._fullLayout, n = t.getBoundingClientRect(), a = n.left, i = n.top, l = a + n.width, s = i + n.height, c = o.apply3DTransform(r._invTransform)(a, i), u = o.apply3DTransform(r._invTransform)(l, s), f = c[0], d = c[1], h = u[0], p = u[1];
                    return {
                        x: f,
                        y: d,
                        width: h - f,
                        height: p - d,
                        top: Math.min(d, p),
                        left: Math.min(f, h),
                        right: Math.max(f, h),
                        bottom: Math.max(d, p)
                    };
                }
            },
            8048: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(7901), i = r(3469).isUnifiedHover;
                e.exports = function(e, t, r, o) {
                    o = o || {};
                    var l = t.legend;
                    function s(e) {
                        o.font[e] || (o.font[e] = l ? t.legend.font[e] : t.font[e]);
                    }
                    t && i(t.hovermode) && (o.font || (o.font = {}), s("size"), s("family"), s("color"), l ? (o.bgcolor || (o.bgcolor = a.combine(t.legend.bgcolor, t.paper_bgcolor)), o.bordercolor || (o.bordercolor = t.legend.bordercolor)) : o.bgcolor || (o.bgcolor = t.paper_bgcolor)), r("hoverlabel.bgcolor", o.bgcolor), r("hoverlabel.bordercolor", o.bordercolor), r("hoverlabel.namelength", o.namelength), n.coerceFont(r, "hoverlabel.font", o.font), r("hoverlabel.align", o.align);
                };
            },
            8212: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(528);
                e.exports = function(e, t) {
                    function r(r, i) {
                        return void 0 !== t[r] ? t[r] : n.coerce(e, t, a, r, i);
                    }
                    return r("clickmode"), r("hovermode");
                };
            },
            211: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(1828), i = r(8569), o = r(3469), l = r(528), s = r(8335);
                e.exports = {
                    moduleType: "component",
                    name: "fx",
                    constants: r(6675),
                    schema: {
                        layout: l
                    },
                    attributes: r(7914),
                    layoutAttributes: l,
                    supplyLayoutGlobalDefaults: r(2774),
                    supplyDefaults: r(4268),
                    supplyLayoutDefaults: r(4938),
                    calc: r(732),
                    getDistanceFunction: o.getDistanceFunction,
                    getClosest: o.getClosest,
                    inbox: o.inbox,
                    quadrature: o.quadrature,
                    appendArrayPointValue: o.appendArrayPointValue,
                    castHoverOption: function(e, t, r) {
                        return a.castOption(e, t, "hoverlabel." + r);
                    },
                    castHoverinfo: function(e, t, r) {
                        return a.castOption(e, r, "hoverinfo", function(r) {
                            return a.coerceHoverinfo({
                                hoverinfo: r
                            }, {
                                _module: e._module
                            }, t);
                        });
                    },
                    hover: s.hover,
                    unhover: i.unhover,
                    loneHover: s.loneHover,
                    loneUnhover: function(e) {
                        var t = a.isD3Selection(e) ? e : n.select(e);
                        t.selectAll("g.hovertext").remove(), t.selectAll(".spikeline").remove();
                    },
                    click: r(5914)
                };
            },
            528: function(e, t, r) {
                "use strict";
                var n = r(6675), a = r(1940), i = a({
                    editType: "none"
                });
                i.family.dflt = n.HOVERFONT, i.size.dflt = n.HOVERFONTSIZE, e.exports = {
                    clickmode: {
                        valType: "flaglist",
                        flags: [
                            "event",
                            "select"
                        ],
                        dflt: "event",
                        editType: "plot",
                        extras: [
                            "none"
                        ]
                    },
                    dragmode: {
                        valType: "enumerated",
                        values: [
                            "zoom",
                            "pan",
                            "select",
                            "lasso",
                            "drawclosedpath",
                            "drawopenpath",
                            "drawline",
                            "drawrect",
                            "drawcircle",
                            "orbit",
                            "turntable",
                            !1
                        ],
                        dflt: "zoom",
                        editType: "modebar"
                    },
                    hovermode: {
                        valType: "enumerated",
                        values: [
                            "x",
                            "y",
                            "closest",
                            !1,
                            "x unified",
                            "y unified"
                        ],
                        dflt: "closest",
                        editType: "modebar"
                    },
                    hoverdistance: {
                        valType: "integer",
                        min: -1,
                        dflt: 20,
                        editType: "none"
                    },
                    spikedistance: {
                        valType: "integer",
                        min: -1,
                        dflt: -1,
                        editType: "none"
                    },
                    hoverlabel: {
                        bgcolor: {
                            valType: "color",
                            editType: "none"
                        },
                        bordercolor: {
                            valType: "color",
                            editType: "none"
                        },
                        font: i,
                        grouptitlefont: a({
                            editType: "none"
                        }),
                        align: {
                            valType: "enumerated",
                            values: [
                                "left",
                                "right",
                                "auto"
                            ],
                            dflt: "auto",
                            editType: "none"
                        },
                        namelength: {
                            valType: "integer",
                            min: -1,
                            dflt: 15,
                            editType: "none"
                        },
                        editType: "none"
                    },
                    selectdirection: {
                        valType: "enumerated",
                        values: [
                            "h",
                            "v",
                            "d",
                            "any"
                        ],
                        dflt: "any",
                        editType: "none"
                    }
                };
            },
            4938: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(528), i = r(8212), o = r(8048);
                e.exports = function(e, t) {
                    function r(r, i) {
                        return n.coerce(e, t, a, r, i);
                    }
                    i(e, t) && (r("hoverdistance"), r("spikedistance")), "select" === r("dragmode") && r("selectdirection");
                    var l = t._has("mapbox"), s = t._has("geo"), c = t._basePlotModules.length;
                    "zoom" === t.dragmode && ((l || s) && 1 === c || l && s && 2 === c) && (t.dragmode = "pan"), o(e, t, r), n.coerceFont(r, "hoverlabel.grouptitlefont", t.hoverlabel.font);
                };
            },
            2774: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(8048), i = r(528);
                e.exports = function(e, t) {
                    a(e, t, function(r, a) {
                        return n.coerce(e, t, i, r, a);
                    });
                };
            },
            3312: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(587).counter, i = r(7670).Y, o = r(5555).idRegex, l = r(4467), s = {
                    rows: {
                        valType: "integer",
                        min: 1,
                        editType: "plot"
                    },
                    roworder: {
                        valType: "enumerated",
                        values: [
                            "top to bottom",
                            "bottom to top"
                        ],
                        dflt: "top to bottom",
                        editType: "plot"
                    },
                    columns: {
                        valType: "integer",
                        min: 1,
                        editType: "plot"
                    },
                    subplots: {
                        valType: "info_array",
                        freeLength: !0,
                        dimensions: 2,
                        items: {
                            valType: "enumerated",
                            values: [
                                a("xy").toString(),
                                ""
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    xaxes: {
                        valType: "info_array",
                        freeLength: !0,
                        items: {
                            valType: "enumerated",
                            values: [
                                o.x.toString(),
                                ""
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    yaxes: {
                        valType: "info_array",
                        freeLength: !0,
                        items: {
                            valType: "enumerated",
                            values: [
                                o.y.toString(),
                                ""
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    pattern: {
                        valType: "enumerated",
                        values: [
                            "independent",
                            "coupled"
                        ],
                        dflt: "coupled",
                        editType: "plot"
                    },
                    xgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "plot"
                    },
                    ygap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "plot"
                    },
                    domain: i({
                        name: "grid",
                        editType: "plot",
                        noGridCell: !0
                    }, {}),
                    xside: {
                        valType: "enumerated",
                        values: [
                            "bottom",
                            "bottom plot",
                            "top plot",
                            "top"
                        ],
                        dflt: "bottom plot",
                        editType: "plot"
                    },
                    yside: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "left plot",
                            "right plot",
                            "right"
                        ],
                        dflt: "left plot",
                        editType: "plot"
                    },
                    editType: "plot"
                };
                function c(e, t, r) {
                    var n = t[r + "axes"], a = Object.keys((e._splomAxes || {})[r] || {});
                    return Array.isArray(n) ? n : a.length ? a : void 0;
                }
                function u(e, t, r, n, a, i) {
                    var o = t(e + "gap", r), l = t("domain." + e);
                    t(e + "side", n);
                    for(var s = new Array(a), c = l[0], u = (l[1] - c) / (a - o), f = u * (1 - o), d = 0; d < a; d++){
                        var h = c + u * d;
                        s[i ? a - 1 - d : d] = [
                            h,
                            h + f
                        ];
                    }
                    return s;
                }
                function f(e, t, r, n, a) {
                    var i, o = new Array(r);
                    function l(e, r) {
                        -1 !== t.indexOf(r) && void 0 === n[r] ? (o[e] = r, n[r] = e) : o[e] = "";
                    }
                    if (Array.isArray(e)) for(i = 0; i < r; i++)l(i, e[i]);
                    else for(l(0, a), i = 1; i < r; i++)l(i, a + (i + 1));
                    return o;
                }
                e.exports = {
                    moduleType: "component",
                    name: "grid",
                    schema: {
                        layout: {
                            grid: s
                        }
                    },
                    layoutAttributes: s,
                    sizeDefaults: function(e, t) {
                        var r = e.grid || {}, a = c(t, r, "x"), i = c(t, r, "y");
                        if (e.grid || a || i) {
                            var o, f, d = Array.isArray(r.subplots) && Array.isArray(r.subplots[0]), h = Array.isArray(a), p = Array.isArray(i), v = h && a !== r.xaxes && p && i !== r.yaxes;
                            d ? (o = r.subplots.length, f = r.subplots[0].length) : (p && (o = i.length), h && (f = a.length));
                            var g = l.newContainer(t, "grid"), y = M("rows", o), m = M("columns", f);
                            if (y * m > 1) {
                                d || h || p || "independent" === M("pattern") && (d = !0), g._hasSubplotGrid = d;
                                var x, b, _ = "top to bottom" === M("roworder"), w = d ? .2 : .1, T = d ? .3 : .1;
                                v && t._splomGridDflt && (x = t._splomGridDflt.xside, b = t._splomGridDflt.yside), g._domains = {
                                    x: u("x", M, w, x, m),
                                    y: u("y", M, T, b, y, _)
                                };
                            } else delete t.grid;
                        }
                        function M(e, t) {
                            return n.coerce(r, g, s, e, t);
                        }
                    },
                    contentDefaults: function(e, t) {
                        var r = t.grid;
                        if (r && r._domains) {
                            var n, a, i, o, l, s, u, d = e.grid || {}, h = t._subplots, p = r._hasSubplotGrid, v = r.rows, g = r.columns, y = "independent" === r.pattern, m = r._axisMap = {};
                            if (p) {
                                var x = d.subplots || [];
                                s = r.subplots = new Array(v);
                                var b = 1;
                                for(n = 0; n < v; n++){
                                    var _ = s[n] = new Array(g), w = x[n] || [];
                                    for(a = 0; a < g; a++)if (y ? (l = 1 === b ? "xy" : "x" + b + "y" + b, b++) : l = w[a], _[a] = "", -1 !== h.cartesian.indexOf(l)) {
                                        if (u = l.indexOf("y"), i = l.slice(0, u), o = l.slice(u), void 0 !== m[i] && m[i] !== a || void 0 !== m[o] && m[o] !== n) continue;
                                        _[a] = l, m[i] = a, m[o] = n;
                                    }
                                }
                            } else {
                                var T = c(t, d, "x"), M = c(t, d, "y");
                                r.xaxes = f(T, h.xaxis, g, m, "x"), r.yaxes = f(M, h.yaxis, v, m, "y");
                            }
                            var k = r._anchors = {}, A = "top to bottom" === r.roworder;
                            for(var L in m){
                                var S, D, O, C = L.charAt(0), P = r[C + "side"];
                                if (P.length < 8) k[L] = "free";
                                else if ("x" === C) {
                                    if ("t" === P.charAt(0) === A ? (S = 0, D = 1, O = v) : (S = v - 1, D = -1, O = -1), p) {
                                        var I = m[L];
                                        for(n = S; n !== O; n += D)if ((l = s[n][I]) && (u = l.indexOf("y"), l.slice(0, u) === L)) {
                                            k[L] = l.slice(u);
                                            break;
                                        }
                                    } else for(n = S; n !== O; n += D)if (o = r.yaxes[n], -1 !== h.cartesian.indexOf(L + o)) {
                                        k[L] = o;
                                        break;
                                    }
                                } else if ("l" === P.charAt(0) ? (S = 0, D = 1, O = g) : (S = g - 1, D = -1, O = -1), p) {
                                    var R = m[L];
                                    for(n = S; n !== O; n += D)if ((l = s[R][n]) && (u = l.indexOf("y"), l.slice(u) === L)) {
                                        k[L] = l.slice(0, u);
                                        break;
                                    }
                                } else for(n = S; n !== O; n += D)if (i = r.xaxes[n], -1 !== h.cartesian.indexOf(i + L)) {
                                    k[L] = i;
                                    break;
                                }
                            }
                        }
                    }
                };
            },
            9819: function(e, t, r) {
                "use strict";
                var n = r(5555), a = r(4467).templatedArray;
                r(4695), e.exports = a("image", {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "arraydraw"
                    },
                    source: {
                        valType: "string",
                        editType: "arraydraw"
                    },
                    layer: {
                        valType: "enumerated",
                        values: [
                            "below",
                            "above"
                        ],
                        dflt: "above",
                        editType: "arraydraw"
                    },
                    sizex: {
                        valType: "number",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    sizey: {
                        valType: "number",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    sizing: {
                        valType: "enumerated",
                        values: [
                            "fill",
                            "contain",
                            "stretch"
                        ],
                        dflt: "contain",
                        editType: "arraydraw"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    x: {
                        valType: "any",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    y: {
                        valType: "any",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left",
                        editType: "arraydraw"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "top",
                        editType: "arraydraw"
                    },
                    xref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            n.idRegex.x.toString()
                        ],
                        dflt: "paper",
                        editType: "arraydraw"
                    },
                    yref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            n.idRegex.y.toString()
                        ],
                        dflt: "paper",
                        editType: "arraydraw"
                    },
                    editType: "arraydraw"
                });
            },
            5378: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(8163);
                e.exports = function(e, t, r, i) {
                    t = t || {};
                    var o = "log" === r && "linear" === t.type, l = "linear" === r && "log" === t.type;
                    if (o || l) {
                        for(var s, c, u = e._fullLayout.images, f = t._id.charAt(0), d = 0; d < u.length; d++)if (c = "images[" + d + "].", (s = u[d])[f + "ref"] === t._id) {
                            var h = s[f], p = s["size" + f], v = null, g = null;
                            if (o) {
                                v = a(h, t.range);
                                var y = p / Math.pow(10, v) / 2;
                                g = 2 * Math.log(y + Math.sqrt(1 + y * y)) / Math.LN10;
                            } else g = (v = Math.pow(10, h)) * (Math.pow(10, p / 2) - Math.pow(10, -p / 2));
                            n(v) ? n(g) || (g = null) : (v = null, g = null), i(c + f, v), i(c + "size" + f, g);
                        }
                    }
                };
            },
            1603: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(9298), i = r(5501), o = r(9819);
                function l(e, t, r) {
                    function i(r, a) {
                        return n.coerce(e, t, o, r, a);
                    }
                    var l = i("source");
                    if (!i("visible", !!l)) return t;
                    i("layer"), i("xanchor"), i("yanchor"), i("sizex"), i("sizey"), i("sizing"), i("opacity");
                    for(var s = {
                        _fullLayout: r
                    }, c = [
                        "x",
                        "y"
                    ], u = 0; u < 2; u++){
                        var f = c[u], d = a.coerceRef(e, t, s, f, "paper", void 0);
                        "paper" !== d && a.getFromId(s, d)._imgIndices.push(t._index), a.coercePosition(t, s, i, d, f, 0);
                    }
                    return t;
                }
                e.exports = function(e, t) {
                    i(e, t, {
                        name: "images",
                        handleItemDefaults: l
                    });
                };
            },
            750: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(1424), i = r(9298), o = r(1675), l = r(7922);
                e.exports = function(e) {
                    var t, r, s = e._fullLayout, c = [], u = {}, f = [];
                    for(r = 0; r < s.images.length; r++){
                        var d = s.images[r];
                        if (d.visible) {
                            if ("below" === d.layer && "paper" !== d.xref && "paper" !== d.yref) {
                                t = o.ref2id(d.xref) + o.ref2id(d.yref);
                                var h = s._plots[t];
                                if (!h) {
                                    f.push(d);
                                    continue;
                                }
                                h.mainplot && (t = h.mainplot.id), u[t] || (u[t] = []), u[t].push(d);
                            } else "above" === d.layer ? c.push(d) : f.push(d);
                        }
                    }
                    var p = {
                        left: {
                            sizing: "xMin",
                            offset: 0
                        },
                        center: {
                            sizing: "xMid",
                            offset: -0.5
                        },
                        right: {
                            sizing: "xMax",
                            offset: -1
                        }
                    }, v = {
                        top: {
                            sizing: "YMin",
                            offset: 0
                        },
                        middle: {
                            sizing: "YMid",
                            offset: -0.5
                        },
                        bottom: {
                            sizing: "YMax",
                            offset: -1
                        }
                    };
                    function g(t) {
                        var r = n.select(this);
                        if (this._imgSrc !== t.source) {
                            if (r.attr("xmlns", l.svg), t.source && "data:" === t.source.slice(0, 5)) r.attr("xlink:href", t.source), this._imgSrc = t.source;
                            else {
                                var a = new Promise((function(e) {
                                    var n = new Image;
                                    function a() {
                                        r.remove(), e();
                                    }
                                    this.img = n, n.setAttribute("crossOrigin", "anonymous"), n.onerror = a, n.onload = function() {
                                        var t = document.createElement("canvas");
                                        t.width = this.width, t.height = this.height, t.getContext("2d", {
                                            willReadFrequently: !0
                                        }).drawImage(this, 0, 0);
                                        var n = t.toDataURL("image/png");
                                        r.attr("xlink:href", n), e();
                                    }, r.on("error", a), n.src = t.source, this._imgSrc = t.source;
                                }).bind(this));
                                e._promises.push(a);
                            }
                        }
                    }
                    function y(t) {
                        var r, o, l = n.select(this), c = i.getFromId(e, t.xref), u = i.getFromId(e, t.yref), f = "domain" === i.getRefType(t.xref), d = "domain" === i.getRefType(t.yref), h = s._size;
                        r = void 0 !== c ? "string" == typeof t.xref && f ? c._length * t.sizex : Math.abs(c.l2p(t.sizex) - c.l2p(0)) : t.sizex * h.w, o = void 0 !== u ? "string" == typeof t.yref && d ? u._length * t.sizey : Math.abs(u.l2p(t.sizey) - u.l2p(0)) : t.sizey * h.h;
                        var g, y, m = r * p[t.xanchor].offset, x = o * v[t.yanchor].offset, b = p[t.xanchor].sizing + v[t.yanchor].sizing;
                        switch(g = void 0 !== c ? "string" == typeof t.xref && f ? c._length * t.x + c._offset : c.r2p(t.x) + c._offset : t.x * h.w + h.l, g += m, y = void 0 !== u ? "string" == typeof t.yref && d ? u._length * (1 - t.y) + u._offset : u.r2p(t.y) + u._offset : h.h - t.y * h.h + h.t, y += x, t.sizing){
                            case "fill":
                                b += " slice";
                                break;
                            case "stretch":
                                b = "none";
                        }
                        l.attr({
                            x: g,
                            y: y,
                            width: r,
                            height: o,
                            preserveAspectRatio: b,
                            opacity: t.opacity
                        });
                        var _ = (c && "domain" !== i.getRefType(t.xref) ? c._id : "") + (u && "domain" !== i.getRefType(t.yref) ? u._id : "");
                        a.setClipUrl(l, _ ? "clip" + s._uid + _ : null, e);
                    }
                    var m = s._imageLowerLayer.selectAll("image").data(f), x = s._imageUpperLayer.selectAll("image").data(c);
                    m.enter().append("image"), x.enter().append("image"), m.exit().remove(), x.exit().remove(), m.each(function(e) {
                        g.bind(this)(e), y.bind(this)(e);
                    }), x.each(function(e) {
                        g.bind(this)(e), y.bind(this)(e);
                    });
                    var b = Object.keys(s._plots);
                    for(r = 0; r < b.length; r++){
                        t = b[r];
                        var _ = s._plots[t];
                        if (_.imagelayer) {
                            var w = _.imagelayer.selectAll("image").data(u[t] || []);
                            w.enter().append("image"), w.exit().remove(), w.each(function(e) {
                                g.bind(this)(e), y.bind(this)(e);
                            });
                        }
                    }
                };
            },
            8804: function(e, t, r) {
                "use strict";
                e.exports = {
                    moduleType: "component",
                    name: "images",
                    layoutAttributes: r(9819),
                    supplyLayoutDefaults: r(1603),
                    includeBasePlot: r(6325)("images"),
                    draw: r(750),
                    convertCoords: r(5378)
                };
            },
            3030: function(e, t, r) {
                "use strict";
                var n = r(1940), a = r(2399);
                e.exports = {
                    _isSubplotObj: !0,
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "legend"
                    },
                    bgcolor: {
                        valType: "color",
                        editType: "legend"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: a.defaultLine,
                        editType: "legend"
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "legend"
                    },
                    font: n({
                        editType: "legend"
                    }),
                    grouptitlefont: n({
                        editType: "legend"
                    }),
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        dflt: "v",
                        editType: "legend"
                    },
                    traceorder: {
                        valType: "flaglist",
                        flags: [
                            "reversed",
                            "grouped"
                        ],
                        extras: [
                            "normal"
                        ],
                        editType: "legend"
                    },
                    tracegroupgap: {
                        valType: "number",
                        min: 0,
                        dflt: 10,
                        editType: "legend"
                    },
                    entrywidth: {
                        valType: "number",
                        min: 0,
                        editType: "legend"
                    },
                    entrywidthmode: {
                        valType: "enumerated",
                        values: [
                            "fraction",
                            "pixels"
                        ],
                        dflt: "pixels",
                        editType: "legend"
                    },
                    itemsizing: {
                        valType: "enumerated",
                        values: [
                            "trace",
                            "constant"
                        ],
                        dflt: "trace",
                        editType: "legend"
                    },
                    itemwidth: {
                        valType: "number",
                        min: 30,
                        dflt: 30,
                        editType: "legend"
                    },
                    itemclick: {
                        valType: "enumerated",
                        values: [
                            "toggle",
                            "toggleothers",
                            !1
                        ],
                        dflt: "toggle",
                        editType: "legend"
                    },
                    itemdoubleclick: {
                        valType: "enumerated",
                        values: [
                            "toggle",
                            "toggleothers",
                            !1
                        ],
                        dflt: "toggleothers",
                        editType: "legend"
                    },
                    groupclick: {
                        valType: "enumerated",
                        values: [
                            "toggleitem",
                            "togglegroup"
                        ],
                        dflt: "togglegroup",
                        editType: "legend"
                    },
                    x: {
                        valType: "number",
                        editType: "legend"
                    },
                    xref: {
                        valType: "enumerated",
                        dflt: "paper",
                        values: [
                            "container",
                            "paper"
                        ],
                        editType: "layoutstyle"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left",
                        editType: "legend"
                    },
                    y: {
                        valType: "number",
                        editType: "legend"
                    },
                    yref: {
                        valType: "enumerated",
                        dflt: "paper",
                        values: [
                            "container",
                            "paper"
                        ],
                        editType: "layoutstyle"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        editType: "legend"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    valign: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "middle",
                        editType: "legend"
                    },
                    title: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "legend"
                        },
                        font: n({
                            editType: "legend"
                        }),
                        side: {
                            valType: "enumerated",
                            values: [
                                "top",
                                "left",
                                "top left",
                                "top center",
                                "top right"
                            ],
                            editType: "legend"
                        },
                        editType: "legend"
                    },
                    editType: "legend"
                };
            },
            4928: function(e) {
                "use strict";
                e.exports = {
                    scrollBarWidth: 6,
                    scrollBarMinHeight: 20,
                    scrollBarColor: "#808BA4",
                    scrollBarMargin: 4,
                    scrollBarEnterAttrs: {
                        rx: 20,
                        ry: 3,
                        width: 0,
                        height: 0
                    },
                    titlePad: 2,
                    itemGap: 5
                };
            },
            9017: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(1828), i = r(4467), o = r(9012), l = r(3030), s = r(820), c = r(130);
                function u(e, t, r, u) {
                    var f = t[e] || {}, d = i.newContainer(r, e);
                    function h(e, t) {
                        return a.coerce(f, d, l, e, t);
                    }
                    var p = a.coerceFont(h, "font", r.font);
                    if (h("bgcolor", r.paper_bgcolor), h("bordercolor"), h("visible")) {
                        for(var v, g = function(e, t) {
                            var r = v._input, n = v;
                            return a.coerce(r, n, o, e, t);
                        }, y = r.font || {}, m = a.coerceFont(h, "grouptitlefont", a.extendFlat({}, y, {
                            size: Math.round(1.1 * y.size)
                        })), x = 0, b = !1, _ = "normal", w = (r.shapes || []).filter(function(e) {
                            return e.showlegend;
                        }), T = u.concat(w).filter(function(t) {
                            return e === (t.legend || "legend");
                        }), M = 0; M < T.length; M++)if ((v = T[M]).visible) {
                            var k = v._isShape;
                            (v.showlegend || v._dfltShowLegend && !(v._module && v._module.attributes && v._module.attributes.showlegend && !1 === v._module.attributes.showlegend.dflt)) && (x++, v.showlegend && (b = !0, (!k && n.traceIs(v, "pie-like") || !0 === v._input.showlegend) && x++), a.coerceFont(g, "legendgrouptitle.font", m)), (!k && n.traceIs(v, "bar") && "stack" === r.barmode || -1 !== [
                                "tonextx",
                                "tonexty"
                            ].indexOf(v.fill)) && (_ = c.isGrouped({
                                traceorder: _
                            }) ? "grouped+reversed" : "reversed"), void 0 !== v.legendgroup && "" !== v.legendgroup && (_ = c.isReversed({
                                traceorder: _
                            }) ? "reversed+grouped" : "grouped");
                        }
                        var A = a.coerce(t, r, s, "showlegend", b && x > ("legend" === e ? 1 : 0));
                        if (!1 === A && (r[e] = void 0), (!1 !== A || f.uirevision) && (h("uirevision", r.uirevision), !1 !== A)) {
                            h("borderwidth");
                            var L, S, D, O = "h" === h("orientation"), C = "paper" === h("yref"), P = "paper" === h("xref"), I = "left";
                            if (O ? (L = 0, n.getComponentMethod("rangeslider", "isVisible")(t.xaxis) ? C ? (S = 1.1, D = "bottom") : (S = 1, D = "top") : C ? (S = -0.1, D = "top") : (S = 0, D = "bottom")) : (S = 1, D = "auto", P ? L = 1.02 : (L = 1, I = "right")), a.coerce(f, d, {
                                x: {
                                    valType: "number",
                                    editType: "legend",
                                    min: P ? -2 : 0,
                                    max: P ? 3 : 1,
                                    dflt: L
                                }
                            }, "x"), a.coerce(f, d, {
                                y: {
                                    valType: "number",
                                    editType: "legend",
                                    min: C ? -2 : 0,
                                    max: C ? 3 : 1,
                                    dflt: S
                                }
                            }, "y"), h("traceorder", _), c.isGrouped(r[e]) && h("tracegroupgap"), h("entrywidth"), h("entrywidthmode"), h("itemsizing"), h("itemwidth"), h("itemclick"), h("itemdoubleclick"), h("groupclick"), h("xanchor", I), h("yanchor", D), h("valign"), a.noneOrAll(f, d, [
                                "x",
                                "y"
                            ]), h("title.text")) {
                                h("title.side", O ? "left" : "top");
                                var R = a.extendFlat({}, p, {
                                    size: a.bigFont(p.size)
                                });
                                a.coerceFont(h, "title.font", R);
                            }
                        }
                    }
                }
                e.exports = function(e, t, r) {
                    var n, i = r.slice(), o = t.shapes;
                    if (o) for(n = 0; n < o.length; n++){
                        var l = o[n];
                        if (l.showlegend) {
                            var s = {
                                _input: l._input,
                                visible: l.visible,
                                showlegend: l.showlegend,
                                legend: l.legend
                            };
                            i.push(s);
                        }
                    }
                    var c = [
                        "legend"
                    ];
                    for(n = 0; n < i.length; n++)a.pushUnique(c, i[n].legend);
                    for(t._legends = [], n = 0; n < c.length; n++){
                        var f = c[n];
                        u(f, e, t, i), t[f] && t[f].visible && (t[f]._id = f), t._legends.push(f);
                    }
                };
            },
            3969: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(1828), i = r(4875), o = r(3972), l = r(1086), s = r(8569), c = r(1424), u = r(7901), f = r(3893), d = r(5167), h = r(4928), p = r(8783), v = p.LINE_SPACING, g = p.FROM_TL, y = p.FROM_BR, m = r(2424), x = r(3630), b = r(130), _ = 1, w = /^legend[0-9]*$/;
                function T(e, t) {
                    var r, l, d = t || {}, p = e._fullLayout, w = P(d), T = d._inHover;
                    if (T ? (l = d.layer, r = "hover") : (l = p._infolayer, r = w), l) {
                        var L;
                        if (r += p._uid, e._legendMouseDownTime || (e._legendMouseDownTime = 0), T) {
                            if (!d.entries) return;
                            L = m(d.entries, d);
                        } else {
                            for(var I = (e.calcdata || []).slice(), R = p.shapes, z = 0; z < R.length; z++){
                                var N = R[z];
                                if (N.showlegend) {
                                    var F = {
                                        _isShape: !0,
                                        _fullInput: N,
                                        index: N._index,
                                        name: N.name || N.label.text || "shape " + N._index,
                                        legend: N.legend,
                                        legendgroup: N.legendgroup,
                                        legendgrouptitle: N.legendgrouptitle,
                                        legendrank: N.legendrank,
                                        legendwidth: N.legendwidth,
                                        showlegend: N.showlegend,
                                        visible: N.visible,
                                        opacity: N.opacity,
                                        mode: "line" === N.type ? "lines" : "markers",
                                        line: N.line,
                                        marker: {
                                            line: N.line,
                                            color: N.fillcolor,
                                            size: 12,
                                            symbol: "rect" === N.type ? "square" : "circle" === N.type ? "circle" : "hexagon2"
                                        }
                                    };
                                    I.push([
                                        {
                                            trace: F
                                        }
                                    ]);
                                }
                            }
                            L = p.showlegend && m(I, d, p._legends.length > 1);
                        }
                        var E = p.hiddenlabels || [];
                        if (!(T || p.showlegend && L.length)) return l.selectAll("." + w).remove(), p._topdefs.select("#" + r).remove(), i.autoMargin(e, w);
                        var H = a.ensureSingle(l, "g", w, function(e) {
                            T || e.attr("pointer-events", "all");
                        }), j = a.ensureSingleById(p._topdefs, "clipPath", r, function(e) {
                            e.append("rect");
                        }), B = a.ensureSingle(H, "rect", "bg", function(e) {
                            e.attr("shape-rendering", "crispEdges");
                        });
                        B.call(u.stroke, d.bordercolor).call(u.fill, d.bgcolor).style("stroke-width", d.borderwidth + "px");
                        var Y, V = a.ensureSingle(H, "g", "scrollbox"), U = d.title;
                        d._titleWidth = 0, d._titleHeight = 0, U.text ? ((Y = a.ensureSingle(V, "text", w + "titletext")).attr("text-anchor", "start").call(c.font, U.font).text(U.text), D(Y, V, e, d, _)) : V.selectAll("." + w + "titletext").remove();
                        var q = a.ensureSingle(H, "rect", "scrollbar", function(e) {
                            e.attr(h.scrollBarEnterAttrs).call(u.fill, h.scrollBarColor);
                        }), G = V.selectAll("g.groups").data(L);
                        G.enter().append("g").attr("class", "groups"), G.exit().remove();
                        var Z = G.selectAll("g.traces").data(a.identity);
                        Z.enter().append("g").attr("class", "traces"), Z.exit().remove(), Z.style("opacity", function(e) {
                            var t = e[0].trace;
                            return o.traceIs(t, "pie-like") ? -1 !== E.indexOf(e[0].label) ? .5 : 1 : "legendonly" === t.visible ? .5 : 1;
                        }).each(function() {
                            n.select(this).call(A, e, d);
                        }).call(x, e, d).each(function() {
                            T || n.select(this).call(S, e, w);
                        }), a.syncOrAsync([
                            i.previousPromises,
                            function() {
                                return function(e, t, r, a) {
                                    var i = e._fullLayout, o = P(a);
                                    a || (a = i[o]);
                                    var l = i._size, s = b.isVertical(a), u = b.isGrouped(a), f = "fraction" === a.entrywidthmode, d = a.borderwidth, p = 2 * d, v = h.itemGap, g = a.itemwidth + 2 * v, y = 2 * (d + v), m = C(a), x = a.y < 0 || 0 === a.y && "top" === m, _ = a.y > 1 || 1 === a.y && "bottom" === m, w = a.tracegroupgap, T = {};
                                    a._maxHeight = Math.max(x || _ ? i.height / 2 : l.h, 30);
                                    var k = 0;
                                    a._width = 0, a._height = 0;
                                    var A = function(e) {
                                        var t = 0, r = 0, n = e.title.side;
                                        return n && (-1 !== n.indexOf("left") && (t = e._titleWidth), -1 !== n.indexOf("top") && (r = e._titleHeight)), [
                                            t,
                                            r
                                        ];
                                    }(a);
                                    if (s) r.each(function(e) {
                                        var t = e[0].height;
                                        c.setTranslate(this, d + A[0], d + A[1] + a._height + t / 2 + v), a._height += t, a._width = Math.max(a._width, e[0].width);
                                    }), k = g + a._width, a._width += v + g + p, a._height += y, u && (t.each(function(e, t) {
                                        c.setTranslate(this, 0, t * a.tracegroupgap);
                                    }), a._height += (a._lgroupsLength - 1) * a.tracegroupgap);
                                    else {
                                        var L = O(a), S = a.x < 0 || 0 === a.x && "right" === L, D = a.x > 1 || 1 === a.x && "left" === L, I = _ || x, R = i.width / 2;
                                        a._maxWidth = Math.max(S ? I && "left" === L ? l.l + l.w : R : D ? I && "right" === L ? l.r + l.w : R : l.w, 2 * g);
                                        var z = 0, N = 0;
                                        r.each(function(e) {
                                            var t = M(e, a, g);
                                            z = Math.max(z, t), N += t;
                                        }), k = null;
                                        var F = 0;
                                        if (u) {
                                            var E = 0, H = 0, j = 0;
                                            t.each(function() {
                                                var e = 0, t = 0;
                                                n.select(this).selectAll("g.traces").each(function(r) {
                                                    var n = M(r, a, g), i = r[0].height;
                                                    c.setTranslate(this, A[0], A[1] + d + v + i / 2 + t), t += i, e = Math.max(e, n), T[r[0].trace.legendgroup] = e;
                                                });
                                                var r = e + v;
                                                H > 0 && r + d + H > a._maxWidth ? (F = Math.max(F, H), H = 0, j += E + w, E = t) : E = Math.max(E, t), c.setTranslate(this, H, j), H += r;
                                            }), a._width = Math.max(F, H) + d, a._height = j + E + y;
                                        } else {
                                            var B = r.size(), Y = N + p + (B - 1) * v < a._maxWidth, V = 0, U = 0, q = 0, G = 0;
                                            r.each(function(e) {
                                                var t = e[0].height, r = M(e, a, g), n = Y ? r : z;
                                                f || (n += v), n + d + U - v >= a._maxWidth && (F = Math.max(F, G), U = 0, q += V, a._height += V, V = 0), c.setTranslate(this, A[0] + d + U, A[1] + d + q + t / 2 + v), G = U + r + v, U += n, V = Math.max(V, t);
                                            }), Y ? (a._width = U + p, a._height = V + y) : (a._width = Math.max(F, G) + p, a._height += V + y);
                                        }
                                    }
                                    a._width = Math.ceil(Math.max(a._width + A[0], a._titleWidth + 2 * (d + h.titlePad))), a._height = Math.ceil(Math.max(a._height + A[1], a._titleHeight + 2 * (d + h.itemGap))), a._effHeight = Math.min(a._height, a._maxHeight);
                                    var Z = e._context.edits, W = Z.legendText || Z.legendPosition;
                                    r.each(function(e) {
                                        var t = n.select(this).select("." + o + "toggle"), r = e[0].height, i = e[0].trace.legendgroup, l = M(e, a, g);
                                        u && "" !== i && (l = T[i]);
                                        var d = W ? g : k || l;
                                        s || f || (d += v / 2), c.setRect(t, 0, -r / 2, d, r);
                                    });
                                }(e, G, Z, d);
                            },
                            function() {
                                var t, u, m, x, b = p._size, _ = d.borderwidth, M = "paper" === d.xref, A = "paper" === d.yref;
                                if (U.text && function(e, t, r) {
                                    if ("top center" === t.title.side || "top right" === t.title.side) {
                                        var n = t.title.font.size * v, a = 0, i = e.node(), o = c.bBox(i).width;
                                        "top center" === t.title.side ? a = .5 * (t._width - 2 * r - 2 * h.titlePad - o) : "top right" === t.title.side && (a = t._width - 2 * r - 2 * h.titlePad - o), f.positionText(e, r + h.titlePad + a, r + n);
                                    }
                                }(Y, d, _), !T) {
                                    var L, S;
                                    L = M ? b.l + b.w * d.x - g[O(d)] * d._width : p.width * d.x - g[O(d)] * d._width, S = A ? b.t + b.h * (1 - d.y) - g[C(d)] * d._effHeight : p.height * (1 - d.y) - g[C(d)] * d._effHeight;
                                    var D = function(e, t, r, n) {
                                        var a = e._fullLayout, o = a[t], l = O(o), s = C(o), c = "paper" === o.xref, u = "paper" === o.yref;
                                        e._fullLayout._reservedMargin[t] = {};
                                        var f = o.y < .5 ? "b" : "t", d = o.x < .5 ? "l" : "r", h = {
                                            r: a.width - r,
                                            l: r + o._width,
                                            b: a.height - n,
                                            t: n + o._effHeight
                                        };
                                        if (c && u) return i.autoMargin(e, t, {
                                            x: o.x,
                                            y: o.y,
                                            l: o._width * g[l],
                                            r: o._width * y[l],
                                            b: o._effHeight * y[s],
                                            t: o._effHeight * g[s]
                                        });
                                        c ? e._fullLayout._reservedMargin[t][f] = h[f] : u || "v" === o.orientation ? e._fullLayout._reservedMargin[t][d] = h[d] : e._fullLayout._reservedMargin[t][f] = h[f];
                                    }(e, w, L, S);
                                    if (D) return;
                                    if (p.margin.autoexpand) {
                                        var P = L, I = S;
                                        L = M ? a.constrain(L, 0, p.width - d._width) : P, S = A ? a.constrain(S, 0, p.height - d._effHeight) : I, L !== P && a.log("Constrain " + w + ".x to make legend fit inside graph"), S !== I && a.log("Constrain " + w + ".y to make legend fit inside graph");
                                    }
                                    c.setTranslate(H, L, S);
                                }
                                if (q.on(".drag", null), H.on("wheel", null), T || d._height <= d._maxHeight || e._context.staticPlot) {
                                    var R = d._effHeight;
                                    T && (R = d._height), B.attr({
                                        width: d._width - _,
                                        height: R - _,
                                        x: _ / 2,
                                        y: _ / 2
                                    }), c.setTranslate(V, 0, 0), j.select("rect").attr({
                                        width: d._width - 2 * _,
                                        height: R - 2 * _,
                                        x: _,
                                        y: _
                                    }), c.setClipUrl(V, r, e), c.setRect(q, 0, 0, 0, 0), delete d._scrollY;
                                } else {
                                    var z, N, F, E = Math.max(h.scrollBarMinHeight, d._effHeight * d._effHeight / d._height), G = d._effHeight - E - 2 * h.scrollBarMargin, Z = d._height - d._effHeight, W = G / Z, X = Math.min(d._scrollY || 0, Z);
                                    B.attr({
                                        width: d._width - 2 * _ + h.scrollBarWidth + h.scrollBarMargin,
                                        height: d._effHeight - _,
                                        x: _ / 2,
                                        y: _ / 2
                                    }), j.select("rect").attr({
                                        width: d._width - 2 * _ + h.scrollBarWidth + h.scrollBarMargin,
                                        height: d._effHeight - 2 * _,
                                        x: _,
                                        y: _ + X
                                    }), c.setClipUrl(V, r, e), Q(X, E, W), H.on("wheel", function() {
                                        Q(X = a.constrain(d._scrollY + n.event.deltaY / G * Z, 0, Z), E, W), 0 !== X && X !== Z && n.event.preventDefault();
                                    });
                                    var J = n.behavior.drag().on("dragstart", function() {
                                        var e = n.event.sourceEvent;
                                        z = "touchstart" === e.type ? e.changedTouches[0].clientY : e.clientY, F = X;
                                    }).on("drag", function() {
                                        var e = n.event.sourceEvent;
                                        2 === e.buttons || e.ctrlKey || (N = "touchmove" === e.type ? e.changedTouches[0].clientY : e.clientY, X = function(e, t, r) {
                                            var n = (r - t) / W + e;
                                            return a.constrain(n, 0, Z);
                                        }(F, z, N), Q(X, E, W));
                                    });
                                    q.call(J);
                                    var K = n.behavior.drag().on("dragstart", function() {
                                        var e = n.event.sourceEvent;
                                        "touchstart" === e.type && (z = e.changedTouches[0].clientY, F = X);
                                    }).on("drag", function() {
                                        var e = n.event.sourceEvent;
                                        "touchmove" === e.type && (N = e.changedTouches[0].clientY, X = function(e, t, r) {
                                            var n = (t - r) / W + e;
                                            return a.constrain(n, 0, Z);
                                        }(F, z, N), Q(X, E, W));
                                    });
                                    V.call(K);
                                }
                                function Q(t, r, n) {
                                    d._scrollY = e._fullLayout[w]._scrollY = t, c.setTranslate(V, 0, -t), c.setRect(q, d._width, h.scrollBarMargin + t * n, h.scrollBarWidth, r), j.select("rect").attr("y", _ + t);
                                }
                                e._context.edits.legendPosition && (H.classed("cursor-move", !0), s.init({
                                    element: H.node(),
                                    gd: e,
                                    prepFn: function() {
                                        var e = c.getTranslate(H);
                                        m = e.x, x = e.y;
                                    },
                                    moveFn: function(e, r) {
                                        var n = m + e, a = x + r;
                                        c.setTranslate(H, n, a), t = s.align(n, d._width, b.l, b.l + b.w, d.xanchor), u = s.align(a + d._height, -d._height, b.t + b.h, b.t, d.yanchor);
                                    },
                                    doneFn: function() {
                                        if (void 0 !== t && void 0 !== u) {
                                            var r = {};
                                            r[w + ".x"] = t, r[w + ".y"] = u, o.call("_guiRelayout", e, r);
                                        }
                                    },
                                    clickFn: function(t, r) {
                                        var n = l.selectAll("g.traces").filter(function() {
                                            var e = this.getBoundingClientRect();
                                            return r.clientX >= e.left && r.clientX <= e.right && r.clientY >= e.top && r.clientY <= e.bottom;
                                        });
                                        n.size() > 0 && k(e, H, n, t, r);
                                    }
                                }));
                            }
                        ], e);
                    }
                }
                function M(e, t, r) {
                    var n = e[0], a = n.width, i = t.entrywidthmode, o = n.trace.legendwidth || t.entrywidth;
                    return "fraction" === i ? t._maxWidth * o : r + (o || a);
                }
                function k(e, t, r, n, a) {
                    var i = r.data()[0][0].trace, s = {
                        event: a,
                        node: r.node(),
                        curveNumber: i.index,
                        expandedIndex: i._expandedIndex,
                        data: e.data,
                        layout: e.layout,
                        frames: e._transitionData._frames,
                        config: e._context,
                        fullData: e._fullData,
                        fullLayout: e._fullLayout
                    };
                    i._group && (s.group = i._group), o.traceIs(i, "pie-like") && (s.label = r.datum()[0].label);
                    var c = l.triggerHandler(e, "plotly_legendclick", s);
                    if (1 === n) {
                        if (!1 === c) return;
                        t._clickTimeout = setTimeout(function() {
                            e._fullLayout && d(r, e, n);
                        }, e._context.doubleClickDelay);
                    } else 2 === n && (t._clickTimeout && clearTimeout(t._clickTimeout), e._legendMouseDownTime = 0, !1 !== l.triggerHandler(e, "plotly_legenddoubleclick", s) && !1 !== c && d(r, e, n));
                }
                function A(e, t, r) {
                    var n, i, l = P(r), s = e.data()[0][0], u = s.trace, d = o.traceIs(u, "pie-like"), p = !r._inHover && t._context.edits.legendText && !d, v = r._maxNameLength;
                    s.groupTitle ? (n = s.groupTitle.text, i = s.groupTitle.font) : (i = r.font, r.entries ? n = s.text : (n = d ? s.label : u.name, u._meta && (n = a.templateString(n, u._meta))));
                    var g = a.ensureSingle(e, "text", l + "text");
                    g.attr("text-anchor", "start").call(c.font, i).text(p ? L(n, v) : n);
                    var y = r.itemwidth + 2 * h.itemGap;
                    f.positionText(g, y, 0), p ? g.call(f.makeEditable, {
                        gd: t,
                        text: n
                    }).call(D, e, t, r).on("edit", function(n) {
                        this.text(L(n, v)).call(D, e, t, r);
                        var i = s.trace._fullInput || {}, l = {};
                        if (o.hasTransform(i, "groupby")) {
                            var c = o.getTransformIndices(i, "groupby"), f = c[c.length - 1], d = a.keyedContainer(i, "transforms[" + f + "].styles", "target", "value.name");
                            d.set(s.trace._group, n), l = d.constructUpdate();
                        } else l.name = n;
                        return i._isShape ? o.call("_guiRelayout", t, "shapes[" + u.index + "].name", l.name) : o.call("_guiRestyle", t, l, u.index);
                    }) : D(g, e, t, r);
                }
                function L(e, t) {
                    var r = Math.max(4, t);
                    if (e && e.trim().length >= r / 2) return e;
                    for(var n = r - (e = e || "").length; n > 0; n--)e += " ";
                    return e;
                }
                function S(e, t, r) {
                    var i, o = t._context.doubleClickDelay, l = 1, s = a.ensureSingle(e, "rect", r + "toggle", function(e) {
                        t._context.staticPlot || e.style("cursor", "pointer").attr("pointer-events", "all"), e.call(u.fill, "rgba(0,0,0,0)");
                    });
                    t._context.staticPlot || (s.on("mousedown", function() {
                        (i = (new Date).getTime()) - t._legendMouseDownTime < o ? l += 1 : (l = 1, t._legendMouseDownTime = i);
                    }), s.on("mouseup", function() {
                        if (!t._dragged && !t._editing) {
                            var a = t._fullLayout[r];
                            (new Date).getTime() - t._legendMouseDownTime > o && (l = Math.max(l - 1, 1)), k(t, a, e, l, n.event);
                        }
                    }));
                }
                function D(e, t, r, n, a) {
                    n._inHover && e.attr("data-notex", !0), f.convertToTspans(e, r, function() {
                        !function(e, t, r, n) {
                            var a = e.data()[0][0];
                            if (r._inHover || !a || a.trace.showlegend) {
                                var i = e.select("g[class*=math-group]"), o = i.node(), l = P(r);
                                r || (r = t._fullLayout[l]);
                                var s, u, d = r.borderwidth, p = (n === _ ? r.title.font : a.groupTitle ? a.groupTitle.font : r.font).size * v;
                                if (o) {
                                    var g = c.bBox(o);
                                    s = g.height, u = g.width, n === _ ? c.setTranslate(i, d, d + .75 * s) : c.setTranslate(i, 0, .25 * s);
                                } else {
                                    var y = "." + l + (n === _ ? "title" : "") + "text", m = e.select(y), x = f.lineCount(m), b = m.node();
                                    if (s = p * x, u = b ? c.bBox(b).width : 0, n === _) "left" === r.title.side && (u += 2 * h.itemGap), f.positionText(m, d + h.titlePad, d + p);
                                    else {
                                        var w = 2 * h.itemGap + r.itemwidth;
                                        a.groupTitle && (w = h.itemGap, u -= r.itemwidth), f.positionText(m, w, -p * ((x - 1) / 2 - .3));
                                    }
                                }
                                n === _ ? (r._titleWidth = u, r._titleHeight = s) : (a.lineHeight = p, a.height = Math.max(s, 16) + 3, a.width = u);
                            } else e.remove();
                        }(t, r, n, a);
                    });
                }
                function O(e) {
                    return a.isRightAnchor(e) ? "right" : a.isCenterAnchor(e) ? "center" : "left";
                }
                function C(e) {
                    return a.isBottomAnchor(e) ? "bottom" : a.isMiddleAnchor(e) ? "middle" : "top";
                }
                function P(e) {
                    return e._id || "legend";
                }
                e.exports = function(e, t) {
                    if (t) T(e, t);
                    else {
                        var r = e._fullLayout, a = r._legends;
                        r._infolayer.selectAll('[class^="legend"]').each(function() {
                            var e = n.select(this), t = e.attr("class").split(" ")[0];
                            t.match(w) && -1 === a.indexOf(t) && e.remove();
                        });
                        for(var i = 0; i < a.length; i++){
                            var o = a[i];
                            T(e, e._fullLayout[o]);
                        }
                    }
                };
            },
            2424: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(130);
                e.exports = function(e, t, r) {
                    var i, o, l = t._inHover, s = a.isGrouped(t), c = a.isReversed(t), u = {}, f = [], d = !1, h = {}, p = 0, v = 0;
                    function g(e, n, i) {
                        if (!1 !== t.visible && (!r || e === t._id)) {
                            if ("" !== n && a.isGrouped(t)) -1 === f.indexOf(n) ? (f.push(n), d = !0, u[n] = [
                                i
                            ]) : u[n].push(i);
                            else {
                                var o = "~~i" + p;
                                f.push(o), u[o] = [
                                    i
                                ], p++;
                            }
                        }
                    }
                    for(i = 0; i < e.length; i++){
                        var y = e[i], m = y[0], x = m.trace, b = x.legend, _ = x.legendgroup;
                        if (l || x.visible && x.showlegend) {
                            if (n.traceIs(x, "pie-like")) for(h[_] || (h[_] = {}), o = 0; o < y.length; o++){
                                var w = y[o].label;
                                h[_][w] || (g(b, _, {
                                    label: w,
                                    color: y[o].color,
                                    i: y[o].i,
                                    trace: x,
                                    pts: y[o].pts
                                }), h[_][w] = !0, v = Math.max(v, (w || "").length));
                            }
                            else g(b, _, m), v = Math.max(v, (x.name || "").length);
                        }
                    }
                    if (!f.length) return [];
                    var T = !d || !s, M = [];
                    for(i = 0; i < f.length; i++){
                        var k = u[f[i]];
                        T ? M.push(k[0]) : M.push(k);
                    }
                    for(T && (M = [
                        M
                    ]), i = 0; i < M.length; i++){
                        var A = 1 / 0;
                        for(o = 0; o < M[i].length; o++){
                            var L = M[i][o].trace.legendrank;
                            A > L && (A = L);
                        }
                        M[i][0]._groupMinRank = A, M[i][0]._preGroupSort = i;
                    }
                    var S = function(e, t) {
                        return e.trace.legendrank - t.trace.legendrank || e._preSort - t._preSort;
                    };
                    for(M.forEach(function(e, t) {
                        e[0]._preGroupSort = t;
                    }), M.sort(function(e, t) {
                        return e[0]._groupMinRank - t[0]._groupMinRank || e[0]._preGroupSort - t[0]._preGroupSort;
                    }), i = 0; i < M.length; i++){
                        M[i].forEach(function(e, t) {
                            e._preSort = t;
                        }), M[i].sort(S);
                        var D = M[i][0].trace, O = null;
                        for(o = 0; o < M[i].length; o++){
                            var C = M[i][o].trace.legendgrouptitle;
                            if (C && C.text) {
                                O = C, l && (C.font = t._groupTitleFont);
                                break;
                            }
                        }
                        if (c && M[i].reverse(), O) {
                            var P = !1;
                            for(o = 0; o < M[i].length; o++)if (n.traceIs(M[i][o].trace, "pie-like")) {
                                P = !0;
                                break;
                            }
                            M[i].unshift({
                                i: -1,
                                groupTitle: O,
                                noClick: P,
                                trace: {
                                    showlegend: D.showlegend,
                                    legendgroup: D.legendgroup,
                                    visible: "toggleitem" === t.groupclick || D.visible
                                }
                            });
                        }
                        for(o = 0; o < M[i].length; o++)M[i][o] = [
                            M[i][o]
                        ];
                    }
                    return t._lgroupsLength = M.length, t._maxNameLength = v, M;
                };
            },
            5167: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(1828), i = a.pushUnique, o = !0;
                e.exports = function(e, t, r) {
                    var l = t._fullLayout;
                    if (!t._dragged && !t._editing) {
                        var s, c = l.legend.itemclick, u = l.legend.itemdoubleclick, f = l.legend.groupclick;
                        if (1 === r && "toggle" === c && "toggleothers" === u && o && t.data && t._context.showTips ? (a.notifier(a._(t, "Double-click on legend to isolate one trace"), "long"), o = !1) : o = !1, 1 === r ? s = c : 2 === r && (s = u), s) {
                            var d = "togglegroup" === f, h = l.hiddenlabels ? l.hiddenlabels.slice() : [], p = e.data()[0][0];
                            if (!p.groupTitle || !p.noClick) {
                                var v = t._fullData, g = (l.shapes || []).filter(function(e) {
                                    return e.showlegend;
                                }), y = v.concat(g), m = p.trace;
                                m._isShape && (m = m._fullInput);
                                var x, b, _, w, T, M = m.legendgroup, k = {}, A = [], L = [], S = [], D = (l.shapes || []).map(function(e) {
                                    return e._input;
                                }), O = !1, C = m.legend, P = m._fullInput;
                                if (P && P._isShape || !n.traceIs(m, "pie-like")) {
                                    var I, R = M && M.length, z = [];
                                    if (R) for(x = 0; x < y.length; x++)(I = y[x]).visible && I.legendgroup === M && z.push(x);
                                    if ("toggle" === s) {
                                        var N;
                                        switch(m.visible){
                                            case !0:
                                                N = "legendonly";
                                                break;
                                            case !1:
                                                N = !1;
                                                break;
                                            case "legendonly":
                                                N = !0;
                                        }
                                        if (R) {
                                            if (d) for(x = 0; x < y.length; x++){
                                                var F = y[x];
                                                !1 !== F.visible && F.legendgroup === M && ee(F, N);
                                            }
                                            else ee(m, N);
                                        } else ee(m, N);
                                    } else if ("toggleothers" === s) {
                                        var E, H, j, B, Y = !0;
                                        for(x = 0; x < y.length; x++)if (E = (B = y[x]) === m, H = !0 !== B.showlegend, !(E || H || R && B.legendgroup === M || B.legend !== C || !0 !== B.visible || n.traceIs(B, "notLegendIsolatable"))) {
                                            Y = !1;
                                            break;
                                        }
                                        for(x = 0; x < y.length; x++)if (!1 !== (B = y[x]).visible && B.legend === C && !n.traceIs(B, "notLegendIsolatable")) switch(m.visible){
                                            case "legendonly":
                                                ee(B, !0);
                                                break;
                                            case !0:
                                                j = !!Y || "legendonly", E = B === m, H = !0 !== B.showlegend && !B.legendgroup, ee(B, !!(E || R && B.legendgroup === M || H) || j);
                                        }
                                    }
                                    for(x = 0; x < L.length; x++)if (_ = L[x]) {
                                        var V = _.constructUpdate(), U = Object.keys(V);
                                        for(b = 0; b < U.length; b++)w = U[b], (k[w] = k[w] || [])[S[x]] = V[w];
                                    }
                                    for(T = Object.keys(k), x = 0; x < T.length; x++)for(w = T[x], b = 0; b < A.length; b++)k[w].hasOwnProperty(b) || (k[w][b] = void 0);
                                    O ? n.call("_guiUpdate", t, k, {
                                        shapes: D
                                    }, A) : n.call("_guiRestyle", t, k, A);
                                } else {
                                    var q = p.label, G = h.indexOf(q);
                                    if ("toggle" === s) -1 === G ? h.push(q) : h.splice(G, 1);
                                    else if ("toggleothers" === s) {
                                        var Z = -1 !== G, W = [];
                                        for(x = 0; x < t.calcdata.length; x++){
                                            var X = t.calcdata[x];
                                            for(b = 0; b < X.length; b++){
                                                var J = X[b].label;
                                                C === X[0].trace.legend && q !== J && (-1 === h.indexOf(J) && (Z = !0), i(h, J), W.push(J));
                                            }
                                        }
                                        if (!Z) for(var K = 0; K < W.length; K++){
                                            var Q = h.indexOf(W[K]);
                                            -1 !== Q && h.splice(Q, 1);
                                        }
                                    }
                                    n.call("_guiRelayout", t, "hiddenlabels", h);
                                }
                            }
                        }
                    }
                    function $(e, t) {
                        var r = A.indexOf(e), n = k.visible;
                        return n || (n = k.visible = []), -1 === A.indexOf(e) && (A.push(e), r = A.length - 1), n[r] = t, r;
                    }
                    function ee(e, t) {
                        if (!p.groupTitle || d) {
                            var r, i = e._fullInput || e, o = i._isShape, l = i.index;
                            if (void 0 === l && (l = i._index), n.hasTransform(i, "groupby")) {
                                var s = L[l];
                                if (!s) {
                                    var c = n.getTransformIndices(i, "groupby"), u = c[c.length - 1];
                                    s = a.keyedContainer(i, "transforms[" + u + "].styles", "target", "value.visible"), L[l] = s;
                                }
                                var f = s.get(e._group);
                                void 0 === f && (f = !0), !1 !== f && s.set(e._group, t), S[l] = $(l, !1 !== i.visible);
                            } else {
                                var h = !1 !== i.visible && t;
                                o ? (r = h, D[l].visible = r, O = !0) : $(l, h);
                            }
                        }
                    }
                };
            },
            130: function(e, t) {
                "use strict";
                t.isGrouped = function(e) {
                    return -1 !== (e.traceorder || "").indexOf("grouped");
                }, t.isVertical = function(e) {
                    return "h" !== e.orientation;
                }, t.isReversed = function(e) {
                    return -1 !== (e.traceorder || "").indexOf("reversed");
                };
            },
            2199: function(e, t, r) {
                "use strict";
                e.exports = {
                    moduleType: "component",
                    name: "legend",
                    layoutAttributes: r(3030),
                    supplyLayoutDefaults: r(9017),
                    draw: r(3969),
                    style: r(3630)
                };
            },
            3630: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(3972), i = r(1828), o = i.strTranslate, l = r(1424), s = r(7901), c = r(2869).extractOpts, u = r(4098), f = r(3463), d = r(3581).castOption, h = r(4928);
                function p(e, t) {
                    return (t ? "radial" : "horizontal") + (e ? "" : "reversed");
                }
                function v(e) {
                    var t = e[0].trace, r = t.contours, n = u.hasLines(t), a = u.hasMarkers(t), i = t.visible && t.fill && "none" !== t.fill, o = !1, l = !1;
                    if (r) {
                        var s = r.coloring;
                        "lines" === s ? o = !0 : n = "none" === s || "heatmap" === s || r.showlines, "constraint" === r.type ? i = "=" !== r._operation : "fill" !== s && "heatmap" !== s || (l = !0);
                    }
                    return {
                        showMarker: a,
                        showLine: n,
                        showFill: i,
                        showGradientLine: o,
                        showGradientFill: l,
                        anyLine: n || o,
                        anyFill: i || l
                    };
                }
                function g(e, t, r) {
                    return e && i.isArrayOrTypedArray(e) ? t : e > r ? r : e;
                }
                e.exports = function(e, t, r) {
                    var y = t._fullLayout;
                    r || (r = y.legend);
                    var m = "constant" === r.itemsizing, x = r.itemwidth, b = (x + 2 * h.itemGap) / 2, _ = o(b, 0), w = function(e, t, r, n) {
                        var a;
                        if (e + 1) a = e;
                        else {
                            if (!(t && t.width > 0)) return 0;
                            a = t.width;
                        }
                        return m ? n : Math.min(a, r);
                    };
                    function T(e, i, o) {
                        var u = e[0].trace, f = u.marker || {}, d = f.line || {}, h = o ? u.visible && u.type === o : a.traceIs(u, "bar"), p = n.select(i).select("g.legendpoints").selectAll("path.legend" + o).data(h ? [
                            e
                        ] : []);
                        p.enter().append("path").classed("legend" + o, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", _), p.exit().remove(), p.each(function(e) {
                            var a = n.select(this), i = e[0], o = w(i.mlw, f.line, 5, 2);
                            a.style("stroke-width", o + "px");
                            var h = i.mcc;
                            if (!r._inHover && "mc" in i) {
                                var p = c(f), v = p.mid;
                                void 0 === v && (v = (p.max + p.min) / 2), h = l.tryColorscale(f, "")(v);
                            }
                            var y = h || i.mc || f.color, m = f.pattern, x = m && l.getPatternAttr(m.shape, 0, "");
                            if (x) {
                                var b = l.getPatternAttr(m.bgcolor, 0, null), _ = l.getPatternAttr(m.fgcolor, 0, null), T = m.fgopacity, M = g(m.size, 8, 10), k = g(m.solidity, .5, 1), A = "legend-" + u.uid;
                                a.call(l.pattern, "legend", t, A, x, M, k, h, m.fillmode, b, _, T);
                            } else a.call(s.fill, y);
                            o && s.stroke(a, i.mlc || d.color);
                        });
                    }
                    function M(e, r, o) {
                        var l = e[0], s = l.trace, c = o ? s.visible && s.type === o : a.traceIs(s, o), u = n.select(r).select("g.legendpoints").selectAll("path.legend" + o).data(c ? [
                            e
                        ] : []);
                        if (u.enter().append("path").classed("legend" + o, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", _), u.exit().remove(), u.size()) {
                            var h = s.marker || {}, p = w(d(h.line.width, l.pts), h.line, 5, 2), v = "pieLike", g = i.minExtend(s, {
                                marker: {
                                    line: {
                                        width: p
                                    }
                                }
                            }, v), y = i.minExtend(l, {
                                trace: g
                            }, v);
                            f(u, y, g, t);
                        }
                    }
                    e.each(function(e) {
                        var t = n.select(this), a = i.ensureSingle(t, "g", "layers");
                        a.style("opacity", e[0].trace.opacity);
                        var l = r.valign, s = e[0].lineHeight, c = e[0].height;
                        if ("middle" !== l && s && c) {
                            var u = {
                                top: 1,
                                bottom: -1
                            }[l] * (.5 * (s - c + 3));
                            a.attr("transform", o(0, u));
                        } else a.attr("transform", null);
                        a.selectAll("g.legendfill").data([
                            e
                        ]).enter().append("g").classed("legendfill", !0), a.selectAll("g.legendlines").data([
                            e
                        ]).enter().append("g").classed("legendlines", !0);
                        var f = a.selectAll("g.legendsymbols").data([
                            e
                        ]);
                        f.enter().append("g").classed("legendsymbols", !0), f.selectAll("g.legendpoints").data([
                            e
                        ]).enter().append("g").classed("legendpoints", !0);
                    }).each(function(e) {
                        var r, a = e[0].trace, o = [];
                        if (a.visible) switch(a.type){
                            case "histogram2d":
                            case "heatmap":
                                o = [
                                    [
                                        "M-15,-2V4H15V-2Z"
                                    ]
                                ], r = !0;
                                break;
                            case "choropleth":
                            case "choroplethmapbox":
                                o = [
                                    [
                                        "M-6,-6V6H6V-6Z"
                                    ]
                                ], r = !0;
                                break;
                            case "densitymapbox":
                                o = [
                                    [
                                        "M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
                                    ]
                                ], r = "radial";
                                break;
                            case "cone":
                                o = [
                                    [
                                        "M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z"
                                    ],
                                    [
                                        "M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z"
                                    ],
                                    [
                                        "M-6,-2 A2,2 0 0,0 -6,2 L6,0Z"
                                    ]
                                ], r = !1;
                                break;
                            case "streamtube":
                                o = [
                                    [
                                        "M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z"
                                    ],
                                    [
                                        "M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z"
                                    ],
                                    [
                                        "M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z"
                                    ]
                                ], r = !1;
                                break;
                            case "surface":
                                o = [
                                    [
                                        "M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z"
                                    ],
                                    [
                                        "M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z"
                                    ]
                                ], r = !0;
                                break;
                            case "mesh3d":
                                o = [
                                    [
                                        "M-6,6H0L-6,-6Z"
                                    ],
                                    [
                                        "M6,6H0L6,-6Z"
                                    ],
                                    [
                                        "M-6,-6H6L0,6Z"
                                    ]
                                ], r = !1;
                                break;
                            case "volume":
                                o = [
                                    [
                                        "M-6,6H0L-6,-6Z"
                                    ],
                                    [
                                        "M6,6H0L6,-6Z"
                                    ],
                                    [
                                        "M-6,-6H6L0,6Z"
                                    ]
                                ], r = !0;
                                break;
                            case "isosurface":
                                o = [
                                    [
                                        "M-6,6H0L-6,-6Z"
                                    ],
                                    [
                                        "M6,6H0L6,-6Z"
                                    ],
                                    [
                                        "M-6,-6 A12,24 0 0,0 6,-6 L0,6Z"
                                    ]
                                ], r = !1;
                        }
                        var u = n.select(this).select("g.legendpoints").selectAll("path.legend3dandfriends").data(o);
                        u.enter().append("path").classed("legend3dandfriends", !0).attr("transform", _).style("stroke-miterlimit", 1), u.exit().remove(), u.each(function(e, o) {
                            var u, f = n.select(this), d = c(a), h = d.colorscale, v = d.reversescale;
                            if (h) {
                                if (!r) {
                                    var g = h.length;
                                    u = 0 === o ? h[v ? g - 1 : 0][1] : 1 === o ? h[v ? 0 : g - 1][1] : h[Math.floor((g - 1) / 2)][1];
                                }
                            } else {
                                var y = a.vertexcolor || a.facecolor || a.color;
                                u = i.isArrayOrTypedArray(y) ? y[o] || y[0] : y;
                            }
                            f.attr("d", e[0]), u ? f.call(s.fill, u) : f.call(function(e) {
                                if (e.size()) {
                                    var n = "legendfill-" + a.uid;
                                    l.gradient(e, t, n, p(v, "radial" === r), h, "fill");
                                }
                            });
                        });
                    }).each(function(e) {
                        var t = e[0].trace, r = "waterfall" === t.type;
                        if (e[0]._distinct && r) {
                            var a = e[0].trace[e[0].dir].marker;
                            return e[0].mc = a.color, e[0].mlw = a.line.width, e[0].mlc = a.line.color, T(e, this, "waterfall");
                        }
                        var i = [];
                        t.visible && r && (i = e[0].hasTotals ? [
                            [
                                "increasing",
                                "M-6,-6V6H0Z"
                            ],
                            [
                                "totals",
                                "M6,6H0L-6,-6H-0Z"
                            ],
                            [
                                "decreasing",
                                "M6,6V-6H0Z"
                            ]
                        ] : [
                            [
                                "increasing",
                                "M-6,-6V6H6Z"
                            ],
                            [
                                "decreasing",
                                "M6,6V-6H-6Z"
                            ]
                        ]);
                        var o = n.select(this).select("g.legendpoints").selectAll("path.legendwaterfall").data(i);
                        o.enter().append("path").classed("legendwaterfall", !0).attr("transform", _).style("stroke-miterlimit", 1), o.exit().remove(), o.each(function(e) {
                            var r = n.select(this), a = t[e[0]].marker, i = w(void 0, a.line, 5, 2);
                            r.attr("d", e[1]).style("stroke-width", i + "px").call(s.fill, a.color), i && r.call(s.stroke, a.line.color);
                        });
                    }).each(function(e) {
                        T(e, this, "funnel");
                    }).each(function(e) {
                        T(e, this);
                    }).each(function(e) {
                        var r = e[0].trace, o = n.select(this).select("g.legendpoints").selectAll("path.legendbox").data(r.visible && a.traceIs(r, "box-violin") ? [
                            e
                        ] : []);
                        o.enter().append("path").classed("legendbox", !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", _), o.exit().remove(), o.each(function() {
                            var e = n.select(this);
                            if ("all" !== r.boxpoints && "all" !== r.points || 0 !== s.opacity(r.fillcolor) || 0 !== s.opacity((r.line || {}).color)) {
                                var a = w(void 0, r.line, 5, 2);
                                e.style("stroke-width", a + "px").call(s.fill, r.fillcolor), a && s.stroke(e, r.line.color);
                            } else {
                                var c = i.minExtend(r, {
                                    marker: {
                                        size: m ? 12 : i.constrain(r.marker.size, 2, 16),
                                        sizeref: 1,
                                        sizemin: 1,
                                        sizemode: "diameter"
                                    }
                                });
                                o.call(l.pointStyle, c, t);
                            }
                        });
                    }).each(function(e) {
                        M(e, this, "funnelarea");
                    }).each(function(e) {
                        M(e, this, "pie");
                    }).each(function(e) {
                        var r, a, o = v(e), s = o.showFill, f = o.showLine, d = o.showGradientLine, h = o.showGradientFill, g = o.anyFill, y = o.anyLine, m = e[0], b = m.trace, _ = c(b), T = _.colorscale, M = _.reversescale, k = u.hasMarkers(b) || !g ? "M5,0" : y ? "M5,-2" : "M5,-3", A = n.select(this), L = A.select(".legendfill").selectAll("path").data(s || h ? [
                            e
                        ] : []);
                        if (L.enter().append("path").classed("js-fill", !0), L.exit().remove(), L.attr("d", k + "h" + x + "v6h-" + x + "z").call(function(e) {
                            if (e.size()) {
                                if (s) l.fillGroupStyle(e, t);
                                else {
                                    var r = "legendfill-" + b.uid;
                                    l.gradient(e, t, r, p(M), T, "fill");
                                }
                            }
                        }), f || d) {
                            var S = w(void 0, b.line, 10, 5);
                            a = i.minExtend(b, {
                                line: {
                                    width: S
                                }
                            }), r = [
                                i.minExtend(m, {
                                    trace: a
                                })
                            ];
                        }
                        var D = A.select(".legendlines").selectAll("path").data(f || d ? [
                            r
                        ] : []);
                        D.enter().append("path").classed("js-line", !0), D.exit().remove(), D.attr("d", k + (d ? "l" + x + ",0.0001" : "h" + x)).call(f ? l.lineGroupStyle : function(e) {
                            if (e.size()) {
                                var r = "legendline-" + b.uid;
                                l.lineGroupStyle(e), l.gradient(e, t, r, p(M), T, "stroke");
                            }
                        });
                    }).each(function(e) {
                        var r, a, o = v(e), s = o.anyFill, c = o.anyLine, f = o.showLine, d = o.showMarker, h = e[0], p = h.trace, g = !d && !c && !s && u.hasText(p);
                        function y(e, t, r, n) {
                            var a = i.nestedProperty(p, e).get(), o = i.isArrayOrTypedArray(a) && t ? t(a) : a;
                            if (m && o && void 0 !== n && (o = n), r) {
                                if (o < r[0]) return r[0];
                                if (o > r[1]) return r[1];
                            }
                            return o;
                        }
                        function x(e) {
                            return h._distinct && h.index && e[h.index] ? e[h.index] : e[0];
                        }
                        if (d || g || f) {
                            var b = {}, w = {};
                            if (d) {
                                b.mc = y("marker.color", x), b.mx = y("marker.symbol", x), b.mo = y("marker.opacity", i.mean, [
                                    .2,
                                    1
                                ]), b.mlc = y("marker.line.color", x), b.mlw = y("marker.line.width", i.mean, [
                                    0,
                                    5
                                ], 2), w.marker = {
                                    sizeref: 1,
                                    sizemin: 1,
                                    sizemode: "diameter"
                                };
                                var T = y("marker.size", i.mean, [
                                    2,
                                    16
                                ], 12);
                                b.ms = T, w.marker.size = T;
                            }
                            f && (w.line = {
                                width: y("line.width", x, [
                                    0,
                                    10
                                ], 5)
                            }), g && (b.tx = "Aa", b.tp = y("textposition", x), b.ts = 10, b.tc = y("textfont.color", x), b.tf = y("textfont.family", x)), r = [
                                i.minExtend(h, b)
                            ], (a = i.minExtend(p, w)).selectedpoints = null, a.texttemplate = null;
                        }
                        var M = n.select(this).select("g.legendpoints"), k = M.selectAll("path.scatterpts").data(d ? r : []);
                        k.enter().insert("path", ":first-child").classed("scatterpts", !0).attr("transform", _), k.exit().remove(), k.call(l.pointStyle, a, t), d && (r[0].mrc = 3);
                        var A = M.selectAll("g.pointtext").data(g ? r : []);
                        A.enter().append("g").classed("pointtext", !0).append("text").attr("transform", _), A.exit().remove(), A.selectAll("text").call(l.textPointStyle, a, t);
                    }).each(function(e) {
                        var t = e[0].trace, r = n.select(this).select("g.legendpoints").selectAll("path.legendcandle").data(t.visible && "candlestick" === t.type ? [
                            e,
                            e
                        ] : []);
                        r.enter().append("path").classed("legendcandle", !0).attr("d", function(e, t) {
                            return t ? "M-15,0H-8M-8,6V-6H8Z" : "M15,0H8M8,-6V6H-8Z";
                        }).attr("transform", _).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function(e, r) {
                            var a = n.select(this), i = t[r ? "increasing" : "decreasing"], o = w(void 0, i.line, 5, 2);
                            a.style("stroke-width", o + "px").call(s.fill, i.fillcolor), o && s.stroke(a, i.line.color);
                        });
                    }).each(function(e) {
                        var t = e[0].trace, r = n.select(this).select("g.legendpoints").selectAll("path.legendohlc").data(t.visible && "ohlc" === t.type ? [
                            e,
                            e
                        ] : []);
                        r.enter().append("path").classed("legendohlc", !0).attr("d", function(e, t) {
                            return t ? "M-15,0H0M-8,-6V0" : "M15,0H0M8,6V0";
                        }).attr("transform", _).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function(e, r) {
                            var a = n.select(this), i = t[r ? "increasing" : "decreasing"], o = w(void 0, i.line, 5, 2);
                            a.style("fill", "none").call(l.dashLine, i.line.dash, o), o && s.stroke(a, i.line.color);
                        });
                    });
                };
            },
            2068: function(e, t, r) {
                "use strict";
                r(3348), e.exports = {
                    editType: "modebar",
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        dflt: "h",
                        editType: "modebar"
                    },
                    bgcolor: {
                        valType: "color",
                        editType: "modebar"
                    },
                    color: {
                        valType: "color",
                        editType: "modebar"
                    },
                    activecolor: {
                        valType: "color",
                        editType: "modebar"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    add: {
                        valType: "string",
                        arrayOk: !0,
                        dflt: "",
                        editType: "modebar"
                    },
                    remove: {
                        valType: "string",
                        arrayOk: !0,
                        dflt: "",
                        editType: "modebar"
                    }
                };
            },
            6023: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(4875), i = r(1675), o = r(4255), l = r(4031).eraseActiveShape, s = r(1828), c = s._, u = e.exports = {};
                function f(e, t) {
                    var r, a, o = t.currentTarget, l = o.getAttribute("data-attr"), s = o.getAttribute("data-val") || !0, c = e._fullLayout, u = {}, f = i.list(e, null, !0), d = c._cartesianSpikesEnabled;
                    if ("zoom" === l) {
                        var h, p = "in" === s ? .5 : 2, v = (1 + p) / 2, g = (1 - p) / 2;
                        for(a = 0; a < f.length; a++)if (!(r = f[a]).fixedrange) {
                            if (h = r._name, "auto" === s) u[h + ".autorange"] = !0;
                            else if ("reset" === s) void 0 === r._rangeInitial0 && void 0 === r._rangeInitial1 ? u[h + ".autorange"] = !0 : void 0 === r._rangeInitial0 ? (u[h + ".autorange"] = r._autorangeInitial, u[h + ".range"] = [
                                null,
                                r._rangeInitial1
                            ]) : void 0 === r._rangeInitial1 ? (u[h + ".range"] = [
                                r._rangeInitial0,
                                null
                            ], u[h + ".autorange"] = r._autorangeInitial) : u[h + ".range"] = [
                                r._rangeInitial0,
                                r._rangeInitial1
                            ], void 0 !== r._showSpikeInitial && (u[h + ".showspikes"] = r._showSpikeInitial, "on" !== d || r._showSpikeInitial || (d = "off"));
                            else {
                                var y = [
                                    r.r2l(r.range[0]),
                                    r.r2l(r.range[1])
                                ], m = [
                                    v * y[0] + g * y[1],
                                    v * y[1] + g * y[0]
                                ];
                                u[h + ".range[0]"] = r.l2r(m[0]), u[h + ".range[1]"] = r.l2r(m[1]);
                            }
                        }
                    } else "hovermode" !== l || "x" !== s && "y" !== s || (s = c._isHoriz ? "y" : "x", o.setAttribute("data-val", s)), u[l] = s;
                    c._cartesianSpikesEnabled = d, n.call("_guiRelayout", e, u);
                }
                function d(e, t) {
                    for(var r = t.currentTarget, a = r.getAttribute("data-attr"), i = r.getAttribute("data-val") || !0, o = e._fullLayout._subplots.gl3d || [], l = {}, s = a.split("."), c = 0; c < o.length; c++)l[o[c] + "." + s[1]] = i;
                    var u = "pan" === i ? i : "zoom";
                    l.dragmode = u, n.call("_guiRelayout", e, l);
                }
                function h(e, t) {
                    for(var r = t.currentTarget.getAttribute("data-attr"), a = "resetLastSave" === r, i = "resetDefault" === r, o = e._fullLayout, l = o._subplots.gl3d || [], s = {}, c = 0; c < l.length; c++){
                        var u, f = l[c], d = f + ".camera", h = f + ".aspectratio", p = f + ".aspectmode", v = o[f]._scene;
                        a ? (s[d + ".up"] = v.viewInitial.up, s[d + ".eye"] = v.viewInitial.eye, s[d + ".center"] = v.viewInitial.center, u = !0) : i && (s[d + ".up"] = null, s[d + ".eye"] = null, s[d + ".center"] = null, u = !0), u && (s[h + ".x"] = v.viewInitial.aspectratio.x, s[h + ".y"] = v.viewInitial.aspectratio.y, s[h + ".z"] = v.viewInitial.aspectratio.z, s[p] = v.viewInitial.aspectmode);
                    }
                    n.call("_guiRelayout", e, s);
                }
                function p(e, t) {
                    var r = t.currentTarget, n = r._previousVal, a = e._fullLayout, i = a._subplots.gl3d || [], o = [
                        "xaxis",
                        "yaxis",
                        "zaxis"
                    ], l = {}, s = {};
                    if (n) s = n, r._previousVal = null;
                    else {
                        for(var c = 0; c < i.length; c++){
                            var u = i[c], f = a[u], d = u + ".hovermode";
                            l[d] = f.hovermode, s[d] = !1;
                            for(var h = 0; h < 3; h++){
                                var p = o[h], v = u + "." + p + ".showspikes";
                                s[v] = !1, l[v] = f[p].showspikes;
                            }
                        }
                        r._previousVal = l;
                    }
                    return s;
                }
                function v(e, t) {
                    for(var r = t.currentTarget, a = r.getAttribute("data-attr"), i = r.getAttribute("data-val") || !0, o = e._fullLayout, l = o._subplots.geo || [], s = 0; s < l.length; s++){
                        var c = l[s], u = o[c];
                        if ("zoom" === a) {
                            var f = u.projection.scale, d = "in" === i ? 2 * f : .5 * f;
                            n.call("_guiRelayout", e, c + ".projection.scale", d);
                        }
                    }
                    "reset" === a && x(e, "geo");
                }
                function g(e) {
                    var t = e._fullLayout;
                    return !t.hovermode && (t._has("cartesian") ? t._isHoriz ? "y" : "x" : "closest");
                }
                function y(e) {
                    var t = g(e);
                    n.call("_guiRelayout", e, "hovermode", t);
                }
                function m(e, t) {
                    for(var r = t.currentTarget.getAttribute("data-val"), a = e._fullLayout, i = a._subplots.mapbox || [], o = {}, l = 0; l < i.length; l++){
                        var s = i[l], c = a[s].zoom, u = "in" === r ? 1.05 * c : c / 1.05;
                        o[s + ".zoom"] = u;
                    }
                    n.call("_guiRelayout", e, o);
                }
                function x(e, t) {
                    for(var r = e._fullLayout, a = r._subplots[t] || [], i = {}, o = 0; o < a.length; o++)for(var l = a[o], s = r[l]._subplot.viewInitial, c = Object.keys(s), u = 0; u < c.length; u++){
                        var f = c[u];
                        i[l + "." + f] = s[f];
                    }
                    n.call("_guiRelayout", e, i);
                }
                u.toImage = {
                    name: "toImage",
                    title: function(e) {
                        var t = (e._context.toImageButtonOptions || {}).format || "png";
                        return c(e, "png" === t ? "Download plot as a png" : "Download plot");
                    },
                    icon: o.camera,
                    click: function(e) {
                        var t = e._context.toImageButtonOptions, r = {
                            format: t.format || "png"
                        };
                        s.notifier(c(e, "Taking snapshot - this may take a few seconds"), "long"), "svg" !== r.format && s.isIE() && (s.notifier(c(e, "IE only supports svg.  Changing format to svg."), "long"), r.format = "svg"), [
                            "filename",
                            "width",
                            "height",
                            "scale"
                        ].forEach(function(e) {
                            e in t && (r[e] = t[e]);
                        }), n.call("downloadImage", e, r).then(function(t) {
                            s.notifier(c(e, "Snapshot succeeded") + " - " + t, "long");
                        }).catch(function() {
                            s.notifier(c(e, "Sorry, there was a problem downloading your snapshot!"), "long");
                        });
                    }
                }, u.sendDataToCloud = {
                    name: "sendDataToCloud",
                    title: function(e) {
                        return c(e, "Edit in Chart Studio");
                    },
                    icon: o.disk,
                    click: function(e) {
                        a.sendDataToCloud(e);
                    }
                }, u.editInChartStudio = {
                    name: "editInChartStudio",
                    title: function(e) {
                        return c(e, "Edit in Chart Studio");
                    },
                    icon: o.pencil,
                    click: function(e) {
                        a.sendDataToCloud(e);
                    }
                }, u.zoom2d = {
                    name: "zoom2d",
                    _cat: "zoom",
                    title: function(e) {
                        return c(e, "Zoom");
                    },
                    attr: "dragmode",
                    val: "zoom",
                    icon: o.zoombox,
                    click: f
                }, u.pan2d = {
                    name: "pan2d",
                    _cat: "pan",
                    title: function(e) {
                        return c(e, "Pan");
                    },
                    attr: "dragmode",
                    val: "pan",
                    icon: o.pan,
                    click: f
                }, u.select2d = {
                    name: "select2d",
                    _cat: "select",
                    title: function(e) {
                        return c(e, "Box Select");
                    },
                    attr: "dragmode",
                    val: "select",
                    icon: o.selectbox,
                    click: f
                }, u.lasso2d = {
                    name: "lasso2d",
                    _cat: "lasso",
                    title: function(e) {
                        return c(e, "Lasso Select");
                    },
                    attr: "dragmode",
                    val: "lasso",
                    icon: o.lasso,
                    click: f
                }, u.drawclosedpath = {
                    name: "drawclosedpath",
                    title: function(e) {
                        return c(e, "Draw closed freeform");
                    },
                    attr: "dragmode",
                    val: "drawclosedpath",
                    icon: o.drawclosedpath,
                    click: f
                }, u.drawopenpath = {
                    name: "drawopenpath",
                    title: function(e) {
                        return c(e, "Draw open freeform");
                    },
                    attr: "dragmode",
                    val: "drawopenpath",
                    icon: o.drawopenpath,
                    click: f
                }, u.drawline = {
                    name: "drawline",
                    title: function(e) {
                        return c(e, "Draw line");
                    },
                    attr: "dragmode",
                    val: "drawline",
                    icon: o.drawline,
                    click: f
                }, u.drawrect = {
                    name: "drawrect",
                    title: function(e) {
                        return c(e, "Draw rectangle");
                    },
                    attr: "dragmode",
                    val: "drawrect",
                    icon: o.drawrect,
                    click: f
                }, u.drawcircle = {
                    name: "drawcircle",
                    title: function(e) {
                        return c(e, "Draw circle");
                    },
                    attr: "dragmode",
                    val: "drawcircle",
                    icon: o.drawcircle,
                    click: f
                }, u.eraseshape = {
                    name: "eraseshape",
                    title: function(e) {
                        return c(e, "Erase active shape");
                    },
                    icon: o.eraseshape,
                    click: l
                }, u.zoomIn2d = {
                    name: "zoomIn2d",
                    _cat: "zoomin",
                    title: function(e) {
                        return c(e, "Zoom in");
                    },
                    attr: "zoom",
                    val: "in",
                    icon: o.zoom_plus,
                    click: f
                }, u.zoomOut2d = {
                    name: "zoomOut2d",
                    _cat: "zoomout",
                    title: function(e) {
                        return c(e, "Zoom out");
                    },
                    attr: "zoom",
                    val: "out",
                    icon: o.zoom_minus,
                    click: f
                }, u.autoScale2d = {
                    name: "autoScale2d",
                    _cat: "autoscale",
                    title: function(e) {
                        return c(e, "Autoscale");
                    },
                    attr: "zoom",
                    val: "auto",
                    icon: o.autoscale,
                    click: f
                }, u.resetScale2d = {
                    name: "resetScale2d",
                    _cat: "resetscale",
                    title: function(e) {
                        return c(e, "Reset axes");
                    },
                    attr: "zoom",
                    val: "reset",
                    icon: o.home,
                    click: f
                }, u.hoverClosestCartesian = {
                    name: "hoverClosestCartesian",
                    _cat: "hoverclosest",
                    title: function(e) {
                        return c(e, "Show closest data on hover");
                    },
                    attr: "hovermode",
                    val: "closest",
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: f
                }, u.hoverCompareCartesian = {
                    name: "hoverCompareCartesian",
                    _cat: "hoverCompare",
                    title: function(e) {
                        return c(e, "Compare data on hover");
                    },
                    attr: "hovermode",
                    val: function(e) {
                        return e._fullLayout._isHoriz ? "y" : "x";
                    },
                    icon: o.tooltip_compare,
                    gravity: "ne",
                    click: f
                }, u.zoom3d = {
                    name: "zoom3d",
                    _cat: "zoom",
                    title: function(e) {
                        return c(e, "Zoom");
                    },
                    attr: "scene.dragmode",
                    val: "zoom",
                    icon: o.zoombox,
                    click: d
                }, u.pan3d = {
                    name: "pan3d",
                    _cat: "pan",
                    title: function(e) {
                        return c(e, "Pan");
                    },
                    attr: "scene.dragmode",
                    val: "pan",
                    icon: o.pan,
                    click: d
                }, u.orbitRotation = {
                    name: "orbitRotation",
                    title: function(e) {
                        return c(e, "Orbital rotation");
                    },
                    attr: "scene.dragmode",
                    val: "orbit",
                    icon: o["3d_rotate"],
                    click: d
                }, u.tableRotation = {
                    name: "tableRotation",
                    title: function(e) {
                        return c(e, "Turntable rotation");
                    },
                    attr: "scene.dragmode",
                    val: "turntable",
                    icon: o["z-axis"],
                    click: d
                }, u.resetCameraDefault3d = {
                    name: "resetCameraDefault3d",
                    _cat: "resetCameraDefault",
                    title: function(e) {
                        return c(e, "Reset camera to default");
                    },
                    attr: "resetDefault",
                    icon: o.home,
                    click: h
                }, u.resetCameraLastSave3d = {
                    name: "resetCameraLastSave3d",
                    _cat: "resetCameraLastSave",
                    title: function(e) {
                        return c(e, "Reset camera to last save");
                    },
                    attr: "resetLastSave",
                    icon: o.movie,
                    click: h
                }, u.hoverClosest3d = {
                    name: "hoverClosest3d",
                    _cat: "hoverclosest",
                    title: function(e) {
                        return c(e, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: function(e, t) {
                        var r = p(e, t);
                        n.call("_guiRelayout", e, r);
                    }
                }, u.zoomInGeo = {
                    name: "zoomInGeo",
                    _cat: "zoomin",
                    title: function(e) {
                        return c(e, "Zoom in");
                    },
                    attr: "zoom",
                    val: "in",
                    icon: o.zoom_plus,
                    click: v
                }, u.zoomOutGeo = {
                    name: "zoomOutGeo",
                    _cat: "zoomout",
                    title: function(e) {
                        return c(e, "Zoom out");
                    },
                    attr: "zoom",
                    val: "out",
                    icon: o.zoom_minus,
                    click: v
                }, u.resetGeo = {
                    name: "resetGeo",
                    _cat: "reset",
                    title: function(e) {
                        return c(e, "Reset");
                    },
                    attr: "reset",
                    val: null,
                    icon: o.autoscale,
                    click: v
                }, u.hoverClosestGeo = {
                    name: "hoverClosestGeo",
                    _cat: "hoverclosest",
                    title: function(e) {
                        return c(e, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: y
                }, u.hoverClosestGl2d = {
                    name: "hoverClosestGl2d",
                    _cat: "hoverclosest",
                    title: function(e) {
                        return c(e, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: y
                }, u.hoverClosestPie = {
                    name: "hoverClosestPie",
                    _cat: "hoverclosest",
                    title: function(e) {
                        return c(e, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: "closest",
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: y
                }, u.resetViewSankey = {
                    name: "resetSankeyGroup",
                    title: function(e) {
                        return c(e, "Reset view");
                    },
                    icon: o.home,
                    click: function(e) {
                        for(var t = {
                            "node.groups": [],
                            "node.x": [],
                            "node.y": []
                        }, r = 0; r < e._fullData.length; r++){
                            var a = e._fullData[r]._viewInitial;
                            t["node.groups"].push(a.node.groups.slice()), t["node.x"].push(a.node.x.slice()), t["node.y"].push(a.node.y.slice());
                        }
                        n.call("restyle", e, t);
                    }
                }, u.toggleHover = {
                    name: "toggleHover",
                    title: function(e) {
                        return c(e, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: function(e, t) {
                        var r = p(e, t);
                        r.hovermode = g(e), n.call("_guiRelayout", e, r);
                    }
                }, u.resetViews = {
                    name: "resetViews",
                    title: function(e) {
                        return c(e, "Reset views");
                    },
                    icon: o.home,
                    click: function(e, t) {
                        var r = t.currentTarget;
                        r.setAttribute("data-attr", "zoom"), r.setAttribute("data-val", "reset"), f(e, t), r.setAttribute("data-attr", "resetLastSave"), h(e, t), x(e, "geo"), x(e, "mapbox");
                    }
                }, u.toggleSpikelines = {
                    name: "toggleSpikelines",
                    title: function(e) {
                        return c(e, "Toggle Spike Lines");
                    },
                    icon: o.spikeline,
                    attr: "_cartesianSpikesEnabled",
                    val: "on",
                    click: function(e) {
                        var t = e._fullLayout, r = t._cartesianSpikesEnabled;
                        t._cartesianSpikesEnabled = "on" === r ? "off" : "on", n.call("_guiRelayout", e, function(e) {
                            for(var t = "on" === e._fullLayout._cartesianSpikesEnabled, r = i.list(e, null, !0), n = {}, a = 0; a < r.length; a++){
                                var o = r[a];
                                n[o._name + ".showspikes"] = !!t || o._showSpikeInitial;
                            }
                            return n;
                        }(e));
                    }
                }, u.resetViewMapbox = {
                    name: "resetViewMapbox",
                    _cat: "resetView",
                    title: function(e) {
                        return c(e, "Reset view");
                    },
                    attr: "reset",
                    icon: o.home,
                    click: function(e) {
                        x(e, "mapbox");
                    }
                }, u.zoomInMapbox = {
                    name: "zoomInMapbox",
                    _cat: "zoomin",
                    title: function(e) {
                        return c(e, "Zoom in");
                    },
                    attr: "zoom",
                    val: "in",
                    icon: o.zoom_plus,
                    click: m
                }, u.zoomOutMapbox = {
                    name: "zoomOutMapbox",
                    _cat: "zoomout",
                    title: function(e) {
                        return c(e, "Zoom out");
                    },
                    attr: "zoom",
                    val: "out",
                    icon: o.zoom_minus,
                    click: m
                };
            },
            3348: function(e, t, r) {
                "use strict";
                var n = r(6023), a = Object.keys(n), i = [
                    "drawline",
                    "drawopenpath",
                    "drawclosedpath",
                    "drawcircle",
                    "drawrect",
                    "eraseshape"
                ], o = [
                    "v1hovermode",
                    "hoverclosest",
                    "hovercompare",
                    "togglehover",
                    "togglespikelines"
                ].concat(i), l = [];
                a.forEach(function(e) {
                    !function(e) {
                        if (-1 === o.indexOf(e._cat || e.name)) {
                            var t = e.name, r = (e._cat || e.name).toLowerCase();
                            -1 === l.indexOf(t) && l.push(t), -1 === l.indexOf(r) && l.push(r);
                        }
                    }(n[e]);
                }), l.sort(), e.exports = {
                    DRAW_MODES: i,
                    backButtons: o,
                    foreButtons: l
                };
            },
            5750: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(7901), i = r(4467), o = r(2068);
                e.exports = function(e, t) {
                    var r = e.modebar || {}, l = i.newContainer(t, "modebar");
                    function s(e, t) {
                        return n.coerce(r, l, o, e, t);
                    }
                    s("orientation"), s("bgcolor", a.addOpacity(t.paper_bgcolor, .5));
                    var c = a.contrast(a.rgb(t.modebar.bgcolor));
                    s("color", a.addOpacity(c, .3)), s("activecolor", a.addOpacity(c, .7)), s("uirevision", t.uirevision), s("add"), s("remove");
                };
            },
            4168: function(e, t, r) {
                "use strict";
                e.exports = {
                    moduleType: "component",
                    name: "modebar",
                    layoutAttributes: r(2068),
                    supplyLayoutDefaults: r(5750),
                    manage: r(4192)
                };
            },
            4192: function(e, t, r) {
                "use strict";
                var n = r(1675), a = r(4098), i = r(3972), o = r(3469).isUnifiedHover, l = r(7676), s = r(6023), c = r(3348).DRAW_MODES, u = r(1828).extendDeep;
                e.exports = function(e) {
                    var t = e._fullLayout, r = e._context, f = t._modeBar;
                    if (r.displayModeBar || r.watermark) {
                        if (!Array.isArray(r.modeBarButtonsToRemove)) throw new Error([
                            "*modeBarButtonsToRemove* configuration options",
                            "must be an array."
                        ].join(" "));
                        if (!Array.isArray(r.modeBarButtonsToAdd)) throw new Error([
                            "*modeBarButtonsToAdd* configuration options",
                            "must be an array."
                        ].join(" "));
                        var d, h = r.modeBarButtons;
                        d = Array.isArray(h) && h.length ? function(e) {
                            for(var t = u([], e), r = 0; r < t.length; r++)for(var n = t[r], a = 0; a < n.length; a++){
                                var i = n[a];
                                if ("string" == typeof i) {
                                    if (void 0 === s[i]) throw new Error([
                                        "*modeBarButtons* configuration options",
                                        "invalid button name"
                                    ].join(" "));
                                    t[r][a] = s[i];
                                }
                            }
                            return t;
                        }(h) : !r.displayModeBar && r.watermark ? [] : function(e) {
                            var t = e._fullLayout, r = e._fullData, l = e._context;
                            function u(e, t) {
                                if ("string" == typeof t) {
                                    if (t.toLowerCase() === e.toLowerCase()) return !0;
                                } else {
                                    var r = t.name, n = t._cat || t.name;
                                    if (r === e || n === e.toLowerCase()) return !0;
                                }
                                return !1;
                            }
                            var f = t.modebar.add;
                            "string" == typeof f && (f = [
                                f
                            ]);
                            var d = t.modebar.remove;
                            "string" == typeof d && (d = [
                                d
                            ]);
                            var h = l.modeBarButtonsToAdd.concat(f.filter(function(e) {
                                for(var t = 0; t < l.modeBarButtonsToRemove.length; t++)if (u(e, l.modeBarButtonsToRemove[t])) return !1;
                                return !0;
                            })), p = l.modeBarButtonsToRemove.concat(d.filter(function(e) {
                                for(var t = 0; t < l.modeBarButtonsToAdd.length; t++)if (u(e, l.modeBarButtonsToAdd[t])) return !1;
                                return !0;
                            })), v = t._has("cartesian"), g = t._has("gl3d"), y = t._has("geo"), m = t._has("pie"), x = t._has("funnelarea"), b = t._has("gl2d"), _ = t._has("ternary"), w = t._has("mapbox"), T = t._has("polar"), M = t._has("smith"), k = t._has("sankey"), A = function(e) {
                                for(var t = n.list({
                                    _fullLayout: e
                                }, null, !0), r = 0; r < t.length; r++)if (!t[r].fixedrange) return !1;
                                return !0;
                            }(t), L = o(t.hovermode), S = [];
                            function D(e) {
                                if (e.length) {
                                    for(var t = [], r = 0; r < e.length; r++){
                                        for(var n = e[r], a = s[n], i = a.name.toLowerCase(), o = (a._cat || a.name).toLowerCase(), l = !1, c = 0; c < p.length; c++){
                                            var u = p[c].toLowerCase();
                                            if (u === i || u === o) {
                                                l = !0;
                                                break;
                                            }
                                        }
                                        l || t.push(s[n]);
                                    }
                                    S.push(t);
                                }
                            }
                            var O = [
                                "toImage"
                            ];
                            l.showEditInChartStudio ? O.push("editInChartStudio") : l.showSendToCloud && O.push("sendDataToCloud"), D(O);
                            var C = [], P = [], I = [], R = [];
                            (v || b || m || x || _) + y + g + w + T + M > 1 ? (P = [
                                "toggleHover"
                            ], I = [
                                "resetViews"
                            ]) : y ? (C = [
                                "zoomInGeo",
                                "zoomOutGeo"
                            ], P = [
                                "hoverClosestGeo"
                            ], I = [
                                "resetGeo"
                            ]) : g ? (P = [
                                "hoverClosest3d"
                            ], I = [
                                "resetCameraDefault3d",
                                "resetCameraLastSave3d"
                            ]) : w ? (C = [
                                "zoomInMapbox",
                                "zoomOutMapbox"
                            ], P = [
                                "toggleHover"
                            ], I = [
                                "resetViewMapbox"
                            ]) : b ? P = [
                                "hoverClosestGl2d"
                            ] : m ? P = [
                                "hoverClosestPie"
                            ] : k ? (P = [
                                "hoverClosestCartesian",
                                "hoverCompareCartesian"
                            ], I = [
                                "resetViewSankey"
                            ]) : P = [
                                "toggleHover"
                            ], v && (P = [
                                "toggleSpikelines",
                                "hoverClosestCartesian",
                                "hoverCompareCartesian"
                            ]), (function(e) {
                                for(var t = 0; t < e.length; t++)if (!i.traceIs(e[t], "noHover")) return !1;
                                return !0;
                            }(r) || L) && (P = []), !v && !b || A || (C = [
                                "zoomIn2d",
                                "zoomOut2d",
                                "autoScale2d"
                            ], "resetViews" !== I[0] && (I = [
                                "resetScale2d"
                            ])), g ? R = [
                                "zoom3d",
                                "pan3d",
                                "orbitRotation",
                                "tableRotation"
                            ] : (v || b) && !A || _ ? R = [
                                "zoom2d",
                                "pan2d"
                            ] : w || y ? R = [
                                "pan2d"
                            ] : T && (R = [
                                "zoom2d"
                            ]), function(e) {
                                for(var t = !1, r = 0; r < e.length && !t; r++){
                                    var n = e[r];
                                    n._module && n._module.selectPoints && (i.traceIs(n, "scatter-like") ? (a.hasMarkers(n) || a.hasText(n)) && (t = !0) : i.traceIs(n, "box-violin") && "all" !== n.boxpoints && "all" !== n.points || (t = !0));
                                }
                                return t;
                            }(r) && R.push("select2d", "lasso2d");
                            var z = [], N = function(e) {
                                -1 === z.indexOf(e) && -1 !== P.indexOf(e) && z.push(e);
                            };
                            if (Array.isArray(h)) {
                                for(var F = [], E = 0; E < h.length; E++){
                                    var H = h[E];
                                    "string" == typeof H ? (H = H.toLowerCase(), -1 !== c.indexOf(H) ? (t._has("mapbox") || t._has("cartesian")) && R.push(H) : "togglespikelines" === H ? N("toggleSpikelines") : "togglehover" === H ? N("toggleHover") : "hovercompare" === H ? N("hoverCompareCartesian") : "hoverclosest" === H ? (N("hoverClosestCartesian"), N("hoverClosestGeo"), N("hoverClosest3d"), N("hoverClosestGl2d"), N("hoverClosestPie")) : "v1hovermode" === H && (N("toggleHover"), N("hoverClosestCartesian"), N("hoverCompareCartesian"), N("hoverClosestGeo"), N("hoverClosest3d"), N("hoverClosestGl2d"), N("hoverClosestPie"))) : F.push(H);
                                }
                                h = F;
                            }
                            return D(R), D(C.concat(I)), D(z), function(e, t) {
                                if (t.length) {
                                    if (Array.isArray(t[0])) for(var r = 0; r < t.length; r++)e.push(t[r]);
                                    else e.push(t);
                                }
                                return e;
                            }(S, h);
                        }(e), f ? f.update(e, d) : t._modeBar = l(e, d);
                    } else f && (f.destroy(), delete t._modeBar);
                };
            },
            7676: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(2770), i = r(1828), o = r(4255), l = r(1506).version, s = new DOMParser;
                function c(e) {
                    this.container = e.container, this.element = document.createElement("div"), this.update(e.graphInfo, e.buttons), this.container.appendChild(this.element);
                }
                var u = c.prototype;
                u.update = function(e, t) {
                    this.graphInfo = e;
                    var r = this.graphInfo._context, n = this.graphInfo._fullLayout, a = "modebar-" + n._uid;
                    this.element.setAttribute("id", a), this._uid = a, this.element.className = "modebar", "hover" === r.displayModeBar && (this.element.className += " modebar--hover ease-bg"), "v" === n.modebar.orientation && (this.element.className += " vertical", t = t.reverse());
                    var o = n.modebar, l = "hover" === r.displayModeBar ? ".js-plotly-plot .plotly:hover " : "";
                    i.deleteRelatedStyleRule(a), i.addRelatedStyleRule(a, l + "#" + a + " .modebar-group", "background-color: " + o.bgcolor), i.addRelatedStyleRule(a, "#" + a + " .modebar-btn .icon path", "fill: " + o.color), i.addRelatedStyleRule(a, "#" + a + " .modebar-btn:hover .icon path", "fill: " + o.activecolor), i.addRelatedStyleRule(a, "#" + a + " .modebar-btn.active .icon path", "fill: " + o.activecolor);
                    var s = !this.hasButtons(t), c = this.hasLogo !== r.displaylogo, u = this.locale !== r.locale;
                    if (this.locale = r.locale, (s || c || u) && (this.removeAllButtons(), this.updateButtons(t), r.watermark || r.displaylogo)) {
                        var f = this.getLogo();
                        r.watermark && (f.className = f.className + " watermark"), "v" === n.modebar.orientation ? this.element.insertBefore(f, this.element.childNodes[0]) : this.element.appendChild(f), this.hasLogo = !0;
                    }
                    this.updateActiveButton();
                }, u.updateButtons = function(e) {
                    var t = this;
                    this.buttons = e, this.buttonElements = [], this.buttonsNames = [], this.buttons.forEach(function(e) {
                        var r = t.createGroup();
                        e.forEach(function(e) {
                            var n = e.name;
                            if (!n) throw new Error("must provide button 'name' in button config");
                            if (-1 !== t.buttonsNames.indexOf(n)) throw new Error("button name '" + n + "' is taken");
                            t.buttonsNames.push(n);
                            var a = t.createButton(e);
                            t.buttonElements.push(a), r.appendChild(a);
                        }), t.element.appendChild(r);
                    });
                }, u.createGroup = function() {
                    var e = document.createElement("div");
                    return e.className = "modebar-group", e;
                }, u.createButton = function(e) {
                    var t = this, r = document.createElement("a");
                    r.setAttribute("rel", "tooltip"), r.className = "modebar-btn";
                    var a = e.title;
                    void 0 === a ? a = e.name : "function" == typeof a && (a = a(this.graphInfo)), (a || 0 === a) && r.setAttribute("data-title", a), void 0 !== e.attr && r.setAttribute("data-attr", e.attr);
                    var i = e.val;
                    if (void 0 !== i && ("function" == typeof i && (i = i(this.graphInfo)), r.setAttribute("data-val", i)), "function" != typeof e.click) throw new Error("must provide button 'click' function in button config");
                    r.addEventListener("click", function(r) {
                        e.click(t.graphInfo, r), t.updateActiveButton(r.currentTarget);
                    }), r.setAttribute("data-toggle", e.toggle || !1), e.toggle && n.select(r).classed("active", !0);
                    var l = e.icon;
                    return "function" == typeof l ? r.appendChild(l()) : r.appendChild(this.createIcon(l || o.question)), r.setAttribute("data-gravity", e.gravity || "n"), r;
                }, u.createIcon = function(e) {
                    var t, r = a(e.height) ? Number(e.height) : e.ascent - e.descent, n = "http://www.w3.org/2000/svg";
                    if (e.path) {
                        (t = document.createElementNS(n, "svg")).setAttribute("viewBox", [
                            0,
                            0,
                            e.width,
                            r
                        ].join(" ")), t.setAttribute("class", "icon");
                        var i = document.createElementNS(n, "path");
                        i.setAttribute("d", e.path), e.transform ? i.setAttribute("transform", e.transform) : void 0 !== e.ascent && i.setAttribute("transform", "matrix(1 0 0 -1 0 " + e.ascent + ")"), t.appendChild(i);
                    }
                    return e.svg && (t = s.parseFromString(e.svg, "application/xml").childNodes[0]), t.setAttribute("height", "1em"), t.setAttribute("width", "1em"), t;
                }, u.updateActiveButton = function(e) {
                    var t = this.graphInfo._fullLayout, r = void 0 !== e ? e.getAttribute("data-attr") : null;
                    this.buttonElements.forEach(function(e) {
                        var a = e.getAttribute("data-val") || !0, o = e.getAttribute("data-attr"), l = "true" === e.getAttribute("data-toggle"), s = n.select(e);
                        if (l) o === r && s.classed("active", !s.classed("active"));
                        else {
                            var c = null === o ? o : i.nestedProperty(t, o).get();
                            s.classed("active", c === a);
                        }
                    });
                }, u.hasButtons = function(e) {
                    var t = this.buttons;
                    if (!t) return !1;
                    if (e.length !== t.length) return !1;
                    for(var r = 0; r < e.length; ++r){
                        if (e[r].length !== t[r].length) return !1;
                        for(var n = 0; n < e[r].length; n++)if (e[r][n].name !== t[r][n].name) return !1;
                    }
                    return !0;
                }, u.getLogo = function() {
                    var e = this.createGroup(), t = document.createElement("a");
                    return t.href = "https://plotly.com/", t.target = "_blank", t.setAttribute("data-title", i._(this.graphInfo, "Produced with Plotly.js") + " (v" + l + ")"), t.className = "modebar-btn plotlyjsicon modebar-btn--logo", t.appendChild(this.createIcon(o.newplotlylogo)), e.appendChild(t), e;
                }, u.removeAllButtons = function() {
                    for(; this.element.firstChild;)this.element.removeChild(this.element.firstChild);
                    this.hasLogo = !1;
                }, u.destroy = function() {
                    i.removeElement(this.container.querySelector(".modebar")), i.deleteRelatedStyleRule(this._uid);
                }, e.exports = function(e, t) {
                    var r = e._fullLayout, a = new c({
                        graphInfo: e,
                        container: r._modebardiv.node(),
                        buttons: t
                    });
                    return r._privateplot && n.select(a.element).append("span").classed("badge-private float--left", !0).text("PRIVATE"), a;
                };
            },
            7113: function(e, t, r) {
                "use strict";
                var n = r(1940), a = r(2399), i = (0, r(4467).templatedArray)("button", {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    step: {
                        valType: "enumerated",
                        values: [
                            "month",
                            "year",
                            "day",
                            "hour",
                            "minute",
                            "second",
                            "all"
                        ],
                        dflt: "month",
                        editType: "plot"
                    },
                    stepmode: {
                        valType: "enumerated",
                        values: [
                            "backward",
                            "todate"
                        ],
                        dflt: "backward",
                        editType: "plot"
                    },
                    count: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "plot"
                    },
                    label: {
                        valType: "string",
                        editType: "plot"
                    },
                    editType: "plot"
                });
                e.exports = {
                    visible: {
                        valType: "boolean",
                        editType: "plot"
                    },
                    buttons: i,
                    x: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        editType: "plot"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left",
                        editType: "plot"
                    },
                    y: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        editType: "plot"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "bottom",
                        editType: "plot"
                    },
                    font: n({
                        editType: "plot"
                    }),
                    bgcolor: {
                        valType: "color",
                        dflt: a.lightLine,
                        editType: "plot"
                    },
                    activecolor: {
                        valType: "color",
                        editType: "plot"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: a.defaultLine,
                        editType: "plot"
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "plot"
                    },
                    editType: "plot"
                };
            },
            9573: function(e) {
                "use strict";
                e.exports = {
                    yPad: .02,
                    minButtonWidth: 30,
                    rx: 3,
                    ry: 3,
                    lightAmount: 25,
                    darkAmount: 10
                };
            },
            8674: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(7901), i = r(4467), o = r(5501), l = r(7113), s = r(9573);
                function c(e, t, r, a) {
                    var i = a.calendar;
                    function o(r, a) {
                        return n.coerce(e, t, l.buttons, r, a);
                    }
                    if (o("visible")) {
                        var s = o("step");
                        "all" !== s && (!i || "gregorian" === i || "month" !== s && "year" !== s ? o("stepmode") : t.stepmode = "backward", o("count")), o("label");
                    }
                }
                e.exports = function(e, t, r, u, f) {
                    var d = e.rangeselector || {}, h = i.newContainer(t, "rangeselector");
                    function p(e, t) {
                        return n.coerce(d, h, l, e, t);
                    }
                    if (p("visible", o(d, h, {
                        name: "buttons",
                        handleItemDefaults: c,
                        calendar: f
                    }).length > 0)) {
                        var v = function(e, t, r) {
                            for(var n = r.filter(function(r) {
                                return t[r].anchor === e._id;
                            }), a = 0, i = 0; i < n.length; i++){
                                var o = t[n[i]].domain;
                                o && (a = Math.max(o[1], a));
                            }
                            return [
                                e.domain[0],
                                a + s.yPad
                            ];
                        }(t, r, u);
                        p("x", v[0]), p("y", v[1]), n.noneOrAll(e, t, [
                            "x",
                            "y"
                        ]), p("xanchor"), p("yanchor"), n.coerceFont(p, "font", r.font);
                        var g = p("bgcolor");
                        p("activecolor", a.contrast(g, s.lightAmount, s.darkAmount)), p("bordercolor"), p("borderwidth");
                    }
                };
            },
            1598: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(3972), i = r(4875), o = r(7901), l = r(1424), s = r(1828), c = s.strTranslate, u = r(3893), f = r(1675), d = r(8783), h = d.LINE_SPACING, p = d.FROM_TL, v = d.FROM_BR, g = r(9573), y = r(7917);
                function m(e) {
                    return e._id;
                }
                function x(e, t, r) {
                    var n = s.ensureSingle(e, "rect", "selector-rect", function(e) {
                        e.attr("shape-rendering", "crispEdges");
                    });
                    n.attr({
                        rx: g.rx,
                        ry: g.ry
                    }), n.call(o.stroke, t.bordercolor).call(o.fill, function(e, t) {
                        return t._isActive || t._isHovered ? e.activecolor : e.bgcolor;
                    }(t, r)).style("stroke-width", t.borderwidth + "px");
                }
                function b(e, t, r, n) {
                    var a, i;
                    s.ensureSingle(e, "text", "selector-text", function(e) {
                        e.attr("text-anchor", "middle");
                    }).call(l.font, t.font).text((a = r, i = n._fullLayout._meta, a.label ? i ? s.templateString(a.label, i) : a.label : "all" === a.step ? "all" : a.count + a.step.charAt(0))).call(function(e) {
                        u.convertToTspans(e, n);
                    });
                }
                e.exports = function(e) {
                    var t = e._fullLayout._infolayer.selectAll(".rangeselector").data(function(e) {
                        for(var t = f.list(e, "x", !0), r = [], n = 0; n < t.length; n++){
                            var a = t[n];
                            a.rangeselector && a.rangeselector.visible && r.push(a);
                        }
                        return r;
                    }(e), m);
                    t.enter().append("g").classed("rangeselector", !0), t.exit().remove(), t.style({
                        cursor: "pointer",
                        "pointer-events": "all"
                    }), t.each(function(t) {
                        var r = n.select(this), o = t, f = o.rangeselector, d = r.selectAll("g.button").data(s.filterVisible(f.buttons));
                        d.enter().append("g").classed("button", !0), d.exit().remove(), d.each(function(t) {
                            var r = n.select(this), i = y(o, t);
                            t._isActive = function(e, t, r) {
                                if ("all" === t.step) return !0 === e.autorange;
                                var n = Object.keys(r);
                                return e.range[0] === r[n[0]] && e.range[1] === r[n[1]];
                            }(o, t, i), r.call(x, f, t), r.call(b, f, t, e), r.on("click", function() {
                                e._dragged || a.call("_guiRelayout", e, i);
                            }), r.on("mouseover", function() {
                                t._isHovered = !0, r.call(x, f, t);
                            }), r.on("mouseout", function() {
                                t._isHovered = !1, r.call(x, f, t);
                            });
                        }), function(e, t, r, a, o) {
                            var f = 0, d = 0, y = r.borderwidth;
                            t.each(function() {
                                var e = n.select(this).select(".selector-text"), t = r.font.size * h, a = Math.max(t * u.lineCount(e), 16) + 3;
                                d = Math.max(d, a);
                            }), t.each(function() {
                                var e = n.select(this), t = e.select(".selector-rect"), a = e.select(".selector-text"), i = a.node() && l.bBox(a.node()).width, o = r.font.size * h, s = u.lineCount(a), p = Math.max(i + 10, g.minButtonWidth);
                                e.attr("transform", c(y + f, y)), t.attr({
                                    x: 0,
                                    y: 0,
                                    width: p,
                                    height: d
                                }), u.positionText(a, p / 2, d / 2 - (s - 1) * o / 2 + 3), f += p + 5;
                            });
                            var m = e._fullLayout._size, x = m.l + m.w * r.x, b = m.t + m.h * (1 - r.y), _ = "left";
                            s.isRightAnchor(r) && (x -= f, _ = "right"), s.isCenterAnchor(r) && (x -= f / 2, _ = "center");
                            var w = "top";
                            s.isBottomAnchor(r) && (b -= d, w = "bottom"), s.isMiddleAnchor(r) && (b -= d / 2, w = "middle"), f = Math.ceil(f), d = Math.ceil(d), x = Math.round(x), b = Math.round(b), i.autoMargin(e, a + "-range-selector", {
                                x: r.x,
                                y: r.y,
                                l: f * p[_],
                                r: f * v[_],
                                b: d * v[w],
                                t: d * p[w]
                            }), o.attr("transform", c(x, b));
                        }(e, d, f, o._name, r);
                    });
                };
            },
            7917: function(e, t, r) {
                "use strict";
                var n = r(1041), a = r(1828).titleCase;
                e.exports = function(e, t) {
                    var r = e._name, i = {};
                    if ("all" === t.step) i[r + ".autorange"] = !0;
                    else {
                        var o = function(e, t) {
                            var r, i = e.range, o = new Date(e.r2l(i[1])), l = t.step, s = n["utc" + a(l)], c = t.count;
                            switch(t.stepmode){
                                case "backward":
                                    r = e.l2r(+s.offset(o, -c));
                                    break;
                                case "todate":
                                    var u = s.offset(o, -c);
                                    r = e.l2r(+s.ceil(u));
                            }
                            return [
                                r,
                                i[1]
                            ];
                        }(e, t);
                        i[r + ".range[0]"] = o[0], i[r + ".range[1]"] = o[1];
                    }
                    return i;
                };
            },
            7218: function(e, t, r) {
                "use strict";
                e.exports = {
                    moduleType: "component",
                    name: "rangeselector",
                    schema: {
                        subplots: {
                            xaxis: {
                                rangeselector: r(7113)
                            }
                        }
                    },
                    layoutAttributes: r(7113),
                    handleDefaults: r(8674),
                    draw: r(1598)
                };
            },
            5148: function(e, t, r) {
                "use strict";
                var n = r(2399);
                e.exports = {
                    bgcolor: {
                        valType: "color",
                        dflt: n.background,
                        editType: "plot"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: n.defaultLine,
                        editType: "plot"
                    },
                    borderwidth: {
                        valType: "integer",
                        dflt: 0,
                        min: 0,
                        editType: "plot"
                    },
                    autorange: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc",
                        impliedEdits: {
                            "range[0]": void 0,
                            "range[1]": void 0
                        }
                    },
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "calc",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            },
                            {
                                valType: "any",
                                editType: "calc",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            }
                        ],
                        editType: "calc",
                        impliedEdits: {
                            autorange: !1
                        }
                    },
                    thickness: {
                        valType: "number",
                        dflt: .15,
                        min: 0,
                        max: 1,
                        editType: "plot"
                    },
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    editType: "calc"
                };
            },
            8443: function(e, t, r) {
                "use strict";
                var n = r(1675).list, a = r(1739).getAutoRange, i = r(3251);
                e.exports = function(e) {
                    for(var t = n(e, "x", !0), r = 0; r < t.length; r++){
                        var o = t[r], l = o[i.name];
                        l && l.visible && l.autorange && (l._input.autorange = !0, l._input.range = l.range = a(e, o));
                    }
                };
            },
            3251: function(e) {
                "use strict";
                e.exports = {
                    name: "rangeslider",
                    containerClassName: "rangeslider-container",
                    bgClassName: "rangeslider-bg",
                    rangePlotClassName: "rangeslider-rangeplot",
                    maskMinClassName: "rangeslider-mask-min",
                    maskMaxClassName: "rangeslider-mask-max",
                    slideBoxClassName: "rangeslider-slidebox",
                    grabberMinClassName: "rangeslider-grabber-min",
                    grabAreaMinClassName: "rangeslider-grabarea-min",
                    handleMinClassName: "rangeslider-handle-min",
                    grabberMaxClassName: "rangeslider-grabber-max",
                    grabAreaMaxClassName: "rangeslider-grabarea-max",
                    handleMaxClassName: "rangeslider-handle-max",
                    maskMinOppAxisClassName: "rangeslider-mask-min-opp-axis",
                    maskMaxOppAxisClassName: "rangeslider-mask-max-opp-axis",
                    maskColor: "rgba(0,0,0,0.4)",
                    maskOppAxisColor: "rgba(0,0,0,0.2)",
                    slideBoxFill: "transparent",
                    slideBoxCursor: "ew-resize",
                    grabAreaFill: "transparent",
                    grabAreaCursor: "col-resize",
                    grabAreaWidth: 10,
                    handleWidth: 4,
                    handleRadius: 1,
                    handleStrokeWidth: 1,
                    extraPad: 15
                };
            },
            6377: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(4467), i = r(1675), o = r(5148), l = r(7850);
                e.exports = function(e, t, r) {
                    var s = e[r], c = t[r];
                    if (s.rangeslider || t._requestRangeslider[c._id]) {
                        n.isPlainObject(s.rangeslider) || (s.rangeslider = {});
                        var u, f, d = s.rangeslider, h = a.newContainer(c, "rangeslider");
                        if (_("visible")) {
                            _("bgcolor", t.plot_bgcolor), _("bordercolor"), _("borderwidth"), _("thickness"), _("autorange", !c.isValidRange(d.range)), _("range");
                            var p = t._subplots;
                            if (p) for(var v = p.cartesian.filter(function(e) {
                                return e.substr(0, e.indexOf("y")) === i.name2id(r);
                            }).map(function(e) {
                                return e.substr(e.indexOf("y"), e.length);
                            }), g = n.simpleMap(v, i.id2name), y = 0; y < g.length; y++){
                                var m = g[y];
                                u = d[m] || {}, f = a.newContainer(h, m, "yaxis");
                                var x, b = t[m];
                                u.range && b.isValidRange(u.range) && (x = "fixed"), "match" !== w("rangemode", x) && w("range", b.range.slice());
                            }
                            h._input = d;
                        }
                    }
                    function _(e, t) {
                        return n.coerce(d, h, o, e, t);
                    }
                    function w(e, t) {
                        return n.coerce(u, f, l, e, t);
                    }
                };
            },
            2413: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(3972), i = r(4875), o = r(1828), l = o.strTranslate, s = r(1424), c = r(7901), u = r(2998), f = r(3612), d = r(1675), h = r(8569), p = r(6964), v = r(3251);
                function g(e, t, r, n) {
                    var a = o.ensureSingle(e, "rect", v.bgClassName, function(e) {
                        e.attr({
                            x: 0,
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }), i = n.borderwidth % 2 == 0 ? n.borderwidth : n.borderwidth - 1, u = -n._offsetShift, f = s.crispRound(t, n.borderwidth);
                    a.attr({
                        width: n._width + i,
                        height: n._height + i,
                        transform: l(u, u),
                        "stroke-width": f
                    }).call(c.stroke, n.bordercolor).call(c.fill, n.bgcolor);
                }
                function y(e, t, r, n) {
                    var a = t._fullLayout;
                    o.ensureSingleById(a._topdefs, "clipPath", n._clipId, function(e) {
                        e.append("rect").attr({
                            x: 0,
                            y: 0
                        });
                    }).select("rect").attr({
                        width: n._width,
                        height: n._height
                    });
                }
                function m(e, t, r, a) {
                    var l, c = t.calcdata, u = e.selectAll("g." + v.rangePlotClassName).data(r._subplotsWith, o.identity);
                    u.enter().append("g").attr("class", function(e) {
                        return v.rangePlotClassName + " " + e;
                    }).call(s.setClipUrl, a._clipId, t), u.order(), u.exit().remove(), u.each(function(e, o) {
                        var s = n.select(this), u = 0 === o, h = d.getFromId(t, e, "y"), p = h._name, v = a[p], g = {
                            data: [],
                            layout: {
                                xaxis: {
                                    type: r.type,
                                    domain: [
                                        0,
                                        1
                                    ],
                                    range: a.range.slice(),
                                    calendar: r.calendar
                                },
                                width: a._width,
                                height: a._height,
                                margin: {
                                    t: 0,
                                    b: 0,
                                    l: 0,
                                    r: 0
                                }
                            },
                            _context: t._context
                        };
                        r.rangebreaks && (g.layout.xaxis.rangebreaks = r.rangebreaks), g.layout[p] = {
                            type: h.type,
                            domain: [
                                0,
                                1
                            ],
                            range: "match" !== v.rangemode ? v.range.slice() : h.range.slice(),
                            calendar: h.calendar
                        }, h.rangebreaks && (g.layout[p].rangebreaks = h.rangebreaks), i.supplyDefaults(g);
                        var y = g._fullLayout.xaxis, m = g._fullLayout[p];
                        y.clearCalc(), y.setScale(), m.clearCalc(), m.setScale();
                        var x = {
                            id: e,
                            plotgroup: s,
                            xaxis: y,
                            yaxis: m,
                            isRangePlot: !0
                        };
                        u ? l = x : (x.mainplot = "xy", x.mainplotinfo = l), f.rangePlot(t, x, function(e, t) {
                            for(var r = [], n = 0; n < e.length; n++){
                                var a = e[n], i = a[0].trace;
                                i.xaxis + i.yaxis === t && r.push(a);
                            }
                            return r;
                        }(c, e));
                    });
                }
                function x(e, t, r, n, a) {
                    o.ensureSingle(e, "rect", v.maskMinClassName, function(e) {
                        e.attr({
                            x: 0,
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("height", n._height).call(c.fill, v.maskColor), o.ensureSingle(e, "rect", v.maskMaxClassName, function(e) {
                        e.attr({
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("height", n._height).call(c.fill, v.maskColor), "match" !== a.rangemode && (o.ensureSingle(e, "rect", v.maskMinOppAxisClassName, function(e) {
                        e.attr({
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("width", n._width).call(c.fill, v.maskOppAxisColor), o.ensureSingle(e, "rect", v.maskMaxOppAxisClassName, function(e) {
                        e.attr({
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("width", n._width).style("border-top", v.maskOppBorder).call(c.fill, v.maskOppAxisColor));
                }
                function b(e, t, r, n) {
                    t._context.staticPlot || o.ensureSingle(e, "rect", v.slideBoxClassName, function(e) {
                        e.attr({
                            y: 0,
                            cursor: v.slideBoxCursor,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr({
                        height: n._height,
                        fill: v.slideBoxFill
                    });
                }
                function _(e, t, r, n) {
                    var a = o.ensureSingle(e, "g", v.grabberMinClassName), i = o.ensureSingle(e, "g", v.grabberMaxClassName), l = {
                        x: 0,
                        width: v.handleWidth,
                        rx: v.handleRadius,
                        fill: c.background,
                        stroke: c.defaultLine,
                        "stroke-width": v.handleStrokeWidth,
                        "shape-rendering": "crispEdges"
                    }, s = {
                        y: Math.round(n._height / 4),
                        height: Math.round(n._height / 2)
                    };
                    o.ensureSingle(a, "rect", v.handleMinClassName, function(e) {
                        e.attr(l);
                    }).attr(s), o.ensureSingle(i, "rect", v.handleMaxClassName, function(e) {
                        e.attr(l);
                    }).attr(s);
                    var u = {
                        width: v.grabAreaWidth,
                        x: 0,
                        y: 0,
                        fill: v.grabAreaFill,
                        cursor: t._context.staticPlot ? void 0 : v.grabAreaCursor
                    };
                    o.ensureSingle(a, "rect", v.grabAreaMinClassName, function(e) {
                        e.attr(u);
                    }).attr("height", n._height), o.ensureSingle(i, "rect", v.grabAreaMaxClassName, function(e) {
                        e.attr(u);
                    }).attr("height", n._height);
                }
                e.exports = function(e) {
                    for(var t = e._fullLayout, r = t._rangeSliderData, i = 0; i < r.length; i++){
                        var s = r[i][v.name];
                        s._clipId = s._id + "-" + t._uid;
                    }
                    var c = t._infolayer.selectAll("g." + v.containerClassName).data(r, function(e) {
                        return e._name;
                    });
                    c.exit().each(function(e) {
                        var r = e[v.name];
                        t._topdefs.select("#" + r._clipId).remove();
                    }).remove(), 0 !== r.length && (c.enter().append("g").classed(v.containerClassName, !0).attr("pointer-events", "all"), c.each(function(r) {
                        var i = n.select(this), s = r[v.name], c = t[d.id2name(r.anchor)], f = s[d.id2name(r.anchor)];
                        if (s.range) {
                            var w, T = o.simpleMap(s.range, r.r2l), M = o.simpleMap(r.range, r.r2l);
                            w = M[0] < M[1] ? [
                                Math.min(T[0], M[0]),
                                Math.max(T[1], M[1])
                            ] : [
                                Math.max(T[0], M[0]),
                                Math.min(T[1], M[1])
                            ], s.range = s._input.range = o.simpleMap(w, r.l2r);
                        }
                        r.cleanRange("rangeslider.range");
                        var k = t._size, A = r.domain;
                        s._width = k.w * (A[1] - A[0]);
                        var L = Math.round(k.l + k.w * A[0]), S = Math.round(k.t + k.h * (1 - r._counterDomainMin) + ("bottom" === r.side ? r._depth : 0) + s._offsetShift + v.extraPad);
                        i.attr("transform", l(L, S)), s._rl = o.simpleMap(s.range, r.r2l);
                        var D = s._rl[0], O = s._rl[1], C = O - D;
                        if (s.p2d = function(e) {
                            return e / s._width * C + D;
                        }, s.d2p = function(e) {
                            return (e - D) / C * s._width;
                        }, r.rangebreaks) {
                            var P = r.locateBreaks(D, O);
                            if (P.length) {
                                var I, R, z = 0;
                                for(I = 0; I < P.length; I++)z += (R = P[I]).max - R.min;
                                var N = s._width / (O - D - z), F = [
                                    -N * D
                                ];
                                for(I = 0; I < P.length; I++)R = P[I], F.push(F[F.length - 1] - N * (R.max - R.min));
                                for(s.d2p = function(e) {
                                    for(var t = F[0], r = 0; r < P.length; r++){
                                        var n = P[r];
                                        if (e >= n.max) t = F[r + 1];
                                        else if (e < n.min) break;
                                    }
                                    return t + N * e;
                                }, I = 0; I < P.length; I++)(R = P[I]).pmin = s.d2p(R.min), R.pmax = s.d2p(R.max);
                                s.p2d = function(e) {
                                    for(var t = F[0], r = 0; r < P.length; r++){
                                        var n = P[r];
                                        if (e >= n.pmax) t = F[r + 1];
                                        else if (e < n.pmin) break;
                                    }
                                    return (e - t) / N;
                                };
                            }
                        }
                        if ("match" !== f.rangemode) {
                            var E = c.r2l(f.range[0]), H = c.r2l(f.range[1]) - E;
                            s.d2pOppAxis = function(e) {
                                return (e - E) / H * s._height;
                            };
                        }
                        i.call(g, e, r, s).call(y, e, r, s).call(m, e, r, s).call(x, e, r, s, f).call(b, e, r, s).call(_, e, r, s), function(e, t, r, i) {
                            if (!t._context.staticPlot) {
                                var l = e.select("rect." + v.slideBoxClassName).node(), s = e.select("rect." + v.grabAreaMinClassName).node(), c = e.select("rect." + v.grabAreaMaxClassName).node();
                                e.on("mousedown", u), e.on("touchstart", u);
                            }
                            function u() {
                                var u = n.event, f = u.target, d = u.clientX || u.touches[0].clientX, v = d - e.node().getBoundingClientRect().left, g = i.d2p(r._rl[0]), y = i.d2p(r._rl[1]), m = h.coverSlip();
                                function x(e) {
                                    var u, h, x, b = +(e.clientX || e.touches[0].clientX) - d;
                                    switch(f){
                                        case l:
                                            if (x = "ew-resize", g + b > r._length || y + b < 0) return;
                                            u = g + b, h = y + b;
                                            break;
                                        case s:
                                            if (x = "col-resize", g + b > r._length) return;
                                            u = g + b, h = y;
                                            break;
                                        case c:
                                            if (x = "col-resize", y + b < 0) return;
                                            u = g, h = y + b;
                                            break;
                                        default:
                                            x = "ew-resize", u = v, h = v + b;
                                    }
                                    if (h < u) {
                                        var _ = h;
                                        h = u, u = _;
                                    }
                                    i._pixelMin = u, i._pixelMax = h, p(n.select(m), x), function(e, t, r, n) {
                                        function i(e) {
                                            return r.l2r(o.constrain(e, n._rl[0], n._rl[1]));
                                        }
                                        var l = i(n.p2d(n._pixelMin)), s = i(n.p2d(n._pixelMax));
                                        window.requestAnimationFrame(function() {
                                            a.call("_guiRelayout", t, r._name + ".range", [
                                                l,
                                                s
                                            ]);
                                        });
                                    }(0, t, r, i);
                                }
                                function b() {
                                    m.removeEventListener("mousemove", x), m.removeEventListener("mouseup", b), this.removeEventListener("touchmove", x), this.removeEventListener("touchend", b), o.removeElement(m);
                                }
                                this.addEventListener("touchmove", x), this.addEventListener("touchend", b), m.addEventListener("mousemove", x), m.addEventListener("mouseup", b);
                            }
                        }(i, e, r, s), function(e, t, r, n, a, i) {
                            var s = v.handleWidth / 2;
                            function c(e) {
                                return o.constrain(e, 0, n._width);
                            }
                            function u(e) {
                                return o.constrain(e, 0, n._height);
                            }
                            function f(e) {
                                return o.constrain(e, -s, n._width + s);
                            }
                            var d = c(n.d2p(r._rl[0])), h = c(n.d2p(r._rl[1]));
                            if (e.select("rect." + v.slideBoxClassName).attr("x", d).attr("width", h - d), e.select("rect." + v.maskMinClassName).attr("width", d), e.select("rect." + v.maskMaxClassName).attr("x", h).attr("width", n._width - h), "match" !== i.rangemode) {
                                var p = n._height - u(n.d2pOppAxis(a._rl[1])), g = n._height - u(n.d2pOppAxis(a._rl[0]));
                                e.select("rect." + v.maskMinOppAxisClassName).attr("x", d).attr("height", p).attr("width", h - d), e.select("rect." + v.maskMaxOppAxisClassName).attr("x", d).attr("y", g).attr("height", n._height - g).attr("width", h - d), e.select("rect." + v.slideBoxClassName).attr("y", p).attr("height", g - p);
                            }
                            var y = .5, m = Math.round(f(d - s)) - y, x = Math.round(f(h - s)) + y;
                            e.select("g." + v.grabberMinClassName).attr("transform", l(m, y)), e.select("g." + v.grabberMaxClassName).attr("transform", l(x, y));
                        }(i, 0, r, s, c, f), "bottom" === r.side && u.draw(e, r._id + "title", {
                            propContainer: r,
                            propName: r._name + ".title",
                            placeholder: t._dfltTitle.x,
                            attributes: {
                                x: r._offset + r._length / 2,
                                y: S + s._height + s._offsetShift + 10 + 1.5 * r.title.font.size,
                                "text-anchor": "middle"
                            }
                        });
                    }));
                };
            },
            549: function(e, t, r) {
                "use strict";
                var n = r(1675), a = r(3893), i = r(3251), o = r(8783).LINE_SPACING, l = i.name;
                function s(e) {
                    var t = e && e[l];
                    return t && t.visible;
                }
                t.isVisible = s, t.makeData = function(e) {
                    var t = n.list({
                        _fullLayout: e
                    }, "x", !0), r = e.margin, a = [];
                    if (!e._has("gl2d")) for(var i = 0; i < t.length; i++){
                        var o = t[i];
                        if (s(o)) {
                            a.push(o);
                            var c = o[l];
                            c._id = l + o._id, c._height = (e.height - r.b - r.t) * c.thickness, c._offsetShift = Math.floor(c.borderwidth / 2);
                        }
                    }
                    e._rangeSliderData = a;
                }, t.autoMarginOpts = function(e, t) {
                    var r = e._fullLayout, n = t[l], s = t._id.charAt(0), c = 0, u = 0;
                    return "bottom" === t.side && (c = t._depth, t.title.text !== r._dfltTitle[s] && (u = 1.5 * t.title.font.size + 10 + n._offsetShift, u += (t.title.text.match(a.BR_TAG_ALL) || []).length * t.title.font.size * o)), {
                        x: 0,
                        y: t._counterDomainMin,
                        l: 0,
                        r: 0,
                        t: 0,
                        b: n._height + c + Math.max(r.margin.b, u),
                        pad: i.extraPad + 2 * n._offsetShift
                    };
                };
            },
            3137: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(5148), i = r(7850), o = r(549);
                e.exports = {
                    moduleType: "component",
                    name: "rangeslider",
                    schema: {
                        subplots: {
                            xaxis: {
                                rangeslider: n.extendFlat({}, a, {
                                    yaxis: i
                                })
                            }
                        }
                    },
                    layoutAttributes: r(5148),
                    handleDefaults: r(6377),
                    calcAutorange: r(8443),
                    draw: r(2413),
                    isVisible: o.isVisible,
                    makeData: o.makeData,
                    autoMarginOpts: o.autoMarginOpts
                };
            },
            7850: function(e) {
                "use strict";
                e.exports = {
                    _isSubplotObj: !0,
                    rangemode: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "fixed",
                            "match"
                        ],
                        dflt: "match",
                        editType: "calc"
                    },
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "plot"
                            },
                            {
                                valType: "any",
                                editType: "plot"
                            }
                        ],
                        editType: "plot"
                    },
                    editType: "calc"
                };
            },
            8389: function(e, t, r) {
                "use strict";
                var n = r(215), a = r(2196).line, i = r(9952).P, o = r(1426).extendFlat, l = r(962).overrideAll, s = r(4467).templatedArray;
                r(4695), e.exports = l(s("selection", {
                    type: {
                        valType: "enumerated",
                        values: [
                            "rect",
                            "path"
                        ]
                    },
                    xref: o({}, n.xref, {}),
                    yref: o({}, n.yref, {}),
                    x0: {
                        valType: "any"
                    },
                    x1: {
                        valType: "any"
                    },
                    y0: {
                        valType: "any"
                    },
                    y1: {
                        valType: "any"
                    },
                    path: {
                        valType: "string",
                        editType: "arraydraw"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .7,
                        editType: "arraydraw"
                    },
                    line: {
                        color: a.color,
                        width: o({}, a.width, {
                            min: 1,
                            dflt: 1
                        }),
                        dash: o({}, i, {
                            dflt: "dot"
                        })
                    }
                }), "arraydraw", "from-root");
            },
            4122: function(e) {
                "use strict";
                e.exports = {
                    BENDPX: 1.5,
                    MINSELECT: 12,
                    SELECTDELAY: 100,
                    SELECTID: "-select"
                };
            },
            9402: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(9298), i = r(5501), o = r(8389), l = r(477);
                function s(e, t, r) {
                    function i(r, a) {
                        return n.coerce(e, t, o, r, a);
                    }
                    var s = i("path"), c = "path" !== i("type", s ? "path" : "rect");
                    c && delete t.path, i("opacity"), i("line.color"), i("line.width"), i("line.dash");
                    for(var u = [
                        "x",
                        "y"
                    ], f = 0; f < 2; f++){
                        var d, h, p, v = u[f], g = {
                            _fullLayout: r
                        }, y = a.coerceRef(e, t, g, v);
                        if ((d = a.getFromId(g, y))._selectionIndices.push(t._index), p = l.rangeToShapePosition(d), h = l.shapePositionToRange(d), c) {
                            var m = v + "0", x = v + "1", b = e[m], _ = e[x];
                            e[m] = h(e[m], !0), e[x] = h(e[x], !0), a.coercePosition(t, g, i, y, m), a.coercePosition(t, g, i, y, x);
                            var w = t[m], T = t[x];
                            void 0 !== w && void 0 !== T && (t[m] = p(w), t[x] = p(T), e[m] = b, e[x] = _);
                        }
                    }
                    c && n.noneOrAll(e, t, [
                        "x0",
                        "x1",
                        "y0",
                        "y1"
                    ]);
                }
                e.exports = function(e, t) {
                    i(e, t, {
                        name: "selections",
                        handleItemDefaults: s
                    });
                    for(var r = t.selections, n = 0; n < r.length; n++){
                        var a = r[n];
                        a && void 0 === a.path && (void 0 !== a.x0 && void 0 !== a.x1 && void 0 !== a.y0 && void 0 !== a.y1 || (t.selections[n] = null));
                    }
                };
            },
            2485: function(e, t, r) {
                "use strict";
                var n = r(165).readPaths, a = r(2359), i = r(1873).clearOutlineControllers, o = r(7901), l = r(1424), s = r(4467).arrayEditor, c = r(477), u = c.getPathString;
                function f(e) {
                    var t = e._fullLayout;
                    for(var r in i(e), t._selectionLayer.selectAll("path").remove(), t._plots){
                        var n = t._plots[r].selectionLayer;
                        n && n.selectAll("path").remove();
                    }
                    for(var a = 0; a < t.selections.length; a++)h(e, a);
                }
                function d(e) {
                    return e._context.editSelection;
                }
                function h(e, t) {
                    e._fullLayout._paperdiv.selectAll('.selectionlayer [data-index="' + t + '"]').remove();
                    var r = c.makeSelectionsOptionsAndPlotinfo(e, t), i = r.options, h = r.plotinfo;
                    i._input && function(r) {
                        var c = u(e, i), g = {
                            "data-index": t,
                            "fill-rule": "evenodd",
                            d: c
                        }, y = i.opacity, m = "rgba(0,0,0,0)", x = i.line.color || o.contrast(e._fullLayout.plot_bgcolor), b = i.line.width, _ = i.line.dash;
                        b || (b = 5, _ = "solid");
                        var w = d(e) && e._fullLayout._activeSelectionIndex === t;
                        w && (m = e._fullLayout.activeselection.fillcolor, y = e._fullLayout.activeselection.opacity);
                        for(var T = [], M = 1; M >= 0; M--){
                            var k = r.append("path").attr(g).style("opacity", M ? .1 : y).call(o.stroke, x).call(o.fill, m).call(l.dashLine, M ? "solid" : _, M ? 4 + b : b);
                            if (p(k, e, i), w) {
                                var A = s(e.layout, "selections", i);
                                k.style({
                                    cursor: "move"
                                });
                                var L = {
                                    element: k.node(),
                                    plotinfo: h,
                                    gd: e,
                                    editHelpers: A,
                                    isActiveSelection: !0
                                }, S = n(c, e);
                                a(S, k, L);
                            } else k.style("pointer-events", M ? "all" : "none");
                            T[M] = k;
                        }
                        var D = T[0];
                        T[1].node().addEventListener("click", function() {
                            return function(e, t) {
                                if (d(e)) {
                                    var r = +t.node().getAttribute("data-index");
                                    if (r >= 0) {
                                        if (r === e._fullLayout._activeSelectionIndex) return void v(e);
                                        e._fullLayout._activeSelectionIndex = r, e._fullLayout._deactivateSelection = v, f(e);
                                    }
                                }
                            }(e, D);
                        });
                    }(e._fullLayout._selectionLayer);
                }
                function p(e, t, r) {
                    var n = r.xref + r.yref;
                    l.setClipUrl(e, "clip" + t._fullLayout._uid + n, t);
                }
                function v(e) {
                    d(e) && e._fullLayout._activeSelectionIndex >= 0 && (i(e), delete e._fullLayout._activeSelectionIndex, f(e));
                }
                e.exports = {
                    draw: f,
                    drawOne: h,
                    activateLastSelection: function(e) {
                        if (d(e)) {
                            var t = e._fullLayout.selections.length - 1;
                            e._fullLayout._activeSelectionIndex = t, e._fullLayout._deactivateSelection = v, f(e);
                        }
                    }
                };
            },
            3777: function(e, t, r) {
                "use strict";
                var n = r(9952).P, a = r(1426).extendFlat;
                e.exports = {
                    newselection: {
                        mode: {
                            valType: "enumerated",
                            values: [
                                "immediate",
                                "gradual"
                            ],
                            dflt: "immediate",
                            editType: "none"
                        },
                        line: {
                            color: {
                                valType: "color",
                                editType: "none"
                            },
                            width: {
                                valType: "number",
                                min: 1,
                                dflt: 1,
                                editType: "none"
                            },
                            dash: a({}, n, {
                                dflt: "dot",
                                editType: "none"
                            }),
                            editType: "none"
                        },
                        editType: "none"
                    },
                    activeselection: {
                        fillcolor: {
                            valType: "color",
                            dflt: "rgba(0,0,0,0)",
                            editType: "none"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .5,
                            editType: "none"
                        },
                        editType: "none"
                    }
                };
            },
            849: function(e) {
                "use strict";
                e.exports = function(e, t, r) {
                    r("newselection.mode"), r("newselection.line.width") && (r("newselection.line.color"), r("newselection.line.dash")), r("activeselection.fillcolor"), r("activeselection.opacity");
                };
            },
            5855: function(e, t, r) {
                "use strict";
                var n = r(4505).selectMode, a = r(1873).clearOutline, i = r(165), o = i.readPaths, l = i.writePaths, s = i.fixDatesForPaths;
                e.exports = function(e, t) {
                    if (e.length) {
                        var r = e[0][0];
                        if (r) {
                            var i = r.getAttribute("d"), c = t.gd, u = c._fullLayout.newselection, f = t.plotinfo, d = f.xaxis, h = f.yaxis, p = t.isActiveSelection, v = t.dragmode, g = (c.layout || {}).selections || [];
                            if (!n(v) && void 0 !== p) {
                                var y = c._fullLayout._activeSelectionIndex;
                                if (y < g.length) switch(c._fullLayout.selections[y].type){
                                    case "rect":
                                        v = "select";
                                        break;
                                    case "path":
                                        v = "lasso";
                                }
                            }
                            var m, x = o(i, c, f, p), b = {
                                xref: d._id,
                                yref: h._id,
                                opacity: u.opacity,
                                line: {
                                    color: u.line.color,
                                    width: u.line.width,
                                    dash: u.line.dash
                                }
                            };
                            1 === x.length && (m = x[0]), m && 5 === m.length && "select" === v ? (b.type = "rect", b.x0 = m[0][1], b.y0 = m[0][2], b.x1 = m[2][1], b.y1 = m[2][2]) : (b.type = "path", d && h && s(x, d, h), b.path = l(x), m = null), a(c);
                            for(var _ = t.editHelpers, w = (_ || {}).modifyItem, T = [], M = 0; M < g.length; M++){
                                var k = c._fullLayout.selections[M];
                                if (k) {
                                    if (T[M] = k._input, void 0 !== p && M === c._fullLayout._activeSelectionIndex) {
                                        var A = b;
                                        switch(k.type){
                                            case "rect":
                                                w("x0", A.x0), w("x1", A.x1), w("y0", A.y0), w("y1", A.y1);
                                                break;
                                            case "path":
                                                w("path", A.path);
                                        }
                                    }
                                } else T[M] = k;
                            }
                            return void 0 === p ? (T.push(b), T) : _ ? _.getUpdateObj() : {};
                        }
                    }
                };
            },
            5549: function(e, t, r) {
                "use strict";
                var n = r(1828).strTranslate;
                function a(e, t) {
                    switch(e.type){
                        case "log":
                            return e.p2d(t);
                        case "date":
                            return e.p2r(t, 0, e.calendar);
                        default:
                            return e.p2r(t);
                    }
                }
                e.exports = {
                    p2r: a,
                    r2p: function(e, t) {
                        switch(e.type){
                            case "log":
                                return e.d2p(t);
                            case "date":
                                return e.r2p(t, 0, e.calendar);
                            default:
                                return e.r2p(t);
                        }
                    },
                    axValue: function(e) {
                        var t = "y" === e._id.charAt(0) ? 1 : 0;
                        return function(r) {
                            return a(e, r[t]);
                        };
                    },
                    getTransform: function(e) {
                        return n(e.xaxis._offset, e.yaxis._offset);
                    }
                };
            },
            7322: function(e, t, r) {
                "use strict";
                var n = r(2485), a = r(3937);
                e.exports = {
                    moduleType: "component",
                    name: "selections",
                    layoutAttributes: r(8389),
                    supplyLayoutDefaults: r(9402),
                    supplyDrawNewSelectionDefaults: r(849),
                    includeBasePlot: r(6325)("selections"),
                    draw: n.draw,
                    drawOne: n.drawOne,
                    reselect: a.reselect,
                    prepSelect: a.prepSelect,
                    clearOutline: a.clearOutline,
                    clearSelectionsCache: a.clearSelectionsCache,
                    selectOnClick: a.selectOnClick
                };
            },
            3937: function(e, t, r) {
                "use strict";
                var n = r(2142), a = r(8258), i = r(3972), o = r(1424).dashStyle, l = r(7901), s = r(211), c = r(3469).makeEventData, u = r(4505), f = u.freeMode, d = u.rectMode, h = u.drawMode, p = u.openMode, v = u.selectMode, g = r(477), y = r(1459), m = r(2359), x = r(1873).clearOutline, b = r(165), _ = b.handleEllipse, w = b.readPaths, T = r(551).newShapes, M = r(5855), k = r(2485).activateLastSelection, A = r(1828), L = A.sorterAsc, S = r(1082), D = r(9990), O = r(1675).getFromId, C = r(3306), P = r(1549).redrawReglTraces, I = r(4122), R = I.MINSELECT, z = S.filter, N = S.tester, F = r(5549), E = F.p2r, H = F.axValue, j = F.getTransform;
                function B(e) {
                    return void 0 !== e.subplot;
                }
                function Y(e, t, r, n, a, i, o) {
                    var l, s, c, u, f, d, h, v, g, y = t._hoverdata, x = t._fullLayout.clickmode.indexOf("event") > -1, b = [];
                    if (function(e) {
                        return e && Array.isArray(e) && !0 !== e[0].hoverOnBox;
                    }(y)) {
                        G(e, t, i);
                        var _ = function(e, t) {
                            var r, n, a = e[0], i = -1, o = [];
                            for(n = 0; n < t.length; n++)if (r = t[n], a.fullData._expandedIndex === r.cd[0].trace._expandedIndex) {
                                if (!0 === a.hoverOnBox) break;
                                void 0 !== a.pointNumber ? i = a.pointNumber : void 0 !== a.binNumber && (i = a.binNumber, o = a.pointNumbers);
                                break;
                            }
                            return {
                                pointNumber: i,
                                pointNumbers: o,
                                searchInfo: r
                            };
                        }(y, l = X(t, r, n, a));
                        if (_.pointNumbers.length > 0 ? function(e, t) {
                            var r, n, a, i = [];
                            for(a = 0; a < e.length; a++)(r = e[a]).cd[0].trace.selectedpoints && r.cd[0].trace.selectedpoints.length > 0 && i.push(r);
                            if (1 === i.length && i[0] === t.searchInfo && (n = t.searchInfo.cd[0].trace).selectedpoints.length === t.pointNumbers.length) {
                                for(a = 0; a < t.pointNumbers.length; a++)if (n.selectedpoints.indexOf(t.pointNumbers[a]) < 0) return !1;
                                return !0;
                            }
                            return !1;
                        }(l, _) : function(e) {
                            var t, r, n = 0;
                            for(r = 0; r < e.length; r++)if ((t = e[r].cd[0].trace).selectedpoints) {
                                if (t.selectedpoints.length > 1) return !1;
                                if ((n += t.selectedpoints.length) > 1) return !1;
                            }
                            return 1 === n;
                        }(l) && (d = K(_))) {
                            for(o && o.remove(), g = 0; g < l.length; g++)(s = l[g])._module.selectPoints(s, !1);
                            Q(t, l), Z(i), x && de(t);
                        } else {
                            for(h = e.shiftKey && (void 0 !== d ? d : K(_)), c = function(e, t, r) {
                                return {
                                    pointNumber: e,
                                    searchInfo: t,
                                    subtract: !!r
                                };
                            }(_.pointNumber, _.searchInfo, h), u = q(i.selectionDefs.concat([
                                c
                            ])), g = 0; g < l.length; g++)if (f = ee(l[g]._module.selectPoints(l[g], u), l[g]), b.length) for(var w = 0; w < f.length; w++)b.push(f[w]);
                            else b = f;
                            if (Q(t, l, v = {
                                points: b
                            }), c && i && i.selectionDefs.push(c), o) {
                                var T = i.mergedPolygons, M = p(i.dragmode);
                                m(te(T, M), o, i);
                            }
                            x && fe(t, v);
                        }
                    }
                }
                function V(e) {
                    return "pointNumber" in e && "searchInfo" in e;
                }
                function U(e) {
                    return {
                        xmin: 0,
                        xmax: 0,
                        ymin: 0,
                        ymax: 0,
                        pts: [],
                        contains: function(t, r, n, a) {
                            var i = e.searchInfo.cd[0].trace._expandedIndex;
                            return a.cd[0].trace._expandedIndex === i && n === e.pointNumber;
                        },
                        isRect: !1,
                        degenerate: !1,
                        subtract: !!e.subtract
                    };
                }
                function q(e) {
                    if (e.length) {
                        for(var t = [], r = V(e[0]) ? 0 : e[0][0][0], n = r, a = V(e[0]) ? 0 : e[0][0][1], i = a, o = 0; o < e.length; o++)if (V(e[o])) t.push(U(e[o]));
                        else {
                            var l = N(e[o]);
                            l.subtract = !!e[o].subtract, t.push(l), r = Math.min(r, l.xmin), n = Math.max(n, l.xmax), a = Math.min(a, l.ymin), i = Math.max(i, l.ymax);
                        }
                        return {
                            xmin: r,
                            xmax: n,
                            ymin: a,
                            ymax: i,
                            pts: [],
                            contains: function(e, r, n, a) {
                                for(var i = !1, o = 0; o < t.length; o++)t[o].contains(e, r, n, a) && (i = !t[o].subtract);
                                return i;
                            },
                            isRect: !1,
                            degenerate: !1
                        };
                    }
                }
                function G(e, t, r) {
                    var n = t._fullLayout, a = r.plotinfo, i = r.dragmode, o = n._lastSelectedSubplot && n._lastSelectedSubplot === a.id, l = (e.shiftKey || e.altKey) && !(h(i) && p(i));
                    o && l && a.selection && a.selection.selectionDefs && !r.selectionDefs ? (r.selectionDefs = a.selection.selectionDefs, r.mergedPolygons = a.selection.mergedPolygons) : l && a.selection || Z(r), o || (x(t), n._lastSelectedSubplot = a.id);
                }
                function Z(e, t) {
                    var r = e.dragmode, n = e.plotinfo, a = e.gd;
                    (function(e) {
                        return e._fullLayout._activeShapeIndex >= 0;
                    })(a) && a._fullLayout._deactivateShape(a), function(e) {
                        return e._fullLayout._activeSelectionIndex >= 0;
                    }(a) && a._fullLayout._deactivateSelection(a);
                    var o = a._fullLayout._zoomlayer, l = h(r), s = v(r);
                    if (l || s) {
                        var c, u, f = o.selectAll(".select-outline-" + n.id);
                        f && a._fullLayout._outlining && (l && (c = T(f, e)), c && i.call("_guiRelayout", a, {
                            shapes: c
                        }), s && !B(e) && (u = M(f, e)), u && (a._fullLayout._noEmitSelectedAtStart = !0, i.call("_guiRelayout", a, {
                            selections: u
                        }).then(function() {
                            t && k(a);
                        })), a._fullLayout._outlining = !1);
                    }
                    n.selection = {}, n.selection.selectionDefs = e.selectionDefs = [], n.selection.mergedPolygons = e.mergedPolygons = [];
                }
                function W(e) {
                    return e._id;
                }
                function X(e, t, r, n) {
                    if (!e.calcdata) return [];
                    var a, i, o, l = [], s = t.map(W), c = r.map(W);
                    for(o = 0; o < e.calcdata.length; o++)if (!0 === (i = (a = e.calcdata[o])[0].trace).visible && i._module && i._module.selectPoints) {
                        if (!B({
                            subplot: n
                        }) || i.subplot !== n && i.geo !== n) {
                            if ("splom" === i.type) {
                                if (i._xaxes[s[0]] && i._yaxes[c[0]]) {
                                    var u = J(i._module, a, t[0], r[0]);
                                    u.scene = e._fullLayout._splomScenes[i.uid], l.push(u);
                                }
                            } else if ("sankey" === i.type) {
                                var f = J(i._module, a, t[0], r[0]);
                                l.push(f);
                            } else {
                                if (-1 === s.indexOf(i.xaxis)) continue;
                                if (-1 === c.indexOf(i.yaxis)) continue;
                                l.push(J(i._module, a, O(e, i.xaxis), O(e, i.yaxis)));
                            }
                        } else l.push(J(i._module, a, t[0], r[0]));
                    }
                    return l;
                }
                function J(e, t, r, n) {
                    return {
                        _module: e,
                        cd: t,
                        xaxis: r,
                        yaxis: n
                    };
                }
                function K(e) {
                    var t = e.searchInfo.cd[0].trace, r = e.pointNumber, n = e.pointNumbers, a = n.length > 0 ? n[0] : r;
                    return !!t.selectedpoints && t.selectedpoints.indexOf(a) > -1;
                }
                function Q(e, t, r) {
                    var n, a;
                    for(n = 0; n < t.length; n++){
                        var o = t[n].cd[0].trace._fullInput, l = e._fullLayout._tracePreGUI[o.uid] || {};
                        void 0 === l.selectedpoints && (l.selectedpoints = o._input.selectedpoints || null);
                    }
                    if (r) {
                        var s = r.points || [];
                        for(n = 0; n < t.length; n++)(a = t[n].cd[0].trace)._input.selectedpoints = a._fullInput.selectedpoints = [], a._fullInput !== a && (a.selectedpoints = []);
                        for(var c = 0; c < s.length; c++){
                            var u = s[c], f = u.data, d = u.fullData, h = u.pointIndex, p = u.pointIndices;
                            p ? ([].push.apply(f.selectedpoints, p), a._fullInput !== a && [].push.apply(d.selectedpoints, p)) : (f.selectedpoints.push(h), a._fullInput !== a && d.selectedpoints.push(h));
                        }
                    } else for(n = 0; n < t.length; n++)delete (a = t[n].cd[0].trace).selectedpoints, delete a._input.selectedpoints, a._fullInput !== a && delete a._fullInput.selectedpoints;
                    !function(e, t) {
                        for(var r = !1, n = 0; n < t.length; n++){
                            var a = t[n], o = a.cd;
                            i.traceIs(o[0].trace, "regl") && (r = !0);
                            var l = a._module, s = l.styleOnSelect || l.style;
                            s && (s(e, o, o[0].node3), o[0].nodeRangePlot3 && s(e, o, o[0].nodeRangePlot3));
                        }
                        r && (C(e), P(e));
                    }(e, t);
                }
                function $(e, t, r) {
                    for(var a = (r ? n.difference : n.union)({
                        regions: e
                    }, {
                        regions: [
                            t
                        ]
                    }).regions.reverse(), i = 0; i < a.length; i++){
                        var o = a[i];
                        o.subtract = le(o, a.slice(0, i));
                    }
                    return a;
                }
                function ee(e, t) {
                    if (Array.isArray(e)) for(var r = t.cd, n = t.cd[0].trace, a = 0; a < e.length; a++)e[a] = c(e[a], n, r);
                    return e;
                }
                function te(e, t) {
                    for(var r = [], n = 0; n < e.length; n++){
                        r[n] = [];
                        for(var a = 0; a < e[n].length; a++){
                            r[n][a] = [], r[n][a][0] = a ? "L" : "M";
                            for(var i = 0; i < e[n][a].length; i++)r[n][a].push(e[n][a][i]);
                        }
                        t || r[n].push([
                            "Z",
                            r[n][0][1],
                            r[n][0][2]
                        ]);
                    }
                    return r;
                }
                function re(e, t) {
                    for(var r, n, a = [], i = [], o = 0; o < t.length; o++){
                        var l = t[o];
                        n = l._module.selectPoints(l, e), i.push(n), r = ee(n, l), a = a.concat(r);
                    }
                    return a;
                }
                function ne(e, t, r, n, a) {
                    var i, o, l, s = !!n;
                    a && (i = a.plotinfo, o = a.xaxes[0]._id, l = a.yaxes[0]._id);
                    var c = [], u = [], f = oe(e), d = e._fullLayout;
                    if (i) {
                        var p = d._zoomlayer, g = d.dragmode, y = h(g), m = v(g);
                        if (y || m) {
                            var x = O(e, o, "x"), b = O(e, l, "y");
                            if (x && b) {
                                var _ = p.selectAll(".select-outline-" + i.id);
                                if (_ && e._fullLayout._outlining && _.length) {
                                    for(var T = _[0][0].getAttribute("d"), M = w(T, e, i), k = [], A = 0; A < M.length; A++){
                                        for(var L = M[A], S = [], D = 0; D < L.length; D++)S.push([
                                            se(x, L[D][1]),
                                            se(b, L[D][2])
                                        ]);
                                        S.xref = o, S.yref = l, S.subtract = le(S, k), k.push(S);
                                    }
                                    f = f.concat(k);
                                }
                            }
                        }
                    }
                    var C = o && l ? [
                        o + l
                    ] : d._subplots.cartesian;
                    !function(e) {
                        var t = e.calcdata;
                        if (t) for(var r = 0; r < t.length; r++){
                            var n = t[r][0].trace, a = e._fullLayout._splomScenes;
                            if (a) {
                                var i = a[n.uid];
                                i && (i.selectBatch = []);
                            }
                        }
                    }(e);
                    for(var P = {}, I = 0; I < C.length; I++){
                        var R = C[I], z = R.indexOf("y"), N = R.slice(0, z), F = R.slice(z), E = o && l ? r : void 0;
                        if (E = ie(f, N, F, E)) {
                            var H = n;
                            if (!s) {
                                var j = O(e, N, "x"), B = O(e, F, "y");
                                H = X(e, [
                                    j
                                ], [
                                    B
                                ], R);
                                for(var Y = 0; Y < H.length; Y++){
                                    var V = H[Y], U = V.cd[0], q = U.trace;
                                    if ("scattergl" === V._module.name && !U.t.xpx) {
                                        var G = q.x, Z = q.y, W = q._length;
                                        U.t.xpx = [], U.t.ypx = [];
                                        for(var J = 0; J < W; J++)U.t.xpx[J] = j.c2p(G[J]), U.t.ypx[J] = B.c2p(Z[J]);
                                    }
                                    "splom" === V._module.name && (P[q.uid] || (P[q.uid] = !0));
                                }
                            }
                            var K = re(E, H);
                            c = c.concat(K), u = u.concat(H);
                        }
                    }
                    var $ = {
                        points: c
                    };
                    Q(e, u, $);
                    var ee = d.clickmode.indexOf("event") > -1 && t;
                    if (!i && t) {
                        var te = oe(e, !0);
                        if (te.length) {
                            var ne = te[0].xref, he = te[0].yref;
                            if (ne && he) {
                                var pe = ce(te);
                                ue([
                                    O(e, ne, "x"),
                                    O(e, he, "y")
                                ])($, pe);
                            }
                        }
                        e._fullLayout._noEmitSelectedAtStart ? e._fullLayout._noEmitSelectedAtStart = !1 : ee && fe(e, $), d._reselect = !1;
                    }
                    if (!i && d._deselect) {
                        var ve = d._deselect;
                        (function(e, t, r) {
                            for(var n = 0; n < r.length; n++){
                                var a = r[n];
                                if (a.xaxis && a.xaxis._id === e && a.yaxis && a.yaxis._id === t) return !0;
                            }
                            return !1;
                        })(o = ve.xref, l = ve.yref, u) || ae(e, o, l, n), ee && ($.points.length ? fe(e, $) : de(e)), d._deselect = !1;
                    }
                    return {
                        eventData: $,
                        selectionTesters: r
                    };
                }
                function ae(e, t, r, n) {
                    n = X(e, [
                        O(e, t, "x")
                    ], [
                        O(e, r, "y")
                    ], t + r);
                    for(var a = 0; a < n.length; a++){
                        var i = n[a];
                        i._module.selectPoints(i, !1);
                    }
                    Q(e, n);
                }
                function ie(e, t, r, n) {
                    for(var a, i = 0; i < e.length; i++){
                        var o = e[i];
                        t === o.xref && r === o.yref && (a ? n = q(a = $(a, o, !!o.subtract)) : (a = [
                            o
                        ], n = N(o)));
                    }
                    return n;
                }
                function oe(e, t) {
                    for(var r = [], n = e._fullLayout, a = n.selections, i = a.length, o = 0; o < i; o++)if (!t || o === n._activeSelectionIndex) {
                        var l = a[o];
                        if (l) {
                            var s, c, u, f, d, h = l.xref, p = l.yref, v = O(e, h, "x"), m = O(e, p, "y");
                            if ("rect" === l.type) {
                                d = [];
                                var x = se(v, l.x0), b = se(v, l.x1), _ = se(m, l.y0), w = se(m, l.y1);
                                d = [
                                    [
                                        x,
                                        _
                                    ],
                                    [
                                        x,
                                        w
                                    ],
                                    [
                                        b,
                                        w
                                    ],
                                    [
                                        b,
                                        _
                                    ]
                                ], s = Math.min(x, b), c = Math.max(x, b), u = Math.min(_, w), f = Math.max(_, w), d.xmin = s, d.xmax = c, d.ymin = u, d.ymax = f, d.xref = h, d.yref = p, d.subtract = !1, d.isRect = !0, r.push(d);
                            } else if ("path" === l.type) for(var T = l.path.split("Z"), M = [], k = 0; k < T.length; k++){
                                var A = T[k];
                                if (A) {
                                    A += "Z";
                                    var L = g.extractPathCoords(A, y.paramIsX, "raw"), S = g.extractPathCoords(A, y.paramIsY, "raw");
                                    s = 1 / 0, c = -1 / 0, u = 1 / 0, f = -1 / 0, d = [];
                                    for(var D = 0; D < L.length; D++){
                                        var C = se(v, L[D]), P = se(m, S[D]);
                                        d.push([
                                            C,
                                            P
                                        ]), s = Math.min(C, s), c = Math.max(C, c), u = Math.min(P, u), f = Math.max(P, f);
                                    }
                                    d.xmin = s, d.xmax = c, d.ymin = u, d.ymax = f, d.xref = h, d.yref = p, d.subtract = le(d, M), M.push(d), r.push(d);
                                }
                            }
                        }
                    }
                    return r;
                }
                function le(e, t) {
                    for(var r = !1, n = 0; n < t.length; n++)for(var i = t[n], o = 0; o < e.length; o++)if (a(e[o], i)) {
                        r = !r;
                        break;
                    }
                    return r;
                }
                function se(e, t) {
                    return "date" === e.type && (t = t.replace("_", " ")), "log" === e.type ? e.c2p(t) : e.r2p(t, null, e.calendar);
                }
                function ce(e) {
                    for(var t = e.length, r = [], n = 0; n < t; n++){
                        var a = e[n];
                        r = (r = r.concat(a)).concat([
                            a[0]
                        ]);
                    }
                    var i;
                    return (i = r).isRect = 5 === i.length && i[0][0] === i[4][0] && i[0][1] === i[4][1] && i[0][0] === i[1][0] && i[2][0] === i[3][0] && i[0][1] === i[3][1] && i[1][1] === i[2][1] || i[0][1] === i[1][1] && i[2][1] === i[3][1] && i[0][0] === i[3][0] && i[1][0] === i[2][0], i.isRect && (i.xmin = Math.min(i[0][0], i[2][0]), i.xmax = Math.max(i[0][0], i[2][0]), i.ymin = Math.min(i[0][1], i[2][1]), i.ymax = Math.max(i[0][1], i[2][1])), i;
                }
                function ue(e) {
                    return function(t, r) {
                        for(var n, a, i = 0; i < e.length; i++){
                            var o = e[i], l = o._id, s = l.charAt(0);
                            if (r.isRect) {
                                n || (n = {});
                                var c = r[s + "min"], u = r[s + "max"];
                                void 0 !== c && void 0 !== u && (n[l] = [
                                    E(o, c),
                                    E(o, u)
                                ].sort(L));
                            } else a || (a = {}), a[l] = r.map(H(o));
                        }
                        n && (t.range = n), a && (t.lassoPoints = a);
                    };
                }
                function fe(e, t) {
                    t && (t.selections = (e.layout || {}).selections || []), e.emit("plotly_selected", t);
                }
                function de(e) {
                    e.emit("plotly_deselect", null);
                }
                e.exports = {
                    reselect: ne,
                    prepSelect: function(e, t, r, n, a) {
                        var c = !B(n), u = f(a), g = d(a), y = p(a), x = h(a), b = v(a), w = "drawcircle" === a, T = "drawline" === a || w, M = n.gd, k = M._fullLayout, L = b && "immediate" === k.newselection.mode && c, S = k._zoomlayer, O = n.element.getBoundingClientRect(), C = n.plotinfo, P = j(C), F = t - O.left, E = r - O.top;
                        k._calcInverseTransform(M);
                        var H = A.apply3DTransform(k._invTransform)(F, E);
                        F = H[0], E = H[1];
                        var V, U, W, J, K, ee, ie, oe = k._invScaleX, le = k._invScaleY, se = F, he = E, pe = "M" + F + "," + E, ve = n.xaxes[0], ge = n.yaxes[0], ye = ve._length, me = ge._length, xe = e.altKey && !(h(a) && y);
                        G(e, M, n), u && (V = z([
                            [
                                F,
                                E
                            ]
                        ], I.BENDPX));
                        var be = S.selectAll("path.select-outline-" + C.id).data([
                            1
                        ]), _e = x ? k.newshape : k.newselection;
                        x && (n.hasText = _e.label.text || _e.label.texttemplate);
                        var we = x && !y ? _e.fillcolor : "rgba(0,0,0,0)", Te = _e.line.color || (c ? l.contrast(M._fullLayout.plot_bgcolor) : "#7f7f7f");
                        be.enter().append("path").attr("class", "select-outline select-outline-" + C.id).style({
                            opacity: x ? _e.opacity / 2 : 1,
                            "stroke-dasharray": o(_e.line.dash, _e.line.width),
                            "stroke-width": _e.line.width + "px",
                            "shape-rendering": "crispEdges"
                        }).call(l.stroke, Te).call(l.fill, we).attr("fill-rule", "evenodd").classed("cursor-move", !!x).attr("transform", P).attr("d", pe + "Z");
                        var Me = S.append("path").attr("class", "zoombox-corners").style({
                            fill: l.background,
                            stroke: l.defaultLine,
                            "stroke-width": 1
                        }).attr("transform", P).attr("d", "M0,0Z");
                        if (x && n.hasText) {
                            var ke = S.select(".label-temp");
                            ke.empty() && (ke = S.append("g").classed("label-temp", !0).classed("select-outline", !0).style({
                                opacity: .8
                            }));
                        }
                        var Ae = k._uid + I.SELECTID, Le = [], Se = X(M, n.xaxes, n.yaxes, n.subplot);
                        L && !e.shiftKey && (n._clearSubplotSelections = function() {
                            if (c) {
                                var e = ve._id, t = ge._id;
                                ae(M, e, t, Se);
                                for(var r = (M.layout || {}).selections || [], n = [], a = !1, o = 0; o < r.length; o++){
                                    var l = k.selections[o];
                                    l.xref !== e || l.yref !== t ? n.push(r[o]) : a = !0;
                                }
                                a && (M._fullLayout._noEmitSelectedAtStart = !0, i.call("_guiRelayout", M, {
                                    selections: n
                                }));
                            }
                        });
                        var De = function(e) {
                            return e.plotinfo.fillRangeItems || ue(e.xaxes.concat(e.yaxes));
                        }(n);
                        n.moveFn = function(e, t) {
                            n._clearSubplotSelections && (n._clearSubplotSelections(), n._clearSubplotSelections = void 0), se = Math.max(0, Math.min(ye, oe * e + F)), he = Math.max(0, Math.min(me, le * t + E));
                            var r = Math.abs(se - F), a = Math.abs(he - E);
                            if (g) {
                                var i, o, l;
                                if (b) {
                                    var s = k.selectdirection;
                                    switch(i = "any" === s ? a < Math.min(.6 * r, R) ? "h" : r < Math.min(.6 * a, R) ? "v" : "d" : s){
                                        case "h":
                                            o = w ? me / 2 : 0, l = me;
                                            break;
                                        case "v":
                                            o = w ? ye / 2 : 0, l = ye;
                                    }
                                }
                                if (x) switch(k.newshape.drawdirection){
                                    case "vertical":
                                        i = "h", o = w ? me / 2 : 0, l = me;
                                        break;
                                    case "horizontal":
                                        i = "v", o = w ? ye / 2 : 0, l = ye;
                                        break;
                                    case "ortho":
                                        r < a ? (i = "h", o = E, l = he) : (i = "v", o = F, l = se);
                                        break;
                                    default:
                                        i = "d";
                                }
                                "h" === i ? ((J = T ? _(w, [
                                    se,
                                    o
                                ], [
                                    se,
                                    l
                                ]) : [
                                    [
                                        F,
                                        o
                                    ],
                                    [
                                        F,
                                        l
                                    ],
                                    [
                                        se,
                                        l
                                    ],
                                    [
                                        se,
                                        o
                                    ]
                                ]).xmin = T ? se : Math.min(F, se), J.xmax = T ? se : Math.max(F, se), J.ymin = Math.min(o, l), J.ymax = Math.max(o, l), Me.attr("d", "M" + J.xmin + "," + (E - R) + "h-4v" + 2 * R + "h4ZM" + (J.xmax - 1) + "," + (E - R) + "h4v" + 2 * R + "h-4Z")) : "v" === i ? ((J = T ? _(w, [
                                    o,
                                    he
                                ], [
                                    l,
                                    he
                                ]) : [
                                    [
                                        o,
                                        E
                                    ],
                                    [
                                        o,
                                        he
                                    ],
                                    [
                                        l,
                                        he
                                    ],
                                    [
                                        l,
                                        E
                                    ]
                                ]).xmin = Math.min(o, l), J.xmax = Math.max(o, l), J.ymin = T ? he : Math.min(E, he), J.ymax = T ? he : Math.max(E, he), Me.attr("d", "M" + (F - R) + "," + J.ymin + "v-4h" + 2 * R + "v4ZM" + (F - R) + "," + (J.ymax - 1) + "v4h" + 2 * R + "v-4Z")) : "d" === i && ((J = T ? _(w, [
                                    F,
                                    E
                                ], [
                                    se,
                                    he
                                ]) : [
                                    [
                                        F,
                                        E
                                    ],
                                    [
                                        F,
                                        he
                                    ],
                                    [
                                        se,
                                        he
                                    ],
                                    [
                                        se,
                                        E
                                    ]
                                ]).xmin = Math.min(F, se), J.xmax = Math.max(F, se), J.ymin = Math.min(E, he), J.ymax = Math.max(E, he), Me.attr("d", "M0,0Z"));
                            } else u && (V.addPt([
                                se,
                                he
                            ]), J = V.filtered);
                            if (n.selectionDefs && n.selectionDefs.length ? (W = $(n.mergedPolygons, J, xe), J.subtract = xe, U = q(n.selectionDefs.concat([
                                J
                            ]))) : (W = [
                                J
                            ], U = N(J)), m(te(W, y), be, n), b) {
                                var c, f = ne(M, !1), d = f.eventData ? f.eventData.points.slice() : [];
                                f = ne(M, !1, U, Se, n), U = f.selectionTesters, ie = f.eventData, c = V ? V.filtered : ce(W), D.throttle(Ae, I.SELECTDELAY, function() {
                                    for(var e = (Le = re(U, Se)).slice(), t = 0; t < d.length; t++){
                                        for(var r = d[t], n = !1, a = 0; a < e.length; a++)if (e[a].curveNumber === r.curveNumber && e[a].pointNumber === r.pointNumber) {
                                            n = !0;
                                            break;
                                        }
                                        n || e.push(r);
                                    }
                                    e.length && (ie || (ie = {}), ie.points = e), De(ie, c), function(e, t) {
                                        e.emit("plotly_selecting", t);
                                    }(M, ie);
                                });
                            }
                        }, n.clickFn = function(e, t) {
                            if (Me.remove(), M._fullLayout._activeShapeIndex >= 0) M._fullLayout._deactivateShape(M);
                            else if (!x) {
                                var r = k.clickmode;
                                D.done(Ae).then(function() {
                                    if (D.clear(Ae), 2 === e) {
                                        for(be.remove(), K = 0; K < Se.length; K++)(ee = Se[K])._module.selectPoints(ee, !1);
                                        if (Q(M, Se), Z(n), de(M), Se.length) {
                                            var a = Se[0].xaxis, o = Se[0].yaxis;
                                            if (a && o) {
                                                for(var l = [], c = M._fullLayout.selections, u = 0; u < c.length; u++){
                                                    var f = c[u];
                                                    f && (f.xref === a._id && f.yref === o._id || l.push(f));
                                                }
                                                l.length < c.length && (M._fullLayout._noEmitSelectedAtStart = !0, i.call("_guiRelayout", M, {
                                                    selections: l
                                                }));
                                            }
                                        }
                                    } else r.indexOf("select") > -1 && Y(t, M, n.xaxes, n.yaxes, n.subplot, n, be), "event" === r && fe(M, void 0);
                                    s.click(M, t);
                                }).catch(A.error);
                            }
                        }, n.doneFn = function() {
                            Me.remove(), D.done(Ae).then(function() {
                                D.clear(Ae), !L && J && n.selectionDefs && (J.subtract = xe, n.selectionDefs.push(J), n.mergedPolygons.length = 0, [].push.apply(n.mergedPolygons, W)), (L || x) && Z(n, L), n.doneFnCompleted && n.doneFnCompleted(Le), b && fe(M, ie);
                            }).catch(A.error);
                        };
                    },
                    clearOutline: x,
                    clearSelectionsCache: Z,
                    selectOnClick: Y
                };
            },
            9827: function(e, t, r) {
                "use strict";
                var n = r(215), a = r(1940), i = r(2196).line, o = r(9952).P, l = r(1426).extendFlat, s = r(4467).templatedArray, c = (r(4695), r(9012)), u = r(5386).R, f = r(7281);
                e.exports = s("shape", {
                    visible: l({}, c.visible, {
                        editType: "calc+arraydraw"
                    }),
                    showlegend: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc+arraydraw"
                    },
                    legend: l({}, c.legend, {
                        editType: "calc+arraydraw"
                    }),
                    legendgroup: l({}, c.legendgroup, {
                        editType: "calc+arraydraw"
                    }),
                    legendgrouptitle: {
                        text: l({}, c.legendgrouptitle.text, {
                            editType: "calc+arraydraw"
                        }),
                        font: a({
                            editType: "calc+arraydraw"
                        }),
                        editType: "calc+arraydraw"
                    },
                    legendrank: l({}, c.legendrank, {
                        editType: "calc+arraydraw"
                    }),
                    legendwidth: l({}, c.legendwidth, {
                        editType: "calc+arraydraw"
                    }),
                    type: {
                        valType: "enumerated",
                        values: [
                            "circle",
                            "rect",
                            "path",
                            "line"
                        ],
                        editType: "calc+arraydraw"
                    },
                    layer: {
                        valType: "enumerated",
                        values: [
                            "below",
                            "above"
                        ],
                        dflt: "above",
                        editType: "arraydraw"
                    },
                    xref: l({}, n.xref, {}),
                    xsizemode: {
                        valType: "enumerated",
                        values: [
                            "scaled",
                            "pixel"
                        ],
                        dflt: "scaled",
                        editType: "calc+arraydraw"
                    },
                    xanchor: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    x0: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    x1: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    yref: l({}, n.yref, {}),
                    ysizemode: {
                        valType: "enumerated",
                        values: [
                            "scaled",
                            "pixel"
                        ],
                        dflt: "scaled",
                        editType: "calc+arraydraw"
                    },
                    yanchor: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    y0: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    y1: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    path: {
                        valType: "string",
                        editType: "calc+arraydraw"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    line: {
                        color: l({}, i.color, {
                            editType: "arraydraw"
                        }),
                        width: l({}, i.width, {
                            editType: "calc+arraydraw"
                        }),
                        dash: l({}, o, {
                            editType: "arraydraw"
                        }),
                        editType: "calc+arraydraw"
                    },
                    fillcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "arraydraw"
                    },
                    fillrule: {
                        valType: "enumerated",
                        values: [
                            "evenodd",
                            "nonzero"
                        ],
                        dflt: "evenodd",
                        editType: "arraydraw"
                    },
                    editable: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc+arraydraw"
                    },
                    label: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "arraydraw"
                        },
                        texttemplate: u({}, {
                            keys: Object.keys(f)
                        }),
                        font: a({
                            editType: "calc+arraydraw",
                            colorEditType: "arraydraw"
                        }),
                        textposition: {
                            valType: "enumerated",
                            values: [
                                "top left",
                                "top center",
                                "top right",
                                "middle left",
                                "middle center",
                                "middle right",
                                "bottom left",
                                "bottom center",
                                "bottom right",
                                "start",
                                "middle",
                                "end"
                            ],
                            editType: "arraydraw"
                        },
                        textangle: {
                            valType: "angle",
                            dflt: "auto",
                            editType: "calc+arraydraw"
                        },
                        xanchor: {
                            valType: "enumerated",
                            values: [
                                "auto",
                                "left",
                                "center",
                                "right"
                            ],
                            dflt: "auto",
                            editType: "calc+arraydraw"
                        },
                        yanchor: {
                            valType: "enumerated",
                            values: [
                                "top",
                                "middle",
                                "bottom"
                            ],
                            editType: "calc+arraydraw"
                        },
                        padding: {
                            valType: "number",
                            dflt: 3,
                            min: 0,
                            editType: "arraydraw"
                        },
                        editType: "arraydraw"
                    },
                    editType: "arraydraw"
                });
            },
            5627: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(9298), i = r(1459), o = r(477);
                function l(e) {
                    return c(e.line.width, e.xsizemode, e.x0, e.x1, e.path, !1);
                }
                function s(e) {
                    return c(e.line.width, e.ysizemode, e.y0, e.y1, e.path, !0);
                }
                function c(e, t, r, a, l, s) {
                    var c = e / 2, u = s;
                    if ("pixel" === t) {
                        var f = l ? o.extractPathCoords(l, s ? i.paramIsY : i.paramIsX) : [
                            r,
                            a
                        ], d = n.aggNums(Math.max, null, f), h = n.aggNums(Math.min, null, f), p = h < 0 ? Math.abs(h) + c : c, v = d > 0 ? d + c : c;
                        return {
                            ppad: c,
                            ppadplus: u ? p : v,
                            ppadminus: u ? v : p
                        };
                    }
                    return {
                        ppad: c
                    };
                }
                function u(e, t, r, n, a) {
                    var l = "category" === e.type || "multicategory" === e.type ? e.r2c : e.d2c;
                    if (void 0 !== t) return [
                        l(t),
                        l(r)
                    ];
                    if (n) {
                        var s, c, u, f, d = 1 / 0, h = -1 / 0, p = n.match(i.segmentRE);
                        for("date" === e.type && (l = o.decodeDate(l)), s = 0; s < p.length; s++)void 0 !== (c = a[p[s].charAt(0)].drawn) && (!(u = p[s].substr(1).match(i.paramRE)) || u.length < c || ((f = l(u[c])) < d && (d = f), f > h && (h = f)));
                        return h >= d ? [
                            d,
                            h
                        ] : void 0;
                    }
                }
                e.exports = function(e) {
                    var t = e._fullLayout, r = n.filterVisible(t.shapes);
                    if (r.length && e._fullData.length) for(var o = 0; o < r.length; o++){
                        var c, f, d = r[o];
                        d._extremes = {};
                        var h = a.getRefType(d.xref), p = a.getRefType(d.yref);
                        if ("paper" !== d.xref && "domain" !== h) {
                            var v = "pixel" === d.xsizemode ? d.xanchor : d.x0, g = "pixel" === d.xsizemode ? d.xanchor : d.x1;
                            (f = u(c = a.getFromId(e, d.xref), v, g, d.path, i.paramIsX)) && (d._extremes[c._id] = a.findExtremes(c, f, l(d)));
                        }
                        if ("paper" !== d.yref && "domain" !== p) {
                            var y = "pixel" === d.ysizemode ? d.yanchor : d.y0, m = "pixel" === d.ysizemode ? d.yanchor : d.y1;
                            (f = u(c = a.getFromId(e, d.yref), y, m, d.path, i.paramIsY)) && (d._extremes[c._id] = a.findExtremes(c, f, s(d)));
                        }
                    }
                };
            },
            1459: function(e) {
                "use strict";
                e.exports = {
                    segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
                    paramRE: /[^\s,]+/g,
                    paramIsX: {
                        M: {
                            0: !0,
                            drawn: 0
                        },
                        L: {
                            0: !0,
                            drawn: 0
                        },
                        H: {
                            0: !0,
                            drawn: 0
                        },
                        V: {},
                        Q: {
                            0: !0,
                            2: !0,
                            drawn: 2
                        },
                        C: {
                            0: !0,
                            2: !0,
                            4: !0,
                            drawn: 4
                        },
                        T: {
                            0: !0,
                            drawn: 0
                        },
                        S: {
                            0: !0,
                            2: !0,
                            drawn: 2
                        },
                        Z: {}
                    },
                    paramIsY: {
                        M: {
                            1: !0,
                            drawn: 1
                        },
                        L: {
                            1: !0,
                            drawn: 1
                        },
                        H: {},
                        V: {
                            0: !0,
                            drawn: 0
                        },
                        Q: {
                            1: !0,
                            3: !0,
                            drawn: 3
                        },
                        C: {
                            1: !0,
                            3: !0,
                            5: !0,
                            drawn: 5
                        },
                        T: {
                            1: !0,
                            drawn: 1
                        },
                        S: {
                            1: !0,
                            3: !0,
                            drawn: 5
                        },
                        Z: {}
                    },
                    numParams: {
                        M: 2,
                        L: 2,
                        H: 1,
                        V: 1,
                        Q: 4,
                        C: 6,
                        T: 2,
                        S: 4,
                        Z: 0
                    }
                };
            },
            4726: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(9298), i = r(5501), o = r(9827), l = r(477);
                function s(e, t, r) {
                    function i(r, a) {
                        return n.coerce(e, t, o, r, a);
                    }
                    if (t._isShape = !0, i("visible")) {
                        i("showlegend") && (i("legend"), i("legendwidth"), i("legendgroup"), i("legendgrouptitle.text"), n.coerceFont(i, "legendgrouptitle.font"), i("legendrank"));
                        var s = i("path"), c = i("type", s ? "path" : "rect"), u = "path" !== c;
                        u && delete t.path, i("editable"), i("layer"), i("opacity"), i("fillcolor"), i("fillrule"), i("line.width") && (i("line.color"), i("line.dash"));
                        for(var f = i("xsizemode"), d = i("ysizemode"), h = [
                            "x",
                            "y"
                        ], p = 0; p < 2; p++){
                            var v, g, y, m = h[p], x = m + "anchor", b = "x" === m ? f : d, _ = {
                                _fullLayout: r
                            }, w = a.coerceRef(e, t, _, m, void 0, "paper");
                            if ("range" === a.getRefType(w) ? ((v = a.getFromId(_, w))._shapeIndices.push(t._index), y = l.rangeToShapePosition(v), g = l.shapePositionToRange(v)) : g = y = n.identity, u) {
                                var T = m + "0", M = m + "1", k = e[T], A = e[M];
                                e[T] = g(e[T], !0), e[M] = g(e[M], !0), "pixel" === b ? (i(T, 0), i(M, 10)) : (a.coercePosition(t, _, i, w, T, .25), a.coercePosition(t, _, i, w, M, .75)), t[T] = y(t[T]), t[M] = y(t[M]), e[T] = k, e[M] = A;
                            }
                            if ("pixel" === b) {
                                var L = e[x];
                                e[x] = g(e[x], !0), a.coercePosition(t, _, i, w, x, .25), t[x] = y(t[x]), e[x] = L;
                            }
                        }
                        u && n.noneOrAll(e, t, [
                            "x0",
                            "x1",
                            "y0",
                            "y1"
                        ]);
                        var S, D, O = "line" === c;
                        if (u && (S = i("label.texttemplate")), S || (D = i("label.text")), D || S) {
                            i("label.textangle");
                            var C = i("label.textposition", O ? "middle" : "middle center");
                            i("label.xanchor"), i("label.yanchor", function(e, t) {
                                return e ? "bottom" : -1 !== t.indexOf("top") ? "top" : -1 !== t.indexOf("bottom") ? "bottom" : "middle";
                            }(O, C)), i("label.padding"), n.coerceFont(i, "label.font", r.font);
                        }
                    }
                }
                e.exports = function(e, t) {
                    i(e, t, {
                        name: "shapes",
                        handleItemDefaults: s
                    });
                };
            },
            8100: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(9298), i = r(3893), o = r(1424), l = r(165).readPaths, s = r(477), c = s.getPathString, u = r(7281), f = r(8783).FROM_TL;
                e.exports = function(e, t, r, d) {
                    if (d.selectAll(".shape-label").remove(), r.label.text || r.label.texttemplate) {
                        var h;
                        if (r.label.texttemplate) {
                            var p = {};
                            if ("path" !== r.type) {
                                var v = a.getFromId(e, r.xref), g = a.getFromId(e, r.yref);
                                for(var y in u){
                                    var m = u[y](r, v, g);
                                    void 0 !== m && (p[y] = m);
                                }
                            }
                            h = n.texttemplateStringForShapes(r.label.texttemplate, {}, e._fullLayout._d3locale, p);
                        } else h = r.label.text;
                        var x, b, _, w, T = {
                            "data-index": t
                        }, M = r.label.font, k = d.append("g").attr(T).classed("shape-label", !0).append("text").attr({
                            "data-notex": 1
                        }).classed("shape-label-text", !0).text(h);
                        if (r.path) {
                            var A = c(e, r), L = l(A, e);
                            x = 1 / 0, _ = 1 / 0, b = -1 / 0, w = -1 / 0;
                            for(var S = 0; S < L.length; S++)for(var D = 0; D < L[S].length; D++)for(var O = L[S][D], C = 1; C < O.length; C += 2){
                                var P = O[C], I = O[C + 1];
                                x = Math.min(x, P), b = Math.max(b, P), _ = Math.min(_, I), w = Math.max(w, I);
                            }
                        } else {
                            var R = a.getFromId(e, r.xref), z = a.getRefType(r.xref), N = a.getFromId(e, r.yref), F = a.getRefType(r.yref), E = s.getDataToPixel(e, R, !1, z), H = s.getDataToPixel(e, N, !0, F);
                            x = E(r.x0), b = E(r.x1), _ = H(r.y0), w = H(r.y1);
                        }
                        var j = r.label.textangle;
                        "auto" === j && (j = "line" === r.type ? function(e, t, r, n) {
                            var a, i;
                            return i = Math.abs(r - e), a = r >= e ? t - n : n - t, -180 / Math.PI * Math.atan2(a, i);
                        }(x, _, b, w) : 0), k.call(function(t) {
                            return t.call(o.font, M).attr({}), i.convertToTspans(t, e), t;
                        });
                        var B = function(e, t, r, n, a, i, o) {
                            var l, s, c, u, d = a.label.textposition, h = a.label.textangle, p = a.label.padding, v = a.type, g = Math.PI / 180 * i, y = Math.sin(g), m = Math.cos(g), x = a.label.xanchor, b = a.label.yanchor;
                            if ("line" === v) {
                                "start" === d ? (l = e, s = t) : "end" === d ? (l = r, s = n) : (l = (e + r) / 2, s = (t + n) / 2), "auto" === x && (x = "start" === d ? "auto" === h ? r > e ? "left" : r < e ? "right" : "center" : r > e ? "right" : r < e ? "left" : "center" : "end" === d ? "auto" === h ? r > e ? "right" : r < e ? "left" : "center" : r > e ? "left" : r < e ? "right" : "center" : "center");
                                var _ = {
                                    bottom: -1,
                                    middle: 0,
                                    top: 1
                                };
                                if ("auto" === h) {
                                    var w = _[b];
                                    c = -p * y * w, u = p * m * w;
                                } else c = p * ({
                                    left: 1,
                                    center: 0,
                                    right: -1
                                })[x], u = p * _[b];
                                l += c, s += u;
                            } else c = p + 3, -1 !== d.indexOf("right") ? (l = Math.max(e, r) - c, "auto" === x && (x = "right")) : -1 !== d.indexOf("left") ? (l = Math.min(e, r) + c, "auto" === x && (x = "left")) : (l = (e + r) / 2, "auto" === x && (x = "center")), s = -1 !== d.indexOf("top") ? Math.min(t, n) : -1 !== d.indexOf("bottom") ? Math.max(t, n) : (t + n) / 2, u = p, "bottom" === b ? s -= u : "top" === b && (s += u);
                            var T = f[b], M = a.label.font.size, k = o.height;
                            return {
                                textx: l + (k * T - M) * y,
                                texty: s + -(k * T - M) * m,
                                xanchor: x
                            };
                        }(x, _, b, w, r, j, o.bBox(k.node())), Y = B.textx, V = B.texty, U = B.xanchor;
                        k.attr({
                            "text-anchor": {
                                left: "start",
                                center: "middle",
                                right: "end"
                            }[U],
                            y: V,
                            x: Y,
                            transform: "rotate(" + j + "," + Y + "," + V + ")"
                        }).call(i.positionText, Y, V);
                    }
                };
            },
            2359: function(e, t, r) {
                "use strict";
                var n = r(1828).strTranslate, a = r(8569), i = r(4505), o = i.drawMode, l = i.selectMode, s = r(3972), c = r(7901), u = r(9995), f = u.i000, d = u.i090, h = u.i180, p = u.i270, v = r(1873).clearOutlineControllers, g = r(165), y = g.pointsOnRectangle, m = g.pointsOnEllipse, x = g.writePaths, b = r(551).newShapes, _ = r(551).createShapeObj, w = r(5855), T = r(8100);
                function M(e, t) {
                    var r, n, a, i = e[t][1], o = e[t][2], l = e.length;
                    return n = e[r = (t + 1) % l][1], a = e[r][2], n === i && a === o && (n = e[r = (t + 2) % l][1], a = e[r][2]), [
                        r,
                        n,
                        a
                    ];
                }
                e.exports = function e(t, r, i, u) {
                    u || (u = 0);
                    var g = i.gd;
                    function k() {
                        e(t, r, i, u++), (m(t[0]) || i.hasText) && A({
                            redrawing: !0
                        });
                    }
                    function A(e) {
                        var t = {};
                        void 0 !== i.isActiveShape && (i.isActiveShape = !1, t = b(r, i)), void 0 !== i.isActiveSelection && (i.isActiveSelection = !1, t = w(r, i), g._fullLayout._reselect = !0), Object.keys(t).length && s.call((e || {}).redrawing ? "relayout" : "_guiRelayout", g, t);
                    }
                    var L, S, D, O, C, P = g._fullLayout._zoomlayer, I = i.dragmode, R = o(I), z = l(I);
                    if ((R || z) && (g._fullLayout._outlining = !0), v(g), r.attr("d", x(t)), u || !i.isActiveShape && !i.isActiveSelection || (C = function(e, t) {
                        for(var r = 0; r < t.length; r++){
                            var n = t[r];
                            e[r] = [];
                            for(var a = 0; a < n.length; a++){
                                e[r][a] = [];
                                for(var i = 0; i < n[a].length; i++)e[r][a][i] = n[a][i];
                            }
                        }
                        return e;
                    }([], t), function(e) {
                        L = [];
                        for(var r = 0; r < t.length; r++){
                            var o = t[r], l = y(o), s = !l && m(o);
                            L[r] = [];
                            for(var u = o.length, v = 0; v < u; v++)if ("Z" !== o[v][0] && (!s || v === f || v === d || v === h || v === p)) {
                                var x, b = l && i.isActiveSelection;
                                b && (x = M(o, v));
                                var _ = o[v][1], w = o[v][2], T = e.append(b ? "rect" : "circle").attr("data-i", r).attr("data-j", v).style({
                                    fill: c.background,
                                    stroke: c.defaultLine,
                                    "stroke-width": 1,
                                    "shape-rendering": "crispEdges"
                                });
                                if (b) {
                                    var k = x[1] - _, A = x[2] - w, S = A ? 5 : Math.max(Math.min(25, Math.abs(k) - 5), 5), D = k ? 5 : Math.max(Math.min(25, Math.abs(A) - 5), 5);
                                    T.classed(A ? "cursor-ew-resize" : "cursor-ns-resize", !0).attr("width", S).attr("height", D).attr("x", _ - S / 2).attr("y", w - D / 2).attr("transform", n(k / 2, A / 2));
                                } else T.classed("cursor-grab", !0).attr("r", 5).attr("cx", _).attr("cy", w);
                                L[r][v] = {
                                    element: T.node(),
                                    gd: g,
                                    prepFn: E,
                                    doneFn: j,
                                    clickFn: B
                                }, a.init(L[r][v]);
                            }
                        }
                    }(P.append("g").attr("class", "outline-controllers")), function() {
                        if (S = [], t.length) S[0] = {
                            element: r[0][0],
                            gd: g,
                            prepFn: V,
                            doneFn: U,
                            clickFn: q
                        }, a.init(S[0]);
                    }()), R && i.hasText) {
                        var N = P.select(".label-temp"), F = _(r, i, i.dragmode);
                        T(g, "label-temp", F, N);
                    }
                    function E(e) {
                        D = +e.srcElement.getAttribute("data-i"), O = +e.srcElement.getAttribute("data-j"), L[D][O].moveFn = H;
                    }
                    function H(e, r) {
                        if (t.length) {
                            var n = C[D][O][1], a = C[D][O][2], o = t[D], l = o.length;
                            if (y(o)) {
                                var s = e, c = r;
                                i.isActiveSelection && (M(o, O)[1] === o[O][1] ? c = 0 : s = 0);
                                for(var u = 0; u < l; u++)if (u !== O) {
                                    var f = o[u];
                                    f[1] === o[O][1] && (f[1] = n + s), f[2] === o[O][2] && (f[2] = a + c);
                                }
                                if (o[O][1] = n + s, o[O][2] = a + c, !y(o)) for(var d = 0; d < l; d++)for(var h = 0; h < o[d].length; h++)o[d][h] = C[D][d][h];
                            } else o[O][1] = n + e, o[O][2] = a + r;
                            k();
                        }
                    }
                    function j() {
                        A();
                    }
                    function B(e, r) {
                        if (2 === e) {
                            D = +r.srcElement.getAttribute("data-i"), O = +r.srcElement.getAttribute("data-j");
                            var n = t[D];
                            y(n) || m(n) || function() {
                                if (t.length && t[D] && t[D].length) {
                                    for(var e = [], r = 0; r < t[D].length; r++)r !== O && e.push(t[D][r]);
                                    e.length > 1 && (2 !== e.length || "Z" !== e[1][0]) && (0 === O && (e[0][0] = "M"), t[D] = e, k(), A());
                                }
                            }();
                        }
                    }
                    function Y(e, r) {
                        !function(e, r) {
                            if (t.length) for(var n = 0; n < t.length; n++)for(var a = 0; a < t[n].length; a++)for(var i = 0; i + 2 < t[n][a].length; i += 2)t[n][a][i + 1] = C[n][a][i + 1] + e, t[n][a][i + 2] = C[n][a][i + 2] + r;
                        }(e, r), k();
                    }
                    function V(e) {
                        (D = +e.srcElement.getAttribute("data-i")) || (D = 0), S[D].moveFn = Y;
                    }
                    function U() {
                        A();
                    }
                    function q(e) {
                        2 === e && function(e) {
                            if (l(e._fullLayout.dragmode)) {
                                v(e);
                                var t = e._fullLayout._activeSelectionIndex, r = (e.layout || {}).selections || [];
                                if (t < r.length) {
                                    for(var n = [], a = 0; a < r.length; a++)a !== t && n.push(r[a]);
                                    delete e._fullLayout._activeSelectionIndex;
                                    var i = e._fullLayout.selections[t];
                                    e._fullLayout._deselect = {
                                        xref: i.xref,
                                        yref: i.yref
                                    }, s.call("_guiRelayout", e, {
                                        selections: n
                                    });
                                }
                            }
                        }(g);
                    }
                };
            },
            4031: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(3972), i = r(1828), o = r(9298), l = r(165).readPaths, s = r(2359), c = r(8100), u = r(1873).clearOutlineControllers, f = r(7901), d = r(1424), h = r(4467).arrayEditor, p = r(8569), v = r(6964), g = r(1459), y = r(477), m = y.getPathString;
                function x(e) {
                    var t = e._fullLayout;
                    for(var r in t._shapeUpperLayer.selectAll("path").remove(), t._shapeLowerLayer.selectAll("path").remove(), t._shapeUpperLayer.selectAll("text").remove(), t._shapeLowerLayer.selectAll("text").remove(), t._plots){
                        var n = t._plots[r].shapelayer;
                        n && (n.selectAll("path").remove(), n.selectAll("text").remove());
                    }
                    for(var a = 0; a < t.shapes.length; a++)!0 === t.shapes[a].visible && w(e, a);
                }
                function b(e) {
                    return !!e._fullLayout._outlining;
                }
                function _(e) {
                    return !e._context.edits.shapePosition;
                }
                function w(e, t) {
                    e._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + t + '"]').remove();
                    var r = y.makeShapesOptionsAndPlotinfo(e, t), u = r.options, w = r.plotinfo;
                    function A(r) {
                        var A = m(e, u), L = {
                            "data-index": t,
                            "fill-rule": u.fillrule,
                            d: A
                        }, S = u.opacity, D = u.fillcolor, O = u.line.width ? u.line.color : "rgba(0,0,0,0)", C = u.line.width, P = u.line.dash;
                        C || !0 !== u.editable || (C = 5, P = "solid");
                        var I = "Z" !== A[A.length - 1], R = _(e) && u.editable && e._fullLayout._activeShapeIndex === t;
                        R && (D = I ? "rgba(0,0,0,0)" : e._fullLayout.activeshape.fillcolor, S = e._fullLayout.activeshape.opacity);
                        var z, N = r.append("g").classed("shape-group", !0).attr({
                            "data-index": t
                        }), F = N.append("path").attr(L).style("opacity", S).call(f.stroke, O).call(f.fill, D).call(d.dashLine, P, C);
                        if (T(N, e, u), c(e, t, u, N), (R || e._context.edits.shapePosition) && (z = h(e.layout, "shapes", u)), R) {
                            F.style({
                                cursor: "move"
                            });
                            var E = {
                                element: F.node(),
                                plotinfo: w,
                                gd: e,
                                editHelpers: z,
                                hasText: u.label.text || u.label.texttemplate,
                                isActiveShape: !0
                            }, H = l(A, e);
                            s(H, F, E);
                        } else e._context.edits.shapePosition ? function(e, t, r, l, s, u) {
                            var f, h, x, _, w, k, A, L, S, D, O, C, P, I, R, z, N = 10, F = 10, E = "pixel" === r.xsizemode, H = "pixel" === r.ysizemode, j = "line" === r.type, B = "path" === r.type, Y = u.modifyItem, V = n.select(t.node().parentNode), U = o.getFromId(e, r.xref), q = o.getRefType(r.xref), G = o.getFromId(e, r.yref), Z = o.getRefType(r.yref), W = y.getDataToPixel(e, U, !1, q), X = y.getDataToPixel(e, G, !0, Z), J = y.getPixelToData(e, U, !1, q), K = y.getPixelToData(e, G, !0, Z), Q = j ? function() {
                                var e = 10, n = Math.max(r.line.width, e), a = s.append("g").attr("data-index", l).attr("drag-helper", !0);
                                a.append("path").attr("d", t.attr("d")).style({
                                    cursor: "move",
                                    "stroke-width": n,
                                    "stroke-opacity": "0"
                                });
                                var i = {
                                    "fill-opacity": "0"
                                }, o = Math.max(n / 2, e);
                                return a.append("circle").attr({
                                    "data-line-point": "start-point",
                                    cx: E ? W(r.xanchor) + r.x0 : W(r.x0),
                                    cy: H ? X(r.yanchor) - r.y0 : X(r.y0),
                                    r: o
                                }).style(i).classed("cursor-grab", !0), a.append("circle").attr({
                                    "data-line-point": "end-point",
                                    cx: E ? W(r.xanchor) + r.x1 : W(r.x1),
                                    cy: H ? X(r.yanchor) - r.y1 : X(r.y1),
                                    r: o
                                }).style(i).classed("cursor-grab", !0), a;
                            }() : t, $ = {
                                element: Q.node(),
                                gd: e,
                                prepFn: function(n) {
                                    b(e) || (E && (w = W(r.xanchor)), H && (k = X(r.yanchor)), "path" === r.type ? R = r.path : (f = E ? r.x0 : W(r.x0), h = H ? r.y0 : X(r.y0), x = E ? r.x1 : W(r.x1), _ = H ? r.y1 : X(r.y1)), f < x ? (S = f, P = "x0", D = x, I = "x1") : (S = x, P = "x1", D = f, I = "x0"), !H && h < _ || H && h > _ ? (A = h, O = "y0", L = _, C = "y1") : (A = _, O = "y1", L = h, C = "y0"), ee(n), ne(s, r), function(e, t, r) {
                                        var n = t.xref, a = t.yref, i = o.getFromId(r, n), l = o.getFromId(r, a), s = "";
                                        "paper" === n || i.autorange || (s += n), "paper" === a || l.autorange || (s += a), d.setClipUrl(e, s ? "clip" + r._fullLayout._uid + s : null, r);
                                    }(t, r, e), $.moveFn = "move" === z ? te : re, $.altKey = n.altKey);
                                },
                                doneFn: function() {
                                    b(e) || (v(t), ae(s), T(t, e, r), a.call("_guiRelayout", e, u.getUpdateObj()));
                                },
                                clickFn: function() {
                                    b(e) || ae(s);
                                }
                            };
                            function ee(r) {
                                if (b(e)) z = null;
                                else if (j) z = "path" === r.target.tagName ? "move" : "start-point" === r.target.attributes["data-line-point"].value ? "resize-over-start-point" : "resize-over-end-point";
                                else {
                                    var n = $.element.getBoundingClientRect(), a = n.right - n.left, i = n.bottom - n.top, o = r.clientX - n.left, l = r.clientY - n.top, s = !B && a > N && i > F && !r.shiftKey ? p.getCursor(o / a, 1 - l / i) : "move";
                                    v(t, s), z = s.split("-")[0];
                                }
                            }
                            function te(n, a) {
                                if ("path" === r.type) {
                                    var i = function(e) {
                                        return e;
                                    }, o = i, u = i;
                                    E ? Y("xanchor", r.xanchor = J(w + n)) : (o = function(e) {
                                        return J(W(e) + n);
                                    }, U && "date" === U.type && (o = y.encodeDate(o))), H ? Y("yanchor", r.yanchor = K(k + a)) : (u = function(e) {
                                        return K(X(e) + a);
                                    }, G && "date" === G.type && (u = y.encodeDate(u))), Y("path", r.path = M(R, o, u));
                                } else E ? Y("xanchor", r.xanchor = J(w + n)) : (Y("x0", r.x0 = J(f + n)), Y("x1", r.x1 = J(x + n))), H ? Y("yanchor", r.yanchor = K(k + a)) : (Y("y0", r.y0 = K(h + a)), Y("y1", r.y1 = K(_ + a)));
                                t.attr("d", m(e, r)), ne(s, r), c(e, l, r, V);
                            }
                            function re(n, a) {
                                if (B) {
                                    var i = function(e) {
                                        return e;
                                    }, o = i, u = i;
                                    E ? Y("xanchor", r.xanchor = J(w + n)) : (o = function(e) {
                                        return J(W(e) + n);
                                    }, U && "date" === U.type && (o = y.encodeDate(o))), H ? Y("yanchor", r.yanchor = K(k + a)) : (u = function(e) {
                                        return K(X(e) + a);
                                    }, G && "date" === G.type && (u = y.encodeDate(u))), Y("path", r.path = M(R, o, u));
                                } else if (j) {
                                    if ("resize-over-start-point" === z) {
                                        var d = f + n, p = H ? h - a : h + a;
                                        Y("x0", r.x0 = E ? d : J(d)), Y("y0", r.y0 = H ? p : K(p));
                                    } else if ("resize-over-end-point" === z) {
                                        var v = x + n, g = H ? _ - a : _ + a;
                                        Y("x1", r.x1 = E ? v : J(v)), Y("y1", r.y1 = H ? g : K(g));
                                    }
                                } else {
                                    var b = function(e) {
                                        return -1 !== z.indexOf(e);
                                    }, T = b("n"), q = b("s"), Z = b("w"), Q = b("e"), $ = T ? A + a : A, ee = q ? L + a : L, te = Z ? S + n : S, re = Q ? D + n : D;
                                    H && (T && ($ = A - a), q && (ee = L - a)), (!H && ee - $ > F || H && $ - ee > F) && (Y(O, r[O] = H ? $ : K($)), Y(C, r[C] = H ? ee : K(ee))), re - te > N && (Y(P, r[P] = E ? te : J(te)), Y(I, r[I] = E ? re : J(re)));
                                }
                                t.attr("d", m(e, r)), ne(s, r), c(e, l, r, V);
                            }
                            function ne(e, t) {
                                (E || H) && function() {
                                    var r = "path" !== t.type, n = e.selectAll(".visual-cue").data([
                                        0
                                    ]);
                                    n.enter().append("path").attr({
                                        fill: "#fff",
                                        "fill-rule": "evenodd",
                                        stroke: "#000",
                                        "stroke-width": 1
                                    }).classed("visual-cue", !0);
                                    var a = W(E ? t.xanchor : i.midRange(r ? [
                                        t.x0,
                                        t.x1
                                    ] : y.extractPathCoords(t.path, g.paramIsX))), o = X(H ? t.yanchor : i.midRange(r ? [
                                        t.y0,
                                        t.y1
                                    ] : y.extractPathCoords(t.path, g.paramIsY)));
                                    if (a = y.roundPositionForSharpStrokeRendering(a, 1), o = y.roundPositionForSharpStrokeRendering(o, 1), E && H) {
                                        var l = "M" + (a - 1 - 1) + "," + (o - 1 - 1) + "h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z";
                                        n.attr("d", l);
                                    } else if (E) {
                                        var s = "M" + (a - 1 - 1) + "," + (o - 9 - 1) + "v18 h2 v-18 Z";
                                        n.attr("d", s);
                                    } else {
                                        var c = "M" + (a - 9 - 1) + "," + (o - 1 - 1) + "h18 v2 h-18 Z";
                                        n.attr("d", c);
                                    }
                                }();
                            }
                            function ae(e) {
                                e.selectAll(".visual-cue").remove();
                            }
                            p.init($), Q.node().onmousemove = ee;
                        }(e, F, u, t, r, z) : !0 === u.editable && F.style("pointer-events", I || f.opacity(D) * S <= .5 ? "stroke" : "all");
                        F.node().addEventListener("click", function() {
                            return function(e, t) {
                                if (_(e)) {
                                    var r = +t.node().getAttribute("data-index");
                                    if (r >= 0) {
                                        if (r === e._fullLayout._activeShapeIndex) return void k(e);
                                        e._fullLayout._activeShapeIndex = r, e._fullLayout._deactivateShape = k, x(e);
                                    }
                                }
                            }(e, F);
                        });
                    }
                    u._input && !0 === u.visible && ("below" !== u.layer ? A(e._fullLayout._shapeUpperLayer) : "paper" === u.xref || "paper" === u.yref ? A(e._fullLayout._shapeLowerLayer) : w._hadPlotinfo ? A((w.mainplotinfo || w).shapelayer) : A(e._fullLayout._shapeLowerLayer));
                }
                function T(e, t, r) {
                    var n = (r.xref + r.yref).replace(/paper/g, "").replace(/[xyz][1-9]* *domain/g, "");
                    d.setClipUrl(e, n ? "clip" + t._fullLayout._uid + n : null, t);
                }
                function M(e, t, r) {
                    return e.replace(g.segmentRE, function(e) {
                        var n = 0, a = e.charAt(0), i = g.paramIsX[a], o = g.paramIsY[a], l = g.numParams[a];
                        return a + e.substr(1).replace(g.paramRE, function(e) {
                            return n >= l || (i[n] ? e = t(e) : o[n] && (e = r(e)), n++), e;
                        });
                    });
                }
                function k(e) {
                    _(e) && e._fullLayout._activeShapeIndex >= 0 && (u(e), delete e._fullLayout._activeShapeIndex, x(e));
                }
                e.exports = {
                    draw: x,
                    drawOne: w,
                    eraseActiveShape: function(e) {
                        if (_(e)) {
                            u(e);
                            var t = e._fullLayout._activeShapeIndex, r = (e.layout || {}).shapes || [];
                            if (t < r.length) {
                                for(var n = [], i = 0; i < r.length; i++)i !== t && n.push(r[i]);
                                return delete e._fullLayout._activeShapeIndex, a.call("_guiRelayout", e, {
                                    shapes: n
                                });
                            }
                        }
                    },
                    drawLabel: c
                };
            },
            9241: function(e, t, r) {
                "use strict";
                var n = r(962).overrideAll, a = r(9012), i = r(1940), o = r(9952).P, l = r(1426).extendFlat, s = r(5386).R, c = r(7281);
                e.exports = n({
                    newshape: {
                        visible: l({}, a.visible, {}),
                        showlegend: {
                            valType: "boolean",
                            dflt: !1
                        },
                        legend: l({}, a.legend, {}),
                        legendgroup: l({}, a.legendgroup, {}),
                        legendgrouptitle: {
                            text: l({}, a.legendgrouptitle.text, {}),
                            font: i({})
                        },
                        legendrank: l({}, a.legendrank, {}),
                        legendwidth: l({}, a.legendwidth, {}),
                        line: {
                            color: {
                                valType: "color"
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                dflt: 4
                            },
                            dash: l({}, o, {
                                dflt: "solid"
                            })
                        },
                        fillcolor: {
                            valType: "color",
                            dflt: "rgba(0,0,0,0)"
                        },
                        fillrule: {
                            valType: "enumerated",
                            values: [
                                "evenodd",
                                "nonzero"
                            ],
                            dflt: "evenodd"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1
                        },
                        layer: {
                            valType: "enumerated",
                            values: [
                                "below",
                                "above"
                            ],
                            dflt: "above"
                        },
                        drawdirection: {
                            valType: "enumerated",
                            values: [
                                "ortho",
                                "horizontal",
                                "vertical",
                                "diagonal"
                            ],
                            dflt: "diagonal"
                        },
                        name: l({}, a.name, {}),
                        label: {
                            text: {
                                valType: "string",
                                dflt: ""
                            },
                            texttemplate: s({
                                newshape: !0
                            }, {
                                keys: Object.keys(c)
                            }),
                            font: i({}),
                            textposition: {
                                valType: "enumerated",
                                values: [
                                    "top left",
                                    "top center",
                                    "top right",
                                    "middle left",
                                    "middle center",
                                    "middle right",
                                    "bottom left",
                                    "bottom center",
                                    "bottom right",
                                    "start",
                                    "middle",
                                    "end"
                                ]
                            },
                            textangle: {
                                valType: "angle",
                                dflt: "auto"
                            },
                            xanchor: {
                                valType: "enumerated",
                                values: [
                                    "auto",
                                    "left",
                                    "center",
                                    "right"
                                ],
                                dflt: "auto"
                            },
                            yanchor: {
                                valType: "enumerated",
                                values: [
                                    "top",
                                    "middle",
                                    "bottom"
                                ]
                            },
                            padding: {
                                valType: "number",
                                dflt: 3,
                                min: 0
                            }
                        }
                    },
                    activeshape: {
                        fillcolor: {
                            valType: "color",
                            dflt: "rgb(255,0,255)"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .5
                        }
                    }
                }, "none", "from-root");
            },
            9995: function(e) {
                "use strict";
                e.exports = {
                    CIRCLE_SIDES: 32,
                    i000: 0,
                    i090: 8,
                    i180: 16,
                    i270: 24,
                    cos45: Math.cos(Math.PI / 4),
                    sin45: Math.sin(Math.PI / 4),
                    SQRT2: Math.sqrt(2)
                };
            },
            5547: function(e, t, r) {
                "use strict";
                var n = r(7901), a = r(1828);
                e.exports = function(e, t, r) {
                    if (r("newshape.visible"), r("newshape.name"), r("newshape.showlegend"), r("newshape.legend"), r("newshape.legendwidth"), r("newshape.legendgroup"), r("newshape.legendgrouptitle.text"), a.coerceFont(r, "newshape.legendgrouptitle.font"), r("newshape.legendrank"), r("newshape.drawdirection"), r("newshape.layer"), r("newshape.fillcolor"), r("newshape.fillrule"), r("newshape.opacity"), r("newshape.line.width")) {
                        var i = (e || {}).plot_bgcolor || "#FFF";
                        r("newshape.line.color", n.contrast(i)), r("newshape.line.dash");
                    }
                    var o = "drawline" === e.dragmode, l = r("newshape.label.text"), s = r("newshape.label.texttemplate");
                    if (l || s) {
                        r("newshape.label.textangle");
                        var c = r("newshape.label.textposition", o ? "middle" : "middle center");
                        r("newshape.label.xanchor"), r("newshape.label.yanchor", function(e, t) {
                            return e ? "bottom" : -1 !== t.indexOf("top") ? "top" : -1 !== t.indexOf("bottom") ? "bottom" : "middle";
                        }(o, c)), r("newshape.label.padding"), a.coerceFont(r, "newshape.label.font", t.font);
                    }
                    r("activeshape.fillcolor"), r("activeshape.opacity");
                };
            },
            165: function(e, t, r) {
                "use strict";
                var n = r(5616), a = r(9995), i = a.CIRCLE_SIDES, o = a.SQRT2, l = r(5549), s = l.p2r, c = l.r2p, u = [
                    0,
                    3,
                    4,
                    5,
                    6,
                    1,
                    2
                ], f = [
                    0,
                    3,
                    4,
                    1,
                    2
                ];
                function d(e, t) {
                    return Math.abs(e - t) <= 1e-6;
                }
                function h(e, t) {
                    var r = t[1] - e[1], n = t[2] - e[2];
                    return Math.sqrt(r * r + n * n);
                }
                t.writePaths = function(e) {
                    var t = e.length;
                    if (!t) return "M0,0Z";
                    for(var r = "", n = 0; n < t; n++)for(var a = e[n].length, i = 0; i < a; i++){
                        var o = e[n][i][0];
                        if ("Z" === o) r += "Z";
                        else for(var l = e[n][i].length, s = 0; s < l; s++){
                            var c = s;
                            "Q" === o || "S" === o ? c = f[s] : "C" === o && (c = u[s]), r += e[n][i][c], s > 0 && s < l - 1 && (r += ",");
                        }
                    }
                    return r;
                }, t.readPaths = function(e, t, r, a) {
                    var o, l, u, f = n(e), d = [], h = -1, p = 0, v = 0, g = function() {
                        l = p, u = v;
                    };
                    g();
                    for(var y = 0; y < f.length; y++){
                        var m, x, b, _, w = [], T = f[y][0], M = T;
                        switch(T){
                            case "M":
                                d[++h] = [], p = +f[y][1], v = +f[y][2], w.push([
                                    M,
                                    p,
                                    v
                                ]), g();
                                break;
                            case "Q":
                            case "S":
                                m = +f[y][1], b = +f[y][2], p = +f[y][3], v = +f[y][4], w.push([
                                    M,
                                    p,
                                    v,
                                    m,
                                    b
                                ]);
                                break;
                            case "C":
                                m = +f[y][1], b = +f[y][2], x = +f[y][3], _ = +f[y][4], p = +f[y][5], v = +f[y][6], w.push([
                                    M,
                                    p,
                                    v,
                                    m,
                                    b,
                                    x,
                                    _
                                ]);
                                break;
                            case "T":
                            case "L":
                                p = +f[y][1], v = +f[y][2], w.push([
                                    M,
                                    p,
                                    v
                                ]);
                                break;
                            case "H":
                                M = "L", p = +f[y][1], w.push([
                                    M,
                                    p,
                                    v
                                ]);
                                break;
                            case "V":
                                M = "L", v = +f[y][1], w.push([
                                    M,
                                    p,
                                    v
                                ]);
                                break;
                            case "A":
                                M = "L";
                                var k = +f[y][1], A = +f[y][2];
                                +f[y][4] || (k = -k, A = -A);
                                var L = p - k, S = v;
                                for(o = 1; o <= i / 2; o++){
                                    var D = 2 * Math.PI * o / i;
                                    w.push([
                                        M,
                                        L + k * Math.cos(D),
                                        S + A * Math.sin(D)
                                    ]);
                                }
                                break;
                            case "Z":
                                p === l && v === u || (p = l, v = u, w.push([
                                    M,
                                    p,
                                    v
                                ]));
                        }
                        for(var O = (r || {}).domain, C = t._fullLayout._size, P = r && "pixel" === r.xsizemode, I = r && "pixel" === r.ysizemode, R = !1 === a, z = 0; z < w.length; z++){
                            for(o = 0; o + 2 < 7; o += 2){
                                var N = w[z][o + 1], F = w[z][o + 2];
                                void 0 !== N && void 0 !== F && (p = N, v = F, r && (r.xaxis && r.xaxis.p2r ? (R && (N -= r.xaxis._offset), N = P ? c(r.xaxis, r.xanchor) + N : s(r.xaxis, N)) : (R && (N -= C.l), O ? N = O.x[0] + N / C.w : N /= C.w), r.yaxis && r.yaxis.p2r ? (R && (F -= r.yaxis._offset), F = I ? c(r.yaxis, r.yanchor) - F : s(r.yaxis, F)) : (R && (F -= C.t), F = O ? O.y[1] - F / C.h : 1 - F / C.h)), w[z][o + 1] = N, w[z][o + 2] = F);
                            }
                            d[h].push(w[z].slice());
                        }
                    }
                    return d;
                }, t.pointsOnRectangle = function(e) {
                    if (5 !== e.length) return !1;
                    for(var t = 1; t < 3; t++){
                        if (!d(e[0][t] - e[1][t], e[3][t] - e[2][t])) return !1;
                        if (!d(e[0][t] - e[3][t], e[1][t] - e[2][t])) return !1;
                    }
                    return !(!d(e[0][1], e[1][1]) && !d(e[0][1], e[3][1]) || !(h(e[0], e[1]) * h(e[0], e[3])));
                }, t.pointsOnEllipse = function(e) {
                    var t = e.length;
                    if (t !== i + 1) return !1;
                    t = i;
                    for(var r = 0; r < t; r++){
                        var n = (2 * t - r) % t, a = (t / 2 + n) % t, o = (t / 2 + r) % t;
                        if (!d(h(e[r], e[o]), h(e[n], e[a]))) return !1;
                    }
                    return !0;
                }, t.handleEllipse = function(e, r, n) {
                    if (!e) return [
                        r,
                        n
                    ];
                    var a = t.ellipseOver({
                        x0: r[0],
                        y0: r[1],
                        x1: n[0],
                        y1: n[1]
                    }), l = (a.x1 + a.x0) / 2, s = (a.y1 + a.y0) / 2, c = (a.x1 - a.x0) / 2, u = (a.y1 - a.y0) / 2;
                    c || (c = u /= o), u || (u = c /= o);
                    for(var f = [], d = 0; d < i; d++){
                        var h = 2 * d * Math.PI / i;
                        f.push([
                            l + c * Math.cos(h),
                            s + u * Math.sin(h)
                        ]);
                    }
                    return f;
                }, t.ellipseOver = function(e) {
                    var t = e.x0, r = e.y0, n = e.x1, a = e.y1, i = n - t, l = a - r, s = ((t -= i) + n) / 2, c = ((r -= l) + a) / 2;
                    return {
                        x0: s - (i *= o),
                        y0: c - (l *= o),
                        x1: s + i,
                        y1: c + l
                    };
                }, t.fixDatesForPaths = function(e, t, r) {
                    var n = "date" === t.type, a = "date" === r.type;
                    if (!n && !a) return e;
                    for(var i = 0; i < e.length; i++)for(var o = 0; o < e[i].length; o++)for(var l = 0; l + 2 < e[i][o].length; l += 2)n && (e[i][o][l + 1] = e[i][o][l + 1].replace(" ", "_")), a && (e[i][o][l + 2] = e[i][o][l + 2].replace(" ", "_"));
                    return e;
                };
            },
            551: function(e, t, r) {
                "use strict";
                var n = r(4505), a = n.drawMode, i = n.openMode, o = r(9995), l = o.i000, s = o.i090, c = o.i180, u = o.i270, f = o.cos45, d = o.sin45, h = r(5549), p = h.p2r, v = h.r2p, g = r(1873).clearOutline, y = r(165), m = y.readPaths, x = y.writePaths, b = y.ellipseOver, _ = y.fixDatesForPaths;
                function w(e, t, r) {
                    var n, a = e[0][0], o = t.gd, h = a.getAttribute("d"), g = o._fullLayout.newshape, y = t.plotinfo, w = t.isActiveShape, T = y.xaxis, M = y.yaxis, k = !!y.domain || !y.xaxis, A = !!y.domain || !y.yaxis, L = i(r), S = m(h, o, y, w), D = {
                        editable: !0,
                        visible: g.visible,
                        name: g.name,
                        showlegend: g.showlegend,
                        legend: g.legend,
                        legendwidth: g.legendwidth,
                        legendgroup: g.legendgroup,
                        legendgrouptitle: {
                            text: g.legendgrouptitle.text,
                            font: g.legendgrouptitle.font
                        },
                        legendrank: g.legendrank,
                        label: g.label,
                        xref: k ? "paper" : T._id,
                        yref: A ? "paper" : M._id,
                        layer: g.layer,
                        opacity: g.opacity,
                        line: {
                            color: g.line.color,
                            width: g.line.width,
                            dash: g.line.dash
                        }
                    };
                    if (L || (D.fillcolor = g.fillcolor, D.fillrule = g.fillrule), 1 === S.length && (n = S[0]), n && 5 === n.length && "drawrect" === r) D.type = "rect", D.x0 = n[0][1], D.y0 = n[0][2], D.x1 = n[2][1], D.y1 = n[2][2];
                    else if (n && "drawline" === r) D.type = "line", D.x0 = n[0][1], D.y0 = n[0][2], D.x1 = n[1][1], D.y1 = n[1][2];
                    else if (n && "drawcircle" === r) {
                        D.type = "circle";
                        var O = n[l][1], C = n[s][1], P = n[c][1], I = n[u][1], R = n[l][2], z = n[s][2], N = n[c][2], F = n[u][2], E = y.xaxis && ("date" === y.xaxis.type || "log" === y.xaxis.type), H = y.yaxis && ("date" === y.yaxis.type || "log" === y.yaxis.type);
                        E && (O = v(y.xaxis, O), C = v(y.xaxis, C), P = v(y.xaxis, P), I = v(y.xaxis, I)), H && (R = v(y.yaxis, R), z = v(y.yaxis, z), N = v(y.yaxis, N), F = v(y.yaxis, F));
                        var j = (C + I) / 2, B = (R + N) / 2, Y = b({
                            x0: j,
                            y0: B,
                            x1: j + (I - C + P - O) / 2 * f,
                            y1: B + (F - z + N - R) / 2 * d
                        });
                        E && (Y.x0 = p(y.xaxis, Y.x0), Y.x1 = p(y.xaxis, Y.x1)), H && (Y.y0 = p(y.yaxis, Y.y0), Y.y1 = p(y.yaxis, Y.y1)), D.x0 = Y.x0, D.y0 = Y.y0, D.x1 = Y.x1, D.y1 = Y.y1;
                    } else D.type = "path", T && M && _(S, T, M), D.path = x(S), n = null;
                    return D;
                }
                e.exports = {
                    newShapes: function(e, t) {
                        if (e.length && e[0][0]) {
                            var r = t.gd, n = t.isActiveShape, i = t.dragmode, o = (r.layout || {}).shapes || [];
                            if (!a(i) && void 0 !== n) {
                                var l = r._fullLayout._activeShapeIndex;
                                if (l < o.length) switch(r._fullLayout.shapes[l].type){
                                    case "rect":
                                        i = "drawrect";
                                        break;
                                    case "circle":
                                        i = "drawcircle";
                                        break;
                                    case "line":
                                        i = "drawline";
                                        break;
                                    case "path":
                                        var s = o[l].path || "";
                                        i = "Z" === s[s.length - 1] ? "drawclosedpath" : "drawopenpath";
                                }
                            }
                            var c = w(e, t, i);
                            g(r);
                            for(var u = t.editHelpers, f = (u || {}).modifyItem, d = [], h = 0; h < o.length; h++){
                                var p = r._fullLayout.shapes[h];
                                if (d[h] = p._input, void 0 !== n && h === r._fullLayout._activeShapeIndex) {
                                    var v = c;
                                    switch(p.type){
                                        case "line":
                                        case "rect":
                                        case "circle":
                                            f("x0", v.x0), f("x1", v.x1), f("y0", v.y0), f("y1", v.y1);
                                            break;
                                        case "path":
                                            f("path", v.path);
                                    }
                                }
                            }
                            return void 0 === n ? (d.push(c), d) : u ? u.getUpdateObj() : {};
                        }
                    },
                    createShapeObj: w
                };
            },
            1873: function(e) {
                "use strict";
                e.exports = {
                    clearOutlineControllers: function(e) {
                        var t = e._fullLayout._zoomlayer;
                        t && t.selectAll(".outline-controllers").remove();
                    },
                    clearOutline: function(e) {
                        var t = e._fullLayout._zoomlayer;
                        t && t.selectAll(".select-outline").remove(), e._fullLayout._outlining = !1;
                    }
                };
            },
            477: function(e, t, r) {
                "use strict";
                var n = r(1459), a = r(1828), i = r(9298);
                t.rangeToShapePosition = function(e) {
                    return "log" === e.type ? e.r2d : function(e) {
                        return e;
                    };
                }, t.shapePositionToRange = function(e) {
                    return "log" === e.type ? e.d2r : function(e) {
                        return e;
                    };
                }, t.decodeDate = function(e) {
                    return function(t) {
                        return t.replace && (t = t.replace("_", " ")), e(t);
                    };
                }, t.encodeDate = function(e) {
                    return function(t) {
                        return e(t).replace(" ", "_");
                    };
                }, t.extractPathCoords = function(e, t, r) {
                    var i = [];
                    return e.match(n.segmentRE).forEach(function(e) {
                        var o = t[e.charAt(0)].drawn;
                        if (void 0 !== o) {
                            var l = e.substr(1).match(n.paramRE);
                            if (l && !(l.length < o)) {
                                var s = l[o], c = r ? s : a.cleanNumber(s);
                                i.push(c);
                            }
                        }
                    }), i;
                }, t.getDataToPixel = function(e, r, n, a) {
                    var i, o = e._fullLayout._size;
                    if (r) {
                        if ("domain" === a) i = function(e) {
                            return r._length * (n ? 1 - e : e) + r._offset;
                        };
                        else {
                            var l = t.shapePositionToRange(r);
                            i = function(e) {
                                return r._offset + r.r2p(l(e, !0));
                            }, "date" === r.type && (i = t.decodeDate(i));
                        }
                    } else i = n ? function(e) {
                        return o.t + o.h * (1 - e);
                    } : function(e) {
                        return o.l + o.w * e;
                    };
                    return i;
                }, t.getPixelToData = function(e, r, n, a) {
                    var i, o = e._fullLayout._size;
                    if (r) {
                        if ("domain" === a) i = function(e) {
                            var t = (e - r._offset) / r._length;
                            return n ? 1 - t : t;
                        };
                        else {
                            var l = t.rangeToShapePosition(r);
                            i = function(e) {
                                return l(r.p2r(e - r._offset));
                            };
                        }
                    } else i = n ? function(e) {
                        return 1 - (e - o.t) / o.h;
                    } : function(e) {
                        return (e - o.l) / o.w;
                    };
                    return i;
                }, t.roundPositionForSharpStrokeRendering = function(e, t) {
                    var r = 1 === Math.round(t % 2), n = Math.round(e);
                    return r ? n + .5 : n;
                }, t.makeShapesOptionsAndPlotinfo = function(e, t) {
                    var r = e._fullLayout.shapes[t] || {}, n = e._fullLayout._plots[r.xref + r.yref];
                    return n ? n._hadPlotinfo = !0 : (n = {}, r.xref && "paper" !== r.xref && (n.xaxis = e._fullLayout[r.xref + "axis"]), r.yref && "paper" !== r.yref && (n.yaxis = e._fullLayout[r.yref + "axis"])), n.xsizemode = r.xsizemode, n.ysizemode = r.ysizemode, n.xanchor = r.xanchor, n.yanchor = r.yanchor, {
                        options: r,
                        plotinfo: n
                    };
                }, t.makeSelectionsOptionsAndPlotinfo = function(e, t) {
                    var r = e._fullLayout.selections[t] || {}, n = e._fullLayout._plots[r.xref + r.yref];
                    return n ? n._hadPlotinfo = !0 : (n = {}, r.xref && (n.xaxis = e._fullLayout[r.xref + "axis"]), r.yref && (n.yaxis = e._fullLayout[r.yref + "axis"])), {
                        options: r,
                        plotinfo: n
                    };
                }, t.getPathString = function(e, r) {
                    var o, l, s, c, u, f, d, h, p = r.type, v = i.getRefType(r.xref), g = i.getRefType(r.yref), y = i.getFromId(e, r.xref), m = i.getFromId(e, r.yref), x = e._fullLayout._size;
                    if (y ? "domain" === v ? l = function(e) {
                        return y._offset + y._length * e;
                    } : (o = t.shapePositionToRange(y), l = function(e) {
                        return y._offset + y.r2p(o(e, !0));
                    }) : l = function(e) {
                        return x.l + x.w * e;
                    }, m ? "domain" === g ? c = function(e) {
                        return m._offset + m._length * (1 - e);
                    } : (s = t.shapePositionToRange(m), c = function(e) {
                        return m._offset + m.r2p(s(e, !0));
                    }) : c = function(e) {
                        return x.t + x.h * (1 - e);
                    }, "path" === p) return y && "date" === y.type && (l = t.decodeDate(l)), m && "date" === m.type && (c = t.decodeDate(c)), function(e, t, r) {
                        var i = e.path, o = e.xsizemode, l = e.ysizemode, s = e.xanchor, c = e.yanchor;
                        return i.replace(n.segmentRE, function(e) {
                            var i = 0, u = e.charAt(0), f = n.paramIsX[u], d = n.paramIsY[u], h = n.numParams[u], p = e.substr(1).replace(n.paramRE, function(e) {
                                return f[i] ? e = "pixel" === o ? t(s) + Number(e) : t(e) : d[i] && (e = "pixel" === l ? r(c) - Number(e) : r(e)), ++i > h && (e = "X"), e;
                            });
                            return i > h && (p = p.replace(/[\s,]*X.*/, ""), a.log("Ignoring extra params in segment " + e)), u + p;
                        });
                    }(r, l, c);
                    if ("pixel" === r.xsizemode) {
                        var b = l(r.xanchor);
                        u = b + r.x0, f = b + r.x1;
                    } else u = l(r.x0), f = l(r.x1);
                    if ("pixel" === r.ysizemode) {
                        var _ = c(r.yanchor);
                        d = _ - r.y0, h = _ - r.y1;
                    } else d = c(r.y0), h = c(r.y1);
                    if ("line" === p) return "M" + u + "," + d + "L" + f + "," + h;
                    if ("rect" === p) return "M" + u + "," + d + "H" + f + "V" + h + "H" + u + "Z";
                    var w = (u + f) / 2, T = (d + h) / 2, M = Math.abs(w - u), k = Math.abs(T - d), A = "A" + M + "," + k, L = w + M + "," + T;
                    return "M" + L + A + " 0 1,1 " + w + "," + (T - k) + A + " 0 0,1 " + L + "Z";
                };
            },
            9853: function(e, t, r) {
                "use strict";
                var n = r(4031);
                e.exports = {
                    moduleType: "component",
                    name: "shapes",
                    layoutAttributes: r(9827),
                    supplyLayoutDefaults: r(4726),
                    supplyDrawNewShapeDefaults: r(5547),
                    includeBasePlot: r(6325)("shapes"),
                    calcAutorange: r(5627),
                    draw: n.draw,
                    drawOne: n.drawOne
                };
            },
            7281: function(e) {
                "use strict";
                function t(e, t) {
                    return t ? t.d2l(e) : e;
                }
                function r(e, t) {
                    return t ? t.l2d(e) : e;
                }
                function n(e, r) {
                    return t(e.x1, r) - t(e.x0, r);
                }
                function a(e, r, n) {
                    return t(e.y1, n) - t(e.y0, n);
                }
                e.exports = {
                    x0: function(e) {
                        return e.x0;
                    },
                    x1: function(e) {
                        return e.x1;
                    },
                    y0: function(e) {
                        return e.y0;
                    },
                    y1: function(e) {
                        return e.y1;
                    },
                    slope: function(e, t, r) {
                        return "line" !== e.type ? void 0 : a(e, 0, r) / n(e, t);
                    },
                    dx: n,
                    dy: a,
                    width: function(e, t) {
                        return Math.abs(n(e, t));
                    },
                    height: function(e, t, r) {
                        return Math.abs(a(e, 0, r));
                    },
                    length: function(e, t, r) {
                        return "line" !== e.type ? void 0 : Math.sqrt(Math.pow(n(e, t), 2) + Math.pow(a(e, 0, r), 2));
                    },
                    xcenter: function(e, n) {
                        return r((t(e.x1, n) + t(e.x0, n)) / 2, n);
                    },
                    ycenter: function(e, n, a) {
                        return r((t(e.y1, a) + t(e.y0, a)) / 2, a);
                    }
                };
            },
            5067: function(e, t, r) {
                "use strict";
                var n = r(1940), a = r(5025), i = r(1426).extendDeepAll, o = r(962).overrideAll, l = r(5594), s = r(4467).templatedArray, c = r(8292), u = s("step", {
                    visible: {
                        valType: "boolean",
                        dflt: !0
                    },
                    method: {
                        valType: "enumerated",
                        values: [
                            "restyle",
                            "relayout",
                            "animate",
                            "update",
                            "skip"
                        ],
                        dflt: "restyle"
                    },
                    args: {
                        valType: "info_array",
                        freeLength: !0,
                        items: [
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            }
                        ]
                    },
                    label: {
                        valType: "string"
                    },
                    value: {
                        valType: "string"
                    },
                    execute: {
                        valType: "boolean",
                        dflt: !0
                    }
                });
                e.exports = o(s("slider", {
                    visible: {
                        valType: "boolean",
                        dflt: !0
                    },
                    active: {
                        valType: "number",
                        min: 0,
                        dflt: 0
                    },
                    steps: u,
                    lenmode: {
                        valType: "enumerated",
                        values: [
                            "fraction",
                            "pixels"
                        ],
                        dflt: "fraction"
                    },
                    len: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    x: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: 0
                    },
                    pad: i(a({
                        editType: "arraydraw"
                    }), {}, {
                        t: {
                            dflt: 20
                        }
                    }),
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left"
                    },
                    y: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: 0
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "top"
                    },
                    transition: {
                        duration: {
                            valType: "number",
                            min: 0,
                            dflt: 150
                        },
                        easing: {
                            valType: "enumerated",
                            values: l.transition.easing.values,
                            dflt: "cubic-in-out"
                        }
                    },
                    currentvalue: {
                        visible: {
                            valType: "boolean",
                            dflt: !0
                        },
                        xanchor: {
                            valType: "enumerated",
                            values: [
                                "left",
                                "center",
                                "right"
                            ],
                            dflt: "left"
                        },
                        offset: {
                            valType: "number",
                            dflt: 10
                        },
                        prefix: {
                            valType: "string"
                        },
                        suffix: {
                            valType: "string"
                        },
                        font: n({})
                    },
                    font: n({}),
                    activebgcolor: {
                        valType: "color",
                        dflt: c.gripBgActiveColor
                    },
                    bgcolor: {
                        valType: "color",
                        dflt: c.railBgColor
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: c.railBorderColor
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: c.railBorderWidth
                    },
                    ticklen: {
                        valType: "number",
                        min: 0,
                        dflt: c.tickLength
                    },
                    tickcolor: {
                        valType: "color",
                        dflt: c.tickColor
                    },
                    tickwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    minorticklen: {
                        valType: "number",
                        min: 0,
                        dflt: c.minorTickLength
                    }
                }), "arraydraw", "from-root");
            },
            8292: function(e) {
                "use strict";
                e.exports = {
                    name: "sliders",
                    containerClassName: "slider-container",
                    groupClassName: "slider-group",
                    inputAreaClass: "slider-input-area",
                    railRectClass: "slider-rail-rect",
                    railTouchRectClass: "slider-rail-touch-rect",
                    gripRectClass: "slider-grip-rect",
                    tickRectClass: "slider-tick-rect",
                    inputProxyClass: "slider-input-proxy",
                    labelsClass: "slider-labels",
                    labelGroupClass: "slider-label-group",
                    labelClass: "slider-label",
                    currentValueClass: "slider-current-value",
                    railHeight: 5,
                    menuIndexAttrName: "slider-active-index",
                    autoMarginIdRoot: "slider-",
                    minWidth: 30,
                    minHeight: 30,
                    textPadX: 40,
                    arrowOffsetX: 4,
                    railRadius: 2,
                    railWidth: 5,
                    railBorder: 4,
                    railBorderWidth: 1,
                    railBorderColor: "#bec8d9",
                    railBgColor: "#f8fafc",
                    railInset: 8,
                    stepInset: 10,
                    gripRadius: 10,
                    gripWidth: 20,
                    gripHeight: 20,
                    gripBorder: 20,
                    gripBorderWidth: 1,
                    gripBorderColor: "#bec8d9",
                    gripBgColor: "#f6f8fa",
                    gripBgActiveColor: "#dbdde0",
                    labelPadding: 8,
                    labelOffset: 0,
                    tickWidth: 1,
                    tickColor: "#333",
                    tickOffset: 25,
                    tickLength: 7,
                    minorTickOffset: 25,
                    minorTickColor: "#333",
                    minorTickLength: 4,
                    currentValuePadding: 8,
                    currentValueInset: 0
                };
            },
            2343: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(5501), i = r(5067), o = r(8292).name, l = i.steps;
                function s(e, t, r) {
                    function o(r, a) {
                        return n.coerce(e, t, i, r, a);
                    }
                    for(var l = a(e, t, {
                        name: "steps",
                        handleItemDefaults: c
                    }), s = 0, u = 0; u < l.length; u++)l[u].visible && s++;
                    if (s < 2 ? t.visible = !1 : o("visible")) {
                        t._stepCount = s;
                        var f = t._visibleSteps = n.filterVisible(l);
                        (l[o("active")] || {}).visible || (t.active = f[0]._index), o("x"), o("y"), n.noneOrAll(e, t, [
                            "x",
                            "y"
                        ]), o("xanchor"), o("yanchor"), o("len"), o("lenmode"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("currentvalue.visible") && (o("currentvalue.xanchor"), o("currentvalue.prefix"), o("currentvalue.suffix"), o("currentvalue.offset"), n.coerceFont(o, "currentvalue.font", t.font)), o("transition.duration"), o("transition.easing"), o("bgcolor"), o("activebgcolor"), o("bordercolor"), o("borderwidth"), o("ticklen"), o("tickwidth"), o("tickcolor"), o("minorticklen");
                    }
                }
                function c(e, t) {
                    function r(r, a) {
                        return n.coerce(e, t, l, r, a);
                    }
                    if ("skip" === e.method || Array.isArray(e.args) ? r("visible") : t.visible = !1) {
                        r("method"), r("args");
                        var a = r("label", "step-" + t._index);
                        r("value", a), r("execute");
                    }
                }
                e.exports = function(e, t) {
                    a(e, t, {
                        name: o,
                        handleItemDefaults: s
                    });
                };
            },
            4504: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(4875), i = r(7901), o = r(1424), l = r(1828), s = l.strTranslate, c = r(3893), u = r(4467).arrayEditor, f = r(8292), d = r(8783), h = d.LINE_SPACING, p = d.FROM_TL, v = d.FROM_BR;
                function g(e) {
                    return f.autoMarginIdRoot + e._index;
                }
                function y(e) {
                    return e._index;
                }
                function m(e, t) {
                    var r = o.tester.selectAll("g." + f.labelGroupClass).data(t._visibleSteps);
                    r.enter().append("g").classed(f.labelGroupClass, !0);
                    var i = 0, s = 0;
                    r.each(function(e) {
                        var r = _(n.select(this), {
                            step: e
                        }, t).node();
                        if (r) {
                            var a = o.bBox(r);
                            s = Math.max(s, a.height), i = Math.max(i, a.width);
                        }
                    }), r.remove();
                    var u = t._dims = {};
                    u.inputAreaWidth = Math.max(f.railWidth, f.gripHeight);
                    var d = e._fullLayout._size;
                    u.lx = d.l + d.w * t.x, u.ly = d.t + d.h * (1 - t.y), "fraction" === t.lenmode ? u.outerLength = Math.round(d.w * t.len) : u.outerLength = t.len, u.inputAreaStart = 0, u.inputAreaLength = Math.round(u.outerLength - t.pad.l - t.pad.r);
                    var h = (u.inputAreaLength - 2 * f.stepInset) / (t._stepCount - 1), y = i + f.labelPadding;
                    if (u.labelStride = Math.max(1, Math.ceil(y / h)), u.labelHeight = s, u.currentValueMaxWidth = 0, u.currentValueHeight = 0, u.currentValueTotalHeight = 0, u.currentValueMaxLines = 1, t.currentvalue.visible) {
                        var m = o.tester.append("g");
                        r.each(function(e) {
                            var r = x(m, t, e.label), n = r.node() && o.bBox(r.node()) || {
                                width: 0,
                                height: 0
                            }, a = c.lineCount(r);
                            u.currentValueMaxWidth = Math.max(u.currentValueMaxWidth, Math.ceil(n.width)), u.currentValueHeight = Math.max(u.currentValueHeight, Math.ceil(n.height)), u.currentValueMaxLines = Math.max(u.currentValueMaxLines, a);
                        }), u.currentValueTotalHeight = u.currentValueHeight + t.currentvalue.offset, m.remove();
                    }
                    u.height = u.currentValueTotalHeight + f.tickOffset + t.ticklen + f.labelOffset + u.labelHeight + t.pad.t + t.pad.b;
                    var b = "left";
                    l.isRightAnchor(t) && (u.lx -= u.outerLength, b = "right"), l.isCenterAnchor(t) && (u.lx -= u.outerLength / 2, b = "center");
                    var w = "top";
                    l.isBottomAnchor(t) && (u.ly -= u.height, w = "bottom"), l.isMiddleAnchor(t) && (u.ly -= u.height / 2, w = "middle"), u.outerLength = Math.ceil(u.outerLength), u.height = Math.ceil(u.height), u.lx = Math.round(u.lx), u.ly = Math.round(u.ly);
                    var T = {
                        y: t.y,
                        b: u.height * v[w],
                        t: u.height * p[w]
                    };
                    "fraction" === t.lenmode ? (T.l = 0, T.xl = t.x - t.len * p[b], T.r = 0, T.xr = t.x + t.len * v[b]) : (T.x = t.x, T.l = u.outerLength * p[b], T.r = u.outerLength * v[b]), a.autoMargin(e, g(t), T);
                }
                function x(e, t, r) {
                    if (t.currentvalue.visible) {
                        var n, a, i = t._dims;
                        switch(t.currentvalue.xanchor){
                            case "right":
                                n = i.inputAreaLength - f.currentValueInset - i.currentValueMaxWidth, a = "left";
                                break;
                            case "center":
                                n = .5 * i.inputAreaLength, a = "middle";
                                break;
                            default:
                                n = f.currentValueInset, a = "left";
                        }
                        var s = l.ensureSingle(e, "text", f.labelClass, function(e) {
                            e.attr({
                                "text-anchor": a,
                                "data-notex": 1
                            });
                        }), u = t.currentvalue.prefix ? t.currentvalue.prefix : "";
                        if ("string" == typeof r) u += r;
                        else {
                            var d = t.steps[t.active].label, p = t._gd._fullLayout._meta;
                            p && (d = l.templateString(d, p)), u += d;
                        }
                        t.currentvalue.suffix && (u += t.currentvalue.suffix), s.call(o.font, t.currentvalue.font).text(u).call(c.convertToTspans, t._gd);
                        var v = c.lineCount(s), g = (i.currentValueMaxLines + 1 - v) * t.currentvalue.font.size * h;
                        return c.positionText(s, n, g), s;
                    }
                }
                function b(e, t, r) {
                    l.ensureSingle(e, "rect", f.gripRectClass, function(n) {
                        n.call(k, t, e, r).style("pointer-events", "all");
                    }).attr({
                        width: f.gripWidth,
                        height: f.gripHeight,
                        rx: f.gripRadius,
                        ry: f.gripRadius
                    }).call(i.stroke, r.bordercolor).call(i.fill, r.bgcolor).style("stroke-width", r.borderwidth + "px");
                }
                function _(e, t, r) {
                    var n = l.ensureSingle(e, "text", f.labelClass, function(e) {
                        e.attr({
                            "text-anchor": "middle",
                            "data-notex": 1
                        });
                    }), a = t.step.label, i = r._gd._fullLayout._meta;
                    return i && (a = l.templateString(a, i)), n.call(o.font, r.font).text(a).call(c.convertToTspans, r._gd), n;
                }
                function w(e, t) {
                    var r = l.ensureSingle(e, "g", f.labelsClass), a = t._dims, i = r.selectAll("g." + f.labelGroupClass).data(a.labelSteps);
                    i.enter().append("g").classed(f.labelGroupClass, !0), i.exit().remove(), i.each(function(e) {
                        var r = n.select(this);
                        r.call(_, e, t), o.setTranslate(r, S(t, e.fraction), f.tickOffset + t.ticklen + t.font.size * h + f.labelOffset + a.currentValueTotalHeight);
                    });
                }
                function T(e, t, r, n, a) {
                    var i = Math.round(n * (r._stepCount - 1)), o = r._visibleSteps[i]._index;
                    o !== r.active && M(e, t, r, o, !0, a);
                }
                function M(e, t, r, n, i, o) {
                    var l = r.active;
                    r.active = n, u(e.layout, f.name, r).applyUpdate("active", n);
                    var s = r.steps[r.active];
                    t.call(L, r, o), t.call(x, r), e.emit("plotly_sliderchange", {
                        slider: r,
                        step: r.steps[r.active],
                        interaction: i,
                        previousActive: l
                    }), s && s.method && i && (t._nextMethod ? (t._nextMethod.step = s, t._nextMethod.doCallback = i, t._nextMethod.doTransition = o) : (t._nextMethod = {
                        step: s,
                        doCallback: i,
                        doTransition: o
                    }, t._nextMethodRaf = window.requestAnimationFrame(function() {
                        var r = t._nextMethod.step;
                        r.method && (r.execute && a.executeAPICommand(e, r.method, r.args), t._nextMethod = null, t._nextMethodRaf = null);
                    })));
                }
                function k(e, t, r) {
                    if (!t._context.staticPlot) {
                        var a = r.node(), o = n.select(t);
                        e.on("mousedown", s), e.on("touchstart", s);
                    }
                    function l() {
                        return r.data()[0];
                    }
                    function s() {
                        var e = l();
                        t.emit("plotly_sliderstart", {
                            slider: e
                        });
                        var s = r.select("." + f.gripRectClass);
                        n.event.stopPropagation(), n.event.preventDefault(), s.call(i.fill, e.activebgcolor);
                        var c = D(e, n.mouse(a)[0]);
                        function u() {
                            var e = l(), i = D(e, n.mouse(a)[0]);
                            T(t, r, e, i, !1);
                        }
                        function d() {
                            var e = l();
                            e._dragging = !1, s.call(i.fill, e.bgcolor), o.on("mouseup", null), o.on("mousemove", null), o.on("touchend", null), o.on("touchmove", null), t.emit("plotly_sliderend", {
                                slider: e,
                                step: e.steps[e.active]
                            });
                        }
                        T(t, r, e, c, !0), e._dragging = !0, o.on("mousemove", u), o.on("touchmove", u), o.on("mouseup", d), o.on("touchend", d);
                    }
                }
                function A(e, t) {
                    var r = e.selectAll("rect." + f.tickRectClass).data(t._visibleSteps), a = t._dims;
                    r.enter().append("rect").classed(f.tickRectClass, !0), r.exit().remove(), r.attr({
                        width: t.tickwidth + "px",
                        "shape-rendering": "crispEdges"
                    }), r.each(function(e, r) {
                        var l = r % a.labelStride == 0, s = n.select(this);
                        s.attr({
                            height: l ? t.ticklen : t.minorticklen
                        }).call(i.fill, t.tickcolor), o.setTranslate(s, S(t, r / (t._stepCount - 1)) - .5 * t.tickwidth, (l ? f.tickOffset : f.minorTickOffset) + a.currentValueTotalHeight);
                    });
                }
                function L(e, t, r) {
                    for(var n = e.select("rect." + f.gripRectClass), a = 0, i = 0; i < t._stepCount; i++)if (t._visibleSteps[i]._index === t.active) {
                        a = i;
                        break;
                    }
                    var o = S(t, a / (t._stepCount - 1));
                    if (!t._invokingCommand) {
                        var l = n;
                        r && t.transition.duration > 0 && (l = l.transition().duration(t.transition.duration).ease(t.transition.easing)), l.attr("transform", s(o - .5 * f.gripWidth, t._dims.currentValueTotalHeight));
                    }
                }
                function S(e, t) {
                    var r = e._dims;
                    return r.inputAreaStart + f.stepInset + (r.inputAreaLength - 2 * f.stepInset) * Math.min(1, Math.max(0, t));
                }
                function D(e, t) {
                    var r = e._dims;
                    return Math.min(1, Math.max(0, (t - f.stepInset - r.inputAreaStart) / (r.inputAreaLength - 2 * f.stepInset - 2 * r.inputAreaStart)));
                }
                function O(e, t, r) {
                    var n = r._dims, a = l.ensureSingle(e, "rect", f.railTouchRectClass, function(n) {
                        n.call(k, t, e, r).style("pointer-events", "all");
                    });
                    a.attr({
                        width: n.inputAreaLength,
                        height: Math.max(n.inputAreaWidth, f.tickOffset + r.ticklen + n.labelHeight)
                    }).call(i.fill, r.bgcolor).attr("opacity", 0), o.setTranslate(a, 0, n.currentValueTotalHeight);
                }
                function C(e, t) {
                    var r = t._dims, n = r.inputAreaLength - 2 * f.railInset, a = l.ensureSingle(e, "rect", f.railRectClass);
                    a.attr({
                        width: n,
                        height: f.railWidth,
                        rx: f.railRadius,
                        ry: f.railRadius,
                        "shape-rendering": "crispEdges"
                    }).call(i.stroke, t.bordercolor).call(i.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px"), o.setTranslate(a, f.railInset, .5 * (r.inputAreaWidth - f.railWidth) + r.currentValueTotalHeight);
                }
                e.exports = function(e) {
                    var t = e._context.staticPlot, r = e._fullLayout, i = function(e, t) {
                        for(var r = e[f.name], n = [], a = 0; a < r.length; a++){
                            var i = r[a];
                            i.visible && (i._gd = t, n.push(i));
                        }
                        return n;
                    }(r, e), l = r._infolayer.selectAll("g." + f.containerClassName).data(i.length > 0 ? [
                        0
                    ] : []);
                    function s(t) {
                        t._commandObserver && (t._commandObserver.remove(), delete t._commandObserver), a.autoMargin(e, g(t));
                    }
                    if (l.enter().append("g").classed(f.containerClassName, !0).style("cursor", t ? null : "ew-resize"), l.exit().each(function() {
                        n.select(this).selectAll("g." + f.groupClassName).each(s);
                    }).remove(), 0 !== i.length) {
                        var c = l.selectAll("g." + f.groupClassName).data(i, y);
                        c.enter().append("g").classed(f.groupClassName, !0), c.exit().each(s).remove();
                        for(var u = 0; u < i.length; u++){
                            var d = i[u];
                            m(e, d);
                        }
                        c.each(function(t) {
                            var r = n.select(this);
                            !function(e) {
                                var t = e._dims;
                                t.labelSteps = [];
                                for(var r = e._stepCount, n = 0; n < r; n += t.labelStride)t.labelSteps.push({
                                    fraction: n / (r - 1),
                                    step: e._visibleSteps[n]
                                });
                            }(t), a.manageCommandObserver(e, t, t._visibleSteps, function(t) {
                                var n = r.data()[0];
                                n.active !== t.index && (n._dragging || M(e, r, n, t.index, !1, !0));
                            }), function(e, t, r) {
                                (r.steps[r.active] || {}).visible || (r.active = r._visibleSteps[0]._index), t.call(x, r).call(C, r).call(w, r).call(A, r).call(O, e, r).call(b, e, r);
                                var n = r._dims;
                                o.setTranslate(t, n.lx + r.pad.l, n.ly + r.pad.t), t.call(L, r, !1), t.call(x, r);
                            }(e, n.select(this), t);
                        });
                    }
                };
            },
            3243: function(e, t, r) {
                "use strict";
                var n = r(8292);
                e.exports = {
                    moduleType: "component",
                    name: n.name,
                    layoutAttributes: r(5067),
                    supplyLayoutDefaults: r(2343),
                    draw: r(4504)
                };
            },
            2998: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(2770), i = r(4875), o = r(3972), l = r(1828), s = l.strTranslate, c = r(1424), u = r(7901), f = r(3893), d = r(7822), h = r(8783).OPPOSITE_SIDE, p = / [XY][0-9]* /;
                e.exports = {
                    draw: function(e, t, r) {
                        var v, g = r.propContainer, y = r.propName, m = r.placeholder, x = r.traceIndex, b = r.avoid || {}, _ = r.attributes, w = r.transform, T = r.containerGroup, M = e._fullLayout, k = 1, A = !1, L = g.title, S = (L && L.text ? L.text : "").trim(), D = L && L.font ? L.font : {}, O = D.family, C = D.size, P = D.color;
                        "title.text" === y ? v = "titleText" : -1 !== y.indexOf("axis") ? v = "axisTitleText" : y.indexOf(!0) && (v = "colorbarTitleText");
                        var I = e._context.edits[v];
                        "" === S ? k = 0 : S.replace(p, " % ") === m.replace(p, " % ") && (k = .2, A = !0, I || (S = "")), r._meta ? S = l.templateString(S, r._meta) : M._meta && (S = l.templateString(S, M._meta));
                        var R, z = S || I;
                        T || (T = l.ensureSingle(M._infolayer, "g", "g-" + t), R = M._hColorbarMoveTitle);
                        var N = T.selectAll("text").data(z ? [
                            0
                        ] : []);
                        if (N.enter().append("text"), N.text(S).attr("class", t), N.exit().remove(), !z) return T;
                        function F(e) {
                            l.syncOrAsync([
                                E,
                                H
                            ], e);
                        }
                        function E(t) {
                            var r;
                            return !w && R && (w = {}), w ? (r = "", w.rotate && (r += "rotate(" + [
                                w.rotate,
                                _.x,
                                _.y
                            ] + ")"), (w.offset || R) && (r += s(0, (w.offset || 0) - (R || 0)))) : r = null, t.attr("transform", r), t.style({
                                "font-family": O,
                                "font-size": n.round(C, 2) + "px",
                                fill: u.rgb(P),
                                opacity: k * u.opacity(P),
                                "font-weight": i.fontWeight
                            }).attr(_).call(f.convertToTspans, e), i.previousPromises(e);
                        }
                        function H(t) {
                            var r = n.select(t.node().parentNode);
                            if (b && b.selection && b.side && S) {
                                r.attr("transform", null);
                                var i = h[b.side], o = "left" === b.side || "top" === b.side ? -1 : 1, u = a(b.pad) ? b.pad : 2, f = c.bBox(r.node()), d = {
                                    t: 0,
                                    b: 0,
                                    l: 0,
                                    r: 0
                                }, p = e._fullLayout._reservedMargin;
                                for(var v in p)for(var y in p[v]){
                                    var m = p[v][y];
                                    d[y] = Math.max(d[y], m);
                                }
                                var x = {
                                    left: d.l,
                                    top: d.t,
                                    right: M.width - d.r,
                                    bottom: M.height - d.b
                                }, _ = b.maxShift || o * (x[b.side] - f[b.side]), w = 0;
                                if (_ < 0) w = _;
                                else {
                                    var T = b.offsetLeft || 0, k = b.offsetTop || 0;
                                    f.left -= T, f.right -= T, f.top -= k, f.bottom -= k, b.selection.each(function() {
                                        var e = c.bBox(this);
                                        l.bBoxIntersect(f, e, u) && (w = Math.max(w, o * (e[b.side] - f[i]) + u));
                                    }), w = Math.min(_, w), g._titleScoot = Math.abs(w);
                                }
                                if (w > 0 || _ < 0) {
                                    var A = {
                                        left: [
                                            -w,
                                            0
                                        ],
                                        right: [
                                            w,
                                            0
                                        ],
                                        top: [
                                            0,
                                            -w
                                        ],
                                        bottom: [
                                            0,
                                            w
                                        ]
                                    }[b.side];
                                    r.attr("transform", s(A[0], A[1]));
                                }
                            }
                        }
                        return N.call(F), I && (S ? N.on(".opacity", null) : (k = 0, A = !0, N.text(m).on("mouseover.opacity", function() {
                            n.select(this).transition().duration(d.SHOW_PLACEHOLDER).style("opacity", 1);
                        }).on("mouseout.opacity", function() {
                            n.select(this).transition().duration(d.HIDE_PLACEHOLDER).style("opacity", 0);
                        })), N.call(f.makeEditable, {
                            gd: e
                        }).on("edit", function(t) {
                            void 0 !== x ? o.call("_guiRestyle", e, y, t, x) : o.call("_guiRelayout", e, y, t);
                        }).on("cancel", function() {
                            this.text(this.attr("data-unformatted")).call(F);
                        }).on("input", function(e) {
                            this.text(e || " ").call(f.positionText, _.x, _.y);
                        })), N.classed("js-placeholder", A), T;
                    }
                };
            },
            7163: function(e, t, r) {
                "use strict";
                var n = r(1940), a = r(2399), i = r(1426).extendFlat, o = r(962).overrideAll, l = r(5025), s = r(4467).templatedArray, c = s("button", {
                    visible: {
                        valType: "boolean"
                    },
                    method: {
                        valType: "enumerated",
                        values: [
                            "restyle",
                            "relayout",
                            "animate",
                            "update",
                            "skip"
                        ],
                        dflt: "restyle"
                    },
                    args: {
                        valType: "info_array",
                        freeLength: !0,
                        items: [
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            }
                        ]
                    },
                    args2: {
                        valType: "info_array",
                        freeLength: !0,
                        items: [
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            }
                        ]
                    },
                    label: {
                        valType: "string",
                        dflt: ""
                    },
                    execute: {
                        valType: "boolean",
                        dflt: !0
                    }
                });
                e.exports = o(s("updatemenu", {
                    _arrayAttrRegexps: [
                        /^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/
                    ],
                    visible: {
                        valType: "boolean"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "dropdown",
                            "buttons"
                        ],
                        dflt: "dropdown"
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "right",
                            "up",
                            "down"
                        ],
                        dflt: "down"
                    },
                    active: {
                        valType: "integer",
                        min: -1,
                        dflt: 0
                    },
                    showactive: {
                        valType: "boolean",
                        dflt: !0
                    },
                    buttons: c,
                    x: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: -0.05
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "right"
                    },
                    y: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: 1
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "top"
                    },
                    pad: i(l({
                        editType: "arraydraw"
                    }), {}),
                    font: n({}),
                    bgcolor: {
                        valType: "color"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: a.borderLine
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "arraydraw"
                    }
                }), "arraydraw", "from-root");
            },
            5909: function(e) {
                "use strict";
                e.exports = {
                    name: "updatemenus",
                    containerClassName: "updatemenu-container",
                    headerGroupClassName: "updatemenu-header-group",
                    headerClassName: "updatemenu-header",
                    headerArrowClassName: "updatemenu-header-arrow",
                    dropdownButtonGroupClassName: "updatemenu-dropdown-button-group",
                    dropdownButtonClassName: "updatemenu-dropdown-button",
                    buttonClassName: "updatemenu-button",
                    itemRectClassName: "updatemenu-item-rect",
                    itemTextClassName: "updatemenu-item-text",
                    menuIndexAttrName: "updatemenu-active-index",
                    autoMarginIdRoot: "updatemenu-",
                    blankHeaderOpts: {
                        label: "  "
                    },
                    minWidth: 30,
                    minHeight: 30,
                    textPadX: 24,
                    arrowPadX: 16,
                    rx: 2,
                    ry: 2,
                    textOffsetX: 12,
                    textOffsetY: 3,
                    arrowOffsetX: 4,
                    gapButtonHeader: 5,
                    gapButton: 2,
                    activeColor: "#F4FAFF",
                    hoverColor: "#F4FAFF",
                    arrowSymbol: {
                        left: "\u25C4",
                        right: "\u25BA",
                        up: "\u25B2",
                        down: "\u25BC"
                    }
                };
            },
            4897: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(5501), i = r(7163), o = r(5909).name, l = i.buttons;
                function s(e, t, r) {
                    function o(r, a) {
                        return n.coerce(e, t, i, r, a);
                    }
                    o("visible", a(e, t, {
                        name: "buttons",
                        handleItemDefaults: c
                    }).length > 0) && (o("active"), o("direction"), o("type"), o("showactive"), o("x"), o("y"), n.noneOrAll(e, t, [
                        "x",
                        "y"
                    ]), o("xanchor"), o("yanchor"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("bgcolor", r.paper_bgcolor), o("bordercolor"), o("borderwidth"));
                }
                function c(e, t) {
                    function r(r, a) {
                        return n.coerce(e, t, l, r, a);
                    }
                    r("visible", "skip" === e.method || Array.isArray(e.args)) && (r("method"), r("args"), r("args2"), r("label"), r("execute"));
                }
                e.exports = function(e, t) {
                    a(e, t, {
                        name: o,
                        handleItemDefaults: s
                    });
                };
            },
            3689: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(4875), i = r(7901), o = r(1424), l = r(1828), s = r(3893), c = r(4467).arrayEditor, u = r(8783).LINE_SPACING, f = r(5909), d = r(5849);
                function h(e) {
                    return e._index;
                }
                function p(e, t) {
                    return +e.attr(f.menuIndexAttrName) === t._index;
                }
                function v(e, t, r, n, a, i, o, l) {
                    t.active = o, c(e.layout, f.name, t).applyUpdate("active", o), "buttons" === t.type ? y(e, n, null, null, t) : "dropdown" === t.type && (a.attr(f.menuIndexAttrName, "-1"), g(e, n, a, i, t), l || y(e, n, a, i, t));
                }
                function g(e, t, r, n, a) {
                    var i = l.ensureSingle(t, "g", f.headerClassName, function(e) {
                        e.style("pointer-events", "all");
                    }), s = a._dims, c = a.active, u = a.buttons[c] || f.blankHeaderOpts, d = {
                        y: a.pad.t,
                        yPad: 0,
                        x: a.pad.l,
                        xPad: 0,
                        index: 0
                    }, h = {
                        width: s.headerWidth,
                        height: s.headerHeight
                    };
                    i.call(m, a, u, e).call(A, a, d, h), l.ensureSingle(t, "text", f.headerArrowClassName, function(e) {
                        e.attr("text-anchor", "end").call(o.font, a.font).text(f.arrowSymbol[a.direction]);
                    }).attr({
                        x: s.headerWidth - f.arrowOffsetX + a.pad.l,
                        y: s.headerHeight / 2 + f.textOffsetY + a.pad.t
                    }), i.on("click", function() {
                        r.call(L, String(p(r, a) ? -1 : a._index)), y(e, t, r, n, a);
                    }), i.on("mouseover", function() {
                        i.call(w);
                    }), i.on("mouseout", function() {
                        i.call(T, a);
                    }), o.setTranslate(t, s.lx, s.ly);
                }
                function y(e, t, r, i, o) {
                    r || (r = t).attr("pointer-events", "all");
                    var s = function(e) {
                        return -1 == +e.attr(f.menuIndexAttrName);
                    }(r) && "buttons" !== o.type ? [] : o.buttons, c = "dropdown" === o.type ? f.dropdownButtonClassName : f.buttonClassName, u = r.selectAll("g." + c).data(l.filterVisible(s)), d = u.enter().append("g").classed(c, !0), h = u.exit();
                    "dropdown" === o.type ? (d.attr("opacity", "0").transition().attr("opacity", "1"), h.transition().attr("opacity", "0").remove()) : h.remove();
                    var p = 0, g = 0, y = o._dims, x = -1 !== [
                        "up",
                        "down"
                    ].indexOf(o.direction);
                    "dropdown" === o.type && (x ? g = y.headerHeight + f.gapButtonHeader : p = y.headerWidth + f.gapButtonHeader), "dropdown" === o.type && "up" === o.direction && (g = -f.gapButtonHeader + f.gapButton - y.openHeight), "dropdown" === o.type && "left" === o.direction && (p = -f.gapButtonHeader + f.gapButton - y.openWidth);
                    var b = {
                        x: y.lx + p + o.pad.l,
                        y: y.ly + g + o.pad.t,
                        yPad: f.gapButton,
                        xPad: f.gapButton,
                        index: 0
                    }, M = {
                        l: b.x + o.borderwidth,
                        t: b.y + o.borderwidth
                    };
                    u.each(function(l, s) {
                        var c = n.select(this);
                        c.call(m, o, l, e).call(A, o, b), c.on("click", function() {
                            n.event.defaultPrevented || (l.execute && (l.args2 && o.active === s ? (v(e, o, 0, t, r, i, -1), a.executeAPICommand(e, l.method, l.args2)) : (v(e, o, 0, t, r, i, s), a.executeAPICommand(e, l.method, l.args))), e.emit("plotly_buttonclicked", {
                                menu: o,
                                button: l,
                                active: o.active
                            }));
                        }), c.on("mouseover", function() {
                            c.call(w);
                        }), c.on("mouseout", function() {
                            c.call(T, o), u.call(_, o);
                        });
                    }), u.call(_, o), x ? (M.w = Math.max(y.openWidth, y.headerWidth), M.h = b.y - M.t) : (M.w = b.x - M.l, M.h = Math.max(y.openHeight, y.headerHeight)), M.direction = o.direction, i && (u.size() ? function(e, t, r, n, a, i) {
                        var o, l, s, c = a.direction, u = "up" === c || "down" === c, d = a._dims, h = a.active;
                        if (u) for(l = 0, s = 0; s < h; s++)l += d.heights[s] + f.gapButton;
                        else for(o = 0, s = 0; s < h; s++)o += d.widths[s] + f.gapButton;
                        n.enable(i, o, l), n.hbar && n.hbar.attr("opacity", "0").transition().attr("opacity", "1"), n.vbar && n.vbar.attr("opacity", "0").transition().attr("opacity", "1");
                    }(0, 0, 0, i, o, M) : function(e) {
                        var t = !!e.hbar, r = !!e.vbar;
                        t && e.hbar.transition().attr("opacity", "0").each("end", function() {
                            t = !1, r || e.disable();
                        }), r && e.vbar.transition().attr("opacity", "0").each("end", function() {
                            r = !1, t || e.disable();
                        });
                    }(i));
                }
                function m(e, t, r, n) {
                    e.call(x, t).call(b, t, r, n);
                }
                function x(e, t) {
                    l.ensureSingle(e, "rect", f.itemRectClassName, function(e) {
                        e.attr({
                            rx: f.rx,
                            ry: f.ry,
                            "shape-rendering": "crispEdges"
                        });
                    }).call(i.stroke, t.bordercolor).call(i.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px");
                }
                function b(e, t, r, n) {
                    var a = l.ensureSingle(e, "text", f.itemTextClassName, function(e) {
                        e.attr({
                            "text-anchor": "start",
                            "data-notex": 1
                        });
                    }), i = r.label, c = n._fullLayout._meta;
                    c && (i = l.templateString(i, c)), a.call(o.font, t.font).text(i).call(s.convertToTspans, n);
                }
                function _(e, t) {
                    var r = t.active;
                    e.each(function(e, a) {
                        var o = n.select(this);
                        a === r && t.showactive && o.select("rect." + f.itemRectClassName).call(i.fill, f.activeColor);
                    });
                }
                function w(e) {
                    e.select("rect." + f.itemRectClassName).call(i.fill, f.hoverColor);
                }
                function T(e, t) {
                    e.select("rect." + f.itemRectClassName).call(i.fill, t.bgcolor);
                }
                function M(e, t) {
                    var r = t._dims = {
                        width1: 0,
                        height1: 0,
                        heights: [],
                        widths: [],
                        totalWidth: 0,
                        totalHeight: 0,
                        openWidth: 0,
                        openHeight: 0,
                        lx: 0,
                        ly: 0
                    }, i = o.tester.selectAll("g." + f.dropdownButtonClassName).data(l.filterVisible(t.buttons));
                    i.enter().append("g").classed(f.dropdownButtonClassName, !0);
                    var c = -1 !== [
                        "up",
                        "down"
                    ].indexOf(t.direction);
                    i.each(function(a, i) {
                        var l = n.select(this);
                        l.call(m, t, a, e);
                        var d = l.select("." + f.itemTextClassName), h = d.node() && o.bBox(d.node()).width, p = Math.max(h + f.textPadX, f.minWidth), v = t.font.size * u, g = s.lineCount(d), y = Math.max(v * g, f.minHeight) + f.textOffsetY;
                        y = Math.ceil(y), p = Math.ceil(p), r.widths[i] = p, r.heights[i] = y, r.height1 = Math.max(r.height1, y), r.width1 = Math.max(r.width1, p), c ? (r.totalWidth = Math.max(r.totalWidth, p), r.openWidth = r.totalWidth, r.totalHeight += y + f.gapButton, r.openHeight += y + f.gapButton) : (r.totalWidth += p + f.gapButton, r.openWidth += p + f.gapButton, r.totalHeight = Math.max(r.totalHeight, y), r.openHeight = r.totalHeight);
                    }), c ? r.totalHeight -= f.gapButton : r.totalWidth -= f.gapButton, r.headerWidth = r.width1 + f.arrowPadX, r.headerHeight = r.height1, "dropdown" === t.type && (c ? (r.width1 += f.arrowPadX, r.totalHeight = r.height1) : r.totalWidth = r.width1, r.totalWidth += f.arrowPadX), i.remove();
                    var d = r.totalWidth + t.pad.l + t.pad.r, h = r.totalHeight + t.pad.t + t.pad.b, p = e._fullLayout._size;
                    r.lx = p.l + p.w * t.x, r.ly = p.t + p.h * (1 - t.y);
                    var v = "left";
                    l.isRightAnchor(t) && (r.lx -= d, v = "right"), l.isCenterAnchor(t) && (r.lx -= d / 2, v = "center");
                    var g = "top";
                    l.isBottomAnchor(t) && (r.ly -= h, g = "bottom"), l.isMiddleAnchor(t) && (r.ly -= h / 2, g = "middle"), r.totalWidth = Math.ceil(r.totalWidth), r.totalHeight = Math.ceil(r.totalHeight), r.lx = Math.round(r.lx), r.ly = Math.round(r.ly), a.autoMargin(e, k(t), {
                        x: t.x,
                        y: t.y,
                        l: d * (({
                            right: 1,
                            center: .5
                        })[v] || 0),
                        r: d * (({
                            left: 1,
                            center: .5
                        })[v] || 0),
                        b: h * (({
                            top: 1,
                            middle: .5
                        })[g] || 0),
                        t: h * (({
                            bottom: 1,
                            middle: .5
                        })[g] || 0)
                    });
                }
                function k(e) {
                    return f.autoMarginIdRoot + e._index;
                }
                function A(e, t, r, n) {
                    n = n || {};
                    var a = e.select("." + f.itemRectClassName), i = e.select("." + f.itemTextClassName), l = t.borderwidth, c = r.index, d = t._dims;
                    o.setTranslate(e, l + r.x, l + r.y);
                    var h = -1 !== [
                        "up",
                        "down"
                    ].indexOf(t.direction), p = n.height || (h ? d.heights[c] : d.height1);
                    a.attr({
                        x: 0,
                        y: 0,
                        width: n.width || (h ? d.width1 : d.widths[c]),
                        height: p
                    });
                    var v = t.font.size * u, g = (s.lineCount(i) - 1) * v / 2;
                    s.positionText(i, f.textOffsetX, p / 2 - g + f.textOffsetY), h ? r.y += d.heights[c] + r.yPad : r.x += d.widths[c] + r.xPad, r.index++;
                }
                function L(e, t) {
                    e.attr(f.menuIndexAttrName, t || "-1").selectAll("g." + f.dropdownButtonClassName).remove();
                }
                e.exports = function(e) {
                    var t = e._fullLayout, r = l.filterVisible(t[f.name]);
                    function i(t) {
                        a.autoMargin(e, k(t));
                    }
                    var o = t._menulayer.selectAll("g." + f.containerClassName).data(r.length > 0 ? [
                        0
                    ] : []);
                    if (o.enter().append("g").classed(f.containerClassName, !0).style("cursor", "pointer"), o.exit().each(function() {
                        n.select(this).selectAll("g." + f.headerGroupClassName).each(i);
                    }).remove(), 0 !== r.length) {
                        var s = o.selectAll("g." + f.headerGroupClassName).data(r, h);
                        s.enter().append("g").classed(f.headerGroupClassName, !0);
                        for(var c = l.ensureSingle(o, "g", f.dropdownButtonGroupClassName, function(e) {
                            e.style("pointer-events", "all");
                        }), u = 0; u < r.length; u++){
                            var m = r[u];
                            M(e, m);
                        }
                        var x = "updatemenus" + t._uid, b = new d(e, c, x);
                        s.enter().size() && (c.node().parentNode.appendChild(c.node()), c.call(L)), s.exit().each(function(e) {
                            c.call(L), i(e);
                        }).remove(), s.each(function(t) {
                            var r = n.select(this), i = "dropdown" === t.type ? c : null;
                            a.manageCommandObserver(e, t, t.buttons, function(n) {
                                v(e, t, t.buttons[n.index], r, i, b, n.index, !0);
                            }), "dropdown" === t.type ? (g(e, r, c, b, t), p(c, t) && y(e, r, c, b, t)) : y(e, r, null, null, t);
                        });
                    }
                };
            },
            763: function(e, t, r) {
                "use strict";
                var n = r(5909);
                e.exports = {
                    moduleType: "component",
                    name: n.name,
                    layoutAttributes: r(7163),
                    supplyLayoutDefaults: r(4897),
                    draw: r(3689)
                };
            },
            5849: function(e, t, r) {
                "use strict";
                e.exports = l;
                var n = r(9898), a = r(7901), i = r(1424), o = r(1828);
                function l(e, t, r) {
                    this.gd = e, this.container = t, this.id = r, this.position = null, this.translateX = null, this.translateY = null, this.hbar = null, this.vbar = null, this.bg = this.container.selectAll("rect.scrollbox-bg").data([
                        0
                    ]), this.bg.exit().on(".drag", null).on("wheel", null).remove(), this.bg.enter().append("rect").classed("scrollbox-bg", !0).style("pointer-events", "all").attr({
                        opacity: 0,
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    });
                }
                l.barWidth = 2, l.barLength = 20, l.barRadius = 2, l.barPad = 1, l.barColor = "#808BA4", l.prototype.enable = function(e, t, r) {
                    var o = this.gd._fullLayout, s = o.width, c = o.height;
                    this.position = e;
                    var u, f, d, h, p = this.position.l, v = this.position.w, g = this.position.t, y = this.position.h, m = this.position.direction, x = "down" === m, b = "left" === m, _ = "up" === m, w = v, T = y;
                    x || b || "right" === m || _ || (this.position.direction = "down", x = !0), x || _ ? (f = (u = p) + w, x ? (d = g, T = (h = Math.min(d + T, c)) - d) : T = (h = g + T) - (d = Math.max(h - T, 0))) : (h = (d = g) + T, b ? w = (f = p + w) - (u = Math.max(f - w, 0)) : (u = p, w = (f = Math.min(u + w, s)) - u)), this._box = {
                        l: u,
                        t: d,
                        w: w,
                        h: T
                    };
                    var M = v > w, k = l.barLength + 2 * l.barPad, A = l.barWidth + 2 * l.barPad, L = p, S = g + y;
                    S + A > c && (S = c - A);
                    var D = this.container.selectAll("rect.scrollbar-horizontal").data(M ? [
                        0
                    ] : []);
                    D.exit().on(".drag", null).remove(), D.enter().append("rect").classed("scrollbar-horizontal", !0).call(a.fill, l.barColor), M ? (this.hbar = D.attr({
                        rx: l.barRadius,
                        ry: l.barRadius,
                        x: L,
                        y: S,
                        width: k,
                        height: A
                    }), this._hbarXMin = L + k / 2, this._hbarTranslateMax = w - k) : (delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax);
                    var O = y > T, C = l.barWidth + 2 * l.barPad, P = l.barLength + 2 * l.barPad, I = p + v, R = g;
                    I + C > s && (I = s - C);
                    var z = this.container.selectAll("rect.scrollbar-vertical").data(O ? [
                        0
                    ] : []);
                    z.exit().on(".drag", null).remove(), z.enter().append("rect").classed("scrollbar-vertical", !0).call(a.fill, l.barColor), O ? (this.vbar = z.attr({
                        rx: l.barRadius,
                        ry: l.barRadius,
                        x: I,
                        y: R,
                        width: C,
                        height: P
                    }), this._vbarYMin = R + P / 2, this._vbarTranslateMax = T - P) : (delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
                    var N = this.id, F = u - .5, E = O ? f + C + .5 : f + .5, H = d - .5, j = M ? h + A + .5 : h + .5, B = o._topdefs.selectAll("#" + N).data(M || O ? [
                        0
                    ] : []);
                    if (B.exit().remove(), B.enter().append("clipPath").attr("id", N).append("rect"), M || O ? (this._clipRect = B.select("rect").attr({
                        x: Math.floor(F),
                        y: Math.floor(H),
                        width: Math.ceil(E) - Math.floor(F),
                        height: Math.ceil(j) - Math.floor(H)
                    }), this.container.call(i.setClipUrl, N, this.gd), this.bg.attr({
                        x: p,
                        y: g,
                        width: v,
                        height: y
                    })) : (this.bg.attr({
                        width: 0,
                        height: 0
                    }), this.container.on("wheel", null).on(".drag", null).call(i.setClipUrl, null), delete this._clipRect), M || O) {
                        var Y = n.behavior.drag().on("dragstart", function() {
                            n.event.sourceEvent.preventDefault();
                        }).on("drag", this._onBoxDrag.bind(this));
                        this.container.on("wheel", null).on("wheel", this._onBoxWheel.bind(this)).on(".drag", null).call(Y);
                        var V = n.behavior.drag().on("dragstart", function() {
                            n.event.sourceEvent.preventDefault(), n.event.sourceEvent.stopPropagation();
                        }).on("drag", this._onBarDrag.bind(this));
                        M && this.hbar.on(".drag", null).call(V), O && this.vbar.on(".drag", null).call(V);
                    }
                    this.setTranslate(t, r);
                }, l.prototype.disable = function() {
                    (this.hbar || this.vbar) && (this.bg.attr({
                        width: 0,
                        height: 0
                    }), this.container.on("wheel", null).on(".drag", null).call(i.setClipUrl, null), delete this._clipRect), this.hbar && (this.hbar.on(".drag", null), this.hbar.remove(), delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax), this.vbar && (this.vbar.on(".drag", null), this.vbar.remove(), delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
                }, l.prototype._onBoxDrag = function() {
                    var e = this.translateX, t = this.translateY;
                    this.hbar && (e -= n.event.dx), this.vbar && (t -= n.event.dy), this.setTranslate(e, t);
                }, l.prototype._onBoxWheel = function() {
                    var e = this.translateX, t = this.translateY;
                    this.hbar && (e += n.event.deltaY), this.vbar && (t += n.event.deltaY), this.setTranslate(e, t);
                }, l.prototype._onBarDrag = function() {
                    var e = this.translateX, t = this.translateY;
                    if (this.hbar) {
                        var r = e + this._hbarXMin, a = r + this._hbarTranslateMax;
                        e = (o.constrain(n.event.x, r, a) - r) / (a - r) * (this.position.w - this._box.w);
                    }
                    if (this.vbar) {
                        var i = t + this._vbarYMin, l = i + this._vbarTranslateMax;
                        t = (o.constrain(n.event.y, i, l) - i) / (l - i) * (this.position.h - this._box.h);
                    }
                    this.setTranslate(e, t);
                }, l.prototype.setTranslate = function(e, t) {
                    var r = this.position.w - this._box.w, n = this.position.h - this._box.h;
                    if (e = o.constrain(e || 0, 0, r), t = o.constrain(t || 0, 0, n), this.translateX = e, this.translateY = t, this.container.call(i.setTranslate, this._box.l - this.position.l - e, this._box.t - this.position.t - t), this._clipRect && this._clipRect.attr({
                        x: Math.floor(this.position.l + e - .5),
                        y: Math.floor(this.position.t + t - .5)
                    }), this.hbar) {
                        var a = e / r;
                        this.hbar.call(i.setTranslate, e + a * this._hbarTranslateMax, t);
                    }
                    if (this.vbar) {
                        var l = t / n;
                        this.vbar.call(i.setTranslate, e, t + l * this._vbarTranslateMax);
                    }
                };
            },
            8783: function(e) {
                "use strict";
                e.exports = {
                    FROM_BL: {
                        left: 0,
                        center: .5,
                        right: 1,
                        bottom: 0,
                        middle: .5,
                        top: 1
                    },
                    FROM_TL: {
                        left: 0,
                        center: .5,
                        right: 1,
                        bottom: 1,
                        middle: .5,
                        top: 0
                    },
                    FROM_BR: {
                        left: 1,
                        center: .5,
                        right: 0,
                        bottom: 0,
                        middle: .5,
                        top: 1
                    },
                    LINE_SPACING: 1.3,
                    CAP_SHIFT: .7,
                    MID_SHIFT: .35,
                    OPPOSITE_SIDE: {
                        left: "right",
                        right: "left",
                        top: "bottom",
                        bottom: "top"
                    }
                };
            },
            4695: function(e) {
                "use strict";
                e.exports = {
                    axisRefDescription: function(e, t, r) {
                        return [
                            "If set to a",
                            e,
                            "axis id (e.g. *" + e + "* or",
                            "*" + e + "2*), the `" + e + "` position refers to a",
                            e,
                            "coordinate. If set to *paper*, the `" + e + "`",
                            "position refers to the distance from the",
                            t,
                            "of the plotting",
                            "area in normalized coordinates where *0* (*1*) corresponds to the",
                            t,
                            "(" + r + "). If set to a",
                            e,
                            "axis ID followed by",
                            "*domain* (separated by a space), the position behaves like for",
                            "*paper*, but refers to the distance in fractions of the domain",
                            "length from the",
                            t,
                            "of the domain of that axis: e.g.,",
                            "*" + e + "2 domain* refers to the domain of the second",
                            e,
                            " axis and a",
                            e,
                            "position of 0.5 refers to the",
                            "point between the",
                            t,
                            "and the",
                            r,
                            "of the domain of the",
                            "second",
                            e,
                            "axis."
                        ].join(" ");
                    }
                };
            },
            1562: function(e) {
                "use strict";
                e.exports = {
                    FORMAT_LINK: "https://github.com/d3/d3-format/tree/v1.4.5#d3-format",
                    DATE_FORMAT_LINK: "https://github.com/d3/d3-time-format/tree/v2.2.3#locale_format"
                };
            },
            4808: function(e) {
                "use strict";
                e.exports = {
                    COMPARISON_OPS: [
                        "=",
                        "!=",
                        "<",
                        ">=",
                        ">",
                        "<="
                    ],
                    COMPARISON_OPS2: [
                        "=",
                        "<",
                        ">=",
                        ">",
                        "<="
                    ],
                    INTERVAL_OPS: [
                        "[]",
                        "()",
                        "[)",
                        "(]",
                        "][",
                        ")(",
                        "](",
                        ")["
                    ],
                    SET_OPS: [
                        "{}",
                        "}{"
                    ],
                    CONSTRAINT_REDUCTION: {
                        "=": "=",
                        "<": "<",
                        "<=": "<",
                        ">": ">",
                        ">=": ">",
                        "[]": "[]",
                        "()": "[]",
                        "[)": "[]",
                        "(]": "[]",
                        "][": "][",
                        ")(": "][",
                        "](": "][",
                        ")[": "]["
                    }
                };
            },
            7822: function(e) {
                "use strict";
                e.exports = {
                    SHOW_PLACEHOLDER: 100,
                    HIDE_PLACEHOLDER: 1e3,
                    DESELECTDIM: .2
                };
            },
            606: function(e) {
                "use strict";
                e.exports = {
                    BADNUM: void 0,
                    FP_SAFE: 1e-4 * Number.MAX_VALUE,
                    ONEMAXYEAR: 316224e5,
                    ONEAVGYEAR: 315576e5,
                    ONEMINYEAR: 31536e6,
                    ONEMAXQUARTER: 79488e5,
                    ONEAVGQUARTER: 78894e5,
                    ONEMINQUARTER: 76896e5,
                    ONEMAXMONTH: 26784e5,
                    ONEAVGMONTH: 26298e5,
                    ONEMINMONTH: 24192e5,
                    ONEWEEK: 6048e5,
                    ONEDAY: 864e5,
                    ONEHOUR: 36e5,
                    ONEMIN: 6e4,
                    ONESEC: 1e3,
                    EPOCHJD: 2440587.5,
                    ALMOST_EQUAL: .999999,
                    LOG_CLIP: 10,
                    MINUS_SIGN: "\u2212"
                };
            },
            7922: function(e, t) {
                "use strict";
                t.xmlns = "http://www.w3.org/2000/xmlns/", t.svg = "http://www.w3.org/2000/svg", t.xlink = "http://www.w3.org/1999/xlink", t.svgAttrs = {
                    xmlns: t.svg,
                    "xmlns:xlink": t.xlink
                };
            },
            8729: function(e, t, r) {
                "use strict";
                t.version = r(1506).version, r(7417), r(8847);
                for(var n = r(3972), a = t.register = n.register, i = r(641), o = Object.keys(i), l = 0; l < o.length; l++){
                    var s = o[l];
                    "_" !== s.charAt(0) && (t[s] = i[s]), a({
                        moduleType: "apiMethod",
                        name: s,
                        fn: i[s]
                    });
                }
                a(r(7368)), a([
                    r(2745),
                    r(2468),
                    r(7322),
                    r(9853),
                    r(8804),
                    r(763),
                    r(3243),
                    r(3137),
                    r(7218),
                    r(3312),
                    r(7369),
                    r(1081),
                    r(2311),
                    r(2199),
                    r(211),
                    r(4168)
                ]), a([
                    r(2177),
                    r(7815)
                ]), window.PlotlyLocales && Array.isArray(window.PlotlyLocales) && (a(window.PlotlyLocales), delete window.PlotlyLocales), t.Icons = r(4255);
                var c = r(211), u = r(4875);
                t.Plots = {
                    resize: u.resize,
                    graphJson: u.graphJson,
                    sendDataToCloud: u.sendDataToCloud
                }, t.Fx = {
                    hover: c.hover,
                    unhover: c.unhover,
                    loneHover: c.loneHover,
                    loneUnhover: c.loneUnhover
                }, t.Snapshot = r(4511), t.PlotSchema = r(6281);
            },
            4255: function(e) {
                "use strict";
                e.exports = {
                    undo: {
                        width: 857.1,
                        height: 1e3,
                        path: "m857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    home: {
                        width: 928.6,
                        height: 1e3,
                        path: "m786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    "camera-retro": {
                        width: 1e3,
                        height: 1e3,
                        path: "m518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    zoombox: {
                        width: 1e3,
                        height: 1e3,
                        path: "m1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    pan: {
                        width: 1e3,
                        height: 1e3,
                        path: "m1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    zoom_plus: {
                        width: 875,
                        height: 1e3,
                        path: "m1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    zoom_minus: {
                        width: 875,
                        height: 1e3,
                        path: "m0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    autoscale: {
                        width: 1e3,
                        height: 1e3,
                        path: "m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    tooltip_basic: {
                        width: 1500,
                        height: 1e3,
                        path: "m375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    tooltip_compare: {
                        width: 1125,
                        height: 1e3,
                        path: "m187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    plotlylogo: {
                        width: 1542,
                        height: 1e3,
                        path: "m0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    "z-axis": {
                        width: 1e3,
                        height: 1e3,
                        path: "m833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    "3d_rotate": {
                        width: 1e3,
                        height: 1e3,
                        path: "m922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    camera: {
                        width: 1e3,
                        height: 1e3,
                        path: "m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    movie: {
                        width: 1e3,
                        height: 1e3,
                        path: "m938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    question: {
                        width: 857.1,
                        height: 1e3,
                        path: "m500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    disk: {
                        width: 857.1,
                        height: 1e3,
                        path: "m214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    drawopenpath: {
                        width: 70,
                        height: 70,
                        path: "M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z",
                        transform: "matrix(1 0 0 1 -15 -15)"
                    },
                    drawclosedpath: {
                        width: 90,
                        height: 90,
                        path: "M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z",
                        transform: "matrix(1 0 0 1 -5 -5)"
                    },
                    lasso: {
                        width: 1031,
                        height: 1e3,
                        path: "m1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    selectbox: {
                        width: 1e3,
                        height: 1e3,
                        path: "m0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    drawline: {
                        width: 70,
                        height: 70,
                        path: "M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z",
                        transform: "matrix(1 0 0 1 -15 -15)"
                    },
                    drawrect: {
                        width: 80,
                        height: 80,
                        path: "M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z",
                        transform: "matrix(1 0 0 1 -10 -10)"
                    },
                    drawcircle: {
                        width: 80,
                        height: 80,
                        path: "M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z",
                        transform: "matrix(1 0 0 1 -10 -10)"
                    },
                    eraseshape: {
                        width: 80,
                        height: 80,
                        path: "M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z",
                        transform: "matrix(1 0 0 1 -10 -10)"
                    },
                    spikeline: {
                        width: 1e3,
                        height: 1e3,
                        path: "M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z",
                        transform: "matrix(1.5 0 0 -1.5 0 850)"
                    },
                    pencil: {
                        width: 1792,
                        height: 1792,
                        path: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z",
                        transform: "matrix(1 0 0 1 0 1)"
                    },
                    newplotlylogo: {
                        name: "newplotlylogo",
                        svg: [
                            "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132 132'>",
                            "<defs>",
                            " <style>",
                            "  .cls-0{fill:#000;}",
                            "  .cls-1{fill:#FFF;}",
                            "  .cls-2{fill:#F26;}",
                            "  .cls-3{fill:#D69;}",
                            "  .cls-4{fill:#BAC;}",
                            "  .cls-5{fill:#9EF;}",
                            " </style>",
                            "</defs>",
                            " <title>plotly-logomark</title>",
                            " <g id='symbol'>",
                            "  <rect class='cls-0' x='0' y='0' width='132' height='132' rx='18' ry='18'/>",
                            "  <circle class='cls-5' cx='102' cy='30' r='6'/>",
                            "  <circle class='cls-4' cx='78' cy='30' r='6'/>",
                            "  <circle class='cls-4' cx='78' cy='54' r='6'/>",
                            "  <circle class='cls-3' cx='54' cy='30' r='6'/>",
                            "  <circle class='cls-2' cx='30' cy='30' r='6'/>",
                            "  <circle class='cls-2' cx='30' cy='54' r='6'/>",
                            "  <path class='cls-1' d='M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z'/>",
                            "  <path class='cls-1' d='M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z'/>",
                            "  <path class='cls-1' d='M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z'/>",
                            "  <path class='cls-1' d='M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z'/>",
                            " </g>",
                            "</svg>"
                        ].join("")
                    }
                };
            },
            9863: function(e, t) {
                "use strict";
                t.isLeftAnchor = function(e) {
                    return "left" === e.xanchor || "auto" === e.xanchor && e.x <= 1 / 3;
                }, t.isCenterAnchor = function(e) {
                    return "center" === e.xanchor || "auto" === e.xanchor && e.x > 1 / 3 && e.x < 2 / 3;
                }, t.isRightAnchor = function(e) {
                    return "right" === e.xanchor || "auto" === e.xanchor && e.x >= 2 / 3;
                }, t.isTopAnchor = function(e) {
                    return "top" === e.yanchor || "auto" === e.yanchor && e.y >= 2 / 3;
                }, t.isMiddleAnchor = function(e) {
                    return "middle" === e.yanchor || "auto" === e.yanchor && e.y > 1 / 3 && e.y < 2 / 3;
                }, t.isBottomAnchor = function(e) {
                    return "bottom" === e.yanchor || "auto" === e.yanchor && e.y <= 1 / 3;
                };
            },
            6348: function(e, t, r) {
                "use strict";
                var n = r(4872), a = n.mod, i = n.modHalf, o = Math.PI, l = 2 * o;
                function s(e) {
                    return Math.abs(e[1] - e[0]) > l - 1e-14;
                }
                function c(e, t) {
                    return i(t - e, l);
                }
                function u(e, t) {
                    if (s(t)) return !0;
                    var r, n;
                    t[0] < t[1] ? (r = t[0], n = t[1]) : (r = t[1], n = t[0]), (r = a(r, l)) > (n = a(n, l)) && (n += l);
                    var i = a(e, l), o = i + l;
                    return i >= r && i <= n || o >= r && o <= n;
                }
                function f(e, t, r, n, a, i, c) {
                    a = a || 0, i = i || 0;
                    var u, f, d, h, p, v = s([
                        r,
                        n
                    ]);
                    function g(e, t) {
                        return [
                            e * Math.cos(t) + a,
                            i - e * Math.sin(t)
                        ];
                    }
                    v ? (u = 0, f = o, d = l) : r < n ? (u = r, d = n) : (u = n, d = r), e < t ? (h = e, p = t) : (h = t, p = e);
                    var y, m = Math.abs(d - u) <= o ? 0 : 1;
                    function x(e, t, r) {
                        return "A" + [
                            e,
                            e
                        ] + " " + [
                            0,
                            m,
                            r
                        ] + " " + g(e, t);
                    }
                    return v ? y = null === h ? "M" + g(p, u) + x(p, f, 0) + x(p, d, 0) + "Z" : "M" + g(h, u) + x(h, f, 0) + x(h, d, 0) + "ZM" + g(p, u) + x(p, f, 1) + x(p, d, 1) + "Z" : null === h ? (y = "M" + g(p, u) + x(p, d, 0), c && (y += "L0,0Z")) : y = "M" + g(h, u) + "L" + g(p, u) + x(p, d, 0) + "L" + g(h, d) + x(h, u, 1) + "Z", y;
                }
                e.exports = {
                    deg2rad: function(e) {
                        return e / 180 * o;
                    },
                    rad2deg: function(e) {
                        return e / o * 180;
                    },
                    angleDelta: c,
                    angleDist: function(e, t) {
                        return Math.abs(c(e, t));
                    },
                    isFullCircle: s,
                    isAngleInsideSector: u,
                    isPtInsideSector: function(e, t, r, n) {
                        var a, i;
                        return !!u(t, n) && (r[0] < r[1] ? (a = r[0], i = r[1]) : (a = r[1], i = r[0]), e >= a && e <= i);
                    },
                    pathArc: function(e, t, r, n, a) {
                        return f(null, e, t, r, n, a, 0);
                    },
                    pathSector: function(e, t, r, n, a) {
                        return f(null, e, t, r, n, a, 1);
                    },
                    pathAnnulus: function(e, t, r, n, a, i) {
                        return f(e, t, r, n, a, i, 1);
                    }
                };
            },
            3627: function(e, t) {
                "use strict";
                var r = Array.isArray, n = ArrayBuffer, a = DataView;
                function i(e) {
                    return n.isView(e) && !(e instanceof a);
                }
                function o(e) {
                    return r(e) || i(e);
                }
                function l(e, t, r) {
                    if (o(e)) {
                        if (o(e[0])) {
                            for(var n = r, a = 0; a < e.length; a++)n = t(n, e[a].length);
                            return n;
                        }
                        return e.length;
                    }
                    return 0;
                }
                t.isTypedArray = i, t.isArrayOrTypedArray = o, t.isArray1D = function(e) {
                    return !o(e[0]);
                }, t.ensureArray = function(e, t) {
                    return r(e) || (e = []), e.length = t, e;
                }, t.concat = function() {
                    var e, t, n, a, i, o, l, s, c = [], u = !0, f = 0;
                    for(n = 0; n < arguments.length; n++)(o = (a = arguments[n]).length) && (t ? c.push(a) : (t = a, i = o), r(a) ? e = !1 : (u = !1, f ? e !== a.constructor && (e = !1) : e = a.constructor), f += o);
                    if (!f) return [];
                    if (!c.length) return t;
                    if (u) return t.concat.apply(t, c);
                    if (e) {
                        for((l = new e(f)).set(t), n = 0; n < c.length; n++)a = c[n], l.set(a, i), i += a.length;
                        return l;
                    }
                    for(l = new Array(f), s = 0; s < t.length; s++)l[s] = t[s];
                    for(n = 0; n < c.length; n++){
                        for(a = c[n], s = 0; s < a.length; s++)l[i + s] = a[s];
                        i += s;
                    }
                    return l;
                }, t.maxRowLength = function(e) {
                    return l(e, Math.max, 0);
                }, t.minRowLength = function(e) {
                    return l(e, Math.min, 1 / 0);
                };
            },
            5218: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(606).BADNUM, i = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
                e.exports = function(e) {
                    return "string" == typeof e && (e = e.replace(i, "")), n(e) ? Number(e) : a;
                };
            },
            3306: function(e) {
                "use strict";
                e.exports = function(e) {
                    var t = e._fullLayout;
                    t._glcanvas && t._glcanvas.size() && t._glcanvas.each(function(e) {
                        e.regl && e.regl.clear({
                            color: !0,
                            depth: !0
                        });
                    });
                };
            },
            6367: function(e) {
                "use strict";
                e.exports = function(e) {
                    e._responsiveChartHandler && (window.removeEventListener("resize", e._responsiveChartHandler), delete e._responsiveChartHandler);
                };
            },
            6554: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(4267), i = r(9012), o = r(3282), l = r(7901), s = r(7822).DESELECTDIM, c = r(5487), u = r(587).counter, f = r(4872).modHalf, d = r(3627).isArrayOrTypedArray;
                function h(e, r) {
                    var n = t.valObjectMeta[r.valType];
                    if (r.arrayOk && d(e)) return !0;
                    if (n.validateFunction) return n.validateFunction(e, r);
                    var a = {}, i = a, o = {
                        set: function(e) {
                            i = e;
                        }
                    };
                    return n.coerceFunction(e, o, a, r), i !== a;
                }
                t.valObjectMeta = {
                    data_array: {
                        coerceFunction: function(e, t, r) {
                            d(e) ? t.set(e) : void 0 !== r && t.set(r);
                        }
                    },
                    enumerated: {
                        coerceFunction: function(e, t, r, n) {
                            n.coerceNumber && (e = +e), -1 === n.values.indexOf(e) ? t.set(r) : t.set(e);
                        },
                        validateFunction: function(e, t) {
                            t.coerceNumber && (e = +e);
                            for(var r = t.values, n = 0; n < r.length; n++){
                                var a = String(r[n]);
                                if ("/" === a.charAt(0) && "/" === a.charAt(a.length - 1)) {
                                    if (new RegExp(a.substr(1, a.length - 2)).test(e)) return !0;
                                } else if (e === r[n]) return !0;
                            }
                            return !1;
                        }
                    },
                    boolean: {
                        coerceFunction: function(e, t, r) {
                            !0 === e || !1 === e ? t.set(e) : t.set(r);
                        }
                    },
                    number: {
                        coerceFunction: function(e, t, r, a) {
                            !n(e) || void 0 !== a.min && e < a.min || void 0 !== a.max && e > a.max ? t.set(r) : t.set(+e);
                        }
                    },
                    integer: {
                        coerceFunction: function(e, t, r, a) {
                            e % 1 || !n(e) || void 0 !== a.min && e < a.min || void 0 !== a.max && e > a.max ? t.set(r) : t.set(+e);
                        }
                    },
                    string: {
                        coerceFunction: function(e, t, r, n) {
                            if ("string" != typeof e) {
                                var a = "number" == typeof e;
                                !0 !== n.strict && a ? t.set(String(e)) : t.set(r);
                            } else n.noBlank && !e ? t.set(r) : t.set(e);
                        }
                    },
                    color: {
                        coerceFunction: function(e, t, r) {
                            a(e).isValid() ? t.set(e) : t.set(r);
                        }
                    },
                    colorlist: {
                        coerceFunction: function(e, t, r) {
                            Array.isArray(e) && e.length && e.every(function(e) {
                                return a(e).isValid();
                            }) ? t.set(e) : t.set(r);
                        }
                    },
                    colorscale: {
                        coerceFunction: function(e, t, r) {
                            t.set(o.get(e, r));
                        }
                    },
                    angle: {
                        coerceFunction: function(e, t, r) {
                            "auto" === e ? t.set("auto") : n(e) ? t.set(f(+e, 360)) : t.set(r);
                        }
                    },
                    subplotid: {
                        coerceFunction: function(e, t, r, n) {
                            var a = n.regex || u(r);
                            "string" == typeof e && a.test(e) ? t.set(e) : t.set(r);
                        },
                        validateFunction: function(e, t) {
                            var r = t.dflt;
                            return e === r || "string" == typeof e && !!u(r).test(e);
                        }
                    },
                    flaglist: {
                        coerceFunction: function(e, t, r, n) {
                            if (-1 === (n.extras || []).indexOf(e)) {
                                if ("string" == typeof e) {
                                    for(var a = e.split("+"), i = 0; i < a.length;){
                                        var o = a[i];
                                        -1 === n.flags.indexOf(o) || a.indexOf(o) < i ? a.splice(i, 1) : i++;
                                    }
                                    a.length ? t.set(a.join("+")) : t.set(r);
                                } else t.set(r);
                            } else t.set(e);
                        }
                    },
                    any: {
                        coerceFunction: function(e, t, r) {
                            void 0 === e ? t.set(r) : t.set(e);
                        }
                    },
                    info_array: {
                        coerceFunction: function(e, r, n, a) {
                            function i(e, r, n) {
                                var a, i = {
                                    set: function(e) {
                                        a = e;
                                    }
                                };
                                return void 0 === n && (n = r.dflt), t.valObjectMeta[r.valType].coerceFunction(e, i, n, r), a;
                            }
                            var o = 2 === a.dimensions || "1-2" === a.dimensions && Array.isArray(e) && Array.isArray(e[0]);
                            if (Array.isArray(e)) {
                                var l, s, c, u, f, d, h = a.items, p = [], v = Array.isArray(h), g = v && o && Array.isArray(h[0]), y = o && v && !g, m = v && !y ? h.length : e.length;
                                if (n = Array.isArray(n) ? n : [], o) for(l = 0; l < m; l++)for(p[l] = [], c = Array.isArray(e[l]) ? e[l] : [], f = y ? h.length : v ? h[l].length : c.length, s = 0; s < f; s++)u = y ? h[s] : v ? h[l][s] : h, void 0 !== (d = i(c[s], u, (n[l] || [])[s])) && (p[l][s] = d);
                                else for(l = 0; l < m; l++)void 0 !== (d = i(e[l], v ? h[l] : h, n[l])) && (p[l] = d);
                                r.set(p);
                            } else r.set(n);
                        },
                        validateFunction: function(e, t) {
                            if (!Array.isArray(e)) return !1;
                            var r = t.items, n = Array.isArray(r), a = 2 === t.dimensions;
                            if (!t.freeLength && e.length !== r.length) return !1;
                            for(var i = 0; i < e.length; i++)if (a) {
                                if (!Array.isArray(e[i]) || !t.freeLength && e[i].length !== r[i].length) return !1;
                                for(var o = 0; o < e[i].length; o++)if (!h(e[i][o], n ? r[i][o] : r)) return !1;
                            } else if (!h(e[i], n ? r[i] : r)) return !1;
                            return !0;
                        }
                    }
                }, t.coerce = function(e, r, n, a, i) {
                    var o = c(n, a).get(), l = c(e, a), s = c(r, a), u = l.get(), f = r._template;
                    if (void 0 === u && f && (u = c(f, a).get(), f = 0), void 0 === i && (i = o.dflt), o.arrayOk && d(u)) return s.set(u), u;
                    var p = t.valObjectMeta[o.valType].coerceFunction;
                    p(u, s, i, o);
                    var v = s.get();
                    return f && v === i && !h(u, o) && (p(u = c(f, a).get(), s, i, o), v = s.get()), v;
                }, t.coerce2 = function(e, r, n, a, i) {
                    var o = c(e, a), l = t.coerce(e, r, n, a, i);
                    return null != o.get() && l;
                }, t.coerceFont = function(e, t, r) {
                    var n = {};
                    return r = r || {}, n.family = e(t + ".family", r.family), n.size = e(t + ".size", r.size), n.color = e(t + ".color", r.color), n;
                }, t.coercePattern = function(e, t, r, n) {
                    if (e(t + ".shape")) {
                        e(t + ".solidity"), e(t + ".size");
                        var a = "overlay" === e(t + ".fillmode");
                        if (!n) {
                            var i = e(t + ".bgcolor", a ? r : void 0);
                            e(t + ".fgcolor", a ? l.contrast(i) : r);
                        }
                        e(t + ".fgopacity", a ? .5 : 1);
                    }
                }, t.coerceHoverinfo = function(e, r, n) {
                    var a, o = r._module.attributes, l = o.hoverinfo ? o : i, s = l.hoverinfo;
                    if (1 === n._dataLength) {
                        var c = "all" === s.dflt ? s.flags.slice() : s.dflt.split("+");
                        c.splice(c.indexOf("name"), 1), a = c.join("+");
                    }
                    return t.coerce(e, r, l, "hoverinfo", a);
                }, t.coerceSelectionMarkerOpacity = function(e, t) {
                    if (e.marker) {
                        var r, n, a = e.marker.opacity;
                        void 0 !== a && (d(a) || e.selected || e.unselected || (r = a, n = s * a), t("selected.marker.opacity", r), t("unselected.marker.opacity", n));
                    }
                }, t.validate = h;
            },
            1631: function(e, t, r) {
                "use strict";
                var n, a, i = r(4096).i$, o = r(2770), l = r(7769), s = r(4872).mod, c = r(606), u = c.BADNUM, f = c.ONEDAY, d = c.ONEHOUR, h = c.ONEMIN, p = c.ONESEC, v = c.EPOCHJD, g = r(3972), y = r(4096).g0, m = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m, x = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m, b = (new Date).getFullYear() - 70;
                function _(e) {
                    return e && g.componentsRegistry.calendars && "string" == typeof e && "gregorian" !== e;
                }
                function w(e, t) {
                    return String(e + Math.pow(10, t)).substr(1);
                }
                t.dateTick0 = function(e, r) {
                    var n = function(e, t) {
                        return _(e) ? t ? g.getComponentMethod("calendars", "CANONICAL_SUNDAY")[e] : g.getComponentMethod("calendars", "CANONICAL_TICK")[e] : t ? "2000-01-02" : "2000-01-01";
                    }(e, !!r);
                    if (r < 2) return n;
                    var a = t.dateTime2ms(n, e);
                    return a += f * (r - 1), t.ms2DateTime(a, 0, e);
                }, t.dfltRange = function(e) {
                    return _(e) ? g.getComponentMethod("calendars", "DFLTRANGE")[e] : [
                        "2000-01-01",
                        "2001-01-01"
                    ];
                }, t.isJSDate = function(e) {
                    return "object" == typeof e && null !== e && "function" == typeof e.getTime;
                }, t.dateTime2ms = function(e, r) {
                    if (t.isJSDate(e)) {
                        var i = e.getTimezoneOffset() * h, o = (e.getUTCMinutes() - e.getMinutes()) * h + (e.getUTCSeconds() - e.getSeconds()) * p + (e.getUTCMilliseconds() - e.getMilliseconds());
                        if (o) {
                            var l = 3 * h;
                            i = i - l / 2 + s(o - i + l / 2, l);
                        }
                        return (e = Number(e) - i) >= n && e <= a ? e : u;
                    }
                    if ("string" != typeof e && "number" != typeof e) return u;
                    e = String(e);
                    var c = _(r), y = e.charAt(0);
                    !c || "G" !== y && "g" !== y || (e = e.substr(1), r = "");
                    var w = c && "chinese" === r.substr(0, 7), T = e.match(w ? x : m);
                    if (!T) return u;
                    var M = T[1], k = T[3] || "1", A = Number(T[5] || 1), L = Number(T[7] || 0), S = Number(T[9] || 0), D = Number(T[11] || 0);
                    if (c) {
                        if (2 === M.length) return u;
                        var O;
                        M = Number(M);
                        try {
                            var C = g.getComponentMethod("calendars", "getCal")(r);
                            if (w) {
                                var P = "i" === k.charAt(k.length - 1);
                                k = parseInt(k, 10), O = C.newDate(M, C.toMonthIndex(M, k, P), A);
                            } else O = C.newDate(M, Number(k), A);
                        } catch (e) {
                            return u;
                        }
                        return O ? (O.toJD() - v) * f + L * d + S * h + D * p : u;
                    }
                    M = 2 === M.length ? (Number(M) + 2e3 - b) % 100 + b : Number(M), k -= 1;
                    var I = new Date(Date.UTC(2e3, k, A, L, S));
                    return I.setUTCFullYear(M), I.getUTCMonth() !== k || I.getUTCDate() !== A ? u : I.getTime() + D * p;
                }, n = t.MIN_MS = t.dateTime2ms("-9999"), a = t.MAX_MS = t.dateTime2ms("9999-12-31 23:59:59.9999"), t.isDateTime = function(e, r) {
                    return t.dateTime2ms(e, r) !== u;
                };
                var T = 90 * f, M = 3 * d, k = 5 * h;
                function A(e, t, r, n, a) {
                    if ((t || r || n || a) && (e += " " + w(t, 2) + ":" + w(r, 2), (n || a) && (e += ":" + w(n, 2), a))) {
                        for(var i = 4; a % 10 == 0;)i -= 1, a /= 10;
                        e += "." + w(a, i);
                    }
                    return e;
                }
                t.ms2DateTime = function(e, t, r) {
                    if ("number" != typeof e || !(e >= n && e <= a)) return u;
                    t || (t = 0);
                    var i, o, l, c, m, x, b = Math.floor(10 * s(e + .05, 1)), w = Math.round(e - b / 10);
                    if (_(r)) {
                        var L = Math.floor(w / f) + v, S = Math.floor(s(e, f));
                        try {
                            i = g.getComponentMethod("calendars", "getCal")(r).fromJD(L).formatDate("yyyy-mm-dd");
                        } catch (e) {
                            i = y("G%Y-%m-%d")(new Date(w));
                        }
                        if ("-" === i.charAt(0)) for(; i.length < 11;)i = "-0" + i.substr(1);
                        else for(; i.length < 10;)i = "0" + i;
                        o = t < T ? Math.floor(S / d) : 0, l = t < T ? Math.floor(S % d / h) : 0, c = t < M ? Math.floor(S % h / p) : 0, m = t < k ? S % p * 10 + b : 0;
                    } else x = new Date(w), i = y("%Y-%m-%d")(x), o = t < T ? x.getUTCHours() : 0, l = t < T ? x.getUTCMinutes() : 0, c = t < M ? x.getUTCSeconds() : 0, m = t < k ? 10 * x.getUTCMilliseconds() + b : 0;
                    return A(i, o, l, c, m);
                }, t.ms2DateTimeLocal = function(e) {
                    if (!(e >= n + f && e <= a - f)) return u;
                    var t = Math.floor(10 * s(e + .05, 1)), r = new Date(Math.round(e - t / 10));
                    return A(i("%Y-%m-%d")(r), r.getHours(), r.getMinutes(), r.getSeconds(), 10 * r.getUTCMilliseconds() + t);
                }, t.cleanDate = function(e, r, n) {
                    if (e === u) return r;
                    if (t.isJSDate(e) || "number" == typeof e && isFinite(e)) {
                        if (_(n)) return l.error("JS Dates and milliseconds are incompatible with world calendars", e), r;
                        if (!(e = t.ms2DateTimeLocal(+e)) && void 0 !== r) return r;
                    } else if (!t.isDateTime(e, n)) return l.error("unrecognized date", e), r;
                    return e;
                };
                var L = /%\d?f/g, S = /%h/g, D = {
                    1: "1",
                    2: "1",
                    3: "2",
                    4: "2"
                };
                function O(e, t, r, n) {
                    e = e.replace(L, function(e) {
                        var r = Math.min(+e.charAt(1) || 6, 6);
                        return (t / 1e3 % 1 + 2).toFixed(r).substr(2).replace(/0+$/, "") || "0";
                    });
                    var a = new Date(Math.floor(t + .05));
                    if (e = e.replace(S, function() {
                        return D[r("%q")(a)];
                    }), _(n)) try {
                        e = g.getComponentMethod("calendars", "worldCalFmt")(e, t, n);
                    } catch (e) {
                        return "Invalid";
                    }
                    return r(e)(a);
                }
                var C = [
                    59,
                    59.9,
                    59.99,
                    59.999,
                    59.9999
                ];
                t.formatDate = function(e, t, r, n, a, i) {
                    if (a = _(a) && a, !t) {
                        if ("y" === r) t = i.year;
                        else if ("m" === r) t = i.month;
                        else {
                            if ("d" !== r) return function(e, t) {
                                var r = s(e + .05, f), n = w(Math.floor(r / d), 2) + ":" + w(s(Math.floor(r / h), 60), 2);
                                if ("M" !== t) {
                                    o(t) || (t = 0);
                                    var a = (100 + Math.min(s(e / p, 60), C[t])).toFixed(t).substr(1);
                                    t > 0 && (a = a.replace(/0+$/, "").replace(/[\.]$/, "")), n += ":" + a;
                                }
                                return n;
                            }(e, r) + "\n" + O(i.dayMonthYear, e, n, a);
                            t = i.dayMonth + "\n" + i.year;
                        }
                    }
                    return O(t, e, n, a);
                };
                var P = 3 * f;
                t.incrementMonth = function(e, t, r) {
                    r = _(r) && r;
                    var n = s(e, f);
                    if (e = Math.round(e - n), r) try {
                        var a = Math.round(e / f) + v, i = g.getComponentMethod("calendars", "getCal")(r), o = i.fromJD(a);
                        return t % 12 ? i.add(o, t, "m") : i.add(o, t / 12, "y"), (o.toJD() - v) * f + n;
                    } catch (t) {
                        l.error("invalid ms " + e + " in calendar " + r);
                    }
                    var c = new Date(e + P);
                    return c.setUTCMonth(c.getUTCMonth() + t) + n - P;
                }, t.findExactDates = function(e, t) {
                    for(var r, n, a = 0, i = 0, l = 0, s = 0, c = _(t) && g.getComponentMethod("calendars", "getCal")(t), u = 0; u < e.length; u++)if (n = e[u], o(n)) {
                        if (!(n % f)) {
                            if (c) try {
                                1 === (r = c.fromJD(n / f + v)).day() ? 1 === r.month() ? a++ : i++ : l++;
                            } catch (e) {}
                            else 1 === (r = new Date(n)).getUTCDate() ? 0 === r.getUTCMonth() ? a++ : i++ : l++;
                        }
                    } else s++;
                    l += i += a;
                    var d = e.length - s;
                    return {
                        exactYears: a / d,
                        exactMonths: i / d,
                        exactDays: l / d
                    };
                };
            },
            4401: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(7769), i = r(5657), o = r(9576);
                function l(e) {
                    var t = e && e.parentNode;
                    t && t.removeChild(e);
                }
                function s(e, t, r) {
                    var n = "plotly.js-style-" + e, i = document.getElementById(n);
                    i || ((i = document.createElement("style")).setAttribute("id", n), i.appendChild(document.createTextNode("")), document.head.appendChild(i));
                    var o = i.sheet;
                    o.insertRule ? o.insertRule(t + "{" + r + "}", 0) : o.addRule ? o.addRule(t, r, 0) : a.warn("addStyleRule failed");
                }
                function c(e) {
                    var t = window.getComputedStyle(e, null), r = t.getPropertyValue("-webkit-transform") || t.getPropertyValue("-moz-transform") || t.getPropertyValue("-ms-transform") || t.getPropertyValue("-o-transform") || t.getPropertyValue("transform");
                    return "none" === r ? null : r.replace("matrix", "").replace("3d", "").slice(1, -1).split(",").map(function(e) {
                        return +e;
                    });
                }
                function u(e) {
                    for(var t = []; f(e);)t.push(e), e = e.parentNode;
                    return t;
                }
                function f(e) {
                    return e && (e instanceof Element || e instanceof HTMLElement);
                }
                e.exports = {
                    getGraphDiv: function(e) {
                        var t;
                        if ("string" == typeof e) {
                            if (null === (t = document.getElementById(e))) throw new Error("No DOM element with id '" + e + "' exists on the page.");
                            return t;
                        }
                        if (null == e) throw new Error("DOM element provided is null or undefined");
                        return e;
                    },
                    isPlotDiv: function(e) {
                        var t = n.select(e);
                        return t.node() instanceof HTMLElement && t.size() && t.classed("js-plotly-plot");
                    },
                    removeElement: l,
                    addStyleRule: function(e, t) {
                        s("global", e, t);
                    },
                    addRelatedStyleRule: s,
                    deleteRelatedStyleRule: function(e) {
                        var t = "plotly.js-style-" + e, r = document.getElementById(t);
                        r && l(r);
                    },
                    getFullTransformMatrix: function(e) {
                        var t = u(e), r = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ];
                        return t.forEach(function(e) {
                            var t = c(e);
                            if (t) {
                                var n = i.convertCssMatrix(t);
                                r = o.multiply(r, r, n);
                            }
                        }), r;
                    },
                    getElementTransformMatrix: c,
                    getElementAndAncestors: u,
                    equalDomRects: function(e, t) {
                        return e && t && e.top === t.top && e.left === t.left && e.right === t.right && e.bottom === t.bottom;
                    }
                };
            },
            1086: function(e, t, r) {
                "use strict";
                var n = r(5398).EventEmitter, a = {
                    init: function(e) {
                        if (e._ev instanceof n) return e;
                        var t = new n, r = new n;
                        return e._ev = t, e._internalEv = r, e.on = t.on.bind(t), e.once = t.once.bind(t), e.removeListener = t.removeListener.bind(t), e.removeAllListeners = t.removeAllListeners.bind(t), e._internalOn = r.on.bind(r), e._internalOnce = r.once.bind(r), e._removeInternalListener = r.removeListener.bind(r), e._removeAllInternalListeners = r.removeAllListeners.bind(r), e.emit = function(n, a) {
                            "undefined" != typeof jQuery && jQuery(e).trigger(n, a), t.emit(n, a), r.emit(n, a);
                        }, e;
                    },
                    triggerHandler: function(e, t, r) {
                        var n, a;
                        "undefined" != typeof jQuery && (n = jQuery(e).triggerHandler(t, r));
                        var i = e._ev;
                        if (!i) return n;
                        var o, l = i._events[t];
                        if (!l) return n;
                        function s(e) {
                            return e.listener ? (i.removeListener(t, e.listener), e.fired ? void 0 : (e.fired = !0, e.listener.apply(i, [
                                r
                            ]))) : e.apply(i, [
                                r
                            ]);
                        }
                        for(l = Array.isArray(l) ? l : [
                            l
                        ], o = 0; o < l.length - 1; o++)s(l[o]);
                        return a = s(l[o]), void 0 !== n ? n : a;
                    },
                    purge: function(e) {
                        return delete e._ev, delete e.on, delete e.once, delete e.removeListener, delete e.removeAllListeners, delete e.emit, delete e._ev, delete e._internalEv, delete e._internalOn, delete e._internalOnce, delete e._removeInternalListener, delete e._removeAllInternalListeners, e;
                    }
                };
                e.exports = a;
            },
            1426: function(e, t, r) {
                "use strict";
                var n = r(1965), a = Array.isArray;
                function i(e, t, r, o) {
                    var l, s, c, u, f, d, h, p = e[0], v = e.length;
                    if (2 === v && a(p) && a(e[1]) && 0 === p.length) {
                        if (h = function(e, t) {
                            var r, n;
                            for(r = 0; r < e.length; r++){
                                if (null !== (n = e[r]) && "object" == typeof n) return !1;
                                void 0 !== n && (t[r] = n);
                            }
                            return !0;
                        }(e[1], p), h) return p;
                        p.splice(0, p.length);
                    }
                    for(var g = 1; g < v; g++)for(s in l = e[g])c = p[s], u = l[s], o && a(u) ? p[s] = u : t && u && (n(u) || (f = a(u))) ? (f ? (f = !1, d = c && a(c) ? c : []) : d = c && n(c) ? c : {}, p[s] = i([
                        d,
                        u
                    ], t, r, o)) : (void 0 !== u || r) && (p[s] = u);
                    return p;
                }
                t.extendFlat = function() {
                    return i(arguments, !1, !1, !1);
                }, t.extendDeep = function() {
                    return i(arguments, !0, !1, !1);
                }, t.extendDeepAll = function() {
                    return i(arguments, !0, !0, !1);
                }, t.extendDeepNoArrays = function() {
                    return i(arguments, !0, !1, !0);
                };
            },
            5744: function(e) {
                "use strict";
                e.exports = function(e) {
                    for(var t = {}, r = [], n = 0, a = 0; a < e.length; a++){
                        var i = e[a];
                        1 !== t[i] && (t[i] = 1, r[n++] = i);
                    }
                    return r;
                };
            },
            6756: function(e) {
                "use strict";
                function t(e) {
                    return !0 === e.visible;
                }
                function r(e) {
                    var t = e[0].trace;
                    return !0 === t.visible && 0 !== t._length;
                }
                e.exports = function(e) {
                    for(var n, a = (n = e, Array.isArray(n) && Array.isArray(n[0]) && n[0][0] && n[0][0].trace ? r : t), i = [], o = 0; o < e.length; o++){
                        var l = e[o];
                        a(l) && i.push(l);
                    }
                    return i;
                };
            },
            7642: function(e, t, r) {
                "use strict";
                var n, a, i, o = r(4872).mod;
                function l(e, t, r, n, a, i, o, l) {
                    var s = r - e, c = a - e, u = o - a, f = n - t, d = i - t, h = l - i, p = s * h - u * f;
                    if (0 === p) return null;
                    var v = (c * h - u * d) / p, g = (c * f - s * d) / p;
                    return g < 0 || g > 1 || v < 0 || v > 1 ? null : {
                        x: e + s * v,
                        y: t + f * v
                    };
                }
                function s(e, t, r, n, a) {
                    var i = n * e + a * t;
                    if (i < 0) return n * n + a * a;
                    if (i > r) {
                        var o = n - e, l = a - t;
                        return o * o + l * l;
                    }
                    var s = n * t - a * e;
                    return s * s / r;
                }
                t.segmentsIntersect = l, t.segmentDistance = function(e, t, r, n, a, i, o, c) {
                    if (l(e, t, r, n, a, i, o, c)) return 0;
                    var u = r - e, f = n - t, d = o - a, h = c - i, p = u * u + f * f, v = d * d + h * h, g = Math.min(s(u, f, p, a - e, i - t), s(u, f, p, o - e, c - t), s(d, h, v, e - a, t - i), s(d, h, v, r - a, n - i));
                    return Math.sqrt(g);
                }, t.getTextLocation = function(e, t, r, l) {
                    if (e === a && l === i || (n = {}, a = e, i = l), n[r]) return n[r];
                    var s = e.getPointAtLength(o(r - l / 2, t)), c = e.getPointAtLength(o(r + l / 2, t)), u = Math.atan((c.y - s.y) / (c.x - s.x)), f = e.getPointAtLength(o(r, t)), d = {
                        x: (4 * f.x + s.x + c.x) / 6,
                        y: (4 * f.y + s.y + c.y) / 6,
                        theta: u
                    };
                    return n[r] = d, d;
                }, t.clearLocationCache = function() {
                    a = null;
                }, t.getVisibleSegment = function(e, t, r) {
                    var n, a, i = t.left, o = t.right, l = t.top, s = t.bottom, c = 0, u = e.getTotalLength(), f = u;
                    function d(t) {
                        var r = e.getPointAtLength(t);
                        0 === t ? n = r : t === u && (a = r);
                        var c = r.x < i ? i - r.x : r.x > o ? r.x - o : 0, f = r.y < l ? l - r.y : r.y > s ? r.y - s : 0;
                        return Math.sqrt(c * c + f * f);
                    }
                    for(var h = d(c); h;){
                        if ((c += h + r) > f) return;
                        h = d(c);
                    }
                    for(h = d(f); h;){
                        if (c > (f -= h + r)) return;
                        h = d(f);
                    }
                    return {
                        min: c,
                        max: f,
                        len: f - c,
                        total: u,
                        isClosed: 0 === c && f === u && Math.abs(n.x - a.x) < .1 && Math.abs(n.y - a.y) < .1
                    };
                }, t.findPointOnPath = function(e, t, r, n) {
                    for(var a, i, o, l = (n = n || {}).pathLength || e.getTotalLength(), s = n.tolerance || .001, c = n.iterationLimit || 30, u = e.getPointAtLength(0)[r] > e.getPointAtLength(l)[r] ? -1 : 1, f = 0, d = 0, h = l; f < c;){
                        if (a = (d + h) / 2, o = (i = e.getPointAtLength(a))[r] - t, Math.abs(o) < s) return i;
                        u * o > 0 ? h = a : d = a, f++;
                    }
                    return i;
                };
            },
            3389: function(e) {
                "use strict";
                e.exports = function(e) {
                    return e;
                };
            },
            9240: function(e) {
                "use strict";
                e.exports = function(e, t) {
                    if (!t) return e;
                    var r = 1 / Math.abs(t), n = r > 1 ? (r * e + r * t) / r : e + t, a = String(n).length;
                    if (a > 16) {
                        var i = String(t).length;
                        if (a >= String(e).length + i) {
                            var o = parseFloat(n).toPrecision(12);
                            -1 === o.indexOf("e+") && (n = +o);
                        }
                    }
                    return n;
                };
            },
            1828: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(4096).g0, i = r(721).WU, o = r(2770), l = r(606), s = l.FP_SAFE, c = -s, u = l.BADNUM, f = e.exports = {};
                f.adjustFormat = function(e) {
                    return !e || /^\d[.]\df/.test(e) || /[.]\d%/.test(e) ? e : "0.f" === e ? "~f" : /^\d%/.test(e) ? "~%" : /^\ds/.test(e) ? "~s" : !/^[~,.0$]/.test(e) && /[&fps]/.test(e) ? "~" + e : e;
                };
                var d = {};
                f.warnBadFormat = function(e) {
                    var t = String(e);
                    d[t] || (d[t] = 1, f.warn('encountered bad format: "' + t + '"'));
                }, f.noFormat = function(e) {
                    return String(e);
                }, f.numberFormat = function(e) {
                    var t;
                    try {
                        t = i(f.adjustFormat(e));
                    } catch (t) {
                        return f.warnBadFormat(e), f.noFormat;
                    }
                    return t;
                }, f.nestedProperty = r(5487), f.keyedContainer = r(6636), f.relativeAttr = r(6962), f.isPlainObject = r(1965), f.toLogRange = r(8163), f.relinkPrivateKeys = r(1332);
                var h = r(3627);
                f.isTypedArray = h.isTypedArray, f.isArrayOrTypedArray = h.isArrayOrTypedArray, f.isArray1D = h.isArray1D, f.ensureArray = h.ensureArray, f.concat = h.concat, f.maxRowLength = h.maxRowLength, f.minRowLength = h.minRowLength;
                var p = r(4872);
                f.mod = p.mod, f.modHalf = p.modHalf;
                var v = r(6554);
                f.valObjectMeta = v.valObjectMeta, f.coerce = v.coerce, f.coerce2 = v.coerce2, f.coerceFont = v.coerceFont, f.coercePattern = v.coercePattern, f.coerceHoverinfo = v.coerceHoverinfo, f.coerceSelectionMarkerOpacity = v.coerceSelectionMarkerOpacity, f.validate = v.validate;
                var g = r(1631);
                f.dateTime2ms = g.dateTime2ms, f.isDateTime = g.isDateTime, f.ms2DateTime = g.ms2DateTime, f.ms2DateTimeLocal = g.ms2DateTimeLocal, f.cleanDate = g.cleanDate, f.isJSDate = g.isJSDate, f.formatDate = g.formatDate, f.incrementMonth = g.incrementMonth, f.dateTick0 = g.dateTick0, f.dfltRange = g.dfltRange, f.findExactDates = g.findExactDates, f.MIN_MS = g.MIN_MS, f.MAX_MS = g.MAX_MS;
                var y = r(5888);
                f.findBin = y.findBin, f.sorterAsc = y.sorterAsc, f.sorterDes = y.sorterDes, f.distinctVals = y.distinctVals, f.roundUp = y.roundUp, f.sort = y.sort, f.findIndexOfMin = y.findIndexOfMin, f.sortObjectKeys = r(8607);
                var m = r(38);
                f.aggNums = m.aggNums, f.len = m.len, f.mean = m.mean, f.median = m.median, f.midRange = m.midRange, f.variance = m.variance, f.stdev = m.stdev, f.interp = m.interp;
                var x = r(5657);
                f.init2dArray = x.init2dArray, f.transposeRagged = x.transposeRagged, f.dot = x.dot, f.translationMatrix = x.translationMatrix, f.rotationMatrix = x.rotationMatrix, f.rotationXYMatrix = x.rotationXYMatrix, f.apply3DTransform = x.apply3DTransform, f.apply2DTransform = x.apply2DTransform, f.apply2DTransform2 = x.apply2DTransform2, f.convertCssMatrix = x.convertCssMatrix, f.inverseTransformMatrix = x.inverseTransformMatrix;
                var b = r(6348);
                f.deg2rad = b.deg2rad, f.rad2deg = b.rad2deg, f.angleDelta = b.angleDelta, f.angleDist = b.angleDist, f.isFullCircle = b.isFullCircle, f.isAngleInsideSector = b.isAngleInsideSector, f.isPtInsideSector = b.isPtInsideSector, f.pathArc = b.pathArc, f.pathSector = b.pathSector, f.pathAnnulus = b.pathAnnulus;
                var _ = r(9863);
                f.isLeftAnchor = _.isLeftAnchor, f.isCenterAnchor = _.isCenterAnchor, f.isRightAnchor = _.isRightAnchor, f.isTopAnchor = _.isTopAnchor, f.isMiddleAnchor = _.isMiddleAnchor, f.isBottomAnchor = _.isBottomAnchor;
                var w = r(7642);
                f.segmentsIntersect = w.segmentsIntersect, f.segmentDistance = w.segmentDistance, f.getTextLocation = w.getTextLocation, f.clearLocationCache = w.clearLocationCache, f.getVisibleSegment = w.getVisibleSegment, f.findPointOnPath = w.findPointOnPath;
                var T = r(1426);
                f.extendFlat = T.extendFlat, f.extendDeep = T.extendDeep, f.extendDeepAll = T.extendDeepAll, f.extendDeepNoArrays = T.extendDeepNoArrays;
                var M = r(7769);
                f.log = M.log, f.warn = M.warn, f.error = M.error;
                var k = r(587);
                f.counterRegex = k.counter;
                var A = r(9990);
                f.throttle = A.throttle, f.throttleDone = A.done, f.clearThrottle = A.clear;
                var L = r(4401);
                function S(e) {
                    var t = {};
                    for(var r in e)for(var n = e[r], a = 0; a < n.length; a++)t[n[a]] = +r;
                    return t;
                }
                f.getGraphDiv = L.getGraphDiv, f.isPlotDiv = L.isPlotDiv, f.removeElement = L.removeElement, f.addStyleRule = L.addStyleRule, f.addRelatedStyleRule = L.addRelatedStyleRule, f.deleteRelatedStyleRule = L.deleteRelatedStyleRule, f.getFullTransformMatrix = L.getFullTransformMatrix, f.getElementTransformMatrix = L.getElementTransformMatrix, f.getElementAndAncestors = L.getElementAndAncestors, f.equalDomRects = L.equalDomRects, f.clearResponsive = r(6367), f.preserveDrawingBuffer = r(5142), f.makeTraceGroups = r(7310), f._ = r(5867), f.notifier = r(5046), f.filterUnique = r(5744), f.filterVisible = r(6756), f.pushUnique = r(5138), f.increment = r(9240), f.cleanNumber = r(5218), f.ensureNumber = function(e) {
                    return o(e) ? (e = Number(e)) > s || e < c ? u : e : u;
                }, f.isIndex = function(e, t) {
                    return !(void 0 !== t && e >= t) && o(e) && e >= 0 && e % 1 == 0;
                }, f.noop = r(4213), f.identity = r(3389), f.repeat = function(e, t) {
                    for(var r = new Array(t), n = 0; n < t; n++)r[n] = e;
                    return r;
                }, f.swapAttrs = function(e, t, r, n) {
                    r || (r = "x"), n || (n = "y");
                    for(var a = 0; a < t.length; a++){
                        var i = t[a], o = f.nestedProperty(e, i.replace("?", r)), l = f.nestedProperty(e, i.replace("?", n)), s = o.get();
                        o.set(l.get()), l.set(s);
                    }
                }, f.raiseToTop = function(e) {
                    e.parentNode.appendChild(e);
                }, f.cancelTransition = function(e) {
                    return e.transition().duration(0);
                }, f.constrain = function(e, t, r) {
                    return t > r ? Math.max(r, Math.min(t, e)) : Math.max(t, Math.min(r, e));
                }, f.bBoxIntersect = function(e, t, r) {
                    return r = r || 0, e.left <= t.right + r && t.left <= e.right + r && e.top <= t.bottom + r && t.top <= e.bottom + r;
                }, f.simpleMap = function(e, t, r, n, a) {
                    for(var i = e.length, o = new Array(i), l = 0; l < i; l++)o[l] = t(e[l], r, n, a);
                    return o;
                }, f.randstr = function e(t, r, n, a) {
                    if (n || (n = 16), void 0 === r && (r = 24), r <= 0) return "0";
                    var i, o, l = Math.log(Math.pow(2, r)) / Math.log(n), s = "";
                    for(i = 2; l === 1 / 0; i *= 2)l = Math.log(Math.pow(2, r / i)) / Math.log(n) * i;
                    var c = l - Math.floor(l);
                    for(i = 0; i < Math.floor(l); i++)s = Math.floor(Math.random() * n).toString(n) + s;
                    c && (o = Math.pow(n, c), s = Math.floor(Math.random() * o).toString(n) + s);
                    var u = parseInt(s, n);
                    return t && t[s] || u !== 1 / 0 && u >= Math.pow(2, r) ? a > 10 ? (f.warn("randstr failed uniqueness"), s) : e(t, r, n, (a || 0) + 1) : s;
                }, f.OptionControl = function(e, t) {
                    e || (e = {}), t || (t = "opt");
                    var r = {
                        optionList: [],
                        _newoption: function(n) {
                            n[t] = e, r[n.name] = n, r.optionList.push(n);
                        }
                    };
                    return r["_" + t] = e, r;
                }, f.smooth = function(e, t) {
                    if ((t = Math.round(t) || 0) < 2) return e;
                    var r, n, a, i, o = e.length, l = 2 * o, s = 2 * t - 1, c = new Array(s), u = new Array(o);
                    for(r = 0; r < s; r++)c[r] = (1 - Math.cos(Math.PI * (r + 1) / t)) / (2 * t);
                    for(r = 0; r < o; r++){
                        for(i = 0, n = 0; n < s; n++)(a = r + n + 1 - t) < -o ? a -= l * Math.round(a / l) : a >= l && (a -= l * Math.floor(a / l)), a < 0 ? a = -1 - a : a >= o && (a = l - 1 - a), i += e[a] * c[n];
                        u[r] = i;
                    }
                    return u;
                }, f.syncOrAsync = function(e, t, r) {
                    var n;
                    function a() {
                        return f.syncOrAsync(e, t, r);
                    }
                    for(; e.length;)if ((n = (0, e.splice(0, 1)[0])(t)) && n.then) return n.then(a);
                    return r && r(t);
                }, f.stripTrailingSlash = function(e) {
                    return "/" === e.substr(-1) ? e.substr(0, e.length - 1) : e;
                }, f.noneOrAll = function(e, t, r) {
                    if (e) {
                        var n, a = !1, i = !0;
                        for(n = 0; n < r.length; n++)null != e[r[n]] ? a = !0 : i = !1;
                        if (a && !i) for(n = 0; n < r.length; n++)e[r[n]] = t[r[n]];
                    }
                }, f.mergeArray = function(e, t, r, n) {
                    var a = "function" == typeof n;
                    if (f.isArrayOrTypedArray(e)) for(var i = Math.min(e.length, t.length), o = 0; o < i; o++){
                        var l = e[o];
                        t[o][r] = a ? n(l) : l;
                    }
                }, f.mergeArrayCastPositive = function(e, t, r) {
                    return f.mergeArray(e, t, r, function(e) {
                        var t = +e;
                        return isFinite(t) && t > 0 ? t : 0;
                    });
                }, f.fillArray = function(e, t, r, n) {
                    if (n = n || f.identity, f.isArrayOrTypedArray(e)) for(var a = 0; a < t.length; a++)t[a][r] = n(e[a]);
                }, f.castOption = function(e, t, r, n) {
                    n = n || f.identity;
                    var a = f.nestedProperty(e, r).get();
                    return f.isArrayOrTypedArray(a) ? Array.isArray(t) && f.isArrayOrTypedArray(a[t[0]]) ? n(a[t[0]][t[1]]) : n(a[t]) : a;
                }, f.extractOption = function(e, t, r, n) {
                    if (r in e) return e[r];
                    var a = f.nestedProperty(t, n).get();
                    return Array.isArray(a) ? void 0 : a;
                }, f.tagSelected = function(e, t, r) {
                    var n, a, i = t.selectedpoints, o = t._indexToPoints;
                    o && (n = S(o));
                    for(var l = 0; l < i.length; l++){
                        var s = i[l];
                        if (f.isIndex(s) || f.isArrayOrTypedArray(s) && f.isIndex(s[0]) && f.isIndex(s[1])) {
                            var c = n ? n[s] : s, u = r ? r[c] : c;
                            void 0 !== (a = u) && a < e.length && (e[u].selected = 1);
                        }
                    }
                }, f.selIndices2selPoints = function(e) {
                    var t = e.selectedpoints, r = e._indexToPoints;
                    if (r) {
                        for(var n = S(r), a = [], i = 0; i < t.length; i++){
                            var o = t[i];
                            if (f.isIndex(o)) {
                                var l = n[o];
                                f.isIndex(l) && a.push(l);
                            }
                        }
                        return a;
                    }
                    return t;
                }, f.getTargetArray = function(e, t) {
                    var r = t.target;
                    if ("string" == typeof r && r) {
                        var n = f.nestedProperty(e, r).get();
                        return !!Array.isArray(n) && n;
                    }
                    return !!Array.isArray(r) && r;
                }, f.minExtend = function e(t, r, n) {
                    var a = {};
                    "object" != typeof r && (r = {});
                    var i, o, l, s = "pieLike" === n ? -1 : 3, c = Object.keys(t);
                    for(i = 0; i < c.length; i++)l = t[o = c[i]], "_" !== o.charAt(0) && "function" != typeof l && ("module" === o ? a[o] = l : Array.isArray(l) ? a[o] = "colorscale" === o || -1 === s ? l.slice() : l.slice(0, s) : f.isTypedArray(l) ? a[o] = -1 === s ? l.subarray() : l.subarray(0, s) : a[o] = l && "object" == typeof l ? e(t[o], r[o], n) : l);
                    for(c = Object.keys(r), i = 0; i < c.length; i++)"object" == typeof (l = r[o = c[i]]) && o in a && "object" == typeof a[o] || (a[o] = l);
                    return a;
                }, f.titleCase = function(e) {
                    return e.charAt(0).toUpperCase() + e.substr(1);
                }, f.containsAny = function(e, t) {
                    for(var r = 0; r < t.length; r++)if (-1 !== e.indexOf(t[r])) return !0;
                    return !1;
                }, f.isIE = function() {
                    return void 0 !== window.navigator.msSaveBlob;
                };
                var D = /Version\/[\d\.]+.*Safari/;
                f.isSafari = function() {
                    return D.test(window.navigator.userAgent);
                };
                var O = /iPad|iPhone|iPod/;
                f.isIOS = function() {
                    return O.test(window.navigator.userAgent);
                };
                var C = /Firefox\/(\d+)\.\d+/;
                f.getFirefoxVersion = function() {
                    var e = C.exec(window.navigator.userAgent);
                    if (e && 2 === e.length) {
                        var t = parseInt(e[1]);
                        if (!isNaN(t)) return t;
                    }
                    return null;
                }, f.isD3Selection = function(e) {
                    return e instanceof n.selection;
                }, f.ensureSingle = function(e, t, r, n) {
                    var a = e.select(t + (r ? "." + r : ""));
                    if (a.size()) return a;
                    var i = e.append(t);
                    return r && i.classed(r, !0), n && i.call(n), i;
                }, f.ensureSingleById = function(e, t, r, n) {
                    var a = e.select(t + "#" + r);
                    if (a.size()) return a;
                    var i = e.append(t).attr("id", r);
                    return n && i.call(n), i;
                }, f.objectFromPath = function(e, t) {
                    for(var r, n = e.split("."), a = r = {}, i = 0; i < n.length; i++){
                        var o = n[i], l = null, s = n[i].match(/(.*)\[([0-9]+)\]/);
                        s ? (o = s[1], l = s[2], r = r[o] = [], i === n.length - 1 ? r[l] = t : r[l] = {}, r = r[l]) : (i === n.length - 1 ? r[o] = t : r[o] = {}, r = r[o]);
                    }
                    return a;
                };
                var P = /^([^\[\.]+)\.(.+)?/, I = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
                function R(e) {
                    return "__" === e.slice(0, 2);
                }
                f.expandObjectPaths = function(e) {
                    var t, r, n, a, i, o, l;
                    if ("object" == typeof e && !Array.isArray(e)) {
                        for(r in e)if (e.hasOwnProperty(r)) {
                            if (t = r.match(P)) {
                                if (a = e[r], R(n = t[1])) continue;
                                delete e[r], e[n] = f.extendDeepNoArrays(e[n] || {}, f.objectFromPath(r, f.expandObjectPaths(a))[n]);
                            } else if (t = r.match(I)) {
                                if (a = e[r], R(n = t[1])) continue;
                                if (i = parseInt(t[2]), delete e[r], e[n] = e[n] || [], "." === t[3]) l = t[4], o = e[n][i] = e[n][i] || {}, f.extendDeepNoArrays(o, f.objectFromPath(l, f.expandObjectPaths(a)));
                                else {
                                    if (R(n)) continue;
                                    e[n][i] = f.expandObjectPaths(a);
                                }
                            } else {
                                if (R(r)) continue;
                                e[r] = f.expandObjectPaths(e[r]);
                            }
                        }
                    }
                    return e;
                }, f.numSeparate = function(e, t, r) {
                    if (r || (r = !1), "string" != typeof t || 0 === t.length) throw new Error("Separator string required for formatting!");
                    "number" == typeof e && (e = String(e));
                    var n = /(\d+)(\d{3})/, a = t.charAt(0), i = t.charAt(1), o = e.split("."), l = o[0], s = o.length > 1 ? a + o[1] : "";
                    if (i && (o.length > 1 || l.length > 4 || r)) for(; n.test(l);)l = l.replace(n, "$1" + i + "$2");
                    return l + s;
                }, f.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
                var z = /^\w*$/;
                f.templateString = function(e, t) {
                    var r = {};
                    return e.replace(f.TEMPLATE_STRING_REGEX, function(e, n) {
                        var a;
                        return z.test(n) ? a = t[n] : (r[n] = r[n] || f.nestedProperty(t, n).get, a = r[n]()), f.isValidTextValue(a) ? a : "";
                    });
                };
                var N = {
                    max: 10,
                    count: 0,
                    name: "hovertemplate"
                };
                f.hovertemplateString = function() {
                    return B.apply(N, arguments);
                };
                var F = {
                    max: 10,
                    count: 0,
                    name: "texttemplate"
                };
                f.texttemplateString = function() {
                    return B.apply(F, arguments);
                };
                var E = /^(\S+)([\*\/])(-?\d+(\.\d+)?)$/, H = {
                    max: 10,
                    count: 0,
                    name: "texttemplate",
                    parseMultDiv: !0
                };
                f.texttemplateStringForShapes = function() {
                    return B.apply(H, arguments);
                };
                var j = /^[:|\|]/;
                function B(e, t, r) {
                    var n = this, i = arguments;
                    t || (t = {});
                    var o = {};
                    return e.replace(f.TEMPLATE_STRING_REGEX, function(e, l, s) {
                        var c = "_xother" === l || "_yother" === l, u = "_xother_" === l || "_yother_" === l, d = "xother_" === l || "yother_" === l, h = "xother" === l || "yother" === l || c || d || u, p = l;
                        (c || u) && (p = p.substring(1)), (d || u) && (p = p.substring(0, p.length - 1));
                        var v, g, y, m = null, x = null;
                        if (n.parseMultDiv) {
                            var b = function(e) {
                                var t = e.match(E);
                                return t ? {
                                    key: t[1],
                                    op: t[2],
                                    number: Number(t[3])
                                } : {
                                    key: e,
                                    op: null,
                                    number: null
                                };
                            }(p);
                            p = b.key, m = b.op, x = b.number;
                        }
                        if (h) {
                            if (void 0 === (v = t[p])) return "";
                        } else for(y = 3; y < i.length; y++)if (g = i[y]) {
                            if (g.hasOwnProperty(p)) {
                                v = g[p];
                                break;
                            }
                            if (z.test(p) || (v = f.nestedProperty(g, p).get(), (v = o[p] || f.nestedProperty(g, p).get()) && (o[p] = v)), void 0 !== v) break;
                        }
                        if (void 0 !== v && ("*" === m && (v *= x), "/" === m && (v /= x)), void 0 === v && n) return n.count < n.max && (f.warn("Variable '" + p + "' in " + n.name + " could not be found!"), v = e), n.count === n.max && f.warn("Too many " + n.name + " warnings - additional warnings will be suppressed"), n.count++, e;
                        if (s) {
                            var _;
                            if (":" === s[0] && (v = (_ = r ? r.numberFormat : f.numberFormat)(s.replace(j, ""))(v)), "|" === s[0]) {
                                _ = r ? r.timeFormat : a;
                                var w = f.dateTime2ms(v);
                                v = f.formatDate(w, s.replace(j, ""), !1, _);
                            }
                        } else {
                            var T = p + "Label";
                            t.hasOwnProperty(T) && (v = t[T]);
                        }
                        return h && (v = "(" + v + ")", (c || u) && (v = " " + v), (d || u) && (v += " ")), v;
                    });
                }
                f.subplotSort = function(e, t) {
                    for(var r = Math.min(e.length, t.length) + 1, n = 0, a = 0, i = 0; i < r; i++){
                        var o = e.charCodeAt(i) || 0, l = t.charCodeAt(i) || 0, s = o >= 48 && o <= 57, c = l >= 48 && l <= 57;
                        if (s && (n = 10 * n + o - 48), c && (a = 10 * a + l - 48), !s || !c) {
                            if (n !== a) return n - a;
                            if (o !== l) return o - l;
                        }
                    }
                    return a - n;
                };
                var Y = 2e9;
                f.seedPseudoRandom = function() {
                    Y = 2e9;
                }, f.pseudoRandom = function() {
                    var e = Y;
                    return Y = (69069 * Y + 1) % 4294967296, Math.abs(Y - e) < 429496729 ? f.pseudoRandom() : Y / 4294967296;
                }, f.fillText = function(e, t, r) {
                    var n = Array.isArray(r) ? function(e) {
                        r.push(e);
                    } : function(e) {
                        r.text = e;
                    }, a = f.extractOption(e, t, "htx", "hovertext");
                    if (f.isValidTextValue(a)) return n(a);
                    var i = f.extractOption(e, t, "tx", "text");
                    return f.isValidTextValue(i) ? n(i) : void 0;
                }, f.isValidTextValue = function(e) {
                    return e || 0 === e;
                }, f.formatPercent = function(e, t) {
                    t = t || 0;
                    for(var r = (Math.round(100 * e * Math.pow(10, t)) * Math.pow(.1, t)).toFixed(t) + "%", n = 0; n < t; n++)-1 !== r.indexOf(".") && (r = (r = r.replace("0%", "%")).replace(".%", "%"));
                    return r;
                }, f.isHidden = function(e) {
                    var t = window.getComputedStyle(e).display;
                    return !t || "none" === t;
                }, f.strTranslate = function(e, t) {
                    return e || t ? "translate(" + e + "," + t + ")" : "";
                }, f.strRotate = function(e) {
                    return e ? "rotate(" + e + ")" : "";
                }, f.strScale = function(e) {
                    return 1 !== e ? "scale(" + e + ")" : "";
                }, f.getTextTransform = function(e) {
                    var t = e.noCenter, r = e.textX, n = e.textY, a = e.targetX, i = e.targetY, o = e.anchorX || 0, l = e.anchorY || 0, s = e.rotate, c = e.scale;
                    return c ? c > 1 && (c = 1) : c = 0, f.strTranslate(a - c * (r + o), i - c * (n + l)) + f.strScale(c) + (s ? "rotate(" + s + (t ? "" : " " + r + " " + n) + ")" : "");
                }, f.setTransormAndDisplay = function(e, t) {
                    e.attr("transform", f.getTextTransform(t)), e.style("display", t.scale ? null : "none");
                }, f.ensureUniformFontSize = function(e, t) {
                    var r = f.extendFlat({}, t);
                    return r.size = Math.max(t.size, e._fullLayout.uniformtext.minsize || 0), r;
                }, f.join2 = function(e, t, r) {
                    var n = e.length;
                    return n > 1 ? e.slice(0, -1).join(t) + r + e[n - 1] : e.join(t);
                }, f.bigFont = function(e) {
                    return Math.round(1.2 * e);
                };
                var V = f.getFirefoxVersion(), U = null !== V && V < 86;
                f.getPositionFromD3Event = function() {
                    return U ? [
                        n.event.layerX,
                        n.event.layerY
                    ] : [
                        n.event.offsetX,
                        n.event.offsetY
                    ];
                };
            },
            1965: function(e) {
                "use strict";
                e.exports = function(e) {
                    return window && window.process && window.process.versions ? "[object Object]" === Object.prototype.toString.call(e) : "[object Object]" === Object.prototype.toString.call(e) && Object.getPrototypeOf(e).hasOwnProperty("hasOwnProperty");
                };
            },
            6636: function(e, t, r) {
                "use strict";
                var n = r(5487), a = /^\w*$/;
                e.exports = function(e, t, r, i) {
                    var o, l, s;
                    r = r || "name", i = i || "value";
                    var c = {};
                    t && t.length ? (s = n(e, t), l = s.get()) : l = e, t = t || "";
                    var u = {};
                    if (l) for(o = 0; o < l.length; o++)u[l[o][r]] = o;
                    var f = a.test(i), d = {
                        set: function(e, t) {
                            var a = null === t ? 4 : 0;
                            if (!l) {
                                if (!s || 4 === a) return;
                                l = [], s.set(l);
                            }
                            var o = u[e];
                            if (void 0 === o) {
                                if (4 === a) return;
                                a |= 3, o = l.length, u[e] = o;
                            } else t !== (f ? l[o][i] : n(l[o], i).get()) && (a |= 2);
                            var h = l[o] = l[o] || {};
                            return h[r] = e, f ? h[i] = t : n(h, i).set(t), null !== t && (a &= -5), c[o] = c[o] | a, d;
                        },
                        get: function(e) {
                            if (l) {
                                var t = u[e];
                                return void 0 === t ? void 0 : f ? l[t][i] : n(l[t], i).get();
                            }
                        },
                        rename: function(e, t) {
                            var n = u[e];
                            return void 0 === n || (c[n] = 1 | c[n], u[t] = n, delete u[e], l[n][r] = t), d;
                        },
                        remove: function(e) {
                            var t = u[e];
                            if (void 0 === t) return d;
                            var a = l[t];
                            if (Object.keys(a).length > 2) return c[t] = 2 | c[t], d.set(e, null);
                            if (f) {
                                for(o = t; o < l.length; o++)c[o] = 3 | c[o];
                                for(o = t; o < l.length; o++)u[l[o][r]]--;
                                l.splice(t, 1), delete u[e];
                            } else n(a, i).set(null), c[t] = 6 | c[t];
                            return d;
                        },
                        constructUpdate: function() {
                            for(var e, a, o = {}, s = Object.keys(c), u = 0; u < s.length; u++)a = s[u], e = t + "[" + a + "]", l[a] ? (1 & c[a] && (o[e + "." + r] = l[a][r]), 2 & c[a] && (o[e + "." + i] = f ? 4 & c[a] ? null : l[a][i] : 4 & c[a] ? null : n(l[a], i).get())) : o[e] = null;
                            return o;
                        }
                    };
                    return d;
                };
            },
            5867: function(e, t, r) {
                "use strict";
                var n = r(3972);
                e.exports = function(e, t) {
                    for(var r = e._context.locale, a = 0; a < 2; a++){
                        for(var i = e._context.locales, o = 0; o < 2; o++){
                            var l = (i[r] || {}).dictionary;
                            if (l) {
                                var s = l[t];
                                if (s) return s;
                            }
                            i = n.localeRegistry;
                        }
                        var c = r.split("-")[0];
                        if (c === r) break;
                        r = c;
                    }
                    return t;
                };
            },
            7769: function(e, t, r) {
                "use strict";
                var n = r(2075).dfltConfig, a = r(5046), i = e.exports = {};
                i.log = function() {
                    var e;
                    if (n.logging > 1) {
                        var t = [
                            "LOG:"
                        ];
                        for(e = 0; e < arguments.length; e++)t.push(arguments[e]);
                        console.trace.apply(console, t);
                    }
                    if (n.notifyOnLogging > 1) {
                        var r = [];
                        for(e = 0; e < arguments.length; e++)r.push(arguments[e]);
                        a(r.join("<br>"), "long");
                    }
                }, i.warn = function() {
                    var e;
                    if (n.logging > 0) {
                        var t = [
                            "WARN:"
                        ];
                        for(e = 0; e < arguments.length; e++)t.push(arguments[e]);
                        console.trace.apply(console, t);
                    }
                    if (n.notifyOnLogging > 0) {
                        var r = [];
                        for(e = 0; e < arguments.length; e++)r.push(arguments[e]);
                        a(r.join("<br>"), "stick");
                    }
                }, i.error = function() {
                    var e;
                    if (n.logging > 0) {
                        var t = [
                            "ERROR:"
                        ];
                        for(e = 0; e < arguments.length; e++)t.push(arguments[e]);
                        console.error.apply(console, t);
                    }
                    if (n.notifyOnLogging > 0) {
                        var r = [];
                        for(e = 0; e < arguments.length; e++)r.push(arguments[e]);
                        a(r.join("<br>"), "stick");
                    }
                };
            },
            7310: function(e, t, r) {
                "use strict";
                var n = r(9898);
                e.exports = function(e, t, r) {
                    var a = e.selectAll("g." + r.replace(/\s/g, ".")).data(t, function(e) {
                        return e[0].trace.uid;
                    });
                    a.exit().remove(), a.enter().append("g").attr("class", r), a.order();
                    var i = e.classed("rangeplot") ? "nodeRangePlot3" : "node3";
                    return a.each(function(e) {
                        e[0][i] = n.select(this);
                    }), a;
                };
            },
            5657: function(e, t, r) {
                "use strict";
                var n = r(9576);
                t.init2dArray = function(e, t) {
                    for(var r = new Array(e), n = 0; n < e; n++)r[n] = new Array(t);
                    return r;
                }, t.transposeRagged = function(e) {
                    var t, r, n = 0, a = e.length;
                    for(t = 0; t < a; t++)n = Math.max(n, e[t].length);
                    var i = new Array(n);
                    for(t = 0; t < n; t++)for(i[t] = new Array(a), r = 0; r < a; r++)i[t][r] = e[r][t];
                    return i;
                }, t.dot = function(e, r) {
                    if (!e.length || !r.length || e.length !== r.length) return null;
                    var n, a, i = e.length;
                    if (e[0].length) for(n = new Array(i), a = 0; a < i; a++)n[a] = t.dot(e[a], r);
                    else if (r[0].length) {
                        var o = t.transposeRagged(r);
                        for(n = new Array(o.length), a = 0; a < o.length; a++)n[a] = t.dot(e, o[a]);
                    } else for(n = 0, a = 0; a < i; a++)n += e[a] * r[a];
                    return n;
                }, t.translationMatrix = function(e, t) {
                    return [
                        [
                            1,
                            0,
                            e
                        ],
                        [
                            0,
                            1,
                            t
                        ],
                        [
                            0,
                            0,
                            1
                        ]
                    ];
                }, t.rotationMatrix = function(e) {
                    var t = e * Math.PI / 180;
                    return [
                        [
                            Math.cos(t),
                            -Math.sin(t),
                            0
                        ],
                        [
                            Math.sin(t),
                            Math.cos(t),
                            0
                        ],
                        [
                            0,
                            0,
                            1
                        ]
                    ];
                }, t.rotationXYMatrix = function(e, r, n) {
                    return t.dot(t.dot(t.translationMatrix(r, n), t.rotationMatrix(e)), t.translationMatrix(-r, -n));
                }, t.apply3DTransform = function(e) {
                    return function() {
                        var r = arguments, n = 1 === arguments.length ? r[0] : [
                            r[0],
                            r[1],
                            r[2] || 0
                        ];
                        return t.dot(e, [
                            n[0],
                            n[1],
                            n[2],
                            1
                        ]).slice(0, 3);
                    };
                }, t.apply2DTransform = function(e) {
                    return function() {
                        var r = arguments;
                        3 === r.length && (r = r[0]);
                        var n = 1 === arguments.length ? r[0] : [
                            r[0],
                            r[1]
                        ];
                        return t.dot(e, [
                            n[0],
                            n[1],
                            1
                        ]).slice(0, 2);
                    };
                }, t.apply2DTransform2 = function(e) {
                    var r = t.apply2DTransform(e);
                    return function(e) {
                        return r(e.slice(0, 2)).concat(r(e.slice(2, 4)));
                    };
                }, t.convertCssMatrix = function(e) {
                    if (e) {
                        var t = e.length;
                        if (16 === t) return e;
                        if (6 === t) return [
                            e[0],
                            e[1],
                            0,
                            0,
                            e[2],
                            e[3],
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            e[4],
                            e[5],
                            0,
                            1
                        ];
                    }
                    return [
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ];
                }, t.inverseTransformMatrix = function(e) {
                    var t = [];
                    return n.invert(t, e), [
                        [
                            t[0],
                            t[1],
                            t[2],
                            t[3]
                        ],
                        [
                            t[4],
                            t[5],
                            t[6],
                            t[7]
                        ],
                        [
                            t[8],
                            t[9],
                            t[10],
                            t[11]
                        ],
                        [
                            t[12],
                            t[13],
                            t[14],
                            t[15]
                        ]
                    ];
                };
            },
            4872: function(e) {
                "use strict";
                e.exports = {
                    mod: function(e, t) {
                        var r = e % t;
                        return r < 0 ? r + t : r;
                    },
                    modHalf: function(e, t) {
                        return Math.abs(e) > t / 2 ? e - Math.round(e / t) * t : e;
                    }
                };
            },
            5487: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(3627).isArrayOrTypedArray;
                function i(e, t) {
                    return function() {
                        var r, n, o, l, s, c = e;
                        for(l = 0; l < t.length - 1; l++){
                            if (-1 === (r = t[l])) {
                                for(n = !0, o = [], s = 0; s < c.length; s++)o[s] = i(c[s], t.slice(l + 1))(), o[s] !== o[0] && (n = !1);
                                return n ? o[0] : o;
                            }
                            if ("number" == typeof r && !a(c)) return;
                            if ("object" != typeof (c = c[r]) || null === c) return;
                        }
                        if ("object" == typeof c && null !== c && null !== (o = c[t[l]])) return o;
                    };
                }
                e.exports = function(e, t) {
                    if (n(t)) t = String(t);
                    else if ("string" != typeof t || "[-1]" === t.substr(t.length - 4)) throw "bad property string";
                    var r, a, o, l, c = t.split(".");
                    for(l = 0; l < c.length; l++)if ("__" === String(c[l]).slice(0, 2)) throw "bad property string";
                    for(l = 0; l < c.length;){
                        if (r = String(c[l]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/)) {
                            if (r[1]) c[l] = r[1];
                            else {
                                if (0 !== l) throw "bad property string";
                                c.splice(0, 1);
                            }
                            for(a = r[2].substr(1, r[2].length - 2).split("]["), o = 0; o < a.length; o++)l++, c.splice(l, 0, Number(a[o]));
                        }
                        l++;
                    }
                    return "object" != typeof e ? function(e, t, r) {
                        return {
                            set: function() {
                                throw "bad container";
                            },
                            get: function() {},
                            astr: t,
                            parts: r,
                            obj: e
                        };
                    }(e, t, c) : {
                        set: s(e, c, t),
                        get: i(e, c),
                        astr: t,
                        parts: c,
                        obj: e
                    };
                };
                var o = /(^|\.)args\[/;
                function l(e, t) {
                    return void 0 === e || null === e && !t.match(o);
                }
                function s(e, t, r) {
                    return function(n) {
                        var i, o, s = e, d = "", h = [
                            [
                                e,
                                d
                            ]
                        ], p = l(n, r);
                        for(o = 0; o < t.length - 1; o++){
                            if ("number" == typeof (i = t[o]) && !a(s)) throw "array index but container is not an array";
                            if (-1 === i) {
                                if (p = !u(s, t.slice(o + 1), n, r)) break;
                                return;
                            }
                            if (!f(s, i, t[o + 1], p)) break;
                            if ("object" != typeof (s = s[i]) || null === s) throw "container is not an object";
                            d = c(d, i), h.push([
                                s,
                                d
                            ]);
                        }
                        if (p) {
                            if (o === t.length - 1 && (delete s[t[o]], Array.isArray(s) && +t[o] == s.length - 1)) for(; s.length && void 0 === s[s.length - 1];)s.pop();
                        } else s[t[o]] = n;
                    };
                }
                function c(e, t) {
                    var r = t;
                    return n(t) ? r = "[" + t + "]" : e && (r = "." + t), e + r;
                }
                function u(e, t, r, n) {
                    var i, o = a(r), c = !0, u = r, d = n.replace("-1", 0), h = !o && l(r, d), p = t[0];
                    for(i = 0; i < e.length; i++)d = n.replace("-1", i), o && (h = l(u = r[i % r.length], d)), h && (c = !1), f(e, i, p, h) && s(e[i], t, n.replace("-1", i))(u);
                    return c;
                }
                function f(e, t, r, n) {
                    if (void 0 === e[t]) {
                        if (n) return !1;
                        e[t] = "number" == typeof r ? [] : {};
                    }
                    return !0;
                }
            },
            4213: function(e) {
                "use strict";
                e.exports = function() {};
            },
            5046: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(2770), i = [];
                e.exports = function(e, t) {
                    if (-1 === i.indexOf(e)) {
                        i.push(e);
                        var r = 1e3;
                        a(t) ? r = t : "long" === t && (r = 3e3);
                        var o = n.select("body").selectAll(".plotly-notifier").data([
                            0
                        ]);
                        o.enter().append("div").classed("plotly-notifier", !0), o.selectAll(".notifier-note").data(i).enter().append("div").classed("notifier-note", !0).style("opacity", 0).each(function(e) {
                            var a = n.select(this);
                            a.append("button").classed("notifier-close", !0).html("&times;").on("click", function() {
                                a.transition().call(l);
                            });
                            for(var i = a.append("p"), o = e.split(/<br\s*\/?>/g), s = 0; s < o.length; s++)s && i.append("br"), i.append("span").text(o[s]);
                            "stick" === t ? a.transition().duration(350).style("opacity", 1) : a.transition().duration(700).style("opacity", 1).transition().delay(r).call(l);
                        });
                    }
                    function l(e) {
                        e.duration(700).style("opacity", 0).each("end", function(e) {
                            var t = i.indexOf(e);
                            -1 !== t && i.splice(t, 1), n.select(this).remove();
                        });
                    }
                };
            },
            9918: function(e, t, r) {
                "use strict";
                var n = r(6964), a = "data-savedcursor";
                e.exports = function(e, t) {
                    var r = e.attr(a);
                    if (t) {
                        if (!r) {
                            for(var i = (e.attr("class") || "").split(" "), o = 0; o < i.length; o++){
                                var l = i[o];
                                0 === l.indexOf("cursor-") && e.attr(a, l.substr(7)).classed(l, !1);
                            }
                            e.attr(a) || e.attr(a, "!!");
                        }
                        n(e, t);
                    } else r && (e.attr(a, null), "!!" === r ? n(e) : n(e, r));
                };
            },
            1082: function(e, t, r) {
                "use strict";
                var n = r(5657).dot, a = r(606).BADNUM, i = e.exports = {};
                i.tester = function(e) {
                    var t, r = e.slice(), n = r[0][0], i = n, o = r[0][1], l = o;
                    for(r[r.length - 1][0] === r[0][0] && r[r.length - 1][1] === r[0][1] || r.push(r[0]), t = 1; t < r.length; t++)n = Math.min(n, r[t][0]), i = Math.max(i, r[t][0]), o = Math.min(o, r[t][1]), l = Math.max(l, r[t][1]);
                    var s, c = !1;
                    5 === r.length && (r[0][0] === r[1][0] ? r[2][0] === r[3][0] && r[0][1] === r[3][1] && r[1][1] === r[2][1] && (c = !0, s = function(e) {
                        return e[0] === r[0][0];
                    }) : r[0][1] === r[1][1] && r[2][1] === r[3][1] && r[0][0] === r[3][0] && r[1][0] === r[2][0] && (c = !0, s = function(e) {
                        return e[1] === r[0][1];
                    }));
                    var u = !0, f = r[0];
                    for(t = 1; t < r.length; t++)if (f[0] !== r[t][0] || f[1] !== r[t][1]) {
                        u = !1;
                        break;
                    }
                    return {
                        xmin: n,
                        xmax: i,
                        ymin: o,
                        ymax: l,
                        pts: r,
                        contains: c ? function(e, t) {
                            var r = e[0], c = e[1];
                            return !(r === a || r < n || r > i || c === a || c < o || c > l || t && s(e));
                        } : function(e, t) {
                            var s = e[0], c = e[1];
                            if (s === a || s < n || s > i || c === a || c < o || c > l) return !1;
                            var u, f, d, h, p, v = r.length, g = r[0][0], y = r[0][1], m = 0;
                            for(u = 1; u < v; u++)if (f = g, d = y, g = r[u][0], y = r[u][1], !(s < (h = Math.min(f, g)) || s > Math.max(f, g) || c > Math.max(d, y))) {
                                if (c < Math.min(d, y)) s !== h && m++;
                                else {
                                    if (c === (p = g === f ? c : d + (s - f) * (y - d) / (g - f))) return 1 !== u || !t;
                                    c <= p && s !== h && m++;
                                }
                            }
                            return m % 2 == 1;
                        },
                        isRect: c,
                        degenerate: u
                    };
                }, i.isSegmentBent = function(e, t, r, a) {
                    var i, o, l, s = e[t], c = [
                        e[r][0] - s[0],
                        e[r][1] - s[1]
                    ], u = n(c, c), f = Math.sqrt(u), d = [
                        -c[1] / f,
                        c[0] / f
                    ];
                    for(i = t + 1; i < r; i++)if (o = [
                        e[i][0] - s[0],
                        e[i][1] - s[1]
                    ], (l = n(o, c)) < 0 || l > u || Math.abs(n(o, d)) > a) return !0;
                    return !1;
                }, i.filter = function(e, t) {
                    var r = [
                        e[0]
                    ], n = 0, a = 0;
                    function o(o) {
                        e.push(o);
                        var l = r.length, s = n;
                        r.splice(a + 1);
                        for(var c = s + 1; c < e.length; c++)(c === e.length - 1 || i.isSegmentBent(e, s, c + 1, t)) && (r.push(e[c]), r.length < l - 2 && (n = c, a = r.length - 1), s = c);
                    }
                    return e.length > 1 && o(e.pop()), {
                        addPt: o,
                        raw: e,
                        filtered: r
                    };
                };
            },
            5142: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(5791);
                e.exports = function(e) {
                    var t;
                    if ("string" != typeof (t = e && e.hasOwnProperty("userAgent") ? e.userAgent : function() {
                        var e;
                        return "undefined" != typeof navigator && (e = navigator.userAgent), e && e.headers && "string" == typeof e.headers["user-agent"] && (e = e.headers["user-agent"]), e;
                    }())) return !0;
                    var r = a({
                        ua: {
                            headers: {
                                "user-agent": t
                            }
                        },
                        tablet: !0,
                        featureDetect: !1
                    });
                    if (!r) {
                        for(var i = t.split(" "), o = 1; o < i.length; o++)if (-1 !== i[o].indexOf("Safari")) for(var l = o - 1; l > -1; l--){
                            var s = i[l];
                            if ("Version/" === s.substr(0, 8)) {
                                var c = s.substr(8).split(".")[0];
                                if (n(c) && (c = +c), c >= 13) return !0;
                            }
                        }
                    }
                    return r;
                };
            },
            5138: function(e) {
                "use strict";
                e.exports = function(e, t) {
                    if (t instanceof RegExp) {
                        for(var r = t.toString(), n = 0; n < e.length; n++)if (e[n] instanceof RegExp && e[n].toString() === r) return e;
                        e.push(t);
                    } else !t && 0 !== t || -1 !== e.indexOf(t) || e.push(t);
                    return e;
                };
            },
            847: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(2075).dfltConfig, i = {
                    add: function(e, t, r, n, i) {
                        var o, l;
                        e.undoQueue = e.undoQueue || {
                            index: 0,
                            queue: [],
                            sequence: !1
                        }, l = e.undoQueue.index, e.autoplay ? e.undoQueue.inSequence || (e.autoplay = !1) : (!e.undoQueue.sequence || e.undoQueue.beginSequence ? (o = {
                            undo: {
                                calls: [],
                                args: []
                            },
                            redo: {
                                calls: [],
                                args: []
                            }
                        }, e.undoQueue.queue.splice(l, e.undoQueue.queue.length - l, o), e.undoQueue.index += 1) : o = e.undoQueue.queue[l - 1], e.undoQueue.beginSequence = !1, o && (o.undo.calls.unshift(t), o.undo.args.unshift(r), o.redo.calls.push(n), o.redo.args.push(i)), e.undoQueue.queue.length > a.queueLength && (e.undoQueue.queue.shift(), e.undoQueue.index--));
                    },
                    startSequence: function(e) {
                        e.undoQueue = e.undoQueue || {
                            index: 0,
                            queue: [],
                            sequence: !1
                        }, e.undoQueue.sequence = !0, e.undoQueue.beginSequence = !0;
                    },
                    stopSequence: function(e) {
                        e.undoQueue = e.undoQueue || {
                            index: 0,
                            queue: [],
                            sequence: !1
                        }, e.undoQueue.sequence = !1, e.undoQueue.beginSequence = !1;
                    },
                    undo: function(e) {
                        var t, r;
                        if (!(void 0 === e.undoQueue || isNaN(e.undoQueue.index) || e.undoQueue.index <= 0)) {
                            for(e.undoQueue.index--, t = e.undoQueue.queue[e.undoQueue.index], e.undoQueue.inSequence = !0, r = 0; r < t.undo.calls.length; r++)i.plotDo(e, t.undo.calls[r], t.undo.args[r]);
                            e.undoQueue.inSequence = !1, e.autoplay = !1;
                        }
                    },
                    redo: function(e) {
                        var t, r;
                        if (!(void 0 === e.undoQueue || isNaN(e.undoQueue.index) || e.undoQueue.index >= e.undoQueue.queue.length)) {
                            for(t = e.undoQueue.queue[e.undoQueue.index], e.undoQueue.inSequence = !0, r = 0; r < t.redo.calls.length; r++)i.plotDo(e, t.redo.calls[r], t.redo.args[r]);
                            e.undoQueue.inSequence = !1, e.autoplay = !1, e.undoQueue.index++;
                        }
                    },
                    plotDo: function(e, t, r) {
                        e.autoplay = !0, r = function(e, t) {
                            for(var r, a = [], i = 0; i < t.length; i++)r = t[i], a[i] = r === e ? r : "object" == typeof r ? Array.isArray(r) ? n.extendDeep([], r) : n.extendDeepAll({}, r) : r;
                            return a;
                        }(e, r), t.apply(null, r);
                    }
                };
                e.exports = i;
            },
            587: function(e, t) {
                "use strict";
                t.counter = function(e, t, r, n) {
                    var a = (t || "") + (r ? "" : "$"), i = !1 === n ? "" : "^";
                    return "xy" === e ? new RegExp(i + "x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?" + a) : new RegExp(i + e + "([2-9]|[1-9][0-9]+)?" + a);
                };
            },
            6962: function(e) {
                "use strict";
                var t = /^(.*)(\.[^\.\[\]]+|\[\d\])$/, r = /^[^\.\[\]]+$/;
                e.exports = function(e, n) {
                    for(; n;){
                        var a = e.match(t);
                        if (a) e = a[1];
                        else {
                            if (!e.match(r)) throw new Error("bad relativeAttr call:" + [
                                e,
                                n
                            ]);
                            e = "";
                        }
                        if ("^" !== n.charAt(0)) break;
                        n = n.slice(1);
                    }
                    return e && "[" !== n.charAt(0) ? e + "." + n : e + n;
                };
            },
            1332: function(e, t, r) {
                "use strict";
                var n = r(3627).isArrayOrTypedArray, a = r(1965);
                e.exports = function e(t, r) {
                    for(var i in r){
                        var o = r[i], l = t[i];
                        if (l !== o) {
                            if ("_" === i.charAt(0) || "function" == typeof o) {
                                if (i in t) continue;
                                t[i] = o;
                            } else if (n(o) && n(l) && a(o[0])) {
                                if ("customdata" === i || "ids" === i) continue;
                                for(var s = Math.min(o.length, l.length), c = 0; c < s; c++)l[c] !== o[c] && a(o[c]) && a(l[c]) && e(l[c], o[c]);
                            } else a(o) && a(l) && (e(l, o), Object.keys(l).length || delete t[i]);
                        }
                    }
                };
            },
            5888: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(7769), i = r(3389), o = r(606).BADNUM, l = 1e-9;
                function s(e, t) {
                    return e < t;
                }
                function c(e, t) {
                    return e <= t;
                }
                function u(e, t) {
                    return e > t;
                }
                function f(e, t) {
                    return e >= t;
                }
                t.findBin = function(e, t, r) {
                    if (n(t.start)) return r ? Math.ceil((e - t.start) / t.size - l) - 1 : Math.floor((e - t.start) / t.size + l);
                    var i, o, d = 0, h = t.length, p = 0, v = h > 1 ? (t[h - 1] - t[0]) / (h - 1) : 1;
                    for(o = v >= 0 ? r ? s : c : r ? f : u, e += v * l * (r ? -1 : 1) * (v >= 0 ? 1 : -1); d < h && p++ < 100;)o(t[i = Math.floor((d + h) / 2)], e) ? d = i + 1 : h = i;
                    return p > 90 && a.log("Long binary search..."), d - 1;
                }, t.sorterAsc = function(e, t) {
                    return e - t;
                }, t.sorterDes = function(e, t) {
                    return t - e;
                }, t.distinctVals = function(e) {
                    var r, n = e.slice();
                    for(n.sort(t.sorterAsc), r = n.length - 1; r > -1 && n[r] === o; r--);
                    for(var a, i = n[r] - n[0] || 1, l = i / (r || 1) / 1e4, s = [], c = 0; c <= r; c++){
                        var u = n[c], f = u - a;
                        void 0 === a ? (s.push(u), a = u) : f > l && (i = Math.min(i, f), s.push(u), a = u);
                    }
                    return {
                        vals: s,
                        minDiff: i
                    };
                }, t.roundUp = function(e, t, r) {
                    for(var n, a = 0, i = t.length - 1, o = 0, l = r ? 0 : 1, s = r ? 1 : 0, c = r ? Math.ceil : Math.floor; a < i && o++ < 100;)t[n = c((a + i) / 2)] <= e ? a = n + l : i = n - s;
                    return t[a];
                }, t.sort = function(e, t) {
                    for(var r = 0, n = 0, a = 1; a < e.length; a++){
                        var i = t(e[a], e[a - 1]);
                        if (i < 0 ? r = 1 : i > 0 && (n = 1), r && n) return e.sort(t);
                    }
                    return n ? e : e.reverse();
                }, t.findIndexOfMin = function(e, t) {
                    t = t || i;
                    for(var r, n = 1 / 0, a = 0; a < e.length; a++){
                        var o = t(e[a]);
                        o < n && (n = o, r = a);
                    }
                    return r;
                };
            },
            6964: function(e) {
                "use strict";
                e.exports = function(e, t) {
                    (e.attr("class") || "").split(" ").forEach(function(t) {
                        0 === t.indexOf("cursor-") && e.classed(t, !1);
                    }), t && e.classed("cursor-" + t, !0);
                };
            },
            8607: function(e) {
                "use strict";
                e.exports = function(e) {
                    return Object.keys(e).sort();
                };
            },
            38: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(3627).isArrayOrTypedArray;
                t.aggNums = function(e, r, i, o) {
                    var l, s;
                    if ((!o || o > i.length) && (o = i.length), n(r) || (r = !1), a(i[0])) {
                        for(s = new Array(o), l = 0; l < o; l++)s[l] = t.aggNums(e, r, i[l]);
                        i = s;
                    }
                    for(l = 0; l < o; l++)n(r) ? n(i[l]) && (r = e(+r, +i[l])) : r = i[l];
                    return r;
                }, t.len = function(e) {
                    return t.aggNums(function(e) {
                        return e + 1;
                    }, 0, e);
                }, t.mean = function(e, r) {
                    return r || (r = t.len(e)), t.aggNums(function(e, t) {
                        return e + t;
                    }, 0, e) / r;
                }, t.midRange = function(e) {
                    if (void 0 !== e && 0 !== e.length) return (t.aggNums(Math.max, null, e) + t.aggNums(Math.min, null, e)) / 2;
                }, t.variance = function(e, r, a) {
                    return r || (r = t.len(e)), n(a) || (a = t.mean(e, r)), t.aggNums(function(e, t) {
                        return e + Math.pow(t - a, 2);
                    }, 0, e) / r;
                }, t.stdev = function(e, r, n) {
                    return Math.sqrt(t.variance(e, r, n));
                }, t.median = function(e) {
                    var r = e.slice().sort();
                    return t.interp(r, .5);
                }, t.interp = function(e, t) {
                    if (!n(t)) throw "n should be a finite number";
                    if ((t = t * e.length - .5) < 0) return e[0];
                    if (t > e.length - 1) return e[e.length - 1];
                    var r = t % 1;
                    return r * e[Math.ceil(t)] + (1 - r) * e[Math.floor(t)];
                };
            },
            3893: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(1828), i = a.strTranslate, o = r(7922), l = r(8783).LINE_SPACING, s = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
                t.convertToTspans = function(e, r, g) {
                    var L = e.text(), S = !e.attr("data-notex") && r && r._context.typesetMath && "undefined" != typeof MathJax && L.match(s), C = n.select(e.node().parentNode);
                    if (!C.empty()) {
                        var P = e.attr("class") ? e.attr("class").split(" ")[0] : "text";
                        return P += "-math", C.selectAll("svg." + P).remove(), C.selectAll("g." + P + "-group").remove(), e.style("display", null).attr({
                            "data-unformatted": L,
                            "data-math": "N"
                        }), S ? (r && r._promises || []).push(new Promise(function(t) {
                            e.style("display", "none");
                            var r = parseInt(e.node().style.fontSize, 10), o = {
                                fontSize: r
                            };
                            !function(e, t, r) {
                                var i, o, l, s, d = parseInt((MathJax.version || "").split(".")[0]);
                                if (2 === d || 3 === d) {
                                    var h = function() {
                                        var r = "math-output-" + a.randstr({}, 64), i = (s = n.select("body").append("div").attr({
                                            id: r
                                        }).style({
                                            visibility: "hidden",
                                            position: "absolute",
                                            "font-size": t.fontSize + "px"
                                        }).text(e.replace(c, "\\lt ").replace(u, "\\gt "))).node();
                                        return 2 === d ? MathJax.Hub.Typeset(i) : MathJax.typeset([
                                            i
                                        ]);
                                    }, p = function() {
                                        var t = s.select(2 === d ? ".MathJax_SVG" : ".MathJax"), i = !t.empty() && s.select("svg").node();
                                        if (i) {
                                            var o, l = i.getBoundingClientRect();
                                            o = 2 === d ? n.select("body").select("#MathJax_SVG_glyphs") : t.select("defs"), r(t, o, l);
                                        } else a.log("There was an error in the tex syntax.", e), r();
                                        s.remove();
                                    };
                                    2 === d ? MathJax.Hub.Queue(function() {
                                        return o = a.extendDeepAll({}, MathJax.Hub.config), l = MathJax.Hub.processSectionDelay, void 0 !== MathJax.Hub.processSectionDelay && (MathJax.Hub.processSectionDelay = 0), MathJax.Hub.Config({
                                            messageStyle: "none",
                                            tex2jax: {
                                                inlineMath: f
                                            },
                                            displayAlign: "left"
                                        });
                                    }, function() {
                                        if ("SVG" !== (i = MathJax.Hub.config.menuSettings.renderer)) return MathJax.Hub.setRenderer("SVG");
                                    }, h, p, function() {
                                        if ("SVG" !== i) return MathJax.Hub.setRenderer(i);
                                    }, function() {
                                        return void 0 !== l && (MathJax.Hub.processSectionDelay = l), MathJax.Hub.Config(o);
                                    }) : 3 === d && (o = a.extendDeepAll({}, MathJax.config), MathJax.config.tex || (MathJax.config.tex = {}), MathJax.config.tex.inlineMath = f, "svg" !== (i = MathJax.config.startup.output) && (MathJax.config.startup.output = "svg"), MathJax.startup.defaultReady(), MathJax.startup.promise.then(function() {
                                        h(), p(), "svg" !== i && (MathJax.config.startup.output = i), MathJax.config = o;
                                    }));
                                } else a.warn("No MathJax version:", MathJax.version);
                            }(S[2], o, function(n, a, o) {
                                C.selectAll("svg." + P).remove(), C.selectAll("g." + P + "-group").remove();
                                var l = n && n.select("svg");
                                if (!l || !l.node()) return I(), void t();
                                var s = C.append("g").classed(P + "-group", !0).attr({
                                    "pointer-events": "none",
                                    "data-unformatted": L,
                                    "data-math": "Y"
                                });
                                s.node().appendChild(l.node()), a && a.node() && l.node().insertBefore(a.node().cloneNode(!0), l.node().firstChild);
                                var c = o.width, u = o.height;
                                l.attr({
                                    class: P,
                                    height: u,
                                    preserveAspectRatio: "xMinYMin meet"
                                }).style({
                                    overflow: "visible",
                                    "pointer-events": "none"
                                });
                                var f = e.node().style.fill || "black", d = l.select("g");
                                d.attr({
                                    fill: f,
                                    stroke: f
                                });
                                var h = d.node().getBoundingClientRect(), p = h.width, v = h.height;
                                (p > c || v > u) && (l.style("overflow", "hidden"), p = (h = l.node().getBoundingClientRect()).width, v = h.height);
                                var y = +e.attr("x"), m = +e.attr("y"), x = -(r || e.node().getBoundingClientRect().height) / 4;
                                if ("y" === P[0]) s.attr({
                                    transform: "rotate(" + [
                                        -90,
                                        y,
                                        m
                                    ] + ")" + i(-p / 2, x - v / 2)
                                });
                                else if ("l" === P[0]) m = x - v / 2;
                                else if ("a" === P[0] && 0 !== P.indexOf("atitle")) y = 0, m = x;
                                else {
                                    var b = e.attr("text-anchor");
                                    y -= p * ("middle" === b ? .5 : "end" === b ? 1 : 0), m = m + x - v / 2;
                                }
                                l.attr({
                                    x: y,
                                    y: m
                                }), g && g.call(e, s), t(s);
                            });
                        })) : I(), e;
                    }
                    function I() {
                        C.empty() || (P = e.attr("class") + "-math", C.select("svg." + P).remove()), e.text("").style("white-space", "pre");
                        var r = function(e, t) {
                            t = t.replace(y, " ");
                            var r, i = !1, s = [], c = -1;
                            function u() {
                                c++;
                                var t = document.createElementNS(o.svg, "tspan");
                                n.select(t).attr({
                                    class: "line",
                                    dy: c * l + "em"
                                }), e.appendChild(t), r = t;
                                var a = s;
                                if (s = [
                                    {
                                        node: t
                                    }
                                ], a.length > 1) for(var i = 1; i < a.length; i++)f(a[i]);
                            }
                            function f(e) {
                                var t, a = e.type, i = {};
                                if ("a" === a) {
                                    t = "a";
                                    var l = e.target, c = e.href, u = e.popup;
                                    c && (i = {
                                        "xlink:xlink:show": "_blank" === l || "_" !== l.charAt(0) ? "new" : "replace",
                                        target: l,
                                        "xlink:xlink:href": c
                                    }, u && (i.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + u + '");return false;'));
                                } else t = "tspan";
                                e.style && (i.style = e.style);
                                var f = document.createElementNS(o.svg, t);
                                if ("sup" === a || "sub" === a) {
                                    g(r, v), r.appendChild(f);
                                    var d = document.createElementNS(o.svg, "tspan");
                                    g(d, v), n.select(d).attr("dy", p[a]), i.dy = h[a], r.appendChild(f), r.appendChild(d);
                                } else r.appendChild(f);
                                n.select(f).attr(i), r = e.node = f, s.push(e);
                            }
                            function g(e, t) {
                                e.appendChild(document.createTextNode(t));
                            }
                            function L(e) {
                                if (1 !== s.length) {
                                    var n = s.pop();
                                    e !== n.type && a.log("Start tag <" + n.type + "> doesnt match end tag <" + e + ">. Pretending it did match.", t), r = s[s.length - 1].node;
                                } else a.log("Ignoring unexpected end tag </" + e + ">.", t);
                            }
                            b.test(t) ? u() : (r = e, s = [
                                {
                                    node: e
                                }
                            ]);
                            for(var S = t.split(m), C = 0; C < S.length; C++){
                                var P = S[C], I = P.match(x), R = I && I[2].toLowerCase(), z = d[R];
                                if ("br" === R) u();
                                else if (void 0 === z) g(r, D(P));
                                else if (I[1]) L(R);
                                else {
                                    var N = I[4], F = {
                                        type: R
                                    }, E = k(N, _);
                                    if (E ? (E = E.replace(A, "$1 fill:"), z && (E += ";" + z)) : z && (E = z), E && (F.style = E), "a" === R) {
                                        i = !0;
                                        var H = k(N, w);
                                        if (H) {
                                            var j = O(H);
                                            j && (F.href = j, F.target = k(N, T) || "_blank", F.popup = k(N, M));
                                        }
                                    }
                                    f(F);
                                }
                            }
                            return i;
                        }(e.node(), L);
                        r && e.style("pointer-events", "all"), t.positionText(e), g && g.call(e);
                    }
                };
                var c = /(<|&lt;|&#60;)/g, u = /(>|&gt;|&#62;)/g, f = [
                    [
                        "$",
                        "$"
                    ],
                    [
                        "\\(",
                        "\\)"
                    ]
                ], d = {
                    sup: "font-size:70%",
                    sub: "font-size:70%",
                    b: "font-weight:bold",
                    i: "font-style:italic",
                    a: "cursor:pointer",
                    span: "",
                    em: "font-style:italic;font-weight:bold"
                }, h = {
                    sub: "0.3em",
                    sup: "-0.6em"
                }, p = {
                    sub: "-0.21em",
                    sup: "0.42em"
                }, v = "\u200B", g = [
                    "http:",
                    "https:",
                    "mailto:",
                    "",
                    void 0,
                    ":"
                ], y = t.NEWLINES = /(\r\n?|\n)/g, m = /(<[^<>]*>)/, x = /<(\/?)([^ >]*)(\s+(.*))?>/i, b = /<br(\s+.*)?>/i;
                t.BR_TAG_ALL = /<br(\s+.*)?>/gi;
                var _ = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i, w = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i, T = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i, M = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
                function k(e, t) {
                    if (!e) return null;
                    var r = e.match(t), n = r && (r[3] || r[4]);
                    return n && D(n);
                }
                var A = /(^|;)\s*color:/;
                t.plainText = function(e, t) {
                    for(var r = void 0 !== (t = t || {}).len && -1 !== t.len ? t.len : 1 / 0, n = void 0 !== t.allowedTags ? t.allowedTags : [
                        "br"
                    ], a = e.split(m), i = [], o = "", l = 0, s = 0; s < a.length; s++){
                        var c = a[s], u = c.match(x), f = u && u[2].toLowerCase();
                        if (f) -1 !== n.indexOf(f) && (i.push(c), o = f);
                        else {
                            var d = c.length;
                            if (l + d < r) i.push(c), l += d;
                            else if (l < r) {
                                var h = r - l;
                                o && ("br" !== o || h <= 3 || d <= 3) && i.pop(), r > 3 ? i.push(c.substr(0, h - 3) + "...") : i.push(c.substr(0, h));
                                break;
                            }
                            o = "";
                        }
                    }
                    return i.join("");
                };
                var L = {
                    mu: "\u03BC",
                    amp: "&",
                    lt: "<",
                    gt: ">",
                    nbsp: "\xa0",
                    times: "\xd7",
                    plusmn: "\xb1",
                    deg: "\xb0"
                }, S = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
                function D(e) {
                    return e.replace(S, function(e, t) {
                        return ("#" === t.charAt(0) ? function(e) {
                            if (!(e > 1114111)) {
                                var t = String.fromCodePoint;
                                if (t) return t(e);
                                var r = String.fromCharCode;
                                return e <= 65535 ? r(e) : r(55232 + (e >> 10), e % 1024 + 56320);
                            }
                        }("x" === t.charAt(1) ? parseInt(t.substr(2), 16) : parseInt(t.substr(1), 10)) : L[t]) || e;
                    });
                }
                function O(e) {
                    var t = encodeURI(decodeURI(e)), r = document.createElement("a"), n = document.createElement("a");
                    r.href = e, n.href = t;
                    var a = r.protocol, i = n.protocol;
                    return -1 !== g.indexOf(a) && -1 !== g.indexOf(i) ? t : "";
                }
                function C(e, t, r) {
                    var n, i, o, l = r.horizontalAlign, s = r.verticalAlign || "top", c = e.node().getBoundingClientRect(), u = t.node().getBoundingClientRect();
                    return i = "bottom" === s ? function() {
                        return c.bottom - n.height;
                    } : "middle" === s ? function() {
                        return c.top + (c.height - n.height) / 2;
                    } : function() {
                        return c.top;
                    }, o = "right" === l ? function() {
                        return c.right - n.width;
                    } : "center" === l ? function() {
                        return c.left + (c.width - n.width) / 2;
                    } : function() {
                        return c.left;
                    }, function() {
                        n = this.node().getBoundingClientRect();
                        var e = o() - u.left, t = i() - u.top, l = r.gd || {};
                        if (r.gd) {
                            l._fullLayout._calcInverseTransform(l);
                            var s = a.apply3DTransform(l._fullLayout._invTransform)(e, t);
                            e = s[0], t = s[1];
                        }
                        return this.style({
                            top: t + "px",
                            left: e + "px",
                            "z-index": 1e3
                        }), this;
                    };
                }
                t.convertEntities = D, t.sanitizeHTML = function(e) {
                    e = e.replace(y, " ");
                    for(var t = document.createElement("p"), r = t, a = [], i = e.split(m), o = 0; o < i.length; o++){
                        var l = i[o], s = l.match(x), c = s && s[2].toLowerCase();
                        if (c in d) {
                            if (s[1]) a.length && (r = a.pop());
                            else {
                                var u = s[4], f = k(u, _), h = f ? {
                                    style: f
                                } : {};
                                if ("a" === c) {
                                    var p = k(u, w);
                                    if (p) {
                                        var v = O(p);
                                        if (v) {
                                            h.href = v;
                                            var g = k(u, T);
                                            g && (h.target = g);
                                        }
                                    }
                                }
                                var b = document.createElement(c);
                                r.appendChild(b), n.select(b).attr(h), r = b, a.push(b);
                            }
                        } else r.appendChild(document.createTextNode(D(l)));
                    }
                    return t.innerHTML;
                }, t.lineCount = function(e) {
                    return e.selectAll("tspan.line").size() || 1;
                }, t.positionText = function(e, t, r) {
                    return e.each(function() {
                        var e = n.select(this);
                        function a(t, r) {
                            return void 0 === r ? null === (r = e.attr(t)) && (e.attr(t, 0), r = 0) : e.attr(t, r), r;
                        }
                        var i = a("x", t), o = a("y", r);
                        "text" === this.nodeName && e.selectAll("tspan.line").attr({
                            x: i,
                            y: o
                        });
                    });
                };
                var P = "1px ";
                t.makeTextShadow = function(e) {
                    return P + P + P + e + ", -" + P + "-" + P + P + e + ", " + P + "-" + P + P + e + ", -" + P + P + P + e;
                }, t.makeEditable = function(e, t) {
                    var r = t.gd, a = t.delegate, i = n.dispatch("edit", "input", "cancel"), o = a || e;
                    if (e.style({
                        "pointer-events": a ? "none" : "all"
                    }), 1 !== e.size()) throw new Error("boo");
                    function l() {
                        var a, l, c, u, f;
                        a = n.select(r).select(".svg-container"), l = a.append("div"), c = e.node().style, u = parseFloat(c.fontSize || 12), void 0 === (f = t.text) && (f = e.attr("data-unformatted")), l.classed("plugin-editable editable", !0).style({
                            position: "absolute",
                            "font-family": c.fontFamily || "Arial",
                            "font-size": u,
                            color: t.fill || c.fill || "black",
                            opacity: 1,
                            "background-color": t.background || "transparent",
                            outline: "#ffffff33 1px solid",
                            margin: [
                                -u / 8 + 1,
                                0,
                                0,
                                -1
                            ].join("px ") + "px",
                            padding: "0",
                            "box-sizing": "border-box"
                        }).attr({
                            contenteditable: !0
                        }).text(f).call(C(e, a, t)).on("blur", function() {
                            r._editing = !1, e.text(this.textContent).style({
                                opacity: 1
                            });
                            var t, a = n.select(this).attr("class");
                            (t = a ? "." + a.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(e.node().parentNode).select(t).style({
                                opacity: 0
                            });
                            var o = this.textContent;
                            n.select(this).transition().duration(0).remove(), n.select(document).on("mouseup", null), i.edit.call(e, o);
                        }).on("focus", function() {
                            var e = this;
                            r._editing = !0, n.select(document).on("mouseup", function() {
                                if (n.event.target === e) return !1;
                                document.activeElement === l.node() && l.node().blur();
                            });
                        }).on("keyup", function() {
                            27 === n.event.which ? (r._editing = !1, e.style({
                                opacity: 1
                            }), n.select(this).style({
                                opacity: 0
                            }).on("blur", function() {
                                return !1;
                            }).transition().remove(), i.cancel.call(e, this.textContent)) : (i.input.call(e, this.textContent), n.select(this).call(C(e, a, t)));
                        }).on("keydown", function() {
                            13 === n.event.which && this.blur();
                        }).call(s), e.style({
                            opacity: 0
                        });
                        var d, h = o.attr("class");
                        (d = h ? "." + h.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(e.node().parentNode).select(d).style({
                            opacity: 0
                        });
                    }
                    function s(e) {
                        var t = e.node(), r = document.createRange();
                        r.selectNodeContents(t);
                        var n = window.getSelection();
                        n.removeAllRanges(), n.addRange(r), t.focus();
                    }
                    return t.immediate ? l() : o.on("click", l), n.rebind(e, i, "on");
                };
            },
            9990: function(e, t) {
                "use strict";
                var r = {};
                function n(e) {
                    e && null !== e.timer && (clearTimeout(e.timer), e.timer = null);
                }
                t.throttle = function(e, t, a) {
                    var i = r[e], o = Date.now();
                    if (!i) {
                        for(var l in r)r[l].ts < o - 6e4 && delete r[l];
                        i = r[e] = {
                            ts: 0,
                            timer: null
                        };
                    }
                    function s() {
                        a(), i.ts = Date.now(), i.onDone && (i.onDone(), i.onDone = null);
                    }
                    n(i), o > i.ts + t ? s() : i.timer = setTimeout(function() {
                        s(), i.timer = null;
                    }, t);
                }, t.done = function(e) {
                    var t = r[e];
                    return t && t.timer ? new Promise(function(e) {
                        var r = t.onDone;
                        t.onDone = function() {
                            r && r(), e(), t.onDone = null;
                        };
                    }) : Promise.resolve();
                }, t.clear = function(e) {
                    if (e) n(r[e]), delete r[e];
                    else for(var a in r)t.clear(a);
                };
            },
            8163: function(e, t, r) {
                "use strict";
                var n = r(2770);
                e.exports = function(e, t) {
                    if (e > 0) return Math.log(e) / Math.LN10;
                    var r = Math.log(Math.min(t[0], t[1])) / Math.LN10;
                    return n(r) || (r = Math.log(Math.max(t[0], t[1])) / Math.LN10 - 6), r;
                };
            },
            7815: function(e) {
                "use strict";
                e.exports = {
                    moduleType: "locale",
                    name: "en-US",
                    dictionary: {
                        "Click to enter Colorscale title": "Click to enter Colorscale title"
                    },
                    format: {
                        date: "%m/%d/%Y"
                    }
                };
            },
            2177: function(e) {
                "use strict";
                e.exports = {
                    moduleType: "locale",
                    name: "en",
                    dictionary: {
                        "Click to enter Colorscale title": "Click to enter Colourscale title"
                    },
                    format: {
                        days: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        shortDays: [
                            "Sun",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        months: [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ],
                        shortMonths: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ],
                        periods: [
                            "AM",
                            "PM"
                        ],
                        dateTime: "%a %b %e %X %Y",
                        date: "%d/%m/%Y",
                        time: "%H:%M:%S",
                        decimal: ".",
                        thousands: ",",
                        grouping: [
                            3
                        ],
                        currency: [
                            "$",
                            ""
                        ],
                        year: "%Y",
                        month: "%b %Y",
                        dayMonth: "%b %-d",
                        dayMonthYear: "%b %-d, %Y"
                    }
                };
            },
            4458: function(e, t, r) {
                "use strict";
                var n = r(3972);
                e.exports = function(e) {
                    for(var t, r, a = n.layoutArrayContainers, i = n.layoutArrayRegexes, o = e.split("[")[0], l = 0; l < i.length; l++)if ((r = e.match(i[l])) && 0 === r.index) {
                        t = r[0];
                        break;
                    }
                    if (t || (t = a[a.indexOf(o)]), !t) return !1;
                    var s = e.substr(t.length);
                    return s ? !!(r = s.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/)) && {
                        array: t,
                        index: Number(r[1]),
                        property: r[3] || ""
                    } : {
                        array: t,
                        index: "",
                        property: ""
                    };
                };
            },
            962: function(e, t, r) {
                "use strict";
                var n = r(1426).extendFlat, a = r(1965), i = {
                    valType: "flaglist",
                    extras: [
                        "none"
                    ],
                    flags: [
                        "calc",
                        "clearAxisTypes",
                        "plot",
                        "style",
                        "markerSize",
                        "colorbars"
                    ]
                }, o = {
                    valType: "flaglist",
                    extras: [
                        "none"
                    ],
                    flags: [
                        "calc",
                        "plot",
                        "legend",
                        "ticks",
                        "axrange",
                        "layoutstyle",
                        "modebar",
                        "camera",
                        "arraydraw",
                        "colorbars"
                    ]
                }, l = i.flags.slice().concat([
                    "fullReplot"
                ]), s = o.flags.slice().concat("layoutReplot");
                function c(e) {
                    for(var t = {}, r = 0; r < e.length; r++)t[e[r]] = !1;
                    return t;
                }
                function u(e, t, r) {
                    var i = n({}, e);
                    for(var o in i){
                        var l = i[o];
                        a(l) && (i[o] = f(l, t, 0, o));
                    }
                    return "from-root" === r && (i.editType = t), i;
                }
                function f(e, t, r, a) {
                    if (e.valType) {
                        var i = n({}, e);
                        if (i.editType = t, Array.isArray(e.items)) {
                            i.items = new Array(e.items.length);
                            for(var o = 0; o < e.items.length; o++)i.items[o] = f(e.items[o], t);
                        }
                        return i;
                    }
                    return u(e, t, "_" === a.charAt(0) ? "nested" : "from-root");
                }
                e.exports = {
                    traces: i,
                    layout: o,
                    traceFlags: function() {
                        return c(l);
                    },
                    layoutFlags: function() {
                        return c(s);
                    },
                    update: function(e, t) {
                        var r = t.editType;
                        if (r && "none" !== r) for(var n = r.split("+"), a = 0; a < n.length; a++)e[n[a]] = !0;
                    },
                    overrideAll: u
                };
            },
            8377: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(7812), i = r(3972), o = r(1828), l = r(4875), s = r(1675), c = r(7901), u = s.cleanId, f = s.getFromTrace, d = i.traceIs;
                function h(e, t) {
                    var r = e[t], n = t.charAt(0);
                    r && "paper" !== r && (e[t] = u(r, n, !0));
                }
                function p(e) {
                    function t(t, r) {
                        var n = e[t], a = e.title && e.title[r];
                        n && !a && (e.title || (e.title = {}), e.title[r] = e[t], delete e[t]);
                    }
                    e && ("string" != typeof e.title && "number" != typeof e.title || (e.title = {
                        text: e.title
                    }), t("titlefont", "font"), t("titleposition", "position"), t("titleside", "side"), t("titleoffset", "offset"));
                }
                function v(e) {
                    if (!o.isPlainObject(e)) return !1;
                    var t = e.name;
                    return delete e.name, delete e.showlegend, ("string" == typeof t || "number" == typeof t) && String(t);
                }
                function g(e, t, r, n) {
                    if (r && !n) return e;
                    if (n && !r) return t;
                    if (!e.trim()) return t;
                    if (!t.trim()) return e;
                    var a, i = Math.min(e.length, t.length);
                    for(a = 0; a < i && e.charAt(a) === t.charAt(a); a++);
                    return e.substr(0, a).trim();
                }
                function y(e) {
                    var t = "middle", r = "center";
                    return "string" == typeof e && (-1 !== e.indexOf("top") ? t = "top" : -1 !== e.indexOf("bottom") && (t = "bottom"), -1 !== e.indexOf("left") ? r = "left" : -1 !== e.indexOf("right") && (r = "right")), t + " " + r;
                }
                function m(e, t) {
                    return t in e && "object" == typeof e[t] && 0 === Object.keys(e[t]).length;
                }
                t.clearPromiseQueue = function(e) {
                    Array.isArray(e._promises) && e._promises.length > 0 && o.log("Clearing previous rejected promises from queue."), e._promises = [];
                }, t.cleanLayout = function(e) {
                    var r, n;
                    e || (e = {}), e.xaxis1 && (e.xaxis || (e.xaxis = e.xaxis1), delete e.xaxis1), e.yaxis1 && (e.yaxis || (e.yaxis = e.yaxis1), delete e.yaxis1), e.scene1 && (e.scene || (e.scene = e.scene1), delete e.scene1);
                    var i = (l.subplotsRegistry.cartesian || {}).attrRegex, s = (l.subplotsRegistry.polar || {}).attrRegex, f = (l.subplotsRegistry.ternary || {}).attrRegex, d = (l.subplotsRegistry.gl3d || {}).attrRegex, v = Object.keys(e);
                    for(r = 0; r < v.length; r++){
                        var g = v[r];
                        if (i && i.test(g)) {
                            var y = e[g];
                            y.anchor && "free" !== y.anchor && (y.anchor = u(y.anchor)), y.overlaying && (y.overlaying = u(y.overlaying)), y.type || (y.isdate ? y.type = "date" : y.islog ? y.type = "log" : !1 === y.isdate && !1 === y.islog && (y.type = "linear")), "withzero" !== y.autorange && "tozero" !== y.autorange || (y.autorange = !0, y.rangemode = "tozero"), delete y.islog, delete y.isdate, delete y.categories, m(y, "domain") && delete y.domain, void 0 !== y.autotick && (void 0 === y.tickmode && (y.tickmode = y.autotick ? "auto" : "linear"), delete y.autotick), p(y);
                        } else if (s && s.test(g)) p(e[g].radialaxis);
                        else if (f && f.test(g)) {
                            var x = e[g];
                            p(x.aaxis), p(x.baxis), p(x.caxis);
                        } else if (d && d.test(g)) {
                            var b = e[g], _ = b.cameraposition;
                            if (Array.isArray(_) && 4 === _[0].length) {
                                var w = _[0], T = _[1], M = _[2], k = a([], w), A = [];
                                for(n = 0; n < 3; ++n)A[n] = T[n] + M * k[2 + 4 * n];
                                b.camera = {
                                    eye: {
                                        x: A[0],
                                        y: A[1],
                                        z: A[2]
                                    },
                                    center: {
                                        x: T[0],
                                        y: T[1],
                                        z: T[2]
                                    },
                                    up: {
                                        x: 0,
                                        y: 0,
                                        z: 1
                                    }
                                }, delete b.cameraposition;
                            }
                            p(b.xaxis), p(b.yaxis), p(b.zaxis);
                        }
                    }
                    var L = Array.isArray(e.annotations) ? e.annotations.length : 0;
                    for(r = 0; r < L; r++){
                        var S = e.annotations[r];
                        o.isPlainObject(S) && (S.ref && ("paper" === S.ref ? (S.xref = "paper", S.yref = "paper") : "data" === S.ref && (S.xref = "x", S.yref = "y"), delete S.ref), h(S, "xref"), h(S, "yref"));
                    }
                    var D = Array.isArray(e.shapes) ? e.shapes.length : 0;
                    for(r = 0; r < D; r++){
                        var O = e.shapes[r];
                        o.isPlainObject(O) && (h(O, "xref"), h(O, "yref"));
                    }
                    var C = Array.isArray(e.images) ? e.images.length : 0;
                    for(r = 0; r < C; r++){
                        var P = e.images[r];
                        o.isPlainObject(P) && (h(P, "xref"), h(P, "yref"));
                    }
                    var I = e.legend;
                    return I && (I.x > 3 ? (I.x = 1.02, I.xanchor = "left") : I.x < -2 && (I.x = -0.02, I.xanchor = "right"), I.y > 3 ? (I.y = 1.02, I.yanchor = "bottom") : I.y < -2 && (I.y = -0.02, I.yanchor = "top")), p(e), "rotate" === e.dragmode && (e.dragmode = "orbit"), c.clean(e), e.template && e.template.layout && t.cleanLayout(e.template.layout), e;
                }, t.cleanData = function(e) {
                    for(var r = 0; r < e.length; r++){
                        var n, a = e[r];
                        if ("histogramy" === a.type && "xbins" in a && !("ybins" in a) && (a.ybins = a.xbins, delete a.xbins), a.error_y && "opacity" in a.error_y) {
                            var s = c.defaults, f = a.error_y.color || (d(a, "bar") ? c.defaultLine : s[r % s.length]);
                            a.error_y.color = c.addOpacity(c.rgb(f), c.opacity(f) * a.error_y.opacity), delete a.error_y.opacity;
                        }
                        if ("bardir" in a && ("h" !== a.bardir || !d(a, "bar") && "histogram" !== a.type.substr(0, 9) || (a.orientation = "h", t.swapXYData(a)), delete a.bardir), "histogramy" === a.type && t.swapXYData(a), "histogramx" !== a.type && "histogramy" !== a.type || (a.type = "histogram"), "scl" in a && !("colorscale" in a) && (a.colorscale = a.scl, delete a.scl), "reversescl" in a && !("reversescale" in a) && (a.reversescale = a.reversescl, delete a.reversescl), a.xaxis && (a.xaxis = u(a.xaxis, "x")), a.yaxis && (a.yaxis = u(a.yaxis, "y")), d(a, "gl3d") && a.scene && (a.scene = l.subplotsRegistry.gl3d.cleanId(a.scene)), !d(a, "pie-like") && !d(a, "bar-like")) {
                            if (Array.isArray(a.textposition)) for(n = 0; n < a.textposition.length; n++)a.textposition[n] = y(a.textposition[n]);
                            else a.textposition && (a.textposition = y(a.textposition));
                        }
                        var h = i.getModule(a);
                        if (h && h.colorbar) {
                            var x = h.colorbar.container, b = x ? a[x] : a;
                            b && b.colorscale && ("YIGnBu" === b.colorscale && (b.colorscale = "YlGnBu"), "YIOrRd" === b.colorscale && (b.colorscale = "YlOrRd"));
                        }
                        if ("surface" === a.type && o.isPlainObject(a.contours)) {
                            var _ = [
                                "x",
                                "y",
                                "z"
                            ];
                            for(n = 0; n < _.length; n++){
                                var w = a.contours[_[n]];
                                o.isPlainObject(w) && (w.highlightColor && (w.highlightcolor = w.highlightColor, delete w.highlightColor), w.highlightWidth && (w.highlightwidth = w.highlightWidth, delete w.highlightWidth));
                            }
                        }
                        if ("candlestick" === a.type || "ohlc" === a.type) {
                            var T = !1 !== (a.increasing || {}).showlegend, M = !1 !== (a.decreasing || {}).showlegend, k = v(a.increasing), A = v(a.decreasing);
                            if (!1 !== k && !1 !== A) {
                                var L = g(k, A, T, M);
                                L && (a.name = L);
                            } else !k && !A || a.name || (a.name = k || A);
                        }
                        if (Array.isArray(a.transforms)) {
                            var S = a.transforms;
                            for(n = 0; n < S.length; n++){
                                var D = S[n];
                                if (o.isPlainObject(D)) switch(D.type){
                                    case "filter":
                                        D.filtersrc && (D.target = D.filtersrc, delete D.filtersrc), D.calendar && (D.valuecalendar || (D.valuecalendar = D.calendar), delete D.calendar);
                                        break;
                                    case "groupby":
                                        if (D.styles = D.styles || D.style, D.styles && !Array.isArray(D.styles)) {
                                            var O = D.styles, C = Object.keys(O);
                                            D.styles = [];
                                            for(var P = 0; P < C.length; P++)D.styles.push({
                                                target: C[P],
                                                value: O[C[P]]
                                            });
                                        }
                                }
                            }
                        }
                        m(a, "line") && delete a.line, "marker" in a && (m(a.marker, "line") && delete a.marker.line, m(a, "marker") && delete a.marker), c.clean(a), a.autobinx && (delete a.autobinx, delete a.xbins), a.autobiny && (delete a.autobiny, delete a.ybins), p(a), a.colorbar && p(a.colorbar), a.marker && a.marker.colorbar && p(a.marker.colorbar), a.line && a.line.colorbar && p(a.line.colorbar), a.aaxis && p(a.aaxis), a.baxis && p(a.baxis);
                    }
                }, t.swapXYData = function(e) {
                    var t;
                    if (o.swapAttrs(e, [
                        "?",
                        "?0",
                        "d?",
                        "?bins",
                        "nbins?",
                        "autobin?",
                        "?src",
                        "error_?"
                    ]), Array.isArray(e.z) && Array.isArray(e.z[0]) && (e.transpose ? delete e.transpose : e.transpose = !0), e.error_x && e.error_y) {
                        var r = e.error_y, n = "copy_ystyle" in r ? r.copy_ystyle : !(r.color || r.thickness || r.width);
                        o.swapAttrs(e, [
                            "error_?.copy_ystyle"
                        ]), n && o.swapAttrs(e, [
                            "error_?.color",
                            "error_?.thickness",
                            "error_?.width"
                        ]);
                    }
                    if ("string" == typeof e.hoverinfo) {
                        var a = e.hoverinfo.split("+");
                        for(t = 0; t < a.length; t++)"x" === a[t] ? a[t] = "y" : "y" === a[t] && (a[t] = "x");
                        e.hoverinfo = a.join("+");
                    }
                }, t.coerceTraceIndices = function(e, t) {
                    if (n(t)) return [
                        t
                    ];
                    if (!Array.isArray(t) || !t.length) return e.data.map(function(e, t) {
                        return t;
                    });
                    if (Array.isArray(t)) {
                        for(var r = [], a = 0; a < t.length; a++)o.isIndex(t[a], e.data.length) ? r.push(t[a]) : o.warn("trace index (", t[a], ") is not a number or is out of bounds");
                        return r;
                    }
                    return t;
                }, t.manageArrayContainers = function(e, t, r) {
                    var a = e.obj, i = e.parts, l = i.length, s = i[l - 1], c = n(s);
                    if (c && null === t) {
                        var u = i.slice(0, l - 1).join(".");
                        o.nestedProperty(a, u).get().splice(s, 1);
                    } else c && void 0 === e.get() ? (void 0 === e.get() && (r[e.astr] = null), e.set(t)) : e.set(t);
                };
                var x = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
                function b(e) {
                    var t = e.search(x);
                    if (t > 0) return e.substr(0, t);
                }
                t.hasParent = function(e, t) {
                    for(var r = b(t); r;){
                        if (r in e) return !0;
                        r = b(r);
                    }
                    return !1;
                };
                var _ = [
                    "x",
                    "y",
                    "z"
                ];
                t.clearAxisTypes = function(e, t, r) {
                    for(var n = 0; n < t.length; n++)for(var a = e._fullData[n], i = 0; i < 3; i++){
                        var l = f(e, a, _[i]);
                        if (l && "log" !== l.type) {
                            var s = l._name, c = l._id.substr(1);
                            if ("scene" === c.substr(0, 5)) {
                                if (void 0 !== r[c]) continue;
                                s = c + "." + s;
                            }
                            var u = s + ".type";
                            void 0 === r[s] && void 0 === r[u] && o.nestedProperty(e.layout, u).set(null);
                        }
                    }
                };
            },
            641: function(e, t, r) {
                "use strict";
                var n = r(2391);
                t._doPlot = n._doPlot, t.newPlot = n.newPlot, t.restyle = n.restyle, t.relayout = n.relayout, t.redraw = n.redraw, t.update = n.update, t._guiRestyle = n._guiRestyle, t._guiRelayout = n._guiRelayout, t._guiUpdate = n._guiUpdate, t._storeDirectGUIEdit = n._storeDirectGUIEdit, t.react = n.react, t.extendTraces = n.extendTraces, t.prependTraces = n.prependTraces, t.addTraces = n.addTraces, t.deleteTraces = n.deleteTraces, t.moveTraces = n.moveTraces, t.purge = n.purge, t.addFrames = n.addFrames, t.deleteFrames = n.deleteFrames, t.animate = n.animate, t.setPlotConfig = n.setPlotConfig;
                var a = r(4401).getGraphDiv, i = r(4031).eraseActiveShape;
                t.deleteActiveShape = function(e) {
                    return i(a(e));
                }, t.toImage = r(403), t.validate = r(4936), t.downloadImage = r(7239);
                var o = r(6318);
                t.makeTemplate = o.makeTemplate, t.validateTemplate = o.validateTemplate;
            },
            6611: function(e, t, r) {
                "use strict";
                var n = r(1965), a = r(4213), i = r(7769), o = r(5888).sorterAsc, l = r(3972);
                t.containerArrayMatch = r(4458);
                var s = t.isAddVal = function(e) {
                    return "add" === e || n(e);
                }, c = t.isRemoveVal = function(e) {
                    return null === e || "remove" === e;
                };
                t.applyContainerArrayChanges = function(e, t, r, n, u) {
                    var f = t.astr, d = l.getComponentMethod(f, "supplyLayoutDefaults"), h = l.getComponentMethod(f, "draw"), p = l.getComponentMethod(f, "drawOne"), v = n.replot || n.recalc || d === a || h === a, g = e.layout, y = e._fullLayout;
                    if (r[""]) {
                        Object.keys(r).length > 1 && i.warn("Full array edits are incompatible with other edits", f);
                        var m = r[""][""];
                        if (c(m)) t.set(null);
                        else {
                            if (!Array.isArray(m)) return i.warn("Unrecognized full array edit value", f, m), !0;
                            t.set(m);
                        }
                        return !v && (d(g, y), h(e), !0);
                    }
                    var x, b, _, w, T, M, k, A, L = Object.keys(r).map(Number).sort(o), S = t.get(), D = S || [], O = u(y, f).get(), C = [], P = -1, I = D.length;
                    for(x = 0; x < L.length; x++)if (w = r[_ = L[x]], T = Object.keys(w), M = w[""], k = s(M), _ < 0 || _ > D.length - (k ? 0 : 1)) i.warn("index out of range", f, _);
                    else if (void 0 !== M) T.length > 1 && i.warn("Insertion & removal are incompatible with edits to the same index.", f, _), c(M) ? C.push(_) : k ? ("add" === M && (M = {}), D.splice(_, 0, M), O && O.splice(_, 0, {})) : i.warn("Unrecognized full object edit value", f, _, M), -1 === P && (P = _);
                    else for(b = 0; b < T.length; b++)A = f + "[" + _ + "].", u(D[_], T[b], A).set(w[T[b]]);
                    for(x = C.length - 1; x >= 0; x--)D.splice(C[x], 1), O && O.splice(C[x], 1);
                    if (D.length ? S || t.set(D) : t.set(null), v) return !1;
                    if (d(g, y), p !== a) {
                        var R;
                        if (-1 === P) R = L;
                        else {
                            for(I = Math.max(D.length, I), R = [], x = 0; x < L.length && !((_ = L[x]) >= P); x++)R.push(_);
                            for(x = P; x < I; x++)R.push(x);
                        }
                        for(x = 0; x < R.length; x++)p(e, R[x]);
                    } else h(e);
                    return !0;
                };
            },
            2391: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(2770), i = r(7035), o = r(1828), l = o.nestedProperty, s = r(1086), c = r(847), u = r(3972), f = r(6281), d = r(4875), h = r(9298), p = r(1424), v = r(7901), g = r(4305).initInteractions, y = r(7922), m = r(7322).clearOutline, x = r(2075).dfltConfig, b = r(6611), _ = r(8377), w = r(1549), T = r(962), M = r(5555).AX_NAME_PATTERN, k = 0;
                function A(e) {
                    var t = e._fullLayout;
                    t._redrawFromAutoMarginCount ? t._redrawFromAutoMarginCount-- : e.emit("plotly_afterplot");
                }
                function L(e, t) {
                    try {
                        e._fullLayout._paper.style("background", t);
                    } catch (e) {
                        o.error(e);
                    }
                }
                function S(e, t) {
                    L(e, v.combine(t, "white"));
                }
                function D(e, t) {
                    if (!e._context) {
                        e._context = o.extendDeep({}, x);
                        var r = n.select("base");
                        e._context._baseUrl = r.size() && r.attr("href") ? window.location.href.split("#")[0] : "";
                    }
                    var a, l, s, c = e._context;
                    if (t) {
                        for(l = Object.keys(t), a = 0; a < l.length; a++)"editable" !== (s = l[a]) && "edits" !== s && s in c && ("setBackground" === s && "opaque" === t[s] ? c[s] = S : c[s] = t[s]);
                        t.plot3dPixelRatio && !c.plotGlPixelRatio && (c.plotGlPixelRatio = c.plot3dPixelRatio);
                        var u = t.editable;
                        if (void 0 !== u) for(c.editable = u, l = Object.keys(c.edits), a = 0; a < l.length; a++)c.edits[l[a]] = u;
                        if (t.edits) for(l = Object.keys(t.edits), a = 0; a < l.length; a++)(s = l[a]) in c.edits && (c.edits[s] = t.edits[s]);
                        c._exportedPlot = t._exportedPlot;
                    }
                    c.staticPlot && (c.editable = !1, c.edits = {}, c.autosizable = !1, c.scrollZoom = !1, c.doubleClick = !1, c.showTips = !1, c.showLink = !1, c.displayModeBar = !1), "hover" !== c.displayModeBar || i || (c.displayModeBar = !0), "transparent" !== c.setBackground && "function" == typeof c.setBackground || (c.setBackground = L), c._hasZeroHeight = c._hasZeroHeight || 0 === e.clientHeight, c._hasZeroWidth = c._hasZeroWidth || 0 === e.clientWidth;
                    var f = c.scrollZoom, d = c._scrollZoom = {};
                    if (!0 === f) d.cartesian = 1, d.gl3d = 1, d.geo = 1, d.mapbox = 1;
                    else if ("string" == typeof f) {
                        var h = f.split("+");
                        for(a = 0; a < h.length; a++)d[h[a]] = 1;
                    } else !1 !== f && (d.gl3d = 1, d.geo = 1, d.mapbox = 1);
                }
                function O(e, t) {
                    var r, n, a = t + 1, i = [];
                    for(r = 0; r < e.length; r++)(n = e[r]) < 0 ? i.push(a + n) : i.push(n);
                    return i;
                }
                function C(e, t, r) {
                    var n, a;
                    for(n = 0; n < t.length; n++){
                        if ((a = t[n]) !== parseInt(a, 10)) throw new Error("all values in " + r + " must be integers");
                        if (a >= e.data.length || a < -e.data.length) throw new Error(r + " must be valid indices for gd.data.");
                        if (t.indexOf(a, n + 1) > -1 || a >= 0 && t.indexOf(-e.data.length + a) > -1 || a < 0 && t.indexOf(e.data.length + a) > -1) throw new Error("each index in " + r + " must be unique.");
                    }
                }
                function P(e, t, r) {
                    if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
                    if (void 0 === t) throw new Error("currentIndices is a required argument.");
                    if (Array.isArray(t) || (t = [
                        t
                    ]), C(e, t, "currentIndices"), void 0 === r || Array.isArray(r) || (r = [
                        r
                    ]), void 0 !== r && C(e, r, "newIndices"), void 0 !== r && t.length !== r.length) throw new Error("current and new indices must be of equal length.");
                }
                function I(e, t, r, n, i) {
                    !function(e, t, r, n) {
                        var a = o.isPlainObject(n);
                        if (!Array.isArray(e.data)) throw new Error("gd.data must be an array");
                        if (!o.isPlainObject(t)) throw new Error("update must be a key:value object");
                        if (void 0 === r) throw new Error("indices must be an integer or array of integers");
                        for(var i in C(e, r, "indices"), t){
                            if (!Array.isArray(t[i]) || t[i].length !== r.length) throw new Error("attribute " + i + " must be an array of length equal to indices array length");
                            if (a && (!(i in n) || !Array.isArray(n[i]) || n[i].length !== t[i].length)) throw new Error("when maxPoints is set as a key:value object it must contain a 1:1 corrispondence with the keys and number of traces in the update object");
                        }
                    }(e, t, r, n);
                    for(var s = function(e, t, r, n) {
                        var i, s, c, u, f, d = o.isPlainObject(n), h = [];
                        for(var p in Array.isArray(r) || (r = [
                            r
                        ]), r = O(r, e.data.length - 1), t)for(var v = 0; v < r.length; v++){
                            if (i = e.data[r[v]], s = (c = l(i, p)).get(), u = t[p][v], !o.isArrayOrTypedArray(u)) throw new Error("attribute: " + p + " index: " + v + " must be an array");
                            if (!o.isArrayOrTypedArray(s)) throw new Error("cannot extend missing or non-array attribute: " + p);
                            if (s.constructor !== u.constructor) throw new Error("cannot extend array with an array of a different type: " + p);
                            f = d ? n[p][v] : n, a(f) || (f = -1), h.push({
                                prop: c,
                                target: s,
                                insert: u,
                                maxp: Math.floor(f)
                            });
                        }
                        return h;
                    }(e, t, r, n), c = {}, u = {}, f = 0; f < s.length; f++){
                        var d = s[f].prop, h = s[f].maxp, p = i(s[f].target, s[f].insert, h);
                        d.set(p[0]), Array.isArray(c[d.astr]) || (c[d.astr] = []), c[d.astr].push(p[1]), Array.isArray(u[d.astr]) || (u[d.astr] = []), u[d.astr].push(s[f].target.length);
                    }
                    return {
                        update: c,
                        maxPoints: u
                    };
                }
                function R(e, t) {
                    var r = new e.constructor(e.length + t.length);
                    return r.set(e), r.set(t, e.length), r;
                }
                function z(e, r, n, a) {
                    e = o.getGraphDiv(e), _.clearPromiseQueue(e);
                    var i = {};
                    if ("string" == typeof r) i[r] = n;
                    else {
                        if (!o.isPlainObject(r)) return o.warn("Restyle fail.", r, n, a), Promise.reject();
                        i = o.extendFlat({}, r), void 0 === a && (a = n);
                    }
                    Object.keys(i).length && (e.changed = !0);
                    var l = _.coerceTraceIndices(e, a), s = H(e, i, l), u = s.flags;
                    u.calc && (e.calcdata = void 0), u.clearAxisTypes && _.clearAxisTypes(e, l, {});
                    var f = [];
                    u.fullReplot ? f.push(t._doPlot) : (f.push(d.previousPromises), d.supplyDefaults(e), u.markerSize && (d.doCalcdata(e), V(f)), u.style && f.push(w.doTraceStyle), u.colorbars && f.push(w.doColorBars), f.push(A)), f.push(d.rehover, d.redrag, d.reselect), c.add(e, z, [
                        e,
                        s.undoit,
                        s.traces
                    ], z, [
                        e,
                        s.redoit,
                        s.traces
                    ]);
                    var h = o.syncOrAsync(f, e);
                    return h && h.then || (h = Promise.resolve()), h.then(function() {
                        return e.emit("plotly_restyle", s.eventData), e;
                    });
                }
                function N(e) {
                    return void 0 === e ? null : e;
                }
                function F(e, t) {
                    return t ? function(t, r, n) {
                        var a = l(t, r), i = a.set;
                        return a.set = function(t) {
                            E((n || "") + r, a.get(), t, e), i(t);
                        }, a;
                    } : l;
                }
                function E(e, t, r, n) {
                    if (Array.isArray(t) || Array.isArray(r)) for(var a = Array.isArray(t) ? t : [], i = Array.isArray(r) ? r : [], l = Math.max(a.length, i.length), s = 0; s < l; s++)E(e + "[" + s + "]", a[s], i[s], n);
                    else if (o.isPlainObject(t) || o.isPlainObject(r)) {
                        var c = o.isPlainObject(t) ? t : {}, u = o.isPlainObject(r) ? r : {}, f = o.extendFlat({}, c, u);
                        for(var d in f)E(e + "." + d, c[d], u[d], n);
                    } else void 0 === n[e] && (n[e] = N(t));
                }
                function H(e, t, r) {
                    var n, a = e._fullLayout, i = e._fullData, s = e.data, c = a._guiEditing, p = F(a._preGUI, c), v = o.extendDeepAll({}, t);
                    j(t);
                    var g, y = T.traceFlags(), m = {}, x = {};
                    function b() {
                        return r.map(function() {});
                    }
                    function w(e) {
                        var t = h.id2name(e);
                        -1 === g.indexOf(t) && g.push(t);
                    }
                    function M(e) {
                        return "LAYOUT" + e + ".autorange";
                    }
                    function k(e) {
                        return "LAYOUT" + e + ".range";
                    }
                    function A(e) {
                        for(var t = e; t < i.length; t++)if (i[t]._input === s[e]) return i[t];
                    }
                    function L(n, i, o) {
                        if (Array.isArray(n)) n.forEach(function(e) {
                            L(e, i, o);
                        });
                        else if (!(n in t) && !_.hasParent(t, n)) {
                            var l;
                            if ("LAYOUT" === n.substr(0, 6)) l = p(e.layout, n.replace("LAYOUT", ""));
                            else {
                                var u = r[o];
                                l = F(a._tracePreGUI[A(u)._fullInput.uid], c)(s[u], n);
                            }
                            n in x || (x[n] = b()), void 0 === x[n][o] && (x[n][o] = N(l.get())), void 0 !== i && l.set(i);
                        }
                    }
                    function S(e) {
                        return function(t) {
                            return i[t][e];
                        };
                    }
                    function D(e) {
                        return function(t, n) {
                            return !1 === t ? i[r[n]][e] : null;
                        };
                    }
                    for(var O in t){
                        if (_.hasParent(t, O)) throw new Error("cannot set " + O + " and a parent attribute simultaneously");
                        var C, P, I, R, z, E, H = t[O];
                        if ("autobinx" !== O && "autobiny" !== O || (O = O.charAt(O.length - 1) + "bins", H = Array.isArray(H) ? H.map(D(O)) : !1 === H ? r.map(S(O)) : null), m[O] = H, "LAYOUT" !== O.substr(0, 6)) {
                            for(x[O] = b(), n = 0; n < r.length; n++)if (C = s[r[n]], P = A(r[n]), R = (I = F(a._tracePreGUI[P._fullInput.uid], c)(C, O)).get(), void 0 !== (z = Array.isArray(H) ? H[n % H.length] : H)) {
                                var B = I.parts[I.parts.length - 1], Y = O.substr(0, O.length - B.length - 1), V = Y ? Y + "." : "", U = Y ? l(P, Y).get() : P;
                                if ((E = f.getTraceValObject(P, I.parts)) && E.impliedEdits && null !== z) for(var q in E.impliedEdits)L(o.relativeAttr(O, q), E.impliedEdits[q], n);
                                else if ("thicknessmode" !== B && "lenmode" !== B || R === z || "fraction" !== z && "pixels" !== z || !U) {
                                    if ("type" === O && ("pie" === z != ("pie" === R) || "funnelarea" === z != ("funnelarea" === R))) {
                                        var G = "x", Z = "y";
                                        "bar" !== z && "bar" !== R || "h" !== C.orientation || (G = "y", Z = "x"), o.swapAttrs(C, [
                                            "?",
                                            "?src"
                                        ], "labels", G), o.swapAttrs(C, [
                                            "d?",
                                            "?0"
                                        ], "label", G), o.swapAttrs(C, [
                                            "?",
                                            "?src"
                                        ], "values", Z), "pie" === R || "funnelarea" === R ? (l(C, "marker.color").set(l(C, "marker.colors").get()), a._pielayer.selectAll("g.trace").remove()) : u.traceIs(C, "cartesian") && l(C, "marker.colors").set(l(C, "marker.color").get());
                                    }
                                } else {
                                    var W = a._size, X = U.orient, J = "top" === X || "bottom" === X;
                                    if ("thicknessmode" === B) {
                                        var K = J ? W.h : W.w;
                                        L(V + "thickness", U.thickness * ("fraction" === z ? 1 / K : K), n);
                                    } else {
                                        var Q = J ? W.w : W.h;
                                        L(V + "len", U.len * ("fraction" === z ? 1 / Q : Q), n);
                                    }
                                }
                                if (x[O][n] = N(R), -1 !== [
                                    "swapxy",
                                    "swapxyaxes",
                                    "orientation",
                                    "orientationaxes"
                                ].indexOf(O)) {
                                    if ("orientation" === O) {
                                        I.set(z);
                                        var $ = C.x && !C.y ? "h" : "v";
                                        if ((I.get() || $) === P.orientation) continue;
                                    } else "orientationaxes" === O && (C.orientation = ({
                                        v: "h",
                                        h: "v"
                                    })[P.orientation]);
                                    _.swapXYData(C), y.calc = y.clearAxisTypes = !0;
                                } else -1 !== d.dataArrayContainers.indexOf(I.parts[0]) ? (_.manageArrayContainers(I, z, x), y.calc = !0) : (E ? E.arrayOk && !u.traceIs(P, "regl") && (o.isArrayOrTypedArray(z) || o.isArrayOrTypedArray(R)) ? y.calc = !0 : T.update(y, E) : y.calc = !0, I.set(z));
                            }
                            if (-1 !== [
                                "swapxyaxes",
                                "orientationaxes"
                            ].indexOf(O) && h.swap(e, r), "orientationaxes" === O) {
                                var ee = l(e.layout, "hovermode"), te = ee.get();
                                "x" === te ? ee.set("y") : "y" === te ? ee.set("x") : "x unified" === te ? ee.set("y unified") : "y unified" === te && ee.set("x unified");
                            }
                            if (-1 !== [
                                "orientation",
                                "type"
                            ].indexOf(O)) {
                                for(g = [], n = 0; n < r.length; n++){
                                    var re = s[r[n]];
                                    u.traceIs(re, "cartesian") && (w(re.xaxis || "x"), w(re.yaxis || "y"));
                                }
                                L(g.map(M), !0, 0), L(g.map(k), [
                                    0,
                                    1
                                ], 0);
                            }
                        } else I = p(e.layout, O.replace("LAYOUT", "")), x[O] = [
                            N(I.get())
                        ], I.set(Array.isArray(H) ? H[0] : H), y.calc = !0;
                    }
                    return (y.calc || y.plot) && (y.fullReplot = !0), {
                        flags: y,
                        undoit: x,
                        redoit: m,
                        traces: r,
                        eventData: o.extendDeepNoArrays([], [
                            v,
                            r
                        ])
                    };
                }
                function j(e) {
                    var t, r, n, a = o.counterRegex("axis", ".title", !1, !1), i = /colorbar\.title$/, l = Object.keys(e);
                    for(t = 0; t < l.length; t++)r = l[t], n = e[r], "title" !== r && !a.test(r) && !i.test(r) || "string" != typeof n && "number" != typeof n ? r.indexOf("titlefont") > -1 && -1 === r.indexOf("grouptitlefont") ? s(r, r.replace("titlefont", "title.font")) : r.indexOf("titleposition") > -1 ? s(r, r.replace("titleposition", "title.position")) : r.indexOf("titleside") > -1 ? s(r, r.replace("titleside", "title.side")) : r.indexOf("titleoffset") > -1 && s(r, r.replace("titleoffset", "title.offset")) : s(r, r.replace("title", "title.text"));
                    function s(t, r) {
                        e[r] = e[t], delete e[t];
                    }
                }
                function B(e, t, r) {
                    e = o.getGraphDiv(e), _.clearPromiseQueue(e);
                    var n = {};
                    if ("string" == typeof t) n[t] = r;
                    else {
                        if (!o.isPlainObject(t)) return o.warn("Relayout fail.", t, r), Promise.reject();
                        n = o.extendFlat({}, t);
                    }
                    Object.keys(n).length && (e.changed = !0);
                    var a = Z(e, n), i = a.flags;
                    i.calc && (e.calcdata = void 0);
                    var l = [
                        d.previousPromises
                    ];
                    i.layoutReplot ? l.push(w.layoutReplot) : Object.keys(n).length && (Y(e, i, a) || d.supplyDefaults(e), i.legend && l.push(w.doLegend), i.layoutstyle && l.push(w.layoutStyles), i.axrange && V(l, a.rangesAltered), i.ticks && l.push(w.doTicksRelayout), i.modebar && l.push(w.doModeBar), i.camera && l.push(w.doCamera), i.colorbars && l.push(w.doColorBars), l.push(A)), l.push(d.rehover, d.redrag, d.reselect), c.add(e, B, [
                        e,
                        a.undoit
                    ], B, [
                        e,
                        a.redoit
                    ]);
                    var s = o.syncOrAsync(l, e);
                    return s && s.then || (s = Promise.resolve(e)), s.then(function() {
                        return e.emit("plotly_relayout", a.eventData), e;
                    });
                }
                function Y(e, t, r) {
                    var n = e._fullLayout;
                    if (!t.axrange) return !1;
                    for(var a in t)if ("axrange" !== a && t[a]) return !1;
                    for(var i in r.rangesAltered){
                        var o = h.id2name(i), l = e.layout[o], s = n[o];
                        s.autorange = l.autorange;
                        var c = s._rangeInitial0, u = s._rangeInitial1;
                        if (void 0 === c && void 0 !== u || void 0 !== c && void 0 === u) return !1;
                        if (l.range && (s.range = l.range.slice()), s.cleanRange(), s._matchGroup) {
                            for(var f in s._matchGroup)if (f !== i) {
                                var d = n[h.id2name(f)];
                                d.autorange = s.autorange, d.range = s.range.slice(), d._input.range = s.range.slice();
                            }
                        }
                    }
                    return !0;
                }
                function V(e, t) {
                    var r = t ? function(e) {
                        var r = [];
                        for(var n in t){
                            var a = h.getFromId(e, n);
                            if (r.push(n), -1 !== (a.ticklabelposition || "").indexOf("inside") && a._anchorAxis && r.push(a._anchorAxis._id), a._matchGroup) for(var i in a._matchGroup)t[i] || r.push(i);
                        }
                        return h.draw(e, r, {
                            skipTitle: !0
                        });
                    } : function(e) {
                        return h.draw(e, "redraw");
                    };
                    e.push(m, w.doAutoRangeAndConstraints, r, w.drawData, w.finalDraw);
                }
                var U = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/, q = /^[xyz]axis[0-9]*\.autorange$/, G = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
                function Z(e, t) {
                    var r, n, a, i = e.layout, s = e._fullLayout, c = s._guiEditing, d = F(s._preGUI, c), p = Object.keys(t), v = h.list(e), g = o.extendDeepAll({}, t), y = {};
                    for(j(t), p = Object.keys(t), n = 0; n < p.length; n++)if (0 === p[n].indexOf("allaxes")) {
                        for(a = 0; a < v.length; a++){
                            var m = v[a]._id.substr(1), x = -1 !== m.indexOf("scene") ? m + "." : "", w = p[n].replace("allaxes", x + v[a]._name);
                            t[w] || (t[w] = t[p[n]]);
                        }
                        delete t[p[n]];
                    }
                    var k = T.layoutFlags(), A = {}, L = {};
                    function S(e, r) {
                        if (Array.isArray(e)) e.forEach(function(e) {
                            S(e, r);
                        });
                        else if (!(e in t) && !_.hasParent(t, e)) {
                            var n = d(i, e);
                            e in L || (L[e] = N(n.get())), void 0 !== r && n.set(r);
                        }
                    }
                    var D, O = {};
                    function C(e) {
                        var t = h.name2id(e.split(".")[0]);
                        return O[t] = 1, t;
                    }
                    for(var P in t){
                        if (_.hasParent(t, P)) throw new Error("cannot set " + P + " and a parent attribute simultaneously");
                        for(var I = d(i, P), R = t[P], z = I.parts.length - 1; z > 0 && "string" != typeof I.parts[z];)z--;
                        var E = I.parts[z], H = I.parts[z - 1] + "." + E, B = I.parts.slice(0, z).join("."), Y = l(e.layout, B).get(), V = l(s, B).get(), Z = I.get();
                        if (void 0 !== R) {
                            A[P] = R, L[P] = "reverse" === E ? R : N(Z);
                            var X = f.getLayoutValObject(s, I.parts);
                            if (X && X.impliedEdits && null !== R) for(var J in X.impliedEdits)S(o.relativeAttr(P, J), X.impliedEdits[J]);
                            if (-1 !== [
                                "width",
                                "height"
                            ].indexOf(P)) {
                                if (R) {
                                    S("autosize", null);
                                    var K = "height" === P ? "width" : "height";
                                    S(K, s[K]);
                                } else s[P] = e._initialAutoSize[P];
                            } else if ("autosize" === P) S("width", R ? null : s.width), S("height", R ? null : s.height);
                            else if (H.match(U)) C(H), l(s, B + "._inputRange").set(null);
                            else if (H.match(q)) {
                                C(H), l(s, B + "._inputRange").set(null);
                                var Q = l(s, B).get();
                                Q._inputDomain && (Q._input.domain = Q._inputDomain.slice());
                            } else H.match(G) && l(s, B + "._inputDomain").set(null);
                            if ("type" === E) {
                                D = Y;
                                var $ = "linear" === V.type && "log" === R, ee = "log" === V.type && "linear" === R;
                                if ($ || ee) {
                                    if (D && D.range) {
                                        if (V.autorange) $ && (D.range = D.range[1] > D.range[0] ? [
                                            1,
                                            2
                                        ] : [
                                            2,
                                            1
                                        ]);
                                        else {
                                            var te = D.range[0], re = D.range[1];
                                            $ ? (te <= 0 && re <= 0 && S(B + ".autorange", !0), te <= 0 ? te = re / 1e6 : re <= 0 && (re = te / 1e6), S(B + ".range[0]", Math.log(te) / Math.LN10), S(B + ".range[1]", Math.log(re) / Math.LN10)) : (S(B + ".range[0]", Math.pow(10, te)), S(B + ".range[1]", Math.pow(10, re)));
                                        }
                                    } else S(B + ".autorange", !0);
                                    Array.isArray(s._subplots.polar) && s._subplots.polar.length && s[I.parts[0]] && "radialaxis" === I.parts[1] && delete s[I.parts[0]]._subplot.viewInitial["radialaxis.range"], u.getComponentMethod("annotations", "convertCoords")(e, V, R, S), u.getComponentMethod("images", "convertCoords")(e, V, R, S);
                                } else S(B + ".autorange", !0), S(B + ".range", null);
                                l(s, B + "._inputRange").set(null);
                            } else if (E.match(M)) {
                                var ne = l(s, P).get(), ae = (R || {}).type;
                                ae && "-" !== ae || (ae = "linear"), u.getComponentMethod("annotations", "convertCoords")(e, ne, ae, S), u.getComponentMethod("images", "convertCoords")(e, ne, ae, S);
                            }
                            var ie = b.containerArrayMatch(P);
                            if (ie) {
                                r = ie.array, n = ie.index;
                                var oe = ie.property, le = X || {
                                    editType: "calc"
                                };
                                "" !== n && "" === oe && (b.isAddVal(R) ? L[P] = null : b.isRemoveVal(R) ? L[P] = (l(i, r).get() || [])[n] : o.warn("unrecognized full object value", t)), T.update(k, le), y[r] || (y[r] = {});
                                var se = y[r][n];
                                se || (se = y[r][n] = {}), se[oe] = R, delete t[P];
                            } else "reverse" === E ? (Y.range ? Y.range.reverse() : (S(B + ".autorange", !0), Y.range = [
                                1,
                                0
                            ]), V.autorange ? k.calc = !0 : k.plot = !0) : ("dragmode" === P && (!1 === R && !1 !== Z || !1 !== R && !1 === Z) || s._has("scatter-like") && s._has("regl") && "dragmode" === P && ("lasso" === R || "select" === R) && "lasso" !== Z && "select" !== Z || s._has("gl2d") ? k.plot = !0 : X ? T.update(k, X) : k.calc = !0, I.set(R));
                        }
                    }
                    for(r in y)b.applyContainerArrayChanges(e, d(i, r), y[r], k, d) || (k.plot = !0);
                    for(var ce in O){
                        var ue = (D = h.getFromId(e, ce)) && D._constraintGroup;
                        if (ue) for(var fe in k.calc = !0, ue)O[fe] || (h.getFromId(e, fe)._constraintShrinkable = !0);
                    }
                    (W(e) || t.height || t.width) && (k.plot = !0);
                    var de = s.shapes;
                    for(n = 0; n < de.length; n++)if (de[n].showlegend) {
                        k.calc = !0;
                        break;
                    }
                    return (k.plot || k.calc) && (k.layoutReplot = !0), {
                        flags: k,
                        rangesAltered: O,
                        undoit: L,
                        redoit: A,
                        eventData: g
                    };
                }
                function W(e) {
                    var t = e._fullLayout, r = t.width, n = t.height;
                    return e.layout.autosize && d.plotAutoSize(e, e.layout, t), t.width !== r || t.height !== n;
                }
                function X(e, r, n, a) {
                    e = o.getGraphDiv(e), _.clearPromiseQueue(e), o.isPlainObject(r) || (r = {}), o.isPlainObject(n) || (n = {}), Object.keys(r).length && (e.changed = !0), Object.keys(n).length && (e.changed = !0);
                    var i = _.coerceTraceIndices(e, a), l = H(e, o.extendFlat({}, r), i), s = l.flags, u = Z(e, o.extendFlat({}, n)), f = u.flags;
                    (s.calc || f.calc) && (e.calcdata = void 0), s.clearAxisTypes && _.clearAxisTypes(e, i, n);
                    var h = [];
                    f.layoutReplot ? h.push(w.layoutReplot) : s.fullReplot ? h.push(t._doPlot) : (h.push(d.previousPromises), Y(e, f, u) || d.supplyDefaults(e), s.style && h.push(w.doTraceStyle), (s.colorbars || f.colorbars) && h.push(w.doColorBars), f.legend && h.push(w.doLegend), f.layoutstyle && h.push(w.layoutStyles), f.axrange && V(h, u.rangesAltered), f.ticks && h.push(w.doTicksRelayout), f.modebar && h.push(w.doModeBar), f.camera && h.push(w.doCamera), h.push(A)), h.push(d.rehover, d.redrag, d.reselect), c.add(e, X, [
                        e,
                        l.undoit,
                        u.undoit,
                        l.traces
                    ], X, [
                        e,
                        l.redoit,
                        u.redoit,
                        l.traces
                    ]);
                    var p = o.syncOrAsync(h, e);
                    return p && p.then || (p = Promise.resolve(e)), p.then(function() {
                        return e.emit("plotly_update", {
                            data: l.eventData,
                            layout: u.eventData
                        }), e;
                    });
                }
                function J(e) {
                    return function(t) {
                        t._fullLayout._guiEditing = !0;
                        var r = e.apply(null, arguments);
                        return t._fullLayout._guiEditing = !1, r;
                    };
                }
                var K = [
                    {
                        pattern: /^hiddenlabels/,
                        attr: "legend.uirevision"
                    },
                    {
                        pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/
                    },
                    {
                        pattern: /axis\d*\.showspikes$/,
                        attr: "modebar.uirevision"
                    },
                    {
                        pattern: /(hover|drag)mode$/,
                        attr: "modebar.uirevision"
                    },
                    {
                        pattern: /^(scene\d*)\.camera/
                    },
                    {
                        pattern: /^(geo\d*)\.(projection|center|fitbounds)/
                    },
                    {
                        pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/
                    },
                    {
                        pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/
                    },
                    {
                        pattern: /^(polar\d*\.angularaxis)\.rotation/
                    },
                    {
                        pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/
                    },
                    {
                        pattern: /^legend\.(x|y)$/,
                        attr: "editrevision"
                    },
                    {
                        pattern: /^(shapes|annotations)/,
                        attr: "editrevision"
                    },
                    {
                        pattern: /^title\.text$/,
                        attr: "editrevision"
                    }
                ], Q = [
                    {
                        pattern: /^selectedpoints$/,
                        attr: "selectionrevision"
                    },
                    {
                        pattern: /(^|value\.)visible$/,
                        attr: "legend.uirevision"
                    },
                    {
                        pattern: /^dimensions\[\d+\]\.constraintrange/
                    },
                    {
                        pattern: /^node\.(x|y|groups)/
                    },
                    {
                        pattern: /^level$/
                    },
                    {
                        pattern: /(^|value\.)name$/
                    },
                    {
                        pattern: /colorbar\.title\.text$/
                    },
                    {
                        pattern: /colorbar\.(x|y)$/,
                        attr: "editrevision"
                    }
                ];
                function $(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r], a = e.match(n.pattern);
                        if (a) {
                            var i = a[1] || "";
                            return {
                                head: i,
                                tail: e.substr(i.length + 1),
                                attr: n.attr
                            };
                        }
                    }
                }
                function ee(e, t) {
                    var r = l(t, e).get();
                    if (void 0 !== r) return r;
                    var n = e.split(".");
                    for(n.pop(); n.length > 1;)if (n.pop(), void 0 !== (r = l(t, n.join(".") + ".uirevision").get())) return r;
                    return t.uirevision;
                }
                function te(e, t) {
                    for(var r = 0; r < t.length; r++)if (t[r]._fullInput.uid === e) return r;
                    return -1;
                }
                function re(e, t, r) {
                    for(var n = 0; n < t.length; n++)if (t[n].uid === e) return n;
                    return !t[r] || t[r].uid ? -1 : r;
                }
                function ne(e, t) {
                    var r = o.isPlainObject(e), n = Array.isArray(e);
                    return r || n ? (r && o.isPlainObject(t) || n && Array.isArray(t)) && JSON.stringify(e) === JSON.stringify(t) : e === t;
                }
                function ae(e, t, r, n) {
                    var a, i, s, c = n.getValObject, u = n.flags, f = n.immutable, d = n.inArray, h = n.arrayIndex;
                    function p() {
                        var e = a.editType;
                        d && -1 !== e.indexOf("arraydraw") ? o.pushUnique(u.arrays[d], h) : (T.update(u, a), "none" !== e && u.nChanges++, n.transition && a.anim && u.nChangesAnim++, (U.test(s) || q.test(s)) && (u.rangesAltered[r[0]] = 1), G.test(s) && l(t, "_inputDomain").set(null), "datarevision" === i && (u.newDataRevision = 1));
                    }
                    function v(e) {
                        return "data_array" === e.valType || e.arrayOk;
                    }
                    for(i in e){
                        if (u.calc && !n.transition) return;
                        var g = e[i], y = t[i], m = r.concat(i);
                        if (s = m.join("."), "_" !== i.charAt(0) && "function" != typeof g && g !== y) {
                            if (("tick0" === i || "dtick" === i) && "geo" !== r[0]) {
                                var x = t.tickmode;
                                if ("auto" === x || "array" === x || !x) continue;
                            }
                            if (("range" !== i || !t.autorange) && ("zmin" !== i && "zmax" !== i || "contourcarpet" !== t.type) && (a = c(m)) && (!a._compareAsJSON || JSON.stringify(g) !== JSON.stringify(y))) {
                                var b, _ = a.valType, w = v(a), M = Array.isArray(g), k = Array.isArray(y);
                                if (M && k) {
                                    var A = "_input_" + i, L = e[A], S = t[A];
                                    if (Array.isArray(L) && L === S) continue;
                                }
                                if (void 0 === y) w && M ? u.calc = !0 : p();
                                else if (a._isLinkedToArray) {
                                    var D = [], O = !1;
                                    d || (u.arrays[i] = D);
                                    var C = Math.min(g.length, y.length), P = Math.max(g.length, y.length);
                                    if (C !== P) {
                                        if ("arraydraw" !== a.editType) {
                                            p();
                                            continue;
                                        }
                                        O = !0;
                                    }
                                    for(b = 0; b < C; b++)ae(g[b], y[b], m.concat(b), o.extendFlat({
                                        inArray: i,
                                        arrayIndex: b
                                    }, n));
                                    if (O) for(b = C; b < P; b++)D.push(b);
                                } else !_ && o.isPlainObject(g) ? ae(g, y, m, n) : w ? M && k ? (f && (u.calc = !0), (f || n.newDataRevision) && p()) : M !== k ? u.calc = !0 : p() : M && k && g.length === y.length && String(g) === String(y) || p();
                            }
                        }
                    }
                    for(i in t)if (!(i in e) && "_" !== i.charAt(0) && "function" != typeof t[i]) {
                        if (v(a = c(r.concat(i))) && Array.isArray(t[i])) return void (u.calc = !0);
                        p();
                    }
                }
                function ie(e, t) {
                    var r;
                    for(r in e)if ("_" !== r.charAt(0)) {
                        var n = e[r], a = t[r];
                        if (n !== a) {
                            if (o.isPlainObject(n) && o.isPlainObject(a)) {
                                if (ie(n, a)) return !0;
                            } else {
                                if (!Array.isArray(n) || !Array.isArray(a)) return !0;
                                if (n.length !== a.length) return !0;
                                for(var i = 0; i < n.length; i++)if (n[i] !== a[i]) {
                                    if (!o.isPlainObject(n[i]) || !o.isPlainObject(a[i])) return !0;
                                    if (ie(n[i], a[i])) return !0;
                                }
                            }
                        }
                    }
                }
                function oe(e) {
                    var t = e._fullLayout, r = e.getBoundingClientRect();
                    if (!o.equalDomRects(r, t._lastBBox)) {
                        var n = t._invTransform = o.inverseTransformMatrix(o.getFullTransformMatrix(e));
                        t._invScaleX = Math.sqrt(n[0][0] * n[0][0] + n[0][1] * n[0][1] + n[0][2] * n[0][2]), t._invScaleY = Math.sqrt(n[1][0] * n[1][0] + n[1][1] * n[1][1] + n[1][2] * n[1][2]), t._lastBBox = r;
                    }
                }
                t.animate = function(e, t, r) {
                    if (e = o.getGraphDiv(e), !o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before animating it. For more details, see https://plotly.com/javascript/animations/");
                    var n = e._transitionData;
                    n._frameQueue || (n._frameQueue = []);
                    var a = (r = d.supplyAnimationDefaults(r)).transition, i = r.frame;
                    function l(e) {
                        return Array.isArray(a) ? e >= a.length ? a[0] : a[e] : a;
                    }
                    function s(e) {
                        return Array.isArray(i) ? e >= i.length ? i[0] : i[e] : i;
                    }
                    function c(e, t) {
                        var r = 0;
                        return function() {
                            if (e && ++r === t) return e();
                        };
                    }
                    return void 0 === n._frameWaitingCnt && (n._frameWaitingCnt = 0), new Promise(function(i, u) {
                        function f() {
                            e.emit("plotly_animating"), n._lastFrameAt = -1 / 0, n._timeToNext = 0, n._runningTransitions = 0, n._currentFrame = null;
                            var t = function() {
                                n._animationRaf = window.requestAnimationFrame(t), Date.now() - n._lastFrameAt > n._timeToNext && function() {
                                    n._currentFrame && n._currentFrame.onComplete && n._currentFrame.onComplete();
                                    var t = n._currentFrame = n._frameQueue.shift();
                                    if (t) {
                                        var r = t.name ? t.name.toString() : null;
                                        e._fullLayout._currentFrame = r, n._lastFrameAt = Date.now(), n._timeToNext = t.frameOpts.duration, d.transition(e, t.frame.data, t.frame.layout, _.coerceTraceIndices(e, t.frame.traces), t.frameOpts, t.transitionOpts).then(function() {
                                            t.onComplete && t.onComplete();
                                        }), e.emit("plotly_animatingframe", {
                                            name: r,
                                            frame: t.frame,
                                            animation: {
                                                frame: t.frameOpts,
                                                transition: t.transitionOpts
                                            }
                                        });
                                    } else e.emit("plotly_animated"), window.cancelAnimationFrame(n._animationRaf), n._animationRaf = null;
                                }();
                            };
                            t();
                        }
                        var h, p, v = 0;
                        function g(e) {
                            return Array.isArray(a) ? v >= a.length ? e.transitionOpts = a[v] : e.transitionOpts = a[0] : e.transitionOpts = a, v++, e;
                        }
                        var y = [], m = null == t, x = Array.isArray(t);
                        if (m || x || !o.isPlainObject(t)) {
                            if (m || -1 !== [
                                "string",
                                "number"
                            ].indexOf(typeof t)) for(h = 0; h < n._frames.length; h++)(p = n._frames[h]) && (m || String(p.group) === String(t)) && y.push({
                                type: "byname",
                                name: String(p.name),
                                data: g({
                                    name: p.name
                                })
                            });
                            else if (x) for(h = 0; h < t.length; h++){
                                var b = t[h];
                                -1 !== [
                                    "number",
                                    "string"
                                ].indexOf(typeof b) ? (b = String(b), y.push({
                                    type: "byname",
                                    name: b,
                                    data: g({
                                        name: b
                                    })
                                })) : o.isPlainObject(b) && y.push({
                                    type: "object",
                                    data: g(o.extendFlat({}, b))
                                });
                            }
                        } else y.push({
                            type: "object",
                            data: g(o.extendFlat({}, t))
                        });
                        for(h = 0; h < y.length; h++)if ("byname" === (p = y[h]).type && !n._frameHash[p.data.name]) return o.warn('animate failure: frame not found: "' + p.data.name + '"'), void u();
                        -1 !== [
                            "next",
                            "immediate"
                        ].indexOf(r.mode) && function() {
                            if (0 !== n._frameQueue.length) {
                                for(; n._frameQueue.length;){
                                    var t = n._frameQueue.pop();
                                    t.onInterrupt && t.onInterrupt();
                                }
                                e.emit("plotly_animationinterrupted", []);
                            }
                        }(), "reverse" === r.direction && y.reverse();
                        var w = e._fullLayout._currentFrame;
                        if (w && r.fromcurrent) {
                            var T = -1;
                            for(h = 0; h < y.length; h++)if ("byname" === (p = y[h]).type && p.name === w) {
                                T = h;
                                break;
                            }
                            if (T > 0 && T < y.length - 1) {
                                var M = [];
                                for(h = 0; h < y.length; h++)p = y[h], ("byname" !== y[h].type || h > T) && M.push(p);
                                y = M;
                            }
                        }
                        y.length > 0 ? function(t) {
                            if (0 !== t.length) {
                                for(var a = 0; a < t.length; a++){
                                    var o;
                                    o = "byname" === t[a].type ? d.computeFrame(e, t[a].name) : t[a].data;
                                    var h = s(a), p = l(a);
                                    p.duration = Math.min(p.duration, h.duration);
                                    var v = {
                                        frame: o,
                                        name: t[a].name,
                                        frameOpts: h,
                                        transitionOpts: p
                                    };
                                    a === t.length - 1 && (v.onComplete = c(i, 2), v.onInterrupt = u), n._frameQueue.push(v);
                                }
                                "immediate" === r.mode && (n._lastFrameAt = -1 / 0), n._animationRaf || f();
                            }
                        }(y) : (e.emit("plotly_animated"), i());
                    });
                }, t.addFrames = function(e, t, r) {
                    if (e = o.getGraphDiv(e), null == t) return Promise.resolve();
                    if (!o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before adding frames. For more details, see https://plotly.com/javascript/animations/");
                    var n, a, i, l, s = e._transitionData._frames, u = e._transitionData._frameHash;
                    if (!Array.isArray(t)) throw new Error("addFrames failure: frameList must be an Array of frame definitions" + t);
                    var f = s.length + 2 * t.length, h = [], p = {};
                    for(n = t.length - 1; n >= 0; n--)if (o.isPlainObject(t[n])) {
                        var v = t[n].name, g = (u[v] || p[v] || {}).name, y = t[n].name, m = u[g] || p[g];
                        g && y && "number" == typeof y && m && k < 5 && (k++, o.warn('addFrames: overwriting frame "' + (u[g] || p[g]).name + '" with a frame whose name of type "number" also equates to "' + g + '". This is valid but may potentially lead to unexpected behavior since all plotly.js frame names are stored internally as strings.'), 5 === k && o.warn("addFrames: This API call has yielded too many of these warnings. For the rest of this call, further warnings about numeric frame names will be suppressed.")), p[v] = {
                            name: v
                        }, h.push({
                            frame: d.supplyFrameDefaults(t[n]),
                            index: r && void 0 !== r[n] && null !== r[n] ? r[n] : f + n
                        });
                    }
                    h.sort(function(e, t) {
                        return e.index > t.index ? -1 : e.index < t.index ? 1 : 0;
                    });
                    var x = [], b = [], _ = s.length;
                    for(n = h.length - 1; n >= 0; n--){
                        if ("number" == typeof (a = h[n].frame).name && o.warn("Warning: addFrames accepts frames with numeric names, but the numbers areimplicitly cast to strings"), !a.name) for(; u[a.name = "frame " + e._transitionData._counter++];);
                        if (u[a.name]) {
                            for(i = 0; i < s.length && (s[i] || {}).name !== a.name; i++);
                            x.push({
                                type: "replace",
                                index: i,
                                value: a
                            }), b.unshift({
                                type: "replace",
                                index: i,
                                value: s[i]
                            });
                        } else l = Math.max(0, Math.min(h[n].index, _)), x.push({
                            type: "insert",
                            index: l,
                            value: a
                        }), b.unshift({
                            type: "delete",
                            index: l
                        }), _++;
                    }
                    var w = d.modifyFrames, T = d.modifyFrames, M = [
                        e,
                        b
                    ], A = [
                        e,
                        x
                    ];
                    return c && c.add(e, w, M, T, A), d.modifyFrames(e, x);
                }, t.deleteFrames = function(e, t) {
                    if (e = o.getGraphDiv(e), !o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
                    var r, n, a = e._transitionData._frames, i = [], l = [];
                    if (!t) for(t = [], r = 0; r < a.length; r++)t.push(r);
                    for((t = t.slice()).sort(), r = t.length - 1; r >= 0; r--)n = t[r], i.push({
                        type: "delete",
                        index: n
                    }), l.unshift({
                        type: "insert",
                        index: n,
                        value: a[n]
                    });
                    var s = d.modifyFrames, u = d.modifyFrames, f = [
                        e,
                        l
                    ], h = [
                        e,
                        i
                    ];
                    return c && c.add(e, s, f, u, h), d.modifyFrames(e, i);
                }, t.addTraces = function e(r, n, a) {
                    r = o.getGraphDiv(r);
                    var i, l, s = [], u = t.deleteTraces, f = e, d = [
                        r,
                        s
                    ], h = [
                        r,
                        n
                    ];
                    for(function(e, t, r) {
                        var n, a;
                        if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
                        if (void 0 === t) throw new Error("traces must be defined.");
                        for(Array.isArray(t) || (t = [
                            t
                        ]), n = 0; n < t.length; n++)if ("object" != typeof (a = t[n]) || Array.isArray(a) || null === a) throw new Error("all values in traces array must be non-array objects");
                        if (void 0 === r || Array.isArray(r) || (r = [
                            r
                        ]), void 0 !== r && r.length !== t.length) throw new Error("if indices is specified, traces.length must equal indices.length");
                    }(r, n, a), Array.isArray(n) || (n = [
                        n
                    ]), n = n.map(function(e) {
                        return o.extendFlat({}, e);
                    }), _.cleanData(n), i = 0; i < n.length; i++)r.data.push(n[i]);
                    for(i = 0; i < n.length; i++)s.push(-n.length + i);
                    if (void 0 === a) return l = t.redraw(r), c.add(r, u, d, f, h), l;
                    Array.isArray(a) || (a = [
                        a
                    ]);
                    try {
                        P(r, s, a);
                    } catch (e) {
                        throw r.data.splice(r.data.length - n.length, n.length), e;
                    }
                    return c.startSequence(r), c.add(r, u, d, f, h), l = t.moveTraces(r, s, a), c.stopSequence(r), l;
                }, t.deleteTraces = function e(r, n) {
                    r = o.getGraphDiv(r);
                    var a, i, l = [], s = t.addTraces, u = e, f = [
                        r,
                        l,
                        n
                    ], d = [
                        r,
                        n
                    ];
                    if (void 0 === n) throw new Error("indices must be an integer or array of integers.");
                    for(Array.isArray(n) || (n = [
                        n
                    ]), C(r, n, "indices"), (n = O(n, r.data.length - 1)).sort(o.sorterDes), a = 0; a < n.length; a += 1)i = r.data.splice(n[a], 1)[0], l.push(i);
                    var h = t.redraw(r);
                    return c.add(r, s, f, u, d), h;
                }, t.extendTraces = function e(r, n, a, i) {
                    var l = I(r = o.getGraphDiv(r), n, a, i, function(e, t, r) {
                        var n, a;
                        if (o.isTypedArray(e)) {
                            if (r < 0) {
                                var i = new e.constructor(0), l = R(e, t);
                                r < 0 ? (n = l, a = i) : (n = i, a = l);
                            } else if (n = new e.constructor(r), a = new e.constructor(e.length + t.length - r), r === t.length) n.set(t), a.set(e);
                            else if (r < t.length) {
                                var s = t.length - r;
                                n.set(t.subarray(s)), a.set(e), a.set(t.subarray(0, s), e.length);
                            } else {
                                var c = r - t.length, u = e.length - c;
                                n.set(e.subarray(u)), n.set(t, c), a.set(e.subarray(0, u));
                            }
                        } else n = e.concat(t), a = r >= 0 && r < n.length ? n.splice(0, n.length - r) : [];
                        return [
                            n,
                            a
                        ];
                    }), s = t.redraw(r), u = [
                        r,
                        l.update,
                        a,
                        l.maxPoints
                    ];
                    return c.add(r, t.prependTraces, u, e, arguments), s;
                }, t.moveTraces = function e(r, n, a) {
                    var i, l = [], s = [], u = e, f = e, d = [
                        r = o.getGraphDiv(r),
                        a,
                        n
                    ], h = [
                        r,
                        n,
                        a
                    ];
                    if (P(r, n, a), n = Array.isArray(n) ? n : [
                        n
                    ], void 0 === a) for(a = [], i = 0; i < n.length; i++)a.push(-n.length + i);
                    for(a = Array.isArray(a) ? a : [
                        a
                    ], n = O(n, r.data.length - 1), a = O(a, r.data.length - 1), i = 0; i < r.data.length; i++)-1 === n.indexOf(i) && l.push(r.data[i]);
                    for(i = 0; i < n.length; i++)s.push({
                        newIndex: a[i],
                        trace: r.data[n[i]]
                    });
                    for(s.sort(function(e, t) {
                        return e.newIndex - t.newIndex;
                    }), i = 0; i < s.length; i += 1)l.splice(s[i].newIndex, 0, s[i].trace);
                    r.data = l;
                    var p = t.redraw(r);
                    return c.add(r, u, d, f, h), p;
                }, t.prependTraces = function e(r, n, a, i) {
                    var l = I(r = o.getGraphDiv(r), n, a, i, function(e, t, r) {
                        var n, a;
                        if (o.isTypedArray(e)) {
                            if (r <= 0) {
                                var i = new e.constructor(0), l = R(t, e);
                                r < 0 ? (n = l, a = i) : (n = i, a = l);
                            } else if (n = new e.constructor(r), a = new e.constructor(e.length + t.length - r), r === t.length) n.set(t), a.set(e);
                            else if (r < t.length) {
                                var s = t.length - r;
                                n.set(t.subarray(0, s)), a.set(t.subarray(s)), a.set(e, s);
                            } else {
                                var c = r - t.length;
                                n.set(t), n.set(e.subarray(0, c), t.length), a.set(e.subarray(c));
                            }
                        } else n = t.concat(e), a = r >= 0 && r < n.length ? n.splice(r, n.length) : [];
                        return [
                            n,
                            a
                        ];
                    }), s = t.redraw(r), u = [
                        r,
                        l.update,
                        a,
                        l.maxPoints
                    ];
                    return c.add(r, t.extendTraces, u, e, arguments), s;
                }, t.newPlot = function(e, r, n, a) {
                    return e = o.getGraphDiv(e), d.cleanPlot([], {}, e._fullData || [], e._fullLayout || {}), d.purge(e), t._doPlot(e, r, n, a);
                }, t._doPlot = function(e, r, a, i) {
                    var l;
                    if (e = o.getGraphDiv(e), s.init(e), o.isPlainObject(r)) {
                        var c = r;
                        r = c.data, a = c.layout, i = c.config, l = c.frames;
                    }
                    if (!1 === s.triggerHandler(e, "plotly_beforeplot", [
                        r,
                        a,
                        i
                    ])) return Promise.reject();
                    r || a || o.isPlotDiv(e) || o.warn("Calling _doPlot as if redrawing but this container doesn't yet have a plot.", e), D(e, i), a || (a = {}), n.select(e).classed("js-plotly-plot", !0), p.makeTester(), Array.isArray(e._promises) || (e._promises = []);
                    var f = 0 === (e.data || []).length && Array.isArray(r);
                    Array.isArray(r) && (_.cleanData(r), f ? e.data = r : e.data.push.apply(e.data, r), e.empty = !1), e.layout && !f || (e.layout = _.cleanLayout(a)), d.supplyDefaults(e);
                    var v = e._fullLayout, m = v._has("cartesian");
                    v._replotting = !0, (f || v._shouldCreateBgLayer) && (function(e) {
                        var t = n.select(e), r = e._fullLayout;
                        if (r._calcInverseTransform = oe, r._calcInverseTransform(e), r._container = t.selectAll(".plot-container").data([
                            0
                        ]), r._container.enter().insert("div", ":first-child").classed("plot-container", !0).classed("plotly", !0), r._paperdiv = r._container.selectAll(".svg-container").data([
                            0
                        ]), r._paperdiv.enter().append("div").classed("user-select-none", !0).classed("svg-container", !0).style("position", "relative"), r._glcontainer = r._paperdiv.selectAll(".gl-container").data([
                            {}
                        ]), r._glcontainer.enter().append("div").classed("gl-container", !0), r._paperdiv.selectAll(".main-svg").remove(), r._paperdiv.select(".modebar-container").remove(), r._paper = r._paperdiv.insert("svg", ":first-child").classed("main-svg", !0), r._toppaper = r._paperdiv.append("svg").classed("main-svg", !0), r._modebardiv = r._paperdiv.append("div"), delete r._modeBar, r._hoverpaper = r._paperdiv.append("svg").classed("main-svg", !0), !r._uid) {
                            var a = {};
                            n.selectAll("defs").each(function() {
                                this.id && (a[this.id.split("-")[1]] = 1);
                            }), r._uid = o.randstr(a);
                        }
                        r._paperdiv.selectAll(".main-svg").attr(y.svgAttrs), r._defs = r._paper.append("defs").attr("id", "defs-" + r._uid), r._clips = r._defs.append("g").classed("clips", !0), r._topdefs = r._toppaper.append("defs").attr("id", "topdefs-" + r._uid), r._topclips = r._topdefs.append("g").classed("clips", !0), r._bgLayer = r._paper.append("g").classed("bglayer", !0), r._draggers = r._paper.append("g").classed("draglayer", !0);
                        var i = r._paper.append("g").classed("layer-below", !0);
                        r._imageLowerLayer = i.append("g").classed("imagelayer", !0), r._shapeLowerLayer = i.append("g").classed("shapelayer", !0), r._cartesianlayer = r._paper.append("g").classed("cartesianlayer", !0), r._polarlayer = r._paper.append("g").classed("polarlayer", !0), r._smithlayer = r._paper.append("g").classed("smithlayer", !0), r._ternarylayer = r._paper.append("g").classed("ternarylayer", !0), r._geolayer = r._paper.append("g").classed("geolayer", !0), r._funnelarealayer = r._paper.append("g").classed("funnelarealayer", !0), r._pielayer = r._paper.append("g").classed("pielayer", !0), r._iciclelayer = r._paper.append("g").classed("iciclelayer", !0), r._treemaplayer = r._paper.append("g").classed("treemaplayer", !0), r._sunburstlayer = r._paper.append("g").classed("sunburstlayer", !0), r._indicatorlayer = r._toppaper.append("g").classed("indicatorlayer", !0), r._glimages = r._paper.append("g").classed("glimages", !0);
                        var l = r._toppaper.append("g").classed("layer-above", !0);
                        r._imageUpperLayer = l.append("g").classed("imagelayer", !0), r._shapeUpperLayer = l.append("g").classed("shapelayer", !0), r._selectionLayer = r._toppaper.append("g").classed("selectionlayer", !0), r._infolayer = r._toppaper.append("g").classed("infolayer", !0), r._menulayer = r._toppaper.append("g").classed("menulayer", !0), r._zoomlayer = r._toppaper.append("g").classed("zoomlayer", !0), r._hoverlayer = r._hoverpaper.append("g").classed("hoverlayer", !0), r._modebardiv.classed("modebar-container", !0).style("position", "absolute").style("top", "0px").style("right", "0px"), e.emit("plotly_framework");
                    }(e), v._shouldCreateBgLayer && delete v._shouldCreateBgLayer), p.initGradients(e), p.initPatterns(e), f && h.saveShowSpikeInitial(e);
                    var x = !e.calcdata || e.calcdata.length !== (e._fullData || []).length;
                    x && d.doCalcdata(e);
                    for(var b = 0; b < e.calcdata.length; b++)e.calcdata[b][0].trace = e._fullData[b];
                    e._context.responsive ? e._responsiveChartHandler || (e._responsiveChartHandler = function() {
                        o.isHidden(e) || d.resize(e);
                    }, window.addEventListener("resize", e._responsiveChartHandler)) : o.clearResponsive(e);
                    var T = o.extendFlat({}, v._size), M = 0;
                    function k() {
                        if (d.clearAutoMarginIds(e), w.drawMarginPushers(e), h.allowAutoMargin(e), e._fullLayout.title.text && e._fullLayout.title.automargin && d.allowAutoMargin(e, "title.automargin"), v._has("pie")) for(var t = e._fullData, r = 0; r < t.length; r++){
                            var n = t[r];
                            "pie" === n.type && n.automargin && d.allowAutoMargin(e, "pie." + n.uid + ".automargin");
                        }
                        return d.doAutoMargin(e), d.previousPromises(e);
                    }
                    function L() {
                        e._transitioning || (w.doAutoRangeAndConstraints(e), f && h.saveRangeInitial(e), u.getComponentMethod("rangeslider", "calcAutorange")(e));
                    }
                    var S = [
                        d.previousPromises,
                        function() {
                            if (l) return t.addFrames(e, l);
                        },
                        function t() {
                            for(var r = v._basePlotModules, n = 0; n < r.length; n++)r[n].drawFramework && r[n].drawFramework(e);
                            !v._glcanvas && v._has("gl") && (v._glcanvas = v._glcontainer.selectAll(".gl-canvas").data([
                                {
                                    key: "contextLayer",
                                    context: !0,
                                    pick: !1
                                },
                                {
                                    key: "focusLayer",
                                    context: !1,
                                    pick: !1
                                },
                                {
                                    key: "pickLayer",
                                    context: !1,
                                    pick: !0
                                }
                            ], function(e) {
                                return e.key;
                            }), v._glcanvas.enter().append("canvas").attr("class", function(e) {
                                return "gl-canvas gl-canvas-" + e.key.replace("Layer", "");
                            }).style({
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible",
                                "pointer-events": "none"
                            }));
                            var a = e._context.plotGlPixelRatio;
                            if (v._glcanvas) {
                                v._glcanvas.attr("width", v.width * a).attr("height", v.height * a).style("width", v.width + "px").style("height", v.height + "px");
                                var i = v._glcanvas.data()[0].regl;
                                if (i && (Math.floor(v.width * a) !== i._gl.drawingBufferWidth || Math.floor(v.height * a) !== i._gl.drawingBufferHeight)) {
                                    var l = "WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.";
                                    if (!M) return o.log(l + " Clearing graph and plotting again."), d.cleanPlot([], {}, e._fullData, v), d.supplyDefaults(e), v = e._fullLayout, d.doCalcdata(e), M++, t();
                                    o.error(l);
                                }
                            }
                            return "h" === v.modebar.orientation ? v._modebardiv.style("height", null).style("width", "100%") : v._modebardiv.style("width", null).style("height", v.height + "px"), d.previousPromises(e);
                        },
                        k,
                        function() {
                            if (d.didMarginChange(T, v._size)) return o.syncOrAsync([
                                k,
                                w.layoutStyles
                            ], e);
                        }
                    ];
                    m && S.push(function() {
                        if (x) return o.syncOrAsync([
                            u.getComponentMethod("shapes", "calcAutorange"),
                            u.getComponentMethod("annotations", "calcAutorange"),
                            L
                        ], e);
                        L();
                    }), S.push(w.layoutStyles), m && S.push(function() {
                        return h.draw(e, f ? "" : "redraw");
                    }, function(e) {
                        e._fullLayout._insideTickLabelsAutorange && B(e, e._fullLayout._insideTickLabelsAutorange).then(function() {
                            e._fullLayout._insideTickLabelsAutorange = void 0;
                        });
                    }), S.push(w.drawData, w.finalDraw, g, d.addLinks, d.rehover, d.redrag, d.reselect, d.doAutoMargin, function(e) {
                        e._fullLayout._insideTickLabelsAutorange && f && h.saveRangeInitial(e, !0);
                    }, d.previousPromises);
                    var O = o.syncOrAsync(S, e);
                    return O && O.then || (O = Promise.resolve()), O.then(function() {
                        return A(e), e;
                    });
                }, t.purge = function(e) {
                    var t = (e = o.getGraphDiv(e))._fullLayout || {}, r = e._fullData || [];
                    return d.cleanPlot([], {}, r, t), d.purge(e), s.purge(e), t._container && t._container.remove(), delete e._context, e;
                }, t.react = function(e, r, n, a) {
                    var i, s;
                    e = o.getGraphDiv(e), _.clearPromiseQueue(e);
                    var c = e._fullData, h = e._fullLayout;
                    if (o.isPlotDiv(e) && c && h) {
                        if (o.isPlainObject(r)) {
                            var p = r;
                            r = p.data, n = p.layout, a = p.config, i = p.frames;
                        }
                        var v = !1;
                        if (a) {
                            var g = o.extendDeep({}, e._context);
                            e._context = void 0, D(e, a), v = ie(g, e._context);
                        }
                        e.data = r || [], _.cleanData(e.data), e.layout = n || {}, _.cleanLayout(e.layout), function(e, t, r, n) {
                            var a, i, s, c, u, f, d, h, p, v, g = n._preGUI, y = [], m = {}, x = {};
                            for(a in g){
                                if (u = $(a, K)) {
                                    if (p = u.head, v = u.tail, i = u.attr || p + ".uirevision", (c = (s = l(n, i).get()) && ee(i, t)) && c === s) {
                                        if (null === (f = g[a]) && (f = void 0), ne(h = (d = l(t, a)).get(), f)) {
                                            void 0 === h && "autorange" === v && y.push(p), d.set(N(l(n, a).get()));
                                            continue;
                                        }
                                        if ("autorange" === v || "range[" === v.substr(0, 6)) {
                                            var b = g[p + ".range[0]"], _ = g[p + ".range[1]"], w = g[p + ".autorange"];
                                            if (w || null === w && null === b && null === _) {
                                                if (!(p in m)) {
                                                    var T = l(t, p).get();
                                                    m[p] = T && (T.autorange || !1 !== T.autorange && (!T.range || 2 !== T.range.length));
                                                }
                                                if (m[p]) {
                                                    d.set(N(l(n, a).get()));
                                                    continue;
                                                }
                                            }
                                        }
                                    }
                                } else o.warn("unrecognized GUI edit: " + a);
                                delete g[a], u && "range[" === u.tail.substr(0, 6) && (x[u.head] = 1);
                            }
                            for(var M = 0; M < y.length; M++){
                                var k = y[M];
                                if (x[k]) {
                                    var A = l(t, k).get();
                                    A && delete A.autorange;
                                }
                            }
                            var L = n._tracePreGUI;
                            for(var S in L){
                                var D, O = L[S], C = null;
                                for(a in O){
                                    if (!C) {
                                        var P = te(S, r);
                                        if (P < 0) {
                                            delete L[S];
                                            break;
                                        }
                                        var I = re(S, e, (D = r[P]._fullInput).index);
                                        if (I < 0) {
                                            delete L[S];
                                            break;
                                        }
                                        C = e[I];
                                    }
                                    if (u = $(a, Q)) {
                                        if (u.attr ? c = (s = l(n, u.attr).get()) && ee(u.attr, t) : (s = D.uirevision, void 0 === (c = C.uirevision) && (c = t.uirevision)), c && c === s && (null === (f = O[a]) && (f = void 0), ne(h = (d = l(C, a)).get(), f))) {
                                            d.set(N(l(D, a).get()));
                                            continue;
                                        }
                                    } else o.warn("unrecognized GUI edit: " + a + " in trace uid " + S);
                                    delete O[a];
                                }
                            }
                        }(e.data, e.layout, c, h), d.supplyDefaults(e, {
                            skipUpdateCalc: !0
                        });
                        var y = e._fullData, m = e._fullLayout, x = void 0 === m.datarevision, b = m.transition, M = function(e, t, r, n, a) {
                            var i = T.layoutFlags();
                            return i.arrays = {}, i.rangesAltered = {}, i.nChanges = 0, i.nChangesAnim = 0, ae(t, r, [], {
                                getValObject: function(e) {
                                    return f.getLayoutValObject(r, e);
                                },
                                flags: i,
                                immutable: n,
                                transition: a,
                                gd: e
                            }), (i.plot || i.calc) && (i.layoutReplot = !0), a && i.nChanges && i.nChangesAnim && (i.anim = i.nChanges === i.nChangesAnim ? "all" : "some"), i;
                        }(e, h, m, x, b), k = M.newDataRevision, L = function(e, t, r, n, a, i) {
                            var o = t.length === r.length;
                            if (!a && !o) return {
                                fullReplot: !0,
                                calc: !0
                            };
                            var l, s, c = T.traceFlags();
                            c.arrays = {}, c.nChanges = 0, c.nChangesAnim = 0;
                            var u = {
                                getValObject: function(e) {
                                    var t = f.getTraceValObject(s, e);
                                    return !s._module.animatable && t.anim && (t.anim = !1), t;
                                },
                                flags: c,
                                immutable: n,
                                transition: a,
                                newDataRevision: i,
                                gd: e
                            }, h = {};
                            for(l = 0; l < t.length; l++)if (r[l]) {
                                if (s = r[l]._fullInput, d.hasMakesDataTransform(s) && (s = r[l]), h[s.uid]) continue;
                                h[s.uid] = 1, ae(t[l]._fullInput, s, [], u);
                            }
                            return (c.calc || c.plot) && (c.fullReplot = !0), a && c.nChanges && c.nChangesAnim && (c.anim = c.nChanges === c.nChangesAnim && o ? "all" : "some"), c;
                        }(e, c, y, x, b, k);
                        if (W(e) && (M.layoutReplot = !0), L.calc || M.calc) {
                            e.calcdata = void 0;
                            for(var S = Object.getOwnPropertyNames(m), O = 0; O < S.length; O++){
                                var C = S[O], P = C.substring(0, 5);
                                if ("xaxis" === P || "yaxis" === P) {
                                    var I = m[C]._emptyCategories;
                                    I && I();
                                }
                            }
                        } else d.supplyDefaultsUpdateCalc(e.calcdata, y);
                        var R = [];
                        if (i && (e._transitionData = {}, d.createTransitionData(e), R.push(function() {
                            return t.addFrames(e, i);
                        })), m.transition && !v && (L.anim || M.anim)) M.ticks && R.push(w.doTicksRelayout), d.doCalcdata(e), w.doAutoRangeAndConstraints(e), R.push(function() {
                            return d.transitionFromReact(e, L, M, h);
                        });
                        else if (L.fullReplot || M.layoutReplot || v) e._fullLayout._skipDefaults = !0, R.push(t._doPlot);
                        else {
                            for(var z in M.arrays){
                                var F = M.arrays[z];
                                if (F.length) {
                                    var E = u.getComponentMethod(z, "drawOne");
                                    if (E !== o.noop) for(var H = 0; H < F.length; H++)E(e, F[H]);
                                    else {
                                        var j = u.getComponentMethod(z, "draw");
                                        if (j === o.noop) throw new Error("cannot draw components: " + z);
                                        j(e);
                                    }
                                }
                            }
                            R.push(d.previousPromises), L.style && R.push(w.doTraceStyle), (L.colorbars || M.colorbars) && R.push(w.doColorBars), M.legend && R.push(w.doLegend), M.layoutstyle && R.push(w.layoutStyles), M.axrange && V(R), M.ticks && R.push(w.doTicksRelayout), M.modebar && R.push(w.doModeBar), M.camera && R.push(w.doCamera), R.push(A);
                        }
                        R.push(d.rehover, d.redrag, d.reselect), (s = o.syncOrAsync(R, e)) && s.then || (s = Promise.resolve(e));
                    } else s = t.newPlot(e, r, n, a);
                    return s.then(function() {
                        return e.emit("plotly_react", {
                            data: r,
                            layout: n
                        }), e;
                    });
                }, t.redraw = function(e) {
                    if (e = o.getGraphDiv(e), !o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
                    return _.cleanData(e.data), _.cleanLayout(e.layout), e.calcdata = void 0, t._doPlot(e).then(function() {
                        return e.emit("plotly_redraw"), e;
                    });
                }, t.relayout = B, t.restyle = z, t.setPlotConfig = function(e) {
                    return o.extendFlat(x, e);
                }, t.update = X, t._guiRelayout = J(B), t._guiRestyle = J(z), t._guiUpdate = J(X), t._storeDirectGUIEdit = function(e, t, r) {
                    for(var n in r)E(n, l(e, n).get(), r[n], t);
                };
            },
            2075: function(e) {
                "use strict";
                var t = {
                    staticPlot: {
                        valType: "boolean",
                        dflt: !1
                    },
                    typesetMath: {
                        valType: "boolean",
                        dflt: !0
                    },
                    plotlyServerURL: {
                        valType: "string",
                        dflt: ""
                    },
                    editable: {
                        valType: "boolean",
                        dflt: !1
                    },
                    edits: {
                        annotationPosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        annotationTail: {
                            valType: "boolean",
                            dflt: !1
                        },
                        annotationText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        axisTitleText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        colorbarPosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        colorbarTitleText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        legendPosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        legendText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        shapePosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        titleText: {
                            valType: "boolean",
                            dflt: !1
                        }
                    },
                    editSelection: {
                        valType: "boolean",
                        dflt: !0
                    },
                    autosizable: {
                        valType: "boolean",
                        dflt: !1
                    },
                    responsive: {
                        valType: "boolean",
                        dflt: !1
                    },
                    fillFrame: {
                        valType: "boolean",
                        dflt: !1
                    },
                    frameMargins: {
                        valType: "number",
                        dflt: 0,
                        min: 0,
                        max: .5
                    },
                    scrollZoom: {
                        valType: "flaglist",
                        flags: [
                            "cartesian",
                            "gl3d",
                            "geo",
                            "mapbox"
                        ],
                        extras: [
                            !0,
                            !1
                        ],
                        dflt: "gl3d+geo+mapbox"
                    },
                    doubleClick: {
                        valType: "enumerated",
                        values: [
                            !1,
                            "reset",
                            "autosize",
                            "reset+autosize"
                        ],
                        dflt: "reset+autosize"
                    },
                    doubleClickDelay: {
                        valType: "number",
                        dflt: 300,
                        min: 0
                    },
                    showAxisDragHandles: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showAxisRangeEntryBoxes: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showTips: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showLink: {
                        valType: "boolean",
                        dflt: !1
                    },
                    linkText: {
                        valType: "string",
                        dflt: "Edit chart",
                        noBlank: !0
                    },
                    sendData: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showSources: {
                        valType: "any",
                        dflt: !1
                    },
                    displayModeBar: {
                        valType: "enumerated",
                        values: [
                            "hover",
                            !0,
                            !1
                        ],
                        dflt: "hover"
                    },
                    showSendToCloud: {
                        valType: "boolean",
                        dflt: !1
                    },
                    showEditInChartStudio: {
                        valType: "boolean",
                        dflt: !1
                    },
                    modeBarButtonsToRemove: {
                        valType: "any",
                        dflt: []
                    },
                    modeBarButtonsToAdd: {
                        valType: "any",
                        dflt: []
                    },
                    modeBarButtons: {
                        valType: "any",
                        dflt: !1
                    },
                    toImageButtonOptions: {
                        valType: "any",
                        dflt: {}
                    },
                    displaylogo: {
                        valType: "boolean",
                        dflt: !0
                    },
                    watermark: {
                        valType: "boolean",
                        dflt: !1
                    },
                    plotGlPixelRatio: {
                        valType: "number",
                        dflt: 2,
                        min: 1,
                        max: 4
                    },
                    setBackground: {
                        valType: "any",
                        dflt: "transparent"
                    },
                    topojsonURL: {
                        valType: "string",
                        noBlank: !0,
                        dflt: "https://cdn.plot.ly/"
                    },
                    mapboxAccessToken: {
                        valType: "string",
                        dflt: null
                    },
                    logging: {
                        valType: "integer",
                        min: 0,
                        max: 2,
                        dflt: 1
                    },
                    notifyOnLogging: {
                        valType: "integer",
                        min: 0,
                        max: 2,
                        dflt: 0
                    },
                    queueLength: {
                        valType: "integer",
                        min: 0,
                        dflt: 0
                    },
                    globalTransforms: {
                        valType: "any",
                        dflt: []
                    },
                    locale: {
                        valType: "string",
                        dflt: "en-US"
                    },
                    locales: {
                        valType: "any",
                        dflt: {}
                    }
                }, r = {};
                !function e(t, r) {
                    for(var n in t){
                        var a = t[n];
                        a.valType ? r[n] = a.dflt : (r[n] || (r[n] = {}), e(a, r[n]));
                    }
                }(t, r), e.exports = {
                    configAttributes: t,
                    dfltConfig: r
                };
            },
            6281: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(1828), i = r(9012), o = r(820), l = r(1391), s = r(5594), c = r(2075).configAttributes, u = r(962), f = a.extendDeepAll, d = a.isPlainObject, h = a.isArrayOrTypedArray, p = a.nestedProperty, v = a.valObjectMeta, g = "_isSubplotObj", y = "_isLinkedToArray", m = "_deprecated", x = [
                    g,
                    y,
                    "_arrayAttrRegexps",
                    m
                ];
                function b(e, t, r) {
                    if (!e) return !1;
                    if (e._isLinkedToArray) {
                        if (_(t[r])) r++;
                        else if (r < t.length) return !1;
                    }
                    for(; r < t.length; r++){
                        var n = e[t[r]];
                        if (!d(n)) break;
                        if (e = n, r === t.length - 1) break;
                        if (e._isLinkedToArray) {
                            if (!_(t[++r])) return !1;
                        } else if ("info_array" === e.valType) {
                            var a = t[++r];
                            if (!_(a)) return !1;
                            var i = e.items;
                            if (Array.isArray(i)) {
                                if (a >= i.length) return !1;
                                if (2 === e.dimensions) {
                                    if (r++, t.length === r) return e;
                                    var o = t[r];
                                    if (!_(o)) return !1;
                                    e = i[a][o];
                                } else e = i[a];
                            } else e = i;
                        }
                    }
                    return e;
                }
                function _(e) {
                    return e === Math.round(e) && e >= 0;
                }
                function w() {
                    var e, t, r = {};
                    for(e in f(r, o), n.subplotsRegistry)if ((t = n.subplotsRegistry[e]).layoutAttributes) {
                        if (Array.isArray(t.attr)) for(var a = 0; a < t.attr.length; a++)M(r, t, t.attr[a]);
                        else M(r, t, "subplot" === t.attr ? t.name : t.attr);
                    }
                    for(e in n.componentsRegistry){
                        var i = (t = n.componentsRegistry[e]).schema;
                        if (i && (i.subplots || i.layout)) {
                            var l = i.subplots;
                            if (l && l.xaxis && !l.yaxis) for(var s in l.xaxis)delete r.yaxis[s];
                            delete r.xaxis.shift, delete r.xaxis.autoshift;
                        } else "colorscale" === t.name ? f(r, t.layoutAttributes) : t.layoutAttributes && k(r, t.layoutAttributes, t.name);
                    }
                    return {
                        layoutAttributes: T(r)
                    };
                }
                function T(e) {
                    return function(e) {
                        t.crawl(e, function(e, r, n) {
                            t.isValObject(e) ? !0 !== e.arrayOk && "data_array" !== e.valType || (n[r + "src"] = {
                                valType: "string",
                                editType: "none"
                            }) : d(e) && (e.role = "object");
                        });
                    }(e), function(e) {
                        t.crawl(e, function(e, t, r) {
                            if (e) {
                                var n = e[y];
                                n && (delete e[y], r[t] = {
                                    items: {}
                                }, r[t].items[n] = e, r[t].role = "object");
                            }
                        });
                    }(e), function(e) {
                        !function e(t) {
                            for(var r in t)if (d(t[r])) e(t[r]);
                            else if (Array.isArray(t[r])) for(var n = 0; n < t[r].length; n++)e(t[r][n]);
                            else t[r] instanceof RegExp && (t[r] = t[r].toString());
                        }(e);
                    }(e), e;
                }
                function M(e, t, r) {
                    var n = p(e, r), a = f({}, t.layoutAttributes);
                    a[g] = !0, n.set(a);
                }
                function k(e, t, r) {
                    var n = p(e, r);
                    n.set(f(n.get() || {}, t));
                }
                t.IS_SUBPLOT_OBJ = g, t.IS_LINKED_TO_ARRAY = y, t.DEPRECATED = m, t.UNDERSCORE_ATTRS = x, t.get = function() {
                    var e = {};
                    n.allTypes.forEach(function(r) {
                        e[r] = function(e) {
                            var r, a;
                            a = (r = n.modules[e]._module).basePlotModule;
                            var o = {
                                type: null
                            }, l = f({}, i), s = f({}, r.attributes);
                            t.crawl(s, function(e, t, r, n, a) {
                                p(l, a).set(void 0), void 0 === e && p(s, a).set(void 0);
                            }), f(o, l), n.traceIs(e, "noOpacity") && delete o.opacity, n.traceIs(e, "showLegend") || (delete o.showlegend, delete o.legendgroup), n.traceIs(e, "noHover") && (delete o.hoverinfo, delete o.hoverlabel), r.selectPoints || delete o.selectedpoints, f(o, s), a.attributes && f(o, a.attributes), o.type = e;
                            var c = {
                                meta: r.meta || {},
                                categories: r.categories || {},
                                animatable: Boolean(r.animatable),
                                type: e,
                                attributes: T(o)
                            };
                            if (r.layoutAttributes) {
                                var u = {};
                                f(u, r.layoutAttributes), c.layoutAttributes = T(u);
                            }
                            return r.animatable || t.crawl(c, function(e) {
                                t.isValObject(e) && "anim" in e && delete e.anim;
                            }), c;
                        }(r);
                    });
                    var r, a = {};
                    return Object.keys(n.transformsRegistry).forEach(function(e) {
                        a[e] = function(e) {
                            var t = n.transformsRegistry[e], r = f({}, t.attributes);
                            return Object.keys(n.componentsRegistry).forEach(function(t) {
                                var a = n.componentsRegistry[t];
                                a.schema && a.schema.transforms && a.schema.transforms[e] && Object.keys(a.schema.transforms[e]).forEach(function(t) {
                                    k(r, a.schema.transforms[e][t], t);
                                });
                            }), {
                                attributes: T(r)
                            };
                        }(e);
                    }), {
                        defs: {
                            valObjects: v,
                            metaKeys: x.concat([
                                "description",
                                "role",
                                "editType",
                                "impliedEdits"
                            ]),
                            editType: {
                                traces: u.traces,
                                layout: u.layout
                            },
                            impliedEdits: {}
                        },
                        traces: e,
                        layout: w(),
                        transforms: a,
                        frames: (r = {
                            frames: f({}, l)
                        }, T(r), r.frames),
                        animation: T(s),
                        config: T(c)
                    };
                }, t.crawl = function(e, r, n, a) {
                    var i = n || 0;
                    a = a || "", Object.keys(e).forEach(function(n) {
                        var o = e[n];
                        if (-1 === x.indexOf(n)) {
                            var l = (a ? a + "." : "") + n;
                            r(o, n, e, i, l), t.isValObject(o) || d(o) && "impliedEdits" !== n && t.crawl(o, r, i + 1, l);
                        }
                    });
                }, t.isValObject = function(e) {
                    return e && void 0 !== e.valType;
                }, t.findArrayAttributes = function(e) {
                    var r, n, a = [], o = [], l = [];
                    function s(e, t, n, a) {
                        o = o.slice(0, a).concat([
                            t
                        ]), l = l.slice(0, a).concat([
                            e && e._isLinkedToArray
                        ]), e && ("data_array" === e.valType || !0 === e.arrayOk) && ("colorbar" !== o[a - 1] || "ticktext" !== t && "tickvals" !== t) && c(r, 0, "");
                    }
                    function c(e, t, r) {
                        var i = e[o[t]], s = r + o[t];
                        if (t === o.length - 1) h(i) && a.push(n + s);
                        else if (l[t]) {
                            if (Array.isArray(i)) for(var u = 0; u < i.length; u++)d(i[u]) && c(i[u], t + 1, s + "[" + u + "].");
                        } else d(i) && c(i, t + 1, s + ".");
                    }
                    r = e, n = "", t.crawl(i, s), e._module && e._module.attributes && t.crawl(e._module.attributes, s);
                    var u = e.transforms;
                    if (u) for(var f = 0; f < u.length; f++){
                        var p = u[f], v = p._module;
                        v && (n = "transforms[" + f + "].", r = p, t.crawl(v.attributes, s));
                    }
                    return a;
                }, t.getTraceValObject = function(e, t) {
                    var r, a, o = t[0], l = 1;
                    if ("transforms" === o) {
                        if (1 === t.length) return i.transforms;
                        var s = e.transforms;
                        if (!Array.isArray(s) || !s.length) return !1;
                        var c = t[1];
                        if (!_(c) || c >= s.length) return !1;
                        a = (r = (n.transformsRegistry[s[c].type] || {}).attributes) && r[t[2]], l = 3;
                    } else {
                        var u = e._module;
                        if (u || (u = (n.modules[e.type || i.type.dflt] || {})._module), !u) return !1;
                        if (!(a = (r = u.attributes) && r[o])) {
                            var f = u.basePlotModule;
                            f && f.attributes && (a = f.attributes[o]);
                        }
                        a || (a = i[o]);
                    }
                    return b(a, t, l);
                }, t.getLayoutValObject = function(e, t) {
                    var r = function(e, t) {
                        var r, a, i, l, s = e._basePlotModules;
                        if (s) {
                            var c;
                            for(r = 0; r < s.length; r++){
                                if ((i = s[r]).attrRegex && i.attrRegex.test(t)) {
                                    if (i.layoutAttrOverrides) return i.layoutAttrOverrides;
                                    !c && i.layoutAttributes && (c = i.layoutAttributes);
                                }
                                var u = i.baseLayoutAttrOverrides;
                                if (u && t in u) return u[t];
                            }
                            if (c) return c;
                        }
                        var f = e._modules;
                        if (f) {
                            for(r = 0; r < f.length; r++)if ((l = f[r].layoutAttributes) && t in l) return l[t];
                        }
                        for(a in n.componentsRegistry){
                            if ("colorscale" === (i = n.componentsRegistry[a]).name && 0 === t.indexOf("coloraxis")) return i.layoutAttributes[t];
                            if (!i.schema && t === i.name) return i.layoutAttributes;
                        }
                        return t in o && o[t];
                    }(e, t[0]);
                    return b(r, t, 1);
                };
            },
            4467: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(9012), i = "templateitemname", o = {
                    name: {
                        valType: "string",
                        editType: "none"
                    }
                };
                function l(e) {
                    return e && "string" == typeof e;
                }
                function s(e) {
                    var t = e.length - 1;
                    return "s" !== e.charAt(t) && n.warn("bad argument to arrayDefaultKey: " + e), e.substr(0, e.length - 1) + "defaults";
                }
                o[i] = {
                    valType: "string",
                    editType: "calc"
                }, t.templatedArray = function(e, t) {
                    return t._isLinkedToArray = e, t.name = o.name, t[i] = o[i], t;
                }, t.traceTemplater = function(e) {
                    var t, r, i = {};
                    for(t in e)r = e[t], Array.isArray(r) && r.length && (i[t] = 0);
                    return {
                        newTrace: function(o) {
                            var l = {
                                type: t = n.coerce(o, {}, a, "type"),
                                _template: null
                            };
                            if (t in i) {
                                r = e[t];
                                var s = i[t] % r.length;
                                i[t]++, l._template = r[s];
                            }
                            return l;
                        }
                    };
                }, t.newContainer = function(e, t, r) {
                    var a = e._template, i = a && (a[t] || r && a[r]);
                    return n.isPlainObject(i) || (i = null), e[t] = {
                        _template: i
                    };
                }, t.arrayTemplater = function(e, t, r) {
                    var n = e._template, a = n && n[s(t)], o = n && n[t];
                    Array.isArray(o) && o.length || (o = []);
                    var c = {};
                    return {
                        newItem: function(e) {
                            var t = {
                                name: e.name,
                                _input: e
                            }, n = t[i] = e[i];
                            if (!l(n)) return t._template = a, t;
                            for(var s = 0; s < o.length; s++){
                                var u = o[s];
                                if (u.name === n) return c[n] = 1, t._template = u, t;
                            }
                            return t[r] = e[r] || !1, t._template = !1, t;
                        },
                        defaultItems: function() {
                            for(var e = [], t = 0; t < o.length; t++){
                                var r = o[t], n = r.name;
                                if (l(n) && !c[n]) {
                                    var a = {
                                        _template: r,
                                        name: n,
                                        _input: {
                                            _templateitemname: n
                                        }
                                    };
                                    a[i] = r[i], e.push(a), c[n] = 1;
                                }
                            }
                            return e;
                        }
                    };
                }, t.arrayDefaultKey = s, t.arrayEditor = function(e, t, r) {
                    var a = (n.nestedProperty(e, t).get() || []).length, o = r._index, l = o >= a && (r._input || {})._templateitemname;
                    l && (o = a);
                    var s, c = t + "[" + o + "]";
                    function u() {
                        s = {}, l && (s[c] = {}, s[c][i] = l);
                    }
                    function f(e, t) {
                        l ? n.nestedProperty(s[c], e).set(t) : s[c + "." + e] = t;
                    }
                    function d() {
                        var e = s;
                        return u(), e;
                    }
                    return u(), {
                        modifyBase: function(e, t) {
                            s[e] = t;
                        },
                        modifyItem: f,
                        getUpdateObj: d,
                        applyUpdate: function(t, r) {
                            t && f(t, r);
                            var a = d();
                            for(var i in a)n.nestedProperty(e, i).set(a[i]);
                        }
                    };
                };
            },
            1549: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(3972), i = r(4875), o = r(1828), l = r(3893), s = r(3306), c = r(7901), u = r(1424), f = r(2998), d = r(4168), h = r(9298), p = r(8783), v = r(9082), g = v.enforce, y = v.clean, m = r(1739).doAutoRange, x = "start";
                function b(e, t, r) {
                    for(var n = 0; n < r.length; n++){
                        var a = r[n][0], i = r[n][1];
                        if (!(a[0] >= e[1] || a[1] <= e[0]) && i[0] < t[1] && i[1] > t[0]) return !0;
                    }
                    return !1;
                }
                function _(e) {
                    var r, a, l, s, f, v, g = e._fullLayout, y = g._size, m = y.p, x = h.list(e, "", !0);
                    if (g._paperdiv.style({
                        width: e._context.responsive && g.autosize && !e._context._hasZeroWidth && !e.layout.width ? "100%" : g.width + "px",
                        height: e._context.responsive && g.autosize && !e._context._hasZeroHeight && !e.layout.height ? "100%" : g.height + "px"
                    }).selectAll(".main-svg").call(u.setSize, g.width, g.height), e._context.setBackground(e, g.paper_bgcolor), t.drawMainTitle(e), d.manage(e), !g._has("cartesian")) return i.previousPromises(e);
                    function _(e, t, r) {
                        var n = e._lw / 2;
                        return "x" === e._id.charAt(0) ? t ? "top" === r ? t._offset - m - n : t._offset + t._length + m + n : y.t + y.h * (1 - (e.position || 0)) + n % 1 : t ? "right" === r ? t._offset + t._length + m + n : t._offset - m - n : y.l + y.w * (e.position || 0) + n % 1;
                    }
                    for(r = 0; r < x.length; r++){
                        var T = (s = x[r])._anchorAxis;
                        s._linepositions = {}, s._lw = u.crispRound(e, s.linewidth, 1), s._mainLinePosition = _(s, T, s.side), s._mainMirrorPosition = s.mirror && T ? _(s, T, p.OPPOSITE_SIDE[s.side]) : null;
                    }
                    var k = [], A = [], L = [], S = 1 === c.opacity(g.paper_bgcolor) && 1 === c.opacity(g.plot_bgcolor) && g.paper_bgcolor === g.plot_bgcolor;
                    for(a in g._plots)if ((l = g._plots[a]).mainplot) l.bg && l.bg.remove(), l.bg = void 0;
                    else {
                        var D = l.xaxis.domain, O = l.yaxis.domain, C = l.plotgroup;
                        if (b(D, O, L)) {
                            var P = C.node(), I = l.bg = o.ensureSingle(C, "rect", "bg");
                            P.insertBefore(I.node(), P.childNodes[0]), A.push(a);
                        } else C.select("rect.bg").remove(), L.push([
                            D,
                            O
                        ]), S || (k.push(a), A.push(a));
                    }
                    var R, z, N, F, E, H, j, B, Y, V, U, q, G, Z = g._bgLayer.selectAll(".bg").data(k);
                    for(Z.enter().append("rect").classed("bg", !0), Z.exit().remove(), Z.each(function(e) {
                        g._plots[e].bg = n.select(this);
                    }), r = 0; r < A.length; r++)l = g._plots[A[r]], f = l.xaxis, v = l.yaxis, l.bg && void 0 !== f._offset && void 0 !== v._offset && l.bg.call(u.setRect, f._offset - m, v._offset - m, f._length + 2 * m, v._length + 2 * m).call(c.fill, g.plot_bgcolor).style("stroke-width", 0);
                    if (!g._hasOnlyLargeSploms) for(a in g._plots){
                        l = g._plots[a], f = l.xaxis, v = l.yaxis;
                        var W, X, J = l.clipId = "clip" + g._uid + a + "plot", K = o.ensureSingleById(g._clips, "clipPath", J, function(e) {
                            e.classed("plotclip", !0).append("rect");
                        });
                        l.clipRect = K.select("rect").attr({
                            width: f._length,
                            height: v._length
                        }), u.setTranslate(l.plot, f._offset, v._offset), l._hasClipOnAxisFalse ? (W = null, X = J) : (W = J, X = null), u.setClipUrl(l.plot, W, e), l.layerClipId = X;
                    }
                    function Q(e) {
                        return "M" + R + "," + e + "H" + z;
                    }
                    function $(e) {
                        return "M" + f._offset + "," + e + "h" + f._length;
                    }
                    function ee(e) {
                        return "M" + e + "," + B + "V" + j;
                    }
                    function te(e) {
                        return void 0 !== v._shift && (e += v._shift), "M" + e + "," + v._offset + "v" + v._length;
                    }
                    function re(e, t, r) {
                        if (!e.showline || a !== e._mainSubplot) return "";
                        if (!e._anchorAxis) return r(e._mainLinePosition);
                        var n = t(e._mainLinePosition);
                        return e.mirror && (n += t(e._mainMirrorPosition)), n;
                    }
                    for(a in g._plots){
                        l = g._plots[a], f = l.xaxis, v = l.yaxis;
                        var ne = "M0,0";
                        w(f, a) && (E = M(f, "left", v, x), R = f._offset - (E ? m + E : 0), H = M(f, "right", v, x), z = f._offset + f._length + (H ? m + H : 0), N = _(f, v, "bottom"), F = _(f, v, "top"), !(G = !f._anchorAxis || a !== f._mainSubplot) || "allticks" !== f.mirror && "all" !== f.mirror || (f._linepositions[a] = [
                            N,
                            F
                        ]), ne = re(f, Q, $), G && f.showline && ("all" === f.mirror || "allticks" === f.mirror) && (ne += Q(N) + Q(F)), l.xlines.style("stroke-width", f._lw + "px").call(c.stroke, f.showline ? f.linecolor : "rgba(0,0,0,0)")), l.xlines.attr("d", ne);
                        var ae = "M0,0";
                        w(v, a) && (U = M(v, "bottom", f, x), j = v._offset + v._length + (U ? m : 0), q = M(v, "top", f, x), B = v._offset - (q ? m : 0), Y = _(v, f, "left"), V = _(v, f, "right"), !(G = !v._anchorAxis || a !== v._mainSubplot) || "allticks" !== v.mirror && "all" !== v.mirror || (v._linepositions[a] = [
                            Y,
                            V
                        ]), ae = re(v, ee, te), G && v.showline && ("all" === v.mirror || "allticks" === v.mirror) && (ae += ee(Y) + ee(V)), l.ylines.style("stroke-width", v._lw + "px").call(c.stroke, v.showline ? v.linecolor : "rgba(0,0,0,0)")), l.ylines.attr("d", ae);
                    }
                    return h.makeClipPaths(e), i.previousPromises(e);
                }
                function w(e, t) {
                    return (e.ticks || e.showline) && (t === e._mainSubplot || "all" === e.mirror || "allticks" === e.mirror);
                }
                function T(e, t, r) {
                    if (!r.showline || !r._lw) return !1;
                    if ("all" === r.mirror || "allticks" === r.mirror) return !0;
                    var n = r._anchorAxis;
                    if (!n) return !1;
                    var a = p.FROM_BL[t];
                    return r.side === t ? n.domain[a] === e.domain[a] : r.mirror && n.domain[1 - a] === e.domain[1 - a];
                }
                function M(e, t, r, n) {
                    if (T(e, t, r)) return r._lw;
                    for(var a = 0; a < n.length; a++){
                        var i = n[a];
                        if (i._mainAxis === r._mainAxis && T(e, t, i)) return i._lw;
                    }
                    return 0;
                }
                t.layoutStyles = function(e) {
                    return o.syncOrAsync([
                        i.doAutoMargin,
                        _
                    ], e);
                }, t.drawMainTitle = function(e) {
                    var t, r = e._fullLayout.title, a = e._fullLayout, s = function(e) {
                        var t = e.title, r = "middle";
                        return o.isRightAnchor(t) ? r = "end" : o.isLeftAnchor(t) && (r = x), r;
                    }(a), c = function(e) {
                        var t = e.title, r = "0em";
                        return o.isTopAnchor(t) ? r = p.CAP_SHIFT + "em" : o.isMiddleAnchor(t) && (r = p.MID_SHIFT + "em"), r;
                    }(a), d = function(e, t) {
                        var r = e.title, n = e._size, a = 0;
                        return "0em" !== t && t ? t === p.CAP_SHIFT + "em" && (a = r.pad.t) : a = -r.pad.b, "auto" === r.y ? n.t / 2 : "paper" === r.yref ? n.t + n.h - n.h * r.y + a : e.height - e.height * r.y + a;
                    }(a, c), h = function(e, t) {
                        var r = e.title, n = e._size, a = 0;
                        return t === x ? a = r.pad.l : "end" === t && (a = -r.pad.r), "paper" === r.xref ? n.l + n.w * r.x + a : e.width * r.x + a;
                    }(a, s);
                    if (f.draw(e, "gtitle", {
                        propContainer: a,
                        propName: "title.text",
                        placeholder: a._dfltTitle.plot,
                        attributes: {
                            x: h,
                            y: d,
                            "text-anchor": s,
                            dy: c
                        }
                    }), r.text && r.automargin) {
                        var v = n.selectAll(".gtitle"), g = u.bBox(v.node()).height, y = function(e, t, r) {
                            var n = t.y, a = t.yanchor, i = n > .5 ? "t" : "b", o = e._fullLayout.margin[i], l = 0;
                            return "paper" === t.yref ? l = r + t.pad.t + t.pad.b : "container" === t.yref && (l = function(e, t, r, n, a) {
                                var i = 0;
                                return "middle" === r && (i += a / 2), "t" === e ? ("top" === r && (i += a), i += n - t * n) : ("bottom" === r && (i += a), i += t * n), i;
                            }(i, n, a, e._fullLayout.height, r) + t.pad.t + t.pad.b), l > o ? l : 0;
                        }(e, r, g);
                        y > 0 && (function(e, t, r, n) {
                            var a = "title.automargin", l = e._fullLayout.title, s = l.y > .5 ? "t" : "b", c = {
                                x: l.x,
                                y: l.y,
                                t: 0,
                                b: 0
                            }, u = {};
                            "paper" === l.yref && function(e, t, r, n, a) {
                                var i = "paper" === t.yref ? e._fullLayout._size.h : e._fullLayout.height, l = o.isTopAnchor(t) ? n : n - a, s = "b" === r ? i - l : l;
                                return !(o.isTopAnchor(t) && "t" === r || o.isBottomAnchor(t) && "b" === r) && s < a;
                            }(e, l, s, t, n) ? c[s] = r : "container" === l.yref && (u[s] = r, e._fullLayout._reservedMargin[a] = u), i.allowAutoMargin(e, a), i.autoMargin(e, a, c);
                        }(e, d, y, g), v.attr({
                            x: h,
                            y: d,
                            "text-anchor": s,
                            dy: (t = r.yanchor, "top" === t ? p.CAP_SHIFT + .3 + "em" : "bottom" === t ? "-0.3em" : p.MID_SHIFT + "em")
                        }).call(l.positionText, h, d));
                    }
                }, t.doTraceStyle = function(e) {
                    var r, n = e.calcdata, o = [];
                    for(r = 0; r < n.length; r++){
                        var l = n[r], c = l[0] || {}, u = c.trace || {}, f = u._module || {}, d = f.arraysToCalcdata;
                        d && d(l, u);
                        var h = f.editStyle;
                        h && o.push({
                            fn: h,
                            cd0: c
                        });
                    }
                    if (o.length) {
                        for(r = 0; r < o.length; r++){
                            var p = o[r];
                            p.fn(e, p.cd0);
                        }
                        s(e), t.redrawReglTraces(e);
                    }
                    return i.style(e), a.getComponentMethod("legend", "draw")(e), i.previousPromises(e);
                }, t.doColorBars = function(e) {
                    return a.getComponentMethod("colorbar", "draw")(e), i.previousPromises(e);
                }, t.layoutReplot = function(e) {
                    var t = e.layout;
                    return e.layout = void 0, a.call("_doPlot", e, "", t);
                }, t.doLegend = function(e) {
                    return a.getComponentMethod("legend", "draw")(e), i.previousPromises(e);
                }, t.doTicksRelayout = function(e) {
                    return h.draw(e, "redraw"), e._fullLayout._hasOnlyLargeSploms && (a.subplotsRegistry.splom.updateGrid(e), s(e), t.redrawReglTraces(e)), t.drawMainTitle(e), i.previousPromises(e);
                }, t.doModeBar = function(e) {
                    var t = e._fullLayout;
                    d.manage(e);
                    for(var r = 0; r < t._basePlotModules.length; r++){
                        var n = t._basePlotModules[r].updateFx;
                        n && n(e);
                    }
                    return i.previousPromises(e);
                }, t.doCamera = function(e) {
                    for(var t = e._fullLayout, r = t._subplots.gl3d, n = 0; n < r.length; n++){
                        var a = t[r[n]];
                        a._scene.setViewport(a);
                    }
                }, t.drawData = function(e) {
                    var r = e._fullLayout;
                    s(e);
                    for(var n = r._basePlotModules, o = 0; o < n.length; o++)n[o].plot(e);
                    return t.redrawReglTraces(e), i.style(e), a.getComponentMethod("selections", "draw")(e), a.getComponentMethod("shapes", "draw")(e), a.getComponentMethod("annotations", "draw")(e), a.getComponentMethod("images", "draw")(e), r._replotting = !1, i.previousPromises(e);
                }, t.redrawReglTraces = function(e) {
                    var t = e._fullLayout;
                    if (t._has("regl")) {
                        var r, n, a = e._fullData, i = [], l = [];
                        for(t._hasOnlyLargeSploms && t._splomGrid.draw(), r = 0; r < a.length; r++){
                            var s = a[r];
                            !0 === s.visible && 0 !== s._length && ("splom" === s.type ? t._splomScenes[s.uid].draw() : "scattergl" === s.type ? o.pushUnique(i, s.xaxis + s.yaxis) : "scatterpolargl" === s.type && o.pushUnique(l, s.subplot));
                        }
                        for(r = 0; r < i.length; r++)(n = t._plots[i[r]])._scene && n._scene.draw();
                        for(r = 0; r < l.length; r++)(n = t[l[r]]._subplot)._scene && n._scene.draw();
                    }
                }, t.doAutoRangeAndConstraints = function(e) {
                    for(var t, r = h.list(e, "", !0), n = {}, a = 0; a < r.length; a++)if (!n[(t = r[a])._id]) {
                        n[t._id] = 1, y(e, t), m(e, t);
                        var i = t._matchGroup;
                        if (i) for(var o in i){
                            var l = h.getFromId(e, o);
                            m(e, l, t.range), n[o] = 1;
                        }
                    }
                    g(e);
                }, t.finalDraw = function(e) {
                    a.getComponentMethod("rangeslider", "draw")(e), a.getComponentMethod("rangeselector", "draw")(e);
                }, t.drawMarginPushers = function(e) {
                    a.getComponentMethod("legend", "draw")(e), a.getComponentMethod("rangeselector", "draw")(e), a.getComponentMethod("sliders", "draw")(e), a.getComponentMethod("updatemenus", "draw")(e), a.getComponentMethod("colorbar", "draw")(e);
                };
            },
            6318: function(e, t, r) {
                "use strict";
                var n = r(1828), a = n.isPlainObject, i = r(6281), o = r(4875), l = r(9012), s = r(4467), c = r(2075).dfltConfig;
                function u(e, t) {
                    e = n.extendDeep({}, e);
                    var r, i, o = Object.keys(e).sort();
                    function l(t, r, n) {
                        if (a(r) && a(t)) u(t, r);
                        else if (Array.isArray(r) && Array.isArray(t)) {
                            var o = s.arrayTemplater({
                                _template: e
                            }, n);
                            for(i = 0; i < r.length; i++){
                                var l = r[i], c = o.newItem(l)._template;
                                c && u(c, l);
                            }
                            var f = o.defaultItems();
                            for(i = 0; i < f.length; i++)r.push(f[i]._template);
                            for(i = 0; i < r.length; i++)delete r[i].templateitemname;
                        }
                    }
                    for(r = 0; r < o.length; r++){
                        var c = o[r], d = e[c];
                        if (c in t ? l(d, t[c], c) : t[c] = d, f(c) === c) for(var h in t){
                            var p = f(h);
                            h === p || p !== c || h in e || l(d, t[h], c);
                        }
                    }
                }
                function f(e) {
                    return e.replace(/[0-9]+$/, "");
                }
                function d(e, t, r, i, o) {
                    var l = o && r(o);
                    for(var c in e){
                        var u = e[c], h = v(e, c, i), p = v(e, c, o), g = r(p);
                        if (!g) {
                            var y = f(c);
                            y !== c && (g = r(p = v(e, y, o)));
                        }
                        if (!(l && l === g || !g || g._noTemplating || "data_array" === g.valType || g.arrayOk && Array.isArray(u))) {
                            if (!g.valType && a(u)) d(u, t, r, h, p);
                            else if (g._isLinkedToArray && Array.isArray(u)) for(var m = !1, x = 0, b = {}, _ = 0; _ < u.length; _++){
                                var w = u[_];
                                if (a(w)) {
                                    var T = w.name;
                                    if (T) b[T] || (d(w, t, r, v(u, x, h), v(u, x, p)), x++, b[T] = 1);
                                    else if (!m) {
                                        var M = v(e, s.arrayDefaultKey(c), i), k = v(u, x, h);
                                        d(w, t, r, k, v(u, x, p));
                                        var A = n.nestedProperty(t, k);
                                        n.nestedProperty(t, M).set(A.get()), A.set(null), m = !0;
                                    }
                                }
                            }
                            else n.nestedProperty(t, h).set(u);
                        }
                    }
                }
                function h(e, t) {
                    return i.getLayoutValObject(e, n.nestedProperty({}, t).parts);
                }
                function p(e, t) {
                    return i.getTraceValObject(e, n.nestedProperty({}, t).parts);
                }
                function v(e, t, r) {
                    return r ? Array.isArray(e) ? r + "[" + t + "]" : r + "." + t : t;
                }
                function g(e) {
                    for(var t = 0; t < e.length; t++)if (a(e[t])) return !0;
                }
                function y(e) {
                    var t;
                    switch(e.code){
                        case "data":
                            t = "The template has no key data.";
                            break;
                        case "layout":
                            t = "The template has no key layout.";
                            break;
                        case "missing":
                            t = e.path ? "There are no templates for item " + e.path + " with name " + e.templateitemname : "There are no templates for trace " + e.index + ", of type " + e.traceType + ".";
                            break;
                        case "unused":
                            t = e.path ? "The template item at " + e.path + " was not used in constructing the plot." : e.dataCount ? "Some of the templates of type " + e.traceType + " were not used. The template has " + e.templateCount + " traces, the data only has " + e.dataCount + " of this type." : "The template has " + e.templateCount + " traces of type " + e.traceType + " but there are none in the data.";
                            break;
                        case "reused":
                            t = "Some of the templates of type " + e.traceType + " were used more than once. The template has " + e.templateCount + " traces, the data has " + e.dataCount + " of this type.";
                    }
                    return e.msg = t, e;
                }
                t.makeTemplate = function(e) {
                    e = n.isPlainObject(e) ? e : n.getGraphDiv(e), e = n.extendDeep({
                        _context: c
                    }, {
                        data: e.data,
                        layout: e.layout
                    }), o.supplyDefaults(e);
                    var t = e.data || [], r = e.layout || {};
                    r._basePlotModules = e._fullLayout._basePlotModules, r._modules = e._fullLayout._modules;
                    var i = {
                        data: {},
                        layout: {}
                    };
                    t.forEach(function(e) {
                        var t = {};
                        d(e, t, p.bind(null, e));
                        var r = n.coerce(e, {}, l, "type"), a = i.data[r];
                        a || (a = i.data[r] = []), a.push(t);
                    }), d(r, i.layout, h.bind(null, r)), delete i.layout.template;
                    var s = r.template;
                    if (a(s)) {
                        var f, v, g, y, m, x, b = s.layout;
                        a(b) && u(b, i.layout);
                        var _ = s.data;
                        if (a(_)) {
                            for(v in i.data)if (g = _[v], Array.isArray(g)) {
                                for(x = (m = i.data[v]).length, y = g.length, f = 0; f < x; f++)u(g[f % y], m[f]);
                                for(f = x; f < y; f++)m.push(n.extendDeep({}, g[f]));
                            }
                            for(v in _)v in i.data || (i.data[v] = n.extendDeep([], _[v]));
                        }
                    }
                    return i;
                }, t.validateTemplate = function(e, t) {
                    var r = n.extendDeep({}, {
                        _context: c,
                        data: e.data,
                        layout: e.layout
                    }), i = r.layout || {};
                    a(t) || (t = i.template || {});
                    var l = t.layout, s = t.data, u = [];
                    r.layout = i, r.layout.template = t, o.supplyDefaults(r);
                    var d = r._fullLayout, h = r._fullData, p = {};
                    if (a(l) ? (function e(t, r) {
                        for(var n in t)if ("_" !== n.charAt(0) && a(t[n])) {
                            var i, o = f(n), l = [];
                            for(i = 0; i < r.length; i++)l.push(v(t, n, r[i])), o !== n && l.push(v(t, o, r[i]));
                            for(i = 0; i < l.length; i++)p[l[i]] = 1;
                            e(t[n], l);
                        }
                    }(d, [
                        "layout"
                    ]), function e(t, r) {
                        for(var n in t)if (-1 === n.indexOf("defaults") && a(t[n])) {
                            var i = v(t, n, r);
                            p[i] ? e(t[n], i) : u.push({
                                code: "unused",
                                path: i
                            });
                        }
                    }(l, "layout")) : u.push({
                        code: "layout"
                    }), a(s)) {
                        for(var m, x = {}, b = 0; b < h.length; b++){
                            var _ = h[b];
                            x[m = _.type] = (x[m] || 0) + 1, _._fullInput._template || u.push({
                                code: "missing",
                                index: _._fullInput.index,
                                traceType: m
                            });
                        }
                        for(m in s){
                            var w = s[m].length, T = x[m] || 0;
                            w > T ? u.push({
                                code: "unused",
                                traceType: m,
                                templateCount: w,
                                dataCount: T
                            }) : T > w && u.push({
                                code: "reused",
                                traceType: m,
                                templateCount: w,
                                dataCount: T
                            });
                        }
                    } else u.push({
                        code: "data"
                    });
                    if (function e(t, r) {
                        for(var n in t)if ("_" !== n.charAt(0)) {
                            var i = t[n], o = v(t, n, r);
                            a(i) ? (Array.isArray(t) && !1 === i._template && i.templateitemname && u.push({
                                code: "missing",
                                path: o,
                                templateitemname: i.templateitemname
                            }), e(i, o)) : Array.isArray(i) && g(i) && e(i, o);
                        }
                    }({
                        data: h,
                        layout: d
                    }, ""), u.length) return u.map(y);
                };
            },
            403: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(2391), i = r(4875), o = r(1828), l = r(5095), s = r(5900), c = r(942), u = r(1506).version, f = {
                    format: {
                        valType: "enumerated",
                        values: [
                            "png",
                            "jpeg",
                            "webp",
                            "svg",
                            "full-json"
                        ],
                        dflt: "png"
                    },
                    width: {
                        valType: "number",
                        min: 1
                    },
                    height: {
                        valType: "number",
                        min: 1
                    },
                    scale: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    setBackground: {
                        valType: "any",
                        dflt: !1
                    },
                    imageDataOnly: {
                        valType: "boolean",
                        dflt: !1
                    }
                };
                e.exports = function(e, t) {
                    var r, d, h, p;
                    function v(e) {
                        return !(e in t) || o.validate(t[e], f[e]);
                    }
                    if (t = t || {}, o.isPlainObject(e) ? (r = e.data || [], d = e.layout || {}, h = e.config || {}, p = {}) : (e = o.getGraphDiv(e), r = o.extendDeep([], e.data), d = o.extendDeep({}, e.layout), h = e._context, p = e._fullLayout || {}), !v("width") && null !== t.width || !v("height") && null !== t.height) throw new Error("Height and width should be pixel values.");
                    if (!v("format")) throw new Error("Export format is not " + o.join2(f.format.values, ", ", " or ") + ".");
                    var g = {};
                    function y(e, r) {
                        return o.coerce(t, g, f, e, r);
                    }
                    var m = y("format"), x = y("width"), b = y("height"), _ = y("scale"), w = y("setBackground"), T = y("imageDataOnly"), M = document.createElement("div");
                    M.style.position = "absolute", M.style.left = "-5000px", document.body.appendChild(M);
                    var k = o.extendFlat({}, d);
                    x ? k.width = x : null === t.width && n(p.width) && (k.width = p.width), b ? k.height = b : null === t.height && n(p.height) && (k.height = p.height);
                    var A = o.extendFlat({}, h, {
                        _exportedPlot: !0,
                        staticPlot: !0,
                        setBackground: w
                    }), L = l.getRedrawFunc(M);
                    function S() {
                        return new Promise(function(e) {
                            setTimeout(e, l.getDelay(M._fullLayout));
                        });
                    }
                    function D() {
                        return new Promise(function(e, t) {
                            var r = s(M, m, _), n = M._fullLayout.width, f = M._fullLayout.height;
                            function d() {
                                a.purge(M), document.body.removeChild(M);
                            }
                            if ("full-json" === m) {
                                var h = i.graphJson(M, !1, "keepdata", "object", !0, !0);
                                return h.version = u, h = JSON.stringify(h), d(), e(T ? h : l.encodeJSON(h));
                            }
                            if (d(), "svg" === m) return e(T ? r : l.encodeSVG(r));
                            var p = document.createElement("canvas");
                            p.id = o.randstr(), c({
                                format: m,
                                width: n,
                                height: f,
                                scale: _,
                                canvas: p,
                                svg: r,
                                promise: !0
                            }).then(e).catch(t);
                        });
                    }
                    return new Promise(function(e, t) {
                        a.newPlot(M, r, k, A).then(L).then(S).then(D).then(function(t) {
                            e(function(e) {
                                return T ? e.replace(l.IMAGE_URL_PREFIX, "") : e;
                            }(t));
                        }).catch(function(e) {
                            t(e);
                        });
                    });
                };
            },
            4936: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(4875), i = r(6281), o = r(2075).dfltConfig, l = n.isPlainObject, s = Array.isArray, c = n.isArrayOrTypedArray;
                function u(e, t, r, a, i, o) {
                    o = o || [];
                    for(var f = Object.keys(e), d = 0; d < f.length; d++){
                        var g = f[d];
                        if ("transforms" !== g) {
                            var y = o.slice();
                            y.push(g);
                            var m = e[g], x = t[g], b = v(r, g), _ = (b || {}).valType, w = "info_array" === _, T = "colorscale" === _, M = (b || {}).items;
                            if (p(r, g)) {
                                if (l(m) && l(x) && "any" !== _) u(m, x, b, a, i, y);
                                else if (w && s(m)) {
                                    m.length > x.length && a.push(h("unused", i, y.concat(x.length)));
                                    var k, A, L, S, D, O = x.length, C = Array.isArray(M);
                                    if (C && (O = Math.min(O, M.length)), 2 === b.dimensions) for(A = 0; A < O; A++)if (s(m[A])) {
                                        m[A].length > x[A].length && a.push(h("unused", i, y.concat(A, x[A].length)));
                                        var P = x[A].length;
                                        for(k = 0; k < (C ? Math.min(P, M[A].length) : P); k++)L = C ? M[A][k] : M, S = m[A][k], D = x[A][k], n.validate(S, L) ? D !== S && D !== +S && a.push(h("dynamic", i, y.concat(A, k), S, D)) : a.push(h("value", i, y.concat(A, k), S));
                                    } else a.push(h("array", i, y.concat(A), m[A]));
                                    else for(A = 0; A < O; A++)L = C ? M[A] : M, S = m[A], D = x[A], n.validate(S, L) ? D !== S && D !== +S && a.push(h("dynamic", i, y.concat(A), S, D)) : a.push(h("value", i, y.concat(A), S));
                                } else if (b.items && !w && s(m)) {
                                    var I, R, z = M[Object.keys(M)[0]], N = [];
                                    for(I = 0; I < x.length; I++){
                                        var F = x[I]._index || I;
                                        if ((R = y.slice()).push(F), l(m[F]) && l(x[I])) {
                                            N.push(F);
                                            var E = m[F], H = x[I];
                                            l(E) && !1 !== E.visible && !1 === H.visible ? a.push(h("invisible", i, R)) : u(E, H, z, a, i, R);
                                        }
                                    }
                                    for(I = 0; I < m.length; I++)(R = y.slice()).push(I), l(m[I]) ? -1 === N.indexOf(I) && a.push(h("unused", i, R)) : a.push(h("object", i, R, m[I]));
                                } else !l(m) && l(x) ? a.push(h("object", i, y, m)) : c(m) || !c(x) || w || T ? g in t ? n.validate(m, b) ? "enumerated" === b.valType && (b.coerceNumber && m !== +x || m !== x) && a.push(h("dynamic", i, y, m, x)) : a.push(h("value", i, y, m)) : a.push(h("unused", i, y, m)) : a.push(h("array", i, y, m));
                            } else a.push(h("schema", i, y));
                        }
                    }
                    return a;
                }
                e.exports = function(e, t) {
                    void 0 === e && (e = []), void 0 === t && (t = {});
                    var r, c, f = i.get(), d = [], p = {
                        _context: n.extendFlat({}, o)
                    };
                    s(e) ? (p.data = n.extendDeep([], e), r = e) : (p.data = [], r = [], d.push(h("array", "data"))), l(t) ? (p.layout = n.extendDeep({}, t), c = t) : (p.layout = {}, c = {}, arguments.length > 1 && d.push(h("object", "layout"))), a.supplyDefaults(p);
                    for(var v = p._fullData, g = r.length, y = 0; y < g; y++){
                        var m = r[y], x = [
                            "data",
                            y
                        ];
                        if (l(m)) {
                            var b = v[y], _ = b.type, w = f.traces[_].attributes;
                            w.type = {
                                valType: "enumerated",
                                values: [
                                    _
                                ]
                            }, !1 === b.visible && !1 !== m.visible && d.push(h("invisible", x)), u(m, b, w, d, x);
                            var T = m.transforms, M = b.transforms;
                            if (T) {
                                s(T) || d.push(h("array", x, [
                                    "transforms"
                                ])), x.push("transforms");
                                for(var k = 0; k < T.length; k++){
                                    var A = [
                                        "transforms",
                                        k
                                    ], L = T[k].type;
                                    if (l(T[k])) {
                                        var S = f.transforms[L] ? f.transforms[L].attributes : {};
                                        S.type = {
                                            valType: "enumerated",
                                            values: Object.keys(f.transforms)
                                        }, u(T[k], M[k], S, d, x, A);
                                    } else d.push(h("object", x, A));
                                }
                            }
                        } else d.push(h("object", x));
                    }
                    var D = p._fullLayout, O = function(e, t) {
                        for(var r = e.layout.layoutAttributes, a = 0; a < t.length; a++){
                            var i = t[a], o = e.traces[i.type], l = o.layoutAttributes;
                            l && (i.subplot ? n.extendFlat(r[o.attributes.subplot.dflt], l) : n.extendFlat(r, l));
                        }
                        return r;
                    }(f, v);
                    return u(c, D, O, d, "layout"), 0 === d.length ? void 0 : d;
                };
                var f = {
                    object: function(e, t) {
                        return ("layout" === e && "" === t ? "The layout argument" : "data" === e[0] && "" === t ? "Trace " + e[1] + " in the data argument" : d(e) + "key " + t) + " must be linked to an object container";
                    },
                    array: function(e, t) {
                        return ("data" === e ? "The data argument" : d(e) + "key " + t) + " must be linked to an array container";
                    },
                    schema: function(e, t) {
                        return d(e) + "key " + t + " is not part of the schema";
                    },
                    unused: function(e, t, r) {
                        var n = l(r) ? "container" : "key";
                        return d(e) + n + " " + t + " did not get coerced";
                    },
                    dynamic: function(e, t, r, n) {
                        return [
                            d(e) + "key",
                            t,
                            "(set to '" + r + "')",
                            "got reset to",
                            "'" + n + "'",
                            "during defaults."
                        ].join(" ");
                    },
                    invisible: function(e, t) {
                        return (t ? d(e) + "item " + t : "Trace " + e[1]) + " got defaulted to be not visible";
                    },
                    value: function(e, t, r) {
                        return [
                            d(e) + "key " + t,
                            "is set to an invalid value (" + r + ")"
                        ].join(" ");
                    }
                };
                function d(e) {
                    return s(e) ? "In data trace " + e[1] + ", " : "In " + e + ", ";
                }
                function h(e, t, r, a, i) {
                    var o, l;
                    r = r || "", s(t) ? (o = t[0], l = t[1]) : (o = t, l = null);
                    var c = function(e) {
                        if (!s(e)) return String(e);
                        for(var t = "", r = 0; r < e.length; r++){
                            var n = e[r];
                            "number" == typeof n ? t = t.substr(0, t.length - 1) + "[" + n + "]" : t += n, r < e.length - 1 && (t += ".");
                        }
                        return t;
                    }(r), u = f[e](t, c, a, i);
                    return n.log(u), {
                        code: e,
                        container: o,
                        trace: l,
                        path: r,
                        astr: c,
                        msg: u
                    };
                }
                function p(e, t) {
                    var r = y(t), n = r.keyMinusId, a = r.id;
                    return !!(n in e && e[n]._isSubplotObj && a) || t in e;
                }
                function v(e, t) {
                    return t in e ? e[t] : e[y(t).keyMinusId];
                }
                var g = n.counterRegex("([a-z]+)");
                function y(e) {
                    var t = e.match(g);
                    return {
                        keyMinusId: t && t[1],
                        id: t && t[2]
                    };
                }
            },
            5594: function(e) {
                "use strict";
                e.exports = {
                    mode: {
                        valType: "enumerated",
                        dflt: "afterall",
                        values: [
                            "immediate",
                            "next",
                            "afterall"
                        ]
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "forward",
                            "reverse"
                        ],
                        dflt: "forward"
                    },
                    fromcurrent: {
                        valType: "boolean",
                        dflt: !1
                    },
                    frame: {
                        duration: {
                            valType: "number",
                            min: 0,
                            dflt: 500
                        },
                        redraw: {
                            valType: "boolean",
                            dflt: !0
                        }
                    },
                    transition: {
                        duration: {
                            valType: "number",
                            min: 0,
                            dflt: 500,
                            editType: "none"
                        },
                        easing: {
                            valType: "enumerated",
                            dflt: "cubic-in-out",
                            values: [
                                "linear",
                                "quad",
                                "cubic",
                                "sin",
                                "exp",
                                "circle",
                                "elastic",
                                "back",
                                "bounce",
                                "linear-in",
                                "quad-in",
                                "cubic-in",
                                "sin-in",
                                "exp-in",
                                "circle-in",
                                "elastic-in",
                                "back-in",
                                "bounce-in",
                                "linear-out",
                                "quad-out",
                                "cubic-out",
                                "sin-out",
                                "exp-out",
                                "circle-out",
                                "elastic-out",
                                "back-out",
                                "bounce-out",
                                "linear-in-out",
                                "quad-in-out",
                                "cubic-in-out",
                                "sin-in-out",
                                "exp-in-out",
                                "circle-in-out",
                                "elastic-in-out",
                                "back-in-out",
                                "bounce-in-out"
                            ],
                            editType: "none"
                        },
                        ordering: {
                            valType: "enumerated",
                            values: [
                                "layout first",
                                "traces first"
                            ],
                            dflt: "layout first",
                            editType: "none"
                        }
                    }
                };
            },
            5501: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(4467);
                e.exports = function(e, t, r) {
                    var i, o, l = r.name, s = r.inclusionAttr || "visible", c = t[l], u = n.isArrayOrTypedArray(e[l]) ? e[l] : [], f = t[l] = [], d = a.arrayTemplater(t, l, s);
                    for(i = 0; i < u.length; i++){
                        var h = u[i];
                        n.isPlainObject(h) ? o = d.newItem(h) : (o = d.newItem({}))[s] = !1, o._index = i, !1 !== o[s] && r.handleItemDefaults(h, o, t, r), f.push(o);
                    }
                    var p = d.defaultItems();
                    for(i = 0; i < p.length; i++)(o = p[i])._index = f.length, r.handleItemDefaults({}, o, t, r, {}), f.push(o);
                    if (n.isArrayOrTypedArray(c)) {
                        var v = Math.min(c.length, f.length);
                        for(i = 0; i < v; i++)n.relinkPrivateKeys(f[i], c[i]);
                    }
                    return f;
                };
            },
            9012: function(e, t, r) {
                "use strict";
                var n = r(1940), a = r(7914);
                e.exports = {
                    type: {
                        valType: "enumerated",
                        values: [],
                        dflt: "scatter",
                        editType: "calc+clearAxisTypes",
                        _noTemplating: !0
                    },
                    visible: {
                        valType: "enumerated",
                        values: [
                            !0,
                            !1,
                            "legendonly"
                        ],
                        dflt: !0,
                        editType: "calc"
                    },
                    showlegend: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "style"
                    },
                    legend: {
                        valType: "subplotid",
                        dflt: "legend",
                        editType: "style"
                    },
                    legendgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "style"
                    },
                    legendgrouptitle: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "style"
                        },
                        font: n({
                            editType: "style"
                        }),
                        editType: "style"
                    },
                    legendrank: {
                        valType: "number",
                        dflt: 1e3,
                        editType: "style"
                    },
                    legendwidth: {
                        valType: "number",
                        min: 0,
                        editType: "style"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "style"
                    },
                    name: {
                        valType: "string",
                        editType: "style"
                    },
                    uid: {
                        valType: "string",
                        editType: "plot",
                        anim: !0
                    },
                    ids: {
                        valType: "data_array",
                        editType: "calc",
                        anim: !0
                    },
                    customdata: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    meta: {
                        valType: "any",
                        arrayOk: !0,
                        editType: "plot"
                    },
                    selectedpoints: {
                        valType: "any",
                        editType: "calc"
                    },
                    hoverinfo: {
                        valType: "flaglist",
                        flags: [
                            "x",
                            "y",
                            "z",
                            "text",
                            "name"
                        ],
                        extras: [
                            "all",
                            "none",
                            "skip"
                        ],
                        arrayOk: !0,
                        dflt: "all",
                        editType: "none"
                    },
                    hoverlabel: a.hoverlabel,
                    stream: {
                        token: {
                            valType: "string",
                            noBlank: !0,
                            strict: !0,
                            editType: "calc"
                        },
                        maxpoints: {
                            valType: "number",
                            min: 0,
                            max: 1e4,
                            dflt: 500,
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    transforms: {
                        _isLinkedToArray: "transform",
                        editType: "calc"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    }
                };
            },
            2973: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(1828), i = a.dateTime2ms, o = a.incrementMonth, l = r(606).ONEAVGMONTH;
                e.exports = function(e, t, r, a) {
                    if ("date" !== t.type) return {
                        vals: a
                    };
                    var s = e[r + "periodalignment"];
                    if (!s) return {
                        vals: a
                    };
                    var c, u = e[r + "period"];
                    if (n(u)) {
                        if ((u = +u) <= 0) return {
                            vals: a
                        };
                    } else if ("string" == typeof u && "M" === u.charAt(0)) {
                        var f = +u.substring(1);
                        if (!(f > 0 && Math.round(f) === f)) return {
                            vals: a
                        };
                        c = f;
                    }
                    for(var d = t.calendar, h = "start" === s, p = "end" === s, v = e[r + "period0"], g = i(v, d) || 0, y = [], m = [], x = [], b = a.length, _ = 0; _ < b; _++){
                        var w, T, M, k = a[_];
                        if (c) {
                            for(w = Math.round((k - g) / (c * l)), M = o(g, c * w, d); M > k;)M = o(M, -c, d);
                            for(; M <= k;)M = o(M, c, d);
                            T = o(M, -c, d);
                        } else {
                            for(M = g + (w = Math.round((k - g) / u)) * u; M > k;)M -= u;
                            for(; M <= k;)M += u;
                            T = M - u;
                        }
                        y[_] = h ? T : p ? M : (T + M) / 2, m[_] = T, x[_] = M;
                    }
                    return {
                        vals: y,
                        starts: m,
                        ends: x
                    };
                };
            },
            9502: function(e) {
                "use strict";
                e.exports = {
                    xaxis: {
                        valType: "subplotid",
                        dflt: "x",
                        editType: "calc+clearAxisTypes"
                    },
                    yaxis: {
                        valType: "subplotid",
                        dflt: "y",
                        editType: "calc+clearAxisTypes"
                    }
                };
            },
            1739: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(2770), i = r(1828), o = r(606).FP_SAFE, l = r(3972), s = r(1424), c = r(1675), u = c.getFromId, f = c.isLinked;
                function d(e, t) {
                    var r, n, a = [], o = e._fullLayout, l = p(o, t, 0), s = p(o, t, 1), c = g(e, t), u = c.min, f = c.max;
                    if (0 === u.length || 0 === f.length) return i.simpleMap(t.range, t.r2l);
                    var d = u[0].val, v = f[0].val;
                    for(r = 1; r < u.length && d === v; r++)d = Math.min(d, u[r].val);
                    for(r = 1; r < f.length && d === v; r++)v = Math.max(v, f[r].val);
                    var y = t.autorange, m = "reversed" === y || "min reversed" === y || "max reversed" === y;
                    if (!m && t.range) {
                        var x = i.simpleMap(t.range, t.r2l);
                        m = x[1] < x[0];
                    }
                    "reversed" === t.autorange && (t.autorange = !0);
                    var b, _, w, T, k, A, L = t.rangemode, S = "tozero" === L, D = "nonnegative" === L, O = t._length, C = O / 10, P = 0;
                    for(r = 0; r < u.length; r++)for(b = u[r], n = 0; n < f.length; n++)(A = (_ = f[n]).val - b.val - h(t, b.val, _.val)) > 0 && ((k = O - l(b) - s(_)) > C ? A / k > P && (w = b, T = _, P = A / k) : A / O > P && (w = {
                        val: b.val,
                        nopad: 1
                    }, T = {
                        val: _.val,
                        nopad: 1
                    }, P = A / O));
                    if (d === v) {
                        var I = d - 1, R = d + 1;
                        if (S) {
                            if (0 === d) a = [
                                0,
                                1
                            ];
                            else {
                                var z = (d > 0 ? f : u).reduce(function(e, t) {
                                    return Math.max(e, s(t));
                                }, 0), N = d / (1 - Math.min(.5, z / O));
                                a = d > 0 ? [
                                    0,
                                    N
                                ] : [
                                    N,
                                    0
                                ];
                            }
                        } else a = D ? [
                            Math.max(0, I),
                            Math.max(1, R)
                        ] : [
                            I,
                            R
                        ];
                    } else S ? (w.val >= 0 && (w = {
                        val: 0,
                        nopad: 1
                    }), T.val <= 0 && (T = {
                        val: 0,
                        nopad: 1
                    })) : D && (w.val - P * l(w) < 0 && (w = {
                        val: 0,
                        nopad: 1
                    }), T.val <= 0 && (T = {
                        val: 1,
                        nopad: 1
                    })), P = (T.val - w.val - h(t, b.val, _.val)) / (O - l(w) - s(T)), a = [
                        w.val - P * l(w),
                        T.val + P * s(T)
                    ];
                    return a = M(a, t), t.limitRange && t.limitRange(), m && a.reverse(), i.simpleMap(a, t.l2r || Number);
                }
                function h(e, t, r) {
                    var n = 0;
                    if (e.rangebreaks) for(var a = e.locateBreaks(t, r), i = 0; i < a.length; i++){
                        var o = a[i];
                        n += o.max - o.min;
                    }
                    return n;
                }
                function p(e, t, r) {
                    var a = .05 * t._length, o = t._anchorAxis || {};
                    if (-1 !== (t.ticklabelposition || "").indexOf("inside") || -1 !== (o.ticklabelposition || "").indexOf("inside")) {
                        var l = t.isReversed();
                        if (!l) {
                            var c = i.simpleMap(t.range, t.r2l);
                            l = c[1] < c[0];
                        }
                        l && (r = !r);
                    }
                    var u = 0;
                    return f(e, t._id) || (u = function(e, t, r) {
                        var a = 0, o = "x" === t._id.charAt(0);
                        for(var l in e._plots){
                            var c = e._plots[l];
                            if (t._id === c.xaxis._id || t._id === c.yaxis._id) {
                                var u = (o ? c.yaxis : c.xaxis) || {};
                                if (-1 !== (u.ticklabelposition || "").indexOf("inside") && (!r && ("left" === u.side || "bottom" === u.side) || r && ("top" === u.side || "right" === u.side))) {
                                    if (u._vals) {
                                        var f = i.deg2rad(u._tickAngles[u._id + "tick"] || 0), d = Math.abs(Math.cos(f)), h = Math.abs(Math.sin(f));
                                        if (!u._vals[0].bb) {
                                            var p = u._id + "tick";
                                            u._selections[p].each(function(e) {
                                                var t = n.select(this);
                                                t.select(".text-math-group").empty() && (e.bb = s.bBox(t.node()));
                                            });
                                        }
                                        for(var g = 0; g < u._vals.length; g++){
                                            var y = u._vals[g].bb;
                                            if (y) {
                                                var m = 2 * v + y.width, x = 2 * v + y.height;
                                                a = Math.max(a, o ? Math.max(m * d, x * h) : Math.max(x * d, m * h));
                                            }
                                        }
                                    }
                                    "inside" === u.ticks && "inside" === u.ticklabelposition && (a += u.ticklen || 0);
                                }
                            }
                        }
                        return a;
                    }(e, t, r)), a = Math.max(u, a), "domain" === t.constrain && t._inputDomain && (a *= (t._inputDomain[1] - t._inputDomain[0]) / (t.domain[1] - t.domain[0])), function(e) {
                        return e.nopad ? 0 : e.pad + (e.extrapad ? a : u);
                    };
                }
                e.exports = {
                    applyAutorangeOptions: M,
                    getAutoRange: d,
                    makePadFn: p,
                    doAutoRange: function(e, t, r) {
                        if (t.setScale(), t.autorange) {
                            t.range = r ? r.slice() : d(e, t), t._r = t.range.slice(), t._rl = i.simpleMap(t._r, t.r2l);
                            var n = t._input, a = {};
                            a[t._attr + ".range"] = t.range, a[t._attr + ".autorange"] = t.autorange, l.call("_storeDirectGUIEdit", e.layout, e._fullLayout._preGUI, a), n.range = t.range.slice(), n.autorange = t.autorange;
                        }
                        var o = t._anchorAxis;
                        if (o && o.rangeslider) {
                            var s = o.rangeslider[t._name];
                            s && "auto" === s.rangemode && (s.range = d(e, t)), o._input.rangeslider[t._name] = i.extendFlat({}, s);
                        }
                    },
                    findExtremes: function(e, t, r) {
                        r || (r = {}), e._m || e.setScale();
                        var n, i, l, s, c, u, f, d, h, p = [], v = [], g = t.length, x = r.padded || !1, _ = r.tozero && ("linear" === e.type || "-" === e.type), w = "log" === e.type, T = !1, M = r.vpadLinearized || !1;
                        function k(e) {
                            if (Array.isArray(e)) return T = !0, function(t) {
                                return Math.max(Number(e[t] || 0), 0);
                            };
                            var t = Math.max(Number(e || 0), 0);
                            return function() {
                                return t;
                            };
                        }
                        var A = k((e._m > 0 ? r.ppadplus : r.ppadminus) || r.ppad || 0), L = k((e._m > 0 ? r.ppadminus : r.ppadplus) || r.ppad || 0), S = k(r.vpadplus || r.vpad), D = k(r.vpadminus || r.vpad);
                        if (!T) {
                            if (d = 1 / 0, h = -1 / 0, w) for(n = 0; n < g; n++)(i = t[n]) < d && i > 0 && (d = i), i > h && i < o && (h = i);
                            else for(n = 0; n < g; n++)(i = t[n]) < d && i > -o && (d = i), i > h && i < o && (h = i);
                            t = [
                                d,
                                h
                            ], g = 2;
                        }
                        var O = {
                            tozero: _,
                            extrapad: x
                        };
                        function C(r) {
                            l = t[r], a(l) && (u = A(r), f = L(r), M ? (s = e.c2l(l) - D(r), c = e.c2l(l) + S(r)) : (d = l - D(r), h = l + S(r), w && d < h / 10 && (d = h / 10), s = e.c2l(d), c = e.c2l(h)), _ && (s = Math.min(0, s), c = Math.max(0, c)), b(s) && y(p, s, f, O), b(c) && m(v, c, u, O));
                        }
                        var P = Math.min(6, g);
                        for(n = 0; n < P; n++)C(n);
                        for(n = g - 1; n >= P; n--)C(n);
                        return {
                            min: p,
                            max: v,
                            opts: r
                        };
                    },
                    concatExtremes: g
                };
                var v = 3;
                function g(e, t, r) {
                    var n, a, i, o = t._id, l = e._fullData, s = e._fullLayout, c = [], f = [];
                    function d(e, t) {
                        for(n = 0; n < t.length; n++){
                            var r = e[t[n]], l = (r._extremes || {})[o];
                            if (!0 === r.visible && l) {
                                for(a = 0; a < l.min.length; a++)i = l.min[a], y(c, i.val, i.pad, {
                                    extrapad: i.extrapad
                                });
                                for(a = 0; a < l.max.length; a++)i = l.max[a], m(f, i.val, i.pad, {
                                    extrapad: i.extrapad
                                });
                            }
                        }
                    }
                    if (d(l, t._traceIndices), d(s.annotations || [], t._annIndices || []), d(s.shapes || [], t._shapeIndices || []), t._matchGroup && !r) {
                        for(var h in t._matchGroup)if (h !== t._id) {
                            var p = u(e, h), v = g(e, p, !0), x = t._length / p._length;
                            for(a = 0; a < v.min.length; a++)i = v.min[a], y(c, i.val, i.pad * x, {
                                extrapad: i.extrapad
                            });
                            for(a = 0; a < v.max.length; a++)i = v.max[a], m(f, i.val, i.pad * x, {
                                extrapad: i.extrapad
                            });
                        }
                    }
                    return {
                        min: c,
                        max: f
                    };
                }
                function y(e, t, r, n) {
                    x(e, t, r, n, _);
                }
                function m(e, t, r, n) {
                    x(e, t, r, n, w);
                }
                function x(e, t, r, n, a) {
                    for(var i = n.tozero, o = n.extrapad, l = !0, s = 0; s < e.length && l; s++){
                        var c = e[s];
                        if (a(c.val, t) && c.pad >= r && (c.extrapad || !o)) {
                            l = !1;
                            break;
                        }
                        a(t, c.val) && c.pad <= r && (o || !c.extrapad) && (e.splice(s, 1), s--);
                    }
                    if (l) {
                        var u = i && 0 === t;
                        e.push({
                            val: t,
                            pad: u ? 0 : r,
                            extrapad: !u && o
                        });
                    }
                }
                function b(e) {
                    return a(e) && Math.abs(e) < o;
                }
                function _(e, t) {
                    return e <= t;
                }
                function w(e, t) {
                    return e >= t;
                }
                function T(e, t, r) {
                    return void 0 === t || void 0 === r || (t = e.d2l(t)) < e.d2l(r);
                }
                function M(e, t) {
                    if (!t || !t.autorangeoptions) return e;
                    var r = e[0], n = e[1], a = t.autorangeoptions.include;
                    if (void 0 !== a) {
                        var o = t.d2l(r), l = t.d2l(n);
                        i.isArrayOrTypedArray(a) || (a = [
                            a
                        ]);
                        for(var s = 0; s < a.length; s++){
                            var c = t.d2l(a[s]);
                            o >= c && (o = c, r = c), l <= c && (l = c, n = c);
                        }
                    }
                    return r = function(e, t) {
                        var r = t.autorangeoptions;
                        return r && void 0 !== r.minallowed && T(t, r.minallowed, r.maxallowed) ? r.minallowed : r && void 0 !== r.clipmin && T(t, r.clipmin, r.clipmax) ? Math.max(e, t.d2l(r.clipmin)) : e;
                    }(r, t), n = function(e, t) {
                        var r = t.autorangeoptions;
                        return r && void 0 !== r.maxallowed && T(t, r.minallowed, r.maxallowed) ? r.maxallowed : r && void 0 !== r.clipmax && T(t, r.clipmin, r.clipmax) ? Math.min(e, t.d2l(r.clipmax)) : e;
                    }(n, t), [
                        r,
                        n
                    ];
                }
            },
            3074: function(e) {
                "use strict";
                e.exports = function(e, t, r) {
                    var n, a;
                    if (r) {
                        var i = "reversed" === t || "min reversed" === t || "max reversed" === t;
                        n = r[i ? 1 : 0], a = r[i ? 0 : 1];
                    }
                    var o = e("autorangeoptions.minallowed", null === a ? n : void 0), l = e("autorangeoptions.maxallowed", null === n ? a : void 0);
                    void 0 === o && e("autorangeoptions.clipmin"), void 0 === l && e("autorangeoptions.clipmax"), e("autorangeoptions.include");
                };
            },
            9298: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(2770), i = r(4875), o = r(3972), l = r(1828), s = l.strTranslate, c = r(3893), u = r(2998), f = r(7901), d = r(1424), h = r(3838), p = r(6287), v = r(606), g = v.ONEMAXYEAR, y = v.ONEAVGYEAR, m = v.ONEMINYEAR, x = v.ONEMAXQUARTER, b = v.ONEAVGQUARTER, _ = v.ONEMINQUARTER, w = v.ONEMAXMONTH, T = v.ONEAVGMONTH, M = v.ONEMINMONTH, k = v.ONEWEEK, A = v.ONEDAY, L = A / 2, S = v.ONEHOUR, D = v.ONEMIN, O = v.ONESEC, C = v.MINUS_SIGN, P = v.BADNUM, I = {
                    K: "zeroline"
                }, R = {
                    K: "gridline",
                    L: "path"
                }, z = {
                    K: "minor-gridline",
                    L: "path"
                }, N = {
                    K: "tick",
                    L: "path"
                }, F = {
                    K: "tick",
                    L: "text"
                }, E = {
                    width: [
                        "x",
                        "r",
                        "l",
                        "xl",
                        "xr"
                    ],
                    height: [
                        "y",
                        "t",
                        "b",
                        "yt",
                        "yb"
                    ],
                    right: [
                        "r",
                        "xr"
                    ],
                    left: [
                        "l",
                        "xl"
                    ],
                    top: [
                        "t",
                        "yt"
                    ],
                    bottom: [
                        "b",
                        "yb"
                    ]
                }, H = r(8783), j = H.MID_SHIFT, B = H.CAP_SHIFT, Y = H.LINE_SPACING, V = H.OPPOSITE_SIDE, U = e.exports = {};
                U.setConvert = r(1994);
                var q = r(4322), G = r(1675), Z = G.idSort, W = G.isLinked;
                U.id2name = G.id2name, U.name2id = G.name2id, U.cleanId = G.cleanId, U.list = G.list, U.listIds = G.listIds, U.getFromId = G.getFromId, U.getFromTrace = G.getFromTrace;
                var X = r(1739);
                U.getAutoRange = X.getAutoRange, U.findExtremes = X.findExtremes;
                var J = 1e-4;
                function K(e) {
                    var t = (e[1] - e[0]) * J;
                    return [
                        e[0] - t,
                        e[1] + t
                    ];
                }
                U.coerceRef = function(e, t, r, n, a, i) {
                    var o = n.charAt(n.length - 1), s = r._fullLayout._subplots[o + "axis"], c = n + "ref", u = {};
                    return a || (a = s[0] || ("string" == typeof i ? i : i[0])), i || (i = a), s = s.concat(s.map(function(e) {
                        return e + " domain";
                    })), u[c] = {
                        valType: "enumerated",
                        values: s.concat(i ? "string" == typeof i ? [
                            i
                        ] : i : []),
                        dflt: a
                    }, l.coerce(e, t, u, c);
                }, U.getRefType = function(e) {
                    return void 0 === e ? e : "paper" === e ? "paper" : "pixel" === e ? "pixel" : /( domain)$/.test(e) ? "domain" : "range";
                }, U.coercePosition = function(e, t, r, n, a, i) {
                    var o, s;
                    if ("range" !== U.getRefType(n)) o = l.ensureNumber, s = r(a, i);
                    else {
                        var c = U.getFromId(t, n);
                        s = r(a, i = c.fraction2r(i)), o = c.cleanPos;
                    }
                    e[a] = o(s);
                }, U.cleanPosition = function(e, t, r) {
                    return ("paper" === r || "pixel" === r ? l.ensureNumber : U.getFromId(t, r).cleanPos)(e);
                }, U.redrawComponents = function(e, t) {
                    t = t || U.listIds(e);
                    var r = e._fullLayout;
                    function n(n, a, i, l) {
                        for(var s = o.getComponentMethod(n, a), c = {}, u = 0; u < t.length; u++)for(var f = r[U.id2name(t[u])][i], d = 0; d < f.length; d++){
                            var h = f[d];
                            if (!c[h] && (s(e, h), c[h] = 1, l)) return;
                        }
                    }
                    n("annotations", "drawOne", "_annIndices"), n("shapes", "drawOne", "_shapeIndices"), n("images", "draw", "_imgIndices", !0), n("selections", "drawOne", "_selectionIndices");
                };
                var Q = U.getDataConversions = function(e, t, r, n) {
                    var a, i = "x" === r || "y" === r || "z" === r ? r : n;
                    if (Array.isArray(i)) {
                        if (a = {
                            type: q(n, void 0, {
                                autotypenumbers: e._fullLayout.autotypenumbers
                            }),
                            _categories: []
                        }, U.setConvert(a), "category" === a.type) for(var o = 0; o < n.length; o++)a.d2c(n[o]);
                    } else a = U.getFromTrace(e, t, i);
                    return a ? {
                        d2c: a.d2c,
                        c2d: a.c2d
                    } : "ids" === i ? {
                        d2c: ee,
                        c2d: ee
                    } : {
                        d2c: $,
                        c2d: $
                    };
                };
                function $(e) {
                    return +e;
                }
                function ee(e) {
                    return String(e);
                }
                function te(e, t) {
                    return Math.abs((e / t + .5) % 1 - .5) < .001;
                }
                function re(e, t) {
                    return Math.abs(e / t - 1) < .001;
                }
                function ne(e) {
                    return +e.substring(1);
                }
                function ae(e, t) {
                    return e.rangebreaks && (t = t.filter(function(t) {
                        return e.maskBreaks(t.x) !== P;
                    })), t;
                }
                function ie(e) {
                    var t = e._mainAxis, r = [];
                    if (t._vals) {
                        for(var n = 0; n < t._vals.length; n++)if (!t._vals[n].noTick) {
                            var a = t.l2p(t._vals[n].x), i = e.p2l(a), o = U.tickText(e, i);
                            t._vals[n].minor && (o.minor = !0, o.text = ""), r.push(o);
                        }
                    }
                    return ae(e, r);
                }
                function oe(e) {
                    var t = K(l.simpleMap(e.range, e.r2l)), r = Math.min(t[0], t[1]), n = Math.max(t[0], t[1]), a = "category" === e.type ? e.d2l_noadd : e.d2l;
                    "log" === e.type && "L" !== String(e.dtick).charAt(0) && (e.dtick = "L" + Math.pow(10, Math.floor(Math.min(e.range[0], e.range[1])) - 1));
                    for(var i = [], o = 0; o <= 1; o++)if (!o || e.minor) {
                        var s = o ? e.minor.tickvals : e.tickvals, c = o ? [] : e.ticktext;
                        if (s) {
                            Array.isArray(c) || (c = []);
                            for(var u = 0; u < s.length; u++){
                                var f = a(s[u]);
                                if (f > r && f < n) {
                                    var d = void 0 === c[u] ? U.tickText(e, f) : ge(e, f, String(c[u]));
                                    o && (d.minor = !0, d.text = ""), i.push(d);
                                }
                            }
                        }
                    }
                    return ae(e, i);
                }
                U.getDataToCoordFunc = function(e, t, r, n) {
                    return Q(e, t, r, n).d2c;
                }, U.counterLetter = function(e) {
                    var t = e.charAt(0);
                    return "x" === t ? "y" : "y" === t ? "x" : void 0;
                }, U.minDtick = function(e, t, r, n) {
                    -1 === [
                        "log",
                        "category",
                        "multicategory"
                    ].indexOf(e.type) && n ? void 0 === e._minDtick ? (e._minDtick = t, e._forceTick0 = r) : e._minDtick && ((e._minDtick / t + 1e-6) % 1 < 2e-6 && ((r - e._forceTick0) / t % 1 + 1.000001) % 1 < 2e-6 ? (e._minDtick = t, e._forceTick0 = r) : ((t / e._minDtick + 1e-6) % 1 > 2e-6 || ((r - e._forceTick0) / e._minDtick % 1 + 1.000001) % 1 > 2e-6) && (e._minDtick = 0)) : e._minDtick = 0;
                }, U.saveRangeInitial = function(e, t) {
                    for(var r = U.list(e, "", !0), n = !1, a = 0; a < r.length; a++){
                        var i = r[a], o = void 0 === i._rangeInitial0 && void 0 === i._rangeInitial1, l = o || i.range[0] !== i._rangeInitial0 || i.range[1] !== i._rangeInitial1, s = i.autorange;
                        (o && !0 !== s || t && l) && (i._rangeInitial0 = "min" === s || "max reversed" === s ? void 0 : i.range[0], i._rangeInitial1 = "max" === s || "min reversed" === s ? void 0 : i.range[1], i._autorangeInitial = s, n = !0);
                    }
                    return n;
                }, U.saveShowSpikeInitial = function(e, t) {
                    for(var r = U.list(e, "", !0), n = !1, a = "on", i = 0; i < r.length; i++){
                        var o = r[i], l = void 0 === o._showSpikeInitial, s = l || !(o.showspikes === o._showspikes);
                        (l || t && s) && (o._showSpikeInitial = o.showspikes, n = !0), "on" !== a || o.showspikes || (a = "off");
                    }
                    return e._fullLayout._cartesianSpikesEnabled = a, n;
                }, U.autoBin = function(e, t, r, n, i, o) {
                    var s, c = l.aggNums(Math.min, null, e), u = l.aggNums(Math.max, null, e);
                    if ("category" === t.type || "multicategory" === t.type) return {
                        start: c - .5,
                        end: u + .5,
                        size: Math.max(1, Math.round(o) || 1),
                        _dataSpan: u - c
                    };
                    if (i || (i = t.calendar), s = "log" === t.type ? {
                        type: "linear",
                        range: [
                            c,
                            u
                        ]
                    } : {
                        type: t.type,
                        range: l.simpleMap([
                            c,
                            u
                        ], t.c2r, 0, i),
                        calendar: i
                    }, U.setConvert(s), o = o && p.dtick(o, s.type)) s.dtick = o, s.tick0 = p.tick0(void 0, s.type, i);
                    else {
                        var f;
                        if (r) f = (u - c) / r;
                        else {
                            var d = l.distinctVals(e), h = Math.pow(10, Math.floor(Math.log(d.minDiff) / Math.LN10)), v = h * l.roundUp(d.minDiff / h, [
                                .9,
                                1.9,
                                4.9,
                                9.9
                            ], !0);
                            f = Math.max(v, 2 * l.stdev(e) / Math.pow(e.length, n ? .25 : .4)), a(f) || (f = 1);
                        }
                        U.autoTicks(s, f);
                    }
                    var g, y = s.dtick, m = U.tickIncrement(U.tickFirst(s), y, "reverse", i);
                    if ("number" == typeof y) m = function(e, t, r, n, i) {
                        var o = 0, l = 0, s = 0, c = 0;
                        function u(t) {
                            return (1 + 100 * (t - e) / r.dtick) % 100 < 2;
                        }
                        for(var f = 0; f < t.length; f++)t[f] % 1 == 0 ? s++ : a(t[f]) || c++, u(t[f]) && o++, u(t[f] + r.dtick / 2) && l++;
                        var d = t.length - c;
                        if (s === d && "date" !== r.type) r.dtick < 1 ? e = n - .5 * r.dtick : (e -= .5) + r.dtick < n && (e += r.dtick);
                        else if (l < .1 * d && (o > .3 * d || u(n) || u(i))) {
                            var h = r.dtick / 2;
                            e += e + h < n ? h : -h;
                        }
                        return e;
                    }(m, e, s, c, u), g = m + (1 + Math.floor((u - m) / y)) * y;
                    else for("M" === s.dtick.charAt(0) && (m = function(e, t, r, n, a) {
                        var i = l.findExactDates(t, a);
                        if (i.exactDays > .8) {
                            var o = Number(r.substr(1));
                            i.exactYears > .8 && o % 12 == 0 ? e = U.tickIncrement(e, "M6", "reverse") + 1.5 * A : i.exactMonths > .8 ? e = U.tickIncrement(e, "M1", "reverse") + 15.5 * A : e -= L;
                            var s = U.tickIncrement(e, r);
                            if (s <= n) return s;
                        }
                        return e;
                    }(m, e, y, c, i)), g = m; g <= u;)g = U.tickIncrement(g, y, !1, i);
                    return {
                        start: t.c2r(m, 0, i),
                        end: t.c2r(g, 0, i),
                        size: y,
                        _dataSpan: u - c
                    };
                }, U.prepMinorTicks = function(e, t, r) {
                    if (!t.minor.dtick) {
                        delete e.dtick;
                        var n, i = t.dtick && a(t._tmin);
                        if (i) {
                            var o = U.tickIncrement(t._tmin, t.dtick, !0);
                            n = [
                                t._tmin,
                                .99 * o + .01 * t._tmin
                            ];
                        } else {
                            var s = l.simpleMap(t.range, t.r2l);
                            n = [
                                s[0],
                                .8 * s[0] + .2 * s[1]
                            ];
                        }
                        if (e.range = l.simpleMap(n, t.l2r), e._isMinor = !0, U.prepTicks(e, r), i) {
                            var c = a(t.dtick), u = a(e.dtick), f = c ? t.dtick : +t.dtick.substring(1), d = u ? e.dtick : +e.dtick.substring(1);
                            c && u ? te(f, d) ? f === 2 * k && d === 2 * A && (e.dtick = k) : f === 2 * k && d === 3 * A ? e.dtick = k : f !== k || (t._input.minor || {}).nticks ? re(f / d, 2.5) ? e.dtick = f / 2 : e.dtick = f : e.dtick = A : "M" === String(t.dtick).charAt(0) ? u ? e.dtick = "M1" : te(f, d) ? f >= 12 && 2 === d && (e.dtick = "M3") : e.dtick = t.dtick : "L" === String(e.dtick).charAt(0) ? "L" === String(t.dtick).charAt(0) ? te(f, d) || (e.dtick = re(f / d, 2.5) ? t.dtick / 2 : t.dtick) : e.dtick = "D1" : "D2" === e.dtick && +t.dtick > 1 && (e.dtick = 1);
                        }
                        e.range = t.range;
                    }
                    void 0 === t.minor._tick0Init && (e.tick0 = t.tick0);
                }, U.prepTicks = function(e, t) {
                    var r = l.simpleMap(e.range, e.r2l, void 0, void 0, t);
                    if ("auto" === e.tickmode || !e.dtick) {
                        var n, i = e.nticks;
                        i || ("category" === e.type || "multicategory" === e.type ? (n = e.tickfont ? l.bigFont(e.tickfont.size || 12) : 15, i = e._length / n) : (n = "y" === e._id.charAt(0) ? 40 : 80, i = l.constrain(e._length / n, 4, 9) + 1), "radialaxis" === e._name && (i *= 2)), e.minor && "array" !== e.minor.tickmode || "array" === e.tickmode && (i *= 100), e._roughDTick = Math.abs(r[1] - r[0]) / i, U.autoTicks(e, e._roughDTick), e._minDtick > 0 && e.dtick < 2 * e._minDtick && (e.dtick = e._minDtick, e.tick0 = e.l2r(e._forceTick0));
                    }
                    "period" === e.ticklabelmode && function(e) {
                        var t;
                        function r() {
                            return !(a(e.dtick) || "M" !== e.dtick.charAt(0));
                        }
                        var n = r(), i = U.getTickFormat(e);
                        if (i) {
                            var o = e._dtickInit !== e.dtick;
                            /%[fLQsSMX]/.test(i) || (/%[HI]/.test(i) ? (t = S, o && !n && e.dtick < S && (e.dtick = S)) : /%p/.test(i) ? (t = L, o && !n && e.dtick < L && (e.dtick = L)) : /%[Aadejuwx]/.test(i) ? (t = A, o && !n && e.dtick < A && (e.dtick = A)) : /%[UVW]/.test(i) ? (t = k, o && !n && e.dtick < k && (e.dtick = k)) : /%[Bbm]/.test(i) ? (t = T, o && (n ? ne(e.dtick) < 1 : e.dtick < M) && (e.dtick = "M1")) : /%[q]/.test(i) ? (t = b, o && (n ? ne(e.dtick) < 3 : e.dtick < _) && (e.dtick = "M3")) : /%[Yy]/.test(i) && (t = y, o && (n ? ne(e.dtick) < 12 : e.dtick < m) && (e.dtick = "M12")));
                        }
                        (n = r()) && e.tick0 === e._dowTick0 && (e.tick0 = e._rawTick0), e._definedDelta = t;
                    }(e), e.tick0 || (e.tick0 = "date" === e.type ? "2000-01-01" : 0), "date" === e.type && e.dtick < .1 && (e.dtick = .1), ve(e);
                }, U.calcTicks = function(e, t) {
                    for(var r, n, i = e.type, o = e.calendar, s = e.ticklabelstep, c = "period" === e.ticklabelmode, u = l.simpleMap(e.range, e.r2l, void 0, void 0, t), f = u[1] < u[0], d = Math.min(u[0], u[1]), h = Math.max(u[0], u[1]), p = Math.max(1e3, e._length || 0), v = [], D = [], O = [], C = [], I = e.minor && (e.minor.ticks || e.minor.showgrid), R = 1; R >= (I ? 0 : 1); R--){
                        var z = !R;
                        R ? (e._dtickInit = e.dtick, e._tick0Init = e.tick0) : (e.minor._dtickInit = e.minor.dtick, e.minor._tick0Init = e.minor.tick0);
                        var N = R ? e : l.extendFlat({}, e, e.minor);
                        if (z ? U.prepMinorTicks(N, e, t) : U.prepTicks(N, t), "array" !== N.tickmode) {
                            if ("sync" !== N.tickmode) {
                                var F = K(u), E = F[0], H = F[1], j = a(N.dtick), B = "log" === i && !(j || "L" === N.dtick.charAt(0)), Y = U.tickFirst(N, t);
                                if (R) {
                                    if (e._tmin = Y, Y < E !== f) break;
                                    "category" !== i && "multicategory" !== i || (H = f ? Math.max(-0.5, H) : Math.min(e._categories.length - .5, H));
                                }
                                var V, q, G = null, Z = Y;
                                R && (j ? q = e.dtick : "date" === i ? "string" == typeof e.dtick && "M" === e.dtick.charAt(0) && (q = T * e.dtick.substring(1)) : q = e._roughDTick, V = Math.round((e.r2l(Z) - e.r2l(e.tick0)) / q) - 1);
                                var W = N.dtick;
                                for(N.rangebreaks && N._tick0Init !== N.tick0 && (Z = ze(Z, e), f || (Z = U.tickIncrement(Z, W, !f, o))), R && c && (Z = U.tickIncrement(Z, W, !f, o), V--); f ? Z >= H : Z <= H; Z = U.tickIncrement(Z, W, f, o)){
                                    if (R && V++, N.rangebreaks && !f) {
                                        if (Z < E) continue;
                                        if (N.maskBreaks(Z) === P && ze(Z, N) >= h) break;
                                    }
                                    if (O.length > p || Z === G) break;
                                    G = Z;
                                    var X = {
                                        value: Z
                                    };
                                    R ? (B && Z !== (0 | Z) && (X.simpleLabel = !0), s > 1 && V % s && (X.skipLabel = !0), O.push(X)) : (X.minor = !0, C.push(X));
                                }
                            } else O = [], v = ie(e);
                        } else R ? (O = [], v = oe(e)) : (C = [], D = oe(e));
                    }
                    if (I && !("inside" === e.minor.ticks && "outside" === e.ticks || "outside" === e.minor.ticks && "inside" === e.ticks)) {
                        for(var J = O.map(function(e) {
                            return e.value;
                        }), Q = [], $ = 0; $ < C.length; $++){
                            var ee = C[$], te = ee.value;
                            if (-1 === J.indexOf(te)) {
                                for(var re = !1, ne = 0; !re && ne < O.length; ne++)1e7 + O[ne].value === 1e7 + te && (re = !0);
                                re || Q.push(ee);
                            }
                        }
                        C = Q;
                    }
                    if (c && function(e, t, r) {
                        for(var n = 0; n < e.length; n++){
                            var a = e[n].value, i = n, o = n + 1;
                            n < e.length - 1 ? (i = n, o = n + 1) : n > 0 ? (i = n - 1, o = n) : (i = n, o = n);
                            var l, s = e[i].value, c = e[o].value, u = Math.abs(c - s), f = r || u, d = 0;
                            f >= m ? d = u >= m && u <= g ? u : y : r === b && f >= _ ? d = u >= _ && u <= x ? u : b : f >= M ? d = u >= M && u <= w ? u : T : r === k && f >= k ? d = k : f >= A ? d = A : r === L && f >= L ? d = L : r === S && f >= S && (d = S), d >= u && (d = u, l = !0);
                            var h = a + d;
                            if (t.rangebreaks && d > 0) {
                                for(var p = 0, v = 0; v < 84; v++){
                                    var D = (v + .5) / 84;
                                    t.maskBreaks(a * (1 - D) + D * h) !== P && p++;
                                }
                                (d *= p / 84) || (e[n].drop = !0), l && u > k && (d = u);
                            }
                            (d > 0 || 0 === n) && (e[n].periodX = a + d / 2);
                        }
                    }(O, e, e._definedDelta), e.rangebreaks) {
                        var ae = "y" === e._id.charAt(0), le = 1;
                        "auto" === e.tickmode && (le = e.tickfont ? e.tickfont.size : 12);
                        var se = NaN;
                        for(r = O.length - 1; r > -1; r--)if (O[r].drop) O.splice(r, 1);
                        else {
                            O[r].value = ze(O[r].value, e);
                            var ce = e.c2p(O[r].value);
                            (ae ? se > ce - le : se < ce + le) ? O.splice(f ? r + 1 : r, 1) : se = ce;
                        }
                    }
                    Re(e) && 360 === Math.abs(u[1] - u[0]) && O.pop(), e._tmax = (O[O.length - 1] || {}).value, e._prevDateHead = "", e._inCalcTicks = !0;
                    var ue, fe, de = function(t) {
                        t.text = "", e._prevDateHead = n;
                    };
                    for(O = O.concat(C), r = 0; r < O.length; r++){
                        var he = O[r].minor, pe = O[r].value;
                        he ? D.push({
                            x: pe,
                            minor: !0
                        }) : (n = e._prevDateHead, ue = U.tickText(e, pe, !1, O[r].simpleLabel), void 0 !== (fe = O[r].periodX) && (ue.periodX = fe, (fe > h || fe < d) && (fe > h && (ue.periodX = h), fe < d && (ue.periodX = d), de(ue))), O[r].skipLabel && de(ue), v.push(ue));
                    }
                    return v = v.concat(D), e._inCalcTicks = !1, c && v.length && (v[0].noTick = !0), v;
                };
                var le = [
                    2,
                    5,
                    10
                ], se = [
                    1,
                    2,
                    3,
                    6,
                    12
                ], ce = [
                    1,
                    2,
                    5,
                    10,
                    15,
                    30
                ], ue = [
                    1,
                    2,
                    3,
                    7,
                    14
                ], fe = [
                    -0.046,
                    0,
                    .301,
                    .477,
                    .602,
                    .699,
                    .778,
                    .845,
                    .903,
                    .954,
                    1
                ], de = [
                    -0.301,
                    0,
                    .301,
                    .699,
                    1
                ], he = [
                    15,
                    30,
                    45,
                    90,
                    180
                ];
                function pe(e, t, r) {
                    return t * l.roundUp(e / t, r);
                }
                function ve(e) {
                    var t = e.dtick;
                    if (e._tickexponent = 0, a(t) || "string" == typeof t || (t = 1), "category" !== e.type && "multicategory" !== e.type || (e._tickround = null), "date" === e.type) {
                        var r = e.r2l(e.tick0), n = e.l2r(r).replace(/(^-|i)/g, ""), i = n.length;
                        if ("M" === String(t).charAt(0)) i > 10 || "01-01" !== n.substr(5) ? e._tickround = "d" : e._tickround = +t.substr(1) % 12 == 0 ? "y" : "m";
                        else if (t >= A && i <= 10 || t >= 15 * A) e._tickround = "d";
                        else if (t >= D && i <= 16 || t >= S) e._tickround = "M";
                        else if (t >= O && i <= 19 || t >= D) e._tickround = "S";
                        else {
                            var o = e.l2r(r + t).replace(/^-/, "").length;
                            e._tickround = Math.max(i, o) - 20, e._tickround < 0 && (e._tickround = 4);
                        }
                    } else if (a(t) || "L" === t.charAt(0)) {
                        var l = e.range.map(e.r2d || Number);
                        a(t) || (t = Number(t.substr(1))), e._tickround = 2 - Math.floor(Math.log(t) / Math.LN10 + .01);
                        var s = Math.max(Math.abs(l[0]), Math.abs(l[1])), c = Math.floor(Math.log(s) / Math.LN10 + .01), u = void 0 === e.minexponent ? 3 : e.minexponent;
                        Math.abs(c) > u && (me(e.exponentformat) && !xe(c) ? e._tickexponent = 3 * Math.round((c - 1) / 3) : e._tickexponent = c);
                    } else e._tickround = null;
                }
                function ge(e, t, r) {
                    var n = e.tickfont || {};
                    return {
                        x: t,
                        dx: 0,
                        dy: 0,
                        text: r || "",
                        fontSize: n.size,
                        font: n.family,
                        fontColor: n.color
                    };
                }
                U.autoTicks = function(e, t, r) {
                    var n;
                    function i(e) {
                        return Math.pow(e, Math.floor(Math.log(t) / Math.LN10));
                    }
                    if ("date" === e.type) {
                        e.tick0 = l.dateTick0(e.calendar, 0);
                        var o = 2 * t;
                        if (o > y) t /= y, n = i(10), e.dtick = "M" + 12 * pe(t, n, le);
                        else if (o > T) t /= T, e.dtick = "M" + pe(t, 1, se);
                        else if (o > A) {
                            if (e.dtick = pe(t, A, e._hasDayOfWeekBreaks ? [
                                1,
                                2,
                                7,
                                14
                            ] : ue), !r) {
                                var s = U.getTickFormat(e), c = "period" === e.ticklabelmode;
                                c && (e._rawTick0 = e.tick0), /%[uVW]/.test(s) ? e.tick0 = l.dateTick0(e.calendar, 2) : e.tick0 = l.dateTick0(e.calendar, 1), c && (e._dowTick0 = e.tick0);
                            }
                        } else o > S ? e.dtick = pe(t, S, se) : o > D ? e.dtick = pe(t, D, ce) : o > O ? e.dtick = pe(t, O, ce) : (n = i(10), e.dtick = pe(t, n, le));
                    } else if ("log" === e.type) {
                        e.tick0 = 0;
                        var u = l.simpleMap(e.range, e.r2l);
                        if (e._isMinor && (t *= 1.5), t > .7) e.dtick = Math.ceil(t);
                        else if (Math.abs(u[1] - u[0]) < 1) {
                            var f = 1.5 * Math.abs((u[1] - u[0]) / t);
                            t = Math.abs(Math.pow(10, u[1]) - Math.pow(10, u[0])) / f, n = i(10), e.dtick = "L" + pe(t, n, le);
                        } else e.dtick = t > .3 ? "D2" : "D1";
                    } else "category" === e.type || "multicategory" === e.type ? (e.tick0 = 0, e.dtick = Math.ceil(Math.max(t, 1))) : Re(e) ? (e.tick0 = 0, n = 1, e.dtick = pe(t, n, he)) : (e.tick0 = 0, n = i(10), e.dtick = pe(t, n, le));
                    if (0 === e.dtick && (e.dtick = 1), !a(e.dtick) && "string" != typeof e.dtick) {
                        var d = e.dtick;
                        throw e.dtick = 1, "ax.dtick error: " + String(d);
                    }
                }, U.tickIncrement = function(e, t, r, i) {
                    var o = r ? -1 : 1;
                    if (a(t)) return l.increment(e, o * t);
                    var s = t.charAt(0), c = o * Number(t.substr(1));
                    if ("M" === s) return l.incrementMonth(e, c, i);
                    if ("L" === s) return Math.log(Math.pow(10, e) + c) / Math.LN10;
                    if ("D" === s) {
                        var u = "D2" === t ? de : fe, f = e + .01 * o, d = l.roundUp(l.mod(f, 1), u, r);
                        return Math.floor(f) + Math.log(n.round(Math.pow(10, d), 1)) / Math.LN10;
                    }
                    throw "unrecognized dtick " + String(t);
                }, U.tickFirst = function(e, t) {
                    var r = e.r2l || Number, i = l.simpleMap(e.range, r, void 0, void 0, t), o = i[1] < i[0], s = o ? Math.floor : Math.ceil, c = K(i)[0], u = e.dtick, f = r(e.tick0);
                    if (a(u)) {
                        var d = s((c - f) / u) * u + f;
                        return "category" !== e.type && "multicategory" !== e.type || (d = l.constrain(d, 0, e._categories.length - 1)), d;
                    }
                    var h = u.charAt(0), p = Number(u.substr(1));
                    if ("M" === h) {
                        for(var v, g, y, m = 0, x = f; m < 10;){
                            if (((v = U.tickIncrement(x, u, o, e.calendar)) - c) * (x - c) <= 0) return o ? Math.min(x, v) : Math.max(x, v);
                            g = (c - (x + v) / 2) / (v - x), y = h + (Math.abs(Math.round(g)) || 1) * p, x = U.tickIncrement(x, y, g < 0 ? !o : o, e.calendar), m++;
                        }
                        return l.error("tickFirst did not converge", e), x;
                    }
                    if ("L" === h) return Math.log(s((Math.pow(10, c) - f) / p) * p + f) / Math.LN10;
                    if ("D" === h) {
                        var b = "D2" === u ? de : fe, _ = l.roundUp(l.mod(c, 1), b, o);
                        return Math.floor(c) + Math.log(n.round(Math.pow(10, _), 1)) / Math.LN10;
                    }
                    throw "unrecognized dtick " + String(u);
                }, U.tickText = function(e, t, r, n) {
                    var i, o = ge(e, t), s = "array" === e.tickmode, c = r || s, u = e.type, f = "category" === u ? e.d2l_noadd : e.d2l;
                    if (s && Array.isArray(e.ticktext)) {
                        var d = l.simpleMap(e.range, e.r2l), h = (Math.abs(d[1] - d[0]) - (e._lBreaks || 0)) / 1e4;
                        for(i = 0; i < e.ticktext.length && !(Math.abs(t - f(e.tickvals[i])) < h); i++);
                        if (i < e.ticktext.length) return o.text = String(e.ticktext[i]), o;
                    }
                    function p(n) {
                        if (void 0 === n) return !0;
                        if (r) return "none" === n;
                        var a = {
                            first: e._tmin,
                            last: e._tmax
                        }[n];
                        return "all" !== n && t !== a;
                    }
                    var v = r ? "never" : "none" !== e.exponentformat && p(e.showexponent) ? "hide" : "";
                    if ("date" === u ? function(e, t, r, n) {
                        var i = e._tickround, o = r && e.hoverformat || U.getTickFormat(e);
                        n && (i = a(i) ? 4 : ({
                            y: "m",
                            m: "d",
                            d: "M",
                            M: "S",
                            S: 4
                        })[i]);
                        var s, c = l.formatDate(t.x, o, i, e._dateFormat, e.calendar, e._extraFormat), u = c.indexOf("\n");
                        if (-1 !== u && (s = c.substr(u + 1), c = c.substr(0, u)), n && ("00:00:00" === c || "00:00" === c ? (c = s, s = "") : 8 === c.length && (c = c.replace(/:00$/, ""))), s) {
                            if (r) "d" === i ? c += ", " + s : c = s + (c ? ", " + c : "");
                            else if (e._inCalcTicks && e._prevDateHead === s) {
                                var f = Ne(e), d = e._trueSide || e.side;
                                (!f && "top" === d || f && "bottom" === d) && (c += "<br> ");
                            } else e._prevDateHead = s, c += "<br>" + s;
                        }
                        t.text = c;
                    }(e, o, r, c) : "log" === u ? function(e, t, r, n, i) {
                        var o = e.dtick, s = t.x, c = e.tickformat, u = "string" == typeof o && o.charAt(0);
                        if ("never" === i && (i = ""), n && "L" !== u && (o = "L3", u = "L"), c || "L" === u) t.text = be(Math.pow(10, s), e, i, n);
                        else if (a(o) || "D" === u && l.mod(s + .01, 1) < .1) {
                            var f = Math.round(s), d = Math.abs(f), h = e.exponentformat;
                            "power" === h || me(h) && xe(f) ? (t.text = 0 === f ? 1 : 1 === f ? "10" : "10<sup>" + (f > 1 ? "" : C) + d + "</sup>", t.fontSize *= 1.25) : ("e" === h || "E" === h) && d > 2 ? t.text = "1" + h + (f > 0 ? "+" : C) + d : (t.text = be(Math.pow(10, s), e, "", "fakehover"), "D1" === o && "y" === e._id.charAt(0) && (t.dy -= t.fontSize / 6));
                        } else {
                            if ("D" !== u) throw "unrecognized dtick " + String(o);
                            t.text = String(Math.round(Math.pow(10, l.mod(s, 1)))), t.fontSize *= .75;
                        }
                        if ("D1" === e.dtick) {
                            var p = String(t.text).charAt(0);
                            "0" !== p && "1" !== p || ("y" === e._id.charAt(0) ? t.dx -= t.fontSize / 4 : (t.dy += t.fontSize / 2, t.dx += (e.range[1] > e.range[0] ? 1 : -1) * t.fontSize * (s < 0 ? .5 : .25)));
                        }
                    }(e, o, 0, c, v) : "category" === u ? function(e, t) {
                        var r = e._categories[Math.round(t.x)];
                        void 0 === r && (r = ""), t.text = String(r);
                    }(e, o) : "multicategory" === u ? function(e, t, r) {
                        var n = Math.round(t.x), a = e._categories[n] || [], i = void 0 === a[1] ? "" : String(a[1]), o = void 0 === a[0] ? "" : String(a[0]);
                        r ? t.text = o + " - " + i : (t.text = i, t.text2 = o);
                    }(e, o, r) : Re(e) ? function(e, t, r, n, a) {
                        if ("radians" !== e.thetaunit || r) t.text = be(t.x, e, a, n);
                        else {
                            var i = t.x / 180;
                            if (0 === i) t.text = "0";
                            else {
                                var o = function(e) {
                                    function t(e, t) {
                                        return Math.abs(e - t) <= 1e-6;
                                    }
                                    var r = function(e) {
                                        for(var r = 1; !t(Math.round(e * r) / r, e);)r *= 10;
                                        return r;
                                    }(e), n = e * r, a = Math.abs(function e(r, n) {
                                        return t(n, 0) ? r : e(n, r % n);
                                    }(n, r));
                                    return [
                                        Math.round(n / a),
                                        Math.round(r / a)
                                    ];
                                }(i);
                                if (o[1] >= 100) t.text = be(l.deg2rad(t.x), e, a, n);
                                else {
                                    var s = t.x < 0;
                                    1 === o[1] ? 1 === o[0] ? t.text = "\u03C0" : t.text = o[0] + "\u03C0" : t.text = [
                                        "<sup>",
                                        o[0],
                                        "</sup>",
                                        "\u2044",
                                        "<sub>",
                                        o[1],
                                        "</sub>",
                                        "\u03C0"
                                    ].join(""), s && (t.text = C + t.text);
                                }
                            }
                        }
                    }(e, o, r, c, v) : function(e, t, r, n, a) {
                        "never" === a ? a = "" : "all" === e.showexponent && Math.abs(t.x / e.dtick) < 1e-6 && (a = "hide"), t.text = be(t.x, e, a, n);
                    }(e, o, 0, c, v), n || (e.tickprefix && !p(e.showtickprefix) && (o.text = e.tickprefix + o.text), e.ticksuffix && !p(e.showticksuffix) && (o.text += e.ticksuffix)), e.labelalias && e.labelalias.hasOwnProperty(o.text)) {
                        var g = e.labelalias[o.text];
                        "string" == typeof g && (o.text = g);
                    }
                    if ("boundaries" === e.tickson || e.showdividers) {
                        var y = function(t) {
                            var r = e.l2p(t);
                            return r >= 0 && r <= e._length ? t : null;
                        };
                        o.xbnd = [
                            y(o.x - .5),
                            y(o.x + e.dtick - .5)
                        ];
                    }
                    return o;
                }, U.hoverLabelText = function(e, t, r) {
                    r && (e = l.extendFlat({}, e, {
                        hoverformat: r
                    }));
                    var n = Array.isArray(t) ? t[0] : t, a = Array.isArray(t) ? t[1] : void 0;
                    if (void 0 !== a && a !== n) return U.hoverLabelText(e, n, r) + " - " + U.hoverLabelText(e, a, r);
                    var i = "log" === e.type && n <= 0, o = U.tickText(e, e.c2l(i ? -n : n), "hover").text;
                    return i ? 0 === n ? "0" : C + o : o;
                };
                var ye = [
                    "f",
                    "p",
                    "n",
                    "\u03BC",
                    "m",
                    "",
                    "k",
                    "M",
                    "G",
                    "T"
                ];
                function me(e) {
                    return "SI" === e || "B" === e;
                }
                function xe(e) {
                    return e > 14 || e < -15;
                }
                function be(e, t, r, n) {
                    var i = e < 0, o = t._tickround, s = r || t.exponentformat || "B", c = t._tickexponent, u = U.getTickFormat(t), f = t.separatethousands;
                    if (n) {
                        var d = {
                            exponentformat: s,
                            minexponent: t.minexponent,
                            dtick: "none" === t.showexponent ? t.dtick : a(e) && Math.abs(e) || 1,
                            range: "none" === t.showexponent ? t.range.map(t.r2d) : [
                                0,
                                e || 1
                            ]
                        };
                        ve(d), o = (Number(d._tickround) || 0) + 4, c = d._tickexponent, t.hoverformat && (u = t.hoverformat);
                    }
                    if (u) return t._numFormat(u)(e).replace(/-/g, C);
                    var h, p = Math.pow(10, -o) / 2;
                    if ("none" === s && (c = 0), (e = Math.abs(e)) < p) e = "0", i = !1;
                    else {
                        if (e += p, c && (e *= Math.pow(10, -c), o += c), 0 === o) e = String(Math.floor(e));
                        else if (o < 0) {
                            e = (e = String(Math.round(e))).substr(0, e.length + o);
                            for(var v = o; v < 0; v++)e += "0";
                        } else {
                            var g = (e = String(e)).indexOf(".") + 1;
                            g && (e = e.substr(0, g + o).replace(/\.?0+$/, ""));
                        }
                        e = l.numSeparate(e, t._separators, f);
                    }
                    return c && "hide" !== s && (me(s) && xe(c) && (s = "power"), h = c < 0 ? C + -c : "power" !== s ? "+" + c : String(c), "e" === s || "E" === s ? e += s + h : "power" === s ? e += "\xd710<sup>" + h + "</sup>" : "B" === s && 9 === c ? e += "B" : me(s) && (e += ye[c / 3 + 5])), i ? C + e : e;
                }
                function _e(e, t) {
                    if (e) {
                        var r = Object.keys(E).reduce(function(e, r) {
                            return -1 !== t.indexOf(r) && E[r].forEach(function(t) {
                                e[t] = 1;
                            }), e;
                        }, {});
                        Object.keys(e).forEach(function(t) {
                            r[t] || (1 === t.length ? e[t] = 0 : delete e[t]);
                        });
                    }
                }
                function we(e, t) {
                    for(var r = [], n = {}, a = 0; a < t.length; a++){
                        var i = t[a];
                        n[i.text2] ? n[i.text2].push(i.x) : n[i.text2] = [
                            i.x
                        ];
                    }
                    for(var o in n)r.push(ge(e, l.interp(n[o], .5), o));
                    return r;
                }
                function Te(e) {
                    return void 0 !== e.periodX ? e.periodX : e.x;
                }
                function Me(e) {
                    return [
                        e.text,
                        e.x,
                        e.axInfo,
                        e.font,
                        e.fontSize,
                        e.fontColor
                    ].join("_");
                }
                function ke(e) {
                    var t = e.title.font.size, r = (e.title.text.match(c.BR_TAG_ALL) || []).length;
                    return e.title.hasOwnProperty("standoff") ? r ? t * (B + r * Y) : t * B : r ? t * (r + 1) * Y : t;
                }
                function Ae(e, t) {
                    var r = e.l2p(t);
                    return r > 1 && r < e._length - 1;
                }
                function Le(e) {
                    var t = n.select(e), r = t.select(".text-math-group");
                    return r.empty() ? t.select("text") : r;
                }
                function Se(e) {
                    return e._id + ".automargin";
                }
                function De(e) {
                    return Se(e) + ".mirror";
                }
                function Oe(e) {
                    return e._id + ".rangeslider";
                }
                function Ce(e, t) {
                    for(var r = 0; r < t.length; r++)-1 === e.indexOf(t[r]) && e.push(t[r]);
                }
                function Pe(e, t, r) {
                    var n, a, i = [], o = [], s = e.layout;
                    for(n = 0; n < t.length; n++)i.push(U.getFromId(e, t[n]));
                    for(n = 0; n < r.length; n++)o.push(U.getFromId(e, r[n]));
                    var c = Object.keys(h), u = [
                        "anchor",
                        "domain",
                        "overlaying",
                        "position",
                        "side",
                        "tickangle",
                        "editType"
                    ], f = [
                        "linear",
                        "log"
                    ];
                    for(n = 0; n < c.length; n++){
                        var d = c[n], p = i[0][d], v = o[0][d], g = !0, y = !1, m = !1;
                        if ("_" !== d.charAt(0) && "function" != typeof p && -1 === u.indexOf(d)) {
                            for(a = 1; a < i.length && g; a++){
                                var x = i[a][d];
                                "type" === d && -1 !== f.indexOf(p) && -1 !== f.indexOf(x) && p !== x ? y = !0 : x !== p && (g = !1);
                            }
                            for(a = 1; a < o.length && g; a++){
                                var b = o[a][d];
                                "type" === d && -1 !== f.indexOf(v) && -1 !== f.indexOf(b) && v !== b ? m = !0 : o[a][d] !== v && (g = !1);
                            }
                            g && (y && (s[i[0]._name].type = "linear"), m && (s[o[0]._name].type = "linear"), Ie(s, d, i, o, e._fullLayout._dfltTitle));
                        }
                    }
                    for(n = 0; n < e._fullLayout.annotations.length; n++){
                        var _ = e._fullLayout.annotations[n];
                        -1 !== t.indexOf(_.xref) && -1 !== r.indexOf(_.yref) && l.swapAttrs(s.annotations[n], [
                            "?"
                        ]);
                    }
                }
                function Ie(e, t, r, n, a) {
                    var i, o = l.nestedProperty, s = o(e[r[0]._name], t).get(), c = o(e[n[0]._name], t).get();
                    for("title" === t && (s && s.text === a.x && (s.text = a.y), c && c.text === a.y && (c.text = a.x)), i = 0; i < r.length; i++)o(e, r[i]._name + "." + t).set(c);
                    for(i = 0; i < n.length; i++)o(e, n[i]._name + "." + t).set(s);
                }
                function Re(e) {
                    return "angularaxis" === e._id;
                }
                function ze(e, t) {
                    for(var r = t._rangebreaks.length, n = 0; n < r; n++){
                        var a = t._rangebreaks[n];
                        if (e >= a.min && e < a.max) return a.max;
                    }
                    return e;
                }
                function Ne(e) {
                    return -1 !== (e.ticklabelposition || "").indexOf("inside");
                }
                function Fe(e, t) {
                    Ne(e._anchorAxis || {}) && e._hideCounterAxisInsideTickLabels && e._hideCounterAxisInsideTickLabels(t);
                }
                function Ee(e, t, r, n) {
                    var a, i = "free" === e.anchor || void 0 !== e.overlaying && !1 !== e.overlaying ? e.overlaying : e._id;
                    a = n ? "right" === e.side ? t : -t : t, i in r || (r[i] = {}), e.side in r[i] || (r[i][e.side] = 0), r[i][e.side] += a;
                }
                U.getTickFormat = function(e) {
                    var t, r, n, a, i, o, l, s;
                    function c(e) {
                        return "string" != typeof e ? e : Number(e.replace("M", "")) * T;
                    }
                    function u(e, t) {
                        var r = [
                            "L",
                            "D"
                        ];
                        if (typeof e == typeof t) {
                            if ("number" == typeof e) return e - t;
                            var n = r.indexOf(e.charAt(0)), a = r.indexOf(t.charAt(0));
                            return n === a ? Number(e.replace(/(L|D)/g, "")) - Number(t.replace(/(L|D)/g, "")) : n - a;
                        }
                        return "number" == typeof e ? 1 : -1;
                    }
                    function f(e, t) {
                        var r = null === t[0], n = null === t[1], a = u(e, t[0]) >= 0, i = u(e, t[1]) <= 0;
                        return (r || a) && (n || i);
                    }
                    if (e.tickformatstops && e.tickformatstops.length > 0) switch(e.type){
                        case "date":
                        case "linear":
                            for(t = 0; t < e.tickformatstops.length; t++)if ((n = e.tickformatstops[t]).enabled && (a = e.dtick, o = void 0, o = c || function(e) {
                                return e;
                            }, l = (i = n.dtickrange)[0], s = i[1], (!l && "number" != typeof l || o(l) <= o(a)) && (!s && "number" != typeof s || o(s) >= o(a)))) {
                                r = n;
                                break;
                            }
                            break;
                        case "log":
                            for(t = 0; t < e.tickformatstops.length; t++)if ((n = e.tickformatstops[t]).enabled && f(e.dtick, n.dtickrange)) {
                                r = n;
                                break;
                            }
                    }
                    return r ? r.value : e.tickformat;
                }, U.getSubplots = function(e, t) {
                    var r = e._fullLayout._subplots, n = r.cartesian.concat(r.gl2d || []), a = t ? U.findSubplotsWithAxis(n, t) : n;
                    return a.sort(function(e, t) {
                        var r = e.substr(1).split("y"), n = t.substr(1).split("y");
                        return r[0] === n[0] ? +r[1] - +n[1] : +r[0] - +n[0];
                    }), a;
                }, U.findSubplotsWithAxis = function(e, t) {
                    for(var r = new RegExp("x" === t._id.charAt(0) ? "^" + t._id + "y" : t._id + "$"), n = [], a = 0; a < e.length; a++){
                        var i = e[a];
                        r.test(i) && n.push(i);
                    }
                    return n;
                }, U.makeClipPaths = function(e) {
                    var t = e._fullLayout;
                    if (!t._hasOnlyLargeSploms) {
                        var r, a, i = {
                            _offset: 0,
                            _length: t.width,
                            _id: ""
                        }, o = {
                            _offset: 0,
                            _length: t.height,
                            _id: ""
                        }, l = U.list(e, "x", !0), s = U.list(e, "y", !0), c = [];
                        for(r = 0; r < l.length; r++)for(c.push({
                            x: l[r],
                            y: o
                        }), a = 0; a < s.length; a++)0 === r && c.push({
                            x: i,
                            y: s[a]
                        }), c.push({
                            x: l[r],
                            y: s[a]
                        });
                        var u = t._clips.selectAll(".axesclip").data(c, function(e) {
                            return e.x._id + e.y._id;
                        });
                        u.enter().append("clipPath").classed("axesclip", !0).attr("id", function(e) {
                            return "clip" + t._uid + e.x._id + e.y._id;
                        }).append("rect"), u.exit().remove(), u.each(function(e) {
                            n.select(this).select("rect").attr({
                                x: e.x._offset || 0,
                                y: e.y._offset || 0,
                                width: e.x._length || 1,
                                height: e.y._length || 1
                            });
                        });
                    }
                }, U.draw = function(e, t, r) {
                    var n = e._fullLayout;
                    "redraw" === t && n._paper.selectAll("g.subplot").each(function(e) {
                        var t = e[0], r = n._plots[t];
                        if (r) {
                            var a = r.xaxis, i = r.yaxis;
                            r.xaxislayer.selectAll("." + a._id + "tick").remove(), r.yaxislayer.selectAll("." + i._id + "tick").remove(), r.xaxislayer.selectAll("." + a._id + "tick2").remove(), r.yaxislayer.selectAll("." + i._id + "tick2").remove(), r.xaxislayer.selectAll("." + a._id + "divider").remove(), r.yaxislayer.selectAll("." + i._id + "divider").remove(), r.minorGridlayer && r.minorGridlayer.selectAll("path").remove(), r.gridlayer && r.gridlayer.selectAll("path").remove(), r.zerolinelayer && r.zerolinelayer.selectAll("path").remove(), n._infolayer.select(".g-" + a._id + "title").remove(), n._infolayer.select(".g-" + i._id + "title").remove();
                        }
                    });
                    var a = t && "redraw" !== t ? t : U.listIds(e), i = U.list(e).filter(function(e) {
                        return e.autoshift;
                    }).map(function(e) {
                        return e.overlaying;
                    });
                    a.map(function(t) {
                        var r = U.getFromId(e, t);
                        if ("sync" === r.tickmode && r.overlaying) {
                            var n = a.findIndex(function(e) {
                                return e === r.overlaying;
                            });
                            n >= 0 && a.unshift(a.splice(n, 1).shift());
                        }
                    });
                    var o = {
                        false: {
                            left: 0,
                            right: 0
                        }
                    };
                    return l.syncOrAsync(a.map(function(t) {
                        return function() {
                            if (t) {
                                var n = U.getFromId(e, t);
                                r || (r = {}), r.axShifts = o, r.overlayingShiftedAx = i;
                                var a = U.drawOne(e, n, r);
                                return n._shiftPusher && Ee(n, n._fullDepth || 0, o, !0), n._r = n.range.slice(), n._rl = l.simpleMap(n._r, n.r2l), a;
                            }
                        };
                    }));
                }, U.drawOne = function(e, t, r) {
                    var n, a, s, c = (r = r || {}).axShifts || {}, h = r.overlayingShiftedAx || [];
                    t.setScale();
                    var p = e._fullLayout, v = t._id, g = v.charAt(0), y = U.counterLetter(v), m = p._plots[t._mainSubplot];
                    if (m) {
                        if (t._shiftPusher = t.autoshift || -1 !== h.indexOf(t._id) || -1 !== h.indexOf(t.overlaying), t._shiftPusher & "free" === t.anchor) {
                            var x = t.linewidth / 2 || 0;
                            "inside" === t.ticks && (x += t.ticklen), Ee(t, x, c, !0), Ee(t, t.shift || 0, c, !1);
                        }
                        !0 === r.skipTitle && void 0 !== t._shift || (t._shift = function(e, t) {
                            return e.autoshift ? t[e.overlaying][e.side] : e.shift || 0;
                        }(t, c));
                        var b = m[g + "axislayer"], _ = t._mainLinePosition, w = _ += t._shift, T = t._mainMirrorPosition, M = t._vals = U.calcTicks(t), k = [
                            t.mirror,
                            w,
                            T
                        ].join("_");
                        for(n = 0; n < M.length; n++)M[n].axInfo = k;
                        t._selections = {}, t._tickAngles && (t._prevTickAngles = t._tickAngles), t._tickAngles = {}, t._depth = null;
                        var A = {};
                        if (t.visible) {
                            var L, S, D = U.makeTransTickFn(t), O = U.makeTransTickLabelFn(t), C = "inside" === t.ticks, P = "outside" === t.ticks;
                            if ("boundaries" === t.tickson) {
                                var I = function(e, t) {
                                    var r, n = [], a = function(e, t) {
                                        var r = e.xbnd[t];
                                        null !== r && n.push(l.extendFlat({}, e, {
                                            x: r
                                        }));
                                    };
                                    if (t.length) {
                                        for(r = 0; r < t.length; r++)a(t[r], 0);
                                        a(t[r - 1], 1);
                                    }
                                    return n;
                                }(0, M);
                                S = U.clipEnds(t, I), L = C ? S : I;
                            } else S = U.clipEnds(t, M), L = C && "period" !== t.ticklabelmode ? S : M;
                            var R, z = t._gridVals = S, N = function(e, t) {
                                var r, n, a = [], i = t.length && t[t.length - 1].x < t[0].x, o = function(e, t) {
                                    var r = e.xbnd[t];
                                    null !== r && a.push(l.extendFlat({}, e, {
                                        x: r
                                    }));
                                };
                                if (e.showdividers && t.length) {
                                    for(r = 0; r < t.length; r++){
                                        var s = t[r];
                                        s.text2 !== n && o(s, i ? 1 : 0), n = s.text2;
                                    }
                                    o(t[r - 1], i ? 0 : 1);
                                }
                                return a;
                            }(t, M);
                            if (!p._hasOnlyLargeSploms) {
                                var F = t._subplotsWith, E = {};
                                for(n = 0; n < F.length; n++){
                                    a = F[n];
                                    var H = (s = p._plots[a])[y + "axis"], j = H._mainAxis._id;
                                    if (!E[j]) {
                                        E[j] = 1;
                                        var B = "x" === g ? "M0," + H._offset + "v" + H._length : "M" + H._offset + ",0h" + H._length;
                                        U.drawGrid(e, t, {
                                            vals: z,
                                            counterAxis: H,
                                            layer: s.gridlayer.select("." + v),
                                            minorLayer: s.minorGridlayer.select("." + v),
                                            path: B,
                                            transFn: D
                                        }), U.drawZeroLine(e, t, {
                                            counterAxis: H,
                                            layer: s.zerolinelayer,
                                            path: B,
                                            transFn: D
                                        });
                                    }
                                }
                            }
                            var q = U.getTickSigns(t), G = U.getTickSigns(t, "minor");
                            if (t.ticks || t.minor && t.minor.ticks) {
                                var Z, W, X, J, K = U.makeTickPath(t, w, q[2]), Q = U.makeTickPath(t, w, G[2], {
                                    minor: !0
                                });
                                if (t._anchorAxis && t.mirror && !0 !== t.mirror ? (Z = U.makeTickPath(t, T, q[3]), W = U.makeTickPath(t, T, G[3], {
                                    minor: !0
                                }), X = K + Z, J = Q + W) : (Z = "", W = "", X = K, J = Q), t.showdividers && P && "boundaries" === t.tickson) {
                                    var $ = {};
                                    for(n = 0; n < N.length; n++)$[N[n].x] = 1;
                                    R = function(e) {
                                        return $[e.x] ? Z : X;
                                    };
                                } else R = function(e) {
                                    return e.minor ? J : X;
                                };
                            }
                            if (U.drawTicks(e, t, {
                                vals: L,
                                layer: b,
                                path: R,
                                transFn: D
                            }), "allticks" === t.mirror) {
                                var ee = Object.keys(t._linepositions || {});
                                for(n = 0; n < ee.length; n++){
                                    a = ee[n], s = p._plots[a];
                                    var te = t._linepositions[a] || [], re = te[0], ne = te[1], ae = te[2], ie = U.makeTickPath(t, re, ae ? q[0] : G[0], {
                                        minor: ae
                                    }) + U.makeTickPath(t, ne, ae ? q[1] : G[1], {
                                        minor: ae
                                    });
                                    U.drawTicks(e, t, {
                                        vals: L,
                                        layer: s[g + "axislayer"],
                                        path: ie,
                                        transFn: D
                                    });
                                }
                            }
                            var oe = [];
                            if (oe.push(function() {
                                return U.drawLabels(e, t, {
                                    vals: M,
                                    layer: b,
                                    plotinfo: s,
                                    transFn: O,
                                    labelFns: U.makeLabelFns(t, w)
                                });
                            }), "multicategory" === t.type) {
                                var le = {
                                    x: 2,
                                    y: 10
                                }[g];
                                oe.push(function() {
                                    var r = {
                                        x: "height",
                                        y: "width"
                                    }[g], n = ce()[r] + le + (t._tickAngles[v + "tick"] ? t.tickfont.size * Y : 0);
                                    return U.drawLabels(e, t, {
                                        vals: we(t, M),
                                        layer: b,
                                        cls: v + "tick2",
                                        repositionOnUpdate: !0,
                                        secondary: !0,
                                        transFn: D,
                                        labelFns: U.makeLabelFns(t, w + n * q[4])
                                    });
                                }), oe.push(function() {
                                    return t._depth = q[4] * (ce("tick2")[t.side] - w), function(e, t, r) {
                                        var n = t._id + "divider", a = r.vals, i = r.layer.selectAll("path." + n).data(a, Me);
                                        i.exit().remove(), i.enter().insert("path", ":first-child").classed(n, 1).classed("crisp", 1).call(f.stroke, t.dividercolor).style("stroke-width", d.crispRound(e, t.dividerwidth, 1) + "px"), i.attr("transform", r.transFn).attr("d", r.path);
                                    }(e, t, {
                                        vals: N,
                                        layer: b,
                                        path: U.makeTickPath(t, w, q[4], {
                                            len: t._depth
                                        }),
                                        transFn: D
                                    });
                                });
                            } else t.title.hasOwnProperty("standoff") && oe.push(function() {
                                t._depth = q[4] * (ce()[t.side] - w);
                            });
                            var se = o.getComponentMethod("rangeslider", "isVisible")(t);
                            return r.skipTitle || se && "bottom" === t.side || oe.push(function() {
                                return function(e, t) {
                                    var r, n = e._fullLayout, a = t._id, i = a.charAt(0), o = t.title.font.size;
                                    if (t.title.hasOwnProperty("standoff")) r = t._depth + t.title.standoff + ke(t);
                                    else {
                                        var l = Ne(t);
                                        if ("multicategory" === t.type) r = t._depth;
                                        else {
                                            var s = 1.5 * o;
                                            l && (s = .5 * o, "outside" === t.ticks && (s += t.ticklen)), r = 10 + s + (t.linewidth ? t.linewidth - 1 : 0);
                                        }
                                        l || (r += "x" === i ? "top" === t.side ? o * (t.showticklabels ? 1 : 0) : o * (t.showticklabels ? 1.5 : .5) : "right" === t.side ? o * (t.showticklabels ? 1 : .5) : o * (t.showticklabels ? .5 : 0));
                                    }
                                    var c, f, h, p, v = U.getPxPosition(e, t);
                                    if ("x" === i ? (f = t._offset + t._length / 2, h = "top" === t.side ? v - r : v + r) : (h = t._offset + t._length / 2, f = "right" === t.side ? v + r : v - r, c = {
                                        rotate: "-90",
                                        offset: 0
                                    }), "multicategory" !== t.type) {
                                        var g = t._selections[t._id + "tick"];
                                        if (p = {
                                            selection: g,
                                            side: t.side
                                        }, g && g.node() && g.node().parentNode) {
                                            var y = d.getTranslate(g.node().parentNode);
                                            p.offsetLeft = y.x, p.offsetTop = y.y;
                                        }
                                        t.title.hasOwnProperty("standoff") && (p.pad = 0);
                                    }
                                    return t._titleStandoff = r, u.draw(e, a + "title", {
                                        propContainer: t,
                                        propName: t._name + ".title.text",
                                        placeholder: n._dfltTitle[i],
                                        avoid: p,
                                        transform: c,
                                        attributes: {
                                            x: f,
                                            y: h,
                                            "text-anchor": "middle"
                                        }
                                    });
                                }(e, t);
                            }), oe.push(function() {
                                var r, n, a, l, s = t.side.charAt(0), c = V[t.side].charAt(0), u = U.getPxPosition(e, t), f = P ? t.ticklen : 0;
                                (t.automargin || se || t._shiftPusher) && ("multicategory" === t.type ? r = ce("tick2") : (r = ce(), "x" === g && "b" === s && (t._depth = Math.max(r.width > 0 ? r.bottom - u : 0, f))));
                                var d = 0, h = 0;
                                if (t._shiftPusher && (d = Math.max(f, r.height > 0 ? "l" === s ? u - r.left : r.right - u : 0), t.title.text !== p._dfltTitle[g] && (h = (t._titleStandoff || 0) + (t._titleScoot || 0), "l" === s && (h += ke(t))), t._fullDepth = Math.max(d, h)), t.automargin) {
                                    n = {
                                        x: 0,
                                        y: 0,
                                        r: 0,
                                        l: 0,
                                        t: 0,
                                        b: 0
                                    };
                                    var v = [
                                        0,
                                        1
                                    ], m = "number" == typeof t._shift ? t._shift : 0;
                                    if ("x" === g) {
                                        if ("b" === s ? n[s] = t._depth : (n[s] = t._depth = Math.max(r.width > 0 ? u - r.top : 0, f), v.reverse()), r.width > 0) {
                                            var x = r.right - (t._offset + t._length);
                                            x > 0 && (n.xr = 1, n.r = x);
                                            var b = t._offset - r.left;
                                            b > 0 && (n.xl = 0, n.l = b);
                                        }
                                    } else if ("l" === s ? (t._depth = Math.max(r.height > 0 ? u - r.left : 0, f), n[s] = t._depth - m) : (t._depth = Math.max(r.height > 0 ? r.right - u : 0, f), n[s] = t._depth + m, v.reverse()), r.height > 0) {
                                        var _ = r.bottom - (t._offset + t._length);
                                        _ > 0 && (n.yb = 0, n.b = _);
                                        var w = t._offset - r.top;
                                        w > 0 && (n.yt = 1, n.t = w);
                                    }
                                    n[y] = "free" === t.anchor ? t.position : t._anchorAxis.domain[v[0]], t.title.text !== p._dfltTitle[g] && (n[s] += ke(t) + (t.title.standoff || 0)), t.mirror && "free" !== t.anchor && ((a = {
                                        x: 0,
                                        y: 0,
                                        r: 0,
                                        l: 0,
                                        t: 0,
                                        b: 0
                                    })[c] = t.linewidth, t.mirror && !0 !== t.mirror && (a[c] += f), !0 === t.mirror || "ticks" === t.mirror ? a[y] = t._anchorAxis.domain[v[1]] : "all" !== t.mirror && "allticks" !== t.mirror || (a[y] = [
                                        t._counterDomainMin,
                                        t._counterDomainMax
                                    ][v[1]]));
                                }
                                se && (l = o.getComponentMethod("rangeslider", "autoMarginOpts")(e, t)), "string" == typeof t.automargin && (_e(n, t.automargin), _e(a, t.automargin)), i.autoMargin(e, Se(t), n), i.autoMargin(e, De(t), a), i.autoMargin(e, Oe(t), l);
                            }), l.syncOrAsync(oe);
                        }
                    }
                    function ce(e) {
                        var r = v + (e || "tick");
                        return A[r] || (A[r] = function(e, t) {
                            var r, n, a, i;
                            return e._selections[t].size() ? (r = 1 / 0, n = -1 / 0, a = 1 / 0, i = -1 / 0, e._selections[t].each(function() {
                                var e = Le(this), t = d.bBox(e.node().parentNode);
                                r = Math.min(r, t.top), n = Math.max(n, t.bottom), a = Math.min(a, t.left), i = Math.max(i, t.right);
                            })) : (r = 0, n = 0, a = 0, i = 0), {
                                top: r,
                                bottom: n,
                                left: a,
                                right: i,
                                height: n - r,
                                width: i - a
                            };
                        }(t, r)), A[r];
                    }
                }, U.getTickSigns = function(e, t) {
                    var r = e._id.charAt(0), n = {
                        x: "top",
                        y: "right"
                    }[r], a = e.side === n ? 1 : -1, i = [
                        -1,
                        1,
                        a,
                        -a
                    ];
                    return "inside" !== (t ? (e.minor || {}).ticks : e.ticks) == ("x" === r) && (i = i.map(function(e) {
                        return -e;
                    })), e.side && i.push({
                        l: -1,
                        t: -1,
                        r: 1,
                        b: 1
                    }[e.side.charAt(0)]), i;
                }, U.makeTransTickFn = function(e) {
                    return "x" === e._id.charAt(0) ? function(t) {
                        return s(e._offset + e.l2p(t.x), 0);
                    } : function(t) {
                        return s(0, e._offset + e.l2p(t.x));
                    };
                }, U.makeTransTickLabelFn = function(e) {
                    var t = function(e) {
                        var t = e.ticklabelposition || "", r = function(e) {
                            return -1 !== t.indexOf(e);
                        }, n = r("top"), a = r("left"), i = r("right"), o = r("bottom"), l = r("inside"), s = o || a || n || i;
                        if (!s && !l) return [
                            0,
                            0
                        ];
                        var c = e.side, u = s ? (e.tickwidth || 0) / 2 : 0, f = 3, d = e.tickfont ? e.tickfont.size : 12;
                        return (o || n) && (u += d * B, f += (e.linewidth || 0) / 2), (a || i) && (u += (e.linewidth || 0) / 2, f += 3), l && "top" === c && (f -= d * (1 - B)), (a || n) && (u = -u), "bottom" !== c && "right" !== c || (f = -f), [
                            s ? u : 0,
                            l ? f : 0
                        ];
                    }(e), r = t[0], n = t[1];
                    return "x" === e._id.charAt(0) ? function(t) {
                        return s(r + e._offset + e.l2p(Te(t)), n);
                    } : function(t) {
                        return s(n, r + e._offset + e.l2p(Te(t)));
                    };
                }, U.makeTickPath = function(e, t, r, n) {
                    n || (n = {});
                    var a = n.minor;
                    if (a && !e.minor) return "";
                    var i = void 0 !== n.len ? n.len : a ? e.minor.ticklen : e.ticklen, o = e._id.charAt(0), l = (e.linewidth || 1) / 2;
                    return "x" === o ? "M0," + (t + l * r) + "v" + i * r : "M" + (t + l * r) + ",0h" + i * r;
                }, U.makeLabelFns = function(e, t, r) {
                    var n = e.ticklabelposition || "", i = function(e) {
                        return -1 !== n.indexOf(e);
                    }, o = i("top"), s = i("left"), c = i("right"), u = i("bottom") || s || o || c, f = i("inside"), d = "inside" === n && "inside" === e.ticks || !f && "outside" === e.ticks && "boundaries" !== e.tickson, h = 0, p = 0, v = d ? e.ticklen : 0;
                    if (f ? v *= -1 : u && (v = 0), d && (h += v, r)) {
                        var g = l.deg2rad(r);
                        h = v * Math.cos(g) + 1, p = v * Math.sin(g);
                    }
                    e.showticklabels && (d || e.showline) && (h += .2 * e.tickfont.size);
                    var y, m, x, b, _, w = {
                        labelStandoff: h += (e.linewidth || 1) / 2 * (f ? -1 : 1),
                        labelShift: p
                    }, T = 0, M = e.side, k = e._id.charAt(0), A = e.tickangle;
                    if ("x" === k) b = (_ = !f && "bottom" === M || f && "top" === M) ? 1 : -1, f && (b *= -1), y = p * b, m = t + h * b, x = _ ? 1 : -0.2, 90 === Math.abs(A) && (f ? x += j : x = -90 === A && "bottom" === M ? B : 90 === A && "top" === M ? j : .5, T = j / 2 * (A / 90)), w.xFn = function(e) {
                        return e.dx + y + T * e.fontSize;
                    }, w.yFn = function(e) {
                        return e.dy + m + e.fontSize * x;
                    }, w.anchorFn = function(e, t) {
                        if (u) {
                            if (s) return "end";
                            if (c) return "start";
                        }
                        return a(t) && 0 !== t && 180 !== t ? t * b < 0 !== f ? "end" : "start" : "middle";
                    }, w.heightFn = function(t, r, n) {
                        return r < -60 || r > 60 ? -0.5 * n : "top" === e.side !== f ? -n : 0;
                    };
                    else if ("y" === k) {
                        if (b = (_ = !f && "left" === M || f && "right" === M) ? 1 : -1, f && (b *= -1), y = h, m = p * b, x = 0, f || 90 !== Math.abs(A) || (x = -90 === A && "left" === M || 90 === A && "right" === M ? B : .5), f) {
                            var L = a(A) ? +A : 0;
                            if (0 !== L) {
                                var S = l.deg2rad(L);
                                T = Math.abs(Math.sin(S)) * B * b, x = 0;
                            }
                        }
                        w.xFn = function(e) {
                            return e.dx + t - (y + e.fontSize * x) * b + T * e.fontSize;
                        }, w.yFn = function(e) {
                            return e.dy + m + e.fontSize * j;
                        }, w.anchorFn = function(e, t) {
                            return a(t) && 90 === Math.abs(t) ? "middle" : _ ? "end" : "start";
                        }, w.heightFn = function(t, r, n) {
                            return "right" === e.side && (r *= -1), r < -30 ? -n : r < 30 ? -0.5 * n : 0;
                        };
                    }
                    return w;
                }, U.drawTicks = function(e, t, r) {
                    r = r || {};
                    var a = t._id + "tick", i = [].concat(t.minor && t.minor.ticks ? r.vals.filter(function(e) {
                        return e.minor && !e.noTick;
                    }) : []).concat(t.ticks ? r.vals.filter(function(e) {
                        return !e.minor && !e.noTick;
                    }) : []), o = r.layer.selectAll("path." + a).data(i, Me);
                    o.exit().remove(), o.enter().append("path").classed(a, 1).classed("ticks", 1).classed("crisp", !1 !== r.crisp).each(function(e) {
                        return f.stroke(n.select(this), e.minor ? t.minor.tickcolor : t.tickcolor);
                    }).style("stroke-width", function(r) {
                        return d.crispRound(e, r.minor ? t.minor.tickwidth : t.tickwidth, 1) + "px";
                    }).attr("d", r.path).style("display", null), Fe(t, [
                        N
                    ]), o.attr("transform", r.transFn);
                }, U.drawGrid = function(e, t, r) {
                    if (r = r || {}, "sync" !== t.tickmode) {
                        var a = t._id + "grid", i = t.minor && t.minor.showgrid, o = i ? r.vals.filter(function(e) {
                            return e.minor;
                        }) : [], l = t.showgrid ? r.vals.filter(function(e) {
                            return !e.minor;
                        }) : [], s = r.counterAxis;
                        if (s && U.shouldShowZeroLine(e, t, s)) for(var c = "array" === t.tickmode, u = 0; u < l.length; u++){
                            var h = l[u].x;
                            if (c ? !h : Math.abs(h) < t.dtick / 100) {
                                if (l = l.slice(0, u).concat(l.slice(u + 1)), !c) break;
                                u--;
                            }
                        }
                        t._gw = d.crispRound(e, t.gridwidth, 1);
                        for(var p = i ? d.crispRound(e, t.minor.gridwidth, 1) : 0, v = r.layer, g = r.minorLayer, y = 1; y >= 0; y--){
                            var m = y ? v : g;
                            if (m) {
                                var x = m.selectAll("path." + a).data(y ? l : o, Me);
                                x.exit().remove(), x.enter().append("path").classed(a, 1).classed("crisp", !1 !== r.crisp), x.attr("transform", r.transFn).attr("d", r.path).each(function(e) {
                                    return f.stroke(n.select(this), e.minor ? t.minor.gridcolor : t.gridcolor || "#ddd");
                                }).style("stroke-dasharray", function(e) {
                                    return d.dashStyle(e.minor ? t.minor.griddash : t.griddash, e.minor ? t.minor.gridwidth : t.gridwidth);
                                }).style("stroke-width", function(e) {
                                    return (e.minor ? p : t._gw) + "px";
                                }).style("display", null), "function" == typeof r.path && x.attr("d", r.path);
                            }
                        }
                        Fe(t, [
                            R,
                            z
                        ]);
                    }
                }, U.drawZeroLine = function(e, t, r) {
                    r = r || r;
                    var n = t._id + "zl", a = U.shouldShowZeroLine(e, t, r.counterAxis), i = r.layer.selectAll("path." + n).data(a ? [
                        {
                            x: 0,
                            id: t._id
                        }
                    ] : []);
                    i.exit().remove(), i.enter().append("path").classed(n, 1).classed("zl", 1).classed("crisp", !1 !== r.crisp).each(function() {
                        r.layer.selectAll("path").sort(function(e, t) {
                            return Z(e.id, t.id);
                        });
                    }), i.attr("transform", r.transFn).attr("d", r.path).call(f.stroke, t.zerolinecolor || f.defaultLine).style("stroke-width", d.crispRound(e, t.zerolinewidth, t._gw || 1) + "px").style("display", null), Fe(t, [
                        I
                    ]);
                }, U.drawLabels = function(e, t, r) {
                    r = r || {};
                    var i = e._fullLayout, o = t._id, u = o.charAt(0), f = r.cls || o + "tick", h = r.vals.filter(function(e) {
                        return e.text;
                    }), p = r.labelFns, v = r.secondary ? 0 : t.tickangle, g = (t._prevTickAngles || {})[f], y = r.layer.selectAll("g." + f).data(t.showticklabels ? h : [], Me), m = [];
                    function x(e, i) {
                        e.each(function(e) {
                            var o = n.select(this), l = o.select(".text-math-group"), u = p.anchorFn(e, i), f = r.transFn.call(o.node(), e) + (a(i) && 0 != +i ? " rotate(" + i + "," + p.xFn(e) + "," + (p.yFn(e) - e.fontSize / 2) + ")" : ""), h = c.lineCount(o), v = Y * e.fontSize, g = p.heightFn(e, a(i) ? +i : 0, (h - 1) * v);
                            if (g && (f += s(0, g)), l.empty()) {
                                var y = o.select("text");
                                y.attr({
                                    transform: f,
                                    "text-anchor": u
                                }), y.style("opacity", 1), t._adjustTickLabelsOverflow && t._adjustTickLabelsOverflow();
                            } else {
                                var m = d.bBox(l.node()).width * ({
                                    end: -0.5,
                                    start: .5
                                })[u];
                                l.attr("transform", f + s(m, 0));
                            }
                        });
                    }
                    y.enter().append("g").classed(f, 1).append("text").attr("text-anchor", "middle").each(function(t) {
                        var r = n.select(this), a = e._promises.length;
                        r.call(c.positionText, p.xFn(t), p.yFn(t)).call(d.font, t.font, t.fontSize, t.fontColor).text(t.text).call(c.convertToTspans, e), e._promises[a] ? m.push(e._promises.pop().then(function() {
                            x(r, v);
                        })) : x(r, v);
                    }), Fe(t, [
                        F
                    ]), y.exit().remove(), r.repositionOnUpdate && y.each(function(e) {
                        n.select(this).select("text").call(c.positionText, p.xFn(e), p.yFn(e));
                    }), t._adjustTickLabelsOverflow = function() {
                        var r = t.ticklabeloverflow;
                        if (r && "allow" !== r) {
                            var a = -1 !== r.indexOf("hide"), o = "x" === t._id.charAt(0), s = 0, c = o ? e._fullLayout.width : e._fullLayout.height;
                            if (-1 !== r.indexOf("domain")) {
                                var u = l.simpleMap(t.range, t.r2l);
                                s = t.l2p(u[0]) + t._offset, c = t.l2p(u[1]) + t._offset;
                            }
                            var f = Math.min(s, c), h = Math.max(s, c), p = t.side, v = 1 / 0, g = -1 / 0;
                            for(var m in y.each(function(e) {
                                var r = n.select(this);
                                if (r.select(".text-math-group").empty()) {
                                    var i = d.bBox(r.node()), l = 0;
                                    o ? (i.right > h || i.left < f) && (l = 1) : (i.bottom > h || i.top + (t.tickangle ? 0 : e.fontSize / 4) < f) && (l = 1);
                                    var s = r.select("text");
                                    l ? a && s.style("opacity", 0) : (s.style("opacity", 1), v = "bottom" === p || "right" === p ? Math.min(v, o ? i.top : i.left) : -1 / 0, g = "top" === p || "left" === p ? Math.max(g, o ? i.bottom : i.right) : 1 / 0);
                                }
                            }), i._plots){
                                var x = i._plots[m];
                                if (t._id === x.xaxis._id || t._id === x.yaxis._id) {
                                    var b = o ? x.yaxis : x.xaxis;
                                    b && (b["_visibleLabelMin_" + t._id] = v, b["_visibleLabelMax_" + t._id] = g);
                                }
                            }
                        }
                    }, t._hideCounterAxisInsideTickLabels = function(e) {
                        var r = "x" === t._id.charAt(0), a = [];
                        for(var o in i._plots){
                            var l = i._plots[o];
                            t._id !== l.xaxis._id && t._id !== l.yaxis._id || a.push(r ? l.yaxis : l.xaxis);
                        }
                        a.forEach(function(r, a) {
                            r && Ne(r) && (e || [
                                I,
                                z,
                                R,
                                N,
                                F
                            ]).forEach(function(e) {
                                var o = "tick" === e.K && "text" === e.L && "period" === t.ticklabelmode, l = i._plots[t._mainSubplot];
                                (e.K === I.K ? l.zerolinelayer.selectAll("." + t._id + "zl") : e.K === z.K ? l.minorGridlayer.selectAll("." + t._id) : e.K === R.K ? l.gridlayer.selectAll("." + t._id) : l[t._id.charAt(0) + "axislayer"]).each(function() {
                                    var i = n.select(this);
                                    e.L && (i = i.selectAll(e.L)), i.each(function(i) {
                                        var l = t.l2p(o ? Te(i) : i.x) + t._offset, s = n.select(this);
                                        l < t["_visibleLabelMax_" + r._id] && l > t["_visibleLabelMin_" + r._id] ? s.style("display", "none") : "tick" !== e.K || a || s.style("display", null);
                                    });
                                });
                            });
                        });
                    }, x(y, g + 1 ? g : v);
                    var b = null;
                    t._selections && (t._selections[f] = y);
                    var _ = [
                        function() {
                            return m.length && Promise.all(m);
                        }
                    ];
                    t.automargin && i._redrawFromAutoMarginCount && 90 === g ? (b = 90, _.push(function() {
                        x(y, g);
                    })) : _.push(function() {
                        if (x(y, v), h.length && "x" === u && !a(v) && ("log" !== t.type || "D" !== String(t.dtick).charAt(0))) {
                            b = 0;
                            var e, n = 0, i = [];
                            if (y.each(function(e) {
                                n = Math.max(n, e.fontSize);
                                var r = t.l2p(e.x), a = Le(this), o = d.bBox(a.node());
                                i.push({
                                    top: 0,
                                    bottom: 10,
                                    height: 10,
                                    left: r - o.width / 2,
                                    right: r + o.width / 2 + 2,
                                    width: o.width + 2
                                });
                            }), "boundaries" !== t.tickson && !t.showdividers || r.secondary) {
                                var o = h.length, s = Math.abs((h[o - 1].x - h[0].x) * t._m) / (o - 1), c = t.ticklabelposition || "", f = function(e) {
                                    return -1 !== c.indexOf(e);
                                }, p = f("top"), g = f("left"), m = f("right"), _ = f("bottom") || g || p || m ? (t.tickwidth || 0) + 6 : 0, w = s < 2.5 * n || "multicategory" === t.type || "realaxis" === t._name;
                                for(e = 0; e < i.length - 1; e++)if (l.bBoxIntersect(i[e], i[e + 1], _)) {
                                    b = w ? 90 : 30;
                                    break;
                                }
                            } else {
                                var T = 2;
                                for(t.ticks && (T += t.tickwidth / 2), e = 0; e < i.length; e++){
                                    var M = h[e].xbnd, k = i[e];
                                    if (null !== M[0] && k.left - t.l2p(M[0]) < T || null !== M[1] && t.l2p(M[1]) - k.right < T) {
                                        b = 90;
                                        break;
                                    }
                                }
                            }
                            b && x(y, b);
                        }
                    }), t._tickAngles && _.push(function() {
                        t._tickAngles[f] = null === b ? a(v) ? v : 0 : b;
                    });
                    var w = t._anchorAxis;
                    w && w.autorange && Ne(t) && !W(i, t._id) && (i._insideTickLabelsAutorange || (i._insideTickLabelsAutorange = {}), i._insideTickLabelsAutorange[w._name + ".autorange"] = w.autorange, _.push(function() {
                        y.each(function(e, r) {
                            var n = Le(this);
                            n.select(".text-math-group").empty() && (t._vals[r].bb = d.bBox(n.node()));
                        });
                    }));
                    var T = l.syncOrAsync(_);
                    return T && T.then && e._promises.push(T), T;
                }, U.getPxPosition = function(e, t) {
                    var r, n = e._fullLayout._size, a = t._id.charAt(0), i = t.side;
                    return "free" !== t.anchor ? r = t._anchorAxis : "x" === a ? r = {
                        _offset: n.t + (1 - (t.position || 0)) * n.h,
                        _length: 0
                    } : "y" === a && (r = {
                        _offset: n.l + (t.position || 0) * n.w + t._shift,
                        _length: 0
                    }), "top" === i || "left" === i ? r._offset : "bottom" === i || "right" === i ? r._offset + r._length : void 0;
                }, U.shouldShowZeroLine = function(e, t, r) {
                    var n = l.simpleMap(t.range, t.r2l);
                    return n[0] * n[1] <= 0 && t.zeroline && ("linear" === t.type || "-" === t.type) && !(t.rangebreaks && t.maskBreaks(0) === P) && (Ae(t, 0) || !function(e, t, r, n) {
                        var a = r._mainAxis;
                        if (a) {
                            var i = e._fullLayout, o = t._id.charAt(0), l = U.counterLetter(t._id), s = t._offset + (Math.abs(n[0]) < Math.abs(n[1]) == ("x" === o) ? 0 : t._length), c = i._plots[r._mainSubplot];
                            if (!(c.mainplotinfo || c).overlays.length) return h(r);
                            for(var u = U.list(e, l), f = 0; f < u.length; f++){
                                var d = u[f];
                                if (d._mainAxis === a && h(d)) return !0;
                            }
                        }
                        function h(e) {
                            if (!e.showline || !e.linewidth) return !1;
                            var r = Math.max((e.linewidth + t.zerolinewidth) / 2, 1);
                            function n(e) {
                                return "number" == typeof e && Math.abs(e - s) < r;
                            }
                            if (n(e._mainLinePosition) || n(e._mainMirrorPosition)) return !0;
                            var a = e._linepositions || {};
                            for(var i in a)if (n(a[i][0]) || n(a[i][1])) return !0;
                        }
                    }(e, t, r, n) || function(e, t) {
                        for(var r = e._fullData, n = t._mainSubplot, a = t._id.charAt(0), i = 0; i < r.length; i++){
                            var l = r[i];
                            if (!0 === l.visible && l.xaxis + l.yaxis === n) {
                                if (o.traceIs(l, "bar-like") && l.orientation === ({
                                    x: "h",
                                    y: "v"
                                })[a]) return !0;
                                if (l.fill && l.fill.charAt(l.fill.length - 1) === a) return !0;
                            }
                        }
                        return !1;
                    }(e, t));
                }, U.clipEnds = function(e, t) {
                    return t.filter(function(t) {
                        return Ae(e, t.x);
                    });
                }, U.allowAutoMargin = function(e) {
                    for(var t = U.list(e, "", !0), r = 0; r < t.length; r++){
                        var n = t[r];
                        n.automargin && (i.allowAutoMargin(e, Se(n)), n.mirror && i.allowAutoMargin(e, De(n))), o.getComponentMethod("rangeslider", "isVisible")(n) && i.allowAutoMargin(e, Oe(n));
                    }
                }, U.swap = function(e, t) {
                    for(var r = function(e, t) {
                        var r, n, a = [];
                        for(r = 0; r < t.length; r++){
                            var i = [], o = e._fullData[t[r]].xaxis, l = e._fullData[t[r]].yaxis;
                            if (o && l) {
                                for(n = 0; n < a.length; n++)-1 === a[n].x.indexOf(o) && -1 === a[n].y.indexOf(l) || i.push(n);
                                if (i.length) {
                                    var s, c = a[i[0]];
                                    if (i.length > 1) for(n = 1; n < i.length; n++)s = a[i[n]], Ce(c.x, s.x), Ce(c.y, s.y);
                                    Ce(c.x, [
                                        o
                                    ]), Ce(c.y, [
                                        l
                                    ]);
                                } else a.push({
                                    x: [
                                        o
                                    ],
                                    y: [
                                        l
                                    ]
                                });
                            }
                        }
                        return a;
                    }(e, t), n = 0; n < r.length; n++)Pe(e, r[n].x, r[n].y);
                };
            },
            4322: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(1828), i = r(606).BADNUM, o = a.isArrayOrTypedArray, l = a.isDateTime, s = a.cleanNumber, c = Math.round;
                function u(e, t) {
                    return t ? n(e) : "number" == typeof e;
                }
                function f(e) {
                    return Math.max(1, (e - 1) / 1e3);
                }
                e.exports = function(e, t, r) {
                    var a = e, d = r.noMultiCategory;
                    if (o(a) && !a.length) return "-";
                    if (!d && function(e) {
                        return o(e[0]) && o(e[1]);
                    }(a)) return "multicategory";
                    if (d && Array.isArray(a[0])) {
                        for(var h = [], p = 0; p < a.length; p++)if (o(a[p])) for(var v = 0; v < a[p].length; v++)h.push(a[p][v]);
                        a = h;
                    }
                    if (function(e, t) {
                        for(var r = e.length, a = f(r), i = 0, o = 0, s = {}, u = 0; u < r; u += a){
                            var d = e[c(u)], h = String(d);
                            s[h] || (s[h] = 1, l(d, t) && i++, n(d) && o++);
                        }
                        return i > 2 * o;
                    }(a, t)) return "date";
                    var g = "strict" !== r.autotypenumbers;
                    return function(e, t) {
                        for(var r = e.length, n = f(r), a = 0, o = 0, l = {}, u = 0; u < r; u += n){
                            var d = e[c(u)], h = String(d);
                            if (!l[h]) {
                                l[h] = 1;
                                var p = typeof d;
                                "boolean" === p ? o++ : (t ? s(d) !== i : "number" === p) ? a++ : "string" === p && o++;
                            }
                        }
                        return o > 2 * a;
                    }(a, g) ? "category" : function(e, t) {
                        for(var r = e.length, n = 0; n < r; n++)if (u(e[n], t)) return !0;
                        return !1;
                    }(a, g) ? "linear" : "-";
                };
            },
            1453: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(3972), i = r(1828), o = r(4467), l = r(5501), s = r(3838), c = r(6218), u = r(8701), f = r(6115), d = r(9426), h = r(5258), p = r(2128), v = r(3074), g = r(1994), y = r(5555).WEEKDAY_PATTERN, m = r(5555).HOUR_PATTERN;
                function x(e, t, r) {
                    function a(r, n) {
                        return i.coerce(e, t, s.rangebreaks, r, n);
                    }
                    if (a("enabled")) {
                        var o = a("bounds");
                        if (o && o.length >= 2) {
                            var l, c, u = "";
                            if (2 === o.length) {
                                for(l = 0; l < 2; l++)if (c = _(o[l])) {
                                    u = y;
                                    break;
                                }
                            }
                            var f = a("pattern", u);
                            if (f === y) for(l = 0; l < 2; l++)(c = _(o[l])) && (t.bounds[l] = o[l] = c - 1);
                            if (f) for(l = 0; l < 2; l++)switch(c = o[l], f){
                                case y:
                                    if (!n(c)) return void (t.enabled = !1);
                                    if ((c = +c) !== Math.floor(c) || c < 0 || c >= 7) return void (t.enabled = !1);
                                    t.bounds[l] = o[l] = c;
                                    break;
                                case m:
                                    if (!n(c)) return void (t.enabled = !1);
                                    if ((c = +c) < 0 || c > 24) return void (t.enabled = !1);
                                    t.bounds[l] = o[l] = c;
                            }
                            if (!1 === r.autorange) {
                                var d = r.range;
                                if (d[0] < d[1]) {
                                    if (o[0] < d[0] && o[1] > d[1]) return void (t.enabled = !1);
                                } else if (o[0] > d[0] && o[1] < d[1]) return void (t.enabled = !1);
                            }
                        } else {
                            var h = a("values");
                            if (!h || !h.length) return void (t.enabled = !1);
                            a("dvalue");
                        }
                    }
                }
                e.exports = function(e, t, r, n, m) {
                    var b, _ = n.letter, w = n.font || {}, T = n.splomStash || {}, M = r("visible", !n.visibleDflt), k = t._template || {}, A = t.type || k.type || "-";
                    "date" === A && (a.getComponentMethod("calendars", "handleDefaults")(e, t, "calendar", n.calendar), n.noTicklabelmode || (b = r("ticklabelmode")));
                    var L = "";
                    n.noTicklabelposition && "multicategory" !== A || (L = i.coerce(e, t, {
                        ticklabelposition: {
                            valType: "enumerated",
                            dflt: "outside",
                            values: "period" === b ? [
                                "outside",
                                "inside"
                            ] : "x" === _ ? [
                                "outside",
                                "inside",
                                "outside left",
                                "inside left",
                                "outside right",
                                "inside right"
                            ] : [
                                "outside",
                                "inside",
                                "outside top",
                                "inside top",
                                "outside bottom",
                                "inside bottom"
                            ]
                        }
                    }, "ticklabelposition")), n.noTicklabeloverflow || r("ticklabeloverflow", -1 !== L.indexOf("inside") ? "hide past domain" : "category" === A || "multicategory" === A ? "allow" : "hide past div"), g(t, m), r("minallowed"), r("maxallowed");
                    var S, D = r("range"), O = t.getAutorangeDflt(D, n), C = r("autorange", O);
                    !D || (null !== D[0] || null !== D[1]) && (null !== D[0] && null !== D[1] || "reversed" !== C && !0 !== C) && (null === D[0] || "min" !== C && "max reversed" !== C) && (null === D[1] || "max" !== C && "min reversed" !== C) || (D = void 0, delete t.range, t.autorange = !0, S = !0), S || (C = r("autorange", O = t.getAutorangeDflt(D, n))), C && (v(r, C, D), "linear" !== A && "-" !== A || r("rangemode")), t.cleanRange(), h(e, t, r, n), "category" === A || n.noHover || r("hoverformat");
                    var P = r("color"), I = P !== s.color.dflt ? P : w.color, R = T.label || m._dfltTitle[_];
                    if (d(e, t, r, A, n), !M) return t;
                    r("title.text", R), i.coerceFont(r, "title.font", {
                        family: w.family,
                        size: i.bigFont(w.size),
                        color: I
                    }), c(e, t, r, A);
                    var z = n.hasMinor;
                    if (z && (o.newContainer(t, "minor"), c(e, t, r, A, {
                        isMinor: !0
                    })), f(e, t, r, A, n), u(e, t, r, n), z) {
                        var N = n.isMinor;
                        n.isMinor = !0, u(e, t, r, n), n.isMinor = N;
                    }
                    p(e, t, r, {
                        dfltColor: P,
                        bgColor: n.bgColor,
                        showGrid: n.showGrid,
                        hasMinor: z,
                        attributes: s
                    }), !z || t.minor.ticks || t.minor.showgrid || delete t.minor, (t.showline || t.ticks) && r("mirror");
                    var F, E = "multicategory" === A;
                    if (n.noTickson || "category" !== A && !E || !t.ticks && !t.showgrid || (E && (F = "boundaries"), "boundaries" === r("tickson", F) && delete t.ticklabelposition), E && r("showdividers") && (r("dividercolor"), r("dividerwidth")), "date" === A) {
                        if (l(e, t, {
                            name: "rangebreaks",
                            inclusionAttr: "enabled",
                            handleItemDefaults: x
                        }), t.rangebreaks.length) {
                            for(var H = 0; H < t.rangebreaks.length; H++)if (t.rangebreaks[H].pattern === y) {
                                t._hasDayOfWeekBreaks = !0;
                                break;
                            }
                            if (g(t, m), m._has("scattergl") || m._has("splom")) for(var j = 0; j < n.data.length; j++){
                                var B = n.data[j];
                                "scattergl" !== B.type && "splom" !== B.type || (B.visible = !1, i.warn(B.type + " traces do not work on axes with rangebreaks. Setting trace " + B.index + " to `visible: false`."));
                            }
                        } else delete t.rangebreaks;
                    }
                    return t;
                };
                var b = {
                    sun: 1,
                    mon: 2,
                    tue: 3,
                    wed: 4,
                    thu: 5,
                    fri: 6,
                    sat: 7
                };
                function _(e) {
                    if ("string" == typeof e) return b[e.substr(0, 3).toLowerCase()];
                }
            },
            2663: function(e, t, r) {
                "use strict";
                var n = r(1562), a = n.FORMAT_LINK, i = n.DATE_FORMAT_LINK;
                function o(e, t) {
                    return [
                        "Sets the " + e + " formatting rule" + (t ? "for `" + t + "` " : ""),
                        "using d3 formatting mini-languages",
                        "which are very similar to those in Python. For numbers, see: " + a + "."
                    ].join(" ");
                }
                function l(e, t) {
                    return o(e, t) + [
                        " And for dates see: " + i + ".",
                        "We add two items to d3's date formatter:",
                        "*%h* for half of the year as a decimal number as well as",
                        "*%{n}f* for fractional seconds",
                        "with n digits. For example, *2016-10-13 09:15:23.456* with tickformat",
                        "*%H~%M~%S.%2f* would display *09~15~23.46*"
                    ].join(" ");
                }
                e.exports = {
                    axisHoverFormat: function(e, t) {
                        return {
                            valType: "string",
                            dflt: "",
                            editType: "none",
                            description: (t ? o : l)("hover text", e) + [
                                "By default the values are formatted using " + (t ? "generic number format" : "`" + e + "axis.hoverformat`") + "."
                            ].join(" ")
                        };
                    },
                    descriptionOnlyNumbers: o,
                    descriptionWithDates: l
                };
            },
            1675: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(5555);
                function i(e, t) {
                    if (t && t.length) {
                        for(var r = 0; r < t.length; r++)if (t[r][e]) return !0;
                    }
                    return !1;
                }
                t.id2name = function(e) {
                    if ("string" == typeof e && e.match(a.AX_ID_PATTERN)) {
                        var t = e.split(" ")[0].substr(1);
                        return "1" === t && (t = ""), e.charAt(0) + "axis" + t;
                    }
                }, t.name2id = function(e) {
                    if (e.match(a.AX_NAME_PATTERN)) {
                        var t = e.substr(5);
                        return "1" === t && (t = ""), e.charAt(0) + t;
                    }
                }, t.cleanId = function(e, t, r) {
                    var n = /( domain)$/.test(e);
                    if ("string" == typeof e && e.match(a.AX_ID_PATTERN) && (!t || e.charAt(0) === t) && (!n || r)) {
                        var i = e.split(" ")[0].substr(1).replace(/^0+/, "");
                        return "1" === i && (i = ""), e.charAt(0) + i + (n && r ? " domain" : "");
                    }
                }, t.list = function(e, r, n) {
                    var a = e._fullLayout;
                    if (!a) return [];
                    var i, o = t.listIds(e, r), l = new Array(o.length);
                    for(i = 0; i < o.length; i++){
                        var s = o[i];
                        l[i] = a[s.charAt(0) + "axis" + s.substr(1)];
                    }
                    if (!n) {
                        var c = a._subplots.gl3d || [];
                        for(i = 0; i < c.length; i++){
                            var u = a[c[i]];
                            r ? l.push(u[r + "axis"]) : l.push(u.xaxis, u.yaxis, u.zaxis);
                        }
                    }
                    return l;
                }, t.listIds = function(e, t) {
                    var r = e._fullLayout;
                    if (!r) return [];
                    var n = r._subplots;
                    return t ? n[t + "axis"] : n.xaxis.concat(n.yaxis);
                }, t.getFromId = function(e, r, n) {
                    var a = e._fullLayout;
                    return r = void 0 === r || "string" != typeof r ? r : r.replace(" domain", ""), "x" === n ? r = r.replace(/y[0-9]*/, "") : "y" === n && (r = r.replace(/x[0-9]*/, "")), a[t.id2name(r)];
                }, t.getFromTrace = function(e, r, a) {
                    var i = e._fullLayout, o = null;
                    if (n.traceIs(r, "gl3d")) {
                        var l = r.scene;
                        "scene" === l.substr(0, 5) && (o = i[l][a + "axis"]);
                    } else o = t.getFromId(e, r[a + "axis"] || a);
                    return o;
                }, t.idSort = function(e, t) {
                    var r = e.charAt(0), n = t.charAt(0);
                    return r !== n ? r > n ? 1 : -1 : +(e.substr(1) || 1) - +(t.substr(1) || 1);
                }, t.ref2id = function(e) {
                    return !!/^[xyz]/.test(e) && e.split(" ")[0];
                }, t.isLinked = function(e, t) {
                    return i(t, e._axisMatchGroups) || i(t, e._axisConstraintGroups);
                };
            },
            5258: function(e) {
                "use strict";
                e.exports = function(e, t, r, n) {
                    if ("category" === t.type) {
                        var a, i = e.categoryarray, o = Array.isArray(i) && i.length > 0;
                        o && (a = "array");
                        var l, s = r("categoryorder", a);
                        "array" === s && (l = r("categoryarray")), o || "array" !== s || (s = t.categoryorder = "trace"), "trace" === s ? t._initialCategories = [] : "array" === s ? t._initialCategories = l.slice() : (l = (function(e, t) {
                            var r, n, a, i = t.dataAttr || e._id.charAt(0), o = {};
                            if (t.axData) r = t.axData;
                            else for(r = [], n = 0; n < t.data.length; n++){
                                var l = t.data[n];
                                l[i + "axis"] === e._id && r.push(l);
                            }
                            for(n = 0; n < r.length; n++){
                                var s = r[n][i];
                                for(a = 0; a < s.length; a++){
                                    var c = s[a];
                                    null != c && (o[c] = 1);
                                }
                            }
                            return Object.keys(o);
                        })(t, n).sort(), "category ascending" === s ? t._initialCategories = l : "category descending" === s && (t._initialCategories = l.reverse()));
                    }
                };
            },
            6287: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(1828), i = r(606), o = i.ONEDAY, l = i.ONEWEEK;
                t.dtick = function(e, t) {
                    var r = "log" === t, a = "date" === t, i = "category" === t, l = a ? o : 1;
                    if (!e) return l;
                    if (n(e)) return (e = Number(e)) <= 0 ? l : i ? Math.max(1, Math.round(e)) : a ? Math.max(.1, e) : e;
                    if ("string" != typeof e || !a && !r) return l;
                    var s = e.charAt(0), c = e.substr(1);
                    return (c = n(c) ? Number(c) : 0) <= 0 || !(a && "M" === s && c === Math.round(c) || r && "L" === s || r && "D" === s && (1 === c || 2 === c)) ? l : e;
                }, t.tick0 = function(e, t, r, i) {
                    return "date" === t ? a.cleanDate(e, a.dateTick0(r, i % l == 0 ? 1 : 0)) : "D1" !== i && "D2" !== i ? n(e) ? Number(e) : 0 : void 0;
                };
            },
            5555: function(e, t, r) {
                "use strict";
                var n = r(587).counter;
                e.exports = {
                    idRegex: {
                        x: n("x", "( domain)?"),
                        y: n("y", "( domain)?")
                    },
                    attrRegex: n("[xy]axis"),
                    xAxisMatch: n("xaxis"),
                    yAxisMatch: n("yaxis"),
                    AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/,
                    AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
                    SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
                    HOUR_PATTERN: "hour",
                    WEEKDAY_PATTERN: "day of week",
                    MINDRAG: 8,
                    MINZOOM: 20,
                    DRAGGERSIZE: 20,
                    REDRAWDELAY: 50,
                    DFLTRANGEX: [
                        -1,
                        6
                    ],
                    DFLTRANGEY: [
                        -1,
                        4
                    ],
                    traceLayerClasses: [
                        "imagelayer",
                        "heatmaplayer",
                        "contourcarpetlayer",
                        "contourlayer",
                        "funnellayer",
                        "waterfalllayer",
                        "barlayer",
                        "carpetlayer",
                        "violinlayer",
                        "boxlayer",
                        "ohlclayer",
                        "scattercarpetlayer",
                        "scatterlayer"
                    ],
                    clipOnAxisFalseQuery: [
                        ".scatterlayer",
                        ".barlayer",
                        ".funnellayer",
                        ".waterfalllayer"
                    ],
                    layerValue2layerClass: {
                        "above traces": "above",
                        "below traces": "below"
                    }
                };
            },
            9082: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(1739), i = r(1675).id2name, o = r(3838), l = r(2449), s = r(1994), c = r(606).ALMOST_EQUAL, u = r(8783).FROM_BL;
                function f(e, t, r) {
                    var a = r.axIds, l = r.layoutOut, s = r.hasImage, c = l._axisConstraintGroups, u = l._axisMatchGroups, f = t._id, v = f.charAt(0), g = ((l._splomAxes || {})[v] || {})[f] || {}, y = t._id, m = "x" === y.charAt(0);
                    function x(r, a) {
                        return n.coerce(e, t, o, r, a);
                    }
                    t._matchGroup = null, t._constraintGroup = null, x("constrain", s ? "domain" : "range"), n.coerce(e, t, {
                        constraintoward: {
                            valType: "enumerated",
                            values: m ? [
                                "left",
                                "center",
                                "right"
                            ] : [
                                "bottom",
                                "middle",
                                "top"
                            ],
                            dflt: m ? "center" : "middle"
                        }
                    }, "constraintoward");
                    var b, _, w = t.type, T = [];
                    for(b = 0; b < a.length; b++)(_ = a[b]) !== y && l[i(_)].type === w && T.push(_);
                    var M = h(c, y);
                    if (M) {
                        var k = [];
                        for(b = 0; b < T.length; b++)M[_ = T[b]] || k.push(_);
                        T = k;
                    }
                    var A, L, S = T.length;
                    S && (e.matches || g.matches) && (A = n.coerce(e, t, {
                        matches: {
                            valType: "enumerated",
                            values: T,
                            dflt: -1 !== T.indexOf(g.matches) ? g.matches : void 0
                        }
                    }, "matches"));
                    var D = s && !m ? t.anchor : void 0;
                    if (S && !A && (e.scaleanchor || D) && (L = n.coerce(e, t, {
                        scaleanchor: {
                            valType: "enumerated",
                            values: T.concat([
                                !1
                            ])
                        }
                    }, "scaleanchor", D)), A) {
                        t._matchGroup = p(u, y, A, 1);
                        var O = l[i(A)], C = d(l, t) / d(l, O);
                        m !== ("x" === A.charAt(0)) && (C = (m ? "x" : "y") + C), p(c, y, A, C);
                    } else e.matches && -1 !== a.indexOf(e.matches) && n.warn("ignored " + t._name + '.matches: "' + e.matches + '" to avoid an infinite loop');
                    if (L) {
                        var P = x("scaleratio");
                        P || (P = t.scaleratio = 1), p(c, y, L, P);
                    } else e.scaleanchor && -1 !== a.indexOf(e.scaleanchor) && n.warn("ignored " + t._name + '.scaleanchor: "' + e.scaleanchor + '" to avoid either an infinite loop and possibly inconsistent scaleratios, or because this axis declares a *matches* constraint.');
                }
                function d(e, t) {
                    var r = t.domain;
                    return r || (r = e[i(t.overlaying)].domain), r[1] - r[0];
                }
                function h(e, t) {
                    for(var r = 0; r < e.length; r++)if (e[r][t]) return e[r];
                    return null;
                }
                function p(e, t, r, n) {
                    var a, i, o, l, s, c = h(e, t);
                    null === c ? ((c = {})[t] = 1, s = e.length, e.push(c)) : s = e.indexOf(c);
                    var u = Object.keys(c);
                    for(a = 0; a < e.length; a++)if (o = e[a], a !== s && o[r]) {
                        var f = o[r];
                        for(i = 0; i < u.length; i++)o[l = u[i]] = v(f, v(n, c[l]));
                        return void e.splice(s, 1);
                    }
                    if (1 !== n) for(i = 0; i < u.length; i++){
                        var d = u[i];
                        c[d] = v(n, c[d]);
                    }
                    c[r] = 1;
                }
                function v(e, t) {
                    var r, n, a = "", i = "";
                    "string" == typeof e && (r = (a = e.match(/^[xy]*/)[0]).length, e = +e.substr(r)), "string" == typeof t && (n = (i = t.match(/^[xy]*/)[0]).length, t = +t.substr(n));
                    var o = e * t;
                    return r || n ? r && n && a.charAt(0) !== i.charAt(0) ? r === n ? o : (r > n ? a.substr(n) : i.substr(r)) + o : a + i + e * t : o;
                }
                function g(e, t) {
                    for(var r = t._size, n = r.h / r.w, a = {}, i = Object.keys(e), o = 0; o < i.length; o++){
                        var l = i[o], s = e[l];
                        if ("string" == typeof s) {
                            var c = s.match(/^[xy]*/)[0], u = c.length;
                            s = +s.substr(u);
                            for(var f = "y" === c.charAt(0) ? n : 1 / n, d = 0; d < u; d++)s *= f;
                        }
                        a[l] = s;
                    }
                    return a;
                }
                function y(e, t) {
                    var r = e._inputDomain, n = u[e.constraintoward], a = r[0] + (r[1] - r[0]) * n;
                    e.domain = e._input.domain = [
                        a + (r[0] - a) / t,
                        a + (r[1] - a) / t
                    ], e.setScale();
                }
                t.handleDefaults = function(e, t, r) {
                    var a, o, l, c, u, d, h, p, v = r.axIds, g = r.axHasImage, y = t._axisConstraintGroups = [], m = t._axisMatchGroups = [];
                    for(a = 0; a < v.length; a++)f(u = e[c = i(v[a])], d = t[c], {
                        axIds: v,
                        layoutOut: t,
                        hasImage: g[c]
                    });
                    function x(e, r) {
                        for(a = 0; a < e.length; a++)for(l in o = e[a])t[i(l)][r] = o;
                    }
                    for(x(m, "_matchGroup"), a = 0; a < y.length; a++)for(l in o = y[a])if ((d = t[i(l)]).fixedrange) {
                        for(var b in o){
                            var _ = i(b);
                            !1 === (e[_] || {}).fixedrange && n.warn("fixedrange was specified as false for axis " + _ + " but was overridden because another axis in its constraint group has fixedrange true"), t[_].fixedrange = !0;
                        }
                        break;
                    }
                    for(a = 0; a < y.length;){
                        for(l in o = y[a]){
                            (d = t[i(l)])._matchGroup && Object.keys(d._matchGroup).length === Object.keys(o).length && (y.splice(a, 1), a--);
                            break;
                        }
                        a++;
                    }
                    x(y, "_constraintGroup");
                    var w = [
                        "constrain",
                        "range",
                        "autorange",
                        "rangemode",
                        "rangebreaks",
                        "categoryorder",
                        "categoryarray"
                    ], T = !1, M = !1;
                    function k() {
                        p = d[h], "rangebreaks" === h && (M = d._hasDayOfWeekBreaks);
                    }
                    for(a = 0; a < m.length; a++){
                        o = m[a];
                        for(var A = 0; A < w.length; A++){
                            var L;
                            for(l in h = w[A], p = null, o)if (u = e[c = i(l)], d = t[c], h in d) {
                                if (!d.matches && (L = d, h in u)) {
                                    k();
                                    break;
                                }
                                null === p && h in u && k();
                            }
                            if ("range" === h && p && u.range && 2 === u.range.length && null !== u.range[0] && null !== u.range[1] && (T = !0), "autorange" === h && null === p && T && (p = !1), null === p && h in L && (p = L[h]), null !== p) for(l in o)(d = t[i(l)])[h] = "range" === h ? p.slice() : p, "rangebreaks" === h && (d._hasDayOfWeekBreaks = M, s(d, t));
                        }
                    }
                }, t.enforce = function(e) {
                    var t, r, n, o, s, u, f, d, h = e._fullLayout, p = h._axisConstraintGroups || [];
                    for(t = 0; t < p.length; t++){
                        n = g(p[t], h);
                        var v = Object.keys(n), m = 1 / 0, x = 0, b = 1 / 0, _ = {}, w = {}, T = !1;
                        for(r = 0; r < v.length; r++)w[o = v[r]] = s = h[i(o)], s._inputDomain ? s.domain = s._inputDomain.slice() : s._inputDomain = s.domain.slice(), s._inputRange || (s._inputRange = s.range.slice()), s.setScale(), _[o] = u = Math.abs(s._m) / n[o], m = Math.min(m, u), "domain" !== s.constrain && s._constraintShrinkable || (b = Math.min(b, u)), delete s._constraintShrinkable, x = Math.max(x, u), "domain" === s.constrain && (T = !0);
                        if (!(m > c * x) || T) {
                            for(r = 0; r < v.length; r++)if (u = _[o = v[r]], f = (s = w[o]).constrain, u !== b || "domain" === f) {
                                if (d = u / b, "range" === f) l(s, d);
                                else {
                                    var M = s._inputDomain, k = (s.domain[1] - s.domain[0]) / (M[1] - M[0]), A = (s.r2l(s.range[1]) - s.r2l(s.range[0])) / (s.r2l(s._inputRange[1]) - s.r2l(s._inputRange[0]));
                                    if ((d /= k) * A < 1) {
                                        s.domain = s._input.domain = M.slice(), l(s, d);
                                        continue;
                                    }
                                    if (A < 1 && (s.range = s._input.range = s._inputRange.slice(), d *= A), s.autorange) {
                                        var L = s.r2l(s.range[0]), S = s.r2l(s.range[1]), D = (L + S) / 2, O = D, C = D, P = Math.abs(S - D), I = D - P * d * 1.0001, R = D + P * d * 1.0001, z = a.makePadFn(h, s, 0), N = a.makePadFn(h, s, 1);
                                        y(s, d);
                                        var F, E, H = Math.abs(s._m), j = a.concatExtremes(e, s), B = j.min, Y = j.max;
                                        for(E = 0; E < B.length; E++)(F = B[E].val - z(B[E]) / H) > I && F < O && (O = F);
                                        for(E = 0; E < Y.length; E++)(F = Y[E].val + N(Y[E]) / H) < R && F > C && (C = F);
                                        d /= (C - O) / (2 * P), O = s.l2r(O), C = s.l2r(C), s.range = s._input.range = L < S ? [
                                            O,
                                            C
                                        ] : [
                                            C,
                                            O
                                        ];
                                    }
                                    y(s, d);
                                }
                            }
                        }
                    }
                }, t.getAxisGroup = function(e, t) {
                    for(var r = e._axisMatchGroups, n = 0; n < r.length; n++)if (r[n][t]) return "g" + n;
                    return t;
                }, t.clean = function(e, t) {
                    if (t._inputDomain) {
                        for(var r = !1, n = t._id, a = e._fullLayout._axisConstraintGroups, i = 0; i < a.length; i++)if (a[i][n]) {
                            r = !0;
                            break;
                        }
                        r && "domain" === t.constrain || (t._input.domain = t.domain = t._inputDomain, delete t._inputDomain);
                    }
                };
            },
            9323: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(1828), i = a.numberFormat, o = r(4267), l = r(8520), s = r(3972), c = a.strTranslate, u = r(3893), f = r(7901), d = r(1424), h = r(211), p = r(9298), v = r(6964), g = r(8569), y = r(4505), m = y.selectingOrDrawing, x = y.freeMode, b = r(8783).FROM_TL, _ = r(3306), w = r(1549).redrawReglTraces, T = r(4875), M = r(1675).getFromId, k = r(7322).prepSelect, A = r(7322).clearOutline, L = r(7322).selectOnClick, S = r(2449), D = r(5555), O = D.MINDRAG, C = D.MINZOOM, P = !0;
                function I(e, t, r, n) {
                    var i = a.ensureSingle(e.draglayer, t, r, function(t) {
                        t.classed("drag", !0).style({
                            fill: "transparent",
                            "stroke-width": 0
                        }).attr("data-subplot", e.id);
                    });
                    return i.call(v, n), i.node();
                }
                function R(e, t, r, a, i, o, l) {
                    var s = I(e, "rect", t, r);
                    return n.select(s).call(d.setRect, a, i, o, l), s;
                }
                function z(e, t) {
                    for(var r = 0; r < e.length; r++)if (!e[r].fixedrange) return t;
                    return "";
                }
                function N(e, t, r, n, a) {
                    for(var i = 0; i < e.length; i++){
                        var o = e[i];
                        if (!o.fixedrange) {
                            if (o.rangebreaks) {
                                var l = "y" === o._id.charAt(0), s = l ? 1 - t : t, c = l ? 1 - r : r;
                                n[o._name + ".range[0]"] = o.l2r(o.p2l(s * o._length)), n[o._name + ".range[1]"] = o.l2r(o.p2l(c * o._length));
                            } else {
                                var u = o._rl[0], f = o._rl[1] - u;
                                n[o._name + ".range[0]"] = o.l2r(u + f * t), n[o._name + ".range[1]"] = o.l2r(u + f * r);
                            }
                        }
                    }
                    if (a && a.length) {
                        var d = (t + (1 - r)) / 2;
                        N(a, d, 1 - d, n, []);
                    }
                }
                function F(e, t) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        if (!n.fixedrange) {
                            if (n.rangebreaks) {
                                var a = n._length, i = (n.p2l(0 + t) - n.p2l(0) + (n.p2l(a + t) - n.p2l(a))) / 2;
                                n.range = [
                                    n.l2r(n._rl[0] - i),
                                    n.l2r(n._rl[1] - i)
                                ];
                            } else n.range = [
                                n.l2r(n._rl[0] - t / n._m),
                                n.l2r(n._rl[1] - t / n._m)
                            ];
                            n.limitRange && n.limitRange();
                        }
                    }
                }
                function E(e) {
                    return 1 - (e >= 0 ? Math.min(e, .9) : 1 / (1 / Math.max(e, -0.3) + 3.222));
                }
                function H(e, t, r, n, a) {
                    return e.append("path").attr("class", "zoombox").style({
                        fill: t > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
                        "stroke-width": 0
                    }).attr("transform", c(r, n)).attr("d", a + "Z");
                }
                function j(e, t, r) {
                    return e.append("path").attr("class", "zoombox-corners").style({
                        fill: f.background,
                        stroke: f.defaultLine,
                        "stroke-width": 1,
                        opacity: 0
                    }).attr("transform", c(t, r)).attr("d", "M0,0Z");
                }
                function B(e, t, r, n, a, i) {
                    e.attr("d", n + "M" + r.l + "," + r.t + "v" + r.h + "h" + r.w + "v-" + r.h + "h-" + r.w + "Z"), Y(e, t, a, i);
                }
                function Y(e, t, r, n) {
                    r || (e.transition().style("fill", n > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), t.transition().style("opacity", 1).duration(200));
                }
                function V(e) {
                    n.select(e).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
                }
                function U(e) {
                    P && e.data && e._context.showTips && (a.notifier(a._(e, "Double-click to zoom back out"), "long"), P = !1);
                }
                function q(e) {
                    var t = Math.floor(Math.min(e.b - e.t, e.r - e.l, C) / 2);
                    return "M" + (e.l - 3.5) + "," + (e.t - .5 + t) + "h3v" + -t + "h" + t + "v-3h-" + (t + 3) + "ZM" + (e.r + 3.5) + "," + (e.t - .5 + t) + "h-3v" + -t + "h" + -t + "v-3h" + (t + 3) + "ZM" + (e.r + 3.5) + "," + (e.b + .5 - t) + "h-3v" + t + "h" + -t + "v3h" + (t + 3) + "ZM" + (e.l - 3.5) + "," + (e.b + .5 - t) + "h3v" + t + "h" + t + "v3h-" + (t + 3) + "Z";
                }
                function G(e, t, r, n, i) {
                    for(var o, l, s, c, u = !1, f = {}, d = {}, h = (i || {}).xaHash, p = (i || {}).yaHash, v = 0; v < t.length; v++){
                        var g = t[v];
                        for(o in r)if (g[o]) {
                            for(s in g)i && (h[s] || p[s]) || ("x" === s.charAt(0) ? r : n)[s] || (f[s] = o);
                            for(l in n)i && (h[l] || p[l]) || !g[l] || (u = !0);
                        }
                        for(l in n)if (g[l]) for(c in g)i && (h[c] || p[c]) || ("x" === c.charAt(0) ? r : n)[c] || (d[c] = l);
                    }
                    u && (a.extendFlat(f, d), d = {});
                    var y = {}, m = [];
                    for(s in f){
                        var x = M(e, s);
                        m.push(x), y[x._id] = x;
                    }
                    var b = {}, _ = [];
                    for(c in d){
                        var w = M(e, c);
                        _.push(w), b[w._id] = w;
                    }
                    return {
                        xaHash: y,
                        yaHash: b,
                        xaxes: m,
                        yaxes: _,
                        xLinks: f,
                        yLinks: d,
                        isSubplotConstrained: u
                    };
                }
                function Z(e, t) {
                    if (l) {
                        var r = void 0 !== e.onwheel ? "wheel" : "mousewheel";
                        e._onwheel && e.removeEventListener(r, e._onwheel), e._onwheel = t, e.addEventListener(r, t, {
                            passive: !1
                        });
                    } else void 0 !== e.onwheel ? e.onwheel = t : void 0 !== e.onmousewheel ? e.onmousewheel = t : e.isAddedWheelEvent || (e.isAddedWheelEvent = !0, e.addEventListener("wheel", t, {
                        passive: !1
                    }));
                }
                function W(e) {
                    var t = [];
                    for(var r in e)t.push(e[r]);
                    return t;
                }
                e.exports = {
                    makeDragBox: function(e, t, r, l, c, f, v, y) {
                        var P, I, Y, X, J, K, Q, $, ee, te, re, ne, ae, ie, oe, le, se, ce, ue, fe, de, he, pe, ve = e._fullLayout._zoomlayer, ge = v + y === "nsew", ye = 1 === (v + y).length;
                        function me() {
                            if (P = t.xaxis, I = t.yaxis, ee = P._length, te = I._length, Q = P._offset, $ = I._offset, (Y = {})[P._id] = P, (X = {})[I._id] = I, v && y) for(var r = t.overlays, n = 0; n < r.length; n++){
                                var a = r[n].xaxis;
                                Y[a._id] = a;
                                var i = r[n].yaxis;
                                X[i._id] = i;
                            }
                            J = W(Y), K = W(X), ae = z(J, y), ie = z(K, v), oe = !ie && !ae, ne = G(e, e._fullLayout._axisMatchGroups, Y, X);
                            var o = (re = G(e, e._fullLayout._axisConstraintGroups, Y, X, ne)).isSubplotConstrained || ne.isSubplotConstrained;
                            le = y || o, se = v || o;
                            var l = e._fullLayout;
                            ce = l._has("scattergl"), ue = l._has("splom"), fe = l._has("svg");
                        }
                        r += t.yaxis._shift, me();
                        var xe = function(e, t, r) {
                            return e ? "nsew" === e ? r ? "" : "pan" === t ? "move" : "crosshair" : e.toLowerCase() + "-resize" : "pointer";
                        }(ie + ae, e._fullLayout.dragmode, ge), be = R(t, v + y + "drag", xe, r, l, c, f);
                        if (oe && !ge) return be.onmousedown = null, be.style.pointerEvents = "none", be;
                        var _e, we, Te, Me, ke, Ae, Le, Se, De, Oe, Ce = {
                            element: be,
                            gd: e,
                            plotinfo: t
                        };
                        function Pe() {
                            Ce.plotinfo.selection = !1, A(e);
                        }
                        function Ie(e, r) {
                            var a = Ce.gd;
                            if (a._fullLayout._activeShapeIndex >= 0) a._fullLayout._deactivateShape(a);
                            else {
                                var o = a._fullLayout.clickmode;
                                if (V(a), 2 !== e || ye || Ue(), ge) o.indexOf("select") > -1 && L(r, a, J, K, t.id, Ce), o.indexOf("event") > -1 && h.click(a, r, t.id);
                                else if (1 === e && ye) {
                                    var l = v ? I : P, c = "s" === v || "w" === y ? 0 : 1, f = l._name + ".range[" + c + "]", d = function(e, t) {
                                        var r, n = e.range[t], a = Math.abs(n - e.range[1 - t]);
                                        return "date" === e.type ? n : "log" === e.type ? (r = Math.ceil(Math.max(0, -Math.log(a) / Math.LN10)) + 3, i("." + r + "g")(Math.pow(10, n))) : (r = Math.floor(Math.log(Math.abs(n)) / Math.LN10) - Math.floor(Math.log(a) / Math.LN10) + 4, i("." + String(r) + "g")(n));
                                    }(l, c), p = "left", g = "middle";
                                    if (l.fixedrange) return;
                                    v ? (g = "n" === v ? "top" : "bottom", "right" === l.side && (p = "right")) : "e" === y && (p = "right"), a._context.showAxisRangeEntryBoxes && n.select(be).call(u.makeEditable, {
                                        gd: a,
                                        immediate: !0,
                                        background: a._fullLayout.paper_bgcolor,
                                        text: String(d),
                                        fill: l.tickfont ? l.tickfont.color : "#444",
                                        horizontalAlign: p,
                                        verticalAlign: g
                                    }).on("edit", function(e) {
                                        var t = l.d2r(e);
                                        void 0 !== t && s.call("_guiRelayout", a, f, t);
                                    });
                                }
                            }
                        }
                        function Re(t, r) {
                            if (e._transitioningWithDuration) return !1;
                            var n = Math.max(0, Math.min(ee, he * t + _e)), a = Math.max(0, Math.min(te, pe * r + we)), i = Math.abs(n - _e), o = Math.abs(a - we);
                            function l() {
                                Le = "", Te.r = Te.l, Te.t = Te.b, De.attr("d", "M0,0Z");
                            }
                            if (Te.l = Math.min(_e, n), Te.r = Math.max(_e, n), Te.t = Math.min(we, a), Te.b = Math.max(we, a), re.isSubplotConstrained) i > C || o > C ? (Le = "xy", i / ee > o / te ? (o = i * te / ee, we > a ? Te.t = we - o : Te.b = we + o) : (i = o * ee / te, _e > n ? Te.l = _e - i : Te.r = _e + i), De.attr("d", q(Te))) : l();
                            else if (ne.isSubplotConstrained) {
                                if (i > C || o > C) {
                                    Le = "xy";
                                    var s = Math.min(Te.l / ee, (te - Te.b) / te), c = Math.max(Te.r / ee, (te - Te.t) / te);
                                    Te.l = s * ee, Te.r = c * ee, Te.b = (1 - s) * te, Te.t = (1 - c) * te, De.attr("d", q(Te));
                                } else l();
                            } else !ie || o < Math.min(Math.max(.6 * i, O), C) ? i < O || !ae ? l() : (Te.t = 0, Te.b = te, Le = "x", De.attr("d", function(e, t) {
                                return "M" + (e.l - .5) + "," + (t - C - .5) + "h-3v" + (2 * C + 1) + "h3ZM" + (e.r + .5) + "," + (t - C - .5) + "h3v" + (2 * C + 1) + "h-3Z";
                            }(Te, we))) : !ae || i < Math.min(.6 * o, C) ? (Te.l = 0, Te.r = ee, Le = "y", De.attr("d", function(e, t) {
                                return "M" + (t - C - .5) + "," + (e.t - .5) + "v-3h" + (2 * C + 1) + "v3ZM" + (t - C - .5) + "," + (e.b + .5) + "v3h" + (2 * C + 1) + "v-3Z";
                            }(Te, _e))) : (Le = "xy", De.attr("d", q(Te)));
                            Te.w = Te.r - Te.l, Te.h = Te.b - Te.t, Le && (Oe = !0), e._dragged = Oe, B(Se, De, Te, ke, Ae, Me), ze(), e.emit("plotly_relayouting", de), Ae = !0;
                        }
                        function ze() {
                            de = {}, "xy" !== Le && "x" !== Le || (N(J, Te.l / ee, Te.r / ee, de, re.xaxes), Ye("x", de)), "xy" !== Le && "y" !== Le || (N(K, (te - Te.b) / te, (te - Te.t) / te, de, re.yaxes), Ye("y", de));
                        }
                        function Ne() {
                            ze(), V(e), qe(), U(e);
                        }
                        Ce.prepFn = function(t, r, n) {
                            var i = Ce.dragmode, l = e._fullLayout.dragmode;
                            l !== i && (Ce.dragmode = l), me(), he = e._fullLayout._invScaleX, pe = e._fullLayout._invScaleY, oe || (ge ? t.shiftKey ? "pan" === l ? l = "zoom" : m(l) || (l = "pan") : t.ctrlKey && (l = "pan") : l = "pan"), x(l) ? Ce.minDrag = 1 : Ce.minDrag = void 0, m(l) ? (Ce.xaxes = J, Ce.yaxes = K, k(t, r, n, Ce, l)) : (Ce.clickFn = Ie, m(i) && Pe(), oe || ("zoom" === l ? (Ce.moveFn = Re, Ce.doneFn = Ne, Ce.minDrag = 1, function(t, r, n) {
                                var i = be.getBoundingClientRect();
                                _e = r - i.left, we = n - i.top, e._fullLayout._calcInverseTransform(e);
                                var l = a.apply3DTransform(e._fullLayout._invTransform)(_e, we);
                                _e = l[0], we = l[1], Te = {
                                    l: _e,
                                    r: _e,
                                    w: 0,
                                    t: we,
                                    b: we,
                                    h: 0
                                }, Me = e._hmpixcount ? e._hmlumcount / e._hmpixcount : o(e._fullLayout.plot_bgcolor).getLuminance(), Ae = !1, Le = "xy", Oe = !1, Se = H(ve, Me, Q, $, ke = "M0,0H" + ee + "V" + te + "H0V0"), De = j(ve, Q, $);
                            }(0, r, n)) : "pan" === l && (Ce.moveFn = Be, Ce.doneFn = qe))), e._fullLayout._redrag = function() {
                                var t = e._dragdata;
                                if (t && t.element === be) {
                                    var r = e._fullLayout.dragmode;
                                    m(r) || (me(), Ge([
                                        0,
                                        0,
                                        ee,
                                        te
                                    ]), Ce.moveFn(t.dx, t.dy));
                                }
                            };
                        }, g.init(Ce);
                        var Fe = [
                            0,
                            0,
                            ee,
                            te
                        ], Ee = null, He = D.REDRAWDELAY, je = t.mainplot ? e._fullLayout._plots[t.mainplot] : t;
                        function Be(t, r) {
                            if (t *= he, r *= pe, !e._transitioningWithDuration) {
                                if (e._fullLayout._replotting = !0, "ew" === ae || "ns" === ie) {
                                    var n = ae ? -t : 0, a = ie ? -r : 0;
                                    if (ne.isSubplotConstrained) {
                                        if (ae && ie) {
                                            var i = (t / ee - r / te) / 2;
                                            n = -(t = i * ee), a = -(r = -i * te);
                                        }
                                        ie ? n = -a * ee / te : a = -n * te / ee;
                                    }
                                    return ae && (F(J, t), Ye("x")), ie && (F(K, r), Ye("y")), Ge([
                                        n,
                                        a,
                                        ee,
                                        te
                                    ]), Ve(), void e.emit("plotly_relayouting", de);
                                }
                                var o, l, s = "w" === ae == ("n" === ie) ? 1 : -1;
                                if (ae && ie && (re.isSubplotConstrained || ne.isSubplotConstrained)) {
                                    var c = (t / ee + s * r / te) / 2;
                                    t = c * ee, r = s * c * te;
                                }
                                if ("w" === ae ? t = h(J, 0, t) : "e" === ae ? t = h(J, 1, -t) : ae || (t = 0), "n" === ie ? r = h(K, 1, r) : "s" === ie ? r = h(K, 0, -r) : ie || (r = 0), o = "w" === ae ? t : 0, l = "n" === ie ? r : 0, re.isSubplotConstrained && !ne.isSubplotConstrained || ne.isSubplotConstrained && ae && ie && s > 0) {
                                    var u;
                                    if (ne.isSubplotConstrained || !ae && 1 === ie.length) {
                                        for(u = 0; u < J.length; u++)J[u].range = J[u]._r.slice(), S(J[u], 1 - r / te);
                                        o = (t = r * ee / te) / 2;
                                    }
                                    if (ne.isSubplotConstrained || !ie && 1 === ae.length) {
                                        for(u = 0; u < K.length; u++)K[u].range = K[u]._r.slice(), S(K[u], 1 - t / ee);
                                        l = (r = t * te / ee) / 2;
                                    }
                                }
                                ne.isSubplotConstrained && ie || Ye("x"), ne.isSubplotConstrained && ae || Ye("y");
                                var f = ee - t, d = te - r;
                                !ne.isSubplotConstrained || ae && ie || (ae ? (l = o ? 0 : t * te / ee, d = f * te / ee) : (o = l ? 0 : r * ee / te, f = d * ee / te)), Ge([
                                    o,
                                    l,
                                    f,
                                    d
                                ]), Ve(), e.emit("plotly_relayouting", de);
                            }
                            function h(e, t, r) {
                                for(var n, a, i = 1 - t, o = 0; o < e.length; o++){
                                    var l = e[o];
                                    if (!l.fixedrange) {
                                        n = l, a = l._rl[i] + (l._rl[t] - l._rl[i]) / E(r / l._length);
                                        var s = l.l2r(a);
                                        !1 !== s && void 0 !== s && (l.range[t] = s);
                                    }
                                }
                                return n._length * (n._rl[t] - a) / (n._rl[t] - n._rl[i]);
                            }
                        }
                        function Ye(e, t) {
                            for(var r = ne.isSubplotConstrained ? ({
                                x: K,
                                y: J
                            })[e] : ne[e + "axes"], n = ne.isSubplotConstrained ? ({
                                x: J,
                                y: K
                            })[e] : [], a = 0; a < r.length; a++){
                                var i = r[a], o = i._id, l = ne.xLinks[o] || ne.yLinks[o], s = n[0] || Y[l] || X[l];
                                s && (t ? (t[i._name + ".range[0]"] = t[s._name + ".range[0]"], t[i._name + ".range[1]"] = t[s._name + ".range[1]"]) : i.range = s.range.slice());
                            }
                        }
                        function Ve() {
                            var r, n = [];
                            function a(e) {
                                for(r = 0; r < e.length; r++)e[r].fixedrange || n.push(e[r]._id);
                            }
                            function i(e, t) {
                                for(r = 0; r < e.length; r++){
                                    var a = e[r], i = a[t];
                                    a.fixedrange || "sync" !== i.tickmode || n.push(i._id);
                                }
                            }
                            for(le && (a(J), a(re.xaxes), a(ne.xaxes), i(t.overlays, "xaxis")), se && (a(K), a(re.yaxes), a(ne.yaxes), i(t.overlays, "yaxis")), de = {}, r = 0; r < n.length; r++){
                                var o = n[r], l = M(e, o);
                                p.drawOne(e, l, {
                                    skipTitle: !0
                                }), de[l._name + ".range[0]"] = l.range[0], de[l._name + ".range[1]"] = l.range[1];
                            }
                            p.redrawComponents(e, n);
                        }
                        function Ue() {
                            if (!e._transitioningWithDuration) {
                                var t = e._context.doubleClick, r = [];
                                ae && (r = r.concat(J)), ie && (r = r.concat(K)), ne.xaxes && (r = r.concat(ne.xaxes)), ne.yaxes && (r = r.concat(ne.yaxes));
                                var n, a, i = {};
                                if ("reset+autosize" === t) for(t = "autosize", a = 0; a < r.length; a++){
                                    var o = (n = r[a])._rangeInitial0, l = n._rangeInitial1, c = void 0 !== o || void 0 !== l;
                                    if (c && (void 0 !== o && o !== n.range[0] || void 0 !== l && l !== n.range[1]) || !c && !0 !== n.autorange) {
                                        t = "reset";
                                        break;
                                    }
                                }
                                if ("autosize" === t) for(a = 0; a < r.length; a++)(n = r[a]).fixedrange || (i[n._name + ".autorange"] = !0);
                                else if ("reset" === t) {
                                    for((ae || re.isSubplotConstrained) && (r = r.concat(re.xaxes)), ie && !re.isSubplotConstrained && (r = r.concat(re.yaxes)), re.isSubplotConstrained && (ae ? ie || (r = r.concat(K)) : r = r.concat(J)), a = 0; a < r.length; a++)if (!(n = r[a]).fixedrange) {
                                        var u = n._name, f = n._autorangeInitial;
                                        void 0 === n._rangeInitial0 && void 0 === n._rangeInitial1 ? i[u + ".autorange"] = !0 : void 0 === n._rangeInitial0 ? (i[u + ".autorange"] = f, i[u + ".range"] = [
                                            null,
                                            n._rangeInitial1
                                        ]) : void 0 === n._rangeInitial1 ? (i[u + ".range"] = [
                                            n._rangeInitial0,
                                            null
                                        ], i[u + ".autorange"] = f) : i[u + ".range"] = [
                                            n._rangeInitial0,
                                            n._rangeInitial1
                                        ];
                                    }
                                }
                                e.emit("plotly_doubleclick", null), s.call("_guiRelayout", e, i);
                            }
                        }
                        function qe() {
                            Ge([
                                0,
                                0,
                                ee,
                                te
                            ]), a.syncOrAsync([
                                T.previousPromises,
                                function() {
                                    e._fullLayout._replotting = !1, s.call("_guiRelayout", e, de);
                                }
                            ], e);
                        }
                        function Ge(t) {
                            var r, n, i, o, l = e._fullLayout, c = l._plots, u = l._subplots.cartesian;
                            if (ue && s.subplotsRegistry.splom.drag(e), ce) {
                                for(r = 0; r < u.length; r++)if (i = (n = c[u[r]]).xaxis, o = n.yaxis, n._scene) {
                                    var f = a.simpleMap(i.range, i.r2l), h = a.simpleMap(o.range, o.r2l);
                                    i.limitRange && i.limitRange(), o.limitRange && o.limitRange(), f = i.range, h = o.range, n._scene.update({
                                        range: [
                                            f[0],
                                            h[0],
                                            f[1],
                                            h[1]
                                        ]
                                    });
                                }
                            }
                            if ((ue || ce) && (_(e), w(e)), fe) {
                                var p = t[2] / P._length, g = t[3] / I._length;
                                for(r = 0; r < u.length; r++){
                                    i = (n = c[u[r]]).xaxis, o = n.yaxis;
                                    var m, x, b, T, M = (le || ne.isSubplotConstrained) && !i.fixedrange && Y[i._id], k = (se || ne.isSubplotConstrained) && !o.fixedrange && X[o._id];
                                    if (M ? (m = p, b = y || ne.isSubplotConstrained ? t[0] : Xe(i, m)) : ne.xaHash[i._id] ? (m = p, b = t[0] * i._length / P._length) : ne.yaHash[i._id] ? (m = g, b = "ns" === ie ? -t[1] * i._length / I._length : Xe(i, m, {
                                        n: "top",
                                        s: "bottom"
                                    }[ie])) : b = We(i, m = Ze(i, p, g)), m > 1 && (void 0 !== i.maxallowed && le === (i.range[0] < i.range[1] ? "e" : "w") || void 0 !== i.minallowed && le === (i.range[0] < i.range[1] ? "w" : "e")) && (m = 1, b = 0), k ? (x = g, T = v || ne.isSubplotConstrained ? t[1] : Xe(o, x)) : ne.yaHash[o._id] ? (x = g, T = t[1] * o._length / I._length) : ne.xaHash[o._id] ? (x = p, T = "ew" === ae ? -t[0] * o._length / P._length : Xe(o, x, {
                                        e: "right",
                                        w: "left"
                                    }[ae])) : T = We(o, x = Ze(o, p, g)), x > 1 && (void 0 !== o.maxallowed && se === (o.range[0] < o.range[1] ? "n" : "s") || void 0 !== o.minallowed && se === (o.range[0] < o.range[1] ? "s" : "n")) && (x = 1, T = 0), m || x) {
                                        m || (m = 1), x || (x = 1);
                                        var A = i._offset - b / m, L = o._offset - T / x;
                                        n.clipRect.call(d.setTranslate, b, T).call(d.setScale, m, x), n.plot.call(d.setTranslate, A, L).call(d.setScale, 1 / m, 1 / x), m === n.xScaleFactor && x === n.yScaleFactor || (d.setPointGroupScale(n.zoomScalePts, m, x), d.setTextPointsScale(n.zoomScaleTxt, m, x)), d.hideOutsideRangePoints(n.clipOnAxisFalseTraces, n), n.xScaleFactor = m, n.yScaleFactor = x;
                                    }
                                }
                            }
                        }
                        function Ze(e, t, r) {
                            return e.fixedrange ? 0 : le && re.xaHash[e._id] ? t : se && (re.isSubplotConstrained ? re.xaHash : re.yaHash)[e._id] ? r : 0;
                        }
                        function We(e, t) {
                            return t ? (e.range = e._r.slice(), S(e, t), Xe(e, t)) : 0;
                        }
                        function Xe(e, t, r) {
                            return e._length * (1 - t) * b[r || e.constraintoward || "middle"];
                        }
                        return v.length * y.length != 1 && Z(be, function(t) {
                            if (e._context._scrollZoom.cartesian || e._fullLayout._enablescrollzoom) {
                                if (Pe(), e._transitioningWithDuration) return t.preventDefault(), void t.stopPropagation();
                                me(), clearTimeout(Ee);
                                var r = -t.deltaY;
                                if (isFinite(r) || (r = t.wheelDelta / 10), isFinite(r)) {
                                    var n, i = Math.exp(-Math.min(Math.max(r, -20), 20) / 200), o = je.draglayer.select(".nsewdrag").node().getBoundingClientRect(), l = (t.clientX - o.left) / o.width, s = (o.bottom - t.clientY) / o.height;
                                    if (le) {
                                        for(y || (l = .5), n = 0; n < J.length; n++)c(J[n], l, i);
                                        Ye("x"), Fe[2] *= i, Fe[0] += Fe[2] * l * (1 / i - 1);
                                    }
                                    if (se) {
                                        for(v || (s = .5), n = 0; n < K.length; n++)c(K[n], s, i);
                                        Ye("y"), Fe[3] *= i, Fe[1] += Fe[3] * (1 - s) * (1 / i - 1);
                                    }
                                    Ge(Fe), Ve(), e.emit("plotly_relayouting", de), Ee = setTimeout(function() {
                                        e._fullLayout && (Fe = [
                                            0,
                                            0,
                                            ee,
                                            te
                                        ], qe());
                                    }, He), t.preventDefault();
                                } else a.log("Did not find wheel motion attributes: ", t);
                            }
                            function c(e, t, r) {
                                if (!e.fixedrange) {
                                    var n = a.simpleMap(e.range, e.r2l), i = n[0] + (n[1] - n[0]) * t;
                                    e.range = n.map(function(t) {
                                        return e.l2r(i + (t - i) * r);
                                    });
                                }
                            }
                        }), be;
                    },
                    makeDragger: I,
                    makeRectDragger: R,
                    makeZoombox: H,
                    makeCorners: j,
                    updateZoombox: B,
                    xyCorners: q,
                    transitionZoombox: Y,
                    removeZoombox: V,
                    showDoubleClickNotifier: U,
                    attachWheelEventHandler: Z
                };
            },
            4305: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(211), i = r(8569), o = r(6964), l = r(9323).makeDragBox, s = r(5555).DRAGGERSIZE;
                t.initInteractions = function(e) {
                    var r = e._fullLayout;
                    if (e._context.staticPlot) n.select(e).selectAll(".drag").remove();
                    else if (r._has("cartesian") || r._has("splom")) {
                        Object.keys(r._plots || {}).sort(function(e, t) {
                            if ((r._plots[e].mainplot && !0) === (r._plots[t].mainplot && !0)) {
                                var n = e.split("y"), a = t.split("y");
                                return n[0] === a[0] ? Number(n[1] || 1) - Number(a[1] || 1) : Number(n[0] || 1) - Number(a[0] || 1);
                            }
                            return r._plots[e].mainplot ? 1 : -1;
                        }).forEach(function(t) {
                            var n = r._plots[t], o = n.xaxis, c = n.yaxis;
                            if (!n.mainplot) {
                                var u = l(e, n, o._offset, c._offset, o._length, c._length, "ns", "ew");
                                u.onmousemove = function(r) {
                                    e._fullLayout._rehover = function() {
                                        e._fullLayout._hoversubplot === t && e._fullLayout._plots[t] && a.hover(e, r, t);
                                    }, a.hover(e, r, t), e._fullLayout._lasthover = u, e._fullLayout._hoversubplot = t;
                                }, u.onmouseout = function(t) {
                                    e._dragging || (e._fullLayout._hoversubplot = null, i.unhover(e, t));
                                }, e._context.showAxisDragHandles && (l(e, n, o._offset - s, c._offset - s, s, s, "n", "w"), l(e, n, o._offset + o._length, c._offset - s, s, s, "n", "e"), l(e, n, o._offset - s, c._offset + c._length, s, s, "s", "w"), l(e, n, o._offset + o._length, c._offset + c._length, s, s, "s", "e"));
                            }
                            if (e._context.showAxisDragHandles) {
                                if (t === o._mainSubplot) {
                                    var f = o._mainLinePosition;
                                    "top" === o.side && (f -= s), l(e, n, o._offset + .1 * o._length, f, .8 * o._length, s, "", "ew"), l(e, n, o._offset, f, .1 * o._length, s, "", "w"), l(e, n, o._offset + .9 * o._length, f, .1 * o._length, s, "", "e");
                                }
                                if (t === c._mainSubplot) {
                                    var d = c._mainLinePosition;
                                    "right" !== c.side && (d -= s), l(e, n, d, c._offset + .1 * c._length, s, .8 * c._length, "ns", ""), l(e, n, d, c._offset + .9 * c._length, s, .1 * c._length, "s", ""), l(e, n, d, c._offset, s, .1 * c._length, "n", "");
                                }
                            }
                        });
                        var o = r._hoverlayer.node();
                        o.onmousemove = function(t) {
                            t.target = e._fullLayout._lasthover, a.hover(e, t, r._hoversubplot);
                        }, o.onclick = function(t) {
                            t.target = e._fullLayout._lasthover, a.click(e, t);
                        }, o.onmousedown = function(t) {
                            e._fullLayout._lasthover.onmousedown(t);
                        }, t.updateFx(e);
                    }
                }, t.updateFx = function(e) {
                    var t = e._fullLayout, r = "pan" === t.dragmode ? "move" : "crosshair";
                    o(t._draggers, r);
                };
            },
            6325: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(1828), i = r(1675);
                e.exports = function(e) {
                    return function(t, r) {
                        var o = t[e];
                        if (Array.isArray(o)) for(var l = n.subplotsRegistry.cartesian, s = l.idRegex, c = r._subplots, u = c.xaxis, f = c.yaxis, d = c.cartesian, h = r._has("cartesian") || r._has("gl2d"), p = 0; p < o.length; p++){
                            var v = o[p];
                            if (a.isPlainObject(v)) {
                                var g = i.cleanId(v.xref, "x", !1), y = i.cleanId(v.yref, "y", !1), m = s.x.test(g), x = s.y.test(y);
                                if (m || x) {
                                    h || a.pushUnique(r._basePlotModules, l);
                                    var b = !1;
                                    m && -1 === u.indexOf(g) && (u.push(g), b = !0), x && -1 === f.indexOf(y) && (f.push(y), b = !0), b && m && x && d.push(g + y);
                                }
                            }
                        }
                    };
                };
            },
            3612: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(3972), i = r(1828), o = r(4875), l = r(1424), s = r(7659).a0, c = r(1675), u = r(5555), f = r(7922), d = i.ensureSingle;
                function h(e, t, r) {
                    return i.ensureSingle(e, t, r, function(e) {
                        e.datum(r);
                    });
                }
                function p(e, t, r, i, o) {
                    for(var c, f, d, h = u.traceLayerClasses, p = e._fullLayout, v = p._modules, g = [], y = [], m = 0; m < v.length; m++){
                        var x = (c = v[m]).name, b = a.modules[x].categories;
                        if (b.svg) {
                            var _ = c.layerName || x + "layer", w = c.plot;
                            d = (f = s(r, w))[0], r = f[1], d.length && g.push({
                                i: h.indexOf(_),
                                className: _,
                                plotMethod: w,
                                cdModule: d
                            }), b.zoomScale && y.push("." + _);
                        }
                    }
                    g.sort(function(e, t) {
                        return e.i - t.i;
                    });
                    var T = t.plot.selectAll("g.mlayer").data(g, function(e) {
                        return e.className;
                    });
                    if (T.enter().append("g").attr("class", function(e) {
                        return e.className;
                    }).classed("mlayer", !0).classed("rangeplot", t.isRangePlot), T.exit().remove(), T.order(), T.each(function(r) {
                        var a = n.select(this), s = r.className;
                        r.plotMethod(e, t, r.cdModule, a, i, o), -1 === u.clipOnAxisFalseQuery.indexOf("." + s) && l.setClipUrl(a, t.layerClipId, e);
                    }), p._has("scattergl") && (c = a.getModule("scattergl"), d = s(r, c)[0], c.plot(e, t, d)), !e._context.staticPlot && (t._hasClipOnAxisFalse && (t.clipOnAxisFalseTraces = t.plot.selectAll(u.clipOnAxisFalseQuery.join(",")).selectAll(".trace")), y.length)) {
                        var M = t.plot.selectAll(y.join(",")).selectAll(".trace");
                        t.zoomScalePts = M.selectAll("path.point"), t.zoomScaleTxt = M.selectAll(".textpoint");
                    }
                }
                function v(e, t) {
                    var r = t.plotgroup, n = t.id, a = u.layerValue2layerClass[t.xaxis.layer], i = u.layerValue2layerClass[t.yaxis.layer], o = e._fullLayout._hasOnlyLargeSploms;
                    if (t.mainplot) {
                        var l = t.mainplotinfo, s = l.plotgroup, f = n + "-x", p = n + "-y";
                        t.minorGridlayer = l.minorGridlayer, t.gridlayer = l.gridlayer, t.zerolinelayer = l.zerolinelayer, d(l.overlinesBelow, "path", f), d(l.overlinesBelow, "path", p), d(l.overaxesBelow, "g", f), d(l.overaxesBelow, "g", p), t.plot = d(l.overplot, "g", n), d(l.overlinesAbove, "path", f), d(l.overlinesAbove, "path", p), d(l.overaxesAbove, "g", f), d(l.overaxesAbove, "g", p), t.xlines = s.select(".overlines-" + a).select("." + f), t.ylines = s.select(".overlines-" + i).select("." + p), t.xaxislayer = s.select(".overaxes-" + a).select("." + f), t.yaxislayer = s.select(".overaxes-" + i).select("." + p);
                    } else if (o) t.xlines = d(r, "path", "xlines-above"), t.ylines = d(r, "path", "ylines-above"), t.xaxislayer = d(r, "g", "xaxislayer-above"), t.yaxislayer = d(r, "g", "yaxislayer-above");
                    else {
                        var v = d(r, "g", "layer-subplot");
                        t.shapelayer = d(v, "g", "shapelayer"), t.imagelayer = d(v, "g", "imagelayer"), t.minorGridlayer = d(r, "g", "minor-gridlayer"), t.gridlayer = d(r, "g", "gridlayer"), t.zerolinelayer = d(r, "g", "zerolinelayer"), d(r, "path", "xlines-below"), d(r, "path", "ylines-below"), t.overlinesBelow = d(r, "g", "overlines-below"), d(r, "g", "xaxislayer-below"), d(r, "g", "yaxislayer-below"), t.overaxesBelow = d(r, "g", "overaxes-below"), t.plot = d(r, "g", "plot"), t.overplot = d(r, "g", "overplot"), t.xlines = d(r, "path", "xlines-above"), t.ylines = d(r, "path", "ylines-above"), t.overlinesAbove = d(r, "g", "overlines-above"), d(r, "g", "xaxislayer-above"), d(r, "g", "yaxislayer-above"), t.overaxesAbove = d(r, "g", "overaxes-above"), t.xlines = r.select(".xlines-" + a), t.ylines = r.select(".ylines-" + i), t.xaxislayer = r.select(".xaxislayer-" + a), t.yaxislayer = r.select(".yaxislayer-" + i);
                    }
                    o || (h(t.minorGridlayer, "g", t.xaxis._id), h(t.minorGridlayer, "g", t.yaxis._id), t.minorGridlayer.selectAll("g").map(function(e) {
                        return e[0];
                    }).sort(c.idSort), h(t.gridlayer, "g", t.xaxis._id), h(t.gridlayer, "g", t.yaxis._id), t.gridlayer.selectAll("g").map(function(e) {
                        return e[0];
                    }).sort(c.idSort)), t.xlines.style("fill", "none").classed("crisp", !0), t.ylines.style("fill", "none").classed("crisp", !0);
                }
                function g(e, t) {
                    if (e) {
                        var r = {};
                        for(var a in e.each(function(e) {
                            var a = e[0];
                            n.select(this).remove(), y(a, t), r[a] = !0;
                        }), t._plots)for(var i = t._plots[a].overlays || [], o = 0; o < i.length; o++){
                            var l = i[o];
                            r[l.id] && l.plot.selectAll(".trace").remove();
                        }
                    }
                }
                function y(e, t) {
                    t._draggers.selectAll("g." + e).remove(), t._defs.select("#clip" + t._uid + e + "plot").remove();
                }
                t.name = "cartesian", t.attr = [
                    "xaxis",
                    "yaxis"
                ], t.idRoot = [
                    "x",
                    "y"
                ], t.idRegex = u.idRegex, t.attrRegex = u.attrRegex, t.attributes = r(9502), t.layoutAttributes = r(3838), t.supplyLayoutDefaults = r(6763), t.transitionAxes = r(6847), t.finalizeSubplots = function(e, t) {
                    var r, n, a, o = t._subplots, l = o.xaxis, s = o.yaxis, f = o.cartesian, d = f.concat(o.gl2d || []), h = {}, p = {};
                    for(r = 0; r < d.length; r++){
                        var v = d[r].split("y");
                        h[v[0]] = 1, p["y" + v[1]] = 1;
                    }
                    for(r = 0; r < l.length; r++)h[n = l[r]] || (a = (e[c.id2name(n)] || {}).anchor, u.idRegex.y.test(a) || (a = "y"), f.push(n + a), d.push(n + a), p[a] || (p[a] = 1, i.pushUnique(s, a)));
                    for(r = 0; r < s.length; r++)p[a = s[r]] || (n = (e[c.id2name(a)] || {}).anchor, u.idRegex.x.test(n) || (n = "x"), f.push(n + a), d.push(n + a), h[n] || (h[n] = 1, i.pushUnique(l, n)));
                    if (!d.length) {
                        for(var g in n = "", a = "", e)u.attrRegex.test(g) && ("x" === g.charAt(0) ? (!n || +g.substr(5) < +n.substr(5)) && (n = g) : (!a || +g.substr(5) < +a.substr(5)) && (a = g));
                        n = n ? c.name2id(n) : "x", a = a ? c.name2id(a) : "y", l.push(n), s.push(a), f.push(n + a);
                    }
                }, t.plot = function(e, t, r, n) {
                    var a, i = e._fullLayout, o = i._subplots.cartesian, l = e.calcdata;
                    if (!Array.isArray(t)) for(t = [], a = 0; a < l.length; a++)t.push(a);
                    for(a = 0; a < o.length; a++){
                        for(var s, c = o[a], u = i._plots[c], f = [], d = 0; d < l.length; d++){
                            var h = l[d], v = h[0].trace;
                            v.xaxis + v.yaxis === c && ((-1 !== t.indexOf(v.index) || v.carpet) && (s && s[0].trace.xaxis + s[0].trace.yaxis === c && -1 !== [
                                "tonextx",
                                "tonexty",
                                "tonext"
                            ].indexOf(v.fill) && -1 === f.indexOf(s) && f.push(s), f.push(h)), s = h);
                        }
                        p(e, u, f, r, n);
                    }
                }, t.clean = function(e, t, r, n) {
                    var a, i, o, l = n._plots || {}, s = t._plots || {}, u = n._subplots || {};
                    if (n._hasOnlyLargeSploms && !t._hasOnlyLargeSploms) for(o in l)(a = l[o]).plotgroup && a.plotgroup.remove();
                    var f = n._has && n._has("gl"), d = t._has && t._has("gl");
                    if (f && !d) for(o in l)(a = l[o])._scene && a._scene.destroy();
                    if (u.xaxis && u.yaxis) {
                        var h = c.listIds({
                            _fullLayout: n
                        });
                        for(i = 0; i < h.length; i++){
                            var p = h[i];
                            t[c.id2name(p)] || n._infolayer.selectAll(".g-" + p + "title").remove();
                        }
                    }
                    var v = n._has && n._has("cartesian"), m = t._has && t._has("cartesian");
                    if (v && !m) g(n._cartesianlayer.selectAll(".subplot"), n), n._defs.selectAll(".axesclip").remove(), delete n._axisConstraintGroups, delete n._axisMatchGroups;
                    else if (u.cartesian) for(i = 0; i < u.cartesian.length; i++){
                        var x = u.cartesian[i];
                        if (!s[x]) {
                            var b = "." + x + ",." + x + "-x,." + x + "-y";
                            n._cartesianlayer.selectAll(b).remove(), y(x, n);
                        }
                    }
                }, t.drawFramework = function(e) {
                    var t = e._fullLayout, r = function(e) {
                        var t, r, n, a, i, o, l = e._fullLayout, s = l._subplots.cartesian, c = s.length, u = [], f = [];
                        for(t = 0; t < c; t++){
                            n = s[t], i = (a = l._plots[n]).xaxis, o = a.yaxis;
                            var d = i._mainAxis, h = o._mainAxis, p = d._id + h._id, v = l._plots[p];
                            a.overlays = [], p !== n && v ? (a.mainplot = p, a.mainplotinfo = v, f.push(n)) : (a.mainplot = void 0, a.mainplotinfo = void 0, u.push(n));
                        }
                        for(t = 0; t < f.length; t++)n = f[t], (a = l._plots[n]).mainplotinfo.overlays.push(a);
                        var g = u.concat(f), y = new Array(c);
                        for(t = 0; t < c; t++){
                            n = g[t], i = (a = l._plots[n]).xaxis, o = a.yaxis;
                            var m = [
                                n,
                                i.layer,
                                o.layer,
                                i.overlaying || "",
                                o.overlaying || ""
                            ];
                            for(r = 0; r < a.overlays.length; r++)m.push(a.overlays[r].id);
                            y[t] = m;
                        }
                        return y;
                    }(e), a = t._cartesianlayer.selectAll(".subplot").data(r, String);
                    a.enter().append("g").attr("class", function(e) {
                        return "subplot " + e[0];
                    }), a.order(), a.exit().call(g, t), a.each(function(r) {
                        var a = r[0], i = t._plots[a];
                        i.plotgroup = n.select(this), v(e, i), i.draglayer = d(t._draggers, "g", a);
                    });
                }, t.rangePlot = function(e, t, r) {
                    v(e, t), p(e, t, r), o.style(e);
                }, t.toSVG = function(e) {
                    var t = e._fullLayout._glimages, r = n.select(e).selectAll(".svg-container");
                    r.filter(function(e, t) {
                        return t === r.size() - 1;
                    }).selectAll(".gl-canvas-context, .gl-canvas-focus").each(function() {
                        var e = this, r = e.toDataURL("image/png");
                        t.append("svg:image").attr({
                            xmlns: f.svg,
                            "xlink:href": r,
                            preserveAspectRatio: "none",
                            x: 0,
                            y: 0,
                            width: e.style.width,
                            height: e.style.height
                        });
                    });
                }, t.updateFx = r(4305).updateFx;
            },
            3838: function(e, t, r) {
                "use strict";
                var n = r(1940), a = r(2399), i = r(9952).P, o = r(1426).extendFlat, l = r(4467).templatedArray, s = r(2663).descriptionWithDates, c = r(606).ONEDAY, u = r(5555), f = u.HOUR_PATTERN, d = u.WEEKDAY_PATTERN, h = {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "linear",
                        "array"
                    ],
                    editType: "ticks",
                    impliedEdits: {
                        tick0: void 0,
                        dtick: void 0
                    }
                }, p = o({}, h, {
                    values: h.values.slice().concat([
                        "sync"
                    ])
                });
                function v(e) {
                    return {
                        valType: "integer",
                        min: 0,
                        dflt: e ? 5 : 0,
                        editType: "ticks"
                    };
                }
                var g = {
                    valType: "any",
                    editType: "ticks",
                    impliedEdits: {
                        tickmode: "linear"
                    }
                }, y = {
                    valType: "any",
                    editType: "ticks",
                    impliedEdits: {
                        tickmode: "linear"
                    }
                }, m = {
                    valType: "data_array",
                    editType: "ticks"
                }, x = {
                    valType: "enumerated",
                    values: [
                        "outside",
                        "inside",
                        ""
                    ],
                    editType: "ticks"
                };
                function b(e) {
                    var t = {
                        valType: "number",
                        min: 0,
                        editType: "ticks"
                    };
                    return e || (t.dflt = 5), t;
                }
                function _(e) {
                    var t = {
                        valType: "number",
                        min: 0,
                        editType: "ticks"
                    };
                    return e || (t.dflt = 1), t;
                }
                var w = {
                    valType: "color",
                    dflt: a.defaultLine,
                    editType: "ticks"
                }, T = {
                    valType: "color",
                    dflt: a.lightLine,
                    editType: "ticks"
                };
                function M(e) {
                    var t = {
                        valType: "number",
                        min: 0,
                        editType: "ticks"
                    };
                    return e || (t.dflt = 1), t;
                }
                var k = o({}, i, {
                    editType: "ticks"
                }), A = {
                    valType: "boolean",
                    editType: "ticks"
                };
                e.exports = {
                    visible: {
                        valType: "boolean",
                        editType: "plot"
                    },
                    color: {
                        valType: "color",
                        dflt: a.defaultLine,
                        editType: "ticks"
                    },
                    title: {
                        text: {
                            valType: "string",
                            editType: "ticks"
                        },
                        font: n({
                            editType: "ticks"
                        }),
                        standoff: {
                            valType: "number",
                            min: 0,
                            editType: "ticks"
                        },
                        editType: "ticks"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "-",
                            "linear",
                            "log",
                            "date",
                            "category",
                            "multicategory"
                        ],
                        dflt: "-",
                        editType: "calc",
                        _noTemplating: !0
                    },
                    autotypenumbers: {
                        valType: "enumerated",
                        values: [
                            "convert types",
                            "strict"
                        ],
                        dflt: "convert types",
                        editType: "calc"
                    },
                    autorange: {
                        valType: "enumerated",
                        values: [
                            !0,
                            !1,
                            "reversed",
                            "min reversed",
                            "max reversed",
                            "min",
                            "max"
                        ],
                        dflt: !0,
                        editType: "axrange",
                        impliedEdits: {
                            "range[0]": void 0,
                            "range[1]": void 0
                        }
                    },
                    autorangeoptions: {
                        minallowed: {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "range[0]": void 0,
                                "range[1]": void 0
                            }
                        },
                        maxallowed: {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "range[0]": void 0,
                                "range[1]": void 0
                            }
                        },
                        clipmin: {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "range[0]": void 0,
                                "range[1]": void 0
                            }
                        },
                        clipmax: {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "range[0]": void 0,
                                "range[1]": void 0
                            }
                        },
                        include: {
                            valType: "any",
                            arrayOk: !0,
                            editType: "plot",
                            impliedEdits: {
                                "range[0]": void 0,
                                "range[1]": void 0
                            }
                        },
                        editType: "plot"
                    },
                    rangemode: {
                        valType: "enumerated",
                        values: [
                            "normal",
                            "tozero",
                            "nonnegative"
                        ],
                        dflt: "normal",
                        editType: "plot"
                    },
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "axrange",
                                impliedEdits: {
                                    "^autorange": !1
                                },
                                anim: !0
                            },
                            {
                                valType: "any",
                                editType: "axrange",
                                impliedEdits: {
                                    "^autorange": !1
                                },
                                anim: !0
                            }
                        ],
                        editType: "axrange",
                        impliedEdits: {
                            autorange: !1
                        },
                        anim: !0
                    },
                    minallowed: {
                        valType: "any",
                        editType: "plot",
                        impliedEdits: {
                            "^autorange": !1
                        }
                    },
                    maxallowed: {
                        valType: "any",
                        editType: "plot",
                        impliedEdits: {
                            "^autorange": !1
                        }
                    },
                    fixedrange: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    scaleanchor: {
                        valType: "enumerated",
                        values: [
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString(),
                            !1
                        ],
                        editType: "plot"
                    },
                    scaleratio: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "plot"
                    },
                    constrain: {
                        valType: "enumerated",
                        values: [
                            "range",
                            "domain"
                        ],
                        editType: "plot"
                    },
                    constraintoward: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        editType: "plot"
                    },
                    matches: {
                        valType: "enumerated",
                        values: [
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString()
                        ],
                        editType: "calc"
                    },
                    rangebreaks: l("rangebreak", {
                        enabled: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        },
                        bounds: {
                            valType: "info_array",
                            items: [
                                {
                                    valType: "any",
                                    editType: "calc"
                                },
                                {
                                    valType: "any",
                                    editType: "calc"
                                }
                            ],
                            editType: "calc"
                        },
                        pattern: {
                            valType: "enumerated",
                            values: [
                                d,
                                f,
                                ""
                            ],
                            editType: "calc"
                        },
                        values: {
                            valType: "info_array",
                            freeLength: !0,
                            editType: "calc",
                            items: {
                                valType: "any",
                                editType: "calc"
                            }
                        },
                        dvalue: {
                            valType: "number",
                            editType: "calc",
                            min: 0,
                            dflt: c
                        },
                        editType: "calc"
                    }),
                    tickmode: p,
                    nticks: v(),
                    tick0: g,
                    dtick: y,
                    ticklabelstep: {
                        valType: "integer",
                        min: 1,
                        dflt: 1,
                        editType: "ticks"
                    },
                    tickvals: m,
                    ticktext: {
                        valType: "data_array",
                        editType: "ticks"
                    },
                    ticks: x,
                    tickson: {
                        valType: "enumerated",
                        values: [
                            "labels",
                            "boundaries"
                        ],
                        dflt: "labels",
                        editType: "ticks"
                    },
                    ticklabelmode: {
                        valType: "enumerated",
                        values: [
                            "instant",
                            "period"
                        ],
                        dflt: "instant",
                        editType: "ticks"
                    },
                    ticklabelposition: {
                        valType: "enumerated",
                        values: [
                            "outside",
                            "inside",
                            "outside top",
                            "inside top",
                            "outside left",
                            "inside left",
                            "outside right",
                            "inside right",
                            "outside bottom",
                            "inside bottom"
                        ],
                        dflt: "outside",
                        editType: "calc"
                    },
                    ticklabeloverflow: {
                        valType: "enumerated",
                        values: [
                            "allow",
                            "hide past div",
                            "hide past domain"
                        ],
                        editType: "calc"
                    },
                    mirror: {
                        valType: "enumerated",
                        values: [
                            !0,
                            "ticks",
                            !1,
                            "all",
                            "allticks"
                        ],
                        dflt: !1,
                        editType: "ticks+layoutstyle"
                    },
                    ticklen: b(),
                    tickwidth: _(),
                    tickcolor: w,
                    showticklabels: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "ticks"
                    },
                    labelalias: {
                        valType: "any",
                        dflt: !1,
                        editType: "ticks"
                    },
                    automargin: {
                        valType: "flaglist",
                        flags: [
                            "height",
                            "width",
                            "left",
                            "right",
                            "top",
                            "bottom"
                        ],
                        extras: [
                            !0,
                            !1
                        ],
                        dflt: !1,
                        editType: "ticks"
                    },
                    showspikes: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "modebar"
                    },
                    spikecolor: {
                        valType: "color",
                        dflt: null,
                        editType: "none"
                    },
                    spikethickness: {
                        valType: "number",
                        dflt: 3,
                        editType: "none"
                    },
                    spikedash: o({}, i, {
                        dflt: "dash",
                        editType: "none"
                    }),
                    spikemode: {
                        valType: "flaglist",
                        flags: [
                            "toaxis",
                            "across",
                            "marker"
                        ],
                        dflt: "toaxis",
                        editType: "none"
                    },
                    spikesnap: {
                        valType: "enumerated",
                        values: [
                            "data",
                            "cursor",
                            "hovered data"
                        ],
                        dflt: "hovered data",
                        editType: "none"
                    },
                    tickfont: n({
                        editType: "ticks"
                    }),
                    tickangle: {
                        valType: "angle",
                        dflt: "auto",
                        editType: "ticks"
                    },
                    tickprefix: {
                        valType: "string",
                        dflt: "",
                        editType: "ticks"
                    },
                    showtickprefix: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "ticks"
                    },
                    ticksuffix: {
                        valType: "string",
                        dflt: "",
                        editType: "ticks"
                    },
                    showticksuffix: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "ticks"
                    },
                    showexponent: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "ticks"
                    },
                    exponentformat: {
                        valType: "enumerated",
                        values: [
                            "none",
                            "e",
                            "E",
                            "power",
                            "SI",
                            "B"
                        ],
                        dflt: "B",
                        editType: "ticks"
                    },
                    minexponent: {
                        valType: "number",
                        dflt: 3,
                        min: 0,
                        editType: "ticks"
                    },
                    separatethousands: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "ticks"
                    },
                    tickformat: {
                        valType: "string",
                        dflt: "",
                        editType: "ticks",
                        description: s("tick label")
                    },
                    tickformatstops: l("tickformatstop", {
                        enabled: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "ticks"
                        },
                        dtickrange: {
                            valType: "info_array",
                            items: [
                                {
                                    valType: "any",
                                    editType: "ticks"
                                },
                                {
                                    valType: "any",
                                    editType: "ticks"
                                }
                            ],
                            editType: "ticks"
                        },
                        value: {
                            valType: "string",
                            dflt: "",
                            editType: "ticks"
                        },
                        editType: "ticks"
                    }),
                    hoverformat: {
                        valType: "string",
                        dflt: "",
                        editType: "none",
                        description: s("hover text")
                    },
                    showline: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "ticks+layoutstyle"
                    },
                    linecolor: {
                        valType: "color",
                        dflt: a.defaultLine,
                        editType: "layoutstyle"
                    },
                    linewidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "ticks+layoutstyle"
                    },
                    showgrid: A,
                    gridcolor: T,
                    gridwidth: M(),
                    griddash: k,
                    zeroline: {
                        valType: "boolean",
                        editType: "ticks"
                    },
                    zerolinecolor: {
                        valType: "color",
                        dflt: a.defaultLine,
                        editType: "ticks"
                    },
                    zerolinewidth: {
                        valType: "number",
                        dflt: 1,
                        editType: "ticks"
                    },
                    showdividers: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "ticks"
                    },
                    dividercolor: {
                        valType: "color",
                        dflt: a.defaultLine,
                        editType: "ticks"
                    },
                    dividerwidth: {
                        valType: "number",
                        dflt: 1,
                        editType: "ticks"
                    },
                    anchor: {
                        valType: "enumerated",
                        values: [
                            "free",
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString()
                        ],
                        editType: "plot"
                    },
                    side: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "bottom",
                            "left",
                            "right"
                        ],
                        editType: "plot"
                    },
                    overlaying: {
                        valType: "enumerated",
                        values: [
                            "free",
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString()
                        ],
                        editType: "plot"
                    },
                    minor: {
                        tickmode: h,
                        nticks: v("minor"),
                        tick0: g,
                        dtick: y,
                        tickvals: m,
                        ticks: x,
                        ticklen: b("minor"),
                        tickwidth: _("minor"),
                        tickcolor: w,
                        gridcolor: T,
                        gridwidth: M("minor"),
                        griddash: k,
                        showgrid: A,
                        editType: "ticks"
                    },
                    layer: {
                        valType: "enumerated",
                        values: [
                            "above traces",
                            "below traces"
                        ],
                        dflt: "above traces",
                        editType: "plot"
                    },
                    domain: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "plot"
                            },
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "plot"
                            }
                        ],
                        dflt: [
                            0,
                            1
                        ],
                        editType: "plot"
                    },
                    position: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "plot"
                    },
                    autoshift: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    shift: {
                        valType: "number",
                        editType: "plot"
                    },
                    categoryorder: {
                        valType: "enumerated",
                        values: [
                            "trace",
                            "category ascending",
                            "category descending",
                            "array",
                            "total ascending",
                            "total descending",
                            "min ascending",
                            "min descending",
                            "max ascending",
                            "max descending",
                            "sum ascending",
                            "sum descending",
                            "mean ascending",
                            "mean descending",
                            "median ascending",
                            "median descending"
                        ],
                        dflt: "trace",
                        editType: "calc"
                    },
                    categoryarray: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editType: "calc",
                    _deprecated: {
                        autotick: {
                            valType: "boolean",
                            editType: "ticks"
                        },
                        title: {
                            valType: "string",
                            editType: "ticks"
                        },
                        titlefont: n({
                            editType: "ticks"
                        })
                    }
                };
            },
            6763: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(7901), i = r(3469).isUnifiedHover, o = r(8212), l = r(4467), s = r(820), c = r(3838), u = r(951), f = r(1453), d = r(9082), h = r(2830), p = r(1675), v = p.id2name, g = p.name2id, y = r(5555).AX_ID_PATTERN, m = r(3972), x = m.traceIs, b = m.getComponentMethod;
                function _(e, t, r) {
                    Array.isArray(e[t]) ? e[t].push(r) : e[t] = [
                        r
                    ];
                }
                e.exports = function(e, t, r) {
                    var m, w, T = t.autotypenumbers, M = {}, k = {}, A = {}, L = {}, S = {}, D = {}, O = {}, C = {}, P = {}, I = {};
                    for(m = 0; m < r.length; m++){
                        var R = r[m];
                        if (x(R, "cartesian") || x(R, "gl2d")) {
                            var z, N;
                            if (R.xaxis) z = v(R.xaxis), _(M, z, R);
                            else if (R.xaxes) for(w = 0; w < R.xaxes.length; w++)_(M, v(R.xaxes[w]), R);
                            if (R.yaxis) N = v(R.yaxis), _(M, N, R);
                            else if (R.yaxes) for(w = 0; w < R.yaxes.length; w++)_(M, v(R.yaxes[w]), R);
                            "funnel" === R.type ? "h" === R.orientation ? (z && (k[z] = !0), N && (O[N] = !0)) : N && (A[N] = !0) : "image" === R.type ? (N && (C[N] = !0), z && (C[z] = !0)) : (N && (S[N] = !0, D[N] = !0), x(R, "carpet") && ("carpet" !== R.type || R._cheater) || z && (L[z] = !0)), "carpet" === R.type && R._cheater && z && (k[z] = !0), x(R, "2dMap") && (P[z] = !0, P[N] = !0), x(R, "oriented") && (I["h" === R.orientation ? N : z] = !0);
                        }
                    }
                    var F = t._subplots, E = F.xaxis, H = F.yaxis, j = n.simpleMap(E, v), B = n.simpleMap(H, v), Y = j.concat(B), V = a.background;
                    E.length && H.length && (V = n.coerce(e, t, s, "plot_bgcolor"));
                    var U, q, G, Z, W, X = a.combine(V, t.paper_bgcolor);
                    function J() {
                        var e = M[U] || [];
                        W._traceIndices = e.map(function(e) {
                            return e._expandedIndex;
                        }), W._annIndices = [], W._shapeIndices = [], W._selectionIndices = [], W._imgIndices = [], W._subplotsWith = [], W._counterAxes = [], W._name = W._attr = U, W._id = q;
                    }
                    function K(e, t) {
                        return n.coerce(Z, W, c, e, t);
                    }
                    function Q(e, t) {
                        return n.coerce2(Z, W, c, e, t);
                    }
                    function $(e) {
                        return "x" === e ? H : E;
                    }
                    function ee(t, r) {
                        for(var n = "x" === t ? j : B, a = [], i = 0; i < n.length; i++){
                            var o = n[i];
                            o === r || (e[o] || {}).overlaying || a.push(g(o));
                        }
                        return a;
                    }
                    var te = {
                        x: $("x"),
                        y: $("y")
                    }, re = te.x.concat(te.y), ne = {}, ae = [];
                    function ie() {
                        var e = Z.matches;
                        y.test(e) && -1 === re.indexOf(e) && (ne[e] = Z.type, ae = Object.keys(ne));
                    }
                    var oe = o(e, t), le = i(oe);
                    for(m = 0; m < Y.length; m++){
                        U = Y[m], q = g(U), G = U.charAt(0), n.isPlainObject(e[U]) || (e[U] = {}), Z = e[U], W = l.newContainer(t, U, G + "axis"), J();
                        var se = "x" === G && !L[U] && k[U] || "y" === G && !S[U] && A[U], ce = "y" === G && (!D[U] && O[U] || C[U]), ue = {
                            hasMinor: !0,
                            letter: G,
                            font: t.font,
                            outerTicks: P[U],
                            showGrid: !I[U],
                            data: M[U] || [],
                            bgColor: X,
                            calendar: t.calendar,
                            automargin: !0,
                            visibleDflt: se,
                            reverseDflt: ce,
                            autotypenumbersDflt: T,
                            splomStash: ((t._splomAxes || {})[G] || {})[q]
                        };
                        K("uirevision", t.uirevision), u(Z, W, K, ue), f(Z, W, K, ue, t);
                        var fe = le && G === oe.charAt(0), de = Q("spikecolor", le ? W.color : void 0), he = Q("spikethickness", le ? 1.5 : void 0), pe = Q("spikedash", le ? "dot" : void 0), ve = Q("spikemode", le ? "across" : void 0), ge = Q("spikesnap");
                        K("showspikes", !!(fe || de || he || pe || ve || ge)) || (delete W.spikecolor, delete W.spikethickness, delete W.spikedash, delete W.spikemode, delete W.spikesnap);
                        var ye = v(Z.overlaying), me = [
                            0,
                            1
                        ];
                        if (void 0 !== t[ye]) {
                            var xe = v(t[ye].anchor);
                            void 0 !== t[xe] && (me = t[xe].domain);
                        }
                        h(Z, W, K, {
                            letter: G,
                            counterAxes: te[G],
                            overlayableAxes: ee(G, U),
                            grid: t.grid,
                            overlayingDomain: me
                        }), K("title.standoff"), ie(), W._input = Z;
                    }
                    for(m = 0; m < ae.length;){
                        q = ae[m++], G = (U = v(q)).charAt(0), n.isPlainObject(e[U]) || (e[U] = {}), Z = e[U], W = l.newContainer(t, U, G + "axis"), J();
                        var be = {
                            letter: G,
                            font: t.font,
                            outerTicks: P[U],
                            showGrid: !I[U],
                            data: [],
                            bgColor: X,
                            calendar: t.calendar,
                            automargin: !0,
                            visibleDflt: !1,
                            reverseDflt: !1,
                            autotypenumbersDflt: T,
                            splomStash: ((t._splomAxes || {})[G] || {})[q]
                        };
                        K("uirevision", t.uirevision), W.type = ne[q] || "linear", f(Z, W, K, be, t), h(Z, W, K, {
                            letter: G,
                            counterAxes: te[G],
                            overlayableAxes: ee(G, U),
                            grid: t.grid
                        }), K("fixedrange"), ie(), W._input = Z;
                    }
                    var _e = b("rangeslider", "handleDefaults"), we = b("rangeselector", "handleDefaults");
                    for(m = 0; m < j.length; m++)U = j[m], Z = e[U], W = t[U], _e(e, t, U), "date" === W.type && we(Z, W, t, B, W.calendar), K("fixedrange");
                    for(m = 0; m < B.length; m++){
                        U = B[m], Z = e[U], W = t[U];
                        var Te = t[v(W.anchor)];
                        K("fixedrange", b("rangeslider", "isVisible")(Te));
                    }
                    d.handleDefaults(e, t, {
                        axIds: re.concat(ae).sort(p.idSort),
                        axHasImage: C
                    });
                };
            },
            2128: function(e, t, r) {
                "use strict";
                var n = r(4267).mix, a = r(2399), i = r(1828);
                e.exports = function(e, t, r, o) {
                    var l = (o = o || {}).dfltColor;
                    function s(r, n) {
                        return i.coerce2(e, t, o.attributes, r, n);
                    }
                    var c = s("linecolor", l), u = s("linewidth");
                    r("showline", o.showLine || !!c || !!u) || (delete t.linecolor, delete t.linewidth);
                    var f = s("gridcolor", n(l, o.bgColor, o.blend || a.lightFraction).toRgbString()), d = s("gridwidth"), h = s("griddash");
                    if (r("showgrid", o.showGrid || !!f || !!d || !!h) || (delete t.gridcolor, delete t.gridwidth, delete t.griddash), o.hasMinor) {
                        var p = s("minor.gridcolor", n(t.gridcolor, o.bgColor, 67).toRgbString()), v = s("minor.gridwidth", t.gridwidth || 1), g = s("minor.griddash", t.griddash || "solid");
                        r("minor.showgrid", !!p || !!v || !!g) || (delete t.minor.gridcolor, delete t.minor.gridwidth, delete t.minor.griddash);
                    }
                    if (!o.noZeroLine) {
                        var y = s("zerolinecolor", l), m = s("zerolinewidth");
                        r("zeroline", o.showGrid || !!y || !!m) || (delete t.zerolinecolor, delete t.zerolinewidth);
                    }
                };
            },
            2830: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(1828);
                e.exports = function(e, t, r, i) {
                    var o, l, s, c, u, f, d = i.counterAxes || [], h = i.overlayableAxes || [], p = i.letter, v = i.grid, g = i.overlayingDomain;
                    v && (l = v._domains[p][v._axisMap[t._id]], o = v._anchors[t._id], l && (s = v[p + "side"].split(" ")[0], c = v.domain[p]["right" === s || "top" === s ? 1 : 0])), l = l || [
                        0,
                        1
                    ], o = o || (n(e.position) ? "free" : d[0] || "free"), s = s || ("x" === p ? "bottom" : "left"), c = c || 0, u = 0, f = !1;
                    var y = a.coerce(e, t, {
                        anchor: {
                            valType: "enumerated",
                            values: [
                                "free"
                            ].concat(d),
                            dflt: o
                        }
                    }, "anchor"), m = a.coerce(e, t, {
                        side: {
                            valType: "enumerated",
                            values: "x" === p ? [
                                "bottom",
                                "top"
                            ] : [
                                "left",
                                "right"
                            ],
                            dflt: s
                        }
                    }, "side");
                    "free" === y && ("y" === p && (r("autoshift") && (c = "left" === m ? g[0] : g[1], f = !t.automargin || t.automargin, u = "left" === m ? -3 : 3), r("shift", u)), r("position", c)), r("automargin", f);
                    var x = !1;
                    if (h.length && (x = a.coerce(e, t, {
                        overlaying: {
                            valType: "enumerated",
                            values: [
                                !1
                            ].concat(h),
                            dflt: !1
                        }
                    }, "overlaying")), !x) {
                        var b = r("domain", l);
                        b[0] > b[1] - 1 / 4096 && (t.domain = l), a.noneOrAll(e.domain, t.domain, l), "sync" === t.tickmode && (t.tickmode = "auto");
                    }
                    return r("layer"), t;
                };
            },
            9426: function(e, t, r) {
                "use strict";
                var n = r(9652);
                e.exports = function(e, t, r, a, i) {
                    i || (i = {});
                    var o = i.tickSuffixDflt, l = n(e);
                    r("tickprefix") && r("showtickprefix", l), r("ticksuffix", o) && r("showticksuffix", l);
                };
            },
            2449: function(e, t, r) {
                "use strict";
                var n = r(8783).FROM_BL;
                e.exports = function(e, t, r) {
                    void 0 === r && (r = n[e.constraintoward || "center"]);
                    var a = [
                        e.r2l(e.range[0]),
                        e.r2l(e.range[1])
                    ], i = a[0] + (a[1] - a[0]) * r;
                    e.range = e._input.range = [
                        e.l2r(i + (a[0] - i) * t),
                        e.l2r(i + (a[1] - i) * t)
                    ], e.setScale();
                };
            },
            1994: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(4096).g0, i = r(1828), o = i.numberFormat, l = r(2770), s = i.cleanNumber, c = i.ms2DateTime, u = i.dateTime2ms, f = i.ensureNumber, d = i.isArrayOrTypedArray, h = r(606), p = h.FP_SAFE, v = h.BADNUM, g = h.LOG_CLIP, y = h.ONEWEEK, m = h.ONEDAY, x = h.ONEHOUR, b = h.ONEMIN, _ = h.ONESEC, w = r(1675), T = r(5555), M = T.HOUR_PATTERN, k = T.WEEKDAY_PATTERN;
                function A(e) {
                    return Math.pow(10, e);
                }
                function L(e) {
                    return null != e;
                }
                e.exports = function(e, t) {
                    t = t || {};
                    var r = e._id || "x", h = r.charAt(0);
                    function S(t, r) {
                        if (t > 0) return Math.log(t) / Math.LN10;
                        if (t <= 0 && r && e.range && 2 === e.range.length) {
                            var n = e.range[0], a = e.range[1];
                            return .5 * (n + a - 2 * g * Math.abs(n - a));
                        }
                        return v;
                    }
                    function D(t, r, n, a) {
                        if ((a || {}).msUTC && l(t)) return +t;
                        var o = u(t, n || e.calendar);
                        if (o === v) {
                            if (!l(t)) return v;
                            t = +t;
                            var s = Math.floor(10 * i.mod(t + .05, 1)), c = Math.round(t - s / 10);
                            o = u(new Date(c)) + s / 10;
                        }
                        return o;
                    }
                    function O(t, r, n) {
                        return c(t, r, n || e.calendar);
                    }
                    function C(t) {
                        return e._categories[Math.round(t)];
                    }
                    function P(t) {
                        if (L(t)) {
                            if (void 0 === e._categoriesMap && (e._categoriesMap = {}), void 0 !== e._categoriesMap[t]) return e._categoriesMap[t];
                            e._categories.push("number" == typeof t ? String(t) : t);
                            var r = e._categories.length - 1;
                            return e._categoriesMap[t] = r, r;
                        }
                        return v;
                    }
                    function I(t) {
                        if (e._categoriesMap) return e._categoriesMap[t];
                    }
                    function R(e) {
                        var t = I(e);
                        return void 0 !== t ? t : l(e) ? +e : void 0;
                    }
                    function z(e) {
                        return l(e) ? +e : I(e);
                    }
                    function N(e, t, r) {
                        return n.round(r + t * e, 2);
                    }
                    function F(e, t, r) {
                        return (e - r) / t;
                    }
                    var E = function(t) {
                        return l(t) ? N(t, e._m, e._b) : v;
                    }, H = function(t) {
                        return F(t, e._m, e._b);
                    };
                    if (e.rangebreaks) {
                        var j = "y" === h;
                        E = function(t) {
                            if (!l(t)) return v;
                            var r = e._rangebreaks.length;
                            if (!r) return N(t, e._m, e._b);
                            var n = j;
                            e.range[0] > e.range[1] && (n = !n);
                            for(var a = n ? -1 : 1, i = a * t, o = 0, s = 0; s < r; s++){
                                var c = a * e._rangebreaks[s].min, u = a * e._rangebreaks[s].max;
                                if (i < c) break;
                                if (!(i > u)) {
                                    o = i < (c + u) / 2 ? s : s + 1;
                                    break;
                                }
                                o = s + 1;
                            }
                            var f = e._B[o] || 0;
                            return isFinite(f) ? N(t, e._m2, f) : 0;
                        }, H = function(t) {
                            var r = e._rangebreaks.length;
                            if (!r) return F(t, e._m, e._b);
                            for(var n = 0, a = 0; a < r && !(t < e._rangebreaks[a].pmin); a++)t > e._rangebreaks[a].pmax && (n = a + 1);
                            return F(t, e._m2, e._B[n]);
                        };
                    }
                    e.c2l = "log" === e.type ? S : f, e.l2c = "log" === e.type ? A : f, e.l2p = E, e.p2l = H, e.c2p = "log" === e.type ? function(e, t) {
                        return E(S(e, t));
                    } : E, e.p2c = "log" === e.type ? function(e) {
                        return A(H(e));
                    } : H, -1 !== [
                        "linear",
                        "-"
                    ].indexOf(e.type) ? (e.d2r = e.r2d = e.d2c = e.r2c = e.d2l = e.r2l = s, e.c2d = e.c2r = e.l2d = e.l2r = f, e.d2p = e.r2p = function(t) {
                        return e.l2p(s(t));
                    }, e.p2d = e.p2r = H, e.cleanPos = f) : "log" === e.type ? (e.d2r = e.d2l = function(e, t) {
                        return S(s(e), t);
                    }, e.r2d = e.r2c = function(e) {
                        return A(s(e));
                    }, e.d2c = e.r2l = s, e.c2d = e.l2r = f, e.c2r = S, e.l2d = A, e.d2p = function(t, r) {
                        return e.l2p(e.d2r(t, r));
                    }, e.p2d = function(e) {
                        return A(H(e));
                    }, e.r2p = function(t) {
                        return e.l2p(s(t));
                    }, e.p2r = H, e.cleanPos = f) : "date" === e.type ? (e.d2r = e.r2d = i.identity, e.d2c = e.r2c = e.d2l = e.r2l = D, e.c2d = e.c2r = e.l2d = e.l2r = O, e.d2p = e.r2p = function(t, r, n) {
                        return e.l2p(D(t, 0, n));
                    }, e.p2d = e.p2r = function(e, t, r) {
                        return O(H(e), t, r);
                    }, e.cleanPos = function(t) {
                        return i.cleanDate(t, v, e.calendar);
                    }) : "category" === e.type ? (e.d2c = e.d2l = P, e.r2d = e.c2d = e.l2d = C, e.d2r = e.d2l_noadd = R, e.r2c = function(t) {
                        var r = z(t);
                        return void 0 !== r ? r : e.fraction2r(.5);
                    }, e.l2r = e.c2r = f, e.r2l = z, e.d2p = function(t) {
                        return e.l2p(e.r2c(t));
                    }, e.p2d = function(e) {
                        return C(H(e));
                    }, e.r2p = e.d2p, e.p2r = H, e.cleanPos = function(e) {
                        return "string" == typeof e && "" !== e ? e : f(e);
                    }) : "multicategory" === e.type && (e.r2d = e.c2d = e.l2d = C, e.d2r = e.d2l_noadd = R, e.r2c = function(t) {
                        var r = R(t);
                        return void 0 !== r ? r : e.fraction2r(.5);
                    }, e.r2c_just_indices = I, e.l2r = e.c2r = f, e.r2l = R, e.d2p = function(t) {
                        return e.l2p(e.r2c(t));
                    }, e.p2d = function(e) {
                        return C(H(e));
                    }, e.r2p = e.d2p, e.p2r = H, e.cleanPos = function(e) {
                        return Array.isArray(e) || "string" == typeof e && "" !== e ? e : f(e);
                    }, e.setupMultiCategory = function(n) {
                        var a, o, l = e._traceIndices, s = e._matchGroup;
                        if (s && 0 === e._categories.length) {
                            for(var c in s)if (c !== r) {
                                var u = t[w.id2name(c)];
                                l = l.concat(u._traceIndices);
                            }
                        }
                        var f = [
                            [
                                0,
                                {}
                            ],
                            [
                                0,
                                {}
                            ]
                        ], p = [];
                        for(a = 0; a < l.length; a++){
                            var v = n[l[a]];
                            if (h in v) {
                                var g = v[h], y = v._length || i.minRowLength(g);
                                if (d(g[0]) && d(g[1])) for(o = 0; o < y; o++){
                                    var m = g[0][o], x = g[1][o];
                                    L(m) && L(x) && (p.push([
                                        m,
                                        x
                                    ]), m in f[0][1] || (f[0][1][m] = f[0][0]++), x in f[1][1] || (f[1][1][x] = f[1][0]++));
                                }
                            }
                        }
                        for(p.sort(function(e, t) {
                            var r = f[0][1], n = r[e[0]] - r[t[0]];
                            if (n) return n;
                            var a = f[1][1];
                            return a[e[1]] - a[t[1]];
                        }), a = 0; a < p.length; a++)P(p[a]);
                    }), e.fraction2r = function(t) {
                        var r = e.r2l(e.range[0]), n = e.r2l(e.range[1]);
                        return e.l2r(r + t * (n - r));
                    }, e.r2fraction = function(t) {
                        var r = e.r2l(e.range[0]), n = e.r2l(e.range[1]);
                        return (e.r2l(t) - r) / (n - r);
                    }, e.limitRange = function(t) {
                        var r = e.minallowed, n = e.maxallowed;
                        if (void 0 !== r || void 0 !== n) {
                            t || (t = "range");
                            var a = i.nestedProperty(e, t).get(), o = i.simpleMap(a, e.r2l), l = o[1] < o[0];
                            l && o.reverse();
                            var s = i.simpleMap([
                                r,
                                n
                            ], e.r2l);
                            void 0 !== r && o[0] < s[0] && (a[l ? 1 : 0] = r), void 0 !== n && o[1] > s[1] && (a[l ? 0 : 1] = n);
                        }
                    }, e.cleanRange = function(t, r) {
                        e._cleanRange(t, r), e.limitRange(t);
                    }, e._cleanRange = function(t, r) {
                        r || (r = {}), t || (t = "range");
                        var n, a, o = i.nestedProperty(e, t).get();
                        if (a = (a = "date" === e.type ? i.dfltRange(e.calendar) : "y" === h ? T.DFLTRANGEY : "realaxis" === e._name ? [
                            0,
                            1
                        ] : r.dfltRange || T.DFLTRANGEX).slice(), "tozero" !== e.rangemode && "nonnegative" !== e.rangemode || (a[0] = 0), o && 2 === o.length) {
                            var s = null === o[0], c = null === o[1];
                            for("date" !== e.type || e.autorange || (o[0] = i.cleanDate(o[0], v, e.calendar), o[1] = i.cleanDate(o[1], v, e.calendar)), n = 0; n < 2; n++)if ("date" === e.type) {
                                if (!i.isDateTime(o[n], e.calendar)) {
                                    e[t] = a;
                                    break;
                                }
                                if (e.r2l(o[0]) === e.r2l(o[1])) {
                                    var u = i.constrain(e.r2l(o[0]), i.MIN_MS + 1e3, i.MAX_MS - 1e3);
                                    o[0] = e.l2r(u - 1e3), o[1] = e.l2r(u + 1e3);
                                    break;
                                }
                            } else {
                                if (!l(o[n])) {
                                    if (s || c || !l(o[1 - n])) {
                                        e[t] = a;
                                        break;
                                    }
                                    o[n] = o[1 - n] * (n ? 10 : .1);
                                }
                                if (o[n] < -p ? o[n] = -p : o[n] > p && (o[n] = p), o[0] === o[1]) {
                                    var f = Math.max(1, Math.abs(1e-6 * o[0]));
                                    o[0] -= f, o[1] += f;
                                }
                            }
                        } else i.nestedProperty(e, t).set(a);
                    }, e.setScale = function(r) {
                        var n = t._size;
                        if (e.overlaying) {
                            var a = w.getFromId({
                                _fullLayout: t
                            }, e.overlaying);
                            e.domain = a.domain;
                        }
                        var i = r && e._r ? "_r" : "range", o = e.calendar;
                        e.cleanRange(i);
                        var l, s, c = e.r2l(e[i][0], o), u = e.r2l(e[i][1], o), f = "y" === h;
                        if (f ? (e._offset = n.t + (1 - e.domain[1]) * n.h, e._length = n.h * (e.domain[1] - e.domain[0]), e._m = e._length / (c - u), e._b = -e._m * u) : (e._offset = n.l + e.domain[0] * n.w, e._length = n.w * (e.domain[1] - e.domain[0]), e._m = e._length / (u - c), e._b = -e._m * c), e._rangebreaks = [], e._lBreaks = 0, e._m2 = 0, e._B = [], e.rangebreaks && (e._rangebreaks = e.locateBreaks(Math.min(c, u), Math.max(c, u)), e._rangebreaks.length)) {
                            for(l = 0; l < e._rangebreaks.length; l++)s = e._rangebreaks[l], e._lBreaks += Math.abs(s.max - s.min);
                            var d = f;
                            c > u && (d = !d), d && e._rangebreaks.reverse();
                            var p = d ? -1 : 1;
                            for(e._m2 = p * e._length / (Math.abs(u - c) - e._lBreaks), e._B.push(-e._m2 * (f ? u : c)), l = 0; l < e._rangebreaks.length; l++)s = e._rangebreaks[l], e._B.push(e._B[e._B.length - 1] - p * e._m2 * (s.max - s.min));
                            for(l = 0; l < e._rangebreaks.length; l++)(s = e._rangebreaks[l]).pmin = E(s.min), s.pmax = E(s.max);
                        }
                        if (!isFinite(e._m) || !isFinite(e._b) || e._length < 0) throw t._replotting = !1, new Error("Something went wrong with axis scaling");
                    }, e.maskBreaks = function(t) {
                        var r, n, a, o, l, c = e.rangebreaks || [];
                        c._cachedPatterns || (c._cachedPatterns = c.map(function(t) {
                            return t.enabled && t.bounds ? i.simpleMap(t.bounds, t.pattern ? s : e.d2c) : null;
                        })), c._cachedValues || (c._cachedValues = c.map(function(t) {
                            return t.enabled && t.values ? i.simpleMap(t.values, e.d2c).sort(i.sorterAsc) : null;
                        }));
                        for(var u = 0; u < c.length; u++){
                            var f = c[u];
                            if (f.enabled) {
                                if (f.bounds) {
                                    var d = f.pattern;
                                    switch(n = (r = c._cachedPatterns[u])[0], a = r[1], d){
                                        case k:
                                            o = (l = new Date(t)).getUTCDay(), n > a && (a += 7, o < n && (o += 7));
                                            break;
                                        case M:
                                            o = (l = new Date(t)).getUTCHours() + (l.getUTCMinutes() / 60 + l.getUTCSeconds() / 3600 + l.getUTCMilliseconds() / 36e5), n > a && (a += 24, o < n && (o += 24));
                                            break;
                                        case "":
                                            o = t;
                                    }
                                    if (o >= n && o < a) return v;
                                } else for(var h = c._cachedValues[u], p = 0; p < h.length; p++)if (a = (n = h[p]) + f.dvalue, t >= n && t < a) return v;
                            }
                        }
                        return t;
                    }, e.locateBreaks = function(t, r) {
                        var n, a, o, l, c = [];
                        if (!e.rangebreaks) return c;
                        var u = e.rangebreaks.slice().sort(function(e, t) {
                            return e.pattern === k && t.pattern === M ? -1 : t.pattern === k && e.pattern === M ? 1 : 0;
                        }), f = function(e, n) {
                            if ((e = i.constrain(e, t, r)) !== (n = i.constrain(n, t, r))) {
                                for(var a = !0, o = 0; o < c.length; o++){
                                    var l = c[o];
                                    e < l.max && n >= l.min && (e < l.min && (l.min = e), n > l.max && (l.max = n), a = !1);
                                }
                                a && c.push({
                                    min: e,
                                    max: n
                                });
                            }
                        };
                        for(n = 0; n < u.length; n++){
                            var d = u[n];
                            if (d.enabled) {
                                if (d.bounds) {
                                    var h = t, p = r;
                                    d.pattern && (h = Math.floor(h)), o = (a = i.simpleMap(d.bounds, d.pattern ? s : e.r2l))[0], l = a[1];
                                    var v, g, w = new Date(h);
                                    switch(d.pattern){
                                        case k:
                                            g = y, v = (l - o + (l < o ? 7 : 0)) * m, h += o * m - (w.getUTCDay() * m + w.getUTCHours() * x + w.getUTCMinutes() * b + w.getUTCSeconds() * _ + w.getUTCMilliseconds());
                                            break;
                                        case M:
                                            g = m, v = (l - o + (l < o ? 24 : 0)) * x, h += o * x - (w.getUTCHours() * x + w.getUTCMinutes() * b + w.getUTCSeconds() * _ + w.getUTCMilliseconds());
                                            break;
                                        default:
                                            h = Math.min(a[0], a[1]), v = g = (p = Math.max(a[0], a[1])) - h;
                                    }
                                    for(var T = h; T < p; T += g)f(T, T + v);
                                } else for(var A = i.simpleMap(d.values, e.d2c), L = 0; L < A.length; L++)f(o = A[L], l = o + d.dvalue);
                            }
                        }
                        return c.sort(function(e, t) {
                            return e.min - t.min;
                        }), c;
                    }, e.makeCalcdata = function(t, r, n) {
                        var a, o, l, s, c = e.type, u = "date" === c && t[r + "calendar"];
                        if (r in t) {
                            if (a = t[r], s = t._length || i.minRowLength(a), i.isTypedArray(a) && ("linear" === c || "log" === c)) {
                                if (s === a.length) return a;
                                if (a.subarray) return a.subarray(0, s);
                            }
                            if ("multicategory" === c) return function(e, t) {
                                for(var r = new Array(t), n = 0; n < t; n++){
                                    var a = (e[0] || [])[n], i = (e[1] || [])[n];
                                    r[n] = I([
                                        a,
                                        i
                                    ]);
                                }
                                return r;
                            }(a, s);
                            for(o = new Array(s), l = 0; l < s; l++)o[l] = e.d2c(a[l], 0, u, n);
                        } else {
                            var f = r + "0" in t ? e.d2c(t[r + "0"], 0, u) : 0, d = t["d" + r] ? Number(t["d" + r]) : 1;
                            for(a = t[({
                                x: "y",
                                y: "x"
                            })[r]], s = t._length || a.length, o = new Array(s), l = 0; l < s; l++)o[l] = f + l * d;
                        }
                        if (e.rangebreaks) for(l = 0; l < s; l++)o[l] = e.maskBreaks(o[l]);
                        return o;
                    }, e.isValidRange = function(t, r) {
                        return Array.isArray(t) && 2 === t.length && (r && null === t[0] || l(e.r2l(t[0]))) && (r && null === t[1] || l(e.r2l(t[1])));
                    }, e.getAutorangeDflt = function(t, r) {
                        var n = !e.isValidRange(t, "nullOk");
                        return n && r && r.reverseDflt ? n = "reversed" : t && (null === t[0] && null === t[1] ? n = !0 : null === t[0] && null !== t[1] ? n = "min" : null !== t[0] && null === t[1] && (n = "max")), n;
                    }, e.isReversed = function() {
                        var t = e.autorange;
                        return "reversed" === t || "min reversed" === t || "max reversed" === t;
                    }, e.isPtWithinRange = function(t, r) {
                        var n = e.c2l(t[h], null, r), a = e.r2l(e.range[0]), i = e.r2l(e.range[1]);
                        return a < i ? a <= n && n <= i : i <= n && n <= a;
                    }, e._emptyCategories = function() {
                        e._categories = [], e._categoriesMap = {};
                    }, e.clearCalc = function() {
                        var r = e._matchGroup;
                        if (r) {
                            var n = null, a = null;
                            for(var i in r){
                                var o = t[w.id2name(i)];
                                if (o._categories) {
                                    n = o._categories, a = o._categoriesMap;
                                    break;
                                }
                            }
                            n && a ? (e._categories = n, e._categoriesMap = a) : e._emptyCategories();
                        } else e._emptyCategories();
                        if (e._initialCategories) for(var l = 0; l < e._initialCategories.length; l++)P(e._initialCategories[l]);
                    }, e.sortByInitialCategories = function() {
                        var n = [];
                        if (e._emptyCategories(), e._initialCategories) for(var a = 0; a < e._initialCategories.length; a++)P(e._initialCategories[a]);
                        n = n.concat(e._traceIndices);
                        var i = e._matchGroup;
                        for(var o in i)if (r !== o) {
                            var l = t[w.id2name(o)];
                            l._categories = e._categories, l._categoriesMap = e._categoriesMap, n = n.concat(l._traceIndices);
                        }
                        return n;
                    };
                    var B = t._d3locale;
                    "date" === e.type && (e._dateFormat = B ? B.timeFormat : a, e._extraFormat = t._extraFormat), e._separators = t.separators, e._numFormat = B ? B.numberFormat : o, delete e._minDtick, delete e._forceTick0;
                };
            },
            9652: function(e) {
                "use strict";
                e.exports = function(e) {
                    var t = [
                        "showexponent",
                        "showtickprefix",
                        "showticksuffix"
                    ].filter(function(t) {
                        return void 0 !== e[t];
                    });
                    if (t.every(function(r) {
                        return e[r] === e[t[0]];
                    }) || 1 === t.length) return e[t[0]];
                };
            },
            6115: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(7901).contrast, i = r(3838), o = r(9652), l = r(5501);
                function s(e, t) {
                    function r(r, a) {
                        return n.coerce(e, t, i.tickformatstops, r, a);
                    }
                    r("enabled") && (r("dtickrange"), r("value"));
                }
                e.exports = function(e, t, r, c, u) {
                    u || (u = {});
                    var f = r("labelalias");
                    n.isPlainObject(f) || delete t.labelalias;
                    var d = o(e);
                    if (r("showticklabels")) {
                        var h = u.font || {}, p = t.color, v = -1 !== (t.ticklabelposition || "").indexOf("inside") ? a(u.bgColor) : p && p !== i.color.dflt ? p : h.color;
                        if (n.coerceFont(r, "tickfont", {
                            family: h.family,
                            size: h.size,
                            color: v
                        }), u.noTicklabelstep || "multicategory" === c || "log" === c || r("ticklabelstep"), u.noAng || r("tickangle"), "category" !== c) {
                            var g = r("tickformat");
                            l(e, t, {
                                name: "tickformatstops",
                                inclusionAttr: "enabled",
                                handleItemDefaults: s
                            }), t.tickformatstops.length || delete t.tickformatstops, u.noExp || g || "date" === c || (r("showexponent", d), r("exponentformat"), r("minexponent"), r("separatethousands"));
                        }
                    }
                };
            },
            8701: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(3838);
                e.exports = function(e, t, r, i) {
                    var o = i.isMinor, l = o ? e.minor || {} : e, s = o ? t.minor : t, c = o ? a.minor : a, u = o ? "minor." : "", f = n.coerce2(l, s, c, "ticklen", o ? .6 * (t.ticklen || 5) : void 0), d = n.coerce2(l, s, c, "tickwidth", o ? t.tickwidth || 1 : void 0), h = n.coerce2(l, s, c, "tickcolor", (o ? t.tickcolor : void 0) || s.color);
                    r(u + "ticks", !o && i.outerTicks || f || d || h ? "outside" : "") || (delete s.ticklen, delete s.tickwidth, delete s.tickcolor);
                };
            },
            6218: function(e, t, r) {
                "use strict";
                var n = r(6287), a = r(1828).isArrayOrTypedArray;
                e.exports = function(e, t, r, i, o) {
                    o || (o = {});
                    var l = o.isMinor, s = l ? e.minor || {} : e, c = l ? t.minor : t, u = l ? "minor." : "";
                    function f(e) {
                        var t = s[e];
                        return void 0 !== t ? t : (c._template || {})[e];
                    }
                    var d = f("tick0"), h = f("dtick"), p = f("tickvals"), v = r(u + "tickmode", a(p) ? "array" : h ? "linear" : "auto");
                    if ("auto" === v || "sync" === v) r(u + "nticks");
                    else if ("linear" === v) {
                        var g = c.dtick = n.dtick(h, i);
                        c.tick0 = n.tick0(d, i, t.calendar, g);
                    } else "multicategory" !== i && (void 0 === r(u + "tickvals") ? c.tickmode = "auto" : l || r("ticktext"));
                };
            },
            6847: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(3972), i = r(1828), o = r(1424), l = r(9298);
                e.exports = function(e, t, r, s) {
                    var c = e._fullLayout;
                    if (0 !== t.length) {
                        var u, f, d, h;
                        s && (u = s());
                        var p = n.ease(r.easing);
                        return e._transitionData._interruptCallbacks.push(function() {
                            return window.cancelAnimationFrame(h), h = null, function() {
                                for(var r = {}, n = 0; n < t.length; n++){
                                    var i = t[n], o = i.plotinfo.xaxis, l = i.plotinfo.yaxis;
                                    i.xr0 && (r[o._name + ".range"] = i.xr0.slice()), i.yr0 && (r[l._name + ".range"] = i.yr0.slice());
                                }
                                return a.call("relayout", e, r).then(function() {
                                    for(var e = 0; e < t.length; e++)v(t[e].plotinfo);
                                });
                            }();
                        }), f = Date.now(), h = window.requestAnimationFrame(function n() {
                            d = Date.now();
                            for(var i = Math.min(1, (d - f) / r.duration), o = p(i), l = 0; l < t.length; l++)g(t[l], o);
                            d - f > r.duration ? (function() {
                                for(var r = {}, n = 0; n < t.length; n++){
                                    var i = t[n], o = i.plotinfo.xaxis, l = i.plotinfo.yaxis;
                                    i.xr1 && (r[o._name + ".range"] = i.xr1.slice()), i.yr1 && (r[l._name + ".range"] = i.yr1.slice());
                                }
                                u && u(), a.call("relayout", e, r).then(function() {
                                    for(var e = 0; e < t.length; e++)v(t[e].plotinfo);
                                });
                            }(), h = window.cancelAnimationFrame(n)) : h = window.requestAnimationFrame(n);
                        }), Promise.resolve();
                    }
                    function v(e) {
                        var t = e.xaxis, r = e.yaxis;
                        c._defs.select("#" + e.clipId + "> rect").call(o.setTranslate, 0, 0).call(o.setScale, 1, 1), e.plot.call(o.setTranslate, t._offset, r._offset).call(o.setScale, 1, 1);
                        var n = e.plot.selectAll(".scatterlayer .trace");
                        n.selectAll(".point").call(o.setPointGroupScale, 1, 1), n.selectAll(".textpoint").call(o.setTextPointsScale, 1, 1), n.call(o.hideOutsideRangePoints, e);
                    }
                    function g(t, r) {
                        var n = t.plotinfo, a = n.xaxis, s = n.yaxis, c = a._length, u = s._length, f = !!t.xr1, d = !!t.yr1, h = [];
                        if (f) {
                            var p = i.simpleMap(t.xr0, a.r2l), v = i.simpleMap(t.xr1, a.r2l), g = p[1] - p[0], y = v[1] - v[0];
                            h[0] = (p[0] * (1 - r) + r * v[0] - p[0]) / (p[1] - p[0]) * c, h[2] = c * (1 - r + r * y / g), a.range[0] = a.l2r(p[0] * (1 - r) + r * v[0]), a.range[1] = a.l2r(p[1] * (1 - r) + r * v[1]);
                        } else h[0] = 0, h[2] = c;
                        if (d) {
                            var m = i.simpleMap(t.yr0, s.r2l), x = i.simpleMap(t.yr1, s.r2l), b = m[1] - m[0], _ = x[1] - x[0];
                            h[1] = (m[1] * (1 - r) + r * x[1] - m[1]) / (m[0] - m[1]) * u, h[3] = u * (1 - r + r * _ / b), s.range[0] = a.l2r(m[0] * (1 - r) + r * x[0]), s.range[1] = s.l2r(m[1] * (1 - r) + r * x[1]);
                        } else h[1] = 0, h[3] = u;
                        l.drawOne(e, a, {
                            skipTitle: !0
                        }), l.drawOne(e, s, {
                            skipTitle: !0
                        }), l.redrawComponents(e, [
                            a._id,
                            s._id
                        ]);
                        var w = f ? c / h[2] : 1, T = d ? u / h[3] : 1, M = f ? h[0] : 0, k = d ? h[1] : 0, A = f ? h[0] / h[2] * c : 0, L = d ? h[1] / h[3] * u : 0, S = a._offset - A, D = s._offset - L;
                        n.clipRect.call(o.setTranslate, M, k).call(o.setScale, 1 / w, 1 / T), n.plot.call(o.setTranslate, S, D).call(o.setScale, w, T), o.setPointGroupScale(n.zoomScalePts, 1 / w, 1 / T), o.setTextPointsScale(n.zoomScaleTxt, 1 / w, 1 / T);
                    }
                    l.redrawComponents(e);
                };
            },
            951: function(e, t, r) {
                "use strict";
                var n = r(3972).traceIs, a = r(4322);
                function i(e) {
                    return ({
                        v: "x",
                        h: "y"
                    })[e.orientation || "v"];
                }
                function o(e, t) {
                    var r = i(e), a = n(e, "box-violin"), o = n(e._fullInput || {}, "candlestick");
                    return a && !o && t === r && void 0 === e[r] && void 0 === e[r + "0"];
                }
                e.exports = function(e, t, r, l) {
                    r("autotypenumbers", l.autotypenumbersDflt), "-" === r("type", (l.splomStash || {}).type) && (function(e, t) {
                        if ("-" === e.type) {
                            var r, l = e._id, s = l.charAt(0);
                            -1 !== l.indexOf("scene") && (l = s);
                            var c = function(e, t, r) {
                                for(var n = 0; n < e.length; n++){
                                    var a = e[n];
                                    if ("splom" === a.type && a._length > 0 && (a["_" + r + "axes"] || {})[t]) return a;
                                    if ((a[r + "axis"] || r) === t) {
                                        if (o(a, r)) return a;
                                        if ((a[r] || []).length || a[r + "0"]) return a;
                                    }
                                }
                            }(t, l, s);
                            if (c) {
                                if ("histogram" !== c.type || s !== ({
                                    v: "y",
                                    h: "x"
                                })[c.orientation || "v"]) {
                                    var u = s + "calendar", f = c[u], d = {
                                        noMultiCategory: !n(c, "cartesian") || n(c, "noMultiCategory")
                                    };
                                    if ("box" === c.type && c._hasPreCompStats && s === ({
                                        h: "x",
                                        v: "y"
                                    })[c.orientation || "v"] && (d.noMultiCategory = !0), d.autotypenumbers = e.autotypenumbers, o(c, s)) {
                                        var h = i(c), p = [];
                                        for(r = 0; r < t.length; r++){
                                            var v = t[r];
                                            n(v, "box-violin") && (v[s + "axis"] || s) === l && (void 0 !== v[h] ? p.push(v[h][0]) : void 0 !== v.name ? p.push(v.name) : p.push("text"), v[u] !== f && (f = void 0));
                                        }
                                        e.type = a(p, f, d);
                                    } else if ("splom" === c.type) {
                                        var g = c.dimensions[c._axesDim[l]];
                                        g.visible && (e.type = a(g.values, f, d));
                                    } else e.type = a(c[s] || [
                                        c[s + "0"]
                                    ], f, d);
                                } else e.type = "linear";
                            }
                        }
                    }(t, l.data), "-" === t.type ? t.type = "linear" : e.type = t.type);
                };
            },
            1137: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(1828);
                function i(e, t, r) {
                    var n, i, o, l = !1;
                    if ("data" === t.type) n = e._fullData[null !== t.traces ? t.traces[0] : 0];
                    else {
                        if ("layout" !== t.type) return !1;
                        n = e._fullLayout;
                    }
                    return i = a.nestedProperty(n, t.prop).get(), (o = r[t.type] = r[t.type] || {}).hasOwnProperty(t.prop) && o[t.prop] !== i && (l = !0), o[t.prop] = i, {
                        changed: l,
                        value: i
                    };
                }
                function o(e, t) {
                    var r = [], n = t[0], i = {};
                    if ("string" == typeof n) i[n] = t[1];
                    else {
                        if (!a.isPlainObject(n)) return r;
                        i = n;
                    }
                    return s(i, function(e, t, n) {
                        r.push({
                            type: "layout",
                            prop: e,
                            value: n
                        });
                    }, "", 0), r;
                }
                function l(e, t) {
                    var r, n, i, o, l = [];
                    if (n = t[0], i = t[1], r = t[2], o = {}, "string" == typeof n) o[n] = i;
                    else {
                        if (!a.isPlainObject(n)) return l;
                        o = n, void 0 === r && (r = i);
                    }
                    return void 0 === r && (r = null), s(o, function(t, n, a) {
                        var i, o;
                        if (Array.isArray(a)) {
                            o = a.slice();
                            var s = Math.min(o.length, e.data.length);
                            r && (s = Math.min(s, r.length)), i = [];
                            for(var c = 0; c < s; c++)i[c] = r ? r[c] : c;
                        } else o = a, i = r ? r.slice() : null;
                        if (null === i) Array.isArray(o) && (o = o[0]);
                        else if (Array.isArray(i)) {
                            if (!Array.isArray(o)) {
                                var u = o;
                                o = [];
                                for(var f = 0; f < i.length; f++)o[f] = u;
                            }
                            o.length = Math.min(i.length, o.length);
                        }
                        l.push({
                            type: "data",
                            prop: t,
                            traces: i,
                            value: o
                        });
                    }, "", 0), l;
                }
                function s(e, t, r, n) {
                    Object.keys(e).forEach(function(i) {
                        var o = e[i];
                        if ("_" !== i[0]) {
                            var l = r + (n > 0 ? "." : "") + i;
                            a.isPlainObject(o) ? s(o, t, l, n + 1) : t(l, i, o);
                        }
                    });
                }
                t.manageCommandObserver = function(e, r, n, o) {
                    var l = {}, s = !0;
                    r && r._commandObserver && (l = r._commandObserver), l.cache || (l.cache = {}), l.lookupTable = {};
                    var c = t.hasSimpleAPICommandBindings(e, n, l.lookupTable);
                    if (r && r._commandObserver) {
                        if (c) return l;
                        if (r._commandObserver.remove) return r._commandObserver.remove(), r._commandObserver = null, l;
                    }
                    if (c) {
                        i(e, c, l.cache), l.check = function() {
                            if (s) {
                                var t = i(e, c, l.cache);
                                return t.changed && o && void 0 !== l.lookupTable[t.value] && (l.disable(), Promise.resolve(o({
                                    value: t.value,
                                    type: c.type,
                                    prop: c.prop,
                                    traces: c.traces,
                                    index: l.lookupTable[t.value]
                                })).then(l.enable, l.enable)), t.changed;
                            }
                        };
                        for(var u = [
                            "plotly_relayout",
                            "plotly_redraw",
                            "plotly_restyle",
                            "plotly_update",
                            "plotly_animatingframe",
                            "plotly_afterplot"
                        ], f = 0; f < u.length; f++)e._internalOn(u[f], l.check);
                        l.remove = function() {
                            for(var t = 0; t < u.length; t++)e._removeInternalListener(u[t], l.check);
                        };
                    } else a.log("Unable to automatically bind plot updates to API command"), l.lookupTable = {}, l.remove = function() {};
                    return l.disable = function() {
                        s = !1;
                    }, l.enable = function() {
                        s = !0;
                    }, r && (r._commandObserver = l), l;
                }, t.hasSimpleAPICommandBindings = function(e, r, n) {
                    var a, i, o = r.length;
                    for(a = 0; a < o; a++){
                        var l, s = r[a], c = s.method, u = s.args;
                        if (Array.isArray(u) || (u = []), !c) return !1;
                        var f = t.computeAPICommandBindings(e, c, u);
                        if (1 !== f.length) return !1;
                        if (i) {
                            if ((l = f[0]).type !== i.type) return !1;
                            if (l.prop !== i.prop) return !1;
                            if (Array.isArray(i.traces)) {
                                if (!Array.isArray(l.traces)) return !1;
                                l.traces.sort();
                                for(var d = 0; d < i.traces.length; d++)if (i.traces[d] !== l.traces[d]) return !1;
                            } else if (l.prop !== i.prop) return !1;
                        } else i = f[0], Array.isArray(i.traces) && i.traces.sort();
                        var h = (l = f[0]).value;
                        if (Array.isArray(h)) {
                            if (1 !== h.length) return !1;
                            h = h[0];
                        }
                        n && (n[h] = a);
                    }
                    return i;
                }, t.executeAPICommand = function(e, t, r) {
                    if ("skip" === t) return Promise.resolve();
                    var i = n.apiMethodRegistry[t], o = [
                        e
                    ];
                    Array.isArray(r) || (r = []);
                    for(var l = 0; l < r.length; l++)o.push(r[l]);
                    return i.apply(null, o).catch(function(e) {
                        return a.warn("API call to Plotly." + t + " rejected.", e), Promise.reject(e);
                    });
                }, t.computeAPICommandBindings = function(e, t, r) {
                    var n;
                    switch(Array.isArray(r) || (r = []), t){
                        case "restyle":
                            n = l(e, r);
                            break;
                        case "relayout":
                            n = o(0, r);
                            break;
                        case "update":
                            n = l(e, [
                                r[0],
                                r[2]
                            ]).concat(o(0, [
                                r[1]
                            ]));
                            break;
                        case "animate":
                            n = function(e, t) {
                                return Array.isArray(t[0]) && 1 === t[0].length && -1 !== [
                                    "string",
                                    "number"
                                ].indexOf(typeof t[0][0]) ? [
                                    {
                                        type: "layout",
                                        prop: "_currentFrame",
                                        value: t[0][0].toString()
                                    }
                                ] : [];
                            }(0, r);
                            break;
                        default:
                            n = [];
                    }
                    return n;
                };
            },
            7670: function(e, t, r) {
                "use strict";
                var n = r(1426).extendFlat;
                t.Y = function(e, t) {
                    t = t || {};
                    var r = {
                        valType: "info_array",
                        editType: (e = e || {}).editType,
                        items: [
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: e.editType
                            },
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: e.editType
                            }
                        ],
                        dflt: [
                            0,
                            1
                        ]
                    }, a = (e.name && e.name, e.trace, t.description && t.description, {
                        x: n({}, r, {}),
                        y: n({}, r, {}),
                        editType: e.editType
                    });
                    return e.noGridCell || (a.row = {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: e.editType
                    }, a.column = {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: e.editType
                    }), a;
                }, t.c = function(e, t, r, n) {
                    var a = n && n.x || [
                        0,
                        1
                    ], i = n && n.y || [
                        0,
                        1
                    ], o = t.grid;
                    if (o) {
                        var l = r("domain.column");
                        void 0 !== l && (l < o.columns ? a = o._domains.x[l] : delete e.domain.column);
                        var s = r("domain.row");
                        void 0 !== s && (s < o.rows ? i = o._domains.y[s] : delete e.domain.row);
                    }
                    var c = r("domain.x", a), u = r("domain.y", i);
                    c[0] < c[1] || (e.domain.x = a.slice()), u[0] < u[1] || (e.domain.y = i.slice());
                };
            },
            1940: function(e) {
                "use strict";
                e.exports = function(e) {
                    var t = e.editType, r = e.colorEditType;
                    void 0 === r && (r = t);
                    var n = {
                        family: {
                            valType: "string",
                            noBlank: !0,
                            strict: !0,
                            editType: t
                        },
                        size: {
                            valType: "number",
                            min: 1,
                            editType: t
                        },
                        color: {
                            valType: "color",
                            editType: r
                        },
                        editType: t
                    };
                    return e.autoSize && (n.size.dflt = "auto"), e.autoColor && (n.color.dflt = "auto"), e.arrayOk && (n.family.arrayOk = !0, n.size.arrayOk = !0, n.color.arrayOk = !0), n;
                };
            },
            1391: function(e) {
                "use strict";
                e.exports = {
                    _isLinkedToArray: "frames_entry",
                    group: {
                        valType: "string"
                    },
                    name: {
                        valType: "string"
                    },
                    traces: {
                        valType: "any"
                    },
                    baseframe: {
                        valType: "string"
                    },
                    data: {
                        valType: "any"
                    },
                    layout: {
                        valType: "any"
                    }
                };
            },
            7659: function(e, t, r) {
                "use strict";
                var n = r(3972);
                r(5555).SUBPLOT_PATTERN;
                t.a0 = function(e, t) {
                    var r, a = [], i = [];
                    if (!(r = "string" == typeof t ? n.getModule(t).plot : "function" == typeof t ? t : t.plot)) return [
                        a,
                        e
                    ];
                    for(var o = 0; o < e.length; o++){
                        var l = e[o], s = l[0].trace;
                        !0 === s.visible && 0 !== s._length && (s._module && s._module.plot === r ? a.push(l) : i.push(l));
                    }
                    return [
                        a,
                        i
                    ];
                };
            },
            3538: function(e) {
                "use strict";
                function t(e, t) {
                    var r, n, a = [
                        0,
                        0,
                        0,
                        0
                    ];
                    for(r = 0; r < 4; ++r)for(n = 0; n < 4; ++n)a[n] += e[4 * r + n] * t[r];
                    return a;
                }
                e.exports = function(e, r) {
                    return t(e.projection, t(e.view, t(e.model, [
                        r[0],
                        r[1],
                        r[2],
                        1
                    ])));
                };
            },
            820: function(e, t, r) {
                "use strict";
                var n = r(1940), a = r(5594), i = r(2399), o = r(9241), l = r(3777), s = r(5025), c = r(1426).extendFlat, u = n({
                    editType: "calc"
                });
                u.family.dflt = '"Open Sans", verdana, arial, sans-serif', u.size.dflt = 12, u.color.dflt = i.defaultLine, e.exports = {
                    font: u,
                    title: {
                        text: {
                            valType: "string",
                            editType: "layoutstyle"
                        },
                        font: n({
                            editType: "layoutstyle"
                        }),
                        xref: {
                            valType: "enumerated",
                            dflt: "container",
                            values: [
                                "container",
                                "paper"
                            ],
                            editType: "layoutstyle"
                        },
                        yref: {
                            valType: "enumerated",
                            dflt: "container",
                            values: [
                                "container",
                                "paper"
                            ],
                            editType: "layoutstyle"
                        },
                        x: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .5,
                            editType: "layoutstyle"
                        },
                        y: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: "auto",
                            editType: "layoutstyle"
                        },
                        xanchor: {
                            valType: "enumerated",
                            dflt: "auto",
                            values: [
                                "auto",
                                "left",
                                "center",
                                "right"
                            ],
                            editType: "layoutstyle"
                        },
                        yanchor: {
                            valType: "enumerated",
                            dflt: "auto",
                            values: [
                                "auto",
                                "top",
                                "middle",
                                "bottom"
                            ],
                            editType: "layoutstyle"
                        },
                        pad: c(s({
                            editType: "layoutstyle"
                        }), {}),
                        automargin: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "plot"
                        },
                        editType: "layoutstyle"
                    },
                    uniformtext: {
                        mode: {
                            valType: "enumerated",
                            values: [
                                !1,
                                "hide",
                                "show"
                            ],
                            dflt: !1,
                            editType: "plot"
                        },
                        minsize: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    autosize: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "none"
                    },
                    width: {
                        valType: "number",
                        min: 10,
                        dflt: 700,
                        editType: "plot"
                    },
                    height: {
                        valType: "number",
                        min: 10,
                        dflt: 450,
                        editType: "plot"
                    },
                    minreducedwidth: {
                        valType: "number",
                        min: 2,
                        dflt: 64,
                        editType: "plot"
                    },
                    minreducedheight: {
                        valType: "number",
                        min: 2,
                        dflt: 64,
                        editType: "plot"
                    },
                    margin: {
                        l: {
                            valType: "number",
                            min: 0,
                            dflt: 80,
                            editType: "plot"
                        },
                        r: {
                            valType: "number",
                            min: 0,
                            dflt: 80,
                            editType: "plot"
                        },
                        t: {
                            valType: "number",
                            min: 0,
                            dflt: 100,
                            editType: "plot"
                        },
                        b: {
                            valType: "number",
                            min: 0,
                            dflt: 80,
                            editType: "plot"
                        },
                        pad: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        autoexpand: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    computed: {
                        valType: "any",
                        editType: "none"
                    },
                    paper_bgcolor: {
                        valType: "color",
                        dflt: i.background,
                        editType: "plot"
                    },
                    plot_bgcolor: {
                        valType: "color",
                        dflt: i.background,
                        editType: "layoutstyle"
                    },
                    autotypenumbers: {
                        valType: "enumerated",
                        values: [
                            "convert types",
                            "strict"
                        ],
                        dflt: "convert types",
                        editType: "calc"
                    },
                    separators: {
                        valType: "string",
                        editType: "plot"
                    },
                    hidesources: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    showlegend: {
                        valType: "boolean",
                        editType: "legend"
                    },
                    colorway: {
                        valType: "colorlist",
                        dflt: i.defaults,
                        editType: "calc"
                    },
                    datarevision: {
                        valType: "any",
                        editType: "calc"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editrevision: {
                        valType: "any",
                        editType: "none"
                    },
                    selectionrevision: {
                        valType: "any",
                        editType: "none"
                    },
                    template: {
                        valType: "any",
                        editType: "calc"
                    },
                    newshape: o.newshape,
                    activeshape: o.activeshape,
                    newselection: l.newselection,
                    activeselection: l.activeselection,
                    meta: {
                        valType: "any",
                        arrayOk: !0,
                        editType: "plot"
                    },
                    transition: c({}, a.transition, {
                        editType: "none"
                    }),
                    _deprecated: {
                        title: {
                            valType: "string",
                            editType: "layoutstyle"
                        },
                        titlefont: n({
                            editType: "layoutstyle"
                        })
                    }
                };
            },
            5025: function(e) {
                "use strict";
                e.exports = function(e) {
                    var t = e.editType;
                    return {
                        t: {
                            valType: "number",
                            dflt: 0,
                            editType: t
                        },
                        r: {
                            valType: "number",
                            dflt: 0,
                            editType: t
                        },
                        b: {
                            valType: "number",
                            dflt: 0,
                            editType: t
                        },
                        l: {
                            valType: "number",
                            dflt: 0,
                            editType: t
                        },
                        editType: t
                    };
                };
            },
            4875: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(4096).Dq, i = r(721).FF, o = r(2770), l = r(3972), s = r(6281), c = r(4467), u = r(1828), f = r(7901), d = r(606).BADNUM, h = r(1675), p = r(1873).clearOutline, v = r(1479), g = r(5594), y = r(1391), m = r(7659).a0, x = u.relinkPrivateKeys, b = u._, _ = e.exports = {};
                u.extendFlat(_, l), _.attributes = r(9012), _.attributes.type.values = _.allTypes, _.fontAttrs = r(1940), _.layoutAttributes = r(820), _.fontWeight = "normal";
                var w = _.transformsRegistry, T = r(1137);
                _.executeAPICommand = T.executeAPICommand, _.computeAPICommandBindings = T.computeAPICommandBindings, _.manageCommandObserver = T.manageCommandObserver, _.hasSimpleAPICommandBindings = T.hasSimpleAPICommandBindings, _.redrawText = function(e) {
                    return e = u.getGraphDiv(e), new Promise(function(t) {
                        setTimeout(function() {
                            e._fullLayout && (l.getComponentMethod("annotations", "draw")(e), l.getComponentMethod("legend", "draw")(e), l.getComponentMethod("colorbar", "draw")(e), t(_.previousPromises(e)));
                        }, 300);
                    });
                }, _.resize = function(e) {
                    var t;
                    e = u.getGraphDiv(e);
                    var r = new Promise(function(r, n) {
                        e && !u.isHidden(e) || n(new Error("Resize must be passed a displayed plot div element.")), e._redrawTimer && clearTimeout(e._redrawTimer), e._resolveResize && (t = e._resolveResize), e._resolveResize = r, e._redrawTimer = setTimeout(function() {
                            if (!e.layout || e.layout.width && e.layout.height || u.isHidden(e)) r(e);
                            else {
                                delete e.layout.width, delete e.layout.height;
                                var t = e.changed;
                                e.autoplay = !0, l.call("relayout", e, {
                                    autosize: !0
                                }).then(function() {
                                    e.changed = t, e._resolveResize === r && (delete e._resolveResize, r(e));
                                });
                            }
                        }, 100);
                    });
                    return t && t(r), r;
                }, _.previousPromises = function(e) {
                    if ((e._promises || []).length) return Promise.all(e._promises).then(function() {
                        e._promises = [];
                    });
                }, _.addLinks = function(e) {
                    if (e._context.showLink || e._context.showSources) {
                        var t = e._fullLayout, r = u.ensureSingle(t._paper, "text", "js-plot-link-container", function(e) {
                            e.style({
                                "font-family": '"Open Sans", Arial, sans-serif',
                                "font-size": "12px",
                                fill: f.defaultLine,
                                "pointer-events": "all"
                            }).each(function() {
                                var e = n.select(this);
                                e.append("tspan").classed("js-link-to-tool", !0), e.append("tspan").classed("js-link-spacer", !0), e.append("tspan").classed("js-sourcelinks", !0);
                            });
                        }), a = r.node(), i = {
                            y: t._paper.attr("height") - 9
                        };
                        document.body.contains(a) && a.getComputedTextLength() >= t.width - 20 ? (i["text-anchor"] = "start", i.x = 5) : (i["text-anchor"] = "end", i.x = t._paper.attr("width") - 7), r.attr(i);
                        var o = r.select(".js-link-to-tool"), l = r.select(".js-link-spacer"), s = r.select(".js-sourcelinks");
                        e._context.showSources && e._context.showSources(e), e._context.showLink && function(e, t) {
                            t.text("");
                            var r = t.append("a").attr({
                                "xlink:xlink:href": "#",
                                class: "link--impt link--embedview",
                                "font-weight": "bold"
                            }).text(e._context.linkText + " " + String.fromCharCode(187));
                            if (e._context.sendData) r.on("click", function() {
                                _.sendDataToCloud(e);
                            });
                            else {
                                var n = window.location.pathname.split("/"), a = window.location.search;
                                r.attr({
                                    "xlink:xlink:show": "new",
                                    "xlink:xlink:href": "/" + n[2].split(".")[0] + "/" + n[1] + a
                                });
                            }
                        }(e, o), l.text(o.text() && s.text() ? " - " : "");
                    }
                }, _.sendDataToCloud = function(e) {
                    var t = (window.PLOTLYENV || {}).BASE_URL || e._context.plotlyServerURL;
                    if (t) {
                        e.emit("plotly_beforeexport");
                        var r = n.select(e).append("div").attr("id", "hiddenform").style("display", "none"), a = r.append("form").attr({
                            action: t + "/external",
                            method: "post",
                            target: "_blank"
                        });
                        return a.append("input").attr({
                            type: "text",
                            name: "data"
                        }).node().value = _.graphJson(e, !1, "keepdata"), a.node().submit(), r.remove(), e.emit("plotly_afterexport"), !1;
                    }
                };
                var M = [
                    "days",
                    "shortDays",
                    "months",
                    "shortMonths",
                    "periods",
                    "dateTime",
                    "date",
                    "time",
                    "decimal",
                    "thousands",
                    "grouping",
                    "currency"
                ], k = [
                    "year",
                    "month",
                    "dayMonth",
                    "dayMonthYear"
                ];
                function A(e, t) {
                    var r = e._context.locale;
                    r || (r = "en-US");
                    var n = !1, a = {};
                    function i(e) {
                        for(var r = !0, i = 0; i < t.length; i++){
                            var o = t[i];
                            a[o] || (e[o] ? a[o] = e[o] : r = !1);
                        }
                        r && (n = !0);
                    }
                    for(var o = 0; o < 2; o++){
                        for(var s = e._context.locales, c = 0; c < 2; c++){
                            var u = (s[r] || {}).format;
                            if (u && (i(u), n)) break;
                            s = l.localeRegistry;
                        }
                        var f = r.split("-")[0];
                        if (n || f === r) break;
                        r = f;
                    }
                    return n || i(l.localeRegistry.en.format), a;
                }
                function L(e, t) {
                    var r = {
                        _fullLayout: t
                    }, n = "x" === e._id.charAt(0), a = e._mainAxis._anchorAxis, i = "", o = "", l = "";
                    if (a && (l = a._mainAxis._id, i = n ? e._id + l : l + e._id), !i || !t._plots[i]) {
                        i = "";
                        for(var s = e._counterAxes, c = 0; c < s.length; c++){
                            var u = s[c], f = n ? e._id + u : u + e._id;
                            o || (o = f);
                            var d = h.getFromId(r, u);
                            if (l && d.overlaying === l) {
                                i = f;
                                break;
                            }
                        }
                    }
                    return i || o;
                }
                function S(e) {
                    var t = e.transforms;
                    if (Array.isArray(t) && t.length) for(var r = 0; r < t.length; r++){
                        var n = t[r], a = n._module || w[n.type];
                        if (a && a.makesData) return !0;
                    }
                    return !1;
                }
                function D(e, t, r, n) {
                    for(var a = e.transforms, i = [
                        e
                    ], o = 0; o < a.length; o++){
                        var l = a[o], s = w[l.type];
                        s && s.transform && (i = s.transform(i, {
                            transform: l,
                            fullTrace: e,
                            fullData: t,
                            layout: r,
                            fullLayout: n,
                            transformIndex: o
                        }));
                    }
                    return i;
                }
                function O(e) {
                    return "string" == typeof e && "px" === e.substr(e.length - 2) && parseFloat(e);
                }
                function C(e) {
                    var t = e.margin;
                    if (!e._size) {
                        var r = e._size = {
                            l: Math.round(t.l),
                            r: Math.round(t.r),
                            t: Math.round(t.t),
                            b: Math.round(t.b),
                            p: Math.round(t.pad)
                        };
                        r.w = Math.round(e.width) - r.l - r.r, r.h = Math.round(e.height) - r.t - r.b;
                    }
                    e._pushmargin || (e._pushmargin = {}), e._pushmarginIds || (e._pushmarginIds = {}), e._reservedMargin || (e._reservedMargin = {});
                }
                _.supplyDefaults = function(e, t) {
                    var r = t && t.skipUpdateCalc, n = e._fullLayout || {};
                    if (n._skipDefaults) delete n._skipDefaults;
                    else {
                        var o, s = e._fullLayout = {}, c = e.layout || {}, f = e._fullData || [], d = e._fullData = [], h = e.data || [], v = e.calcdata || [], g = e._context || {};
                        e._transitionData || _.createTransitionData(e), s._dfltTitle = {
                            plot: b(e, "Click to enter Plot title"),
                            x: b(e, "Click to enter X axis title"),
                            y: b(e, "Click to enter Y axis title"),
                            colorbar: b(e, "Click to enter Colorscale title"),
                            annotation: b(e, "new text")
                        }, s._traceWord = b(e, "trace");
                        var y = A(e, M);
                        if (s._mapboxAccessToken = g.mapboxAccessToken, n._initialAutoSizeIsDone) {
                            var m = n.width, w = n.height;
                            _.supplyLayoutGlobalDefaults(c, s, y), c.width || (s.width = m), c.height || (s.height = w), _.sanitizeMargins(s);
                        } else {
                            _.supplyLayoutGlobalDefaults(c, s, y);
                            var T = !c.width || !c.height, L = s.autosize, S = g.autosizable;
                            T && (L || S) ? _.plotAutoSize(e, c, s) : T && _.sanitizeMargins(s), !L && T && (c.width = s.width, c.height = s.height);
                        }
                        s._d3locale = function(e, t) {
                            return e.decimal = t.charAt(0), e.thousands = t.charAt(1), {
                                numberFormat: function(t) {
                                    try {
                                        t = i(e).format(u.adjustFormat(t));
                                    } catch (e) {
                                        return u.warnBadFormat(t), u.noFormat;
                                    }
                                    return t;
                                },
                                timeFormat: a(e).utcFormat
                            };
                        }(y, s.separators), s._extraFormat = A(e, k), s._initialAutoSizeIsDone = !0, s._dataLength = h.length, s._modules = [], s._visibleModules = [], s._basePlotModules = [];
                        var D = s._subplots = function() {
                            var e, t, r = l.collectableSubplotTypes, n = {};
                            if (!r) {
                                r = [];
                                var a = l.subplotsRegistry;
                                for(var i in a){
                                    var o = a[i].attr;
                                    if (o && (r.push(i), Array.isArray(o))) for(t = 0; t < o.length; t++)u.pushUnique(r, o[t]);
                                }
                            }
                            for(e = 0; e < r.length; e++)n[r[e]] = [];
                            return n;
                        }(), O = s._splomAxes = {
                            x: {},
                            y: {}
                        }, P = s._splomSubplots = {};
                        s._splomGridDflt = {}, s._scatterStackOpts = {}, s._firstScatter = {}, s._alignmentOpts = {}, s._colorAxes = {}, s._requestRangeslider = {}, s._traceUids = function(e, t) {
                            var r, n, a = t.length, i = [];
                            for(r = 0; r < e.length; r++){
                                var o = e[r]._fullInput;
                                o !== n && i.push(o), n = o;
                            }
                            var l = i.length, s = new Array(a), c = {};
                            function f(e, t) {
                                s[t] = e, c[e] = 1;
                            }
                            function d(e, t) {
                                if (e && "string" == typeof e && !c[e]) return f(e, t), !0;
                            }
                            for(r = 0; r < a; r++){
                                var h = t[r].uid;
                                "number" == typeof h && (h = String(h)), d(h, r) || r < l && d(i[r].uid, r) || f(u.randstr(c), r);
                            }
                            return s;
                        }(f, h), s._globalTransforms = (e._context || {}).globalTransforms, _.supplyDataDefaults(h, d, c, s);
                        var I = Object.keys(O.x), R = Object.keys(O.y);
                        if (I.length > 1 && R.length > 1) {
                            for(l.getComponentMethod("grid", "sizeDefaults")(c, s), o = 0; o < I.length; o++)u.pushUnique(D.xaxis, I[o]);
                            for(o = 0; o < R.length; o++)u.pushUnique(D.yaxis, R[o]);
                            for(var z in P)u.pushUnique(D.cartesian, z);
                        }
                        if (s._has = _._hasPlotType.bind(s), f.length === d.length) for(o = 0; o < d.length; o++)x(d[o], f[o]);
                        _.supplyLayoutModuleDefaults(c, s, d, e._transitionData);
                        var N = s._visibleModules, F = [];
                        for(o = 0; o < N.length; o++){
                            var E = N[o].crossTraceDefaults;
                            E && u.pushUnique(F, E);
                        }
                        for(o = 0; o < F.length; o++)F[o](d, s);
                        s._hasOnlyLargeSploms = 1 === s._basePlotModules.length && "splom" === s._basePlotModules[0].name && I.length > 15 && R.length > 15 && 0 === s.shapes.length && 0 === s.images.length, _.linkSubplots(d, s, f, n), _.cleanPlot(d, s, f, n);
                        var H = !(!n._has || !n._has("gl2d")), j = !(!s._has || !s._has("gl2d")), B = !(!n._has || !n._has("cartesian")) || H, Y = !(!s._has || !s._has("cartesian")) || j;
                        B && !Y ? n._bgLayer.remove() : Y && !B && (s._shouldCreateBgLayer = !0), n._zoomlayer && !e._dragging && p({
                            _fullLayout: n
                        }), function(e, t) {
                            var r, n = [];
                            t.meta && (r = t._meta = {
                                meta: t.meta,
                                layout: {
                                    meta: t.meta
                                }
                            });
                            for(var a = 0; a < e.length; a++){
                                var i = e[a];
                                i.meta ? n[i.index] = i._meta = {
                                    meta: i.meta
                                } : t.meta && (i._meta = {
                                    meta: t.meta
                                }), t.meta && (i._meta.layout = {
                                    meta: t.meta
                                });
                            }
                            n.length && (r || (r = t._meta = {}), r.data = n);
                        }(d, s), x(s, n), l.getComponentMethod("colorscale", "crossTraceDefaults")(d, s), s._preGUI || (s._preGUI = {}), s._tracePreGUI || (s._tracePreGUI = {});
                        var V, U = s._tracePreGUI, q = {};
                        for(V in U)q[V] = "old";
                        for(o = 0; o < d.length; o++)q[V = d[o]._fullInput.uid] || (U[V] = {}), q[V] = "new";
                        for(V in q)"old" === q[V] && delete U[V];
                        C(s), l.getComponentMethod("rangeslider", "makeData")(s), r || v.length !== d.length || _.supplyDefaultsUpdateCalc(v, d);
                    }
                }, _.supplyDefaultsUpdateCalc = function(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r], a = (e[r] || [])[0];
                        if (a && a.trace) {
                            var i = a.trace;
                            if (i._hasCalcTransform) {
                                var o, l, s, c = i._arrayAttrs;
                                for(o = 0; o < c.length; o++)l = c[o], s = u.nestedProperty(i, l).get().slice(), u.nestedProperty(n, l).set(s);
                            }
                            a.trace = n;
                        }
                    }
                }, _.createTransitionData = function(e) {
                    e._transitionData || (e._transitionData = {}), e._transitionData._frames || (e._transitionData._frames = []), e._transitionData._frameHash || (e._transitionData._frameHash = {}), e._transitionData._counter || (e._transitionData._counter = 0), e._transitionData._interruptCallbacks || (e._transitionData._interruptCallbacks = []);
                }, _._hasPlotType = function(e) {
                    var t, r = this._basePlotModules || [];
                    for(t = 0; t < r.length; t++)if (r[t].name === e) return !0;
                    var n = this._modules || [];
                    for(t = 0; t < n.length; t++){
                        var a = n[t].name;
                        if (a === e) return !0;
                        var i = l.modules[a];
                        if (i && i.categories[e]) return !0;
                    }
                    return !1;
                }, _.cleanPlot = function(e, t, r, n) {
                    var a, i, o = n._basePlotModules || [];
                    for(a = 0; a < o.length; a++){
                        var l = o[a];
                        l.clean && l.clean(e, t, r, n);
                    }
                    var s = n._has && n._has("gl"), c = t._has && t._has("gl");
                    s && !c && void 0 !== n._glcontainer && (n._glcontainer.selectAll(".gl-canvas").remove(), n._glcontainer.selectAll(".no-webgl").remove(), n._glcanvas = null);
                    var u = !!n._infolayer;
                    e: for(a = 0; a < r.length; a++){
                        var f = r[a].uid;
                        for(i = 0; i < e.length; i++)if (f === e[i].uid) continue e;
                        u && n._infolayer.select(".cb" + f).remove();
                    }
                }, _.linkSubplots = function(e, t, r, n) {
                    var a, i, o = n._plots || {}, s = t._plots = {}, c = t._subplots, f = {
                        _fullData: e,
                        _fullLayout: t
                    }, d = c.cartesian.concat(c.gl2d || []);
                    for(a = 0; a < d.length; a++){
                        var p, v = d[a], g = o[v], y = h.getFromId(f, v, "x"), m = h.getFromId(f, v, "y");
                        for(g ? p = s[v] = g : (p = s[v] = {}).id = v, y._counterAxes.push(m._id), m._counterAxes.push(y._id), y._subplotsWith.push(v), m._subplotsWith.push(v), p.xaxis = y, p.yaxis = m, p._hasClipOnAxisFalse = !1, i = 0; i < e.length; i++){
                            var x = e[i];
                            if (x.xaxis === p.xaxis._id && x.yaxis === p.yaxis._id && !1 === x.cliponaxis) {
                                p._hasClipOnAxisFalse = !0;
                                break;
                            }
                        }
                    }
                    var b, _ = h.list(f, null, !0);
                    for(a = 0; a < _.length; a++){
                        var w = null;
                        (b = _[a]).overlaying && (w = h.getFromId(f, b.overlaying)) && w.overlaying && (b.overlaying = !1, w = null), b._mainAxis = w || b, w && (b.domain = w.domain.slice()), b._anchorAxis = "free" === b.anchor ? null : h.getFromId(f, b.anchor);
                    }
                    for(a = 0; a < _.length; a++)if ((b = _[a])._counterAxes.sort(h.idSort), b._subplotsWith.sort(u.subplotSort), b._mainSubplot = L(b, t), b._counterAxes.length && (b.spikemode && -1 !== b.spikemode.indexOf("across") || b.automargin && b.mirror && "free" !== b.anchor || l.getComponentMethod("rangeslider", "isVisible")(b))) {
                        var T = 1, M = 0;
                        for(i = 0; i < b._counterAxes.length; i++){
                            var k = h.getFromId(f, b._counterAxes[i]);
                            T = Math.min(T, k.domain[0]), M = Math.max(M, k.domain[1]);
                        }
                        T < M && (b._counterDomainMin = T, b._counterDomainMax = M);
                    }
                }, _.clearExpandedTraceDefaultColors = function(e) {
                    var t, r, n;
                    for(r = [], (t = e._module._colorAttrs) || (e._module._colorAttrs = t = [], s.crawl(e._module.attributes, function(e, n, a, i) {
                        r[i] = n, r.length = i + 1, "color" === e.valType && void 0 === e.dflt && t.push(r.join("."));
                    })), n = 0; n < t.length; n++)u.nestedProperty(e, "_input." + t[n]).get() || u.nestedProperty(e, t[n]).set(null);
                }, _.supplyDataDefaults = function(e, t, r, n) {
                    var a, i, o, s = n._modules, f = n._visibleModules, d = n._basePlotModules, h = 0, p = 0;
                    function v(e) {
                        t.push(e);
                        var r = e._module;
                        r && (u.pushUnique(s, r), !0 === e.visible && u.pushUnique(f, r), u.pushUnique(d, e._module.basePlotModule), h++, !1 !== e._input.visible && p++);
                    }
                    n._transformModules = [];
                    var g = {}, y = [], m = (r.template || {}).data || {}, b = c.traceTemplater(m);
                    for(a = 0; a < e.length; a++){
                        if (o = e[a], (i = b.newTrace(o)).uid = n._traceUids[a], _.supplyTraceDefaults(o, i, p, n, a), i.index = a, i._input = o, i._expandedIndex = h, i.transforms && i.transforms.length) for(var w = !1 !== o.visible && !1 === i.visible, T = D(i, t, r, n), M = 0; M < T.length; M++){
                            var k = T[M], A = {
                                _template: i._template,
                                type: i.type,
                                uid: i.uid + M
                            };
                            w && !1 === k.visible && delete k.visible, _.supplyTraceDefaults(k, A, h, n, a), x(A, k), A.index = a, A._input = o, A._fullInput = i, A._expandedIndex = h, A._expandedInput = k, v(A);
                        }
                        else i._fullInput = i, i._expandedInput = i, v(i);
                        l.traceIs(i, "carpetAxis") && (g[i.carpet] = i), l.traceIs(i, "carpetDependent") && y.push(a);
                    }
                    for(a = 0; a < y.length; a++)if ((i = t[y[a]]).visible) {
                        var L = g[i.carpet];
                        i._carpet = L, L && L.visible ? (i.xaxis = L.xaxis, i.yaxis = L.yaxis) : i.visible = !1;
                    }
                }, _.supplyAnimationDefaults = function(e) {
                    var t;
                    e = e || {};
                    var r = {};
                    function n(t, n) {
                        return u.coerce(e || {}, r, g, t, n);
                    }
                    if (n("mode"), n("direction"), n("fromcurrent"), Array.isArray(e.frame)) for(r.frame = [], t = 0; t < e.frame.length; t++)r.frame[t] = _.supplyAnimationFrameDefaults(e.frame[t] || {});
                    else r.frame = _.supplyAnimationFrameDefaults(e.frame || {});
                    if (Array.isArray(e.transition)) for(r.transition = [], t = 0; t < e.transition.length; t++)r.transition[t] = _.supplyAnimationTransitionDefaults(e.transition[t] || {});
                    else r.transition = _.supplyAnimationTransitionDefaults(e.transition || {});
                    return r;
                }, _.supplyAnimationFrameDefaults = function(e) {
                    var t = {};
                    function r(r, n) {
                        return u.coerce(e || {}, t, g.frame, r, n);
                    }
                    return r("duration"), r("redraw"), t;
                }, _.supplyAnimationTransitionDefaults = function(e) {
                    var t = {};
                    function r(r, n) {
                        return u.coerce(e || {}, t, g.transition, r, n);
                    }
                    return r("duration"), r("easing"), t;
                }, _.supplyFrameDefaults = function(e) {
                    var t = {};
                    function r(r, n) {
                        return u.coerce(e, t, y, r, n);
                    }
                    return r("group"), r("name"), r("traces"), r("baseframe"), r("data"), r("layout"), t;
                }, _.supplyTraceDefaults = function(e, t, r, n, a) {
                    var i, o = n.colorway || f.defaults, s = o[r % o.length];
                    function c(r, n) {
                        return u.coerce(e, t, _.attributes, r, n);
                    }
                    var d = c("visible");
                    c("type"), c("name", n._traceWord + " " + a), c("uirevision", n.uirevision);
                    var h = _.getModule(t);
                    if (t._module = h, h) {
                        var p = h.basePlotModule, v = p.attr, g = p.attributes;
                        if (v && g) {
                            var y = n._subplots, m = "";
                            if (d || "gl2d" !== p.name) {
                                if (Array.isArray(v)) for(i = 0; i < v.length; i++){
                                    var x = v[i], b = u.coerce(e, t, g, x);
                                    y[x] && u.pushUnique(y[x], b), m += b;
                                }
                                else m = u.coerce(e, t, g, v);
                                y[p.name] && u.pushUnique(y[p.name], m);
                            }
                        }
                    }
                    return d && (c("customdata"), c("ids"), c("meta"), l.traceIs(t, "showLegend") ? (u.coerce(e, t, h.attributes.showlegend ? h.attributes : _.attributes, "showlegend"), c("legend"), c("legendwidth"), c("legendgroup"), c("legendgrouptitle.text"), c("legendrank"), t._dfltShowLegend = !0) : t._dfltShowLegend = !1, h && h.supplyDefaults(e, t, s, n), l.traceIs(t, "noOpacity") || c("opacity"), l.traceIs(t, "notLegendIsolatable") && (t.visible = !!t.visible), l.traceIs(t, "noHover") || (t.hovertemplate || u.coerceHoverinfo(e, t, n), "parcats" !== t.type && l.getComponentMethod("fx", "supplyDefaults")(e, t, s, n)), h && h.selectPoints && c("selectedpoints"), _.supplyTransformDefaults(e, t, n)), t;
                }, _.hasMakesDataTransform = S, _.supplyTransformDefaults = function(e, t, r) {
                    if (t._length || S(e)) {
                        var n = r._globalTransforms || [], a = r._transformModules || [];
                        if (Array.isArray(e.transforms) || 0 !== n.length) for(var i = e.transforms || [], o = n.concat(i), l = t.transforms = [], s = 0; s < o.length; s++){
                            var c, f = o[s], d = f.type, h = w[d], p = !(f._module && f._module === h), v = h && "function" == typeof h.transform;
                            h || u.warn("Unrecognized transform type " + d + "."), h && h.supplyDefaults && (p || v) ? ((c = h.supplyDefaults(f, t, r, e)).type = d, c._module = h, u.pushUnique(a, h)) : c = u.extendFlat({}, f), l.push(c);
                        }
                    }
                }, _.supplyLayoutGlobalDefaults = function(e, t, r) {
                    function n(r, n) {
                        return u.coerce(e, t, _.layoutAttributes, r, n);
                    }
                    var a = e.template;
                    u.isPlainObject(a) && (t.template = a, t._template = a.layout, t._dataTemplate = a.data), n("autotypenumbers");
                    var i = u.coerceFont(n, "font"), o = i.size;
                    u.coerceFont(n, "title.font", u.extendFlat({}, i, {
                        size: Math.round(1.4 * o)
                    })), n("title.text", t._dfltTitle.plot), n("title.xref");
                    var s = n("title.yref");
                    n("title.pad.t"), n("title.pad.r"), n("title.pad.b"), n("title.pad.l");
                    var c = n("title.automargin");
                    n("title.x"), n("title.xanchor"), n("title.y"), n("title.yanchor"), c && ("paper" === s && (0 !== t.title.y && (t.title.y = 1), "auto" === t.title.yanchor && (t.title.yanchor = 0 === t.title.y ? "top" : "bottom")), "container" === s && ("auto" === t.title.y && (t.title.y = 1), "auto" === t.title.yanchor && (t.title.yanchor = t.title.y < .5 ? "bottom" : "top"))), n("uniformtext.mode") && n("uniformtext.minsize"), n("autosize", !(e.width && e.height)), n("width"), n("height"), n("minreducedwidth"), n("minreducedheight"), n("margin.l"), n("margin.r"), n("margin.t"), n("margin.b"), n("margin.pad"), n("margin.autoexpand"), e.width && e.height && _.sanitizeMargins(t), l.getComponentMethod("grid", "sizeDefaults")(e, t), n("paper_bgcolor"), n("separators", r.decimal + r.thousands), n("hidesources"), n("colorway"), n("datarevision");
                    var f = n("uirevision");
                    n("editrevision", f), n("selectionrevision", f), l.getComponentMethod("modebar", "supplyLayoutDefaults")(e, t), l.getComponentMethod("shapes", "supplyDrawNewShapeDefaults")(e, t, n), l.getComponentMethod("selections", "supplyDrawNewSelectionDefaults")(e, t, n), n("meta"), u.isPlainObject(e.transition) && (n("transition.duration"), n("transition.easing"), n("transition.ordering")), l.getComponentMethod("calendars", "handleDefaults")(e, t, "calendar"), l.getComponentMethod("fx", "supplyLayoutGlobalDefaults")(e, t, n), u.coerce(e, t, v, "scattermode");
                }, _.plotAutoSize = function(e, t, r) {
                    var n, a, i = e._context || {}, l = i.frameMargins, s = u.isPlotDiv(e);
                    if (s && e.emit("plotly_autosize"), i.fillFrame) n = window.innerWidth, a = window.innerHeight, document.body.style.overflow = "hidden";
                    else {
                        var c = s ? window.getComputedStyle(e) : {};
                        if (n = O(c.width) || O(c.maxWidth) || r.width, a = O(c.height) || O(c.maxHeight) || r.height, o(l) && l > 0) {
                            var f = 1 - 2 * l;
                            n = Math.round(f * n), a = Math.round(f * a);
                        }
                    }
                    var d = _.layoutAttributes.width.min, h = _.layoutAttributes.height.min;
                    n < d && (n = d), a < h && (a = h);
                    var p = !t.width && Math.abs(r.width - n) > 1, v = !t.height && Math.abs(r.height - a) > 1;
                    (v || p) && (p && (r.width = n), v && (r.height = a)), e._initialAutoSize || (e._initialAutoSize = {
                        width: n,
                        height: a
                    }), _.sanitizeMargins(r);
                }, _.supplyLayoutModuleDefaults = function(e, t, r, n) {
                    var a, i, o, s = l.componentsRegistry, c = t._basePlotModules, f = l.subplotsRegistry.cartesian;
                    for(a in s)(o = s[a]).includeBasePlot && o.includeBasePlot(e, t);
                    for(var d in c.length || c.push(f), t._has("cartesian") && (l.getComponentMethod("grid", "contentDefaults")(e, t), f.finalizeSubplots(e, t)), t._subplots)t._subplots[d].sort(u.subplotSort);
                    for(i = 0; i < c.length; i++)(o = c[i]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r);
                    var h = t._modules;
                    for(i = 0; i < h.length; i++)(o = h[i]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r);
                    var p = t._transformModules;
                    for(i = 0; i < p.length; i++)(o = p[i]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r, n);
                    for(a in s)(o = s[a]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r);
                }, _.purge = function(e) {
                    var t = e._fullLayout || {};
                    void 0 !== t._glcontainer && (t._glcontainer.selectAll(".gl-canvas").remove(), t._glcontainer.remove(), t._glcanvas = null), t._modeBar && t._modeBar.destroy(), e._transitionData && (e._transitionData._interruptCallbacks && (e._transitionData._interruptCallbacks.length = 0), e._transitionData._animationRaf && window.cancelAnimationFrame(e._transitionData._animationRaf)), u.clearThrottle(), u.clearResponsive(e), delete e.data, delete e.layout, delete e._fullData, delete e._fullLayout, delete e.calcdata, delete e.empty, delete e.fid, delete e.undoqueue, delete e.undonum, delete e.autoplay, delete e.changed, delete e._promises, delete e._redrawTimer, delete e._hmlumcount, delete e._hmpixcount, delete e._transitionData, delete e._transitioning, delete e._initialAutoSize, delete e._transitioningWithDuration, delete e._dragging, delete e._dragged, delete e._dragdata, delete e._hoverdata, delete e._snapshotInProgress, delete e._editing, delete e._mouseDownTime, delete e._legendMouseDownTime, e.removeAllListeners && e.removeAllListeners();
                }, _.style = function(e) {
                    var t, r = e._fullLayout._visibleModules, n = [];
                    for(t = 0; t < r.length; t++){
                        var a = r[t];
                        a.style && u.pushUnique(n, a.style);
                    }
                    for(t = 0; t < n.length; t++)n[t](e);
                }, _.sanitizeMargins = function(e) {
                    if (e && e.margin) {
                        var t, r = e.width, n = e.height, a = e.margin, i = r - (a.l + a.r), o = n - (a.t + a.b);
                        i < 0 && (t = (r - 1) / (a.l + a.r), a.l = Math.floor(t * a.l), a.r = Math.floor(t * a.r)), o < 0 && (t = (n - 1) / (a.t + a.b), a.t = Math.floor(t * a.t), a.b = Math.floor(t * a.b));
                    }
                }, _.clearAutoMarginIds = function(e) {
                    e._fullLayout._pushmarginIds = {};
                }, _.allowAutoMargin = function(e, t) {
                    e._fullLayout._pushmarginIds[t] = 1;
                }, _.autoMargin = function(e, t, r) {
                    var n = e._fullLayout, a = n.width, i = n.height, o = n.margin, l = n.minreducedwidth, s = n.minreducedheight, c = u.constrain(a - o.l - o.r, 2, l), f = u.constrain(i - o.t - o.b, 2, s), d = Math.max(0, a - c), h = Math.max(0, i - f), p = n._pushmargin, v = n._pushmarginIds;
                    if (!1 !== o.autoexpand) {
                        if (r) {
                            var g = r.pad;
                            if (void 0 === g && (g = Math.min(12, o.l, o.r, o.t, o.b)), d) {
                                var y = (r.l + r.r) / d;
                                y > 1 && (r.l /= y, r.r /= y);
                            }
                            if (h) {
                                var m = (r.t + r.b) / h;
                                m > 1 && (r.t /= m, r.b /= m);
                            }
                            var x = void 0 !== r.xl ? r.xl : r.x, b = void 0 !== r.xr ? r.xr : r.x, w = void 0 !== r.yt ? r.yt : r.y, T = void 0 !== r.yb ? r.yb : r.y;
                            p[t] = {
                                l: {
                                    val: x,
                                    size: r.l + g
                                },
                                r: {
                                    val: b,
                                    size: r.r + g
                                },
                                b: {
                                    val: T,
                                    size: r.b + g
                                },
                                t: {
                                    val: w,
                                    size: r.t + g
                                }
                            }, v[t] = 1;
                        } else delete p[t], delete v[t];
                        if (!n._replotting) return _.doAutoMargin(e);
                    }
                }, _.doAutoMargin = function(e) {
                    var t = e._fullLayout, r = t.width, n = t.height;
                    t._size || (t._size = {}), C(t);
                    var a = t._size, i = t.margin, s = {
                        t: 0,
                        b: 0,
                        l: 0,
                        r: 0
                    }, c = u.extendFlat({}, a), f = i.l, d = i.r, p = i.t, v = i.b, g = t._pushmargin, y = t._pushmarginIds, m = t.minreducedwidth, x = t.minreducedheight;
                    if (!1 !== i.autoexpand) {
                        for(var b in g)y[b] || delete g[b];
                        var w = e._fullLayout._reservedMargin;
                        for(var T in w)for(var M in w[T]){
                            var k = w[T][M];
                            s[M] = Math.max(s[M], k);
                        }
                        for(var A in g.base = {
                            l: {
                                val: 0,
                                size: f
                            },
                            r: {
                                val: 1,
                                size: d
                            },
                            t: {
                                val: 1,
                                size: p
                            },
                            b: {
                                val: 0,
                                size: v
                            }
                        }, s){
                            var L = 0;
                            for(var S in g)"base" !== S && o(g[S][A].size) && (L = g[S][A].size > L ? g[S][A].size : L);
                            var D = Math.max(0, i[A] - L);
                            s[A] = Math.max(0, s[A] - D);
                        }
                        for(var O in g){
                            var P = g[O].l || {}, I = g[O].b || {}, R = P.val, z = P.size, N = I.val, F = I.size, E = r - s.r - s.l, H = n - s.t - s.b;
                            for(var j in g){
                                if (o(z) && g[j].r) {
                                    var B = g[j].r.val, Y = g[j].r.size;
                                    if (B > R) {
                                        var V = (z * B + (Y - E) * R) / (B - R), U = (Y * (1 - R) + (z - E) * (1 - B)) / (B - R);
                                        V + U > f + d && (f = V, d = U);
                                    }
                                }
                                if (o(F) && g[j].t) {
                                    var q = g[j].t.val, G = g[j].t.size;
                                    if (q > N) {
                                        var Z = (F * q + (G - H) * N) / (q - N), W = (G * (1 - N) + (F - H) * (1 - q)) / (q - N);
                                        Z + W > v + p && (v = Z, p = W);
                                    }
                                }
                            }
                        }
                    }
                    var X = u.constrain(r - i.l - i.r, 2, m), J = u.constrain(n - i.t - i.b, 2, x), K = Math.max(0, r - X), Q = Math.max(0, n - J);
                    if (K) {
                        var $ = (f + d) / K;
                        $ > 1 && (f /= $, d /= $);
                    }
                    if (Q) {
                        var ee = (v + p) / Q;
                        ee > 1 && (v /= ee, p /= ee);
                    }
                    if (a.l = Math.round(f) + s.l, a.r = Math.round(d) + s.r, a.t = Math.round(p) + s.t, a.b = Math.round(v) + s.b, a.p = Math.round(i.pad), a.w = Math.round(r) - a.l - a.r, a.h = Math.round(n) - a.t - a.b, !t._replotting && (_.didMarginChange(c, a) || function(e) {
                        if ("_redrawFromAutoMarginCount" in e._fullLayout) return !1;
                        var t = h.list(e, "", !0);
                        for(var r in t)if (t[r].autoshift || t[r].shift) return !0;
                        return !1;
                    }(e))) {
                        "_redrawFromAutoMarginCount" in t ? t._redrawFromAutoMarginCount++ : t._redrawFromAutoMarginCount = 1;
                        var te = 3 * (1 + Object.keys(y).length);
                        if (t._redrawFromAutoMarginCount < te) return l.call("_doPlot", e);
                        t._size = c, u.warn("Too many auto-margin redraws.");
                    }
                    !function(e) {
                        var t = h.list(e, "", !0);
                        [
                            "_adjustTickLabelsOverflow",
                            "_hideCounterAxisInsideTickLabels"
                        ].forEach(function(e) {
                            for(var r = 0; r < t.length; r++){
                                var n = t[r][e];
                                n && n();
                            }
                        });
                    }(e);
                };
                var P = [
                    "l",
                    "r",
                    "t",
                    "b",
                    "p",
                    "w",
                    "h"
                ];
                function I(e, t, r) {
                    var n = !1, a = [
                        _.previousPromises,
                        function() {
                            if (e._transitionData) return e._transitioning = !1, function(e) {
                                var t = Promise.resolve();
                                if (!e) return t;
                                for(; e.length;)t = t.then(e.shift());
                                return t;
                            }(e._transitionData._interruptCallbacks);
                        },
                        r.prepareFn,
                        _.rehover,
                        _.reselect,
                        function() {
                            return e.emit("plotly_transitioning", []), new Promise(function(a) {
                                e._transitioning = !0, t.duration > 0 && (e._transitioningWithDuration = !0), e._transitionData._interruptCallbacks.push(function() {
                                    n = !0;
                                }), r.redraw && e._transitionData._interruptCallbacks.push(function() {
                                    return l.call("redraw", e);
                                }), e._transitionData._interruptCallbacks.push(function() {
                                    e.emit("plotly_transitioninterrupted", []);
                                });
                                var i = 0, o = 0;
                                function s() {
                                    return i++, function() {
                                        var t;
                                        o++, n || o !== i || (t = a, e._transitionData && (function(e) {
                                            if (e) for(; e.length;)e.shift();
                                        }(e._transitionData._interruptCallbacks), Promise.resolve().then(function() {
                                            if (r.redraw) return l.call("redraw", e);
                                        }).then(function() {
                                            e._transitioning = !1, e._transitioningWithDuration = !1, e.emit("plotly_transitioned", []);
                                        }).then(t)));
                                    };
                                }
                                r.runFn(s), setTimeout(s());
                            });
                        }
                    ], i = u.syncOrAsync(a, e);
                    return i && i.then || (i = Promise.resolve()), i.then(function() {
                        return e;
                    });
                }
                _.didMarginChange = function(e, t) {
                    for(var r = 0; r < P.length; r++){
                        var n = P[r], a = e[n], i = t[n];
                        if (!o(a) || Math.abs(i - a) > 1) return !0;
                    }
                    return !1;
                }, _.graphJson = function(e, t, r, n, a, i) {
                    (a && t && !e._fullData || a && !t && !e._fullLayout) && _.supplyDefaults(e);
                    var o = a ? e._fullData : e.data, l = a ? e._fullLayout : e.layout, s = (e._transitionData || {})._frames;
                    function c(e, t) {
                        if ("function" == typeof e) return t ? "_function_" : null;
                        if (u.isPlainObject(e)) {
                            var n, a = {};
                            return Object.keys(e).sort().forEach(function(i) {
                                if (-1 === [
                                    "_",
                                    "["
                                ].indexOf(i.charAt(0))) {
                                    if ("function" != typeof e[i]) {
                                        if ("keepdata" === r) {
                                            if ("src" === i.substr(i.length - 3)) return;
                                        } else if ("keepstream" === r) {
                                            if ("string" == typeof (n = e[i + "src"]) && n.indexOf(":") > 0 && !u.isPlainObject(e.stream)) return;
                                        } else if ("keepall" !== r && "string" == typeof (n = e[i + "src"]) && n.indexOf(":") > 0) return;
                                        a[i] = c(e[i], t);
                                    } else t && (a[i] = "_function");
                                }
                            }), a;
                        }
                        return Array.isArray(e) ? e.map(function(e) {
                            return c(e, t);
                        }) : u.isTypedArray(e) ? u.simpleMap(e, u.identity) : u.isJSDate(e) ? u.ms2DateTimeLocal(+e) : e;
                    }
                    var f = {
                        data: (o || []).map(function(e) {
                            var r = c(e);
                            return t && delete r.fit, r;
                        })
                    };
                    if (!t && (f.layout = c(l), a)) {
                        var d = l._size;
                        f.layout.computed = {
                            margin: {
                                b: d.b,
                                l: d.l,
                                r: d.r,
                                t: d.t
                            }
                        };
                    }
                    return s && (f.frames = c(s)), i && (f.config = c(e._context, !0)), "object" === n ? f : JSON.stringify(f);
                }, _.modifyFrames = function(e, t) {
                    var r, n, a, i = e._transitionData._frames, o = e._transitionData._frameHash;
                    for(r = 0; r < t.length; r++)switch((n = t[r]).type){
                        case "replace":
                            a = n.value;
                            var l = (i[n.index] || {}).name, s = a.name;
                            i[n.index] = o[s] = a, s !== l && (delete o[l], o[s] = a);
                            break;
                        case "insert":
                            o[(a = n.value).name] = a, i.splice(n.index, 0, a);
                            break;
                        case "delete":
                            delete o[(a = i[n.index]).name], i.splice(n.index, 1);
                    }
                    return Promise.resolve();
                }, _.computeFrame = function(e, t) {
                    var r, n, a, i, o = e._transitionData._frameHash;
                    if (!t) throw new Error("computeFrame must be given a string frame name");
                    var l = o[t.toString()];
                    if (!l) return !1;
                    for(var s = [
                        l
                    ], c = [
                        l.name
                    ]; l.baseframe && (l = o[l.baseframe.toString()]) && -1 === c.indexOf(l.name);)s.push(l), c.push(l.name);
                    for(var u = {}; l = s.pop();)if (l.layout && (u.layout = _.extendLayout(u.layout, l.layout)), l.data) {
                        if (u.data || (u.data = []), !(n = l.traces)) for(n = [], r = 0; r < l.data.length; r++)n[r] = r;
                        for(u.traces || (u.traces = []), r = 0; r < l.data.length; r++)null != (a = n[r]) && (-1 === (i = u.traces.indexOf(a)) && (i = u.data.length, u.traces[i] = a), u.data[i] = _.extendTrace(u.data[i], l.data[r]));
                    }
                    return u;
                }, _.recomputeFrameHash = function(e) {
                    for(var t = e._transitionData._frameHash = {}, r = e._transitionData._frames, n = 0; n < r.length; n++){
                        var a = r[n];
                        a && a.name && (t[a.name] = a);
                    }
                }, _.extendObjectWithContainers = function(e, t, r) {
                    var n, a, i, o, l, s, c, f = u.extendDeepNoArrays({}, t || {}), d = u.expandObjectPaths(f), h = {};
                    if (r && r.length) for(i = 0; i < r.length; i++)void 0 === (a = (n = u.nestedProperty(d, r[i])).get()) ? u.nestedProperty(h, r[i]).set(null) : (n.set(null), u.nestedProperty(h, r[i]).set(a));
                    if (e = u.extendDeepNoArrays(e || {}, d), r && r.length) {
                        for(i = 0; i < r.length; i++)if (s = u.nestedProperty(h, r[i]).get()) {
                            for(c = (l = u.nestedProperty(e, r[i])).get(), Array.isArray(c) || (c = [], l.set(c)), o = 0; o < s.length; o++){
                                var p = s[o];
                                c[o] = null === p ? null : _.extendObjectWithContainers(c[o], p);
                            }
                            l.set(c);
                        }
                    }
                    return e;
                }, _.dataArrayContainers = [
                    "transforms",
                    "dimensions"
                ], _.layoutArrayContainers = l.layoutArrayContainers, _.extendTrace = function(e, t) {
                    return _.extendObjectWithContainers(e, t, _.dataArrayContainers);
                }, _.extendLayout = function(e, t) {
                    return _.extendObjectWithContainers(e, t, _.layoutArrayContainers);
                }, _.transition = function(e, t, r, n, a, i) {
                    var o = {
                        redraw: a.redraw
                    }, l = {}, s = [];
                    return o.prepareFn = function() {
                        for(var a = Array.isArray(t) ? t.length : 0, i = n.slice(0, a), o = 0; o < i.length; o++){
                            var c = i[o], f = e._fullData[c]._module;
                            if (f) {
                                if (f.animatable) {
                                    var d = f.basePlotModule.name;
                                    l[d] || (l[d] = []), l[d].push(c);
                                }
                                e.data[i[o]] = _.extendTrace(e.data[i[o]], t[o]);
                            }
                        }
                        var h = u.expandObjectPaths(u.extendDeepNoArrays({}, r)), p = /^[xy]axis[0-9]*$/;
                        for(var v in h)p.test(v) && delete h[v].range;
                        _.extendLayout(e.layout, h), delete e.calcdata, _.supplyDefaults(e), _.doCalcdata(e);
                        var g = u.expandObjectPaths(r);
                        if (g) {
                            var y = e._fullLayout._plots;
                            for(var m in y){
                                var x = y[m], b = x.xaxis, w = x.yaxis, T = b.range.slice(), M = w.range.slice(), k = null, A = null, L = null, S = null;
                                Array.isArray(g[b._name + ".range"]) ? k = g[b._name + ".range"].slice() : Array.isArray((g[b._name] || {}).range) && (k = g[b._name].range.slice()), Array.isArray(g[w._name + ".range"]) ? A = g[w._name + ".range"].slice() : Array.isArray((g[w._name] || {}).range) && (A = g[w._name].range.slice()), T && k && (b.r2l(T[0]) !== b.r2l(k[0]) || b.r2l(T[1]) !== b.r2l(k[1])) && (L = {
                                    xr0: T,
                                    xr1: k
                                }), M && A && (w.r2l(M[0]) !== w.r2l(A[0]) || w.r2l(M[1]) !== w.r2l(A[1])) && (S = {
                                    yr0: M,
                                    yr1: A
                                }), (L || S) && s.push(u.extendFlat({
                                    plotinfo: x
                                }, L, S));
                            }
                        }
                        return Promise.resolve();
                    }, o.runFn = function(t) {
                        var n, a, o = e._fullLayout._basePlotModules, c = s.length;
                        if (r) for(a = 0; a < o.length; a++)o[a].transitionAxes && o[a].transitionAxes(e, s, i, t);
                        for(var f in c ? ((n = u.extendFlat({}, i)).duration = 0, delete l.cartesian) : n = i, l){
                            var d = l[f];
                            e._fullData[d[0]]._module.basePlotModule.plot(e, d, n, t);
                        }
                    }, I(e, i, o);
                }, _.transitionFromReact = function(e, t, r, n) {
                    var a = e._fullLayout, i = a.transition, o = {}, l = [];
                    return o.prepareFn = function() {
                        var e = a._plots;
                        for(var i in o.redraw = !1, "some" === t.anim && (o.redraw = !0), "some" === r.anim && (o.redraw = !0), e){
                            var s = e[i], c = s.xaxis, f = s.yaxis, d = n[c._name].range.slice(), h = n[f._name].range.slice(), p = c.range.slice(), v = f.range.slice();
                            c.setScale(), f.setScale();
                            var g = null, y = null;
                            c.r2l(d[0]) === c.r2l(p[0]) && c.r2l(d[1]) === c.r2l(p[1]) || (g = {
                                xr0: d,
                                xr1: p
                            }), f.r2l(h[0]) === f.r2l(v[0]) && f.r2l(h[1]) === f.r2l(v[1]) || (y = {
                                yr0: h,
                                yr1: v
                            }), (g || y) && l.push(u.extendFlat({
                                plotinfo: s
                            }, g, y));
                        }
                        return Promise.resolve();
                    }, o.runFn = function(r) {
                        for(var n, a, o, s = e._fullData, c = e._fullLayout._basePlotModules, f = [], d = 0; d < s.length; d++)f.push(d);
                        function h() {
                            if (e._fullLayout) for(var t = 0; t < c.length; t++)c[t].transitionAxes && c[t].transitionAxes(e, l, n, r);
                        }
                        function p() {
                            if (e._fullLayout) for(var t = 0; t < c.length; t++)c[t].plot(e, o, a, r);
                        }
                        l.length && t.anim ? "traces first" === i.ordering ? (n = u.extendFlat({}, i, {
                            duration: 0
                        }), o = f, a = i, setTimeout(h, i.duration), p()) : (n = i, o = null, a = u.extendFlat({}, i, {
                            duration: 0
                        }), setTimeout(p, n.duration), h()) : l.length ? (n = i, h()) : t.anim && (o = f, a = i, p());
                    }, I(e, i, o);
                }, _.doCalcdata = function(e, t) {
                    var r, n, a, i, o = h.list(e), c = e._fullData, f = e._fullLayout, p = new Array(c.length), v = (e.calcdata || []).slice();
                    for(e.calcdata = p, f._numBoxes = 0, f._numViolins = 0, f._violinScaleGroupStats = {}, e._hmpixcount = 0, e._hmlumcount = 0, f._piecolormap = {}, f._sunburstcolormap = {}, f._treemapcolormap = {}, f._iciclecolormap = {}, f._funnelareacolormap = {}, a = 0; a < c.length; a++)Array.isArray(t) && -1 === t.indexOf(a) && (p[a] = v[a]);
                    for(a = 0; a < c.length; a++)(r = c[a])._arrayAttrs = s.findArrayAttributes(r), r._extremes = {};
                    var g = f._subplots.polar || [];
                    for(a = 0; a < g.length; a++)o.push(f[g[a]].radialaxis, f[g[a]].angularaxis);
                    for(var y in f._colorAxes){
                        var m = f[y];
                        !1 !== m.cauto && (delete m.cmin, delete m.cmax);
                    }
                    var x = !1;
                    function b(t) {
                        if (r = c[t], n = r._module, !0 === r.visible && r.transforms) {
                            if (n && n.calc) {
                                var a = n.calc(e, r);
                                a[0] && a[0].t && a[0].t._scene && delete a[0].t._scene.dirty;
                            }
                            for(i = 0; i < r.transforms.length; i++){
                                var o = r.transforms[i];
                                (n = w[o.type]) && n.calcTransform && (r._hasCalcTransform = !0, x = !0, n.calcTransform(e, r, o));
                            }
                        }
                    }
                    function _(t, a) {
                        if (r = c[t], !!(n = r._module).isContainer === a) {
                            var o = [];
                            if (!0 === r.visible && 0 !== r._length) {
                                delete r._indexToPoints;
                                var l = r.transforms || [];
                                for(i = l.length - 1; i >= 0; i--)if (l[i].enabled) {
                                    r._indexToPoints = l[i]._indexToPoints;
                                    break;
                                }
                                n && n.calc && (o = n.calc(e, r));
                            }
                            Array.isArray(o) && o[0] || (o = [
                                {
                                    x: d,
                                    y: d
                                }
                            ]), o[0].t || (o[0].t = {}), o[0].trace = r, p[t] = o;
                        }
                    }
                    for(z(o, c, f), a = 0; a < c.length; a++)_(a, !0);
                    for(a = 0; a < c.length; a++)b(a);
                    for(x && z(o, c, f), a = 0; a < c.length; a++)_(a, !0);
                    for(a = 0; a < c.length; a++)_(a, !1);
                    N(e);
                    var T = function(e, t) {
                        var r, n, a, i, o, s = [];
                        function c(e, r, n) {
                            var a = r._id.charAt(0);
                            if ("histogram2dcontour" === e) {
                                var i = r._counterAxes[0], o = h.getFromId(t, i), l = "x" === a || "x" === i && "category" === o.type, s = "y" === a || "y" === i && "category" === o.type;
                                return function(e, t) {
                                    return 0 === e || 0 === t || l && e === n[t].length - 1 || s && t === n.length - 1 ? -1 : ("y" === a ? t : e) - 1;
                                };
                            }
                            return function(e, t) {
                                return "y" === a ? t : e;
                            };
                        }
                        var f = {
                            min: function(e) {
                                return u.aggNums(Math.min, null, e);
                            },
                            max: function(e) {
                                return u.aggNums(Math.max, null, e);
                            },
                            sum: function(e) {
                                return u.aggNums(function(e, t) {
                                    return e + t;
                                }, null, e);
                            },
                            total: function(e) {
                                return u.aggNums(function(e, t) {
                                    return e + t;
                                }, null, e);
                            },
                            mean: function(e) {
                                return u.mean(e);
                            },
                            median: function(e) {
                                return u.median(e);
                            }
                        };
                        for(r = 0; r < e.length; r++){
                            var d = e[r];
                            if ("category" === d.type) {
                                var p = d.categoryorder.match(R);
                                if (p) {
                                    var v = p[1], g = p[2], y = d._id.charAt(0), m = "x" === y, x = [];
                                    for(n = 0; n < d._categories.length; n++)x.push([
                                        d._categories[n],
                                        []
                                    ]);
                                    for(n = 0; n < d._traceIndices.length; n++){
                                        var b = d._traceIndices[n], _ = t._fullData[b];
                                        if (!0 === _.visible) {
                                            var w = _.type;
                                            l.traceIs(_, "histogram") && (delete _._xautoBinFinished, delete _._yautoBinFinished);
                                            var T = "splom" === w, M = "scattergl" === w, k = t.calcdata[b];
                                            for(a = 0; a < k.length; a++){
                                                var A, L, S = k[a];
                                                if (T) {
                                                    var D = _._axesDim[d._id];
                                                    if (!m) {
                                                        var O = _._diag[D][0];
                                                        O && (d = t._fullLayout[h.id2name(O)]);
                                                    }
                                                    var C = S.trace.dimensions[D].values;
                                                    for(i = 0; i < C.length; i++)for(A = d._categoriesMap[C[i]], o = 0; o < S.trace.dimensions.length; o++)if (o !== D) {
                                                        var P = S.trace.dimensions[o];
                                                        x[A][1].push(P.values[i]);
                                                    }
                                                } else if (M) {
                                                    for(i = 0; i < S.t.x.length; i++)m ? (A = S.t.x[i], L = S.t.y[i]) : (A = S.t.y[i], L = S.t.x[i]), x[A][1].push(L);
                                                    S.t && S.t._scene && delete S.t._scene.dirty;
                                                } else if (S.hasOwnProperty("z")) {
                                                    L = S.z;
                                                    var I = c(_.type, d, L);
                                                    for(i = 0; i < L.length; i++)for(o = 0; o < L[i].length; o++)(A = I(o, i)) + 1 && x[A][1].push(L[i][o]);
                                                } else for(void 0 === (A = S.p) && (A = S[y]), void 0 === (L = S.s) && (L = S.v), void 0 === L && (L = m ? S.y : S.x), Array.isArray(L) || (L = void 0 === L ? [] : [
                                                    L
                                                ]), i = 0; i < L.length; i++)x[A][1].push(L[i]);
                                            }
                                        }
                                    }
                                    d._categoriesValue = x;
                                    var z = [];
                                    for(n = 0; n < x.length; n++)z.push([
                                        x[n][0],
                                        f[v](x[n][1])
                                    ]);
                                    z.sort(function(e, t) {
                                        return e[1] - t[1];
                                    }), d._categoriesAggregatedValue = z, d._initialCategories = z.map(function(e) {
                                        return e[0];
                                    }), "descending" === g && d._initialCategories.reverse(), s = s.concat(d.sortByInitialCategories());
                                }
                            }
                        }
                        return s;
                    }(o, e);
                    if (T.length) {
                        for(f._numBoxes = 0, f._numViolins = 0, a = 0; a < T.length; a++)_(T[a], !0);
                        for(a = 0; a < T.length; a++)_(T[a], !1);
                        N(e);
                    }
                    l.getComponentMethod("fx", "calc")(e), l.getComponentMethod("errorbars", "calc")(e);
                };
                var R = /(total|sum|min|max|mean|median) (ascending|descending)/;
                function z(e, t, r) {
                    var n = {};
                    function a(e) {
                        e.clearCalc(), "multicategory" === e.type && e.setupMultiCategory(t), n[e._id] = 1;
                    }
                    u.simpleMap(e, a);
                    for(var i = r._axisMatchGroups || [], o = 0; o < i.length; o++)for(var l in i[o])n[l] || a(r[h.id2name(l)]);
                }
                function N(e) {
                    var t, r, n, a = e._fullLayout, i = a._visibleModules, o = {};
                    for(r = 0; r < i.length; r++){
                        var l = i[r], s = l.crossTraceCalc;
                        if (s) {
                            var c = l.basePlotModule.name;
                            o[c] ? u.pushUnique(o[c], s) : o[c] = [
                                s
                            ];
                        }
                    }
                    for(n in o){
                        var f = o[n], d = a._subplots[n];
                        if (Array.isArray(d)) for(t = 0; t < d.length; t++){
                            var h = d[t], p = "cartesian" === n ? a._plots[h] : a[h];
                            for(r = 0; r < f.length; r++)f[r](e, p, h);
                        }
                        else for(r = 0; r < f.length; r++)f[r](e);
                    }
                }
                _.rehover = function(e) {
                    e._fullLayout._rehover && e._fullLayout._rehover();
                }, _.redrag = function(e) {
                    e._fullLayout._redrag && e._fullLayout._redrag();
                }, _.reselect = function(e) {
                    var t = e._fullLayout, r = (e.layout || {}).selections, n = t._previousSelections;
                    t._previousSelections = r;
                    var a = t._reselect || JSON.stringify(r) !== JSON.stringify(n);
                    l.getComponentMethod("selections", "reselect")(e, a);
                }, _.generalUpdatePerTraceModule = function(e, t, r, n) {
                    var a, i = t.traceHash, o = {};
                    for(a = 0; a < r.length; a++){
                        var l = r[a], s = l[0].trace;
                        s.visible && (o[s.type] = o[s.type] || [], o[s.type].push(l));
                    }
                    for(var c in i)if (!o[c]) {
                        var f = i[c][0];
                        f[0].trace.visible = !1, o[c] = [
                            f
                        ];
                    }
                    for(var d in o){
                        var h = o[d];
                        h[0][0].trace._module.plot(e, t, u.filterVisible(h), n);
                    }
                    t.traceHash = o;
                }, _.plotBasePlot = function(e, t, r, n, a) {
                    var i = l.getModule(e), o = m(t.calcdata, i)[0];
                    i.plot(t, o, n, a);
                }, _.cleanBasePlot = function(e, t, r, n, a) {
                    var i = a._has && a._has(e), o = r._has && r._has(e);
                    i && !o && a["_" + e + "layer"].selectAll("g.trace").remove();
                };
            },
            5386: function(e, t, r) {
                "use strict";
                var n = r(1562);
                function a(e) {
                    var t = e.description ? " " + e.description : "", r = e.keys || [];
                    if (r.length > 0) {
                        for(var n = [], a = 0; a < r.length; a++)n[a] = "`" + r[a] + "`";
                        t += "Finally, the template string has access to ", t = 1 === r.length ? t + "variable " + n[0] : t + "variables " + n.slice(0, -1).join(", ") + " and " + n.slice(-1) + ".";
                    }
                    return t;
                }
                n.FORMAT_LINK, n.DATE_FORMAT_LINK, t.fF = function(e, t) {
                    e = e || {}, a(t = t || {});
                    var r = {
                        valType: "string",
                        dflt: "",
                        editType: e.editType || "none"
                    };
                    return !1 !== e.arrayOk && (r.arrayOk = !0), r;
                }, t.si = function(e, t) {
                    e = e || {}, a(t = t || {});
                    var r = {
                        valType: "string",
                        dflt: "",
                        editType: e.editType || "calc"
                    };
                    return !1 !== e.arrayOk && (r.arrayOk = !0), r;
                }, t.R = function(e, t) {
                    return t = t || {}, (e = e || {}).newshape, a(t), {
                        valType: "string",
                        dflt: "",
                        editType: e.editType || "arraydraw"
                    };
                };
            },
            3972: function(e, t, r) {
                "use strict";
                var n = r(7769), a = r(4213), i = r(5138), o = r(1965), l = r(4401).addStyleRule, s = r(1426), c = r(9012), u = r(820), f = s.extendFlat, d = s.extendDeepAll;
                function h(e) {
                    var r = e.name, a = e.categories, i = e.meta;
                    if (t.modules[r]) n.log("Type " + r + " already registered");
                    else {
                        t.subplotsRegistry[e.basePlotModule.name] || function(e) {
                            var r = e.name;
                            if (t.subplotsRegistry[r]) n.log("Plot type " + r + " already registered.");
                            else for(var a in y(e), t.subplotsRegistry[r] = e, t.componentsRegistry)b(a, e.name);
                        }(e.basePlotModule);
                        for(var o = {}, s = 0; s < a.length; s++)o[a[s]] = !0, t.allCategories[a[s]] = !0;
                        for(var c in t.modules[r] = {
                            _module: e,
                            categories: o
                        }, i && Object.keys(i).length && (t.modules[r].meta = i), t.allTypes.push(r), t.componentsRegistry)m(c, r);
                        e.layoutAttributes && f(t.traceLayoutAttributes, e.layoutAttributes);
                        var u = e.basePlotModule, d = u.name;
                        if ("mapbox" === d) {
                            var h = u.constants.styleRules;
                            for(var p in h)l(".js-plotly-plot .plotly .mapboxgl-" + p, h[p]);
                        }
                        "geo" !== d && "mapbox" !== d || void 0 !== window.PlotlyGeoAssets || (window.PlotlyGeoAssets = {
                            topojson: {}
                        });
                    }
                }
                function p(e) {
                    if ("string" != typeof e.name) throw new Error("Component module *name* must be a string.");
                    var r = e.name;
                    for(var n in t.componentsRegistry[r] = e, e.layoutAttributes && (e.layoutAttributes._isLinkedToArray && i(t.layoutArrayContainers, r), y(e)), t.modules)m(r, n);
                    for(var a in t.subplotsRegistry)b(r, a);
                    for(var o in t.transformsRegistry)x(r, o);
                    e.schema && e.schema.layout && d(u, e.schema.layout);
                }
                function v(e) {
                    if ("string" != typeof e.name) throw new Error("Transform module *name* must be a string.");
                    var r = "Transform module " + e.name, a = "function" == typeof e.transform, i = "function" == typeof e.calcTransform;
                    if (!a && !i) throw new Error(r + " is missing a *transform* or *calcTransform* method.");
                    for(var l in a && i && n.log([
                        r + " has both a *transform* and *calcTransform* methods.",
                        "Please note that all *transform* methods are executed",
                        "before all *calcTransform* methods."
                    ].join(" ")), o(e.attributes) || n.log(r + " registered without an *attributes* object."), "function" != typeof e.supplyDefaults && n.log(r + " registered without a *supplyDefaults* method."), t.transformsRegistry[e.name] = e, t.componentsRegistry)x(l, e.name);
                }
                function g(e) {
                    var r = e.name, n = r.split("-")[0], a = e.dictionary, i = e.format, o = a && Object.keys(a).length, l = i && Object.keys(i).length, s = t.localeRegistry, c = s[r];
                    if (c || (s[r] = c = {}), n !== r) {
                        var u = s[n];
                        u || (s[n] = u = {}), o && u.dictionary === c.dictionary && (u.dictionary = a), l && u.format === c.format && (u.format = i);
                    }
                    o && (c.dictionary = a), l && (c.format = i);
                }
                function y(e) {
                    if (e.layoutAttributes) {
                        var r = e.layoutAttributes._arrayAttrRegexps;
                        if (r) for(var n = 0; n < r.length; n++)i(t.layoutArrayRegexes, r[n]);
                    }
                }
                function m(e, r) {
                    var n = t.componentsRegistry[e].schema;
                    if (n && n.traces) {
                        var a = n.traces[r];
                        a && d(t.modules[r]._module.attributes, a);
                    }
                }
                function x(e, r) {
                    var n = t.componentsRegistry[e].schema;
                    if (n && n.transforms) {
                        var a = n.transforms[r];
                        a && d(t.transformsRegistry[r].attributes, a);
                    }
                }
                function b(e, r) {
                    var n = t.componentsRegistry[e].schema;
                    if (n && n.subplots) {
                        var a = t.subplotsRegistry[r], i = a.layoutAttributes, o = "subplot" === a.attr ? a.name : a.attr;
                        Array.isArray(o) && (o = o[0]);
                        var l = n.subplots[o];
                        i && l && d(i, l);
                    }
                }
                function _(e) {
                    return "object" == typeof e && (e = e.type), e;
                }
                t.modules = {}, t.allCategories = {}, t.allTypes = [], t.subplotsRegistry = {}, t.transformsRegistry = {}, t.componentsRegistry = {}, t.layoutArrayContainers = [], t.layoutArrayRegexes = [], t.traceLayoutAttributes = {}, t.localeRegistry = {}, t.apiMethodRegistry = {}, t.collectableSubplotTypes = null, t.register = function(e) {
                    if (t.collectableSubplotTypes = null, !e) throw new Error("No argument passed to Plotly.register.");
                    e && !Array.isArray(e) && (e = [
                        e
                    ]);
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        if (!n) throw new Error("Invalid module was attempted to be registered!");
                        switch(n.moduleType){
                            case "trace":
                                h(n);
                                break;
                            case "transform":
                                v(n);
                                break;
                            case "component":
                                p(n);
                                break;
                            case "locale":
                                g(n);
                                break;
                            case "apiMethod":
                                var a = n.name;
                                t.apiMethodRegistry[a] = n.fn;
                                break;
                            default:
                                throw new Error("Invalid module was attempted to be registered!");
                        }
                    }
                }, t.getModule = function(e) {
                    var r = t.modules[_(e)];
                    return !!r && r._module;
                }, t.traceIs = function(e, r) {
                    if ("various" === (e = _(e))) return !1;
                    var a = t.modules[e];
                    return a || (e && n.log("Unrecognized trace type " + e + "."), a = t.modules[c.type.dflt]), !!a.categories[r];
                }, t.getTransformIndices = function(e, t) {
                    for(var r = [], n = e.transforms || [], a = 0; a < n.length; a++)n[a].type === t && r.push(a);
                    return r;
                }, t.hasTransform = function(e, t) {
                    for(var r = e.transforms || [], n = 0; n < r.length; n++)if (r[n].type === t) return !0;
                    return !1;
                }, t.getComponentMethod = function(e, r) {
                    var n = t.componentsRegistry[e];
                    return n && n[r] || a;
                }, t.call = function() {
                    var e = arguments[0], r = [].slice.call(arguments, 1);
                    return t.apiMethodRegistry[e].apply(null, r);
                };
            },
            1914: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(1828), i = a.extendFlat, o = a.extendDeep;
                function l(e) {
                    var t;
                    switch(e){
                        case "themes__thumb":
                            t = {
                                autosize: !0,
                                width: 150,
                                height: 150,
                                title: {
                                    text: ""
                                },
                                showlegend: !1,
                                margin: {
                                    l: 5,
                                    r: 5,
                                    t: 5,
                                    b: 5,
                                    pad: 0
                                },
                                annotations: []
                            };
                            break;
                        case "thumbnail":
                            t = {
                                title: {
                                    text: ""
                                },
                                hidesources: !0,
                                showlegend: !1,
                                borderwidth: 0,
                                bordercolor: "",
                                margin: {
                                    l: 1,
                                    r: 1,
                                    t: 1,
                                    b: 1,
                                    pad: 0
                                },
                                annotations: []
                            };
                            break;
                        default:
                            t = {};
                    }
                    return t;
                }
                e.exports = function(e, t) {
                    var r, a, s = e.data, c = e.layout, u = o([], s), f = o({}, c, l(t.tileClass)), d = e._context || {};
                    if (t.width && (f.width = t.width), t.height && (f.height = t.height), "thumbnail" === t.tileClass || "themes__thumb" === t.tileClass) {
                        f.annotations = [];
                        var h = Object.keys(f);
                        for(r = 0; r < h.length; r++)a = h[r], [
                            "xaxis",
                            "yaxis",
                            "zaxis"
                        ].indexOf(a.slice(0, 5)) > -1 && (f[h[r]].title = {
                            text: ""
                        });
                        for(r = 0; r < u.length; r++){
                            var p = u[r];
                            p.showscale = !1, p.marker && (p.marker.showscale = !1), n.traceIs(p, "pie-like") && (p.textposition = "none");
                        }
                    }
                    if (Array.isArray(t.annotations)) for(r = 0; r < t.annotations.length; r++)f.annotations.push(t.annotations[r]);
                    var v = Object.keys(f).filter(function(e) {
                        return e.match(/^scene\d*$/);
                    });
                    if (v.length) {
                        var g = {};
                        for("thumbnail" === t.tileClass && (g = {
                            title: {
                                text: ""
                            },
                            showaxeslabels: !1,
                            showticklabels: !1,
                            linetickenable: !1
                        }), r = 0; r < v.length; r++){
                            var y = f[v[r]];
                            y.xaxis || (y.xaxis = {}), y.yaxis || (y.yaxis = {}), y.zaxis || (y.zaxis = {}), i(y.xaxis, g), i(y.yaxis, g), i(y.zaxis, g), y._scene = null;
                        }
                    }
                    var m = document.createElement("div");
                    t.tileClass && (m.className = t.tileClass);
                    var x = {
                        gd: m,
                        td: m,
                        layout: f,
                        data: u,
                        config: {
                            staticPlot: void 0 === t.staticPlot || t.staticPlot,
                            plotGlPixelRatio: void 0 === t.plotGlPixelRatio ? 2 : t.plotGlPixelRatio,
                            displaylogo: t.displaylogo || !1,
                            showLink: t.showLink || !1,
                            showTips: t.showTips || !1,
                            mapboxAccessToken: d.mapboxAccessToken
                        }
                    };
                    return "transparent" !== t.setBackground && (x.config.setBackground = t.setBackground || "opaque"), x.gd.defaultLayout = l(t.tileClass), x;
                };
            },
            7239: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(403), i = r(2435), o = r(5095);
                e.exports = function(e, t) {
                    var r;
                    return n.isPlainObject(e) || (r = n.getGraphDiv(e)), (t = t || {}).format = t.format || "png", t.width = t.width || null, t.height = t.height || null, t.imageDataOnly = !0, new Promise(function(l, s) {
                        r && r._snapshotInProgress && s(new Error("Snapshotting already in progress.")), n.isIE() && "svg" !== t.format && s(new Error(o.MSG_IE_BAD_FORMAT)), r && (r._snapshotInProgress = !0);
                        var c = a(e, t), u = t.filename || e.fn || "newplot";
                        u += "." + t.format.replace("-", "."), c.then(function(e) {
                            return r && (r._snapshotInProgress = !1), i(e, u, t.format);
                        }).then(function(e) {
                            l(e);
                        }).catch(function(e) {
                            r && (r._snapshotInProgress = !1), s(e);
                        });
                    });
                };
            },
            2435: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(5095);
                e.exports = function(e, t, r) {
                    var i = document.createElement("a"), o = "download" in i;
                    return new Promise(function(l, s) {
                        var c, u;
                        if (n.isIE()) return c = a.createBlob(e, "svg"), window.navigator.msSaveBlob(c, t), c = null, l(t);
                        if (o) return c = a.createBlob(e, r), u = a.createObjectURL(c), i.href = u, i.download = t, document.body.appendChild(i), i.click(), document.body.removeChild(i), a.revokeObjectURL(u), c = null, l(t);
                        if (n.isSafari()) {
                            var f = "svg" === r ? "," : ";base64,";
                            return a.octetStream(f + encodeURIComponent(e)), l(t);
                        }
                        s(new Error("download error"));
                    });
                };
            },
            5095: function(e, t, r) {
                "use strict";
                var n = r(3972);
                t.getDelay = function(e) {
                    return e._has && (e._has("gl3d") || e._has("gl2d") || e._has("mapbox")) ? 500 : 0;
                }, t.getRedrawFunc = function(e) {
                    return function() {
                        n.getComponentMethod("colorbar", "draw")(e);
                    };
                }, t.encodeSVG = function(e) {
                    return "data:image/svg+xml," + encodeURIComponent(e);
                }, t.encodeJSON = function(e) {
                    return "data:application/json," + encodeURIComponent(e);
                };
                var a = window.URL || window.webkitURL;
                t.createObjectURL = function(e) {
                    return a.createObjectURL(e);
                }, t.revokeObjectURL = function(e) {
                    return a.revokeObjectURL(e);
                }, t.createBlob = function(e, t) {
                    if ("svg" === t) return new window.Blob([
                        e
                    ], {
                        type: "image/svg+xml;charset=utf-8"
                    });
                    if ("full-json" === t) return new window.Blob([
                        e
                    ], {
                        type: "application/json;charset=utf-8"
                    });
                    var r = function(e) {
                        for(var t = e.length, r = new ArrayBuffer(t), n = new Uint8Array(r), a = 0; a < t; a++)n[a] = e.charCodeAt(a);
                        return r;
                    }(window.atob(e));
                    return new window.Blob([
                        r
                    ], {
                        type: "image/" + t
                    });
                }, t.octetStream = function(e) {
                    document.location.href = "data:application/octet-stream" + e;
                }, t.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/, t.MSG_IE_BAD_FORMAT = "Sorry IE does not support downloading from canvas. Try {format:'svg'} instead.";
            },
            4511: function(e, t, r) {
                "use strict";
                var n = r(5095), a = {
                    getDelay: n.getDelay,
                    getRedrawFunc: n.getRedrawFunc,
                    clone: r(1914),
                    toSVG: r(5900),
                    svgToImg: r(942),
                    toImage: r(6395),
                    downloadImage: r(7239)
                };
                e.exports = a;
            },
            942: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(5398).EventEmitter, i = r(5095);
                e.exports = function(e) {
                    var t = e.emitter || new a, r = new Promise(function(a, o) {
                        var l = window.Image, s = e.svg, c = e.format || "png";
                        if (n.isIE() && "svg" !== c) {
                            var u = new Error(i.MSG_IE_BAD_FORMAT);
                            return o(u), e.promise ? r : t.emit("error", u);
                        }
                        var f, d, h = e.canvas, p = e.scale || 1, v = e.width || 300, g = e.height || 150, y = p * v, m = p * g, x = h.getContext("2d", {
                            willReadFrequently: !0
                        }), b = new l;
                        "svg" === c || n.isSafari() ? d = i.encodeSVG(s) : (f = i.createBlob(s, "svg"), d = i.createObjectURL(f)), h.width = y, h.height = m, b.onload = function() {
                            var r;
                            switch(f = null, i.revokeObjectURL(d), "svg" !== c && x.drawImage(b, 0, 0, y, m), c){
                                case "jpeg":
                                    r = h.toDataURL("image/jpeg");
                                    break;
                                case "png":
                                    r = h.toDataURL("image/png");
                                    break;
                                case "webp":
                                    r = h.toDataURL("image/webp");
                                    break;
                                case "svg":
                                    r = d;
                                    break;
                                default:
                                    var n = "Image format is not jpeg, png, svg or webp.";
                                    if (o(new Error(n)), !e.promise) return t.emit("error", n);
                            }
                            a(r), e.promise || t.emit("success", r);
                        }, b.onerror = function(r) {
                            if (f = null, i.revokeObjectURL(d), o(r), !e.promise) return t.emit("error", r);
                        }, b.src = d;
                    });
                    return e.promise ? r : t;
                };
            },
            6395: function(e, t, r) {
                "use strict";
                var n = r(5398).EventEmitter, a = r(3972), i = r(1828), o = r(5095), l = r(1914), s = r(5900), c = r(942);
                e.exports = function(e, t) {
                    var r = new n, u = l(e, {
                        format: "png"
                    }), f = u.gd;
                    f.style.position = "absolute", f.style.left = "-5000px", document.body.appendChild(f);
                    var d = o.getRedrawFunc(f);
                    return a.call("_doPlot", f, u.data, u.layout, u.config).then(d).then(function() {
                        var e = o.getDelay(f._fullLayout);
                        setTimeout(function() {
                            var e = s(f), n = document.createElement("canvas");
                            n.id = i.randstr(), (r = c({
                                format: t.format,
                                width: f._fullLayout.width,
                                height: f._fullLayout.height,
                                canvas: n,
                                emitter: r,
                                svg: e
                            })).clean = function() {
                                f && document.body.removeChild(f);
                            };
                        }, e);
                    }).catch(function(e) {
                        r.emit("error", e);
                    }), r;
                };
            },
            5900: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(1828), i = r(1424), o = r(7901), l = r(7922), s = /"/g, c = "TOBESTRIPPED", u = new RegExp('("' + c + ")|(" + c + '")', "g");
                e.exports = function(e, t, r) {
                    var f, d = e._fullLayout, h = d._paper, p = d._toppaper, v = d.width, g = d.height;
                    h.insert("rect", ":first-child").call(i.setRect, 0, 0, v, g).call(o.fill, d.paper_bgcolor);
                    var y = d._basePlotModules || [];
                    for(f = 0; f < y.length; f++){
                        var m = y[f];
                        m.toSVG && m.toSVG(e);
                    }
                    if (p) {
                        var x = p.node().childNodes, b = Array.prototype.slice.call(x);
                        for(f = 0; f < b.length; f++){
                            var _ = b[f];
                            _.childNodes.length && h.node().appendChild(_);
                        }
                    }
                    d._draggers && d._draggers.remove(), h.node().style.background = "", h.selectAll("text").attr({
                        "data-unformatted": null,
                        "data-math": null
                    }).each(function() {
                        var e = n.select(this);
                        if ("hidden" !== this.style.visibility && "none" !== this.style.display) {
                            e.style({
                                visibility: null,
                                display: null
                            });
                            var t = this.style.fontFamily;
                            t && -1 !== t.indexOf('"') && e.style("font-family", t.replace(s, c));
                        } else e.remove();
                    }), h.selectAll(".gradient_filled,.pattern_filled").each(function() {
                        var e = n.select(this), t = this.style.fill;
                        t && -1 !== t.indexOf("url(") && e.style("fill", t.replace(s, c));
                        var r = this.style.stroke;
                        r && -1 !== r.indexOf("url(") && e.style("stroke", r.replace(s, c));
                    }), "pdf" !== t && "eps" !== t || h.selectAll("#MathJax_SVG_glyphs path").attr("stroke-width", 0), h.node().setAttributeNS(l.xmlns, "xmlns", l.svg), h.node().setAttributeNS(l.xmlns, "xmlns:xlink", l.xlink), "svg" === t && r && (h.attr("width", r * v), h.attr("height", r * g), h.attr("viewBox", "0 0 " + v + " " + g));
                    var w = (new window.XMLSerializer).serializeToString(h.node());
                    return w = (w = (w = function(e) {
                        var t = n.select("body").append("div").style({
                            display: "none"
                        }).html(""), r = e.replace(/(&[^;]*;)/gi, function(e) {
                            return "&lt;" === e ? "&#60;" : "&rt;" === e ? "&#62;" : -1 !== e.indexOf("<") || -1 !== e.indexOf(">") ? "" : t.html(e).text();
                        });
                        return t.remove(), r;
                    }(w)).replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, "&amp;")).replace(u, "'"), a.isIE() && (w = (w = (w = w.replace(/"/gi, "'")).replace(/(\('#)([^']*)('\))/gi, '("#$2")')).replace(/(\\')/gi, '"')), w;
                };
            },
            5341: function(e, t, r) {
                "use strict";
                var n = r(1828);
                e.exports = function(e, t) {
                    for(var r = 0; r < e.length; r++)e[r].i = r;
                    n.mergeArray(t.text, e, "tx"), n.mergeArray(t.hovertext, e, "htx");
                    var a = t.marker;
                    if (a) {
                        n.mergeArray(a.opacity, e, "mo", !0), n.mergeArray(a.color, e, "mc");
                        var i = a.line;
                        i && (n.mergeArray(i.color, e, "mlc"), n.mergeArrayCastPositive(i.width, e, "mlw"));
                    }
                };
            },
            1486: function(e, t, r) {
                "use strict";
                var n = r(2196), a = r(2663).axisHoverFormat, i = r(5386).fF, o = r(5386).si, l = r(693), s = r(1940), c = r(7313), u = r(9952).u, f = r(1426).extendFlat, d = s({
                    editType: "calc",
                    arrayOk: !0,
                    colorEditType: "style"
                }), h = f({}, n.marker.line.width, {
                    dflt: 0
                }), p = f({
                    width: h,
                    editType: "calc"
                }, l("marker.line")), v = f({
                    line: p,
                    editType: "calc"
                }, l("marker"), {
                    opacity: {
                        valType: "number",
                        arrayOk: !0,
                        dflt: 1,
                        min: 0,
                        max: 1,
                        editType: "style"
                    },
                    pattern: u
                });
                e.exports = {
                    x: n.x,
                    x0: n.x0,
                    dx: n.dx,
                    y: n.y,
                    y0: n.y0,
                    dy: n.dy,
                    xperiod: n.xperiod,
                    yperiod: n.yperiod,
                    xperiod0: n.xperiod0,
                    yperiod0: n.yperiod0,
                    xperiodalignment: n.xperiodalignment,
                    yperiodalignment: n.yperiodalignment,
                    xhoverformat: a("x"),
                    yhoverformat: a("y"),
                    text: n.text,
                    texttemplate: o({
                        editType: "plot"
                    }, {
                        keys: c.eventDataKeys
                    }),
                    hovertext: n.hovertext,
                    hovertemplate: i({}, {
                        keys: c.eventDataKeys
                    }),
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "inside",
                            "outside",
                            "auto",
                            "none"
                        ],
                        dflt: "auto",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    insidetextanchor: {
                        valType: "enumerated",
                        values: [
                            "end",
                            "middle",
                            "start"
                        ],
                        dflt: "end",
                        editType: "plot"
                    },
                    textangle: {
                        valType: "angle",
                        dflt: "auto",
                        editType: "plot"
                    },
                    textfont: f({}, d, {}),
                    insidetextfont: f({}, d, {}),
                    outsidetextfont: f({}, d, {}),
                    constraintext: {
                        valType: "enumerated",
                        values: [
                            "inside",
                            "outside",
                            "both",
                            "none"
                        ],
                        dflt: "both",
                        editType: "calc"
                    },
                    cliponaxis: f({}, n.cliponaxis, {}),
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        editType: "calc+clearAxisTypes"
                    },
                    base: {
                        valType: "any",
                        dflt: null,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    offset: {
                        valType: "number",
                        dflt: null,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    width: {
                        valType: "number",
                        dflt: null,
                        min: 0,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    marker: v,
                    offsetgroup: n.offsetgroup,
                    alignmentgroup: n.alignmentgroup,
                    selected: {
                        marker: {
                            opacity: n.selected.marker.opacity,
                            color: n.selected.marker.color,
                            editType: "style"
                        },
                        textfont: n.selected.textfont,
                        editType: "style"
                    },
                    unselected: {
                        marker: {
                            opacity: n.unselected.marker.opacity,
                            color: n.unselected.marker.color,
                            editType: "style"
                        },
                        textfont: n.unselected.textfont,
                        editType: "style"
                    },
                    _deprecated: {
                        bardir: {
                            valType: "enumerated",
                            editType: "calc",
                            values: [
                                "v",
                                "h"
                            ]
                        }
                    }
                };
            },
            2290: function(e, t, r) {
                "use strict";
                var n = r(9298), a = r(2973), i = r(2869).hasColorscale, o = r(8803), l = r(5341), s = r(6279);
                e.exports = function(e, t) {
                    var r, c, u, f, d, h, p = n.getFromId(e, t.xaxis || "x"), v = n.getFromId(e, t.yaxis || "y"), g = {
                        msUTC: !(!t.base && 0 !== t.base)
                    };
                    "h" === t.orientation ? (r = p.makeCalcdata(t, "x", g), u = v.makeCalcdata(t, "y"), f = a(t, v, "y", u), d = !!t.yperiodalignment, h = "y") : (r = v.makeCalcdata(t, "y", g), u = p.makeCalcdata(t, "x"), f = a(t, p, "x", u), d = !!t.xperiodalignment, h = "x"), c = f.vals;
                    for(var y = Math.min(c.length, r.length), m = new Array(y), x = 0; x < y; x++)m[x] = {
                        p: c[x],
                        s: r[x]
                    }, d && (m[x].orig_p = u[x], m[x][h + "End"] = f.ends[x], m[x][h + "Start"] = f.starts[x]), t.ids && (m[x].id = String(t.ids[x]));
                    return i(t, "marker") && o(e, t, {
                        vals: t.marker.color,
                        containerStr: "marker",
                        cLetter: "c"
                    }), i(t, "marker.line") && o(e, t, {
                        vals: t.marker.line.color,
                        containerStr: "marker.line",
                        cLetter: "c"
                    }), l(m, t), s(m, t), m;
                };
            },
            7313: function(e) {
                "use strict";
                e.exports = {
                    TEXTPAD: 3,
                    eventDataKeys: [
                        "value",
                        "label"
                    ]
                };
            },
            1661: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(1828).isArrayOrTypedArray, i = r(606).BADNUM, o = r(3972), l = r(9298), s = r(9082).getAxisGroup, c = r(1546);
                function u(e, t, r, o, u) {
                    if (o.length) {
                        var b, _, w, T;
                        switch(function(e, t) {
                            var r, i;
                            for(r = 0; r < t.length; r++){
                                var o, l = t[r], s = l[0].trace, c = "funnel" === s.type ? s._base : s.base, u = "h" === s.orientation ? s.xcalendar : s.ycalendar, f = "category" === e.type || "multicategory" === e.type ? function() {
                                    return null;
                                } : e.d2c;
                                if (a(c)) {
                                    for(i = 0; i < Math.min(c.length, l.length); i++)o = f(c[i], 0, u), n(o) ? (l[i].b = +o, l[i].hasB = 1) : l[i].b = 0;
                                    for(; i < l.length; i++)l[i].b = 0;
                                } else {
                                    o = f(c, 0, u);
                                    var d = n(o);
                                    for(o = d ? o : 0, i = 0; i < l.length; i++)l[i].b = o, d && (l[i].hasB = 1);
                                }
                            }
                        }(r, o), u.mode){
                            case "overlay":
                                f(t, r, o, u);
                                break;
                            case "group":
                                for(b = [], _ = [], w = 0; w < o.length; w++)void 0 === (T = o[w])[0].trace.offset ? _.push(T) : b.push(T);
                                _.length && function(e, t, r, n, a) {
                                    var o = new c(n, {
                                        posAxis: t,
                                        sepNegVal: !1,
                                        overlapNoMerge: !a.norm
                                    });
                                    (function(e, t, r, n) {
                                        for(var a = e._fullLayout, i = r.positions, o = r.distinctPositions, l = r.minDiff, c = r.traces, u = c.length, f = i.length !== o.length, d = l * (1 - n.gap), g = s(a, t._id) + c[0][0].trace.orientation, y = a._alignmentOpts[g] || {}, m = 0; m < u; m++){
                                            var x, b, _ = c[m], w = _[0].trace, T = y[w.alignmentgroup] || {}, M = Object.keys(T.offsetGroups || {}).length, k = (x = M ? d / M : f ? d / u : d) * (1 - (n.groupgap || 0));
                                            b = M ? ((2 * w._offsetIndex + 1 - M) * x - k) / 2 : f ? ((2 * m + 1 - u) * x - k) / 2 : -k / 2;
                                            var A = _[0].t;
                                            A.barwidth = k, A.poffset = b, A.bargroupwidth = d, A.bardelta = l;
                                        }
                                        r.binWidth = c[0][0].t.barwidth / 100, h(r), p(t, r), v(t, r, f);
                                    })(e, t, o, a), function(e, t) {
                                        for(var r = e.traces, n = 0; n < r.length; n++){
                                            var a = r[n];
                                            if (void 0 === a[0].trace.base) for(var o = new c([
                                                a
                                            ], {
                                                posAxis: t,
                                                sepNegVal: !0,
                                                overlapNoMerge: !0
                                            }), l = 0; l < a.length; l++){
                                                var s = a[l];
                                                if (s.p !== i) {
                                                    var u = o.put(s.p, s.b + s.s);
                                                    u && (s.b = u);
                                                }
                                            }
                                        }
                                    }(o, t), a.norm ? (y(o), m(r, o, a)) : g(r, o);
                                }(e, t, r, _, u), b.length && f(t, r, b, u);
                                break;
                            case "stack":
                            case "relative":
                                for(b = [], _ = [], w = 0; w < o.length; w++)void 0 === (T = o[w])[0].trace.base ? _.push(T) : b.push(T);
                                _.length && function(e, t, r, n, a) {
                                    var o = new c(n, {
                                        posAxis: t,
                                        sepNegVal: "relative" === a.mode,
                                        overlapNoMerge: !(a.norm || "stack" === a.mode || "relative" === a.mode)
                                    });
                                    d(t, o, a), function(e, t, r) {
                                        var n, a, o, s, c, u, f = x(e), d = t.traces;
                                        for(s = 0; s < d.length; s++)if ("funnel" === (a = (n = d[s])[0].trace).type) for(c = 0; c < n.length; c++)(u = n[c]).s !== i && t.put(u.p, -0.5 * u.s);
                                        for(s = 0; s < d.length; s++){
                                            o = "funnel" === (a = (n = d[s])[0].trace).type;
                                            var h = [];
                                            for(c = 0; c < n.length; c++)if ((u = n[c]).s !== i) {
                                                var p;
                                                p = o ? u.s : u.s + u.b;
                                                var v = t.put(u.p, p), g = v + p;
                                                u.b = v, u[f] = g, r.norm || (h.push(g), u.hasB && h.push(v));
                                            }
                                            r.norm || (a._extremes[e._id] = l.findExtremes(e, h, {
                                                tozero: !0,
                                                padded: !0
                                            }));
                                        }
                                    }(r, o, a);
                                    for(var s = 0; s < n.length; s++)for(var u = n[s], f = 0; f < u.length; f++){
                                        var h = u[f];
                                        h.s !== i && h.b + h.s === o.get(h.p, h.s) && (h._outmost = !0);
                                    }
                                    a.norm && m(r, o, a);
                                }(0, t, r, _, u), b.length && f(t, r, b, u);
                        }
                        !function(e, t) {
                            var r, a, i, o = x(t), l = {}, s = 1 / 0, c = -1 / 0;
                            for(r = 0; r < e.length; r++)for(i = e[r], a = 0; a < i.length; a++){
                                var u = i[a].p;
                                n(u) && (s = Math.min(s, u), c = Math.max(c, u));
                            }
                            var f = 1e4 / (c - s), d = l.round = function(e) {
                                return String(Math.round(f * (e - s)));
                            };
                            for(r = 0; r < e.length; r++){
                                (i = e[r])[0].t.extents = l;
                                var h = i[0].t.poffset, p = Array.isArray(h);
                                for(a = 0; a < i.length; a++){
                                    var v = i[a], g = v[o] - v.w / 2;
                                    if (n(g)) {
                                        var y = v[o] + v.w / 2, m = d(v.p);
                                        l[m] ? l[m] = [
                                            Math.min(g, l[m][0]),
                                            Math.max(y, l[m][1])
                                        ] : l[m] = [
                                            g,
                                            y
                                        ];
                                    }
                                    v.p0 = v.p + (p ? h[a] : h), v.p1 = v.p0 + v.w, v.s0 = v.b, v.s1 = v.s0 + v.s;
                                }
                            }
                        }(o, t);
                    }
                }
                function f(e, t, r, n) {
                    for(var a = 0; a < r.length; a++){
                        var i = r[a], o = new c([
                            i
                        ], {
                            posAxis: e,
                            sepNegVal: !1,
                            overlapNoMerge: !n.norm
                        });
                        d(e, o, n), n.norm ? (y(o), m(t, o, n)) : g(t, o);
                    }
                }
                function d(e, t, r) {
                    for(var n = t.minDiff, a = t.traces, i = n * (1 - r.gap), o = i * (1 - (r.groupgap || 0)), l = -o / 2, s = 0; s < a.length; s++){
                        var c = a[s][0].t;
                        c.barwidth = o, c.poffset = l, c.bargroupwidth = i, c.bardelta = n;
                    }
                    t.binWidth = a[0][0].t.barwidth / 100, h(t), p(e, t), v(e, t);
                }
                function h(e) {
                    var t, r, i = e.traces;
                    for(t = 0; t < i.length; t++){
                        var o, l = i[t], s = l[0], c = s.trace, u = s.t, f = c._offset || c.offset, d = u.poffset;
                        if (a(f)) {
                            for(o = Array.prototype.slice.call(f, 0, l.length), r = 0; r < o.length; r++)n(o[r]) || (o[r] = d);
                            for(r = o.length; r < l.length; r++)o.push(d);
                            u.poffset = o;
                        } else void 0 !== f && (u.poffset = f);
                        var h = c._width || c.width, p = u.barwidth;
                        if (a(h)) {
                            var v = Array.prototype.slice.call(h, 0, l.length);
                            for(r = 0; r < v.length; r++)n(v[r]) || (v[r] = p);
                            for(r = v.length; r < l.length; r++)v.push(p);
                            if (u.barwidth = v, void 0 === f) {
                                for(o = [], r = 0; r < l.length; r++)o.push(d + (p - v[r]) / 2);
                                u.poffset = o;
                            }
                        } else void 0 !== h && (u.barwidth = h, void 0 === f && (u.poffset = d + (p - h) / 2));
                    }
                }
                function p(e, t) {
                    for(var r = t.traces, n = x(e), a = 0; a < r.length; a++)for(var i = r[a], o = i[0].t, l = o.poffset, s = Array.isArray(l), c = o.barwidth, u = Array.isArray(c), f = 0; f < i.length; f++){
                        var d = i[f], h = d.w = u ? c[f] : c;
                        void 0 === d.p && (d.p = d[n], d["orig_" + n] = d[n]);
                        var p = (s ? l[f] : l) + h / 2;
                        d[n] = d.p + p;
                    }
                }
                function v(e, t, r) {
                    var n = t.traces, a = t.minDiff / 2;
                    l.minDtick(e, t.minDiff, t.distinctPositions[0], r);
                    for(var i = 0; i < n.length; i++){
                        var o, s, c, u, f = n[i], d = f[0], h = d.trace, p = [];
                        for(u = 0; u < f.length; u++)s = (o = f[u]).p - a, c = o.p + a, p.push(s, c);
                        if (h.width || h.offset) {
                            var v = d.t, g = v.poffset, y = v.barwidth, m = Array.isArray(g), x = Array.isArray(y);
                            for(u = 0; u < f.length; u++){
                                o = f[u];
                                var b = m ? g[u] : g, _ = x ? y[u] : y;
                                c = (s = o.p + b) + _, p.push(s, c);
                            }
                        }
                        h._extremes[e._id] = l.findExtremes(e, p, {
                            padded: !1
                        });
                    }
                }
                function g(e, t) {
                    for(var r = t.traces, n = x(e), a = 0; a < r.length; a++){
                        for(var i = r[a], o = i[0].trace, s = "scatter" === o.type, c = "v" === o.orientation, u = [], f = !1, d = 0; d < i.length; d++){
                            var h = i[d], p = s ? 0 : h.b, v = s ? c ? h.y : h.x : p + h.s;
                            h[n] = v, u.push(v), h.hasB && u.push(p), h.hasB && h.b || (f = !0);
                        }
                        o._extremes[e._id] = l.findExtremes(e, u, {
                            tozero: f,
                            padded: !0
                        });
                    }
                }
                function y(e) {
                    for(var t = e.traces, r = 0; r < t.length; r++)for(var n = t[r], a = 0; a < n.length; a++){
                        var o = n[a];
                        o.s !== i && e.put(o.p, o.b + o.s);
                    }
                }
                function m(e, t, r) {
                    var a = t.traces, o = x(e), s = "fraction" === r.norm ? 1 : 100, c = s / 1e9, u = e.l2c(e.c2l(0)), f = "stack" === r.mode ? s : u;
                    function d(t) {
                        return n(e.c2l(t)) && (t < u - c || t > f + c || !n(u));
                    }
                    for(var h = 0; h < a.length; h++){
                        for(var p = a[h], v = p[0].trace, g = [], y = !1, m = !1, b = 0; b < p.length; b++){
                            var _ = p[b];
                            if (_.s !== i) {
                                var w = Math.abs(s / t.get(_.p, _.s));
                                _.b *= w, _.s *= w;
                                var T = _.b, M = T + _.s;
                                _[o] = M, g.push(M), m = m || d(M), _.hasB && (g.push(T), m = m || d(T)), _.hasB && _.b || (y = !0);
                            }
                        }
                        v._extremes[e._id] = l.findExtremes(e, g, {
                            tozero: y,
                            padded: m
                        });
                    }
                }
                function x(e) {
                    return e._id.charAt(0);
                }
                e.exports = {
                    crossTraceCalc: function(e, t) {
                        for(var r = t.xaxis, n = t.yaxis, a = e._fullLayout, i = e._fullData, l = e.calcdata, s = [], c = [], f = 0; f < i.length; f++){
                            var d = i[f];
                            if (!0 === d.visible && o.traceIs(d, "bar") && d.xaxis === r._id && d.yaxis === n._id && ("h" === d.orientation ? s.push(l[f]) : c.push(l[f]), d._computePh)) for(var h = e.calcdata[f], p = 0; p < h.length; p++)"function" == typeof h[p].ph0 && (h[p].ph0 = h[p].ph0()), "function" == typeof h[p].ph1 && (h[p].ph1 = h[p].ph1());
                        }
                        var v = {
                            xCat: "category" === r.type || "multicategory" === r.type,
                            yCat: "category" === n.type || "multicategory" === n.type,
                            mode: a.barmode,
                            norm: a.barnorm,
                            gap: a.bargap,
                            groupgap: a.bargroupgap
                        };
                        u(e, r, n, c, v), u(e, n, r, s, v);
                    },
                    setGroupPositions: u
                };
            },
            769: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(7901), i = r(3972), o = r(7513), l = r(3927), s = r(8340), c = r(6125), u = r(1486), f = n.coerceFont;
                function d(e, t, r, a, i, o) {
                    var l = !(!1 === (o = o || {}).moduleHasSelected), s = !(!1 === o.moduleHasUnselected), c = !(!1 === o.moduleHasConstrain), u = !(!1 === o.moduleHasCliponaxis), d = !(!1 === o.moduleHasTextangle), h = !(!1 === o.moduleHasInsideanchor), p = !!o.hasPathbar, v = Array.isArray(i) || "auto" === i, g = v || "inside" === i, y = v || "outside" === i;
                    if (g || y) {
                        var m = f(a, "textfont", r.font), x = n.extendFlat({}, m), b = !(e.textfont && e.textfont.color);
                        if (b && delete x.color, f(a, "insidetextfont", x), p) {
                            var _ = n.extendFlat({}, m);
                            b && delete _.color, f(a, "pathbar.textfont", _);
                        }
                        y && f(a, "outsidetextfont", m), l && a("selected.textfont.color"), s && a("unselected.textfont.color"), c && a("constraintext"), u && a("cliponaxis"), d && a("textangle"), a("texttemplate");
                    }
                    g && h && a("insidetextanchor");
                }
                e.exports = {
                    supplyDefaults: function(e, t, r, c) {
                        function f(r, a) {
                            return n.coerce(e, t, u, r, a);
                        }
                        if (o(e, t, c, f)) {
                            l(e, t, c, f), f("xhoverformat"), f("yhoverformat"), f("orientation", t.x && !t.y ? "h" : "v"), f("base"), f("offset"), f("width"), f("text"), f("hovertext"), f("hovertemplate");
                            var h = f("textposition");
                            d(e, 0, c, f, h, {
                                moduleHasSelected: !0,
                                moduleHasUnselected: !0,
                                moduleHasConstrain: !0,
                                moduleHasCliponaxis: !0,
                                moduleHasTextangle: !0,
                                moduleHasInsideanchor: !0
                            }), s(e, t, f, r, c);
                            var p = (t.marker.line || {}).color, v = i.getComponentMethod("errorbars", "supplyDefaults");
                            v(e, t, p || a.defaultLine, {
                                axis: "y"
                            }), v(e, t, p || a.defaultLine, {
                                axis: "x",
                                inherit: "y"
                            }), n.coerceSelectionMarkerOpacity(t, f);
                        } else t.visible = !1;
                    },
                    crossTraceDefaults: function(e, t) {
                        var r, a;
                        function i(e) {
                            return n.coerce(a._input, a, u, e);
                        }
                        if ("group" === t.barmode) for(var o = 0; o < e.length; o++)"bar" === (a = e[o]).type && (r = a._input, c(r, a, t, i));
                    },
                    handleText: d
                };
            },
            8065: function(e) {
                "use strict";
                e.exports = function(e, t, r) {
                    return e.x = "xVal" in t ? t.xVal : t.x, e.y = "yVal" in t ? t.yVal : t.y, t.xa && (e.xaxis = t.xa), t.ya && (e.yaxis = t.ya), "h" === r.orientation ? (e.label = e.y, e.value = e.x) : (e.label = e.x, e.value = e.y), e;
                };
            },
            9383: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(4267), i = r(1828).isArrayOrTypedArray;
                t.coerceString = function(e, t, r) {
                    if ("string" == typeof t) {
                        if (t || !e.noBlank) return t;
                    } else if (("number" == typeof t || !0 === t) && !e.strict) return String(t);
                    return void 0 !== r ? r : e.dflt;
                }, t.coerceNumber = function(e, t, r) {
                    if (n(t)) {
                        t = +t;
                        var a = e.min, i = e.max;
                        if (!(void 0 !== a && t < a || void 0 !== i && t > i)) return t;
                    }
                    return void 0 !== r ? r : e.dflt;
                }, t.coerceColor = function(e, t, r) {
                    return a(t).isValid() ? t : void 0 !== r ? r : e.dflt;
                }, t.coerceEnumerated = function(e, t, r) {
                    return e.coerceNumber && (t = +t), -1 !== e.values.indexOf(t) ? t : void 0 !== r ? r : e.dflt;
                }, t.getValue = function(e, t) {
                    var r;
                    return Array.isArray(e) ? t < e.length && (r = e[t]) : r = e, r;
                }, t.getLineWidth = function(e, t) {
                    return 0 < t.mlw ? t.mlw : i(e.marker.line.width) ? 0 : e.marker.line.width;
                };
            },
            5423: function(e, t, r) {
                "use strict";
                var n = r(211), a = r(3972), i = r(7901), o = r(1828).fillText, l = r(9383).getLineWidth, s = r(9298).hoverLabelText, c = r(606).BADNUM;
                function u(e, t, r, a, i) {
                    var l, u, f, d, h, p, v, g = e.cd, y = g[0].trace, m = g[0].t, x = "closest" === a, b = "waterfall" === y.type, _ = e.maxHoverDistance, w = e.maxSpikeDistance;
                    "h" === y.orientation ? (l = r, u = t, f = "y", d = "x", h = R, p = P) : (l = t, u = r, f = "x", d = "y", p = R, h = P);
                    var T = y[f + "period"], M = x || T;
                    function k(e) {
                        return L(e, -1);
                    }
                    function A(e) {
                        return L(e, 1);
                    }
                    function L(e, t) {
                        var r = e.w;
                        return e[f] + t * r / 2;
                    }
                    function S(e) {
                        return e[f + "End"] - e[f + "Start"];
                    }
                    var D = x ? k : T ? function(e) {
                        return e.p - S(e) / 2;
                    } : function(e) {
                        return Math.min(k(e), e.p - m.bardelta / 2);
                    }, O = x ? A : T ? function(e) {
                        return e.p + S(e) / 2;
                    } : function(e) {
                        return Math.max(A(e), e.p + m.bardelta / 2);
                    };
                    function C(e, t, r) {
                        return i.finiteRange && (r = 0), n.inbox(e - l, t - l, r + Math.min(1, Math.abs(t - e) / v) - 1);
                    }
                    function P(e) {
                        return C(D(e), O(e), _);
                    }
                    function I(e) {
                        var t = e[d];
                        if (b) {
                            var r = Math.abs(e.rawS) || 0;
                            u > 0 ? t += r : u < 0 && (t -= r);
                        }
                        return t;
                    }
                    function R(e) {
                        var t = u, r = e.b, a = I(e);
                        return n.inbox(r - t, a - t, _ + (a - t) / (a - r) - 1);
                    }
                    var z = e[f + "a"], N = e[d + "a"];
                    v = Math.abs(z.r2c(z.range[1]) - z.r2c(z.range[0]));
                    var F = n.getDistanceFunction(a, h, p, function(e) {
                        return (h(e) + p(e)) / 2;
                    });
                    if (n.getClosest(g, F, e), !1 !== e.index && g[e.index].p !== c) {
                        M || (D = function(e) {
                            return Math.min(k(e), e.p - m.bargroupwidth / 2);
                        }, O = function(e) {
                            return Math.max(A(e), e.p + m.bargroupwidth / 2);
                        });
                        var E = g[e.index], H = y.base ? E.b + E.s : E.s;
                        e[d + "0"] = e[d + "1"] = N.c2p(E[d], !0), e[d + "LabelVal"] = H;
                        var j = m.extents[m.extents.round(E.p)];
                        e[f + "0"] = z.c2p(x ? D(E) : j[0], !0), e[f + "1"] = z.c2p(x ? O(E) : j[1], !0);
                        var B = void 0 !== E.orig_p;
                        return e[f + "LabelVal"] = B ? E.orig_p : E.p, e.labelLabel = s(z, e[f + "LabelVal"], y[f + "hoverformat"]), e.valueLabel = s(N, e[d + "LabelVal"], y[d + "hoverformat"]), e.baseLabel = s(N, E.b, y[d + "hoverformat"]), e.spikeDistance = (function(e) {
                            var t = u, r = e.b, a = I(e);
                            return n.inbox(r - t, a - t, w + (a - t) / (a - r) - 1);
                        }(E) + function(e) {
                            return C(k(e), A(e), w);
                        }(E)) / 2, e[f + "Spike"] = z.c2p(E.p, !0), o(E, y, e), e.hovertemplate = y.hovertemplate, e;
                    }
                }
                function f(e, t) {
                    var r = t.mcc || e.marker.color, n = t.mlcc || e.marker.line.color, a = l(e, t);
                    return i.opacity(r) ? r : i.opacity(n) && a ? n : void 0;
                }
                e.exports = {
                    hoverPoints: function(e, t, r, n, i) {
                        var o = u(e, t, r, n, i);
                        if (o) {
                            var l = o.cd, s = l[0].trace, c = l[o.index];
                            return o.color = f(s, c), a.getComponentMethod("errorbars", "hoverInfo")(c, s, o), [
                                o
                            ];
                        }
                    },
                    hoverOnBars: u,
                    getTraceColor: f
                };
            },
            822: function(e, t, r) {
                "use strict";
                e.exports = {
                    attributes: r(1486),
                    layoutAttributes: r(3641),
                    supplyDefaults: r(769).supplyDefaults,
                    crossTraceDefaults: r(769).crossTraceDefaults,
                    supplyLayoutDefaults: r(3957),
                    calc: r(2290),
                    crossTraceCalc: r(1661).crossTraceCalc,
                    colorbar: r(4898),
                    arraysToCalcdata: r(5341),
                    plot: r(7295).plot,
                    style: r(6688).style,
                    styleOnSelect: r(6688).styleOnSelect,
                    hoverPoints: r(5423).hoverPoints,
                    eventData: r(8065),
                    selectPoints: r(1974),
                    moduleType: "trace",
                    name: "bar",
                    basePlotModule: r(3612),
                    categories: [
                        "bar-like",
                        "cartesian",
                        "svg",
                        "bar",
                        "oriented",
                        "errorBarsOK",
                        "showLegend",
                        "zoomScale"
                    ],
                    animatable: !0,
                    meta: {}
                };
            },
            3641: function(e) {
                "use strict";
                e.exports = {
                    barmode: {
                        valType: "enumerated",
                        values: [
                            "stack",
                            "group",
                            "overlay",
                            "relative"
                        ],
                        dflt: "group",
                        editType: "calc"
                    },
                    barnorm: {
                        valType: "enumerated",
                        values: [
                            "",
                            "fraction",
                            "percent"
                        ],
                        dflt: "",
                        editType: "calc"
                    },
                    bargap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "calc"
                    },
                    bargroupgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "calc"
                    }
                };
            },
            3957: function(e, t, r) {
                "use strict";
                var n = r(3972), a = r(9298), i = r(1828), o = r(3641);
                e.exports = function(e, t, r) {
                    function l(r, n) {
                        return i.coerce(e, t, o, r, n);
                    }
                    for(var s = !1, c = !1, u = !1, f = {}, d = l("barmode"), h = 0; h < r.length; h++){
                        var p = r[h];
                        if (n.traceIs(p, "bar") && p.visible) {
                            if (s = !0, "group" === d) {
                                var v = p.xaxis + p.yaxis;
                                f[v] && (u = !0), f[v] = !0;
                            }
                            p.visible && "histogram" === p.type && "category" !== a.getFromId({
                                _fullLayout: t
                            }, p["v" === p.orientation ? "xaxis" : "yaxis"]).type && (c = !0);
                        }
                    }
                    s ? ("overlay" !== d && l("barnorm"), l("bargap", c && !u ? 0 : .2), l("bargroupgap")) : delete t.barmode;
                };
            },
            7295: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(2770), i = r(1828), o = r(3893), l = r(7901), s = r(1424), c = r(3972), u = r(9298).tickText, f = r(2597), d = f.recordMinTextSize, h = f.clearMinTextSize, p = r(6688), v = r(9383), g = r(7313), y = r(1486), m = y.text, x = y.textposition, b = r(3469).appendArrayPointValue, _ = g.TEXTPAD;
                function w(e) {
                    return e.id;
                }
                function T(e) {
                    if (e.ids) return w;
                }
                function M(e, t) {
                    return e < t ? 1 : -1;
                }
                function k(e, t, r, n) {
                    var a;
                    return !t.uniformtext.mode && A(r) ? (n && (a = n()), e.transition().duration(r.duration).ease(r.easing).each("end", function() {
                        a && a();
                    }).each("interrupt", function() {
                        a && a();
                    })) : e;
                }
                function A(e) {
                    return e && e.duration > 0;
                }
                function L(e) {
                    return "auto" === e ? 0 : e;
                }
                function S(e, t) {
                    var r = Math.PI / 180 * t, n = Math.abs(Math.sin(r)), a = Math.abs(Math.cos(r));
                    return {
                        x: e.width * a + e.height * n,
                        y: e.width * n + e.height * a
                    };
                }
                function D(e, t, r, n, a, i) {
                    var o = !!i.isHorizontal, l = !!i.constrained, s = i.angle || 0, c = i.anchor || "end", u = "end" === c, f = "start" === c, d = ((i.leftToRight || 0) + 1) / 2, h = 1 - d, p = a.width, v = a.height, g = Math.abs(t - e), y = Math.abs(n - r), m = g > 2 * _ && y > 2 * _ ? _ : 0;
                    g -= 2 * m, y -= 2 * m;
                    var x = L(s);
                    "auto" !== s || p <= g && v <= y || !(p > g || v > y) || (p > y || v > g) && p < v == g < y || (x += 90);
                    var b = S(a, x), w = 1;
                    l && (w = Math.min(1, g / b.x, y / b.y));
                    var T = a.left * h + a.right * d, k = (a.top + a.bottom) / 2, A = (e + _) * h + (t - _) * d, D = (r + n) / 2, O = 0, C = 0;
                    if (f || u) {
                        var P = (o ? b.x : b.y) / 2, I = o ? M(e, t) : M(r, n);
                        o ? f ? (A = e + I * m, O = -I * P) : (A = t - I * m, O = I * P) : f ? (D = r + I * m, C = -I * P) : (D = n - I * m, C = I * P);
                    }
                    return {
                        textX: T,
                        textY: k,
                        targetX: A,
                        targetY: D,
                        anchorX: O,
                        anchorY: C,
                        scale: w,
                        rotate: x
                    };
                }
                e.exports = {
                    plot: function(e, t, r, f, g, y) {
                        var w = t.xaxis, O = t.yaxis, C = e._fullLayout, P = e._context.staticPlot;
                        g || (g = {
                            mode: C.barmode,
                            norm: C.barmode,
                            gap: C.bargap,
                            groupgap: C.bargroupgap
                        }, h("bar", C));
                        var I = i.makeTraceGroups(f, r, "trace bars").each(function(r) {
                            var c = n.select(this), f = r[0].trace, h = "waterfall" === f.type, I = "funnel" === f.type, R = "bar" === f.type || I, z = 0;
                            h && f.connector.visible && "between" === f.connector.mode && (z = f.connector.line.width / 2);
                            var N = "h" === f.orientation, F = A(g), E = i.ensureSingle(c, "g", "points"), H = T(f), j = E.selectAll("g.point").data(i.identity, H);
                            j.enter().append("g").classed("point", !0), j.exit().remove(), j.each(function(c, h) {
                                var T, A, I = n.select(this), E = function(e, t, r, n) {
                                    var a = [], i = [], o = n ? t : r, l = n ? r : t;
                                    return a[0] = o.c2p(e.s0, !0), i[0] = l.c2p(e.p0, !0), a[1] = o.c2p(e.s1, !0), i[1] = l.c2p(e.p1, !0), n ? [
                                        a,
                                        i
                                    ] : [
                                        i,
                                        a
                                    ];
                                }(c, w, O, N), H = E[0][0], j = E[0][1], B = E[1][0], Y = E[1][1], V = 0 == (N ? j - H : Y - B);
                                if (V && R && v.getLineWidth(f, c) && (V = !1), V || (V = !(a(H) && a(j) && a(B) && a(Y))), c.isBlank = V, V && (N ? j = H : Y = B), z && !V && (N ? (H -= M(H, j) * z, j += M(H, j) * z) : (B -= M(B, Y) * z, Y += M(B, Y) * z)), "waterfall" === f.type) {
                                    if (!V) {
                                        var U = f[c.dir].marker;
                                        T = U.line.width, A = U.color;
                                    }
                                } else T = v.getLineWidth(f, c), A = c.mc || f.marker.color;
                                function q(e) {
                                    var t = n.round(T / 2 % 1, 2);
                                    return 0 === g.gap && 0 === g.groupgap ? n.round(Math.round(e) - t, 2) : e;
                                }
                                if (!e._context.staticPlot) {
                                    var G = l.opacity(A) < 1 || T > .01 ? q : function(e, t, r) {
                                        return r && e === t ? e : Math.abs(e - t) >= 2 ? q(e) : e > t ? Math.ceil(e) : Math.floor(e);
                                    };
                                    H = G(H, j, N), j = G(j, H, N), B = G(B, Y, !N), Y = G(Y, B, !N);
                                }
                                var Z = k(i.ensureSingle(I, "path"), C, g, y);
                                if (Z.style("vector-effect", P ? "none" : "non-scaling-stroke").attr("d", isNaN((j - H) * (Y - B)) || V && e._context.staticPlot ? "M0,0Z" : "M" + H + "," + B + "V" + Y + "H" + j + "V" + B + "Z").call(s.setClipUrl, t.layerClipId, e), !C.uniformtext.mode && F) {
                                    var W = s.makePointStyleFns(f);
                                    s.singlePointStyle(c, Z, f, W, e);
                                }
                                !function(e, t, r, n, a, l, c, f, h, g, y) {
                                    var w, T = t.xaxis, A = t.yaxis, O = e._fullLayout;
                                    function C(t, r, n) {
                                        return i.ensureSingle(t, "text").text(r).attr({
                                            class: "bartext bartext-" + w,
                                            "text-anchor": "middle",
                                            "data-notex": 1
                                        }).call(s.font, n).call(o.convertToTspans, e);
                                    }
                                    var P = n[0].trace, I = "h" === P.orientation, R = function(e, t, r, n, a) {
                                        var o, l = t[0].trace;
                                        return o = l.texttemplate ? function(e, t, r, n, a) {
                                            var o = t[0].trace, l = i.castOption(o, r, "texttemplate");
                                            if (!l) return "";
                                            var s, c, f, d, h = "histogram" === o.type, p = "waterfall" === o.type, v = "funnel" === o.type, g = "h" === o.orientation;
                                            function y(e) {
                                                return u(d, d.c2l(e), !0).text;
                                            }
                                            g ? (s = "y", c = a, f = "x", d = n) : (s = "x", c = n, f = "y", d = a);
                                            var m, x = t[r], _ = {};
                                            _.label = x.p, _.labelLabel = _[s + "Label"] = (m = x.p, u(c, c.c2l(m), !0).text);
                                            var w = i.castOption(o, x.i, "text");
                                            (0 === w || w) && (_.text = w), _.value = x.s, _.valueLabel = _[f + "Label"] = y(x.s);
                                            var T = {};
                                            b(T, o, x.i), (h || void 0 === T.x) && (T.x = g ? _.value : _.label), (h || void 0 === T.y) && (T.y = g ? _.label : _.value), (h || void 0 === T.xLabel) && (T.xLabel = g ? _.valueLabel : _.labelLabel), (h || void 0 === T.yLabel) && (T.yLabel = g ? _.labelLabel : _.valueLabel), p && (_.delta = +x.rawS || x.s, _.deltaLabel = y(_.delta), _.final = x.v, _.finalLabel = y(_.final), _.initial = _.final - _.delta, _.initialLabel = y(_.initial)), v && (_.value = x.s, _.valueLabel = y(_.value), _.percentInitial = x.begR, _.percentInitialLabel = i.formatPercent(x.begR), _.percentPrevious = x.difR, _.percentPreviousLabel = i.formatPercent(x.difR), _.percentTotal = x.sumR, _.percenTotalLabel = i.formatPercent(x.sumR));
                                            var M = i.castOption(o, x.i, "customdata");
                                            return M && (_.customdata = M), i.texttemplateString(l, _, e._d3locale, T, _, o._meta || {});
                                        }(e, t, r, n, a) : l.textinfo ? function(e, t, r, n) {
                                            var a = e[0].trace, o = "h" === a.orientation, l = "waterfall" === a.type, s = "funnel" === a.type;
                                            function c(e) {
                                                return u(o ? r : n, +e, !0).text;
                                            }
                                            var f, d, h = a.textinfo, p = e[t], v = h.split("+"), g = [], y = function(e) {
                                                return -1 !== v.indexOf(e);
                                            };
                                            if (y("label") && g.push((d = e[t].p, u(o ? n : r, d, !0).text)), y("text") && (0 === (f = i.castOption(a, p.i, "text")) || f) && g.push(f), l) {
                                                var m = +p.rawS || p.s, x = p.v, b = x - m;
                                                y("initial") && g.push(c(b)), y("delta") && g.push(c(m)), y("final") && g.push(c(x));
                                            }
                                            if (s) {
                                                y("value") && g.push(c(p.s));
                                                var _ = 0;
                                                y("percent initial") && _++, y("percent previous") && _++, y("percent total") && _++;
                                                var w = _ > 1;
                                                y("percent initial") && (f = i.formatPercent(p.begR), w && (f += " of initial"), g.push(f)), y("percent previous") && (f = i.formatPercent(p.difR), w && (f += " of previous"), g.push(f)), y("percent total") && (f = i.formatPercent(p.sumR), w && (f += " of total"), g.push(f));
                                            }
                                            return g.join("<br>");
                                        }(t, r, n, a) : v.getValue(l.text, r), v.coerceString(m, o);
                                    }(O, n, a, T, A);
                                    w = function(e, t) {
                                        var r = v.getValue(e.textposition, t);
                                        return v.coerceEnumerated(x, r);
                                    }(P, a);
                                    var z = "stack" === g.mode || "relative" === g.mode, N = n[a], F = !z || N._outmost;
                                    if (R && "none" !== w && (!N.isBlank && l !== c && f !== h || "auto" !== w && "inside" !== w)) {
                                        var E = O.font, H = p.getBarColor(n[a], P), j = p.getInsideTextFont(P, a, E, H), B = p.getOutsideTextFont(P, a, E), Y = r.datum();
                                        I ? "log" === T.type && Y.s0 <= 0 && (l = T.range[0] < T.range[1] ? 0 : T._length) : "log" === A.type && Y.s0 <= 0 && (f = A.range[0] < A.range[1] ? A._length : 0);
                                        var V, U, q, G, Z, W = Math.abs(c - l) - 2 * _, X = Math.abs(h - f) - 2 * _;
                                        if ("outside" === w && (F || N.hasB || (w = "inside")), "auto" === w && (F ? (w = "inside", V = C(r, R, Z = i.ensureUniformFontSize(e, j)), q = (U = s.bBox(V.node())).width, G = U.height, q > 0 && G > 0 && (q <= W && G <= X || q <= X && G <= W || (I ? W >= q * (X / G) : X >= G * (W / q))) ? w = "inside" : (w = "outside", V.remove(), V = null)) : w = "inside"), !V) {
                                            var J = (V = C(r, R, Z = i.ensureUniformFontSize(e, "outside" === w ? B : j))).attr("transform");
                                            if (V.attr("transform", ""), q = (U = s.bBox(V.node())).width, G = U.height, V.attr("transform", J), q <= 0 || G <= 0) return void V.remove();
                                        }
                                        var K, Q = P.textangle;
                                        K = "outside" === w ? function(e, t, r, n, a, i) {
                                            var o, l = !!i.isHorizontal, s = !!i.constrained, c = i.angle || 0, u = a.width, f = a.height, d = Math.abs(t - e), h = Math.abs(n - r);
                                            o = l ? h > 2 * _ ? _ : 0 : d > 2 * _ ? _ : 0;
                                            var p = 1;
                                            s && (p = l ? Math.min(1, h / f) : Math.min(1, d / u));
                                            var v = L(c), g = S(a, v), y = (l ? g.x : g.y) / 2, m = (a.left + a.right) / 2, x = (a.top + a.bottom) / 2, b = (e + t) / 2, w = (r + n) / 2, T = 0, k = 0, A = l ? M(t, e) : M(r, n);
                                            return l ? (b = t - A * o, T = A * y) : (w = n + A * o, k = -A * y), {
                                                textX: m,
                                                textY: x,
                                                targetX: b,
                                                targetY: w,
                                                anchorX: T,
                                                anchorY: k,
                                                scale: p,
                                                rotate: v
                                            };
                                        }(l, c, f, h, U, {
                                            isHorizontal: I,
                                            constrained: "both" === P.constraintext || "outside" === P.constraintext,
                                            angle: Q
                                        }) : D(l, c, f, h, U, {
                                            isHorizontal: I,
                                            constrained: "both" === P.constraintext || "inside" === P.constraintext,
                                            angle: Q,
                                            anchor: P.insidetextanchor
                                        }), K.fontSize = Z.size, d("histogram" === P.type ? "bar" : P.type, K, O), N.transform = K;
                                        var $ = k(V, O, g, y);
                                        i.setTransormAndDisplay($, K);
                                    } else r.select("text").remove();
                                }(e, t, I, r, h, H, j, B, Y, g, y), t.layerClipId && s.hideOutsideRangePoint(c, I.select("text"), w, O, f.xcalendar, f.ycalendar);
                            });
                            var B = !1 === f.cliponaxis;
                            s.setClipUrl(c, B ? null : t.layerClipId, e);
                        });
                        c.getComponentMethod("errorbars", "plot")(e, I, t, g);
                    },
                    toMoveInsideBar: D
                };
            },
            1974: function(e) {
                "use strict";
                function t(e, t, r, n, a) {
                    var i = t.c2p(n ? e.s0 : e.p0, !0), o = t.c2p(n ? e.s1 : e.p1, !0), l = r.c2p(n ? e.p0 : e.s0, !0), s = r.c2p(n ? e.p1 : e.s1, !0);
                    return a ? [
                        (i + o) / 2,
                        (l + s) / 2
                    ] : n ? [
                        o,
                        (l + s) / 2
                    ] : [
                        (i + o) / 2,
                        s
                    ];
                }
                e.exports = function(e, r) {
                    var n, a = e.cd, i = e.xaxis, o = e.yaxis, l = a[0].trace, s = "funnel" === l.type, c = "h" === l.orientation, u = [];
                    if (!1 === r) for(n = 0; n < a.length; n++)a[n].selected = 0;
                    else for(n = 0; n < a.length; n++){
                        var f = a[n], d = "ct" in f ? f.ct : t(f, i, o, c, s);
                        r.contains(d, !1, n, e) ? (u.push({
                            pointNumber: n,
                            x: i.c2d(f.x),
                            y: o.c2d(f.y)
                        }), f.selected = 1) : f.selected = 0;
                    }
                    return u;
                };
            },
            1546: function(e, t, r) {
                "use strict";
                e.exports = a;
                var n = r(1828).distinctVals;
                function a(e, t) {
                    this.traces = e, this.sepNegVal = t.sepNegVal, this.overlapNoMerge = t.overlapNoMerge;
                    for(var r = 1 / 0, a = t.posAxis._id.charAt(0), i = [], o = 0; o < e.length; o++){
                        for(var l = e[o], s = 0; s < l.length; s++){
                            var c = l[s], u = c.p;
                            void 0 === u && (u = c[a]), void 0 !== u && i.push(u);
                        }
                        l[0] && l[0].width1 && (r = Math.min(l[0].width1, r));
                    }
                    this.positions = i;
                    var f = n(i);
                    this.distinctPositions = f.vals, 1 === f.vals.length && r !== 1 / 0 ? this.minDiff = r : this.minDiff = Math.min(f.minDiff, r);
                    var d = (t.posAxis || {}).type;
                    "category" !== d && "multicategory" !== d || (this.minDiff = 1), this.binWidth = this.minDiff, this.bins = {};
                }
                a.prototype.put = function(e, t) {
                    var r = this.getLabel(e, t), n = this.bins[r] || 0;
                    return this.bins[r] = n + t, n;
                }, a.prototype.get = function(e, t) {
                    var r = this.getLabel(e, t);
                    return this.bins[r] || 0;
                }, a.prototype.getLabel = function(e, t) {
                    return (t < 0 && this.sepNegVal ? "v" : "^") + (this.overlapNoMerge ? e : Math.round(e / this.binWidth));
                };
            },
            6688: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(7901), i = r(1424), o = r(1828), l = r(3972), s = r(2597).resizeText, c = r(1486), u = c.textfont, f = c.insidetextfont, d = c.outsidetextfont, h = r(9383);
                function p(e, t, r) {
                    i.pointStyle(e.selectAll("path"), t, r), v(e, t, r);
                }
                function v(e, t, r) {
                    e.selectAll("text").each(function(e) {
                        var a = n.select(this), l = o.ensureUniformFontSize(r, g(a, e, t, r));
                        i.font(a, l);
                    });
                }
                function g(e, t, r, n) {
                    var a = n._fullLayout.font, i = r.textfont;
                    if (e.classed("bartext-inside")) {
                        var o = _(t, r);
                        i = m(r, t.i, a, o);
                    } else e.classed("bartext-outside") && (i = x(r, t.i, a));
                    return i;
                }
                function y(e, t, r) {
                    return b(u, e.textfont, t, r);
                }
                function m(e, t, r, n) {
                    var i = y(e, t, r);
                    return (void 0 === e._input.textfont || void 0 === e._input.textfont.color || Array.isArray(e.textfont.color) && void 0 === e.textfont.color[t]) && (i = {
                        color: a.contrast(n),
                        family: i.family,
                        size: i.size
                    }), b(f, e.insidetextfont, t, i);
                }
                function x(e, t, r) {
                    var n = y(e, t, r);
                    return b(d, e.outsidetextfont, t, n);
                }
                function b(e, t, r, n) {
                    t = t || {};
                    var a = h.getValue(t.family, r), i = h.getValue(t.size, r), o = h.getValue(t.color, r);
                    return {
                        family: h.coerceString(e.family, a, n.family),
                        size: h.coerceNumber(e.size, i, n.size),
                        color: h.coerceColor(e.color, o, n.color)
                    };
                }
                function _(e, t) {
                    return "waterfall" === t.type ? t[e.dir].marker.color : e.mcc || e.mc || t.marker.color;
                }
                e.exports = {
                    style: function(e) {
                        var t = n.select(e).selectAll("g.barlayer").selectAll("g.trace");
                        s(e, t, "bar");
                        var r = t.size(), a = e._fullLayout;
                        t.style("opacity", function(e) {
                            return e[0].trace.opacity;
                        }).each(function(e) {
                            ("stack" === a.barmode && r > 1 || 0 === a.bargap && 0 === a.bargroupgap && !e[0].trace.marker.line.width) && n.select(this).attr("shape-rendering", "crispEdges");
                        }), t.selectAll("g.points").each(function(t) {
                            p(n.select(this), t[0].trace, e);
                        }), l.getComponentMethod("errorbars", "style")(t);
                    },
                    styleTextPoints: v,
                    styleOnSelect: function(e, t, r) {
                        var a = t[0].trace;
                        a.selectedpoints ? function(e, t, r) {
                            i.selectedPointStyle(e.selectAll("path"), t), function(e, t, r) {
                                e.each(function(e) {
                                    var a, l = n.select(this);
                                    if (e.selected) {
                                        a = o.ensureUniformFontSize(r, g(l, e, t, r));
                                        var s = t.selected.textfont && t.selected.textfont.color;
                                        s && (a.color = s), i.font(l, a);
                                    } else i.selectedTextStyle(l, t);
                                });
                            }(e.selectAll("text"), t, r);
                        }(r, a, e) : (p(r, a, e), l.getComponentMethod("errorbars", "style")(r));
                    },
                    getInsideTextFont: m,
                    getOutsideTextFont: x,
                    getBarColor: _,
                    resizeText: s
                };
            },
            8340: function(e, t, r) {
                "use strict";
                var n = r(7901), a = r(2869).hasColorscale, i = r(1586), o = r(1828).coercePattern;
                e.exports = function(e, t, r, l, s) {
                    var c = r("marker.color", l), u = a(e, "marker");
                    u && i(e, t, s, r, {
                        prefix: "marker.",
                        cLetter: "c"
                    }), r("marker.line.color", n.defaultLine), a(e, "marker.line") && i(e, t, s, r, {
                        prefix: "marker.line.",
                        cLetter: "c"
                    }), r("marker.line.width"), r("marker.opacity"), o(r, "marker.pattern", c, u), r("selected.marker.color"), r("unselected.marker.color");
                };
            },
            2597: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(1828);
                function i(e) {
                    return "_" + e + "Text_minsize";
                }
                e.exports = {
                    recordMinTextSize: function(e, t, r) {
                        if (r.uniformtext.mode) {
                            var n = i(e), a = r.uniformtext.minsize, o = t.scale * t.fontSize;
                            t.hide = o < a, r[n] = r[n] || 1 / 0, t.hide || (r[n] = Math.min(r[n], Math.max(o, a)));
                        }
                    },
                    clearMinTextSize: function(e, t) {
                        t[i(e)] = void 0;
                    },
                    resizeText: function(e, t, r) {
                        var i = e._fullLayout, o = i["_" + r + "Text_minsize"];
                        if (o) {
                            var l, s = "hide" === i.uniformtext.mode;
                            switch(r){
                                case "funnelarea":
                                case "pie":
                                case "sunburst":
                                    l = "g.slice";
                                    break;
                                case "treemap":
                                case "icicle":
                                    l = "g.slice, g.pathbar";
                                    break;
                                default:
                                    l = "g.points > g.point";
                            }
                            t.selectAll(l).each(function(e) {
                                var t = e.transform;
                                if (t) {
                                    t.scale = s && t.hide ? 0 : o / t.fontSize;
                                    var r = n.select(this).select("text");
                                    a.setTransormAndDisplay(r, t);
                                }
                            });
                        }
                    }
                };
            },
            4e3: function(e, t, r) {
                "use strict";
                var n = r(9012), a = r(7670).Y, i = r(1940), o = r(2399), l = r(5386).fF, s = r(5386).si, c = r(1426).extendFlat, u = r(9952).u, f = i({
                    editType: "plot",
                    arrayOk: !0,
                    colorEditType: "plot"
                });
                e.exports = {
                    labels: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    label0: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc"
                    },
                    dlabel: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    values: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    marker: {
                        colors: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        line: {
                            color: {
                                valType: "color",
                                dflt: o.defaultLine,
                                arrayOk: !0,
                                editType: "style"
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                dflt: 0,
                                arrayOk: !0,
                                editType: "style"
                            },
                            editType: "calc"
                        },
                        pattern: u,
                        editType: "calc"
                    },
                    text: {
                        valType: "data_array",
                        editType: "plot"
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "style"
                    },
                    scalegroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    textinfo: {
                        valType: "flaglist",
                        flags: [
                            "label",
                            "text",
                            "value",
                            "percent"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "calc"
                    },
                    hoverinfo: c({}, n.hoverinfo, {
                        flags: [
                            "label",
                            "text",
                            "value",
                            "percent",
                            "name"
                        ]
                    }),
                    hovertemplate: l({}, {
                        keys: [
                            "label",
                            "color",
                            "value",
                            "percent",
                            "text"
                        ]
                    }),
                    texttemplate: s({
                        editType: "plot"
                    }, {
                        keys: [
                            "label",
                            "color",
                            "value",
                            "percent",
                            "text"
                        ]
                    }),
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "inside",
                            "outside",
                            "auto",
                            "none"
                        ],
                        dflt: "auto",
                        arrayOk: !0,
                        editType: "plot"
                    },
                    textfont: c({}, f, {}),
                    insidetextorientation: {
                        valType: "enumerated",
                        values: [
                            "horizontal",
                            "radial",
                            "tangential",
                            "auto"
                        ],
                        dflt: "auto",
                        editType: "plot"
                    },
                    insidetextfont: c({}, f, {}),
                    outsidetextfont: c({}, f, {}),
                    automargin: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    title: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "plot"
                        },
                        font: c({}, f, {}),
                        position: {
                            valType: "enumerated",
                            values: [
                                "top left",
                                "top center",
                                "top right",
                                "middle center",
                                "bottom left",
                                "bottom center",
                                "bottom right"
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    domain: a({
                        name: "pie",
                        trace: !0,
                        editType: "calc"
                    }),
                    hole: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "calc"
                    },
                    sort: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "clockwise",
                            "counterclockwise"
                        ],
                        dflt: "counterclockwise",
                        editType: "calc"
                    },
                    rotation: {
                        valType: "angle",
                        dflt: 0,
                        editType: "calc"
                    },
                    pull: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    _deprecated: {
                        title: {
                            valType: "string",
                            dflt: "",
                            editType: "calc"
                        },
                        titlefont: c({}, f, {}),
                        titleposition: {
                            valType: "enumerated",
                            values: [
                                "top left",
                                "top center",
                                "top right",
                                "middle center",
                                "bottom left",
                                "bottom center",
                                "bottom right"
                            ],
                            editType: "calc"
                        }
                    }
                };
            },
            3584: function(e, t, r) {
                "use strict";
                var n = r(4875);
                t.name = "pie", t.plot = function(e, r, a, i) {
                    n.plotBasePlot(t.name, e, r, a, i);
                }, t.clean = function(e, r, a, i) {
                    n.cleanBasePlot(t.name, e, r, a, i);
                };
            },
            2354: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(4267), i = r(7901), o = {};
                function l(e) {
                    return function(t, r) {
                        return !!t && !!(t = a(t)).isValid() && (t = i.addOpacity(t, t.getAlpha()), e[r] || (e[r] = t), t);
                    };
                }
                function s(e, t) {
                    var r, n = JSON.stringify(e), i = t[n];
                    if (!i) {
                        for(i = e.slice(), r = 0; r < e.length; r++)i.push(a(e[r]).lighten(20).toHexString());
                        for(r = 0; r < e.length; r++)i.push(a(e[r]).darken(20).toHexString());
                        t[n] = i;
                    }
                    return i;
                }
                e.exports = {
                    calc: function(e, t) {
                        var r, a, i = [], o = e._fullLayout, s = o.hiddenlabels || [], c = t.labels, u = t.marker.colors || [], f = t.values, d = t._length, h = t._hasValues && d;
                        if (t.dlabel) for(c = new Array(d), r = 0; r < d; r++)c[r] = String(t.label0 + r * t.dlabel);
                        var p = {}, v = l(o["_" + t.type + "colormap"]), g = 0, y = !1;
                        for(r = 0; r < d; r++){
                            var m, x, b;
                            if (h) {
                                if (m = f[r], !n(m)) continue;
                                m = +m;
                            } else m = 1;
                            void 0 !== (x = c[r]) && "" !== x || (x = r);
                            var _ = p[x = String(x)];
                            void 0 === _ ? (p[x] = i.length, (b = -1 !== s.indexOf(x)) || (g += m), i.push({
                                v: m,
                                label: x,
                                color: v(u[r], x),
                                i: r,
                                pts: [
                                    r
                                ],
                                hidden: b
                            })) : (y = !0, (a = i[_]).v += m, a.pts.push(r), a.hidden || (g += m), !1 === a.color && u[r] && (a.color = v(u[r], x)));
                        }
                        return i = i.filter(function(e) {
                            return e.v >= 0;
                        }), ("funnelarea" === t.type ? y : t.sort) && i.sort(function(e, t) {
                            return t.v - e.v;
                        }), i[0] && (i[0].vTotal = g), i;
                    },
                    crossTraceCalc: function(e, t) {
                        var r = (t || {}).type;
                        r || (r = "pie");
                        var n = e._fullLayout, a = e.calcdata, i = n[r + "colorway"], l = n["_" + r + "colormap"];
                        n["extend" + r + "colors"] && (i = s(i, o));
                        for(var c = 0, u = 0; u < a.length; u++){
                            var f = a[u];
                            if (f[0].trace.type === r) for(var d = 0; d < f.length; d++){
                                var h = f[d];
                                !1 === h.color && (l[h.label] ? h.color = l[h.label] : (l[h.label] = h.color = i[c % i.length], c++));
                            }
                        }
                    },
                    makePullColorFn: l,
                    generateExtendedColors: s
                };
            },
            7434: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(1828), i = r(4e3), o = r(7670).c, l = r(769).handleText, s = r(1828).coercePattern;
                function c(e, t) {
                    var r = Array.isArray(e), i = a.isArrayOrTypedArray(t), o = Math.min(r ? e.length : 1 / 0, i ? t.length : 1 / 0);
                    if (isFinite(o) || (o = 0), o && i) {
                        for(var l, s = 0; s < o; s++){
                            var c = t[s];
                            if (n(c) && c > 0) {
                                l = !0;
                                break;
                            }
                        }
                        l || (o = 0);
                    }
                    return {
                        hasLabels: r,
                        hasValues: i,
                        len: o
                    };
                }
                function u(e, t, r, n, a) {
                    n("marker.line.width") && n("marker.line.color", a ? void 0 : r.paper_bgcolor);
                    var i = n("marker.colors");
                    s(n, "marker.pattern", i), e.marker && !t.marker.pattern.fgcolor && (t.marker.pattern.fgcolor = e.marker.colors), t.marker.pattern.bgcolor || (t.marker.pattern.bgcolor = r.paper_bgcolor);
                }
                e.exports = {
                    handleLabelsAndValues: c,
                    handleMarkerDefaults: u,
                    supplyDefaults: function(e, t, r, n) {
                        function s(r, n) {
                            return a.coerce(e, t, i, r, n);
                        }
                        var f = c(s("labels"), s("values")), d = f.len;
                        if (t._hasLabels = f.hasLabels, t._hasValues = f.hasValues, !t._hasLabels && t._hasValues && (s("label0"), s("dlabel")), d) {
                            t._length = d, u(e, t, n, s, !0), s("scalegroup");
                            var h, p = s("text"), v = s("texttemplate");
                            if (v || (h = s("textinfo", Array.isArray(p) ? "text+percent" : "percent")), s("hovertext"), s("hovertemplate"), v || h && "none" !== h) {
                                var g = s("textposition");
                                l(e, t, n, s, g, {
                                    moduleHasSelected: !1,
                                    moduleHasUnselected: !1,
                                    moduleHasConstrain: !1,
                                    moduleHasCliponaxis: !1,
                                    moduleHasTextangle: !1,
                                    moduleHasInsideanchor: !1
                                }), (Array.isArray(g) || "auto" === g || "outside" === g) && s("automargin"), ("inside" === g || "auto" === g || Array.isArray(g)) && s("insidetextorientation");
                            }
                            o(t, n, s);
                            var y = s("hole");
                            if (s("title.text")) {
                                var m = s("title.position", y ? "middle center" : "top center");
                                y || "middle center" !== m || (t.title.position = "top center"), a.coerceFont(s, "title.font", n.font);
                            }
                            s("sort"), s("direction"), s("rotation"), s("pull");
                        } else t.visible = !1;
                    }
                };
            },
            7: function(e, t, r) {
                "use strict";
                var n = r(3469).appendArrayMultiPointValues;
                e.exports = function(e, t) {
                    var r = {
                        curveNumber: t.index,
                        pointNumbers: e.pts,
                        data: t._input,
                        fullData: t,
                        label: e.label,
                        color: e.color,
                        value: e.v,
                        percent: e.percent,
                        text: e.text,
                        bbox: e.bbox,
                        v: e.v
                    };
                    return 1 === e.pts.length && (r.pointNumber = r.i = e.pts[0]), n(r, t, e.pts), "funnelarea" === t.type && (delete r.v, delete r.i), r;
                };
            },
            2209: function(e, t, r) {
                "use strict";
                var n = r(1424), a = r(7901);
                e.exports = function(e, t, r, i) {
                    var o = r.marker.pattern;
                    o && o.shape ? n.pointStyle(e, r, i, t) : a.fill(e, t.color);
                };
            },
            3581: function(e, t, r) {
                "use strict";
                var n = r(1828);
                function a(e) {
                    return -1 !== e.indexOf("e") ? e.replace(/[.]?0+e/, "e") : -1 !== e.indexOf(".") ? e.replace(/[.]?0+$/, "") : e;
                }
                t.formatPiePercent = function(e, t) {
                    var r = a((100 * e).toPrecision(3));
                    return n.numSeparate(r, t) + "%";
                }, t.formatPieValue = function(e, t) {
                    var r = a(e.toPrecision(10));
                    return n.numSeparate(r, t);
                }, t.getFirstFilled = function(e, t) {
                    if (Array.isArray(e)) for(var r = 0; r < t.length; r++){
                        var n = e[t[r]];
                        if (n || 0 === n || "" === n) return n;
                    }
                }, t.castOption = function(e, r) {
                    return Array.isArray(e) ? t.getFirstFilled(e, r) : e || void 0;
                }, t.getRotationAngle = function(e) {
                    return ("auto" === e ? 0 : e) * Math.PI / 180;
                };
            },
            8810: function(e, t, r) {
                "use strict";
                e.exports = {
                    attributes: r(4e3),
                    supplyDefaults: r(7434).supplyDefaults,
                    supplyLayoutDefaults: r(2097),
                    layoutAttributes: r(7550),
                    calc: r(2354).calc,
                    crossTraceCalc: r(2354).crossTraceCalc,
                    plot: r(4575).plot,
                    style: r(8357),
                    styleOne: r(3463),
                    moduleType: "trace",
                    name: "pie",
                    basePlotModule: r(3584),
                    categories: [
                        "pie-like",
                        "pie",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            7550: function(e) {
                "use strict";
                e.exports = {
                    hiddenlabels: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    piecolorway: {
                        valType: "colorlist",
                        editType: "calc"
                    },
                    extendpiecolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                };
            },
            2097: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(7550);
                e.exports = function(e, t) {
                    function r(r, i) {
                        return n.coerce(e, t, a, r, i);
                    }
                    r("hiddenlabels"), r("piecolorway", t.colorway), r("extendpiecolors");
                };
            },
            4575: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(4875), i = r(211), o = r(7901), l = r(1424), s = r(1828), c = s.strScale, u = s.strTranslate, f = r(3893), d = r(2597), h = d.recordMinTextSize, p = d.clearMinTextSize, v = r(7313).TEXTPAD, g = r(3581), y = r(7), m = r(1828).isValidTextValue;
                function x(e, t, r) {
                    var a = r[0], o = a.cx, l = a.cy, c = a.trace, u = "funnelarea" === c.type;
                    "_hasHoverLabel" in c || (c._hasHoverLabel = !1), "_hasHoverEvent" in c || (c._hasHoverEvent = !1), e.on("mouseover", function(e) {
                        var r = t._fullLayout, f = t._fullData[c.index];
                        if (!t._dragging && !1 !== r.hovermode) {
                            var d = f.hoverinfo;
                            if (Array.isArray(d) && (d = i.castHoverinfo({
                                hoverinfo: [
                                    g.castOption(d, e.pts)
                                ],
                                _module: c._module
                            }, r, 0)), "all" === d && (d = "label+text+value+percent+name"), f.hovertemplate || "none" !== d && "skip" !== d && d) {
                                var h = e.rInscribed || 0, p = o + e.pxmid[0] * (1 - h), v = l + e.pxmid[1] * (1 - h), m = r.separators, x = [];
                                if (d && -1 !== d.indexOf("label") && x.push(e.label), e.text = g.castOption(f.hovertext || f.text, e.pts), d && -1 !== d.indexOf("text")) {
                                    var b = e.text;
                                    s.isValidTextValue(b) && x.push(b);
                                }
                                e.value = e.v, e.valueLabel = g.formatPieValue(e.v, m), d && -1 !== d.indexOf("value") && x.push(e.valueLabel), e.percent = e.v / a.vTotal, e.percentLabel = g.formatPiePercent(e.percent, m), d && -1 !== d.indexOf("percent") && x.push(e.percentLabel);
                                var _ = f.hoverlabel, w = _.font, T = [];
                                i.loneHover({
                                    trace: c,
                                    x0: p - h * a.r,
                                    x1: p + h * a.r,
                                    y: v,
                                    _x0: u ? o + e.TL[0] : p - h * a.r,
                                    _x1: u ? o + e.TR[0] : p + h * a.r,
                                    _y0: u ? l + e.TL[1] : v - h * a.r,
                                    _y1: u ? l + e.BL[1] : v + h * a.r,
                                    text: x.join("<br>"),
                                    name: f.hovertemplate || -1 !== d.indexOf("name") ? f.name : void 0,
                                    idealAlign: e.pxmid[0] < 0 ? "left" : "right",
                                    color: g.castOption(_.bgcolor, e.pts) || e.color,
                                    borderColor: g.castOption(_.bordercolor, e.pts),
                                    fontFamily: g.castOption(w.family, e.pts),
                                    fontSize: g.castOption(w.size, e.pts),
                                    fontColor: g.castOption(w.color, e.pts),
                                    nameLength: g.castOption(_.namelength, e.pts),
                                    textAlign: g.castOption(_.align, e.pts),
                                    hovertemplate: g.castOption(f.hovertemplate, e.pts),
                                    hovertemplateLabels: e,
                                    eventData: [
                                        y(e, f)
                                    ]
                                }, {
                                    container: r._hoverlayer.node(),
                                    outerContainer: r._paper.node(),
                                    gd: t,
                                    inOut_bbox: T
                                }), e.bbox = T[0], c._hasHoverLabel = !0;
                            }
                            c._hasHoverEvent = !0, t.emit("plotly_hover", {
                                points: [
                                    y(e, f)
                                ],
                                event: n.event
                            });
                        }
                    }), e.on("mouseout", function(e) {
                        var r = t._fullLayout, a = t._fullData[c.index], o = n.select(this).datum();
                        c._hasHoverEvent && (e.originalEvent = n.event, t.emit("plotly_unhover", {
                            points: [
                                y(o, a)
                            ],
                            event: n.event
                        }), c._hasHoverEvent = !1), c._hasHoverLabel && (i.loneUnhover(r._hoverlayer.node()), c._hasHoverLabel = !1);
                    }), e.on("click", function(e) {
                        var r = t._fullLayout, a = t._fullData[c.index];
                        t._dragging || !1 === r.hovermode || (t._hoverdata = [
                            y(e, a)
                        ], i.click(t, n.event));
                    });
                }
                function b(e, t, r) {
                    var n = g.castOption(e.insidetextfont.color, t.pts);
                    !n && e._input.textfont && (n = g.castOption(e._input.textfont.color, t.pts));
                    var a = g.castOption(e.insidetextfont.family, t.pts) || g.castOption(e.textfont.family, t.pts) || r.family, i = g.castOption(e.insidetextfont.size, t.pts) || g.castOption(e.textfont.size, t.pts) || r.size;
                    return {
                        color: n || o.contrast(t.color),
                        family: a,
                        size: i
                    };
                }
                function _(e, t) {
                    for(var r, n, a = 0; a < e.length; a++)if ((n = (r = e[a][0]).trace).title.text) {
                        var i = n.title.text;
                        n._meta && (i = s.templateString(i, n._meta));
                        var o = l.tester.append("text").attr("data-notex", 1).text(i).call(l.font, n.title.font).call(f.convertToTspans, t), c = l.bBox(o.node(), !0);
                        r.titleBox = {
                            width: c.width,
                            height: c.height
                        }, o.remove();
                    }
                }
                function w(e, t, r) {
                    var n = r.r || t.rpx1, a = t.rInscribed;
                    if (t.startangle === t.stopangle) return {
                        rCenter: 1 - a,
                        scale: 0,
                        rotate: 0,
                        textPosAngle: 0
                    };
                    var i, o = t.ring, l = 1 === o && Math.abs(t.startangle - t.stopangle) === 2 * Math.PI, s = t.halfangle, c = t.midangle, u = r.trace.insidetextorientation, f = "horizontal" === u, d = "tangential" === u, h = "radial" === u, p = "auto" === u, v = [];
                    if (!p) {
                        var g, y = function(r, a) {
                            if (function(e, t) {
                                var r = e.startangle, n = e.stopangle;
                                return r > t && t > n || r < t && t < n;
                            }(t, r)) {
                                var l = Math.abs(r - t.startangle), s = Math.abs(r - t.stopangle), c = l < s ? l : s;
                                (i = "tan" === a ? M(e, n, o, c, 0) : T(e, n, o, c, Math.PI / 2)).textPosAngle = r, v.push(i);
                            }
                        };
                        if (f || d) {
                            for(g = 4; g >= -4; g -= 2)y(Math.PI * g, "tan");
                            for(g = 4; g >= -4; g -= 2)y(Math.PI * (g + 1), "tan");
                        }
                        if (f || h) {
                            for(g = 4; g >= -4; g -= 2)y(Math.PI * (g + 1.5), "rad");
                            for(g = 4; g >= -4; g -= 2)y(Math.PI * (g + .5), "rad");
                        }
                    }
                    if (l || p || f) {
                        var m = Math.sqrt(e.width * e.width + e.height * e.height);
                        if ((i = {
                            scale: a * n * 2 / m,
                            rCenter: 1 - a,
                            rotate: 0
                        }).textPosAngle = (t.startangle + t.stopangle) / 2, i.scale >= 1) return i;
                        v.push(i);
                    }
                    (p || h) && ((i = T(e, n, o, s, c)).textPosAngle = (t.startangle + t.stopangle) / 2, v.push(i)), (p || d) && ((i = M(e, n, o, s, c)).textPosAngle = (t.startangle + t.stopangle) / 2, v.push(i));
                    for(var x = 0, b = 0, _ = 0; _ < v.length; _++){
                        var w = v[_].scale;
                        if (b < w && (b = w, x = _), !p && b >= 1) break;
                    }
                    return v[x];
                }
                function T(e, t, r, n, a) {
                    t = Math.max(0, t - 2 * v);
                    var i = e.width / e.height, o = L(i, n, t, r);
                    return {
                        scale: 2 * o / e.height,
                        rCenter: k(i, o / t),
                        rotate: A(a)
                    };
                }
                function M(e, t, r, n, a) {
                    t = Math.max(0, t - 2 * v);
                    var i = e.height / e.width, o = L(i, n, t, r);
                    return {
                        scale: 2 * o / e.width,
                        rCenter: k(i, o / t),
                        rotate: A(a + Math.PI / 2)
                    };
                }
                function k(e, t) {
                    return Math.cos(t) - e * t;
                }
                function A(e) {
                    return (180 / Math.PI * e + 720) % 180 - 90;
                }
                function L(e, t, r, n) {
                    var a = e + 1 / (2 * Math.tan(t));
                    return r * Math.min(1 / (Math.sqrt(a * a + .5) + a), n / (Math.sqrt(e * e + n / 2) + e));
                }
                function S(e, t) {
                    return e.v !== t.vTotal || t.trace.hole ? Math.min(1 / (1 + 1 / Math.sin(e.halfangle)), e.ring / 2) : 1;
                }
                function D(e, t) {
                    var r = t.pxmid[0], n = t.pxmid[1], a = e.width / 2, i = e.height / 2;
                    return r < 0 && (a *= -1), n < 0 && (i *= -1), {
                        scale: 1,
                        rCenter: 1,
                        rotate: 0,
                        x: a + Math.abs(i) * (a > 0 ? 1 : -1) / 2,
                        y: i / (1 + r * r / (n * n)),
                        outside: !0
                    };
                }
                function O(e, t) {
                    var r, n, a, i = e.trace, o = {
                        x: e.cx,
                        y: e.cy
                    }, l = {
                        tx: 0,
                        ty: 0
                    };
                    l.ty += i.title.font.size, a = P(i), -1 !== i.title.position.indexOf("top") ? (o.y -= (1 + a) * e.r, l.ty -= e.titleBox.height) : -1 !== i.title.position.indexOf("bottom") && (o.y += (1 + a) * e.r);
                    var s, c = e.r / (void 0 === (s = e.trace.aspectratio) ? 1 : s), u = t.w * (i.domain.x[1] - i.domain.x[0]) / 2;
                    return -1 !== i.title.position.indexOf("left") ? (u += c, o.x -= (1 + a) * c, l.tx += e.titleBox.width / 2) : -1 !== i.title.position.indexOf("center") ? u *= 2 : -1 !== i.title.position.indexOf("right") && (u += c, o.x += (1 + a) * c, l.tx -= e.titleBox.width / 2), r = u / e.titleBox.width, n = C(e, t) / e.titleBox.height, {
                        x: o.x,
                        y: o.y,
                        scale: Math.min(r, n),
                        tx: l.tx,
                        ty: l.ty
                    };
                }
                function C(e, t) {
                    var r = e.trace, n = t.h * (r.domain.y[1] - r.domain.y[0]);
                    return Math.min(e.titleBox.height, n / 2);
                }
                function P(e) {
                    var t, r = e.pull;
                    if (!r) return 0;
                    if (Array.isArray(r)) for(r = 0, t = 0; t < e.pull.length; t++)e.pull[t] > r && (r = e.pull[t]);
                    return r;
                }
                function I(e, t) {
                    for(var r = [], n = 0; n < e.length; n++){
                        var a = e[n][0], i = a.trace, o = i.domain, l = t.w * (o.x[1] - o.x[0]), s = t.h * (o.y[1] - o.y[0]);
                        i.title.text && "middle center" !== i.title.position && (s -= C(a, t));
                        var c = l / 2, u = s / 2;
                        "funnelarea" !== i.type || i.scalegroup || (u /= i.aspectratio), a.r = Math.min(c, u) / (1 + P(i)), a.cx = t.l + t.w * (i.domain.x[1] + i.domain.x[0]) / 2, a.cy = t.t + t.h * (1 - i.domain.y[0]) - s / 2, i.title.text && -1 !== i.title.position.indexOf("bottom") && (a.cy -= C(a, t)), i.scalegroup && -1 === r.indexOf(i.scalegroup) && r.push(i.scalegroup);
                    }
                    !function(e, t) {
                        for(var r, n, a, i = 0; i < t.length; i++){
                            var o = 1 / 0, l = t[i];
                            for(n = 0; n < e.length; n++)if ((a = (r = e[n][0]).trace).scalegroup === l) {
                                var s;
                                if ("pie" === a.type) s = r.r * r.r;
                                else if ("funnelarea" === a.type) {
                                    var c, u;
                                    a.aspectratio > 1 ? u = (c = r.r) / a.aspectratio : c = (u = r.r) * a.aspectratio, s = (c *= (1 + a.baseratio) / 2) * u;
                                }
                                o = Math.min(o, s / r.vTotal);
                            }
                            for(n = 0; n < e.length; n++)if ((a = (r = e[n][0]).trace).scalegroup === l) {
                                var f = o * r.vTotal;
                                "funnelarea" === a.type && (f /= (1 + a.baseratio) / 2, f /= a.aspectratio), r.r = Math.sqrt(f);
                            }
                        }
                    }(e, r);
                }
                function R(e, t) {
                    return [
                        e * Math.sin(t),
                        -e * Math.cos(t)
                    ];
                }
                function z(e, t, r) {
                    var n = e._fullLayout, a = r.trace, i = a.texttemplate, o = a.textinfo;
                    if (!i && o && "none" !== o) {
                        var l, c = o.split("+"), u = function(e) {
                            return -1 !== c.indexOf(e);
                        }, f = u("label"), d = u("text"), h = u("value"), p = u("percent"), v = n.separators;
                        if (l = f ? [
                            t.label
                        ] : [], d) {
                            var y = g.getFirstFilled(a.text, t.pts);
                            m(y) && l.push(y);
                        }
                        h && l.push(g.formatPieValue(t.v, v)), p && l.push(g.formatPiePercent(t.v / r.vTotal, v)), t.text = l.join("<br>");
                    }
                    if (i) {
                        var x = s.castOption(a, t.i, "texttemplate");
                        if (x) {
                            var b = function(e) {
                                return {
                                    label: e.label,
                                    value: e.v,
                                    valueLabel: g.formatPieValue(e.v, n.separators),
                                    percent: e.v / r.vTotal,
                                    percentLabel: g.formatPiePercent(e.v / r.vTotal, n.separators),
                                    color: e.color,
                                    text: e.text,
                                    customdata: s.castOption(a, e.i, "customdata")
                                };
                            }(t), _ = g.getFirstFilled(a.text, t.pts);
                            (m(_) || "" === _) && (b.text = _), t.text = s.texttemplateString(x, b, e._fullLayout._d3locale, b, a._meta || {});
                        } else t.text = "";
                    }
                }
                function N(e, t) {
                    var r = e.rotate * Math.PI / 180, n = Math.cos(r), a = Math.sin(r), i = (t.left + t.right) / 2, o = (t.top + t.bottom) / 2;
                    e.textX = i * n - o * a, e.textY = i * a + o * n, e.noCenter = !0;
                }
                e.exports = {
                    plot: function(e, t) {
                        var r = e._context.staticPlot, i = e._fullLayout, d = i._size;
                        p("pie", i), _(t, e), I(t, d);
                        var v = s.makeTraceGroups(i._pielayer, t, "trace").each(function(t) {
                            var p = n.select(this), v = t[0], y = v.trace;
                            !function(e) {
                                var t, r, n, a = e[0], i = a.r, o = a.trace, l = g.getRotationAngle(o.rotation), s = 2 * Math.PI / a.vTotal, c = "px0", u = "px1";
                                if ("counterclockwise" === o.direction) {
                                    for(t = 0; t < e.length && e[t].hidden; t++);
                                    if (t === e.length) return;
                                    l += s * e[t].v, s *= -1, c = "px1", u = "px0";
                                }
                                for(n = R(i, l), t = 0; t < e.length; t++)(r = e[t]).hidden || (r[c] = n, r.startangle = l, l += s * r.v / 2, r.pxmid = R(i, l), r.midangle = l, n = R(i, l += s * r.v / 2), r.stopangle = l, r[u] = n, r.largeArc = r.v > a.vTotal / 2 ? 1 : 0, r.halfangle = Math.PI * Math.min(r.v / a.vTotal, .5), r.ring = 1 - o.hole, r.rInscribed = S(r, a));
                            }(t), p.attr("stroke-linejoin", "round"), p.each(function() {
                                var m = n.select(this).selectAll("g.slice").data(t);
                                m.enter().append("g").classed("slice", !0), m.exit().remove();
                                var _ = [
                                    [
                                        [],
                                        []
                                    ],
                                    [
                                        [],
                                        []
                                    ]
                                ], T = !1;
                                m.each(function(a, o) {
                                    if (a.hidden) n.select(this).selectAll("path,g").remove();
                                    else {
                                        a.pointNumber = a.i, a.curveNumber = y.index, _[a.pxmid[1] < 0 ? 0 : 1][a.pxmid[0] < 0 ? 0 : 1].push(a);
                                        var c = v.cx, u = v.cy, d = n.select(this), p = d.selectAll("path.surface").data([
                                            a
                                        ]);
                                        if (p.enter().append("path").classed("surface", !0).style({
                                            "pointer-events": r ? "none" : "all"
                                        }), d.call(x, e, t), y.pull) {
                                            var m = +g.castOption(y.pull, a.pts) || 0;
                                            m > 0 && (c += m * a.pxmid[0], u += m * a.pxmid[1]);
                                        }
                                        a.cxFinal = c, a.cyFinal = u;
                                        var M = y.hole;
                                        if (a.v === v.vTotal) {
                                            var k = "M" + (c + a.px0[0]) + "," + (u + a.px0[1]) + C(a.px0, a.pxmid, !0, 1) + C(a.pxmid, a.px0, !0, 1) + "Z";
                                            M ? p.attr("d", "M" + (c + M * a.px0[0]) + "," + (u + M * a.px0[1]) + C(a.px0, a.pxmid, !1, M) + C(a.pxmid, a.px0, !1, M) + "Z" + k) : p.attr("d", k);
                                        } else {
                                            var A = C(a.px0, a.px1, !0, 1);
                                            if (M) {
                                                var L = 1 - M;
                                                p.attr("d", "M" + (c + M * a.px1[0]) + "," + (u + M * a.px1[1]) + C(a.px1, a.px0, !1, M) + "l" + L * a.px0[0] + "," + L * a.px0[1] + A + "Z");
                                            } else p.attr("d", "M" + c + "," + u + "l" + a.px0[0] + "," + a.px0[1] + A + "Z");
                                        }
                                        z(e, a, v);
                                        var S = g.castOption(y.textposition, a.pts), O = d.selectAll("g.slicetext").data(a.text && "none" !== S ? [
                                            0
                                        ] : []);
                                        O.enter().append("g").classed("slicetext", !0), O.exit().remove(), O.each(function() {
                                            var r = s.ensureSingle(n.select(this), "text", "", function(e) {
                                                e.attr("data-notex", 1);
                                            }), d = s.ensureUniformFontSize(e, "outside" === S ? function(e, t, r) {
                                                return {
                                                    color: g.castOption(e.outsidetextfont.color, t.pts) || g.castOption(e.textfont.color, t.pts) || r.color,
                                                    family: g.castOption(e.outsidetextfont.family, t.pts) || g.castOption(e.textfont.family, t.pts) || r.family,
                                                    size: g.castOption(e.outsidetextfont.size, t.pts) || g.castOption(e.textfont.size, t.pts) || r.size
                                                };
                                            }(y, a, i.font) : b(y, a, i.font));
                                            r.text(a.text).attr({
                                                class: "slicetext",
                                                transform: "",
                                                "text-anchor": "middle"
                                            }).call(l.font, d).call(f.convertToTspans, e);
                                            var p, m = l.bBox(r.node());
                                            if ("outside" === S) p = D(m, a);
                                            else if (p = w(m, a, v), "auto" === S && p.scale < 1) {
                                                var x = s.ensureUniformFontSize(e, y.outsidetextfont);
                                                r.call(l.font, x), p = D(m = l.bBox(r.node()), a);
                                            }
                                            var _ = p.textPosAngle, M = void 0 === _ ? a.pxmid : R(v.r, _);
                                            if (p.targetX = c + M[0] * p.rCenter + (p.x || 0), p.targetY = u + M[1] * p.rCenter + (p.y || 0), N(p, m), p.outside) {
                                                var k = p.targetY;
                                                a.yLabelMin = k - m.height / 2, a.yLabelMid = k, a.yLabelMax = k + m.height / 2, a.labelExtraX = 0, a.labelExtraY = 0, T = !0;
                                            }
                                            p.fontSize = d.size, h(y.type, p, i), t[o].transform = p, s.setTransormAndDisplay(r, p);
                                        });
                                    }
                                    function C(e, t, r, n) {
                                        var i = n * (t[0] - e[0]), o = n * (t[1] - e[1]);
                                        return "a" + n * v.r + "," + n * v.r + " 0 " + a.largeArc + (r ? " 1 " : " 0 ") + i + "," + o;
                                    }
                                });
                                var M = n.select(this).selectAll("g.titletext").data(y.title.text ? [
                                    0
                                ] : []);
                                if (M.enter().append("g").classed("titletext", !0), M.exit().remove(), M.each(function() {
                                    var t, r = s.ensureSingle(n.select(this), "text", "", function(e) {
                                        e.attr("data-notex", 1);
                                    }), a = y.title.text;
                                    y._meta && (a = s.templateString(a, y._meta)), r.text(a).attr({
                                        class: "titletext",
                                        transform: "",
                                        "text-anchor": "middle"
                                    }).call(l.font, y.title.font).call(f.convertToTspans, e), t = "middle center" === y.title.position ? function(e) {
                                        var t = Math.sqrt(e.titleBox.width * e.titleBox.width + e.titleBox.height * e.titleBox.height);
                                        return {
                                            x: e.cx,
                                            y: e.cy,
                                            scale: e.trace.hole * e.r * 2 / t,
                                            tx: 0,
                                            ty: -e.titleBox.height / 2 + e.trace.title.font.size
                                        };
                                    }(v) : O(v, d), r.attr("transform", u(t.x, t.y) + c(Math.min(1, t.scale)) + u(t.tx, t.ty));
                                }), T && function(e, t) {
                                    var r, n, a, i, o, l, s, c, u, f, d, h, p;
                                    function v(e, t) {
                                        return e.pxmid[1] - t.pxmid[1];
                                    }
                                    function y(e, t) {
                                        return t.pxmid[1] - e.pxmid[1];
                                    }
                                    function m(e, r) {
                                        r || (r = {});
                                        var a, c, u, d, h = r.labelExtraY + (n ? r.yLabelMax : r.yLabelMin), p = n ? e.yLabelMin : e.yLabelMax, v = n ? e.yLabelMax : e.yLabelMin, y = e.cyFinal + o(e.px0[1], e.px1[1]), m = h - p;
                                        if (m * s > 0 && (e.labelExtraY = m), Array.isArray(t.pull)) for(c = 0; c < f.length; c++)(u = f[c]) === e || (g.castOption(t.pull, e.pts) || 0) >= (g.castOption(t.pull, u.pts) || 0) || ((e.pxmid[1] - u.pxmid[1]) * s > 0 ? (m = u.cyFinal + o(u.px0[1], u.px1[1]) - p - e.labelExtraY) * s > 0 && (e.labelExtraY += m) : (v + e.labelExtraY - y) * s > 0 && (a = 3 * l * Math.abs(c - f.indexOf(e)), (d = u.cxFinal + i(u.px0[0], u.px1[0]) + a - (e.cxFinal + e.pxmid[0]) - e.labelExtraX) * l > 0 && (e.labelExtraX += d)));
                                    }
                                    for(n = 0; n < 2; n++)for(a = n ? v : y, o = n ? Math.max : Math.min, s = n ? 1 : -1, r = 0; r < 2; r++){
                                        for(i = r ? Math.max : Math.min, l = r ? 1 : -1, (c = e[n][r]).sort(a), u = e[1 - n][r], f = u.concat(c), h = [], d = 0; d < c.length; d++)void 0 !== c[d].yLabelMid && h.push(c[d]);
                                        for(p = !1, d = 0; n && d < u.length; d++)if (void 0 !== u[d].yLabelMid) {
                                            p = u[d];
                                            break;
                                        }
                                        for(d = 0; d < h.length; d++){
                                            var x = d && h[d - 1];
                                            p && !d && (x = p), m(h[d], x);
                                        }
                                    }
                                }(_, y), function(e, t) {
                                    e.each(function(e) {
                                        var r = n.select(this);
                                        if (e.labelExtraX || e.labelExtraY) {
                                            var a = r.select("g.slicetext text");
                                            e.transform.targetX += e.labelExtraX, e.transform.targetY += e.labelExtraY, s.setTransormAndDisplay(a, e.transform);
                                            var i = e.cxFinal + e.pxmid[0], l = "M" + i + "," + (e.cyFinal + e.pxmid[1]), c = (e.yLabelMax - e.yLabelMin) * (e.pxmid[0] < 0 ? -1 : 1) / 4;
                                            if (e.labelExtraX) {
                                                var u = e.labelExtraX * e.pxmid[1] / e.pxmid[0], f = e.yLabelMid + e.labelExtraY - (e.cyFinal + e.pxmid[1]);
                                                Math.abs(u) > Math.abs(f) ? l += "l" + f * e.pxmid[0] / e.pxmid[1] + "," + f + "H" + (i + e.labelExtraX + c) : l += "l" + e.labelExtraX + "," + u + "v" + (f - u) + "h" + c;
                                            } else l += "V" + (e.yLabelMid + e.labelExtraY) + "h" + c;
                                            s.ensureSingle(r, "path", "textline").call(o.stroke, t.outsidetextfont.color).attr({
                                                "stroke-width": Math.min(2, t.outsidetextfont.size / 8),
                                                d: l,
                                                fill: "none"
                                            });
                                        } else r.select("path.textline").remove();
                                    });
                                }(m, y), T && y.automargin) {
                                    var k = l.bBox(p.node()), A = y.domain, L = d.w * (A.x[1] - A.x[0]), S = d.h * (A.y[1] - A.y[0]), C = (.5 * L - v.r) / d.w, P = (.5 * S - v.r) / d.h;
                                    a.autoMargin(e, "pie." + y.uid + ".automargin", {
                                        xl: A.x[0] - C,
                                        xr: A.x[1] + C,
                                        yb: A.y[0] - P,
                                        yt: A.y[1] + P,
                                        l: Math.max(v.cx - v.r - k.left, 0),
                                        r: Math.max(k.right - (v.cx + v.r), 0),
                                        b: Math.max(k.bottom - (v.cy + v.r), 0),
                                        t: Math.max(v.cy - v.r - k.top, 0),
                                        pad: 5
                                    });
                                }
                            });
                        });
                        setTimeout(function() {
                            v.selectAll("tspan").each(function() {
                                var e = n.select(this);
                                e.attr("dy") && e.attr("dy", e.attr("dy"));
                            });
                        }, 0);
                    },
                    formatSliceLabel: z,
                    transformInsideText: w,
                    determineInsideTextFont: b,
                    positionTitleOutside: O,
                    prerenderTitles: _,
                    layoutAreas: I,
                    attachFxHandlers: x,
                    computeTransform: N
                };
            },
            8357: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(3463), i = r(2597).resizeText;
                e.exports = function(e) {
                    var t = e._fullLayout._pielayer.selectAll(".trace");
                    i(e, t, "pie"), t.each(function(t) {
                        var r = t[0].trace, i = n.select(this);
                        i.style({
                            opacity: r.opacity
                        }), i.selectAll("path.surface").each(function(t) {
                            n.select(this).call(a, t, r, e);
                        });
                    });
                };
            },
            3463: function(e, t, r) {
                "use strict";
                var n = r(7901), a = r(3581).castOption, i = r(2209);
                e.exports = function(e, t, r, o) {
                    var l = r.marker.line, s = a(l.color, t.pts) || n.defaultLine, c = a(l.width, t.pts) || 0;
                    e.call(i, t, r, o).style("stroke-width", c).call(n.stroke, s);
                };
            },
            5225: function(e, t, r) {
                "use strict";
                var n = r(1828);
                e.exports = function(e, t) {
                    for(var r = 0; r < e.length; r++)e[r].i = r;
                    n.mergeArray(t.text, e, "tx"), n.mergeArray(t.texttemplate, e, "txt"), n.mergeArray(t.hovertext, e, "htx"), n.mergeArray(t.customdata, e, "data"), n.mergeArray(t.textposition, e, "tp"), t.textfont && (n.mergeArrayCastPositive(t.textfont.size, e, "ts"), n.mergeArray(t.textfont.color, e, "tc"), n.mergeArray(t.textfont.family, e, "tf"));
                    var a = t.marker;
                    if (a) {
                        n.mergeArrayCastPositive(a.size, e, "ms"), n.mergeArrayCastPositive(a.opacity, e, "mo"), n.mergeArray(a.symbol, e, "mx"), n.mergeArray(a.angle, e, "ma"), n.mergeArray(a.standoff, e, "mf"), n.mergeArray(a.color, e, "mc");
                        var i = a.line;
                        a.line && (n.mergeArray(i.color, e, "mlc"), n.mergeArrayCastPositive(i.width, e, "mlw"));
                        var o = a.gradient;
                        o && "none" !== o.type && (n.mergeArray(o.type, e, "mgt"), n.mergeArray(o.color, e, "mgc"));
                    }
                };
            },
            2196: function(e, t, r) {
                "use strict";
                var n = r(2663).axisHoverFormat, a = r(5386).si, i = r(5386).fF, o = r(693), l = r(1940), s = r(9952).P, c = r(9952).u, u = r(1424), f = r(7581), d = r(1426).extendFlat;
                e.exports = {
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    x0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    dx: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc",
                        anim: !0
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    y0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    dy: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc",
                        anim: !0
                    },
                    xperiod: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc"
                    },
                    yperiod: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc"
                    },
                    xperiod0: {
                        valType: "any",
                        editType: "calc"
                    },
                    yperiod0: {
                        valType: "any",
                        editType: "calc"
                    },
                    xperiodalignment: {
                        valType: "enumerated",
                        values: [
                            "start",
                            "middle",
                            "end"
                        ],
                        dflt: "middle",
                        editType: "calc"
                    },
                    yperiodalignment: {
                        valType: "enumerated",
                        values: [
                            "start",
                            "middle",
                            "end"
                        ],
                        dflt: "middle",
                        editType: "calc"
                    },
                    xhoverformat: n("x"),
                    yhoverformat: n("y"),
                    offsetgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    alignmentgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    stackgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        editType: "calc"
                    },
                    groupnorm: {
                        valType: "enumerated",
                        values: [
                            "",
                            "fraction",
                            "percent"
                        ],
                        dflt: "",
                        editType: "calc"
                    },
                    stackgaps: {
                        valType: "enumerated",
                        values: [
                            "infer zero",
                            "interpolate"
                        ],
                        dflt: "infer zero",
                        editType: "calc"
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    texttemplate: a({}, {}),
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "style"
                    },
                    mode: {
                        valType: "flaglist",
                        flags: [
                            "lines",
                            "markers",
                            "text"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "calc"
                    },
                    hoveron: {
                        valType: "flaglist",
                        flags: [
                            "points",
                            "fills"
                        ],
                        editType: "style"
                    },
                    hovertemplate: i({}, {
                        keys: f.eventDataKeys
                    }),
                    line: {
                        color: {
                            valType: "color",
                            editType: "style",
                            anim: !0
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 2,
                            editType: "style",
                            anim: !0
                        },
                        shape: {
                            valType: "enumerated",
                            values: [
                                "linear",
                                "spline",
                                "hv",
                                "vh",
                                "hvh",
                                "vhv"
                            ],
                            dflt: "linear",
                            editType: "plot"
                        },
                        smoothing: {
                            valType: "number",
                            min: 0,
                            max: 1.3,
                            dflt: 1,
                            editType: "plot"
                        },
                        dash: d({}, s, {
                            editType: "style"
                        }),
                        backoff: {
                            valType: "number",
                            min: 0,
                            dflt: "auto",
                            arrayOk: !0,
                            editType: "plot"
                        },
                        simplify: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    connectgaps: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    cliponaxis: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    fill: {
                        valType: "enumerated",
                        values: [
                            "none",
                            "tozeroy",
                            "tozerox",
                            "tonexty",
                            "tonextx",
                            "toself",
                            "tonext"
                        ],
                        editType: "calc"
                    },
                    fillcolor: {
                        valType: "color",
                        editType: "style",
                        anim: !0
                    },
                    fillpattern: c,
                    marker: d({
                        symbol: {
                            valType: "enumerated",
                            values: u.symbolList,
                            dflt: "circle",
                            arrayOk: !0,
                            editType: "style"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            arrayOk: !0,
                            editType: "style",
                            anim: !0
                        },
                        angle: {
                            valType: "angle",
                            dflt: 0,
                            arrayOk: !0,
                            editType: "plot",
                            anim: !1
                        },
                        angleref: {
                            valType: "enumerated",
                            values: [
                                "previous",
                                "up"
                            ],
                            dflt: "up",
                            editType: "plot",
                            anim: !1
                        },
                        standoff: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            arrayOk: !0,
                            editType: "plot",
                            anim: !0
                        },
                        size: {
                            valType: "number",
                            min: 0,
                            dflt: 6,
                            arrayOk: !0,
                            editType: "calc",
                            anim: !0
                        },
                        maxdisplayed: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        sizeref: {
                            valType: "number",
                            dflt: 1,
                            editType: "calc"
                        },
                        sizemin: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "calc"
                        },
                        sizemode: {
                            valType: "enumerated",
                            values: [
                                "diameter",
                                "area"
                            ],
                            dflt: "diameter",
                            editType: "calc"
                        },
                        line: d({
                            width: {
                                valType: "number",
                                min: 0,
                                arrayOk: !0,
                                editType: "style",
                                anim: !0
                            },
                            editType: "calc"
                        }, o("marker.line", {
                            anim: !0
                        })),
                        gradient: {
                            type: {
                                valType: "enumerated",
                                values: [
                                    "radial",
                                    "horizontal",
                                    "vertical",
                                    "none"
                                ],
                                arrayOk: !0,
                                dflt: "none",
                                editType: "calc"
                            },
                            color: {
                                valType: "color",
                                arrayOk: !0,
                                editType: "calc"
                            },
                            editType: "calc"
                        },
                        editType: "calc"
                    }, o("marker", {
                        anim: !0
                    })),
                    selected: {
                        marker: {
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "style"
                            },
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            size: {
                                valType: "number",
                                min: 0,
                                editType: "style"
                            },
                            editType: "style"
                        },
                        textfont: {
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "style"
                    },
                    unselected: {
                        marker: {
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "style"
                            },
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            size: {
                                valType: "number",
                                min: 0,
                                editType: "style"
                            },
                            editType: "style"
                        },
                        textfont: {
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "style"
                    },
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "top left",
                            "top center",
                            "top right",
                            "middle left",
                            "middle center",
                            "middle right",
                            "bottom left",
                            "bottom center",
                            "bottom right"
                        ],
                        dflt: "middle center",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    textfont: l({
                        editType: "calc",
                        colorEditType: "style",
                        arrayOk: !0
                    })
                };
            },
            7761: function(e, t, r) {
                "use strict";
                var n = r(2770), a = r(1828), i = r(9298), o = r(2973), l = r(606).BADNUM, s = r(4098), c = r(6922), u = r(5225), f = r(6279);
                function d(e, t, r, n, a, o, l) {
                    var c = t._length, u = e._fullLayout, f = r._id, d = n._id, h = u._firstScatter[v(t)] === t.uid, p = (g(t, u, r, n) || {}).orientation, y = t.fill;
                    r._minDtick = 0, n._minDtick = 0;
                    var m = {
                        padded: !0
                    }, x = {
                        padded: !0
                    };
                    l && (m.ppad = x.ppad = l);
                    var b = c < 2 || a[0] !== a[c - 1] || o[0] !== o[c - 1];
                    b && ("tozerox" === y || "tonextx" === y && (h || "h" === p)) ? m.tozero = !0 : (t.error_y || {}).visible || "tonexty" !== y && "tozeroy" !== y && (s.hasMarkers(t) || s.hasText(t)) || (m.padded = !1, m.ppad = 0), b && ("tozeroy" === y || "tonexty" === y && (h || "v" === p)) ? x.tozero = !0 : "tonextx" !== y && "tozerox" !== y || (x.padded = !1), f && (t._extremes[f] = i.findExtremes(r, a, m)), d && (t._extremes[d] = i.findExtremes(n, o, x));
                }
                function h(e, t) {
                    if (s.hasMarkers(e)) {
                        var r, n = e.marker, o = 1.6 * (e.marker.sizeref || 1);
                        if (r = "area" === e.marker.sizemode ? function(e) {
                            return Math.max(Math.sqrt((e || 0) / o), 3);
                        } : function(e) {
                            return Math.max((e || 0) / o, 3);
                        }, a.isArrayOrTypedArray(n.size)) {
                            var l = {
                                type: "linear"
                            };
                            i.setConvert(l);
                            for(var c = l.makeCalcdata(e.marker, "size"), u = new Array(t), f = 0; f < t; f++)u[f] = r(c[f]);
                            return u;
                        }
                        return r(n.size);
                    }
                }
                function p(e, t) {
                    var r = v(t), n = e._firstScatter;
                    n[r] || (n[r] = t.uid);
                }
                function v(e) {
                    var t = e.stackgroup;
                    return e.xaxis + e.yaxis + e.type + (t ? "-" + t : "");
                }
                function g(e, t, r, n) {
                    var a = e.stackgroup;
                    if (a) {
                        var i = t._scatterStackOpts[r._id + n._id][a], o = "v" === i.orientation ? n : r;
                        return "linear" === o.type || "log" === o.type ? i : void 0;
                    }
                }
                e.exports = {
                    calc: function(e, t) {
                        var r, s, v, y, m, x, b = e._fullLayout, _ = t._xA = i.getFromId(e, t.xaxis || "x", "x"), w = t._yA = i.getFromId(e, t.yaxis || "y", "y"), T = _.makeCalcdata(t, "x"), M = w.makeCalcdata(t, "y"), k = o(t, _, "x", T), A = o(t, w, "y", M), L = k.vals, S = A.vals, D = t._length, O = new Array(D), C = t.ids, P = g(t, b, _, w), I = !1;
                        p(b, t);
                        var R, z = "x", N = "y";
                        P ? (a.pushUnique(P.traceIndices, t._expandedIndex), (r = "v" === P.orientation) ? (N = "s", R = "x") : (z = "s", R = "y"), m = "interpolate" === P.stackgaps) : d(e, t, _, w, L, S, h(t, D));
                        var F = !!t.xperiodalignment, E = !!t.yperiodalignment;
                        for(s = 0; s < D; s++){
                            var H = O[s] = {}, j = n(L[s]), B = n(S[s]);
                            j && B ? (H[z] = L[s], H[N] = S[s], F && (H.orig_x = T[s], H.xEnd = k.ends[s], H.xStart = k.starts[s]), E && (H.orig_y = M[s], H.yEnd = A.ends[s], H.yStart = A.starts[s])) : P && (r ? j : B) ? (H[R] = r ? L[s] : S[s], H.gap = !0, m ? (H.s = l, I = !0) : H.s = 0) : H[z] = H[N] = l, C && (H.id = String(C[s]));
                        }
                        if (u(O, t), c(e, t), f(O, t), P) {
                            for(s = 0; s < O.length;)O[s][R] === l ? O.splice(s, 1) : s++;
                            if (a.sort(O, function(e, t) {
                                return e[R] - t[R] || e.i - t.i;
                            }), I) {
                                for(s = 0; s < O.length - 1 && O[s].gap;)s++;
                                for((x = O[s].s) || (x = O[s].s = 0), v = 0; v < s; v++)O[v].s = x;
                                for(y = O.length - 1; y > s && O[y].gap;)y--;
                                for(x = O[y].s, v = O.length - 1; v > y; v--)O[v].s = x;
                                for(; s < y;)if (O[++s].gap) {
                                    for(v = s + 1; O[v].gap;)v++;
                                    for(var Y = O[s - 1][R], V = O[s - 1].s, U = (O[v].s - V) / (O[v][R] - Y); s < v;)O[s].s = V + (O[s][R] - Y) * U, s++;
                                }
                            }
                        }
                        return O;
                    },
                    calcMarkerSize: h,
                    calcAxisExpansion: d,
                    setFirstScatter: p,
                    getStackOpts: g
                };
            },
            6279: function(e, t, r) {
                "use strict";
                var n = r(1828);
                e.exports = function(e, t) {
                    n.isArrayOrTypedArray(t.selectedpoints) && n.tagSelected(e, t);
                };
            },
            6922: function(e, t, r) {
                "use strict";
                var n = r(2869).hasColorscale, a = r(8803), i = r(4098);
                e.exports = function(e, t) {
                    i.hasLines(t) && n(t, "line") && a(e, t, {
                        vals: t.line.color,
                        containerStr: "line",
                        cLetter: "c"
                    }), i.hasMarkers(t) && (n(t, "marker") && a(e, t, {
                        vals: t.marker.color,
                        containerStr: "marker",
                        cLetter: "c"
                    }), n(t, "marker.line") && a(e, t, {
                        vals: t.marker.line.color,
                        containerStr: "marker.line",
                        cLetter: "c"
                    }));
                };
            },
            7581: function(e) {
                "use strict";
                e.exports = {
                    PTS_LINESONLY: 20,
                    minTolerance: .2,
                    toleranceGrowth: 10,
                    maxScreensAway: 20,
                    eventDataKeys: []
                };
            },
            2626: function(e, t, r) {
                "use strict";
                var n = r(7761), a = r(1661).setGroupPositions;
                function i(e, t, r, n, a, i, o) {
                    a[n] = !0;
                    var l = {
                        i: null,
                        gap: !0,
                        s: 0
                    };
                    if (l[o] = r, e.splice(t, 0, l), t && r === e[t - 1][o]) {
                        var s = e[t - 1];
                        l.s = s.s, l.i = s.i, l.gap = s.gap;
                    } else i && (l.s = function(e, t, r, n) {
                        var a = e[t - 1], i = e[t + 1];
                        return i ? a ? a.s + (i.s - a.s) * (r - a[n]) / (i[n] - a[n]) : i.s : a.s;
                    }(e, t, r, o));
                    t || (e[0].t = e[1].t, e[0].trace = e[1].trace, delete e[1].t, delete e[1].trace);
                }
                e.exports = function(e, t) {
                    "group" === e._fullLayout.scattermode && function(e, t) {
                        for(var r = t.xaxis, n = t.yaxis, i = e._fullLayout, o = e._fullData, l = e.calcdata, s = [], c = [], u = 0; u < o.length; u++){
                            var f = o[u];
                            !0 === f.visible && "scatter" === f.type && f.xaxis === r._id && f.yaxis === n._id && ("h" === f.orientation ? s.push(l[u]) : "v" === f.orientation && c.push(l[u]));
                        }
                        var d = {
                            mode: i.scattermode,
                            gap: i.scattergap
                        };
                        a(e, r, n, c, d), a(e, n, r, s, d);
                    }(e, t);
                    var r = t.xaxis, o = t.yaxis, l = r._id + o._id, s = e._fullLayout._scatterStackOpts[l];
                    if (s) {
                        var c, u, f, d, h, p, v, g, y, m, x, b, _, w, T, M = e.calcdata;
                        for(var k in s){
                            var A = (m = s[k]).traceIndices;
                            if (A.length) {
                                for(x = "interpolate" === m.stackgaps, b = m.groupnorm, "v" === m.orientation ? (_ = "x", w = "y") : (_ = "y", w = "x"), T = new Array(A.length), c = 0; c < T.length; c++)T[c] = !1;
                                p = M[A[0]];
                                var L = new Array(p.length);
                                for(c = 0; c < p.length; c++)L[c] = p[c][_];
                                for(c = 1; c < A.length; c++){
                                    for(h = M[A[c]], u = f = 0; u < h.length; u++){
                                        for(v = h[u][_]; v > L[f] && f < L.length; f++)i(h, u, L[f], c, T, x, _), u++;
                                        if (v !== L[f]) {
                                            for(d = 0; d < c; d++)i(M[A[d]], f, v, d, T, x, _);
                                            L.splice(f, 0, v);
                                        }
                                        f++;
                                    }
                                    for(; f < L.length; f++)i(h, u, L[f], c, T, x, _), u++;
                                }
                                var S = L.length;
                                for(u = 0; u < p.length; u++){
                                    for(g = p[u][w] = p[u].s, c = 1; c < A.length; c++)(h = M[A[c]])[0].trace._rawLength = h[0].trace._length, h[0].trace._length = S, g += h[u].s, h[u][w] = g;
                                    if (b) for(y = ("fraction" === b ? g : g / 100) || 1, c = 0; c < A.length; c++){
                                        var D = M[A[c]][u];
                                        D[w] /= y, D.sNorm = D.s / y;
                                    }
                                }
                                for(c = 0; c < A.length; c++){
                                    var O = (h = M[A[c]])[0].trace, C = n.calcMarkerSize(O, O._rawLength), P = Array.isArray(C);
                                    if (C && T[c] || P) {
                                        var I = C;
                                        for(C = new Array(S), u = 0; u < S; u++)C[u] = h[u].gap ? 0 : P ? I[h[u].i] : I;
                                    }
                                    var R = new Array(S), z = new Array(S);
                                    for(u = 0; u < S; u++)R[u] = h[u].x, z[u] = h[u].y;
                                    n.calcAxisExpansion(e, O, r, o, R, z, C), h[0].t.orientation = m.orientation;
                                }
                            }
                        }
                    }
                };
            },
            462: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(6125), i = r(2196);
                e.exports = function(e, t) {
                    var r, o, l;
                    function s(e) {
                        return n.coerce(o._input, o, i, e);
                    }
                    if ("group" === t.scattermode) for(l = 0; l < e.length; l++)"scatter" === (o = e[l]).type && (r = o._input, a(r, o, t, s));
                    for(l = 0; l < e.length; l++){
                        var c = e[l];
                        if ("scatter" === c.type) {
                            var u = c.fill;
                            if ("none" !== u && "toself" !== u && (c.opacity = void 0, "tonexty" === u || "tonextx" === u)) for(var f = l - 1; f >= 0; f--){
                                var d = e[f];
                                if ("scatter" === d.type && d.xaxis === c.xaxis && d.yaxis === c.yaxis) {
                                    d.opacity = void 0;
                                    break;
                                }
                            }
                        }
                    }
                };
            },
            7438: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(3972), i = r(2196), o = r(7581), l = r(4098), s = r(7513), c = r(3927), u = r(565), f = r(9508), d = r(1058), h = r(4039), p = r(2410), v = r(8908), g = r(1828).coercePattern;
                e.exports = function(e, t, r, y) {
                    function m(r, a) {
                        return n.coerce(e, t, i, r, a);
                    }
                    var x = s(e, t, y, m);
                    if (x || (t.visible = !1), t.visible) {
                        c(e, t, y, m), m("xhoverformat"), m("yhoverformat");
                        var b = u(e, t, y, m);
                        "group" === y.scattermode && void 0 === t.orientation && m("orientation", "v");
                        var _ = !b && x < o.PTS_LINESONLY ? "lines+markers" : "lines";
                        m("text"), m("hovertext"), m("mode", _), l.hasLines(t) && (d(e, t, r, y, m, {
                            backoff: !0
                        }), h(e, t, m), m("connectgaps"), m("line.simplify")), l.hasMarkers(t) && f(e, t, r, y, m, {
                            gradient: !0
                        }), l.hasText(t) && (m("texttemplate"), p(e, t, y, m));
                        var w = [];
                        (l.hasMarkers(t) || l.hasText(t)) && (m("cliponaxis"), m("marker.maxdisplayed"), w.push("points")), m("fill", b ? b.fillDflt : "none"), "none" !== t.fill && (v(e, t, r, m), l.hasLines(t) || h(e, t, m), g(m, "fillpattern", t.fillcolor, !1));
                        var T = (t.line || {}).color, M = (t.marker || {}).color;
                        "tonext" !== t.fill && "toself" !== t.fill || w.push("fills"), m("hoveron", w.join("+") || "points"), "fills" !== t.hoveron && m("hovertemplate");
                        var k = a.getComponentMethod("errorbars", "supplyDefaults");
                        k(e, t, T || M || r, {
                            axis: "y"
                        }), k(e, t, T || M || r, {
                            axis: "x",
                            inherit: "y"
                        }), n.coerceSelectionMarkerOpacity(t, m);
                    }
                };
            },
            8908: function(e, t, r) {
                "use strict";
                var n = r(7901), a = r(1828).isArrayOrTypedArray;
                e.exports = function(e, t, r, i) {
                    var o = !1;
                    if (t.marker) {
                        var l = t.marker.color, s = (t.marker.line || {}).color;
                        l && !a(l) ? o = l : s && !a(s) && (o = s);
                    }
                    i("fillcolor", n.addOpacity((t.line || {}).color || o || r, .5));
                };
            },
            8225: function(e, t, r) {
                "use strict";
                var n = r(9298);
                e.exports = function(e, t, r) {
                    var a = {}, i = {
                        _fullLayout: r
                    }, o = n.getFromTrace(i, t, "x"), l = n.getFromTrace(i, t, "y"), s = e.orig_x;
                    void 0 === s && (s = e.x);
                    var c = e.orig_y;
                    return void 0 === c && (c = e.y), a.xLabel = n.tickText(o, o.c2l(s), !0).text, a.yLabel = n.tickText(l, l.c2l(c), !0).text, a;
                };
            },
            4603: function(e, t, r) {
                "use strict";
                var n = r(7901), a = r(4098);
                e.exports = function(e, t) {
                    var r, i;
                    if ("lines" === e.mode) return (r = e.line.color) && n.opacity(r) ? r : e.fillcolor;
                    if ("none" === e.mode) return e.fill ? e.fillcolor : "";
                    var o = t.mcc || (e.marker || {}).color, l = t.mlcc || ((e.marker || {}).line || {}).color;
                    return (i = o && n.opacity(o) ? o : l && n.opacity(l) && (t.mlw || ((e.marker || {}).line || {}).width) ? l : "") ? n.opacity(i) < .3 ? n.addOpacity(i, .3) : i : (r = (e.line || {}).color) && n.opacity(r) && a.hasLines(e) && e.line.width ? r : e.fillcolor;
                };
            },
            6125: function(e, t, r) {
                "use strict";
                var n = r(9082).getAxisGroup;
                e.exports = function(e, t, r, a) {
                    var i = t.orientation, o = t[({
                        v: "x",
                        h: "y"
                    })[i] + "axis"], l = n(r, o) + i, s = r._alignmentOpts || {}, c = a("alignmentgroup"), u = s[l];
                    u || (u = s[l] = {});
                    var f = u[c];
                    f ? f.traces.push(t) : f = u[c] = {
                        traces: [
                            t
                        ],
                        alignmentIndex: Object.keys(u).length,
                        offsetGroups: {}
                    };
                    var d = a("offsetgroup"), h = f.offsetGroups, p = h[d];
                    d && (p || (p = h[d] = {
                        offsetIndex: Object.keys(h).length
                    }), t._offsetIndex = p.offsetIndex);
                };
            },
            3720: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(211), i = r(3972), o = r(4603), l = r(7901), s = n.fillText;
                e.exports = function(e, t, r, c) {
                    var u = e.cd, f = u[0].trace, d = e.xa, h = e.ya, p = d.c2p(t), v = h.c2p(r), g = [
                        p,
                        v
                    ], y = f.hoveron || "", m = -1 !== f.mode.indexOf("markers") ? 3 : .5, x = !!f.xperiodalignment, b = !!f.yperiodalignment;
                    if (-1 !== y.indexOf("points")) {
                        var _ = function(e) {
                            var t = Math.max(m, e.mrc || 0), r = d.c2p(e.x) - p, n = h.c2p(e.y) - v;
                            return Math.max(Math.sqrt(r * r + n * n) - t, 1 - m / t);
                        }, w = a.getDistanceFunction(c, function(e) {
                            if (x) {
                                var t = d.c2p(e.xStart), r = d.c2p(e.xEnd);
                                return p >= Math.min(t, r) && p <= Math.max(t, r) ? 0 : 1 / 0;
                            }
                            var n = Math.max(3, e.mrc || 0), a = 1 - 1 / n, i = Math.abs(d.c2p(e.x) - p);
                            return i < n ? a * i / n : i - n + a;
                        }, function(e) {
                            if (b) {
                                var t = h.c2p(e.yStart), r = h.c2p(e.yEnd);
                                return v >= Math.min(t, r) && v <= Math.max(t, r) ? 0 : 1 / 0;
                            }
                            var n = Math.max(3, e.mrc || 0), a = 1 - 1 / n, i = Math.abs(h.c2p(e.y) - v);
                            return i < n ? a * i / n : i - n + a;
                        }, _);
                        if (a.getClosest(u, w, e), !1 !== e.index) {
                            var T = u[e.index], M = d.c2p(T.x, !0), k = h.c2p(T.y, !0), A = T.mrc || 1;
                            e.index = T.i;
                            var L = u[0].t.orientation, S = L && (T.sNorm || T.s), D = "h" === L ? S : void 0 !== T.orig_x ? T.orig_x : T.x, O = "v" === L ? S : void 0 !== T.orig_y ? T.orig_y : T.y;
                            return n.extendFlat(e, {
                                color: o(f, T),
                                x0: M - A,
                                x1: M + A,
                                xLabelVal: D,
                                y0: k - A,
                                y1: k + A,
                                yLabelVal: O,
                                spikeDistance: _(T),
                                hovertemplate: f.hovertemplate
                            }), s(T, f, e), i.getComponentMethod("errorbars", "hoverInfo")(T, f, e), [
                                e
                            ];
                        }
                    }
                    if (-1 !== y.indexOf("fills") && f._polygons) {
                        var C, P, I, R, z, N, F, E, H, j = f._polygons, B = [], Y = !1, V = 1 / 0, U = -1 / 0, q = 1 / 0, G = -1 / 0;
                        for(C = 0; C < j.length; C++)(I = j[C]).contains(g) && (Y = !Y, B.push(I), q = Math.min(q, I.ymin), G = Math.max(G, I.ymax));
                        if (Y) {
                            var Z = ((q = Math.max(q, 0)) + (G = Math.min(G, h._length))) / 2;
                            for(C = 0; C < B.length; C++)for(R = B[C].pts, P = 1; P < R.length; P++)(E = R[P - 1][1]) > Z != (H = R[P][1]) >= Z && (N = R[P - 1][0], F = R[P][0], H - E && (z = N + (F - N) * (Z - E) / (H - E), V = Math.min(V, z), U = Math.max(U, z)));
                            V = Math.max(V, 0), U = Math.min(U, d._length);
                            var W = l.defaultLine;
                            return l.opacity(f.fillcolor) ? W = f.fillcolor : l.opacity((f.line || {}).color) && (W = f.line.color), n.extendFlat(e, {
                                distance: e.maxHoverDistance,
                                x0: V,
                                x1: U,
                                y0: Z,
                                y1: Z,
                                color: W,
                                hovertemplate: !1
                            }), delete e.index, f.text && !Array.isArray(f.text) ? e.text = String(f.text) : e.text = f.name, [
                                e
                            ];
                        }
                    }
                };
            },
            7368: function(e, t, r) {
                "use strict";
                var n = r(4098);
                e.exports = {
                    hasLines: n.hasLines,
                    hasMarkers: n.hasMarkers,
                    hasText: n.hasText,
                    isBubble: n.isBubble,
                    attributes: r(2196),
                    layoutAttributes: r(1479),
                    supplyDefaults: r(7438),
                    crossTraceDefaults: r(462),
                    supplyLayoutDefaults: r(9334),
                    calc: r(7761).calc,
                    crossTraceCalc: r(2626),
                    arraysToCalcdata: r(5225),
                    plot: r(7399),
                    colorbar: r(4898),
                    formatLabels: r(8225),
                    style: r(6296).style,
                    styleOnSelect: r(6296).styleOnSelect,
                    hoverPoints: r(3720),
                    selectPoints: r(8002),
                    animatable: !0,
                    moduleType: "trace",
                    name: "scatter",
                    basePlotModule: r(3612),
                    categories: [
                        "cartesian",
                        "svg",
                        "symbols",
                        "errorBarsOK",
                        "showLegend",
                        "scatter-like",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            1479: function(e) {
                "use strict";
                e.exports = {
                    scattermode: {
                        valType: "enumerated",
                        values: [
                            "group",
                            "overlay"
                        ],
                        dflt: "overlay",
                        editType: "calc"
                    },
                    scattergap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "calc"
                    }
                };
            },
            9334: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(1479);
                e.exports = function(e, t) {
                    var r, i = "group" === t.barmode;
                    "group" === t.scattermode && (r = i ? t.bargap : .2, n.coerce(e, t, a, "scattergap", r));
                };
            },
            1058: function(e, t, r) {
                "use strict";
                var n = r(1828).isArrayOrTypedArray, a = r(2869).hasColorscale, i = r(1586);
                e.exports = function(e, t, r, o, l, s) {
                    s || (s = {});
                    var c = (e.marker || {}).color;
                    l("line.color", r), a(e, "line") ? i(e, t, o, l, {
                        prefix: "line.",
                        cLetter: "c"
                    }) : l("line.color", !n(c) && c || r), l("line.width"), s.noDash || l("line.dash"), s.backoff && l("line.backoff");
                };
            },
            4621: function(e, t, r) {
                "use strict";
                var n = r(1424), a = r(606), i = a.BADNUM, o = a.LOG_CLIP, l = o + .5, s = o - .5, c = r(1828), u = c.segmentsIntersect, f = c.constrain, d = r(7581);
                e.exports = function(e, t) {
                    var r, a, o, h, p, v, g, y, m, x, b, _, w, T, M, k, A, L, S = t.trace || {}, D = t.xaxis, O = t.yaxis, C = "log" === D.type, P = "log" === O.type, I = D._length, R = O._length, z = t.backoff, N = S.marker, F = t.connectGaps, E = t.baseTolerance, H = t.shape, j = "linear" === H, B = S.fill && "none" !== S.fill, Y = [], V = d.minTolerance, U = e.length, q = new Array(U), G = 0;
                    function Z(r) {
                        var n = e[r];
                        if (!n) return !1;
                        var a = t.linearized ? D.l2p(n.x) : D.c2p(n.x), o = t.linearized ? O.l2p(n.y) : O.c2p(n.y);
                        if (a === i) {
                            if (C && (a = D.c2p(n.x, !0)), a === i) return !1;
                            P && o === i && (a *= Math.abs(D._m * R * (D._m > 0 ? l : s) / (O._m * I * (O._m > 0 ? l : s)))), a *= 1e3;
                        }
                        if (o === i) {
                            if (P && (o = O.c2p(n.y, !0)), o === i) return !1;
                            o *= 1e3;
                        }
                        return [
                            a,
                            o
                        ];
                    }
                    function W(e, t, r, n) {
                        var a = r - e, i = n - t, o = .5 - e, l = .5 - t, s = a * a + i * i, c = a * o + i * l;
                        if (c > 0 && c < s) {
                            var u = o * i - l * a;
                            if (u * u < s) return !0;
                        }
                    }
                    function X(e, t) {
                        var r = e[0] / I, n = e[1] / R, a = Math.max(0, -r, r - 1, -n, n - 1);
                        return a && void 0 !== A && W(r, n, A, L) && (a = 0), a && t && W(r, n, t[0] / I, t[1] / R) && (a = 0), (1 + d.toleranceGrowth * a) * E;
                    }
                    function J(e, t) {
                        var r = e[0] - t[0], n = e[1] - t[1];
                        return Math.sqrt(r * r + n * n);
                    }
                    var K, Q, $, ee, te, re, ne, ae = d.maxScreensAway, ie = -I * ae, oe = I * (1 + ae), le = -R * ae, se = R * (1 + ae), ce = [
                        [
                            ie,
                            le,
                            oe,
                            le
                        ],
                        [
                            oe,
                            le,
                            oe,
                            se
                        ],
                        [
                            oe,
                            se,
                            ie,
                            se
                        ],
                        [
                            ie,
                            se,
                            ie,
                            le
                        ]
                    ];
                    function ue(e) {
                        if (e[0] < ie || e[0] > oe || e[1] < le || e[1] > se) return [
                            f(e[0], ie, oe),
                            f(e[1], le, se)
                        ];
                    }
                    function fe(e, t) {
                        return e[0] === t[0] && (e[0] === ie || e[0] === oe) || e[1] === t[1] && (e[1] === le || e[1] === se) || void 0;
                    }
                    function de(e, t, r) {
                        return function(n, a) {
                            var i = ue(n), o = ue(a), l = [];
                            if (i && o && fe(i, o)) return l;
                            i && l.push(i), o && l.push(o);
                            var s = 2 * c.constrain((n[e] + a[e]) / 2, t, r) - ((i || n)[e] + (o || a)[e]);
                            return s && ((i && o ? s > 0 == i[e] > o[e] ? i : o : i || o)[e] += s), l;
                        };
                    }
                    function he(e) {
                        var t = e[0], r = e[1], n = t === q[G - 1][0], a = r === q[G - 1][1];
                        if (!n || !a) {
                            if (G > 1) {
                                var i = t === q[G - 2][0], o = r === q[G - 2][1];
                                n && (t === ie || t === oe) && i ? o ? G-- : q[G - 1] = e : a && (r === le || r === se) && o ? i ? G-- : q[G - 1] = e : q[G++] = e;
                            } else q[G++] = e;
                        }
                    }
                    function pe(e) {
                        q[G - 1][0] !== e[0] && q[G - 1][1] !== e[1] && he([
                            $,
                            ee
                        ]), he(e), te = null, $ = ee = 0;
                    }
                    "linear" === H || "spline" === H ? ne = function(e, t) {
                        for(var r = [], n = 0, a = 0; a < 4; a++){
                            var i = ce[a], o = u(e[0], e[1], t[0], t[1], i[0], i[1], i[2], i[3]);
                            o && (!n || Math.abs(o.x - r[0][0]) > 1 || Math.abs(o.y - r[0][1]) > 1) && (o = [
                                o.x,
                                o.y
                            ], n && J(o, e) < J(r[0], e) ? r.unshift(o) : r.push(o), n++);
                        }
                        return r;
                    } : "hv" === H || "vh" === H ? ne = function(e, t) {
                        var r = [], n = ue(e), a = ue(t);
                        return n && a && fe(n, a) || (n && r.push(n), a && r.push(a)), r;
                    } : "hvh" === H ? ne = de(0, ie, oe) : "vhv" === H && (ne = de(1, le, se));
                    var ve = c.isArrayOrTypedArray(N);
                    function ge(t) {
                        if (t && z && (t.i = r, t.d = e, t.trace = S, t.marker = ve ? N[t.i] : N, t.backoff = z), A = t[0] / I, L = t[1] / R, K = t[0] < ie ? ie : t[0] > oe ? oe : 0, Q = t[1] < le ? le : t[1] > se ? se : 0, K || Q) {
                            if (G) {
                                if (te) {
                                    var n = ne(te, t);
                                    n.length > 1 && (pe(n[0]), q[G++] = n[1]);
                                } else re = ne(q[G - 1], t)[0], q[G++] = re;
                            } else q[G++] = [
                                K || t[0],
                                Q || t[1]
                            ];
                            var a = q[G - 1];
                            K && Q && (a[0] !== K || a[1] !== Q) ? (te && ($ !== K && ee !== Q ? he($ && ee ? (i = te, l = (o = t)[0] - i[0], s = (o[1] - i[1]) / l, (i[1] * o[0] - o[1] * i[0]) / l > 0 ? [
                                s > 0 ? ie : oe,
                                se
                            ] : [
                                s > 0 ? oe : ie,
                                le
                            ]) : [
                                $ || K,
                                ee || Q
                            ]) : $ && ee && he([
                                $,
                                ee
                            ])), he([
                                K,
                                Q
                            ])) : $ - K && ee - Q && he([
                                K || $,
                                Q || ee
                            ]), te = t, $ = K, ee = Q;
                        } else te && pe(ne(te, t)[0]), q[G++] = t;
                        var i, o, l, s;
                    }
                    for(r = 0; r < U; r++)if (a = Z(r)) {
                        for(G = 0, te = null, ge(a), r++; r < U; r++){
                            if (!(h = Z(r))) {
                                if (F) continue;
                                break;
                            }
                            if (j && t.simplify) {
                                var ye = Z(r + 1);
                                if (x = J(h, a), B && (0 === G || G === U - 1) || !(x < X(h, ye) * V)) {
                                    for(y = [
                                        (h[0] - a[0]) / x,
                                        (h[1] - a[1]) / x
                                    ], p = a, b = x, _ = T = M = 0, g = !1, o = h, r++; r < e.length; r++){
                                        if (v = ye, ye = Z(r + 1), !v) {
                                            if (F) continue;
                                            break;
                                        }
                                        if (k = (m = [
                                            v[0] - a[0],
                                            v[1] - a[1]
                                        ])[0] * y[1] - m[1] * y[0], T = Math.min(T, k), (M = Math.max(M, k)) - T > X(v, ye)) break;
                                        o = v, (w = m[0] * y[0] + m[1] * y[1]) > b ? (b = w, h = v, g = !1) : w < _ && (_ = w, p = v, g = !0);
                                    }
                                    if (g ? (ge(h), o !== p && ge(p)) : (p !== a && ge(p), o !== h && ge(h)), ge(o), r >= e.length || !v) break;
                                    ge(v), a = v;
                                }
                            } else ge(h);
                        }
                        te && he([
                            $ || te[0],
                            ee || te[1]
                        ]), Y.push(q.slice(0, G));
                    }
                    var me = H.slice(H.length - 1);
                    if (z && "h" !== me && "v" !== me) {
                        for(var xe = !1, be = -1, _e = [], we = 0; we < Y.length; we++)for(var Te = 0; Te < Y[we].length - 1; Te++){
                            var Me = Y[we][Te], ke = Y[we][Te + 1], Ae = n.applyBackoff(ke, Me);
                            Ae[0] === ke[0] && Ae[1] === ke[1] || (xe = !0), _e[be + 1] || (_e[++be] = [
                                Me,
                                [
                                    Ae[0],
                                    Ae[1]
                                ]
                            ]);
                        }
                        return xe ? _e : Y;
                    }
                    return Y;
                };
            },
            4039: function(e) {
                "use strict";
                e.exports = function(e, t, r) {
                    "spline" === r("line.shape") && r("line.smoothing");
                };
            },
            8687: function(e) {
                "use strict";
                var t = {
                    tonextx: 1,
                    tonexty: 1,
                    tonext: 1
                };
                e.exports = function(e, r, n) {
                    var a, i, o, l, s, c = {}, u = !1, f = -1, d = 0, h = -1;
                    for(i = 0; i < n.length; i++)(o = (a = n[i][0].trace).stackgroup || "") ? o in c ? s = c[o] : (s = c[o] = d, d++) : a.fill in t && h >= 0 ? s = h : (s = h = d, d++), s < f && (u = !0), a._groupIndex = f = s;
                    var p = n.slice();
                    u && p.sort(function(e, t) {
                        var r = e[0].trace, n = t[0].trace;
                        return r._groupIndex - n._groupIndex || r.index - n.index;
                    });
                    var v = {};
                    for(i = 0; i < p.length; i++)o = (a = p[i][0].trace).stackgroup || "", !0 === a.visible ? (a._nexttrace = null, a.fill in t && (l = v[o], a._prevtrace = l || null, l && (l._nexttrace = a)), a._ownfill = a.fill && ("tozero" === a.fill.substr(0, 6) || "toself" === a.fill || "to" === a.fill.substr(0, 2) && !a._prevtrace), v[o] = a) : a._prevtrace = a._nexttrace = a._ownfill = null;
                    return p;
                };
            },
            9984: function(e, t, r) {
                "use strict";
                var n = r(2770);
                e.exports = function(e, t) {
                    t || (t = 2);
                    var r = e.marker, a = r.sizeref || 1, i = r.sizemin || 0, o = "area" === r.sizemode ? function(e) {
                        return Math.sqrt(e / a);
                    } : function(e) {
                        return e / a;
                    };
                    return function(e) {
                        var r = o(e / t);
                        return n(r) && r > 0 ? Math.max(r, i) : 0;
                    };
                };
            },
            4898: function(e) {
                "use strict";
                e.exports = {
                    container: "marker",
                    min: "cmin",
                    max: "cmax"
                };
            },
            9508: function(e, t, r) {
                "use strict";
                var n = r(7901), a = r(2869).hasColorscale, i = r(1586), o = r(4098);
                e.exports = function(e, t, r, l, s, c) {
                    var u = o.isBubble(e), f = (e.line || {}).color;
                    c = c || {}, f && (r = f), s("marker.symbol"), s("marker.opacity", u ? .7 : 1), s("marker.size"), c.noAngle || (s("marker.angle"), c.noAngleRef || s("marker.angleref"), c.noStandOff || s("marker.standoff")), s("marker.color", r), a(e, "marker") && i(e, t, l, s, {
                        prefix: "marker.",
                        cLetter: "c"
                    }), c.noSelect || (s("selected.marker.color"), s("unselected.marker.color"), s("selected.marker.size"), s("unselected.marker.size")), c.noLine || (s("marker.line.color", f && !Array.isArray(f) && t.marker.color !== f ? f : u ? n.background : n.defaultLine), a(e, "marker.line") && i(e, t, l, s, {
                        prefix: "marker.line.",
                        cLetter: "c"
                    }), s("marker.line.width", u ? 1 : 0)), u && (s("marker.sizeref"), s("marker.sizemin"), s("marker.sizemode")), c.gradient && "none" !== s("marker.gradient.type") && s("marker.gradient.color");
                };
            },
            3927: function(e, t, r) {
                "use strict";
                var n = r(1828).dateTick0, a = r(606).ONEWEEK;
                function i(e, t) {
                    return n(t, e % a == 0 ? 1 : 0);
                }
                e.exports = function(e, t, r, n, a) {
                    if (a || (a = {
                        x: !0,
                        y: !0
                    }), a.x) {
                        var o = n("xperiod");
                        o && (n("xperiod0", i(o, t.xcalendar)), n("xperiodalignment"));
                    }
                    if (a.y) {
                        var l = n("yperiod");
                        l && (n("yperiod0", i(l, t.ycalendar)), n("yperiodalignment"));
                    }
                };
            },
            7399: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(3972), i = r(1828), o = i.ensureSingle, l = i.identity, s = r(1424), c = r(4098), u = r(4621), f = r(8687), d = r(1082).tester;
                function h(e, t, r, f, h, p, v) {
                    var g, y = e._context.staticPlot;
                    !function(e, t, r, a, o) {
                        var l = r.xaxis, s = r.yaxis, u = n.extent(i.simpleMap(l.range, l.r2c)), f = n.extent(i.simpleMap(s.range, s.r2c)), d = a[0].trace;
                        if (c.hasMarkers(d)) {
                            var h = d.marker.maxdisplayed;
                            if (0 !== h) {
                                var p = a.filter(function(e) {
                                    return e.x >= u[0] && e.x <= u[1] && e.y >= f[0] && e.y <= f[1];
                                }), v = Math.ceil(p.length / h), g = 0;
                                o.forEach(function(e, r) {
                                    var n = e[0].trace;
                                    c.hasMarkers(n) && n.marker.maxdisplayed > 0 && r < t && g++;
                                });
                                var y = Math.round(g * v / 3 + Math.floor(g / 3) * v / 7.1);
                                a.forEach(function(e) {
                                    delete e.vis;
                                }), p.forEach(function(e, t) {
                                    0 === Math.round((t + y) % v) && (e.vis = !0);
                                });
                            }
                        }
                    }(0, t, r, f, h);
                    var m = !!v && v.duration > 0;
                    function x(e) {
                        return m ? e.transition() : e;
                    }
                    var b = r.xaxis, _ = r.yaxis, w = f[0].trace, T = w.line, M = n.select(p), k = o(M, "g", "errorbars"), A = o(M, "g", "lines"), L = o(M, "g", "points"), S = o(M, "g", "text");
                    if (a.getComponentMethod("errorbars", "plot")(e, k, r, v), !0 === w.visible) {
                        var D, O;
                        x(M).style("opacity", w.opacity);
                        var C = w.fill.charAt(w.fill.length - 1);
                        "x" !== C && "y" !== C && (C = ""), f[0][r.isRangePlot ? "nodeRangePlot3" : "node3"] = M;
                        var P, I, R = "", z = [], N = w._prevtrace;
                        N && (R = N._prevRevpath || "", O = N._nextFill, z = N._polygons);
                        var F, E, H, j, B, Y, V, U = "", q = "", G = [], Z = i.noop;
                        if (D = w._ownFill, c.hasLines(w) || "none" !== w.fill) {
                            for(O && O.datum(f), -1 !== [
                                "hv",
                                "vh",
                                "hvh",
                                "vhv"
                            ].indexOf(T.shape) ? (F = s.steps(T.shape), E = s.steps(T.shape.split("").reverse().join(""))) : F = E = "spline" === T.shape ? function(e) {
                                var t = e[e.length - 1];
                                return e.length > 1 && e[0][0] === t[0] && e[0][1] === t[1] ? s.smoothclosed(e.slice(1), T.smoothing) : s.smoothopen(e, T.smoothing);
                            } : function(e) {
                                return "M" + e.join("L");
                            }, H = function(e) {
                                return E(e.reverse());
                            }, G = u(f, {
                                xaxis: b,
                                yaxis: _,
                                trace: w,
                                connectGaps: w.connectgaps,
                                baseTolerance: Math.max(T.width || 1, 3) / 4,
                                shape: T.shape,
                                backoff: T.backoff,
                                simplify: T.simplify,
                                fill: w.fill
                            }), V = w._polygons = new Array(G.length), g = 0; g < G.length; g++)w._polygons[g] = d(G[g]);
                            G.length && (j = G[0][0], Y = (B = G[G.length - 1])[B.length - 1]), Z = function(e) {
                                return function(t) {
                                    if (P = F(t), I = H(t), U ? C ? (U += "L" + P.substr(1), q = I + "L" + q.substr(1)) : (U += "Z" + P, q = I + "Z" + q) : (U = P, q = I), c.hasLines(w)) {
                                        var r = n.select(this);
                                        if (r.datum(f), e) x(r.style("opacity", 0).attr("d", P).call(s.lineGroupStyle)).style("opacity", 1);
                                        else {
                                            var a = x(r);
                                            a.attr("d", P), s.singleLineStyle(f, a);
                                        }
                                    }
                                };
                            };
                        }
                        var W = A.selectAll(".js-line").data(G);
                        x(W.exit()).style("opacity", 0).remove(), W.each(Z(!1)), W.enter().append("path").classed("js-line", !0).style("vector-effect", y ? "none" : "non-scaling-stroke").call(s.lineGroupStyle).each(Z(!0)), s.setClipUrl(W, r.layerClipId, e), G.length ? (D ? (D.datum(f), j && Y && (C ? ("y" === C ? j[1] = Y[1] = _.c2p(0, !0) : "x" === C && (j[0] = Y[0] = b.c2p(0, !0)), x(D).attr("d", "M" + Y + "L" + j + "L" + U.substr(1)).call(s.singleFillStyle, e)) : x(D).attr("d", U + "Z").call(s.singleFillStyle, e))) : O && ("tonext" === w.fill.substr(0, 6) && U && R ? ("tonext" === w.fill ? x(O).attr("d", U + "Z" + R + "Z").call(s.singleFillStyle, e) : x(O).attr("d", U + "L" + R.substr(1) + "Z").call(s.singleFillStyle, e), w._polygons = w._polygons.concat(z)) : (J(O), w._polygons = null)), w._prevRevpath = q, w._prevPolygons = V) : (D ? J(D) : O && J(O), w._polygons = w._prevRevpath = w._prevPolygons = null), L.datum(f), S.datum(f), function(t, a, i) {
                            var o, u = i[0].trace, f = c.hasMarkers(u), d = c.hasText(u), h = te(u), p = re, v = re;
                            if (f || d) {
                                var g = l, y = u.stackgroup, w = y && "infer zero" === e._fullLayout._scatterStackOpts[b._id + _._id][y].stackgaps;
                                u.marker.maxdisplayed || u._needsCull ? g = w ? Q : K : y && !w && (g = $), f && (p = g), d && (v = g);
                            }
                            var T, M = (o = t.selectAll("path.point").data(p, h)).enter().append("path").classed("point", !0);
                            m && M.call(s.pointStyle, u, e).call(s.translatePoints, b, _).style("opacity", 0).transition().style("opacity", 1), o.order(), f && (T = s.makePointStyleFns(u)), o.each(function(t) {
                                var a = n.select(this), i = x(a);
                                s.translatePoint(t, i, b, _) ? (s.singlePointStyle(t, i, u, T, e), r.layerClipId && s.hideOutsideRangePoint(t, i, b, _, u.xcalendar, u.ycalendar), u.customdata && a.classed("plotly-customdata", null !== t.data && void 0 !== t.data)) : i.remove();
                            }), m ? o.exit().transition().style("opacity", 0).remove() : o.exit().remove(), (o = a.selectAll("g").data(v, h)).enter().append("g").classed("textpoint", !0).append("text"), o.order(), o.each(function(e) {
                                var t = n.select(this), a = x(t.select("text"));
                                s.translatePoint(e, a, b, _) ? r.layerClipId && s.hideOutsideRangePoint(e, t, b, _, u.xcalendar, u.ycalendar) : t.remove();
                            }), o.selectAll("text").call(s.textPointStyle, u, e).each(function(e) {
                                var t = b.c2p(e.x), r = _.c2p(e.y);
                                n.select(this).selectAll("tspan.line").each(function() {
                                    x(n.select(this)).attr({
                                        x: t,
                                        y: r
                                    });
                                });
                            }), o.exit().remove();
                        }(L, S, f);
                        var X = !1 === w.cliponaxis ? null : r.layerClipId;
                        s.setClipUrl(L, X, e), s.setClipUrl(S, X, e);
                    }
                    function J(e) {
                        x(e).attr("d", "M0,0Z");
                    }
                    function K(e) {
                        return e.filter(function(e) {
                            return !e.gap && e.vis;
                        });
                    }
                    function Q(e) {
                        return e.filter(function(e) {
                            return e.vis;
                        });
                    }
                    function $(e) {
                        return e.filter(function(e) {
                            return !e.gap;
                        });
                    }
                    function ee(e) {
                        return e.id;
                    }
                    function te(e) {
                        if (e.ids) return ee;
                    }
                    function re() {
                        return !1;
                    }
                }
                e.exports = function(e, t, r, a, i, c) {
                    var u, d, p = !i, v = !!i && i.duration > 0, g = f(e, t, r);
                    (u = a.selectAll("g.trace").data(g, function(e) {
                        return e[0].trace.uid;
                    })).enter().append("g").attr("class", function(e) {
                        return "trace scatter trace" + e[0].trace.uid;
                    }).style("stroke-miterlimit", 2), u.order(), function(e, t, r) {
                        t.each(function(t) {
                            var a = o(n.select(this), "g", "fills");
                            s.setClipUrl(a, r.layerClipId, e);
                            var i = t[0].trace, c = [];
                            i._ownfill && c.push("_ownFill"), i._nexttrace && c.push("_nextFill");
                            var u = a.selectAll("g").data(c, l);
                            u.enter().append("g"), u.exit().each(function(e) {
                                i[e] = null;
                            }).remove(), u.order().each(function(e) {
                                i[e] = o(n.select(this), "path", "js-fill");
                            });
                        });
                    }(e, u, t), v ? (c && (d = c()), n.transition().duration(i.duration).ease(i.easing).each("end", function() {
                        d && d();
                    }).each("interrupt", function() {
                        d && d();
                    }).each(function() {
                        a.selectAll("g.trace").each(function(r, n) {
                            h(e, n, t, r, g, this, i);
                        });
                    })) : u.each(function(r, n) {
                        h(e, n, t, r, g, this, i);
                    }), p && u.exit().remove(), a.selectAll("path:not([d])").remove();
                };
            },
            8002: function(e, t, r) {
                "use strict";
                var n = r(4098);
                e.exports = function(e, t) {
                    var r, a, i, o, l = e.cd, s = e.xaxis, c = e.yaxis, u = [], f = l[0].trace;
                    if (!n.hasMarkers(f) && !n.hasText(f)) return [];
                    if (!1 === t) for(r = 0; r < l.length; r++)l[r].selected = 0;
                    else for(r = 0; r < l.length; r++)a = l[r], i = s.c2p(a.x), o = c.c2p(a.y), null !== a.i && t.contains([
                        i,
                        o
                    ], !1, r, e) ? (u.push({
                        pointNumber: a.i,
                        x: s.c2d(a.x),
                        y: c.c2d(a.y)
                    }), a.selected = 1) : a.selected = 0;
                    return u;
                };
            },
            565: function(e) {
                "use strict";
                var t = [
                    "orientation",
                    "groupnorm",
                    "stackgaps"
                ];
                e.exports = function(e, r, n, a) {
                    var i = n._scatterStackOpts, o = a("stackgroup");
                    if (o) {
                        var l = r.xaxis + r.yaxis, s = i[l];
                        s || (s = i[l] = {});
                        var c = s[o], u = !1;
                        c ? c.traces.push(r) : (c = s[o] = {
                            traceIndices: [],
                            traces: [
                                r
                            ]
                        }, u = !0);
                        for(var f = {
                            orientation: r.x && !r.y ? "h" : "v"
                        }, d = 0; d < t.length; d++){
                            var h = t[d], p = h + "Found";
                            if (!c[p]) {
                                var v = void 0 !== e[h], g = "orientation" === h;
                                if ((v || u) && (c[h] = a(h, f[h]), g && (c.fillDflt = "h" === c[h] ? "tonextx" : "tonexty"), v && (c[p] = !0, !u && (delete c.traces[0][h], g)))) for(var y = 0; y < c.traces.length - 1; y++){
                                    var m = c.traces[y];
                                    m._input.fill !== m.fill && (m.fill = c.fillDflt);
                                }
                            }
                        }
                        return c;
                    }
                };
            },
            6296: function(e, t, r) {
                "use strict";
                var n = r(9898), a = r(1424), i = r(3972);
                function o(e, t, r) {
                    a.pointStyle(e.selectAll("path.point"), t, r);
                }
                function l(e, t, r) {
                    a.textPointStyle(e.selectAll("text"), t, r);
                }
                e.exports = {
                    style: function(e) {
                        var t = n.select(e).selectAll("g.trace.scatter");
                        t.style("opacity", function(e) {
                            return e[0].trace.opacity;
                        }), t.selectAll("g.points").each(function(t) {
                            o(n.select(this), t.trace || t[0].trace, e);
                        }), t.selectAll("g.text").each(function(t) {
                            l(n.select(this), t.trace || t[0].trace, e);
                        }), t.selectAll("g.trace path.js-line").call(a.lineGroupStyle), t.selectAll("g.trace path.js-fill").call(a.fillGroupStyle, e), i.getComponentMethod("errorbars", "style")(t);
                    },
                    stylePoints: o,
                    styleText: l,
                    styleOnSelect: function(e, t, r) {
                        var n = t[0].trace;
                        n.selectedpoints ? (a.selectedPointStyle(r.selectAll("path.point"), n), a.selectedTextStyle(r.selectAll("text"), n)) : (o(r, n, e), l(r, n, e));
                    }
                };
            },
            4098: function(e, t, r) {
                "use strict";
                var n = r(1828);
                e.exports = {
                    hasLines: function(e) {
                        return e.visible && e.mode && -1 !== e.mode.indexOf("lines");
                    },
                    hasMarkers: function(e) {
                        return e.visible && (e.mode && -1 !== e.mode.indexOf("markers") || "splom" === e.type);
                    },
                    hasText: function(e) {
                        return e.visible && e.mode && -1 !== e.mode.indexOf("text");
                    },
                    isBubble: function(e) {
                        return n.isPlainObject(e.marker) && n.isArrayOrTypedArray(e.marker.size);
                    }
                };
            },
            2410: function(e, t, r) {
                "use strict";
                var n = r(1828);
                e.exports = function(e, t, r, a, i) {
                    i = i || {}, a("textposition"), n.coerceFont(a, "textfont", i.font || r.font), i.noSelect || (a("selected.textfont.color"), a("unselected.textfont.color"));
                };
            },
            7513: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(3972);
                e.exports = function(e, t, r, i) {
                    var o, l = i("x"), s = i("y");
                    if (a.getComponentMethod("calendars", "handleTraceDefaults")(e, t, [
                        "x",
                        "y"
                    ], r), l) {
                        var c = n.minRowLength(l);
                        s ? o = Math.min(c, n.minRowLength(s)) : (o = c, i("y0"), i("dy"));
                    } else {
                        if (!s) return 0;
                        o = n.minRowLength(s), i("x0"), i("dx");
                    }
                    return t._length = o, o;
                };
            },
            2887: function(e, t, r) {
                "use strict";
                var n = r(9298), a = r(1828), i = r(6281), o = r(9344).p, l = r(606).BADNUM;
                t.moduleType = "transform", t.name = "aggregate";
                var s = t.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    groups: {
                        valType: "string",
                        strict: !0,
                        noBlank: !0,
                        arrayOk: !0,
                        dflt: "x",
                        editType: "calc"
                    },
                    aggregations: {
                        _isLinkedToArray: "aggregation",
                        target: {
                            valType: "string",
                            editType: "calc"
                        },
                        func: {
                            valType: "enumerated",
                            values: [
                                "count",
                                "sum",
                                "avg",
                                "median",
                                "mode",
                                "rms",
                                "stddev",
                                "min",
                                "max",
                                "first",
                                "last",
                                "change",
                                "range"
                            ],
                            dflt: "first",
                            editType: "calc"
                        },
                        funcmode: {
                            valType: "enumerated",
                            values: [
                                "sample",
                                "population"
                            ],
                            dflt: "sample",
                            editType: "calc"
                        },
                        enabled: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    editType: "calc"
                }, c = s.aggregations;
                function u(e, t, r, i) {
                    if (i.enabled) {
                        for(var o = i.target, s = a.nestedProperty(t, o), c = s.get(), u = function(e, t) {
                            var r = e.func, n = t.d2c, i = t.c2d;
                            switch(r){
                                case "count":
                                    return f;
                                case "first":
                                    return d;
                                case "last":
                                    return h;
                                case "sum":
                                    return function(e, t) {
                                        for(var r = 0, a = 0; a < t.length; a++){
                                            var o = n(e[t[a]]);
                                            o !== l && (r += o);
                                        }
                                        return i(r);
                                    };
                                case "avg":
                                    return function(e, t) {
                                        for(var r = 0, a = 0, o = 0; o < t.length; o++){
                                            var s = n(e[t[o]]);
                                            s !== l && (r += s, a++);
                                        }
                                        return a ? i(r / a) : l;
                                    };
                                case "min":
                                    return function(e, t) {
                                        for(var r = 1 / 0, a = 0; a < t.length; a++){
                                            var o = n(e[t[a]]);
                                            o !== l && (r = Math.min(r, o));
                                        }
                                        return r === 1 / 0 ? l : i(r);
                                    };
                                case "max":
                                    return function(e, t) {
                                        for(var r = -1 / 0, a = 0; a < t.length; a++){
                                            var o = n(e[t[a]]);
                                            o !== l && (r = Math.max(r, o));
                                        }
                                        return r === -1 / 0 ? l : i(r);
                                    };
                                case "range":
                                    return function(e, t) {
                                        for(var r = 1 / 0, a = -1 / 0, o = 0; o < t.length; o++){
                                            var s = n(e[t[o]]);
                                            s !== l && (r = Math.min(r, s), a = Math.max(a, s));
                                        }
                                        return a === -1 / 0 || r === 1 / 0 ? l : i(a - r);
                                    };
                                case "change":
                                    return function(e, t) {
                                        var r = n(e[t[0]]), a = n(e[t[t.length - 1]]);
                                        return r === l || a === l ? l : i(a - r);
                                    };
                                case "median":
                                    return function(e, t) {
                                        for(var r = [], o = 0; o < t.length; o++){
                                            var s = n(e[t[o]]);
                                            s !== l && r.push(s);
                                        }
                                        if (!r.length) return l;
                                        r.sort(a.sorterAsc);
                                        var c = (r.length - 1) / 2;
                                        return i((r[Math.floor(c)] + r[Math.ceil(c)]) / 2);
                                    };
                                case "mode":
                                    return function(e, t) {
                                        for(var r = {}, a = 0, o = l, s = 0; s < t.length; s++){
                                            var c = n(e[t[s]]);
                                            if (c !== l) {
                                                var u = r[c] = (r[c] || 0) + 1;
                                                u > a && (a = u, o = c);
                                            }
                                        }
                                        return a ? i(o) : l;
                                    };
                                case "rms":
                                    return function(e, t) {
                                        for(var r = 0, a = 0, o = 0; o < t.length; o++){
                                            var s = n(e[t[o]]);
                                            s !== l && (r += s * s, a++);
                                        }
                                        return a ? i(Math.sqrt(r / a)) : l;
                                    };
                                case "stddev":
                                    return function(t, r) {
                                        var a, i = 0, o = 0, s = 1, c = l;
                                        for(a = 0; a < r.length && c === l; a++)c = n(t[r[a]]);
                                        if (c === l) return l;
                                        for(; a < r.length; a++){
                                            var u = n(t[r[a]]);
                                            if (u !== l) {
                                                var f = u - c;
                                                i += f, o += f * f, s++;
                                            }
                                        }
                                        var d = "sample" === e.funcmode ? s - 1 : s;
                                        return d ? Math.sqrt((o - i * i / s) / d) : 0;
                                    };
                            }
                        }(i, n.getDataConversions(e, t, o, c)), p = new Array(r.length), v = 0; v < r.length; v++)p[v] = u(c, r[v]);
                        s.set(p), "count" === i.func && a.pushUnique(t._arrayAttrs, o);
                    }
                }
                function f(e, t) {
                    return t.length;
                }
                function d(e, t) {
                    return e[t[0]];
                }
                function h(e, t) {
                    return e[t[t.length - 1]];
                }
                t.supplyDefaults = function(e, t) {
                    var r, n = {};
                    function o(t, r) {
                        return a.coerce(e, n, s, t, r);
                    }
                    if (!o("enabled")) return n;
                    var l = i.findArrayAttributes(t), u = {};
                    for(r = 0; r < l.length; r++)u[l[r]] = 1;
                    var f = o("groups");
                    if (!Array.isArray(f)) {
                        if (!u[f]) return n.enabled = !1, n;
                        u[f] = 0;
                    }
                    var d, h = e.aggregations || [], p = n.aggregations = new Array(h.length);
                    function v(e, t) {
                        return a.coerce(h[r], d, c, e, t);
                    }
                    for(r = 0; r < h.length; r++){
                        d = {
                            _index: r
                        };
                        var g = v("target"), y = v("func");
                        v("enabled") && g && (u[g] || "count" === y && void 0 === u[g]) ? ("stddev" === y && v("funcmode"), u[g] = 0, p[r] = d) : p[r] = {
                            enabled: !1,
                            _index: r
                        };
                    }
                    for(r = 0; r < l.length; r++)u[l[r]] && p.push({
                        target: l[r],
                        func: c.func.dflt,
                        enabled: !0,
                        _index: -1
                    });
                    return n;
                }, t.calcTransform = function(e, t, r) {
                    if (r.enabled) {
                        var n = r.groups, i = a.getTargetArray(t, {
                            target: n
                        });
                        if (i) {
                            var l, s, c, f, d = {}, h = {}, p = [], v = o(t.transforms, r), g = i.length;
                            for(t._length && (g = Math.min(g, t._length)), l = 0; l < g; l++)void 0 === (c = d[s = i[l]]) ? (d[s] = p.length, f = [
                                l
                            ], p.push(f), h[d[s]] = v(l)) : (p[c].push(l), h[d[s]] = (h[d[s]] || []).concat(v(l)));
                            r._indexToPoints = h;
                            var y = r.aggregations;
                            for(l = 0; l < y.length; l++)u(e, t, p, y[l]);
                            "string" == typeof n && u(e, t, p, {
                                target: n,
                                func: "first",
                                enabled: !0
                            }), t._length = p.length;
                        }
                    }
                };
            },
            4382: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(3972), i = r(9298), o = r(9344).p, l = r(4808), s = l.COMPARISON_OPS, c = l.INTERVAL_OPS, u = l.SET_OPS;
                t.moduleType = "transform", t.name = "filter", t.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    target: {
                        valType: "string",
                        strict: !0,
                        noBlank: !0,
                        arrayOk: !0,
                        dflt: "x",
                        editType: "calc"
                    },
                    operation: {
                        valType: "enumerated",
                        values: [].concat(s).concat(c).concat(u),
                        dflt: "=",
                        editType: "calc"
                    },
                    value: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc"
                    },
                    preservegaps: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    editType: "calc"
                }, t.supplyDefaults = function(e) {
                    var r = {};
                    function i(a, i) {
                        return n.coerce(e, r, t.attributes, a, i);
                    }
                    if (i("enabled")) {
                        var o = i("target");
                        if (n.isArrayOrTypedArray(o) && 0 === o.length) return r.enabled = !1, r;
                        i("preservegaps"), i("operation"), i("value");
                        var l = a.getComponentMethod("calendars", "handleDefaults");
                        l(e, r, "valuecalendar", null), l(e, r, "targetcalendar", null);
                    }
                    return r;
                }, t.calcTransform = function(e, t, r) {
                    if (r.enabled) {
                        var a = n.getTargetArray(t, r);
                        if (a) {
                            var l = r.target, f = a.length;
                            t._length && (f = Math.min(f, t._length));
                            var d = r.targetcalendar, h = t._arrayAttrs, p = r.preservegaps;
                            if ("string" == typeof l) {
                                var v = n.nestedProperty(t, l + "calendar").get();
                                v && (d = v);
                            }
                            var g, y, m = function(e, t, r) {
                                var n = e.operation, a = e.value, i = Array.isArray(a);
                                function o(e) {
                                    return -1 !== e.indexOf(n);
                                }
                                var l, f = function(r) {
                                    return t(r, 0, e.valuecalendar);
                                }, d = function(e) {
                                    return t(e, 0, r);
                                };
                                switch(o(s) ? l = f(i ? a[0] : a) : o(c) ? l = i ? [
                                    f(a[0]),
                                    f(a[1])
                                ] : [
                                    f(a),
                                    f(a)
                                ] : o(u) && (l = i ? a.map(f) : [
                                    f(a)
                                ]), n){
                                    case "=":
                                        return function(e) {
                                            return d(e) === l;
                                        };
                                    case "!=":
                                        return function(e) {
                                            return d(e) !== l;
                                        };
                                    case "<":
                                        return function(e) {
                                            return d(e) < l;
                                        };
                                    case "<=":
                                        return function(e) {
                                            return d(e) <= l;
                                        };
                                    case ">":
                                        return function(e) {
                                            return d(e) > l;
                                        };
                                    case ">=":
                                        return function(e) {
                                            return d(e) >= l;
                                        };
                                    case "[]":
                                        return function(e) {
                                            var t = d(e);
                                            return t >= l[0] && t <= l[1];
                                        };
                                    case "()":
                                        return function(e) {
                                            var t = d(e);
                                            return t > l[0] && t < l[1];
                                        };
                                    case "[)":
                                        return function(e) {
                                            var t = d(e);
                                            return t >= l[0] && t < l[1];
                                        };
                                    case "(]":
                                        return function(e) {
                                            var t = d(e);
                                            return t > l[0] && t <= l[1];
                                        };
                                    case "][":
                                        return function(e) {
                                            var t = d(e);
                                            return t <= l[0] || t >= l[1];
                                        };
                                    case ")(":
                                        return function(e) {
                                            var t = d(e);
                                            return t < l[0] || t > l[1];
                                        };
                                    case "](":
                                        return function(e) {
                                            var t = d(e);
                                            return t <= l[0] || t > l[1];
                                        };
                                    case ")[":
                                        return function(e) {
                                            var t = d(e);
                                            return t < l[0] || t >= l[1];
                                        };
                                    case "{}":
                                        return function(e) {
                                            return -1 !== l.indexOf(d(e));
                                        };
                                    case "}{":
                                        return function(e) {
                                            return -1 === l.indexOf(d(e));
                                        };
                                }
                            }(r, i.getDataToCoordFunc(e, t, l, a), d), x = {}, b = {}, _ = 0;
                            p ? (g = function(e) {
                                x[e.astr] = n.extendDeep([], e.get()), e.set(new Array(f));
                            }, y = function(e, t) {
                                var r = x[e.astr][t];
                                e.get()[t] = r;
                            }) : (g = function(e) {
                                x[e.astr] = n.extendDeep([], e.get()), e.set([]);
                            }, y = function(e, t) {
                                var r = x[e.astr][t];
                                e.get().push(r);
                            }), M(g);
                            for(var w = o(t.transforms, r), T = 0; T < f; T++)m(a[T]) ? (M(y, T), b[_++] = w(T)) : p && _++;
                            r._indexToPoints = b, t._length = _;
                        }
                    }
                    function M(e, r) {
                        for(var a = 0; a < h.length; a++)e(n.nestedProperty(t, h[a]), r);
                    }
                };
            },
            3102: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(6281), i = r(4875), o = r(9344).p;
                function l(e, t) {
                    var r, l, s, c, u, f, d, h, p, v, g = t.transform, y = t.transformIndex, m = e.transforms[y].groups, x = o(e.transforms, g);
                    if (!n.isArrayOrTypedArray(m) || 0 === m.length) return [
                        e
                    ];
                    var b = n.filterUnique(m), _ = new Array(b.length), w = m.length, T = a.findArrayAttributes(e), M = g.styles || [], k = {};
                    for(r = 0; r < M.length; r++)k[M[r].target] = M[r].value;
                    g.styles && (v = n.keyedContainer(g, "styles", "target", "value.name"));
                    var A = {}, L = {};
                    for(r = 0; r < b.length; r++){
                        A[f = b[r]] = r, L[f] = 0, (d = _[r] = n.extendDeepNoArrays({}, e))._group = f, d.transforms[y]._indexToPoints = {};
                        var S = null;
                        for(v && (S = v.get(f)), d.name = S || "" === S ? S : n.templateString(g.nameformat, {
                            trace: e.name,
                            group: f
                        }), h = d.transforms, d.transforms = [], l = 0; l < h.length; l++)d.transforms[l] = n.extendDeepNoArrays({}, h[l]);
                        for(l = 0; l < T.length; l++)n.nestedProperty(d, T[l]).set([]);
                    }
                    for(s = 0; s < T.length; s++){
                        for(c = T[s], l = 0, p = []; l < b.length; l++)p[l] = n.nestedProperty(_[l], c).get();
                        for(u = n.nestedProperty(e, c).get(), l = 0; l < w; l++)p[A[m[l]]].push(u[l]);
                    }
                    for(l = 0; l < w; l++)(d = _[A[m[l]]]).transforms[y]._indexToPoints[L[m[l]]] = x(l), L[m[l]]++;
                    for(r = 0; r < b.length; r++)f = b[r], d = _[r], i.clearExpandedTraceDefaultColors(d), d = n.extendDeepNoArrays(d, k[f] || {});
                    return _;
                }
                t.moduleType = "transform", t.name = "groupby", t.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    groups: {
                        valType: "data_array",
                        dflt: [],
                        editType: "calc"
                    },
                    nameformat: {
                        valType: "string",
                        editType: "calc"
                    },
                    styles: {
                        _isLinkedToArray: "style",
                        target: {
                            valType: "string",
                            editType: "calc"
                        },
                        value: {
                            valType: "any",
                            dflt: {},
                            editType: "calc",
                            _compareAsJSON: !0
                        },
                        editType: "calc"
                    },
                    editType: "calc"
                }, t.supplyDefaults = function(e, r, a) {
                    var i, o = {};
                    function l(r, a) {
                        return n.coerce(e, o, t.attributes, r, a);
                    }
                    if (!l("enabled")) return o;
                    l("groups"), l("nameformat", a._dataLength > 1 ? "%{group} (%{trace})" : "%{group}");
                    var s = e.styles, c = o.styles = [];
                    if (s) for(i = 0; i < s.length; i++){
                        var u = c[i] = {};
                        n.coerce(s[i], c[i], t.attributes.styles, "target");
                        var f = n.coerce(s[i], c[i], t.attributes.styles, "value");
                        n.isPlainObject(f) ? u.value = n.extendDeep({}, f) : f && delete u.value;
                    }
                    return o;
                }, t.transform = function(e, t) {
                    var r, n, a, i = [];
                    for(n = 0; n < e.length; n++)for(r = l(e[n], t), a = 0; a < r.length; a++)i.push(r[a]);
                    return i;
                };
            },
            9344: function(e, t) {
                "use strict";
                t.p = function(e, t) {
                    for(var r, n, a = 0; a < e.length && (r = e[a]) !== t; a++)r._indexToPoints && !1 !== r.enabled && (n = r._indexToPoints);
                    var i = n ? function(e) {
                        return n[e];
                    } : function(e) {
                        return [
                            e
                        ];
                    };
                    return i;
                };
            },
            2275: function(e, t, r) {
                "use strict";
                var n = r(1828), a = r(9298), i = r(9344).p, o = r(606).BADNUM;
                t.moduleType = "transform", t.name = "sort", t.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    target: {
                        valType: "string",
                        strict: !0,
                        noBlank: !0,
                        arrayOk: !0,
                        dflt: "x",
                        editType: "calc"
                    },
                    order: {
                        valType: "enumerated",
                        values: [
                            "ascending",
                            "descending"
                        ],
                        dflt: "ascending",
                        editType: "calc"
                    },
                    editType: "calc"
                }, t.supplyDefaults = function(e) {
                    var r = {};
                    function a(a, i) {
                        return n.coerce(e, r, t.attributes, a, i);
                    }
                    return a("enabled") && (a("target"), a("order")), r;
                }, t.calcTransform = function(e, t, r) {
                    if (r.enabled) {
                        var l = n.getTargetArray(t, r);
                        if (l) {
                            var s = r.target, c = l.length;
                            t._length && (c = Math.min(c, t._length));
                            var u, f, d = t._arrayAttrs, h = function(e, t, r, n) {
                                var a, i = new Array(n), l = new Array(n);
                                for(a = 0; a < n; a++)i[a] = {
                                    v: t[a],
                                    i: a
                                };
                                for(i.sort(function(e, t) {
                                    switch(e.order){
                                        case "ascending":
                                            return function(e, r) {
                                                var n = t(e.v), a = t(r.v);
                                                return n === o ? 1 : a === o ? -1 : n - a;
                                            };
                                        case "descending":
                                            return function(e, r) {
                                                var n = t(e.v), a = t(r.v);
                                                return n === o ? 1 : a === o ? -1 : a - n;
                                            };
                                    }
                                }(e, r)), a = 0; a < n; a++)l[a] = i[a].i;
                                return l;
                            }(r, l, a.getDataToCoordFunc(e, t, s, l), c), p = i(t.transforms, r), v = {};
                            for(u = 0; u < d.length; u++){
                                var g = n.nestedProperty(t, d[u]), y = g.get(), m = new Array(c);
                                for(f = 0; f < c; f++)m[f] = y[h[f]];
                                g.set(m);
                            }
                            for(f = 0; f < c; f++)v[f] = p(h[f]);
                            r._indexToPoints = v, t._length = c;
                        }
                    }
                };
            },
            1506: function(e, t) {
                "use strict";
                t.version = "2.26.1";
            },
            5791: function(e) {
                "use strict";
                e.exports = a, e.exports.isMobile = a, e.exports.default = a;
                var t = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, r = /CrOS/, n = /android|ipad|playbook|silk/i;
                function a(e) {
                    e || (e = {});
                    var a = e.ua;
                    if (a || "undefined" == typeof navigator || (a = navigator.userAgent), a && a.headers && "string" == typeof a.headers["user-agent"] && (a = a.headers["user-agent"]), "string" != typeof a) return !1;
                    var i = t.test(a) && !r.test(a) || !!e.tablet && n.test(a);
                    return !i && e.tablet && e.featureDetect && navigator && navigator.maxTouchPoints > 1 && -1 !== a.indexOf("Macintosh") && -1 !== a.indexOf("Safari") && (i = !0), i;
                }
            },
            9898: function(e, t, r) {
                var n, a;
                (function() {
                    var i = {
                        version: "3.8.0"
                    }, o = [].slice, l = function(e) {
                        return o.call(e);
                    }, s = self.document;
                    function c(e) {
                        return e && (e.ownerDocument || e.document || e).documentElement;
                    }
                    function u(e) {
                        return e && (e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView);
                    }
                    if (s) try {
                        l(s.documentElement.childNodes)[0].nodeType;
                    } catch (e) {
                        l = function(e) {
                            for(var t = e.length, r = new Array(t); t--;)r[t] = e[t];
                            return r;
                        };
                    }
                    if (Date.now || (Date.now = function() {
                        return +new Date;
                    }), s) try {
                        s.createElement("DIV").style.setProperty("opacity", 0, "");
                    } catch (e) {
                        var f = this.Element.prototype, d = f.setAttribute, h = f.setAttributeNS, p = this.CSSStyleDeclaration.prototype, v = p.setProperty;
                        f.setAttribute = function(e, t) {
                            d.call(this, e, t + "");
                        }, f.setAttributeNS = function(e, t, r) {
                            h.call(this, e, t, r + "");
                        }, p.setProperty = function(e, t, r) {
                            v.call(this, e, t + "", r);
                        };
                    }
                    function g(e, t) {
                        return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
                    }
                    function y(e) {
                        return null === e ? NaN : +e;
                    }
                    function m(e) {
                        return !isNaN(e);
                    }
                    function x(e) {
                        return {
                            left: function(t, r, n, a) {
                                for(arguments.length < 3 && (n = 0), arguments.length < 4 && (a = t.length); n < a;){
                                    var i = n + a >>> 1;
                                    e(t[i], r) < 0 ? n = i + 1 : a = i;
                                }
                                return n;
                            },
                            right: function(t, r, n, a) {
                                for(arguments.length < 3 && (n = 0), arguments.length < 4 && (a = t.length); n < a;){
                                    var i = n + a >>> 1;
                                    e(t[i], r) > 0 ? a = i : n = i + 1;
                                }
                                return n;
                            }
                        };
                    }
                    i.ascending = g, i.descending = function(e, t) {
                        return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
                    }, i.min = function(e, t) {
                        var r, n, a = -1, i = e.length;
                        if (1 === arguments.length) {
                            for(; ++a < i;)if (null != (n = e[a]) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++a < i;)null != (n = e[a]) && r > n && (r = n);
                        } else {
                            for(; ++a < i;)if (null != (n = t.call(e, e[a], a)) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++a < i;)null != (n = t.call(e, e[a], a)) && r > n && (r = n);
                        }
                        return r;
                    }, i.max = function(e, t) {
                        var r, n, a = -1, i = e.length;
                        if (1 === arguments.length) {
                            for(; ++a < i;)if (null != (n = e[a]) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++a < i;)null != (n = e[a]) && n > r && (r = n);
                        } else {
                            for(; ++a < i;)if (null != (n = t.call(e, e[a], a)) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++a < i;)null != (n = t.call(e, e[a], a)) && n > r && (r = n);
                        }
                        return r;
                    }, i.extent = function(e, t) {
                        var r, n, a, i = -1, o = e.length;
                        if (1 === arguments.length) {
                            for(; ++i < o;)if (null != (n = e[i]) && n >= n) {
                                r = a = n;
                                break;
                            }
                            for(; ++i < o;)null != (n = e[i]) && (r > n && (r = n), a < n && (a = n));
                        } else {
                            for(; ++i < o;)if (null != (n = t.call(e, e[i], i)) && n >= n) {
                                r = a = n;
                                break;
                            }
                            for(; ++i < o;)null != (n = t.call(e, e[i], i)) && (r > n && (r = n), a < n && (a = n));
                        }
                        return [
                            r,
                            a
                        ];
                    }, i.sum = function(e, t) {
                        var r, n = 0, a = e.length, i = -1;
                        if (1 === arguments.length) for(; ++i < a;)m(r = +e[i]) && (n += r);
                        else for(; ++i < a;)m(r = +t.call(e, e[i], i)) && (n += r);
                        return n;
                    }, i.mean = function(e, t) {
                        var r, n = 0, a = e.length, i = -1, o = a;
                        if (1 === arguments.length) for(; ++i < a;)m(r = y(e[i])) ? n += r : --o;
                        else for(; ++i < a;)m(r = y(t.call(e, e[i], i))) ? n += r : --o;
                        if (o) return n / o;
                    }, i.quantile = function(e, t) {
                        var r = (e.length - 1) * t + 1, n = Math.floor(r), a = +e[n - 1], i = r - n;
                        return i ? a + i * (e[n] - a) : a;
                    }, i.median = function(e, t) {
                        var r, n = [], a = e.length, o = -1;
                        if (1 === arguments.length) for(; ++o < a;)m(r = y(e[o])) && n.push(r);
                        else for(; ++o < a;)m(r = y(t.call(e, e[o], o))) && n.push(r);
                        if (n.length) return i.quantile(n.sort(g), .5);
                    }, i.variance = function(e, t) {
                        var r, n, a = e.length, i = 0, o = 0, l = -1, s = 0;
                        if (1 === arguments.length) for(; ++l < a;)m(r = y(e[l])) && (o += (n = r - i) * (r - (i += n / ++s)));
                        else for(; ++l < a;)m(r = y(t.call(e, e[l], l))) && (o += (n = r - i) * (r - (i += n / ++s)));
                        if (s > 1) return o / (s - 1);
                    }, i.deviation = function() {
                        var e = i.variance.apply(this, arguments);
                        return e ? Math.sqrt(e) : e;
                    };
                    var b = x(g);
                    function _(e) {
                        return e.length;
                    }
                    i.bisectLeft = b.left, i.bisect = i.bisectRight = b.right, i.bisector = function(e) {
                        return x(1 === e.length ? function(t, r) {
                            return g(e(t), r);
                        } : e);
                    }, i.shuffle = function(e, t, r) {
                        (i = arguments.length) < 3 && (r = e.length, i < 2 && (t = 0));
                        for(var n, a, i = r - t; i;)a = Math.random() * i-- | 0, n = e[i + t], e[i + t] = e[a + t], e[a + t] = n;
                        return e;
                    }, i.permute = function(e, t) {
                        for(var r = t.length, n = new Array(r); r--;)n[r] = e[t[r]];
                        return n;
                    }, i.pairs = function(e) {
                        for(var t = 0, r = e.length - 1, n = e[0], a = new Array(r < 0 ? 0 : r); t < r;)a[t] = [
                            n,
                            n = e[++t]
                        ];
                        return a;
                    }, i.transpose = function(e) {
                        if (!(a = e.length)) return [];
                        for(var t = -1, r = i.min(e, _), n = new Array(r); ++t < r;)for(var a, o = -1, l = n[t] = new Array(a); ++o < a;)l[o] = e[o][t];
                        return n;
                    }, i.zip = function() {
                        return i.transpose(arguments);
                    }, i.keys = function(e) {
                        var t = [];
                        for(var r in e)t.push(r);
                        return t;
                    }, i.values = function(e) {
                        var t = [];
                        for(var r in e)t.push(e[r]);
                        return t;
                    }, i.entries = function(e) {
                        var t = [];
                        for(var r in e)t.push({
                            key: r,
                            value: e[r]
                        });
                        return t;
                    }, i.merge = function(e) {
                        for(var t, r, n, a = e.length, i = -1, o = 0; ++i < a;)o += e[i].length;
                        for(r = new Array(o); --a >= 0;)for(t = (n = e[a]).length; --t >= 0;)r[--o] = n[t];
                        return r;
                    };
                    var w = Math.abs;
                    function T(e, t) {
                        for(var r in t)Object.defineProperty(e.prototype, r, {
                            value: t[r],
                            enumerable: !1
                        });
                    }
                    function M() {
                        this._ = Object.create(null);
                    }
                    i.range = function(e, t, r) {
                        if (arguments.length < 3 && (r = 1, arguments.length < 2 && (t = e, e = 0)), (t - e) / r == 1 / 0) throw new Error("infinite range");
                        var n, a = [], i = function(e) {
                            for(var t = 1; e * t % 1;)t *= 10;
                            return t;
                        }(w(r)), o = -1;
                        if (e *= i, t *= i, (r *= i) < 0) for(; (n = e + r * ++o) > t;)a.push(n / i);
                        else for(; (n = e + r * ++o) < t;)a.push(n / i);
                        return a;
                    }, i.map = function(e, t) {
                        var r = new M;
                        if (e instanceof M) e.forEach(function(e, t) {
                            r.set(e, t);
                        });
                        else if (Array.isArray(e)) {
                            var n, a = -1, i = e.length;
                            if (1 === arguments.length) for(; ++a < i;)r.set(a, e[a]);
                            else for(; ++a < i;)r.set(t.call(e, n = e[a], a), n);
                        } else for(var o in e)r.set(o, e[o]);
                        return r;
                    };
                    var k = "__proto__", A = "\0";
                    function L(e) {
                        return (e += "") === k || e[0] === A ? A + e : e;
                    }
                    function S(e) {
                        return (e += "")[0] === A ? e.slice(1) : e;
                    }
                    function D(e) {
                        return L(e) in this._;
                    }
                    function O(e) {
                        return (e = L(e)) in this._ && delete this._[e];
                    }
                    function C() {
                        var e = [];
                        for(var t in this._)e.push(S(t));
                        return e;
                    }
                    function P() {
                        var e = 0;
                        for(var t in this._)++e;
                        return e;
                    }
                    function I() {
                        for(var e in this._)return !1;
                        return !0;
                    }
                    function R() {
                        this._ = Object.create(null);
                    }
                    function z(e) {
                        return e;
                    }
                    function N(e, t, r) {
                        return function() {
                            var n = r.apply(t, arguments);
                            return n === t ? e : n;
                        };
                    }
                    function F(e, t) {
                        if (t in e) return t;
                        t = t.charAt(0).toUpperCase() + t.slice(1);
                        for(var r = 0, n = E.length; r < n; ++r){
                            var a = E[r] + t;
                            if (a in e) return a;
                        }
                    }
                    T(M, {
                        has: D,
                        get: function(e) {
                            return this._[L(e)];
                        },
                        set: function(e, t) {
                            return this._[L(e)] = t;
                        },
                        remove: O,
                        keys: C,
                        values: function() {
                            var e = [];
                            for(var t in this._)e.push(this._[t]);
                            return e;
                        },
                        entries: function() {
                            var e = [];
                            for(var t in this._)e.push({
                                key: S(t),
                                value: this._[t]
                            });
                            return e;
                        },
                        size: P,
                        empty: I,
                        forEach: function(e) {
                            for(var t in this._)e.call(this, S(t), this._[t]);
                        }
                    }), i.nest = function() {
                        var e, t, r = {}, n = [], a = [];
                        function o(a, i, l) {
                            if (l >= n.length) return t ? t.call(r, i) : e ? i.sort(e) : i;
                            for(var s, c, u, f, d = -1, h = i.length, p = n[l++], v = new M; ++d < h;)(f = v.get(s = p(c = i[d]))) ? f.push(c) : v.set(s, [
                                c
                            ]);
                            return a ? (c = a(), u = function(e, t) {
                                c.set(e, o(a, t, l));
                            }) : (c = {}, u = function(e, t) {
                                c[e] = o(a, t, l);
                            }), v.forEach(u), c;
                        }
                        function l(e, t) {
                            if (t >= n.length) return e;
                            var r = [], i = a[t++];
                            return e.forEach(function(e, n) {
                                r.push({
                                    key: e,
                                    values: l(n, t)
                                });
                            }), i ? r.sort(function(e, t) {
                                return i(e.key, t.key);
                            }) : r;
                        }
                        return r.map = function(e, t) {
                            return o(t, e, 0);
                        }, r.entries = function(e) {
                            return l(o(i.map, e, 0), 0);
                        }, r.key = function(e) {
                            return n.push(e), r;
                        }, r.sortKeys = function(e) {
                            return a[n.length - 1] = e, r;
                        }, r.sortValues = function(t) {
                            return e = t, r;
                        }, r.rollup = function(e) {
                            return t = e, r;
                        }, r;
                    }, i.set = function(e) {
                        var t = new R;
                        if (e) for(var r = 0, n = e.length; r < n; ++r)t.add(e[r]);
                        return t;
                    }, T(R, {
                        has: D,
                        add: function(e) {
                            return this._[L(e += "")] = !0, e;
                        },
                        remove: O,
                        values: C,
                        size: P,
                        empty: I,
                        forEach: function(e) {
                            for(var t in this._)e.call(this, S(t));
                        }
                    }), i.behavior = {}, i.rebind = function(e, t) {
                        for(var r, n = 1, a = arguments.length; ++n < a;)e[r = arguments[n]] = N(e, t, t[r]);
                        return e;
                    };
                    var E = [
                        "webkit",
                        "ms",
                        "moz",
                        "Moz",
                        "o",
                        "O"
                    ];
                    function H() {}
                    function j() {}
                    function B(e) {
                        var t = [], r = new M;
                        function n() {
                            for(var r, n = t, a = -1, i = n.length; ++a < i;)(r = n[a].on) && r.apply(this, arguments);
                            return e;
                        }
                        return n.on = function(n, a) {
                            var i, o = r.get(n);
                            return arguments.length < 2 ? o && o.on : (o && (o.on = null, t = t.slice(0, i = t.indexOf(o)).concat(t.slice(i + 1)), r.remove(n)), a && t.push(r.set(n, {
                                on: a
                            })), e);
                        }, n;
                    }
                    function Y() {
                        i.event.preventDefault();
                    }
                    function V() {
                        for(var e, t = i.event; e = t.sourceEvent;)t = e;
                        return t;
                    }
                    function U(e) {
                        for(var t = new j, r = 0, n = arguments.length; ++r < n;)t[arguments[r]] = B(t);
                        return t.of = function(r, n) {
                            return function(a) {
                                try {
                                    var o = a.sourceEvent = i.event;
                                    a.target = e, i.event = a, t[a.type].apply(r, n);
                                } finally{
                                    i.event = o;
                                }
                            };
                        }, t;
                    }
                    i.dispatch = function() {
                        for(var e = new j, t = -1, r = arguments.length; ++t < r;)e[arguments[t]] = B(e);
                        return e;
                    }, j.prototype.on = function(e, t) {
                        var r = e.indexOf("."), n = "";
                        if (r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), e) return arguments.length < 2 ? this[e].on(n) : this[e].on(n, t);
                        if (2 === arguments.length) {
                            if (null == t) for(e in this)this.hasOwnProperty(e) && this[e].on(n, null);
                            return this;
                        }
                    }, i.event = null, i.requote = function(e) {
                        return e.replace(q, "\\$&");
                    };
                    var q = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g, G = {}.__proto__ ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var r in t)e[r] = t[r];
                    };
                    function Z(e) {
                        return G(e, K), e;
                    }
                    var W = function(e, t) {
                        return t.querySelector(e);
                    }, X = function(e, t) {
                        return t.querySelectorAll(e);
                    }, J = function(e, t) {
                        var r = e.matches || e[F(e, "matchesSelector")];
                        return J = function(e, t) {
                            return r.call(e, t);
                        }, J(e, t);
                    };
                    "function" == typeof Sizzle && (W = function(e, t) {
                        return Sizzle(e, t)[0] || null;
                    }, X = Sizzle, J = Sizzle.matchesSelector), i.selection = function() {
                        return i.select(s.documentElement);
                    };
                    var K = i.selection.prototype = [];
                    function Q(e) {
                        return "function" == typeof e ? e : function() {
                            return W(e, this);
                        };
                    }
                    function $(e) {
                        return "function" == typeof e ? e : function() {
                            return X(e, this);
                        };
                    }
                    K.select = function(e) {
                        var t, r, n, a, i = [];
                        e = Q(e);
                        for(var o = -1, l = this.length; ++o < l;){
                            i.push(t = []), t.parentNode = (n = this[o]).parentNode;
                            for(var s = -1, c = n.length; ++s < c;)(a = n[s]) ? (t.push(r = e.call(a, a.__data__, s, o)), r && "__data__" in a && (r.__data__ = a.__data__)) : t.push(null);
                        }
                        return Z(i);
                    }, K.selectAll = function(e) {
                        var t, r, n = [];
                        e = $(e);
                        for(var a = -1, i = this.length; ++a < i;)for(var o = this[a], s = -1, c = o.length; ++s < c;)(r = o[s]) && (n.push(t = l(e.call(r, r.__data__, s, a))), t.parentNode = r);
                        return Z(n);
                    };
                    var ee = "http://www.w3.org/1999/xhtml", te = {
                        svg: "http://www.w3.org/2000/svg",
                        xhtml: ee,
                        xlink: "http://www.w3.org/1999/xlink",
                        xml: "http://www.w3.org/XML/1998/namespace",
                        xmlns: "http://www.w3.org/2000/xmlns/"
                    };
                    function re(e, t) {
                        return e = i.ns.qualify(e), null == t ? e.local ? function() {
                            this.removeAttributeNS(e.space, e.local);
                        } : function() {
                            this.removeAttribute(e);
                        } : "function" == typeof t ? e.local ? function() {
                            var r = t.apply(this, arguments);
                            null == r ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, r);
                        } : function() {
                            var r = t.apply(this, arguments);
                            null == r ? this.removeAttribute(e) : this.setAttribute(e, r);
                        } : e.local ? function() {
                            this.setAttributeNS(e.space, e.local, t);
                        } : function() {
                            this.setAttribute(e, t);
                        };
                    }
                    function ne(e) {
                        return e.trim().replace(/\s+/g, " ");
                    }
                    function ae(e) {
                        return new RegExp("(?:^|\\s+)" + i.requote(e) + "(?:\\s+|$)", "g");
                    }
                    function ie(e) {
                        return (e + "").trim().split(/^|\s+/);
                    }
                    function oe(e, t) {
                        var r = (e = ie(e).map(le)).length;
                        return "function" == typeof t ? function() {
                            for(var n = -1, a = t.apply(this, arguments); ++n < r;)e[n](this, a);
                        } : function() {
                            for(var n = -1; ++n < r;)e[n](this, t);
                        };
                    }
                    function le(e) {
                        var t = ae(e);
                        return function(r, n) {
                            if (a = r.classList) return n ? a.add(e) : a.remove(e);
                            var a = r.getAttribute("class") || "";
                            n ? (t.lastIndex = 0, t.test(a) || r.setAttribute("class", ne(a + " " + e))) : r.setAttribute("class", ne(a.replace(t, " ")));
                        };
                    }
                    function se(e, t, r) {
                        return null == t ? function() {
                            this.style.removeProperty(e);
                        } : "function" == typeof t ? function() {
                            var n = t.apply(this, arguments);
                            null == n ? this.style.removeProperty(e) : this.style.setProperty(e, n, r);
                        } : function() {
                            this.style.setProperty(e, t, r);
                        };
                    }
                    function ce(e, t) {
                        return null == t ? function() {
                            delete this[e];
                        } : "function" == typeof t ? function() {
                            var r = t.apply(this, arguments);
                            null == r ? delete this[e] : this[e] = r;
                        } : function() {
                            this[e] = t;
                        };
                    }
                    function ue(e) {
                        return "function" == typeof e ? e : (e = i.ns.qualify(e)).local ? function() {
                            return this.ownerDocument.createElementNS(e.space, e.local);
                        } : function() {
                            var t = this.ownerDocument, r = this.namespaceURI;
                            return r === ee && t.documentElement.namespaceURI === ee ? t.createElement(e) : t.createElementNS(r, e);
                        };
                    }
                    function fe() {
                        var e = this.parentNode;
                        e && e.removeChild(this);
                    }
                    function de(e) {
                        return {
                            __data__: e
                        };
                    }
                    function he(e) {
                        return function() {
                            return J(this, e);
                        };
                    }
                    function pe(e) {
                        return arguments.length || (e = g), function(t, r) {
                            return t && r ? e(t.__data__, r.__data__) : !t - !r;
                        };
                    }
                    function ve(e, t) {
                        for(var r = 0, n = e.length; r < n; r++)for(var a, i = e[r], o = 0, l = i.length; o < l; o++)(a = i[o]) && t(a, o, r);
                        return e;
                    }
                    function ge(e) {
                        return G(e, ye), e;
                    }
                    i.ns = {
                        prefix: te,
                        qualify: function(e) {
                            var t = e.indexOf(":"), r = e;
                            return t >= 0 && "xmlns" !== (r = e.slice(0, t)) && (e = e.slice(t + 1)), te.hasOwnProperty(r) ? {
                                space: te[r],
                                local: e
                            } : e;
                        }
                    }, K.attr = function(e, t) {
                        if (arguments.length < 2) {
                            if ("string" == typeof e) {
                                var r = this.node();
                                return (e = i.ns.qualify(e)).local ? r.getAttributeNS(e.space, e.local) : r.getAttribute(e);
                            }
                            for(t in e)this.each(re(t, e[t]));
                            return this;
                        }
                        return this.each(re(e, t));
                    }, K.classed = function(e, t) {
                        if (arguments.length < 2) {
                            if ("string" == typeof e) {
                                var r = this.node(), n = (e = ie(e)).length, a = -1;
                                if (t = r.classList) {
                                    for(; ++a < n;)if (!t.contains(e[a])) return !1;
                                } else for(t = r.getAttribute("class"); ++a < n;)if (!ae(e[a]).test(t)) return !1;
                                return !0;
                            }
                            for(t in e)this.each(oe(t, e[t]));
                            return this;
                        }
                        return this.each(oe(e, t));
                    }, K.style = function(e, t, r) {
                        var n = arguments.length;
                        if (n < 3) {
                            if ("string" != typeof e) {
                                for(r in n < 2 && (t = ""), e)this.each(se(r, e[r], t));
                                return this;
                            }
                            if (n < 2) {
                                var a = this.node();
                                return u(a).getComputedStyle(a, null).getPropertyValue(e);
                            }
                            r = "";
                        }
                        return this.each(se(e, t, r));
                    }, K.property = function(e, t) {
                        if (arguments.length < 2) {
                            if ("string" == typeof e) return this.node()[e];
                            for(t in e)this.each(ce(t, e[t]));
                            return this;
                        }
                        return this.each(ce(e, t));
                    }, K.text = function(e) {
                        return arguments.length ? this.each("function" == typeof e ? function() {
                            var t = e.apply(this, arguments);
                            this.textContent = null == t ? "" : t;
                        } : null == e ? function() {
                            this.textContent = "";
                        } : function() {
                            this.textContent = e;
                        }) : this.node().textContent;
                    }, K.html = function(e) {
                        return arguments.length ? this.each("function" == typeof e ? function() {
                            var t = e.apply(this, arguments);
                            this.innerHTML = null == t ? "" : t;
                        } : null == e ? function() {
                            this.innerHTML = "";
                        } : function() {
                            this.innerHTML = e;
                        }) : this.node().innerHTML;
                    }, K.append = function(e) {
                        return e = ue(e), this.select(function() {
                            return this.appendChild(e.apply(this, arguments));
                        });
                    }, K.insert = function(e, t) {
                        return e = ue(e), t = Q(t), this.select(function() {
                            return this.insertBefore(e.apply(this, arguments), t.apply(this, arguments) || null);
                        });
                    }, K.remove = function() {
                        return this.each(fe);
                    }, K.data = function(e, t) {
                        var r, n, a = -1, i = this.length;
                        if (!arguments.length) {
                            for(e = new Array(i = (r = this[0]).length); ++a < i;)(n = r[a]) && (e[a] = n.__data__);
                            return e;
                        }
                        function o(e, r) {
                            var n, a, i, o = e.length, u = r.length, f = Math.min(o, u), d = new Array(u), h = new Array(u), p = new Array(o);
                            if (t) {
                                var v, g = new M, y = new Array(o);
                                for(n = -1; ++n < o;)(a = e[n]) && (g.has(v = t.call(a, a.__data__, n)) ? p[n] = a : g.set(v, a), y[n] = v);
                                for(n = -1; ++n < u;)(a = g.get(v = t.call(r, i = r[n], n))) ? !0 !== a && (d[n] = a, a.__data__ = i) : h[n] = de(i), g.set(v, !0);
                                for(n = -1; ++n < o;)n in y && !0 !== g.get(y[n]) && (p[n] = e[n]);
                            } else {
                                for(n = -1; ++n < f;)a = e[n], i = r[n], a ? (a.__data__ = i, d[n] = a) : h[n] = de(i);
                                for(; n < u; ++n)h[n] = de(r[n]);
                                for(; n < o; ++n)p[n] = e[n];
                            }
                            h.update = d, h.parentNode = d.parentNode = p.parentNode = e.parentNode, l.push(h), s.push(d), c.push(p);
                        }
                        var l = ge([]), s = Z([]), c = Z([]);
                        if ("function" == typeof e) for(; ++a < i;)o(r = this[a], e.call(r, r.parentNode.__data__, a));
                        else for(; ++a < i;)o(r = this[a], e);
                        return s.enter = function() {
                            return l;
                        }, s.exit = function() {
                            return c;
                        }, s;
                    }, K.datum = function(e) {
                        return arguments.length ? this.property("__data__", e) : this.property("__data__");
                    }, K.filter = function(e) {
                        var t, r, n, a = [];
                        "function" != typeof e && (e = he(e));
                        for(var i = 0, o = this.length; i < o; i++){
                            a.push(t = []), t.parentNode = (r = this[i]).parentNode;
                            for(var l = 0, s = r.length; l < s; l++)(n = r[l]) && e.call(n, n.__data__, l, i) && t.push(n);
                        }
                        return Z(a);
                    }, K.order = function() {
                        for(var e = -1, t = this.length; ++e < t;)for(var r, n = this[e], a = n.length - 1, i = n[a]; --a >= 0;)(r = n[a]) && (i && i !== r.nextSibling && i.parentNode.insertBefore(r, i), i = r);
                        return this;
                    }, K.sort = function(e) {
                        e = pe.apply(this, arguments);
                        for(var t = -1, r = this.length; ++t < r;)this[t].sort(e);
                        return this.order();
                    }, K.each = function(e) {
                        return ve(this, function(t, r, n) {
                            e.call(t, t.__data__, r, n);
                        });
                    }, K.call = function(e) {
                        var t = l(arguments);
                        return e.apply(t[0] = this, t), this;
                    }, K.empty = function() {
                        return !this.node();
                    }, K.node = function() {
                        for(var e = 0, t = this.length; e < t; e++)for(var r = this[e], n = 0, a = r.length; n < a; n++){
                            var i = r[n];
                            if (i) return i;
                        }
                        return null;
                    }, K.size = function() {
                        var e = 0;
                        return ve(this, function() {
                            ++e;
                        }), e;
                    };
                    var ye = [];
                    function me(e, t, r) {
                        var n = "__on" + e, a = e.indexOf("."), o = be;
                        a > 0 && (e = e.slice(0, a));
                        var s = xe.get(e);
                        function c() {
                            var t = this[n];
                            t && (this.removeEventListener(e, t, t.$), delete this[n]);
                        }
                        return s && (e = s, o = _e), a ? t ? function() {
                            var a = o(t, l(arguments));
                            c.call(this), this.addEventListener(e, this[n] = a, a.$ = r), a._ = t;
                        } : c : t ? H : function() {
                            var t, r = new RegExp("^__on([^.]+)" + i.requote(e) + "$");
                            for(var n in this)if (t = n.match(r)) {
                                var a = this[n];
                                this.removeEventListener(t[1], a, a.$), delete this[n];
                            }
                        };
                    }
                    i.selection.enter = ge, i.selection.enter.prototype = ye, ye.append = K.append, ye.empty = K.empty, ye.node = K.node, ye.call = K.call, ye.size = K.size, ye.select = function(e) {
                        for(var t, r, n, a, i, o = [], l = -1, s = this.length; ++l < s;){
                            n = (a = this[l]).update, o.push(t = []), t.parentNode = a.parentNode;
                            for(var c = -1, u = a.length; ++c < u;)(i = a[c]) ? (t.push(n[c] = r = e.call(a.parentNode, i.__data__, c, l)), r.__data__ = i.__data__) : t.push(null);
                        }
                        return Z(o);
                    }, ye.insert = function(e, t) {
                        var r, n, a;
                        return arguments.length < 2 && (r = this, t = function(e, t, i) {
                            var o, l = r[i].update, s = l.length;
                            for(i != a && (a = i, n = 0), t >= n && (n = t + 1); !(o = l[n]) && ++n < s;);
                            return o;
                        }), K.insert.call(this, e, t);
                    }, i.select = function(e) {
                        var t;
                        return "string" == typeof e ? (t = [
                            W(e, s)
                        ]).parentNode = s.documentElement : (t = [
                            e
                        ]).parentNode = c(e), Z([
                            t
                        ]);
                    }, i.selectAll = function(e) {
                        var t;
                        return "string" == typeof e ? (t = l(X(e, s))).parentNode = s.documentElement : (t = l(e)).parentNode = null, Z([
                            t
                        ]);
                    }, K.on = function(e, t, r) {
                        var n = arguments.length;
                        if (n < 3) {
                            if ("string" != typeof e) {
                                for(r in n < 2 && (t = !1), e)this.each(me(r, e[r], t));
                                return this;
                            }
                            if (n < 2) return (n = this.node()["__on" + e]) && n._;
                            r = !1;
                        }
                        return this.each(me(e, t, r));
                    };
                    var xe = i.map({
                        mouseenter: "mouseover",
                        mouseleave: "mouseout"
                    });
                    function be(e, t) {
                        return function(r) {
                            var n = i.event;
                            i.event = r, t[0] = this.__data__;
                            try {
                                e.apply(this, t);
                            } finally{
                                i.event = n;
                            }
                        };
                    }
                    function _e(e, t) {
                        var r = be(e, t);
                        return function(e) {
                            var t = this, n = e.relatedTarget;
                            n && (n === t || 8 & n.compareDocumentPosition(t)) || r.call(t, e);
                        };
                    }
                    s && xe.forEach(function(e) {
                        "on" + e in s && xe.remove(e);
                    });
                    var we, Te = 0;
                    function Me(e) {
                        var t = ".dragsuppress-" + ++Te, r = "click" + t, n = i.select(u(e)).on("touchmove" + t, Y).on("dragstart" + t, Y).on("selectstart" + t, Y);
                        if (null == we && (we = !("onselectstart" in e) && F(e.style, "userSelect")), we) {
                            var a = c(e).style, o = a[we];
                            a[we] = "none";
                        }
                        return function(e) {
                            if (n.on(t, null), we && (a[we] = o), e) {
                                var i = function() {
                                    n.on(r, null);
                                };
                                n.on(r, function() {
                                    Y(), i();
                                }, !0), setTimeout(i, 0);
                            }
                        };
                    }
                    i.mouse = function(e) {
                        return Ae(e, V());
                    };
                    var ke = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
                    function Ae(e, t) {
                        t.changedTouches && (t = t.changedTouches[0]);
                        var r = e.ownerSVGElement || e;
                        if (r.createSVGPoint) {
                            var n = r.createSVGPoint();
                            if (ke < 0) {
                                var a = u(e);
                                if (a.scrollX || a.scrollY) {
                                    var o = (r = i.select("body").append("svg").style({
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        margin: 0,
                                        padding: 0,
                                        border: "none"
                                    }, "important"))[0][0].getScreenCTM();
                                    ke = !(o.f || o.e), r.remove();
                                }
                            }
                            return ke ? (n.x = t.pageX, n.y = t.pageY) : (n.x = t.clientX, n.y = t.clientY), [
                                (n = n.matrixTransform(e.getScreenCTM().inverse())).x,
                                n.y
                            ];
                        }
                        var l = e.getBoundingClientRect();
                        return [
                            t.clientX - l.left - e.clientLeft,
                            t.clientY - l.top - e.clientTop
                        ];
                    }
                    function Le() {
                        return i.event.changedTouches[0].identifier;
                    }
                    i.touch = function(e, t, r) {
                        if (arguments.length < 3 && (r = t, t = V().changedTouches), t) {
                            for(var n, a = 0, i = t.length; a < i; ++a)if ((n = t[a]).identifier === r) return Ae(e, n);
                        }
                    }, i.behavior.drag = function() {
                        var e = U(a, "drag", "dragstart", "dragend"), t = null, r = o(H, i.mouse, u, "mousemove", "mouseup"), n = o(Le, i.touch, z, "touchmove", "touchend");
                        function a() {
                            this.on("mousedown.drag", r).on("touchstart.drag", n);
                        }
                        function o(r, n, a, o, l) {
                            return function() {
                                var s, c = this, u = i.event.target.correspondingElement || i.event.target, f = c.parentNode, d = e.of(c, arguments), h = 0, p = r(), v = ".drag" + (null == p ? "" : "-" + p), g = i.select(a(u)).on(o + v, function() {
                                    var e, t, r = n(f, p);
                                    r && (e = r[0] - m[0], t = r[1] - m[1], h |= e | t, m = r, d({
                                        type: "drag",
                                        x: r[0] + s[0],
                                        y: r[1] + s[1],
                                        dx: e,
                                        dy: t
                                    }));
                                }).on(l + v, function() {
                                    n(f, p) && (g.on(o + v, null).on(l + v, null), y(h), d({
                                        type: "dragend"
                                    }));
                                }), y = Me(u), m = n(f, p);
                                s = t ? [
                                    (s = t.apply(c, arguments)).x - m[0],
                                    s.y - m[1]
                                ] : [
                                    0,
                                    0
                                ], d({
                                    type: "dragstart"
                                });
                            };
                        }
                        return a.origin = function(e) {
                            return arguments.length ? (t = e, a) : t;
                        }, i.rebind(a, e, "on");
                    }, i.touches = function(e, t) {
                        return arguments.length < 2 && (t = V().touches), t ? l(t).map(function(t) {
                            var r = Ae(e, t);
                            return r.identifier = t.identifier, r;
                        }) : [];
                    };
                    var Se = 1e-6, De = Se * Se, Oe = Math.PI, Ce = 2 * Oe, Pe = Ce - Se, Ie = Oe / 2, Re = Oe / 180, ze = 180 / Oe;
                    function Ne(e) {
                        return e > 1 ? Ie : e < -1 ? -Ie : Math.asin(e);
                    }
                    function Fe(e) {
                        return ((e = Math.exp(e)) + 1 / e) / 2;
                    }
                    var Ee = Math.SQRT2;
                    i.interpolateZoom = function(e, t) {
                        var r, n, a = e[0], i = e[1], o = e[2], l = t[0], s = t[1], c = t[2], u = l - a, f = s - i, d = u * u + f * f;
                        if (d < De) n = Math.log(c / o) / Ee, r = function(e) {
                            return [
                                a + e * u,
                                i + e * f,
                                o * Math.exp(Ee * e * n)
                            ];
                        };
                        else {
                            var h = Math.sqrt(d), p = (c * c - o * o + 4 * d) / (2 * o * 2 * h), v = (c * c - o * o - 4 * d) / (2 * c * 2 * h), g = Math.log(Math.sqrt(p * p + 1) - p), y = Math.log(Math.sqrt(v * v + 1) - v);
                            n = (y - g) / Ee, r = function(e) {
                                var t, r = e * n, l = Fe(g), s = o / (2 * h) * (l * (t = Ee * r + g, ((t = Math.exp(2 * t)) - 1) / (t + 1)) - function(e) {
                                    return ((e = Math.exp(e)) - 1 / e) / 2;
                                }(g));
                                return [
                                    a + s * u,
                                    i + s * f,
                                    o * l / Fe(Ee * r + g)
                                ];
                            };
                        }
                        return r.duration = 1e3 * n, r;
                    }, i.behavior.zoom = function() {
                        var e, t, r, n, a, o, l, c, f, d = {
                            x: 0,
                            y: 0,
                            k: 1
                        }, h = [
                            960,
                            500
                        ], p = Be, v = 250, g = 0, y = "mousedown.zoom", m = "mousemove.zoom", x = "mouseup.zoom", b = "touchstart.zoom", _ = U(w, "zoomstart", "zoom", "zoomend");
                        function w(e) {
                            e.on(y, C).on(je + ".zoom", I).on("dblclick.zoom", R).on(b, P);
                        }
                        function T(e) {
                            return [
                                (e[0] - d.x) / d.k,
                                (e[1] - d.y) / d.k
                            ];
                        }
                        function M(e) {
                            d.k = Math.max(p[0], Math.min(p[1], e));
                        }
                        function k(e, t) {
                            t = function(e) {
                                return [
                                    e[0] * d.k + d.x,
                                    e[1] * d.k + d.y
                                ];
                            }(t), d.x += e[0] - t[0], d.y += e[1] - t[1];
                        }
                        function A(e, r, n, a) {
                            e.__chart__ = {
                                x: d.x,
                                y: d.y,
                                k: d.k
                            }, M(Math.pow(2, a)), k(t = r, n), e = i.select(e), v > 0 && (e = e.transition().duration(v)), e.call(w.event);
                        }
                        function L() {
                            l && l.domain(o.range().map(function(e) {
                                return (e - d.x) / d.k;
                            }).map(o.invert)), f && f.domain(c.range().map(function(e) {
                                return (e - d.y) / d.k;
                            }).map(c.invert));
                        }
                        function S(e) {
                            g++ || e({
                                type: "zoomstart"
                            });
                        }
                        function D(e) {
                            L(), e({
                                type: "zoom",
                                scale: d.k,
                                translate: [
                                    d.x,
                                    d.y
                                ]
                            });
                        }
                        function O(e) {
                            --g || (e({
                                type: "zoomend"
                            }), t = null);
                        }
                        function C() {
                            var e = this, t = _.of(e, arguments), r = 0, n = i.select(u(e)).on(m, function() {
                                r = 1, k(i.mouse(e), a), D(t);
                            }).on(x, function() {
                                n.on(m, null).on(x, null), o(r), O(t);
                            }), a = T(i.mouse(e)), o = Me(e);
                            Ja.call(e), S(t);
                        }
                        function P() {
                            var e, t = this, r = _.of(t, arguments), n = {}, o = 0, l = ".zoom-" + i.event.changedTouches[0].identifier, s = "touchmove" + l, c = "touchend" + l, u = [], f = i.select(t), h = Me(t);
                            function p() {
                                var r = i.touches(t);
                                return e = d.k, r.forEach(function(e) {
                                    e.identifier in n && (n[e.identifier] = T(e));
                                }), r;
                            }
                            function v() {
                                var e = i.event.target;
                                i.select(e).on(s, g).on(c, m), u.push(e);
                                for(var r = i.event.changedTouches, l = 0, f = r.length; l < f; ++l)n[r[l].identifier] = null;
                                var h = p(), v = Date.now();
                                if (1 === h.length) {
                                    if (v - a < 500) {
                                        var y = h[0];
                                        A(t, y, n[y.identifier], Math.floor(Math.log(d.k) / Math.LN2) + 1), Y();
                                    }
                                    a = v;
                                } else if (h.length > 1) {
                                    y = h[0];
                                    var x = h[1], b = y[0] - x[0], _ = y[1] - x[1];
                                    o = b * b + _ * _;
                                }
                            }
                            function g() {
                                var l, s, c, u, f = i.touches(t);
                                Ja.call(t);
                                for(var d = 0, h = f.length; d < h; ++d, u = null)if (c = f[d], u = n[c.identifier]) {
                                    if (s) break;
                                    l = c, s = u;
                                }
                                if (u) {
                                    var p = (p = c[0] - l[0]) * p + (p = c[1] - l[1]) * p, v = o && Math.sqrt(p / o);
                                    l = [
                                        (l[0] + c[0]) / 2,
                                        (l[1] + c[1]) / 2
                                    ], s = [
                                        (s[0] + u[0]) / 2,
                                        (s[1] + u[1]) / 2
                                    ], M(v * e);
                                }
                                a = null, k(l, s), D(r);
                            }
                            function m() {
                                if (i.event.touches.length) {
                                    for(var e = i.event.changedTouches, t = 0, a = e.length; t < a; ++t)delete n[e[t].identifier];
                                    for(var o in n)return void p();
                                }
                                i.selectAll(u).on(l, null), f.on(y, C).on(b, P), h(), O(r);
                            }
                            v(), S(r), f.on(y, null).on(b, v);
                        }
                        function I() {
                            var a = _.of(this, arguments);
                            n ? clearTimeout(n) : (Ja.call(this), e = T(t = r || i.mouse(this)), S(a)), n = setTimeout(function() {
                                n = null, O(a);
                            }, 50), Y(), M(Math.pow(2, .002 * He()) * d.k), k(t, e), D(a);
                        }
                        function R() {
                            var e = i.mouse(this), t = Math.log(d.k) / Math.LN2;
                            A(this, e, T(e), i.event.shiftKey ? Math.ceil(t) - 1 : Math.floor(t) + 1);
                        }
                        return je || (je = "onwheel" in s ? (He = function() {
                            return -i.event.deltaY * (i.event.deltaMode ? 120 : 1);
                        }, "wheel") : "onmousewheel" in s ? (He = function() {
                            return i.event.wheelDelta;
                        }, "mousewheel") : (He = function() {
                            return -i.event.detail;
                        }, "MozMousePixelScroll")), w.event = function(e) {
                            e.each(function() {
                                var e = _.of(this, arguments), r = d;
                                $a ? i.select(this).transition().each("start.zoom", function() {
                                    d = this.__chart__ || {
                                        x: 0,
                                        y: 0,
                                        k: 1
                                    }, S(e);
                                }).tween("zoom:zoom", function() {
                                    var n = h[0], a = h[1], o = t ? t[0] : n / 2, l = t ? t[1] : a / 2, s = i.interpolateZoom([
                                        (o - d.x) / d.k,
                                        (l - d.y) / d.k,
                                        n / d.k
                                    ], [
                                        (o - r.x) / r.k,
                                        (l - r.y) / r.k,
                                        n / r.k
                                    ]);
                                    return function(t) {
                                        var r = s(t), a = n / r[2];
                                        this.__chart__ = d = {
                                            x: o - r[0] * a,
                                            y: l - r[1] * a,
                                            k: a
                                        }, D(e);
                                    };
                                }).each("interrupt.zoom", function() {
                                    O(e);
                                }).each("end.zoom", function() {
                                    O(e);
                                }) : (this.__chart__ = d, S(e), D(e), O(e));
                            });
                        }, w.translate = function(e) {
                            return arguments.length ? (d = {
                                x: +e[0],
                                y: +e[1],
                                k: d.k
                            }, L(), w) : [
                                d.x,
                                d.y
                            ];
                        }, w.scale = function(e) {
                            return arguments.length ? (d = {
                                x: d.x,
                                y: d.y,
                                k: null
                            }, M(+e), L(), w) : d.k;
                        }, w.scaleExtent = function(e) {
                            return arguments.length ? (p = null == e ? Be : [
                                +e[0],
                                +e[1]
                            ], w) : p;
                        }, w.center = function(e) {
                            return arguments.length ? (r = e && [
                                +e[0],
                                +e[1]
                            ], w) : r;
                        }, w.size = function(e) {
                            return arguments.length ? (h = e && [
                                +e[0],
                                +e[1]
                            ], w) : h;
                        }, w.duration = function(e) {
                            return arguments.length ? (v = +e, w) : v;
                        }, w.x = function(e) {
                            return arguments.length ? (l = e, o = e.copy(), d = {
                                x: 0,
                                y: 0,
                                k: 1
                            }, w) : l;
                        }, w.y = function(e) {
                            return arguments.length ? (f = e, c = e.copy(), d = {
                                x: 0,
                                y: 0,
                                k: 1
                            }, w) : f;
                        }, i.rebind(w, _, "on");
                    };
                    var He, je, Be = [
                        0,
                        1 / 0
                    ];
                    function Ye() {}
                    function Ve(e, t, r) {
                        return this instanceof Ve ? (this.h = +e, this.s = +t, void (this.l = +r)) : arguments.length < 2 ? e instanceof Ve ? new Ve(e.h, e.s, e.l) : ut("" + e, ft, Ve) : new Ve(e, t, r);
                    }
                    i.color = Ye, Ye.prototype.toString = function() {
                        return this.rgb() + "";
                    }, i.hsl = Ve;
                    var Ue = Ve.prototype = new Ye;
                    function qe(e, t, r) {
                        var n, a;
                        function i(e) {
                            return Math.round(255 * function(e) {
                                return e > 360 ? e -= 360 : e < 0 && (e += 360), e < 60 ? n + (a - n) * e / 60 : e < 180 ? a : e < 240 ? n + (a - n) * (240 - e) / 60 : n;
                            }(e));
                        }
                        return e = isNaN(e) ? 0 : (e %= 360) < 0 ? e + 360 : e, t = isNaN(t) || t < 0 ? 0 : t > 1 ? 1 : t, n = 2 * (r = r < 0 ? 0 : r > 1 ? 1 : r) - (a = r <= .5 ? r * (1 + t) : r + t - r * t), new it(i(e + 120), i(e), i(e - 120));
                    }
                    function Ge(e, t, r) {
                        return this instanceof Ge ? (this.h = +e, this.c = +t, void (this.l = +r)) : arguments.length < 2 ? e instanceof Ge ? new Ge(e.h, e.c, e.l) : function(e, t, r) {
                            return e > 0 ? new Ge(Math.atan2(r, t) * ze, Math.sqrt(t * t + r * r), e) : new Ge(NaN, NaN, e);
                        }(e instanceof Xe ? e.l : (e = dt((e = i.rgb(e)).r, e.g, e.b)).l, e.a, e.b) : new Ge(e, t, r);
                    }
                    Ue.brighter = function(e) {
                        return e = Math.pow(.7, arguments.length ? e : 1), new Ve(this.h, this.s, this.l / e);
                    }, Ue.darker = function(e) {
                        return e = Math.pow(.7, arguments.length ? e : 1), new Ve(this.h, this.s, e * this.l);
                    }, Ue.rgb = function() {
                        return qe(this.h, this.s, this.l);
                    }, i.hcl = Ge;
                    var Ze = Ge.prototype = new Ye;
                    function We(e, t, r) {
                        return isNaN(e) && (e = 0), isNaN(t) && (t = 0), new Xe(r, Math.cos(e *= Re) * t, Math.sin(e) * t);
                    }
                    function Xe(e, t, r) {
                        return this instanceof Xe ? (this.l = +e, this.a = +t, void (this.b = +r)) : arguments.length < 2 ? e instanceof Xe ? new Xe(e.l, e.a, e.b) : e instanceof Ge ? We(e.h, e.c, e.l) : dt((e = it(e)).r, e.g, e.b) : new Xe(e, t, r);
                    }
                    Ze.brighter = function(e) {
                        return new Ge(this.h, this.c, Math.min(100, this.l + Je * (arguments.length ? e : 1)));
                    }, Ze.darker = function(e) {
                        return new Ge(this.h, this.c, Math.max(0, this.l - Je * (arguments.length ? e : 1)));
                    }, Ze.rgb = function() {
                        return We(this.h, this.c, this.l).rgb();
                    }, i.lab = Xe;
                    var Je = 18, Ke = .95047, Qe = 1, $e = 1.08883, et = Xe.prototype = new Ye;
                    function tt(e, t, r) {
                        var n = (e + 16) / 116, a = n + t / 500, i = n - r / 200;
                        return new it(at(3.2404542 * (a = rt(a) * Ke) - 1.5371385 * (n = rt(n) * Qe) - .4985314 * (i = rt(i) * $e)), at(-0.969266 * a + 1.8760108 * n + .041556 * i), at(.0556434 * a - .2040259 * n + 1.0572252 * i));
                    }
                    function rt(e) {
                        return e > .206893034 ? e * e * e : (e - 4 / 29) / 7.787037;
                    }
                    function nt(e) {
                        return e > .008856 ? Math.pow(e, 1 / 3) : 7.787037 * e + 4 / 29;
                    }
                    function at(e) {
                        return Math.round(255 * (e <= .00304 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055));
                    }
                    function it(e, t, r) {
                        return this instanceof it ? (this.r = ~~e, this.g = ~~t, void (this.b = ~~r)) : arguments.length < 2 ? e instanceof it ? new it(e.r, e.g, e.b) : ut("" + e, it, qe) : new it(e, t, r);
                    }
                    function ot(e) {
                        return new it(e >> 16, e >> 8 & 255, 255 & e);
                    }
                    function lt(e) {
                        return ot(e) + "";
                    }
                    et.brighter = function(e) {
                        return new Xe(Math.min(100, this.l + Je * (arguments.length ? e : 1)), this.a, this.b);
                    }, et.darker = function(e) {
                        return new Xe(Math.max(0, this.l - Je * (arguments.length ? e : 1)), this.a, this.b);
                    }, et.rgb = function() {
                        return tt(this.l, this.a, this.b);
                    }, i.rgb = it;
                    var st = it.prototype = new Ye;
                    function ct(e) {
                        return e < 16 ? "0" + Math.max(0, e).toString(16) : Math.min(255, e).toString(16);
                    }
                    function ut(e, t, r) {
                        var n, a, i, o = 0, l = 0, s = 0;
                        if (n = /([a-z]+)\((.*)\)/.exec(e = e.toLowerCase())) switch(a = n[2].split(","), n[1]){
                            case "hsl":
                                return r(parseFloat(a[0]), parseFloat(a[1]) / 100, parseFloat(a[2]) / 100);
                            case "rgb":
                                return t(pt(a[0]), pt(a[1]), pt(a[2]));
                        }
                        return (i = vt.get(e)) ? t(i.r, i.g, i.b) : (null == e || "#" !== e.charAt(0) || isNaN(i = parseInt(e.slice(1), 16)) || (4 === e.length ? (o = (3840 & i) >> 4, o |= o >> 4, l = 240 & i, l |= l >> 4, s = 15 & i, s |= s << 4) : 7 === e.length && (o = (16711680 & i) >> 16, l = (65280 & i) >> 8, s = 255 & i)), t(o, l, s));
                    }
                    function ft(e, t, r) {
                        var n, a, i = Math.min(e /= 255, t /= 255, r /= 255), o = Math.max(e, t, r), l = o - i, s = (o + i) / 2;
                        return l ? (a = s < .5 ? l / (o + i) : l / (2 - o - i), n = e == o ? (t - r) / l + (t < r ? 6 : 0) : t == o ? (r - e) / l + 2 : (e - t) / l + 4, n *= 60) : (n = NaN, a = s > 0 && s < 1 ? 0 : n), new Ve(n, a, s);
                    }
                    function dt(e, t, r) {
                        var n = nt((.4124564 * (e = ht(e)) + .3575761 * (t = ht(t)) + .1804375 * (r = ht(r))) / Ke), a = nt((.2126729 * e + .7151522 * t + .072175 * r) / Qe);
                        return Xe(116 * a - 16, 500 * (n - a), 200 * (a - nt((.0193339 * e + .119192 * t + .9503041 * r) / $e)));
                    }
                    function ht(e) {
                        return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
                    }
                    function pt(e) {
                        var t = parseFloat(e);
                        return "%" === e.charAt(e.length - 1) ? Math.round(2.55 * t) : t;
                    }
                    st.brighter = function(e) {
                        e = Math.pow(.7, arguments.length ? e : 1);
                        var t = this.r, r = this.g, n = this.b, a = 30;
                        return t || r || n ? (t && t < a && (t = a), r && r < a && (r = a), n && n < a && (n = a), new it(Math.min(255, t / e), Math.min(255, r / e), Math.min(255, n / e))) : new it(a, a, a);
                    }, st.darker = function(e) {
                        return new it((e = Math.pow(.7, arguments.length ? e : 1)) * this.r, e * this.g, e * this.b);
                    }, st.hsl = function() {
                        return ft(this.r, this.g, this.b);
                    }, st.toString = function() {
                        return "#" + ct(this.r) + ct(this.g) + ct(this.b);
                    };
                    var vt = i.map({
                        aliceblue: 15792383,
                        antiquewhite: 16444375,
                        aqua: 65535,
                        aquamarine: 8388564,
                        azure: 15794175,
                        beige: 16119260,
                        bisque: 16770244,
                        black: 0,
                        blanchedalmond: 16772045,
                        blue: 255,
                        blueviolet: 9055202,
                        brown: 10824234,
                        burlywood: 14596231,
                        cadetblue: 6266528,
                        chartreuse: 8388352,
                        chocolate: 13789470,
                        coral: 16744272,
                        cornflowerblue: 6591981,
                        cornsilk: 16775388,
                        crimson: 14423100,
                        cyan: 65535,
                        darkblue: 139,
                        darkcyan: 35723,
                        darkgoldenrod: 12092939,
                        darkgray: 11119017,
                        darkgreen: 25600,
                        darkgrey: 11119017,
                        darkkhaki: 12433259,
                        darkmagenta: 9109643,
                        darkolivegreen: 5597999,
                        darkorange: 16747520,
                        darkorchid: 10040012,
                        darkred: 9109504,
                        darksalmon: 15308410,
                        darkseagreen: 9419919,
                        darkslateblue: 4734347,
                        darkslategray: 3100495,
                        darkslategrey: 3100495,
                        darkturquoise: 52945,
                        darkviolet: 9699539,
                        deeppink: 16716947,
                        deepskyblue: 49151,
                        dimgray: 6908265,
                        dimgrey: 6908265,
                        dodgerblue: 2003199,
                        firebrick: 11674146,
                        floralwhite: 16775920,
                        forestgreen: 2263842,
                        fuchsia: 16711935,
                        gainsboro: 14474460,
                        ghostwhite: 16316671,
                        gold: 16766720,
                        goldenrod: 14329120,
                        gray: 8421504,
                        green: 32768,
                        greenyellow: 11403055,
                        grey: 8421504,
                        honeydew: 15794160,
                        hotpink: 16738740,
                        indianred: 13458524,
                        indigo: 4915330,
                        ivory: 16777200,
                        khaki: 15787660,
                        lavender: 15132410,
                        lavenderblush: 16773365,
                        lawngreen: 8190976,
                        lemonchiffon: 16775885,
                        lightblue: 11393254,
                        lightcoral: 15761536,
                        lightcyan: 14745599,
                        lightgoldenrodyellow: 16448210,
                        lightgray: 13882323,
                        lightgreen: 9498256,
                        lightgrey: 13882323,
                        lightpink: 16758465,
                        lightsalmon: 16752762,
                        lightseagreen: 2142890,
                        lightskyblue: 8900346,
                        lightslategray: 7833753,
                        lightslategrey: 7833753,
                        lightsteelblue: 11584734,
                        lightyellow: 16777184,
                        lime: 65280,
                        limegreen: 3329330,
                        linen: 16445670,
                        magenta: 16711935,
                        maroon: 8388608,
                        mediumaquamarine: 6737322,
                        mediumblue: 205,
                        mediumorchid: 12211667,
                        mediumpurple: 9662683,
                        mediumseagreen: 3978097,
                        mediumslateblue: 8087790,
                        mediumspringgreen: 64154,
                        mediumturquoise: 4772300,
                        mediumvioletred: 13047173,
                        midnightblue: 1644912,
                        mintcream: 16121850,
                        mistyrose: 16770273,
                        moccasin: 16770229,
                        navajowhite: 16768685,
                        navy: 128,
                        oldlace: 16643558,
                        olive: 8421376,
                        olivedrab: 7048739,
                        orange: 16753920,
                        orangered: 16729344,
                        orchid: 14315734,
                        palegoldenrod: 15657130,
                        palegreen: 10025880,
                        paleturquoise: 11529966,
                        palevioletred: 14381203,
                        papayawhip: 16773077,
                        peachpuff: 16767673,
                        peru: 13468991,
                        pink: 16761035,
                        plum: 14524637,
                        powderblue: 11591910,
                        purple: 8388736,
                        rebeccapurple: 6697881,
                        red: 16711680,
                        rosybrown: 12357519,
                        royalblue: 4286945,
                        saddlebrown: 9127187,
                        salmon: 16416882,
                        sandybrown: 16032864,
                        seagreen: 3050327,
                        seashell: 16774638,
                        sienna: 10506797,
                        silver: 12632256,
                        skyblue: 8900331,
                        slateblue: 6970061,
                        slategray: 7372944,
                        slategrey: 7372944,
                        snow: 16775930,
                        springgreen: 65407,
                        steelblue: 4620980,
                        tan: 13808780,
                        teal: 32896,
                        thistle: 14204888,
                        tomato: 16737095,
                        turquoise: 4251856,
                        violet: 15631086,
                        wheat: 16113331,
                        white: 16777215,
                        whitesmoke: 16119285,
                        yellow: 16776960,
                        yellowgreen: 10145074
                    });
                    function gt(e) {
                        return "function" == typeof e ? e : function() {
                            return e;
                        };
                    }
                    function yt(e) {
                        return function(t, r, n) {
                            return 2 === arguments.length && "function" == typeof r && (n = r, r = null), mt(t, r, e, n);
                        };
                    }
                    function mt(e, t, r, n) {
                        var a = {}, o = i.dispatch("beforesend", "progress", "load", "error"), s = {}, c = new XMLHttpRequest, u = null;
                        function f() {
                            var e, t = c.status;
                            if (!t && function(e) {
                                var t = e.responseType;
                                return t && "text" !== t ? e.response : e.responseText;
                            }(c) || t >= 200 && t < 300 || 304 === t) {
                                try {
                                    e = r.call(a, c);
                                } catch (e) {
                                    return void o.error.call(a, e);
                                }
                                o.load.call(a, e);
                            } else o.error.call(a, c);
                        }
                        return self.XDomainRequest && !("withCredentials" in c) && /^(http(s)?:)?\/\//.test(e) && (c = new XDomainRequest), "onload" in c ? c.onload = c.onerror = f : c.onreadystatechange = function() {
                            c.readyState > 3 && f();
                        }, c.onprogress = function(e) {
                            var t = i.event;
                            i.event = e;
                            try {
                                o.progress.call(a, c);
                            } finally{
                                i.event = t;
                            }
                        }, a.header = function(e, t) {
                            return e = (e + "").toLowerCase(), arguments.length < 2 ? s[e] : (null == t ? delete s[e] : s[e] = t + "", a);
                        }, a.mimeType = function(e) {
                            return arguments.length ? (t = null == e ? null : e + "", a) : t;
                        }, a.responseType = function(e) {
                            return arguments.length ? (u = e, a) : u;
                        }, a.response = function(e) {
                            return r = e, a;
                        }, [
                            "get",
                            "post"
                        ].forEach(function(e) {
                            a[e] = function() {
                                return a.send.apply(a, [
                                    e
                                ].concat(l(arguments)));
                            };
                        }), a.send = function(r, n, i) {
                            if (2 === arguments.length && "function" == typeof n && (i = n, n = null), c.open(r, e, !0), null == t || "accept" in s || (s.accept = t + ",*/*"), c.setRequestHeader) for(var l in s)c.setRequestHeader(l, s[l]);
                            return null != t && c.overrideMimeType && c.overrideMimeType(t), null != u && (c.responseType = u), null != i && a.on("error", i).on("load", function(e) {
                                i(null, e);
                            }), o.beforesend.call(a, c), c.send(null == n ? null : n), a;
                        }, a.abort = function() {
                            return c.abort(), a;
                        }, i.rebind(a, o, "on"), null == n ? a : a.get(function(e) {
                            return 1 === e.length ? function(t, r) {
                                e(null == t ? r : null);
                            } : e;
                        }(n));
                    }
                    vt.forEach(function(e, t) {
                        vt.set(e, ot(t));
                    }), i.functor = gt, i.xhr = yt(z), i.dsv = function(e, t) {
                        var r = new RegExp('["' + e + "\n]"), n = e.charCodeAt(0);
                        function a(e, r, n) {
                            arguments.length < 3 && (n = r, r = null);
                            var a = mt(e, t, null == r ? i : o(r), n);
                            return a.row = function(e) {
                                return arguments.length ? a.response(null == (r = e) ? i : o(e)) : r;
                            }, a;
                        }
                        function i(e) {
                            return a.parse(e.responseText);
                        }
                        function o(e) {
                            return function(t) {
                                return a.parse(t.responseText, e);
                            };
                        }
                        function l(t) {
                            return t.map(s).join(e);
                        }
                        function s(e) {
                            return r.test(e) ? '"' + e.replace(/\"/g, '""') + '"' : e;
                        }
                        return a.parse = function(e, t) {
                            var r;
                            return a.parseRows(e, function(e, n) {
                                if (r) return r(e, n - 1);
                                var a = function(t) {
                                    for(var r = {}, n = e.length, a = 0; a < n; ++a)r[e[a]] = t[a];
                                    return r;
                                };
                                r = t ? function(e, r) {
                                    return t(a(e), r);
                                } : a;
                            });
                        }, a.parseRows = function(e, t) {
                            var r, a, i = {}, o = {}, l = [], s = e.length, c = 0, u = 0;
                            function f() {
                                if (c >= s) return o;
                                if (a) return a = !1, i;
                                var t = c;
                                if (34 === e.charCodeAt(t)) {
                                    for(var r = t; r++ < s;)if (34 === e.charCodeAt(r)) {
                                        if (34 !== e.charCodeAt(r + 1)) break;
                                        ++r;
                                    }
                                    return c = r + 2, 13 === (l = e.charCodeAt(r + 1)) ? (a = !0, 10 === e.charCodeAt(r + 2) && ++c) : 10 === l && (a = !0), e.slice(t + 1, r).replace(/""/g, '"');
                                }
                                for(; c < s;){
                                    var l, u = 1;
                                    if (10 === (l = e.charCodeAt(c++))) a = !0;
                                    else if (13 === l) a = !0, 10 === e.charCodeAt(c) && (++c, ++u);
                                    else if (l !== n) continue;
                                    return e.slice(t, c - u);
                                }
                                return e.slice(t);
                            }
                            for(; (r = f()) !== o;){
                                for(var d = []; r !== i && r !== o;)d.push(r), r = f();
                                t && null == (d = t(d, u++)) || l.push(d);
                            }
                            return l;
                        }, a.format = function(t) {
                            if (Array.isArray(t[0])) return a.formatRows(t);
                            var r = new R, n = [];
                            return t.forEach(function(e) {
                                for(var t in e)r.has(t) || n.push(r.add(t));
                            }), [
                                n.map(s).join(e)
                            ].concat(t.map(function(t) {
                                return n.map(function(e) {
                                    return s(t[e]);
                                }).join(e);
                            })).join("\n");
                        }, a.formatRows = function(e) {
                            return e.map(l).join("\n");
                        }, a;
                    }, i.csv = i.dsv(",", "text/csv"), i.tsv = i.dsv("	", "text/tab-separated-values");
                    var xt, bt, _t, wt, Tt = this[F(this, "requestAnimationFrame")] || function(e) {
                        setTimeout(e, 17);
                    };
                    function Mt(e, t, r) {
                        var n = arguments.length;
                        n < 2 && (t = 0), n < 3 && (r = Date.now());
                        var a = {
                            c: e,
                            t: r + t,
                            n: null
                        };
                        return bt ? bt.n = a : xt = a, bt = a, _t || (wt = clearTimeout(wt), _t = 1, Tt(kt)), a;
                    }
                    function kt() {
                        var e = At(), t = Lt() - e;
                        t > 24 ? (isFinite(t) && (clearTimeout(wt), wt = setTimeout(kt, t)), _t = 0) : (_t = 1, Tt(kt));
                    }
                    function At() {
                        for(var e = Date.now(), t = xt; t;)e >= t.t && t.c(e - t.t) && (t.c = null), t = t.n;
                        return e;
                    }
                    function Lt() {
                        for(var e, t = xt, r = 1 / 0; t;)t.c ? (t.t < r && (r = t.t), t = (e = t).n) : t = e ? e.n = t.n : xt = t.n;
                        return bt = e, r;
                    }
                    function St(e) {
                        return e[0];
                    }
                    function Dt(e) {
                        return e[1];
                    }
                    function Ot(e) {
                        for(var t, r, n, a = e.length, i = [
                            0,
                            1
                        ], o = 2, l = 2; l < a; l++){
                            for(; o > 1 && (t = e[i[o - 2]], r = e[i[o - 1]], n = e[l], (r[0] - t[0]) * (n[1] - t[1]) - (r[1] - t[1]) * (n[0] - t[0]) <= 0);)--o;
                            i[o++] = l;
                        }
                        return i.slice(0, o);
                    }
                    function Ct(e, t) {
                        return e[0] - t[0] || e[1] - t[1];
                    }
                    i.timer = function() {
                        Mt.apply(this, arguments);
                    }, i.timer.flush = function() {
                        At(), Lt();
                    }, i.round = function(e, t) {
                        return t ? Math.round(e * (t = Math.pow(10, t))) / t : Math.round(e);
                    }, i.geom = {}, i.geom.hull = function(e) {
                        var t = St, r = Dt;
                        if (arguments.length) return n(e);
                        function n(e) {
                            if (e.length < 3) return [];
                            var n, a = gt(t), i = gt(r), o = e.length, l = [], s = [];
                            for(n = 0; n < o; n++)l.push([
                                +a.call(this, e[n], n),
                                +i.call(this, e[n], n),
                                n
                            ]);
                            for(l.sort(Ct), n = 0; n < o; n++)s.push([
                                l[n][0],
                                -l[n][1]
                            ]);
                            var c = Ot(l), u = Ot(s), f = u[0] === c[0], d = u[u.length - 1] === c[c.length - 1], h = [];
                            for(n = c.length - 1; n >= 0; --n)h.push(e[l[c[n]][2]]);
                            for(n = +f; n < u.length - d; ++n)h.push(e[l[u[n]][2]]);
                            return h;
                        }
                        return n.x = function(e) {
                            return arguments.length ? (t = e, n) : t;
                        }, n.y = function(e) {
                            return arguments.length ? (r = e, n) : r;
                        }, n;
                    }, i.geom.polygon = function(e) {
                        return G(e, Pt), e;
                    };
                    var Pt = i.geom.polygon.prototype = [];
                    function It(e, t, r) {
                        return (r[0] - t[0]) * (e[1] - t[1]) < (r[1] - t[1]) * (e[0] - t[0]);
                    }
                    function Rt(e, t, r, n) {
                        var a = e[0], i = r[0], o = t[0] - a, l = n[0] - i, s = e[1], c = r[1], u = t[1] - s, f = n[1] - c, d = (l * (s - c) - f * (a - i)) / (f * o - l * u);
                        return [
                            a + d * o,
                            s + d * u
                        ];
                    }
                    function zt(e) {
                        var t = e[0], r = e[e.length - 1];
                        return !(t[0] - r[0] || t[1] - r[1]);
                    }
                    Pt.area = function() {
                        for(var e, t = -1, r = this.length, n = this[r - 1], a = 0; ++t < r;)e = n, n = this[t], a += e[1] * n[0] - e[0] * n[1];
                        return .5 * a;
                    }, Pt.centroid = function(e) {
                        var t, r, n = -1, a = this.length, i = 0, o = 0, l = this[a - 1];
                        for(arguments.length || (e = -1 / (6 * this.area())); ++n < a;)t = l, l = this[n], r = t[0] * l[1] - l[0] * t[1], i += (t[0] + l[0]) * r, o += (t[1] + l[1]) * r;
                        return [
                            i * e,
                            o * e
                        ];
                    }, Pt.clip = function(e) {
                        for(var t, r, n, a, i, o, l = zt(e), s = -1, c = this.length - zt(this), u = this[c - 1]; ++s < c;){
                            for(t = e.slice(), e.length = 0, a = this[s], i = t[(n = t.length - l) - 1], r = -1; ++r < n;)It(o = t[r], u, a) ? (It(i, u, a) || e.push(Rt(i, o, u, a)), e.push(o)) : It(i, u, a) && e.push(Rt(i, o, u, a)), i = o;
                            l && e.push(e[0]), u = a;
                        }
                        return e;
                    };
                    var Nt, Ft, Et, Ht, jt, Bt = [], Yt = [];
                    function Vt() {
                        lr(this), this.edge = this.site = this.circle = null;
                    }
                    function Ut(e) {
                        var t = Bt.pop() || new Vt;
                        return t.site = e, t;
                    }
                    function qt(e) {
                        er(e), Et.remove(e), Bt.push(e), lr(e);
                    }
                    function Gt(e) {
                        var t = e.circle, r = t.x, n = t.cy, a = {
                            x: r,
                            y: n
                        }, i = e.P, o = e.N, l = [
                            e
                        ];
                        qt(e);
                        for(var s = i; s.circle && w(r - s.circle.x) < Se && w(n - s.circle.cy) < Se;)i = s.P, l.unshift(s), qt(s), s = i;
                        l.unshift(s), er(s);
                        for(var c = o; c.circle && w(r - c.circle.x) < Se && w(n - c.circle.cy) < Se;)o = c.N, l.push(c), qt(c), c = o;
                        l.push(c), er(c);
                        var u, f = l.length;
                        for(u = 1; u < f; ++u)c = l[u], s = l[u - 1], ar(c.edge, s.site, c.site, a);
                        s = l[0], (c = l[f - 1]).edge = nr(s.site, c.site, null, a), $t(s), $t(c);
                    }
                    function Zt(e) {
                        for(var t, r, n, a, i = e.x, o = e.y, l = Et._; l;)if ((n = Wt(l, o) - i) > Se) l = l.L;
                        else {
                            if (!((a = i - Xt(l, o)) > Se)) {
                                n > -Se ? (t = l.P, r = l) : a > -Se ? (t = l, r = l.N) : t = r = l;
                                break;
                            }
                            if (!l.R) {
                                t = l;
                                break;
                            }
                            l = l.R;
                        }
                        var s = Ut(e);
                        if (Et.insert(t, s), t || r) {
                            if (t === r) return er(t), r = Ut(t.site), Et.insert(s, r), s.edge = r.edge = nr(t.site, s.site), $t(t), void $t(r);
                            if (r) {
                                er(t), er(r);
                                var c = t.site, u = c.x, f = c.y, d = e.x - u, h = e.y - f, p = r.site, v = p.x - u, g = p.y - f, y = 2 * (d * g - h * v), m = d * d + h * h, x = v * v + g * g, b = {
                                    x: (g * m - h * x) / y + u,
                                    y: (d * x - v * m) / y + f
                                };
                                ar(r.edge, c, p, b), s.edge = nr(c, e, null, b), r.edge = nr(e, p, null, b), $t(t), $t(r);
                            } else s.edge = nr(t.site, s.site);
                        }
                    }
                    function Wt(e, t) {
                        var r = e.site, n = r.x, a = r.y, i = a - t;
                        if (!i) return n;
                        var o = e.P;
                        if (!o) return -1 / 0;
                        var l = (r = o.site).x, s = r.y, c = s - t;
                        if (!c) return l;
                        var u = l - n, f = 1 / i - 1 / c, d = u / c;
                        return f ? (-d + Math.sqrt(d * d - 2 * f * (u * u / (-2 * c) - s + c / 2 + a - i / 2))) / f + n : (n + l) / 2;
                    }
                    function Xt(e, t) {
                        var r = e.N;
                        if (r) return Wt(r, t);
                        var n = e.site;
                        return n.y === t ? n.x : 1 / 0;
                    }
                    function Jt(e) {
                        this.site = e, this.edges = [];
                    }
                    function Kt(e, t) {
                        return t.angle - e.angle;
                    }
                    function Qt() {
                        lr(this), this.x = this.y = this.arc = this.site = this.cy = null;
                    }
                    function $t(e) {
                        var t = e.P, r = e.N;
                        if (t && r) {
                            var n = t.site, a = e.site, i = r.site;
                            if (n !== i) {
                                var o = a.x, l = a.y, s = n.x - o, c = n.y - l, u = i.x - o, f = 2 * (s * (g = i.y - l) - c * u);
                                if (!(f >= -De)) {
                                    var d = s * s + c * c, h = u * u + g * g, p = (g * d - c * h) / f, v = (s * h - u * d) / f, g = v + l, y = Yt.pop() || new Qt;
                                    y.arc = e, y.site = a, y.x = p + o, y.y = g + Math.sqrt(p * p + v * v), y.cy = g, e.circle = y;
                                    for(var m = null, x = jt._; x;)if (y.y < x.y || y.y === x.y && y.x <= x.x) {
                                        if (!x.L) {
                                            m = x.P;
                                            break;
                                        }
                                        x = x.L;
                                    } else {
                                        if (!x.R) {
                                            m = x;
                                            break;
                                        }
                                        x = x.R;
                                    }
                                    jt.insert(m, y), m || (Ht = y);
                                }
                            }
                        }
                    }
                    function er(e) {
                        var t = e.circle;
                        t && (t.P || (Ht = t.N), jt.remove(t), Yt.push(t), lr(t), e.circle = null);
                    }
                    function tr(e, t) {
                        var r = e.b;
                        if (r) return !0;
                        var n, a, i = e.a, o = t[0][0], l = t[1][0], s = t[0][1], c = t[1][1], u = e.l, f = e.r, d = u.x, h = u.y, p = f.x, v = f.y, g = (d + p) / 2, y = (h + v) / 2;
                        if (v === h) {
                            if (g < o || g >= l) return;
                            if (d > p) {
                                if (i) {
                                    if (i.y >= c) return;
                                } else i = {
                                    x: g,
                                    y: s
                                };
                                r = {
                                    x: g,
                                    y: c
                                };
                            } else {
                                if (i) {
                                    if (i.y < s) return;
                                } else i = {
                                    x: g,
                                    y: c
                                };
                                r = {
                                    x: g,
                                    y: s
                                };
                            }
                        } else if (a = y - (n = (d - p) / (v - h)) * g, n < -1 || n > 1) {
                            if (d > p) {
                                if (i) {
                                    if (i.y >= c) return;
                                } else i = {
                                    x: (s - a) / n,
                                    y: s
                                };
                                r = {
                                    x: (c - a) / n,
                                    y: c
                                };
                            } else {
                                if (i) {
                                    if (i.y < s) return;
                                } else i = {
                                    x: (c - a) / n,
                                    y: c
                                };
                                r = {
                                    x: (s - a) / n,
                                    y: s
                                };
                            }
                        } else if (h < v) {
                            if (i) {
                                if (i.x >= l) return;
                            } else i = {
                                x: o,
                                y: n * o + a
                            };
                            r = {
                                x: l,
                                y: n * l + a
                            };
                        } else {
                            if (i) {
                                if (i.x < o) return;
                            } else i = {
                                x: l,
                                y: n * l + a
                            };
                            r = {
                                x: o,
                                y: n * o + a
                            };
                        }
                        return e.a = i, e.b = r, !0;
                    }
                    function rr(e, t) {
                        this.l = e, this.r = t, this.a = this.b = null;
                    }
                    function nr(e, t, r, n) {
                        var a = new rr(e, t);
                        return Nt.push(a), r && ar(a, e, t, r), n && ar(a, t, e, n), Ft[e.i].edges.push(new ir(a, e, t)), Ft[t.i].edges.push(new ir(a, t, e)), a;
                    }
                    function ar(e, t, r, n) {
                        e.a || e.b ? e.l === r ? e.b = n : e.a = n : (e.a = n, e.l = t, e.r = r);
                    }
                    function ir(e, t, r) {
                        var n = e.a, a = e.b;
                        this.edge = e, this.site = t, this.angle = r ? Math.atan2(r.y - t.y, r.x - t.x) : e.l === t ? Math.atan2(a.x - n.x, n.y - a.y) : Math.atan2(n.x - a.x, a.y - n.y);
                    }
                    function or() {
                        this._ = null;
                    }
                    function lr(e) {
                        e.U = e.C = e.L = e.R = e.P = e.N = null;
                    }
                    function sr(e, t) {
                        var r = t, n = t.R, a = r.U;
                        a ? a.L === r ? a.L = n : a.R = n : e._ = n, n.U = a, r.U = n, r.R = n.L, r.R && (r.R.U = r), n.L = r;
                    }
                    function cr(e, t) {
                        var r = t, n = t.L, a = r.U;
                        a ? a.L === r ? a.L = n : a.R = n : e._ = n, n.U = a, r.U = n, r.L = n.R, r.L && (r.L.U = r), n.R = r;
                    }
                    function ur(e) {
                        for(; e.L;)e = e.L;
                        return e;
                    }
                    function fr(e, t) {
                        var r, n, a, i = e.sort(dr).pop();
                        for(Nt = [], Ft = new Array(e.length), Et = new or, jt = new or;;)if (a = Ht, i && (!a || i.y < a.y || i.y === a.y && i.x < a.x)) i.x === r && i.y === n || (Ft[i.i] = new Jt(i), Zt(i), r = i.x, n = i.y), i = e.pop();
                        else {
                            if (!a) break;
                            Gt(a.arc);
                        }
                        t && (function(e) {
                            for(var t, r, n, a, i, o = Nt, l = (r = e[0][0], n = e[0][1], a = e[1][0], i = e[1][1], function(e) {
                                var t, o = e.a, l = e.b, s = o.x, c = o.y, u = 0, f = 1, d = l.x - s, h = l.y - c;
                                if (t = r - s, d || !(t > 0)) {
                                    if (t /= d, d < 0) {
                                        if (t < u) return;
                                        t < f && (f = t);
                                    } else if (d > 0) {
                                        if (t > f) return;
                                        t > u && (u = t);
                                    }
                                    if (t = a - s, d || !(t < 0)) {
                                        if (t /= d, d < 0) {
                                            if (t > f) return;
                                            t > u && (u = t);
                                        } else if (d > 0) {
                                            if (t < u) return;
                                            t < f && (f = t);
                                        }
                                        if (t = n - c, h || !(t > 0)) {
                                            if (t /= h, h < 0) {
                                                if (t < u) return;
                                                t < f && (f = t);
                                            } else if (h > 0) {
                                                if (t > f) return;
                                                t > u && (u = t);
                                            }
                                            if (t = i - c, h || !(t < 0)) {
                                                if (t /= h, h < 0) {
                                                    if (t > f) return;
                                                    t > u && (u = t);
                                                } else if (h > 0) {
                                                    if (t < u) return;
                                                    t < f && (f = t);
                                                }
                                                return u > 0 && (e.a = {
                                                    x: s + u * d,
                                                    y: c + u * h
                                                }), f < 1 && (e.b = {
                                                    x: s + f * d,
                                                    y: c + f * h
                                                }), e;
                                            }
                                        }
                                    }
                                }
                            }), s = o.length; s--;)(!tr(t = o[s], e) || !l(t) || w(t.a.x - t.b.x) < Se && w(t.a.y - t.b.y) < Se) && (t.a = t.b = null, o.splice(s, 1));
                        }(t), function(e) {
                            for(var t, r, n, a, i, o, l, s, c, u, f = e[0][0], d = e[1][0], h = e[0][1], p = e[1][1], v = Ft, g = v.length; g--;)if ((i = v[g]) && i.prepare()) for(s = (l = i.edges).length, o = 0; o < s;)n = (u = l[o].end()).x, a = u.y, t = (c = l[++o % s].start()).x, r = c.y, (w(n - t) > Se || w(a - r) > Se) && (l.splice(o, 0, new ir((y = i.site, m = u, x = w(n - f) < Se && p - a > Se ? {
                                x: f,
                                y: w(t - f) < Se ? r : p
                            } : w(a - p) < Se && d - n > Se ? {
                                x: w(r - p) < Se ? t : d,
                                y: p
                            } : w(n - d) < Se && a - h > Se ? {
                                x: d,
                                y: w(t - d) < Se ? r : h
                            } : w(a - h) < Se && n - f > Se ? {
                                x: w(r - h) < Se ? t : f,
                                y: h
                            } : null, b = void 0, (b = new rr(y, null)).a = m, b.b = x, Nt.push(b), b), i.site, null)), ++s);
                            var y, m, x, b;
                        }(t));
                        var o = {
                            cells: Ft,
                            edges: Nt
                        };
                        return Et = jt = Nt = Ft = null, o;
                    }
                    function dr(e, t) {
                        return t.y - e.y || t.x - e.x;
                    }
                    Jt.prototype.prepare = function() {
                        for(var e, t = this.edges, r = t.length; r--;)(e = t[r].edge).b && e.a || t.splice(r, 1);
                        return t.sort(Kt), t.length;
                    }, ir.prototype = {
                        start: function() {
                            return this.edge.l === this.site ? this.edge.a : this.edge.b;
                        },
                        end: function() {
                            return this.edge.l === this.site ? this.edge.b : this.edge.a;
                        }
                    }, or.prototype = {
                        insert: function(e, t) {
                            var r, n, a;
                            if (e) {
                                if (t.P = e, t.N = e.N, e.N && (e.N.P = t), e.N = t, e.R) {
                                    for(e = e.R; e.L;)e = e.L;
                                    e.L = t;
                                } else e.R = t;
                                r = e;
                            } else this._ ? (e = ur(this._), t.P = null, t.N = e, e.P = e.L = t, r = e) : (t.P = t.N = null, this._ = t, r = null);
                            for(t.L = t.R = null, t.U = r, t.C = !0, e = t; r && r.C;)r === (n = r.U).L ? (a = n.R) && a.C ? (r.C = a.C = !1, n.C = !0, e = n) : (e === r.R && (sr(this, r), r = (e = r).U), r.C = !1, n.C = !0, cr(this, n)) : (a = n.L) && a.C ? (r.C = a.C = !1, n.C = !0, e = n) : (e === r.L && (cr(this, r), r = (e = r).U), r.C = !1, n.C = !0, sr(this, n)), r = e.U;
                            this._.C = !1;
                        },
                        remove: function(e) {
                            e.N && (e.N.P = e.P), e.P && (e.P.N = e.N), e.N = e.P = null;
                            var t, r, n, a = e.U, i = e.L, o = e.R;
                            if (r = i ? o ? ur(o) : i : o, a ? a.L === e ? a.L = r : a.R = r : this._ = r, i && o ? (n = r.C, r.C = e.C, r.L = i, i.U = r, r !== o ? (a = r.U, r.U = e.U, e = r.R, a.L = e, r.R = o, o.U = r) : (r.U = a, a = r, e = r.R)) : (n = e.C, e = r), e && (e.U = a), !n) {
                                if (e && e.C) e.C = !1;
                                else {
                                    do {
                                        if (e === this._) break;
                                        if (e === a.L) {
                                            if ((t = a.R).C && (t.C = !1, a.C = !0, sr(this, a), t = a.R), t.L && t.L.C || t.R && t.R.C) {
                                                t.R && t.R.C || (t.L.C = !1, t.C = !0, cr(this, t), t = a.R), t.C = a.C, a.C = t.R.C = !1, sr(this, a), e = this._;
                                                break;
                                            }
                                        } else if ((t = a.L).C && (t.C = !1, a.C = !0, cr(this, a), t = a.L), t.L && t.L.C || t.R && t.R.C) {
                                            t.L && t.L.C || (t.R.C = !1, t.C = !0, sr(this, t), t = a.L), t.C = a.C, a.C = t.L.C = !1, cr(this, a), e = this._;
                                            break;
                                        }
                                        t.C = !0, e = a, a = a.U;
                                    }while (!e.C);
                                    e && (e.C = !1);
                                }
                            }
                        }
                    }, i.geom.voronoi = function(e) {
                        var t = St, r = Dt, n = t, a = r, i = hr;
                        if (e) return o(e);
                        function o(e) {
                            var t = new Array(e.length), r = i[0][0], n = i[0][1], a = i[1][0], o = i[1][1];
                            return fr(l(e), i).cells.forEach(function(i, l) {
                                var s = i.edges, c = i.site;
                                (t[l] = s.length ? s.map(function(e) {
                                    var t = e.start();
                                    return [
                                        t.x,
                                        t.y
                                    ];
                                }) : c.x >= r && c.x <= a && c.y >= n && c.y <= o ? [
                                    [
                                        r,
                                        o
                                    ],
                                    [
                                        a,
                                        o
                                    ],
                                    [
                                        a,
                                        n
                                    ],
                                    [
                                        r,
                                        n
                                    ]
                                ] : []).point = e[l];
                            }), t;
                        }
                        function l(e) {
                            return e.map(function(e, t) {
                                return {
                                    x: Math.round(n(e, t) / Se) * Se,
                                    y: Math.round(a(e, t) / Se) * Se,
                                    i: t
                                };
                            });
                        }
                        return o.links = function(e) {
                            return fr(l(e)).edges.filter(function(e) {
                                return e.l && e.r;
                            }).map(function(t) {
                                return {
                                    source: e[t.l.i],
                                    target: e[t.r.i]
                                };
                            });
                        }, o.triangles = function(e) {
                            var t = [];
                            return fr(l(e)).cells.forEach(function(r, n) {
                                for(var a, i, o, l, s = r.site, c = r.edges.sort(Kt), u = -1, f = c.length, d = c[f - 1].edge, h = d.l === s ? d.r : d.l; ++u < f;)a = h, h = (d = c[u].edge).l === s ? d.r : d.l, n < a.i && n < h.i && (o = a, l = h, ((i = s).x - l.x) * (o.y - i.y) - (i.x - o.x) * (l.y - i.y) < 0) && t.push([
                                    e[n],
                                    e[a.i],
                                    e[h.i]
                                ]);
                            }), t;
                        }, o.x = function(e) {
                            return arguments.length ? (n = gt(t = e), o) : t;
                        }, o.y = function(e) {
                            return arguments.length ? (a = gt(r = e), o) : r;
                        }, o.clipExtent = function(e) {
                            return arguments.length ? (i = null == e ? hr : e, o) : i === hr ? null : i;
                        }, o.size = function(e) {
                            return arguments.length ? o.clipExtent(e && [
                                [
                                    0,
                                    0
                                ],
                                e
                            ]) : i === hr ? null : i && i[1];
                        }, o;
                    };
                    var hr = [
                        [
                            -1000000,
                            -1000000
                        ],
                        [
                            1e6,
                            1e6
                        ]
                    ];
                    function pr(e) {
                        return e.x;
                    }
                    function vr(e) {
                        return e.y;
                    }
                    function gr(e, t, r, n, a, i) {
                        if (!e(t, r, n, a, i)) {
                            var o = .5 * (r + a), l = .5 * (n + i), s = t.nodes;
                            s[0] && gr(e, s[0], r, n, o, l), s[1] && gr(e, s[1], o, n, a, l), s[2] && gr(e, s[2], r, l, o, i), s[3] && gr(e, s[3], o, l, a, i);
                        }
                    }
                    function yr(e, t) {
                        e = i.rgb(e), t = i.rgb(t);
                        var r = e.r, n = e.g, a = e.b, o = t.r - r, l = t.g - n, s = t.b - a;
                        return function(e) {
                            return "#" + ct(Math.round(r + o * e)) + ct(Math.round(n + l * e)) + ct(Math.round(a + s * e));
                        };
                    }
                    function mr(e, t) {
                        var r, n = {}, a = {};
                        for(r in e)r in t ? n[r] = Tr(e[r], t[r]) : a[r] = e[r];
                        for(r in t)r in e || (a[r] = t[r]);
                        return function(e) {
                            for(r in n)a[r] = n[r](e);
                            return a;
                        };
                    }
                    function xr(e, t) {
                        return e = +e, t = +t, function(r) {
                            return e * (1 - r) + t * r;
                        };
                    }
                    function br(e, t) {
                        var r, n, a, i = _r.lastIndex = wr.lastIndex = 0, o = -1, l = [], s = [];
                        for(e += "", t += ""; (r = _r.exec(e)) && (n = wr.exec(t));)(a = n.index) > i && (a = t.slice(i, a), l[o] ? l[o] += a : l[++o] = a), (r = r[0]) === (n = n[0]) ? l[o] ? l[o] += n : l[++o] = n : (l[++o] = null, s.push({
                            i: o,
                            x: xr(r, n)
                        })), i = wr.lastIndex;
                        return i < t.length && (a = t.slice(i), l[o] ? l[o] += a : l[++o] = a), l.length < 2 ? s[0] ? (t = s[0].x, function(e) {
                            return t(e) + "";
                        }) : function() {
                            return t;
                        } : (t = s.length, function(e) {
                            for(var r, n = 0; n < t; ++n)l[(r = s[n]).i] = r.x(e);
                            return l.join("");
                        });
                    }
                    i.geom.delaunay = function(e) {
                        return i.geom.voronoi().triangles(e);
                    }, i.geom.quadtree = function(e, t, r, n, a) {
                        var i, o = St, l = Dt;
                        if (i = arguments.length) return o = pr, l = vr, 3 === i && (a = r, n = t, r = t = 0), s(e);
                        function s(e) {
                            var s, c, u, f, d, h, p, v, g, y = gt(o), m = gt(l);
                            if (null != t) h = t, p = r, v = n, g = a;
                            else if (v = g = -(h = p = 1 / 0), c = [], u = [], d = e.length, i) for(f = 0; f < d; ++f)(s = e[f]).x < h && (h = s.x), s.y < p && (p = s.y), s.x > v && (v = s.x), s.y > g && (g = s.y), c.push(s.x), u.push(s.y);
                            else for(f = 0; f < d; ++f){
                                var x = +y(s = e[f], f), b = +m(s, f);
                                x < h && (h = x), b < p && (p = b), x > v && (v = x), b > g && (g = b), c.push(x), u.push(b);
                            }
                            var _ = v - h, T = g - p;
                            function M(e, t, r, n, a, i, o, l) {
                                if (!isNaN(r) && !isNaN(n)) {
                                    if (e.leaf) {
                                        var s = e.x, c = e.y;
                                        if (null != s) {
                                            if (w(s - r) + w(c - n) < .01) k(e, t, r, n, a, i, o, l);
                                            else {
                                                var u = e.point;
                                                e.x = e.y = e.point = null, k(e, u, s, c, a, i, o, l), k(e, t, r, n, a, i, o, l);
                                            }
                                        } else e.x = r, e.y = n, e.point = t;
                                    } else k(e, t, r, n, a, i, o, l);
                                }
                            }
                            function k(e, t, r, n, a, i, o, l) {
                                var s = .5 * (a + o), c = .5 * (i + l), u = r >= s, f = n >= c, d = f << 1 | u;
                                e.leaf = !1, u ? a = s : o = s, f ? i = c : l = c, M(e = e.nodes[d] || (e.nodes[d] = {
                                    leaf: !0,
                                    nodes: [],
                                    point: null,
                                    x: null,
                                    y: null
                                }), t, r, n, a, i, o, l);
                            }
                            _ > T ? g = p + _ : v = h + T;
                            var A = {
                                leaf: !0,
                                nodes: [],
                                point: null,
                                x: null,
                                y: null,
                                add: function(e) {
                                    M(A, e, +y(e, ++f), +m(e, f), h, p, v, g);
                                }
                            };
                            if (A.visit = function(e) {
                                gr(e, A, h, p, v, g);
                            }, A.find = function(e) {
                                return function(e, t, r, n, a, i, o) {
                                    var l, s = 1 / 0;
                                    return function e(c, u, f, d, h) {
                                        if (!(u > i || f > o || d < n || h < a)) {
                                            if (p = c.point) {
                                                var p, v = t - c.x, g = r - c.y, y = v * v + g * g;
                                                if (y < s) {
                                                    var m = Math.sqrt(s = y);
                                                    n = t - m, a = r - m, i = t + m, o = r + m, l = p;
                                                }
                                            }
                                            for(var x = c.nodes, b = .5 * (u + d), _ = .5 * (f + h), w = (r >= _) << 1 | t >= b, T = w + 4; w < T; ++w)if (c = x[3 & w]) switch(3 & w){
                                                case 0:
                                                    e(c, u, f, b, _);
                                                    break;
                                                case 1:
                                                    e(c, b, f, d, _);
                                                    break;
                                                case 2:
                                                    e(c, u, _, b, h);
                                                    break;
                                                case 3:
                                                    e(c, b, _, d, h);
                                            }
                                        }
                                    }(e, n, a, i, o), l;
                                }(A, e[0], e[1], h, p, v, g);
                            }, f = -1, null == t) {
                                for(; ++f < d;)M(A, e[f], c[f], u[f], h, p, v, g);
                                --f;
                            } else e.forEach(A.add);
                            return c = u = e = s = null, A;
                        }
                        return s.x = function(e) {
                            return arguments.length ? (o = e, s) : o;
                        }, s.y = function(e) {
                            return arguments.length ? (l = e, s) : l;
                        }, s.extent = function(e) {
                            return arguments.length ? (null == e ? t = r = n = a = null : (t = +e[0][0], r = +e[0][1], n = +e[1][0], a = +e[1][1]), s) : null == t ? null : [
                                [
                                    t,
                                    r
                                ],
                                [
                                    n,
                                    a
                                ]
                            ];
                        }, s.size = function(e) {
                            return arguments.length ? (null == e ? t = r = n = a = null : (t = r = 0, n = +e[0], a = +e[1]), s) : null == t ? null : [
                                n - t,
                                a - r
                            ];
                        }, s;
                    }, i.interpolateRgb = yr, i.interpolateObject = mr, i.interpolateNumber = xr, i.interpolateString = br;
                    var _r = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, wr = new RegExp(_r.source, "g");
                    function Tr(e, t) {
                        for(var r, n = i.interpolators.length; --n >= 0 && !(r = i.interpolators[n](e, t)););
                        return r;
                    }
                    function Mr(e, t) {
                        var r, n = [], a = [], i = e.length, o = t.length, l = Math.min(e.length, t.length);
                        for(r = 0; r < l; ++r)n.push(Tr(e[r], t[r]));
                        for(; r < i; ++r)a[r] = e[r];
                        for(; r < o; ++r)a[r] = t[r];
                        return function(e) {
                            for(r = 0; r < l; ++r)a[r] = n[r](e);
                            return a;
                        };
                    }
                    i.interpolate = Tr, i.interpolators = [
                        function(e, t) {
                            var r = typeof t;
                            return ("string" === r ? vt.has(t.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(t) ? yr : br : t instanceof Ye ? yr : Array.isArray(t) ? Mr : "object" === r && isNaN(t) ? mr : xr)(e, t);
                        }
                    ], i.interpolateArray = Mr;
                    var kr = function() {
                        return z;
                    }, Ar = i.map({
                        linear: kr,
                        poly: function(e) {
                            return function(t) {
                                return Math.pow(t, e);
                            };
                        },
                        quad: function() {
                            return Or;
                        },
                        cubic: function() {
                            return Cr;
                        },
                        sin: function() {
                            return Ir;
                        },
                        exp: function() {
                            return Rr;
                        },
                        circle: function() {
                            return zr;
                        },
                        elastic: function(e, t) {
                            var r;
                            return arguments.length < 2 && (t = .45), arguments.length ? r = t / Ce * Math.asin(1 / e) : (e = 1, r = t / 4), function(n) {
                                return 1 + e * Math.pow(2, -10 * n) * Math.sin((n - r) * Ce / t);
                            };
                        },
                        back: function(e) {
                            return e || (e = 1.70158), function(t) {
                                return t * t * ((e + 1) * t - e);
                            };
                        },
                        bounce: function() {
                            return Nr;
                        }
                    }), Lr = i.map({
                        in: z,
                        out: Sr,
                        "in-out": Dr,
                        "out-in": function(e) {
                            return Dr(Sr(e));
                        }
                    });
                    function Sr(e) {
                        return function(t) {
                            return 1 - e(1 - t);
                        };
                    }
                    function Dr(e) {
                        return function(t) {
                            return .5 * (t < .5 ? e(2 * t) : 2 - e(2 - 2 * t));
                        };
                    }
                    function Or(e) {
                        return e * e;
                    }
                    function Cr(e) {
                        return e * e * e;
                    }
                    function Pr(e) {
                        if (e <= 0) return 0;
                        if (e >= 1) return 1;
                        var t = e * e, r = t * e;
                        return 4 * (e < .5 ? r : 3 * (e - t) + r - .75);
                    }
                    function Ir(e) {
                        return 1 - Math.cos(e * Ie);
                    }
                    function Rr(e) {
                        return Math.pow(2, 10 * (e - 1));
                    }
                    function zr(e) {
                        return 1 - Math.sqrt(1 - e * e);
                    }
                    function Nr(e) {
                        return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + .75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + .9375 : 7.5625 * (e -= 2.625 / 2.75) * e + .984375;
                    }
                    function Fr(e, t) {
                        return t -= e, function(r) {
                            return Math.round(e + t * r);
                        };
                    }
                    function Er(e) {
                        var t, r, n, a = [
                            e.a,
                            e.b
                        ], i = [
                            e.c,
                            e.d
                        ], o = jr(a), l = Hr(a, i), s = jr(((t = i)[0] += (n = -l) * (r = a)[0], t[1] += n * r[1], t)) || 0;
                        a[0] * i[1] < i[0] * a[1] && (a[0] *= -1, a[1] *= -1, o *= -1, l *= -1), this.rotate = (o ? Math.atan2(a[1], a[0]) : Math.atan2(-i[0], i[1])) * ze, this.translate = [
                            e.e,
                            e.f
                        ], this.scale = [
                            o,
                            s
                        ], this.skew = s ? Math.atan2(l, s) * ze : 0;
                    }
                    function Hr(e, t) {
                        return e[0] * t[0] + e[1] * t[1];
                    }
                    function jr(e) {
                        var t = Math.sqrt(Hr(e, e));
                        return t && (e[0] /= t, e[1] /= t), t;
                    }
                    i.ease = function(e) {
                        var t, r = e.indexOf("-"), n = r >= 0 ? e.slice(0, r) : e, a = r >= 0 ? e.slice(r + 1) : "in";
                        return n = Ar.get(n) || kr, a = Lr.get(a) || z, t = a(n.apply(null, o.call(arguments, 1))), function(e) {
                            return e <= 0 ? 0 : e >= 1 ? 1 : t(e);
                        };
                    }, i.interpolateHcl = function(e, t) {
                        e = i.hcl(e), t = i.hcl(t);
                        var r = e.h, n = e.c, a = e.l, o = t.h - r, l = t.c - n, s = t.l - a;
                        return isNaN(l) && (l = 0, n = isNaN(n) ? t.c : n), isNaN(o) ? (o = 0, r = isNaN(r) ? t.h : r) : o > 180 ? o -= 360 : o < -180 && (o += 360), function(e) {
                            return We(r + o * e, n + l * e, a + s * e) + "";
                        };
                    }, i.interpolateHsl = function(e, t) {
                        e = i.hsl(e), t = i.hsl(t);
                        var r = e.h, n = e.s, a = e.l, o = t.h - r, l = t.s - n, s = t.l - a;
                        return isNaN(l) && (l = 0, n = isNaN(n) ? t.s : n), isNaN(o) ? (o = 0, r = isNaN(r) ? t.h : r) : o > 180 ? o -= 360 : o < -180 && (o += 360), function(e) {
                            return qe(r + o * e, n + l * e, a + s * e) + "";
                        };
                    }, i.interpolateLab = function(e, t) {
                        e = i.lab(e), t = i.lab(t);
                        var r = e.l, n = e.a, a = e.b, o = t.l - r, l = t.a - n, s = t.b - a;
                        return function(e) {
                            return tt(r + o * e, n + l * e, a + s * e) + "";
                        };
                    }, i.interpolateRound = Fr, i.transform = function(e) {
                        var t = s.createElementNS(i.ns.prefix.svg, "g");
                        return (i.transform = function(e) {
                            if (null != e) {
                                t.setAttribute("transform", e);
                                var r = t.transform.baseVal.consolidate();
                            }
                            return new Er(r ? r.matrix : Br);
                        })(e);
                    }, Er.prototype.toString = function() {
                        return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
                    };
                    var Br = {
                        a: 1,
                        b: 0,
                        c: 0,
                        d: 1,
                        e: 0,
                        f: 0
                    };
                    function Yr(e) {
                        return e.length ? e.pop() + "," : "";
                    }
                    function Vr(e, t) {
                        var r = [], n = [];
                        return e = i.transform(e), t = i.transform(t), function(e, t, r, n) {
                            if (e[0] !== t[0] || e[1] !== t[1]) {
                                var a = r.push("translate(", null, ",", null, ")");
                                n.push({
                                    i: a - 4,
                                    x: xr(e[0], t[0])
                                }, {
                                    i: a - 2,
                                    x: xr(e[1], t[1])
                                });
                            } else (t[0] || t[1]) && r.push("translate(" + t + ")");
                        }(e.translate, t.translate, r, n), function(e, t, r, n) {
                            e !== t ? (e - t > 180 ? t += 360 : t - e > 180 && (e += 360), n.push({
                                i: r.push(Yr(r) + "rotate(", null, ")") - 2,
                                x: xr(e, t)
                            })) : t && r.push(Yr(r) + "rotate(" + t + ")");
                        }(e.rotate, t.rotate, r, n), function(e, t, r, n) {
                            e !== t ? n.push({
                                i: r.push(Yr(r) + "skewX(", null, ")") - 2,
                                x: xr(e, t)
                            }) : t && r.push(Yr(r) + "skewX(" + t + ")");
                        }(e.skew, t.skew, r, n), function(e, t, r, n) {
                            if (e[0] !== t[0] || e[1] !== t[1]) {
                                var a = r.push(Yr(r) + "scale(", null, ",", null, ")");
                                n.push({
                                    i: a - 4,
                                    x: xr(e[0], t[0])
                                }, {
                                    i: a - 2,
                                    x: xr(e[1], t[1])
                                });
                            } else 1 === t[0] && 1 === t[1] || r.push(Yr(r) + "scale(" + t + ")");
                        }(e.scale, t.scale, r, n), e = t = null, function(e) {
                            for(var t, a = -1, i = n.length; ++a < i;)r[(t = n[a]).i] = t.x(e);
                            return r.join("");
                        };
                    }
                    function Ur(e, t) {
                        return t = (t -= e = +e) || 1 / t, function(r) {
                            return (r - e) / t;
                        };
                    }
                    function qr(e, t) {
                        return t = (t -= e = +e) || 1 / t, function(r) {
                            return Math.max(0, Math.min(1, (r - e) / t));
                        };
                    }
                    function Gr(e) {
                        for(var t = e.source, r = e.target, n = function(e, t) {
                            if (e === t) return e;
                            for(var r = Zr(e), n = Zr(t), a = r.pop(), i = n.pop(), o = null; a === i;)o = a, a = r.pop(), i = n.pop();
                            return o;
                        }(t, r), a = [
                            t
                        ]; t !== n;)t = t.parent, a.push(t);
                        for(var i = a.length; r !== n;)a.splice(i, 0, r), r = r.parent;
                        return a;
                    }
                    function Zr(e) {
                        for(var t = [], r = e.parent; null != r;)t.push(e), e = r, r = r.parent;
                        return t.push(e), t;
                    }
                    function Wr(e) {
                        e.fixed |= 2;
                    }
                    function Xr(e) {
                        e.fixed &= -7;
                    }
                    function Jr(e) {
                        e.fixed |= 4, e.px = e.x, e.py = e.y;
                    }
                    function Kr(e) {
                        e.fixed &= -5;
                    }
                    function Qr(e, t, r) {
                        var n = 0, a = 0;
                        if (e.charge = 0, !e.leaf) for(var i, o = e.nodes, l = o.length, s = -1; ++s < l;)null != (i = o[s]) && (Qr(i, t, r), e.charge += i.charge, n += i.charge * i.cx, a += i.charge * i.cy);
                        if (e.point) {
                            e.leaf || (e.point.x += Math.random() - .5, e.point.y += Math.random() - .5);
                            var c = t * r[e.point.index];
                            e.charge += e.pointCharge = c, n += c * e.point.x, a += c * e.point.y;
                        }
                        e.cx = n / e.charge, e.cy = a / e.charge;
                    }
                    i.interpolateTransform = Vr, i.layout = {}, i.layout.bundle = function() {
                        return function(e) {
                            for(var t = [], r = -1, n = e.length; ++r < n;)t.push(Gr(e[r]));
                            return t;
                        };
                    }, i.layout.chord = function() {
                        var e, t, r, n, a, o, l, s = {}, c = 0;
                        function u() {
                            var s, u, d, h, p, v = {}, g = [], y = i.range(n), m = [];
                            for(e = [], t = [], s = 0, h = -1; ++h < n;){
                                for(u = 0, p = -1; ++p < n;)u += r[h][p];
                                g.push(u), m.push(i.range(n)), s += u;
                            }
                            for(a && y.sort(function(e, t) {
                                return a(g[e], g[t]);
                            }), o && m.forEach(function(e, t) {
                                e.sort(function(e, n) {
                                    return o(r[t][e], r[t][n]);
                                });
                            }), s = (Ce - c * n) / s, u = 0, h = -1; ++h < n;){
                                for(d = u, p = -1; ++p < n;){
                                    var x = y[h], b = m[x][p], _ = r[x][b], w = u, T = u += _ * s;
                                    v[x + "-" + b] = {
                                        index: x,
                                        subindex: b,
                                        startAngle: w,
                                        endAngle: T,
                                        value: _
                                    };
                                }
                                t[x] = {
                                    index: x,
                                    startAngle: d,
                                    endAngle: u,
                                    value: g[x]
                                }, u += c;
                            }
                            for(h = -1; ++h < n;)for(p = h - 1; ++p < n;){
                                var M = v[h + "-" + p], k = v[p + "-" + h];
                                (M.value || k.value) && e.push(M.value < k.value ? {
                                    source: k,
                                    target: M
                                } : {
                                    source: M,
                                    target: k
                                });
                            }
                            l && f();
                        }
                        function f() {
                            e.sort(function(e, t) {
                                return l((e.source.value + e.target.value) / 2, (t.source.value + t.target.value) / 2);
                            });
                        }
                        return s.matrix = function(a) {
                            return arguments.length ? (n = (r = a) && r.length, e = t = null, s) : r;
                        }, s.padding = function(r) {
                            return arguments.length ? (c = r, e = t = null, s) : c;
                        }, s.sortGroups = function(r) {
                            return arguments.length ? (a = r, e = t = null, s) : a;
                        }, s.sortSubgroups = function(t) {
                            return arguments.length ? (o = t, e = null, s) : o;
                        }, s.sortChords = function(t) {
                            return arguments.length ? (l = t, e && f(), s) : l;
                        }, s.chords = function() {
                            return e || u(), e;
                        }, s.groups = function() {
                            return t || u(), t;
                        }, s;
                    }, i.layout.force = function() {
                        var e, t, r, n, a, o, l = {}, s = i.dispatch("start", "tick", "end"), c = [
                            1,
                            1
                        ], u = .9, f = $r, d = en, h = -30, p = tn, v = .1, g = .64, y = [], m = [];
                        function x(e) {
                            return function(t, r, n, a) {
                                if (t.point !== e) {
                                    var i = t.cx - e.x, o = t.cy - e.y, l = a - r, s = i * i + o * o;
                                    if (l * l / g < s) {
                                        if (s < p) {
                                            var c = t.charge / s;
                                            e.px -= i * c, e.py -= o * c;
                                        }
                                        return !0;
                                    }
                                    t.point && s && s < p && (c = t.pointCharge / s, e.px -= i * c, e.py -= o * c);
                                }
                                return !t.charge;
                            };
                        }
                        function b(e) {
                            e.px = i.event.x, e.py = i.event.y, l.resume();
                        }
                        return l.tick = function() {
                            if ((r *= .99) < .005) return e = null, s.end({
                                type: "end",
                                alpha: r = 0
                            }), !0;
                            var t, l, f, d, p, g, b, _, w, T = y.length, M = m.length;
                            for(l = 0; l < M; ++l)d = (f = m[l]).source, (g = (_ = (p = f.target).x - d.x) * _ + (w = p.y - d.y) * w) && (_ *= g = r * a[l] * ((g = Math.sqrt(g)) - n[l]) / g, w *= g, p.x -= _ * (b = d.weight + p.weight ? d.weight / (d.weight + p.weight) : .5), p.y -= w * b, d.x += _ * (b = 1 - b), d.y += w * b);
                            if ((b = r * v) && (_ = c[0] / 2, w = c[1] / 2, l = -1, b)) for(; ++l < T;)(f = y[l]).x += (_ - f.x) * b, f.y += (w - f.y) * b;
                            if (h) for(Qr(t = i.geom.quadtree(y), r, o), l = -1; ++l < T;)(f = y[l]).fixed || t.visit(x(f));
                            for(l = -1; ++l < T;)(f = y[l]).fixed ? (f.x = f.px, f.y = f.py) : (f.x -= (f.px - (f.px = f.x)) * u, f.y -= (f.py - (f.py = f.y)) * u);
                            s.tick({
                                type: "tick",
                                alpha: r
                            });
                        }, l.nodes = function(e) {
                            return arguments.length ? (y = e, l) : y;
                        }, l.links = function(e) {
                            return arguments.length ? (m = e, l) : m;
                        }, l.size = function(e) {
                            return arguments.length ? (c = e, l) : c;
                        }, l.linkDistance = function(e) {
                            return arguments.length ? (f = "function" == typeof e ? e : +e, l) : f;
                        }, l.distance = l.linkDistance, l.linkStrength = function(e) {
                            return arguments.length ? (d = "function" == typeof e ? e : +e, l) : d;
                        }, l.friction = function(e) {
                            return arguments.length ? (u = +e, l) : u;
                        }, l.charge = function(e) {
                            return arguments.length ? (h = "function" == typeof e ? e : +e, l) : h;
                        }, l.chargeDistance = function(e) {
                            return arguments.length ? (p = e * e, l) : Math.sqrt(p);
                        }, l.gravity = function(e) {
                            return arguments.length ? (v = +e, l) : v;
                        }, l.theta = function(e) {
                            return arguments.length ? (g = e * e, l) : Math.sqrt(g);
                        }, l.alpha = function(t) {
                            return arguments.length ? (t = +t, r ? t > 0 ? r = t : (e.c = null, e.t = NaN, e = null, s.end({
                                type: "end",
                                alpha: r = 0
                            })) : t > 0 && (s.start({
                                type: "start",
                                alpha: r = t
                            }), e = Mt(l.tick)), l) : r;
                        }, l.start = function() {
                            var e, t, r, i = y.length, s = m.length, u = c[0], p = c[1];
                            for(e = 0; e < i; ++e)(r = y[e]).index = e, r.weight = 0;
                            for(e = 0; e < s; ++e)"number" == typeof (r = m[e]).source && (r.source = y[r.source]), "number" == typeof r.target && (r.target = y[r.target]), ++r.source.weight, ++r.target.weight;
                            for(e = 0; e < i; ++e)r = y[e], isNaN(r.x) && (r.x = v("x", u)), isNaN(r.y) && (r.y = v("y", p)), isNaN(r.px) && (r.px = r.x), isNaN(r.py) && (r.py = r.y);
                            if (n = [], "function" == typeof f) for(e = 0; e < s; ++e)n[e] = +f.call(this, m[e], e);
                            else for(e = 0; e < s; ++e)n[e] = f;
                            if (a = [], "function" == typeof d) for(e = 0; e < s; ++e)a[e] = +d.call(this, m[e], e);
                            else for(e = 0; e < s; ++e)a[e] = d;
                            if (o = [], "function" == typeof h) for(e = 0; e < i; ++e)o[e] = +h.call(this, y[e], e);
                            else for(e = 0; e < i; ++e)o[e] = h;
                            function v(r, n) {
                                if (!t) {
                                    for(t = new Array(i), c = 0; c < i; ++c)t[c] = [];
                                    for(c = 0; c < s; ++c){
                                        var a = m[c];
                                        t[a.source.index].push(a.target), t[a.target.index].push(a.source);
                                    }
                                }
                                for(var o, l = t[e], c = -1, u = l.length; ++c < u;)if (!isNaN(o = l[c][r])) return o;
                                return Math.random() * n;
                            }
                            return l.resume();
                        }, l.resume = function() {
                            return l.alpha(.1);
                        }, l.stop = function() {
                            return l.alpha(0);
                        }, l.drag = function() {
                            if (t || (t = i.behavior.drag().origin(z).on("dragstart.force", Wr).on("drag.force", b).on("dragend.force", Xr)), !arguments.length) return t;
                            this.on("mouseover.force", Jr).on("mouseout.force", Kr).call(t);
                        }, i.rebind(l, s, "on");
                    };
                    var $r = 20, en = 1, tn = 1 / 0;
                    function rn(e, t) {
                        return i.rebind(e, t, "sort", "children", "value"), e.nodes = e, e.links = cn, e;
                    }
                    function nn(e, t) {
                        for(var r = [
                            e
                        ]; null != (e = r.pop());)if (t(e), (a = e.children) && (n = a.length)) for(var n, a; --n >= 0;)r.push(a[n]);
                    }
                    function an(e, t) {
                        for(var r = [
                            e
                        ], n = []; null != (e = r.pop());)if (n.push(e), (i = e.children) && (a = i.length)) for(var a, i, o = -1; ++o < a;)r.push(i[o]);
                        for(; null != (e = n.pop());)t(e);
                    }
                    function on(e) {
                        return e.children;
                    }
                    function ln(e) {
                        return e.value;
                    }
                    function sn(e, t) {
                        return t.value - e.value;
                    }
                    function cn(e) {
                        return i.merge(e.map(function(e) {
                            return (e.children || []).map(function(t) {
                                return {
                                    source: e,
                                    target: t
                                };
                            });
                        }));
                    }
                    i.layout.hierarchy = function() {
                        var e = sn, t = on, r = ln;
                        function n(a) {
                            var i, o = [
                                a
                            ], l = [];
                            for(a.depth = 0; null != (i = o.pop());)if (l.push(i), (c = t.call(n, i, i.depth)) && (s = c.length)) {
                                for(var s, c, u; --s >= 0;)o.push(u = c[s]), u.parent = i, u.depth = i.depth + 1;
                                r && (i.value = 0), i.children = c;
                            } else r && (i.value = +r.call(n, i, i.depth) || 0), delete i.children;
                            return an(a, function(t) {
                                var n, a;
                                e && (n = t.children) && n.sort(e), r && (a = t.parent) && (a.value += t.value);
                            }), l;
                        }
                        return n.sort = function(t) {
                            return arguments.length ? (e = t, n) : e;
                        }, n.children = function(e) {
                            return arguments.length ? (t = e, n) : t;
                        }, n.value = function(e) {
                            return arguments.length ? (r = e, n) : r;
                        }, n.revalue = function(e) {
                            return r && (nn(e, function(e) {
                                e.children && (e.value = 0);
                            }), an(e, function(e) {
                                var t;
                                e.children || (e.value = +r.call(n, e, e.depth) || 0), (t = e.parent) && (t.value += e.value);
                            })), e;
                        }, n;
                    }, i.layout.partition = function() {
                        var e = i.layout.hierarchy(), t = [
                            1,
                            1
                        ];
                        function r(e, t, n, a) {
                            var i = e.children;
                            if (e.x = t, e.y = e.depth * a, e.dx = n, e.dy = a, i && (o = i.length)) {
                                var o, l, s, c = -1;
                                for(n = e.value ? n / e.value : 0; ++c < o;)r(l = i[c], t, s = l.value * n, a), t += s;
                            }
                        }
                        function n(e) {
                            var t = e.children, r = 0;
                            if (t && (a = t.length)) for(var a, i = -1; ++i < a;)r = Math.max(r, n(t[i]));
                            return 1 + r;
                        }
                        function a(a, i) {
                            var o = e.call(this, a, i);
                            return r(o[0], 0, t[0], t[1] / n(o[0])), o;
                        }
                        return a.size = function(e) {
                            return arguments.length ? (t = e, a) : t;
                        }, rn(a, e);
                    }, i.layout.pie = function() {
                        var e = Number, t = un, r = 0, n = Ce, a = 0;
                        function o(l) {
                            var s, c = l.length, u = l.map(function(t, r) {
                                return +e.call(o, t, r);
                            }), f = +("function" == typeof r ? r.apply(this, arguments) : r), d = ("function" == typeof n ? n.apply(this, arguments) : n) - f, h = Math.min(Math.abs(d) / c, +("function" == typeof a ? a.apply(this, arguments) : a)), p = h * (d < 0 ? -1 : 1), v = i.sum(u), g = v ? (d - c * p) / v : 0, y = i.range(c), m = [];
                            return null != t && y.sort(t === un ? function(e, t) {
                                return u[t] - u[e];
                            } : function(e, r) {
                                return t(l[e], l[r]);
                            }), y.forEach(function(e) {
                                m[e] = {
                                    data: l[e],
                                    value: s = u[e],
                                    startAngle: f,
                                    endAngle: f += s * g + p,
                                    padAngle: h
                                };
                            }), m;
                        }
                        return o.value = function(t) {
                            return arguments.length ? (e = t, o) : e;
                        }, o.sort = function(e) {
                            return arguments.length ? (t = e, o) : t;
                        }, o.startAngle = function(e) {
                            return arguments.length ? (r = e, o) : r;
                        }, o.endAngle = function(e) {
                            return arguments.length ? (n = e, o) : n;
                        }, o.padAngle = function(e) {
                            return arguments.length ? (a = e, o) : a;
                        }, o;
                    };
                    var un = {};
                    function fn(e) {
                        return e.x;
                    }
                    function dn(e) {
                        return e.y;
                    }
                    function hn(e, t, r) {
                        e.y0 = t, e.y = r;
                    }
                    i.layout.stack = function() {
                        var e = z, t = gn, r = yn, n = hn, a = fn, o = dn;
                        function l(s, c) {
                            if (!(h = s.length)) return s;
                            var u = s.map(function(t, r) {
                                return e.call(l, t, r);
                            }), f = u.map(function(e) {
                                return e.map(function(e, t) {
                                    return [
                                        a.call(l, e, t),
                                        o.call(l, e, t)
                                    ];
                                });
                            }), d = t.call(l, f, c);
                            u = i.permute(u, d), f = i.permute(f, d);
                            var h, p, v, g, y = r.call(l, f, c), m = u[0].length;
                            for(v = 0; v < m; ++v)for(n.call(l, u[0][v], g = y[v], f[0][v][1]), p = 1; p < h; ++p)n.call(l, u[p][v], g += f[p - 1][v][1], f[p][v][1]);
                            return s;
                        }
                        return l.values = function(t) {
                            return arguments.length ? (e = t, l) : e;
                        }, l.order = function(e) {
                            return arguments.length ? (t = "function" == typeof e ? e : pn.get(e) || gn, l) : t;
                        }, l.offset = function(e) {
                            return arguments.length ? (r = "function" == typeof e ? e : vn.get(e) || yn, l) : r;
                        }, l.x = function(e) {
                            return arguments.length ? (a = e, l) : a;
                        }, l.y = function(e) {
                            return arguments.length ? (o = e, l) : o;
                        }, l.out = function(e) {
                            return arguments.length ? (n = e, l) : n;
                        }, l;
                    };
                    var pn = i.map({
                        "inside-out": function(e) {
                            var t, r, n = e.length, a = e.map(mn), o = e.map(xn), l = i.range(n).sort(function(e, t) {
                                return a[e] - a[t];
                            }), s = 0, c = 0, u = [], f = [];
                            for(t = 0; t < n; ++t)r = l[t], s < c ? (s += o[r], u.push(r)) : (c += o[r], f.push(r));
                            return f.reverse().concat(u);
                        },
                        reverse: function(e) {
                            return i.range(e.length).reverse();
                        },
                        default: gn
                    }), vn = i.map({
                        silhouette: function(e) {
                            var t, r, n, a = e.length, i = e[0].length, o = [], l = 0, s = [];
                            for(r = 0; r < i; ++r){
                                for(t = 0, n = 0; t < a; t++)n += e[t][r][1];
                                n > l && (l = n), o.push(n);
                            }
                            for(r = 0; r < i; ++r)s[r] = (l - o[r]) / 2;
                            return s;
                        },
                        wiggle: function(e) {
                            var t, r, n, a, i, o, l, s, c, u = e.length, f = e[0], d = f.length, h = [];
                            for(h[0] = s = c = 0, r = 1; r < d; ++r){
                                for(t = 0, a = 0; t < u; ++t)a += e[t][r][1];
                                for(t = 0, i = 0, l = f[r][0] - f[r - 1][0]; t < u; ++t){
                                    for(n = 0, o = (e[t][r][1] - e[t][r - 1][1]) / (2 * l); n < t; ++n)o += (e[n][r][1] - e[n][r - 1][1]) / l;
                                    i += o * e[t][r][1];
                                }
                                h[r] = s -= a ? i / a * l : 0, s < c && (c = s);
                            }
                            for(r = 0; r < d; ++r)h[r] -= c;
                            return h;
                        },
                        expand: function(e) {
                            var t, r, n, a = e.length, i = e[0].length, o = 1 / a, l = [];
                            for(r = 0; r < i; ++r){
                                for(t = 0, n = 0; t < a; t++)n += e[t][r][1];
                                if (n) for(t = 0; t < a; t++)e[t][r][1] /= n;
                                else for(t = 0; t < a; t++)e[t][r][1] = o;
                            }
                            for(r = 0; r < i; ++r)l[r] = 0;
                            return l;
                        },
                        zero: yn
                    });
                    function gn(e) {
                        return i.range(e.length);
                    }
                    function yn(e) {
                        for(var t = -1, r = e[0].length, n = []; ++t < r;)n[t] = 0;
                        return n;
                    }
                    function mn(e) {
                        for(var t, r = 1, n = 0, a = e[0][1], i = e.length; r < i; ++r)(t = e[r][1]) > a && (n = r, a = t);
                        return n;
                    }
                    function xn(e) {
                        return e.reduce(bn, 0);
                    }
                    function bn(e, t) {
                        return e + t[1];
                    }
                    function _n(e, t) {
                        return wn(e, Math.ceil(Math.log(t.length) / Math.LN2 + 1));
                    }
                    function wn(e, t) {
                        for(var r = -1, n = +e[0], a = (e[1] - n) / t, i = []; ++r <= t;)i[r] = a * r + n;
                        return i;
                    }
                    function Tn(e) {
                        return [
                            i.min(e),
                            i.max(e)
                        ];
                    }
                    function Mn(e, t) {
                        return e.value - t.value;
                    }
                    function kn(e, t) {
                        var r = e._pack_next;
                        e._pack_next = t, t._pack_prev = e, t._pack_next = r, r._pack_prev = t;
                    }
                    function An(e, t) {
                        e._pack_next = t, t._pack_prev = e;
                    }
                    function Ln(e, t) {
                        var r = t.x - e.x, n = t.y - e.y, a = e.r + t.r;
                        return .999 * a * a > r * r + n * n;
                    }
                    function Sn(e) {
                        if ((t = e.children) && (s = t.length)) {
                            var t, r, n, a, i, o, l, s, c = 1 / 0, u = -1 / 0, f = 1 / 0, d = -1 / 0;
                            if (t.forEach(Dn), (r = t[0]).x = -r.r, r.y = 0, x(r), s > 1 && ((n = t[1]).x = n.r, n.y = 0, x(n), s > 2)) for(Pn(r, n, a = t[2]), x(a), kn(r, a), r._pack_prev = a, kn(a, n), n = r._pack_next, i = 3; i < s; i++){
                                Pn(r, n, a = t[i]);
                                var h = 0, p = 1, v = 1;
                                for(o = n._pack_next; o !== n; o = o._pack_next, p++)if (Ln(o, a)) {
                                    h = 1;
                                    break;
                                }
                                if (1 == h) for(l = r._pack_prev; l !== o._pack_prev && !Ln(l, a); l = l._pack_prev, v++);
                                h ? (p < v || p == v && n.r < r.r ? An(r, n = o) : An(r = l, n), i--) : (kn(r, a), n = a, x(a));
                            }
                            var g = (c + u) / 2, y = (f + d) / 2, m = 0;
                            for(i = 0; i < s; i++)(a = t[i]).x -= g, a.y -= y, m = Math.max(m, a.r + Math.sqrt(a.x * a.x + a.y * a.y));
                            e.r = m, t.forEach(On);
                        }
                        function x(e) {
                            c = Math.min(e.x - e.r, c), u = Math.max(e.x + e.r, u), f = Math.min(e.y - e.r, f), d = Math.max(e.y + e.r, d);
                        }
                    }
                    function Dn(e) {
                        e._pack_next = e._pack_prev = e;
                    }
                    function On(e) {
                        delete e._pack_next, delete e._pack_prev;
                    }
                    function Cn(e, t, r, n) {
                        var a = e.children;
                        if (e.x = t += n * e.x, e.y = r += n * e.y, e.r *= n, a) for(var i = -1, o = a.length; ++i < o;)Cn(a[i], t, r, n);
                    }
                    function Pn(e, t, r) {
                        var n = e.r + r.r, a = t.x - e.x, i = t.y - e.y;
                        if (n && (a || i)) {
                            var o = t.r + r.r, l = a * a + i * i, s = .5 + ((n *= n) - (o *= o)) / (2 * l), c = Math.sqrt(Math.max(0, 2 * o * (n + l) - (n -= l) * n - o * o)) / (2 * l);
                            r.x = e.x + s * a + c * i, r.y = e.y + s * i - c * a;
                        } else r.x = e.x + n, r.y = e.y;
                    }
                    function In(e, t) {
                        return e.parent == t.parent ? 1 : 2;
                    }
                    function Rn(e) {
                        var t = e.children;
                        return t.length ? t[0] : e.t;
                    }
                    function zn(e) {
                        var t, r = e.children;
                        return (t = r.length) ? r[t - 1] : e.t;
                    }
                    function Nn(e, t, r) {
                        var n = r / (t.i - e.i);
                        t.c -= n, t.s += r, e.c += n, t.z += r, t.m += r;
                    }
                    function Fn(e, t, r) {
                        return e.a.parent === t.parent ? e.a : r;
                    }
                    function En(e) {
                        var t = e.children;
                        return t && t.length ? En(t[0]) : e;
                    }
                    function Hn(e) {
                        var t, r = e.children;
                        return r && (t = r.length) ? Hn(r[t - 1]) : e;
                    }
                    function jn(e) {
                        return {
                            x: e.x,
                            y: e.y,
                            dx: e.dx,
                            dy: e.dy
                        };
                    }
                    function Bn(e, t) {
                        var r = e.x + t[3], n = e.y + t[0], a = e.dx - t[1] - t[3], i = e.dy - t[0] - t[2];
                        return a < 0 && (r += a / 2, a = 0), i < 0 && (n += i / 2, i = 0), {
                            x: r,
                            y: n,
                            dx: a,
                            dy: i
                        };
                    }
                    function Yn(e) {
                        var t = e[0], r = e[e.length - 1];
                        return t < r ? [
                            t,
                            r
                        ] : [
                            r,
                            t
                        ];
                    }
                    function Vn(e) {
                        return e.rangeExtent ? e.rangeExtent() : Yn(e.range());
                    }
                    function Un(e, t, r, n) {
                        var a = r(e[0], e[1]), i = n(t[0], t[1]);
                        return function(e) {
                            return i(a(e));
                        };
                    }
                    function qn(e, t) {
                        var r, n = 0, a = e.length - 1, i = e[n], o = e[a];
                        return o < i && (r = n, n = a, a = r, r = i, i = o, o = r), e[n] = t.floor(i), e[a] = t.ceil(o), e;
                    }
                    function Gn(e) {
                        return e ? {
                            floor: function(t) {
                                return Math.floor(t / e) * e;
                            },
                            ceil: function(t) {
                                return Math.ceil(t / e) * e;
                            }
                        } : Zn;
                    }
                    i.layout.histogram = function() {
                        var e = !0, t = Number, r = Tn, n = _n;
                        function a(a, o) {
                            for(var l, s, c = [], u = a.map(t, this), f = r.call(this, u, o), d = n.call(this, f, u, o), h = (o = -1, u.length), p = d.length - 1, v = e ? 1 : 1 / h; ++o < p;)(l = c[o] = []).dx = d[o + 1] - (l.x = d[o]), l.y = 0;
                            if (p > 0) for(o = -1; ++o < h;)(s = u[o]) >= f[0] && s <= f[1] && ((l = c[i.bisect(d, s, 1, p) - 1]).y += v, l.push(a[o]));
                            return c;
                        }
                        return a.value = function(e) {
                            return arguments.length ? (t = e, a) : t;
                        }, a.range = function(e) {
                            return arguments.length ? (r = gt(e), a) : r;
                        }, a.bins = function(e) {
                            return arguments.length ? (n = "number" == typeof e ? function(t) {
                                return wn(t, e);
                            } : gt(e), a) : n;
                        }, a.frequency = function(t) {
                            return arguments.length ? (e = !!t, a) : e;
                        }, a;
                    }, i.layout.pack = function() {
                        var e, t = i.layout.hierarchy().sort(Mn), r = 0, n = [
                            1,
                            1
                        ];
                        function a(a, i) {
                            var o = t.call(this, a, i), l = o[0], s = n[0], c = n[1], u = null == e ? Math.sqrt : "function" == typeof e ? e : function() {
                                return e;
                            };
                            if (l.x = l.y = 0, an(l, function(e) {
                                e.r = +u(e.value);
                            }), an(l, Sn), r) {
                                var f = r * (e ? 1 : Math.max(2 * l.r / s, 2 * l.r / c)) / 2;
                                an(l, function(e) {
                                    e.r += f;
                                }), an(l, Sn), an(l, function(e) {
                                    e.r -= f;
                                });
                            }
                            return Cn(l, s / 2, c / 2, e ? 1 : 1 / Math.max(2 * l.r / s, 2 * l.r / c)), o;
                        }
                        return a.size = function(e) {
                            return arguments.length ? (n = e, a) : n;
                        }, a.radius = function(t) {
                            return arguments.length ? (e = null == t || "function" == typeof t ? t : +t, a) : e;
                        }, a.padding = function(e) {
                            return arguments.length ? (r = +e, a) : r;
                        }, rn(a, t);
                    }, i.layout.tree = function() {
                        var e = i.layout.hierarchy().sort(null).value(null), t = In, r = [
                            1,
                            1
                        ], n = null;
                        function a(a, i) {
                            var c = e.call(this, a, i), u = c[0], f = function(e) {
                                for(var t, r = {
                                    A: null,
                                    children: [
                                        e
                                    ]
                                }, n = [
                                    r
                                ]; null != (t = n.pop());)for(var a, i = t.children, o = 0, l = i.length; o < l; ++o)n.push((i[o] = a = {
                                    _: i[o],
                                    parent: t,
                                    children: (a = i[o].children) && a.slice() || [],
                                    A: null,
                                    a: null,
                                    z: 0,
                                    m: 0,
                                    c: 0,
                                    s: 0,
                                    t: null,
                                    i: o
                                }).a = a);
                                return r.children[0];
                            }(u);
                            if (an(f, o), f.parent.m = -f.z, nn(f, l), n) nn(u, s);
                            else {
                                var d = u, h = u, p = u;
                                nn(u, function(e) {
                                    e.x < d.x && (d = e), e.x > h.x && (h = e), e.depth > p.depth && (p = e);
                                });
                                var v = t(d, h) / 2 - d.x, g = r[0] / (h.x + t(h, d) / 2 + v), y = r[1] / (p.depth || 1);
                                nn(u, function(e) {
                                    e.x = (e.x + v) * g, e.y = e.depth * y;
                                });
                            }
                            return c;
                        }
                        function o(e) {
                            var r = e.children, n = e.parent.children, a = e.i ? n[e.i - 1] : null;
                            if (r.length) {
                                !function(e) {
                                    for(var t, r = 0, n = 0, a = e.children, i = a.length; --i >= 0;)(t = a[i]).z += r, t.m += r, r += t.s + (n += t.c);
                                }(e);
                                var i = (r[0].z + r[r.length - 1].z) / 2;
                                a ? (e.z = a.z + t(e._, a._), e.m = e.z - i) : e.z = i;
                            } else a && (e.z = a.z + t(e._, a._));
                            e.parent.A = function(e, r, n) {
                                if (r) {
                                    for(var a, i = e, o = e, l = r, s = i.parent.children[0], c = i.m, u = o.m, f = l.m, d = s.m; l = zn(l), i = Rn(i), l && i;)s = Rn(s), (o = zn(o)).a = e, (a = l.z + f - i.z - c + t(l._, i._)) > 0 && (Nn(Fn(l, e, n), e, a), c += a, u += a), f += l.m, c += i.m, d += s.m, u += o.m;
                                    l && !zn(o) && (o.t = l, o.m += f - u), i && !Rn(s) && (s.t = i, s.m += c - d, n = e);
                                }
                                return n;
                            }(e, a, e.parent.A || n[0]);
                        }
                        function l(e) {
                            e._.x = e.z + e.parent.m, e.m += e.parent.m;
                        }
                        function s(e) {
                            e.x *= r[0], e.y = e.depth * r[1];
                        }
                        return a.separation = function(e) {
                            return arguments.length ? (t = e, a) : t;
                        }, a.size = function(e) {
                            return arguments.length ? (n = null == (r = e) ? s : null, a) : n ? null : r;
                        }, a.nodeSize = function(e) {
                            return arguments.length ? (n = null == (r = e) ? null : s, a) : n ? r : null;
                        }, rn(a, e);
                    }, i.layout.cluster = function() {
                        var e = i.layout.hierarchy().sort(null).value(null), t = In, r = [
                            1,
                            1
                        ], n = !1;
                        function a(a, o) {
                            var l, s = e.call(this, a, o), c = s[0], u = 0;
                            an(c, function(e) {
                                var r = e.children;
                                r && r.length ? (e.x = function(e) {
                                    return e.reduce(function(e, t) {
                                        return e + t.x;
                                    }, 0) / e.length;
                                }(r), e.y = function(e) {
                                    return 1 + i.max(e, function(e) {
                                        return e.y;
                                    });
                                }(r)) : (e.x = l ? u += t(e, l) : 0, e.y = 0, l = e);
                            });
                            var f = En(c), d = Hn(c), h = f.x - t(f, d) / 2, p = d.x + t(d, f) / 2;
                            return an(c, n ? function(e) {
                                e.x = (e.x - c.x) * r[0], e.y = (c.y - e.y) * r[1];
                            } : function(e) {
                                e.x = (e.x - h) / (p - h) * r[0], e.y = (1 - (c.y ? e.y / c.y : 1)) * r[1];
                            }), s;
                        }
                        return a.separation = function(e) {
                            return arguments.length ? (t = e, a) : t;
                        }, a.size = function(e) {
                            return arguments.length ? (n = null == (r = e), a) : n ? null : r;
                        }, a.nodeSize = function(e) {
                            return arguments.length ? (n = null != (r = e), a) : n ? r : null;
                        }, rn(a, e);
                    }, i.layout.treemap = function() {
                        var e, t = i.layout.hierarchy(), r = Math.round, n = [
                            1,
                            1
                        ], a = null, o = jn, l = !1, s = "squarify", c = .5 * (1 + Math.sqrt(5));
                        function u(e, t) {
                            for(var r, n, a = -1, i = e.length; ++a < i;)n = (r = e[a]).value * (t < 0 ? 0 : t), r.area = isNaN(n) || n <= 0 ? 0 : n;
                        }
                        function f(e) {
                            var t = e.children;
                            if (t && t.length) {
                                var r, n, a, i = o(e), l = [], c = t.slice(), d = 1 / 0, v = "slice" === s ? i.dx : "dice" === s ? i.dy : "slice-dice" === s ? 1 & e.depth ? i.dy : i.dx : Math.min(i.dx, i.dy);
                                for(u(c, i.dx * i.dy / e.value), l.area = 0; (a = c.length) > 0;)l.push(r = c[a - 1]), l.area += r.area, "squarify" !== s || (n = h(l, v)) <= d ? (c.pop(), d = n) : (l.area -= l.pop().area, p(l, v, i, !1), v = Math.min(i.dx, i.dy), l.length = l.area = 0, d = 1 / 0);
                                l.length && (p(l, v, i, !0), l.length = l.area = 0), t.forEach(f);
                            }
                        }
                        function d(e) {
                            var t = e.children;
                            if (t && t.length) {
                                var r, n = o(e), a = t.slice(), i = [];
                                for(u(a, n.dx * n.dy / e.value), i.area = 0; r = a.pop();)i.push(r), i.area += r.area, null != r.z && (p(i, r.z ? n.dx : n.dy, n, !a.length), i.length = i.area = 0);
                                t.forEach(d);
                            }
                        }
                        function h(e, t) {
                            for(var r, n = e.area, a = 0, i = 1 / 0, o = -1, l = e.length; ++o < l;)(r = e[o].area) && (r < i && (i = r), r > a && (a = r));
                            return t *= t, (n *= n) ? Math.max(t * a * c / n, n / (t * i * c)) : 1 / 0;
                        }
                        function p(e, t, n, a) {
                            var i, o = -1, l = e.length, s = n.x, c = n.y, u = t ? r(e.area / t) : 0;
                            if (t == n.dx) {
                                for((a || u > n.dy) && (u = n.dy); ++o < l;)(i = e[o]).x = s, i.y = c, i.dy = u, s += i.dx = Math.min(n.x + n.dx - s, u ? r(i.area / u) : 0);
                                i.z = !0, i.dx += n.x + n.dx - s, n.y += u, n.dy -= u;
                            } else {
                                for((a || u > n.dx) && (u = n.dx); ++o < l;)(i = e[o]).x = s, i.y = c, i.dx = u, c += i.dy = Math.min(n.y + n.dy - c, u ? r(i.area / u) : 0);
                                i.z = !1, i.dy += n.y + n.dy - c, n.x += u, n.dx -= u;
                            }
                        }
                        function v(r) {
                            var a = e || t(r), i = a[0];
                            return i.x = i.y = 0, i.value ? (i.dx = n[0], i.dy = n[1]) : i.dx = i.dy = 0, e && t.revalue(i), u([
                                i
                            ], i.dx * i.dy / i.value), (e ? d : f)(i), l && (e = a), a;
                        }
                        return v.size = function(e) {
                            return arguments.length ? (n = e, v) : n;
                        }, v.padding = function(e) {
                            if (!arguments.length) return a;
                            function t(t) {
                                return Bn(t, e);
                            }
                            var r;
                            return o = null == (a = e) ? jn : "function" == (r = typeof e) ? function(t) {
                                var r = e.call(v, t, t.depth);
                                return null == r ? jn(t) : Bn(t, "number" == typeof r ? [
                                    r,
                                    r,
                                    r,
                                    r
                                ] : r);
                            } : "number" === r ? (e = [
                                e,
                                e,
                                e,
                                e
                            ], t) : t, v;
                        }, v.round = function(e) {
                            return arguments.length ? (r = e ? Math.round : Number, v) : r != Number;
                        }, v.sticky = function(t) {
                            return arguments.length ? (l = t, e = null, v) : l;
                        }, v.ratio = function(e) {
                            return arguments.length ? (c = e, v) : c;
                        }, v.mode = function(e) {
                            return arguments.length ? (s = e + "", v) : s;
                        }, rn(v, t);
                    }, i.random = {
                        normal: function(e, t) {
                            var r = arguments.length;
                            return r < 2 && (t = 1), r < 1 && (e = 0), function() {
                                var r, n, a;
                                do a = (r = 2 * Math.random() - 1) * r + (n = 2 * Math.random() - 1) * n;
                                while (!a || a > 1);
                                return e + t * r * Math.sqrt(-2 * Math.log(a) / a);
                            };
                        },
                        logNormal: function() {
                            var e = i.random.normal.apply(i, arguments);
                            return function() {
                                return Math.exp(e());
                            };
                        },
                        bates: function(e) {
                            var t = i.random.irwinHall(e);
                            return function() {
                                return t() / e;
                            };
                        },
                        irwinHall: function(e) {
                            return function() {
                                for(var t = 0, r = 0; r < e; r++)t += Math.random();
                                return t;
                            };
                        }
                    }, i.scale = {};
                    var Zn = {
                        floor: z,
                        ceil: z
                    };
                    function Wn(e, t, r, n) {
                        var a = [], o = [], l = 0, s = Math.min(e.length, t.length) - 1;
                        for(e[s] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++l <= s;)a.push(r(e[l - 1], e[l])), o.push(n(t[l - 1], t[l]));
                        return function(t) {
                            var r = i.bisect(e, t, 1, s) - 1;
                            return o[r](a[r](t));
                        };
                    }
                    function Xn(e, t, r, n) {
                        var a, i;
                        function o() {
                            var o = Math.min(e.length, t.length) > 2 ? Wn : Un, s = n ? qr : Ur;
                            return a = o(e, t, s, r), i = o(t, e, s, Tr), l;
                        }
                        function l(e) {
                            return a(e);
                        }
                        return l.invert = function(e) {
                            return i(e);
                        }, l.domain = function(t) {
                            return arguments.length ? (e = t.map(Number), o()) : e;
                        }, l.range = function(e) {
                            return arguments.length ? (t = e, o()) : t;
                        }, l.rangeRound = function(e) {
                            return l.range(e).interpolate(Fr);
                        }, l.clamp = function(e) {
                            return arguments.length ? (n = e, o()) : n;
                        }, l.interpolate = function(e) {
                            return arguments.length ? (r = e, o()) : r;
                        }, l.ticks = function(t) {
                            return $n(e, t);
                        }, l.tickFormat = function(t, r) {
                            return d3_scale_linearTickFormat(e, t, r);
                        }, l.nice = function(t) {
                            return Kn(e, t), o();
                        }, l.copy = function() {
                            return Xn(e, t, r, n);
                        }, o();
                    }
                    function Jn(e, t) {
                        return i.rebind(e, t, "range", "rangeRound", "interpolate", "clamp");
                    }
                    function Kn(e, t) {
                        return qn(e, Gn(Qn(e, t)[2])), qn(e, Gn(Qn(e, t)[2])), e;
                    }
                    function Qn(e, t) {
                        null == t && (t = 10);
                        var r = Yn(e), n = r[1] - r[0], a = Math.pow(10, Math.floor(Math.log(n / t) / Math.LN10)), i = t / n * a;
                        return i <= .15 ? a *= 10 : i <= .35 ? a *= 5 : i <= .75 && (a *= 2), r[0] = Math.ceil(r[0] / a) * a, r[1] = Math.floor(r[1] / a) * a + .5 * a, r[2] = a, r;
                    }
                    function $n(e, t) {
                        return i.range.apply(i, Qn(e, t));
                    }
                    function ea(e, t, r, n) {
                        function a(e) {
                            return (r ? Math.log(e < 0 ? 0 : e) : -Math.log(e > 0 ? 0 : -e)) / Math.log(t);
                        }
                        function i(e) {
                            return r ? Math.pow(t, e) : -Math.pow(t, -e);
                        }
                        function o(t) {
                            return e(a(t));
                        }
                        return o.invert = function(t) {
                            return i(e.invert(t));
                        }, o.domain = function(t) {
                            return arguments.length ? (r = t[0] >= 0, e.domain((n = t.map(Number)).map(a)), o) : n;
                        }, o.base = function(r) {
                            return arguments.length ? (t = +r, e.domain(n.map(a)), o) : t;
                        }, o.nice = function() {
                            var t = qn(n.map(a), r ? Math : ta);
                            return e.domain(t), n = t.map(i), o;
                        }, o.ticks = function() {
                            var e = Yn(n), o = [], l = e[0], s = e[1], c = Math.floor(a(l)), u = Math.ceil(a(s)), f = t % 1 ? 2 : t;
                            if (isFinite(u - c)) {
                                if (r) {
                                    for(; c < u; c++)for(var d = 1; d < f; d++)o.push(i(c) * d);
                                    o.push(i(c));
                                } else for(o.push(i(c)); c++ < u;)for(d = f - 1; d > 0; d--)o.push(i(c) * d);
                                for(c = 0; o[c] < l; c++);
                                for(u = o.length; o[u - 1] > s; u--);
                                o = o.slice(c, u);
                            }
                            return o;
                        }, o.copy = function() {
                            return ea(e.copy(), t, r, n);
                        }, Jn(o, e);
                    }
                    i.scale.linear = function() {
                        return Xn([
                            0,
                            1
                        ], [
                            0,
                            1
                        ], Tr, !1);
                    }, i.scale.log = function() {
                        return ea(i.scale.linear().domain([
                            0,
                            1
                        ]), 10, !0, [
                            1,
                            10
                        ]);
                    };
                    var ta = {
                        floor: function(e) {
                            return -Math.ceil(-e);
                        },
                        ceil: function(e) {
                            return -Math.floor(-e);
                        }
                    };
                    function ra(e, t, r) {
                        var n = na(t), a = na(1 / t);
                        function i(t) {
                            return e(n(t));
                        }
                        return i.invert = function(t) {
                            return a(e.invert(t));
                        }, i.domain = function(t) {
                            return arguments.length ? (e.domain((r = t.map(Number)).map(n)), i) : r;
                        }, i.ticks = function(e) {
                            return $n(r, e);
                        }, i.tickFormat = function(e, t) {
                            return d3_scale_linearTickFormat(r, e, t);
                        }, i.nice = function(e) {
                            return i.domain(Kn(r, e));
                        }, i.exponent = function(o) {
                            return arguments.length ? (n = na(t = o), a = na(1 / t), e.domain(r.map(n)), i) : t;
                        }, i.copy = function() {
                            return ra(e.copy(), t, r);
                        }, Jn(i, e);
                    }
                    function na(e) {
                        return function(t) {
                            return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
                        };
                    }
                    function aa(e, t) {
                        var r, n, a;
                        function o(a) {
                            return n[((r.get(a) || ("range" === t.t ? r.set(a, e.push(a)) : NaN)) - 1) % n.length];
                        }
                        function l(t, r) {
                            return i.range(e.length).map(function(e) {
                                return t + r * e;
                            });
                        }
                        return o.domain = function(n) {
                            if (!arguments.length) return e;
                            e = [], r = new M;
                            for(var a, i = -1, l = n.length; ++i < l;)r.has(a = n[i]) || r.set(a, e.push(a));
                            return o[t.t].apply(o, t.a);
                        }, o.range = function(e) {
                            return arguments.length ? (n = e, a = 0, t = {
                                t: "range",
                                a: arguments
                            }, o) : n;
                        }, o.rangePoints = function(r, i) {
                            arguments.length < 2 && (i = 0);
                            var s = r[0], c = r[1], u = e.length < 2 ? (s = (s + c) / 2, 0) : (c - s) / (e.length - 1 + i);
                            return n = l(s + u * i / 2, u), a = 0, t = {
                                t: "rangePoints",
                                a: arguments
                            }, o;
                        }, o.rangeRoundPoints = function(r, i) {
                            arguments.length < 2 && (i = 0);
                            var s = r[0], c = r[1], u = e.length < 2 ? (s = c = Math.round((s + c) / 2), 0) : (c - s) / (e.length - 1 + i) | 0;
                            return n = l(s + Math.round(u * i / 2 + (c - s - (e.length - 1 + i) * u) / 2), u), a = 0, t = {
                                t: "rangeRoundPoints",
                                a: arguments
                            }, o;
                        }, o.rangeBands = function(r, i, s) {
                            arguments.length < 2 && (i = 0), arguments.length < 3 && (s = i);
                            var c = r[1] < r[0], u = r[c - 0], f = (r[1 - c] - u) / (e.length - i + 2 * s);
                            return n = l(u + f * s, f), c && n.reverse(), a = f * (1 - i), t = {
                                t: "rangeBands",
                                a: arguments
                            }, o;
                        }, o.rangeRoundBands = function(r, i, s) {
                            arguments.length < 2 && (i = 0), arguments.length < 3 && (s = i);
                            var c = r[1] < r[0], u = r[c - 0], f = r[1 - c], d = Math.floor((f - u) / (e.length - i + 2 * s));
                            return n = l(u + Math.round((f - u - (e.length - i) * d) / 2), d), c && n.reverse(), a = Math.round(d * (1 - i)), t = {
                                t: "rangeRoundBands",
                                a: arguments
                            }, o;
                        }, o.rangeBand = function() {
                            return a;
                        }, o.rangeExtent = function() {
                            return Yn(t.a[0]);
                        }, o.copy = function() {
                            return aa(e, t);
                        }, o.domain(e);
                    }
                    i.scale.pow = function() {
                        return ra(i.scale.linear(), 1, [
                            0,
                            1
                        ]);
                    }, i.scale.sqrt = function() {
                        return i.scale.pow().exponent(.5);
                    }, i.scale.ordinal = function() {
                        return aa([], {
                            t: "range",
                            a: [
                                []
                            ]
                        });
                    }, i.scale.category10 = function() {
                        return i.scale.ordinal().range(ia);
                    }, i.scale.category20 = function() {
                        return i.scale.ordinal().range(oa);
                    }, i.scale.category20b = function() {
                        return i.scale.ordinal().range(la);
                    }, i.scale.category20c = function() {
                        return i.scale.ordinal().range(sa);
                    };
                    var ia = [
                        2062260,
                        16744206,
                        2924588,
                        14034728,
                        9725885,
                        9197131,
                        14907330,
                        8355711,
                        12369186,
                        1556175
                    ].map(lt), oa = [
                        2062260,
                        11454440,
                        16744206,
                        16759672,
                        2924588,
                        10018698,
                        14034728,
                        16750742,
                        9725885,
                        12955861,
                        9197131,
                        12885140,
                        14907330,
                        16234194,
                        8355711,
                        13092807,
                        12369186,
                        14408589,
                        1556175,
                        10410725
                    ].map(lt), la = [
                        3750777,
                        5395619,
                        7040719,
                        10264286,
                        6519097,
                        9216594,
                        11915115,
                        13556636,
                        9202993,
                        12426809,
                        15186514,
                        15190932,
                        8666169,
                        11356490,
                        14049643,
                        15177372,
                        8077683,
                        10834324,
                        13528509,
                        14589654
                    ].map(lt), sa = [
                        3244733,
                        7057110,
                        10406625,
                        13032431,
                        15095053,
                        16616764,
                        16625259,
                        16634018,
                        3253076,
                        7652470,
                        10607003,
                        13101504,
                        7695281,
                        10394312,
                        12369372,
                        14342891,
                        6513507,
                        9868950,
                        12434877,
                        14277081
                    ].map(lt);
                    function ca(e, t) {
                        var r;
                        function n() {
                            var n = 0, o = t.length;
                            for(r = []; ++n < o;)r[n - 1] = i.quantile(e, n / o);
                            return a;
                        }
                        function a(e) {
                            if (!isNaN(e = +e)) return t[i.bisect(r, e)];
                        }
                        return a.domain = function(t) {
                            return arguments.length ? (e = t.map(y).filter(m).sort(g), n()) : e;
                        }, a.range = function(e) {
                            return arguments.length ? (t = e, n()) : t;
                        }, a.quantiles = function() {
                            return r;
                        }, a.invertExtent = function(n) {
                            return (n = t.indexOf(n)) < 0 ? [
                                NaN,
                                NaN
                            ] : [
                                n > 0 ? r[n - 1] : e[0],
                                n < r.length ? r[n] : e[e.length - 1]
                            ];
                        }, a.copy = function() {
                            return ca(e, t);
                        }, n();
                    }
                    function ua(e, t, r) {
                        var n, a;
                        function i(t) {
                            return r[Math.max(0, Math.min(a, Math.floor(n * (t - e))))];
                        }
                        function o() {
                            return n = r.length / (t - e), a = r.length - 1, i;
                        }
                        return i.domain = function(r) {
                            return arguments.length ? (e = +r[0], t = +r[r.length - 1], o()) : [
                                e,
                                t
                            ];
                        }, i.range = function(e) {
                            return arguments.length ? (r = e, o()) : r;
                        }, i.invertExtent = function(t) {
                            return [
                                t = (t = r.indexOf(t)) < 0 ? NaN : t / n + e,
                                t + 1 / n
                            ];
                        }, i.copy = function() {
                            return ua(e, t, r);
                        }, o();
                    }
                    function fa(e, t) {
                        function r(r) {
                            if (r <= r) return t[i.bisect(e, r)];
                        }
                        return r.domain = function(t) {
                            return arguments.length ? (e = t, r) : e;
                        }, r.range = function(e) {
                            return arguments.length ? (t = e, r) : t;
                        }, r.invertExtent = function(r) {
                            return r = t.indexOf(r), [
                                e[r - 1],
                                e[r]
                            ];
                        }, r.copy = function() {
                            return fa(e, t);
                        }, r;
                    }
                    function da(e) {
                        function t(e) {
                            return +e;
                        }
                        return t.invert = t, t.domain = t.range = function(r) {
                            return arguments.length ? (e = r.map(t), t) : e;
                        }, t.ticks = function(t) {
                            return $n(e, t);
                        }, t.tickFormat = function(t, r) {
                            return d3_scale_linearTickFormat(e, t, r);
                        }, t.copy = function() {
                            return da(e);
                        }, t;
                    }
                    function ha() {
                        return 0;
                    }
                    i.scale.quantile = function() {
                        return ca([], []);
                    }, i.scale.quantize = function() {
                        return ua(0, 1, [
                            0,
                            1
                        ]);
                    }, i.scale.threshold = function() {
                        return fa([
                            .5
                        ], [
                            0,
                            1
                        ]);
                    }, i.scale.identity = function() {
                        return da([
                            0,
                            1
                        ]);
                    }, i.svg = {}, i.svg.arc = function() {
                        var e = va, t = ga, r = ha, n = pa, a = ya, i = ma, o = xa;
                        function l() {
                            var l = Math.max(0, +e.apply(this, arguments)), c = Math.max(0, +t.apply(this, arguments)), u = a.apply(this, arguments) - Ie, f = i.apply(this, arguments) - Ie, d = Math.abs(f - u), h = u > f ? 0 : 1;
                            if (c < l && (p = c, c = l, l = p), d >= Pe) return s(c, h) + (l ? s(l, 1 - h) : "") + "Z";
                            var p, v, g, y, m, x, b, _, w, T, M, k, A = 0, L = 0, S = [];
                            if ((y = (+o.apply(this, arguments) || 0) / 2) && (g = n === pa ? Math.sqrt(l * l + c * c) : +n.apply(this, arguments), h || (L *= -1), c && (L = Ne(g / c * Math.sin(y))), l && (A = Ne(g / l * Math.sin(y)))), c) {
                                m = c * Math.cos(u + L), x = c * Math.sin(u + L), b = c * Math.cos(f - L), _ = c * Math.sin(f - L);
                                var D = Math.abs(f - u - 2 * L) <= Oe ? 0 : 1;
                                if (L && ba(m, x, b, _) === h ^ D) {
                                    var O = (u + f) / 2;
                                    m = c * Math.cos(O), x = c * Math.sin(O), b = _ = null;
                                }
                            } else m = x = 0;
                            if (l) {
                                w = l * Math.cos(f - A), T = l * Math.sin(f - A), M = l * Math.cos(u + A), k = l * Math.sin(u + A);
                                var C = Math.abs(u - f + 2 * A) <= Oe ? 0 : 1;
                                if (A && ba(w, T, M, k) === 1 - h ^ C) {
                                    var P = (u + f) / 2;
                                    w = l * Math.cos(P), T = l * Math.sin(P), M = k = null;
                                }
                            } else w = T = 0;
                            if (d > Se && (p = Math.min(Math.abs(c - l) / 2, +r.apply(this, arguments))) > .001) {
                                v = l < c ^ h ? 0 : 1;
                                var I = p, R = p;
                                if (d < Oe) {
                                    var z = null == M ? [
                                        w,
                                        T
                                    ] : null == b ? [
                                        m,
                                        x
                                    ] : Rt([
                                        m,
                                        x
                                    ], [
                                        M,
                                        k
                                    ], [
                                        b,
                                        _
                                    ], [
                                        w,
                                        T
                                    ]), N = m - z[0], F = x - z[1], E = b - z[0], H = _ - z[1], j = 1 / Math.sin(Math.acos((N * E + F * H) / (Math.sqrt(N * N + F * F) * Math.sqrt(E * E + H * H))) / 2), B = Math.sqrt(z[0] * z[0] + z[1] * z[1]);
                                    R = Math.min(p, (l - B) / (j - 1)), I = Math.min(p, (c - B) / (j + 1));
                                }
                                if (null != b) {
                                    var Y = _a(null == M ? [
                                        w,
                                        T
                                    ] : [
                                        M,
                                        k
                                    ], [
                                        m,
                                        x
                                    ], c, I, h), V = _a([
                                        b,
                                        _
                                    ], [
                                        w,
                                        T
                                    ], c, I, h);
                                    p === I ? S.push("M", Y[0], "A", I, ",", I, " 0 0,", v, " ", Y[1], "A", c, ",", c, " 0 ", 1 - h ^ ba(Y[1][0], Y[1][1], V[1][0], V[1][1]), ",", h, " ", V[1], "A", I, ",", I, " 0 0,", v, " ", V[0]) : S.push("M", Y[0], "A", I, ",", I, " 0 1,", v, " ", V[0]);
                                } else S.push("M", m, ",", x);
                                if (null != M) {
                                    var U = _a([
                                        m,
                                        x
                                    ], [
                                        M,
                                        k
                                    ], l, -R, h), q = _a([
                                        w,
                                        T
                                    ], null == b ? [
                                        m,
                                        x
                                    ] : [
                                        b,
                                        _
                                    ], l, -R, h);
                                    p === R ? S.push("L", q[0], "A", R, ",", R, " 0 0,", v, " ", q[1], "A", l, ",", l, " 0 ", h ^ ba(q[1][0], q[1][1], U[1][0], U[1][1]), ",", 1 - h, " ", U[1], "A", R, ",", R, " 0 0,", v, " ", U[0]) : S.push("L", q[0], "A", R, ",", R, " 0 0,", v, " ", U[0]);
                                } else S.push("L", w, ",", T);
                            } else S.push("M", m, ",", x), null != b && S.push("A", c, ",", c, " 0 ", D, ",", h, " ", b, ",", _), S.push("L", w, ",", T), null != M && S.push("A", l, ",", l, " 0 ", C, ",", 1 - h, " ", M, ",", k);
                            return S.push("Z"), S.join("");
                        }
                        function s(e, t) {
                            return "M0," + e + "A" + e + "," + e + " 0 1," + t + " 0," + -e + "A" + e + "," + e + " 0 1," + t + " 0," + e;
                        }
                        return l.innerRadius = function(t) {
                            return arguments.length ? (e = gt(t), l) : e;
                        }, l.outerRadius = function(e) {
                            return arguments.length ? (t = gt(e), l) : t;
                        }, l.cornerRadius = function(e) {
                            return arguments.length ? (r = gt(e), l) : r;
                        }, l.padRadius = function(e) {
                            return arguments.length ? (n = e == pa ? pa : gt(e), l) : n;
                        }, l.startAngle = function(e) {
                            return arguments.length ? (a = gt(e), l) : a;
                        }, l.endAngle = function(e) {
                            return arguments.length ? (i = gt(e), l) : i;
                        }, l.padAngle = function(e) {
                            return arguments.length ? (o = gt(e), l) : o;
                        }, l.centroid = function() {
                            var r = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, n = (+a.apply(this, arguments) + +i.apply(this, arguments)) / 2 - Ie;
                            return [
                                Math.cos(n) * r,
                                Math.sin(n) * r
                            ];
                        }, l;
                    };
                    var pa = "auto";
                    function va(e) {
                        return e.innerRadius;
                    }
                    function ga(e) {
                        return e.outerRadius;
                    }
                    function ya(e) {
                        return e.startAngle;
                    }
                    function ma(e) {
                        return e.endAngle;
                    }
                    function xa(e) {
                        return e && e.padAngle;
                    }
                    function ba(e, t, r, n) {
                        return (e - r) * t - (t - n) * e > 0 ? 0 : 1;
                    }
                    function _a(e, t, r, n, a) {
                        var i = e[0] - t[0], o = e[1] - t[1], l = (a ? n : -n) / Math.sqrt(i * i + o * o), s = l * o, c = -l * i, u = e[0] + s, f = e[1] + c, d = t[0] + s, h = t[1] + c, p = (u + d) / 2, v = (f + h) / 2, g = d - u, y = h - f, m = g * g + y * y, x = r - n, b = u * h - d * f, _ = (y < 0 ? -1 : 1) * Math.sqrt(Math.max(0, x * x * m - b * b)), w = (b * y - g * _) / m, T = (-b * g - y * _) / m, M = (b * y + g * _) / m, k = (-b * g + y * _) / m, A = w - p, L = T - v, S = M - p, D = k - v;
                        return A * A + L * L > S * S + D * D && (w = M, T = k), [
                            [
                                w - s,
                                T - c
                            ],
                            [
                                w * r / x,
                                T * r / x
                            ]
                        ];
                    }
                    function wa() {
                        return !0;
                    }
                    function Ta(e) {
                        var t = St, r = Dt, n = wa, a = ka, i = a.key, o = .7;
                        function l(i) {
                            var l, s = [], c = [], u = -1, f = i.length, d = gt(t), h = gt(r);
                            function p() {
                                s.push("M", a(e(c), o));
                            }
                            for(; ++u < f;)n.call(this, l = i[u], u) ? c.push([
                                +d.call(this, l, u),
                                +h.call(this, l, u)
                            ]) : c.length && (p(), c = []);
                            return c.length && p(), s.length ? s.join("") : null;
                        }
                        return l.x = function(e) {
                            return arguments.length ? (t = e, l) : t;
                        }, l.y = function(e) {
                            return arguments.length ? (r = e, l) : r;
                        }, l.defined = function(e) {
                            return arguments.length ? (n = e, l) : n;
                        }, l.interpolate = function(e) {
                            return arguments.length ? (i = "function" == typeof e ? a = e : (a = Ma.get(e) || ka).key, l) : i;
                        }, l.tension = function(e) {
                            return arguments.length ? (o = e, l) : o;
                        }, l;
                    }
                    i.svg.line = function() {
                        return Ta(z);
                    };
                    var Ma = i.map({
                        linear: ka,
                        "linear-closed": Aa,
                        step: function(e) {
                            for(var t = 0, r = e.length, n = e[0], a = [
                                n[0],
                                ",",
                                n[1]
                            ]; ++t < r;)a.push("H", (n[0] + (n = e[t])[0]) / 2, "V", n[1]);
                            return r > 1 && a.push("H", n[0]), a.join("");
                        },
                        "step-before": La,
                        "step-after": Sa,
                        basis: Ca,
                        "basis-open": function(e) {
                            if (e.length < 4) return ka(e);
                            for(var t, r = [], n = -1, a = e.length, i = [
                                0
                            ], o = [
                                0
                            ]; ++n < 3;)t = e[n], i.push(t[0]), o.push(t[1]);
                            for(r.push(Pa(za, i) + "," + Pa(za, o)), --n; ++n < a;)t = e[n], i.shift(), i.push(t[0]), o.shift(), o.push(t[1]), Na(r, i, o);
                            return r.join("");
                        },
                        "basis-closed": function(e) {
                            for(var t, r, n = -1, a = e.length, i = a + 4, o = [], l = []; ++n < 4;)r = e[n % a], o.push(r[0]), l.push(r[1]);
                            for(t = [
                                Pa(za, o),
                                ",",
                                Pa(za, l)
                            ], --n; ++n < i;)r = e[n % a], o.shift(), o.push(r[0]), l.shift(), l.push(r[1]), Na(t, o, l);
                            return t.join("");
                        },
                        bundle: function(e, t) {
                            var r = e.length - 1;
                            if (r) for(var n, a, i = e[0][0], o = e[0][1], l = e[r][0] - i, s = e[r][1] - o, c = -1; ++c <= r;)a = c / r, (n = e[c])[0] = t * n[0] + (1 - t) * (i + a * l), n[1] = t * n[1] + (1 - t) * (o + a * s);
                            return Ca(e);
                        },
                        cardinal: function(e, t) {
                            return e.length < 3 ? ka(e) : e[0] + Da(e, Oa(e, t));
                        },
                        "cardinal-open": function(e, t) {
                            return e.length < 4 ? ka(e) : e[1] + Da(e.slice(1, -1), Oa(e, t));
                        },
                        "cardinal-closed": function(e, t) {
                            return e.length < 3 ? Aa(e) : e[0] + Da((e.push(e[0]), e), Oa([
                                e[e.length - 2]
                            ].concat(e, [
                                e[1]
                            ]), t));
                        },
                        monotone: function(e) {
                            return e.length < 3 ? ka(e) : e[0] + Da(e, function(e) {
                                for(var t, r, n, a, i = [], o = function(e) {
                                    for(var t = 0, r = e.length - 1, n = [], a = e[0], i = e[1], o = n[0] = Fa(a, i); ++t < r;)n[t] = (o + (o = Fa(a = i, i = e[t + 1]))) / 2;
                                    return n[t] = o, n;
                                }(e), l = -1, s = e.length - 1; ++l < s;)t = Fa(e[l], e[l + 1]), w(t) < Se ? o[l] = o[l + 1] = 0 : (a = (r = o[l] / t) * r + (n = o[l + 1] / t) * n) > 9 && (a = 3 * t / Math.sqrt(a), o[l] = a * r, o[l + 1] = a * n);
                                for(l = -1; ++l <= s;)a = (e[Math.min(s, l + 1)][0] - e[Math.max(0, l - 1)][0]) / (6 * (1 + o[l] * o[l])), i.push([
                                    a || 0,
                                    o[l] * a || 0
                                ]);
                                return i;
                            }(e));
                        }
                    });
                    function ka(e) {
                        return e.length > 1 ? e.join("L") : e + "Z";
                    }
                    function Aa(e) {
                        return e.join("L") + "Z";
                    }
                    function La(e) {
                        for(var t = 0, r = e.length, n = e[0], a = [
                            n[0],
                            ",",
                            n[1]
                        ]; ++t < r;)a.push("V", (n = e[t])[1], "H", n[0]);
                        return a.join("");
                    }
                    function Sa(e) {
                        for(var t = 0, r = e.length, n = e[0], a = [
                            n[0],
                            ",",
                            n[1]
                        ]; ++t < r;)a.push("H", (n = e[t])[0], "V", n[1]);
                        return a.join("");
                    }
                    function Da(e, t) {
                        if (t.length < 1 || e.length != t.length && e.length != t.length + 2) return ka(e);
                        var r = e.length != t.length, n = "", a = e[0], i = e[1], o = t[0], l = o, s = 1;
                        if (r && (n += "Q" + (i[0] - 2 * o[0] / 3) + "," + (i[1] - 2 * o[1] / 3) + "," + i[0] + "," + i[1], a = e[1], s = 2), t.length > 1) {
                            l = t[1], i = e[s], s++, n += "C" + (a[0] + o[0]) + "," + (a[1] + o[1]) + "," + (i[0] - l[0]) + "," + (i[1] - l[1]) + "," + i[0] + "," + i[1];
                            for(var c = 2; c < t.length; c++, s++)i = e[s], l = t[c], n += "S" + (i[0] - l[0]) + "," + (i[1] - l[1]) + "," + i[0] + "," + i[1];
                        }
                        if (r) {
                            var u = e[s];
                            n += "Q" + (i[0] + 2 * l[0] / 3) + "," + (i[1] + 2 * l[1] / 3) + "," + u[0] + "," + u[1];
                        }
                        return n;
                    }
                    function Oa(e, t) {
                        for(var r, n = [], a = (1 - t) / 2, i = e[0], o = e[1], l = 1, s = e.length; ++l < s;)r = i, i = o, o = e[l], n.push([
                            a * (o[0] - r[0]),
                            a * (o[1] - r[1])
                        ]);
                        return n;
                    }
                    function Ca(e) {
                        if (e.length < 3) return ka(e);
                        var t = 1, r = e.length, n = e[0], a = n[0], i = n[1], o = [
                            a,
                            a,
                            a,
                            (n = e[1])[0]
                        ], l = [
                            i,
                            i,
                            i,
                            n[1]
                        ], s = [
                            a,
                            ",",
                            i,
                            "L",
                            Pa(za, o),
                            ",",
                            Pa(za, l)
                        ];
                        for(e.push(e[r - 1]); ++t <= r;)n = e[t], o.shift(), o.push(n[0]), l.shift(), l.push(n[1]), Na(s, o, l);
                        return e.pop(), s.push("L", n), s.join("");
                    }
                    function Pa(e, t) {
                        return e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3] * t[3];
                    }
                    Ma.forEach(function(e, t) {
                        t.key = e, t.closed = /-closed$/.test(e);
                    });
                    var Ia = [
                        0,
                        2 / 3,
                        1 / 3,
                        0
                    ], Ra = [
                        0,
                        1 / 3,
                        2 / 3,
                        0
                    ], za = [
                        0,
                        1 / 6,
                        2 / 3,
                        1 / 6
                    ];
                    function Na(e, t, r) {
                        e.push("C", Pa(Ia, t), ",", Pa(Ia, r), ",", Pa(Ra, t), ",", Pa(Ra, r), ",", Pa(za, t), ",", Pa(za, r));
                    }
                    function Fa(e, t) {
                        return (t[1] - e[1]) / (t[0] - e[0]);
                    }
                    function Ea(e) {
                        for(var t, r, n, a = -1, i = e.length; ++a < i;)r = (t = e[a])[0], n = t[1] - Ie, t[0] = r * Math.cos(n), t[1] = r * Math.sin(n);
                        return e;
                    }
                    function Ha(e) {
                        var t = St, r = St, n = 0, a = Dt, i = wa, o = ka, l = o.key, s = o, c = "L", u = .7;
                        function f(l) {
                            var f, d, h, p = [], v = [], g = [], y = -1, m = l.length, x = gt(t), b = gt(n), _ = t === r ? function() {
                                return d;
                            } : gt(r), w = n === a ? function() {
                                return h;
                            } : gt(a);
                            function T() {
                                p.push("M", o(e(g), u), c, s(e(v.reverse()), u), "Z");
                            }
                            for(; ++y < m;)i.call(this, f = l[y], y) ? (v.push([
                                d = +x.call(this, f, y),
                                h = +b.call(this, f, y)
                            ]), g.push([
                                +_.call(this, f, y),
                                +w.call(this, f, y)
                            ])) : v.length && (T(), v = [], g = []);
                            return v.length && T(), p.length ? p.join("") : null;
                        }
                        return f.x = function(e) {
                            return arguments.length ? (t = r = e, f) : r;
                        }, f.x0 = function(e) {
                            return arguments.length ? (t = e, f) : t;
                        }, f.x1 = function(e) {
                            return arguments.length ? (r = e, f) : r;
                        }, f.y = function(e) {
                            return arguments.length ? (n = a = e, f) : a;
                        }, f.y0 = function(e) {
                            return arguments.length ? (n = e, f) : n;
                        }, f.y1 = function(e) {
                            return arguments.length ? (a = e, f) : a;
                        }, f.defined = function(e) {
                            return arguments.length ? (i = e, f) : i;
                        }, f.interpolate = function(e) {
                            return arguments.length ? (l = "function" == typeof e ? o = e : (o = Ma.get(e) || ka).key, s = o.reverse || o, c = o.closed ? "M" : "L", f) : l;
                        }, f.tension = function(e) {
                            return arguments.length ? (u = e, f) : u;
                        }, f;
                    }
                    function ja(e) {
                        return e.source;
                    }
                    function Ba(e) {
                        return e.target;
                    }
                    function Ya(e) {
                        return e.radius;
                    }
                    function Va(e) {
                        return [
                            e.x,
                            e.y
                        ];
                    }
                    function Ua() {
                        return 64;
                    }
                    function qa() {
                        return "circle";
                    }
                    function Ga(e) {
                        var t = Math.sqrt(e / Oe);
                        return "M0," + t + "A" + t + "," + t + " 0 1,1 0," + -t + "A" + t + "," + t + " 0 1,1 0," + t + "Z";
                    }
                    i.svg.line.radial = function() {
                        var e = Ta(Ea);
                        return e.radius = e.x, delete e.x, e.angle = e.y, delete e.y, e;
                    }, La.reverse = Sa, Sa.reverse = La, i.svg.area = function() {
                        return Ha(z);
                    }, i.svg.area.radial = function() {
                        var e = Ha(Ea);
                        return e.radius = e.x, delete e.x, e.innerRadius = e.x0, delete e.x0, e.outerRadius = e.x1, delete e.x1, e.angle = e.y, delete e.y, e.startAngle = e.y0, delete e.y0, e.endAngle = e.y1, delete e.y1, e;
                    }, i.svg.chord = function() {
                        var e = ja, t = Ba, r = Ya, n = ya, a = ma;
                        function i(r, n) {
                            var a, i, c = o(this, e, r, n), u = o(this, t, r, n);
                            return "M" + c.p0 + l(c.r, c.p1, c.a1 - c.a0) + (i = u, ((a = c).a0 == i.a0 && a.a1 == i.a1 ? s(c.r, c.p1, c.r, c.p0) : s(c.r, c.p1, u.r, u.p0) + l(u.r, u.p1, u.a1 - u.a0) + s(u.r, u.p1, c.r, c.p0)) + "Z");
                        }
                        function o(e, t, i, o) {
                            var l = t.call(e, i, o), s = r.call(e, l, o), c = n.call(e, l, o) - Ie, u = a.call(e, l, o) - Ie;
                            return {
                                r: s,
                                a0: c,
                                a1: u,
                                p0: [
                                    s * Math.cos(c),
                                    s * Math.sin(c)
                                ],
                                p1: [
                                    s * Math.cos(u),
                                    s * Math.sin(u)
                                ]
                            };
                        }
                        function l(e, t, r) {
                            return "A" + e + "," + e + " 0 " + +(r > Oe) + ",1 " + t;
                        }
                        function s(e, t, r, n) {
                            return "Q 0,0 " + n;
                        }
                        return i.radius = function(e) {
                            return arguments.length ? (r = gt(e), i) : r;
                        }, i.source = function(t) {
                            return arguments.length ? (e = gt(t), i) : e;
                        }, i.target = function(e) {
                            return arguments.length ? (t = gt(e), i) : t;
                        }, i.startAngle = function(e) {
                            return arguments.length ? (n = gt(e), i) : n;
                        }, i.endAngle = function(e) {
                            return arguments.length ? (a = gt(e), i) : a;
                        }, i;
                    }, i.svg.diagonal = function() {
                        var e = ja, t = Ba, r = Va;
                        function n(n, a) {
                            var i = e.call(this, n, a), o = t.call(this, n, a), l = (i.y + o.y) / 2, s = [
                                i,
                                {
                                    x: i.x,
                                    y: l
                                },
                                {
                                    x: o.x,
                                    y: l
                                },
                                o
                            ];
                            return "M" + (s = s.map(r))[0] + "C" + s[1] + " " + s[2] + " " + s[3];
                        }
                        return n.source = function(t) {
                            return arguments.length ? (e = gt(t), n) : e;
                        }, n.target = function(e) {
                            return arguments.length ? (t = gt(e), n) : t;
                        }, n.projection = function(e) {
                            return arguments.length ? (r = e, n) : r;
                        }, n;
                    }, i.svg.diagonal.radial = function() {
                        var e = i.svg.diagonal(), t = Va, r = e.projection;
                        return e.projection = function(e) {
                            return arguments.length ? r(function(e) {
                                return function() {
                                    var t = e.apply(this, arguments), r = t[0], n = t[1] - Ie;
                                    return [
                                        r * Math.cos(n),
                                        r * Math.sin(n)
                                    ];
                                };
                            }(t = e)) : t;
                        }, e;
                    }, i.svg.symbol = function() {
                        var e = qa, t = Ua;
                        function r(r, n) {
                            return (Za.get(e.call(this, r, n)) || Ga)(t.call(this, r, n));
                        }
                        return r.type = function(t) {
                            return arguments.length ? (e = gt(t), r) : e;
                        }, r.size = function(e) {
                            return arguments.length ? (t = gt(e), r) : t;
                        }, r;
                    };
                    var Za = i.map({
                        circle: Ga,
                        cross: function(e) {
                            var t = Math.sqrt(e / 5) / 2;
                            return "M" + -3 * t + "," + -t + "H" + -t + "V" + -3 * t + "H" + t + "V" + -t + "H" + 3 * t + "V" + t + "H" + t + "V" + 3 * t + "H" + -t + "V" + t + "H" + -3 * t + "Z";
                        },
                        diamond: function(e) {
                            var t = Math.sqrt(e / (2 * Xa)), r = t * Xa;
                            return "M0," + -t + "L" + r + ",0 0," + t + " " + -r + ",0Z";
                        },
                        square: function(e) {
                            var t = Math.sqrt(e) / 2;
                            return "M" + -t + "," + -t + "L" + t + "," + -t + " " + t + "," + t + " " + -t + "," + t + "Z";
                        },
                        "triangle-down": function(e) {
                            var t = Math.sqrt(e / Wa), r = t * Wa / 2;
                            return "M0," + r + "L" + t + "," + -r + " " + -t + "," + -r + "Z";
                        },
                        "triangle-up": function(e) {
                            var t = Math.sqrt(e / Wa), r = t * Wa / 2;
                            return "M0," + -r + "L" + t + "," + r + " " + -t + "," + r + "Z";
                        }
                    });
                    i.svg.symbolTypes = Za.keys();
                    var Wa = Math.sqrt(3), Xa = Math.tan(30 * Re);
                    K.transition = function(e) {
                        for(var t, r, n = $a || ++ri, a = ii(e), i = [], o = ei || {
                            time: Date.now(),
                            ease: Pr,
                            delay: 0,
                            duration: 250
                        }, l = -1, s = this.length; ++l < s;){
                            i.push(t = []);
                            for(var c = this[l], u = -1, f = c.length; ++u < f;)(r = c[u]) && oi(r, u, a, n, o), t.push(r);
                        }
                        return Qa(i, a, n);
                    }, K.interrupt = function(e) {
                        return this.each(null == e ? Ja : Ka(ii(e)));
                    };
                    var Ja = Ka(ii());
                    function Ka(e) {
                        return function() {
                            var t, r, n;
                            (t = this[e]) && (n = t[r = t.active]) && (n.timer.c = null, n.timer.t = NaN, --t.count ? delete t[r] : delete this[e], t.active += .5, n.event && n.event.interrupt.call(this, this.__data__, n.index));
                        };
                    }
                    function Qa(e, t, r) {
                        return G(e, ti), e.namespace = t, e.id = r, e;
                    }
                    var $a, ei, ti = [], ri = 0;
                    function ni(e, t, r, n) {
                        var a = e.id, i = e.namespace;
                        return ve(e, "function" == typeof r ? function(e, o, l) {
                            e[i][a].tween.set(t, n(r.call(e, e.__data__, o, l)));
                        } : (r = n(r), function(e) {
                            e[i][a].tween.set(t, r);
                        }));
                    }
                    function ai(e) {
                        return null == e && (e = ""), function() {
                            this.textContent = e;
                        };
                    }
                    function ii(e) {
                        return null == e ? "__transition__" : "__transition_" + e + "__";
                    }
                    function oi(e, t, r, n, a) {
                        var i, o, l, s, c, u = e[r] || (e[r] = {
                            active: 0,
                            count: 0
                        }), f = u[n];
                        function d(r) {
                            var a = u.active, d = u[a];
                            for(var p in d && (d.timer.c = null, d.timer.t = NaN, --u.count, delete u[a], d.event && d.event.interrupt.call(e, e.__data__, d.index)), u)if (+p < n) {
                                var v = u[p];
                                v.timer.c = null, v.timer.t = NaN, --u.count, delete u[p];
                            }
                            o.c = h, Mt(function() {
                                return o.c && h(r || 1) && (o.c = null, o.t = NaN), 1;
                            }, 0, i), u.active = n, f.event && f.event.start.call(e, e.__data__, t), c = [], f.tween.forEach(function(r, n) {
                                (n = n.call(e, e.__data__, t)) && c.push(n);
                            }), s = f.ease, l = f.duration;
                        }
                        function h(a) {
                            for(var i = a / l, o = s(i), d = c.length; d > 0;)c[--d].call(e, o);
                            if (i >= 1) return f.event && f.event.end.call(e, e.__data__, t), --u.count ? delete u[n] : delete e[r], 1;
                        }
                        f || (i = a.time, o = Mt(function(e) {
                            var t = f.delay;
                            if (o.t = t + i, t <= e) return d(e - t);
                            o.c = d;
                        }, 0, i), f = u[n] = {
                            tween: new M,
                            time: i,
                            timer: o,
                            delay: a.delay,
                            duration: a.duration,
                            ease: a.ease,
                            index: t
                        }, a = null, ++u.count);
                    }
                    ti.call = K.call, ti.empty = K.empty, ti.node = K.node, ti.size = K.size, i.transition = function(e, t) {
                        return e && e.transition ? $a ? e.transition(t) : e : i.selection().transition(e);
                    }, i.transition.prototype = ti, ti.select = function(e) {
                        var t, r, n, a = this.id, i = this.namespace, o = [];
                        e = Q(e);
                        for(var l = -1, s = this.length; ++l < s;){
                            o.push(t = []);
                            for(var c = this[l], u = -1, f = c.length; ++u < f;)(n = c[u]) && (r = e.call(n, n.__data__, u, l)) ? ("__data__" in n && (r.__data__ = n.__data__), oi(r, u, i, a, n[i][a]), t.push(r)) : t.push(null);
                        }
                        return Qa(o, i, a);
                    }, ti.selectAll = function(e) {
                        var t, r, n, a, i, o = this.id, l = this.namespace, s = [];
                        e = $(e);
                        for(var c = -1, u = this.length; ++c < u;)for(var f = this[c], d = -1, h = f.length; ++d < h;)if (n = f[d]) {
                            i = n[l][o], r = e.call(n, n.__data__, d, c), s.push(t = []);
                            for(var p = -1, v = r.length; ++p < v;)(a = r[p]) && oi(a, p, l, o, i), t.push(a);
                        }
                        return Qa(s, l, o);
                    }, ti.filter = function(e) {
                        var t, r, n = [];
                        "function" != typeof e && (e = he(e));
                        for(var a = 0, i = this.length; a < i; a++){
                            n.push(t = []);
                            for(var o, l = 0, s = (o = this[a]).length; l < s; l++)(r = o[l]) && e.call(r, r.__data__, l, a) && t.push(r);
                        }
                        return Qa(n, this.namespace, this.id);
                    }, ti.tween = function(e, t) {
                        var r = this.id, n = this.namespace;
                        return arguments.length < 2 ? this.node()[n][r].tween.get(e) : ve(this, null == t ? function(t) {
                            t[n][r].tween.remove(e);
                        } : function(a) {
                            a[n][r].tween.set(e, t);
                        });
                    }, ti.attr = function(e, t) {
                        if (arguments.length < 2) {
                            for(t in e)this.attr(t, e[t]);
                            return this;
                        }
                        var r = "transform" == e ? Vr : Tr, n = i.ns.qualify(e);
                        function a() {
                            this.removeAttribute(n);
                        }
                        function o() {
                            this.removeAttributeNS(n.space, n.local);
                        }
                        return ni(this, "attr." + e, t, n.local ? function(e) {
                            return null == e ? o : (e += "", function() {
                                var t, a = this.getAttributeNS(n.space, n.local);
                                return a !== e && (t = r(a, e), function(e) {
                                    this.setAttributeNS(n.space, n.local, t(e));
                                });
                            });
                        } : function(e) {
                            return null == e ? a : (e += "", function() {
                                var t, a = this.getAttribute(n);
                                return a !== e && (t = r(a, e), function(e) {
                                    this.setAttribute(n, t(e));
                                });
                            });
                        });
                    }, ti.attrTween = function(e, t) {
                        var r = i.ns.qualify(e);
                        return this.tween("attr." + e, r.local ? function(e, n) {
                            var a = t.call(this, e, n, this.getAttributeNS(r.space, r.local));
                            return a && function(e) {
                                this.setAttributeNS(r.space, r.local, a(e));
                            };
                        } : function(e, n) {
                            var a = t.call(this, e, n, this.getAttribute(r));
                            return a && function(e) {
                                this.setAttribute(r, a(e));
                            };
                        });
                    }, ti.style = function(e, t, r) {
                        var n = arguments.length;
                        if (n < 3) {
                            if ("string" != typeof e) {
                                for(r in n < 2 && (t = ""), e)this.style(r, e[r], t);
                                return this;
                            }
                            r = "";
                        }
                        function a() {
                            this.style.removeProperty(e);
                        }
                        return ni(this, "style." + e, t, function(t) {
                            return null == t ? a : (t += "", function() {
                                var n, a = u(this).getComputedStyle(this, null).getPropertyValue(e);
                                return a !== t && (n = Tr(a, t), function(t) {
                                    this.style.setProperty(e, n(t), r);
                                });
                            });
                        });
                    }, ti.styleTween = function(e, t, r) {
                        return arguments.length < 3 && (r = ""), this.tween("style." + e, function(n, a) {
                            var i = t.call(this, n, a, u(this).getComputedStyle(this, null).getPropertyValue(e));
                            return i && function(t) {
                                this.style.setProperty(e, i(t), r);
                            };
                        });
                    }, ti.text = function(e) {
                        return ni(this, "text", e, ai);
                    }, ti.remove = function() {
                        var e = this.namespace;
                        return this.each("end.transition", function() {
                            var t;
                            this[e].count < 2 && (t = this.parentNode) && t.removeChild(this);
                        });
                    }, ti.ease = function(e) {
                        var t = this.id, r = this.namespace;
                        return arguments.length < 1 ? this.node()[r][t].ease : ("function" != typeof e && (e = i.ease.apply(i, arguments)), ve(this, function(n) {
                            n[r][t].ease = e;
                        }));
                    }, ti.delay = function(e) {
                        var t = this.id, r = this.namespace;
                        return arguments.length < 1 ? this.node()[r][t].delay : ve(this, "function" == typeof e ? function(n, a, i) {
                            n[r][t].delay = +e.call(n, n.__data__, a, i);
                        } : (e = +e, function(n) {
                            n[r][t].delay = e;
                        }));
                    }, ti.duration = function(e) {
                        var t = this.id, r = this.namespace;
                        return arguments.length < 1 ? this.node()[r][t].duration : ve(this, "function" == typeof e ? function(n, a, i) {
                            n[r][t].duration = Math.max(1, e.call(n, n.__data__, a, i));
                        } : (e = Math.max(1, e), function(n) {
                            n[r][t].duration = e;
                        }));
                    }, ti.each = function(e, t) {
                        var r = this.id, n = this.namespace;
                        if (arguments.length < 2) {
                            var a = ei, o = $a;
                            try {
                                $a = r, ve(this, function(t, a, i) {
                                    ei = t[n][r], e.call(t, t.__data__, a, i);
                                });
                            } finally{
                                ei = a, $a = o;
                            }
                        } else ve(this, function(a) {
                            var o = a[n][r];
                            (o.event || (o.event = i.dispatch("start", "end", "interrupt"))).on(e, t);
                        });
                        return this;
                    }, ti.transition = function() {
                        for(var e, t, r, n = this.id, a = ++ri, i = this.namespace, o = [], l = 0, s = this.length; l < s; l++){
                            o.push(e = []);
                            for(var c, u = 0, f = (c = this[l]).length; u < f; u++)(t = c[u]) && oi(t, u, i, a, {
                                time: (r = t[i][n]).time,
                                ease: r.ease,
                                delay: r.delay + r.duration,
                                duration: r.duration
                            }), e.push(t);
                        }
                        return Qa(o, i, a);
                    }, i.svg.axis = function() {
                        var e, t = i.scale.linear(), r = li, n = 6, a = 6, o = 3, s = [
                            10
                        ], c = null;
                        function u(l) {
                            l.each(function() {
                                var l, u = i.select(this), f = this.__chart__ || t, d = this.__chart__ = t.copy(), h = null == c ? d.ticks ? d.ticks.apply(d, s) : d.domain() : c, p = null == e ? d.tickFormat ? d.tickFormat.apply(d, s) : z : e, v = u.selectAll(".tick").data(h, d), g = v.enter().insert("g", ".domain").attr("class", "tick").style("opacity", Se), y = i.transition(v.exit()).style("opacity", Se).remove(), m = i.transition(v.order()).style("opacity", 1), x = Math.max(n, 0) + o, b = Vn(d), _ = u.selectAll(".domain").data([
                                    0
                                ]), w = (_.enter().append("path").attr("class", "domain"), i.transition(_));
                                g.append("line"), g.append("text");
                                var T, M, k, A, L = g.select("line"), S = m.select("line"), D = v.select("text").text(p), O = g.select("text"), C = m.select("text"), P = "top" === r || "left" === r ? -1 : 1;
                                if ("bottom" === r || "top" === r ? (l = ci, T = "x", k = "y", M = "x2", A = "y2", D.attr("dy", P < 0 ? "0em" : ".71em").style("text-anchor", "middle"), w.attr("d", "M" + b[0] + "," + P * a + "V0H" + b[1] + "V" + P * a)) : (l = ui, T = "y", k = "x", M = "y2", A = "x2", D.attr("dy", ".32em").style("text-anchor", P < 0 ? "end" : "start"), w.attr("d", "M" + P * a + "," + b[0] + "H0V" + b[1] + "H" + P * a)), L.attr(A, P * n), O.attr(k, P * x), S.attr(M, 0).attr(A, P * n), C.attr(T, 0).attr(k, P * x), d.rangeBand) {
                                    var I = d, R = I.rangeBand() / 2;
                                    f = d = function(e) {
                                        return I(e) + R;
                                    };
                                } else f.rangeBand ? f = d : y.call(l, d, f);
                                g.call(l, f, d), m.call(l, d, d);
                            });
                        }
                        return u.scale = function(e) {
                            return arguments.length ? (t = e, u) : t;
                        }, u.orient = function(e) {
                            return arguments.length ? (r = e in si ? e + "" : li, u) : r;
                        }, u.ticks = function() {
                            return arguments.length ? (s = l(arguments), u) : s;
                        }, u.tickValues = function(e) {
                            return arguments.length ? (c = e, u) : c;
                        }, u.tickFormat = function(t) {
                            return arguments.length ? (e = t, u) : e;
                        }, u.tickSize = function(e) {
                            var t = arguments.length;
                            return t ? (n = +e, a = +arguments[t - 1], u) : n;
                        }, u.innerTickSize = function(e) {
                            return arguments.length ? (n = +e, u) : n;
                        }, u.outerTickSize = function(e) {
                            return arguments.length ? (a = +e, u) : a;
                        }, u.tickPadding = function(e) {
                            return arguments.length ? (o = +e, u) : o;
                        }, u.tickSubdivide = function() {
                            return arguments.length && u;
                        }, u;
                    };
                    var li = "bottom", si = {
                        top: 1,
                        right: 1,
                        bottom: 1,
                        left: 1
                    };
                    function ci(e, t, r) {
                        e.attr("transform", function(e) {
                            var n = t(e);
                            return "translate(" + (isFinite(n) ? n : r(e)) + ",0)";
                        });
                    }
                    function ui(e, t, r) {
                        e.attr("transform", function(e) {
                            var n = t(e);
                            return "translate(0," + (isFinite(n) ? n : r(e)) + ")";
                        });
                    }
                    i.svg.brush = function() {
                        var e, t, r = U(d, "brushstart", "brush", "brushend"), n = null, a = null, o = [
                            0,
                            0
                        ], l = [
                            0,
                            0
                        ], s = !0, c = !0, f = di[0];
                        function d(e) {
                            e.each(function() {
                                var e = i.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", g).on("touchstart.brush", g), t = e.selectAll(".background").data([
                                    0
                                ]);
                                t.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), e.selectAll(".extent").data([
                                    0
                                ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
                                var r = e.selectAll(".resize").data(f, z);
                                r.exit().remove(), r.enter().append("g").attr("class", function(e) {
                                    return "resize " + e;
                                }).style("cursor", function(e) {
                                    return fi[e];
                                }).append("rect").attr("x", function(e) {
                                    return /[ew]$/.test(e) ? -3 : null;
                                }).attr("y", function(e) {
                                    return /^[ns]/.test(e) ? -3 : null;
                                }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), r.style("display", d.empty() ? "none" : null);
                                var o, l = i.transition(e), s = i.transition(t);
                                n && (o = Vn(n), s.attr("x", o[0]).attr("width", o[1] - o[0]), p(l)), a && (o = Vn(a), s.attr("y", o[0]).attr("height", o[1] - o[0]), v(l)), h(l);
                            });
                        }
                        function h(e) {
                            e.selectAll(".resize").attr("transform", function(e) {
                                return "translate(" + o[+/e$/.test(e)] + "," + l[+/^s/.test(e)] + ")";
                            });
                        }
                        function p(e) {
                            e.select(".extent").attr("x", o[0]), e.selectAll(".extent,.n>rect,.s>rect").attr("width", o[1] - o[0]);
                        }
                        function v(e) {
                            e.select(".extent").attr("y", l[0]), e.selectAll(".extent,.e>rect,.w>rect").attr("height", l[1] - l[0]);
                        }
                        function g() {
                            var f, g, y = this, m = i.select(i.event.target), x = r.of(y, arguments), b = i.select(y), _ = m.datum(), w = !/^(n|s)$/.test(_) && n, T = !/^(e|w)$/.test(_) && a, M = m.classed("extent"), k = Me(y), A = i.mouse(y), L = i.select(u(y)).on("keydown.brush", function() {
                                32 == i.event.keyCode && (M || (f = null, A[0] -= o[1], A[1] -= l[1], M = 2), Y());
                            }).on("keyup.brush", function() {
                                32 == i.event.keyCode && 2 == M && (A[0] += o[1], A[1] += l[1], M = 0, Y());
                            });
                            if (i.event.changedTouches ? L.on("touchmove.brush", O).on("touchend.brush", P) : L.on("mousemove.brush", O).on("mouseup.brush", P), b.interrupt().selectAll("*").interrupt(), M) A[0] = o[0] - A[0], A[1] = l[0] - A[1];
                            else if (_) {
                                var S = +/w$/.test(_), D = +/^n/.test(_);
                                g = [
                                    o[1 - S] - A[0],
                                    l[1 - D] - A[1]
                                ], A[0] = o[S], A[1] = l[D];
                            } else i.event.altKey && (f = A.slice());
                            function O() {
                                var e = i.mouse(y), t = !1;
                                g && (e[0] += g[0], e[1] += g[1]), M || (i.event.altKey ? (f || (f = [
                                    (o[0] + o[1]) / 2,
                                    (l[0] + l[1]) / 2
                                ]), A[0] = o[+(e[0] < f[0])], A[1] = l[+(e[1] < f[1])]) : f = null), w && C(e, n, 0) && (p(b), t = !0), T && C(e, a, 1) && (v(b), t = !0), t && (h(b), x({
                                    type: "brush",
                                    mode: M ? "move" : "resize"
                                }));
                            }
                            function C(r, n, a) {
                                var i, u, d = Vn(n), h = d[0], p = d[1], v = A[a], g = a ? l : o, y = g[1] - g[0];
                                if (M && (h -= v, p -= y + v), i = (a ? c : s) ? Math.max(h, Math.min(p, r[a])) : r[a], M ? u = (i += v) + y : (f && (v = Math.max(h, Math.min(p, 2 * f[a] - i))), v < i ? (u = i, i = v) : u = v), g[0] != i || g[1] != u) return a ? t = null : e = null, g[0] = i, g[1] = u, !0;
                            }
                            function P() {
                                O(), b.style("pointer-events", "all").selectAll(".resize").style("display", d.empty() ? "none" : null), i.select("body").style("cursor", null), L.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), k(), x({
                                    type: "brushend"
                                });
                            }
                            b.style("pointer-events", "none").selectAll(".resize").style("display", null), i.select("body").style("cursor", m.style("cursor")), x({
                                type: "brushstart"
                            }), O();
                        }
                        return d.event = function(n) {
                            n.each(function() {
                                var n = r.of(this, arguments), a = {
                                    x: o,
                                    y: l,
                                    i: e,
                                    j: t
                                }, s = this.__chart__ || a;
                                this.__chart__ = a, $a ? i.select(this).transition().each("start.brush", function() {
                                    e = s.i, t = s.j, o = s.x, l = s.y, n({
                                        type: "brushstart"
                                    });
                                }).tween("brush:brush", function() {
                                    var r = Mr(o, a.x), i = Mr(l, a.y);
                                    return e = t = null, function(e) {
                                        o = a.x = r(e), l = a.y = i(e), n({
                                            type: "brush",
                                            mode: "resize"
                                        });
                                    };
                                }).each("end.brush", function() {
                                    e = a.i, t = a.j, n({
                                        type: "brush",
                                        mode: "resize"
                                    }), n({
                                        type: "brushend"
                                    });
                                }) : (n({
                                    type: "brushstart"
                                }), n({
                                    type: "brush",
                                    mode: "resize"
                                }), n({
                                    type: "brushend"
                                }));
                            });
                        }, d.x = function(e) {
                            return arguments.length ? (f = di[!(n = e) << 1 | !a], d) : n;
                        }, d.y = function(e) {
                            return arguments.length ? (f = di[!n << 1 | !(a = e)], d) : a;
                        }, d.clamp = function(e) {
                            return arguments.length ? (n && a ? (s = !!e[0], c = !!e[1]) : n ? s = !!e : a && (c = !!e), d) : n && a ? [
                                s,
                                c
                            ] : n ? s : a ? c : null;
                        }, d.extent = function(r) {
                            var i, s, c, u, f;
                            return arguments.length ? (n && (i = r[0], s = r[1], a && (i = i[0], s = s[0]), e = [
                                i,
                                s
                            ], n.invert && (i = n(i), s = n(s)), s < i && (f = i, i = s, s = f), i == o[0] && s == o[1] || (o = [
                                i,
                                s
                            ])), a && (c = r[0], u = r[1], n && (c = c[1], u = u[1]), t = [
                                c,
                                u
                            ], a.invert && (c = a(c), u = a(u)), u < c && (f = c, c = u, u = f), c == l[0] && u == l[1] || (l = [
                                c,
                                u
                            ])), d) : (n && (e ? (i = e[0], s = e[1]) : (i = o[0], s = o[1], n.invert && (i = n.invert(i), s = n.invert(s)), s < i && (f = i, i = s, s = f))), a && (t ? (c = t[0], u = t[1]) : (c = l[0], u = l[1], a.invert && (c = a.invert(c), u = a.invert(u)), u < c && (f = c, c = u, u = f))), n && a ? [
                                [
                                    i,
                                    c
                                ],
                                [
                                    s,
                                    u
                                ]
                            ] : n ? [
                                i,
                                s
                            ] : a && [
                                c,
                                u
                            ]);
                        }, d.clear = function() {
                            return d.empty() || (o = [
                                0,
                                0
                            ], l = [
                                0,
                                0
                            ], e = t = null), d;
                        }, d.empty = function() {
                            return !!n && o[0] == o[1] || !!a && l[0] == l[1];
                        }, i.rebind(d, r, "on");
                    };
                    var fi = {
                        n: "ns-resize",
                        e: "ew-resize",
                        s: "ns-resize",
                        w: "ew-resize",
                        nw: "nwse-resize",
                        ne: "nesw-resize",
                        se: "nwse-resize",
                        sw: "nesw-resize"
                    }, di = [
                        [
                            "n",
                            "e",
                            "s",
                            "w",
                            "nw",
                            "ne",
                            "se",
                            "sw"
                        ],
                        [
                            "e",
                            "w"
                        ],
                        [
                            "n",
                            "s"
                        ],
                        []
                    ];
                    function hi(e) {
                        return JSON.parse(e.responseText);
                    }
                    function pi(e) {
                        var t = s.createRange();
                        return t.selectNode(s.body), t.createContextualFragment(e.responseText);
                    }
                    i.text = yt(function(e) {
                        return e.responseText;
                    }), i.json = function(e, t) {
                        return mt(e, "application/json", hi, t);
                    }, i.html = function(e, t) {
                        return mt(e, "text/html", pi, t);
                    }, i.xml = yt(function(e) {
                        return e.responseXML;
                    }), void 0 === (a = "function" == typeof (n = i) ? n.call(t, r, t, e) : n) || (e.exports = a);
                }).apply(self);
            },
            721: function(e, t, r) {
                "use strict";
                function n(e, t) {
                    if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
                    var r, n = e.slice(0, r);
                    return [
                        n.length > 1 ? n[0] + n.slice(2) : n,
                        +e.slice(r + 1)
                    ];
                }
                r.d(t, {
                    WU: function() {
                        return d;
                    },
                    FF: function() {
                        return v;
                    }
                });
                var a, i = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
                function o(e) {
                    if (!(t = i.exec(e))) throw new Error("invalid format: " + e);
                    var t;
                    return new l({
                        fill: t[1],
                        align: t[2],
                        sign: t[3],
                        symbol: t[4],
                        zero: t[5],
                        width: t[6],
                        comma: t[7],
                        precision: t[8] && t[8].slice(1),
                        trim: t[9],
                        type: t[10]
                    });
                }
                function l(e) {
                    this.fill = void 0 === e.fill ? " " : e.fill + "", this.align = void 0 === e.align ? ">" : e.align + "", this.sign = void 0 === e.sign ? "-" : e.sign + "", this.symbol = void 0 === e.symbol ? "" : e.symbol + "", this.zero = !!e.zero, this.width = void 0 === e.width ? void 0 : +e.width, this.comma = !!e.comma, this.precision = void 0 === e.precision ? void 0 : +e.precision, this.trim = !!e.trim, this.type = void 0 === e.type ? "" : e.type + "";
                }
                function s(e, t) {
                    var r = n(e, t);
                    if (!r) return e + "";
                    var a = r[0], i = r[1];
                    return i < 0 ? "0." + new Array(-i).join("0") + a : a.length > i + 1 ? a.slice(0, i + 1) + "." + a.slice(i + 1) : a + new Array(i - a.length + 2).join("0");
                }
                o.prototype = l.prototype, l.prototype.toString = function() {
                    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
                };
                var c = {
                    "%": function(e, t) {
                        return (100 * e).toFixed(t);
                    },
                    b: function(e) {
                        return Math.round(e).toString(2);
                    },
                    c: function(e) {
                        return e + "";
                    },
                    d: function(e) {
                        return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
                    },
                    e: function(e, t) {
                        return e.toExponential(t);
                    },
                    f: function(e, t) {
                        return e.toFixed(t);
                    },
                    g: function(e, t) {
                        return e.toPrecision(t);
                    },
                    o: function(e) {
                        return Math.round(e).toString(8);
                    },
                    p: function(e, t) {
                        return s(100 * e, t);
                    },
                    r: s,
                    s: function(e, t) {
                        var r = n(e, t);
                        if (!r) return e + "";
                        var i = r[0], o = r[1], l = o - (a = 3 * Math.max(-8, Math.min(8, Math.floor(o / 3)))) + 1, s = i.length;
                        return l === s ? i : l > s ? i + new Array(l - s + 1).join("0") : l > 0 ? i.slice(0, l) + "." + i.slice(l) : "0." + new Array(1 - l).join("0") + n(e, Math.max(0, t + l - 1))[0];
                    },
                    X: function(e) {
                        return Math.round(e).toString(16).toUpperCase();
                    },
                    x: function(e) {
                        return Math.round(e).toString(16);
                    }
                };
                function u(e) {
                    return e;
                }
                var f, d, h = Array.prototype.map, p = [
                    "y",
                    "z",
                    "a",
                    "f",
                    "p",
                    "n",
                    "\xb5",
                    "m",
                    "",
                    "k",
                    "M",
                    "G",
                    "T",
                    "P",
                    "E",
                    "Z",
                    "Y"
                ];
                function v(e) {
                    var t, r, i = void 0 === e.grouping || void 0 === e.thousands ? u : (t = h.call(e.grouping, Number), r = e.thousands + "", function(e, n) {
                        for(var a = e.length, i = [], o = 0, l = t[0], s = 0; a > 0 && l > 0 && (s + l + 1 > n && (l = Math.max(1, n - s)), i.push(e.substring(a -= l, a + l)), !((s += l + 1) > n));)l = t[o = (o + 1) % t.length];
                        return i.reverse().join(r);
                    }), l = void 0 === e.currency ? "" : e.currency[0] + "", s = void 0 === e.currency ? "" : e.currency[1] + "", f = void 0 === e.decimal ? "." : e.decimal + "", d = void 0 === e.numerals ? u : function(e) {
                        return function(t) {
                            return t.replace(/[0-9]/g, function(t) {
                                return e[+t];
                            });
                        };
                    }(h.call(e.numerals, String)), v = void 0 === e.percent ? "%" : e.percent + "", g = void 0 === e.minus ? "-" : e.minus + "", y = void 0 === e.nan ? "NaN" : e.nan + "";
                    function m(e) {
                        var t = (e = o(e)).fill, r = e.align, n = e.sign, u = e.symbol, h = e.zero, m = e.width, x = e.comma, b = e.precision, _ = e.trim, w = e.type;
                        "n" === w ? (x = !0, w = "g") : c[w] || (void 0 === b && (b = 12), _ = !0, w = "g"), (h || "0" === t && "=" === r) && (h = !0, t = "0", r = "=");
                        var T = "$" === u ? l : "#" === u && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", M = "$" === u ? s : /[%p]/.test(w) ? v : "", k = c[w], A = /[defgprs%]/.test(w);
                        function L(e) {
                            var o, l, s, c = T, u = M;
                            if ("c" === w) u = k(e) + u, e = "";
                            else {
                                var v = (e = +e) < 0 || 1 / e < 0;
                                if (e = isNaN(e) ? y : k(Math.abs(e), b), _ && (e = function(e) {
                                    e: for(var t, r = e.length, n = 1, a = -1; n < r; ++n)switch(e[n]){
                                        case ".":
                                            a = t = n;
                                            break;
                                        case "0":
                                            0 === a && (a = n), t = n;
                                            break;
                                        default:
                                            if (!+e[n]) break e;
                                            a > 0 && (a = 0);
                                    }
                                    return a > 0 ? e.slice(0, a) + e.slice(t + 1) : e;
                                }(e)), v && 0 == +e && "+" !== n && (v = !1), c = (v ? "(" === n ? n : g : "-" === n || "(" === n ? "" : n) + c, u = ("s" === w ? p[8 + a / 3] : "") + u + (v && "(" === n ? ")" : ""), A) {
                                    for(o = -1, l = e.length; ++o < l;)if (48 > (s = e.charCodeAt(o)) || s > 57) {
                                        u = (46 === s ? f + e.slice(o + 1) : e.slice(o)) + u, e = e.slice(0, o);
                                        break;
                                    }
                                }
                            }
                            x && !h && (e = i(e, 1 / 0));
                            var L = c.length + e.length + u.length, S = L < m ? new Array(m - L + 1).join(t) : "";
                            switch(x && h && (e = i(S + e, S.length ? m - u.length : 1 / 0), S = ""), r){
                                case "<":
                                    e = c + e + u + S;
                                    break;
                                case "=":
                                    e = c + S + e + u;
                                    break;
                                case "^":
                                    e = S.slice(0, L = S.length >> 1) + c + e + u + S.slice(L);
                                    break;
                                default:
                                    e = S + c + e + u;
                            }
                            return d(e);
                        }
                        return b = void 0 === b ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, b)) : Math.max(0, Math.min(20, b)), L.toString = function() {
                            return e + "";
                        }, L;
                    }
                    return {
                        format: m,
                        formatPrefix: function(e, t) {
                            var r, a = m(((e = o(e)).type = "f", e)), i = 3 * Math.max(-8, Math.min(8, Math.floor((r = t, ((r = n(Math.abs(r))) ? r[1] : NaN) / 3)))), l = Math.pow(10, -i), s = p[8 + i / 3];
                            return function(e) {
                                return a(l * e) + s;
                            };
                        }
                    };
                }
                f = v({
                    decimal: ".",
                    thousands: ",",
                    grouping: [
                        3
                    ],
                    currency: [
                        "$",
                        ""
                    ],
                    minus: "-"
                }), d = f.format, f.formatPrefix;
            },
            4096: function(e, t, r) {
                "use strict";
                r.d(t, {
                    i$: function() {
                        return p;
                    },
                    Dq: function() {
                        return d;
                    },
                    g0: function() {
                        return v;
                    }
                });
                var n = r(8176), a = r(8480), i = r(9879), o = r(2301), l = r(4823), s = r(9791);
                function c(e) {
                    if (0 <= e.y && e.y < 100) {
                        var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
                        return t.setFullYear(e.y), t;
                    }
                    return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
                }
                function u(e) {
                    if (0 <= e.y && e.y < 100) {
                        var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
                        return t.setUTCFullYear(e.y), t;
                    }
                    return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
                }
                function f(e, t, r) {
                    return {
                        y: e,
                        m: t,
                        d: r,
                        H: 0,
                        M: 0,
                        S: 0,
                        L: 0
                    };
                }
                function d(e) {
                    var t = e.dateTime, r = e.date, l = e.time, s = e.periods, d = e.days, h = e.shortDays, p = e.months, v = e.shortMonths, y = w(s), m = T(s), x = w(d), b = T(d), _ = w(h), Le = T(h), Se = w(p), De = T(p), Oe = w(v), Ce = T(v), Pe = {
                        a: function(e) {
                            return h[e.getDay()];
                        },
                        A: function(e) {
                            return d[e.getDay()];
                        },
                        b: function(e) {
                            return v[e.getMonth()];
                        },
                        B: function(e) {
                            return p[e.getMonth()];
                        },
                        c: null,
                        d: U,
                        e: U,
                        f: X,
                        H: q,
                        I: G,
                        j: Z,
                        L: W,
                        m: J,
                        M: K,
                        p: function(e) {
                            return s[+(e.getHours() >= 12)];
                        },
                        q: function(e) {
                            return 1 + ~~(e.getMonth() / 3);
                        },
                        Q: ke,
                        s: Ae,
                        S: Q,
                        u: $,
                        U: ee,
                        V: te,
                        w: re,
                        W: ne,
                        x: null,
                        X: null,
                        y: ae,
                        Y: ie,
                        Z: oe,
                        "%": Me
                    }, Ie = {
                        a: function(e) {
                            return h[e.getUTCDay()];
                        },
                        A: function(e) {
                            return d[e.getUTCDay()];
                        },
                        b: function(e) {
                            return v[e.getUTCMonth()];
                        },
                        B: function(e) {
                            return p[e.getUTCMonth()];
                        },
                        c: null,
                        d: le,
                        e: le,
                        f: de,
                        H: se,
                        I: ce,
                        j: ue,
                        L: fe,
                        m: he,
                        M: pe,
                        p: function(e) {
                            return s[+(e.getUTCHours() >= 12)];
                        },
                        q: function(e) {
                            return 1 + ~~(e.getUTCMonth() / 3);
                        },
                        Q: ke,
                        s: Ae,
                        S: ve,
                        u: ge,
                        U: ye,
                        V: me,
                        w: xe,
                        W: be,
                        x: null,
                        X: null,
                        y: _e,
                        Y: we,
                        Z: Te,
                        "%": Me
                    }, Re = {
                        a: function(e, t, r) {
                            var n = _.exec(t.slice(r));
                            return n ? (e.w = Le[n[0].toLowerCase()], r + n[0].length) : -1;
                        },
                        A: function(e, t, r) {
                            var n = x.exec(t.slice(r));
                            return n ? (e.w = b[n[0].toLowerCase()], r + n[0].length) : -1;
                        },
                        b: function(e, t, r) {
                            var n = Oe.exec(t.slice(r));
                            return n ? (e.m = Ce[n[0].toLowerCase()], r + n[0].length) : -1;
                        },
                        B: function(e, t, r) {
                            var n = Se.exec(t.slice(r));
                            return n ? (e.m = De[n[0].toLowerCase()], r + n[0].length) : -1;
                        },
                        c: function(e, r, n) {
                            return Fe(e, t, r, n);
                        },
                        d: R,
                        e: R,
                        f: j,
                        H: N,
                        I: N,
                        j: z,
                        L: H,
                        m: I,
                        M: F,
                        p: function(e, t, r) {
                            var n = y.exec(t.slice(r));
                            return n ? (e.p = m[n[0].toLowerCase()], r + n[0].length) : -1;
                        },
                        q: P,
                        Q: Y,
                        s: V,
                        S: E,
                        u: k,
                        U: A,
                        V: L,
                        w: M,
                        W: S,
                        x: function(e, t, n) {
                            return Fe(e, r, t, n);
                        },
                        X: function(e, t, r) {
                            return Fe(e, l, t, r);
                        },
                        y: O,
                        Y: D,
                        Z: C,
                        "%": B
                    };
                    function ze(e, t) {
                        return function(r) {
                            var n, a, i, o = [], l = -1, s = 0, c = e.length;
                            for(r instanceof Date || (r = new Date(+r)); ++l < c;)37 === e.charCodeAt(l) && (o.push(e.slice(s, l)), null != (a = g[n = e.charAt(++l)]) ? n = e.charAt(++l) : a = "e" === n ? " " : "0", (i = t[n]) && (n = i(r, a)), o.push(n), s = l + 1);
                            return o.push(e.slice(s, l)), o.join("");
                        };
                    }
                    function Ne(e, t) {
                        return function(r) {
                            var l, s, d = f(1900, void 0, 1);
                            if (Fe(d, e, r += "", 0) != r.length) return null;
                            if ("Q" in d) return new Date(d.Q);
                            if ("s" in d) return new Date(1e3 * d.s + ("L" in d ? d.L : 0));
                            if (t && !("Z" in d) && (d.Z = 0), "p" in d && (d.H = d.H % 12 + 12 * d.p), void 0 === d.m && (d.m = "q" in d ? d.q : 0), "V" in d) {
                                if (d.V < 1 || d.V > 53) return null;
                                "w" in d || (d.w = 1), "Z" in d ? (s = (l = u(f(d.y, 0, 1))).getUTCDay(), l = s > 4 || 0 === s ? n.l6.ceil(l) : (0, n.l6)(l), l = a.Z.offset(l, 7 * (d.V - 1)), d.y = l.getUTCFullYear(), d.m = l.getUTCMonth(), d.d = l.getUTCDate() + (d.w + 6) % 7) : (s = (l = c(f(d.y, 0, 1))).getDay(), l = s > 4 || 0 === s ? i.wA.ceil(l) : (0, i.wA)(l), l = o.Z.offset(l, 7 * (d.V - 1)), d.y = l.getFullYear(), d.m = l.getMonth(), d.d = l.getDate() + (d.w + 6) % 7);
                            } else ("W" in d || "U" in d) && ("w" in d || (d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0), s = "Z" in d ? u(f(d.y, 0, 1)).getUTCDay() : c(f(d.y, 0, 1)).getDay(), d.m = 0, d.d = "W" in d ? (d.w + 6) % 7 + 7 * d.W - (s + 5) % 7 : d.w + 7 * d.U - (s + 6) % 7);
                            return "Z" in d ? (d.H += d.Z / 100 | 0, d.M += d.Z % 100, u(d)) : c(d);
                        };
                    }
                    function Fe(e, t, r, n) {
                        for(var a, i, o = 0, l = t.length, s = r.length; o < l;){
                            if (n >= s) return -1;
                            if (37 === (a = t.charCodeAt(o++))) {
                                if (a = t.charAt(o++), !(i = Re[a in g ? t.charAt(o++) : a]) || (n = i(e, r, n)) < 0) return -1;
                            } else if (a != r.charCodeAt(n++)) return -1;
                        }
                        return n;
                    }
                    return Pe.x = ze(r, Pe), Pe.X = ze(l, Pe), Pe.c = ze(t, Pe), Ie.x = ze(r, Ie), Ie.X = ze(l, Ie), Ie.c = ze(t, Ie), {
                        format: function(e) {
                            var t = ze(e += "", Pe);
                            return t.toString = function() {
                                return e;
                            }, t;
                        },
                        parse: function(e) {
                            var t = Ne(e += "", !1);
                            return t.toString = function() {
                                return e;
                            }, t;
                        },
                        utcFormat: function(e) {
                            var t = ze(e += "", Ie);
                            return t.toString = function() {
                                return e;
                            }, t;
                        },
                        utcParse: function(e) {
                            var t = Ne(e += "", !0);
                            return t.toString = function() {
                                return e;
                            }, t;
                        }
                    };
                }
                var h, p, v, g = {
                    "-": "",
                    _: " ",
                    0: "0"
                }, y = /^\s*\d+/, m = /^%/, x = /[\\^$*+?|[\]().{}]/g;
                function b(e, t, r) {
                    var n = e < 0 ? "-" : "", a = (n ? -e : e) + "", i = a.length;
                    return n + (i < r ? new Array(r - i + 1).join(t) + a : a);
                }
                function _(e) {
                    return e.replace(x, "\\$&");
                }
                function w(e) {
                    return new RegExp("^(?:" + e.map(_).join("|") + ")", "i");
                }
                function T(e) {
                    for(var t = {}, r = -1, n = e.length; ++r < n;)t[e[r].toLowerCase()] = r;
                    return t;
                }
                function M(e, t, r) {
                    var n = y.exec(t.slice(r, r + 1));
                    return n ? (e.w = +n[0], r + n[0].length) : -1;
                }
                function k(e, t, r) {
                    var n = y.exec(t.slice(r, r + 1));
                    return n ? (e.u = +n[0], r + n[0].length) : -1;
                }
                function A(e, t, r) {
                    var n = y.exec(t.slice(r, r + 2));
                    return n ? (e.U = +n[0], r + n[0].length) : -1;
                }
                function L(e, t, r) {
                    var n = y.exec(t.slice(r, r + 2));
                    return n ? (e.V = +n[0], r + n[0].length) : -1;
                }
                function S(e, t, r) {
                    var n = y.exec(t.slice(r, r + 2));
                    return n ? (e.W = +n[0], r + n[0].length) : -1;
                }
                function D(e, t, r) {
                    var n = y.exec(t.slice(r, r + 4));
                    return n ? (e.y = +n[0], r + n[0].length) : -1;
                }
                function O(e, t, r) {
                    var n = y.exec(t.slice(r, r + 2));
                    return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
                }
                function C(e, t, r) {
                    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
                    return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
                }
                function P(e, t, r) {
                    var n = y.exec(t.slice(r, r + 1));
                    return n ? (e.q = 3 * n[0] - 3, r + n[0].length) : -1;
                }
                function I(e, t, r) {
                    var n = y.exec(t.slice(r, r + 2));
                    return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
                }
                function R(e, t, r) {
                    var n = y.exec(t.slice(r, r + 2));
                    return n ? (e.d = +n[0], r + n[0].length) : -1;
                }
                function z(e, t, r) {
                    var n = y.exec(t.slice(r, r + 3));
                    return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
                }
                function N(e, t, r) {
                    var n = y.exec(t.slice(r, r + 2));
                    return n ? (e.H = +n[0], r + n[0].length) : -1;
                }
                function F(e, t, r) {
                    var n = y.exec(t.slice(r, r + 2));
                    return n ? (e.M = +n[0], r + n[0].length) : -1;
                }
                function E(e, t, r) {
                    var n = y.exec(t.slice(r, r + 2));
                    return n ? (e.S = +n[0], r + n[0].length) : -1;
                }
                function H(e, t, r) {
                    var n = y.exec(t.slice(r, r + 3));
                    return n ? (e.L = +n[0], r + n[0].length) : -1;
                }
                function j(e, t, r) {
                    var n = y.exec(t.slice(r, r + 6));
                    return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
                }
                function B(e, t, r) {
                    var n = m.exec(t.slice(r, r + 1));
                    return n ? r + n[0].length : -1;
                }
                function Y(e, t, r) {
                    var n = y.exec(t.slice(r));
                    return n ? (e.Q = +n[0], r + n[0].length) : -1;
                }
                function V(e, t, r) {
                    var n = y.exec(t.slice(r));
                    return n ? (e.s = +n[0], r + n[0].length) : -1;
                }
                function U(e, t) {
                    return b(e.getDate(), t, 2);
                }
                function q(e, t) {
                    return b(e.getHours(), t, 2);
                }
                function G(e, t) {
                    return b(e.getHours() % 12 || 12, t, 2);
                }
                function Z(e, t) {
                    return b(1 + o.Z.count((0, l.Z)(e), e), t, 3);
                }
                function W(e, t) {
                    return b(e.getMilliseconds(), t, 3);
                }
                function X(e, t) {
                    return W(e, t) + "000";
                }
                function J(e, t) {
                    return b(e.getMonth() + 1, t, 2);
                }
                function K(e, t) {
                    return b(e.getMinutes(), t, 2);
                }
                function Q(e, t) {
                    return b(e.getSeconds(), t, 2);
                }
                function $(e) {
                    var t = e.getDay();
                    return 0 === t ? 7 : t;
                }
                function ee(e, t) {
                    return b(i.OM.count((0, l.Z)(e) - 1, e), t, 2);
                }
                function te(e, t) {
                    var r = e.getDay();
                    return e = r >= 4 || 0 === r ? (0, i.bL)(e) : i.bL.ceil(e), b(i.bL.count((0, l.Z)(e), e) + (4 === (0, l.Z)(e).getDay()), t, 2);
                }
                function re(e) {
                    return e.getDay();
                }
                function ne(e, t) {
                    return b(i.wA.count((0, l.Z)(e) - 1, e), t, 2);
                }
                function ae(e, t) {
                    return b(e.getFullYear() % 100, t, 2);
                }
                function ie(e, t) {
                    return b(e.getFullYear() % 1e4, t, 4);
                }
                function oe(e) {
                    var t = e.getTimezoneOffset();
                    return (t > 0 ? "-" : (t *= -1, "+")) + b(t / 60 | 0, "0", 2) + b(t % 60, "0", 2);
                }
                function le(e, t) {
                    return b(e.getUTCDate(), t, 2);
                }
                function se(e, t) {
                    return b(e.getUTCHours(), t, 2);
                }
                function ce(e, t) {
                    return b(e.getUTCHours() % 12 || 12, t, 2);
                }
                function ue(e, t) {
                    return b(1 + a.Z.count((0, s.Z)(e), e), t, 3);
                }
                function fe(e, t) {
                    return b(e.getUTCMilliseconds(), t, 3);
                }
                function de(e, t) {
                    return fe(e, t) + "000";
                }
                function he(e, t) {
                    return b(e.getUTCMonth() + 1, t, 2);
                }
                function pe(e, t) {
                    return b(e.getUTCMinutes(), t, 2);
                }
                function ve(e, t) {
                    return b(e.getUTCSeconds(), t, 2);
                }
                function ge(e) {
                    var t = e.getUTCDay();
                    return 0 === t ? 7 : t;
                }
                function ye(e, t) {
                    return b(n.Ox.count((0, s.Z)(e) - 1, e), t, 2);
                }
                function me(e, t) {
                    var r = e.getUTCDay();
                    return e = r >= 4 || 0 === r ? (0, n.hB)(e) : n.hB.ceil(e), b(n.hB.count((0, s.Z)(e), e) + (4 === (0, s.Z)(e).getUTCDay()), t, 2);
                }
                function xe(e) {
                    return e.getUTCDay();
                }
                function be(e, t) {
                    return b(n.l6.count((0, s.Z)(e) - 1, e), t, 2);
                }
                function _e(e, t) {
                    return b(e.getUTCFullYear() % 100, t, 2);
                }
                function we(e, t) {
                    return b(e.getUTCFullYear() % 1e4, t, 4);
                }
                function Te() {
                    return "+0000";
                }
                function Me() {
                    return "%";
                }
                function ke(e) {
                    return +e;
                }
                function Ae(e) {
                    return Math.floor(+e / 1e3);
                }
                h = d({
                    dateTime: "%x, %X",
                    date: "%-m/%-d/%Y",
                    time: "%-I:%M:%S %p",
                    periods: [
                        "AM",
                        "PM"
                    ],
                    days: [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ],
                    shortDays: [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    months: [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    shortMonths: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ]
                }), p = h.format, h.parse, v = h.utcFormat, h.utcParse;
            },
            2301: function(e, t, r) {
                "use strict";
                r.d(t, {
                    a: function() {
                        return o;
                    }
                });
                var n = r(52), a = r(4263), i = (0, n.Z)(function(e) {
                    e.setHours(0, 0, 0, 0);
                }, function(e, t) {
                    e.setDate(e.getDate() + t);
                }, function(e, t) {
                    return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * a.yB) / a.UD;
                }, function(e) {
                    return e.getDate() - 1;
                });
                t.Z = i;
                var o = i.range;
            },
            4263: function(e, t, r) {
                "use strict";
                r.d(t, {
                    UD: function() {
                        return o;
                    },
                    Y2: function() {
                        return i;
                    },
                    Ym: function() {
                        return n;
                    },
                    iM: function() {
                        return l;
                    },
                    yB: function() {
                        return a;
                    }
                });
                var n = 1e3, a = 6e4, i = 36e5, o = 864e5, l = 6048e5;
            },
            1041: function(e, t, r) {
                "use strict";
                r.r(t), r.d(t, {
                    timeDay: function() {
                        return y.Z;
                    },
                    timeDays: function() {
                        return y.a;
                    },
                    timeFriday: function() {
                        return m.mC;
                    },
                    timeFridays: function() {
                        return m.b$;
                    },
                    timeHour: function() {
                        return v;
                    },
                    timeHours: function() {
                        return g;
                    },
                    timeInterval: function() {
                        return n.Z;
                    },
                    timeMillisecond: function() {
                        return i;
                    },
                    timeMilliseconds: function() {
                        return o;
                    },
                    timeMinute: function() {
                        return d;
                    },
                    timeMinutes: function() {
                        return h;
                    },
                    timeMonday: function() {
                        return m.wA;
                    },
                    timeMondays: function() {
                        return m.bJ;
                    },
                    timeMonth: function() {
                        return b;
                    },
                    timeMonths: function() {
                        return _;
                    },
                    timeSaturday: function() {
                        return m.EY;
                    },
                    timeSaturdays: function() {
                        return m.Ff;
                    },
                    timeSecond: function() {
                        return c;
                    },
                    timeSeconds: function() {
                        return u;
                    },
                    timeSunday: function() {
                        return m.OM;
                    },
                    timeSundays: function() {
                        return m.vm;
                    },
                    timeThursday: function() {
                        return m.bL;
                    },
                    timeThursdays: function() {
                        return m.$t;
                    },
                    timeTuesday: function() {
                        return m.sy;
                    },
                    timeTuesdays: function() {
                        return m.aU;
                    },
                    timeWednesday: function() {
                        return m.zg;
                    },
                    timeWednesdays: function() {
                        return m.Ld;
                    },
                    timeWeek: function() {
                        return m.OM;
                    },
                    timeWeeks: function() {
                        return m.vm;
                    },
                    timeYear: function() {
                        return w.Z;
                    },
                    timeYears: function() {
                        return w.g;
                    },
                    utcDay: function() {
                        return D.Z;
                    },
                    utcDays: function() {
                        return D.y;
                    },
                    utcFriday: function() {
                        return O.QQ;
                    },
                    utcFridays: function() {
                        return O.fz;
                    },
                    utcHour: function() {
                        return L;
                    },
                    utcHours: function() {
                        return S;
                    },
                    utcMillisecond: function() {
                        return i;
                    },
                    utcMilliseconds: function() {
                        return o;
                    },
                    utcMinute: function() {
                        return M;
                    },
                    utcMinutes: function() {
                        return k;
                    },
                    utcMonday: function() {
                        return O.l6;
                    },
                    utcMondays: function() {
                        return O.$3;
                    },
                    utcMonth: function() {
                        return P;
                    },
                    utcMonths: function() {
                        return I;
                    },
                    utcSaturday: function() {
                        return O.g4;
                    },
                    utcSaturdays: function() {
                        return O.Q_;
                    },
                    utcSecond: function() {
                        return c;
                    },
                    utcSeconds: function() {
                        return u;
                    },
                    utcSunday: function() {
                        return O.Ox;
                    },
                    utcSundays: function() {
                        return O.SU;
                    },
                    utcThursday: function() {
                        return O.hB;
                    },
                    utcThursdays: function() {
                        return O.xj;
                    },
                    utcTuesday: function() {
                        return O.J1;
                    },
                    utcTuesdays: function() {
                        return O.DK;
                    },
                    utcWednesday: function() {
                        return O.b3;
                    },
                    utcWednesdays: function() {
                        return O.uy;
                    },
                    utcWeek: function() {
                        return O.Ox;
                    },
                    utcWeeks: function() {
                        return O.SU;
                    },
                    utcYear: function() {
                        return R.Z;
                    },
                    utcYears: function() {
                        return R.D;
                    }
                });
                var n = r(52), a = (0, n.Z)(function() {}, function(e, t) {
                    e.setTime(+e + t);
                }, function(e, t) {
                    return t - e;
                });
                a.every = function(e) {
                    return e = Math.floor(e), isFinite(e) && e > 0 ? e > 1 ? (0, n.Z)(function(t) {
                        t.setTime(Math.floor(t / e) * e);
                    }, function(t, r) {
                        t.setTime(+t + r * e);
                    }, function(t, r) {
                        return (r - t) / e;
                    }) : a : null;
                };
                var i = a, o = a.range, l = r(4263), s = (0, n.Z)(function(e) {
                    e.setTime(e - e.getMilliseconds());
                }, function(e, t) {
                    e.setTime(+e + t * l.Ym);
                }, function(e, t) {
                    return (t - e) / l.Ym;
                }, function(e) {
                    return e.getUTCSeconds();
                }), c = s, u = s.range, f = (0, n.Z)(function(e) {
                    e.setTime(e - e.getMilliseconds() - e.getSeconds() * l.Ym);
                }, function(e, t) {
                    e.setTime(+e + t * l.yB);
                }, function(e, t) {
                    return (t - e) / l.yB;
                }, function(e) {
                    return e.getMinutes();
                }), d = f, h = f.range, p = (0, n.Z)(function(e) {
                    e.setTime(e - e.getMilliseconds() - e.getSeconds() * l.Ym - e.getMinutes() * l.yB);
                }, function(e, t) {
                    e.setTime(+e + t * l.Y2);
                }, function(e, t) {
                    return (t - e) / l.Y2;
                }, function(e) {
                    return e.getHours();
                }), v = p, g = p.range, y = r(2301), m = r(9879), x = (0, n.Z)(function(e) {
                    e.setDate(1), e.setHours(0, 0, 0, 0);
                }, function(e, t) {
                    e.setMonth(e.getMonth() + t);
                }, function(e, t) {
                    return t.getMonth() - e.getMonth() + 12 * (t.getFullYear() - e.getFullYear());
                }, function(e) {
                    return e.getMonth();
                }), b = x, _ = x.range, w = r(4823), T = (0, n.Z)(function(e) {
                    e.setUTCSeconds(0, 0);
                }, function(e, t) {
                    e.setTime(+e + t * l.yB);
                }, function(e, t) {
                    return (t - e) / l.yB;
                }, function(e) {
                    return e.getUTCMinutes();
                }), M = T, k = T.range, A = (0, n.Z)(function(e) {
                    e.setUTCMinutes(0, 0, 0);
                }, function(e, t) {
                    e.setTime(+e + t * l.Y2);
                }, function(e, t) {
                    return (t - e) / l.Y2;
                }, function(e) {
                    return e.getUTCHours();
                }), L = A, S = A.range, D = r(8480), O = r(8176), C = (0, n.Z)(function(e) {
                    e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
                }, function(e, t) {
                    e.setUTCMonth(e.getUTCMonth() + t);
                }, function(e, t) {
                    return t.getUTCMonth() - e.getUTCMonth() + 12 * (t.getUTCFullYear() - e.getUTCFullYear());
                }, function(e) {
                    return e.getUTCMonth();
                }), P = C, I = C.range, R = r(9791);
            },
            52: function(e, t, r) {
                "use strict";
                r.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var n = new Date, a = new Date;
                function i(e, t, r, o) {
                    function l(t) {
                        return e(t = 0 === arguments.length ? new Date : new Date(+t)), t;
                    }
                    return l.floor = function(t) {
                        return e(t = new Date(+t)), t;
                    }, l.ceil = function(r) {
                        return e(r = new Date(r - 1)), t(r, 1), e(r), r;
                    }, l.round = function(e) {
                        var t = l(e), r = l.ceil(e);
                        return e - t < r - e ? t : r;
                    }, l.offset = function(e, r) {
                        return t(e = new Date(+e), null == r ? 1 : Math.floor(r)), e;
                    }, l.range = function(r, n, a) {
                        var i, o = [];
                        if (r = l.ceil(r), a = null == a ? 1 : Math.floor(a), !(r < n && a > 0)) return o;
                        do o.push(i = new Date(+r)), t(r, a), e(r);
                        while (i < r && r < n);
                        return o;
                    }, l.filter = function(r) {
                        return i(function(t) {
                            if (t >= t) for(; e(t), !r(t);)t.setTime(t - 1);
                        }, function(e, n) {
                            if (e >= e) {
                                if (n < 0) for(; ++n <= 0;)for(; t(e, -1), !r(e););
                                else for(; --n >= 0;)for(; t(e, 1), !r(e););
                            }
                        });
                    }, r && (l.count = function(t, i) {
                        return n.setTime(+t), a.setTime(+i), e(n), e(a), Math.floor(r(n, a));
                    }, l.every = function(e) {
                        return e = Math.floor(e), isFinite(e) && e > 0 ? e > 1 ? l.filter(o ? function(t) {
                            return o(t) % e == 0;
                        } : function(t) {
                            return l.count(0, t) % e == 0;
                        }) : l : null;
                    }), l;
                }
            },
            8480: function(e, t, r) {
                "use strict";
                r.d(t, {
                    y: function() {
                        return o;
                    }
                });
                var n = r(52), a = r(4263), i = (0, n.Z)(function(e) {
                    e.setUTCHours(0, 0, 0, 0);
                }, function(e, t) {
                    e.setUTCDate(e.getUTCDate() + t);
                }, function(e, t) {
                    return (t - e) / a.UD;
                }, function(e) {
                    return e.getUTCDate() - 1;
                });
                t.Z = i;
                var o = i.range;
            },
            8176: function(e, t, r) {
                "use strict";
                r.d(t, {
                    $3: function() {
                        return p;
                    },
                    DK: function() {
                        return v;
                    },
                    J1: function() {
                        return s;
                    },
                    Ox: function() {
                        return o;
                    },
                    QQ: function() {
                        return f;
                    },
                    Q_: function() {
                        return x;
                    },
                    SU: function() {
                        return h;
                    },
                    b3: function() {
                        return c;
                    },
                    fz: function() {
                        return m;
                    },
                    g4: function() {
                        return d;
                    },
                    hB: function() {
                        return u;
                    },
                    l6: function() {
                        return l;
                    },
                    uy: function() {
                        return g;
                    },
                    xj: function() {
                        return y;
                    }
                });
                var n = r(52), a = r(4263);
                function i(e) {
                    return (0, n.Z)(function(t) {
                        t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
                    }, function(e, t) {
                        e.setUTCDate(e.getUTCDate() + 7 * t);
                    }, function(e, t) {
                        return (t - e) / a.iM;
                    });
                }
                var o = i(0), l = i(1), s = i(2), c = i(3), u = i(4), f = i(5), d = i(6), h = o.range, p = l.range, v = s.range, g = c.range, y = u.range, m = f.range, x = d.range;
            },
            9791: function(e, t, r) {
                "use strict";
                r.d(t, {
                    D: function() {
                        return i;
                    }
                });
                var n = r(52), a = (0, n.Z)(function(e) {
                    e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
                }, function(e, t) {
                    e.setUTCFullYear(e.getUTCFullYear() + t);
                }, function(e, t) {
                    return t.getUTCFullYear() - e.getUTCFullYear();
                }, function(e) {
                    return e.getUTCFullYear();
                });
                a.every = function(e) {
                    return isFinite(e = Math.floor(e)) && e > 0 ? (0, n.Z)(function(t) {
                        t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
                    }, function(t, r) {
                        t.setUTCFullYear(t.getUTCFullYear() + r * e);
                    }) : null;
                }, t.Z = a;
                var i = a.range;
            },
            9879: function(e, t, r) {
                "use strict";
                r.d(t, {
                    $t: function() {
                        return y;
                    },
                    EY: function() {
                        return d;
                    },
                    Ff: function() {
                        return x;
                    },
                    Ld: function() {
                        return g;
                    },
                    OM: function() {
                        return o;
                    },
                    aU: function() {
                        return v;
                    },
                    b$: function() {
                        return m;
                    },
                    bJ: function() {
                        return p;
                    },
                    bL: function() {
                        return u;
                    },
                    mC: function() {
                        return f;
                    },
                    sy: function() {
                        return s;
                    },
                    vm: function() {
                        return h;
                    },
                    wA: function() {
                        return l;
                    },
                    zg: function() {
                        return c;
                    }
                });
                var n = r(52), a = r(4263);
                function i(e) {
                    return (0, n.Z)(function(t) {
                        t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
                    }, function(e, t) {
                        e.setDate(e.getDate() + 7 * t);
                    }, function(e, t) {
                        return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * a.yB) / a.iM;
                    });
                }
                var o = i(0), l = i(1), s = i(2), c = i(3), u = i(4), f = i(5), d = i(6), h = o.range, p = l.range, v = s.range, g = c.range, y = u.range, m = f.range, x = d.range;
            },
            4823: function(e, t, r) {
                "use strict";
                r.d(t, {
                    g: function() {
                        return i;
                    }
                });
                var n = r(52), a = (0, n.Z)(function(e) {
                    e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
                }, function(e, t) {
                    e.setFullYear(e.getFullYear() + t);
                }, function(e, t) {
                    return t.getFullYear() - e.getFullYear();
                }, function(e) {
                    return e.getFullYear();
                });
                a.every = function(e) {
                    return isFinite(e = Math.floor(e)) && e > 0 ? (0, n.Z)(function(t) {
                        t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
                    }, function(t, r) {
                        t.setFullYear(t.getFullYear() + r * e);
                    }) : null;
                }, t.Z = a;
                var i = a.range;
            },
            5398: function(e) {
                "use strict";
                var t, r = "object" == typeof Reflect ? Reflect : null, n = r && "function" == typeof r.apply ? r.apply : function(e, t, r) {
                    return Function.prototype.apply.call(e, t, r);
                };
                t = r && "function" == typeof r.ownKeys ? r.ownKeys : Object.getOwnPropertySymbols ? function(e) {
                    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
                } : function(e) {
                    return Object.getOwnPropertyNames(e);
                };
                var a = Number.isNaN || function(e) {
                    return e != e;
                };
                function i() {
                    i.init.call(this);
                }
                e.exports = i, e.exports.once = function(e, t) {
                    return new Promise(function(r, n) {
                        function a(r) {
                            e.removeListener(t, i), n(r);
                        }
                        function i() {
                            "function" == typeof e.removeListener && e.removeListener("error", a), r([].slice.call(arguments));
                        }
                        v(e, t, i, {
                            once: !0
                        }), "error" !== t && function(e, t, r) {
                            "function" == typeof e.on && v(e, "error", t, {
                                once: !0
                            });
                        }(e, a);
                    });
                }, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
                var o = 10;
                function l(e) {
                    if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
                }
                function s(e) {
                    return void 0 === e._maxListeners ? i.defaultMaxListeners : e._maxListeners;
                }
                function c(e, t, r, n) {
                    var a, i, o, c;
                    if (l(r), void 0 === (i = e._events) ? (i = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== i.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), i = e._events), o = i[t]), void 0 === o) o = i[t] = r, ++e._eventsCount;
                    else if ("function" == typeof o ? o = i[t] = n ? [
                        r,
                        o
                    ] : [
                        o,
                        r
                    ] : n ? o.unshift(r) : o.push(r), (a = s(e)) > 0 && o.length > a && !o.warned) {
                        o.warned = !0;
                        var u = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                        u.name = "MaxListenersExceededWarning", u.emitter = e, u.type = t, u.count = o.length, c = u, console && console.warn && console.warn(c);
                    }
                    return e;
                }
                function u() {
                    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                }
                function f(e, t, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: r
                    }, a = u.bind(n);
                    return a.listener = r, n.wrapFn = a, a;
                }
                function d(e, t, r) {
                    var n = e._events;
                    if (void 0 === n) return [];
                    var a = n[t];
                    return void 0 === a ? [] : "function" == typeof a ? r ? [
                        a.listener || a
                    ] : [
                        a
                    ] : r ? function(e) {
                        for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                        return t;
                    }(a) : p(a, a.length);
                }
                function h(e) {
                    var t = this._events;
                    if (void 0 !== t) {
                        var r = t[e];
                        if ("function" == typeof r) return 1;
                        if (void 0 !== r) return r.length;
                    }
                    return 0;
                }
                function p(e, t) {
                    for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                    return r;
                }
                function v(e, t, r, n) {
                    if ("function" == typeof e.on) n.once ? e.once(t, r) : e.on(t, r);
                    else {
                        if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
                        e.addEventListener(t, function a(i) {
                            n.once && e.removeEventListener(t, a), r(i);
                        });
                    }
                }
                Object.defineProperty(i, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return o;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
                        o = e;
                    }
                }), i.init = function() {
                    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }, i.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
                    return this._maxListeners = e, this;
                }, i.prototype.getMaxListeners = function() {
                    return s(this);
                }, i.prototype.emit = function(e) {
                    for(var t = [], r = 1; r < arguments.length; r++)t.push(arguments[r]);
                    var a = "error" === e, i = this._events;
                    if (void 0 !== i) a = a && void 0 === i.error;
                    else if (!a) return !1;
                    if (a) {
                        var o;
                        if (t.length > 0 && (o = t[0]), o instanceof Error) throw o;
                        var l = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
                        throw l.context = o, l;
                    }
                    var s = i[e];
                    if (void 0 === s) return !1;
                    if ("function" == typeof s) n(s, this, t);
                    else {
                        var c = s.length, u = p(s, c);
                        for(r = 0; r < c; ++r)n(u[r], this, t);
                    }
                    return !0;
                }, i.prototype.addListener = function(e, t) {
                    return c(this, e, t, !1);
                }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function(e, t) {
                    return c(this, e, t, !0);
                }, i.prototype.once = function(e, t) {
                    return l(t), this.on(e, f(this, e, t)), this;
                }, i.prototype.prependOnceListener = function(e, t) {
                    return l(t), this.prependListener(e, f(this, e, t)), this;
                }, i.prototype.removeListener = function(e, t) {
                    var r, n, a, i, o;
                    if (l(t), void 0 === (n = this._events)) return this;
                    if (void 0 === (r = n[e])) return this;
                    if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, r.listener || t));
                    else if ("function" != typeof r) {
                        for(a = -1, i = r.length - 1; i >= 0; i--)if (r[i] === t || r[i].listener === t) {
                            o = r[i].listener, a = i;
                            break;
                        }
                        if (a < 0) return this;
                        0 === a ? r.shift() : function(e, t) {
                            for(; t + 1 < e.length; t++)e[t] = e[t + 1];
                            e.pop();
                        }(r, a), 1 === r.length && (n[e] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", e, o || t);
                    }
                    return this;
                }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function(e) {
                    var t, r, n;
                    if (void 0 === (r = this._events)) return this;
                    if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[e]), this;
                    if (0 === arguments.length) {
                        var a, i = Object.keys(r);
                        for(n = 0; n < i.length; ++n)"removeListener" !== (a = i[n]) && this.removeAllListeners(a);
                        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = r[e])) this.removeListener(e, t);
                    else if (void 0 !== t) for(n = t.length - 1; n >= 0; n--)this.removeListener(e, t[n]);
                    return this;
                }, i.prototype.listeners = function(e) {
                    return d(this, e, !0);
                }, i.prototype.rawListeners = function(e) {
                    return d(this, e, !1);
                }, i.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : h.call(e, t);
                }, i.prototype.listenerCount = h, i.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? t(this._events) : [];
                };
            },
            2770: function(e, t, r) {
                "use strict";
                var n = r(8546);
                e.exports = function(e) {
                    var t = typeof e;
                    if ("string" === t) {
                        var r = e;
                        if (0 == (e = +e) && n(r)) return !1;
                    } else if ("number" !== t) return !1;
                    return e - e < 1;
                };
            },
            5400: function(e) {
                e.exports = function(e, t) {
                    var r = t[0], n = t[1], a = t[2], i = t[3], o = t[4], l = t[5], s = t[6], c = t[7], u = t[8], f = t[9], d = t[10], h = t[11], p = t[12], v = t[13], g = t[14], y = t[15];
                    return e[0] = l * (d * y - h * g) - f * (s * y - c * g) + v * (s * h - c * d), e[1] = -(n * (d * y - h * g) - f * (a * y - i * g) + v * (a * h - i * d)), e[2] = n * (s * y - c * g) - l * (a * y - i * g) + v * (a * c - i * s), e[3] = -(n * (s * h - c * d) - l * (a * h - i * d) + f * (a * c - i * s)), e[4] = -(o * (d * y - h * g) - u * (s * y - c * g) + p * (s * h - c * d)), e[5] = r * (d * y - h * g) - u * (a * y - i * g) + p * (a * h - i * d), e[6] = -(r * (s * y - c * g) - o * (a * y - i * g) + p * (a * c - i * s)), e[7] = r * (s * h - c * d) - o * (a * h - i * d) + u * (a * c - i * s), e[8] = o * (f * y - h * v) - u * (l * y - c * v) + p * (l * h - c * f), e[9] = -(r * (f * y - h * v) - u * (n * y - i * v) + p * (n * h - i * f)), e[10] = r * (l * y - c * v) - o * (n * y - i * v) + p * (n * c - i * l), e[11] = -(r * (l * h - c * f) - o * (n * h - i * f) + u * (n * c - i * l)), e[12] = -(o * (f * g - d * v) - u * (l * g - s * v) + p * (l * d - s * f)), e[13] = r * (f * g - d * v) - u * (n * g - a * v) + p * (n * d - a * f), e[14] = -(r * (l * g - s * v) - o * (n * g - a * v) + p * (n * s - a * l)), e[15] = r * (l * d - s * f) - o * (n * d - a * f) + u * (n * s - a * l), e;
                };
            },
            2331: function(e) {
                e.exports = function(e) {
                    var t = new Float32Array(16);
                    return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
                };
            },
            1042: function(e) {
                e.exports = function(e, t) {
                    return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
                };
            },
            1902: function(e) {
                e.exports = function() {
                    var e = new Float32Array(16);
                    return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
                };
            },
            9887: function(e) {
                e.exports = function(e) {
                    var t = e[0], r = e[1], n = e[2], a = e[3], i = e[4], o = e[5], l = e[6], s = e[7], c = e[8], u = e[9], f = e[10], d = e[11], h = e[12], p = e[13], v = e[14], g = e[15];
                    return (t * o - r * i) * (f * g - d * v) - (t * l - n * i) * (u * g - d * p) + (t * s - a * i) * (u * v - f * p) + (r * l - n * o) * (c * g - d * h) - (r * s - a * o) * (c * v - f * h) + (n * s - a * l) * (c * p - u * h);
                };
            },
            7812: function(e) {
                e.exports = function(e, t) {
                    var r = t[0], n = t[1], a = t[2], i = t[3], o = r + r, l = n + n, s = a + a, c = r * o, u = n * o, f = n * l, d = a * o, h = a * l, p = a * s, v = i * o, g = i * l, y = i * s;
                    return e[0] = 1 - f - p, e[1] = u + y, e[2] = d - g, e[3] = 0, e[4] = u - y, e[5] = 1 - c - p, e[6] = h + v, e[7] = 0, e[8] = d + g, e[9] = h - v, e[10] = 1 - c - f, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
                };
            },
            4045: function(e) {
                e.exports = function(e, t, r) {
                    var n, a, i, o = r[0], l = r[1], s = r[2], c = Math.sqrt(o * o + l * l + s * s);
                    return Math.abs(c) < 1e-6 ? null : (o *= c = 1 / c, l *= c, s *= c, n = Math.sin(t), i = 1 - (a = Math.cos(t)), e[0] = o * o * i + a, e[1] = l * o * i + s * n, e[2] = s * o * i - l * n, e[3] = 0, e[4] = o * l * i - s * n, e[5] = l * l * i + a, e[6] = s * l * i + o * n, e[7] = 0, e[8] = o * s * i + l * n, e[9] = l * s * i - o * n, e[10] = s * s * i + a, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e);
                };
            },
            5973: function(e) {
                e.exports = function(e, t, r) {
                    var n = t[0], a = t[1], i = t[2], o = t[3], l = n + n, s = a + a, c = i + i, u = n * l, f = n * s, d = n * c, h = a * s, p = a * c, v = i * c, g = o * l, y = o * s, m = o * c;
                    return e[0] = 1 - (h + v), e[1] = f + m, e[2] = d - y, e[3] = 0, e[4] = f - m, e[5] = 1 - (u + v), e[6] = p + g, e[7] = 0, e[8] = d + y, e[9] = p - g, e[10] = 1 - (u + h), e[11] = 0, e[12] = r[0], e[13] = r[1], e[14] = r[2], e[15] = 1, e;
                };
            },
            1472: function(e) {
                e.exports = function(e, t) {
                    return e[0] = t[0], e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = t[1], e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = t[2], e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
                };
            },
            4669: function(e) {
                e.exports = function(e, t) {
                    return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = t[0], e[13] = t[1], e[14] = t[2], e[15] = 1, e;
                };
            },
            5262: function(e) {
                e.exports = function(e, t) {
                    var r = Math.sin(t), n = Math.cos(t);
                    return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = n, e[6] = r, e[7] = 0, e[8] = 0, e[9] = -r, e[10] = n, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
                };
            },
            331: function(e) {
                e.exports = function(e, t) {
                    var r = Math.sin(t), n = Math.cos(t);
                    return e[0] = n, e[1] = 0, e[2] = -r, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = r, e[9] = 0, e[10] = n, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
                };
            },
            1049: function(e) {
                e.exports = function(e, t) {
                    var r = Math.sin(t), n = Math.cos(t);
                    return e[0] = n, e[1] = r, e[2] = 0, e[3] = 0, e[4] = -r, e[5] = n, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
                };
            },
            5195: function(e) {
                e.exports = function(e, t, r, n, a, i, o) {
                    var l = 1 / (r - t), s = 1 / (a - n), c = 1 / (i - o);
                    return e[0] = 2 * i * l, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 2 * i * s, e[6] = 0, e[7] = 0, e[8] = (r + t) * l, e[9] = (a + n) * s, e[10] = (o + i) * c, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = o * i * 2 * c, e[15] = 0, e;
                };
            },
            1551: function(e) {
                e.exports = function(e) {
                    return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
                };
            },
            9576: function(e, t, r) {
                e.exports = {
                    create: r(1902),
                    clone: r(2331),
                    copy: r(1042),
                    identity: r(1551),
                    transpose: r(8654),
                    invert: r(5874),
                    adjoint: r(5400),
                    determinant: r(9887),
                    multiply: r(1362),
                    translate: r(1283),
                    scale: r(789),
                    rotate: r(5074),
                    rotateX: r(5545),
                    rotateY: r(4918),
                    rotateZ: r(5692),
                    fromRotation: r(4045),
                    fromRotationTranslation: r(5973),
                    fromScaling: r(1472),
                    fromTranslation: r(4669),
                    fromXRotation: r(5262),
                    fromYRotation: r(331),
                    fromZRotation: r(1049),
                    fromQuat: r(7812),
                    frustum: r(5195),
                    perspective: r(7864),
                    perspectiveFromFieldOfView: r(5279),
                    ortho: r(378),
                    lookAt: r(5551),
                    str: r(6726)
                };
            },
            5874: function(e) {
                e.exports = function(e, t) {
                    var r = t[0], n = t[1], a = t[2], i = t[3], o = t[4], l = t[5], s = t[6], c = t[7], u = t[8], f = t[9], d = t[10], h = t[11], p = t[12], v = t[13], g = t[14], y = t[15], m = r * l - n * o, x = r * s - a * o, b = r * c - i * o, _ = n * s - a * l, w = n * c - i * l, T = a * c - i * s, M = u * v - f * p, k = u * g - d * p, A = u * y - h * p, L = f * g - d * v, S = f * y - h * v, D = d * y - h * g, O = m * D - x * S + b * L + _ * A - w * k + T * M;
                    return O ? (O = 1 / O, e[0] = (l * D - s * S + c * L) * O, e[1] = (a * S - n * D - i * L) * O, e[2] = (v * T - g * w + y * _) * O, e[3] = (d * w - f * T - h * _) * O, e[4] = (s * A - o * D - c * k) * O, e[5] = (r * D - a * A + i * k) * O, e[6] = (g * b - p * T - y * x) * O, e[7] = (u * T - d * b + h * x) * O, e[8] = (o * S - l * A + c * M) * O, e[9] = (n * A - r * S - i * M) * O, e[10] = (p * w - v * b + y * m) * O, e[11] = (f * b - u * w - h * m) * O, e[12] = (l * k - o * L - s * M) * O, e[13] = (r * L - n * k + a * M) * O, e[14] = (v * x - p * _ - g * m) * O, e[15] = (u * _ - f * x + d * m) * O, e) : null;
                };
            },
            5551: function(e, t, r) {
                var n = r(1551);
                e.exports = function(e, t, r, a) {
                    var i, o, l, s, c, u, f, d, h, p, v = t[0], g = t[1], y = t[2], m = a[0], x = a[1], b = a[2], _ = r[0], w = r[1], T = r[2];
                    return Math.abs(v - _) < 1e-6 && Math.abs(g - w) < 1e-6 && Math.abs(y - T) < 1e-6 ? n(e) : (f = v - _, d = g - w, h = y - T, i = x * (h *= p = 1 / Math.sqrt(f * f + d * d + h * h)) - b * (d *= p), o = b * (f *= p) - m * h, l = m * d - x * f, (p = Math.sqrt(i * i + o * o + l * l)) ? (i *= p = 1 / p, o *= p, l *= p) : (i = 0, o = 0, l = 0), s = d * l - h * o, c = h * i - f * l, u = f * o - d * i, (p = Math.sqrt(s * s + c * c + u * u)) ? (s *= p = 1 / p, c *= p, u *= p) : (s = 0, c = 0, u = 0), e[0] = i, e[1] = s, e[2] = f, e[3] = 0, e[4] = o, e[5] = c, e[6] = d, e[7] = 0, e[8] = l, e[9] = u, e[10] = h, e[11] = 0, e[12] = -(i * v + o * g + l * y), e[13] = -(s * v + c * g + u * y), e[14] = -(f * v + d * g + h * y), e[15] = 1, e);
                };
            },
            1362: function(e) {
                e.exports = function(e, t, r) {
                    var n = t[0], a = t[1], i = t[2], o = t[3], l = t[4], s = t[5], c = t[6], u = t[7], f = t[8], d = t[9], h = t[10], p = t[11], v = t[12], g = t[13], y = t[14], m = t[15], x = r[0], b = r[1], _ = r[2], w = r[3];
                    return e[0] = x * n + b * l + _ * f + w * v, e[1] = x * a + b * s + _ * d + w * g, e[2] = x * i + b * c + _ * h + w * y, e[3] = x * o + b * u + _ * p + w * m, x = r[4], b = r[5], _ = r[6], w = r[7], e[4] = x * n + b * l + _ * f + w * v, e[5] = x * a + b * s + _ * d + w * g, e[6] = x * i + b * c + _ * h + w * y, e[7] = x * o + b * u + _ * p + w * m, x = r[8], b = r[9], _ = r[10], w = r[11], e[8] = x * n + b * l + _ * f + w * v, e[9] = x * a + b * s + _ * d + w * g, e[10] = x * i + b * c + _ * h + w * y, e[11] = x * o + b * u + _ * p + w * m, x = r[12], b = r[13], _ = r[14], w = r[15], e[12] = x * n + b * l + _ * f + w * v, e[13] = x * a + b * s + _ * d + w * g, e[14] = x * i + b * c + _ * h + w * y, e[15] = x * o + b * u + _ * p + w * m, e;
                };
            },
            378: function(e) {
                e.exports = function(e, t, r, n, a, i, o) {
                    var l = 1 / (t - r), s = 1 / (n - a), c = 1 / (i - o);
                    return e[0] = -2 * l, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * s, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * c, e[11] = 0, e[12] = (t + r) * l, e[13] = (a + n) * s, e[14] = (o + i) * c, e[15] = 1, e;
                };
            },
            7864: function(e) {
                e.exports = function(e, t, r, n, a) {
                    var i = 1 / Math.tan(t / 2), o = 1 / (n - a);
                    return e[0] = i / r, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = i, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = (a + n) * o, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = 2 * a * n * o, e[15] = 0, e;
                };
            },
            5279: function(e) {
                e.exports = function(e, t, r, n) {
                    var a = Math.tan(t.upDegrees * Math.PI / 180), i = Math.tan(t.downDegrees * Math.PI / 180), o = Math.tan(t.leftDegrees * Math.PI / 180), l = Math.tan(t.rightDegrees * Math.PI / 180), s = 2 / (o + l), c = 2 / (a + i);
                    return e[0] = s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = c, e[6] = 0, e[7] = 0, e[8] = -(o - l) * s * .5, e[9] = (a - i) * c * .5, e[10] = n / (r - n), e[11] = -1, e[12] = 0, e[13] = 0, e[14] = n * r / (r - n), e[15] = 0, e;
                };
            },
            5074: function(e) {
                e.exports = function(e, t, r, n) {
                    var a, i, o, l, s, c, u, f, d, h, p, v, g, y, m, x, b, _, w, T, M, k, A, L, S = n[0], D = n[1], O = n[2], C = Math.sqrt(S * S + D * D + O * O);
                    return Math.abs(C) < 1e-6 ? null : (S *= C = 1 / C, D *= C, O *= C, a = Math.sin(r), o = 1 - (i = Math.cos(r)), l = t[0], s = t[1], c = t[2], u = t[3], f = t[4], d = t[5], h = t[6], p = t[7], v = t[8], g = t[9], y = t[10], m = t[11], x = S * S * o + i, b = D * S * o + O * a, _ = O * S * o - D * a, w = S * D * o - O * a, T = D * D * o + i, M = O * D * o + S * a, k = S * O * o + D * a, A = D * O * o - S * a, L = O * O * o + i, e[0] = l * x + f * b + v * _, e[1] = s * x + d * b + g * _, e[2] = c * x + h * b + y * _, e[3] = u * x + p * b + m * _, e[4] = l * w + f * T + v * M, e[5] = s * w + d * T + g * M, e[6] = c * w + h * T + y * M, e[7] = u * w + p * T + m * M, e[8] = l * k + f * A + v * L, e[9] = s * k + d * A + g * L, e[10] = c * k + h * A + y * L, e[11] = u * k + p * A + m * L, t !== e && (e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e);
                };
            },
            5545: function(e) {
                e.exports = function(e, t, r) {
                    var n = Math.sin(r), a = Math.cos(r), i = t[4], o = t[5], l = t[6], s = t[7], c = t[8], u = t[9], f = t[10], d = t[11];
                    return t !== e && (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[4] = i * a + c * n, e[5] = o * a + u * n, e[6] = l * a + f * n, e[7] = s * a + d * n, e[8] = c * a - i * n, e[9] = u * a - o * n, e[10] = f * a - l * n, e[11] = d * a - s * n, e;
                };
            },
            4918: function(e) {
                e.exports = function(e, t, r) {
                    var n = Math.sin(r), a = Math.cos(r), i = t[0], o = t[1], l = t[2], s = t[3], c = t[8], u = t[9], f = t[10], d = t[11];
                    return t !== e && (e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = i * a - c * n, e[1] = o * a - u * n, e[2] = l * a - f * n, e[3] = s * a - d * n, e[8] = i * n + c * a, e[9] = o * n + u * a, e[10] = l * n + f * a, e[11] = s * n + d * a, e;
                };
            },
            5692: function(e) {
                e.exports = function(e, t, r) {
                    var n = Math.sin(r), a = Math.cos(r), i = t[0], o = t[1], l = t[2], s = t[3], c = t[4], u = t[5], f = t[6], d = t[7];
                    return t !== e && (e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = i * a + c * n, e[1] = o * a + u * n, e[2] = l * a + f * n, e[3] = s * a + d * n, e[4] = c * a - i * n, e[5] = u * a - o * n, e[6] = f * a - l * n, e[7] = d * a - s * n, e;
                };
            },
            789: function(e) {
                e.exports = function(e, t, r) {
                    var n = r[0], a = r[1], i = r[2];
                    return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e[4] = t[4] * a, e[5] = t[5] * a, e[6] = t[6] * a, e[7] = t[7] * a, e[8] = t[8] * i, e[9] = t[9] * i, e[10] = t[10] * i, e[11] = t[11] * i, e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
                };
            },
            6726: function(e) {
                e.exports = function(e) {
                    return "mat4(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ", " + e[6] + ", " + e[7] + ", " + e[8] + ", " + e[9] + ", " + e[10] + ", " + e[11] + ", " + e[12] + ", " + e[13] + ", " + e[14] + ", " + e[15] + ")";
                };
            },
            1283: function(e) {
                e.exports = function(e, t, r) {
                    var n, a, i, o, l, s, c, u, f, d, h, p, v = r[0], g = r[1], y = r[2];
                    return t === e ? (e[12] = t[0] * v + t[4] * g + t[8] * y + t[12], e[13] = t[1] * v + t[5] * g + t[9] * y + t[13], e[14] = t[2] * v + t[6] * g + t[10] * y + t[14], e[15] = t[3] * v + t[7] * g + t[11] * y + t[15]) : (n = t[0], a = t[1], i = t[2], o = t[3], l = t[4], s = t[5], c = t[6], u = t[7], f = t[8], d = t[9], h = t[10], p = t[11], e[0] = n, e[1] = a, e[2] = i, e[3] = o, e[4] = l, e[5] = s, e[6] = c, e[7] = u, e[8] = f, e[9] = d, e[10] = h, e[11] = p, e[12] = n * v + l * g + f * y + t[12], e[13] = a * v + s * g + d * y + t[13], e[14] = i * v + c * g + h * y + t[14], e[15] = o * v + u * g + p * y + t[15]), e;
                };
            },
            8654: function(e) {
                e.exports = function(e, t) {
                    if (e === t) {
                        var r = t[1], n = t[2], a = t[3], i = t[6], o = t[7], l = t[11];
                        e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = r, e[6] = t[9], e[7] = t[13], e[8] = n, e[9] = i, e[11] = t[14], e[12] = a, e[13] = o, e[14] = l;
                    } else e[0] = t[0], e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = t[1], e[5] = t[5], e[6] = t[9], e[7] = t[13], e[8] = t[2], e[9] = t[6], e[10] = t[10], e[11] = t[14], e[12] = t[3], e[13] = t[7], e[14] = t[11], e[15] = t[15];
                    return e;
                };
            },
            7035: function(e, t, r) {
                "use strict";
                var n, a = r(4404);
                n = "function" == typeof r.g.matchMedia ? !r.g.matchMedia("(hover: none)").matches : a, e.exports = n;
            },
            8520: function(e, t, r) {
                "use strict";
                var n = r(4404);
                e.exports = n && function() {
                    var e = !1;
                    try {
                        var t = Object.defineProperty({}, "passive", {
                            get: function() {
                                e = !0;
                            }
                        });
                        window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
                    } catch (t) {
                        e = !1;
                    }
                    return e;
                }();
            },
            4404: function(e) {
                e.exports = !0;
            },
            8546: function(e) {
                "use strict";
                e.exports = function(e) {
                    for(var t, r = e.length, n = 0; n < r; n++)if (((t = e.charCodeAt(n)) < 9 || t > 13) && 32 !== t && 133 !== t && 160 !== t && 5760 !== t && 6158 !== t && (t < 8192 || t > 8205) && 8232 !== t && 8233 !== t && 8239 !== t && 8287 !== t && 8288 !== t && 12288 !== t && 65279 !== t) return !1;
                    return !0;
                };
            },
            8956: function(e) {
                var t = {
                    left: 0,
                    top: 0
                };
                e.exports = function(e, r, n) {
                    r = r || e.currentTarget || e.srcElement, Array.isArray(n) || (n = [
                        0,
                        0
                    ]);
                    var a, i = e.clientX || 0, o = e.clientY || 0, l = (a = r) === window || a === document || a === document.body ? t : a.getBoundingClientRect();
                    return n[0] = i - l.left, n[1] = o - l.top, n;
                };
            },
            7417: function(e, t, r) {
                var n, a, i, o;
                a = "Promise", o = function() {
                    "use strict";
                    var e, t, r, n = Object.prototype.toString, a = "undefined" != typeof setImmediate ? function(e) {
                        return setImmediate(e);
                    } : setTimeout;
                    try {
                        Object.defineProperty({}, "x", {}), e = function(e, t, r, n) {
                            return Object.defineProperty(e, t, {
                                value: r,
                                writable: !0,
                                configurable: !1 !== n
                            });
                        };
                    } catch (t) {
                        e = function(e, t, r) {
                            return e[t] = r, e;
                        };
                    }
                    function i(e, n) {
                        r.add(e, n), t || (t = a(r.drain));
                    }
                    function o(e) {
                        var t, r = typeof e;
                        return null == e || "object" != r && "function" != r || (t = e.then), "function" == typeof t && t;
                    }
                    function l() {
                        for(var e = 0; e < this.chain.length; e++)s(this, 1 === this.state ? this.chain[e].success : this.chain[e].failure, this.chain[e]);
                        this.chain.length = 0;
                    }
                    function s(e, t, r) {
                        var n, a;
                        try {
                            !1 === t ? r.reject(e.msg) : (n = !0 === t ? e.msg : t.call(void 0, e.msg)) === r.promise ? r.reject(TypeError("Promise-chain cycle")) : (a = o(n)) ? a.call(n, r.resolve, r.reject) : r.resolve(n);
                        } catch (e) {
                            r.reject(e);
                        }
                    }
                    function c(e) {
                        var t, r = this;
                        if (!r.triggered) {
                            r.triggered = !0, r.def && (r = r.def);
                            try {
                                (t = o(e)) ? i(function() {
                                    var n = new d(r);
                                    try {
                                        t.call(e, function() {
                                            c.apply(n, arguments);
                                        }, function() {
                                            u.apply(n, arguments);
                                        });
                                    } catch (e) {
                                        u.call(n, e);
                                    }
                                }) : (r.msg = e, r.state = 1, r.chain.length > 0 && i(l, r));
                            } catch (e) {
                                u.call(new d(r), e);
                            }
                        }
                    }
                    function u(e) {
                        var t = this;
                        t.triggered || (t.triggered = !0, t.def && (t = t.def), t.msg = e, t.state = 2, t.chain.length > 0 && i(l, t));
                    }
                    function f(e, t, r, n) {
                        for(var a = 0; a < t.length; a++)!function(a) {
                            e.resolve(t[a]).then(function(e) {
                                r(a, e);
                            }, n);
                        }(a);
                    }
                    function d(e) {
                        this.def = e, this.triggered = !1;
                    }
                    function h(e) {
                        this.promise = e, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
                    }
                    function p(e) {
                        if ("function" != typeof e) throw TypeError("Not a function");
                        if (0 !== this.__NPO__) throw TypeError("Not a promise");
                        this.__NPO__ = 1;
                        var t = new h(this);
                        this.then = function(e, r) {
                            var n = {
                                success: "function" != typeof e || e,
                                failure: "function" == typeof r && r
                            };
                            return n.promise = new this.constructor(function(e, t) {
                                if ("function" != typeof e || "function" != typeof t) throw TypeError("Not a function");
                                n.resolve = e, n.reject = t;
                            }), t.chain.push(n), 0 !== t.state && i(l, t), n.promise;
                        }, this.catch = function(e) {
                            return this.then(void 0, e);
                        };
                        try {
                            e.call(void 0, function(e) {
                                c.call(t, e);
                            }, function(e) {
                                u.call(t, e);
                            });
                        } catch (e) {
                            u.call(t, e);
                        }
                    }
                    r = function() {
                        var e, r, n;
                        function a(e, t) {
                            this.fn = e, this.self = t, this.next = void 0;
                        }
                        return {
                            add: function(t, i) {
                                n = new a(t, i), r ? r.next = n : e = n, r = n, n = void 0;
                            },
                            drain: function() {
                                var n = e;
                                for(e = r = t = void 0; n;)n.fn.call(n.self), n = n.next;
                            }
                        };
                    }();
                    var v = e({}, "constructor", p, !1);
                    return p.prototype = v, e(v, "__NPO__", 0, !1), e(p, "resolve", function(e) {
                        return e && "object" == typeof e && 1 === e.__NPO__ ? e : new this(function(t, r) {
                            if ("function" != typeof t || "function" != typeof r) throw TypeError("Not a function");
                            t(e);
                        });
                    }), e(p, "reject", function(e) {
                        return new this(function(t, r) {
                            if ("function" != typeof t || "function" != typeof r) throw TypeError("Not a function");
                            r(e);
                        });
                    }), e(p, "all", function(e) {
                        var t = this;
                        return "[object Array]" != n.call(e) ? t.reject(TypeError("Not an array")) : 0 === e.length ? t.resolve([]) : new t(function(r, n) {
                            if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                            var a = e.length, i = Array(a), o = 0;
                            f(t, e, function(e, t) {
                                i[e] = t, ++o === a && r(i);
                            }, n);
                        });
                    }), e(p, "race", function(e) {
                        var t = this;
                        return "[object Array]" != n.call(e) ? t.reject(TypeError("Not an array")) : new t(function(r, n) {
                            if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                            f(t, e, function(e, t) {
                                r(t);
                            }, n);
                        });
                    }), p;
                }, (i = void 0 !== r.g ? r.g : this)[a] = i[a] || o(), e.exports ? e.exports = i[a] : void 0 === (n = (function() {
                    return i[a];
                }).call(t, r, t, e)) || (e.exports = n);
            },
            6131: function(e) {
                "use strict";
                var t = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
                e.exports = function() {
                    try {
                        if (!Object.assign) return !1;
                        var e = new String("abc");
                        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
                        for(var t = {}, r = 0; r < 10; r++)t["_" + String.fromCharCode(r)] = r;
                        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function(e) {
                            return t[e];
                        }).join("")) return !1;
                        var n = {};
                        return "abcdefghijklmnopqrst".split("").forEach(function(e) {
                            n[e] = e;
                        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
                    } catch (e) {
                        return !1;
                    }
                }() ? Object.assign : function(e, a) {
                    for(var i, o, l = function(e) {
                        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
                        return Object(e);
                    }(e), s = 1; s < arguments.length; s++){
                        for(var c in i = Object(arguments[s]))r.call(i, c) && (l[c] = i[c]);
                        if (t) {
                            o = t(i);
                            for(var u = 0; u < o.length; u++)n.call(i, o[u]) && (l[o[u]] = i[o[u]]);
                        }
                    }
                    return l;
                };
            },
            5616: function(e) {
                e.exports = function(e) {
                    var a = [];
                    return e.replace(r, function(e, r, i) {
                        var o = r.toLowerCase();
                        for(i = function(e) {
                            var t = e.match(n);
                            return t ? t.map(Number) : [];
                        }(i), "m" == o && i.length > 2 && (a.push([
                            r
                        ].concat(i.splice(0, 2))), o = "l", r = "m" == r ? "l" : "L");;){
                            if (i.length == t[o]) return i.unshift(r), a.push(i);
                            if (i.length < t[o]) throw new Error("malformed path data");
                            a.push([
                                r
                            ].concat(i.splice(0, t[o])));
                        }
                    }), a;
                };
                var t = {
                    a: 7,
                    c: 6,
                    h: 1,
                    l: 2,
                    m: 2,
                    q: 4,
                    s: 4,
                    t: 2,
                    v: 1,
                    z: 0
                }, r = /([astvzqmhlc])([^astvzqmhlc]*)/gi, n = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
            },
            8258: function(e) {
                e.exports = function(e, t, r, n) {
                    var a = e[0], i = e[1], o = !1;
                    void 0 === r && (r = 0), void 0 === n && (n = t.length);
                    for(var l = n - r, s = 0, c = l - 1; s < l; c = s++){
                        var u = t[s + r][0], f = t[s + r][1], d = t[c + r][0], h = t[c + r][1];
                        f > i != h > i && a < (d - u) * (i - f) / (h - f) + u && (o = !o);
                    }
                    return o;
                };
            },
            2142: function(e, t, r) {
                var n, a = r(9444), i = r(9023), o = r(7263), l = r(1328), s = r(5968), c = r(670), u = !1, f = i();
                function d(e, t, r) {
                    var a = n.segments(e), i = n.segments(t), o = r(n.combine(a, i));
                    return n.polygon(o);
                }
                n = {
                    buildLog: function(e) {
                        return !0 === e ? u = a() : !1 === e && (u = !1), !1 !== u && u.list;
                    },
                    epsilon: function(e) {
                        return f.epsilon(e);
                    },
                    segments: function(e) {
                        var t = o(!0, f, u);
                        return e.regions.forEach(t.addRegion), {
                            segments: t.calculate(e.inverted),
                            inverted: e.inverted
                        };
                    },
                    combine: function(e, t) {
                        return {
                            combined: o(!1, f, u).calculate(e.segments, e.inverted, t.segments, t.inverted),
                            inverted1: e.inverted,
                            inverted2: t.inverted
                        };
                    },
                    selectUnion: function(e) {
                        return {
                            segments: s.union(e.combined, u),
                            inverted: e.inverted1 || e.inverted2
                        };
                    },
                    selectIntersect: function(e) {
                        return {
                            segments: s.intersect(e.combined, u),
                            inverted: e.inverted1 && e.inverted2
                        };
                    },
                    selectDifference: function(e) {
                        return {
                            segments: s.difference(e.combined, u),
                            inverted: e.inverted1 && !e.inverted2
                        };
                    },
                    selectDifferenceRev: function(e) {
                        return {
                            segments: s.differenceRev(e.combined, u),
                            inverted: !e.inverted1 && e.inverted2
                        };
                    },
                    selectXor: function(e) {
                        return {
                            segments: s.xor(e.combined, u),
                            inverted: e.inverted1 !== e.inverted2
                        };
                    },
                    polygon: function(e) {
                        return {
                            regions: l(e.segments, f, u),
                            inverted: e.inverted
                        };
                    },
                    polygonFromGeoJSON: function(e) {
                        return c.toPolygon(n, e);
                    },
                    polygonToGeoJSON: function(e) {
                        return c.fromPolygon(n, f, e);
                    },
                    union: function(e, t) {
                        return d(e, t, n.selectUnion);
                    },
                    intersect: function(e, t) {
                        return d(e, t, n.selectIntersect);
                    },
                    difference: function(e, t) {
                        return d(e, t, n.selectDifference);
                    },
                    differenceRev: function(e, t) {
                        return d(e, t, n.selectDifferenceRev);
                    },
                    xor: function(e, t) {
                        return d(e, t, n.selectXor);
                    }
                }, "object" == typeof window && (window.PolyBool = n), e.exports = n;
            },
            9444: function(e) {
                e.exports = function() {
                    var e, t = 0, r = !1;
                    function n(t, r) {
                        return e.list.push({
                            type: t,
                            data: r ? JSON.parse(JSON.stringify(r)) : void 0
                        }), e;
                    }
                    return e = {
                        list: [],
                        segmentId: function() {
                            return t++;
                        },
                        checkIntersection: function(e, t) {
                            return n("check", {
                                seg1: e,
                                seg2: t
                            });
                        },
                        segmentChop: function(e, t) {
                            return n("div_seg", {
                                seg: e,
                                pt: t
                            }), n("chop", {
                                seg: e,
                                pt: t
                            });
                        },
                        statusRemove: function(e) {
                            return n("pop_seg", {
                                seg: e
                            });
                        },
                        segmentUpdate: function(e) {
                            return n("seg_update", {
                                seg: e
                            });
                        },
                        segmentNew: function(e, t) {
                            return n("new_seg", {
                                seg: e,
                                primary: t
                            });
                        },
                        segmentRemove: function(e) {
                            return n("rem_seg", {
                                seg: e
                            });
                        },
                        tempStatus: function(e, t, r) {
                            return n("temp_status", {
                                seg: e,
                                above: t,
                                below: r
                            });
                        },
                        rewind: function(e) {
                            return n("rewind", {
                                seg: e
                            });
                        },
                        status: function(e, t, r) {
                            return n("status", {
                                seg: e,
                                above: t,
                                below: r
                            });
                        },
                        vert: function(t) {
                            return t === r ? e : (r = t, n("vert", {
                                x: t
                            }));
                        },
                        log: function(e) {
                            return "string" != typeof e && (e = JSON.stringify(e, !1, "  ")), n("log", {
                                txt: e
                            });
                        },
                        reset: function() {
                            return n("reset");
                        },
                        selected: function(e) {
                            return n("selected", {
                                segs: e
                            });
                        },
                        chainStart: function(e) {
                            return n("chain_start", {
                                seg: e
                            });
                        },
                        chainRemoveHead: function(e, t) {
                            return n("chain_rem_head", {
                                index: e,
                                pt: t
                            });
                        },
                        chainRemoveTail: function(e, t) {
                            return n("chain_rem_tail", {
                                index: e,
                                pt: t
                            });
                        },
                        chainNew: function(e, t) {
                            return n("chain_new", {
                                pt1: e,
                                pt2: t
                            });
                        },
                        chainMatch: function(e) {
                            return n("chain_match", {
                                index: e
                            });
                        },
                        chainClose: function(e) {
                            return n("chain_close", {
                                index: e
                            });
                        },
                        chainAddHead: function(e, t) {
                            return n("chain_add_head", {
                                index: e,
                                pt: t
                            });
                        },
                        chainAddTail: function(e, t) {
                            return n("chain_add_tail", {
                                index: e,
                                pt: t
                            });
                        },
                        chainConnect: function(e, t) {
                            return n("chain_con", {
                                index1: e,
                                index2: t
                            });
                        },
                        chainReverse: function(e) {
                            return n("chain_rev", {
                                index: e
                            });
                        },
                        chainJoin: function(e, t) {
                            return n("chain_join", {
                                index1: e,
                                index2: t
                            });
                        },
                        done: function() {
                            return n("done");
                        }
                    };
                };
            },
            9023: function(e) {
                e.exports = function(e) {
                    "number" != typeof e && (e = 1e-10);
                    var t = {
                        epsilon: function(t) {
                            return "number" == typeof t && (e = t), e;
                        },
                        pointAboveOrOnLine: function(t, r, n) {
                            var a = r[0], i = r[1], o = n[0], l = n[1], s = t[0];
                            return (o - a) * (t[1] - i) - (l - i) * (s - a) >= -e;
                        },
                        pointBetween: function(t, r, n) {
                            var a = t[1] - r[1], i = n[0] - r[0], o = t[0] - r[0], l = n[1] - r[1], s = o * i + a * l;
                            return !(s < e || s - (i * i + l * l) > -e);
                        },
                        pointsSameX: function(t, r) {
                            return Math.abs(t[0] - r[0]) < e;
                        },
                        pointsSameY: function(t, r) {
                            return Math.abs(t[1] - r[1]) < e;
                        },
                        pointsSame: function(e, r) {
                            return t.pointsSameX(e, r) && t.pointsSameY(e, r);
                        },
                        pointsCompare: function(e, r) {
                            return t.pointsSameX(e, r) ? t.pointsSameY(e, r) ? 0 : e[1] < r[1] ? -1 : 1 : e[0] < r[0] ? -1 : 1;
                        },
                        pointsCollinear: function(t, r, n) {
                            var a = t[0] - r[0], i = t[1] - r[1], o = r[0] - n[0], l = r[1] - n[1];
                            return Math.abs(a * l - o * i) < e;
                        },
                        linesIntersect: function(t, r, n, a) {
                            var i = r[0] - t[0], o = r[1] - t[1], l = a[0] - n[0], s = a[1] - n[1], c = i * s - o * l;
                            if (Math.abs(c) < e) return !1;
                            var u = t[0] - n[0], f = t[1] - n[1], d = (l * f - s * u) / c, h = (i * f - o * u) / c, p = {
                                alongA: 0,
                                alongB: 0,
                                pt: [
                                    t[0] + d * i,
                                    t[1] + d * o
                                ]
                            };
                            return p.alongA = d <= -e ? -2 : d < e ? -1 : d - 1 <= -e ? 0 : d - 1 < e ? 1 : 2, p.alongB = h <= -e ? -2 : h < e ? -1 : h - 1 <= -e ? 0 : h - 1 < e ? 1 : 2, p;
                        },
                        pointInsideRegion: function(t, r) {
                            for(var n = t[0], a = t[1], i = r[r.length - 1][0], o = r[r.length - 1][1], l = !1, s = 0; s < r.length; s++){
                                var c = r[s][0], u = r[s][1];
                                u - a > e != o - a > e && (i - c) * (a - u) / (o - u) + c - n > e && (l = !l), i = c, o = u;
                            }
                            return l;
                        }
                    };
                    return t;
                };
            },
            670: function(e) {
                var t = {
                    toPolygon: function(e, t) {
                        function r(t) {
                            if (t.length <= 0) return e.segments({
                                inverted: !1,
                                regions: []
                            });
                            function r(t) {
                                var r = t.slice(0, t.length - 1);
                                return e.segments({
                                    inverted: !1,
                                    regions: [
                                        r
                                    ]
                                });
                            }
                            for(var n = r(t[0]), a = 1; a < t.length; a++)n = e.selectDifference(e.combine(n, r(t[a])));
                            return n;
                        }
                        if ("Polygon" === t.type) return e.polygon(r(t.coordinates));
                        if ("MultiPolygon" === t.type) {
                            for(var n = e.segments({
                                inverted: !1,
                                regions: []
                            }), a = 0; a < t.coordinates.length; a++)n = e.selectUnion(e.combine(n, r(t.coordinates[a])));
                            return e.polygon(n);
                        }
                        throw new Error("PolyBool: Cannot convert GeoJSON object to PolyBool polygon");
                    },
                    fromPolygon: function(e, t, r) {
                        function n(e, r) {
                            return t.pointInsideRegion([
                                .5 * (e[0][0] + e[1][0]),
                                .5 * (e[0][1] + e[1][1])
                            ], r);
                        }
                        function a(e) {
                            return {
                                region: e,
                                children: []
                            };
                        }
                        r = e.polygon(e.segments(r));
                        var i = a(null);
                        function o(e, t) {
                            for(var r = 0; r < e.children.length; r++)if (n(t, (l = e.children[r]).region)) return void o(l, t);
                            var i = a(t);
                            for(r = 0; r < e.children.length; r++){
                                var l;
                                n((l = e.children[r]).region, t) && (i.children.push(l), e.children.splice(r, 1), r--);
                            }
                            e.children.push(i);
                        }
                        for(var l = 0; l < r.regions.length; l++){
                            var s = r.regions[l];
                            s.length < 3 || o(i, s);
                        }
                        function c(e, t) {
                            for(var r = 0, n = e[e.length - 1][0], a = e[e.length - 1][1], i = [], o = 0; o < e.length; o++){
                                var l = e[o][0], s = e[o][1];
                                i.push([
                                    l,
                                    s
                                ]), r += s * n - l * a, n = l, a = s;
                            }
                            return r < 0 !== t && i.reverse(), i.push([
                                i[0][0],
                                i[0][1]
                            ]), i;
                        }
                        var u = [];
                        function f(e) {
                            var t = [
                                c(e.region, !1)
                            ];
                            u.push(t);
                            for(var r = 0; r < e.children.length; r++)t.push(d(e.children[r]));
                        }
                        function d(e) {
                            for(var t = 0; t < e.children.length; t++)f(e.children[t]);
                            return c(e.region, !0);
                        }
                        for(l = 0; l < i.children.length; l++)f(i.children[l]);
                        return u.length <= 0 ? {
                            type: "Polygon",
                            coordinates: []
                        } : 1 == u.length ? {
                            type: "Polygon",
                            coordinates: u[0]
                        } : {
                            type: "MultiPolygon",
                            coordinates: u
                        };
                    }
                };
                e.exports = t;
            },
            7263: function(e, t, r) {
                var n = r(6859);
                e.exports = function(e, t, r) {
                    function a(e, t, n) {
                        return {
                            id: r ? r.segmentId() : -1,
                            start: e,
                            end: t,
                            myFill: {
                                above: n.myFill.above,
                                below: n.myFill.below
                            },
                            otherFill: null
                        };
                    }
                    var i = n.create();
                    function o(e, r) {
                        i.insertBefore(e, function(n) {
                            var a, i, o, l, s, c, u;
                            return a = e.isStart, i = e.pt, o = r, l = n.isStart, s = n.pt, c = n.other.pt, (0 !== (u = t.pointsCompare(i, s)) ? u : t.pointsSame(o, c) ? 0 : a !== l ? a ? 1 : -1 : t.pointAboveOrOnLine(o, l ? s : c, l ? c : s) ? 1 : -1) < 0;
                        });
                    }
                    function l(e, t) {
                        var r = function(e, t) {
                            var r = n.node({
                                isStart: !0,
                                pt: e.start,
                                seg: e,
                                primary: t,
                                other: null,
                                status: null
                            });
                            return o(r, e.end), r;
                        }(e, t);
                        return function(e, t, r) {
                            var a = n.node({
                                isStart: !1,
                                pt: t.end,
                                seg: t,
                                primary: r,
                                other: e,
                                status: null
                            });
                            e.other = a, o(a, e.pt);
                        }(r, e, t), r;
                    }
                    function s(e, t) {
                        var n = a(t, e.seg.end, e.seg);
                        return function(e, t) {
                            r && r.segmentChop(e.seg, t), e.other.remove(), e.seg.end = t, e.other.pt = t, o(e.other, e.pt);
                        }(e, t), l(n, e.primary);
                    }
                    function c(a, o) {
                        var l = n.create();
                        function c(e) {
                            return l.findTransition(function(r) {
                                var n, a, i, o, l, s;
                                return n = e, a = r.ev, i = n.seg.start, o = n.seg.end, l = a.seg.start, s = a.seg.end, (t.pointsCollinear(i, l, s) ? t.pointsCollinear(o, l, s) || t.pointAboveOrOnLine(o, l, s) ? 1 : -1 : t.pointAboveOrOnLine(i, l, s) ? 1 : -1) > 0;
                            });
                        }
                        function u(e, n) {
                            var a = e.seg, i = n.seg, o = a.start, l = a.end, c = i.start, u = i.end;
                            r && r.checkIntersection(a, i);
                            var f = t.linesIntersect(o, l, c, u);
                            if (!1 === f) {
                                if (!t.pointsCollinear(o, l, c)) return !1;
                                if (t.pointsSame(o, u) || t.pointsSame(l, c)) return !1;
                                var d = t.pointsSame(o, c), h = t.pointsSame(l, u);
                                if (d && h) return n;
                                var p = !d && t.pointBetween(o, c, u), v = !h && t.pointBetween(l, c, u);
                                if (d) return v ? s(n, l) : s(e, u), n;
                                p && (h || (v ? s(n, l) : s(e, u)), s(n, o));
                            } else 0 === f.alongA && (-1 === f.alongB ? s(e, c) : 0 === f.alongB ? s(e, f.pt) : 1 === f.alongB && s(e, u)), 0 === f.alongB && (-1 === f.alongA ? s(n, o) : 0 === f.alongA ? s(n, f.pt) : 1 === f.alongA && s(n, l));
                            return !1;
                        }
                        for(var f = []; !i.isEmpty();){
                            var d = i.getHead();
                            if (r && r.vert(d.pt[0]), d.isStart) {
                                r && r.segmentNew(d.seg, d.primary);
                                var h = c(d), p = h.before ? h.before.ev : null, v = h.after ? h.after.ev : null;
                                function g() {
                                    if (p) {
                                        var e = u(d, p);
                                        if (e) return e;
                                    }
                                    return !!v && u(d, v);
                                }
                                r && r.tempStatus(d.seg, !!p && p.seg, !!v && v.seg);
                                var y, m, x = g();
                                if (x) e ? (m = null === d.seg.myFill.below || d.seg.myFill.above !== d.seg.myFill.below) && (x.seg.myFill.above = !x.seg.myFill.above) : x.seg.otherFill = d.seg.myFill, r && r.segmentUpdate(x.seg), d.other.remove(), d.remove();
                                if (i.getHead() !== d) {
                                    r && r.rewind(d.seg);
                                    continue;
                                }
                                e ? (m = null === d.seg.myFill.below || d.seg.myFill.above !== d.seg.myFill.below, d.seg.myFill.below = v ? v.seg.myFill.above : a, d.seg.myFill.above = m ? !d.seg.myFill.below : d.seg.myFill.below) : null === d.seg.otherFill && (y = v ? d.primary === v.primary ? v.seg.otherFill.above : v.seg.myFill.above : d.primary ? o : a, d.seg.otherFill = {
                                    above: y,
                                    below: y
                                }), r && r.status(d.seg, !!p && p.seg, !!v && v.seg), d.other.status = h.insert(n.node({
                                    ev: d
                                }));
                            } else {
                                var b = d.status;
                                if (null === b) throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");
                                if (l.exists(b.prev) && l.exists(b.next) && u(b.prev.ev, b.next.ev), r && r.statusRemove(b.ev.seg), b.remove(), !d.primary) {
                                    var _ = d.seg.myFill;
                                    d.seg.myFill = d.seg.otherFill, d.seg.otherFill = _;
                                }
                                f.push(d.seg);
                            }
                            i.getHead().remove();
                        }
                        return r && r.done(), f;
                    }
                    return e ? {
                        addRegion: function(e) {
                            for(var n, a, i, o = e[e.length - 1], s = 0; s < e.length; s++){
                                n = o, o = e[s];
                                var c = t.pointsCompare(n, o);
                                0 !== c && l((a = c < 0 ? n : o, i = c < 0 ? o : n, {
                                    id: r ? r.segmentId() : -1,
                                    start: a,
                                    end: i,
                                    myFill: {
                                        above: null,
                                        below: null
                                    },
                                    otherFill: null
                                }), !0);
                            }
                        },
                        calculate: function(e) {
                            return c(e, !1);
                        }
                    } : {
                        calculate: function(e, t, r, n) {
                            return e.forEach(function(e) {
                                l(a(e.start, e.end, e), !0);
                            }), r.forEach(function(e) {
                                l(a(e.start, e.end, e), !1);
                            }), c(t, n);
                        }
                    };
                };
            },
            6859: function(e) {
                e.exports = {
                    create: function() {
                        var e = {
                            root: {
                                root: !0,
                                next: null
                            },
                            exists: function(t) {
                                return null !== t && t !== e.root;
                            },
                            isEmpty: function() {
                                return null === e.root.next;
                            },
                            getHead: function() {
                                return e.root.next;
                            },
                            insertBefore: function(t, r) {
                                for(var n = e.root, a = e.root.next; null !== a;){
                                    if (r(a)) return t.prev = a.prev, t.next = a, a.prev.next = t, void (a.prev = t);
                                    n = a, a = a.next;
                                }
                                n.next = t, t.prev = n, t.next = null;
                            },
                            findTransition: function(t) {
                                for(var r = e.root, n = e.root.next; null !== n && !t(n);)r = n, n = n.next;
                                return {
                                    before: r === e.root ? null : r,
                                    after: n,
                                    insert: function(e) {
                                        return e.prev = r, e.next = n, r.next = e, null !== n && (n.prev = e), e;
                                    }
                                };
                            }
                        };
                        return e;
                    },
                    node: function(e) {
                        return e.prev = null, e.next = null, e.remove = function() {
                            e.prev.next = e.next, e.next && (e.next.prev = e.prev), e.prev = null, e.next = null;
                        }, e;
                    }
                };
            },
            1328: function(e) {
                e.exports = function(e, t, r) {
                    var n = [], a = [];
                    return e.forEach(function(e) {
                        var i = e.start, o = e.end;
                        if (t.pointsSame(i, o)) console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");
                        else {
                            r && r.chainStart(e);
                            for(var l = {
                                index: 0,
                                matches_head: !1,
                                matches_pt1: !1
                            }, s = {
                                index: 0,
                                matches_head: !1,
                                matches_pt1: !1
                            }, c = l, u = 0; u < n.length; u++){
                                var f = (g = n[u])[0], d = (g[1], g[g.length - 1]);
                                if (g[g.length - 2], t.pointsSame(f, i)) {
                                    if (M(u, !0, !0)) break;
                                } else if (t.pointsSame(f, o)) {
                                    if (M(u, !0, !1)) break;
                                } else if (t.pointsSame(d, i)) {
                                    if (M(u, !1, !0)) break;
                                } else if (t.pointsSame(d, o) && M(u, !1, !1)) break;
                            }
                            if (c === l) return n.push([
                                i,
                                o
                            ]), void (r && r.chainNew(i, o));
                            if (c === s) {
                                r && r.chainMatch(l.index);
                                var h = l.index, p = l.matches_pt1 ? o : i, v = l.matches_head, g = n[h], y = v ? g[0] : g[g.length - 1], m = v ? g[1] : g[g.length - 2], x = v ? g[g.length - 1] : g[0], b = v ? g[g.length - 2] : g[1];
                                return t.pointsCollinear(m, y, p) && (v ? (r && r.chainRemoveHead(l.index, p), g.shift()) : (r && r.chainRemoveTail(l.index, p), g.pop()), y = m), t.pointsSame(x, p) ? (n.splice(h, 1), t.pointsCollinear(b, x, y) && (v ? (r && r.chainRemoveTail(l.index, y), g.pop()) : (r && r.chainRemoveHead(l.index, y), g.shift())), r && r.chainClose(l.index), void a.push(g)) : void (v ? (r && r.chainAddHead(l.index, p), g.unshift(p)) : (r && r.chainAddTail(l.index, p), g.push(p)));
                            }
                            var _ = l.index, w = s.index;
                            r && r.chainConnect(_, w);
                            var T = n[_].length < n[w].length;
                            l.matches_head ? s.matches_head ? T ? (k(_), A(_, w)) : (k(w), A(w, _)) : A(w, _) : s.matches_head ? A(_, w) : T ? (k(_), A(w, _)) : (k(w), A(_, w));
                        }
                        function M(e, t, r) {
                            return c.index = e, c.matches_head = t, c.matches_pt1 = r, c === l ? (c = s, !1) : (c = null, !0);
                        }
                        function k(e) {
                            r && r.chainReverse(e), n[e].reverse();
                        }
                        function A(e, a) {
                            var i = n[e], o = n[a], l = i[i.length - 1], s = i[i.length - 2], c = o[0], u = o[1];
                            t.pointsCollinear(s, l, c) && (r && r.chainRemoveTail(e, l), i.pop(), l = s), t.pointsCollinear(l, c, u) && (r && r.chainRemoveHead(a, c), o.shift()), r && r.chainJoin(e, a), n[e] = i.concat(o), n.splice(a, 1);
                        }
                    }), a;
                };
            },
            5968: function(e) {
                function t(e, t, r) {
                    var n = [];
                    return e.forEach(function(e) {
                        var a = (e.myFill.above ? 8 : 0) + (e.myFill.below ? 4 : 0) + (e.otherFill && e.otherFill.above ? 2 : 0) + (e.otherFill && e.otherFill.below ? 1 : 0);
                        0 !== t[a] && n.push({
                            id: r ? r.segmentId() : -1,
                            start: e.start,
                            end: e.end,
                            myFill: {
                                above: 1 === t[a],
                                below: 2 === t[a]
                            },
                            otherFill: null
                        });
                    }), r && r.selected(n), n;
                }
                var r = {
                    union: function(e, r) {
                        return t(e, [
                            0,
                            2,
                            1,
                            0,
                            2,
                            2,
                            0,
                            0,
                            1,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0
                        ], r);
                    },
                    intersect: function(e, r) {
                        return t(e, [
                            0,
                            0,
                            0,
                            0,
                            0,
                            2,
                            0,
                            2,
                            0,
                            0,
                            1,
                            1,
                            0,
                            2,
                            1,
                            0
                        ], r);
                    },
                    difference: function(e, r) {
                        return t(e, [
                            0,
                            0,
                            0,
                            0,
                            2,
                            0,
                            2,
                            0,
                            1,
                            1,
                            0,
                            0,
                            0,
                            1,
                            2,
                            0
                        ], r);
                    },
                    differenceRev: function(e, r) {
                        return t(e, [
                            0,
                            2,
                            1,
                            0,
                            0,
                            0,
                            1,
                            1,
                            0,
                            2,
                            0,
                            2,
                            0,
                            0,
                            0,
                            0
                        ], r);
                    },
                    xor: function(e, r) {
                        return t(e, [
                            0,
                            2,
                            1,
                            0,
                            2,
                            0,
                            0,
                            1,
                            1,
                            0,
                            0,
                            2,
                            0,
                            1,
                            2,
                            0
                        ], r);
                    }
                };
                e.exports = r;
            },
            4267: function(e, t, r) {
                var n;
                !function(a) {
                    var i = /^\s+/, o = /\s+$/, l = 0, s = a.round, c = a.min, u = a.max, f = a.random;
                    function d(e, t) {
                        if (t = t || {}, (e = e || "") instanceof d) return e;
                        if (!(this instanceof d)) return new d(e, t);
                        var r = function(e) {
                            var t, r, n, l = {
                                r: 0,
                                g: 0,
                                b: 0
                            }, s = 1, f = null, d = null, h = null, p = !1, v = !1;
                            return "string" == typeof e && (e = function(e) {
                                e = e.replace(i, "").replace(o, "").toLowerCase();
                                var t, r = !1;
                                if (O[e]) e = O[e], r = !0;
                                else if ("transparent" == e) return {
                                    r: 0,
                                    g: 0,
                                    b: 0,
                                    a: 0,
                                    format: "name"
                                };
                                return (t = V.rgb.exec(e)) ? {
                                    r: t[1],
                                    g: t[2],
                                    b: t[3]
                                } : (t = V.rgba.exec(e)) ? {
                                    r: t[1],
                                    g: t[2],
                                    b: t[3],
                                    a: t[4]
                                } : (t = V.hsl.exec(e)) ? {
                                    h: t[1],
                                    s: t[2],
                                    l: t[3]
                                } : (t = V.hsla.exec(e)) ? {
                                    h: t[1],
                                    s: t[2],
                                    l: t[3],
                                    a: t[4]
                                } : (t = V.hsv.exec(e)) ? {
                                    h: t[1],
                                    s: t[2],
                                    v: t[3]
                                } : (t = V.hsva.exec(e)) ? {
                                    h: t[1],
                                    s: t[2],
                                    v: t[3],
                                    a: t[4]
                                } : (t = V.hex8.exec(e)) ? {
                                    r: z(t[1]),
                                    g: z(t[2]),
                                    b: z(t[3]),
                                    a: H(t[4]),
                                    format: r ? "name" : "hex8"
                                } : (t = V.hex6.exec(e)) ? {
                                    r: z(t[1]),
                                    g: z(t[2]),
                                    b: z(t[3]),
                                    format: r ? "name" : "hex"
                                } : (t = V.hex4.exec(e)) ? {
                                    r: z(t[1] + "" + t[1]),
                                    g: z(t[2] + "" + t[2]),
                                    b: z(t[3] + "" + t[3]),
                                    a: H(t[4] + "" + t[4]),
                                    format: r ? "name" : "hex8"
                                } : !!(t = V.hex3.exec(e)) && {
                                    r: z(t[1] + "" + t[1]),
                                    g: z(t[2] + "" + t[2]),
                                    b: z(t[3] + "" + t[3]),
                                    format: r ? "name" : "hex"
                                };
                            }(e)), "object" == typeof e && (U(e.r) && U(e.g) && U(e.b) ? (t = e.r, r = e.g, n = e.b, l = {
                                r: 255 * I(t, 255),
                                g: 255 * I(r, 255),
                                b: 255 * I(n, 255)
                            }, p = !0, v = "%" === String(e.r).substr(-1) ? "prgb" : "rgb") : U(e.h) && U(e.s) && U(e.v) ? (f = F(e.s), d = F(e.v), l = function(e, t, r) {
                                e = 6 * I(e, 360), t = I(t, 100), r = I(r, 100);
                                var n = a.floor(e), i = e - n, o = r * (1 - t), l = r * (1 - i * t), s = r * (1 - (1 - i) * t), c = n % 6;
                                return {
                                    r: 255 * [
                                        r,
                                        l,
                                        o,
                                        o,
                                        s,
                                        r
                                    ][c],
                                    g: 255 * [
                                        s,
                                        r,
                                        r,
                                        l,
                                        o,
                                        o
                                    ][c],
                                    b: 255 * [
                                        o,
                                        o,
                                        s,
                                        r,
                                        r,
                                        l
                                    ][c]
                                };
                            }(e.h, f, d), p = !0, v = "hsv") : U(e.h) && U(e.s) && U(e.l) && (f = F(e.s), h = F(e.l), l = function(e, t, r) {
                                var n, a, i;
                                function o(e, t, r) {
                                    return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + 6 * (t - e) * r : r < .5 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
                                }
                                if (e = I(e, 360), t = I(t, 100), r = I(r, 100), 0 === t) n = a = i = r;
                                else {
                                    var l = r < .5 ? r * (1 + t) : r + t - r * t, s = 2 * r - l;
                                    n = o(s, l, e + 1 / 3), a = o(s, l, e), i = o(s, l, e - 1 / 3);
                                }
                                return {
                                    r: 255 * n,
                                    g: 255 * a,
                                    b: 255 * i
                                };
                            }(e.h, f, h), p = !0, v = "hsl"), e.hasOwnProperty("a") && (s = e.a)), s = P(s), {
                                ok: p,
                                format: e.format || v,
                                r: c(255, u(l.r, 0)),
                                g: c(255, u(l.g, 0)),
                                b: c(255, u(l.b, 0)),
                                a: s
                            };
                        }(e);
                        this._originalInput = e, this._r = r.r, this._g = r.g, this._b = r.b, this._a = r.a, this._roundA = s(100 * this._a) / 100, this._format = t.format || r.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = s(this._r)), this._g < 1 && (this._g = s(this._g)), this._b < 1 && (this._b = s(this._b)), this._ok = r.ok, this._tc_id = l++;
                    }
                    function h(e, t, r) {
                        e = I(e, 255), t = I(t, 255), r = I(r, 255);
                        var n, a, i = u(e, t, r), o = c(e, t, r), l = (i + o) / 2;
                        if (i == o) n = a = 0;
                        else {
                            var s = i - o;
                            switch(a = l > .5 ? s / (2 - i - o) : s / (i + o), i){
                                case e:
                                    n = (t - r) / s + (t < r ? 6 : 0);
                                    break;
                                case t:
                                    n = (r - e) / s + 2;
                                    break;
                                case r:
                                    n = (e - t) / s + 4;
                            }
                            n /= 6;
                        }
                        return {
                            h: n,
                            s: a,
                            l: l
                        };
                    }
                    function p(e, t, r) {
                        e = I(e, 255), t = I(t, 255), r = I(r, 255);
                        var n, a, i = u(e, t, r), o = c(e, t, r), l = i, s = i - o;
                        if (a = 0 === i ? 0 : s / i, i == o) n = 0;
                        else {
                            switch(i){
                                case e:
                                    n = (t - r) / s + (t < r ? 6 : 0);
                                    break;
                                case t:
                                    n = (r - e) / s + 2;
                                    break;
                                case r:
                                    n = (e - t) / s + 4;
                            }
                            n /= 6;
                        }
                        return {
                            h: n,
                            s: a,
                            v: l
                        };
                    }
                    function v(e, t, r, n) {
                        var a = [
                            N(s(e).toString(16)),
                            N(s(t).toString(16)),
                            N(s(r).toString(16))
                        ];
                        return n && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
                    }
                    function g(e, t, r, n) {
                        return [
                            N(E(n)),
                            N(s(e).toString(16)),
                            N(s(t).toString(16)),
                            N(s(r).toString(16))
                        ].join("");
                    }
                    function y(e, t) {
                        t = 0 === t ? 0 : t || 10;
                        var r = d(e).toHsl();
                        return r.s -= t / 100, r.s = R(r.s), d(r);
                    }
                    function m(e, t) {
                        t = 0 === t ? 0 : t || 10;
                        var r = d(e).toHsl();
                        return r.s += t / 100, r.s = R(r.s), d(r);
                    }
                    function x(e) {
                        return d(e).desaturate(100);
                    }
                    function b(e, t) {
                        t = 0 === t ? 0 : t || 10;
                        var r = d(e).toHsl();
                        return r.l += t / 100, r.l = R(r.l), d(r);
                    }
                    function _(e, t) {
                        t = 0 === t ? 0 : t || 10;
                        var r = d(e).toRgb();
                        return r.r = u(0, c(255, r.r - s(-t / 100 * 255))), r.g = u(0, c(255, r.g - s(-t / 100 * 255))), r.b = u(0, c(255, r.b - s(-t / 100 * 255))), d(r);
                    }
                    function w(e, t) {
                        t = 0 === t ? 0 : t || 10;
                        var r = d(e).toHsl();
                        return r.l -= t / 100, r.l = R(r.l), d(r);
                    }
                    function T(e, t) {
                        var r = d(e).toHsl(), n = (r.h + t) % 360;
                        return r.h = n < 0 ? 360 + n : n, d(r);
                    }
                    function M(e) {
                        var t = d(e).toHsl();
                        return t.h = (t.h + 180) % 360, d(t);
                    }
                    function k(e) {
                        var t = d(e).toHsl(), r = t.h;
                        return [
                            d(e),
                            d({
                                h: (r + 120) % 360,
                                s: t.s,
                                l: t.l
                            }),
                            d({
                                h: (r + 240) % 360,
                                s: t.s,
                                l: t.l
                            })
                        ];
                    }
                    function A(e) {
                        var t = d(e).toHsl(), r = t.h;
                        return [
                            d(e),
                            d({
                                h: (r + 90) % 360,
                                s: t.s,
                                l: t.l
                            }),
                            d({
                                h: (r + 180) % 360,
                                s: t.s,
                                l: t.l
                            }),
                            d({
                                h: (r + 270) % 360,
                                s: t.s,
                                l: t.l
                            })
                        ];
                    }
                    function L(e) {
                        var t = d(e).toHsl(), r = t.h;
                        return [
                            d(e),
                            d({
                                h: (r + 72) % 360,
                                s: t.s,
                                l: t.l
                            }),
                            d({
                                h: (r + 216) % 360,
                                s: t.s,
                                l: t.l
                            })
                        ];
                    }
                    function S(e, t, r) {
                        t = t || 6, r = r || 30;
                        var n = d(e).toHsl(), a = 360 / r, i = [
                            d(e)
                        ];
                        for(n.h = (n.h - (a * t >> 1) + 720) % 360; --t;)n.h = (n.h + a) % 360, i.push(d(n));
                        return i;
                    }
                    function D(e, t) {
                        t = t || 6;
                        for(var r = d(e).toHsv(), n = r.h, a = r.s, i = r.v, o = [], l = 1 / t; t--;)o.push(d({
                            h: n,
                            s: a,
                            v: i
                        })), i = (i + l) % 1;
                        return o;
                    }
                    d.prototype = {
                        isDark: function() {
                            return this.getBrightness() < 128;
                        },
                        isLight: function() {
                            return !this.isDark();
                        },
                        isValid: function() {
                            return this._ok;
                        },
                        getOriginalInput: function() {
                            return this._originalInput;
                        },
                        getFormat: function() {
                            return this._format;
                        },
                        getAlpha: function() {
                            return this._a;
                        },
                        getBrightness: function() {
                            var e = this.toRgb();
                            return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3;
                        },
                        getLuminance: function() {
                            var e, t, r, n = this.toRgb();
                            return e = n.r / 255, t = n.g / 255, r = n.b / 255, .2126 * (e <= .03928 ? e / 12.92 : a.pow((e + .055) / 1.055, 2.4)) + .7152 * (t <= .03928 ? t / 12.92 : a.pow((t + .055) / 1.055, 2.4)) + .0722 * (r <= .03928 ? r / 12.92 : a.pow((r + .055) / 1.055, 2.4));
                        },
                        setAlpha: function(e) {
                            return this._a = P(e), this._roundA = s(100 * this._a) / 100, this;
                        },
                        toHsv: function() {
                            var e = p(this._r, this._g, this._b);
                            return {
                                h: 360 * e.h,
                                s: e.s,
                                v: e.v,
                                a: this._a
                            };
                        },
                        toHsvString: function() {
                            var e = p(this._r, this._g, this._b), t = s(360 * e.h), r = s(100 * e.s), n = s(100 * e.v);
                            return 1 == this._a ? "hsv(" + t + ", " + r + "%, " + n + "%)" : "hsva(" + t + ", " + r + "%, " + n + "%, " + this._roundA + ")";
                        },
                        toHsl: function() {
                            var e = h(this._r, this._g, this._b);
                            return {
                                h: 360 * e.h,
                                s: e.s,
                                l: e.l,
                                a: this._a
                            };
                        },
                        toHslString: function() {
                            var e = h(this._r, this._g, this._b), t = s(360 * e.h), r = s(100 * e.s), n = s(100 * e.l);
                            return 1 == this._a ? "hsl(" + t + ", " + r + "%, " + n + "%)" : "hsla(" + t + ", " + r + "%, " + n + "%, " + this._roundA + ")";
                        },
                        toHex: function(e) {
                            return v(this._r, this._g, this._b, e);
                        },
                        toHexString: function(e) {
                            return "#" + this.toHex(e);
                        },
                        toHex8: function(e) {
                            return function(e, t, r, n, a) {
                                var i = [
                                    N(s(e).toString(16)),
                                    N(s(t).toString(16)),
                                    N(s(r).toString(16)),
                                    N(E(n))
                                ];
                                return a && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) && i[3].charAt(0) == i[3].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
                            }(this._r, this._g, this._b, this._a, e);
                        },
                        toHex8String: function(e) {
                            return "#" + this.toHex8(e);
                        },
                        toRgb: function() {
                            return {
                                r: s(this._r),
                                g: s(this._g),
                                b: s(this._b),
                                a: this._a
                            };
                        },
                        toRgbString: function() {
                            return 1 == this._a ? "rgb(" + s(this._r) + ", " + s(this._g) + ", " + s(this._b) + ")" : "rgba(" + s(this._r) + ", " + s(this._g) + ", " + s(this._b) + ", " + this._roundA + ")";
                        },
                        toPercentageRgb: function() {
                            return {
                                r: s(100 * I(this._r, 255)) + "%",
                                g: s(100 * I(this._g, 255)) + "%",
                                b: s(100 * I(this._b, 255)) + "%",
                                a: this._a
                            };
                        },
                        toPercentageRgbString: function() {
                            return 1 == this._a ? "rgb(" + s(100 * I(this._r, 255)) + "%, " + s(100 * I(this._g, 255)) + "%, " + s(100 * I(this._b, 255)) + "%)" : "rgba(" + s(100 * I(this._r, 255)) + "%, " + s(100 * I(this._g, 255)) + "%, " + s(100 * I(this._b, 255)) + "%, " + this._roundA + ")";
                        },
                        toName: function() {
                            return 0 === this._a ? "transparent" : !(this._a < 1) && (C[v(this._r, this._g, this._b, !0)] || !1);
                        },
                        toFilter: function(e) {
                            var t = "#" + g(this._r, this._g, this._b, this._a), r = t, n = this._gradientType ? "GradientType = 1, " : "";
                            if (e) {
                                var a = d(e);
                                r = "#" + g(a._r, a._g, a._b, a._a);
                            }
                            return "progid:DXImageTransform.Microsoft.gradient(" + n + "startColorstr=" + t + ",endColorstr=" + r + ")";
                        },
                        toString: function(e) {
                            var t = !!e;
                            e = e || this._format;
                            var r = !1, n = this._a < 1 && this._a >= 0;
                            return t || !n || "hex" !== e && "hex6" !== e && "hex3" !== e && "hex4" !== e && "hex8" !== e && "name" !== e ? ("rgb" === e && (r = this.toRgbString()), "prgb" === e && (r = this.toPercentageRgbString()), "hex" !== e && "hex6" !== e || (r = this.toHexString()), "hex3" === e && (r = this.toHexString(!0)), "hex4" === e && (r = this.toHex8String(!0)), "hex8" === e && (r = this.toHex8String()), "name" === e && (r = this.toName()), "hsl" === e && (r = this.toHslString()), "hsv" === e && (r = this.toHsvString()), r || this.toHexString()) : "name" === e && 0 === this._a ? this.toName() : this.toRgbString();
                        },
                        clone: function() {
                            return d(this.toString());
                        },
                        _applyModification: function(e, t) {
                            var r = e.apply(null, [
                                this
                            ].concat([].slice.call(t)));
                            return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
                        },
                        lighten: function() {
                            return this._applyModification(b, arguments);
                        },
                        brighten: function() {
                            return this._applyModification(_, arguments);
                        },
                        darken: function() {
                            return this._applyModification(w, arguments);
                        },
                        desaturate: function() {
                            return this._applyModification(y, arguments);
                        },
                        saturate: function() {
                            return this._applyModification(m, arguments);
                        },
                        greyscale: function() {
                            return this._applyModification(x, arguments);
                        },
                        spin: function() {
                            return this._applyModification(T, arguments);
                        },
                        _applyCombination: function(e, t) {
                            return e.apply(null, [
                                this
                            ].concat([].slice.call(t)));
                        },
                        analogous: function() {
                            return this._applyCombination(S, arguments);
                        },
                        complement: function() {
                            return this._applyCombination(M, arguments);
                        },
                        monochromatic: function() {
                            return this._applyCombination(D, arguments);
                        },
                        splitcomplement: function() {
                            return this._applyCombination(L, arguments);
                        },
                        triad: function() {
                            return this._applyCombination(k, arguments);
                        },
                        tetrad: function() {
                            return this._applyCombination(A, arguments);
                        }
                    }, d.fromRatio = function(e, t) {
                        if ("object" == typeof e) {
                            var r = {};
                            for(var n in e)e.hasOwnProperty(n) && (r[n] = "a" === n ? e[n] : F(e[n]));
                            e = r;
                        }
                        return d(e, t);
                    }, d.equals = function(e, t) {
                        return !(!e || !t) && d(e).toRgbString() == d(t).toRgbString();
                    }, d.random = function() {
                        return d.fromRatio({
                            r: f(),
                            g: f(),
                            b: f()
                        });
                    }, d.mix = function(e, t, r) {
                        r = 0 === r ? 0 : r || 50;
                        var n = d(e).toRgb(), a = d(t).toRgb(), i = r / 100;
                        return d({
                            r: (a.r - n.r) * i + n.r,
                            g: (a.g - n.g) * i + n.g,
                            b: (a.b - n.b) * i + n.b,
                            a: (a.a - n.a) * i + n.a
                        });
                    }, d.readability = function(e, t) {
                        var r = d(e), n = d(t);
                        return (a.max(r.getLuminance(), n.getLuminance()) + .05) / (a.min(r.getLuminance(), n.getLuminance()) + .05);
                    }, d.isReadable = function(e, t, r) {
                        var n, a, i, o, l, s = d.readability(e, t);
                        switch(a = !1, (i = r, "AA" !== (o = ((i = i || {
                            level: "AA",
                            size: "small"
                        }).level || "AA").toUpperCase()) && "AAA" !== o && (o = "AA"), "small" !== (l = (i.size || "small").toLowerCase()) && "large" !== l && (l = "small"), n = {
                            level: o,
                            size: l
                        }).level + n.size){
                            case "AAsmall":
                            case "AAAlarge":
                                a = s >= 4.5;
                                break;
                            case "AAlarge":
                                a = s >= 3;
                                break;
                            case "AAAsmall":
                                a = s >= 7;
                        }
                        return a;
                    }, d.mostReadable = function(e, t, r) {
                        var n, a, i, o, l = null, s = 0;
                        a = (r = r || {}).includeFallbackColors, i = r.level, o = r.size;
                        for(var c = 0; c < t.length; c++)(n = d.readability(e, t[c])) > s && (s = n, l = d(t[c]));
                        return d.isReadable(e, l, {
                            level: i,
                            size: o
                        }) || !a ? l : (r.includeFallbackColors = !1, d.mostReadable(e, [
                            "#fff",
                            "#000"
                        ], r));
                    };
                    var O = d.names = {
                        aliceblue: "f0f8ff",
                        antiquewhite: "faebd7",
                        aqua: "0ff",
                        aquamarine: "7fffd4",
                        azure: "f0ffff",
                        beige: "f5f5dc",
                        bisque: "ffe4c4",
                        black: "000",
                        blanchedalmond: "ffebcd",
                        blue: "00f",
                        blueviolet: "8a2be2",
                        brown: "a52a2a",
                        burlywood: "deb887",
                        burntsienna: "ea7e5d",
                        cadetblue: "5f9ea0",
                        chartreuse: "7fff00",
                        chocolate: "d2691e",
                        coral: "ff7f50",
                        cornflowerblue: "6495ed",
                        cornsilk: "fff8dc",
                        crimson: "dc143c",
                        cyan: "0ff",
                        darkblue: "00008b",
                        darkcyan: "008b8b",
                        darkgoldenrod: "b8860b",
                        darkgray: "a9a9a9",
                        darkgreen: "006400",
                        darkgrey: "a9a9a9",
                        darkkhaki: "bdb76b",
                        darkmagenta: "8b008b",
                        darkolivegreen: "556b2f",
                        darkorange: "ff8c00",
                        darkorchid: "9932cc",
                        darkred: "8b0000",
                        darksalmon: "e9967a",
                        darkseagreen: "8fbc8f",
                        darkslateblue: "483d8b",
                        darkslategray: "2f4f4f",
                        darkslategrey: "2f4f4f",
                        darkturquoise: "00ced1",
                        darkviolet: "9400d3",
                        deeppink: "ff1493",
                        deepskyblue: "00bfff",
                        dimgray: "696969",
                        dimgrey: "696969",
                        dodgerblue: "1e90ff",
                        firebrick: "b22222",
                        floralwhite: "fffaf0",
                        forestgreen: "228b22",
                        fuchsia: "f0f",
                        gainsboro: "dcdcdc",
                        ghostwhite: "f8f8ff",
                        gold: "ffd700",
                        goldenrod: "daa520",
                        gray: "808080",
                        green: "008000",
                        greenyellow: "adff2f",
                        grey: "808080",
                        honeydew: "f0fff0",
                        hotpink: "ff69b4",
                        indianred: "cd5c5c",
                        indigo: "4b0082",
                        ivory: "fffff0",
                        khaki: "f0e68c",
                        lavender: "e6e6fa",
                        lavenderblush: "fff0f5",
                        lawngreen: "7cfc00",
                        lemonchiffon: "fffacd",
                        lightblue: "add8e6",
                        lightcoral: "f08080",
                        lightcyan: "e0ffff",
                        lightgoldenrodyellow: "fafad2",
                        lightgray: "d3d3d3",
                        lightgreen: "90ee90",
                        lightgrey: "d3d3d3",
                        lightpink: "ffb6c1",
                        lightsalmon: "ffa07a",
                        lightseagreen: "20b2aa",
                        lightskyblue: "87cefa",
                        lightslategray: "789",
                        lightslategrey: "789",
                        lightsteelblue: "b0c4de",
                        lightyellow: "ffffe0",
                        lime: "0f0",
                        limegreen: "32cd32",
                        linen: "faf0e6",
                        magenta: "f0f",
                        maroon: "800000",
                        mediumaquamarine: "66cdaa",
                        mediumblue: "0000cd",
                        mediumorchid: "ba55d3",
                        mediumpurple: "9370db",
                        mediumseagreen: "3cb371",
                        mediumslateblue: "7b68ee",
                        mediumspringgreen: "00fa9a",
                        mediumturquoise: "48d1cc",
                        mediumvioletred: "c71585",
                        midnightblue: "191970",
                        mintcream: "f5fffa",
                        mistyrose: "ffe4e1",
                        moccasin: "ffe4b5",
                        navajowhite: "ffdead",
                        navy: "000080",
                        oldlace: "fdf5e6",
                        olive: "808000",
                        olivedrab: "6b8e23",
                        orange: "ffa500",
                        orangered: "ff4500",
                        orchid: "da70d6",
                        palegoldenrod: "eee8aa",
                        palegreen: "98fb98",
                        paleturquoise: "afeeee",
                        palevioletred: "db7093",
                        papayawhip: "ffefd5",
                        peachpuff: "ffdab9",
                        peru: "cd853f",
                        pink: "ffc0cb",
                        plum: "dda0dd",
                        powderblue: "b0e0e6",
                        purple: "800080",
                        rebeccapurple: "663399",
                        red: "f00",
                        rosybrown: "bc8f8f",
                        royalblue: "4169e1",
                        saddlebrown: "8b4513",
                        salmon: "fa8072",
                        sandybrown: "f4a460",
                        seagreen: "2e8b57",
                        seashell: "fff5ee",
                        sienna: "a0522d",
                        silver: "c0c0c0",
                        skyblue: "87ceeb",
                        slateblue: "6a5acd",
                        slategray: "708090",
                        slategrey: "708090",
                        snow: "fffafa",
                        springgreen: "00ff7f",
                        steelblue: "4682b4",
                        tan: "d2b48c",
                        teal: "008080",
                        thistle: "d8bfd8",
                        tomato: "ff6347",
                        turquoise: "40e0d0",
                        violet: "ee82ee",
                        wheat: "f5deb3",
                        white: "fff",
                        whitesmoke: "f5f5f5",
                        yellow: "ff0",
                        yellowgreen: "9acd32"
                    }, C = d.hexNames = function(e) {
                        var t = {};
                        for(var r in e)e.hasOwnProperty(r) && (t[e[r]] = r);
                        return t;
                    }(O);
                    function P(e) {
                        return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
                    }
                    function I(e, t) {
                        (function(e) {
                            return "string" == typeof e && -1 != e.indexOf(".") && 1 === parseFloat(e);
                        })(e) && (e = "100%");
                        var r = function(e) {
                            return "string" == typeof e && -1 != e.indexOf("%");
                        }(e);
                        return e = c(t, u(0, parseFloat(e))), r && (e = parseInt(e * t, 10) / 100), a.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
                    }
                    function R(e) {
                        return c(1, u(0, e));
                    }
                    function z(e) {
                        return parseInt(e, 16);
                    }
                    function N(e) {
                        return 1 == e.length ? "0" + e : "" + e;
                    }
                    function F(e) {
                        return e <= 1 && (e = 100 * e + "%"), e;
                    }
                    function E(e) {
                        return a.round(255 * parseFloat(e)).toString(16);
                    }
                    function H(e) {
                        return z(e) / 255;
                    }
                    var j, B, Y, V = (B = "[\\s|\\(]+(" + (j = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + j + ")[,|\\s]+(" + j + ")\\s*\\)?", Y = "[\\s|\\(]+(" + j + ")[,|\\s]+(" + j + ")[,|\\s]+(" + j + ")[,|\\s]+(" + j + ")\\s*\\)?", {
                        CSS_UNIT: new RegExp(j),
                        rgb: new RegExp("rgb" + B),
                        rgba: new RegExp("rgba" + Y),
                        hsl: new RegExp("hsl" + B),
                        hsla: new RegExp("hsla" + Y),
                        hsv: new RegExp("hsv" + B),
                        hsva: new RegExp("hsva" + Y),
                        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
                        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
                    });
                    function U(e) {
                        return !!V.CSS_UNIT.exec(e);
                    }
                    e.exports ? e.exports = d : void 0 === (n = (function() {
                        return d;
                    }).call(t, r, t, e)) || (e.exports = n);
                }(Math);
            },
            3961: function(e, t, r) {
                var n = r(3489), a = r(6131), i = n.instance();
                function o(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                o.prototype = new n.baseCalendar, a(o.prototype, {
                    name: "Chinese",
                    jdEpoch: 1721425.5,
                    hasYearZero: !1,
                    minMonth: 0,
                    firstMonth: 0,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Chinese",
                            epochs: [
                                "BEC",
                                "EC"
                            ],
                            monthNumbers: function(e, t) {
                                if ("string" == typeof e) {
                                    var r = e.match(s);
                                    return r ? r[0] : "";
                                }
                                var n = this._validateYear(e), a = e.month(), i = "" + this.toChineseMonth(n, a);
                                return t && i.length < 2 && (i = "0" + i), this.isIntercalaryMonth(n, a) && (i += "i"), i;
                            },
                            monthNames: function(e) {
                                if ("string" == typeof e) {
                                    var t = e.match(c);
                                    return t ? t[0] : "";
                                }
                                var r = this._validateYear(e), n = e.month(), a = [
                                    "\u4E00\u6708",
                                    "\u4E8C\u6708",
                                    "\u4E09\u6708",
                                    "\u56DB\u6708",
                                    "\u4E94\u6708",
                                    "\u516D\u6708",
                                    "\u4E03\u6708",
                                    "\u516B\u6708",
                                    "\u4E5D\u6708",
                                    "\u5341\u6708",
                                    "\u5341\u4E00\u6708",
                                    "\u5341\u4E8C\u6708"
                                ][this.toChineseMonth(r, n) - 1];
                                return this.isIntercalaryMonth(r, n) && (a = "\u95F0" + a), a;
                            },
                            monthNamesShort: function(e) {
                                if ("string" == typeof e) {
                                    var t = e.match(u);
                                    return t ? t[0] : "";
                                }
                                var r = this._validateYear(e), n = e.month(), a = [
                                    "\u4E00",
                                    "\u4E8C",
                                    "\u4E09",
                                    "\u56DB",
                                    "\u4E94",
                                    "\u516D",
                                    "\u4E03",
                                    "\u516B",
                                    "\u4E5D",
                                    "\u5341",
                                    "\u5341\u4E00",
                                    "\u5341\u4E8C"
                                ][this.toChineseMonth(r, n) - 1];
                                return this.isIntercalaryMonth(r, n) && (a = "\u95F0" + a), a;
                            },
                            parseMonth: function(e, t) {
                                e = this._validateYear(e);
                                var r, n = parseInt(t);
                                if (isNaN(n)) "\u95F0" === t[0] && (r = !0, t = t.substring(1)), "\u6708" === t[t.length - 1] && (t = t.substring(0, t.length - 1)), n = 1 + [
                                    "\u4E00",
                                    "\u4E8C",
                                    "\u4E09",
                                    "\u56DB",
                                    "\u4E94",
                                    "\u516D",
                                    "\u4E03",
                                    "\u516B",
                                    "\u4E5D",
                                    "\u5341",
                                    "\u5341\u4E00",
                                    "\u5341\u4E8C"
                                ].indexOf(t);
                                else {
                                    var a = t[t.length - 1];
                                    r = "i" === a || "I" === a;
                                }
                                return this.toMonthIndex(e, n, r);
                            },
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 1,
                            isRTL: !1
                        }
                    },
                    _validateYear: function(e, t) {
                        if (e.year && (e = e.year()), "number" != typeof e || e < 1888 || e > 2111) throw t.replace(/\{0\}/, this.local.name);
                        return e;
                    },
                    toMonthIndex: function(e, t, r) {
                        var a = this.intercalaryMonth(e);
                        if (r && t !== a || t < 1 || t > 12) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
                        return a ? !r && t <= a ? t - 1 : t : t - 1;
                    },
                    toChineseMonth: function(e, t) {
                        e.year && (t = (e = e.year()).month());
                        var r = this.intercalaryMonth(e);
                        if (t < 0 || t > (r ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
                        return r ? t < r ? t + 1 : t : t + 1;
                    },
                    intercalaryMonth: function(e) {
                        return e = this._validateYear(e), f[e - f[0]] >> 13;
                    },
                    isIntercalaryMonth: function(e, t) {
                        e.year && (t = (e = e.year()).month());
                        var r = this.intercalaryMonth(e);
                        return !!r && r === t;
                    },
                    leapYear: function(e) {
                        return 0 !== this.intercalaryMonth(e);
                    },
                    weekOfYear: function(e, t, r) {
                        var a, o = this._validateYear(e, n.local.invalidyear), l = d[o - d[0]], s = l >> 9 & 4095, c = l >> 5 & 15, u = 31 & l;
                        (a = i.newDate(s, c, u)).add(4 - (a.dayOfWeek() || 7), "d");
                        var f = this.toJD(e, t, r) - a.toJD();
                        return 1 + Math.floor(f / 7);
                    },
                    monthsInYear: function(e) {
                        return this.leapYear(e) ? 13 : 12;
                    },
                    daysInMonth: function(e, t) {
                        e.year && (t = e.month(), e = e.year()), e = this._validateYear(e);
                        var r = f[e - f[0]];
                        if (t > (r >> 13 ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
                        return r & 1 << 12 - t ? 30 : 29;
                    },
                    weekDay: function(e, t, r) {
                        return (this.dayOfWeek(e, t, r) || 7) < 6;
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, l, r, n.local.invalidDate);
                        e = this._validateYear(a.year()), t = a.month(), r = a.day();
                        var o = this.isIntercalaryMonth(e, t), l = this.toChineseMonth(e, t), s = function(e, t, r, n, a) {
                            var i, o, l;
                            if ("object" == typeof e) o = e, i = t || {};
                            else {
                                var s;
                                if (!("number" == typeof e && e >= 1888 && e <= 2111)) throw new Error("Lunar year outside range 1888-2111");
                                if (!("number" == typeof t && t >= 1 && t <= 12)) throw new Error("Lunar month outside range 1 - 12");
                                if (!("number" == typeof r && r >= 1 && r <= 30)) throw new Error("Lunar day outside range 1 - 30");
                                "object" == typeof n ? (s = !1, i = n) : (s = !!n, i = {}), o = {
                                    year: e,
                                    month: t,
                                    day: r,
                                    isIntercalary: s
                                };
                            }
                            l = o.day - 1;
                            var c, u = f[o.year - f[0]], h = u >> 13;
                            c = h && (o.month > h || o.isIntercalary) ? o.month : o.month - 1;
                            for(var p = 0; p < c; p++)l += u & 1 << 12 - p ? 30 : 29;
                            var v = d[o.year - d[0]], g = new Date(v >> 9 & 4095, (v >> 5 & 15) - 1, (31 & v) + l);
                            return i.year = g.getFullYear(), i.month = 1 + g.getMonth(), i.day = g.getDate(), i;
                        }(e, l, r, o);
                        return i.toJD(s.year, s.month, s.day);
                    },
                    fromJD: function(e) {
                        var t = i.fromJD(e), r = function(e, t, r, n) {
                            var a, i;
                            if ("object" == typeof e) a = e, i = t || {};
                            else {
                                if (!("number" == typeof e && e >= 1888 && e <= 2111)) throw new Error("Solar year outside range 1888-2111");
                                if (!("number" == typeof t && t >= 1 && t <= 12)) throw new Error("Solar month outside range 1 - 12");
                                if (!("number" == typeof r && r >= 1 && r <= 31)) throw new Error("Solar day outside range 1 - 31");
                                a = {
                                    year: e,
                                    month: t,
                                    day: r
                                }, i = {};
                            }
                            var o = d[a.year - d[0]], l = a.year << 9 | a.month << 5 | a.day;
                            i.year = l >= o ? a.year : a.year - 1, o = d[i.year - d[0]];
                            var s, c = new Date(o >> 9 & 4095, (o >> 5 & 15) - 1, 31 & o), u = new Date(a.year, a.month - 1, a.day);
                            s = Math.round((u - c) / 864e5);
                            var h, p = f[i.year - f[0]];
                            for(h = 0; h < 13; h++){
                                var v = p & 1 << 12 - h ? 30 : 29;
                                if (s < v) break;
                                s -= v;
                            }
                            var g = p >> 13;
                            return !g || h < g ? (i.isIntercalary = !1, i.month = 1 + h) : h === g ? (i.isIntercalary = !0, i.month = h) : (i.isIntercalary = !1, i.month = h), i.day = 1 + s, i;
                        }(t.year(), t.month(), t.day()), n = this.toMonthIndex(r.year, r.month, r.isIntercalary);
                        return this.newDate(r.year, n, r.day);
                    },
                    fromString: function(e) {
                        var t = e.match(l), r = this._validateYear(+t[1]), n = +t[2], a = !!t[3], i = this.toMonthIndex(r, n, a), o = +t[4];
                        return this.newDate(r, i, o);
                    },
                    add: function(e, t, r) {
                        var n = e.year(), a = e.month(), i = this.isIntercalaryMonth(n, a), l = this.toChineseMonth(n, a), s = Object.getPrototypeOf(o.prototype).add.call(this, e, t, r);
                        if ("y" === r) {
                            var c = s.year(), u = s.month(), f = this.isIntercalaryMonth(c, l), d = i && f ? this.toMonthIndex(c, l, !0) : this.toMonthIndex(c, l, !1);
                            d !== u && s.month(d);
                        }
                        return s;
                    }
                });
                var l = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m, s = /^\d?\d[iI]?/m, c = /^闰?十?[一二三四五六七八九]?月/m, u = /^闰?十?[一二三四五六七八九]?/m;
                n.calendars.chinese = o;
                var f = [
                    1887,
                    5780,
                    5802,
                    19157,
                    2742,
                    50359,
                    1198,
                    2646,
                    46378,
                    7466,
                    3412,
                    30122,
                    5482,
                    67949,
                    2396,
                    5294,
                    43597,
                    6732,
                    6954,
                    36181,
                    2772,
                    4954,
                    18781,
                    2396,
                    54427,
                    5274,
                    6730,
                    47781,
                    5800,
                    6868,
                    21210,
                    4790,
                    59703,
                    2350,
                    5270,
                    46667,
                    3402,
                    3496,
                    38325,
                    1388,
                    4782,
                    18735,
                    2350,
                    52374,
                    6804,
                    7498,
                    44457,
                    2906,
                    1388,
                    29294,
                    4700,
                    63789,
                    6442,
                    6804,
                    56138,
                    5802,
                    2772,
                    38235,
                    1210,
                    4698,
                    22827,
                    5418,
                    63125,
                    3476,
                    5802,
                    43701,
                    2484,
                    5302,
                    27223,
                    2646,
                    70954,
                    7466,
                    3412,
                    54698,
                    5482,
                    2412,
                    38062,
                    5294,
                    2636,
                    32038,
                    6954,
                    60245,
                    2772,
                    4826,
                    43357,
                    2394,
                    5274,
                    39501,
                    6730,
                    72357,
                    5800,
                    5844,
                    53978,
                    4790,
                    2358,
                    38039,
                    5270,
                    87627,
                    3402,
                    3496,
                    54708,
                    5484,
                    4782,
                    43311,
                    2350,
                    3222,
                    27978,
                    7498,
                    68965,
                    2904,
                    5484,
                    45677,
                    4700,
                    6444,
                    39573,
                    6804,
                    6986,
                    19285,
                    2772,
                    62811,
                    1210,
                    4698,
                    47403,
                    5418,
                    5780,
                    38570,
                    5546,
                    76469,
                    2420,
                    5302,
                    51799,
                    2646,
                    5414,
                    36501,
                    3412,
                    5546,
                    18869,
                    2412,
                    54446,
                    5276,
                    6732,
                    48422,
                    6822,
                    2900,
                    28010,
                    4826,
                    92509,
                    2394,
                    5274,
                    55883,
                    6730,
                    6820,
                    47956,
                    5812,
                    2778,
                    18779,
                    2358,
                    62615,
                    5270,
                    5450,
                    46757,
                    3492,
                    5556,
                    27318,
                    4718,
                    67887,
                    2350,
                    3222,
                    52554,
                    7498,
                    3428,
                    38252,
                    5468,
                    4700,
                    31022,
                    6444,
                    64149,
                    6804,
                    6986,
                    43861,
                    2772,
                    5338,
                    35421,
                    2650,
                    70955,
                    5418,
                    5780,
                    54954,
                    5546,
                    2740,
                    38074,
                    5302,
                    2646,
                    29991,
                    3366,
                    61011,
                    3412,
                    5546,
                    43445,
                    2412,
                    5294,
                    35406,
                    6732,
                    72998,
                    6820,
                    6996,
                    52586,
                    2778,
                    2396,
                    38045,
                    5274,
                    6698,
                    23333,
                    6820,
                    64338,
                    5812,
                    2746,
                    43355,
                    2358,
                    5270,
                    39499,
                    5450,
                    79525,
                    3492,
                    5548
                ], d = [
                    1887,
                    966732,
                    967231,
                    967733,
                    968265,
                    968766,
                    969297,
                    969798,
                    970298,
                    970829,
                    971330,
                    971830,
                    972362,
                    972863,
                    973395,
                    973896,
                    974397,
                    974928,
                    975428,
                    975929,
                    976461,
                    976962,
                    977462,
                    977994,
                    978494,
                    979026,
                    979526,
                    980026,
                    980558,
                    981059,
                    981559,
                    982091,
                    982593,
                    983124,
                    983624,
                    984124,
                    984656,
                    985157,
                    985656,
                    986189,
                    986690,
                    987191,
                    987722,
                    988222,
                    988753,
                    989254,
                    989754,
                    990286,
                    990788,
                    991288,
                    991819,
                    992319,
                    992851,
                    993352,
                    993851,
                    994383,
                    994885,
                    995385,
                    995917,
                    996418,
                    996918,
                    997450,
                    997949,
                    998481,
                    998982,
                    999483,
                    1000014,
                    1000515,
                    1001016,
                    1001548,
                    1002047,
                    1002578,
                    1003080,
                    1003580,
                    1004111,
                    1004613,
                    1005113,
                    1005645,
                    1006146,
                    1006645,
                    1007177,
                    1007678,
                    1008209,
                    1008710,
                    1009211,
                    1009743,
                    1010243,
                    1010743,
                    1011275,
                    1011775,
                    1012306,
                    1012807,
                    1013308,
                    1013840,
                    1014341,
                    1014841,
                    1015373,
                    1015874,
                    1016404,
                    1016905,
                    1017405,
                    1017937,
                    1018438,
                    1018939,
                    1019471,
                    1019972,
                    1020471,
                    1021002,
                    1021503,
                    1022035,
                    1022535,
                    1023036,
                    1023568,
                    1024069,
                    1024568,
                    1025100,
                    1025601,
                    1026102,
                    1026633,
                    1027133,
                    1027666,
                    1028167,
                    1028666,
                    1029198,
                    1029699,
                    1030199,
                    1030730,
                    1031231,
                    1031763,
                    1032264,
                    1032764,
                    1033296,
                    1033797,
                    1034297,
                    1034828,
                    1035329,
                    1035830,
                    1036362,
                    1036861,
                    1037393,
                    1037894,
                    1038394,
                    1038925,
                    1039427,
                    1039927,
                    1040459,
                    1040959,
                    1041491,
                    1041992,
                    1042492,
                    1043023,
                    1043524,
                    1044024,
                    1044556,
                    1045057,
                    1045558,
                    1046090,
                    1046590,
                    1047121,
                    1047622,
                    1048122,
                    1048654,
                    1049154,
                    1049655,
                    1050187,
                    1050689,
                    1051219,
                    1051720,
                    1052220,
                    1052751,
                    1053252,
                    1053752,
                    1054284,
                    1054786,
                    1055285,
                    1055817,
                    1056317,
                    1056849,
                    1057349,
                    1057850,
                    1058382,
                    1058883,
                    1059383,
                    1059915,
                    1060415,
                    1060947,
                    1061447,
                    1061947,
                    1062479,
                    1062981,
                    1063480,
                    1064012,
                    1064514,
                    1065014,
                    1065545,
                    1066045,
                    1066577,
                    1067078,
                    1067578,
                    1068110,
                    1068611,
                    1069112,
                    1069642,
                    1070142,
                    1070674,
                    1071175,
                    1071675,
                    1072207,
                    1072709,
                    1073209,
                    1073740,
                    1074241,
                    1074741,
                    1075273,
                    1075773,
                    1076305,
                    1076807,
                    1077308,
                    1077839,
                    1078340,
                    1078840,
                    1079372,
                    1079871,
                    1080403,
                    1080904
                ];
            },
            8751: function(e, t, r) {
                var n = r(3489), a = r(6131);
                function i(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                i.prototype = new n.baseCalendar, a(i.prototype, {
                    name: "Coptic",
                    jdEpoch: 1825029.5,
                    daysPerMonth: [
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        5
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Coptic",
                            epochs: [
                                "BAM",
                                "AM"
                            ],
                            monthNames: [
                                "Thout",
                                "Paopi",
                                "Hathor",
                                "Koiak",
                                "Tobi",
                                "Meshir",
                                "Paremhat",
                                "Paremoude",
                                "Pashons",
                                "Paoni",
                                "Epip",
                                "Mesori",
                                "Pi Kogi Enavot"
                            ],
                            monthNamesShort: [
                                "Tho",
                                "Pao",
                                "Hath",
                                "Koi",
                                "Tob",
                                "Mesh",
                                "Pat",
                                "Pad",
                                "Pash",
                                "Pao",
                                "Epi",
                                "Meso",
                                "PiK"
                            ],
                            dayNames: [
                                "Tkyriaka",
                                "Pesnau",
                                "Pshoment",
                                "Peftoou",
                                "Ptiou",
                                "Psoou",
                                "Psabbaton"
                            ],
                            dayNamesShort: [
                                "Tky",
                                "Pes",
                                "Psh",
                                "Pef",
                                "Pti",
                                "Pso",
                                "Psa"
                            ],
                            dayNamesMin: [
                                "Tk",
                                "Pes",
                                "Psh",
                                "Pef",
                                "Pt",
                                "Pso",
                                "Psa"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
                        return (e = t.year() + (t.year() < 0 ? 1 : 0)) % 4 == 3 || e % 4 == -1;
                    },
                    monthsInYear: function(e) {
                        return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
                    },
                    weekOfYear: function(e, t, r) {
                        var n = this.newDate(e, t, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(e, t) {
                        var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(e, t, r) {
                        return (this.dayOfWeek(e, t, r) || 7) < 6;
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        return (e = a.year()) < 0 && e++, a.day() + 30 * (a.month() - 1) + 365 * (e - 1) + Math.floor(e / 4) + this.jdEpoch - 1;
                    },
                    fromJD: function(e) {
                        var t = Math.floor(e) + .5 - this.jdEpoch, r = Math.floor((t - Math.floor((t + 366) / 1461)) / 365) + 1;
                        r <= 0 && r--, t = Math.floor(e) + .5 - this.newDate(r, 1, 1).toJD();
                        var n = Math.floor(t / 30) + 1, a = t - 30 * (n - 1) + 1;
                        return this.newDate(r, n, a);
                    }
                }), n.calendars.coptic = i;
            },
            6825: function(e, t, r) {
                var n = r(3489), a = r(6131);
                function i(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                i.prototype = new n.baseCalendar, a(i.prototype, {
                    name: "Discworld",
                    jdEpoch: 1721425.5,
                    daysPerMonth: [
                        16,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Discworld",
                            epochs: [
                                "BUC",
                                "UC"
                            ],
                            monthNames: [
                                "Ick",
                                "Offle",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "Grune",
                                "August",
                                "Spune",
                                "Sektober",
                                "Ember",
                                "December"
                            ],
                            monthNamesShort: [
                                "Ick",
                                "Off",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Gru",
                                "Aug",
                                "Spu",
                                "Sek",
                                "Emb",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Octeday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Oct",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Oc",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 2,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), !1;
                    },
                    monthsInYear: function(e) {
                        return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 13;
                    },
                    daysInYear: function(e) {
                        return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 400;
                    },
                    weekOfYear: function(e, t, r) {
                        var n = this.newDate(e, t, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 8) + 1;
                    },
                    daysInMonth: function(e, t) {
                        var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1];
                    },
                    daysInWeek: function() {
                        return 8;
                    },
                    dayOfWeek: function(e, t, r) {
                        return (this._validate(e, t, r, n.local.invalidDate).day() + 1) % 8;
                    },
                    weekDay: function(e, t, r) {
                        var n = this.dayOfWeek(e, t, r);
                        return n >= 2 && n <= 6;
                    },
                    extraInfo: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        return {
                            century: o[Math.floor((a.year() - 1) / 100) + 1] || ""
                        };
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        return e = a.year() + (a.year() < 0 ? 1 : 0), t = a.month(), (r = a.day()) + (t > 1 ? 16 : 0) + (t > 2 ? 32 * (t - 2) : 0) + 400 * (e - 1) + this.jdEpoch - 1;
                    },
                    fromJD: function(e) {
                        e = Math.floor(e + .5) - Math.floor(this.jdEpoch) - 1;
                        var t = Math.floor(e / 400) + 1;
                        e -= 400 * (t - 1), e += e > 15 ? 16 : 0;
                        var r = Math.floor(e / 32) + 1, n = e - 32 * (r - 1) + 1;
                        return this.newDate(t <= 0 ? t - 1 : t, r, n);
                    }
                });
                var o = {
                    20: "Fruitbat",
                    21: "Anchovy"
                };
                n.calendars.discworld = i;
            },
            7715: function(e, t, r) {
                var n = r(3489), a = r(6131);
                function i(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                i.prototype = new n.baseCalendar, a(i.prototype, {
                    name: "Ethiopian",
                    jdEpoch: 1724220.5,
                    daysPerMonth: [
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        5
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Ethiopian",
                            epochs: [
                                "BEE",
                                "EE"
                            ],
                            monthNames: [
                                "Meskerem",
                                "Tikemet",
                                "Hidar",
                                "Tahesas",
                                "Tir",
                                "Yekatit",
                                "Megabit",
                                "Miazia",
                                "Genbot",
                                "Sene",
                                "Hamle",
                                "Nehase",
                                "Pagume"
                            ],
                            monthNamesShort: [
                                "Mes",
                                "Tik",
                                "Hid",
                                "Tah",
                                "Tir",
                                "Yek",
                                "Meg",
                                "Mia",
                                "Gen",
                                "Sen",
                                "Ham",
                                "Neh",
                                "Pag"
                            ],
                            dayNames: [
                                "Ehud",
                                "Segno",
                                "Maksegno",
                                "Irob",
                                "Hamus",
                                "Arb",
                                "Kidame"
                            ],
                            dayNamesShort: [
                                "Ehu",
                                "Seg",
                                "Mak",
                                "Iro",
                                "Ham",
                                "Arb",
                                "Kid"
                            ],
                            dayNamesMin: [
                                "Eh",
                                "Se",
                                "Ma",
                                "Ir",
                                "Ha",
                                "Ar",
                                "Ki"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
                        return (e = t.year() + (t.year() < 0 ? 1 : 0)) % 4 == 3 || e % 4 == -1;
                    },
                    monthsInYear: function(e) {
                        return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
                    },
                    weekOfYear: function(e, t, r) {
                        var n = this.newDate(e, t, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(e, t) {
                        var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(e, t, r) {
                        return (this.dayOfWeek(e, t, r) || 7) < 6;
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        return (e = a.year()) < 0 && e++, a.day() + 30 * (a.month() - 1) + 365 * (e - 1) + Math.floor(e / 4) + this.jdEpoch - 1;
                    },
                    fromJD: function(e) {
                        var t = Math.floor(e) + .5 - this.jdEpoch, r = Math.floor((t - Math.floor((t + 366) / 1461)) / 365) + 1;
                        r <= 0 && r--, t = Math.floor(e) + .5 - this.newDate(r, 1, 1).toJD();
                        var n = Math.floor(t / 30) + 1, a = t - 30 * (n - 1) + 1;
                        return this.newDate(r, n, a);
                    }
                }), n.calendars.ethiopian = i;
            },
            9384: function(e, t, r) {
                var n = r(3489), a = r(6131);
                function i(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                function o(e, t) {
                    return e - t * Math.floor(e / t);
                }
                i.prototype = new n.baseCalendar, a(i.prototype, {
                    name: "Hebrew",
                    jdEpoch: 347995.5,
                    daysPerMonth: [
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        29
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 7,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Hebrew",
                            epochs: [
                                "BAM",
                                "AM"
                            ],
                            monthNames: [
                                "Nisan",
                                "Iyar",
                                "Sivan",
                                "Tammuz",
                                "Av",
                                "Elul",
                                "Tishrei",
                                "Cheshvan",
                                "Kislev",
                                "Tevet",
                                "Shevat",
                                "Adar",
                                "Adar II"
                            ],
                            monthNamesShort: [
                                "Nis",
                                "Iya",
                                "Siv",
                                "Tam",
                                "Av",
                                "Elu",
                                "Tis",
                                "Che",
                                "Kis",
                                "Tev",
                                "She",
                                "Ada",
                                "Ad2"
                            ],
                            dayNames: [
                                "Yom Rishon",
                                "Yom Sheni",
                                "Yom Shlishi",
                                "Yom Revi'i",
                                "Yom Chamishi",
                                "Yom Shishi",
                                "Yom Shabbat"
                            ],
                            dayNamesShort: [
                                "Ris",
                                "She",
                                "Shl",
                                "Rev",
                                "Cha",
                                "Shi",
                                "Sha"
                            ],
                            dayNamesMin: [
                                "Ri",
                                "She",
                                "Shl",
                                "Re",
                                "Ch",
                                "Shi",
                                "Sha"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
                        return this._leapYear(t.year());
                    },
                    _leapYear: function(e) {
                        return o(7 * (e = e < 0 ? e + 1 : e) + 1, 19) < 7;
                    },
                    monthsInYear: function(e) {
                        return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), this._leapYear(e.year ? e.year() : e) ? 13 : 12;
                    },
                    weekOfYear: function(e, t, r) {
                        var n = this.newDate(e, t, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(e) {
                        return e = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year(), this.toJD(-1 === e ? 1 : e + 1, 7, 1) - this.toJD(e, 7, 1);
                    },
                    daysInMonth: function(e, t) {
                        return e.year && (t = e.month(), e = e.year()), this._validate(e, t, this.minDay, n.local.invalidMonth), 12 === t && this.leapYear(e) || 8 === t && 5 === o(this.daysInYear(e), 10) ? 30 : 9 === t && 3 === o(this.daysInYear(e), 10) ? 29 : this.daysPerMonth[t - 1];
                    },
                    weekDay: function(e, t, r) {
                        return 6 !== this.dayOfWeek(e, t, r);
                    },
                    extraInfo: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        return {
                            yearType: (this.leapYear(a) ? "embolismic" : "common") + " " + [
                                "deficient",
                                "regular",
                                "complete"
                            ][this.daysInYear(a) % 10 - 3]
                        };
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        e = a.year(), t = a.month(), r = a.day();
                        var i = e <= 0 ? e + 1 : e, o = this.jdEpoch + this._delay1(i) + this._delay2(i) + r + 1;
                        if (t < 7) {
                            for(var l = 7; l <= this.monthsInYear(e); l++)o += this.daysInMonth(e, l);
                            for(l = 1; l < t; l++)o += this.daysInMonth(e, l);
                        } else for(l = 7; l < t; l++)o += this.daysInMonth(e, l);
                        return o;
                    },
                    _delay1: function(e) {
                        var t = Math.floor((235 * e - 234) / 19), r = 12084 + 13753 * t, n = 29 * t + Math.floor(r / 25920);
                        return o(3 * (n + 1), 7) < 3 && n++, n;
                    },
                    _delay2: function(e) {
                        var t = this._delay1(e - 1), r = this._delay1(e);
                        return this._delay1(e + 1) - r == 356 ? 2 : r - t == 382 ? 1 : 0;
                    },
                    fromJD: function(e) {
                        e = Math.floor(e) + .5;
                        for(var t = Math.floor(98496 * (e - this.jdEpoch) / 35975351) - 1; e >= this.toJD(-1 === t ? 1 : t + 1, 7, 1);)t++;
                        for(var r = e < this.toJD(t, 1, 1) ? 7 : 1; e > this.toJD(t, r, this.daysInMonth(t, r));)r++;
                        var n = e - this.toJD(t, r, 1) + 1;
                        return this.newDate(t, r, n);
                    }
                }), n.calendars.hebrew = i;
            },
            3805: function(e, t, r) {
                var n = r(3489), a = r(6131);
                function i(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                i.prototype = new n.baseCalendar, a(i.prototype, {
                    name: "Islamic",
                    jdEpoch: 1948439.5,
                    daysPerMonth: [
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Islamic",
                            epochs: [
                                "BH",
                                "AH"
                            ],
                            monthNames: [
                                "Muharram",
                                "Safar",
                                "Rabi' al-awwal",
                                "Rabi' al-thani",
                                "Jumada al-awwal",
                                "Jumada al-thani",
                                "Rajab",
                                "Sha'aban",
                                "Ramadan",
                                "Shawwal",
                                "Dhu al-Qi'dah",
                                "Dhu al-Hijjah"
                            ],
                            monthNamesShort: [
                                "Muh",
                                "Saf",
                                "Rab1",
                                "Rab2",
                                "Jum1",
                                "Jum2",
                                "Raj",
                                "Sha'",
                                "Ram",
                                "Shaw",
                                "DhuQ",
                                "DhuH"
                            ],
                            dayNames: [
                                "Yawm al-ahad",
                                "Yawm al-ithnayn",
                                "Yawm ath-thulaathaa'",
                                "Yawm al-arbi'aa'",
                                "Yawm al-kham\u012Bs",
                                "Yawm al-jum'a",
                                "Yawm as-sabt"
                            ],
                            dayNamesShort: [
                                "Aha",
                                "Ith",
                                "Thu",
                                "Arb",
                                "Kha",
                                "Jum",
                                "Sab"
                            ],
                            dayNamesMin: [
                                "Ah",
                                "It",
                                "Th",
                                "Ar",
                                "Kh",
                                "Ju",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 6,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        return (11 * this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year() + 14) % 30 < 11;
                    },
                    weekOfYear: function(e, t, r) {
                        var n = this.newDate(e, t, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(e) {
                        return this.leapYear(e) ? 355 : 354;
                    },
                    daysInMonth: function(e, t) {
                        var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(e, t, r) {
                        return 5 !== this.dayOfWeek(e, t, r);
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        return e = a.year(), t = a.month(), e = e <= 0 ? e + 1 : e, (r = a.day()) + Math.ceil(29.5 * (t - 1)) + 354 * (e - 1) + Math.floor((3 + 11 * e) / 30) + this.jdEpoch - 1;
                    },
                    fromJD: function(e) {
                        e = Math.floor(e) + .5;
                        var t = Math.floor((30 * (e - this.jdEpoch) + 10646) / 10631);
                        t = t <= 0 ? t - 1 : t;
                        var r = Math.min(12, Math.ceil((e - 29 - this.toJD(t, 1, 1)) / 29.5) + 1), n = e - this.toJD(t, r, 1) + 1;
                        return this.newDate(t, r, n);
                    }
                }), n.calendars.islamic = i;
            },
            8874: function(e, t, r) {
                var n = r(3489), a = r(6131);
                function i(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                i.prototype = new n.baseCalendar, a(i.prototype, {
                    name: "Julian",
                    jdEpoch: 1721423.5,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Julian",
                            epochs: [
                                "BC",
                                "AD"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "mm/dd/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
                        return (e = t.year() < 0 ? t.year() + 1 : t.year()) % 4 == 0;
                    },
                    weekOfYear: function(e, t, r) {
                        var n = this.newDate(e, t, r);
                        return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(e, t) {
                        var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(e, t, r) {
                        return (this.dayOfWeek(e, t, r) || 7) < 6;
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        return e = a.year(), t = a.month(), r = a.day(), e < 0 && e++, t <= 2 && (e--, t += 12), Math.floor(365.25 * (e + 4716)) + Math.floor(30.6001 * (t + 1)) + r - 1524.5;
                    },
                    fromJD: function(e) {
                        var t = Math.floor(e + .5) + 1524, r = Math.floor((t - 122.1) / 365.25), n = Math.floor(365.25 * r), a = Math.floor((t - n) / 30.6001), i = a - Math.floor(a < 14 ? 1 : 13), o = r - Math.floor(i > 2 ? 4716 : 4715), l = t - n - Math.floor(30.6001 * a);
                        return o <= 0 && o--, this.newDate(o, i, l);
                    }
                }), n.calendars.julian = i;
            },
            3290: function(e, t, r) {
                var n = r(3489), a = r(6131);
                function i(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                function o(e, t) {
                    return e - t * Math.floor(e / t);
                }
                function l(e, t) {
                    return o(e - 1, t) + 1;
                }
                i.prototype = new n.baseCalendar, a(i.prototype, {
                    name: "Mayan",
                    jdEpoch: 584282.5,
                    hasYearZero: !0,
                    minMonth: 0,
                    firstMonth: 0,
                    minDay: 0,
                    regionalOptions: {
                        "": {
                            name: "Mayan",
                            epochs: [
                                "",
                                ""
                            ],
                            monthNames: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17"
                            ],
                            monthNamesShort: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17"
                            ],
                            dayNames: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17",
                                "18",
                                "19"
                            ],
                            dayNamesShort: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17",
                                "18",
                                "19"
                            ],
                            dayNamesMin: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17",
                                "18",
                                "19"
                            ],
                            digits: null,
                            dateFormat: "YYYY.m.d",
                            firstDay: 0,
                            isRTL: !1,
                            haabMonths: [
                                "Pop",
                                "Uo",
                                "Zip",
                                "Zotz",
                                "Tzec",
                                "Xul",
                                "Yaxkin",
                                "Mol",
                                "Chen",
                                "Yax",
                                "Zac",
                                "Ceh",
                                "Mac",
                                "Kankin",
                                "Muan",
                                "Pax",
                                "Kayab",
                                "Cumku",
                                "Uayeb"
                            ],
                            tzolkinMonths: [
                                "Imix",
                                "Ik",
                                "Akbal",
                                "Kan",
                                "Chicchan",
                                "Cimi",
                                "Manik",
                                "Lamat",
                                "Muluc",
                                "Oc",
                                "Chuen",
                                "Eb",
                                "Ben",
                                "Ix",
                                "Men",
                                "Cib",
                                "Caban",
                                "Etznab",
                                "Cauac",
                                "Ahau"
                            ]
                        }
                    },
                    leapYear: function(e) {
                        return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), !1;
                    },
                    formatYear: function(e) {
                        e = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year();
                        var t = Math.floor(e / 400);
                        return e %= 400, e += e < 0 ? 400 : 0, t + "." + Math.floor(e / 20) + "." + e % 20;
                    },
                    forYear: function(e) {
                        if ((e = e.split(".")).length < 3) throw "Invalid Mayan year";
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = parseInt(e[r], 10);
                            if (Math.abs(n) > 19 || r > 0 && n < 0) throw "Invalid Mayan year";
                            t = 20 * t + n;
                        }
                        return t;
                    },
                    monthsInYear: function(e) {
                        return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 18;
                    },
                    weekOfYear: function(e, t, r) {
                        return this._validate(e, t, r, n.local.invalidDate), 0;
                    },
                    daysInYear: function(e) {
                        return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 360;
                    },
                    daysInMonth: function(e, t) {
                        return this._validate(e, t, this.minDay, n.local.invalidMonth), 20;
                    },
                    daysInWeek: function() {
                        return 5;
                    },
                    dayOfWeek: function(e, t, r) {
                        return this._validate(e, t, r, n.local.invalidDate).day();
                    },
                    weekDay: function(e, t, r) {
                        return this._validate(e, t, r, n.local.invalidDate), !0;
                    },
                    extraInfo: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate).toJD(), i = this._toHaab(a), o = this._toTzolkin(a);
                        return {
                            haabMonthName: this.local.haabMonths[i[0] - 1],
                            haabMonth: i[0],
                            haabDay: i[1],
                            tzolkinDayName: this.local.tzolkinMonths[o[0] - 1],
                            tzolkinDay: o[0],
                            tzolkinTrecena: o[1]
                        };
                    },
                    _toHaab: function(e) {
                        var t = o(8 + (e -= this.jdEpoch) + 340, 365);
                        return [
                            Math.floor(t / 20) + 1,
                            o(t, 20)
                        ];
                    },
                    _toTzolkin: function(e) {
                        return [
                            l(20 + (e -= this.jdEpoch), 20),
                            l(e + 4, 13)
                        ];
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        return a.day() + 20 * a.month() + 360 * a.year() + this.jdEpoch;
                    },
                    fromJD: function(e) {
                        e = Math.floor(e) + .5 - this.jdEpoch;
                        var t = Math.floor(e / 360);
                        e %= 360, e += e < 0 ? 360 : 0;
                        var r = Math.floor(e / 20), n = e % 20;
                        return this.newDate(t, r, n);
                    }
                }), n.calendars.mayan = i;
            },
            9108: function(e, t, r) {
                var n = r(3489), a = r(6131);
                function i(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                i.prototype = new n.baseCalendar;
                var o = n.instance("gregorian");
                a(i.prototype, {
                    name: "Nanakshahi",
                    jdEpoch: 2257673.5,
                    daysPerMonth: [
                        31,
                        31,
                        31,
                        31,
                        31,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Nanakshahi",
                            epochs: [
                                "BN",
                                "AN"
                            ],
                            monthNames: [
                                "Chet",
                                "Vaisakh",
                                "Jeth",
                                "Harh",
                                "Sawan",
                                "Bhadon",
                                "Assu",
                                "Katak",
                                "Maghar",
                                "Poh",
                                "Magh",
                                "Phagun"
                            ],
                            monthNamesShort: [
                                "Che",
                                "Vai",
                                "Jet",
                                "Har",
                                "Saw",
                                "Bha",
                                "Ass",
                                "Kat",
                                "Mgr",
                                "Poh",
                                "Mgh",
                                "Pha"
                            ],
                            dayNames: [
                                "Somvaar",
                                "Mangalvar",
                                "Budhvaar",
                                "Veervaar",
                                "Shukarvaar",
                                "Sanicharvaar",
                                "Etvaar"
                            ],
                            dayNamesShort: [
                                "Som",
                                "Mangal",
                                "Budh",
                                "Veer",
                                "Shukar",
                                "Sanichar",
                                "Et"
                            ],
                            dayNamesMin: [
                                "So",
                                "Ma",
                                "Bu",
                                "Ve",
                                "Sh",
                                "Sa",
                                "Et"
                            ],
                            digits: null,
                            dateFormat: "dd-mm-yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear);
                        return o.leapYear(t.year() + (t.year() < 1 ? 1 : 0) + 1469);
                    },
                    weekOfYear: function(e, t, r) {
                        var n = this.newDate(e, t, r);
                        return n.add(1 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(e, t) {
                        var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(e, t, r) {
                        return (this.dayOfWeek(e, t, r) || 7) < 6;
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidMonth);
                        (e = a.year()) < 0 && e++;
                        for(var i = a.day(), l = 1; l < a.month(); l++)i += this.daysPerMonth[l - 1];
                        return i + o.toJD(e + 1468, 3, 13);
                    },
                    fromJD: function(e) {
                        e = Math.floor(e + .5);
                        for(var t = Math.floor((e - (this.jdEpoch - 1)) / 366); e >= this.toJD(t + 1, 1, 1);)t++;
                        for(var r = e - Math.floor(this.toJD(t, 1, 1) + .5) + 1, n = 1; r > this.daysInMonth(t, n);)r -= this.daysInMonth(t, n), n++;
                        return this.newDate(t, n, r);
                    }
                }), n.calendars.nanakshahi = i;
            },
            5422: function(e, t, r) {
                var n = r(3489), a = r(6131);
                function i(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                i.prototype = new n.baseCalendar, a(i.prototype, {
                    name: "Nepali",
                    jdEpoch: 1700709.5,
                    daysPerMonth: [
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    daysPerYear: 365,
                    regionalOptions: {
                        "": {
                            name: "Nepali",
                            epochs: [
                                "BBS",
                                "ABS"
                            ],
                            monthNames: [
                                "Baisakh",
                                "Jestha",
                                "Ashadh",
                                "Shrawan",
                                "Bhadra",
                                "Ashwin",
                                "Kartik",
                                "Mangsir",
                                "Paush",
                                "Mangh",
                                "Falgun",
                                "Chaitra"
                            ],
                            monthNamesShort: [
                                "Bai",
                                "Je",
                                "As",
                                "Shra",
                                "Bha",
                                "Ash",
                                "Kar",
                                "Mang",
                                "Pau",
                                "Ma",
                                "Fal",
                                "Chai"
                            ],
                            dayNames: [
                                "Aaitabaar",
                                "Sombaar",
                                "Manglbaar",
                                "Budhabaar",
                                "Bihibaar",
                                "Shukrabaar",
                                "Shanibaar"
                            ],
                            dayNamesShort: [
                                "Aaita",
                                "Som",
                                "Mangl",
                                "Budha",
                                "Bihi",
                                "Shukra",
                                "Shani"
                            ],
                            dayNamesMin: [
                                "Aai",
                                "So",
                                "Man",
                                "Bu",
                                "Bi",
                                "Shu",
                                "Sha"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 1,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        return this.daysInYear(e) !== this.daysPerYear;
                    },
                    weekOfYear: function(e, t, r) {
                        var n = this.newDate(e, t, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(e) {
                        if (e = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year(), void 0 === this.NEPALI_CALENDAR_DATA[e]) return this.daysPerYear;
                        for(var t = 0, r = this.minMonth; r <= 12; r++)t += this.NEPALI_CALENDAR_DATA[e][r];
                        return t;
                    },
                    daysInMonth: function(e, t) {
                        return e.year && (t = e.month(), e = e.year()), this._validate(e, t, this.minDay, n.local.invalidMonth), void 0 === this.NEPALI_CALENDAR_DATA[e] ? this.daysPerMonth[t - 1] : this.NEPALI_CALENDAR_DATA[e][t];
                    },
                    weekDay: function(e, t, r) {
                        return 6 !== this.dayOfWeek(e, t, r);
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        e = a.year(), t = a.month(), r = a.day();
                        var i = n.instance(), o = 0, l = t, s = e;
                        this._createMissingCalendarData(e);
                        var c = e - (l > 9 || 9 === l && r >= this.NEPALI_CALENDAR_DATA[s][0] ? 56 : 57);
                        for(9 !== t && (o = r, l--); 9 !== l;)l <= 0 && (l = 12, s--), o += this.NEPALI_CALENDAR_DATA[s][l], l--;
                        return 9 === t ? (o += r - this.NEPALI_CALENDAR_DATA[s][0]) < 0 && (o += i.daysInYear(c)) : o += this.NEPALI_CALENDAR_DATA[s][9] - this.NEPALI_CALENDAR_DATA[s][0], i.newDate(c, 1, 1).add(o, "d").toJD();
                    },
                    fromJD: function(e) {
                        var t = n.instance().fromJD(e), r = t.year(), a = t.dayOfYear(), i = r + 56;
                        this._createMissingCalendarData(i);
                        for(var o = 9, l = this.NEPALI_CALENDAR_DATA[i][0], s = this.NEPALI_CALENDAR_DATA[i][o] - l + 1; a > s;)++o > 12 && (o = 1, i++), s += this.NEPALI_CALENDAR_DATA[i][o];
                        var c = this.NEPALI_CALENDAR_DATA[i][o] - (s - a);
                        return this.newDate(i, o, c);
                    },
                    _createMissingCalendarData: function(e) {
                        var t = this.daysPerMonth.slice(0);
                        t.unshift(17);
                        for(var r = e - 1; r < e + 2; r++)void 0 === this.NEPALI_CALENDAR_DATA[r] && (this.NEPALI_CALENDAR_DATA[r] = t);
                    },
                    NEPALI_CALENDAR_DATA: {
                        1970: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1971: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            32,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1972: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        1973: [
                            19,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1974: [
                            19,
                            31,
                            31,
                            32,
                            30,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1975: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            30,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1976: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1977: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1978: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1979: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1980: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1981: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        1982: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1983: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1984: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1985: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        1986: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1987: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1988: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1989: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1990: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1991: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1992: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1993: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1994: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1995: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        1996: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1997: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1998: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1999: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2e3: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2001: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2002: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2003: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2004: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2005: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2006: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2007: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2008: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            29,
                            31
                        ],
                        2009: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2010: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2011: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2012: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2013: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2014: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2015: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2016: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2017: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2018: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2019: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2020: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2021: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2022: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2023: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2024: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2025: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2026: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2027: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2028: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2029: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            32,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2030: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            30,
                            30,
                            30,
                            31
                        ],
                        2031: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            31,
                            31,
                            31,
                            31,
                            31,
                            31,
                            31
                        ],
                        2032: [
                            17,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32
                        ],
                        2033: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2034: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2035: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            29,
                            31
                        ],
                        2036: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2037: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2038: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2039: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2040: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2041: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2042: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2043: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2044: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2045: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2046: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2047: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2048: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2049: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2050: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2051: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2052: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2053: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2054: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2055: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            30,
                            29,
                            30
                        ],
                        2056: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            32,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2057: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2058: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2059: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2060: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2061: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2062: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2063: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2064: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2065: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2066: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            29,
                            31
                        ],
                        2067: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2068: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2069: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2070: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2071: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2072: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2073: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2074: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2075: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2076: [
                            16,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2077: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2078: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2079: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2080: [
                            16,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2081: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2082: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2083: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2084: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2085: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2086: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2087: [
                            16,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2088: [
                            16,
                            30,
                            31,
                            32,
                            32,
                            30,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2089: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2090: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2091: [
                            16,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2092: [
                            16,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2093: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2094: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2095: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            30,
                            30,
                            30
                        ],
                        2096: [
                            17,
                            30,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2097: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2098: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            29,
                            30,
                            29,
                            30,
                            30,
                            31
                        ],
                        2099: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            29,
                            30,
                            30,
                            30
                        ],
                        2100: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            30,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ]
                    }
                }), n.calendars.nepali = i;
            },
            4320: function(e, t, r) {
                var n = r(3489), a = r(6131);
                function i(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                function o(e, t) {
                    return e - t * Math.floor(e / t);
                }
                i.prototype = new n.baseCalendar, a(i.prototype, {
                    name: "Persian",
                    jdEpoch: 1948320.5,
                    daysPerMonth: [
                        31,
                        31,
                        31,
                        31,
                        31,
                        31,
                        30,
                        30,
                        30,
                        30,
                        30,
                        29
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Persian",
                            epochs: [
                                "BP",
                                "AP"
                            ],
                            monthNames: [
                                "Farvardin",
                                "Ordibehesht",
                                "Khordad",
                                "Tir",
                                "Mordad",
                                "Shahrivar",
                                "Mehr",
                                "Aban",
                                "Azar",
                                "Day",
                                "Bahman",
                                "Esfand"
                            ],
                            monthNamesShort: [
                                "Far",
                                "Ord",
                                "Kho",
                                "Tir",
                                "Mor",
                                "Sha",
                                "Meh",
                                "Aba",
                                "Aza",
                                "Day",
                                "Bah",
                                "Esf"
                            ],
                            dayNames: [
                                "Yekshambe",
                                "Doshambe",
                                "Seshambe",
                                "Ch\xe6harshambe",
                                "Panjshambe",
                                "Jom'e",
                                "Shambe"
                            ],
                            dayNamesShort: [
                                "Yek",
                                "Do",
                                "Se",
                                "Ch\xe6",
                                "Panj",
                                "Jom",
                                "Sha"
                            ],
                            dayNamesMin: [
                                "Ye",
                                "Do",
                                "Se",
                                "Ch",
                                "Pa",
                                "Jo",
                                "Sh"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 6,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
                        return 682 * ((t.year() - (t.year() > 0 ? 474 : 473)) % 2820 + 474 + 38) % 2816 < 682;
                    },
                    weekOfYear: function(e, t, r) {
                        var n = this.newDate(e, t, r);
                        return n.add(-(n.dayOfWeek() + 1) % 7, "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(e, t) {
                        var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(e, t, r) {
                        return 5 !== this.dayOfWeek(e, t, r);
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        e = a.year(), t = a.month(), r = a.day();
                        var i = e - (e >= 0 ? 474 : 473), l = 474 + o(i, 2820);
                        return r + (t <= 7 ? 31 * (t - 1) : 30 * (t - 1) + 6) + Math.floor((682 * l - 110) / 2816) + 365 * (l - 1) + 1029983 * Math.floor(i / 2820) + this.jdEpoch - 1;
                    },
                    fromJD: function(e) {
                        var t = (e = Math.floor(e) + .5) - this.toJD(475, 1, 1), r = Math.floor(t / 1029983), n = o(t, 1029983), a = 2820;
                        if (1029982 !== n) {
                            var i = Math.floor(n / 366), l = o(n, 366);
                            a = Math.floor((2134 * i + 2816 * l + 2815) / 1028522) + i + 1;
                        }
                        var s = a + 2820 * r + 474;
                        s = s <= 0 ? s - 1 : s;
                        var c = e - this.toJD(s, 1, 1) + 1, u = c <= 186 ? Math.ceil(c / 31) : Math.ceil((c - 6) / 30), f = e - this.toJD(s, u, 1) + 1;
                        return this.newDate(s, u, f);
                    }
                }), n.calendars.persian = i, n.calendars.jalali = i;
            },
            1320: function(e, t, r) {
                var n = r(3489), a = r(6131), i = n.instance();
                function o(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                o.prototype = new n.baseCalendar, a(o.prototype, {
                    name: "Taiwan",
                    jdEpoch: 2419402.5,
                    yearsOffset: 1911,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Taiwan",
                            epochs: [
                                "BROC",
                                "ROC"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 1,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
                        return e = this._t2gYear(t.year()), i.leapYear(e);
                    },
                    weekOfYear: function(e, t, r) {
                        var a = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
                        return e = this._t2gYear(a.year()), i.weekOfYear(e, a.month(), a.day());
                    },
                    daysInMonth: function(e, t) {
                        var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(e, t, r) {
                        return (this.dayOfWeek(e, t, r) || 7) < 6;
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        return e = this._t2gYear(a.year()), i.toJD(e, a.month(), a.day());
                    },
                    fromJD: function(e) {
                        var t = i.fromJD(e), r = this._g2tYear(t.year());
                        return this.newDate(r, t.month(), t.day());
                    },
                    _t2gYear: function(e) {
                        return e + this.yearsOffset + (e >= -this.yearsOffset && e <= -1 ? 1 : 0);
                    },
                    _g2tYear: function(e) {
                        return e - this.yearsOffset - (e >= 1 && e <= this.yearsOffset ? 1 : 0);
                    }
                }), n.calendars.taiwan = o;
            },
            1367: function(e, t, r) {
                var n = r(3489), a = r(6131), i = n.instance();
                function o(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                o.prototype = new n.baseCalendar, a(o.prototype, {
                    name: "Thai",
                    jdEpoch: 1523098.5,
                    yearsOffset: 543,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Thai",
                            epochs: [
                                "BBE",
                                "BE"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
                        return e = this._t2gYear(t.year()), i.leapYear(e);
                    },
                    weekOfYear: function(e, t, r) {
                        var a = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
                        return e = this._t2gYear(a.year()), i.weekOfYear(e, a.month(), a.day());
                    },
                    daysInMonth: function(e, t) {
                        var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(e, t, r) {
                        return (this.dayOfWeek(e, t, r) || 7) < 6;
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate);
                        return e = this._t2gYear(a.year()), i.toJD(e, a.month(), a.day());
                    },
                    fromJD: function(e) {
                        var t = i.fromJD(e), r = this._g2tYear(t.year());
                        return this.newDate(r, t.month(), t.day());
                    },
                    _t2gYear: function(e) {
                        return e - this.yearsOffset - (e >= 1 && e <= this.yearsOffset ? 1 : 0);
                    },
                    _g2tYear: function(e) {
                        return e + this.yearsOffset + (e >= -this.yearsOffset && e <= -1 ? 1 : 0);
                    }
                }), n.calendars.thai = o;
            },
            1457: function(e, t, r) {
                var n = r(3489), a = r(6131);
                function i(e) {
                    this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
                }
                i.prototype = new n.baseCalendar, a(i.prototype, {
                    name: "UmmAlQura",
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Umm al-Qura",
                            epochs: [
                                "BH",
                                "AH"
                            ],
                            monthNames: [
                                "Al-Muharram",
                                "Safar",
                                "Rabi' al-awwal",
                                "Rabi' Al-Thani",
                                "Jumada Al-Awwal",
                                "Jumada Al-Thani",
                                "Rajab",
                                "Sha'aban",
                                "Ramadan",
                                "Shawwal",
                                "Dhu al-Qi'dah",
                                "Dhu al-Hijjah"
                            ],
                            monthNamesShort: [
                                "Muh",
                                "Saf",
                                "Rab1",
                                "Rab2",
                                "Jum1",
                                "Jum2",
                                "Raj",
                                "Sha'",
                                "Ram",
                                "Shaw",
                                "DhuQ",
                                "DhuH"
                            ],
                            dayNames: [
                                "Yawm al-Ahad",
                                "Yawm al-Ithnain",
                                "Yawm al-Thal\u0101th\u0101\u2019",
                                "Yawm al-Arba\u2018\u0101\u2019",
                                "Yawm al-Kham\u012Bs",
                                "Yawm al-Jum\u2018a",
                                "Yawm al-Sabt"
                            ],
                            dayNamesMin: [
                                "Ah",
                                "Ith",
                                "Th",
                                "Ar",
                                "Kh",
                                "Ju",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 6,
                            isRTL: !0
                        }
                    },
                    leapYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
                        return 355 === this.daysInYear(t.year());
                    },
                    weekOfYear: function(e, t, r) {
                        var n = this.newDate(e, t, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(e) {
                        for(var t = 0, r = 1; r <= 12; r++)t += this.daysInMonth(e, r);
                        return t;
                    },
                    daysInMonth: function(e, t) {
                        for(var r = this._validate(e, t, this.minDay, n.local.invalidMonth).toJD() - 24e5 + .5, a = 0, i = 0; i < o.length; i++){
                            if (o[i] > r) return o[a] - o[a - 1];
                            a++;
                        }
                        return 30;
                    },
                    weekDay: function(e, t, r) {
                        return 5 !== this.dayOfWeek(e, t, r);
                    },
                    toJD: function(e, t, r) {
                        var a = this._validate(e, t, r, n.local.invalidDate), i = 12 * (a.year() - 1) + a.month() - 15292;
                        return a.day() + o[i - 1] - 1 + 24e5 - .5;
                    },
                    fromJD: function(e) {
                        for(var t = e - 24e5 + .5, r = 0, n = 0; n < o.length && !(o[n] > t); n++)r++;
                        var a = r + 15292, i = Math.floor((a - 1) / 12), l = i + 1, s = a - 12 * i, c = t - o[r - 1] + 1;
                        return this.newDate(l, s, c);
                    },
                    isValid: function(e, t, r) {
                        var a = n.baseCalendar.prototype.isValid.apply(this, arguments);
                        return a && (a = (e = null != e.year ? e.year : e) >= 1276 && e <= 1500), a;
                    },
                    _validate: function(e, t, r, a) {
                        var i = n.baseCalendar.prototype._validate.apply(this, arguments);
                        if (i.year < 1276 || i.year > 1500) throw a.replace(/\{0\}/, this.local.name);
                        return i;
                    }
                }), n.calendars.ummalqura = i;
                var o = [
                    20,
                    50,
                    79,
                    109,
                    138,
                    168,
                    197,
                    227,
                    256,
                    286,
                    315,
                    345,
                    374,
                    404,
                    433,
                    463,
                    492,
                    522,
                    551,
                    581,
                    611,
                    641,
                    670,
                    700,
                    729,
                    759,
                    788,
                    818,
                    847,
                    877,
                    906,
                    936,
                    965,
                    995,
                    1024,
                    1054,
                    1083,
                    1113,
                    1142,
                    1172,
                    1201,
                    1231,
                    1260,
                    1290,
                    1320,
                    1350,
                    1379,
                    1409,
                    1438,
                    1468,
                    1497,
                    1527,
                    1556,
                    1586,
                    1615,
                    1645,
                    1674,
                    1704,
                    1733,
                    1763,
                    1792,
                    1822,
                    1851,
                    1881,
                    1910,
                    1940,
                    1969,
                    1999,
                    2028,
                    2058,
                    2087,
                    2117,
                    2146,
                    2176,
                    2205,
                    2235,
                    2264,
                    2294,
                    2323,
                    2353,
                    2383,
                    2413,
                    2442,
                    2472,
                    2501,
                    2531,
                    2560,
                    2590,
                    2619,
                    2649,
                    2678,
                    2708,
                    2737,
                    2767,
                    2796,
                    2826,
                    2855,
                    2885,
                    2914,
                    2944,
                    2973,
                    3003,
                    3032,
                    3062,
                    3091,
                    3121,
                    3150,
                    3180,
                    3209,
                    3239,
                    3268,
                    3298,
                    3327,
                    3357,
                    3386,
                    3416,
                    3446,
                    3476,
                    3505,
                    3535,
                    3564,
                    3594,
                    3623,
                    3653,
                    3682,
                    3712,
                    3741,
                    3771,
                    3800,
                    3830,
                    3859,
                    3889,
                    3918,
                    3948,
                    3977,
                    4007,
                    4036,
                    4066,
                    4095,
                    4125,
                    4155,
                    4185,
                    4214,
                    4244,
                    4273,
                    4303,
                    4332,
                    4362,
                    4391,
                    4421,
                    4450,
                    4480,
                    4509,
                    4539,
                    4568,
                    4598,
                    4627,
                    4657,
                    4686,
                    4716,
                    4745,
                    4775,
                    4804,
                    4834,
                    4863,
                    4893,
                    4922,
                    4952,
                    4981,
                    5011,
                    5040,
                    5070,
                    5099,
                    5129,
                    5158,
                    5188,
                    5218,
                    5248,
                    5277,
                    5307,
                    5336,
                    5366,
                    5395,
                    5425,
                    5454,
                    5484,
                    5513,
                    5543,
                    5572,
                    5602,
                    5631,
                    5661,
                    5690,
                    5720,
                    5749,
                    5779,
                    5808,
                    5838,
                    5867,
                    5897,
                    5926,
                    5956,
                    5985,
                    6015,
                    6044,
                    6074,
                    6103,
                    6133,
                    6162,
                    6192,
                    6221,
                    6251,
                    6281,
                    6311,
                    6340,
                    6370,
                    6399,
                    6429,
                    6458,
                    6488,
                    6517,
                    6547,
                    6576,
                    6606,
                    6635,
                    6665,
                    6694,
                    6724,
                    6753,
                    6783,
                    6812,
                    6842,
                    6871,
                    6901,
                    6930,
                    6960,
                    6989,
                    7019,
                    7048,
                    7078,
                    7107,
                    7137,
                    7166,
                    7196,
                    7225,
                    7255,
                    7284,
                    7314,
                    7344,
                    7374,
                    7403,
                    7433,
                    7462,
                    7492,
                    7521,
                    7551,
                    7580,
                    7610,
                    7639,
                    7669,
                    7698,
                    7728,
                    7757,
                    7787,
                    7816,
                    7846,
                    7875,
                    7905,
                    7934,
                    7964,
                    7993,
                    8023,
                    8053,
                    8083,
                    8112,
                    8142,
                    8171,
                    8201,
                    8230,
                    8260,
                    8289,
                    8319,
                    8348,
                    8378,
                    8407,
                    8437,
                    8466,
                    8496,
                    8525,
                    8555,
                    8584,
                    8614,
                    8643,
                    8673,
                    8702,
                    8732,
                    8761,
                    8791,
                    8821,
                    8850,
                    8880,
                    8909,
                    8938,
                    8968,
                    8997,
                    9027,
                    9056,
                    9086,
                    9115,
                    9145,
                    9175,
                    9205,
                    9234,
                    9264,
                    9293,
                    9322,
                    9352,
                    9381,
                    9410,
                    9440,
                    9470,
                    9499,
                    9529,
                    9559,
                    9589,
                    9618,
                    9648,
                    9677,
                    9706,
                    9736,
                    9765,
                    9794,
                    9824,
                    9853,
                    9883,
                    9913,
                    9943,
                    9972,
                    10002,
                    10032,
                    10061,
                    10090,
                    10120,
                    10149,
                    10178,
                    10208,
                    10237,
                    10267,
                    10297,
                    10326,
                    10356,
                    10386,
                    10415,
                    10445,
                    10474,
                    10504,
                    10533,
                    10562,
                    10592,
                    10621,
                    10651,
                    10680,
                    10710,
                    10740,
                    10770,
                    10799,
                    10829,
                    10858,
                    10888,
                    10917,
                    10947,
                    10976,
                    11005,
                    11035,
                    11064,
                    11094,
                    11124,
                    11153,
                    11183,
                    11213,
                    11242,
                    11272,
                    11301,
                    11331,
                    11360,
                    11389,
                    11419,
                    11448,
                    11478,
                    11507,
                    11537,
                    11567,
                    11596,
                    11626,
                    11655,
                    11685,
                    11715,
                    11744,
                    11774,
                    11803,
                    11832,
                    11862,
                    11891,
                    11921,
                    11950,
                    11980,
                    12010,
                    12039,
                    12069,
                    12099,
                    12128,
                    12158,
                    12187,
                    12216,
                    12246,
                    12275,
                    12304,
                    12334,
                    12364,
                    12393,
                    12423,
                    12453,
                    12483,
                    12512,
                    12542,
                    12571,
                    12600,
                    12630,
                    12659,
                    12688,
                    12718,
                    12747,
                    12777,
                    12807,
                    12837,
                    12866,
                    12896,
                    12926,
                    12955,
                    12984,
                    13014,
                    13043,
                    13072,
                    13102,
                    13131,
                    13161,
                    13191,
                    13220,
                    13250,
                    13280,
                    13310,
                    13339,
                    13368,
                    13398,
                    13427,
                    13456,
                    13486,
                    13515,
                    13545,
                    13574,
                    13604,
                    13634,
                    13664,
                    13693,
                    13723,
                    13752,
                    13782,
                    13811,
                    13840,
                    13870,
                    13899,
                    13929,
                    13958,
                    13988,
                    14018,
                    14047,
                    14077,
                    14107,
                    14136,
                    14166,
                    14195,
                    14224,
                    14254,
                    14283,
                    14313,
                    14342,
                    14372,
                    14401,
                    14431,
                    14461,
                    14490,
                    14520,
                    14550,
                    14579,
                    14609,
                    14638,
                    14667,
                    14697,
                    14726,
                    14756,
                    14785,
                    14815,
                    14844,
                    14874,
                    14904,
                    14933,
                    14963,
                    14993,
                    15021,
                    15051,
                    15081,
                    15110,
                    15140,
                    15169,
                    15199,
                    15228,
                    15258,
                    15287,
                    15317,
                    15347,
                    15377,
                    15406,
                    15436,
                    15465,
                    15494,
                    15524,
                    15553,
                    15582,
                    15612,
                    15641,
                    15671,
                    15701,
                    15731,
                    15760,
                    15790,
                    15820,
                    15849,
                    15878,
                    15908,
                    15937,
                    15966,
                    15996,
                    16025,
                    16055,
                    16085,
                    16114,
                    16144,
                    16174,
                    16204,
                    16233,
                    16262,
                    16292,
                    16321,
                    16350,
                    16380,
                    16409,
                    16439,
                    16468,
                    16498,
                    16528,
                    16558,
                    16587,
                    16617,
                    16646,
                    16676,
                    16705,
                    16734,
                    16764,
                    16793,
                    16823,
                    16852,
                    16882,
                    16912,
                    16941,
                    16971,
                    17001,
                    17030,
                    17060,
                    17089,
                    17118,
                    17148,
                    17177,
                    17207,
                    17236,
                    17266,
                    17295,
                    17325,
                    17355,
                    17384,
                    17414,
                    17444,
                    17473,
                    17502,
                    17532,
                    17561,
                    17591,
                    17620,
                    17650,
                    17679,
                    17709,
                    17738,
                    17768,
                    17798,
                    17827,
                    17857,
                    17886,
                    17916,
                    17945,
                    17975,
                    18004,
                    18034,
                    18063,
                    18093,
                    18122,
                    18152,
                    18181,
                    18211,
                    18241,
                    18270,
                    18300,
                    18330,
                    18359,
                    18388,
                    18418,
                    18447,
                    18476,
                    18506,
                    18535,
                    18565,
                    18595,
                    18625,
                    18654,
                    18684,
                    18714,
                    18743,
                    18772,
                    18802,
                    18831,
                    18860,
                    18890,
                    18919,
                    18949,
                    18979,
                    19008,
                    19038,
                    19068,
                    19098,
                    19127,
                    19156,
                    19186,
                    19215,
                    19244,
                    19274,
                    19303,
                    19333,
                    19362,
                    19392,
                    19422,
                    19452,
                    19481,
                    19511,
                    19540,
                    19570,
                    19599,
                    19628,
                    19658,
                    19687,
                    19717,
                    19746,
                    19776,
                    19806,
                    19836,
                    19865,
                    19895,
                    19924,
                    19954,
                    19983,
                    20012,
                    20042,
                    20071,
                    20101,
                    20130,
                    20160,
                    20190,
                    20219,
                    20249,
                    20279,
                    20308,
                    20338,
                    20367,
                    20396,
                    20426,
                    20455,
                    20485,
                    20514,
                    20544,
                    20573,
                    20603,
                    20633,
                    20662,
                    20692,
                    20721,
                    20751,
                    20780,
                    20810,
                    20839,
                    20869,
                    20898,
                    20928,
                    20957,
                    20987,
                    21016,
                    21046,
                    21076,
                    21105,
                    21135,
                    21164,
                    21194,
                    21223,
                    21253,
                    21282,
                    21312,
                    21341,
                    21371,
                    21400,
                    21430,
                    21459,
                    21489,
                    21519,
                    21548,
                    21578,
                    21607,
                    21637,
                    21666,
                    21696,
                    21725,
                    21754,
                    21784,
                    21813,
                    21843,
                    21873,
                    21902,
                    21932,
                    21962,
                    21991,
                    22021,
                    22050,
                    22080,
                    22109,
                    22138,
                    22168,
                    22197,
                    22227,
                    22256,
                    22286,
                    22316,
                    22346,
                    22375,
                    22405,
                    22434,
                    22464,
                    22493,
                    22522,
                    22552,
                    22581,
                    22611,
                    22640,
                    22670,
                    22700,
                    22730,
                    22759,
                    22789,
                    22818,
                    22848,
                    22877,
                    22906,
                    22936,
                    22965,
                    22994,
                    23024,
                    23054,
                    23083,
                    23113,
                    23143,
                    23173,
                    23202,
                    23232,
                    23261,
                    23290,
                    23320,
                    23349,
                    23379,
                    23408,
                    23438,
                    23467,
                    23497,
                    23527,
                    23556,
                    23586,
                    23616,
                    23645,
                    23674,
                    23704,
                    23733,
                    23763,
                    23792,
                    23822,
                    23851,
                    23881,
                    23910,
                    23940,
                    23970,
                    23999,
                    24029,
                    24058,
                    24088,
                    24117,
                    24147,
                    24176,
                    24206,
                    24235,
                    24265,
                    24294,
                    24324,
                    24353,
                    24383,
                    24413,
                    24442,
                    24472,
                    24501,
                    24531,
                    24560,
                    24590,
                    24619,
                    24648,
                    24678,
                    24707,
                    24737,
                    24767,
                    24796,
                    24826,
                    24856,
                    24885,
                    24915,
                    24944,
                    24974,
                    25003,
                    25032,
                    25062,
                    25091,
                    25121,
                    25150,
                    25180,
                    25210,
                    25240,
                    25269,
                    25299,
                    25328,
                    25358,
                    25387,
                    25416,
                    25446,
                    25475,
                    25505,
                    25534,
                    25564,
                    25594,
                    25624,
                    25653,
                    25683,
                    25712,
                    25742,
                    25771,
                    25800,
                    25830,
                    25859,
                    25888,
                    25918,
                    25948,
                    25977,
                    26007,
                    26037,
                    26067,
                    26096,
                    26126,
                    26155,
                    26184,
                    26214,
                    26243,
                    26272,
                    26302,
                    26332,
                    26361,
                    26391,
                    26421,
                    26451,
                    26480,
                    26510,
                    26539,
                    26568,
                    26598,
                    26627,
                    26656,
                    26686,
                    26715,
                    26745,
                    26775,
                    26805,
                    26834,
                    26864,
                    26893,
                    26923,
                    26952,
                    26982,
                    27011,
                    27041,
                    27070,
                    27099,
                    27129,
                    27159,
                    27188,
                    27218,
                    27248,
                    27277,
                    27307,
                    27336,
                    27366,
                    27395,
                    27425,
                    27454,
                    27484,
                    27513,
                    27542,
                    27572,
                    27602,
                    27631,
                    27661,
                    27691,
                    27720,
                    27750,
                    27779,
                    27809,
                    27838,
                    27868,
                    27897,
                    27926,
                    27956,
                    27985,
                    28015,
                    28045,
                    28074,
                    28104,
                    28134,
                    28163,
                    28193,
                    28222,
                    28252,
                    28281,
                    28310,
                    28340,
                    28369,
                    28399,
                    28428,
                    28458,
                    28488,
                    28517,
                    28547,
                    28577,
                    28607,
                    28636,
                    28665,
                    28695,
                    28724,
                    28754,
                    28783,
                    28813,
                    28843,
                    28872,
                    28901,
                    28931,
                    28960,
                    28990,
                    29019,
                    29049,
                    29078,
                    29108,
                    29137,
                    29167,
                    29196,
                    29226,
                    29255,
                    29285,
                    29315,
                    29345,
                    29375,
                    29404,
                    29434,
                    29463,
                    29492,
                    29522,
                    29551,
                    29580,
                    29610,
                    29640,
                    29669,
                    29699,
                    29729,
                    29759,
                    29788,
                    29818,
                    29847,
                    29876,
                    29906,
                    29935,
                    29964,
                    29994,
                    30023,
                    30053,
                    30082,
                    30112,
                    30141,
                    30171,
                    30200,
                    30230,
                    30259,
                    30289,
                    30318,
                    30348,
                    30378,
                    30408,
                    30437,
                    30467,
                    30496,
                    30526,
                    30555,
                    30585,
                    30614,
                    30644,
                    30673,
                    30703,
                    30732,
                    30762,
                    30791,
                    30821,
                    30850,
                    30880,
                    30909,
                    30939,
                    30968,
                    30998,
                    31027,
                    31057,
                    31086,
                    31116,
                    31145,
                    31175,
                    31204,
                    31234,
                    31263,
                    31293,
                    31322,
                    31352,
                    31381,
                    31411,
                    31441,
                    31471,
                    31500,
                    31530,
                    31559,
                    31589,
                    31618,
                    31648,
                    31676,
                    31706,
                    31736,
                    31766,
                    31795,
                    31825,
                    31854,
                    31884,
                    31913,
                    31943,
                    31972,
                    32002,
                    32031,
                    32061,
                    32090,
                    32120,
                    32150,
                    32180,
                    32209,
                    32239,
                    32268,
                    32298,
                    32327,
                    32357,
                    32386,
                    32416,
                    32445,
                    32475,
                    32504,
                    32534,
                    32563,
                    32593,
                    32622,
                    32652,
                    32681,
                    32711,
                    32740,
                    32770,
                    32799,
                    32829,
                    32858,
                    32888,
                    32917,
                    32947,
                    32976,
                    33006,
                    33035,
                    33065,
                    33094,
                    33124,
                    33153,
                    33183,
                    33213,
                    33243,
                    33272,
                    33302,
                    33331,
                    33361,
                    33390,
                    33420,
                    33450,
                    33479,
                    33509,
                    33539,
                    33568,
                    33598,
                    33627,
                    33657,
                    33686,
                    33716,
                    33745,
                    33775,
                    33804,
                    33834,
                    33863,
                    33893,
                    33922,
                    33952,
                    33981,
                    34011,
                    34040,
                    34069,
                    34099,
                    34128,
                    34158,
                    34187,
                    34217,
                    34247,
                    34277,
                    34306,
                    34336,
                    34365,
                    34395,
                    34424,
                    34454,
                    34483,
                    34512,
                    34542,
                    34571,
                    34601,
                    34631,
                    34660,
                    34690,
                    34719,
                    34749,
                    34778,
                    34808,
                    34837,
                    34867,
                    34896,
                    34926,
                    34955,
                    34985,
                    35015,
                    35044,
                    35074,
                    35103,
                    35133,
                    35162,
                    35192,
                    35222,
                    35251,
                    35280,
                    35310,
                    35340,
                    35370,
                    35399,
                    35429,
                    35458,
                    35488,
                    35517,
                    35547,
                    35576,
                    35605,
                    35635,
                    35665,
                    35694,
                    35723,
                    35753,
                    35782,
                    35811,
                    35841,
                    35871,
                    35901,
                    35930,
                    35960,
                    35989,
                    36019,
                    36048,
                    36078,
                    36107,
                    36136,
                    36166,
                    36195,
                    36225,
                    36254,
                    36284,
                    36314,
                    36343,
                    36373,
                    36403,
                    36433,
                    36462,
                    36492,
                    36521,
                    36551,
                    36580,
                    36610,
                    36639,
                    36669,
                    36698,
                    36728,
                    36757,
                    36786,
                    36816,
                    36845,
                    36875,
                    36904,
                    36934,
                    36963,
                    36993,
                    37022,
                    37052,
                    37081,
                    37111,
                    37141,
                    37170,
                    37200,
                    37229,
                    37259,
                    37288,
                    37318,
                    37347,
                    37377,
                    37406,
                    37436,
                    37465,
                    37495,
                    37524,
                    37554,
                    37584,
                    37613,
                    37643,
                    37672,
                    37701,
                    37731,
                    37760,
                    37790,
                    37819,
                    37849,
                    37878,
                    37908,
                    37938,
                    37967,
                    37997,
                    38027,
                    38056,
                    38085,
                    38115,
                    38144,
                    38174,
                    38203,
                    38233,
                    38262,
                    38292,
                    38322,
                    38351,
                    38381,
                    38410,
                    38440,
                    38469,
                    38499,
                    38528,
                    38558,
                    38587,
                    38617,
                    38646,
                    38676,
                    38705,
                    38735,
                    38764,
                    38794,
                    38823,
                    38853,
                    38882,
                    38912,
                    38941,
                    38971,
                    39001,
                    39030,
                    39059,
                    39089,
                    39118,
                    39148,
                    39178,
                    39208,
                    39237,
                    39267,
                    39297,
                    39326,
                    39355,
                    39385,
                    39414,
                    39444,
                    39473,
                    39503,
                    39532,
                    39562,
                    39592,
                    39621,
                    39650,
                    39680,
                    39709,
                    39739,
                    39768,
                    39798,
                    39827,
                    39857,
                    39886,
                    39916,
                    39946,
                    39975,
                    40005,
                    40035,
                    40064,
                    40094,
                    40123,
                    40153,
                    40182,
                    40212,
                    40241,
                    40271,
                    40300,
                    40330,
                    40359,
                    40389,
                    40418,
                    40448,
                    40477,
                    40507,
                    40536,
                    40566,
                    40595,
                    40625,
                    40655,
                    40685,
                    40714,
                    40744,
                    40773,
                    40803,
                    40832,
                    40862,
                    40892,
                    40921,
                    40951,
                    40980,
                    41009,
                    41039,
                    41068,
                    41098,
                    41127,
                    41157,
                    41186,
                    41216,
                    41245,
                    41275,
                    41304,
                    41334,
                    41364,
                    41393,
                    41422,
                    41452,
                    41481,
                    41511,
                    41540,
                    41570,
                    41599,
                    41629,
                    41658,
                    41688,
                    41718,
                    41748,
                    41777,
                    41807,
                    41836,
                    41865,
                    41894,
                    41924,
                    41953,
                    41983,
                    42012,
                    42042,
                    42072,
                    42102,
                    42131,
                    42161,
                    42190,
                    42220,
                    42249,
                    42279,
                    42308,
                    42337,
                    42367,
                    42397,
                    42426,
                    42456,
                    42485,
                    42515,
                    42545,
                    42574,
                    42604,
                    42633,
                    42662,
                    42692,
                    42721,
                    42751,
                    42780,
                    42810,
                    42839,
                    42869,
                    42899,
                    42929,
                    42958,
                    42988,
                    43017,
                    43046,
                    43076,
                    43105,
                    43135,
                    43164,
                    43194,
                    43223,
                    43253,
                    43283,
                    43312,
                    43342,
                    43371,
                    43401,
                    43430,
                    43460,
                    43489,
                    43519,
                    43548,
                    43578,
                    43607,
                    43637,
                    43666,
                    43696,
                    43726,
                    43755,
                    43785,
                    43814,
                    43844,
                    43873,
                    43903,
                    43932,
                    43962,
                    43991,
                    44021,
                    44050,
                    44080,
                    44109,
                    44139,
                    44169,
                    44198,
                    44228,
                    44258,
                    44287,
                    44317,
                    44346,
                    44375,
                    44405,
                    44434,
                    44464,
                    44493,
                    44523,
                    44553,
                    44582,
                    44612,
                    44641,
                    44671,
                    44700,
                    44730,
                    44759,
                    44788,
                    44818,
                    44847,
                    44877,
                    44906,
                    44936,
                    44966,
                    44996,
                    45025,
                    45055,
                    45084,
                    45114,
                    45143,
                    45172,
                    45202,
                    45231,
                    45261,
                    45290,
                    45320,
                    45350,
                    45380,
                    45409,
                    45439,
                    45468,
                    45498,
                    45527,
                    45556,
                    45586,
                    45615,
                    45644,
                    45674,
                    45704,
                    45733,
                    45763,
                    45793,
                    45823,
                    45852,
                    45882,
                    45911,
                    45940,
                    45970,
                    45999,
                    46028,
                    46058,
                    46088,
                    46117,
                    46147,
                    46177,
                    46206,
                    46236,
                    46265,
                    46295,
                    46324,
                    46354,
                    46383,
                    46413,
                    46442,
                    46472,
                    46501,
                    46531,
                    46560,
                    46590,
                    46620,
                    46649,
                    46679,
                    46708,
                    46738,
                    46767,
                    46797,
                    46826,
                    46856,
                    46885,
                    46915,
                    46944,
                    46974,
                    47003,
                    47033,
                    47063,
                    47092,
                    47122,
                    47151,
                    47181,
                    47210,
                    47240,
                    47269,
                    47298,
                    47328,
                    47357,
                    47387,
                    47417,
                    47446,
                    47476,
                    47506,
                    47535,
                    47565,
                    47594,
                    47624,
                    47653,
                    47682,
                    47712,
                    47741,
                    47771,
                    47800,
                    47830,
                    47860,
                    47890,
                    47919,
                    47949,
                    47978,
                    48008,
                    48037,
                    48066,
                    48096,
                    48125,
                    48155,
                    48184,
                    48214,
                    48244,
                    48273,
                    48303,
                    48333,
                    48362,
                    48392,
                    48421,
                    48450,
                    48480,
                    48509,
                    48538,
                    48568,
                    48598,
                    48627,
                    48657,
                    48687,
                    48717,
                    48746,
                    48776,
                    48805,
                    48834,
                    48864,
                    48893,
                    48922,
                    48952,
                    48982,
                    49011,
                    49041,
                    49071,
                    49100,
                    49130,
                    49160,
                    49189,
                    49218,
                    49248,
                    49277,
                    49306,
                    49336,
                    49365,
                    49395,
                    49425,
                    49455,
                    49484,
                    49514,
                    49543,
                    49573,
                    49602,
                    49632,
                    49661,
                    49690,
                    49720,
                    49749,
                    49779,
                    49809,
                    49838,
                    49868,
                    49898,
                    49927,
                    49957,
                    49986,
                    50016,
                    50045,
                    50075,
                    50104,
                    50133,
                    50163,
                    50192,
                    50222,
                    50252,
                    50281,
                    50311,
                    50340,
                    50370,
                    50400,
                    50429,
                    50459,
                    50488,
                    50518,
                    50547,
                    50576,
                    50606,
                    50635,
                    50665,
                    50694,
                    50724,
                    50754,
                    50784,
                    50813,
                    50843,
                    50872,
                    50902,
                    50931,
                    50960,
                    50990,
                    51019,
                    51049,
                    51078,
                    51108,
                    51138,
                    51167,
                    51197,
                    51227,
                    51256,
                    51286,
                    51315,
                    51345,
                    51374,
                    51403,
                    51433,
                    51462,
                    51492,
                    51522,
                    51552,
                    51582,
                    51611,
                    51641,
                    51670,
                    51699,
                    51729,
                    51758,
                    51787,
                    51816,
                    51846,
                    51876,
                    51906,
                    51936,
                    51965,
                    51995,
                    52025,
                    52054,
                    52083,
                    52113,
                    52142,
                    52171,
                    52200,
                    52230,
                    52260,
                    52290,
                    52319,
                    52349,
                    52379,
                    52408,
                    52438,
                    52467,
                    52497,
                    52526,
                    52555,
                    52585,
                    52614,
                    52644,
                    52673,
                    52703,
                    52733,
                    52762,
                    52792,
                    52822,
                    52851,
                    52881,
                    52910,
                    52939,
                    52969,
                    52998,
                    53028,
                    53057,
                    53087,
                    53116,
                    53146,
                    53176,
                    53205,
                    53235,
                    53264,
                    53294,
                    53324,
                    53353,
                    53383,
                    53412,
                    53441,
                    53471,
                    53500,
                    53530,
                    53559,
                    53589,
                    53619,
                    53648,
                    53678,
                    53708,
                    53737,
                    53767,
                    53796,
                    53825,
                    53855,
                    53884,
                    53913,
                    53943,
                    53973,
                    54003,
                    54032,
                    54062,
                    54092,
                    54121,
                    54151,
                    54180,
                    54209,
                    54239,
                    54268,
                    54297,
                    54327,
                    54357,
                    54387,
                    54416,
                    54446,
                    54476,
                    54505,
                    54535,
                    54564,
                    54593,
                    54623,
                    54652,
                    54681,
                    54711,
                    54741,
                    54770,
                    54800,
                    54830,
                    54859,
                    54889,
                    54919,
                    54948,
                    54977,
                    55007,
                    55036,
                    55066,
                    55095,
                    55125,
                    55154,
                    55184,
                    55213,
                    55243,
                    55273,
                    55302,
                    55332,
                    55361,
                    55391,
                    55420,
                    55450,
                    55479,
                    55508,
                    55538,
                    55567,
                    55597,
                    55627,
                    55657,
                    55686,
                    55716,
                    55745,
                    55775,
                    55804,
                    55834,
                    55863,
                    55892,
                    55922,
                    55951,
                    55981,
                    56011,
                    56040,
                    56070,
                    56100,
                    56129,
                    56159,
                    56188,
                    56218,
                    56247,
                    56276,
                    56306,
                    56335,
                    56365,
                    56394,
                    56424,
                    56454,
                    56483,
                    56513,
                    56543,
                    56572,
                    56601,
                    56631,
                    56660,
                    56690,
                    56719,
                    56749,
                    56778,
                    56808,
                    56837,
                    56867,
                    56897,
                    56926,
                    56956,
                    56985,
                    57015,
                    57044,
                    57074,
                    57103,
                    57133,
                    57162,
                    57192,
                    57221,
                    57251,
                    57280,
                    57310,
                    57340,
                    57369,
                    57399,
                    57429,
                    57458,
                    57487,
                    57517,
                    57546,
                    57576,
                    57605,
                    57634,
                    57664,
                    57694,
                    57723,
                    57753,
                    57783,
                    57813,
                    57842,
                    57871,
                    57901,
                    57930,
                    57959,
                    57989,
                    58018,
                    58048,
                    58077,
                    58107,
                    58137,
                    58167,
                    58196,
                    58226,
                    58255,
                    58285,
                    58314,
                    58343,
                    58373,
                    58402,
                    58432,
                    58461,
                    58491,
                    58521,
                    58551,
                    58580,
                    58610,
                    58639,
                    58669,
                    58698,
                    58727,
                    58757,
                    58786,
                    58816,
                    58845,
                    58875,
                    58905,
                    58934,
                    58964,
                    58994,
                    59023,
                    59053,
                    59082,
                    59111,
                    59141,
                    59170,
                    59200,
                    59229,
                    59259,
                    59288,
                    59318,
                    59348,
                    59377,
                    59407,
                    59436,
                    59466,
                    59495,
                    59525,
                    59554,
                    59584,
                    59613,
                    59643,
                    59672,
                    59702,
                    59731,
                    59761,
                    59791,
                    59820,
                    59850,
                    59879,
                    59909,
                    59939,
                    59968,
                    59997,
                    60027,
                    60056,
                    60086,
                    60115,
                    60145,
                    60174,
                    60204,
                    60234,
                    60264,
                    60293,
                    60323,
                    60352,
                    60381,
                    60411,
                    60440,
                    60469,
                    60499,
                    60528,
                    60558,
                    60588,
                    60618,
                    60648,
                    60677,
                    60707,
                    60736,
                    60765,
                    60795,
                    60824,
                    60853,
                    60883,
                    60912,
                    60942,
                    60972,
                    61002,
                    61031,
                    61061,
                    61090,
                    61120,
                    61149,
                    61179,
                    61208,
                    61237,
                    61267,
                    61296,
                    61326,
                    61356,
                    61385,
                    61415,
                    61445,
                    61474,
                    61504,
                    61533,
                    61563,
                    61592,
                    61621,
                    61651,
                    61680,
                    61710,
                    61739,
                    61769,
                    61799,
                    61828,
                    61858,
                    61888,
                    61917,
                    61947,
                    61976,
                    62006,
                    62035,
                    62064,
                    62094,
                    62123,
                    62153,
                    62182,
                    62212,
                    62242,
                    62271,
                    62301,
                    62331,
                    62360,
                    62390,
                    62419,
                    62448,
                    62478,
                    62507,
                    62537,
                    62566,
                    62596,
                    62625,
                    62655,
                    62685,
                    62715,
                    62744,
                    62774,
                    62803,
                    62832,
                    62862,
                    62891,
                    62921,
                    62950,
                    62980,
                    63009,
                    63039,
                    63069,
                    63099,
                    63128,
                    63157,
                    63187,
                    63216,
                    63246,
                    63275,
                    63305,
                    63334,
                    63363,
                    63393,
                    63423,
                    63453,
                    63482,
                    63512,
                    63541,
                    63571,
                    63600,
                    63630,
                    63659,
                    63689,
                    63718,
                    63747,
                    63777,
                    63807,
                    63836,
                    63866,
                    63895,
                    63925,
                    63955,
                    63984,
                    64014,
                    64043,
                    64073,
                    64102,
                    64131,
                    64161,
                    64190,
                    64220,
                    64249,
                    64279,
                    64309,
                    64339,
                    64368,
                    64398,
                    64427,
                    64457,
                    64486,
                    64515,
                    64545,
                    64574,
                    64603,
                    64633,
                    64663,
                    64692,
                    64722,
                    64752,
                    64782,
                    64811,
                    64841,
                    64870,
                    64899,
                    64929,
                    64958,
                    64987,
                    65017,
                    65047,
                    65076,
                    65106,
                    65136,
                    65166,
                    65195,
                    65225,
                    65254,
                    65283,
                    65313,
                    65342,
                    65371,
                    65401,
                    65431,
                    65460,
                    65490,
                    65520,
                    65549,
                    65579,
                    65608,
                    65638,
                    65667,
                    65697,
                    65726,
                    65755,
                    65785,
                    65815,
                    65844,
                    65874,
                    65903,
                    65933,
                    65963,
                    65992,
                    66022,
                    66051,
                    66081,
                    66110,
                    66140,
                    66169,
                    66199,
                    66228,
                    66258,
                    66287,
                    66317,
                    66346,
                    66376,
                    66405,
                    66435,
                    66465,
                    66494,
                    66524,
                    66553,
                    66583,
                    66612,
                    66641,
                    66671,
                    66700,
                    66730,
                    66760,
                    66789,
                    66819,
                    66849,
                    66878,
                    66908,
                    66937,
                    66967,
                    66996,
                    67025,
                    67055,
                    67084,
                    67114,
                    67143,
                    67173,
                    67203,
                    67233,
                    67262,
                    67292,
                    67321,
                    67351,
                    67380,
                    67409,
                    67439,
                    67468,
                    67497,
                    67527,
                    67557,
                    67587,
                    67617,
                    67646,
                    67676,
                    67705,
                    67735,
                    67764,
                    67793,
                    67823,
                    67852,
                    67882,
                    67911,
                    67941,
                    67971,
                    68e3,
                    68030,
                    68060,
                    68089,
                    68119,
                    68148,
                    68177,
                    68207,
                    68236,
                    68266,
                    68295,
                    68325,
                    68354,
                    68384,
                    68414,
                    68443,
                    68473,
                    68502,
                    68532,
                    68561,
                    68591,
                    68620,
                    68650,
                    68679,
                    68708,
                    68738,
                    68768,
                    68797,
                    68827,
                    68857,
                    68886,
                    68916,
                    68946,
                    68975,
                    69004,
                    69034,
                    69063,
                    69092,
                    69122,
                    69152,
                    69181,
                    69211,
                    69240,
                    69270,
                    69300,
                    69330,
                    69359,
                    69388,
                    69418,
                    69447,
                    69476,
                    69506,
                    69535,
                    69565,
                    69595,
                    69624,
                    69654,
                    69684,
                    69713,
                    69743,
                    69772,
                    69802,
                    69831,
                    69861,
                    69890,
                    69919,
                    69949,
                    69978,
                    70008,
                    70038,
                    70067,
                    70097,
                    70126,
                    70156,
                    70186,
                    70215,
                    70245,
                    70274,
                    70303,
                    70333,
                    70362,
                    70392,
                    70421,
                    70451,
                    70481,
                    70510,
                    70540,
                    70570,
                    70599,
                    70629,
                    70658,
                    70687,
                    70717,
                    70746,
                    70776,
                    70805,
                    70835,
                    70864,
                    70894,
                    70924,
                    70954,
                    70983,
                    71013,
                    71042,
                    71071,
                    71101,
                    71130,
                    71159,
                    71189,
                    71218,
                    71248,
                    71278,
                    71308,
                    71337,
                    71367,
                    71397,
                    71426,
                    71455,
                    71485,
                    71514,
                    71543,
                    71573,
                    71602,
                    71632,
                    71662,
                    71691,
                    71721,
                    71751,
                    71781,
                    71810,
                    71839,
                    71869,
                    71898,
                    71927,
                    71957,
                    71986,
                    72016,
                    72046,
                    72075,
                    72105,
                    72135,
                    72164,
                    72194,
                    72223,
                    72253,
                    72282,
                    72311,
                    72341,
                    72370,
                    72400,
                    72429,
                    72459,
                    72489,
                    72518,
                    72548,
                    72577,
                    72607,
                    72637,
                    72666,
                    72695,
                    72725,
                    72754,
                    72784,
                    72813,
                    72843,
                    72872,
                    72902,
                    72931,
                    72961,
                    72991,
                    73020,
                    73050,
                    73080,
                    73109,
                    73139,
                    73168,
                    73197,
                    73227,
                    73256,
                    73286,
                    73315,
                    73345,
                    73375,
                    73404,
                    73434,
                    73464,
                    73493,
                    73523,
                    73552,
                    73581,
                    73611,
                    73640,
                    73669,
                    73699,
                    73729,
                    73758,
                    73788,
                    73818,
                    73848,
                    73877,
                    73907,
                    73936,
                    73965,
                    73995,
                    74024,
                    74053,
                    74083,
                    74113,
                    74142,
                    74172,
                    74202,
                    74231,
                    74261,
                    74291,
                    74320,
                    74349,
                    74379,
                    74408,
                    74437,
                    74467,
                    74497,
                    74526,
                    74556,
                    74586,
                    74615,
                    74645,
                    74675,
                    74704,
                    74733,
                    74763,
                    74792,
                    74822,
                    74851,
                    74881,
                    74910,
                    74940,
                    74969,
                    74999,
                    75029,
                    75058,
                    75088,
                    75117,
                    75147,
                    75176,
                    75206,
                    75235,
                    75264,
                    75294,
                    75323,
                    75353,
                    75383,
                    75412,
                    75442,
                    75472,
                    75501,
                    75531,
                    75560,
                    75590,
                    75619,
                    75648,
                    75678,
                    75707,
                    75737,
                    75766,
                    75796,
                    75826,
                    75856,
                    75885,
                    75915,
                    75944,
                    75974,
                    76003,
                    76032,
                    76062,
                    76091,
                    76121,
                    76150,
                    76180,
                    76210,
                    76239,
                    76269,
                    76299,
                    76328,
                    76358,
                    76387,
                    76416,
                    76446,
                    76475,
                    76505,
                    76534,
                    76564,
                    76593,
                    76623,
                    76653,
                    76682,
                    76712,
                    76741,
                    76771,
                    76801,
                    76830,
                    76859,
                    76889,
                    76918,
                    76948,
                    76977,
                    77007,
                    77036,
                    77066,
                    77096,
                    77125,
                    77155,
                    77185,
                    77214,
                    77243,
                    77273,
                    77302,
                    77332,
                    77361,
                    77390,
                    77420,
                    77450,
                    77479,
                    77509,
                    77539,
                    77569,
                    77598,
                    77627,
                    77657,
                    77686,
                    77715,
                    77745,
                    77774,
                    77804,
                    77833,
                    77863,
                    77893,
                    77923,
                    77952,
                    77982,
                    78011,
                    78041,
                    78070,
                    78099,
                    78129,
                    78158,
                    78188,
                    78217,
                    78247,
                    78277,
                    78307,
                    78336,
                    78366,
                    78395,
                    78425,
                    78454,
                    78483,
                    78513,
                    78542,
                    78572,
                    78601,
                    78631,
                    78661,
                    78690,
                    78720,
                    78750,
                    78779,
                    78808,
                    78838,
                    78867,
                    78897,
                    78926,
                    78956,
                    78985,
                    79015,
                    79044,
                    79074,
                    79104,
                    79133,
                    79163,
                    79192,
                    79222,
                    79251,
                    79281,
                    79310,
                    79340,
                    79369,
                    79399,
                    79428,
                    79458,
                    79487,
                    79517,
                    79546,
                    79576,
                    79606,
                    79635,
                    79665,
                    79695,
                    79724,
                    79753,
                    79783,
                    79812,
                    79841,
                    79871,
                    79900,
                    79930,
                    79960,
                    79990
                ];
            },
            3489: function(e, t, r) {
                var n = r(6131);
                function a() {
                    this.regionalOptions = [], this.regionalOptions[""] = {
                        invalidCalendar: "Calendar {0} not found",
                        invalidDate: "Invalid {0} date",
                        invalidMonth: "Invalid {0} month",
                        invalidYear: "Invalid {0} year",
                        differentCalendars: "Cannot mix {0} and {1} dates"
                    }, this.local = this.regionalOptions[""], this.calendars = {}, this._localCals = {};
                }
                function i(e, t, r, n) {
                    if (this._calendar = e, this._year = t, this._month = r, this._day = n, 0 === this._calendar._validateLevel && !this._calendar.isValid(this._year, this._month, this._day)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
                }
                function o(e, t) {
                    return "000000".substring(0, t - (e = "" + e).length) + e;
                }
                function l() {
                    this.shortYearCutoff = "+10";
                }
                function s(e) {
                    this.local = this.regionalOptions[e] || this.regionalOptions[""];
                }
                n(a.prototype, {
                    instance: function(e, t) {
                        e = (e || "gregorian").toLowerCase(), t = t || "";
                        var r = this._localCals[e + "-" + t];
                        if (!r && this.calendars[e] && (r = new this.calendars[e](t), this._localCals[e + "-" + t] = r), !r) throw (this.local.invalidCalendar || this.regionalOptions[""].invalidCalendar).replace(/\{0\}/, e);
                        return r;
                    },
                    newDate: function(e, t, r, n, a) {
                        return (n = (null != e && e.year ? e.calendar() : "string" == typeof n ? this.instance(n, a) : n) || this.instance()).newDate(e, t, r);
                    },
                    substituteDigits: function(e) {
                        return function(t) {
                            return (t + "").replace(/[0-9]/g, function(t) {
                                return e[t];
                            });
                        };
                    },
                    substituteChineseDigits: function(e, t) {
                        return function(r) {
                            for(var n = "", a = 0; r > 0;){
                                var i = r % 10;
                                n = (0 === i ? "" : e[i] + t[a]) + n, a++, r = Math.floor(r / 10);
                            }
                            return 0 === n.indexOf(e[1] + t[1]) && (n = n.substr(1)), n || e[0];
                        };
                    }
                }), n(i.prototype, {
                    newDate: function(e, t, r) {
                        return this._calendar.newDate(null == e ? this : e, t, r);
                    },
                    year: function(e) {
                        return 0 === arguments.length ? this._year : this.set(e, "y");
                    },
                    month: function(e) {
                        return 0 === arguments.length ? this._month : this.set(e, "m");
                    },
                    day: function(e) {
                        return 0 === arguments.length ? this._day : this.set(e, "d");
                    },
                    date: function(e, t, r) {
                        if (!this._calendar.isValid(e, t, r)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
                        return this._year = e, this._month = t, this._day = r, this;
                    },
                    leapYear: function() {
                        return this._calendar.leapYear(this);
                    },
                    epoch: function() {
                        return this._calendar.epoch(this);
                    },
                    formatYear: function() {
                        return this._calendar.formatYear(this);
                    },
                    monthOfYear: function() {
                        return this._calendar.monthOfYear(this);
                    },
                    weekOfYear: function() {
                        return this._calendar.weekOfYear(this);
                    },
                    daysInYear: function() {
                        return this._calendar.daysInYear(this);
                    },
                    dayOfYear: function() {
                        return this._calendar.dayOfYear(this);
                    },
                    daysInMonth: function() {
                        return this._calendar.daysInMonth(this);
                    },
                    dayOfWeek: function() {
                        return this._calendar.dayOfWeek(this);
                    },
                    weekDay: function() {
                        return this._calendar.weekDay(this);
                    },
                    extraInfo: function() {
                        return this._calendar.extraInfo(this);
                    },
                    add: function(e, t) {
                        return this._calendar.add(this, e, t);
                    },
                    set: function(e, t) {
                        return this._calendar.set(this, e, t);
                    },
                    compareTo: function(e) {
                        if (this._calendar.name !== e._calendar.name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, e._calendar.local.name);
                        var t = this._year !== e._year ? this._year - e._year : this._month !== e._month ? this.monthOfYear() - e.monthOfYear() : this._day - e._day;
                        return 0 === t ? 0 : t < 0 ? -1 : 1;
                    },
                    calendar: function() {
                        return this._calendar;
                    },
                    toJD: function() {
                        return this._calendar.toJD(this);
                    },
                    fromJD: function(e) {
                        return this._calendar.fromJD(e);
                    },
                    toJSDate: function() {
                        return this._calendar.toJSDate(this);
                    },
                    fromJSDate: function(e) {
                        return this._calendar.fromJSDate(e);
                    },
                    toString: function() {
                        return (this.year() < 0 ? "-" : "") + o(Math.abs(this.year()), 4) + "-" + o(this.month(), 2) + "-" + o(this.day(), 2);
                    }
                }), n(l.prototype, {
                    _validateLevel: 0,
                    newDate: function(e, t, r) {
                        return null == e ? this.today() : (e.year && (this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), r = e.day(), t = e.month(), e = e.year()), new i(this, e, t, r));
                    },
                    today: function() {
                        return this.fromJSDate(new Date);
                    },
                    epoch: function(e) {
                        return this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear).year() < 0 ? this.local.epochs[0] : this.local.epochs[1];
                    },
                    formatYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
                        return (t.year() < 0 ? "-" : "") + o(Math.abs(t.year()), 4);
                    },
                    monthsInYear: function(e) {
                        return this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear), 12;
                    },
                    monthOfYear: function(e, t) {
                        var r = this._validate(e, t, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);
                        return (r.month() + this.monthsInYear(r) - this.firstMonth) % this.monthsInYear(r) + this.minMonth;
                    },
                    fromMonthOfYear: function(e, t) {
                        var r = (t + this.firstMonth - 2 * this.minMonth) % this.monthsInYear(e) + this.minMonth;
                        return this._validate(e, r, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth), r;
                    },
                    daysInYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
                        return this.leapYear(t) ? 366 : 365;
                    },
                    dayOfYear: function(e, t, r) {
                        var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        return n.toJD() - this.newDate(n.year(), this.fromMonthOfYear(n.year(), this.minMonth), this.minDay).toJD() + 1;
                    },
                    daysInWeek: function() {
                        return 7;
                    },
                    dayOfWeek: function(e, t, r) {
                        var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        return (Math.floor(this.toJD(n)) + 2) % this.daysInWeek();
                    },
                    extraInfo: function(e, t, r) {
                        return this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), {};
                    },
                    add: function(e, t, r) {
                        return this._validate(e, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate), this._correctAdd(e, this._add(e, t, r), t, r);
                    },
                    _add: function(e, t, r) {
                        if (this._validateLevel++, "d" === r || "w" === r) {
                            var n = e.toJD() + t * ("w" === r ? this.daysInWeek() : 1), a = e.calendar().fromJD(n);
                            return this._validateLevel--, [
                                a.year(),
                                a.month(),
                                a.day()
                            ];
                        }
                        try {
                            var i = e.year() + ("y" === r ? t : 0), o = e.monthOfYear() + ("m" === r ? t : 0);
                            a = e.day(), "y" === r ? (e.month() !== this.fromMonthOfYear(i, o) && (o = this.newDate(i, e.month(), this.minDay).monthOfYear()), o = Math.min(o, this.monthsInYear(i)), a = Math.min(a, this.daysInMonth(i, this.fromMonthOfYear(i, o)))) : "m" === r && (function(e) {
                                for(; o < e.minMonth;)i--, o += e.monthsInYear(i);
                                for(var t = e.monthsInYear(i); o > t - 1 + e.minMonth;)i++, o -= t, t = e.monthsInYear(i);
                            }(this), a = Math.min(a, this.daysInMonth(i, this.fromMonthOfYear(i, o))));
                            var l = [
                                i,
                                this.fromMonthOfYear(i, o),
                                a
                            ];
                            return this._validateLevel--, l;
                        } catch (e) {
                            throw this._validateLevel--, e;
                        }
                    },
                    _correctAdd: function(e, t, r, n) {
                        if (!(this.hasYearZero || "y" !== n && "m" !== n || 0 !== t[0] && e.year() > 0 == t[0] > 0)) {
                            var a = {
                                y: [
                                    1,
                                    1,
                                    "y"
                                ],
                                m: [
                                    1,
                                    this.monthsInYear(-1),
                                    "m"
                                ],
                                w: [
                                    this.daysInWeek(),
                                    this.daysInYear(-1),
                                    "d"
                                ],
                                d: [
                                    1,
                                    this.daysInYear(-1),
                                    "d"
                                ]
                            }[n], i = r < 0 ? -1 : 1;
                            t = this._add(e, r * a[0] + i * a[1], a[2]);
                        }
                        return e.date(t[0], t[1], t[2]);
                    },
                    set: function(e, t, r) {
                        this._validate(e, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        var n = "y" === r ? t : e.year(), a = "m" === r ? t : e.month(), i = "d" === r ? t : e.day();
                        return "y" !== r && "m" !== r || (i = Math.min(i, this.daysInMonth(n, a))), e.date(n, a, i);
                    },
                    isValid: function(e, t, r) {
                        this._validateLevel++;
                        var n = this.hasYearZero || 0 !== e;
                        if (n) {
                            var a = this.newDate(e, t, this.minDay);
                            n = t >= this.minMonth && t - this.minMonth < this.monthsInYear(a) && r >= this.minDay && r - this.minDay < this.daysInMonth(a);
                        }
                        return this._validateLevel--, n;
                    },
                    toJSDate: function(e, t, r) {
                        var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        return c.instance().fromJD(this.toJD(n)).toJSDate();
                    },
                    fromJSDate: function(e) {
                        return this.fromJD(c.instance().fromJSDate(e).toJD());
                    },
                    _validate: function(e, t, r, n) {
                        if (e.year) {
                            if (0 === this._validateLevel && this.name !== e.calendar().name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this.local.name).replace(/\{1\}/, e.calendar().local.name);
                            return e;
                        }
                        try {
                            if (this._validateLevel++, 1 === this._validateLevel && !this.isValid(e, t, r)) throw n.replace(/\{0\}/, this.local.name);
                            var a = this.newDate(e, t, r);
                            return this._validateLevel--, a;
                        } catch (e) {
                            throw this._validateLevel--, e;
                        }
                    }
                }), s.prototype = new l, n(s.prototype, {
                    name: "Gregorian",
                    jdEpoch: 1721425.5,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Gregorian",
                            epochs: [
                                "BCE",
                                "CE"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "mm/dd/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(e) {
                        var t = this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
                        return (e = t.year() + (t.year() < 0 ? 1 : 0)) % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
                    },
                    weekOfYear: function(e, t, r) {
                        var n = this.newDate(e, t, r);
                        return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(e, t) {
                        var r = this._validate(e, t, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(e, t, r) {
                        return (this.dayOfWeek(e, t, r) || 7) < 6;
                    },
                    toJD: function(e, t, r) {
                        var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        e = n.year(), t = n.month(), r = n.day(), e < 0 && e++, t < 3 && (t += 12, e--);
                        var a = Math.floor(e / 100), i = 2 - a + Math.floor(a / 4);
                        return Math.floor(365.25 * (e + 4716)) + Math.floor(30.6001 * (t + 1)) + r + i - 1524.5;
                    },
                    fromJD: function(e) {
                        var t = Math.floor(e + .5), r = Math.floor((t - 1867216.25) / 36524.25), n = 1524 + (r = t + 1 + r - Math.floor(r / 4)), a = Math.floor((n - 122.1) / 365.25), i = Math.floor(365.25 * a), o = Math.floor((n - i) / 30.6001), l = n - i - Math.floor(30.6001 * o), s = o - (o > 13.5 ? 13 : 1), c = a - (s > 2.5 ? 4716 : 4715);
                        return c <= 0 && c--, this.newDate(c, s, l);
                    },
                    toJSDate: function(e, t, r) {
                        var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), a = new Date(n.year(), n.month() - 1, n.day());
                        return a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0), a.setHours(a.getHours() > 12 ? a.getHours() + 2 : 0), a;
                    },
                    fromJSDate: function(e) {
                        return this.newDate(e.getFullYear(), e.getMonth() + 1, e.getDate());
                    }
                });
                var c = e.exports = new a;
                c.cdate = i, c.baseCalendar = l, c.calendars.gregorian = s;
            },
            4338: function(e, t, r) {
                var n = r(6131), a = r(3489);
                n(a.regionalOptions[""], {
                    invalidArguments: "Invalid arguments",
                    invalidFormat: "Cannot format a date from another calendar",
                    missingNumberAt: "Missing number at position {0}",
                    unknownNameAt: "Unknown name at position {0}",
                    unexpectedLiteralAt: "Unexpected literal at position {0}",
                    unexpectedText: "Additional text found at end"
                }), a.local = a.regionalOptions[""], n(a.cdate.prototype, {
                    formatDate: function(e, t) {
                        return "string" != typeof e && (t = e, e = ""), this._calendar.formatDate(e || "", this, t);
                    }
                }), n(a.baseCalendar.prototype, {
                    UNIX_EPOCH: a.instance().newDate(1970, 1, 1).toJD(),
                    SECS_PER_DAY: 86400,
                    TICKS_EPOCH: a.instance().jdEpoch,
                    TICKS_PER_DAY: 864e9,
                    ATOM: "yyyy-mm-dd",
                    COOKIE: "D, dd M yyyy",
                    FULL: "DD, MM d, yyyy",
                    ISO_8601: "yyyy-mm-dd",
                    JULIAN: "J",
                    RFC_822: "D, d M yy",
                    RFC_850: "DD, dd-M-yy",
                    RFC_1036: "D, d M yy",
                    RFC_1123: "D, d M yyyy",
                    RFC_2822: "D, d M yyyy",
                    RSS: "D, d M yy",
                    TICKS: "!",
                    TIMESTAMP: "@",
                    W3C: "yyyy-mm-dd",
                    formatDate: function(e, t, r) {
                        if ("string" != typeof e && (r = t, t = e, e = ""), !t) return "";
                        if (t.calendar() !== this) throw a.local.invalidFormat || a.regionalOptions[""].invalidFormat;
                        e = e || this.local.dateFormat;
                        for(var n, i, o, l = (r = r || {}).dayNamesShort || this.local.dayNamesShort, s = r.dayNames || this.local.dayNames, c = r.monthNumbers || this.local.monthNumbers, u = r.monthNamesShort || this.local.monthNamesShort, f = r.monthNames || this.local.monthNames, d = (r.calculateWeek || this.local.calculateWeek, function(t, r) {
                            for(var n = 1; _ + n < e.length && e.charAt(_ + n) === t;)n++;
                            return _ += n - 1, Math.floor(n / (r || 1)) > 1;
                        }), h = function(e, t, r, n) {
                            var a = "" + t;
                            if (d(e, n)) for(; a.length < r;)a = "0" + a;
                            return a;
                        }, p = this, v = function(e) {
                            return "function" == typeof c ? c.call(p, e, d("m")) : m(h("m", e.month(), 2));
                        }, g = function(e, t) {
                            return t ? "function" == typeof f ? f.call(p, e) : f[e.month() - p.minMonth] : "function" == typeof u ? u.call(p, e) : u[e.month() - p.minMonth];
                        }, y = this.local.digits, m = function(e) {
                            return r.localNumbers && y ? y(e) : e;
                        }, x = "", b = !1, _ = 0; _ < e.length; _++)if (b) "'" !== e.charAt(_) || d("'") ? x += e.charAt(_) : b = !1;
                        else switch(e.charAt(_)){
                            case "d":
                                x += m(h("d", t.day(), 2));
                                break;
                            case "D":
                                x += (n = t.dayOfWeek(), i = l, o = s, d("D") ? o[n] : i[n]);
                                break;
                            case "o":
                                x += h("o", t.dayOfYear(), 3);
                                break;
                            case "w":
                                x += h("w", t.weekOfYear(), 2);
                                break;
                            case "m":
                                x += v(t);
                                break;
                            case "M":
                                x += g(t, d("M"));
                                break;
                            case "y":
                                x += d("y", 2) ? t.year() : (t.year() % 100 < 10 ? "0" : "") + t.year() % 100;
                                break;
                            case "Y":
                                d("Y", 2), x += t.formatYear();
                                break;
                            case "J":
                                x += t.toJD();
                                break;
                            case "@":
                                x += (t.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY;
                                break;
                            case "!":
                                x += (t.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY;
                                break;
                            case "'":
                                d("'") ? x += "'" : b = !0;
                                break;
                            default:
                                x += e.charAt(_);
                        }
                        return x;
                    },
                    parseDate: function(e, t, r) {
                        if (null == t) throw a.local.invalidArguments || a.regionalOptions[""].invalidArguments;
                        if ("" === (t = "object" == typeof t ? t.toString() : t + "")) return null;
                        e = e || this.local.dateFormat;
                        var n = (r = r || {}).shortYearCutoff || this.shortYearCutoff;
                        n = "string" != typeof n ? n : this.today().year() % 100 + parseInt(n, 10);
                        for(var i = r.dayNamesShort || this.local.dayNamesShort, o = r.dayNames || this.local.dayNames, l = r.parseMonth || this.local.parseMonth, s = r.monthNumbers || this.local.monthNumbers, c = r.monthNamesShort || this.local.monthNamesShort, u = r.monthNames || this.local.monthNames, f = -1, d = -1, h = -1, p = -1, v = -1, g = !1, y = !1, m = function(t, r) {
                            for(var n = 1; A + n < e.length && e.charAt(A + n) === t;)n++;
                            return A += n - 1, Math.floor(n / (r || 1)) > 1;
                        }, x = function(e, r) {
                            var n = m(e, r), i = [
                                2,
                                3,
                                n ? 4 : 2,
                                n ? 4 : 2,
                                10,
                                11,
                                20
                            ]["oyYJ@!".indexOf(e) + 1], o = new RegExp("^-?\\d{1," + i + "}"), l = t.substring(k).match(o);
                            if (!l) throw (a.local.missingNumberAt || a.regionalOptions[""].missingNumberAt).replace(/\{0\}/, k);
                            return k += l[0].length, parseInt(l[0], 10);
                        }, b = this, _ = function() {
                            if ("function" == typeof s) {
                                m("m");
                                var e = s.call(b, t.substring(k));
                                return k += e.length, e;
                            }
                            return x("m");
                        }, w = function(e, r, n, i) {
                            for(var o = m(e, i) ? n : r, l = 0; l < o.length; l++)if (t.substr(k, o[l].length).toLowerCase() === o[l].toLowerCase()) return k += o[l].length, l + b.minMonth;
                            throw (a.local.unknownNameAt || a.regionalOptions[""].unknownNameAt).replace(/\{0\}/, k);
                        }, T = function() {
                            if ("function" == typeof u) {
                                var e = m("M") ? u.call(b, t.substring(k)) : c.call(b, t.substring(k));
                                return k += e.length, e;
                            }
                            return w("M", c, u);
                        }, M = function() {
                            if (t.charAt(k) !== e.charAt(A)) throw (a.local.unexpectedLiteralAt || a.regionalOptions[""].unexpectedLiteralAt).replace(/\{0\}/, k);
                            k++;
                        }, k = 0, A = 0; A < e.length; A++)if (y) "'" !== e.charAt(A) || m("'") ? M() : y = !1;
                        else switch(e.charAt(A)){
                            case "d":
                                p = x("d");
                                break;
                            case "D":
                                w("D", i, o);
                                break;
                            case "o":
                                v = x("o");
                                break;
                            case "w":
                                x("w");
                                break;
                            case "m":
                                h = _();
                                break;
                            case "M":
                                h = T();
                                break;
                            case "y":
                                var L = A;
                                g = !m("y", 2), A = L, d = x("y", 2);
                                break;
                            case "Y":
                                d = x("Y", 2);
                                break;
                            case "J":
                                f = x("J") + .5, "." === t.charAt(k) && (k++, x("J"));
                                break;
                            case "@":
                                f = x("@") / this.SECS_PER_DAY + this.UNIX_EPOCH;
                                break;
                            case "!":
                                f = x("!") / this.TICKS_PER_DAY + this.TICKS_EPOCH;
                                break;
                            case "*":
                                k = t.length;
                                break;
                            case "'":
                                m("'") ? M() : y = !0;
                                break;
                            default:
                                M();
                        }
                        if (k < t.length) throw a.local.unexpectedText || a.regionalOptions[""].unexpectedText;
                        if (-1 === d ? d = this.today().year() : d < 100 && g && (d += -1 === n ? 1900 : this.today().year() - this.today().year() % 100 - (d <= n ? 0 : 100)), "string" == typeof h && (h = l.call(this, d, h)), v > -1) {
                            h = 1, p = v;
                            for(var S = this.daysInMonth(d, h); p > S; S = this.daysInMonth(d, h))h++, p -= S;
                        }
                        return f > -1 ? this.fromJD(f) : this.newDate(d, h, p);
                    },
                    determineDate: function(e, t, r, n, a) {
                        r && "object" != typeof r && (a = n, n = r, r = null), "string" != typeof n && (a = n, n = "");
                        var i = this;
                        return t = t ? t.newDate() : null, null == e ? t : "string" == typeof e ? function(e) {
                            try {
                                return i.parseDate(n, e, a);
                            } catch (e) {}
                            for(var t = ((e = e.toLowerCase()).match(/^c/) && r ? r.newDate() : null) || i.today(), o = /([+-]?[0-9]+)\s*(d|w|m|y)?/g, l = o.exec(e); l;)t.add(parseInt(l[1], 10), l[2] || "d"), l = o.exec(e);
                            return t;
                        }(e) : "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? t : i.today().add(e, "d") : i.newDate(e);
                    }
                });
            }
        }, t = {};
        function r(n) {
            var a = t[n];
            if (void 0 !== a) return a.exports;
            var i = t[n] = {
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.exports;
        }
        return r.d = function(e, t) {
            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r(2576);
    }();
});



const $405f46edf3c84493$var$FONT = "Roboto";
const $405f46edf3c84493$var$FONT_SIZE_NORMAL = 16;
const $405f46edf3c84493$var$TICK_LABEL_SIZE_MULTIPLIER = 0.8;
const $405f46edf3c84493$var$DEFAULT_THICKNESS = 1.2;
const $405f46edf3c84493$var$CONFIG = {
    modeBarButtonsToRemove: [
        "select2d",
        "lasso2d"
    ],
    displaylogo: false,
    editable: true,
    // scrollZoom: true,
    showEditInChartStudio: true,
    plotlyServerURL: "https://chart-studio.plotly.com"
};
class $405f46edf3c84493$export$5512561d86ae4f70 {
    /** A plotly.js graph with the methods to control it
   *
   * @param element
   * @param width {number}
   * @param height {number}
   * @param layout {Object|undefined}
   */ constructor(element, width, height, layout = {}){
        this.NUMBER_OF_POINTS_IN_SEGMENT = 30;
        this.parentElement = element;
        this.isDrawn = false;
        this.lines = new Map(); // []
        this.lineStyles = new Map(); // this.linesProps = []
        this.xTicksValues = [];
        this.xTicksTexts = [];
        this.data = [];
        this.layout = {
            title: "",
            showlegend: false,
            autosize: true,
            hovermode: false,
            // dragmode: 'pan',
            margin: {
                l: 20,
                // this.margins.left,
                r: 20,
                // this.margins.right,
                b: 20,
                // this.margins.bottom,
                t: 30,
                // this.margins.top,
                pad: 0
            },
            xaxis: {
                showline: true,
                showgrid: true,
                mirror: "ticks",
                automargin: true,
                titlefont: {
                    "family": $405f46edf3c84493$var$FONT
                },
                tickfont: {
                    "family": $405f46edf3c84493$var$FONT,
                    "size": $405f46edf3c84493$var$TICK_LABEL_SIZE_MULTIPLIER * $405f46edf3c84493$var$FONT_SIZE_NORMAL
                }
            },
            yaxis: {
                showline: true,
                showgrid: true,
                mirror: "ticks",
                automargin: true,
                autorange: false,
                titlefont: {
                    "family": $405f46edf3c84493$var$FONT
                },
                tickfont: {
                    "family": $405f46edf3c84493$var$FONT,
                    "size": $405f46edf3c84493$var$TICK_LABEL_SIZE_MULTIPLIER * $405f46edf3c84493$var$FONT_SIZE_NORMAL
                },
                zerolinecolor: "#969696",
                zerolinewidth: 1
            }
        };
        if (width !== undefined) this.layout.width = width;
        if (height !== undefined) this.layout.height = height;
        // update this layout with the given values
        (0, $ab6e98e8f37dab02$export$6969335ea1e4e77c)(this.layout, layout);
    }
    /**
   * Sets the labels and value range for the axes
   * @param {string} xLabel X axis label
   * @param {string} yLabel Y axis label
   * @param {boolean} isXFixedRange Indicates if the x-axis has fixed range (for band structure)
   * @param {number} xMin X axis minimum value
   * @param {number} xMax X axis maximum value
   * @param {number} yMinInit Y axis initial minimum value
   * @param {number} yMaxInit Y axis initial maximum value
   * @param {number} yMin Y axis absolute minimum value
   *   (minimum value reachable using the interaction)
   * @param {number} yMax Y axis absolute maximum value
   *   (maximum value reachable using the interaction)
   */ setAxisLabelsAndRange(xLabel, yLabel, isXFixedRange = false, xMin, xMax, yMinInit, yMaxInit, yMin, yMax) {
        if (yMinInit !== undefined || yMin !== undefined) yMin = Math.max(yMinInit, yMin);
        if (yMaxInit !== undefined || yMax !== undefined) yMax = Math.min(yMaxInit, yMax);
        this.layout.xaxis.title = xLabel;
        if (xMin !== undefined && xMax !== undefined) this.layout.xaxis.range = [
            xMin,
            xMax
        ];
        if (isXFixedRange) this.layout.xaxis.fixedrange = true;
        this.layout.yaxis.title = yLabel;
        if (yMin !== undefined && yMax !== undefined) this.layout.yaxis.range = [
            yMin,
            yMax
        ];
        if (this.isDrawn) (0, (/*@__PURE__*/$parcel$interopDefault($0ae81143a7e218db$exports))).relayout(this.parentElement, this.layout);
    }
    /**
   * Sets a tick text on the X axis
   * @param {int} x
   * @param {string} tickText
   */ setXAxisTickText(x, tickText) {
        this.xTicksValues.push(x);
        this.xTicksTexts.push(tickText);
        this.layout.xaxis.tickvals = this.xTicksValues;
        this.layout.xaxis.ticktext = this.xTicksTexts;
        if (this.isDrawn) (0, (/*@__PURE__*/$parcel$interopDefault($0ae81143a7e218db$exports))).relayout(this.parentElement, this.layout);
    }
    /**
   * Adds a group of lines
   * @param {string} name Group name
   * @param {object} style Line style
   */ addLineGroup(name, style) {
        this.lines.set(name, []);
        if (style.defaultColor) style.strokeColor = style.defaultColor;
        this.lineStyles.set(name, style);
    }
    /** Checks if the group with the name has already been added
   * @param name {string}
   * @returns {boolean}
   */ hasLineGroup(name) {
        return this.lines.has(name);
    }
    /** An iterator over existing line groups
   * @returns {Generator<any, void, *>}
   */ *lineGroups() {
        for (const key of this.lines.keys())yield key;
    }
    /**
   * Adds a line (data) to a group of lines
   * @param {(number[])[]} lineData the X and Y data for the line
   * @param {string} group
   */ setLineData(lineData, group) {
        this.lines.get(group).push(lineData);
    }
    /** Getter for line thickness
   * @param groupName {string}
   */ getThickness(groupName) {
        if (!this.isDrawn) throw "the graph is not drawn yet";
        if (!this.lines.has(groupName)) throw `${groupName} is not in group names`;
        const trace = Array.from(this.lines.keys()).indexOf(groupName);
        return this.parentElement.data[trace].line.width;
    }
    /** Getter for line color
   * @param groupName {string}
   */ getColor(groupName) {
        if (!this.isDrawn) throw "the graph is not drawn yet";
        if (!this.lines.has(groupName)) throw `${groupName} is not in group names`;
        const trace = Array.from(this.lines.keys()).indexOf(groupName);
        return this.parentElement.data[trace].line.color;
    }
    /** Adds dropdown controls to layout (update menus attributes)
   * @param defaultGroup {string} the label of the default
   */ #addDropdownControl(defaultGroup = "") {
        if (this.isDrawn) throw "the graph is already drawn";
        const nGroups = this.lines.size;
        const groups = [
            ...Array(nGroups).keys()
        ];
        // hide all the traces
        let trace = 0;
        this.data.forEach((group, idx)=>{
            group.visible = false;
            if (group.meta === defaultGroup) trace = idx;
        });
        //  show the default trace
        const name = this.data[trace].meta;
        this.data[trace].visible = true;
        this.layout.yaxis.title = this.lineStyles.get(name).yTitle;
        // make update menus
        let updateMenus = [
            {
                buttons: [],
                x: 0.9,
                xanchor: "right",
                y: 0.9,
                yanchor: "top",
                visible: true,
                active: trace
            }
        ];
        this.data.forEach((group, idx)=>{
            const name = group.meta;
            let visible = groups.map((_)=>false);
            visible[idx] = true;
            updateMenus[0].buttons.push({
                args: [
                    {
                        visible: visible
                    },
                    {
                        "yaxis.title": this.lineStyles.get(name).yTitle
                    }
                ],
                method: "update",
                label: name
            });
        });
        this.layout.updatemenus = updateMenus;
    }
    /** Converts lines and line styles to actual plottable objects
   */ #dataToLines() {
        this.lines.forEach((lines, groupName)=>{
            const style = this.lineStyles.get(groupName);
            let polyLines = {
                x: [],
                y: [],
                meta: groupName,
                connectgaps: false,
                line: {
                    color: style.strokeColor,
                    width: $405f46edf3c84493$var$DEFAULT_THICKNESS
                }
            };
            lines.forEach((line)=>{
                let points = {
                    x: [],
                    y: []
                };
                //  plotting each STEPth point
                const step = this.NUMBER_OF_POINTS_IN_SEGMENT > 0 && line[0].length > this.NUMBER_OF_POINTS_IN_SEGMENT ? Math.round(line[0].length / this.NUMBER_OF_POINTS_IN_SEGMENT) : 1;
                points.x.push(...line[0].filter((_, idx)=>idx % step === 0));
                points.y.push(...line[1].filter((_, idx)=>idx % step === 0));
                // the last point (is added if not already)
                if ((line[0].length - 1) % step !== 0) {
                    points.x.push(line[0][line[0].length - 1]);
                    points.y.push(line[1][line[1].length - 1]);
                }
                // if (Math.min(...points.y) > this.yMin - 1 && Math.max(...points.y) <= this.yMax + 1) {
                polyLines.x.push(...points.x, null);
                polyLines.y.push(...points.y, null);
            // }
            });
            if (polyLines.x.length > 0) this.data.push(polyLines);
        });
    }
    /** Returns the name of the chosen group
   */ getDropdownGroup() {
        let activeGroup = this.parentElement.layout.updatemenus[0].active;
        return this.parentElement.layout.updatemenus[0].buttons[activeGroup].label;
    }
    /** Adds a graph and draws the data
   * @param withDropdown {boolean} a flag to add the dropdown controls to the graph
   * @param defaultGroup {string} the name of the default group
   */ draw(withDropdown = false, defaultGroup = "") {
        if (this.isDrawn) throw "The graph is already drawn!";
        this.#dataToLines();
        const start = performance.now();
        if (withDropdown) this.#addDropdownControl(defaultGroup);
        (0, (/*@__PURE__*/$parcel$interopDefault($0ae81143a7e218db$exports))).newPlot(this.parentElement, this.data, this.layout, $405f46edf3c84493$var$CONFIG);
        this.isDrawn = true;
        console.log("time building graphs: " + (performance.now() - start));
    }
    /**
   * Clears and purges the graph
   */ clear() {
        // clear everything
        this.lines = new Map(); // []
        this.lineStyles = new Map(); // this.linesProps = []
        this.xTicksValues = [];
        this.xTicksTexts = [];
        this.data = [];
        // purge div
        (0, (/*@__PURE__*/$parcel$interopDefault($0ae81143a7e218db$exports))).purge(this.parentElement);
        this.isDrawn = false;
    }
    /**
   * Changes the axes labels and the title styles
   * @param  {number} sizeMult Font size multiplier
   * @param  {string} color Color code
   */ changeLabelsStyle(sizeMult, color) {
        const layout = {
            "xaxis.title.font.size": sizeMult * $405f46edf3c84493$var$FONT_SIZE_NORMAL,
            "xaxis.title.font.color": color,
            "xaxis.tickfont.size": $405f46edf3c84493$var$TICK_LABEL_SIZE_MULTIPLIER * sizeMult * $405f46edf3c84493$var$FONT_SIZE_NORMAL,
            "xaxis.tickfont.color": color,
            "yaxis.title.font.size": sizeMult * $405f46edf3c84493$var$FONT_SIZE_NORMAL,
            "yaxis.title.font.color": color,
            "yaxis.tickfont.size": $405f46edf3c84493$var$TICK_LABEL_SIZE_MULTIPLIER * sizeMult * $405f46edf3c84493$var$FONT_SIZE_NORMAL,
            "yaxis.tickfont.color": color
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($0ae81143a7e218db$exports))).relayout(this.parentElement, layout);
    }
    /**
   * Changes the data lines style
   * @param  {string} groupName Lines group name
   * @param  {number} thickness Lines thickness
   * @param  {string} color Color code
   */ changeDataLinesStyle(groupName, thickness, color) {
        if (!this.lines.has(groupName)) throw `${groupName} is not in group names`;
        const trace = Array.from(this.lines.keys()).indexOf(groupName);
        const style = {
            "line.color": color,
            "line.width": thickness
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($0ae81143a7e218db$exports))).restyle(this.parentElement, style, [
            trace
        ]);
    }
}
function $405f46edf3c84493$export$79a4e539e3d844f0(divs, data) {
    if (data === undefined) {
        // initial join
        const yRange = [
            Math.min(...divs.map((div)=>div.layout.yaxis.range[0])),
            Math.max(...divs.map((div)=>div.layout.yaxis.range[1]))
        ];
        divs.forEach((div)=>(0, (/*@__PURE__*/$parcel$interopDefault($0ae81143a7e218db$exports))).relayout(div, {
                "yaxis.range[0]": yRange[0],
                "yaxis.range[1]": yRange[1]
            }));
        return;
    }
    if (Object.entries(data).length === 0) return;
    let yAutoRange = undefined;
    divs.forEach((div)=>{
        if (data["yaxis.autorange"] && div.layout.yaxis.autorange) yAutoRange = div.layout.yaxis.range;
    });
    divs.forEach((div)=>{
        let y = div.layout.yaxis;
        let yRange = yAutoRange !== undefined ? yAutoRange : [
            data["yaxis.range[0]"],
            data["yaxis.range[1]"]
        ];
        if (y.range[0] !== yRange[0] || y.range[1] !== yRange[1]) {
            const update = {
                "yaxis.range[0]": yRange[0],
                "yaxis.range[1]": yRange[1]
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($0ae81143a7e218db$exports))).relayout(div, update);
        }
    });
}



/**
 * @author Iker Hurtado
 *
 * @overview Form is a UI component that intends to make easy the setup
 * of fully-featured forms in the application
 */ 
/**
 * @author Andrey Sobolev
 * @year 2022
 *
 * @overview A file containing classes for all the form elements: Radio, Input, noInput and Select
 */ /**
 * @author Iker Hurtado
 *
 * @fileoverview File holding the Tooltip UI component
 */ 
class $63ecf2f4b2cde17e$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("div", ".Tooltip");
    }
    /**
   * Sets the relative position regarding the HTML element
   * @param {string} pos Values: left or right
   * @param {int} offset Distance from the element side
   */ setRelPosition(pos, offset) {
        this.pos = pos;
        this.offset = offset;
    }
    /**
   * Sets the HTML element reference for the tooltip
   * @param {HTMLElement} target
   */ setTargetElement(target) {
        target.addEventListener("mouseover", (e)=>{
            this.setHTML(`<div>${target.getAttribute("data-explanation")}</div>`);
            target.appendChild(this.e);
            // Once the tooltip is inserted in the target element
            this.setLeftTop(target);
        });
        target.addEventListener("mouseout", (e)=>{
            target.removeChild(this.e);
        });
    }
    /**
   * Sets effectively the position of the tooltip
   * @param {HTMLElement} target
   */ setLeftTop(target) {
        // the coordinates are absolute to the wrapper div parent
        const getTop = (el)=>el.offsetTop + (el.offsetParent && getTop(el.offsetParent));
        const getLeft = (el)=>el.offsetLeft + (el.offsetParent && getLeft(el.offsetParent));
        let top = getTop(target) + target.clientHeight / 2 - this.e.clientHeight / 2;
        if (this.pos === "left") {
            this.e.style.left = -(getLeft(target) + this.offset) + "px";
            this.e.style.top = top + "px";
        } else if (this.pos === "right") {
            this.e.style.left = getLeft(target) + target.clientWidth + this.offset + "px";
            this.e.style.top = top + "px";
        }
    }
}
// Creates the application modal popup
/**
 * Tooltip application instance (singleton)
 */ const $63ecf2f4b2cde17e$var$tooltip = new $63ecf2f4b2cde17e$export$2e2bcd8739ae039();
function $63ecf2f4b2cde17e$export$98e7b0896a5387fa(target) {
    $63ecf2f4b2cde17e$var$tooltip.setTargetElement(target);
}
function $63ecf2f4b2cde17e$export$91006f7f52398ef9(pos, offset) {
    $63ecf2f4b2cde17e$var$tooltip.setRelPosition(pos, offset);
}



class $5990f42f57bd63bd$var$FormElement {
    /**
   * An abstract class for form elements
   * @param component {(UIComponent | HTMLElement)} A wrapper or form
   * @param name {string} an HTML name for the element
   * @param text {string} a label text
   * @param required {boolean} is the field required to run the code? If yes and not given, mark the field
   * @param explicitInclusion {boolean} is the field needed to be explicitly included in the input?
   * @param explanation {string} a tooltip for the field label
   * Shows checkbox if yes
   */ constructor(component, name, text = "", required = false, explicitInclusion = false, explanation = ""){
        this.name = name;
        this.labelText = text;
        this.required = required;
        this.explicitInclusion = explicitInclusion;
        this.hidden = false;
        this.constraint = undefined;
        this.num = 1; // a number of HTML input elements
        this.HTMLFields = []; // an array of HTML input elements
        if (component instanceof HTMLElement) // we're given a div wrapper
        this.wrapper = component;
        else {
            // we're given a Form itself, let's build a wrapper
            this.wrapper = component.addElement("div");
            this.wrapper.className = `${name}-form-field`;
            let checkboxHTML = '<div class="explicit-inclusion-box"></div>';
            if (explicitInclusion) checkboxHTML = `<div class="explicit-inclusion-box"><input type="checkbox" name="${name}-box"` + ` class="${name}-explicitInclusion" ondblclick="this.checked=false;"></div>`;
            this.wrapper.innerHTML = checkboxHTML + " <label>" + this.labelText + `</label><div class="value-box"></div>` + `<div class="units-box"></div>`;
        }
        this.checkbox = this.wrapper.querySelector(".explicit-inclusion-box input");
        // try to add a tooltip
        if (explanation) {
            this.wrapper.setAttribute("data-explanation", explanation);
            $63ecf2f4b2cde17e$export$98e7b0896a5387fa(this.wrapper);
        }
    }
    /**
   * Checks if the form element is included to the input file
   * @returns {boolean}
   */ isExplicitlyIncluded() {
        let included = false;
        if (this.explicitInclusion) included = this.checkbox.checked;
        return included;
    }
    /**
   * Checks if the form element is visible in the form
   * @returns {boolean}
   */ isVisible() {
        return !this.hidden;
    // return !!( this.labelElement.offsetWidth || this.labelElement.offsetHeight ||
    //   this.labelElement.getClientRects().length );
    }
    /**
   * Checks if the form element is required to build control.in
   * @returns {boolean}
   */ isRequired() {
        return this.isVisible() && this.required;
    }
    hide() {
        this.wrapper.style.display = "none";
        this.hidden = true;
    }
    show() {
        this.wrapper.style.display = "flex";
        this.hidden = false;
    }
    validate() {
        let isValid = true;
        if (this.isRequired() || this.isExplicitlyIncluded()) for(let i = 0; i < this.num; i++)if (this.HTMLFields[i].value === "") {
            $5990f42f57bd63bd$var$markField(this.HTMLFields[i]);
            isValid = false;
        } else $5990f42f57bd63bd$var$unmarkField(this.HTMLFields[i]);
        return isValid;
    }
    /**
   * Sets a constraint to the element; entangles its visibility with masters' values
   * @param constraint {Constraint}
   */ setConstraint(constraint) {
        this.constraint = constraint;
        // this.constraint.masters.forEach(f => console.log(f.HTMLFields[0].setEventListener))
        if (this.constraint.condition !== "included") // trigger on value change
        this.constraint.masters.forEach((f)=>f.HTMLFields.forEach((el)=>{
                el.addEventListener("change", (_)=>trigger(this, constraint));
            }));
        else // trigger on explicit inclusion
        this.constraint.left.checkbox.addEventListener("change", (_)=>trigger(this, constraint));
        // triggers field event or include event based on constraint
        this.constraint.trigger(this.constraint.condition === "included");
        function trigger(instance, constraint) {
            if (constraint.evaluate()) instance.show();
            else instance.hide();
        }
    }
    /**
   * Dispatches event from the element of HTMLField
   * @param e {Event}
   */ dispatchEvent(e) {
        this.HTMLFields.forEach((el)=>el.dispatchEvent(e));
    }
    /**
   * Dispatches event from the explicit inclusion checkbox
   * @param e {Event}
   */ dispatchIncludeEvent(e) {
        if (this.explicitInclusion) this.checkbox.dispatchEvent(e);
    }
}
class $5990f42f57bd63bd$export$60605fd4959c6555 extends $5990f42f57bd63bd$var$FormElement {
    /**
   * A constructor for a field with no inputs
   * @param wrapper {(UIComponent | HTMLElement)}
   * @param name {string} a name for the radio
   * @param text {string} a label text
   * @param required {boolean} is the field required to run the code? If yes and not given, mark the field
   * @param explicitInclusion {boolean} is the field needed to be explicitly included in the input?
   * @param explanation {string} a tooltip for the field label
   * Shows checkbox if yes
   */ constructor(wrapper, name, text, required, explicitInclusion, explanation = ""){
        super(wrapper, name, text, required, explicitInclusion, explanation);
    }
    validate() {
        return true;
    }
    getValue() {
        return "";
    }
}
class $5990f42f57bd63bd$export$4aaf0c609b3e241e {
    /**
   * A RadioField constructor
   * @param component {UIComponent} the div wrapper for the radios
   * @param name {string} a name for the radio
   * @param value {Object} a map with other form elements
   * @param required {boolean} is the field required to run the code? If yes and not given, mark the field
   */ #name;
    constructor(component, name, value, required){
        this.component = component;
        this.#name = name;
        this.required = required;
        this.hidden = false;
        this.fields = [];
        this.constraint = undefined;
        for (const [k, v] of Object.entries(value)){
            const wrapper = this.component.addElement("div");
            const field_name = v["flag"] ? v["flag"] : k;
            wrapper.className = `${field_name}-form-field`;
            wrapper.innerHTML = `<div class="radio-chooser"><input type="radio" name="${name}" value="${k}"></div><label>` + v["text"] + `</label><div class="value-box"></div><div class="units-box"></div>`;
            const field = new $5990f42f57bd63bd$export$dd2171e2b7d3bc5b(wrapper, field_name, v["text"], v["inputType"], v["dataType"], 1, this.required, false, v["units"], v["explanation"], {
                "radio_value": k
            });
            this.fields.push(field);
        }
        // disable currently non-selected inputs
        this.radios = this.component.getElements(`[name=${name}]`);
        this.radios.forEach((f)=>f.addEventListener("change", radioCheckHandler));
        // check the first element in the radio by default
        let instance = this;
        this.radios[0].setAttribute("checked", "true");
        let event = new Event("change");
        this.radios[0].dispatchEvent(event);
        function radioCheckHandler(e) {
            instance.fields.forEach((f)=>f.HTMLFields.forEach((s)=>s.disabled = e.target.value !== f.extras["radio_value"]));
        }
    }
    isVisible() {
        return !this.hidden;
    }
    isRequired() {
        return this.isVisible() && this.required;
    }
    show() {
        this.fields.forEach((f)=>f.show());
        this.hidden = false;
    }
    hide() {
        this.fields.forEach((f)=>f.hide());
        this.hidden = true;
    }
    isExplicitlyIncluded() {
        return false;
    }
    /**
   * Returns a checked field
   * @returns {FormElement}
   */ checkedField() {
        const checkedValue = this.component.getElement(`input[name=${this.#name}]:checked`)["value"];
        for (const field of this.fields){
            if (field.extras["radio_value"] === checkedValue) return field;
        }
    }
    get name() {
        const field = this.checkedField();
        return field.name;
    }
    getValue() {
        const field = this.checkedField();
        if (field instanceof $5990f42f57bd63bd$var$FormElement) return field.getValue();
    }
    validate() {
        return this.checkedField().validate();
    }
}
class $5990f42f57bd63bd$export$dd2171e2b7d3bc5b extends $5990f42f57bd63bd$var$FormElement {
    /**
   * An InputField constructor
   * @param wrapper {(UIComponent | HTMLElement)}
   * @param name {string}
   * @param text {string}
   * @param type {string} a type of input control (contains the information on the quantity of subfields and their names)
   * @param datatype {(string|Array<string>)} a data type from the input (for the validator)
   * @param group
   * @param required {boolean} is the field required to run the code? If yes and not given, mark the field
   * @param explicitInclusion {boolean} is the field needed to be explicitly included in the input?
   * Shows checkbox if yes
   * @param units {string|Array<string>} a units name to go after the input box
   * @param explanation {string} a tooltip for the field label
   * @param extras {Object} extra parameters to the field
   */ constructor(wrapper, name, text, type, datatype, group = 0, required = false, explicitInclusion = false, units = "", explanation = "", extras = {}){
        super(wrapper, name, text, required, explicitInclusion, explanation);
        // Check if the field is multiple (num > 1), it is composed by several input field
        if (datatype instanceof Array) this.datatypes = datatype;
        else this.datatypes = [
            datatype
        ];
        this.extras = extras;
        this.HTMLFieldNames = [];
        this.type = type;
        if (type.includes(":")) {
            let a = type.split(":");
            this.type = a[0];
            this.num = parseInt(a[1]);
            if (a.length === 3) this.HTMLFieldNames = a[2].split(",");
        }
        if (this.HTMLFieldNames.length === 0) this.#createUnnamedFields(units);
        else this.#createNamedFields(units);
        // add validators to fields
        for(let i = 0; i < this.num; i++)switch(this.datatypes[i]){
            case "integer":
                this.HTMLFields[i].addEventListener("input", (0, $4aa0937dc0e8c453$export$68e9a3393520dd2e));
                this.HTMLFields[i].addEventListener("blur", (0, $4aa0937dc0e8c453$export$7800b12359c7379e));
                break;
            case "float":
                this.HTMLFields[i].addEventListener("input", (0, $4aa0937dc0e8c453$export$f047cd856756950a));
                this.HTMLFields[i].addEventListener("blur", (0, $4aa0937dc0e8c453$export$3a461cfe4e90e4ad));
                break;
            case "default":
                break;
        }
    }
    /**
   * A helper function creating a number of unnamed fields in one row
   * @param units {string} a string representing field units
   */ #createUnnamedFields(units) {
        for(let i = 0; i < this.num; i++){
            // field without subfields
            let field = document.createElement("input");
            field.type = "text";
            field.style.width = 100 / this.num + "%";
            const valueInputBox = this.wrapper.querySelector(".value-box");
            valueInputBox.appendChild(field);
            this.HTMLFields.push(field);
        }
        const unitsBox = this.wrapper.querySelector(".units-box");
        unitsBox.innerHTML = units;
    }
    /**
   * A helper function creating a number of unnamed fields in one row
   * @param units {Array<string>} an array of strings representing field units
   */ #createNamedFields(units) {
        const valueInputBox = this.wrapper.querySelector(".value-box");
        const unitsBox = this.wrapper.querySelector(".units-box");
        for(let i = 0; i < this.num; i++){
            // field with named subfields
            let field = document.createElement("input");
            field.type = "text";
            let subfieldsBox = document.createElement("div");
            subfieldsBox.className = "named-subfield";
            let label = document.createElement("span");
            label.innerHTML = this.HTMLFieldNames[i];
            subfieldsBox.appendChild(label);
            subfieldsBox.appendChild(field);
            valueInputBox.appendChild(subfieldsBox);
            let subfieldsUnitsBox = document.createElement("div");
            subfieldsUnitsBox.className = "named-subfield-units";
            let unitText = document.createElement("div");
            unitText.innerHTML = units ? units[i] : "";
            subfieldsUnitsBox.appendChild(unitText);
            unitsBox.appendChild(subfieldsUnitsBox);
            this.HTMLFields.push(field);
        }
    }
    /**
   * Returns value/values of the field
   * @returns {*[]|*}
   */ getValue() {
        const parsers = {
            "integer": parseInt,
            "float": parseFloat,
            "string": (v)=>v
        };
        let value = [];
        for(let i = 0; i < this.num; i++)value.push(parsers[this.datatypes[i]](this.HTMLFields[i].value));
        return this.num === 1 ? value[0] : value;
    }
    setValue(value) {
        if (!(value instanceof Array)) value = [
            value
        ];
        if (value.length !== this.num) throw `Cannot set value to ${this.name}`;
        for(let i = 0; i < this.num; i++)this.HTMLFields[i].value = value[i];
    }
}
class $5990f42f57bd63bd$export$d55b50a564d0b931 extends $5990f42f57bd63bd$var$FormElement {
    /**
   * A SelectField constructor
   * @param wrapper {(UIComponent | HTMLElement)}
   * @param name {string}
   * @param text {string}
   * @param type {string} a type of input control (contains the information on the quantity of subfields and their names)
   * @param value {array<string>} An array of values for the select control
   * @param datatype {(string|Array<string>)} a data type from the input (for the validator)
   * @param group
   * @param required {boolean} is the field required to run the code? If yes and not given, mark the field
   * @param explicitInclusion {boolean} is the field needed to be explicitly included in the input?
   * Shows checkbox if yes
   * @param units {string} a units name to go after the input box
   * @param explanation {string} a tooltip for the field label
   * @param extras {Object} extra parameters to the field
   */ constructor(wrapper, name, text, type, value, datatype, group = 0, required = false, explicitInclusion = false, units = "", explanation = "", extras = {}){
        super(wrapper, name, text, required, explicitInclusion, explanation);
        let field = document.createElement("select");
        value.forEach((v)=>{
            let option = document.createElement("option");
            if (v.includes(":")) {
                option.text = v.split(":")[0];
                option.value = v.split(":").slice(1).join(":");
            } else option.text = v;
            field.add(option);
        });
        const valueInputBox = this.wrapper.querySelector(".value-box");
        valueInputBox.appendChild(field);
        this.HTMLFields.push(field);
    }
    getValue() {
        const value = this.HTMLFields[0].value;
        if (value[0] !== "{") return value;
        else return JSON.parse(value);
    }
}
class $5990f42f57bd63bd$export$b322c47b2525bd34 extends $5990f42f57bd63bd$var$FormElement {
    constructor(wrapper, name, text, values, group = 0, required = false, explicitInclusion = false, explanation = ""){
        super(wrapper, name, text, required, explicitInclusion, explanation);
        let field = document.createElement("input");
        field.type = "range";
        field.style.width = "100%";
        const [minValue, maxValue, value] = values;
        field.min = minValue;
        field.max = maxValue;
        field.step = "any";
        field.value = value;
        const valueInputBox = this.wrapper.querySelector(".value-box");
        valueInputBox.appendChild(field);
        this.HTMLFields.push(field);
    }
    setValue(value) {
        this.HTMLFields[0].value = value[2];
    }
}
class $5990f42f57bd63bd$export$b865d4358897bb17 extends $5990f42f57bd63bd$var$FormElement {
    constructor(wrapper, name, text, value, group = 0, required = false, explicitInclusion = false, explanation = ""){
        super(wrapper, name, text, required, explicitInclusion, explanation);
        let field = document.createElement("input");
        field.type = "color";
        field.style.width = "100%";
        field.value = value;
        const valueInputBox = this.wrapper.querySelector(".value-box");
        valueInputBox.appendChild(field);
        this.HTMLFields.push(field);
    }
    getValue() {
        return this.HTMLFields[0].value;
    }
    setValue(value) {
        this.HTMLFields[0].value = value;
    }
}
// utility functions
/**
 * Marks a required field
 * @param field {HTMLElement}
 */ function $5990f42f57bd63bd$var$markField(field) {
    field.classList.add("markedField");
}
/**
 * Unmarks a required field
 * @param field {HTMLElement}
 */ function $5990f42f57bd63bd$var$unmarkField(field) {
    field.classList.remove("markedField");
}


class $a68e8293ba5aab8f$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param {string} className - Specific class name for the form instance
   */ constructor(className){
        //
        super("div", ".Form " + className);
        this.setHTML(`<div class="user-msg"><div>`);
        this.addElement("div", `<div class="info    "><div>`);
        this.parent = undefined;
        this.idx = undefined;
        this.fieldMap = new Map();
        this.initValues = new Map();
        this.validationInfo = new Map();
        this.explicitInclusionInfo = new Map();
        this.datatype = new Map();
        this.info = this.getElement(".info");
        // User message area. It can be used from outside and disabled
        // The fields validation messages are shown here
        this.userMsg = this.getElement(".user-msg");
    }
    /**
   * It returns the html input of the named field.
   * This could be an array of inputs for multi-fields
   * @param {string} name - Field name (identifier)
   * @return {HTMLElement} Html input of the named field
   */ getField(name) {
        return this.fieldMap.get(name);
    }
    /**
   * It returns the html element containing the input field(s)
   * @param {string} name - Field name (identifier)
   * @return {HTMLElement} Html element containing the field(s)
   */ getFieldBox(name) {
        let field = this.fieldMap.get(name);
        if (field) {
            // it could be undefined, no value field
            if (Array.isArray(field)) return this.fieldMap.get(name)[0].parentElement;
            else return this.fieldMap.get(name).parentElement;
        }
    }
    /**
   * It returns the number of fields
   * @return {int} Number of fields
   */ getFieldNum() {
        return this.fieldMap.size;
    }
    /**
   * It adds a new section to the form.
   * The form can be divided in sections holding the fields
   * @param {string} name - Field name (identifier)
   * @return {HTMLElement} The section element
   */ addSection(name) {
        let section = this.addElement("div");
        section.className = "section-title";
        section.innerHTML = name;
        return section;
    }
    addInfo(text) {
        this.info.innerHTML = text;
    }
    /**
   * It adds a new field to the form.
   *
   * @param {string} name - Field name (identifier)
   * @param {string} text - Field name shown to the user
   * @param {string} inputType - String that determines the type (input-text,
   * input-range, select, etc.) and the number of sub-fields (multi-field)
   * @param {(string | Array<string> | number | array<number>)} value - Default value for the field
   * @param dataType {(string | Array<string>)} data type for input / data types for sub-inputs. used for validating
   * @param group {int}
   * @param {boolean} required - If the value is mandatory or not
   * @param {boolean} explicitInclusion - If the field has to be explicitly
   * indicated (by a checkbox on the left) to be included as a regular field
   * @param units {(string|Array<string>)} units string(s) to be added to the fields
   * @param explanation {string} a tooltip for the field label
   * @return {FormElement}
   * The new field or set of fields added
   */ addField(name, text, inputType, value, dataType, group = 0, required = false, explicitInclusion = false, units = "", explanation = "") {
        if (value) this.initValues.set(name, value);
        else value = "";
        // console.log(name)
        this.validationInfo.set(name, required);
        this.explicitInclusionInfo.set(name, explicitInclusion);
        this.datatype.set(name, dataType);
        const controlType = inputType.split(":")[0];
        switch(controlType){
            case "radio":
                this.fieldMap.set(name, new (0, $5990f42f57bd63bd$export$4aaf0c609b3e241e)(this, name, value, required));
                break;
            case "input-text":
                this.fieldMap.set(name, new (0, $5990f42f57bd63bd$export$dd2171e2b7d3bc5b)(this, name, text, inputType, dataType, group, required, explicitInclusion, units, explanation));
                // sets value if given
                if (value) this.fieldMap.get(name).setValue(value);
                break;
            case "no-input":
                this.fieldMap.set(name, new (0, $5990f42f57bd63bd$export$60605fd4959c6555)(this, name, text, required, explicitInclusion, explanation));
                break;
            case "select":
                this.fieldMap.set(name, new (0, $5990f42f57bd63bd$export$d55b50a564d0b931)(this, name, text, inputType, value, dataType, group, required, explicitInclusion, units, explanation));
                break;
            case "input-range":
                this.fieldMap.set(name, new (0, $5990f42f57bd63bd$export$b322c47b2525bd34)(this, name, text, value, group, required, explicitInclusion, units, explanation));
                break;
            case "input-color":
                this.fieldMap.set(name, new (0, $5990f42f57bd63bd$export$b865d4358897bb17)(this, name, text, value, group, required, explicitInclusion, units, explanation));
        }
        return this.fieldMap.get(name);
    }
    /**
   * It adds a button to the form (not included by default, it can be controlled
   * from outside)
   * @param {string} label - Button label
   * @return {HTMLElement} The new button
   */ addButton(label) {
        let div = document.createElement("div");
        div.className = "Form-button-box";
        this.button = document.createElement("button");
        this.button.innerHTML = label;
        div.appendChild(this.button);
        this.e.appendChild(div);
        return this.button;
    }
    /**
   * It validates that the required fields are filled
   * @return {boolean} If the validation was good or not
   */ validate() {
        let isValid = true;
        for (const field of this.fieldMap.values())isValid = field.validate() && isValid;
        if (!isValid) this.userMsg.innerHTML = "There are some fields required to generate the control.in file not filled";
        else this.userMsg.innerHTML = "";
        return isValid;
    }
    /**
   * It marks or unmarks a field normally in the validation process
   * @param {string} fieldName - Field name (identifier)
   * @param {int} i - Subfield index in the field set
   * @param {boolean} unmark - If the operation is the opposite: unmark the
   * field instead of marking it
   */ markField(fieldName, i, unmark = false) {
        let field = i !== undefined ? this.fieldMap.get(fieldName)[i] : this.fieldMap.get(fieldName);
        //log('markField',fieldName, field)
        if (unmark) field.classList.remove("markedField");
        else field.classList.add("markedField");
    }
    setConstraint(condition) {
        // if (condition && this.parent) {
        //   this.parent.showSection(this.idx)
        //   for (const field of this.fieldMap.values()) {
        //     field.show()
        //     if (field.constraint) field.constraint.trigger(true)
        // }}
        // else {
        if (!(condition && this.parent)) {
            // everything is shown by default;
            // hide the section if the constraint condition is not met
            for (const field of this.fieldMap.values())field.hide();
            this.parent.hideSection(this.idx);
        }
    }
    /**
   * It sets a user message
   * @param {string} msg - Message for the user
   */ setUserMsg(msg) {
        this.userMsg.innerHTML = msg;
    }
    /**
   * It disables the user message area. Enabled by default
   */ disableUserMsg() {
        this.userMsg.style.display = "none";
    }
    /**
   * Returns an object with the pairs: field name-value
   * @return {object} Object containing the fields name-value pairs
   */ getFieldsNameValue() {
        let result = {};
        this.fieldMap.forEach((field)=>{
            if (field.isRequired() || field.isExplicitlyIncluded()) {
                let value = field.getValue();
                if (value instanceof Object && !Array.isArray(value)) Object.assign(result, value);
                else result[field.name] = value;
            }
        });
        return result;
    }
    /**
   * It resets the fields values to their initial values
   */ resetFieldsValues() {
        this.fieldMap.forEach((field, name)=>field.setValue(this.initValues.get(name)));
    }
}


const $1c4abff4029f667e$var$DEFAULT_LABELS_FONT_MULTIPLIER = 1.;
const $1c4abff4029f667e$var$DEFAULT_COLOR = "#000000";
class $1c4abff4029f667e$export$1ff0c23d1088691a extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /** A dashboard with one or several graphs and graph controls
   *
   * @param parent {HTMLElement}
   * @param uiClass {string} a class for Dashboard element
   */ constructor(parent, uiClass = ".plotly-dashboard"){
        super("div", uiClass);
        this.parentElement = parent;
        this.parentElement.appendChild(this.e);
        this.graphs = {};
        this.form = undefined;
    }
    /**
  * Creates and attaches the graph canvas inside an HTML layout element.
  * Sets the width and height of the canvas, and optionally the
  * canvas resolution can be doubled
  * @param  {string} label
  * @param  {int} width
  * @param  {int} height
  * @param layout {object}
  */ attach(label, width, height, layout = {}) {
        // search in DOM, if not found, then create and append to parent
        if (![
            ".",
            "#"
        ].includes(label[0])) label = "." + label;
        if (this.getElement(label) === undefined) {
            const node = new (0, $175b311ee190559c$export$2e2bcd8739ae039)("div", label);
            this.parentElement.appendChild(node.e);
        }
        const el = this.getElement(label);
        width = width !== undefined ? width : el.clientWidth;
        height = height !== undefined ? height : el.clientHeight;
        //  strip # or . from label
        this.graphs[label.slice(1)] = new (0, $405f46edf3c84493$export$5512561d86ae4f70)(el, width, height, layout);
    }
    createForm(label) {
        this.form = new (0, $a68e8293ba5aab8f$export$2e2bcd8739ae039)(label);
        this.form.disableUserMsg();
        this.form.addSection("Labels style");
        //
        let field = this.form.addField("axesLabelsSize", "Axes label size", "input-range", [
            0.8,
            2.2,
            $1c4abff4029f667e$var$DEFAULT_LABELS_FONT_MULTIPLIER
        ], "float");
        field.HTMLFields[0].addEventListener("input", (e)=>{
            // change
            const multiplier = parseFloat(e.target.value);
            this.changeLabelsStyle(multiplier, undefined);
        });
        this.labelColorField = this.form.addField("labelsColor", "Axes label color", "input-color", $1c4abff4029f667e$var$DEFAULT_COLOR, "color");
        this.labelColorField.HTMLFields[0].addEventListener("input", (e)=>{
            this.changeLabelsStyle(undefined, e.target.value);
        });
    }
    /** Couple the axis of two graphs given by labels
   *
   * @param first {string} 1st graph label
   * @param second {string} 2nd graph label
   * @param axis {string} the name of the axis
   */ _couple(first, second, axis = "y") {
        if (axis !== "x" && axis !== "y") throw "Axis parameter has to be either `x` or `y`";
        if (!(first in this.graphs || second in this.graphs)) throw `Found no graph with labels ${first} or ${second}`;
        const divs = [
            this.graphs[first].parentElement,
            this.graphs[second].parentElement
        ];
        (0, $405f46edf3c84493$export$79a4e539e3d844f0)(divs);
        divs.forEach((div)=>div.on("plotly_relayout", (data)=>(0, $405f46edf3c84493$export$79a4e539e3d844f0)(divs, data)));
    }
    /** Sets data trace to the given graph; adds metadata to build controls
   *
   * @param data {[[]]} a data object
   * @param layout {object} a layout object
   * @param graphLabel {string} graph label
   */ setData(data, layout, graphLabel) {
        // sanity check
        if (!(graphLabel in this.graphs)) return;
        // actual addition of data
        this.graphs[graphLabel].setLineData(data, "");
    }
    /**
   * Changes the axes labels and the title styles
   * @param  {number} sizeMult Font size multiplier
   * @param  {string} color Color code
  */ changeLabelsStyle(sizeMult, color) {
        for(const graph in this.graphs)this.graphs[graph].changeLabelsStyle(sizeMult, color);
    }
}


/**
 * @author Iker Hurtado, Andrey Sobolev
 *
 * @fileOverview File holding the DOSPlotter graph
 */ 

/**
 * @author Andrey Sobolev
 *
 * @fileOverview File holding the abstract class for Plotters
 */ class $40af6a9ade829703$export$2dcdd97d9ccbe1a7 {
    /** Abstract plotter class
   *
   * @param {InteractiveGraph} graph
   * @param  {Map<string, array>|object|array} data Object with DOS files data
   */ constructor(graph, data){
        this.graph = graph;
        this.data = data;
        this.formControls = {};
    }
    /** Updates control form
   * @param form {Form}
   * @param sectionName {string}
   * @param sectionClass {string}
   */ updateForm(form, sectionName, sectionClass) {
        let sectionBox = form.addSection(sectionName);
        sectionBox.classList.add(sectionClass);
        for (const group of this.graph.lineGroups()){
            let thicknessField = form.addField("linesThickness", "Thickness " + group, "input-range", [
                0.8,
                4,
                this.graph.getThickness(group)
            ], "float");
            thicknessField.wrapper.classList.add("bsDiv");
            thicknessField.HTMLFields[0].addEventListener("input", (e)=>{
                const multiplier = parseFloat(e.target.value);
                this.graph.changeDataLinesStyle(group, multiplier, undefined);
            });
            let colorField = form.addField("linesColor", "Color " + group, "input-color", this.graph.getColor(group), "string");
            colorField.wrapper.classList.add("bsDiv");
            colorField.HTMLFields[0].addEventListener("input", (e)=>{
                this.graph.changeDataLinesStyle(group, undefined, e.target.value);
            });
            this.formControls[group] = [
                thicknessField,
                colorField
            ];
        }
    }
}



const $2f0cabd1cd29e6d1$var$X_AXIS_LABEL = "DOS (states/eV/cell)";
const $2f0cabd1cd29e6d1$var$Y_AXIS_LABEL = "Energy (eV)";
class $2f0cabd1cd29e6d1$export$667b2089ba1c9583 extends (0, $40af6a9ade829703$export$2dcdd97d9ccbe1a7) {
    /** Parses and plots dos files
  * @param {InteractiveGraph} graph
  * @param  {Map<string, array>} dosFiles Object with DOS files data
   * @param {boolean} isMolecule a flag for molecular DOS
   * @param {boolean} hasSpin a flag for spin-collinear calculation
   * @param  {string} eAxis A flag denoting energy axis (`x` or `y`)
   */ constructor(graph, dosFiles, isMolecule, hasSpin, eAxis = "y"){
        if (![
            "x",
            "y"
        ].includes(eAxis)) throw Error("Energy axis should be x or y");
        super(graph, dosFiles);
        this.graph.NUMBER_OF_POINTS_IN_SEGMENT = 0;
        this.broadening = 0.2;
        this.isMolecule = isMolecule;
        this.hasSpin = hasSpin;
        if (this.isMolecule) for (const name of dosFiles.keys()){
            let mDOS = $2f0cabd1cd29e6d1$var$getMolDos(dosFiles, this.broadening, name);
            this.data.set(name, mDOS);
        }
        this.config = new Map();
        let count = 0;
        for (const name of dosFiles.keys()){
            count++;
            this.config.set(name, {
                "color": (0, $e64b414b86723191$export$e2a301f55f143803).ELEMENT_COLORS[count + 1],
                "selected": true
            });
        }
    }
    /** Updates control form
    * @param form {Form}
    * @param sectionName {string}
    * @param sectionClass {string}
    */ updateForm(form, sectionName, sectionClass) {
        super.updateForm(form, sectionName, sectionClass);
        if (this.isMolecule) {
            form.addSection("Broadening");
            let broadenField = form.addField("broadening", "Broadening", "input-text", 0.2, "float", 0, true, false, "eV");
            broadenField.HTMLFields[0].addEventListener("change", (e)=>{
                this.broadening = e.target.value;
            // let mDOS = getMolDos(this.data, newBroadening, molDosName)
            // this.data.set(molDosName,mDOS)
            // this.dosFilesConfig.set(molDosName, {'color':'#000000','selected': true})
            // this.dosPlotter.setData(this.data, ENERGY_AXIS_MIN, ENERGY_AXIS_MAX, this.dosFilesConfig)
            });
        }
    }
    /**
    * Finds the DOS data to be plotted.
    * Also, the top and bottom X values can be passed
    * @param {number} eAxisMin
    * @param {number} eAxisMax
    */ plotData(eAxisMin = -6, eAxisMax = 12) {
        let maxDosVal = -100000000;
        let minEnergyVal = eAxisMin;
        let maxEnergyVal = eAxisMax;
        // FIXME: change of eAxis is not yet implemented
        this.data.forEach((data, name)=>{
            let energy = data.map((el)=>el[0]);
            let dosUp = data.map((el)=>el[1]);
            let dosDown = this.hasSpin ? data.map((el)=>-el[2]) : [];
            maxDosVal = Math.max(maxDosVal, ...dosUp, ...dosDown);
            maxEnergyVal = Math.min(maxEnergyVal, Math.max(...energy));
            minEnergyVal = Math.max(minEnergyVal, Math.min(...energy));
            let groupName = this.hasSpin ? name + "_Up" : name;
            this.graph.addLineGroup(groupName, {
                defaultColor: this.config.get(name).color
            });
            this.graph.setLineData([
                dosUp,
                energy
            ], groupName); //, lineWidth: 2})//[{x:1,y:1}, {x:5, y:5}])//
            if (this.hasSpin) {
                this.graph.addLineGroup(name + "_Down", {
                    defaultColor: this.config.get(name).color
                });
                this.graph.setLineData([
                    dosDown,
                    energy
                ], name + "_Down");
            }
        });
        const minDosVal = this.hasSpin ? -1 * maxDosVal : 0;
        this.graph.setAxisLabelsAndRange($2f0cabd1cd29e6d1$var$X_AXIS_LABEL, $2f0cabd1cd29e6d1$var$Y_AXIS_LABEL, true, minDosVal, maxDosVal, eAxisMin, eAxisMax, minEnergyVal, maxEnergyVal);
        this.graph.draw();
    }
    onDosButtonClick() {
        let dosNames = Array.from(this.data.keys());
        let content = ``;
        for(let k = 0; k < dosNames.length; k++){
            // For every segment
            let dosName = dosNames[k];
            let checked = this.config.get(dosName).selected ? "checked" : "";
            content += `<input type="checkbox" id="${dosName}" name="dosChoice" value="${dosName}" ${checked}>${dosName}<br>`;
        }
        $9d993874406c4873$export$b964053cbf2907a2(content);
        let chooseSegment = document.createElement("button");
        chooseSegment.innerHTML = "Apply";
        // chooseSegment.addEventListener('click', _ => {
        // 	let cb = document.querySelectorAll(`input[name="dosChoice"]:checked`)
        // 	let newDosFiles = new Map()
        // 	this.config.forEach( (value, key) => {
        // 		value.selected = false
        // 		for (const control of this.formControls[key])
        // 			control.hide()
        // 	})
        // 	cb.forEach((checkbox) => {
        // 		this.config.get(checkbox.value).selected = true
        // 		for (const control of this.formControls[checkbox.value])
        // 			control.show()
        // 	 	newDosFiles.set(checkbox.value, this.data.get(checkbox.value))
        // 	})
        // 	let newDosData = this.data.get(cb[0].value)
        // 	this.setData(ENERGY_AXIS_MIN, ENERGY_AXIS_MAX)
        // })
        $9d993874406c4873$export$a778490beb6e83b8(chooseSegment, true);
        $9d993874406c4873$export$d7e8d4d4450c819c(true);
    }
}
/** Returns molecular DOS (a set of broadened eigenvalues). Original author: Hagen-Henrik Kowalski
 *
 * @param dosFiles
 * @param broadening
 * @param molDosName
 * @returns {*[]}
 */ function $2f0cabd1cd29e6d1$var$getMolDos(dosFiles, broadening, molDosName) {
    //const LINES_THICKNESS = {groups: ['spin1', 'spin2', 'soc'], thicknessMult: DEFAULT_LINES_THICKNESS_MULTIPLIER}
    let start = -100, stop = 50;
    let steps = 3001;
    let hasSpin = false;
    let molDosData = dosFiles.get(molDosName);
    if (molDosName.endsWith(".spin")) hasSpin = true;
    let molDosDataLength = molDosData.length / 2;
    let finalDos = [];
    let step = (stop - start) / (steps - 1);
    for(let i = 0; i < steps; i++)if (hasSpin) finalDos.push([
        start + step * i,
        0,
        0
    ]);
    else finalDos.push([
        start + step * i,
        0
    ]);
    if (!hasSpin) molDosData.forEach((mDD)=>{
        finalDos.forEach((xy)=>{
            if (mDD[2] > start - 5 * broadening) xy[1] += (0, $ab6e98e8f37dab02$export$770bce1690f63f17)(broadening, xy[0], mDD[2]);
        });
    });
    else molDosData.forEach((mDD, counter)=>{
        if (counter < molDosDataLength) finalDos.forEach((xy)=>{
            if (mDD[2] > start - 5 * broadening) xy[1] += (0, $ab6e98e8f37dab02$export$770bce1690f63f17)(broadening, xy[0], mDD[2]);
        });
        else finalDos.forEach((xy)=>{
            if (mDD[2] > start - 5 * broadening) xy[2] += (0, $ab6e98e8f37dab02$export$770bce1690f63f17)(broadening, xy[0], mDD[2]);
        });
    });
    //console.log("it's the final dos")
    //console.log(finalDos)
    return finalDos;
}


/**
 * @author Iker Hurtado, Andrey Sobolev
 *
 * @fileOverview File holding the BSPlotter graph
 */ 

const $04eb082e7fe3bf1a$var$X_AXIS_LABEL = "Band path";
const $04eb082e7fe3bf1a$var$Y_AXIS_LABEL = "Energy (eV)";
const $04eb082e7fe3bf1a$var$SPIN_DEFAULT_COLOR = [
    "#f26430",
    "#009ddc",
    "#30f243"
];
class $04eb082e7fe3bf1a$export$2e2bcd8739ae039 extends (0, $40af6a9ade829703$export$2dcdd97d9ccbe1a7) {
    /**
   * @param {InteractiveGraph} graph
   * @param {array} bsData Band structure data
   * @param {boolean} hasSpin A flag for spin polarization
   * @param {boolean} hasSOC A flag for spin-orbit coupling
   */ constructor(graph, bsData, hasSpin, hasSOC){
        super(graph, bsData);
        this.hasSOC = hasSOC;
        this.hasSpin = hasSpin;
        this.factor = 1;
    }
    /**
   * Returns the highest and lowest values of the bands
   * @param  {array} data
   * @return {Array<number>}
   */ getEnergyExtrema(data) {
        let bandMax = -10000;
        let bandMin = 10000;
        for(let i = 0; i < data.length; i++){
            // Per segment
            const bands = data[i].band_energies[0].flat();
            const bands2 = data[i].band_energies.length > 1 ? data[i].band_energies[1].flat() : [];
            const bands3 = data[i].band_energies.length > 2 ? data[i].band_energies[2].flat() : [];
            bandMin = Math.min(bandMin, ...bands, ...bands2, ...bands3);
            bandMax = Math.max(bandMax, ...bands, ...bands2, ...bands3);
        }
        return [
            bandMin / this.factor,
            bandMax / this.factor
        ];
    }
    /**
   * Draws a k-point label on the X axis
   * @param  {int} x
   * @param  {string} label
   */ drawKPointLabel(x, label) {
        this.graph.setXAxisTickText(x, label);
    }
    /**
   * Sets the band structure data to be plotted.
   * Also, the top and bottom X values can be passed
   * @param {int} eAxisMin
   * @param {int} eAxisMax
   */ plotData(eAxisMin = -100, eAxisMax = 100) {
        // Gather all the points per band (divided by spin) crossing the segments
        let energyExtrema = this.getEnergyExtrema(this.data);
        let minEnergyVal = energyExtrema[0];
        let maxEnergyVal = energyExtrema[1];
        this.graph.setAxisLabelsAndRange($04eb082e7fe3bf1a$var$X_AXIS_LABEL, $04eb082e7fe3bf1a$var$Y_AXIS_LABEL, true, 0, 1, eAxisMin, eAxisMax, minEnergyVal, maxEnergyVal);
        // Calculates de distance
        let totalDistance = 0;
        let prevBandNum = 0;
        for(let k = 0; k < this.data.length; k++){
            prevBandNum = this.data[k].segment_num;
            let kPoints = this.data[k].band_k_points;
            totalDistance += $04eb082e7fe3bf1a$var$kPointDistance(kPoints, kPoints.length - 1);
        }
        let currentDistance = 0;
        let prevLastLabel = undefined;
        for(let k = 0; k < this.data.length; k++){
            // For every segment
            let segment = this.data[k];
            let kPoints = segment.band_k_points;
            const kDistances = kPoints.map((el, j)=>(currentDistance + $04eb082e7fe3bf1a$var$kPointDistance(kPoints, j)) / totalDistance);
            // if SOC or spin calculation, k-points repeat
            let n = kDistances.length;
            let labels = segment.band_segm_labels;
            // dealing with k-point labels
            let segmentDistance = $04eb082e7fe3bf1a$var$kPointDistance(kPoints, kPoints.length - 1);
            // Set k-points labels
            if (labels !== undefined) {
                if (prevLastLabel !== undefined && prevLastLabel !== labels[0]) this.drawKPointLabel(currentDistance / totalDistance, $04eb082e7fe3bf1a$var$getSymbol(prevLastLabel) + "|" + $04eb082e7fe3bf1a$var$getSymbol(labels[0]));
                else this.drawKPointLabel(currentDistance / totalDistance, $04eb082e7fe3bf1a$var$getSymbol(labels[0]));
                // The last label
                if (k === this.data.length - 1) this.drawKPointLabel(1, $04eb082e7fe3bf1a$var$getSymbol(labels[1]));
                prevLastLabel = labels[1];
            }
            for (const [i, energies] of segment.band_energies.entries()){
                const groupName = segment.bsName[i][0];
                if (energies.length > 0) {
                    // add line group
                    if (!this.graph.hasLineGroup(groupName)) this.graph.addLineGroup(groupName, {
                        defaultColor: $04eb082e7fe3bf1a$var$SPIN_DEFAULT_COLOR[i]
                    });
                    // transpose energies array
                    const kBands = energies[0].map((col, j)=>energies.map((row)=>row[j] / this.factor));
                    for (const band of kBands)this.graph.setLineData([
                        kDistances.slice(0, n),
                        band
                    ], groupName);
                }
            }
            currentDistance += segmentDistance;
        }
        // Drawing part
        this.graph.draw();
    }
}
/**
 * Returns the distance between first k-point and given for the position
 * @param  {Array<float>} kPoints
 * @param  {int} position
 * @return {number}
 */ function $04eb082e7fe3bf1a$var$kPointDistance(kPoints, position) {
    let p0 = kPoints[0];
    let p1 = kPoints[position];
    let deltaX = p1[0] - p0[0];
    let deltaY = p1[1] - p0[1];
    let deltaZ = p1[2] - p0[2];
    return Math.sqrt(deltaX * deltaX + deltaY * deltaY + deltaZ * deltaZ);
}
/**
 * Returns the k-point label. Transforms several possible Gamma labels
 * in the symbol
 * @param  {string} label
 * @return {string}
 */ function $04eb082e7fe3bf1a$var$getSymbol(label) {
    if (label === "Gamma" || label === "GAMMA" || label === "G") return "\u0393";
    else return label;
}


const $c0f4112c4fdba9f5$var$ENERGY_AXIS_MAX = 20;
const $c0f4112c4fdba9f5$var$ENERGY_AXIS_MIN = -20;
class $c0f4112c4fdba9f5$export$398f804bf564247a extends (0, $1c4abff4029f667e$export$1ff0c23d1088691a) {
    bsLabel = "band-structure-graph";
    dosLabel = "dos-graph";
    /** A band structure and DOS plotter
   *
   * @param parent {HTMLElement}
   * @param uiClass {string}
   * @param width {number}
   * @param height {number}
   * @param hasBS {boolean} a band structure flag
   * @param hasDOS {boolean} a density of states flag
   * @param hasSpin {boolean} a spin polarization flag
   * @param hasSOC {boolean} a spin-orbit coupling flag
   */ constructor(parent, uiClass, width, height, hasBS = true, hasDOS = true, hasSpin = false, hasSOC = false){
        super(parent, uiClass);
        this.hasBS = hasBS;
        this.hasDOS = hasDOS;
        this.hasSpin = hasSpin;
        this.hasSOC = hasSOC;
        this.setHTML(`
			<div class="graph-box">
				<div>
		      <div id="${this.bsLabel}" > </div>
<!--					<button id="segment-button"></button>-->
				</div>
				<div>
		      <div id="${this.dosLabel}" > </div>
					<button id="dos-button"></button>
				</div>
			</div>
      <div class="graph-controls-box" >
        <div>
          <div style="text-align: center">
          </div>
          <!-- Here goes the form -->
        </div>
      </div>
    `);
        // this.bsButton = this.getElement('#segment-button')
        this.dosButton = this.getElement("#dos-button");
        let w_BS = this.hasDOS ? width * 0.7 : width;
        let w_DOS = this.hasBS ? width * 0.3 : width;
        if (this.hasBS) this.attach("#" + this.bsLabel, w_BS, height);
        if (this.hasDOS) this.attach("#" + this.dosLabel, w_DOS, height);
        if (this.hasDOS) this.dosButton.innerHTML = "Select DOS File";
        else this.dosButton.style.display = "none";
        this.createForm("OutputAnalyzer-graph-controls-form");
        const formDiv = this.getElement(".graph-controls-box > div");
        formDiv.appendChild(this.form.e);
    }
    couple() {
        super._couple(this.bsLabel, this.dosLabel);
    }
    /** Sets band structure data for plotting`
   * @param bsData {array}
   */ setBSData(bsData) {
        if (!this.hasBS) return;
        console.log("BSData:", bsData);
        let plotter = new (0, $04eb082e7fe3bf1a$export$2e2bcd8739ae039)(this.graphs[this.bsLabel], bsData, this.hasSpin, this.hasSOC);
        plotter.plotData($c0f4112c4fdba9f5$var$ENERGY_AXIS_MIN, $c0f4112c4fdba9f5$var$ENERGY_AXIS_MAX);
        plotter.updateForm(this.form, "Band structure", "bsDiv");
    }
    /** Sets DOS data for plotting
   * @param dosFiles {Map<string,array>}
   */ setDOSData(dosFiles) {
        if (!this.hasDOS) return;
        //  check for molecular DOS
        let molDosName = Array.from(dosFiles.keys())[0];
        const isMolecule = molDosName.includes("MolDOS");
        let plotter = new (0, $2f0cabd1cd29e6d1$export$667b2089ba1c9583)(this.graphs[this.dosLabel], dosFiles, isMolecule, this.hasSpin);
        plotter.plotData($c0f4112c4fdba9f5$var$ENERGY_AXIS_MIN, $c0f4112c4fdba9f5$var$ENERGY_AXIS_MAX);
        plotter.updateForm(this.form, "Density of states", "dosDiv");
        this.dosButton.addEventListener("click", (_)=>plotter.onDosButtonClick());
    }
}


/**
 * @author Andrey Sobolev
 *
 * @fileOverview File holding the Absorption and Dielectric function dashboard based on Plotly.js
 */ 
/**
 * @author Iker Hurtado, Andrey Sobolev
 *
 * @fileOverview File holding the AbsorptionPlotter graph
 */ 

const $5d501f08636f5cf5$var$X_AXIS_LABEL = "Freq. (eV)";
const $5d501f08636f5cf5$var$Y_AXIS_LABEL = "Absorption Function";
const $5d501f08636f5cf5$var$AB_DEFAULT_COLOR = "#f26430";
class $5d501f08636f5cf5$export$ea8e9f7161a2407 extends (0, $40af6a9ade829703$export$2dcdd97d9ccbe1a7) {
    /**
   * Sets the absorption data to be plotted.
   * @param xAxisMin {number}
   * @param xAxisMax {number}
   */ plotData(xAxisMin, xAxisMax) {
        for (const [name, data] of this.data.entries()){
            const groupName = name.match(/(absorption_.*)_[xyz]_[xyz].out/)[1];
            if (!this.graph.hasLineGroup(groupName)) this.graph.addLineGroup(groupName, {
                defaultColor: $5d501f08636f5cf5$var$AB_DEFAULT_COLOR
            });
            const [x, y] = (0, $ab6e98e8f37dab02$export$9cb09a71b7d66923)(data);
            // xAxisMin = Math.max(xAxisMin, Math.min(...x))
            // xAxisMax = Math.min(xAxisMax, Math.max(...x))
            xAxisMin = Math.min(...x);
            xAxisMax = Math.max(...x);
            this.graph.setLineData([
                x,
                y
            ], groupName);
        }
        this.graph.setAxisLabelsAndRange($5d501f08636f5cf5$var$X_AXIS_LABEL, $5d501f08636f5cf5$var$Y_AXIS_LABEL, false, xAxisMin, xAxisMax);
        this.graph.draw();
    }
}


/**
 * @author Iker Hurtado, Andrey Sobolev
 *
 * @fileOverview File holding the dielectric function plotter
 */ 

const $853134a9ca121575$var$X_AXIS_LABEL = "Freq. (eV)";
const $853134a9ca121575$var$Y_AXIS_LABEL = "Dielectric Function";
const $853134a9ca121575$var$CONFIG = {
    re_vac: {
        name: "Real vacuum",
        color: "#009ddc"
    },
    im_vac: {
        name: "Imag vacuum",
        color: "#30f243"
    },
    re_po_inter: {
        name: "Real polarization interband",
        color: "#dfff00"
    },
    im_po_inter: {
        name: "Imag polarization interband",
        color: "#ffbf00"
    },
    re_po_intra: {
        name: "Real polarization intraband",
        color: "#ff7f50"
    },
    im_po_intra: {
        name: "Imag polarization interband",
        color: "#de3163"
    },
    re_die: {
        name: "Real dielectric",
        color: "#9fe2bf"
    },
    im_die: {
        name: "Imag dielectric",
        color: "#40e0d0"
    }
};
class $853134a9ca121575$export$14e62853bc487bf extends (0, $40af6a9ade829703$export$2dcdd97d9ccbe1a7) {
    /**
   * Sets the dielectric data to be plotted.
   * @param {number} xAxisMin
   * @param {number} xAxisMax
   */ plotData(xAxisMin = -6, xAxisMax = 12) {
        for (const data of this.data.values()){
            const xy = (0, $ab6e98e8f37dab02$export$9cb09a71b7d66923)(data);
            let idx = 0;
            for(const group in $853134a9ca121575$var$CONFIG){
                idx++;
                if (!this.graph.hasLineGroup(group)) this.graph.addLineGroup($853134a9ca121575$var$CONFIG[group].name, {
                    defaultColor: $853134a9ca121575$var$CONFIG[group].color
                });
                this.graph.setLineData([
                    xy[0],
                    xy[idx]
                ], $853134a9ca121575$var$CONFIG[group].name);
            }
        }
        this.graph.setAxisLabelsAndRange($853134a9ca121575$var$X_AXIS_LABEL, $853134a9ca121575$var$Y_AXIS_LABEL, false);
        this.graph.draw();
    }
}


const $305065bfb85fb4c3$var$FREQUENCY_AXIS_MAX = 0.1;
const $305065bfb85fb4c3$var$FREQUENCY_AXIS_MIN = 0.01;
class $305065bfb85fb4c3$export$880166fe85778fd5 extends (0, $1c4abff4029f667e$export$1ff0c23d1088691a) {
    abLabel = "absorption-graph";
    diLabel = "dielectric-graph";
    /** A band structure and DOS plotter
   *
   * @param parent {HTMLElement}
   * @param uiClass {string}
   * @param width {number}
   * @param height {number}
   * @param hasAb {boolean} a flag to include absorption graphs
   * @param hasDi {boolean} a flag to include dielectric function graphs
   */ constructor(parent, uiClass, width, height, hasAb, hasDi){
        super(parent, uiClass);
        this.setHTML(`
			<div>
	      <div id="${this.abLabel}" > </div>
<!--				<button id="absorption-button"></button>-->
			</div>
			<div>
	      <div id="${this.diLabel}" > </div>
<!--				<button id="dielectric-button"></button>-->
			</div>
      <div class="graph-controls-box" >
        <div>
          <!-- Here it goes the form -->
        </div>
      </div>
    `);
        if (hasAb) this.attach("#" + this.abLabel, width, height, {
            yaxis: {
                autorange: true
            }
        });
        if (hasDi) this.attach("#" + this.diLabel, width, height, {
            yaxis: {
                autorange: true
            }
        });
        this.createForm("OutputAnalyzer-graph-controls-form");
        const formDiv = this.getElement(".graph-controls-box > div");
        formDiv.appendChild(this.form.e);
    }
    /** Sets absorption data for plotting
   * @param absorptionFiles {Map<string, array>}
   */ setAbData(absorptionFiles) {
        if (!absorptionFiles) return;
        let plotter = new (0, $5d501f08636f5cf5$export$ea8e9f7161a2407)(this.graphs[this.abLabel], absorptionFiles);
        plotter.plotData($305065bfb85fb4c3$var$FREQUENCY_AXIS_MIN, $305065bfb85fb4c3$var$FREQUENCY_AXIS_MAX);
        plotter.updateForm(this.form, "Absorption", "dosDiv");
    }
    /** Sets absorption data for plotting
   * @param dielectricFiles {Map<string, array>}
   */ setDiData(dielectricFiles) {
        if (!dielectricFiles) return;
        let plotter = new (0, $853134a9ca121575$export$14e62853bc487bf)(this.graphs[this.diLabel], dielectricFiles);
        plotter.plotData($305065bfb85fb4c3$var$FREQUENCY_AXIS_MIN, $305065bfb85fb4c3$var$FREQUENCY_AXIS_MAX);
        plotter.updateForm(this.form, "Dielectric function", "dosDiv");
    }
} // let absorptionButton = this.getElement('#absorption-button') // <button> </button>
 // absorptionButton.innerHTML = 'Select Absorption File' // <button>Select Band Segment</button>
 // absorptionButton.addEventListener('click', _ => {
 // 	let absorptionNames = Array.from(absorptionFiles.keys())
 // 	let content = `<ul>`
 // 	for (let k = 0; k < absorptionNames.length; k++) { // For every  segment
 // 		let absorptionName = absorptionNames[k]
 // 		content += `<input type="checkbox" id="${absorptionName}" name="absorptionChoice" value="${absorptionName}" checked>${absorptionName}<br>`
 // }
 // 	content += `</ul>`
 // 	ModalPopup.setModalContent(content)
 // 	let chooseSegment = document.createElement('button')
 // 	chooseSegment.innerHTML = 'Apply'
 // 	chooseSegment.addEventListener('click', _ => {
 // 		let cb = document.querySelectorAll(`input[name="absorptionChoice"]:checked`)
 // 		let newAbsorptionFiles = new Map()
 // 		console.log(cb)
 // 		this.resetFieldsAndPlots()
 // 		// cb.forEach((checkbox) => {})
 //
 // 		this.absorptionPlotter.setData(newAbsorptionFiles, FREQUENCY_AXIS_MIN, FREQUENCY_AXIS_MAX)
 // 	})
 // 	ModalPopup.setModalComponent(chooseSegment,true)
 // 	ModalPopup.showModal(true)
 // 	})
 //
 // 	let dielectricButton = this.getElement('#dielectric-button') // <button> </button>
 // 	dielectricButton.innerHTML = 'Select Dielectric File' // <button>Select Band Segment</button>
 // 	dielectricButton.addEventListener('click', _ => {
 // 		let dielectricNames = Array.from(dielectricFiles.keys())
 // 		let content = `<ul>`
 // 		for (let k = 0; k < dielectricNames.length; k++) { // For every  segment
 // 			let dielectricName = dielectricNames[k]
 // 			if (dielectricName === this.currentlyPlottedDielectric){
 // 				content += `<input type="radio" id="${dielectricName}" name="dielectricChoice" value="${dielectricName}" checked>${dielectricName}<br>`
 // 			}
 // 			else if (dielectricName !== this.currentlyPlottedDielectric) {
 // 				content += `<input type="radio" id="${dielectricName}" name="dielectricChoice" value="${dielectricName}">${dielectricName}<br>`
 // 			}
 //
 // 	}
 // 		content += `</ul>`
 // 		ModalPopup.setModalContent(content)
 // 		let chooseSegment = document.createElement('button')
 // 		chooseSegment.innerHTML = 'Apply'
 // 		chooseSegment.addEventListener('click', _ => {
 // 			let cb = document.querySelectorAll(`input[name="dielectricChoise"]:checked`)
 // 			let newDielectricFiles = new Map()
 // 			console.log(cb)
 // 			this.resetFieldsAndPlots()
 // 			cb.forEach((checkbox) => {
 // 				newDielectricFiles.set(checkbox.value, dielectricFiles.get(checkbox.value))
 // 				this.currentlyPlottedDielectric = checkbox.value
 // 			})
 // 			let maxYAxisDecider = []
 // 			let F_AXIS_MAX = -10000
 // 			let F_AXIS_MIN = -10000
 // 			let newDielectricData = newDielectricFiles.size > 0 ? newDielectricFiles.get(newDielectricFiles.keys().next().value) : undefined
 // 			for (let i = 0; i < newDielectricData.length; i++){
 //
 // 				maxYAxisDecider.push(newDielectricData[i][1])
 // 				maxYAxisDecider.push(newDielectricData[i][2])
 // 				maxYAxisDecider.push(newDielectricData[i][3])
 // 				maxYAxisDecider.push(newDielectricData[i][4])
 // 				maxYAxisDecider.push(newDielectricData[i][5])
 // 				maxYAxisDecider.push(newDielectricData[i][6])
 // 				maxYAxisDecider.push(newDielectricData[i][7])
 // 				maxYAxisDecider.push(newDielectricData[i][8])
 // 			}
 // 			F_AXIS_MAX = Math.max.apply(F_AXIS_MAX, maxYAxisDecider);
 //       F_AXIS_MIN = Math.min.apply(F_AXIS_MIN, maxYAxisDecider);
 // 			this.dielectricPlotter.setData(newDielectricFiles, F_AXIS_MIN, F_AXIS_MAX)
 // 		})
 // 		ModalPopup.setModalComponent(chooseSegment,true)
 // 		ModalPopup.showModal(true)
 // 		})


/**
 * @author Andrey Sobolev
 *
 * @fileOverview File holding the Convergence graph dashboard based on Plotly.js
 */ 

/**
 * @author Iker Hurtado
 *
 * @fileoverview It's a UI component implementing a pagination control
 */ 


class $aa25e5800a3f62e9$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param {string} label Component label next to the control buttons
   * @param {int} startPage Starting page. Default: 1
   */ constructor(label, startPage = 1){
        super("div", ".Pagination-selector");
        // component state
        this.startPage = startPage;
        this.page = startPage;
        this.pageNum;
        this.setHTML(`
        <span class="page-selector-label"> ${label} </span>&nbsp;
        <button class="prev-page"> 
          <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($a4dce173ac6e0d02$exports)))}" height="14px" style="vertical-align: middle;">
        </button>
        <span class="current-page-label"></span>
        <button class="next-page"> 
          <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($96ee8327d03b4521$exports)))}" height="14px" style="vertical-align: middle;">
        </button>
    `);
        this.pageLabel = this.getElement(".current-page-label");
        const prevButton = this.getElement("button.prev-page");
        const nextButton = this.getElement("button.next-page");
        prevButton.addEventListener("click", (e)=>{
            if (this.page > this.startPage) {
                this.page--;
                this.updatePageLabel();
                this.prevListener(this.page);
            }
        });
        nextButton.addEventListener("click", (e)=>{
            if (this.pageNum + this.startPage - 1 > this.page) {
                this.page++;
                this.updatePageLabel();
                this.nextListener(this.page);
            }
        });
    }
    /**
   * Initilizes the component up to the number of pages
   * @param {int} pageNum
   */ init(pageNum) {
        this.pageNum = pageNum;
        this.updatePageLabel();
    }
    /**
   * Set the page number
   * @param {int} page
   */ setPage(page) {
        this.page = page;
        this.updatePageLabel();
    }
    /**
   * Update the page label being shown
   */ updatePageLabel() {
        this.pageLabel.textContent = this.page + "/" + (this.pageNum + this.startPage - 1);
    }
    /**
   * Set the listener that will be called when the previous button is clicked
   * @param {function} listener
   */ setPrevListener(listener) {
        this.prevListener = listener;
    }
    /**
   * Set the listener that will be called when the next button is clicked
   * @param {function} listener
   */ setNextListener(listener) {
        this.nextListener = listener;
    }
}


class $8e4cd46b96c526bb$export$ed788f6308546a28 extends (0, $1c4abff4029f667e$export$1ff0c23d1088691a) {
    /** A relaxation and convergence data plotter
   *
   * @param parent {HTMLElement}
   * @param uiClass {string}
   * @param isRelaxation {boolean}
  \   */ constructor(parent, uiClass, isRelaxation){
        super(parent, uiClass);
        this.setHTML(`
      <div class="relaxation-graph-ph" style="padding-bottom: 20px"></div>
      <div class="convergence-graph-ph" ></div>
    `);
        this.isRelaxation = isRelaxation;
        this.stepSelector = undefined;
        // Relaxation graph
        if (isRelaxation && !this.relaxationGraph) // Print this graph only if relaxation
        this.relaxationGraph = new $8e4cd46b96c526bb$var$RelaxationGraph(this.getElement(".relaxation-graph-ph"));
        // Convergence graph
        if (!this.convergenceGraph) this.convergenceGraph = new $8e4cd46b96c526bb$var$ConvergenceGraph(this.getElement(".convergence-graph-ph"));
        this.stepSelector = new (0, $aa25e5800a3f62e9$export$2e2bcd8739ae039)("Relaxation step", 1);
        this.e.insertBefore(this.stepSelector.e, this.convergenceGraph.parentElement);
        this.stepSelector.setPrevListener((s)=>this.plotIterData(s));
        this.stepSelector.setNextListener((s)=>this.plotIterData(s));
    }
    /** Plots data on the dashboard
   * @param convergenceData
   * @param relaxationData
   */ plotData(convergenceData, relaxationData) {
        // turn on the pagination selector
        // console.log(relaxationData)
        this.stepSelector.e.style.display = convergenceData.length > 1 ? "block" : "none";
        if (convergenceData.length > 1) this.stepSelector.init(convergenceData.length);
        this.convergenceData = convergenceData;
        this.relaxationData = relaxationData;
        // clear the graphs
        if (this.isRelaxation && this.relaxationData !== undefined) this.plotRelaxData();
        // draw convergence data
        this.plotIterData(1);
    }
    /**
   * Sets and draws the data of an iteration
   * @param {number} iter
   */ plotIterData(iter) {
        // begin the number from 0
        iter -= 1;
        console.log(this.convergenceData);
        let activeGroup = this.convergenceGraph.isDrawn ? this.convergenceGraph.getDropdownGroup() : "Change of Charge Density";
        this.convergenceGraph.clear();
        let stepData = this.convergenceData[iter];
        for(const name in stepData){
            const datum = stepData[name];
            const x = [
                ...Array(datum.data.length).keys()
            ];
            const y = datum.data.map((el)=>Math.abs(el));
            if (!this.convergenceGraph.hasLineGroup(datum.label)) this.convergenceGraph.addLineGroup(datum.label, {
                defaultColor: datum.color,
                yTitle: this.convergenceGraph.Y_AXIS_LABEL[name]
            });
            this.convergenceGraph.setLineData([
                x,
                y
            ], datum.label);
        }
        this.convergenceGraph.draw(true, activeGroup);
    }
    plotRelaxData() {
        this.relaxationGraph.clear();
        delete this.relaxationData.labels;
        for(const name in this.relaxationData){
            const datum = this.relaxationData[name];
            const x = [
                ...Array(datum.data.length).keys()
            ];
            const y = datum.data;
            if (!this.relaxationGraph.hasLineGroup(datum.label)) this.relaxationGraph.addLineGroup(datum.label, {
                defaultColor: datum.borderColor,
                yTitle: this.relaxationGraph.Y_AXIS_LABEL[name]
            });
            this.relaxationGraph.setLineData([
                x,
                y
            ], datum.label);
        }
        this.relaxationGraph.draw(true, "Maximum Force Component");
    }
}
class $8e4cd46b96c526bb$var$RelaxationGraph extends (0, $405f46edf3c84493$export$5512561d86ae4f70) {
    Y_AXIS_LABEL = {
        forces: "Maximum force component (eV/\xc5)",
        energy: "Change of total energy (eV)"
    };
    constructor(element){
        const layout = {
            title: "Relaxation",
            xaxis: {
                title: "Number of iterations",
                rangemode: "tozero"
            },
            yaxis: {
                type: "log",
                showexponent: "all",
                exponentformat: "power",
                autorange: true
            }
        };
        super(element, undefined, undefined, layout);
        this.NUMBER_OF_POINTS_IN_SEGMENT = 0;
    }
}
class $8e4cd46b96c526bb$var$ConvergenceGraph extends (0, $405f46edf3c84493$export$5512561d86ae4f70) {
    Y_AXIS_LABEL = {
        eigenvalues: "Change of sum of eigenvalues (eV)",
        totalEnergy: "Change of total energy (eV)",
        chargeDensity: `Change of charge density (Bohr<sup>-3</sup>)`,
        chargeDensityUp: `Change of charge density (Bohr<sup>-3</sup>)`,
        chargeDensityDown: `Change of spin density (Bohr<sup>-3</sup>)`
    };
    constructor(element){
        const layout = {
            xaxis: {
                title: "Number of iterations",
                rangemode: "tozero"
            },
            yaxis: {
                type: "log",
                showexponent: "all",
                exponentformat: "power",
                autorange: true
            }
        };
        super(element, undefined, undefined, layout);
        this.NUMBER_OF_POINTS_IN_SEGMENT = 0;
    }
}


let $4df3196f0fa11f92$var$init_html = `

	<h1> Output Analyzer </h1>

	<div class="output-analyzer-importer-ph" > <div> </div>  <label><input type="checkbox"/>Select a folder containing the files</label> </div>

	<div class="no-output-box" style="display: none; ">
	</div>

	<div class="output-file-content" style="display: none">

		<div class="system-info-section page-section" style="margin-bottom: 0" >

			<div style="width: 40%">
				<table class="system-info-fields set-of-fields" style="width: 360px">
						<tr><td>Chemical Formula</td> <td><span class="formula-value"></span></td></tr>
						<tr><td>Number of atoms</td> <td><span class="atom-num-value"></span></td></tr>
				</table>

				<div class="page-section" style="margin-bottom: 0">
					<div class="page-section-title">Results</div>
					<table class="results-info-fields set-of-fields" style="width: 360px">
					</table>
				</div>

			</div>
      <div>
			  <div class="geometry-viz-ph" > </div>
			  <div class="geometry-viz-controls"> </div>
			</div>
		</div>
	</div>

	<div class="dos-bs-box page-section" style="display: none">
		<div class="page-section-title">DOS and Band Structure graphs</div>
		<div class="bs-error-msg" > </div>
		<div class="section-content" style="justify-content: space-evenly;"></div>
	</div>

	<div class="bz-viewer-box page-section" style="display: none;">
		<div class="bz-viewer-ph" style="justify-content: space-evenly;"></div>
	</div>

	<div class="absorption-box page-section" style="display: none">
		<div class="page-section-title">Absorption and Dielectric function graphs</div>
		<div class="absorption-error-msg" > </div>
		<div class="section-content" style="justify-content: space-evenly;"></div>
	</div>

	<div class="output-file-content" style="display: none">
		<div class="page-section" >
			<div class="page-section-title">Calculation Summary</div>
			<div class="section-content" style="justify-content: space-evenly;">
        <table class="calculation-info-fields set-of-fields" style="width: 350px"></table>
        <div id="summary-graphs" style="width: 60%"></div>
      </div>
    </div>
	</div>

	<div class="input-files-section" style="display: none">

		<div class="page-section" >

			<div class="page-section-title">Input files</div>

			<div class="section-content input-files-box" style="justify-content: space-evenly;">
			</div>

		</div>

	</div>

	<div class="parsing-files-section" style="display: none">
		<div class="page-section" >
			<div class="page-section-title">Parsing Errors</div>
			<div class="section-content">
				<table class="parsing-info-fields set-of-fields" style="width: 350px"></table>
			</div>
		</div>
	</div>
`;
const $4df3196f0fa11f92$var$NO_MAIN_FILE_TEXT = "No main output file has been detected";
const $4df3196f0fa11f92$var$NO_FILE_TEXT = "No parsable file detected";
const $4df3196f0fa11f92$var$PARSING_ERROR = `
	Something unexpectedly went wrong when parsing the main output file.<br>
	Please raise an issue in the <a href="https://gitlab.com/gims-developers/gims/-/issues" target="_blank">GIMS-gitlab</a>. Sorry for any inconvenience!
`;
class $4df3196f0fa11f92$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("div", "#OutputAnalyzerMod");
        this.setHTML($4df3196f0fa11f92$var$init_html);
        this.importer = new (0, $d4667050cb9a5b91$export$2e2bcd8739ae039)("Import output files:", true);
        this.getElement(".output-analyzer-importer-ph div").appendChild(this.importer.e);
        this.getElement('.output-analyzer-importer-ph input[type="checkbox"]').addEventListener("click", (e)=>{
            this.importer.setDirectoryMode(e.target.checked);
        });
        this.buttons = [];
        this.noOutputBox = this.getElement(".no-output-box");
        this.outputContentBoxes = this.getElements(".output-file-content");
        this.dosBsBox = this.getElement(".dos-bs-box");
        this.bzViewerBox = this.getElement(".bz-viewer-box");
        this.bsErrorMsgBox = this.getElement(".bs-error-msg");
        this.absorptionBox = this.getElement(".absorption-box");
        // this.absorptionMsgBox = this.getElement('.absorption-error-msg')
        this.inputFilesBox = this.getElement(".input-files-section");
        this.calculationSummary = undefined;
    }
    /**
   * Updates the component for a code change (application level event)
   * Do nothing in this case
   * @param  {string} code
   */ updateForCode(code) {
    //log('updateForCode')
    }
    /**
   * Updates the component for a setting change (application level event)
   * Do nothing in this case
   * @param  {object} newSettings
   */ updateSettings(newSettings) {}
    /**
   * Module initialization method.
   * Sets the behavior of the module when the calculation output files
   * are imported: they are parsed and the relevant info is shown
   */ init() {
        this.importer.setImportListener(async (files)=>{
            let promises = [];
            // client processing
            for(let i = 0; i < files.length; i++){
                let file = files[i];
                let reader = new FileReader();
                // when the file is read it triggers the onload event above.
                if (file.type.includes("gzip")) reader.readAsArrayBuffer(file);
                else reader.readAsText(file);
                promises.push(new Promise((resolve, _)=>{
                    reader.addEventListener("load", (e)=>{
                        resolve({
                            content: e.target.result,
                            name: file.name,
                            type: file.type
                        });
                    });
                }));
            }
            Promise.all(promises).then((filesData)=>(0, $ab6e98e8f37dab02$export$7b2a59254a5000b2)(filesData)).then((output)=>{
                // reset the panels
                showElement(this.noOutputBox, false);
                showElement(this.outputContentBoxes[0], false);
                showElement(this.dosBsBox, false);
                showElement(this.absorptionBox, false);
                showElement(this.outputContentBoxes[1], false);
                showElement(this.inputFilesBox, false);
                showElement(this.bzViewerBox, false);
                if (!output) {
                    this.noOutputBox.innerHTML = $4df3196f0fa11f92$var$NO_FILE_TEXT;
                    showElement(this.noOutputBox);
                    return;
                }
                // Disambiguation modal window. More than one output file and/or two DOS data files
                const outputFiles = output.files.output;
                const dosFiles = output.files.dos;
                const absorptionFiles = output.files.absorption;
                const dielectricFiles = output.files.dielectric;
                // console.log("In OutputAAnalyser")
                // console.log(dielectricFiles)
                // let dosNames = Array.from(dosFiles.keys())
                if (outputFiles.size > 1) {
                    if (output.workflows.length > 0 && dosFiles.size === 0) for (const fileName of outputFiles.keys()){
                        console.log(fileName);
                        const workflow = fileName.split("/")[0];
                        output.parseOutputFile(fileName);
                        if (output.runTimeChoices.isPeriodic === false) {
                            if (output.runTimeChoices.spin !== "collinear") dosFiles.set(workflow + "/MolDOS.dat", output.ksEv);
                            else dosFiles.set(workflow + "/MolDOS.dat.spin", output.ksEv);
                        }
                    }
                    // FileChooser popup appears
                    let fileChooser = new $4df3196f0fa11f92$var$FileChooser(outputFiles, dosFiles);
                    // this happens when the FileChooser button is clicked
                    fileChooser.setListener((outputFileName)=>{
                        if (outputFiles.size > 0) {
                            // If only one output file: outputFileName = undefined, no choice
                            try {
                                output.parseOutputFile(outputFileName);
                            } catch (e) {
                                this.noOutputBox.innerHTML = $4df3196f0fa11f92$var$PARSING_ERROR;
                                showElement(this.noOutputBox);
                            }
                            // The first is parsed
                            this.showOutputLayout(output);
                        } else {
                            this.noOutputBox.innerHTML = $4df3196f0fa11f92$var$NO_MAIN_FILE_TEXT;
                            showElement(this.noOutputBox);
                        }
                        let bsInfo = output.getBsInfo();
                        this.showBSAndDOSData(bsInfo.bsData, dosFiles, bsInfo.lackingSegments, output.getStructure(), bsInfo.hasSOC, bsInfo.hasSpin);
                        $9d993874406c4873$export$af4939467128bcd0();
                    });
                    $9d993874406c4873$export$a778490beb6e83b8(fileChooser.e);
                    $9d993874406c4873$export$d7e8d4d4450c819c(true);
                } else {
                    // No modal window: no more than one output file and DOS data file
                    if (outputFiles.size === 1) {
                        // there is output file
                        try {
                            output.parseOutputFile(outputFiles[0]);
                        } catch (e) {
                            this.noOutputBox.innerHTML = $4df3196f0fa11f92$var$PARSING_ERROR + `<br>The error is:<br>` + output.errors;
                            showElement(this.noOutputBox);
                        }
                        this.showOutputLayout(output);
                    } else {
                        this.noOutputBox.innerHTML = $4df3196f0fa11f92$var$NO_MAIN_FILE_TEXT;
                        showElement(this.noOutputBox);
                    }
                    const bsInfo = output.getBsInfo();
                    if (output.runTimeChoices.isPeriodic === false && output.runTimeChoices.spin !== "collinear" && dosFiles.size === 0 && outputFiles.size === 1) dosFiles.set("MolDOS.dat", output.ksEv);
                    else if (output.runTimeChoices.isPeriodic === false && output.runTimeChoices.spin === "collinear" && dosFiles.size === 0 && outputFiles.size === 1) dosFiles.set("MolDOS.dat.spin", output.ksEv);
                    this.showBSAndDOSData(bsInfo.bsData, dosFiles, bsInfo.lackingSegments, output.getStructure(), bsInfo.hasSOC, bsInfo.hasSpin);
                    this.showAbsorptionData(absorptionFiles, dielectricFiles);
                } // else
            }, (error)=>{
                $6ff060c6e60f738f$export$ddf018cf7a99d36f("Error uploading files");
                console.error("ERROR ", error);
            });
        });
    }
    /**
   * The DOS and band structure plots are built and shown
   * @param  {array} bsData
   * @param  {Map<string,array>} dosFiles
   * @param  {object} lackingSegments
   * @param  {object} structure
   * @param  {boolean} hasSOC
   * @param  {boolean} hasSpin
   *  Info of the bands structure lacking segments
   */ //HHK
    showBSAndDOSData(bsData, dosFiles, lackingSegments, structure, hasSOC = false, hasSpin = false) {
        if (this.dosBsGraphs !== undefined) {
            this.dosBsGraphs.e.innerHTML = "";
            this.dosBsGraphs = null;
        }
        // DOS and band structure graphs
        const hasBS = bsData.length > 0;
        const hasDOS = dosFiles.size > 0;
        let isStructure = structure && structure.atoms.length > 0;
        this.dosBsBox.style.display = hasBS || hasDOS ? "block" : "none";
        this.bzViewerBox.style.display = isStructure && bsData.length > 0 ? "flex" : "none";
        if (hasBS || hasDOS) {
            this.dosBsGraphs = new (0, $c0f4112c4fdba9f5$export$398f804bf564247a)(this.dosBsBox.querySelector(".section-content"), "graph-box", 1150, 700, hasBS, hasDOS, hasSpin, hasSOC);
            this.dosBsGraphs.setBSData(bsData);
            this.dosBsGraphs.setDOSData(dosFiles);
            // couple two graphs
            if (hasBS && hasDOS) this.dosBsGraphs.couple();
            if (bsData.length > 0 && lackingSegments.length > 0) this.bsErrorMsgBox.innerHTML = "Some band structure files are lacking: " + lackingSegments.join(", ");
            else this.bsErrorMsgBox.innerHTML = "";
        }
        let table = this.getElement(".band-path-table");
        if (table) this.bzViewerBox.removeChild(table);
        if (isStructure > 0 && bsData && bsData.length > 0) {
            if (this.bzViewer === undefined) this.bzViewer = new (0, $d0456dc84d1a72e5$export$2e2bcd8739ae039)(this.getElement(".bz-viewer-ph"));
            let paths = this.bzViewer.getBandPath(bsData);
            if (paths) {
                this.bzViewer.setNewStructure(structure, true, paths);
                let table = this.bzViewer.getHTMLBandPath(paths);
                this.bzViewerBox.appendChild(table);
            }
        } else this.bzViewerBox.style.display = "none";
    }
    /**
    * The absorption plots are built and shown
    * @param  {Map<string, array>} absorptionFiles
    * @param  {Map<string, array>} dielectricFiles
    *  Info of the bands structure lacking segments
    */ //HHK
    showAbsorptionData(absorptionFiles, dielectricFiles) {
        console.log("in show abso");
        let absorptionData = absorptionFiles.size > 0 ? absorptionFiles.get(absorptionFiles.keys().next().value) : undefined;
        let dielectricData = dielectricFiles.size > 0 ? dielectricFiles.get(dielectricFiles.keys().next().value) : undefined;
        const anyAbsorptionData = absorptionData;
        const anyDielectricData = dielectricData;
        this.absorptionBox.style.display = anyAbsorptionData || anyDielectricData ? "block" : "none";
        if (anyAbsorptionData || anyDielectricData) {
            this.absorptionGraphs = new (0, $305065bfb85fb4c3$export$880166fe85778fd5)(this.absorptionBox.querySelector(".section-content"), ".AbsorptionGraphs", 900, 600, !!anyAbsorptionData, !!anyDielectricData);
            this.absorptionGraphs.setAbData(absorptionFiles);
            this.absorptionGraphs.setDiData(dielectricFiles);
        }
    }
    /**
   * The main output information is shown
   * @param  {object} output
   */ showOutputLayout(output) {
        showElement(this.outputContentBoxes[0]);
        showElement(this.outputContentBoxes[1]);
        const isRelaxation = output.isRelaxation();
        let structure = output.getStructure();
        //  **** System information section ****
        this.getElement(".formula-value").textContent = output.systemInformation.formulaUnit;
        this.getElement(".atom-num-value").textContent = output.systemInformation.nAtoms;
        // Structure viewer (animation for relaxation case)
        if (this.viewer) this.viewer.reset();
        else this.viewer = new (0, $a197da9598f0bd1e$export$2e2bcd8739ae039)(this.getElement(".geometry-viz-ph"), false, undefined);
        // console.log(output.scfLoops);
        const structureSequence = [];
        if (isRelaxation) {
            // console.log(output.calculation.scfLoops);
            output.scfLoops.forEach((scfLoop)=>{
                // log('scfLoop.structure', i++, scfLoop.structure)
                if (scfLoop.structure) // let loopStructure = new Structure()
                // loopStructure.atoms = scfLoop.structure.atoms
                //***** TODO lattice vector??
                structureSequence.push(scfLoop.structure);
            });
            // console.log(structureSequence);
            if (structureSequence.length > 0) this.viewer.setNewAnimation(structureSequence);
        } else this.viewer.setNewStructure(structure);
        // Atom visualization controls
        let divVizControls = this.getElement(".geometry-viz-controls");
        if (output.mulliken || output.hirshfeld) divVizControls.innerHTML += `<input type="radio" id="atom-viz-species" name="atom-viz-radio" class="hidden" checked>
        <label for="atom-viz-species" class="atom-viz-label">Species</label>`;
        if (output.hirshfeld) divVizControls.innerHTML += `<input type="radio" id="atom-viz-hirshfeld" name="atom-viz-radio" class="hidden">
        <label for="atom-viz-hirshfeld" class="atom-viz-label">Hirshfeld</label>`;
        if (output.mulliken) for(const key in output.mulliken){
            const mode = key === "simple" ? "" : `(${key.toUpperCase()})`;
            divVizControls.innerHTML += `<input type="radio" id="atom-viz-mulliken:${key}" name="atom-viz-radio" class="hidden">
            <label for="atom-viz-mulliken:${key}" class="atom-viz-label">Mulliken ${mode}</label>`;
        }
        let vizControls = this.getElements(".geometry-viz-controls input");
        vizControls.forEach((e)=>e.addEventListener("change", (ev)=>{
                let vizType = ev.target.id.split("-")[2];
                switch(vizType){
                    case "mulliken:simple":
                        this.viewer.changeAtomsColors(output.mulliken["simple"]);
                        break;
                    case "mulliken:sr":
                        this.viewer.changeAtomsColors(output.mulliken["sr"]);
                        break;
                    case "mulliken:soc":
                        this.viewer.changeAtomsColors(output.mulliken["soc"]);
                        break;
                    case "hirshfeld":
                        this.viewer.changeAtomsColors(output.hirshfeld);
                        break;
                    case "species":
                        this.viewer.changeAtomsColors();
                }
            }));
        console.log("Output:", output);
        //  **** Results section ****
        this.getElement(".results-info-fields").innerHTML = (0, $ab6e98e8f37dab02$export$133463a98c8c6308)(output.getResultsQuantities());
        //  ***** Calculation summary section
        if (this.calculationSummary === undefined) this.calculationSummary = new (0, $8e4cd46b96c526bb$export$ed788f6308546a28)(this.getElement("#summary-graphs"), ".convergence-graphs", isRelaxation);
        this.calculationSummary.plotData(output.dataSeries, output.relaxationSeries);
        // Calculation information
        this.getElement(".calculation-info-fields").innerHTML = (0, $ab6e98e8f37dab02$export$133463a98c8c6308)(output.getCalculationInfo(), false);
        //**** Input files section ****
        let inputFileMap = output.getInputFilesMap();
        showElement(this.inputFilesBox, inputFileMap.size > 0);
        this.getElement(".input-files-box").innerHTML = "";
        inputFileMap.forEach((content, name)=>{
            const href = window.URL.createObjectURL(new Blob([
                content
            ], {
                type: "text/plain"
            }));
            const boxElement = document.createElement("div");
            boxElement.innerHTML = `
          <button class="input-files-button"> View <b>${name}</b> </button>
          <a class="download-link" download="${name}" href="${href}">
            <img style="vertical-align: middle; padding-left: 10px" src="${0, (/*@__PURE__*/$parcel$interopDefault($71de690891678265$exports))}" alt="Download" />
          </a>
        `;
            let dtext = content.replace(/[\u00A0-\u9999<>&]/gim, function(i) {
                return "&#" + i.charCodeAt(0) + ";";
            });
            boxElement.querySelectorAll(".input-files-button").forEach((e)=>{
                e.addEventListener("click", (_)=>{
                    $9d993874406c4873$export$b964053cbf2907a2("<blockquote><pre><code>" + dtext + "</code></pre></blockquote>");
                    $9d993874406c4873$export$d7e8d4d4450c819c(true);
                });
            });
            this.getElement(".input-files-box").appendChild(boxElement);
        });
        // Parsing errors - by Sebastian
        // console.log(output.errors);
        this.getElement(".parsing-files-section").style.display = output.errors.length > 0 ? "block" : "none";
        let html = "";
        output.errors.forEach((er)=>{
            console.log(er);
            html += `<tr> <td>${er[0]}</td> <td>${er[1].replace(/[\u00A0-\u9999<>&]/gim, function(i) {
                return "&#" + i.charCodeAt(0) + ";";
            })}</td> </tr>`;
        });
        this.getElement(".parsing-info-fields").innerHTML = html;
    }
}
/**
 * Simple UI component that enables the choice between two files of the same type
 * (output and DOS files). It's shown inside a modal popup
 */ class $4df3196f0fa11f92$var$FileChooser extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param  outputFiles {Map<string,string>}
   * @param  dosFiles {Map<string,string>}
   */ constructor(outputFiles, dosFiles){
        super("div", ".extensionChooser");
        let html = "";
        if (outputFiles.size > 1) {
            html += '<div>More than one aims output file uploaded, choose the one to be displayed:</div><div class="radios-ph">';
            outputFiles.forEach((data, fileName)=>{
                html += `<input type="radio" name="output-file-name" value="${fileName}"> ${fileName} <br>`;
            });
            html += "</div>";
        }
        this.setHTML(html + '<div class="button-ph"><button>Done</button></div>');
        this.getElement("button").addEventListener("click", (_)=>{
            //log('DOS file'+chosenInput.value)
            let outputFileEl = this.getElement('input[name="output-file-name"]:checked');
            let dosFileEl = this.getElement('input[name="dos-data-file"]:checked');
            this.listener(outputFileEl === null ? undefined : outputFileEl.value, dosFileEl === null ? undefined : dosFileEl.value);
        });
    }
    /**
   * Sets the listener that will be called when the button is clicked
   * @param {function} listener
   */ setListener(listener) {
        this.listener = listener;
    }
}


/**
 * @author Iker Hurtado
 *
 * @overview File holding the ControlGeneratorMod class and module
 */ 






var $48d6490f6bd543c9$exports = {};
$48d6490f6bd543c9$exports = new URL("k_grid_density-formula.9368f611.png", import.meta.url).toString();


var $74f838f4185c8cba$exports = {};
$74f838f4185c8cba$exports = new URL("atom_properties_shot.51402526.png", import.meta.url).toString();


const $0e488ab2a2fafc52$export$18438811c86f084f = [
    {
        label: "Basic Settings",
        // info: 'To activate "spin collinear" please specify initial moments in the Structure Builder.\n(click on the species color right to the atomic coordinates)',
        fields: {
            species: {
                // If there are no flags attributes the field name is taken ('species' in this case)
                text: "Geometry species",
                inputType: "input-text",
                required: true,
                dataType: "string",
                explanation: `
            This field reflects the different species included in your structure.
            The ControlGenerator accepts any valid element of the periodic table.
        `,
                value: (s)=>{
                    let species = [];
                    s.atoms.forEach((atom)=>{
                        if (!species.includes(atom.species)) species.push(atom.species);
                    });
                    return species.join(" ");
                },
                workflow: "default"
            },
            xc: {
                // XC functional for FHIaims
                text: "XC functional",
                inputType: "select",
                required: true,
                value: [
                    "",
                    "pz-lda",
                    "pw-lda",
                    "pbe",
                    'pbe+TS:{"xc":"pbe","vdw_correction_hirshfeld":true}',
                    'pbe+MBD:{"xc":"pbe","many_body_dispersion":""}',
                    'pbe+MBD-NL:{"xc":"pbe","many_body_dispersion_nl":""}',
                    'b86bpbe+XDM:{"xc": "b86bpbe","xdm":""}',
                    "pbesol",
                    "pbe0",
                    'pbe0+TS:{"xc":"pbe","vdw_correction_hirshfeld":true}',
                    'pbe0+MBD:{"xc":"pbe0","many_body_dispersion":""}',
                    'pbe0+MBD-NL:{"xc":"pbe0","many_body_dispersion_nl":""}',
                    'hse06:{"xc":"hse06 0.11","hse_unit":"bohr","hybrid_xc_coeff":"0.25"}',
                    'hse06+TS:{"xc":"hse06 0.11","hse_unit":"bohr","hybrid_xc_coeff":"0.25","vdw_correction_hirshfeld":true}',
                    'hse06+MBD:{"xc":"hse06 0.11","hse_unit":"bohr","hybrid_xc_coeff":"0.25","many_body_dispersion":""}',
                    'hse06+MBD-NL:{"xc":"hse06 0.11","hse_unit":"bohr","hybrid_xc_coeff":"0.25","many_body_dispersion_nl":""}',
                    'b86bpbe-25+XDM:{"xc": "b86bpbe-25","xdm":""}',
                    "hf"
                ],
                dataType: "string",
                explanation: `
            Select the exchange correlation (XC) functional for your calculation. <br>
            <b>pz-lda:</b> Perdew-Zunger LDA<br>
            <b>pw-lda:</b> Perdew-Wang LDA<br>
            <b>pbe:</b> Perdew-Burke-Ernzerhof GGA<br>
            <b>pbe+TS:</b> pbe + Tkatchenko-Scheffler vdW correction<br>
            <b>pbe+MBD:</b> pbe + Many-Body-Dispersion correction<br>
            <b>pbe+MBD-NL:</b> pbe + Non-Local Many-Body-Dispersion correction<br>
            <b>b86bpbe+XDM:</b> pbe + eXchange-hole Dipole Model<br>
            <b>pbesol:</b> pbe optimized for solids<br>
            <b>pbe0:</b> pbe + hf hybrid functional<br>
            <b>pbe0+TS:</b> pbe + hf hybrid functional + Tkatchenko-Scheffler vdW correction<br>
            <b>pbe0+MBD:</b> pbe + hf hybrid functional + Many-Body-Dispersion correction<br>
            <b>pbe0+MBD-NL:</b> pbe + hf hybrid functional + Non-Local Many-Body-Dispersion correction<br>
            <b>hse06:</b> Heyd-Scuseria-Ernzerhof screened exchange hybrid functional<br>
            <b>hse06+TS:</b> hse06 + Tkatchenko-Scheffler vdW correction<br>
            <b>hse06+MBD:</b> hse06 + Many-Body-Dispersion correction<br>
            <b>hse06+MBD-NL:</b> hse06 + Non-Local Many-Body-Dispersion correction<br>
            <b>hf:</b> Hartree-Fock method
        `,
                workflow: "default"
            },
            basisSettings: {
                // FHIaims only
                text: "Species Default Settings",
                group: 0,
                inputType: "select",
                required: true,
                value: [
                    "",
                    "light",
                    "intermediate",
                    "tight",
                    "really_tight"
                ],
                dataType: "string",
                explanation: `
            The species defaults are a collection of pre-defined numerical parameters for the integration grids and 
            basis functions.<br>
            <b>light:</b> Settings for fast pre-relaxations, structure searches, etc. Usually, no obvious geometry or 
            convergence errors resulted from these settings. Recommended for many household tasks.<br>
            <b>intermediate:</b> Only available for a few elements, but can play an important role for large and 
            expensive calculations, especially for hybrid functionals.<br>
            <b>tight:</b> Regarding the integration grids, Hartree potential, and basis cutoff potentials, the settings
             specified here are rather safe, intended to provide meV-level accurate energy differences also 
             for large structures.
        `,
                workflow: "default"
            },
            spin: {
                text: "Spin",
                group: 0,
                inputType: "select",
                required: false,
                value: [
                    "",
                    "none",
                    "collinear"
                ],
                dataType: "string",
                explanation: `
            Specifies whether or not a spin-polarized calculation is run. If you choose 'collinear', please assign 
            initial moments in the Structure Builder to at least one atom. Choosing the right initial spin density 
            can be performance-critical, and critical for the resulting physics.
        `,
                sanity_check: (field, s)=>{
                    if (field.getValue() === "collinear" && !s.isMagnetic()) return {
                        type: "error",
                        message: `To make use of collinear spin keyword, at least one initial moment has to be set.<br>
                        It can be done in Structure Builder by clicking on species color:<br>
                         <img src="${0, (/*@__PURE__*/$parcel$interopDefault($74f838f4185c8cba$exports))}" alt="Atom properties"/>`
                    };
                    if ([
                        "none",
                        ""
                    ].includes(field.getValue()) && s.isMagnetic()) return {
                        type: "error",
                        message: "If atomic initial moments are set, spin keyword needs to be set to 'collinear'"
                    };
                },
                workflow: "default"
            }
        }
    },
    // End BasicSettings
    {
        label: "K-grid",
        info: (s)=>{
            try {
                let [a, b, c] = s.structureInfo["unit_cell_parameters"].value.slice(0, 3);
                return `Structure lattice vectors: <br>` + `<table style="width:100%"><tr><td>${a.toFixed(3)} &#197;</td>` + `<td>${b.toFixed(3)} &#197;</td>` + `<td>${c.toFixed(3)} &#197;</td></tr></table></table>`;
            } catch (_) {
                return "";
            }
        },
        constraint: (ctx)=>ctx["structure"].isAPeriodicSystem(),
        fields: {
            k_grid_radio: {
                flag: "k_grid_radio",
                inputType: "radio",
                required: true,
                // if it's not required it's not shown
                workflow: "default",
                sanity_check: (field, s)=>{
                    if (!s.isAPeriodicSystem()) return undefined;
                    if (field.name === "k_grid") {
                        // check if a_i * N_i >= 40
                        let [a, b, c] = s.structureInfo["unit_cell_parameters"].value.slice(0, 3);
                        let [i, j, k] = field.getValue();
                        if (a * i < 35 || b * j < 35 || c * k < 35) return {
                            type: "warning",
                            message: "The k-point grid seems to be insufficient"
                        };
                    }
                },
                value: {
                    kgrid_mesh: {
                        flag: "k_grid",
                        text: "k-points grid",
                        inputType: "input-text:3",
                        dataType: [
                            "integer",
                            "integer",
                            "integer"
                        ],
                        explanation: `Enter the number of k-points along each reciprocal lattice vector. The rule of thumb is to use
              such N<sub>i</sub> so that<br><i>N<sub>i</sub> &middot; a<sub>i</sub> &#8805; 40</i>.`,
                        workflow: "default"
                    },
                    k_grid_density: {
                        flag: "k_grid_density",
                        text: "k-points grid density",
                        inputType: "input-text",
                        dataType: "float",
                        explanation: `Sets the k-point density in the mesh (that is, the number of k-points per 1&#197;&#8315;&#185; 
              of the reciprocal lattice vector). The sane choice is 6&#197;. The number of k-points along the axis
              is then found as <div style="text-align:center"><img src="${(0, (/*@__PURE__*/$parcel$interopDefault($48d6490f6bd543c9$exports)))}" alt="2pi/|a|*rho"/></div>`,
                        units: `&#197`,
                        workflow: "default"
                    }
                }
            },
            k_grid_offset: {
                flag: "k_offset",
                constraint: [
                    "xc",
                    "in",
                    [
                        "pw-lda",
                        "pz-lda",
                        "pbe",
                        "pbesol"
                    ]
                ],
                text: "k-points grid offset",
                inputType: "input-text:3",
                required: false,
                // Required in some cases, not always
                dataType: [
                    "integer",
                    "integer",
                    "integer"
                ],
                explanation: "K-grid offset can not be used with HF or hybrid potential calculation",
                workflow: "default"
            }
        }
    },
    {
        label: "Molecular dynamics",
        fields: {
            mdRun: {
                text: "MD ensemble",
                flag: "MD_run",
                group: 0,
                inputType: "select",
                required: true,
                value: [
                    "",
                    "NVE",
                    "NVT_parrinello"
                ],
                dataType: "string",
                explanation: `
            Central controls of the physical parameters of a Born-Oppenheimer molecular dynamics run.
            Specifies the MD ensemble:<br>
            <b>NVE:</b> performs molecular dynamics in the microcanonical ensemble;<br>
            <b>NVT_parrinello:</b> molecular dynamics run using the Bussi-Donadio-Parrinello thermostat.<br>
        `,
                workflow: "MD"
            },
            mdRunTime: {
                text: "MD run time",
                flag: "MD_run_time",
                group: 0,
                inputType: "input-text",
                required: true,
                dataType: "float",
                units: "ps",
                explanation: `
          The run time for AIMD simulation in picoseconds
        `,
                workflow: "MD"
            },
            mdRunParameters: {
                text: "Thermostat parameters",
                flag: "MD_run_params",
                group: 0,
                inputType: "input-text:2:Temperature,Tau",
                required: true,
                dataType: [
                    "float",
                    "float"
                ],
                units: [
                    "K",
                    "ps"
                ],
                explanation: `
          AIMD thermostat parameters:<br>
            <b>Temperature:</b> the simulation temperature in K;<br>
            <b>Tau:</b> the relaxation time of the thermostat, in ps.<br>
        `,
                constraint: [
                    "mdRun",
                    "in",
                    [
                        "NVT_parrinello"
                    ]
                ],
                workflow: "MD"
            },
            mdTimeStep: {
                text: "MD time step",
                flag: "MD_time_step",
                group: 0,
                inputType: "input-text",
                required: true,
                dataType: "float",
                units: "ps",
                explanation: `
          The time step for AIMD simulation in picoseconds
        `,
                workflow: "MD"
            },
            mdMBInit: {
                text: "Velocity initialization temperature",
                flag: "MD_MB_init",
                group: 0,
                inputType: "input-text",
                required: true,
                dataType: "float",
                units: "K",
                explanation: `
          Initializes random velocities in a molecular dynamics calculation using a Maxwell-Boltzmann distribution.<br>
          Please specify an appropriate temperature in Kelvin.
        `,
                workflow: "MD"
            }
        }
    },
    {
        label: "GW self-energy correction",
        fields: {
            qpeCalc: {
                text: "Perturbative quasiparticle correction",
                flag: "qpe_calc",
                group: 0,
                inputType: "select",
                required: true,
                value: [
                    "",
                    "gw",
                    "gw_expt",
                    "ev_scgw",
                    "ev_scgw0"
                ],
                dataType: "string",
                explanation: `
            Enables a perturbative quasiparticle correction to the single-particle eigenvalues at a postprocessing step. 
            Specifies which correction to use:<br>
            <b>gw:</b> Perturbative G<sub>0</sub>W<sub>0</sub>-type self-energy for cluster geometries, 
            where the Green\u{2019}s function G<sub>0</sub> and the screened Coulomb interaction W<sub>0</sub> are 
            computed once, based on the self-consistent DFT or HF ground state eigenvalues and eigenfunctions;<br>
            <b>gw_expt:</b> the same as <code>gw</code>, but for periodic structures;<br>
            <b>ev_scgw:</b> the self-energy is evaluated with partial self-consistency in the eigenvalues. 
            The eigenvalues are iterated in G <i>and</i> W;<br>
            <b>ev_scgw0:</b> the self-energy is evaluated with partial self-consistency in the eigenvalues. 
            The eigenvalues are iterated <i>only</i> in G but not in W.<br>
        `,
                sanity_check: (field, s)=>{
                    if (s.isAPeriodicSystem() && field.getValue() !== "gw_expt") return {
                        type: "error",
                        message: "For the periodic system quasiparticle correction flag has to be set to <b>gw_expt</b>"
                    };
                    if (!s.isAPeriodicSystem() && field.getValue() === "gw_expt") return {
                        type: "error",
                        message: "For a non-periodic system quasiparticle correction flag should not be set to <b>gw_expt</b>"
                    };
                },
                workflow: "GW"
            },
            // sc_self_energy -- fully self-consistent GW calculation (for clusters only!)
            anaconType: {
                text: "Analytic continuation of self-energy",
                flag: "anacon_type",
                group: 0,
                inputType: "select",
                required: true,
                value: [
                    "",
                    "two-pole",
                    "pade"
                ],
                dataType: "string",
                explanation: `
            Specifies the type of analytical continuation for the self-energy on the real axis:<br>
            <b>two-pole:</b> the normal two-pole fitting (eq. 3.60 in AIMS manual);<br>
            <b>pade:</b> Pade approximation (eq. 3.61 in AIMS manual).<br>
            In practice two-pole fitting is often found to give good performance.
        `,
                workflow: "GW"
            },
            frequencyPoints: {
                text: "Number of frequency points",
                flag: "frequency_points",
                inputType: "input-text",
                required: false,
                explicitInclusion: "checkbox",
                value: 80,
                dataType: "integer",
                explanation: `
            Specifies the number of (imaginary) frequency points for the self-energy calculation.<br>
            <i>Default values</i>:<br> 
            40 for two-pole fitting ('two-pole' in the line above);<br>
            100 for Pade approximation ('pade' in the line above).<br>
        `,
                workflow: "GW"
            },
            GWBandStructure: {
                text: "GW Band Structure",
                inputType: "input-text:1:k-point density",
                dataType: "float",
                required: true,
                explicitInclusion: false,
                explanation: `
            Specifies the k-point density (Number of k-points over &#197<sup>-1</sup>) for the bands calculation in GW framework. 
            Recommendation: 40.
        `,
                constraint: [
                    "qpeCalc",
                    "in",
                    [
                        "gw_expt"
                    ]
                ],
                units: [
                    `k-points &sdot; &#197;`
                ],
                workflow: "GW"
            },
            needDFTInputs: {
                text: "Also prepare DFT inputs",
                inputType: "no-input",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
          A flag that determines whether to prepare inputs for DFT calculations in addition to GW for comparing outputs
        `,
                workflow: "GW"
            }
        }
    },
    {
        label: "Post-processing",
        constraint: (ctx)=>ctx["workflow"] !== "GW" && ctx["workflow"] !== "MD",
        folded: true,
        fields: {
            includeSpinOrbit: {
                text: "Include Spin-Orbit Coupling",
                flag: "include_spin_orbit",
                inputType: "no-input",
                dataType: "none",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
           Activates the perturbative spin-orbit coupling calculation for post-processing output,
           such as for the DOS or Band Structure.
        `,
                workflow: "default"
            },
            bandStructure: {
                text: "Band Structure",
                inputType: "input-text:1:k-point density",
                dataType: "float",
                required: true,
                explicitInclusion: false,
                explanation: `
            Specifies the k-point density (Number of k-points times AA) for the band path. Recommendation: 40.
        `,
                sanity_check: (field, s)=>{
                    if (!s.isAPeriodicSystem()) return {
                        type: "error",
                        message: "You need a <b>periodic</b> system to do a Band structure calculation"
                    };
                },
                units: [
                    `k-points &sdot; &#197;`
                ],
                workflow: "BandStructure"
            },
            dos: {
                flag: "output dos",
                text: "DOS",
                inputType: "input-text:4:Energy start,Energy end,Number of sampling points,Broadening",
                required: false,
                explicitInclusion: "checkbox",
                dataType: [
                    "float",
                    "float",
                    "integer",
                    "float"
                ],
                explanation: `
            Writes the density of states (DOS) to an external file for plotting purposes.<br>
            <b>Energy start:</b> Lower bound of single-particle energy range for which the DOS is given. 
            Recommended value: -20 eV.<br>
            <b>Energy end:</b> Upper bound of single-particle energy range for which the DOS is given. 
            Recommended value: 10 eV.<br>
            <b>Number of sampling points:</b> Number of energy data points for which the DOS is given. 
            Recommended value: 3001<br>
            <b>Broadening:</b> Gaussian broadening applied to obtain a smooth DOS based on the peaks 
            produced by individual states. 0.1 eV is a typical value, although it will create a relatively 
            noticeable broadening<br>
        `,
                units: [
                    "eV",
                    "eV",
                    " ",
                    "eV"
                ],
                workflow: "default"
            },
            dielectric: {
                flag: "compute_dielectric",
                text: "Absorption Function and Dielectric Tensor",
                inputType: "input-text:2:Upper frequency bound,Number of frequency points",
                required: false,
                explicitInclusion: "checkbox",
                dataType: [
                    "float",
                    "integer"
                ],
                explanation: `
           Sets basic parameters for calculating the imaginary and real part of the inter-band and 
           intra-band contribution to the linear dielectric tensor within the random-phase approximation.<br>
           <b>Upper frequency bound</b> is a real valued number. This defines the upper frequency limit 
           (in eV) up to which the dielectric function should be written to files. Choose 10 eV or larger 
           in order to ensure that later transformations, such as Kramers-Kronig, are accurate.<br>
           <b>Number of frequency points</b> for which the dielectric function is calculated should be at least 
           1000 or larger.`,
                units: [
                    "eV",
                    ""
                ],
                workflow: "default"
            },
            hirshfeld: {
                flag: "output                             hirshfeld",
                text: "Hirshfeld analysis output",
                inputType: "no-input",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
            Writes a Hirshfeld analysis (the difference between the molecular and unrelaxed atomic charge densities) 
            for the final geometry of an FHI-aims run.
        `,
                workflow: "default"
            },
            mulliken: {
                flag: "output                             mulliken",
                text: "Mulliken analysis output",
                inputType: "no-input",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
            Produces a Mulliken analysis of the occupation of each atom and its angular momentum channels in terms 
            of the basis used.
        `,
                workflow: "default"
            }
        }
    },
    // End output
    {
        label: "Structure Optimization, Forces, and Stress",
        constraint: (ctx)=>ctx["workflow"] !== "GW" && ctx["workflow"] !== "MD",
        folded: true,
        fields: {
            relaxGeometry: {
                // Only for FHIaims
                flag: "relax_geometry trm",
                //'relax_geometry bfgs',s
                text: "Relax Atom Positions",
                inputType: "input-text",
                value: "5e-3",
                required: false,
                explicitInclusion: "checkbox",
                dataType: "float",
                explanation: `
            Switches on the optimization of the atom positions. The field specifies the maximum residual force component 
            per atom (in eV/AA). FHI-aims uses a trust radius method enhanced version of the BFGS optimization.
        `,
                units: `eV/&#197;`,
                workflow: "default"
            },
            relaxUnitCell: {
                // Only for FHIaims
                flag: "relax_unit_cell",
                text: "Relax Unit Cell",
                inputType: "select",
                value: [
                    "full",
                    "fixed_angles"
                ],
                dataType: "string",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `Switches on the optimization of the lattice vectors. Does not have an effect unless <b>Relax Atom Positions</b> is switched on as well.`,
                constraint: [
                    "relaxGeometry",
                    "included"
                ],
                workflow: "default"
            },
            calculateForces: {
                flag: "compute_forces",
                text: "Calculate Forces",
                inputType: "no-input",
                dataType: "boolean",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
           Activates the calculation of the forces at the end of an SCF cycle, only.
        `,
                workflow: "default"
            },
            calculateStresses: {
                // Only for FHIaims
                flag: "compute_analytical_stress",
                text: "Calculate Stress",
                inputType: "no-input",
                required: false,
                dataType: "boolean",
                explicitInclusion: "checkbox",
                explanation: `
            Switches on the computation of the analytical stress tensor.
        `,
                workflow: "default"
            }
        }
    },
    // End OptimizationForcesStress
    {
        label: "Self-Consistent Field Convergence (optional)",
        folded: true,
        info: "Note: FHI-aims usually determines reliable SCF convergence parameters on its own. We recommend to keep the defaults unless for a very good reason.",
        fields: {
            totalEnergyAccuracy: {
                flag: "sc_accuracy_etot",
                text: "Total Energy Accuracy",
                inputType: "input-text",
                dataType: "float",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
           Sets the SCF convergence criterion for the total energy (in eV).
        `,
                units: `eV`,
                workflow: "default"
            },
            totalDensityAccuracy: {
                flag: "sc_accuracy_rho",
                text: "Total Density Accuracy",
                inputType: "input-text",
                dataType: "float",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
           Sets the SCF convergence criterion for the total electron density (in e/AA^3).
        `,
                units: `e/&#197;<sup>3</sup>`,
                workflow: "default"
            },
            eigenvalueAccuracy: {
                flag: "sc_accuracy_eev",
                text: "Eigenvalue Accuracy",
                inputType: "input-text",
                dataType: "float",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
           Sets the SCF convergence criterion for the sum of the eigenvalues (in eV).
        `,
                units: `eV`,
                workflow: "default"
            },
            forcesAccuracy: {
                flag: "sc_accuracy_forces",
                text: "Accuracy of Forces",
                inputType: "input-text",
                dataType: "float",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
           Sets the SCF convergence criterion for the forces (in eV/AA).
        `,
                units: `eV/&#197;`,
                workflow: "default"
            },
            chargeMixParam: {
                flag: "charge_mix_param",
                text: "Density mixing ratio",
                inputType: "input-text",
                dataType: "float",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
           The ratio by which the updated Kohn-Sham density is mixed with an average of electron densities 
           of previous s.c.f. iterations. For systems with a narrow or vanishing gap, FHI-aims sets a 
           conservative default (0.02) that will converge even difficult systems reliably. If desired, for some
           benign metallic systems, a larger value (e.g., 0.05) may be acceptable and slightly faster. 
           In case of difficulties with converging the s.c.f. cycle, refer to FHI-aims' manual for more details. 
        `,
                workflow: "default"
            }
        }
    } // End numericalAccuracy
];


const $4094003cba99b02a$export$3a46fb01a98ed764 = [
    {
        label: "Basic Settings",
        fields: {
            species: {
                // If there are no flags attributes the field name is taken ('species' in this case)
                text: "Geometry species",
                inputType: "input-text",
                required: true,
                dataType: "string",
                explanation: `
            This field reflects the different species included in your structure.
            The ControlGenerator accepts any valid element of the periodic table.
        `,
                workflow: "default"
            },
            xctype: {
                // XC functional for Exciting
                text: "XC functional",
                inputType: "select",
                required: true,
                dataType: "string",
                value: [
                    "",
                    "pz-lda:LDA_PZ",
                    "pw-lda:LDA_PW",
                    "pbe:GGA_PBE",
                    "pbesol:GGA_PBE_SOL",
                    "pbe0:HYB_PBE0",
                    "hf:EXX"
                ],
                explanation: `
            Select the exchange correlation (XC) functional for your calculation. <br>
            <b>pz-lda:</b> Perdew-Zunger LDA<br>
            <b>pw-lda:</b> Perdew-Wang LDA<br>
            <b>pbe:</b> Perdew-Burke-Ernzerhof GGA<br>
            <b>pbesol:</b> pbe optimized for solids<br>
            <b>pbe0:</b> pbe + hf hybrid functional<br>
            <b>hf:</b> Hartee-Fock method
        `,
                workflow: "default"
            },
            kgrid: {
                flag: "ngridk",
                text: "k-points grid",
                inputType: "input-text:3",
                required: false,
                // REquired in some cases not always
                dataType: [
                    "integer",
                    "integer",
                    "integer"
                ],
                explanation: "Enter the number of k-points along each reciprocal lattice vector.",
                workflow: "default"
            },
            rgkmax: {
                // Only for Exciting code
                text: "rgkmax",
                inputType: "input-text",
                required: true,
                dataType: "float",
                workflow: "default"
            }
        }
    },
    // End BasicSettings
    {
        label: "Output",
        fields: {
            bandStructure: {
                text: "Band Structure",
                inputType: "input-text:1:k-point density",
                dataType: "float",
                required: true,
                explicitInclusion: false,
                explanation: `
            Specifies the k-point density (Number of k-points times AA) for the band path. Recommendation: 40.
        `,
                workflow: "BandStructure"
            },
            dos: {
                text: "DOS",
                inputType: "input-text:3:Energy start,Energy end,Number of sampling points",
                required: false,
                explicitInclusion: "checkbox",
                dataType: [
                    "float",
                    "float",
                    "integer"
                ],
                workflow: "default"
            }
        }
    },
    // End output
    {
        label: "Structure Optimization and Forces",
        fields: {
            relax: {
                // Only for Exciting
                text: "Relax Atom Positions",
                inputType: "no-input",
                required: false,
                explicitInclusion: "checkbox",
                dataType: "none",
                workflow: "default"
            },
            tforce: {
                text: "Calculate Forces",
                inputType: "no-input",
                dataType: "boolean",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
           Activates the calculation of the forces at the end of an SCF cycle.
        `,
                workflow: "default"
            }
        }
    },
    // End OptimizationForcesStress
    {
        label: "Numerical Accuracy",
        fields: {
            epsengy: {
                text: "Total Energy Accuracy",
                inputType: "input-text",
                dataType: "float",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
           Sets the SCF-convergence criteria for the total energy.
        `,
                workflow: "default"
            },
            epschg: {
                text: "Total Density Accuracy",
                inputType: "input-text",
                dataType: "float",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
           Sets the SCF-convergence criteria for the total electron density.
        `,
                workflow: "default"
            },
            epsforcescf: {
                text: "Forces Accuracy",
                inputType: "input-text",
                dataType: "float",
                required: false,
                explicitInclusion: "checkbox",
                explanation: `
           Sets the SCF-convergence criteria for the forces.
        `,
                workflow: "default"
            },
            epspot: {
                // Only exciting
                text: "Effective Potential",
                inputType: "input-text",
                dataType: "float",
                required: false,
                explicitInclusion: "checkbox",
                workflow: "default"
            }
        }
    } // End numericalAccuracy
];


class $81d60a621f10a412$export$2e2bcd8739ae039 {
    constructor(){
        this.FHIaims = (0, $0e488ab2a2fafc52$export$18438811c86f084f);
        this.Exciting = (0, $4094003cba99b02a$export$3a46fb01a98ed764);
    }
}



/**
 * @author Andrey Sobolev <sobolev@fhi.mpg.de>
 *
 * @overview File holding the class describing constraints in control generation form (or any forms, for that case)
 */ class $a5de9592116f38f3$export$2e2bcd8739ae039 {
    /**
   * A Constraints binary tree
   * @param constraintData {Object|Array}
   */ constructor(constraintData){
        this.left = undefined;
        this.condition = undefined;
        this.right = undefined;
        this.leaf = false;
        if (Array.isArray(constraintData)) {
            if (!Array.isArray(constraintData[0])) {
                [this.left, this.condition, this.right] = constraintData;
                this.leaf = true;
            } else switch(constraintData.length){
                case 0:
                    throw "Constraints (if given) should not be empty";
                case 1:
                    const c = new $a5de9592116f38f3$export$2e2bcd8739ae039(constraintData[0]);
                    for(const k in c)this[k] = c[k];
                    break;
                default:
                    this.condition = "and";
                    this.left = new $a5de9592116f38f3$export$2e2bcd8739ae039(constraintData[0]);
                    this.right = new $a5de9592116f38f3$export$2e2bcd8739ae039(constraintData.slice(1));
            }
        } else if (constraintData instanceof Object) {
            let k = Object.keys(constraintData)[0];
            let v = constraintData[k];
            this.condition = k;
            if (!Array.isArray(v) || v.length !== 2) throw "If a condition is given with the Object, it's value has to be an Array with a length of 2";
            this.left = new $a5de9592116f38f3$export$2e2bcd8739ae039(v[0]);
            this.right = new $a5de9592116f38f3$export$2e2bcd8739ae039(v[1]);
        }
        this.masters = this.getMasters();
    }
    /**
   * Auxiliary function aimed at getting the master fields for the constraint
   */ getMasters() {
        if (this.leaf) return new Set([
            this.left
        ]);
        else return new Set([
            ...this.left.getMasters(),
            ...this.right.getMasters()
        ]);
    }
    /**
   * Dispatches events that trigger the constraints
   * @param include {boolean} whether to dispatch an include event
   */ trigger(include = false) {
        if (include) this.masters.forEach((el)=>el.dispatchIncludeEvent(new Event("change")));
        else this.masters.forEach((el)=>el.dispatchEvent(new Event("change")));
    }
    /**
   * Evaluates the condition to boolean value
   * @returns {boolean}
   */ evaluate() {
        if (this.leaf) return this.#evaluateLeaf();
        else return this.#evaluateBranch();
    }
    #evaluateLeaf() {
        switch(this.condition){
            case "==":
                return this.left.getValue() === this.right;
            case "in":
                return this.right.includes(this.left.getValue());
            case "included":
                return this.left.isExplicitlyIncluded();
            default:
                throw "Not implemented";
        }
    }
    #evaluateBranch() {
        switch(this.condition){
            case "and":
                return this.left.evaluate() && this.right.evaluate();
            case "or":
                return this.left.evaluate() || this.right.evaluate();
            default:
                throw "Not implemented";
        }
    }
}


/**
 * @author Andrey Sobolev
 * @year 2023
 *
 * @overview File holding the class for the extra control.in parameters code and table
 */ 
const $9df7e97ee6fe1617$export$9c35f1cb8fe66314 = `<svg viewBox="0 0 512 512" width="16">
        <path d="M64 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H64zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 
        0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM464 
        32H344l-9.4-18.7A24 24 0 0 0 313.1 0H198.8a23.72 23.72 0 0 0-21.4 13.3L168 32H48A16 16 0 0 0 32 
        48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"></path>
      </svg>`;
const $9df7e97ee6fe1617$export$e3e86e4263fb9f0d = `<svg viewBox="0 0 512 512" width="16">
        <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 
        12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 
        12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"></path>
      </svg>`;
class $9df7e97ee6fe1617$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(className){
        //
        super("div", ".Form " + className);
        this.setHTML(`
      <div style="display:flex">
        <div class="info">Here any non-essential keywords can be added to control.in. Please beware that 
        there are no sanity checks for these and use with discretion.</div>
      </div>
      <!--  Bootstrap table-->
      <div class="extras-table">
          <table>
            <colgroup>
              <col style="width:7%">
              <col style="width:43%">
              <col style="width:37%">
              <col style="width:13%">
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th>Key</th>
                <th>Value</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
            <tr>
              <td></td>
              <td><input class="key-input" type="text" name="key" placeholder="output"></td>
              <td><input class="value-input" type="text" name="value" placeholder="json_log"></td>
              <td><button class="add-data" title="Add New Data">${$9df7e97ee6fe1617$export$e3e86e4263fb9f0d}</button></td>
            </tr>
            </tbody>
        </table>
      </div>`);
        this.table = this.e.querySelector(".extras-table table");
        let addButton = this.getElement("button.add-data");
        addButton.addEventListener("click", (_)=>{
            let keyInput = this.e.querySelector("input.key-input");
            let valueInput = this.e.querySelector("input.value-input");
            if (keyInput.value === "") return;
            const nRows = this.table.rows.length;
            let newRow = this.table.insertRow(nRows - 1);
            newRow.insertCell(0);
            newRow.insertCell(1).appendChild(document.createTextNode(keyInput.value));
            newRow.insertCell(2).appendChild(document.createTextNode(valueInput.value));
            let buttonDOM = document.createElement("template");
            buttonDOM.innerHTML = `<button class="delete-data" title="Remove keyword">${$9df7e97ee6fe1617$export$9c35f1cb8fe66314}</button>`;
            newRow.insertCell(3).appendChild(buttonDOM.content);
            const deleteButton = newRow.querySelector("button");
            deleteButton.addEventListener("click", (ev)=>{
                this.table.deleteRow(ev.target.closest("tr").rowIndex);
            });
            keyInput.value = valueInput.value = "";
        });
    }
    /** Finds and returns the data stored in the Extras table
   *
   * @returns {Object}
   */ getData() {
        const trueValues = [
            "",
            "true",
            ".true.",
            "t"
        ];
        const falseValues = [
            ,
            "false",
            ".false.",
            "f"
        ];
        let data = {};
        // output keys stack in array; throw them away afterwards if there are none
        data["output"] = [];
        const rows = Array.from(this.table.rows);
        for (let row of rows.slice(1, rows.length - 1)){
            const key = row.cells[1].innerText.toLowerCase();
            const value = row.cells[2].innerText.toLowerCase();
            if (key === "output") data[key].push(value);
            else if (trueValues.includes(value)) data[key] = true;
            else if (falseValues.includes(value)) data[key] = false;
            else data[key] = value;
        }
        if (data["output"].length === 0) delete data["output"];
        return data;
    }
}



class $0eda6e4362e8054a$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("div", "#ControlGeneratorMod");
        this.setHTML(`
      <h1> Control Generator </h1>

      <div class="content">

        <div class="form-accordion" > </div>

        <div class="download-input-files-button">
          <a class="download-input-files-link" download="input_files.tar">
            <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($71de690891678265$exports)))}" alt="Download"/>Generate and download input file(s)
          </a>
        </div>

      </div>
    `);
        this.allFields = new (0, $81d60a621f10a412$export$2e2bcd8739ae039)(); // All available fields
        this.fields = []; // The effective fields (data) for this instance
        this.forms = []; // There is a form per accordion section
        this.workflow = undefined;
        this.formAccordion = new (0, $b17664ddee69cf4f$export$2e2bcd8739ae039)("control-gen-accordion");
        this.getElement(".form-accordion").appendChild(this.formAccordion.e);
        this.button = this.getElement(".download-input-files-button");
        this.downloadLink = this.getElement(".download-input-files-link");
        this.button.addEventListener("click", (e)=>{
            e.preventDefault(); // This prevents the regular link behavior (the link is empty at that time)
            // because we want it after the request callback when it is linked to the tar file
            this.requestInputFiles((tarFiles)=>{
                this.downloadLink.href = window.URL.createObjectURL(new Blob([
                    tarFiles
                ], {
                    type: "application/x-tar"
                }));
                // The first time the user clicks on the link the tar file is got from the server,
                // the link href is still empty so no file to download is shown to the user
                // therefore a new click event is created and issued on the link to get the download offer
                this.downloadLink.dispatchEvent(new MouseEvent("click"));
            });
        });
        this.standalone = true; // standalone module (not inside a workflow)
    }
    /**
   * Initialization method
   * @param  {string} workflow A name of the workflow  for which the control generator form is built
   */ init(workflow) {
        this.buildAccordion(workflow);
    }
    /**
   * Builds the accordion UI component
   */ buildAccordion(workflow) {
        // reset
        // console.log(workflow);
        this.workflow = workflow;
        workflow = workflow ? workflow : "default";
        // console.log('buildAccordion',workflow)
        this.fields = {};
        this.forms = [];
        this.constraints = {};
        this.functions = {};
        this.sanityChecks = [];
        this.formAccordion.reset();
        $63ecf2f4b2cde17e$export$91006f7f52398ef9("right", -25);
        let myCode = $1ad59a1a7edcd764$export$9a0a9c75ccef13fb();
        let myGroups = (0, $4aa0937dc0e8c453$export$b7d58db314e0ac27)(this.allFields[myCode]);
        myGroups.forEach((group, i)=>{
            let form = new (0, $a68e8293ba5aab8f$export$2e2bcd8739ae039)("control-gen-form");
            form.parent = this.formAccordion;
            form.idx = i;
            form.disableUserMsg();
            group = this.collectFunctionalValues(i, group);
            if (group.info) form.addInfo(group.info);
            for(const prop in group.fields){
                let data = group.fields[prop];
                if (data.workflow === workflow || data.workflow === "default") {
                    // collect data values given as functions
                    data = this.collectFunctionalValues(prop, data);
                    form.addField(prop, data.text, data.inputType, data.value, data.dataType, i, !!data.required, data.explicitInclusion, data.units, data.explanation);
                    this.fields[prop] = form.fieldMap.get(prop);
                    // get constraints; clone them as they'll be changed in-place
                    if (data.constraint) this.constraints[prop] = structuredClone(data.constraint);
                }
            }
            this.forms.push(form);
            this.formAccordion.setSection(group.label, form.e);
            if (form.getFieldNum() === 0) // The empty sections are not shown
            this.formAccordion.hideSection(form.idx);
            if (group.folded) this.formAccordion.foldSection(form.idx);
        });
        // the last form in accordion
        this.extrasTable = new (0, $9df7e97ee6fe1617$export$2e2bcd8739ae039)("control-gen-form");
        this.formAccordion.setSection("Extra keywords", this.extrasTable.e);
        // prepare and set constraints
        for (let [name, c] of Object.entries(this.constraints)){
            const constraint = new (0, $a5de9592116f38f3$export$2e2bcd8739ae039)(this.#prepareConstraint(c));
            let f = this.fields[name];
            f.setConstraint(constraint);
        }
    }
    /**
   * Stores the values given by functions in instance attribute. Changes them to defaults until no structure is set
   * @param name {string | number}
   * @param data {object}
   */ collectFunctionalValues(name, data) {
        for (const [key, field] of Object.entries(data))if (field instanceof Function) {
            this.functions[`${name}.${key}`] = field;
            delete data[key];
        }
        return data;
    }
    /**
   * Prepare constraints, setting the masters' names to actual master fields
   * @param constraintData {Object|Array}
   */ #prepareConstraint(constraintData) {
        if (Array.isArray(constraintData)) {
            if (Array.isArray(constraintData[0])) for(let i = 0; i < constraintData.length; i++)constraintData[i][0] = this.fields[constraintData[i][0]];
            else constraintData[0] = this.fields[constraintData[0]];
            return constraintData;
        } else if (constraintData instanceof Object) {
            let [k, v] = Object.entries(constraintData)[0];
            return {
                [k]: this.#prepareConstraint(v)
            };
        } else return [];
    }
    /**
   * Provides an input structure. The species filed is filled up
   * Optional use for the instance. Used in instances inside workflows.
   * @param {Structure} structure
   */ setStructure(structure) {
        this.standalone = false;
        this.button.style.display = "none";
        this.sanityChecks = []; // sanity check is a check of a field against the structure
        // this.periodicSystem = structure.isAPeriodicSystem()
        for (let [name, f] of Object.entries(this.functions)){
            const [field_name, subfield] = name.split(".");
            // if field_name is a number, it refers to a form, otherwise it refers to a field
            let field = parseInt(field_name) ? this.forms[parseInt(field_name)] : this.fields[field_name];
            // use context for hiding fields
            let context = {
                "structure": structure,
                "workflow": this.workflow
            };
            switch(subfield){
                case "value":
                    field.setValue(f(structure));
                    break;
                case "info":
                    field.addInfo(f(structure));
                    break;
                case "constraint":
                    field.setConstraint(f(context));
                    break;
                case "sanity_check":
                    this.sanityChecks.push({
                        field: field,
                        check: (field)=>f(field, structure)
                    });
            }
        }
        this.structure = {
            cell: structure.latVectors,
            positions: structure.atoms,
            info: structure.structureInfo
        };
    }
    /**
   * Runs the sanity check functions found in the fields' dictionary; collects the results
   * @returns {(boolean|string[])[]}
   */ runSanityChecks() {
        let messages = [];
        let isSane = true;
        for (let check of this.sanityChecks){
            const field = check["field"], checkFunction = check["check"];
            const checkResult = checkFunction(field);
            if (checkResult === undefined) continue;
            if (checkResult["type"] === "error") isSane = false;
            messages.push(checkResult);
        }
        return [
            isSane,
            messages
        ];
    }
    /**
   * Updates the component for a code change (application level event)
   * @param  {string} code
   */ updateForCode(code) {
        const speciesFieldValue = this.forms[0].getField("species").getValue();
        this.buildAccordion(this.workflow);
        this.forms[0].getField("species").setValue(speciesFieldValue);
        this.downloadLink.href = undefined;
    }
    /**
   * Updates the component for a setting change (application level event)
   * @param  {object} newSettings
   */ updateSettings(newSettings) {
        console.log("new setting! ", newSettings);
    }
    /**
   * Goes through the field getting the values entered and builds a json object
   * representing a server request to get an input file
   * @return {object}
   */ getInputFilesRequestJson() {
        /* Convenience lines for development
    this.forms[0].getField('species').value = 'H'
    if (AppState.isExcitingCode()) this.forms[0].getField('xctype').value = 'EXX' // Exciting
    else this.forms[0].getField('xc').value = 'hf' // FHIAims
    this.forms[0].getField('kgrid')[0].value = 9;  this.forms[0].getField('kgrid')[1].value = 9;  this.forms[0].getField('kgrid')[2].value = 9
    if (AppState.isExcitingCode())  this.forms[0].getField('rgkmax').value = 7 // Exciting
    else this.forms[0].getField('basisSettings').value = 'light' // FHIAims
    */ // getting the results from the forms
        let namesValues = Object.assign({}, ...this.forms.map((form)=>form.getFieldsNameValue()));
        // SPECIES FIELD. It's assumed the species field is present
        let allSpecies = namesValues.species;
        let species = [];
        if (allSpecies.includes(",")) allSpecies.split(",").forEach((s)=>species.push(s.trim()));
        else allSpecies.split(" ").forEach((s)=>species.push(s.trim()));
        for(let i = 0; i < species.length; i++)if ((0, $e64b414b86723191$export$e2a301f55f143803).getSpeciesAtomicNumber(species[i]) === 0) {
            this.forms[0].markField("species", 0);
            $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("Some species is not valid: " + species[i]); //this.form.userMsg.innerHTML = 'Some species is not valid'
            return;
        }
        namesValues.species = species;
        // A new object is built with the field flags as object keys
        let flagsValues = {};
        let myCode = $1ad59a1a7edcd764$export$9a0a9c75ccef13fb();
        let allFields = Object.assign({}, ...this.allFields[myCode].map((el)=>el.fields));
        for(let fieldName in namesValues)if (allFields[fieldName] && allFields[fieldName]["flag"]) flagsValues[allFields[fieldName]["flag"]] = namesValues[fieldName];
        else flagsValues[fieldName] = namesValues[fieldName];
        // update flagsValues object with the data from extras
        Object.assign(flagsValues, this.extrasTable.getData());
        // log('inputFilesRequestJson', inputFilesRequestJson)
        return {
            code: $1ad59a1a7edcd764$export$9a0a9c75ccef13fb(),
            structure: this.structure,
            form: flagsValues
        };
    }
    /**
   * Fetches a server request asking for a tar file packaging a set of input files
   * That is passed in a listener
   * @param {function} listener
   */ async requestInputFiles(listener) {
        if (!this.getInputFilesRequestJson()) return;
        let response = await fetch("/generate-control-in", {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(this.getInputFilesRequestJson())
        });
        if (response.ok) {
            // File or server controlled errors
            // It's needed to get the text because of the FileNotFoundError checking
            let tarFiles = await response.text(); //await response.arrayBuffer()
            if (tarFiles === "FileNotFoundError") $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("Species defaults not found. Check your species. Not all species are defined for <i>intermediate</i>.");
            else listener(tarFiles); //, requestJson)
        } else // Unknown server ERROR
        $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("Unknown server ERROR ");
    }
    /** Runs sanity and validity checks on the form
   *
   * @return {boolean}
   */ runChecks() {
        // Run validity checks. If any of the forms is not validated the function returns
        let isValid = true;
        for(let i = 0; i < this.forms.length; i++)isValid = this.forms[i].validate() && isValid;
        if (!isValid) {
            $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("There are some fields required to generate the control.in file not filled");
            return false;
        }
        // } else UserMsgBox.setError('')
        // Run sanity checks including the given structure
        let [isSane, messages] = this.runSanityChecks();
        for (const message of messages)if (message["type"] === "error") $6ff060c6e60f738f$export$b8d0bb2aa0adefe5(message["message"]);
        else $6ff060c6e60f738f$export$ddf018cf7a99d36f(message["message"]);
        return isSane;
    }
    async requestDownloadInfo(listener) {
        if (!this.runChecks()) return;
        //log('DownloadInputFilesPage requestInputFiles', requestJson)
        if (!this.getInputFilesRequestJson()) return;
        let response = await fetch("/get-download-info", {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(this.getInputFilesRequestJson())
        });
        if (response.ok) {
            // File or server controlled errors
            // It's needed to get the text because of the FileNotFoundError checking
            let downloadInfo = await response.text(); //await response.arrayBuffer()
            console.log(downloadInfo);
            listener(downloadInfo); //, requestJson)
        } else // Unknown server ERROR
        $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("Unknown server ERROR ");
    }
}


/**
 * @author Iker Hurtado
 *
 * @overview Workflow configuration file
 */ // Predefined workflow steps
const $42aee24e9c9e61b5$var$StructureBuilderStep = {
    title: "Create or upload geometry",
    nextButtonText: "Save geometry & ",
    component: "StructureBuilder"
};
const $42aee24e9c9e61b5$var$ControlGeneratorStep = {
    title: "Specify calculation control parameters",
    nextButtonText: "Save control info & ",
    component: "ControlGenerator:default"
};
const $42aee24e9c9e61b5$var$ControlGeneratorBSDOSStep = {
    title: "Specify calculation control parameters",
    nextButtonText: "Save control info & ",
    component: "ControlGenerator:BandStructure"
};
const $42aee24e9c9e61b5$var$ControlGeneratorGWStep = {
    title: "Specify calculation control parameters",
    nextButtonText: "Save control info & ",
    component: "ControlGenerator:GW"
};
const $42aee24e9c9e61b5$var$ControlGeneratorMDStep = {
    title: "Specify calculation control parameters",
    nextButtonText: "Save control info & ",
    component: "ControlGenerator:MD"
};
const $42aee24e9c9e61b5$var$WorkflowDesignerStep = {
    title: "Design a workflow",
    nextButtonText: "Save a workflow & ",
    component: "WorkflowDesigner"
};
const $42aee24e9c9e61b5$var$DownloadInputFilesPageStep = {
    title: "Download the input files and start your calculation",
    nextButtonText: "",
    component: "DownloadInputFilesPage"
};
const $42aee24e9c9e61b5$var$OutputAnalyzerStep = {
    title: "Upload the output file",
    //  nextButtonText - No next button
    component: "OutputAnalyzer"
};
const $42aee24e9c9e61b5$export$9bf3ee7c0a1089c5 = {
    SimpleCalculation: {
        text: "Simple Calculation",
        steps: [
            $42aee24e9c9e61b5$var$StructureBuilderStep,
            $42aee24e9c9e61b5$var$ControlGeneratorStep,
            $42aee24e9c9e61b5$var$DownloadInputFilesPageStep,
            $42aee24e9c9e61b5$var$OutputAnalyzerStep
        ]
    },
    BandStructure: {
        text: "Band Structure",
        steps: [
            $42aee24e9c9e61b5$var$StructureBuilderStep,
            $42aee24e9c9e61b5$var$ControlGeneratorBSDOSStep,
            $42aee24e9c9e61b5$var$DownloadInputFilesPageStep,
            $42aee24e9c9e61b5$var$OutputAnalyzerStep
        ]
    },
    GWCalculation: {
        text: "GW Calculation",
        steps: [
            $42aee24e9c9e61b5$var$StructureBuilderStep,
            $42aee24e9c9e61b5$var$ControlGeneratorGWStep,
            $42aee24e9c9e61b5$var$DownloadInputFilesPageStep,
            $42aee24e9c9e61b5$var$OutputAnalyzerStep
        ]
    },
    MDCalculation: {
        text: "MD Calculation",
        steps: [
            $42aee24e9c9e61b5$var$StructureBuilderStep,
            $42aee24e9c9e61b5$var$ControlGeneratorMDStep,
            $42aee24e9c9e61b5$var$DownloadInputFilesPageStep,
            $42aee24e9c9e61b5$var$OutputAnalyzerStep
        ]
    },
    Designed: {
        text: "Designed",
        steps: [
            $42aee24e9c9e61b5$var$WorkflowDesignerStep,
            $42aee24e9c9e61b5$var$DownloadInputFilesPageStep,
            $42aee24e9c9e61b5$var$OutputAnalyzerStep
        ]
    }
};



/**
 * @author Iker Hurtado
 *
 * @overview File holding the Settings UI component
 */ 




class $33c426b17ad0a12d$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("div", ".Settings");
        this.setHTML(`
        <div style="text-align: center">APPLICATION SETTINGS</div>
    `);
        this.form = new (0, $a68e8293ba5aab8f$export$2e2bcd8739ae039)("settings-form");
        this.form.disableUserMsg();
        this.form.addField("decimalDigits", "Number of decimal digits", "input-text", (0, $e64b414b86723191$export$e2a301f55f143803).settings.decimalDigits, "integer", 0, true);
        this.form.addField("symmetryThreshold", "Symmetry Threshold", "input-text", (0, $e64b414b86723191$export$e2a301f55f143803).settings.symmetryThreshold, "float", 0, true, false, "\xc5");
        this.button = this.form.addButton("UPDATE");
        this.e.appendChild(this.form.e);
        this.button.addEventListener("click", (_)=>{
            (0, $e64b414b86723191$export$e2a301f55f143803).settings = this.form.getFieldsNameValue();
            $1ad59a1a7edcd764$export$f558026a994b6051((0, $e64b414b86723191$export$e2a301f55f143803).settings);
            $9d993874406c4873$export$af4939467128bcd0();
        });
    }
}


/**
 * @author Iker Hurtado
 *
 * @fileOverview File holding the Workflow  module main class
 */ 




/**
 * @author Iker Hurtado
 *
 * @fileoverview File holding the DownloadInputFilesPage UI component
 */ 

class $5ad55c3ff0fdeb5f$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("div", ".DownloadInputFilesPage");
        this.setHTML(`
      <div style="display: block;">
        <div class="download-info"></div>
      </div>
      <div>
      <a class="download-input-files-link" download="input_files.tar">
          <img style="vertical-align: middle; padding: 0 10px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($71de690891678265$exports)))}" />Download the input files
      </a>
      </div>
    `);
    }
    /**
   * Does nothing but it's mandatory for every workflow page
   */ init() {}
    /**
   * Sets the input files tar bundle on the download link
   * @param {File} filesTar
   */ setInputFiles(filesTar) {
        this.getElement("a.download-input-files-link").href = window.URL.createObjectURL(new Blob([
            filesTar
        ], {
            type: "application/x-tar"
        }));
    }
    setDownloadInfo(downloadInfo) {
        let di = JSON.parse(downloadInfo);
        //console.log(di);
        let html = "";
        for (var [key, entry] of Object.entries(di.DownloadInputFilesPage))entry.split("\n").forEach((line)=>{
            html += `${line} <br>`;
        });
        /*html += `<h3>References</h3>`
    let i = 0
    di.references.forEach(ref => {
      i += 1
      html += `<h4> <a href="${ref.packageURL}" target="_blank">${ref.packageName}</a></h4>`
      html += `[${i}] ${ref.citeText} <br>`
      html += `    doi: <a href="${ref.doiUrl}" target="_blank">${ref.doiUrl}</a> <br>`
    })
    console.log(html);*/ this.getElement(".download-info").innerHTML = html;
    }
    /**
   * Updates the component for a code change (application level event)
   * @param  {string} code
   */ updateForCode(code) {}
    /**
   * Updates the component for a setting change (application level event)
   * @param  {object} newSettings 
   */ updateSettings(newSettings) {}
}


/**
 * @author Andrey Sobolev
 *
 * @overview A workflow designer UI component based on the Sequential Workflow Designer
 * (https://github.com/nocode-js/sequential-workflow-designer/)
 */ 
/**
 * @author Andrey Sobolev
 *
 * @overview A designed workflow class based on the Sequential Workflow Designer
 * (https://github.com/nocode-js/sequential-workflow-designer/)
 */ const $80d696a83b36994b$var$defaultResolvers = [
    $80d696a83b36994b$var$sequentialResolver,
    $80d696a83b36994b$var$branchedResolver
];
function $80d696a83b36994b$var$branchedResolver(step) {
    const branches = step.branches;
    if (branches) return {
        type: $80d696a83b36994b$export$e70eb8b76bb64866.branches,
        items: branches
    };
    return null;
}
function $80d696a83b36994b$var$sequentialResolver(step) {
    const sequence = step.sequence;
    if (sequence) return {
        type: $80d696a83b36994b$export$e70eb8b76bb64866.sequence,
        items: sequence
    };
    return null;
}
var $80d696a83b36994b$export$e70eb8b76bb64866;
(function(StepChildrenType) {
    StepChildrenType[StepChildrenType["sequence"] = 1] = "sequence";
    StepChildrenType[StepChildrenType["branches"] = 2] = "branches";
})($80d696a83b36994b$export$e70eb8b76bb64866 || ($80d696a83b36994b$export$e70eb8b76bb64866 = {}));
class $80d696a83b36994b$export$5d7b81b9ee07c001 {
    constructor(resolvers){
        this.resolvers = resolvers ? resolvers.concat($80d696a83b36994b$var$defaultResolvers) : $80d696a83b36994b$var$defaultResolvers;
    }
    /**
     * Returns children of the step. If the step doesn't have children, returns null.
     * @param step The step.
     */ getChildren(step) {
        const count = this.resolvers.length;
        for(let i = 0; i < count; i++){
            const result = this.resolvers[i](step);
            if (result) return result;
        }
        return null;
    }
    /**
     * Returns the parents of the step or the sequence.
     * @param definition The definition.
     * @param needle The step, stepId or sequence to find.
     * @returns The parents of the step or the sequence.
     */ getParents(definition, needle) {
        const result = [];
        let searchSequence = null;
        let searchStepId = null;
        if (Array.isArray(needle)) searchSequence = needle;
        else if (typeof needle === "string") searchStepId = needle;
        else searchStepId = needle.id;
        if (this.find(definition.sequence, searchSequence, searchStepId, result)) {
            result.reverse();
            return result.map((item)=>{
                return typeof item === "string" ? item : item.step;
            });
        }
        throw new Error(searchStepId ? `Cannot get parents of step: ${searchStepId}` : "Cannot get parents of sequence");
    }
    findParentSequence(definition, stepId) {
        const result = [];
        if (this.find(definition.sequence, null, stepId, result)) return result[0];
        return null;
    }
    getParentSequence(definition, stepId) {
        const result = this.findParentSequence(definition, stepId);
        if (!result) throw new Error(`Cannot find step by id: ${stepId}`);
        return result;
    }
    findById(definition, stepId) {
        const result = this.findParentSequence(definition, stepId);
        return result ? result.step : null;
    }
    getById(definition, stepId) {
        return this.getParentSequence(definition, stepId).step;
    }
    forEach(sequenceOrDefinition, callback) {
        const sequence = Array.isArray(sequenceOrDefinition) ? sequenceOrDefinition : sequenceOrDefinition.sequence;
        this.iterate(sequence, callback);
    }
    find(sequence, needSequence, needStepId, result) {
        if (needSequence && sequence === needSequence) return true;
        const count = sequence.length;
        for(let index = 0; index < count; index++){
            const step = sequence[index];
            if (needStepId && step.id === needStepId) {
                result.push({
                    step: step,
                    index: index,
                    parentSequence: sequence
                });
                return true;
            }
            const children = this.getChildren(step);
            if (children) switch(children.type){
                case $80d696a83b36994b$export$e70eb8b76bb64866.sequence:
                    {
                        const parentSequence = children.items;
                        if (this.find(parentSequence, needSequence, needStepId, result)) {
                            result.push({
                                step: step,
                                index: index,
                                parentSequence: parentSequence
                            });
                            return true;
                        }
                    }
                    break;
                case $80d696a83b36994b$export$e70eb8b76bb64866.branches:
                    {
                        const branches = children.items;
                        const branchNames = Object.keys(branches);
                        for (const branchName of branchNames){
                            const parentSequence = branches[branchName];
                            if (this.find(parentSequence, needSequence, needStepId, result)) {
                                result.push(branchName);
                                result.push({
                                    step: step,
                                    index: index,
                                    parentSequence: parentSequence
                                });
                                return true;
                            }
                        }
                    }
                    break;
                default:
                    throw new Error(`Step children type ${children.type} is not supported`);
            }
        }
        return false;
    }
    iterate(sequence, callback) {
        const count = sequence.length;
        for(let index = 0; index < count; index++){
            const step = sequence[index];
            if (callback(step, index, sequence) === false) return false;
            const children = this.getChildren(step);
            if (children) switch(children.type){
                case $80d696a83b36994b$export$e70eb8b76bb64866.sequence:
                    {
                        const childSequence = children.items;
                        if (this.iterate(childSequence, callback) === false) return false;
                    }
                    break;
                case $80d696a83b36994b$export$e70eb8b76bb64866.branches:
                    {
                        const branches = children.items;
                        const branchNames = Object.keys(branches);
                        for (const branchName of branchNames){
                            const parentSequence = branches[branchName];
                            if (this.iterate(parentSequence, callback) === false) return false;
                        }
                    }
                    break;
                default:
                    throw new Error(`Step children type ${children.type} is not supported`);
            }
        }
        return true;
    }
}


class $b668c8ebb790e355$export$83c961469296adb8 {
    constructor(state, historyController, definitionModifier, viewportApi){
        this.state = state;
        this.historyController = historyController;
        this.definitionModifier = definitionModifier;
        this.viewportApi = viewportApi;
    }
    /**
     * @deprecated Don't use this method
     */ subscribe(handler) {
        // TODO: this should be refactored
        this.state.onIsReadonlyChanged.subscribe(handler);
        this.state.onSelectedStepIdChanged.subscribe(handler);
        this.state.onIsDragDisabledChanged.subscribe(handler);
        if (this.isUndoRedoSupported()) this.state.onDefinitionChanged.subscribe(handler);
    }
    resetViewport() {
        this.viewportApi.resetViewport();
    }
    zoomIn() {
        this.viewportApi.zoom(true);
    }
    zoomOut() {
        this.viewportApi.zoom(false);
    }
    isDragDisabled() {
        return this.state.isDragDisabled;
    }
    toggleIsDragDisabled() {
        this.state.toggleIsDragDisabled();
    }
    isUndoRedoSupported() {
        return !!this.historyController;
    }
    tryUndo() {
        if (this.canUndo() && this.historyController) {
            this.historyController.undo();
            return true;
        }
        return false;
    }
    canUndo() {
        return !!this.historyController && this.historyController.canUndo() && !this.state.isReadonly && !this.state.isDragging;
    }
    tryRedo() {
        if (this.canRedo() && this.historyController) {
            this.historyController.redo();
            return true;
        }
        return false;
    }
    canRedo() {
        return !!this.historyController && this.historyController.canRedo() && !this.state.isReadonly && !this.state.isDragging;
    }
    tryDelete() {
        if (this.canDelete() && this.state.selectedStepId) {
            this.definitionModifier.tryDelete(this.state.selectedStepId);
            return true;
        }
        return false;
    }
    canDelete() {
        return !!this.state.selectedStepId && !this.state.isReadonly && !this.state.isDragging && this.definitionModifier.isDeletable(this.state.selectedStepId);
    }
}
class $b668c8ebb790e355$export$298d5abb39333987 {
    constructor(){
        this.listeners = [];
    }
    subscribe(listener) {
        this.listeners.push(listener);
    }
    unsubscribe(listener) {
        const index = this.listeners.indexOf(listener);
        if (index >= 0) this.listeners.splice(index, 1);
        else throw new Error("Unknown listener");
    }
    forward(value) {
        if (this.listeners.length > 0) this.listeners.forEach((listener)=>listener(value));
    }
    count() {
        return this.listeners.length;
    }
}
class $b668c8ebb790e355$export$9b781de7bf37bf48 {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    add(v) {
        return new $b668c8ebb790e355$export$9b781de7bf37bf48(this.x + v.x, this.y + v.y);
    }
    subtract(v) {
        return new $b668c8ebb790e355$export$9b781de7bf37bf48(this.x - v.x, this.y - v.y);
    }
    multiplyByScalar(s) {
        return new $b668c8ebb790e355$export$9b781de7bf37bf48(this.x * s, this.y * s);
    }
    divideByScalar(s) {
        return new $b668c8ebb790e355$export$9b781de7bf37bf48(this.x / s, this.y / s);
    }
    round() {
        return new $b668c8ebb790e355$export$9b781de7bf37bf48(Math.round(this.x), Math.round(this.y));
    }
    distance() {
        return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2));
    }
}
var $b668c8ebb790e355$export$afd229a7a55e23c2;
(function(DefinitionChangeType) {
    DefinitionChangeType[DefinitionChangeType["stepNameChanged"] = 1] = "stepNameChanged";
    DefinitionChangeType[DefinitionChangeType["stepPropertyChanged"] = 2] = "stepPropertyChanged";
    DefinitionChangeType[DefinitionChangeType["stepChildrenChanged"] = 3] = "stepChildrenChanged";
    DefinitionChangeType[DefinitionChangeType["stepDeleted"] = 4] = "stepDeleted";
    DefinitionChangeType[DefinitionChangeType["stepMoved"] = 5] = "stepMoved";
    DefinitionChangeType[DefinitionChangeType["stepInserted"] = 6] = "stepInserted";
    DefinitionChangeType[DefinitionChangeType["globalPropertyChanged"] = 7] = "globalPropertyChanged";
    DefinitionChangeType[DefinitionChangeType["rootReplaced"] = 8] = "rootReplaced";
})($b668c8ebb790e355$export$afd229a7a55e23c2 || ($b668c8ebb790e355$export$afd229a7a55e23c2 = {}));
class $b668c8ebb790e355$export$cc4be4ee48b28947 {
    constructor(definition, isReadonly, isToolboxCollapsed, isEditorCollapsed){
        this.definition = definition;
        this.isReadonly = isReadonly;
        this.isToolboxCollapsed = isToolboxCollapsed;
        this.isEditorCollapsed = isEditorCollapsed;
        this.onViewportChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        this.onSelectedStepIdChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        this.onFolderPathChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        this.onIsReadonlyChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        this.onIsDraggingChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        this.onIsDragDisabledChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        this.onDefinitionChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        this.onIsToolboxCollapsedChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        this.onIsEditorCollapsedChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        this.viewport = {
            position: new $b668c8ebb790e355$export$9b781de7bf37bf48(0, 0),
            scale: 1
        };
        this.selectedStepId = null;
        this.folderPath = [];
        this.isDragging = false;
        this.isDragDisabled = false;
    }
    setSelectedStepId(stepId) {
        if (this.selectedStepId !== stepId) {
            this.selectedStepId = stepId;
            this.onSelectedStepIdChanged.forward(stepId);
        }
    }
    pushStepIdToFolderPath(stepId) {
        this.folderPath.push(stepId);
        this.onFolderPathChanged.forward(this.folderPath);
    }
    setFolderPath(path) {
        this.folderPath = path;
        this.onFolderPathChanged.forward(path);
    }
    tryGetLastStepIdFromFolderPath() {
        return this.folderPath.length > 0 ? this.folderPath[this.folderPath.length - 1] : null;
    }
    setDefinition(definition) {
        this.definition = definition;
        this.notifyDefinitionChanged($b668c8ebb790e355$export$afd229a7a55e23c2.rootReplaced, null);
    }
    notifyDefinitionChanged(changeType, stepId) {
        this.onDefinitionChanged.forward({
            changeType: changeType,
            stepId: stepId
        });
    }
    setViewport(viewport) {
        this.viewport = viewport;
        this.onViewportChanged.forward(viewport);
    }
    setIsReadonly(isReadonly) {
        if (this.isReadonly !== isReadonly) {
            this.isReadonly = isReadonly;
            this.onIsReadonlyChanged.forward(isReadonly);
        }
    }
    setIsDragging(isDragging) {
        if (this.isDragging !== isDragging) {
            this.isDragging = isDragging;
            this.onIsDraggingChanged.forward(isDragging);
        }
    }
    toggleIsDragDisabled() {
        this.isDragDisabled = !this.isDragDisabled;
        this.onIsDragDisabledChanged.forward(this.isDragDisabled);
    }
    setIsToolboxCollapsed(isCollapsed) {
        if (this.isToolboxCollapsed !== isCollapsed) {
            this.isToolboxCollapsed = isCollapsed;
            this.onIsToolboxCollapsedChanged.forward(isCollapsed);
        }
    }
    setIsEditorCollapsed(isCollapsed) {
        if (this.isEditorCollapsed !== isCollapsed) {
            this.isEditorCollapsed = isCollapsed;
            this.onIsEditorCollapsedChanged.forward(isCollapsed);
        }
    }
}
class $b668c8ebb790e355$export$1e2eb70c93855705 {
    static svg(name, attributes) {
        const element = document.createElementNS("http://www.w3.org/2000/svg", name);
        if (attributes) $b668c8ebb790e355$export$1e2eb70c93855705.attrs(element, attributes);
        return element;
    }
    static translate(element, x, y) {
        element.setAttribute("transform", `translate(${x}, ${y})`);
    }
    static attrs(element, attributes) {
        Object.keys(attributes).forEach((name)=>{
            const value = attributes[name];
            element.setAttribute(name, typeof value === "string" ? value : value.toString());
        });
    }
    static element(name, attributes) {
        const element = document.createElement(name);
        if (attributes) $b668c8ebb790e355$export$1e2eb70c93855705.attrs(element, attributes);
        return element;
    }
    static toggleClass(element, isEnabled, className) {
        if (isEnabled) element.classList.add(className);
        else element.classList.remove(className);
    }
}
// Source: https://fonts.google.com/icons or https://github.com/google/material-design-icons
class $b668c8ebb790e355$export$4f13f83fd8bb1dac {
    static appendPath(parent, pathClassName, d, size) {
        const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g");
        const scale = size / 48;
        const path = $b668c8ebb790e355$export$1e2eb70c93855705.svg("path", {
            d: d,
            class: pathClassName,
            transform: `scale(${scale})`
        });
        g.appendChild(path);
        parent.appendChild(g);
        return g;
    }
    static createSvg(className, d) {
        const icon = $b668c8ebb790e355$export$1e2eb70c93855705.svg("svg", {
            class: className,
            viewBox: "0 0 48 48"
        });
        const path = $b668c8ebb790e355$export$1e2eb70c93855705.svg("path", {
            d: d,
            class: "sqd-icon-path"
        });
        icon.appendChild(path);
        return icon;
    }
}
$b668c8ebb790e355$export$4f13f83fd8bb1dac.folderIn = "M42.05 42.25H11.996v-7.12h17.388L6 11.746 11.546 6.2 34.93 29.584V12.196h7.12V42.25z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.folderOut = "M6 6.2h30.054v7.12H18.666L42.05 36.704l-5.546 5.546L13.12 18.866v17.388H6V6.2z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.center = "M9 42q-1.2 0-2.1-.9Q6 40.2 6 39v-8.6h3V39h8.6v3Zm21.4 0v-3H39v-8.6h3V39q0 1.2-.9 2.1-.9.9-2.1.9ZM24 31.15q-3.15 0-5.15-2-2-2-2-5.15 0-3.15 2-5.15 2-2 5.15-2 3.15 0 5.15 2 2 2 2 5.15 0 3.15-2 5.15-2 2-5.15 2ZM6 17.6V9q0-1.2.9-2.1Q7.8 6 9 6h8.6v3H9v8.6Zm33 0V9h-8.6V6H39q1.2 0 2.1.9.9.9.9 2.1v8.6Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.zoomIn = "M39.8 41.95 26.65 28.8q-1.5 1.3-3.5 2.025-2 .725-4.25.725-5.4 0-9.15-3.75T6 18.75q0-5.3 3.75-9.05 3.75-3.75 9.1-3.75 5.3 0 9.025 3.75 3.725 3.75 3.725 9.05 0 2.15-.7 4.15-.7 2-2.1 3.75L42 39.75Zm-20.95-13.4q4.05 0 6.9-2.875Q28.6 22.8 28.6 18.75t-2.85-6.925Q22.9 8.95 18.85 8.95q-4.1 0-6.975 2.875T9 18.75q0 4.05 2.875 6.925t6.975 2.875ZM17.3 24.3v-4.1h-4.1v-3h4.1v-4.05h3v4.05h4.05v3H20.3v4.1Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.zoomOut = "M39.8 41.95 26.65 28.8q-1.5 1.3-3.5 2.025-2 .725-4.25.725-5.4 0-9.15-3.75T6 18.75q0-5.3 3.75-9.05 3.75-3.75 9.1-3.75 5.3 0 9.025 3.75 3.725 3.75 3.725 9.05 0 2.15-.7 4.15-.7 2-2.1 3.75L42 39.75Zm-20.95-13.4q4.05 0 6.9-2.875Q28.6 22.8 28.6 18.75t-2.85-6.925Q22.9 8.95 18.85 8.95q-4.1 0-6.975 2.875T9 18.75q0 4.05 2.875 6.925t6.975 2.875Zm-5.1-8.35v-3H23.8v3Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.undo = "M14 38v-3h14.45q3.5 0 6.025-2.325Q37 30.35 37 26.9t-2.525-5.775Q31.95 18.8 28.45 18.8H13.7l5.7 5.7-2.1 2.1L8 17.3 17.3 8l2.1 2.1-5.7 5.7h14.7q4.75 0 8.175 3.2Q40 22.2 40 26.9t-3.425 7.9Q33.15 38 28.4 38Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.redo = "M19.6 38q-4.75 0-8.175-3.2Q8 31.6 8 26.9t3.425-7.9q3.425-3.2 8.175-3.2h14.7l-5.7-5.7L30.7 8l9.3 9.3-9.3 9.3-2.1-2.1 5.7-5.7H19.55q-3.5 0-6.025 2.325Q11 23.45 11 26.9t2.525 5.775Q16.05 35 19.55 35H34v3Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.move = "m24 44-8.15-8.15 2.2-2.2 4.45 4.45v-9.45h3v9.45l4.45-4.45 2.2 2.2ZM11.9 31.9 4 24l7.95-7.95 2.2 2.2L9.9 22.5h9.45v3H9.9l4.2 4.2Zm24.2 0-2.2-2.2 4.2-4.2h-9.4v-3h9.4l-4.2-4.2 2.2-2.2L44 24ZM22.5 19.3V9.9l-4.2 4.2-2.2-2.2L24 4l7.9 7.9-2.2 2.2-4.2-4.2v9.4Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.delete = "m16.5 33.6 7.5-7.5 7.5 7.5 2.1-2.1-7.5-7.5 7.5-7.5-2.1-2.1-7.5 7.5-7.5-7.5-2.1 2.1 7.5 7.5-7.5 7.5ZM24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.8 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24 4q4.15 0 7.8 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.folderUp = "M22.5 34h3V23.75l3.7 3.7 2.1-2.1-7.3-7.3-7.3 7.3 2.1 2.1 3.7-3.7ZM7.05 40q-1.2 0-2.1-.925-.9-.925-.9-2.075V11q0-1.15.9-2.075Q5.85 8 7.05 8h14l3 3h17q1.15 0 2.075.925.925.925.925 2.075v23q0 1.15-.925 2.075Q42.2 40 41.05 40Zm0-29v26h34V14H22.8l-3-3H7.05Zm0 0v26Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.close = "m12.45 37.65-2.1-2.1L21.9 24 10.35 12.45l2.1-2.1L24 21.9l11.55-11.55 2.1 2.1L26.1 24l11.55 11.55-2.1 2.1L24 26.1Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.options = "m19.4 44-1-6.3q-.95-.35-2-.95t-1.85-1.25l-5.9 2.7L4 30l5.4-3.95q-.1-.45-.125-1.025Q9.25 24.45 9.25 24q0-.45.025-1.025T9.4 21.95L4 18l4.65-8.2 5.9 2.7q.8-.65 1.85-1.25t2-.9l1-6.35h9.2l1 6.3q.95.35 2.025.925Q32.7 11.8 33.45 12.5l5.9-2.7L44 18l-5.4 3.85q.1.5.125 1.075.025.575.025 1.075t-.025 1.05q-.025.55-.125 1.05L44 30l-4.65 8.2-5.9-2.7q-.8.65-1.825 1.275-1.025.625-2.025.925l-1 6.3ZM24 30.5q2.7 0 4.6-1.9 1.9-1.9 1.9-4.6 0-2.7-1.9-4.6-1.9-1.9-4.6-1.9-2.7 0-4.6 1.9-1.9 1.9-1.9 4.6 0 2.7 1.9 4.6 1.9 1.9 4.6 1.9Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.expand = "m24 30.75-12-12 2.15-2.15L24 26.5l9.85-9.85L36 18.8Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.alert = "M24 42q-1.45 0-2.475-1.025Q20.5 39.95 20.5 38.5q0-1.45 1.025-2.475Q22.55 35 24 35q1.45 0 2.475 1.025Q27.5 37.05 27.5 38.5q0 1.45-1.025 2.475Q25.45 42 24 42Zm-3.5-12V6h7v24Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.play = "M14.75 40.15V7.55l25.6 16.3Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.stop = "M10.75 37.25V10.7H37.3v26.55Z";
$b668c8ebb790e355$export$4f13f83fd8bb1dac.folder = "M7.05 40q-1.2 0-2.1-.925-.9-.925-.9-2.075V11q0-1.15.9-2.075Q5.85 8 7.05 8h14l3 3h17q1.15 0 2.075.925.925.925.925 2.075v23q0 1.15-.925 2.075Q42.2 40 41.05 40Z";
class $b668c8ebb790e355$export$f2181c17a691a65b {
    static deepClone(instance) {
        if (typeof window.structuredClone !== "undefined") return window.structuredClone(instance);
        return JSON.parse(JSON.stringify(instance));
    }
}
class $b668c8ebb790e355$export$3c53144688d69293 {
    static next() {
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        return Array.from(bytes, (v)=>v.toString(16).padStart(2, "0")).join("");
    }
}
function $b668c8ebb790e355$export$236c05de452bec2(timeout, a, b, c) {
    const value = [
        undefined,
        undefined,
        undefined
    ];
    const result = new $b668c8ebb790e355$export$298d5abb39333987();
    let scheduled = false;
    function forward() {
        if (scheduled) return;
        scheduled = true;
        setTimeout(()=>{
            try {
                result.forward(value);
            } finally{
                scheduled = false;
                value.fill(undefined);
            }
        }, timeout);
    }
    [
        a,
        b,
        c
    ].filter((e)=>e).forEach((e, index)=>{
        e.subscribe((v)=>{
            value[index] = v;
            forward();
        });
    });
    return result;
}
class $b668c8ebb790e355$var$EditorRenderer {
    static create(state, definitionWalker, handler) {
        const listener = new $b668c8ebb790e355$var$EditorRenderer(state, definitionWalker, handler);
        $b668c8ebb790e355$export$236c05de452bec2(0, state.onDefinitionChanged, state.onSelectedStepIdChanged).subscribe((r)=>{
            const [definitionChanged, selectedStepId] = r;
            if (definitionChanged) listener.onDefinitionChanged(definitionChanged);
            else if (selectedStepId !== undefined) listener.onSelectedStepIdChanged(selectedStepId);
        });
        listener.tryRender(state.selectedStepId);
        return listener;
    }
    constructor(state, definitionWalker, handler){
        this.state = state;
        this.definitionWalker = definitionWalker;
        this.handler = handler;
        this.currentStepId = undefined;
    }
    destroy() {
    // TODO: unsubscribe from events
    }
    render(stepId) {
        const step = stepId ? this.definitionWalker.getById(this.state.definition, stepId) : null;
        this.currentStepId = stepId;
        this.handler(step);
    }
    tryRender(stepId) {
        if (this.currentStepId !== stepId) this.render(stepId);
    }
    onDefinitionChanged(event) {
        if (event.changeType === $b668c8ebb790e355$export$afd229a7a55e23c2.rootReplaced) this.render(this.state.selectedStepId);
        else this.tryRender(this.state.selectedStepId);
    }
    onSelectedStepIdChanged(stepId) {
        this.tryRender(stepId);
    }
}
class $b668c8ebb790e355$export$8da78e3ee2ba20fb {
    constructor(state, definitionWalker, definitionModifier){
        this.state = state;
        this.definitionWalker = definitionWalker;
        this.definitionModifier = definitionModifier;
    }
    isCollapsed() {
        return this.state.isEditorCollapsed;
    }
    toggleIsCollapsed() {
        this.state.setIsEditorCollapsed(!this.state.isEditorCollapsed);
    }
    subscribeIsCollapsed(listener) {
        this.state.onIsEditorCollapsedChanged.subscribe(listener);
    }
    getDefinition() {
        return this.state.definition;
    }
    runRenderer(rendererHandler) {
        return $b668c8ebb790e355$var$EditorRenderer.create(this.state, this.definitionWalker, rendererHandler);
    }
    createStepEditorContext(stepId) {
        if (!stepId) throw new Error("Step id is empty");
        return {
            notifyPropertiesChanged: ()=>{
                this.state.notifyDefinitionChanged($b668c8ebb790e355$export$afd229a7a55e23c2.stepPropertyChanged, stepId);
            },
            notifyNameChanged: ()=>{
                this.state.notifyDefinitionChanged($b668c8ebb790e355$export$afd229a7a55e23c2.stepNameChanged, stepId);
            },
            notifyChildrenChanged: ()=>{
                this.state.notifyDefinitionChanged($b668c8ebb790e355$export$afd229a7a55e23c2.stepChildrenChanged, stepId);
                this.definitionModifier.updateDependantFields();
            }
        };
    }
    createGlobalEditorContext() {
        return {
            notifyPropertiesChanged: ()=>{
                this.state.notifyDefinitionChanged($b668c8ebb790e355$export$afd229a7a55e23c2.globalPropertyChanged, null);
            }
        };
    }
}
class $b668c8ebb790e355$export$b61aa3ec355e580d {
    constructor(state, definitionWalker){
        this.state = state;
        this.definitionWalker = definitionWalker;
    }
    /**
     * @deprecated Don't use this method
     */ subscribe(handler) {
        // TODO: this should be refactored
        $b668c8ebb790e355$export$236c05de452bec2(0, this.state.onFolderPathChanged, this.state.onDefinitionChanged).subscribe(handler);
    }
    setFolderPath(path) {
        this.state.setFolderPath(path);
    }
    getFolderPath() {
        return this.state.folderPath;
    }
    getFolderPathStepNames() {
        return this.state.folderPath.map((stepId)=>{
            return this.definitionWalker.getById(this.state.definition, stepId).name;
        });
    }
}
class $b668c8ebb790e355$var$DragStepView {
    static create(step, configuration, componentContext) {
        const theme = configuration.theme || "light";
        const layer = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: `sqd-drag sqd-theme-${theme}`
        });
        document.body.appendChild(layer);
        const component = componentContext.services.draggedComponent.create(layer, step, componentContext);
        return new $b668c8ebb790e355$var$DragStepView(component, layer);
    }
    constructor(component, layer){
        this.component = component;
        this.layer = layer;
    }
    setPosition(position) {
        this.layer.style.top = position.y + "px";
        this.layer.style.left = position.x + "px";
    }
    remove() {
        this.component.destroy();
        document.body.removeChild(this.layer);
    }
}
class $b668c8ebb790e355$var$PlaceholderFinder {
    static create(placeholders, state) {
        const checker = new $b668c8ebb790e355$var$PlaceholderFinder(placeholders, state);
        state.onViewportChanged.subscribe(checker.clearCacheHandler);
        window.addEventListener("scroll", checker.clearCacheHandler, false);
        return checker;
    }
    constructor(placeholders, state){
        this.placeholders = placeholders;
        this.state = state;
        this.clearCacheHandler = ()=>this.clearCache();
    }
    find(vLt, vWidth, vHeight) {
        var _a;
        if (!this.cache) {
            const scroll = new $b668c8ebb790e355$export$9b781de7bf37bf48(window.scrollX, window.scrollY);
            this.cache = this.placeholders.map((placeholder)=>{
                const rect = placeholder.getClientRect();
                return {
                    placeholder: placeholder,
                    lt: new $b668c8ebb790e355$export$9b781de7bf37bf48(rect.x, rect.y).add(scroll),
                    br: new $b668c8ebb790e355$export$9b781de7bf37bf48(rect.x + rect.width, rect.y + rect.height).add(scroll)
                };
            });
            this.cache.sort((a, b)=>a.lt.y - b.lt.y);
        }
        const vR = vLt.x + vWidth;
        const vB = vLt.y + vHeight;
        return (_a = this.cache.find((p)=>{
            return Math.max(vLt.x, p.lt.x) < Math.min(vR, p.br.x) && Math.max(vLt.y, p.lt.y) < Math.min(vB, p.br.y);
        })) === null || _a === void 0 ? void 0 : _a.placeholder;
    }
    destroy() {
        this.state.onViewportChanged.unsubscribe(this.clearCacheHandler);
        window.removeEventListener("scroll", this.clearCacheHandler, false);
    }
    clearCache() {
        this.cache = undefined;
    }
}
class $b668c8ebb790e355$var$DragStepBehavior {
    static create(designerContext, step, draggedStepComponent) {
        const view = $b668c8ebb790e355$var$DragStepView.create(step, designerContext.configuration, designerContext.componentContext);
        return new $b668c8ebb790e355$var$DragStepBehavior(view, designerContext.workspaceController, designerContext.state, step, designerContext.definitionModifier, draggedStepComponent);
    }
    constructor(view, workspaceController, designerState, step, definitionModifier, draggedStepComponent){
        this.view = view;
        this.workspaceController = workspaceController;
        this.designerState = designerState;
        this.step = step;
        this.definitionModifier = definitionModifier;
        this.draggedStepComponent = draggedStepComponent;
    }
    onStart(position) {
        let offset = null;
        if (this.draggedStepComponent) {
            this.draggedStepComponent.setIsDisabled(true);
            const hasSameSize = this.draggedStepComponent.view.width === this.view.component.width && this.draggedStepComponent.view.height === this.view.component.height;
            if (hasSameSize) {
                const scroll = new $b668c8ebb790e355$export$9b781de7bf37bf48(window.scrollX, window.scrollY);
                // Mouse cursor will be positioned on the same place as the source component.
                const pagePosition = this.draggedStepComponent.view.getClientPosition().add(scroll);
                offset = position.subtract(pagePosition);
            }
        }
        if (!offset) // Mouse cursor will be positioned in the center of the component.
        offset = new $b668c8ebb790e355$export$9b781de7bf37bf48(this.view.component.width, this.view.component.height).divideByScalar(2);
        this.view.setPosition(position.subtract(offset));
        this.designerState.setIsDragging(true);
        const placeholders = this.workspaceController.getPlaceholders();
        this.state = {
            startPosition: position,
            finder: $b668c8ebb790e355$var$PlaceholderFinder.create(placeholders, this.designerState),
            offset: offset
        };
    }
    onMove(delta) {
        if (this.state) {
            const newPosition = this.state.startPosition.subtract(delta).subtract(this.state.offset);
            this.view.setPosition(newPosition);
            const placeholder = this.state.finder.find(newPosition, this.view.component.width, this.view.component.height);
            if (this.currentPlaceholder !== placeholder) {
                if (this.currentPlaceholder) this.currentPlaceholder.setIsHover(false);
                if (placeholder) placeholder.setIsHover(true);
                this.currentPlaceholder = placeholder;
            }
        }
    }
    onEnd(interrupt) {
        if (!this.state) throw new Error("Invalid state");
        this.state.finder.destroy();
        this.state = undefined;
        this.view.remove();
        this.designerState.setIsDragging(false);
        let modified = false;
        if (!interrupt && this.currentPlaceholder) {
            if (this.draggedStepComponent) modified = this.definitionModifier.tryMove(this.draggedStepComponent.parentSequence, this.draggedStepComponent.step, this.currentPlaceholder.parentSequence, this.currentPlaceholder.index);
            else modified = this.definitionModifier.tryInsert(this.step, this.currentPlaceholder.parentSequence, this.currentPlaceholder.index);
        }
        if (!modified) {
            if (this.draggedStepComponent) this.draggedStepComponent.setIsDisabled(false);
            if (this.currentPlaceholder) this.currentPlaceholder.setIsHover(false);
        }
        this.currentPlaceholder = undefined;
    }
}
class $b668c8ebb790e355$export$614141a033903563 {
    constructor(state, designerContext, behaviorController, iconProvider, configuration, uidGenerator){
        this.state = state;
        this.designerContext = designerContext;
        this.behaviorController = behaviorController;
        this.iconProvider = iconProvider;
        this.configuration = configuration;
        this.uidGenerator = uidGenerator;
    }
    isCollapsed() {
        return this.state.isToolboxCollapsed;
    }
    toggleIsCollapsed() {
        this.state.setIsToolboxCollapsed(!this.state.isToolboxCollapsed);
    }
    subscribeIsCollapsed(listener) {
        this.state.onIsToolboxCollapsedChanged.subscribe(listener);
    }
    tryGetIconUrl(step) {
        return this.iconProvider.getIconUrl(step);
    }
    getLabel(step) {
        const labelProvider = this.getConfiguration().labelProvider;
        return labelProvider ? labelProvider(step) : step.name;
    }
    filterGroups(filter) {
        return this.getConfiguration().groups.map((group)=>{
            return {
                name: group.name,
                steps: group.steps.filter((s)=>{
                    return filter ? s.name.toLowerCase().includes(filter) : true;
                })
            };
        }).filter((group)=>group.steps.length > 0);
    }
    /**
     * @param position Mouse or touch position.
     * @param step Step definition.
     * @returns If started dragging returns true, otherwise returns false.
     */ tryDrag(position, step) {
        if (!this.state.isReadonly) {
            const newStep = this.activateStep(step);
            this.behaviorController.start(position, $b668c8ebb790e355$var$DragStepBehavior.create(this.designerContext, newStep));
            return true;
        }
        return false;
    }
    activateStep(step) {
        const newStep = $b668c8ebb790e355$export$f2181c17a691a65b.deepClone(step);
        newStep.id = this.uidGenerator ? this.uidGenerator() : $b668c8ebb790e355$export$3c53144688d69293.next();
        return newStep;
    }
    getConfiguration() {
        if (!this.configuration) throw new Error("Toolbox is disabled");
        return this.configuration;
    }
}
class $b668c8ebb790e355$var$ViewportApi {
    constructor(workspaceController, viewportController){
        this.workspaceController = workspaceController;
        this.viewportController = viewportController;
    }
    resetViewport() {
        this.viewportController.setDefault();
    }
    zoom(direction) {
        this.viewportController.zoom(direction);
    }
    moveViewportToStep(stepId) {
        const component = this.workspaceController.getComponentByStepId(stepId);
        const componentPosition = component.view.getClientPosition();
        const componentSize = new $b668c8ebb790e355$export$9b781de7bf37bf48(component.view.width, component.view.height);
        this.viewportController.focusOnComponent(componentPosition, componentSize);
    }
}
class $b668c8ebb790e355$export$4f960bf15f8823c1 {
    constructor(state, workspaceController){
        this.state = state;
        this.workspaceController = workspaceController;
    }
    getCanvasPosition() {
        return this.workspaceController.getCanvasPosition();
    }
    getCanvasSize() {
        return this.workspaceController.getCanvasSize();
    }
    getRootComponentSize() {
        return this.workspaceController.getRootComponentSize();
    }
    getViewport() {
        return this.state.viewport;
    }
    setViewport(viewport) {
        this.state.setViewport(viewport);
    }
    updateRootComponent() {
        this.workspaceController.updateRootComponent();
    }
    updateBadges() {
        this.workspaceController.updateBadges();
    }
    updateCanvasSize() {
        this.workspaceController.updateCanvasSize();
    }
}
class $b668c8ebb790e355$export$3503bfda72123b3e {
    static create(context) {
        const workspace = new $b668c8ebb790e355$export$4f960bf15f8823c1(context.state, context.workspaceController);
        const viewportController = context.services.viewportController.create(workspace);
        const viewport = new $b668c8ebb790e355$var$ViewportApi(context.workspaceController, viewportController);
        return new $b668c8ebb790e355$export$3503bfda72123b3e(new $b668c8ebb790e355$export$83c961469296adb8(context.state, context.historyController, context.definitionModifier, viewport), new $b668c8ebb790e355$export$614141a033903563(context.state, context, context.behaviorController, context.componentContext.iconProvider, context.configuration.toolbox, context.configuration.uidGenerator), new $b668c8ebb790e355$export$8da78e3ee2ba20fb(context.state, context.definitionWalker, context.definitionModifier), workspace, viewport, new $b668c8ebb790e355$export$b61aa3ec355e580d(context.state, context.definitionWalker));
    }
    constructor(controlBar, toolbox, editor, workspace, viewport, pathBar){
        this.controlBar = controlBar;
        this.toolbox = toolbox;
        this.editor = editor;
        this.workspace = workspace;
        this.viewport = viewport;
        this.pathBar = pathBar;
    }
}
class $b668c8ebb790e355$var$DefinitionValidator {
    constructor(configuration, state){
        this.configuration = configuration;
        this.state = state;
    }
    validateStep(step, parentSequence) {
        var _a;
        if ((_a = this.configuration) === null || _a === void 0 ? void 0 : _a.step) return this.configuration.step(step, parentSequence, this.state.definition);
        return true;
    }
    validateRoot() {
        var _a;
        if ((_a = this.configuration) === null || _a === void 0 ? void 0 : _a.root) return this.configuration.root(this.state.definition);
        return true;
    }
}
class $b668c8ebb790e355$var$IconProvider {
    constructor(configuration){
        this.configuration = configuration;
    }
    getIconUrl(step) {
        if (this.configuration.iconUrlProvider) return this.configuration.iconUrlProvider(step.componentType, step.type);
        return null;
    }
}
const $b668c8ebb790e355$var$BADGE_GAP = 4;
class $b668c8ebb790e355$export$a7be05036dfae7c5 {
    static createForStep(stepContext, view, componentContext) {
        const g = $b668c8ebb790e355$var$createG(view.g);
        const badges = componentContext.services.badges.map((ext)=>ext.createForStep(g, stepContext, componentContext));
        const position = new $b668c8ebb790e355$export$9b781de7bf37bf48(view.width, 0);
        return new $b668c8ebb790e355$export$a7be05036dfae7c5(g, position, badges);
    }
    static createForRoot(parentElement, position, componentContext) {
        const g = $b668c8ebb790e355$var$createG(parentElement);
        const badges = componentContext.services.badges.map((ext)=>{
            return ext.createForRoot ? ext.createForRoot(g, componentContext) : null;
        });
        return new $b668c8ebb790e355$export$a7be05036dfae7c5(g, position, badges);
    }
    constructor(g, position, badges){
        this.g = g;
        this.position = position;
        this.badges = badges;
    }
    update(result) {
        const count = this.badges.length;
        for(let i = 0; i < count; i++){
            const badge = this.badges[i];
            if (badge) result[i] = badge.update(result[i]);
        }
        let offsetX = 0;
        let maxHeight = 0;
        let j = 0;
        for(let i = 0; i < count; i++){
            const badge = this.badges[i];
            if (badge && badge.view) {
                offsetX += j === 0 ? badge.view.width / 2 : badge.view.width;
                maxHeight = Math.max(maxHeight, badge.view.height);
                $b668c8ebb790e355$export$1e2eb70c93855705.translate(badge.view.g, -offsetX, 0);
                offsetX += $b668c8ebb790e355$var$BADGE_GAP;
                j++;
            }
        }
        $b668c8ebb790e355$export$1e2eb70c93855705.translate(this.g, this.position.x, this.position.y + -maxHeight / 2);
    }
    resolveClick(click) {
        for (const badge of this.badges){
            const command = badge && badge.resolveClick(click);
            if (command) return command;
        }
        return null;
    }
}
function $b668c8ebb790e355$var$createG(parentElement) {
    const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g", {
        class: "sqd-badges"
    });
    parentElement.appendChild(g);
    return g;
}
var $b668c8ebb790e355$export$82c5bd54d8caea70;
(function(ClickCommandType) {
    ClickCommandType[ClickCommandType["selectStep"] = 1] = "selectStep";
    ClickCommandType[ClickCommandType["rerenderStep"] = 2] = "rerenderStep";
    ClickCommandType[ClickCommandType["openFolder"] = 3] = "openFolder";
    ClickCommandType[ClickCommandType["triggerCustomAction"] = 4] = "triggerCustomAction";
})($b668c8ebb790e355$export$82c5bd54d8caea70 || ($b668c8ebb790e355$export$82c5bd54d8caea70 = {}));
var $b668c8ebb790e355$export$f36c40dbf5da813f;
(function(PlaceholderDirection) {
    PlaceholderDirection[PlaceholderDirection["none"] = 0] = "none";
    PlaceholderDirection[PlaceholderDirection["in"] = 1] = "in";
    PlaceholderDirection[PlaceholderDirection["out"] = 2] = "out";
})($b668c8ebb790e355$export$f36c40dbf5da813f || ($b668c8ebb790e355$export$f36c40dbf5da813f = {}));
class $b668c8ebb790e355$export$462095ac2a42fb1d {
    static create(view, stepContext, componentContext) {
        const badges = $b668c8ebb790e355$export$a7be05036dfae7c5.createForStep(stepContext, view, componentContext);
        return new $b668c8ebb790e355$export$462095ac2a42fb1d(view, stepContext.step, stepContext.parentSequence, view.hasOutput(), badges);
    }
    constructor(view, step, parentSequence, hasOutput, badges){
        this.view = view;
        this.step = step;
        this.parentSequence = parentSequence;
        this.hasOutput = hasOutput;
        this.badges = badges;
        this.isDisabled = false;
    }
    findById(stepId) {
        if (this.step.id === stepId) return this;
        if (this.view.sequenceComponents) for (const component of this.view.sequenceComponents){
            const result = component.findById(stepId);
            if (result) return result;
        }
        return null;
    }
    resolveClick(click) {
        if (this.view.sequenceComponents) for (const component of this.view.sequenceComponents){
            const result = component.resolveClick(click);
            if (result) return result;
        }
        const badgeResult = this.badges.resolveClick(click);
        if (badgeResult) return badgeResult;
        const viewResult = this.view.resolveClick(click);
        if (viewResult) return viewResult === true ? {
            type: $b668c8ebb790e355$export$82c5bd54d8caea70.selectStep,
            component: this
        } : viewResult;
        return null;
    }
    getPlaceholders(result) {
        if (!this.isDisabled) {
            if (this.view.sequenceComponents) this.view.sequenceComponents.forEach((component)=>component.getPlaceholders(result));
            if (this.view.placeholders) this.view.placeholders.forEach((ph)=>result.push(ph));
        }
    }
    setIsDragging(isDragging) {
        if (!this.isDisabled) {
            if (this.view.sequenceComponents) this.view.sequenceComponents.forEach((component)=>component.setIsDragging(isDragging));
            if (this.view.placeholders) this.view.placeholders.forEach((ph)=>ph.setIsVisible(isDragging));
        }
        this.view.setIsDragging(isDragging);
    }
    setIsSelected(isSelected) {
        this.view.setIsSelected(isSelected);
    }
    setIsDisabled(isDisabled) {
        this.isDisabled = isDisabled;
        this.view.setIsDisabled(isDisabled);
    }
    updateBadges(result) {
        if (this.view.sequenceComponents) this.view.sequenceComponents.forEach((component)=>component.updateBadges(result));
        this.badges.update(result);
    }
}
class $b668c8ebb790e355$var$StepComponentViewContextFactory {
    static create(stepContext, componentContext) {
        return {
            getStepIconUrl: ()=>componentContext.iconProvider.getIconUrl(stepContext.step),
            createSequenceComponent: (parentElement, sequence)=>{
                const sequenceContext = {
                    sequence: sequence,
                    depth: stepContext.depth + 1,
                    isInputConnected: true,
                    isOutputConnected: stepContext.isOutputConnected
                };
                return componentContext.services.sequenceComponent.create(parentElement, sequenceContext, componentContext);
            },
            createPlaceholderForArea: componentContext.services.placeholder.createForArea.bind(componentContext.services.placeholder)
        };
    }
}
class $b668c8ebb790e355$var$StepComponentFactory {
    constructor(stepExtensionResolver){
        this.stepExtensionResolver = stepExtensionResolver;
    }
    create(parentElement, stepContext, componentContext) {
        const viewContext = $b668c8ebb790e355$var$StepComponentViewContextFactory.create(stepContext, componentContext);
        const extension = this.stepExtensionResolver.resolve(stepContext.step.componentType);
        const view = extension.createComponentView(parentElement, stepContext, viewContext);
        const wrappedView = componentContext.services.stepComponentViewWrapper.wrap(view, stepContext);
        return $b668c8ebb790e355$export$462095ac2a42fb1d.create(wrappedView, stepContext, componentContext);
    }
}
class $b668c8ebb790e355$export$baac0fb5196ccae9 {
    static create(stepsConfiguration, validatorConfiguration, state, stepExtensionResolver, services) {
        const validator = new $b668c8ebb790e355$var$DefinitionValidator(validatorConfiguration, state);
        const iconProvider = new $b668c8ebb790e355$var$IconProvider(stepsConfiguration);
        const placeholderController = services.placeholderController.create();
        const stepComponentFactory = new $b668c8ebb790e355$var$StepComponentFactory(stepExtensionResolver);
        return new $b668c8ebb790e355$export$baac0fb5196ccae9(validator, iconProvider, placeholderController, stepComponentFactory, services);
    }
    constructor(validator, iconProvider, placeholderController, stepComponentFactory, services){
        this.validator = validator;
        this.iconProvider = iconProvider;
        this.placeholderController = placeholderController;
        this.stepComponentFactory = stepComponentFactory;
        this.services = services;
    }
}
class $b668c8ebb790e355$var$EditorView {
    static create(parent) {
        return new $b668c8ebb790e355$var$EditorView(parent);
    }
    constructor(parent){
        this.parent = parent;
        this.currentContainer = null;
    }
    setContent(content, className) {
        const container = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: className
        });
        container.appendChild(content);
        if (this.currentContainer) this.parent.removeChild(this.currentContainer);
        this.parent.appendChild(container);
        this.currentContainer = container;
    }
    destroy() {
        if (this.currentContainer) this.parent.removeChild(this.currentContainer);
    }
}
class $b668c8ebb790e355$export$7cda8d932e2f33c0 {
    static create(parent, api, stepEditorClassName, stepEditorProvider, globalEditorClassName, globalEditorProvider) {
        const view = $b668c8ebb790e355$var$EditorView.create(parent);
        function render(step) {
            const definition = api.getDefinition();
            let content;
            let className;
            if (step) {
                const stepContext = api.createStepEditorContext(step.id);
                content = stepEditorProvider(step, stepContext, definition);
                className = stepEditorClassName;
            } else {
                const globalContext = api.createGlobalEditorContext();
                content = globalEditorProvider(definition, globalContext);
                className = globalEditorClassName;
            }
            view.setContent(content, className);
        }
        const renderer = api.runRenderer((step)=>render(step));
        return new $b668c8ebb790e355$export$7cda8d932e2f33c0(view, renderer);
    }
    constructor(view, renderer){
        this.view = view;
        this.renderer = renderer;
    }
    destroy() {
        this.view.destroy();
        this.renderer.destroy();
    }
}
class $b668c8ebb790e355$var$ValidationErrorBadgeView {
    static create(parent, cfg) {
        const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g");
        const halfOfSize = cfg.size / 2;
        const circle = $b668c8ebb790e355$export$1e2eb70c93855705.svg("path", {
            class: "sqd-validation-error",
            d: `M 0 ${-halfOfSize} l ${halfOfSize} ${cfg.size} l ${-cfg.size} 0 Z`
        });
        $b668c8ebb790e355$export$1e2eb70c93855705.translate(circle, halfOfSize, halfOfSize);
        g.appendChild(circle);
        const icon = $b668c8ebb790e355$export$4f13f83fd8bb1dac.appendPath(g, "sqd-validation-error-icon-path", $b668c8ebb790e355$export$4f13f83fd8bb1dac.alert, cfg.iconSize);
        const offsetX = (cfg.size - cfg.iconSize) * 0.5;
        const offsetY = offsetX * 1.5;
        $b668c8ebb790e355$export$1e2eb70c93855705.translate(icon, offsetX, offsetY);
        parent.appendChild(g);
        return new $b668c8ebb790e355$var$ValidationErrorBadgeView(parent, g, cfg.size, cfg.size);
    }
    constructor(parent, g, width, height){
        this.parent = parent;
        this.g = g;
        this.width = width;
        this.height = height;
    }
    destroy() {
        this.parent.removeChild(this.g);
    }
}
class $b668c8ebb790e355$var$ValidationErrorBadge {
    static createForStep(parentElement, stepContext, componentContext, configuration) {
        const validator = ()=>componentContext.validator.validateStep(stepContext.step, stepContext.parentSequence);
        return new $b668c8ebb790e355$var$ValidationErrorBadge(parentElement, validator, configuration);
    }
    static createForRoot(parentElement, componentContext, configuration) {
        const validator = ()=>componentContext.validator.validateRoot();
        return new $b668c8ebb790e355$var$ValidationErrorBadge(parentElement, validator, configuration);
    }
    constructor(parentElement, validator, configuration){
        this.parentElement = parentElement;
        this.validator = validator;
        this.configuration = configuration;
        this.view = null;
    }
    update(result) {
        const isValid = this.validator();
        if (isValid) {
            if (this.view) {
                this.view.destroy();
                this.view = null;
            }
        } else if (!this.view) this.view = $b668c8ebb790e355$var$ValidationErrorBadgeView.create(this.parentElement, this.configuration);
        return isValid && result;
    }
    resolveClick() {
        return null;
    }
}
const $b668c8ebb790e355$var$defaultConfiguration$5 = {
    view: {
        size: 22,
        iconSize: 12
    }
};
class $b668c8ebb790e355$export$31e30dce99868251 {
    static create(configuration) {
        return new $b668c8ebb790e355$export$31e30dce99868251(configuration !== null && configuration !== void 0 ? configuration : $b668c8ebb790e355$var$defaultConfiguration$5);
    }
    constructor(configuration){
        this.configuration = configuration;
        this.id = "validationError";
        this.createStartValue = ()=>true;
    }
    createForStep(parentElement, stepContext, componentContext) {
        return $b668c8ebb790e355$var$ValidationErrorBadge.createForStep(parentElement, stepContext, componentContext, this.configuration.view);
    }
    createForRoot(parentElement, componentContext) {
        return $b668c8ebb790e355$var$ValidationErrorBadge.createForRoot(parentElement, componentContext, this.configuration.view);
    }
}
class $b668c8ebb790e355$export$d046d2870d3b0a10 {
    static createRectInput(parent, x, y, size, iconSize, iconUrl) {
        const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g");
        parent.appendChild(g);
        const rect = $b668c8ebb790e355$export$1e2eb70c93855705.svg("rect", {
            class: "sqd-input",
            width: size,
            height: size,
            x: x - size / 2,
            y: y + size / -2 + 0.5,
            rx: 4,
            ry: 4
        });
        g.appendChild(rect);
        if (iconUrl) {
            const icon = $b668c8ebb790e355$export$1e2eb70c93855705.svg("image", {
                href: iconUrl,
                width: iconSize,
                height: iconSize,
                x: x - iconSize / 2,
                y: y + iconSize / -2
            });
            g.appendChild(icon);
        }
        return new $b668c8ebb790e355$export$d046d2870d3b0a10(g);
    }
    static createRoundInput(parent, x, y, size) {
        const circle = $b668c8ebb790e355$export$1e2eb70c93855705.svg("circle", {
            class: "sqd-input",
            cx: x,
            xy: y,
            r: size / 2
        });
        parent.appendChild(circle);
        return new $b668c8ebb790e355$export$d046d2870d3b0a10(circle);
    }
    constructor(root){
        this.root = root;
    }
    setIsHidden(isHidden) {
        $b668c8ebb790e355$export$1e2eb70c93855705.attrs(this.root, {
            visibility: isHidden ? "hidden" : "visible"
        });
    }
}
class $b668c8ebb790e355$export$e144401a8d7d8961 {
    static createStraightJoin(parent, start, height) {
        const join = $b668c8ebb790e355$export$1e2eb70c93855705.svg("line", {
            class: "sqd-join",
            x1: start.x,
            y1: start.y,
            x2: start.x,
            y2: start.y + height
        });
        parent.insertBefore(join, parent.firstChild);
    }
    static createJoins(parent, start, targets) {
        const firstTarget = targets[0];
        const h = Math.abs(firstTarget.y - start.y) / 2; // half height
        const y = Math.sign(firstTarget.y - start.y); // y direction
        switch(targets.length){
            case 1:
                if (start.x === targets[0].x) $b668c8ebb790e355$export$e144401a8d7d8961.createStraightJoin(parent, start, firstTarget.y * y);
                else $b668c8ebb790e355$var$appendCurvedJoins(parent, start, targets, h, y);
                break;
            case 2:
                $b668c8ebb790e355$var$appendCurvedJoins(parent, start, targets, h, y);
                break;
            default:
                {
                    const f = targets[0]; // first
                    const l = targets[targets.length - 1]; // last
                    $b668c8ebb790e355$var$appendJoin(parent, `M ${f.x} ${f.y} q ${h * 0.3} ${h * -y * 0.8} ${h} ${h * -y} ` + `l ${l.x - f.x - h * 2} 0 q ${h * 0.8} ${-h * -y * 0.3} ${h} ${-h * -y}`);
                    for(let i = 1; i < targets.length - 1; i++)$b668c8ebb790e355$export$e144401a8d7d8961.createStraightJoin(parent, targets[i], h * -y);
                    $b668c8ebb790e355$export$e144401a8d7d8961.createStraightJoin(parent, start, h * y);
                }
                break;
        }
    }
}
function $b668c8ebb790e355$var$appendCurvedJoins(parent, start, targets, h, y) {
    for (const target of targets){
        const l = Math.abs(target.x - start.x) - h * 2; // line size
        const x = Math.sign(target.x - start.x); // x direction
        $b668c8ebb790e355$var$appendJoin(parent, `M ${start.x} ${start.y} q ${x * h * 0.3} ${y * h * 0.8} ${x * h} ${y * h} ` + `l ${x * l} 0 q ${x * h * 0.7} ${y * h * 0.2} ${x * h} ${y * h}`);
    }
}
function $b668c8ebb790e355$var$appendJoin(parent, d) {
    const join = $b668c8ebb790e355$export$1e2eb70c93855705.svg("path", {
        class: "sqd-join",
        fill: "none",
        d: d
    });
    parent.insertBefore(join, parent.firstChild);
}
class $b668c8ebb790e355$export$84062398251b1ba {
    static create(parent, y, cfg, text, theme) {
        const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g", {
            class: `sqd-label sqd-label-${theme}`
        });
        parent.appendChild(g);
        const nameText = $b668c8ebb790e355$export$1e2eb70c93855705.svg("text", {
            class: "sqd-label-text",
            y: y + cfg.height / 2
        });
        nameText.textContent = text;
        g.appendChild(nameText);
        const width = Math.max(nameText.getBBox().width + cfg.paddingX * 2, cfg.minWidth);
        const nameRect = $b668c8ebb790e355$export$1e2eb70c93855705.svg("rect", {
            class: "sqd-label-rect",
            width: width,
            height: cfg.height,
            x: -width / 2 + 0.5,
            y: y + 0.5,
            rx: cfg.radius,
            ry: cfg.radius
        });
        g.insertBefore(nameRect, nameText);
        return new $b668c8ebb790e355$export$84062398251b1ba(g, width, cfg.height);
    }
    constructor(g, width, height){
        this.g = g;
        this.width = width;
        this.height = height;
    }
}
class $b668c8ebb790e355$export$fa85ae460c856c26 {
    static create(parent, x, y, size) {
        const circle = $b668c8ebb790e355$export$1e2eb70c93855705.svg("circle", {
            class: "sqd-output",
            cx: x,
            cy: y,
            r: size / 2
        });
        parent.appendChild(circle);
        return new $b668c8ebb790e355$export$fa85ae460c856c26(circle);
    }
    constructor(root){
        this.root = root;
    }
    setIsHidden(isHidden) {
        $b668c8ebb790e355$export$1e2eb70c93855705.attrs(this.root, {
            visibility: isHidden ? "hidden" : "visible"
        });
    }
}
class $b668c8ebb790e355$export$99d0a526f07fd97b {
    static create(parent, widths, height) {
        const totalWidth = widths.reduce((result, width)=>result + width, 0);
        const lines = [
            $b668c8ebb790e355$var$drawLine(parent, 0, 0, totalWidth, 0),
            $b668c8ebb790e355$var$drawLine(parent, 0, 0, 0, height),
            $b668c8ebb790e355$var$drawLine(parent, 0, height, totalWidth, height),
            $b668c8ebb790e355$var$drawLine(parent, totalWidth, 0, totalWidth, height)
        ];
        let offsetX = widths[0];
        for(let i = 1; i < widths.length; i++){
            lines.push($b668c8ebb790e355$var$drawLine(parent, offsetX, 0, offsetX, height));
            offsetX += widths[i];
        }
        return new $b668c8ebb790e355$export$99d0a526f07fd97b(lines, totalWidth, height);
    }
    constructor(lines, width, height){
        this.lines = lines;
        this.width = width;
        this.height = height;
    }
    getClientPosition() {
        const rect = this.lines[0].getBoundingClientRect();
        return new $b668c8ebb790e355$export$9b781de7bf37bf48(rect.x, rect.y);
    }
    resolveClick(click) {
        const regionPosition = this.getClientPosition();
        const d = click.position.subtract(regionPosition);
        return d.x >= 0 && d.y >= 0 && d.x < this.width * click.scale && d.y < this.height * click.scale;
    }
    setIsSelected(isSelected) {
        this.lines.forEach((region)=>{
            $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(region, isSelected, "sqd-selected");
        });
    }
}
function $b668c8ebb790e355$var$drawLine(parent, x1, y1, x2, y2) {
    const line = $b668c8ebb790e355$export$1e2eb70c93855705.svg("line", {
        class: "sqd-region",
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    parent.insertBefore(line, parent.firstChild);
    return line;
}
class $b668c8ebb790e355$export$a0681089af028427 {
    static create(parent, width, height, radius, iconSize, direction) {
        const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g", {
            visibility: "hidden",
            class: "sqd-placeholder"
        });
        parent.appendChild(g);
        const rect = $b668c8ebb790e355$export$1e2eb70c93855705.svg("rect", {
            class: "sqd-placeholder-rect",
            width: width,
            height: height,
            rx: radius,
            ry: radius
        });
        g.appendChild(rect);
        if (direction) {
            const iconD = direction === $b668c8ebb790e355$export$f36c40dbf5da813f.in ? $b668c8ebb790e355$export$4f13f83fd8bb1dac.folderIn : $b668c8ebb790e355$export$4f13f83fd8bb1dac.folderOut;
            const icon = $b668c8ebb790e355$export$4f13f83fd8bb1dac.appendPath(g, "sqd-placeholder-icon-path", iconD, iconSize);
            $b668c8ebb790e355$export$1e2eb70c93855705.translate(icon, (width - iconSize) / 2, (height - iconSize) / 2);
        }
        parent.appendChild(g);
        return new $b668c8ebb790e355$export$a0681089af028427(rect, g);
    }
    constructor(rect, g){
        this.rect = rect;
        this.g = g;
    }
    setIsHover(isHover) {
        $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(this.g, isHover, "sqd-hover");
    }
    setIsVisible(isVisible) {
        $b668c8ebb790e355$export$1e2eb70c93855705.attrs(this.g, {
            visibility: isVisible ? "visible" : "hidden"
        });
    }
}
class $b668c8ebb790e355$export$57feaec1eacf2d67 {
    static create(parent, sequenceContext, componentContext) {
        const phWidth = componentContext.services.placeholder.gapSize.x;
        const phHeight = componentContext.services.placeholder.gapSize.y;
        const { sequence: sequence } = sequenceContext;
        const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g");
        parent.appendChild(g);
        const components = [];
        for(let index = 0; index < sequence.length; index++){
            const stepContext = {
                parentSequence: sequenceContext.sequence,
                step: sequence[index],
                depth: sequenceContext.depth,
                position: index,
                isInputConnected: index === 0 ? sequenceContext.isInputConnected : components[index - 1].hasOutput,
                isOutputConnected: index === sequence.length - 1 ? sequenceContext.isOutputConnected : true
            };
            components[index] = componentContext.stepComponentFactory.create(g, stepContext, componentContext);
        }
        let joinX;
        let totalWidth;
        if (components.length > 0) {
            const restWidth = Math.max(...components.map((c)=>c.view.width - c.view.joinX));
            joinX = Math.max(...components.map((c)=>c.view.joinX));
            totalWidth = joinX + restWidth;
        } else {
            joinX = phWidth / 2;
            totalWidth = phWidth;
        }
        let offsetY = phHeight;
        const placeholders = [];
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            const offsetX = joinX - component.view.joinX;
            if (i === 0 && sequenceContext.isInputConnected || i > 0 && components[i - 1].hasOutput) $b668c8ebb790e355$export$e144401a8d7d8961.createStraightJoin(g, new $b668c8ebb790e355$export$9b781de7bf37bf48(joinX, offsetY - phHeight), phHeight);
            if (componentContext.placeholderController.canCreate(sequence, i)) {
                const ph = componentContext.services.placeholder.createForGap(g, sequence, i);
                $b668c8ebb790e355$export$1e2eb70c93855705.translate(ph.view.g, joinX - phWidth / 2, offsetY - phHeight);
                placeholders.push(ph);
            }
            $b668c8ebb790e355$export$1e2eb70c93855705.translate(component.view.g, offsetX, offsetY);
            offsetY += component.view.height + phHeight;
        }
        if (sequenceContext.isOutputConnected && (components.length === 0 || components[components.length - 1].hasOutput)) $b668c8ebb790e355$export$e144401a8d7d8961.createStraightJoin(g, new $b668c8ebb790e355$export$9b781de7bf37bf48(joinX, offsetY - phHeight), phHeight);
        const newIndex = components.length;
        if (componentContext.placeholderController.canCreate(sequence, newIndex)) {
            const ph = componentContext.services.placeholder.createForGap(g, sequence, newIndex);
            $b668c8ebb790e355$export$1e2eb70c93855705.translate(ph.view.g, joinX - phWidth / 2, offsetY - phHeight);
            placeholders.push(ph);
        }
        return new $b668c8ebb790e355$export$57feaec1eacf2d67(g, totalWidth, offsetY, joinX, placeholders, components);
    }
    constructor(g, width, height, joinX, placeholders, components){
        this.g = g;
        this.width = width;
        this.height = height;
        this.joinX = joinX;
        this.placeholders = placeholders;
        this.components = components;
    }
    setIsDragging(isDragging) {
        this.placeholders.forEach((placeholder)=>{
            placeholder.setIsVisible(isDragging);
        });
    }
    hasOutput() {
        if (this.components.length > 0) return this.components[this.components.length - 1].hasOutput;
        return true;
    }
}
class $b668c8ebb790e355$export$24ac18814bbca960 {
    static create(parentElement, sequenceContext, context) {
        const view = $b668c8ebb790e355$export$57feaec1eacf2d67.create(parentElement, sequenceContext, context);
        return new $b668c8ebb790e355$export$24ac18814bbca960(view, view.hasOutput());
    }
    constructor(view, hasOutput){
        this.view = view;
        this.hasOutput = hasOutput;
    }
    resolveClick(click) {
        for (const component of this.view.components){
            const result = component.resolveClick(click);
            if (result) return result;
        }
        for (const placeholder of this.view.placeholders){
            const result = placeholder.resolveClick(click);
            if (result) return result;
        }
        return null;
    }
    findById(stepId) {
        for (const component of this.view.components){
            const sc = component.findById(stepId);
            if (sc) return sc;
        }
        return null;
    }
    getPlaceholders(result) {
        this.view.placeholders.forEach((placeholder)=>result.push(placeholder));
        this.view.components.forEach((c)=>c.getPlaceholders(result));
    }
    setIsDragging(isDragging) {
        this.view.setIsDragging(isDragging);
        this.view.components.forEach((c)=>c.setIsDragging(isDragging));
    }
    updateBadges(result) {
        for (const component of this.view.components)component.updateBadges(result);
    }
}
const $b668c8ebb790e355$export$7053e7d9eb350367 = (cfg)=>(parentElement, stepContext, viewContext)=>{
        const { step: step } = stepContext;
        const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g", {
            class: `sqd-step-container sqd-type-${step.type}`
        });
        parentElement.appendChild(g);
        const labelView = $b668c8ebb790e355$export$84062398251b1ba.create(g, cfg.paddingTop, cfg.label, step.name, "primary");
        const sequenceComponent = viewContext.createSequenceComponent(g, step.sequence);
        const halfOfWidestElement = labelView.width / 2;
        const offsetLeft = Math.max(halfOfWidestElement - sequenceComponent.view.joinX, 0) + cfg.paddingX;
        const offsetRight = Math.max(halfOfWidestElement - (sequenceComponent.view.width - sequenceComponent.view.joinX), 0) + cfg.paddingX;
        const width = offsetLeft + sequenceComponent.view.width + offsetRight;
        const height = cfg.paddingTop + cfg.label.height + sequenceComponent.view.height;
        const joinX = sequenceComponent.view.joinX + offsetLeft;
        $b668c8ebb790e355$export$1e2eb70c93855705.translate(labelView.g, joinX, 0);
        $b668c8ebb790e355$export$1e2eb70c93855705.translate(sequenceComponent.view.g, offsetLeft, cfg.paddingTop + cfg.label.height);
        const iconUrl = viewContext.getStepIconUrl();
        const inputView = $b668c8ebb790e355$export$d046d2870d3b0a10.createRectInput(g, joinX, 0, cfg.inputSize, cfg.inputIconSize, iconUrl);
        $b668c8ebb790e355$export$e144401a8d7d8961.createStraightJoin(g, new $b668c8ebb790e355$export$9b781de7bf37bf48(joinX, 0), cfg.paddingTop);
        const regionView = $b668c8ebb790e355$export$99d0a526f07fd97b.create(g, [
            width
        ], height);
        return {
            g: g,
            width: width,
            height: height,
            joinX: joinX,
            placeholders: null,
            sequenceComponents: [
                sequenceComponent
            ],
            getClientPosition () {
                return regionView.getClientPosition();
            },
            resolveClick (click) {
                return regionView.resolveClick(click) || g.contains(click.element) ? true : null;
            },
            setIsDragging (isDragging) {
                inputView.setIsHidden(isDragging);
            },
            setIsSelected (isSelected) {
                regionView.setIsSelected(isSelected);
            },
            setIsDisabled (isDisabled) {
                $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(g, isDisabled, "sqd-disabled");
            },
            hasOutput () {
                return sequenceComponent.hasOutput;
            }
        };
    };
const $b668c8ebb790e355$export$f046b8db22527b17 = (cfg)=>(parent, stepContext, viewContext)=>{
        const { step: step } = stepContext;
        const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g", {
            class: `sqd-step-switch sqd-type-${step.type}`
        });
        parent.appendChild(g);
        const branchNames = Object.keys(step.branches);
        const branchComponents = branchNames.map((branchName)=>{
            return viewContext.createSequenceComponent(g, step.branches[branchName]);
        });
        const branchLabelViews = branchNames.map((branchName)=>{
            const labelY = cfg.paddingTop + cfg.nameLabel.height + cfg.connectionHeight;
            return $b668c8ebb790e355$export$84062398251b1ba.create(g, labelY, cfg.branchNameLabel, branchName, "secondary");
        });
        const nameLabelView = $b668c8ebb790e355$export$84062398251b1ba.create(g, cfg.paddingTop, cfg.nameLabel, step.name, "primary");
        let prevOffsetX = 0;
        const branchSizes = branchComponents.map((component, i)=>{
            const halfOfWidestBranchElement = Math.max(branchLabelViews[i].width, cfg.minContainerWidth) / 2;
            const branchOffsetLeft = Math.max(halfOfWidestBranchElement - component.view.joinX, 0) + cfg.paddingX;
            const branchOffsetRight = Math.max(halfOfWidestBranchElement - (component.view.width - component.view.joinX), 0) + cfg.paddingX;
            const width = component.view.width + branchOffsetLeft + branchOffsetRight;
            const joinX = component.view.joinX + branchOffsetLeft;
            const offsetX = prevOffsetX;
            prevOffsetX += width;
            return {
                width: width,
                branchOffsetLeft: branchOffsetLeft,
                offsetX: offsetX,
                joinX: joinX
            };
        });
        const centerBranchIndex = Math.floor(branchNames.length / 2);
        const centerBranchSize = branchSizes[centerBranchIndex];
        let joinX = centerBranchSize.offsetX;
        if (branchNames.length % 2 !== 0) joinX += centerBranchSize.joinX;
        const totalBranchesWidth = branchSizes.reduce((result, s)=>result + s.width, 0);
        const maxBranchesHeight = Math.max(...branchComponents.map((s)=>s.view.height));
        const halfOfWidestSwitchElement = nameLabelView.width / 2 + cfg.paddingX;
        const switchOffsetLeft = Math.max(halfOfWidestSwitchElement - joinX, 0);
        const switchOffsetRight = Math.max(halfOfWidestSwitchElement - (totalBranchesWidth - joinX), 0);
        const viewWidth = switchOffsetLeft + totalBranchesWidth + switchOffsetRight;
        const viewHeight = maxBranchesHeight + cfg.paddingTop + cfg.nameLabel.height + cfg.branchNameLabel.height + cfg.connectionHeight * 2;
        const shiftedJoinX = switchOffsetLeft + joinX;
        $b668c8ebb790e355$export$1e2eb70c93855705.translate(nameLabelView.g, shiftedJoinX, 0);
        const branchOffsetTop = cfg.paddingTop + cfg.nameLabel.height + cfg.branchNameLabel.height + cfg.connectionHeight;
        branchComponents.forEach((component, i)=>{
            const branchSize = branchSizes[i];
            const branchOffsetLeft = switchOffsetLeft + branchSize.offsetX + branchSize.branchOffsetLeft;
            $b668c8ebb790e355$export$1e2eb70c93855705.translate(branchLabelViews[i].g, switchOffsetLeft + branchSize.offsetX + branchSize.joinX, 0);
            $b668c8ebb790e355$export$1e2eb70c93855705.translate(component.view.g, branchOffsetLeft, branchOffsetTop);
            if (component.hasOutput && stepContext.isOutputConnected) {
                const endOffsetTopOfComponent = cfg.paddingTop + cfg.nameLabel.height + cfg.branchNameLabel.height + cfg.connectionHeight + component.view.height;
                const missingHeight = viewHeight - endOffsetTopOfComponent - cfg.connectionHeight;
                if (missingHeight > 0) $b668c8ebb790e355$export$e144401a8d7d8961.createStraightJoin(g, new $b668c8ebb790e355$export$9b781de7bf37bf48(switchOffsetLeft + branchSize.offsetX + branchSize.joinX, endOffsetTopOfComponent), missingHeight);
            }
        });
        let inputView = null;
        if (cfg.inputSize > 0) {
            const iconUrl = viewContext.getStepIconUrl();
            inputView = $b668c8ebb790e355$export$d046d2870d3b0a10.createRectInput(g, shiftedJoinX, 0, cfg.inputSize, cfg.inputIconSize, iconUrl);
        }
        $b668c8ebb790e355$export$e144401a8d7d8961.createStraightJoin(g, new $b668c8ebb790e355$export$9b781de7bf37bf48(shiftedJoinX, 0), cfg.paddingTop);
        $b668c8ebb790e355$export$e144401a8d7d8961.createJoins(g, new $b668c8ebb790e355$export$9b781de7bf37bf48(shiftedJoinX, cfg.paddingTop + cfg.nameLabel.height), branchSizes.map((o)=>new $b668c8ebb790e355$export$9b781de7bf37bf48(switchOffsetLeft + o.offsetX + o.joinX, cfg.paddingTop + cfg.nameLabel.height + cfg.connectionHeight)));
        if (stepContext.isOutputConnected) {
            const ongoingSequenceIndexes = branchComponents.map((component, index)=>component.hasOutput ? index : null).filter((index)=>index !== null);
            const ongoingJoinTargets = ongoingSequenceIndexes.map((i)=>new $b668c8ebb790e355$export$9b781de7bf37bf48(switchOffsetLeft + branchSizes[i].offsetX + branchSizes[i].joinX, cfg.paddingTop + cfg.connectionHeight + cfg.nameLabel.height + cfg.branchNameLabel.height + maxBranchesHeight));
            if (ongoingJoinTargets.length > 0) $b668c8ebb790e355$export$e144401a8d7d8961.createJoins(g, new $b668c8ebb790e355$export$9b781de7bf37bf48(shiftedJoinX, viewHeight), ongoingJoinTargets);
        }
        const regions = branchSizes.map((s)=>s.width);
        regions[0] += switchOffsetLeft;
        regions[regions.length - 1] += switchOffsetRight;
        const regionView = $b668c8ebb790e355$export$99d0a526f07fd97b.create(g, regions, viewHeight);
        return {
            g: g,
            width: viewWidth,
            height: viewHeight,
            joinX: shiftedJoinX,
            placeholders: null,
            sequenceComponents: branchComponents,
            getClientPosition () {
                return regionView.getClientPosition();
            },
            resolveClick (click) {
                return regionView.resolveClick(click) || g.contains(click.element) ? true : null;
            },
            setIsDragging (isDragging) {
                inputView === null || inputView === void 0 || inputView.setIsHidden(isDragging);
            },
            setIsSelected (isSelected) {
                regionView.setIsSelected(isSelected);
            },
            setIsDisabled (isDisabled) {
                $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(g, isDisabled, "sqd-disabled");
            },
            hasOutput () {
                return branchComponents.some((c)=>c.hasOutput);
            }
        };
    };
const $b668c8ebb790e355$export$965405a8d9b9c636 = (isInterrupted, cfg)=>(parentElement, stepContext, viewContext)=>{
        const { step: step } = stepContext;
        const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g", {
            class: `sqd-step-task sqd-type-${step.type}`
        });
        parentElement.appendChild(g);
        const boxHeight = cfg.paddingY * 2 + cfg.iconSize;
        const text = $b668c8ebb790e355$export$1e2eb70c93855705.svg("text", {
            x: cfg.paddingLeft + cfg.iconSize + cfg.textMarginLeft,
            y: boxHeight / 2,
            class: "sqd-step-task-text"
        });
        text.textContent = step.name;
        g.appendChild(text);
        const textWidth = Math.max(text.getBBox().width, cfg.minTextWidth);
        const boxWidth = cfg.iconSize + cfg.paddingLeft + cfg.paddingRight + cfg.textMarginLeft + textWidth;
        const rect = $b668c8ebb790e355$export$1e2eb70c93855705.svg("rect", {
            x: 0.5,
            y: 0.5,
            class: "sqd-step-task-rect",
            width: boxWidth,
            height: boxHeight,
            rx: cfg.radius,
            ry: cfg.radius
        });
        g.insertBefore(rect, text);
        const iconUrl = viewContext.getStepIconUrl();
        const icon = iconUrl ? $b668c8ebb790e355$export$1e2eb70c93855705.svg("image", {
            href: iconUrl
        }) : $b668c8ebb790e355$export$1e2eb70c93855705.svg("rect", {
            class: "sqd-step-task-empty-icon",
            rx: cfg.radius,
            ry: cfg.radius
        });
        $b668c8ebb790e355$export$1e2eb70c93855705.attrs(icon, {
            x: cfg.paddingLeft,
            y: cfg.paddingY,
            width: cfg.iconSize,
            height: cfg.iconSize
        });
        g.appendChild(icon);
        const isInputViewHidden = stepContext.depth === 0 && stepContext.position === 0 && !stepContext.isInputConnected;
        const isOutputViewHidden = isInterrupted;
        const inputView = isInputViewHidden ? null : $b668c8ebb790e355$export$d046d2870d3b0a10.createRoundInput(g, boxWidth / 2, 0, cfg.inputSize);
        const outputView = isOutputViewHidden ? null : $b668c8ebb790e355$export$fa85ae460c856c26.create(g, boxWidth / 2, boxHeight, cfg.outputSize);
        return {
            g: g,
            width: boxWidth,
            height: boxHeight,
            joinX: boxWidth / 2,
            sequenceComponents: null,
            placeholders: null,
            hasOutput () {
                return !!outputView;
            },
            getClientPosition () {
                const r = rect.getBoundingClientRect();
                return new $b668c8ebb790e355$export$9b781de7bf37bf48(r.x, r.y);
            },
            resolveClick (click) {
                return g.contains(click.element) ? true : null;
            },
            setIsDragging (isDragging) {
                inputView === null || inputView === void 0 || inputView.setIsHidden(isDragging);
                outputView === null || outputView === void 0 || outputView.setIsHidden(isDragging);
            },
            setIsDisabled (isDisabled) {
                $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(g, isDisabled, "sqd-disabled");
            },
            setIsSelected (isSelected) {
                $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(rect, isSelected, "sqd-selected");
            }
        };
    };
class $b668c8ebb790e355$export$36bbac8737d1ee35 {
    static center(margin, canvasSize, rootComponentSize) {
        const canvasSafeWidth = Math.max(canvasSize.x - margin * 2, 0);
        const canvasSafeHeight = Math.max(canvasSize.y - margin * 2, 0);
        const scale = Math.min(Math.min(canvasSafeWidth / rootComponentSize.x, canvasSafeHeight / rootComponentSize.y), 1);
        const width = rootComponentSize.x * scale;
        const height = rootComponentSize.y * scale;
        const x = Math.max(0, (canvasSize.x - width) / 2);
        const y = Math.max(0, (canvasSize.y - height) / 2);
        return {
            position: new $b668c8ebb790e355$export$9b781de7bf37bf48(x, y),
            scale: scale
        };
    }
    static focusOnComponent(canvasSize, viewport, componentPosition, componentSize) {
        const realPosition = viewport.position.divideByScalar(viewport.scale).subtract(componentPosition.divideByScalar(viewport.scale));
        const componentOffset = componentSize.divideByScalar(2);
        const position = realPosition.add(canvasSize.divideByScalar(2)).subtract(componentOffset);
        return {
            position: position,
            scale: 1
        };
    }
}
class $b668c8ebb790e355$var$NextQuantifiedNumber {
    constructor(values){
        this.values = values;
    }
    next(value, direction) {
        let bestIndex = 0;
        let bestDistance = Number.MAX_VALUE;
        for(let i = 0; i < this.values.length; i++){
            const distance = Math.abs(this.values[i] - value);
            if (bestDistance > distance) {
                bestIndex = i;
                bestDistance = distance;
            }
        }
        let index;
        if (direction) index = Math.min(bestIndex + 1, this.values.length - 1);
        else index = Math.max(bestIndex - 1, 0);
        return {
            current: this.values[bestIndex],
            next: this.values[index]
        };
    }
}
const $b668c8ebb790e355$var$SCALES = [
    0.06,
    0.08,
    0.1,
    0.12,
    0.16,
    0.2,
    0.26,
    0.32,
    0.4,
    0.5,
    0.6,
    0.7,
    0.8,
    0.9,
    1
];
const $b668c8ebb790e355$var$MAX_DELTA_Y = 16;
const $b668c8ebb790e355$var$quantifiedScale = new $b668c8ebb790e355$var$NextQuantifiedNumber($b668c8ebb790e355$var$SCALES);
class $b668c8ebb790e355$export$6ecaa023d616901c {
    static zoom(current, direction) {
        const nextScale = $b668c8ebb790e355$var$quantifiedScale.next(current.scale, direction);
        return {
            position: current.position,
            scale: nextScale.next
        };
    }
    static zoomByWheel(current, e, canvasPosition) {
        if (e.deltaY === 0) return null;
        const nextScale = $b668c8ebb790e355$var$quantifiedScale.next(current.scale, e.deltaY < 0);
        let scale;
        const absDeltaY = Math.abs(e.deltaY);
        if (absDeltaY < $b668c8ebb790e355$var$MAX_DELTA_Y) {
            const fraction = absDeltaY / $b668c8ebb790e355$var$MAX_DELTA_Y;
            const step = nextScale.next - nextScale.current;
            scale = current.scale + step * fraction;
        } else scale = nextScale.next;
        const mousePoint = new $b668c8ebb790e355$export$9b781de7bf37bf48(e.pageX, e.pageY).subtract(canvasPosition);
        // The real point is point on canvas with no scale.
        const mouseRealPoint = mousePoint.divideByScalar(current.scale).subtract(current.position.divideByScalar(current.scale));
        const position = mouseRealPoint.multiplyByScalar(-scale).add(mousePoint);
        return {
            position: position,
            scale: scale
        };
    }
}
class $b668c8ebb790e355$var$ClassicWheelController {
    static create(api) {
        return new $b668c8ebb790e355$var$ClassicWheelController(api);
    }
    constructor(api){
        this.api = api;
    }
    onWheel(e) {
        const viewport = this.api.getViewport();
        const canvasPosition = this.api.getCanvasPosition();
        const newViewport = $b668c8ebb790e355$export$6ecaa023d616901c.zoomByWheel(viewport, e, canvasPosition);
        if (newViewport) this.api.setViewport(newViewport);
    }
}
class $b668c8ebb790e355$export$1caa0588f1264dfc {
    constructor(){
        this.create = $b668c8ebb790e355$var$ClassicWheelController.create;
    }
}
function $b668c8ebb790e355$var$animate(interval, handler) {
    const iv = setInterval(tick, 15);
    const startTime = Date.now();
    const anim = {
        isAlive: true,
        stop: ()=>{
            anim.isAlive = false;
            clearInterval(iv);
        }
    };
    function tick() {
        const progress = Math.min((Date.now() - startTime) / interval, 1);
        handler(progress);
        if (progress === 1) anim.stop();
    }
    return anim;
}
class $b668c8ebb790e355$var$ViewportAnimator {
    constructor(api){
        this.api = api;
    }
    execute(target) {
        if (this.animation && this.animation.isAlive) this.animation.stop();
        const viewport = this.api.getViewport();
        const startPosition = viewport.position;
        const startScale = viewport.scale;
        const deltaPosition = startPosition.subtract(target.position);
        const deltaScale = startScale - target.scale;
        this.animation = $b668c8ebb790e355$var$animate(150, (progress)=>{
            const newScale = startScale - deltaScale * progress;
            this.api.setViewport({
                position: startPosition.subtract(deltaPosition.multiplyByScalar(progress)),
                scale: newScale
            });
        });
    }
}
const $b668c8ebb790e355$var$CENTER_MARGIN = 10;
class $b668c8ebb790e355$export$be0dd43c10f70d61 {
    static create(api) {
        return new $b668c8ebb790e355$export$be0dd43c10f70d61(api);
    }
    constructor(api){
        this.api = api;
        this.animator = new $b668c8ebb790e355$var$ViewportAnimator(this.api);
    }
    setDefault() {
        const rootComponentSize = this.api.getRootComponentSize();
        const canvasSize = this.api.getCanvasSize();
        const target = $b668c8ebb790e355$export$36bbac8737d1ee35.center($b668c8ebb790e355$var$CENTER_MARGIN, canvasSize, rootComponentSize);
        this.api.setViewport(target);
    }
    zoom(direction) {
        const viewport = this.api.getViewport();
        const target = $b668c8ebb790e355$export$6ecaa023d616901c.zoom(viewport, direction);
        this.api.setViewport(target);
    }
    focusOnComponent(componentPosition, componentSize) {
        const viewport = this.api.getViewport();
        const canvasSize = this.api.getCanvasSize();
        const target = $b668c8ebb790e355$export$36bbac8737d1ee35.focusOnComponent(canvasSize, viewport, componentPosition, componentSize);
        this.animateTo(target);
    }
    animateTo(viewport) {
        this.animator.execute(viewport);
    }
}
class $b668c8ebb790e355$export$80c54b090f89a409 {
    constructor(){
        this.create = $b668c8ebb790e355$export$be0dd43c10f70d61.create;
    }
}
class $b668c8ebb790e355$export$3933642def4b1728 {
    static create(services) {
        const dict = {};
        for(let i = services.steps.length - 1; i >= 0; i--){
            const extension = services.steps[i];
            dict[extension.componentType] = extension;
        }
        return new $b668c8ebb790e355$export$3933642def4b1728(dict);
    }
    constructor(dict){
        this.dict = dict;
    }
    resolve(componentType) {
        const extension = this.dict[componentType];
        if (!extension) throw new Error(`Not supported component type: ${componentType}`);
        return extension;
    }
}
class $b668c8ebb790e355$export$75410064e8388d0 {
    static create(parent, size, direction, sequence, index, configuration) {
        const view = $b668c8ebb790e355$export$a0681089af028427.create(parent, size.x, size.y, configuration.radius, configuration.iconSize, direction);
        return new $b668c8ebb790e355$export$75410064e8388d0(view, sequence, index);
    }
    constructor(view, parentSequence, index){
        this.view = view;
        this.parentSequence = parentSequence;
        this.index = index;
    }
    getClientRect() {
        return this.view.rect.getBoundingClientRect();
    }
    setIsHover(isHover) {
        this.view.setIsHover(isHover);
    }
    setIsVisible(isVisible) {
        this.view.setIsVisible(isVisible);
    }
    resolveClick() {
        return null;
    }
}
function $b668c8ebb790e355$var$readMousePosition(e) {
    return new $b668c8ebb790e355$export$9b781de7bf37bf48(e.pageX, e.pageY);
}
function $b668c8ebb790e355$var$readTouchClientPosition(e) {
    if (e.touches.length > 0) {
        const touch = e.touches[0];
        return new $b668c8ebb790e355$export$9b781de7bf37bf48(touch.clientX, touch.clientY);
    }
    throw new Error("Unknown touch position");
}
function $b668c8ebb790e355$var$readTouchPosition(e) {
    if (e.touches.length > 0) {
        const touch = e.touches[0];
        return new $b668c8ebb790e355$export$9b781de7bf37bf48(touch.pageX, touch.pageY);
    }
    throw new Error("Unknown touch position");
}
const $b668c8ebb790e355$var$notInitializedError = "State is not initialized";
const $b668c8ebb790e355$var$nonPassiveOptions = {
    passive: false
};
class $b668c8ebb790e355$var$BehaviorController {
    constructor(){
        this.onMouseMove = (e)=>{
            e.preventDefault();
            this.move($b668c8ebb790e355$var$readMousePosition(e));
        };
        this.onTouchMove = (e)=>{
            e.preventDefault();
            this.move($b668c8ebb790e355$var$readTouchPosition(e));
        };
        this.onMouseUp = (e)=>{
            e.preventDefault();
            this.stop(false, e.target);
        };
        this.onTouchEnd = (e)=>{
            var _a;
            e.preventDefault();
            if (!this.state) throw new Error($b668c8ebb790e355$var$notInitializedError);
            const position = (_a = this.state.lastPosition) !== null && _a !== void 0 ? _a : this.state.startPosition;
            const element = document.elementFromPoint(position.x, position.y);
            this.stop(false, element);
        };
        this.onTouchStart = (e)=>{
            e.preventDefault();
            if (e.touches.length !== 1) this.stop(true, null);
        };
    }
    start(startPosition, behavior) {
        if (this.state) {
            this.stop(true, null);
            return;
        }
        this.state = {
            startPosition: startPosition,
            behavior: behavior
        };
        behavior.onStart(this.state.startPosition);
        window.addEventListener("mousemove", this.onMouseMove, false);
        window.addEventListener("touchmove", this.onTouchMove, $b668c8ebb790e355$var$nonPassiveOptions);
        window.addEventListener("mouseup", this.onMouseUp, false);
        window.addEventListener("touchend", this.onTouchEnd, $b668c8ebb790e355$var$nonPassiveOptions);
        window.addEventListener("touchstart", this.onTouchStart, $b668c8ebb790e355$var$nonPassiveOptions);
    }
    move(position) {
        if (!this.state) throw new Error($b668c8ebb790e355$var$notInitializedError);
        this.state.lastPosition = position;
        const delta = this.state.startPosition.subtract(position);
        const newBehavior = this.state.behavior.onMove(delta);
        if (newBehavior) {
            this.state.behavior.onEnd(true, null);
            this.state.behavior = newBehavior;
            this.state.startPosition = position;
            this.state.behavior.onStart(this.state.startPosition);
        }
    }
    stop(interrupt, element) {
        if (!this.state) throw new Error($b668c8ebb790e355$var$notInitializedError);
        window.removeEventListener("mousemove", this.onMouseMove, false);
        window.removeEventListener("touchmove", this.onTouchMove, $b668c8ebb790e355$var$nonPassiveOptions);
        window.removeEventListener("mouseup", this.onMouseUp, false);
        window.removeEventListener("touchend", this.onTouchEnd, $b668c8ebb790e355$var$nonPassiveOptions);
        window.removeEventListener("touchstart", this.onTouchStart, $b668c8ebb790e355$var$nonPassiveOptions);
        this.state.behavior.onEnd(interrupt, element);
        this.state = undefined;
    }
}
class $b668c8ebb790e355$var$SequenceModifier {
    static tryMoveStep(sourceSequence, step, targetSequence, targetIndex) {
        const sourceIndex = sourceSequence.indexOf(step);
        if (sourceIndex < 0) throw new Error("Step not found in source sequence");
        const isSameSequence = sourceSequence === targetSequence;
        if (isSameSequence) {
            if (sourceIndex < targetIndex) targetIndex--;
            if (sourceIndex === targetIndex) return null; // No changes
        }
        return function apply() {
            sourceSequence.splice(sourceIndex, 1);
            targetSequence.splice(targetIndex, 0, step);
        };
    }
    static insertStep(step, targetSequence, targetIndex) {
        targetSequence.splice(targetIndex, 0, step);
    }
    static deleteStep(step, parentSequence) {
        const index = parentSequence.indexOf(step);
        if (index < 0) throw new Error("Unknown step");
        parentSequence.splice(index, 1);
    }
}
class $b668c8ebb790e355$var$DefinitionModifier {
    constructor(definitionWalker, state, configuration){
        this.definitionWalker = definitionWalker;
        this.state = state;
        this.configuration = configuration;
    }
    isDeletable(stepId) {
        if (this.configuration.steps.isDeletable) {
            const result = this.definitionWalker.getParentSequence(this.state.definition, stepId);
            return this.configuration.steps.isDeletable(result.step, result.parentSequence);
        }
        return true;
    }
    tryDelete(stepId) {
        const result = this.definitionWalker.getParentSequence(this.state.definition, stepId);
        const canDeleteStep = this.configuration.steps.canDeleteStep ? this.configuration.steps.canDeleteStep(result.step, result.parentSequence) : true;
        if (!canDeleteStep) return false;
        $b668c8ebb790e355$var$SequenceModifier.deleteStep(result.step, result.parentSequence);
        this.state.notifyDefinitionChanged($b668c8ebb790e355$export$afd229a7a55e23c2.stepDeleted, result.step.id);
        this.updateDependantFields();
        return true;
    }
    tryInsert(step, targetSequence, targetIndex) {
        const canInsertStep = this.configuration.steps.canInsertStep ? this.configuration.steps.canInsertStep(step, targetSequence, targetIndex) : true;
        if (!canInsertStep) return false;
        $b668c8ebb790e355$var$SequenceModifier.insertStep(step, targetSequence, targetIndex);
        this.state.notifyDefinitionChanged($b668c8ebb790e355$export$afd229a7a55e23c2.stepInserted, step.id);
        this.state.setSelectedStepId(step.id);
        return true;
    }
    isDraggable(step, parentSequence) {
        return this.configuration.steps.isDraggable ? this.configuration.steps.isDraggable(step, parentSequence) : true;
    }
    tryMove(sourceSequence, step, targetSequence, targetIndex) {
        const apply = $b668c8ebb790e355$var$SequenceModifier.tryMoveStep(sourceSequence, step, targetSequence, targetIndex);
        if (!apply) return false;
        const canMoveStep = this.configuration.steps.canMoveStep ? this.configuration.steps.canMoveStep(sourceSequence, step, targetSequence, targetIndex) : true;
        if (!canMoveStep) return false;
        apply();
        this.state.notifyDefinitionChanged($b668c8ebb790e355$export$afd229a7a55e23c2.stepMoved, step.id);
        this.state.setSelectedStepId(step.id);
        return true;
    }
    replaceDefinition(definition) {
        if (!definition) throw new Error("Definition is empty");
        this.state.setDefinition(definition);
        this.updateDependantFields();
    }
    updateDependantFields() {
        if (this.state.selectedStepId) {
            const found = this.definitionWalker.findById(this.state.definition, this.state.selectedStepId);
            if (!found) // We need to unselect step when it's deleted.
            this.state.setSelectedStepId(null);
        }
        for(let index = 0; index < this.state.folderPath.length; index++){
            const stepId = this.state.folderPath[index];
            const found = this.definitionWalker.findById(this.state.definition, stepId);
            if (!found) {
                // We need to update path if any folder is deleted.
                const newPath = this.state.folderPath.slice(0, index);
                this.state.setFolderPath(newPath);
                break;
            }
        }
    }
}
class $b668c8ebb790e355$var$HistoryController {
    static create(state, definitionModifier, configuration) {
        if (!configuration.undoStackSize || configuration.undoStackSize < 1) throw new Error("Invalid undo stack size");
        const controller = new $b668c8ebb790e355$var$HistoryController(state, definitionModifier, configuration.undoStackSize);
        controller.remember($b668c8ebb790e355$export$afd229a7a55e23c2.rootReplaced, null);
        state.onDefinitionChanged.subscribe((event)=>{
            if (event.changeType !== $b668c8ebb790e355$export$afd229a7a55e23c2.rootReplaced) controller.remember(event.changeType, event.stepId);
        });
        return controller;
    }
    constructor(state, definitionModifier, stackSize){
        this.state = state;
        this.definitionModifier = definitionModifier;
        this.stackSize = stackSize;
        this.stack = [];
        this.currentIndex = 0;
    }
    canUndo() {
        return this.currentIndex > 1;
    }
    undo() {
        this.currentIndex--;
        this.commit();
    }
    canRedo() {
        return this.currentIndex < this.stack.length;
    }
    redo() {
        this.currentIndex++;
        this.commit();
    }
    remember(changeType, stepId) {
        const definition = $b668c8ebb790e355$export$f2181c17a691a65b.deepClone(this.state.definition);
        if (this.stack.length > 0 && this.currentIndex === this.stack.length) {
            const lastItem = this.stack[this.stack.length - 1];
            if ($b668c8ebb790e355$var$areItemsEqual(lastItem, changeType, stepId)) {
                lastItem.definition = definition;
                return;
            }
        }
        this.stack.splice(this.currentIndex);
        this.stack.push({
            definition: definition,
            changeType: changeType,
            stepId: stepId
        });
        if (this.stack.length > this.stackSize) this.stack.splice(0, this.stack.length - this.stackSize - 1);
        this.currentIndex = this.stack.length;
    }
    commit() {
        const definition = $b668c8ebb790e355$export$f2181c17a691a65b.deepClone(this.stack[this.currentIndex - 1].definition);
        this.definitionModifier.replaceDefinition(definition);
    }
}
function $b668c8ebb790e355$var$areItemsEqual(item, changeType, stepId) {
    return item.changeType === changeType && item.stepId === stepId;
}
class $b668c8ebb790e355$var$LayoutController {
    constructor(parent){
        this.parent = parent;
    }
    isMobile() {
        return this.parent.clientWidth < 400; // TODO
    }
}
class $b668c8ebb790e355$var$WorkspaceControllerWrapper {
    set(controller) {
        if (this.controller) throw new Error("Controller is already set");
        this.controller = controller;
    }
    get() {
        if (!this.controller) throw new Error("Controller is not set");
        return this.controller;
    }
    getPlaceholders() {
        return this.get().getPlaceholders();
    }
    getComponentByStepId(stepId) {
        return this.get().getComponentByStepId(stepId);
    }
    getCanvasPosition() {
        return this.get().getCanvasPosition();
    }
    getCanvasSize() {
        return this.get().getCanvasSize();
    }
    getRootComponentSize() {
        return this.get().getRootComponentSize();
    }
    updateBadges() {
        this.get().updateBadges();
    }
    updateRootComponent() {
        this.get().updateRootComponent();
    }
    updateCanvasSize() {
        this.get().updateCanvasSize();
    }
}
class $b668c8ebb790e355$export$cf98525e95b5411b {
    static create(parent, startDefinition, configuration, services) {
        var _a, _b, _c;
        const definition = $b668c8ebb790e355$export$f2181c17a691a65b.deepClone(startDefinition);
        const layoutController = new $b668c8ebb790e355$var$LayoutController(parent);
        const isReadonly = !!configuration.isReadonly;
        const isToolboxCollapsed = configuration.toolbox ? (_a = configuration.toolbox.isCollapsed) !== null && _a !== void 0 ? _a : layoutController.isMobile() : false;
        const isEditorCollapsed = configuration.editors ? (_b = configuration.editors.isCollapsed) !== null && _b !== void 0 ? _b : layoutController.isMobile() : false;
        const state = new $b668c8ebb790e355$export$cc4be4ee48b28947(definition, isReadonly, isToolboxCollapsed, isEditorCollapsed);
        const workspaceController = new $b668c8ebb790e355$var$WorkspaceControllerWrapper();
        const behaviorController = new $b668c8ebb790e355$var$BehaviorController();
        const stepExtensionResolver = $b668c8ebb790e355$export$3933642def4b1728.create(services);
        const definitionWalker = (_c = configuration.definitionWalker) !== null && _c !== void 0 ? _c : new (0, $80d696a83b36994b$export$5d7b81b9ee07c001)();
        const definitionModifier = new $b668c8ebb790e355$var$DefinitionModifier(definitionWalker, state, configuration);
        let historyController = undefined;
        if (configuration.undoStackSize) historyController = $b668c8ebb790e355$var$HistoryController.create(state, definitionModifier, configuration);
        const componentContext = $b668c8ebb790e355$export$baac0fb5196ccae9.create(configuration.steps, configuration.validator, state, stepExtensionResolver, services);
        return new $b668c8ebb790e355$export$cf98525e95b5411b(state, configuration, services, componentContext, definitionWalker, definitionModifier, layoutController, workspaceController, behaviorController, historyController);
    }
    constructor(state, configuration, services, componentContext, definitionWalker, definitionModifier, layoutController, workspaceController, behaviorController, historyController){
        this.state = state;
        this.configuration = configuration;
        this.services = services;
        this.componentContext = componentContext;
        this.definitionWalker = definitionWalker;
        this.definitionModifier = definitionModifier;
        this.layoutController = layoutController;
        this.workspaceController = workspaceController;
        this.behaviorController = behaviorController;
        this.historyController = historyController;
    }
    setWorkspaceController(controller) {
        this.workspaceController.set(controller);
    }
}
function $b668c8ebb790e355$var$isElementAttached(element) {
    return !(document.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_DISCONNECTED);
}
let $b668c8ebb790e355$var$lastGridPatternId = 0;
class $b668c8ebb790e355$var$WorkspaceView {
    static create(parent, componentContext) {
        const patternId = "sqd-grid-pattern-" + $b668c8ebb790e355$var$lastGridPatternId++;
        const pattern = $b668c8ebb790e355$export$1e2eb70c93855705.svg("pattern", {
            id: patternId,
            patternUnits: "userSpaceOnUse"
        });
        const gridPattern = componentContext.services.grid.create();
        const defs = $b668c8ebb790e355$export$1e2eb70c93855705.svg("defs");
        pattern.appendChild(gridPattern.element);
        defs.appendChild(pattern);
        const foreground = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g");
        const workspace = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: "sqd-workspace"
        });
        const canvas = $b668c8ebb790e355$export$1e2eb70c93855705.svg("svg", {
            class: "sqd-workspace-canvas"
        });
        canvas.appendChild(defs);
        canvas.appendChild($b668c8ebb790e355$export$1e2eb70c93855705.svg("rect", {
            width: "100%",
            height: "100%",
            fill: `url(#${patternId})`
        }));
        canvas.appendChild(foreground);
        workspace.appendChild(canvas);
        parent.appendChild(workspace);
        const view = new $b668c8ebb790e355$var$WorkspaceView(workspace, canvas, pattern, gridPattern, foreground, componentContext);
        window.addEventListener("resize", view.onResizeHandler, false);
        return view;
    }
    constructor(workspace, canvas, pattern, gridPattern, foreground, context){
        this.workspace = workspace;
        this.canvas = canvas;
        this.pattern = pattern;
        this.gridPattern = gridPattern;
        this.foreground = foreground;
        this.context = context;
        this.onResizeHandler = ()=>this.onResize();
    }
    render(sequence, parentSequencePlaceIndicator) {
        if (this.rootComponent) this.foreground.removeChild(this.rootComponent.view.g);
        this.rootComponent = this.context.services.rootComponent.create(this.foreground, sequence, parentSequencePlaceIndicator, this.context);
        this.refreshSize();
    }
    setPositionAndScale(position, scale) {
        const scaledSize = this.gridPattern.size.multiplyByScalar(scale);
        $b668c8ebb790e355$export$1e2eb70c93855705.attrs(this.pattern, {
            x: position.x,
            y: position.y,
            width: scaledSize.x,
            height: scaledSize.y
        });
        this.gridPattern.setScale(scale, scaledSize);
        $b668c8ebb790e355$export$1e2eb70c93855705.attrs(this.foreground, {
            transform: `translate(${position.x}, ${position.y}) scale(${scale})`
        });
    }
    getCanvasPosition() {
        const rect = this.canvas.getBoundingClientRect();
        return new $b668c8ebb790e355$export$9b781de7bf37bf48(rect.x + window.scrollX, rect.y + window.scrollY);
    }
    getCanvasSize() {
        return new $b668c8ebb790e355$export$9b781de7bf37bf48(this.canvas.clientWidth, this.canvas.clientHeight);
    }
    bindClick(handler) {
        this.canvas.addEventListener("mousedown", (e)=>{
            e.preventDefault();
            handler($b668c8ebb790e355$var$readMousePosition(e), e.target, e.button);
        }, false);
        this.canvas.addEventListener("touchstart", (e)=>{
            e.preventDefault();
            const clientPosition = $b668c8ebb790e355$var$readTouchClientPosition(e);
            const element = document.elementFromPoint(clientPosition.x, clientPosition.y);
            if (element) {
                const position = $b668c8ebb790e355$var$readTouchPosition(e);
                handler(position, element, 0);
            }
        }, {
            passive: false
        });
    }
    bindContextMenu(handler) {
        this.canvas.addEventListener("contextmenu", handler, false);
    }
    bindWheel(handler) {
        this.canvas.addEventListener("wheel", handler, false);
    }
    destroy() {
        window.removeEventListener("resize", this.onResizeHandler, false);
    }
    refreshSize() {
        $b668c8ebb790e355$export$1e2eb70c93855705.attrs(this.canvas, {
            width: this.workspace.offsetWidth,
            height: this.workspace.offsetHeight
        });
    }
    onResize() {
        this.refreshSize();
    }
}
class $b668c8ebb790e355$var$MoveViewportBehavior {
    static create(state, resetSelectedStep) {
        return new $b668c8ebb790e355$var$MoveViewportBehavior(state.viewport.position, resetSelectedStep, state);
    }
    constructor(startPosition, resetSelectedStep, state){
        this.startPosition = startPosition;
        this.resetSelectedStep = resetSelectedStep;
        this.state = state;
    }
    onStart() {
        if (this.resetSelectedStep) {
            const stepId = this.state.tryGetLastStepIdFromFolderPath();
            this.state.setSelectedStepId(stepId);
        }
    }
    onMove(delta) {
        this.state.setViewport({
            position: this.startPosition.subtract(delta),
            scale: this.state.viewport.scale
        });
    }
    onEnd() {
    // Nothing to do.
    }
}
class $b668c8ebb790e355$var$SelectStepBehavior {
    static create(pressedStepComponent, forceDisableDrag, context) {
        const isDragDisabled = forceDisableDrag || context.state.isDragDisabled || !context.definitionModifier.isDraggable(pressedStepComponent.step, pressedStepComponent.parentSequence);
        return new $b668c8ebb790e355$var$SelectStepBehavior(pressedStepComponent, isDragDisabled, context, context.state);
    }
    constructor(pressedStepComponent, isDragDisabled, context, state){
        this.pressedStepComponent = pressedStepComponent;
        this.isDragDisabled = isDragDisabled;
        this.context = context;
        this.state = state;
    }
    onStart() {
    // Nothing to do.
    }
    onMove(delta) {
        if (delta.distance() > 2) {
            const canDrag = !this.state.isReadonly && !this.isDragDisabled;
            if (canDrag) {
                this.state.setSelectedStepId(null);
                return $b668c8ebb790e355$var$DragStepBehavior.create(this.context, this.pressedStepComponent.step, this.pressedStepComponent);
            } else return $b668c8ebb790e355$var$MoveViewportBehavior.create(this.state, false);
        }
    }
    onEnd(interrupt) {
        if (!interrupt) this.state.setSelectedStepId(this.pressedStepComponent.step.id);
    }
}
class $b668c8ebb790e355$var$PressingBehavior {
    static create(clickedElement, handler) {
        return new $b668c8ebb790e355$var$PressingBehavior(clickedElement, handler);
    }
    constructor(clickedElement, handler){
        this.clickedElement = clickedElement;
        this.handler = handler;
    }
    onStart() {
    // Nothing...
    }
    onMove() {
    // Nothing...
    }
    onEnd(interrupt, element) {
        if (!interrupt && element && this.clickedElement === element) this.handler.handle();
    }
}
class $b668c8ebb790e355$var$RerenderStepPressingBehaviorHandler {
    constructor(designerContext){
        this.designerContext = designerContext;
    }
    handle() {
        this.designerContext.workspaceController.updateRootComponent();
    }
}
class $b668c8ebb790e355$var$OpenFolderPressingBehaviorHandler {
    constructor(command, designerContext){
        this.command = command;
        this.designerContext = designerContext;
    }
    handle() {
        const stepId = this.command.step.id;
        this.designerContext.state.pushStepIdToFolderPath(stepId);
    }
}
class $b668c8ebb790e355$var$TriggerCustomActionPressingBehaviorHandler {
    constructor(command, designerContext){
        this.command = command;
        this.designerContext = designerContext;
    }
    handle() {
        const customActionHandler = this.designerContext.configuration.customActionHandler;
        if (!customActionHandler) {
            console.warn(`Custom action handler is not defined (action type: ${this.command.action.type})`);
            return;
        }
        const context = this.createContext();
        customActionHandler(this.command.action, this.command.step, this.command.sequence, context);
    }
    createContext() {
        return {
            notifyStepNameChanged: (stepId)=>this.notifyStepChanged($b668c8ebb790e355$export$afd229a7a55e23c2.stepNameChanged, stepId),
            notifyStepPropertiesChanged: (stepId)=>this.notifyStepChanged($b668c8ebb790e355$export$afd229a7a55e23c2.stepPropertyChanged, stepId),
            notifyStepInserted: (stepId)=>this.notifyStepChanged($b668c8ebb790e355$export$afd229a7a55e23c2.stepInserted, stepId),
            notifyStepMoved: (stepId)=>this.notifyStepChanged($b668c8ebb790e355$export$afd229a7a55e23c2.stepMoved, stepId),
            notifyStepDeleted: (stepId)=>this.notifyStepChanged($b668c8ebb790e355$export$afd229a7a55e23c2.stepDeleted, stepId)
        };
    }
    notifyStepChanged(changeType, stepId) {
        if (!stepId) throw new Error("Step id is empty");
        this.designerContext.state.notifyDefinitionChanged(changeType, stepId);
    }
}
class $b668c8ebb790e355$var$ClickBehaviorResolver {
    constructor(designerContext, state){
        this.designerContext = designerContext;
        this.state = state;
    }
    resolve(rootComponent, element, position, forceDisableDrag) {
        const click = {
            element: element,
            position: position,
            scale: this.state.viewport.scale
        };
        const command = rootComponent.resolveClick(click);
        if (!command) return $b668c8ebb790e355$var$MoveViewportBehavior.create(this.state, true);
        switch(command.type){
            case $b668c8ebb790e355$export$82c5bd54d8caea70.selectStep:
                return $b668c8ebb790e355$var$SelectStepBehavior.create(command.component, forceDisableDrag, this.designerContext);
            case $b668c8ebb790e355$export$82c5bd54d8caea70.rerenderStep:
                return $b668c8ebb790e355$var$PressingBehavior.create(element, new $b668c8ebb790e355$var$RerenderStepPressingBehaviorHandler(this.designerContext));
            case $b668c8ebb790e355$export$82c5bd54d8caea70.openFolder:
                return $b668c8ebb790e355$var$PressingBehavior.create(element, new $b668c8ebb790e355$var$OpenFolderPressingBehaviorHandler(command, this.designerContext));
            case $b668c8ebb790e355$export$82c5bd54d8caea70.triggerCustomAction:
                return $b668c8ebb790e355$var$PressingBehavior.create(element, new $b668c8ebb790e355$var$TriggerCustomActionPressingBehaviorHandler(command, this.designerContext));
            default:
                throw new Error("Not supported behavior type");
        }
    }
}
class $b668c8ebb790e355$var$BadgesResultFactory {
    static create(services) {
        return services.badges.map((ext)=>ext.createStartValue());
    }
}
function $b668c8ebb790e355$var$findValidationBadgeIndex(extensions) {
    return extensions.findIndex((ext)=>ext.id === "validationError");
}
class $b668c8ebb790e355$var$Workspace {
    static create(parent, designerContext, api) {
        const view = $b668c8ebb790e355$var$WorkspaceView.create(parent, designerContext.componentContext);
        const clickBehaviorResolver = new $b668c8ebb790e355$var$ClickBehaviorResolver(designerContext, designerContext.state);
        const wheelController = designerContext.services.wheelController.create(api.workspace);
        const workspace = new $b668c8ebb790e355$var$Workspace(view, designerContext.definitionWalker, designerContext.state, designerContext.behaviorController, wheelController, clickBehaviorResolver, api.viewport, designerContext.services);
        setTimeout(()=>{
            workspace.updateRootComponent();
            api.viewport.resetViewport();
            workspace.onReady.forward();
        });
        designerContext.setWorkspaceController(workspace);
        designerContext.state.onViewportChanged.subscribe((vp)=>workspace.onViewportChanged(vp));
        designerContext.state.onIsDraggingChanged.subscribe((is)=>workspace.onIsDraggingChanged(is));
        $b668c8ebb790e355$export$236c05de452bec2(0, designerContext.state.onDefinitionChanged, designerContext.state.onSelectedStepIdChanged, designerContext.state.onFolderPathChanged).subscribe((r)=>{
            workspace.onStateChanged(r[0], r[1], r[2]);
        });
        view.bindClick((p, t, b)=>workspace.onClick(p, t, b));
        view.bindWheel((e)=>workspace.onWheel(e));
        view.bindContextMenu((e)=>workspace.onContextMenu(e));
        return workspace;
    }
    constructor(view, definitionWalker, state, behaviorController, wheelController, clickBehaviorResolver, viewportApi, services){
        this.view = view;
        this.definitionWalker = definitionWalker;
        this.state = state;
        this.behaviorController = behaviorController;
        this.wheelController = wheelController;
        this.clickBehaviorResolver = clickBehaviorResolver;
        this.viewportApi = viewportApi;
        this.services = services;
        this.onReady = new $b668c8ebb790e355$export$298d5abb39333987();
        this.isValid = false;
        this.selectedStepComponent = null;
        this.validationErrorBadgeIndex = null;
    }
    updateRootComponent() {
        this.selectedStepComponent = null;
        let parentSequencePlaceIndicator;
        let sequence;
        const stepId = this.state.tryGetLastStepIdFromFolderPath();
        if (stepId) {
            const parentSequence = this.definitionWalker.getParentSequence(this.state.definition, stepId);
            const children = this.definitionWalker.getChildren(parentSequence.step);
            if (!children || children.type !== (0, $80d696a83b36994b$export$e70eb8b76bb64866).sequence) throw new Error("Cannot find single sequence in folder step");
            sequence = children.items;
            parentSequencePlaceIndicator = {
                sequence: parentSequence.parentSequence,
                index: parentSequence.index
            };
        } else {
            sequence = this.state.definition.sequence;
            parentSequencePlaceIndicator = null;
        }
        this.view.render(sequence, parentSequencePlaceIndicator);
        this.trySelectStepComponent(this.state.selectedStepId);
        this.updateBadges();
    }
    updateBadges() {
        const result = $b668c8ebb790e355$var$BadgesResultFactory.create(this.services);
        this.getRootComponent().updateBadges(result);
        if (this.validationErrorBadgeIndex === null) this.validationErrorBadgeIndex = $b668c8ebb790e355$var$findValidationBadgeIndex(this.services.badges);
        this.isValid = Boolean(result[this.validationErrorBadgeIndex]);
    }
    getPlaceholders() {
        const result = [];
        this.getRootComponent().getPlaceholders(result);
        return result;
    }
    getComponentByStepId(stepId) {
        const component = this.getRootComponent().findById(stepId);
        if (!component) throw new Error(`Cannot find component for step id: ${stepId}`);
        return component;
    }
    getCanvasPosition() {
        return this.view.getCanvasPosition();
    }
    getCanvasSize() {
        return this.view.getCanvasSize();
    }
    getRootComponentSize() {
        const view = this.getRootComponent().view;
        return new $b668c8ebb790e355$export$9b781de7bf37bf48(view.width, view.height);
    }
    updateCanvasSize() {
        setTimeout(()=>this.view.refreshSize());
    }
    destroy() {
        this.view.destroy();
    }
    onClick(position, target, buttonIndex) {
        const isPrimaryButton = buttonIndex === 0;
        const isMiddleButton = buttonIndex === 1;
        if (isPrimaryButton || isMiddleButton) {
            const rootComponent = this.getRootComponent();
            const forceDisableDrag = isMiddleButton;
            const behavior = this.clickBehaviorResolver.resolve(rootComponent, target, position, forceDisableDrag);
            this.behaviorController.start(position, behavior);
        }
    }
    onWheel(e) {
        e.preventDefault();
        e.stopPropagation();
        this.wheelController.onWheel(e);
    }
    onContextMenu(e) {
        e.preventDefault();
    }
    onIsDraggingChanged(isDragging) {
        this.getRootComponent().setIsDragging(isDragging);
    }
    onViewportChanged(viewport) {
        this.view.setPositionAndScale(viewport.position, viewport.scale);
    }
    onStateChanged(definitionChanged, selectedStepIdChanged, folderPathChanged) {
        if (folderPathChanged) {
            this.updateRootComponent();
            this.viewportApi.resetViewport();
        } else if (definitionChanged) {
            if (definitionChanged.changeType === $b668c8ebb790e355$export$afd229a7a55e23c2.stepPropertyChanged) this.updateBadges();
            else this.updateRootComponent();
        } else if (selectedStepIdChanged !== undefined) this.trySelectStepComponent(selectedStepIdChanged);
    }
    trySelectStepComponent(stepId) {
        if (this.selectedStepComponent) {
            this.selectedStepComponent.setIsSelected(false);
            this.selectedStepComponent = null;
        }
        if (stepId) {
            this.selectedStepComponent = this.getRootComponent().findById(stepId);
            if (this.selectedStepComponent) this.selectedStepComponent.setIsSelected(true);
        }
    }
    getRootComponent() {
        if (this.view.rootComponent) return this.view.rootComponent;
        throw new Error("Root component not found");
    }
}
class $b668c8ebb790e355$var$DesignerView {
    static create(parent, designerContext, configuration, api) {
        const theme = configuration.theme || "light";
        const root = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: `sqd-designer sqd-theme-${theme}`
        });
        parent.appendChild(root);
        const workspace = $b668c8ebb790e355$var$Workspace.create(root, designerContext, api);
        const uiComponents = designerContext.services.uiComponents.map((factory)=>factory.create(root, api));
        const daemons = designerContext.services.daemons.map((factory)=>factory.create(api));
        const view = new $b668c8ebb790e355$var$DesignerView(root, designerContext.layoutController, workspace, uiComponents, daemons);
        view.reloadLayout();
        window.addEventListener("resize", view.onResizeHandler, false);
        return view;
    }
    constructor(root, layoutController, workspace, uiComponents, daemons){
        this.root = root;
        this.layoutController = layoutController;
        this.workspace = workspace;
        this.uiComponents = uiComponents;
        this.daemons = daemons;
        this.onResizeHandler = ()=>this.onResize();
    }
    destroy() {
        var _a;
        window.removeEventListener("resize", this.onResizeHandler, false);
        this.workspace.destroy();
        this.uiComponents.forEach((component)=>component.destroy());
        this.daemons.forEach((daemon)=>daemon.destroy());
        (_a = this.root.parentElement) === null || _a === void 0 || _a.removeChild(this.root);
    }
    onResize() {
        this.reloadLayout();
    }
    reloadLayout() {
        const isMobile = this.layoutController.isMobile();
        $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(this.root, !isMobile, "sqd-layout-desktop");
        $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(this.root, isMobile, "sqd-layout-mobile");
    }
}
const $b668c8ebb790e355$var$SAFE_OFFSET = 10;
class $b668c8ebb790e355$var$DefaultDraggedComponent {
    static create(parent, step, componentContext) {
        const canvas = $b668c8ebb790e355$export$1e2eb70c93855705.svg("svg");
        canvas.style.marginLeft = -$b668c8ebb790e355$var$SAFE_OFFSET + "px";
        canvas.style.marginTop = -$b668c8ebb790e355$var$SAFE_OFFSET + "px";
        parent.appendChild(canvas);
        const fakeStepContext = {
            parentSequence: [],
            step: step,
            depth: 0,
            position: 0,
            isInputConnected: true,
            isOutputConnected: true
        };
        const stepComponent = componentContext.stepComponentFactory.create(canvas, fakeStepContext, componentContext);
        $b668c8ebb790e355$export$1e2eb70c93855705.attrs(canvas, {
            width: stepComponent.view.width + $b668c8ebb790e355$var$SAFE_OFFSET * 2,
            height: stepComponent.view.height + $b668c8ebb790e355$var$SAFE_OFFSET * 2
        });
        $b668c8ebb790e355$export$1e2eb70c93855705.translate(stepComponent.view.g, $b668c8ebb790e355$var$SAFE_OFFSET, $b668c8ebb790e355$var$SAFE_OFFSET);
        return new $b668c8ebb790e355$var$DefaultDraggedComponent(stepComponent.view.width, stepComponent.view.height);
    }
    constructor(width, height){
        this.width = width;
        this.height = height;
    }
    destroy() {
    // Nothing to destroy...
    }
}
class $b668c8ebb790e355$var$DefaultDraggedComponentExtension {
    constructor(){
        this.create = $b668c8ebb790e355$var$DefaultDraggedComponent.create;
    }
}
class $b668c8ebb790e355$var$ControlBarView {
    static create(parent, isUndoRedoSupported) {
        const root = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: "sqd-control-bar"
        });
        const resetButton = $b668c8ebb790e355$var$createButton($b668c8ebb790e355$export$4f13f83fd8bb1dac.center, "Reset view");
        root.appendChild(resetButton);
        const zoomInButton = $b668c8ebb790e355$var$createButton($b668c8ebb790e355$export$4f13f83fd8bb1dac.zoomIn, "Zoom in");
        root.appendChild(zoomInButton);
        const zoomOutButton = $b668c8ebb790e355$var$createButton($b668c8ebb790e355$export$4f13f83fd8bb1dac.zoomOut, "Zoom out");
        root.appendChild(zoomOutButton);
        let undoButton = null;
        let redoButton = null;
        if (isUndoRedoSupported) {
            undoButton = $b668c8ebb790e355$var$createButton($b668c8ebb790e355$export$4f13f83fd8bb1dac.undo, "Undo");
            root.appendChild(undoButton);
            redoButton = $b668c8ebb790e355$var$createButton($b668c8ebb790e355$export$4f13f83fd8bb1dac.redo, "Redo");
            root.appendChild(redoButton);
        }
        const disableDragButton = $b668c8ebb790e355$var$createButton($b668c8ebb790e355$export$4f13f83fd8bb1dac.move, "Turn on/off drag and drop");
        disableDragButton.classList.add("sqd-disabled");
        root.appendChild(disableDragButton);
        const deleteButton = $b668c8ebb790e355$var$createButton($b668c8ebb790e355$export$4f13f83fd8bb1dac.delete, "Delete selected step");
        deleteButton.classList.add("sqd-delete");
        deleteButton.classList.add("sqd-hidden");
        root.appendChild(deleteButton);
        parent.appendChild(root);
        return new $b668c8ebb790e355$var$ControlBarView(resetButton, zoomInButton, zoomOutButton, undoButton, redoButton, disableDragButton, deleteButton);
    }
    constructor(resetButton, zoomInButton, zoomOutButton, undoButton, redoButton, disableDragButton, deleteButton){
        this.resetButton = resetButton;
        this.zoomInButton = zoomInButton;
        this.zoomOutButton = zoomOutButton;
        this.undoButton = undoButton;
        this.redoButton = redoButton;
        this.disableDragButton = disableDragButton;
        this.deleteButton = deleteButton;
    }
    bindResetButtonClick(handler) {
        $b668c8ebb790e355$var$bindClick(this.resetButton, handler);
    }
    bindZoomInButtonClick(handler) {
        $b668c8ebb790e355$var$bindClick(this.zoomInButton, handler);
    }
    bindZoomOutButtonClick(handler) {
        $b668c8ebb790e355$var$bindClick(this.zoomOutButton, handler);
    }
    bindUndoButtonClick(handler) {
        if (!this.undoButton) throw new Error("Undo button is disabled");
        $b668c8ebb790e355$var$bindClick(this.undoButton, handler);
    }
    bindRedoButtonClick(handler) {
        if (!this.redoButton) throw new Error("Redo button is disabled");
        $b668c8ebb790e355$var$bindClick(this.redoButton, handler);
    }
    bindDisableDragButtonClick(handler) {
        $b668c8ebb790e355$var$bindClick(this.disableDragButton, handler);
    }
    bindDeleteButtonClick(handler) {
        $b668c8ebb790e355$var$bindClick(this.deleteButton, handler);
    }
    setIsDeleteButtonHidden(isHidden) {
        $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(this.deleteButton, isHidden, "sqd-hidden");
    }
    setDisableDragButtonDisabled(isDisabled) {
        $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(this.disableDragButton, isDisabled, "sqd-disabled");
    }
    setUndoButtonDisabled(isDisabled) {
        if (!this.undoButton) throw new Error("Undo button is disabled");
        $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(this.undoButton, isDisabled, "sqd-disabled");
    }
    setRedoButtonDisabled(isDisabled) {
        if (!this.redoButton) throw new Error("Redo button is disabled");
        $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(this.redoButton, isDisabled, "sqd-disabled");
    }
}
function $b668c8ebb790e355$var$bindClick(element, handler) {
    element.addEventListener("click", (e)=>{
        e.preventDefault();
        handler();
    }, false);
}
function $b668c8ebb790e355$var$createButton(d, title) {
    const button = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
        class: "sqd-control-bar-button",
        title: title
    });
    const icon = $b668c8ebb790e355$export$4f13f83fd8bb1dac.createSvg("sqd-control-bar-button-icon", d);
    button.appendChild(icon);
    return button;
}
class $b668c8ebb790e355$var$ControlBar {
    static create(parent, api) {
        const isUndoRedoSupported = api.controlBar.isUndoRedoSupported();
        const view = $b668c8ebb790e355$var$ControlBarView.create(parent, isUndoRedoSupported);
        const bar = new $b668c8ebb790e355$var$ControlBar(view, api.controlBar, isUndoRedoSupported);
        view.bindResetButtonClick(()=>bar.onResetButtonClicked());
        view.bindZoomInButtonClick(()=>bar.onZoomInButtonClicked());
        view.bindZoomOutButtonClick(()=>bar.onZoomOutButtonClicked());
        view.bindDisableDragButtonClick(()=>bar.onMoveButtonClicked());
        view.bindDeleteButtonClick(()=>bar.onDeleteButtonClicked());
        api.controlBar.subscribe(()=>bar.refreshButtons());
        if (isUndoRedoSupported) {
            view.bindUndoButtonClick(()=>bar.onUndoButtonClicked());
            view.bindRedoButtonClick(()=>bar.onRedoButtonClicked());
        }
        bar.refreshButtons();
        return bar;
    }
    constructor(view, controlBarApi, isUndoRedoSupported){
        this.view = view;
        this.controlBarApi = controlBarApi;
        this.isUndoRedoSupported = isUndoRedoSupported;
    }
    destroy() {
    //
    }
    onResetButtonClicked() {
        this.controlBarApi.resetViewport();
    }
    onZoomInButtonClicked() {
        this.controlBarApi.zoomIn();
    }
    onZoomOutButtonClicked() {
        this.controlBarApi.zoomOut();
    }
    onMoveButtonClicked() {
        this.controlBarApi.toggleIsDragDisabled();
    }
    onUndoButtonClicked() {
        this.controlBarApi.tryUndo();
    }
    onRedoButtonClicked() {
        this.controlBarApi.tryRedo();
    }
    onDeleteButtonClicked() {
        this.controlBarApi.tryDelete();
    }
    refreshButtons() {
        this.refreshDeleteButtonVisibility();
        this.refreshIsDragDisabled();
        if (this.isUndoRedoSupported) this.refreshUndoRedoAvailability();
    }
    //
    refreshIsDragDisabled() {
        const isDragDisabled = this.controlBarApi.isDragDisabled();
        this.view.setDisableDragButtonDisabled(!isDragDisabled);
    }
    refreshUndoRedoAvailability() {
        const canUndo = this.controlBarApi.canUndo();
        const canRedo = this.controlBarApi.canRedo();
        this.view.setUndoButtonDisabled(!canUndo);
        this.view.setRedoButtonDisabled(!canRedo);
    }
    refreshDeleteButtonVisibility() {
        const canDelete = this.controlBarApi.canDelete();
        this.view.setIsDeleteButtonHidden(!canDelete);
    }
}
class $b668c8ebb790e355$var$ControlBarExtension {
    constructor(){
        this.create = $b668c8ebb790e355$var$ControlBar.create;
    }
}
const $b668c8ebb790e355$var$supportedKeys = [
    "Backspace",
    "Delete"
];
const $b668c8ebb790e355$var$ignoreTagNames = [
    "INPUT",
    "TEXTAREA"
];
class $b668c8ebb790e355$var$KeyboardDaemon {
    static create(api) {
        const controller = new $b668c8ebb790e355$var$KeyboardDaemon(api.controlBar);
        document.addEventListener("keyup", controller.onKeyUp, false);
        return controller;
    }
    constructor(controlBarApi){
        this.controlBarApi = controlBarApi;
        this.onKeyUp = (e)=>{
            if (!$b668c8ebb790e355$var$supportedKeys.includes(e.key)) return;
            if (document.activeElement && $b668c8ebb790e355$var$ignoreTagNames.includes(document.activeElement.tagName)) return;
            const isDeletable = this.controlBarApi.canDelete();
            if (isDeletable) {
                e.preventDefault();
                e.stopPropagation();
                this.controlBarApi.tryDelete();
            }
        };
    }
    destroy() {
        document.removeEventListener("keyup", this.onKeyUp, false);
    }
}
class $b668c8ebb790e355$var$KeyboardDaemonExtension {
    constructor(){
        this.create = $b668c8ebb790e355$var$KeyboardDaemon.create;
    }
}
class $b668c8ebb790e355$var$SmartEditorView {
    static create(parent, api, configuration) {
        const root = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: "sqd-smart-editor"
        });
        const toggle = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: "sqd-smart-editor-toggle",
            title: "Toggle editor"
        });
        parent.appendChild(toggle);
        parent.appendChild(root);
        const editor = $b668c8ebb790e355$export$7cda8d932e2f33c0.create(root, api, "sqd-editor sqd-step-editor", configuration.stepEditorProvider, "sqd-editor sqd-global-editor", configuration.globalEditorProvider);
        return new $b668c8ebb790e355$var$SmartEditorView(root, toggle, editor);
    }
    constructor(root, toggle, editor){
        this.root = root;
        this.toggle = toggle;
        this.editor = editor;
    }
    bindToggleClick(handler) {
        this.toggle.addEventListener("click", (e)=>{
            e.preventDefault();
            handler();
        }, false);
    }
    setIsCollapsed(isCollapsed) {
        $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(this.root, isCollapsed, "sqd-hidden");
        $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(this.toggle, isCollapsed, "sqd-collapsed");
        if (this.toggleIcon) this.toggle.removeChild(this.toggleIcon);
        this.toggleIcon = $b668c8ebb790e355$export$4f13f83fd8bb1dac.createSvg("sqd-smart-editor-toggle-icon", isCollapsed ? $b668c8ebb790e355$export$4f13f83fd8bb1dac.options : $b668c8ebb790e355$export$4f13f83fd8bb1dac.close);
        this.toggle.appendChild(this.toggleIcon);
    }
    destroy() {
        this.editor.destroy();
    }
}
class $b668c8ebb790e355$var$SmartEditor {
    static create(parent, api, configuration) {
        const view = $b668c8ebb790e355$var$SmartEditorView.create(parent, api.editor, configuration);
        const editor = new $b668c8ebb790e355$var$SmartEditor(view, api.editor, api.workspace);
        editor.updateVisibility();
        view.bindToggleClick(()=>editor.onToggleClicked());
        api.editor.subscribeIsCollapsed(()=>editor.onIsCollapsedChanged());
        return editor;
    }
    constructor(view, editorApi, workspaceApi){
        this.view = view;
        this.editorApi = editorApi;
        this.workspaceApi = workspaceApi;
    }
    onToggleClicked() {
        this.editorApi.toggleIsCollapsed();
    }
    setIsCollapsed(isCollapsed) {
        this.view.setIsCollapsed(isCollapsed);
    }
    onIsCollapsedChanged() {
        this.updateVisibility();
        this.workspaceApi.updateCanvasSize();
    }
    updateVisibility() {
        this.setIsCollapsed(this.editorApi.isCollapsed());
    }
    destroy() {
        this.view.destroy();
    }
}
class $b668c8ebb790e355$var$SmartEditorExtension {
    constructor(configuration){
        this.configuration = configuration;
    }
    create(root, api) {
        return $b668c8ebb790e355$var$SmartEditor.create(root, api, this.configuration);
    }
}
const $b668c8ebb790e355$var$listenerOptions = {
    passive: false
};
class $b668c8ebb790e355$var$ScrollBoxView {
    static create(parent, viewport) {
        const root = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: "sqd-scrollbox"
        });
        parent.appendChild(root);
        const view = new $b668c8ebb790e355$var$ScrollBoxView(root, viewport);
        window.addEventListener("resize", view.onResize, false);
        root.addEventListener("wheel", (e)=>view.onWheel(e), false);
        root.addEventListener("touchstart", (e)=>view.onTouchStart(e), $b668c8ebb790e355$var$listenerOptions);
        root.addEventListener("mousedown", (e)=>view.onMouseDown(e), false);
        return view;
    }
    constructor(root, viewport){
        this.root = root;
        this.viewport = viewport;
        this.onResize = ()=>{
            this.refresh();
        };
        this.onTouchStart = (e)=>{
            e.preventDefault();
            this.startScroll($b668c8ebb790e355$var$readTouchPosition(e));
        };
        this.onMouseDown = (e)=>{
            this.startScroll($b668c8ebb790e355$var$readMousePosition(e));
        };
        this.onTouchMove = (e)=>{
            e.preventDefault();
            this.moveScroll($b668c8ebb790e355$var$readTouchPosition(e));
        };
        this.onMouseMove = (e)=>{
            e.preventDefault();
            this.moveScroll($b668c8ebb790e355$var$readMousePosition(e));
        };
        this.onTouchEnd = (e)=>{
            e.preventDefault();
            this.stopScroll();
        };
        this.onMouseUp = (e)=>{
            e.preventDefault();
            this.stopScroll();
        };
    }
    setContent(element) {
        if (this.content) this.root.removeChild(this.content.element);
        element.classList.add("sqd-scrollbox-body");
        this.root.appendChild(element);
        this.reload(element);
    }
    refresh() {
        if (this.content) this.reload(this.content.element);
    }
    destroy() {
        window.removeEventListener("resize", this.onResize, false);
    }
    reload(element) {
        const maxHeightPercent = 0.7;
        const minDistance = 206;
        let height = Math.min(this.viewport.clientHeight * maxHeightPercent, element.clientHeight);
        height = Math.min(height, this.viewport.clientHeight - minDistance);
        this.root.style.height = height + "px";
        element.style.top = "0px";
        this.content = {
            element: element,
            height: height
        };
    }
    onWheel(e) {
        e.stopPropagation();
        if (this.content) {
            const delta = e.deltaY > 0 ? -25 : 25;
            const scrollTop = this.getScrollTop();
            this.setScrollTop(scrollTop + delta);
        }
    }
    startScroll(startPosition) {
        if (!this.scroll) {
            window.addEventListener("touchmove", this.onTouchMove, $b668c8ebb790e355$var$listenerOptions);
            window.addEventListener("mousemove", this.onMouseMove, false);
            window.addEventListener("touchend", this.onTouchEnd, $b668c8ebb790e355$var$listenerOptions);
            window.addEventListener("mouseup", this.onMouseUp, false);
        }
        this.scroll = {
            startPositionY: startPosition.y,
            startScrollTop: this.getScrollTop()
        };
    }
    moveScroll(position) {
        if (this.scroll) {
            const delta = position.y - this.scroll.startPositionY;
            this.setScrollTop(this.scroll.startScrollTop + delta);
        }
    }
    stopScroll() {
        if (this.scroll) {
            window.removeEventListener("touchmove", this.onTouchMove, $b668c8ebb790e355$var$listenerOptions);
            window.removeEventListener("mousemove", this.onMouseMove, false);
            window.removeEventListener("touchend", this.onTouchEnd, $b668c8ebb790e355$var$listenerOptions);
            window.removeEventListener("mouseup", this.onMouseUp, false);
            this.scroll = undefined;
        }
    }
    getScrollTop() {
        if (this.content && this.content.element.style.top) return parseInt(this.content.element.style.top);
        return 0;
    }
    setScrollTop(scrollTop) {
        if (this.content) {
            const max = this.content.element.clientHeight - this.content.height;
            const limited = Math.max(Math.min(scrollTop, 0), -max);
            this.content.element.style.top = limited + "px";
        }
    }
}
const $b668c8ebb790e355$var$regexp = /^[a-zA-Z][a-zA-Z0-9_-]+$/;
class $b668c8ebb790e355$var$StepTypeValidator {
    static validate(type) {
        if (!$b668c8ebb790e355$var$regexp.test(type)) throw new Error(`Step type "${type}" contains not allowed characters`);
    }
}
class $b668c8ebb790e355$var$ToolboxItemView {
    static create(parent, step, api) {
        const label = api.getLabel(step);
        const root = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: `sqd-toolbox-item sqd-type-${step.type}`,
            title: label
        });
        const iconUrl = api.tryGetIconUrl(step);
        const icon = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: "sqd-toolbox-item-icon"
        });
        if (iconUrl) {
            const iconImage = $b668c8ebb790e355$export$1e2eb70c93855705.element("img", {
                class: "sqd-toolbox-item-icon-image",
                src: iconUrl
            });
            icon.appendChild(iconImage);
        } else icon.classList.add("sqd-no-icon");
        const text = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: "sqd-toolbox-item-text"
        });
        text.textContent = label;
        root.appendChild(icon);
        root.appendChild(text);
        parent.appendChild(root);
        return new $b668c8ebb790e355$var$ToolboxItemView(root);
    }
    constructor(root){
        this.root = root;
    }
    bindMousedown(handler) {
        this.root.addEventListener("mousedown", handler, false);
    }
    bindTouchstart(handler) {
        this.root.addEventListener("touchstart", handler, false);
    }
    bindContextMenu(handler) {
        this.root.addEventListener("contextmenu", handler, false);
    }
}
class $b668c8ebb790e355$var$ToolboxItem {
    static create(parent, step, api) {
        $b668c8ebb790e355$var$StepTypeValidator.validate(step.type);
        const view = $b668c8ebb790e355$var$ToolboxItemView.create(parent, step, api);
        const item = new $b668c8ebb790e355$var$ToolboxItem(step, api);
        view.bindMousedown((e)=>item.onMousedown(e));
        view.bindTouchstart((e)=>item.onTouchstart(e));
        view.bindContextMenu((e)=>item.onContextMenu(e));
        return item;
    }
    constructor(step, api){
        this.step = step;
        this.api = api;
    }
    onTouchstart(e) {
        e.preventDefault();
        if (e.touches.length === 1) {
            e.stopPropagation();
            this.tryDrag($b668c8ebb790e355$var$readTouchPosition(e));
        }
    }
    onMousedown(e) {
        e.stopPropagation();
        const isPrimaryButton = e.button === 0;
        if (isPrimaryButton) this.tryDrag($b668c8ebb790e355$var$readMousePosition(e));
    }
    onContextMenu(e) {
        e.preventDefault();
    }
    tryDrag(position) {
        this.api.tryDrag(position, this.step);
    }
}
class $b668c8ebb790e355$var$ToolboxView {
    static create(parent, api) {
        const root = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: "sqd-toolbox"
        });
        const header = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: "sqd-toolbox-header"
        });
        const headerTitle = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: "sqd-toolbox-header-title"
        });
        headerTitle.innerText = "Toolbox";
        const body = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
            class: "sqd-toolbox-body"
        });
        const filterInput = $b668c8ebb790e355$export$1e2eb70c93855705.element("input", {
            class: "sqd-toolbox-filter",
            type: "text",
            placeholder: "Search..."
        });
        root.appendChild(header);
        root.appendChild(body);
        header.appendChild(headerTitle);
        body.appendChild(filterInput);
        parent.appendChild(root);
        const scrollBoxView = $b668c8ebb790e355$var$ScrollBoxView.create(body, parent);
        return new $b668c8ebb790e355$var$ToolboxView(header, body, filterInput, scrollBoxView, api);
    }
    constructor(header, body, filterInput, scrollBoxView, api){
        this.header = header;
        this.body = body;
        this.filterInput = filterInput;
        this.scrollBoxView = scrollBoxView;
        this.api = api;
    }
    bindToggleClick(handler) {
        function forward(e) {
            e.preventDefault();
            handler();
        }
        this.header.addEventListener("click", forward, false);
    }
    bindFilterInputChange(handler) {
        function forward(e) {
            handler(e.target.value);
        }
        this.filterInput.addEventListener("keyup", forward, false);
        this.filterInput.addEventListener("blur", forward, false);
    }
    setIsCollapsed(isCollapsed) {
        $b668c8ebb790e355$export$1e2eb70c93855705.toggleClass(this.body, isCollapsed, "sqd-hidden");
        if (this.headerToggleIcon) this.header.removeChild(this.headerToggleIcon);
        this.headerToggleIcon = $b668c8ebb790e355$export$4f13f83fd8bb1dac.createSvg("sqd-toolbox-toggle-icon", isCollapsed ? $b668c8ebb790e355$export$4f13f83fd8bb1dac.expand : $b668c8ebb790e355$export$4f13f83fd8bb1dac.close);
        this.header.appendChild(this.headerToggleIcon);
        if (!isCollapsed) this.scrollBoxView.refresh();
    }
    setGroups(groups) {
        const list = $b668c8ebb790e355$export$1e2eb70c93855705.element("div");
        groups.forEach((group)=>{
            const groupTitle = $b668c8ebb790e355$export$1e2eb70c93855705.element("div", {
                class: "sqd-toolbox-group-title"
            });
            groupTitle.innerText = group.name;
            list.appendChild(groupTitle);
            group.steps.forEach((s)=>$b668c8ebb790e355$var$ToolboxItem.create(list, s, this.api));
        });
        this.scrollBoxView.setContent(list);
    }
    destroy() {
        this.scrollBoxView.destroy();
    }
}
class $b668c8ebb790e355$var$Toolbox {
    static create(root, api) {
        const view = $b668c8ebb790e355$var$ToolboxView.create(root, api);
        const toolbox = new $b668c8ebb790e355$var$Toolbox(view, api);
        toolbox.render();
        toolbox.onIsCollapsedChanged();
        view.bindToggleClick(()=>toolbox.onToggleClicked());
        view.bindFilterInputChange((v)=>toolbox.onFilterInputChanged(v));
        api.subscribeIsCollapsed(()=>toolbox.onIsCollapsedChanged());
        return toolbox;
    }
    constructor(view, api){
        this.view = view;
        this.api = api;
    }
    destroy() {
        this.view.destroy();
    }
    render() {
        const groups = this.api.filterGroups(this.filter);
        this.view.setGroups(groups);
    }
    onIsCollapsedChanged() {
        this.view.setIsCollapsed(this.api.isCollapsed());
    }
    onToggleClicked() {
        this.api.toggleIsCollapsed();
    }
    onFilterInputChanged(value) {
        this.filter = value.toLowerCase();
        this.render();
    }
}
class $b668c8ebb790e355$var$ToolboxExtension {
    create(root, api) {
        return $b668c8ebb790e355$var$Toolbox.create(root, api.toolbox);
    }
}
const $b668c8ebb790e355$var$defaultConfiguration$4 = {
    view: {
        paddingTop: 20,
        paddingX: 20,
        inputSize: 18,
        inputIconSize: 14,
        label: {
            height: 22,
            paddingX: 10,
            minWidth: 50,
            radius: 10
        }
    }
};
class $b668c8ebb790e355$var$ContainerStepExtension {
    static create(configuration) {
        return new $b668c8ebb790e355$var$ContainerStepExtension(configuration !== null && configuration !== void 0 ? configuration : $b668c8ebb790e355$var$defaultConfiguration$4);
    }
    constructor(configuration){
        this.configuration = configuration;
        this.componentType = "container";
        this.createComponentView = $b668c8ebb790e355$export$7053e7d9eb350367(this.configuration.view);
    }
}
class $b668c8ebb790e355$var$DefaultPlaceholderControllerExtension {
    create() {
        return {
            canCreate: ()=>true
        };
    }
}
const $b668c8ebb790e355$var$defaultConfiguration$3 = {
    gapWidth: 100,
    gapHeight: 24,
    radius: 6,
    iconSize: 16
};
class $b668c8ebb790e355$var$RectPlaceholderExtension {
    static create(configuration) {
        return new $b668c8ebb790e355$var$RectPlaceholderExtension(configuration !== null && configuration !== void 0 ? configuration : $b668c8ebb790e355$var$defaultConfiguration$3);
    }
    constructor(configuration){
        this.configuration = configuration;
        this.gapSize = new $b668c8ebb790e355$export$9b781de7bf37bf48(this.configuration.gapWidth, this.configuration.gapHeight);
    }
    createForGap(parent, parentSequence, index) {
        return $b668c8ebb790e355$export$75410064e8388d0.create(parent, this.gapSize, $b668c8ebb790e355$export$f36c40dbf5da813f.none, parentSequence, index, this.configuration);
    }
    createForArea(parent, size, direction, parentSequence, index) {
        return $b668c8ebb790e355$export$75410064e8388d0.create(parent, size, direction, parentSequence, index, this.configuration);
    }
}
const $b668c8ebb790e355$var$SIZE = 30;
const $b668c8ebb790e355$var$DEFAULT_ICON_SIZE = 22;
const $b668c8ebb790e355$var$FOLDER_ICON_SIZE = 18;
class $b668c8ebb790e355$var$StartStopRootComponentView {
    static create(parent, sequence, parentPlaceIndicator, context) {
        const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g", {
            class: "sqd-root-start-stop"
        });
        parent.appendChild(g);
        const sequenceComponent = $b668c8ebb790e355$export$24ac18814bbca960.create(g, {
            sequence: sequence,
            depth: 0,
            isInputConnected: true,
            isOutputConnected: true
        }, context);
        const view = sequenceComponent.view;
        const x = view.joinX - $b668c8ebb790e355$var$SIZE / 2;
        const endY = $b668c8ebb790e355$var$SIZE + view.height;
        const iconSize = parentPlaceIndicator ? $b668c8ebb790e355$var$FOLDER_ICON_SIZE : $b668c8ebb790e355$var$DEFAULT_ICON_SIZE;
        const startCircle = $b668c8ebb790e355$var$createCircle(parentPlaceIndicator ? $b668c8ebb790e355$export$4f13f83fd8bb1dac.folder : $b668c8ebb790e355$export$4f13f83fd8bb1dac.play, iconSize);
        $b668c8ebb790e355$export$1e2eb70c93855705.translate(startCircle, x, 0);
        g.appendChild(startCircle);
        $b668c8ebb790e355$export$1e2eb70c93855705.translate(view.g, 0, $b668c8ebb790e355$var$SIZE);
        const endCircle = $b668c8ebb790e355$var$createCircle(parentPlaceIndicator ? $b668c8ebb790e355$export$4f13f83fd8bb1dac.folder : $b668c8ebb790e355$export$4f13f83fd8bb1dac.stop, iconSize);
        $b668c8ebb790e355$export$1e2eb70c93855705.translate(endCircle, x, endY);
        g.appendChild(endCircle);
        let startPlaceholder = null;
        let endPlaceholder = null;
        if (parentPlaceIndicator) {
            const size = new $b668c8ebb790e355$export$9b781de7bf37bf48($b668c8ebb790e355$var$SIZE, $b668c8ebb790e355$var$SIZE);
            startPlaceholder = context.services.placeholder.createForArea(g, size, $b668c8ebb790e355$export$f36c40dbf5da813f.out, parentPlaceIndicator.sequence, parentPlaceIndicator.index);
            endPlaceholder = context.services.placeholder.createForArea(g, size, $b668c8ebb790e355$export$f36c40dbf5da813f.out, parentPlaceIndicator.sequence, parentPlaceIndicator.index);
            $b668c8ebb790e355$export$1e2eb70c93855705.translate(startPlaceholder.view.g, x, 0);
            $b668c8ebb790e355$export$1e2eb70c93855705.translate(endPlaceholder.view.g, x, endY);
        }
        const badges = $b668c8ebb790e355$export$a7be05036dfae7c5.createForRoot(g, new $b668c8ebb790e355$export$9b781de7bf37bf48(x + $b668c8ebb790e355$var$SIZE, 0), context);
        return new $b668c8ebb790e355$var$StartStopRootComponentView(g, view.width, view.height + $b668c8ebb790e355$var$SIZE * 2, view.joinX, sequenceComponent, startPlaceholder, endPlaceholder, badges);
    }
    constructor(g, width, height, joinX, component, startPlaceholder, endPlaceholder, badges){
        this.g = g;
        this.width = width;
        this.height = height;
        this.joinX = joinX;
        this.component = component;
        this.startPlaceholder = startPlaceholder;
        this.endPlaceholder = endPlaceholder;
        this.badges = badges;
    }
    destroy() {
        var _a;
        (_a = this.g.parentNode) === null || _a === void 0 || _a.removeChild(this.g);
    }
}
function $b668c8ebb790e355$var$createCircle(d, iconSize) {
    const r = $b668c8ebb790e355$var$SIZE / 2;
    const circle = $b668c8ebb790e355$export$1e2eb70c93855705.svg("circle", {
        class: "sqd-root-start-stop-circle",
        cx: r,
        cy: r,
        r: r
    });
    const g = $b668c8ebb790e355$export$1e2eb70c93855705.svg("g");
    g.appendChild(circle);
    const offset = ($b668c8ebb790e355$var$SIZE - iconSize) / 2;
    const icon = $b668c8ebb790e355$export$4f13f83fd8bb1dac.appendPath(g, "sqd-root-start-stop-icon", d, iconSize);
    $b668c8ebb790e355$export$1e2eb70c93855705.translate(icon, offset, offset);
    return g;
}
class $b668c8ebb790e355$var$StartStopRootComponent {
    static create(parentElement, sequence, parentPlaceIndicator, context) {
        const view = $b668c8ebb790e355$var$StartStopRootComponentView.create(parentElement, sequence, parentPlaceIndicator, context);
        return new $b668c8ebb790e355$var$StartStopRootComponent(view);
    }
    constructor(view){
        this.view = view;
    }
    resolveClick(click) {
        return this.view.component.resolveClick(click);
    }
    findById(stepId) {
        return this.view.component.findById(stepId);
    }
    getPlaceholders(result) {
        this.view.component.getPlaceholders(result);
        if (this.view.startPlaceholder && this.view.endPlaceholder) {
            result.push(this.view.startPlaceholder);
            result.push(this.view.endPlaceholder);
        }
    }
    setIsDragging(isDragging) {
        this.view.component.setIsDragging(isDragging);
        if (this.view.startPlaceholder && this.view.endPlaceholder) {
            this.view.startPlaceholder.setIsVisible(isDragging);
            this.view.endPlaceholder.setIsVisible(isDragging);
        }
    }
    updateBadges(result) {
        this.view.badges.update(result);
        this.view.component.updateBadges(result);
    }
}
class $b668c8ebb790e355$var$StartStopRootComponentExtension {
    constructor(){
        this.create = $b668c8ebb790e355$var$StartStopRootComponent.create;
    }
}
const $b668c8ebb790e355$var$defaultConfiguration$2 = {
    view: {
        minContainerWidth: 40,
        paddingX: 20,
        paddingTop: 20,
        connectionHeight: 16,
        inputSize: 18,
        inputIconSize: 14,
        branchNameLabel: {
            height: 22,
            paddingX: 10,
            minWidth: 50,
            radius: 10
        },
        nameLabel: {
            height: 22,
            paddingX: 10,
            minWidth: 50,
            radius: 10
        }
    }
};
class $b668c8ebb790e355$var$SwitchStepExtension {
    static create(configuration) {
        return new $b668c8ebb790e355$var$SwitchStepExtension(configuration !== null && configuration !== void 0 ? configuration : $b668c8ebb790e355$var$defaultConfiguration$2);
    }
    constructor(configuration){
        this.configuration = configuration;
        this.componentType = "switch";
        this.createComponentView = $b668c8ebb790e355$export$f046b8db22527b17(this.configuration.view);
    }
}
const $b668c8ebb790e355$var$defaultConfiguration$1 = {
    view: {
        paddingLeft: 12,
        paddingRight: 12,
        paddingY: 10,
        textMarginLeft: 12,
        minTextWidth: 70,
        iconSize: 22,
        radius: 5,
        inputSize: 14,
        outputSize: 10
    }
};
class $b668c8ebb790e355$var$TaskStepExtension {
    static create(configuration) {
        return new $b668c8ebb790e355$var$TaskStepExtension(configuration !== null && configuration !== void 0 ? configuration : $b668c8ebb790e355$var$defaultConfiguration$1);
    }
    constructor(configuration){
        this.configuration = configuration;
        this.componentType = "task";
        this.createComponentView = $b668c8ebb790e355$export$965405a8d9b9c636(false, this.configuration.view);
    }
}
class $b668c8ebb790e355$var$DefaultSequenceComponentExtension {
    constructor(){
        this.create = $b668c8ebb790e355$export$24ac18814bbca960.create;
    }
}
class $b668c8ebb790e355$var$DefaultStepComponentViewWrapperExtension {
    constructor(){
        this.wrap = (view)=>view;
    }
}
class $b668c8ebb790e355$var$LineGrid {
    static create(size) {
        const path = $b668c8ebb790e355$export$1e2eb70c93855705.svg("path", {
            class: "sqd-grid-path",
            fill: "none"
        });
        return new $b668c8ebb790e355$var$LineGrid(size, path);
    }
    constructor(size, element){
        this.size = size;
        this.element = element;
    }
    setScale(_, scaledSize) {
        $b668c8ebb790e355$export$1e2eb70c93855705.attrs(this.element, {
            d: `M ${scaledSize.x} 0 L 0 0 0 ${scaledSize.y}`
        });
    }
}
const $b668c8ebb790e355$var$defaultConfiguration = {
    gridSizeX: 48,
    gridSizeY: 48
};
class $b668c8ebb790e355$var$LineGridExtension {
    static create(configuration) {
        return new $b668c8ebb790e355$var$LineGridExtension(configuration !== null && configuration !== void 0 ? configuration : $b668c8ebb790e355$var$defaultConfiguration);
    }
    constructor(configuration){
        this.configuration = configuration;
    }
    create() {
        const size = new $b668c8ebb790e355$export$9b781de7bf37bf48(this.configuration.gridSizeX, this.configuration.gridSizeY);
        return $b668c8ebb790e355$var$LineGrid.create(size);
    }
}
class $b668c8ebb790e355$export$e0c788c40ea46f15 {
    static resolve(extensions, configuration) {
        const services = {};
        $b668c8ebb790e355$var$merge(services, extensions || []);
        $b668c8ebb790e355$var$setDefault(services, configuration);
        return services;
    }
}
function $b668c8ebb790e355$var$merge(services, extensions) {
    for (const ext of extensions){
        if (ext.steps) services.steps = (services.steps || []).concat(ext.steps);
        if (ext.stepComponentViewWrapper) services.stepComponentViewWrapper = ext.stepComponentViewWrapper;
        if (ext.badges) services.badges = (services.badges || []).concat(ext.badges);
        if (ext.uiComponents) services.uiComponents = (services.uiComponents || []).concat(ext.uiComponents);
        if (ext.draggedComponent) services.draggedComponent = ext.draggedComponent;
        if (ext.wheelController) services.wheelController = ext.wheelController;
        if (ext.placeholderController) services.placeholderController = ext.placeholderController;
        if (ext.placeholder) services.placeholder = ext.placeholder;
        if (ext.viewportController) services.viewportController = ext.viewportController;
        if (ext.grid) services.grid = ext.grid;
        if (ext.rootComponent) services.rootComponent = ext.rootComponent;
        if (ext.sequenceComponent) services.sequenceComponent = ext.sequenceComponent;
        if (ext.daemons) services.daemons = (services.daemons || []).concat(ext.daemons);
    }
}
function $b668c8ebb790e355$var$setDefault(services, configuration) {
    if (!services.steps) services.steps = [];
    services.steps.push($b668c8ebb790e355$var$ContainerStepExtension.create());
    services.steps.push($b668c8ebb790e355$var$SwitchStepExtension.create());
    services.steps.push($b668c8ebb790e355$var$TaskStepExtension.create());
    if (!services.stepComponentViewWrapper) services.stepComponentViewWrapper = new $b668c8ebb790e355$var$DefaultStepComponentViewWrapperExtension();
    if (!services.badges) services.badges = [];
    if ($b668c8ebb790e355$var$findValidationBadgeIndex(services.badges) < 0) services.badges.push($b668c8ebb790e355$export$31e30dce99868251.create());
    if (!services.draggedComponent) services.draggedComponent = new $b668c8ebb790e355$var$DefaultDraggedComponentExtension();
    if (!services.uiComponents) services.uiComponents = [];
    if (configuration.controlBar) services.uiComponents.push(new $b668c8ebb790e355$var$ControlBarExtension());
    if (configuration.editors) services.uiComponents.push(new $b668c8ebb790e355$var$SmartEditorExtension(configuration.editors));
    if (configuration.toolbox) services.uiComponents.push(new $b668c8ebb790e355$var$ToolboxExtension());
    if (!services.wheelController) services.wheelController = new $b668c8ebb790e355$export$1caa0588f1264dfc();
    if (!services.placeholderController) services.placeholderController = new $b668c8ebb790e355$var$DefaultPlaceholderControllerExtension();
    if (!services.placeholder) services.placeholder = $b668c8ebb790e355$var$RectPlaceholderExtension.create();
    if (!services.viewportController) services.viewportController = new $b668c8ebb790e355$export$80c54b090f89a409();
    if (!services.grid) services.grid = $b668c8ebb790e355$var$LineGridExtension.create();
    if (!services.rootComponent) services.rootComponent = new $b668c8ebb790e355$var$StartStopRootComponentExtension();
    if (!services.sequenceComponent) services.sequenceComponent = new $b668c8ebb790e355$var$DefaultSequenceComponentExtension();
    if (!services.daemons) services.daemons = [];
    services.daemons.push(new $b668c8ebb790e355$var$KeyboardDaemonExtension());
}
function $b668c8ebb790e355$var$throwDepreciatedError(propertyName, groupName) {
    throw new Error(`The "${propertyName}" property in the "${groupName}" configuration is depreciated`);
}
function $b668c8ebb790e355$var$validateConfiguration(configuration) {
    if (configuration.controlBar === undefined) throw new Error('The "controlBar" property is not defined in the configuration');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (configuration.toolbox && configuration.toolbox.isHidden !== undefined) $b668c8ebb790e355$var$throwDepreciatedError("isHidden", "toolbox");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (configuration.editors && configuration.editors.isHidden !== undefined) $b668c8ebb790e355$var$throwDepreciatedError("isHidden", "editors");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (configuration.steps.validator) $b668c8ebb790e355$var$throwDepreciatedError("validator", "steps");
}
class $b668c8ebb790e355$export$803fba03ef8d998a {
    /**
     * Creates a designer.
     * @param placeholder Placeholder where the designer will be attached.
     * @param startDefinition Start definition of a flow.
     * @param configuration Designer's configuration.
     * @returns An instance of the designer.
     */ static create(placeholder, startDefinition, configuration) {
        if (!placeholder) throw new Error("Placeholder is not set");
        if (!$b668c8ebb790e355$var$isElementAttached(placeholder)) throw new Error("Placeholder is not attached to the DOM");
        if (!startDefinition) throw new Error("Start definition is not set");
        if (!configuration) throw new Error("Configuration is not set");
        const config = configuration;
        $b668c8ebb790e355$var$validateConfiguration(config);
        const services = $b668c8ebb790e355$export$e0c788c40ea46f15.resolve(configuration.extensions, config);
        const designerContext = $b668c8ebb790e355$export$cf98525e95b5411b.create(placeholder, startDefinition, config, services);
        const designerApi = $b668c8ebb790e355$export$3503bfda72123b3e.create(designerContext);
        const view = $b668c8ebb790e355$var$DesignerView.create(placeholder, designerContext, config, designerApi);
        const designer = new $b668c8ebb790e355$export$803fba03ef8d998a(view, designerContext.state, designerContext.definitionWalker, designerApi);
        view.workspace.onReady.subscribe(()=>designer.onReady.forward());
        designerContext.state.onDefinitionChanged.subscribe(()=>{
            setTimeout(()=>designer.onDefinitionChanged.forward(designerContext.state.definition));
        });
        designerContext.state.onSelectedStepIdChanged.subscribe(()=>designer.onSelectedStepIdChanged.forward(designerContext.state.selectedStepId));
        designer.state.onIsToolboxCollapsedChanged.subscribe((isCollapsed)=>{
            designer.onIsToolboxCollapsedChanged.forward(isCollapsed);
        });
        designer.state.onIsEditorCollapsedChanged.subscribe((isCollapsed)=>{
            designer.onIsEditorCollapsedChanged.forward(isCollapsed);
        });
        return designer;
    }
    constructor(view, state, walker, api){
        this.view = view;
        this.state = state;
        this.walker = walker;
        this.api = api;
        /**
         * @description Fires when the designer is initialized and ready to use.
         */ this.onReady = new $b668c8ebb790e355$export$298d5abb39333987();
        /**
         * @description Fires when the definition has changed.
         */ this.onDefinitionChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        /**
         * @description Fires when the selected step has changed.
         */ this.onSelectedStepIdChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        /**
         * @description Fires when the toolbox is collapsed or expanded.
         */ this.onIsToolboxCollapsedChanged = new $b668c8ebb790e355$export$298d5abb39333987();
        /**
         * @description Fires when the editor is collapsed or expanded.
         */ this.onIsEditorCollapsedChanged = new $b668c8ebb790e355$export$298d5abb39333987();
    }
    /**
     * @returns the current definition of the workflow.
     */ getDefinition() {
        return this.state.definition;
    }
    /**
     * @returns the validation result of the current definition.
     */ isValid() {
        return this.view.workspace.isValid;
    }
    /**
     * @returns the readonly flag.
     */ isReadonly() {
        return this.state.isReadonly;
    }
    /**
     * @description Changes the readonly flag.
     */ setIsReadonly(isReadonly) {
        this.state.setIsReadonly(isReadonly);
    }
    /**
     * @returns current selected step id or `null` if nothing is selected.
     */ getSelectedStepId() {
        return this.state.selectedStepId;
    }
    /**
     * @description Selects a step by the id.
     */ selectStepById(stepId) {
        this.state.setSelectedStepId(stepId);
    }
    /**
     * @description Unselects the selected step.
     */ clearSelectedStep() {
        this.state.setSelectedStepId(null);
    }
    /**
     * @description Moves the viewport to the step with the animation.
     */ moveViewportToStep(stepId) {
        this.api.viewport.moveViewportToStep(stepId);
    }
    /**
     * @deprecated Use `moveViewportToStep` instead.
     */ moveViewPortToStep(stepId) {
        this.moveViewportToStep(stepId);
    }
    /**
     * @description Rerender the root component and all its children.
     */ updateRootComponent() {
        this.api.workspace.updateRootComponent();
    }
    /**
     * @description Updates all badges.
     */ updateBadges() {
        this.api.workspace.updateBadges();
    }
    /**
     * @returns a flag that indicates whether the toolbox is collapsed.
     */ isToolboxCollapsed() {
        return this.state.isToolboxCollapsed;
    }
    /**
     * @description Sets a flag that indicates whether the toolbox is collapsed.
     */ setIsToolboxCollapsed(isCollapsed) {
        this.state.setIsToolboxCollapsed(isCollapsed);
    }
    /**
     * @returns a flag that indicates whether the editor is collapsed.
     */ isEditorCollapsed() {
        return this.state.isEditorCollapsed;
    }
    /**
     * @description Sets a flag that indicates whether the editor is collapsed.
     */ setIsEditorCollapsed(isCollapsed) {
        this.state.setIsEditorCollapsed(isCollapsed);
    }
    /**
     * @param needle A step, a sequence or a step id.
     * @returns parent steps and branch names.
     */ getStepParents(needle) {
        return this.walker.getParents(this.state.definition, needle);
    }
    /**
     * @description Destroys the designer and deletes all nodes from the placeholder.
     */ destroy() {
        this.view.destroy();
    }
}
class $b668c8ebb790e355$export$1383bb780db4bfb2 {
    static create(configuration) {
        const grid = $b668c8ebb790e355$var$LineGridExtension.create(configuration);
        return new $b668c8ebb790e355$export$1383bb780db4bfb2(grid);
    }
    constructor(grid){
        this.grid = grid;
    }
}
class $b668c8ebb790e355$export$f9f2132960ba43e4 {
    static create(configuration) {
        const steps = [];
        if (configuration.container) steps.push($b668c8ebb790e355$var$ContainerStepExtension.create(configuration.container));
        if (configuration.switch) steps.push($b668c8ebb790e355$var$SwitchStepExtension.create(configuration.switch));
        if (configuration.task) steps.push($b668c8ebb790e355$var$TaskStepExtension.create(configuration.task));
        return new $b668c8ebb790e355$export$f9f2132960ba43e4(steps);
    }
    constructor(steps){
        this.steps = steps;
    }
}
/**
 * @deprecated Use `StepsDesignerExtension` instead.
 */ class $b668c8ebb790e355$export$62f1fb98c941de71 extends $b668c8ebb790e355$export$f9f2132960ba43e4 {
}


/**
 * @author Andrey Sobolev
 *
 * @overview The Editor for the structure builder workflow step (includes a button to the StructureBuilder)
 */ /**
 * @author Andrey Sobolev
 *
 * @overview The parent class for the Workflow Designer step editors
 */ 
class $280f3bfb60d3be1f$export$a1e6c1164d3e6eee {
    static config = {
        componentType: "task",
        properties: {}
    };
    constructor(parent, stepId){
        this.workflow = parent;
        this.id = stepId;
        this.editor = new $280f3bfb60d3be1f$export$af1164875b51fc1e(this);
    }
    /** A kind of class destructor, runs when it's removed from definition
   */ destroy() {}
    save() {
        return true;
    }
    /** A validator for the given step
  * @returns {boolean}
  */ validate() {
        return true;
    }
}
class $280f3bfb60d3be1f$export$af1164875b51fc1e extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(parent){
        super("div", ".swd-editor");
        this.parent = parent;
        this.step = undefined;
        this.ctx = undefined;
    }
    /** Provides an HTML element of the editor
   *
   * @param step
   * @param ctx
   * @returns {HTMLElement}
   */ provide(step, ctx) {
        this.step = this.step === undefined ? step : this.step;
        this.ctx = this.ctx === undefined ? ctx : this.ctx;
        this.getElement(".swd-button").addEventListener("click", (_)=>this._reroute());
        return this.e;
    }
    /** Reroute to the needed workflow step with hash mechanism
   */ _reroute() {
        let hashParts = document.location.hash.split("#");
        document.location.hash = hashParts[1] + "#" + hashParts[2] + "#" + this.parent.id;
    }
}




class $8d41f7f77765cb8f$export$734eae8749d535a extends (0, $280f3bfb60d3be1f$export$a1e6c1164d3e6eee) {
    static config = {
        ...(0, $280f3bfb60d3be1f$export$a1e6c1164d3e6eee).config,
        group: "Structure",
        name: "Structure Builder",
        type: "StructureBuilder"
    };
    constructor(parent, stepId){
        super(parent, stepId);
        this.editor = new $8d41f7f77765cb8f$export$488bf1894244f809(this);
        this.component = new (0, $5394a2fd932d6e8f$export$2e2bcd8739ae039)();
        this.label = "Create or upload geometry";
        this.properties = {};
    }
    save() {
        this.properties.structure = this.component.getCurrentStructure();
        this.editor.update();
        return true;
    }
    validate() {
        return this.properties.structure !== undefined;
    }
    destroy() {
        this.workflow.structure = undefined;
    }
}
class $8d41f7f77765cb8f$export$488bf1894244f809 extends (0, $280f3bfb60d3be1f$export$af1164875b51fc1e) {
    constructor(parent){
        super(parent);
        this.setHTML(`<button class="swd-button">Choose a structure</button>
                  <div class="swd-structure-info" style="display:block"></div>`);
        this.structureInfo = new (0, $6307f518240c06cd$export$2e2bcd8739ae039)(undefined);
        this.getElement(".swd-structure-info").appendChild(this.structureInfo.e);
    }
    update() {
        this.step.properties = this.parent.properties;
        this.structureInfo.updateTable(this.step.properties.structure.structureInfo);
        this.ctx.notifyPropertiesChanged();
    }
}


/**
 * @author Andrey Sobolev
 *
 * @overview The Editor for the control generator workflow step (includes a button to the ControlGenerator)
 */ 


class $50829c403813e334$export$327a964fcf60a8ef extends (0, $280f3bfb60d3be1f$export$a1e6c1164d3e6eee) {
    static config = {
        ...(0, $280f3bfb60d3be1f$export$a1e6c1164d3e6eee).config,
        group: "Calculations"
    };
    constructor(parent, stepId){
        super(parent, stepId);
        this.editor = new $50829c403813e334$export$4c6727460b326c2f(this);
        this.component = new (0, $0eda6e4362e8054a$export$2e2bcd8739ae039)();
        this.controlName = "";
        this.properties = {};
    }
    save() {
        if (!this.component.runChecks()) return false;
        this.properties.control = this.component.getInputFilesRequestJson();
        this.editor.update();
        return true;
    }
    validate() {
        return this.workflow.hasStructure(this.id) && this.properties.control !== undefined;
    }
}
class $50829c403813e334$export$45c3819e6ab69b4f extends $50829c403813e334$export$327a964fcf60a8ef {
    static config = {
        ...$50829c403813e334$export$327a964fcf60a8ef.config,
        name: "DFT Calculation",
        type: "DFTCalculation"
    };
    constructor(parent, stepId){
        super(parent, stepId);
        this.label = "DFT calculation: Generate control.in";
        this.controlName = "default";
        this.component.init(this.controlName);
        this.initialized = true;
    }
}
class $50829c403813e334$export$949217e3b4672d32 extends $50829c403813e334$export$327a964fcf60a8ef {
    static config = {
        ...$50829c403813e334$export$327a964fcf60a8ef.config,
        name: "GW Calculation",
        type: "GWCalculation"
    };
    constructor(parent, stepId){
        super(parent, stepId);
        this.label = "GW calculation: Generate control.in";
        this.controlName = "GW";
        this.component.init(this.controlName);
        this.initialized = true;
    }
}
class $50829c403813e334$export$4c6727460b326c2f extends (0, $280f3bfb60d3be1f$export$af1164875b51fc1e) {
    constructor(parent){
        super(parent);
        this.setHTML(`<button class="swd-button">Build control.in</button>`);
    }
    _reroute() {
        if (!this.parent.workflow.hasStructure(this.parent.id)) {
            (0, $6ff060c6e60f738f$export$b8d0bb2aa0adefe5)("You have to set structure first!");
            return;
        }
        super._reroute();
        this.parent.component.setStructure(this.parent.workflow.getStructure(this.parent.id));
    }
    update() {
        this.step.properties = this.parent.properties;
        this.ctx.notifyPropertiesChanged();
    }
}


/**
 * @author Andrey Sobolev
 *
 * @overview The Editor for the Convergence workflow step (includes a combobox of convergence parameters and a table of their values)
 */ 




class $18ede2b528b3800a$export$5168ae7e3cfeba20 extends (0, $280f3bfb60d3be1f$export$a1e6c1164d3e6eee) {
    static config = {
        ...(0, $280f3bfb60d3be1f$export$a1e6c1164d3e6eee).config,
        group: "Optimizations",
        name: "Convergence",
        type: "Convergence"
    };
    constructor(parent, stepId){
        super(parent, stepId);
        this.editor = new $18ede2b528b3800a$export$4d5bdebb8b7382f8(this);
        this.properties = {};
    }
    save() {
        const param = this.editor.getConvergenceParam();
        if (param === "") return false;
        const tableData = this.editor.table.getData();
        if (tableData === []) this.properties.convergence = undefined;
        else this.properties.convergence = {
            [param]: tableData
        };
        this.editor.update();
        return true;
    }
    validate() {
        return this.workflow.hasStructure(this.id) && this.workflow.hasControl(this.id) && this.properties.convergence !== undefined;
    }
}
class $18ede2b528b3800a$export$4d5bdebb8b7382f8 extends (0, $280f3bfb60d3be1f$export$af1164875b51fc1e) {
    constructor(parent){
        super(parent);
        this.setHTML(`<div class="swd-editor-title">
    Convergence criteria: 
</div>
<div class="swd-editor-div" id="selection-box">
    <select name="input-keys-select" style="width: 80%;">
        <option value="">--- Convergence parameter ---</option>
        <option value="k_grid">k_grid</option>
        <option value="species_defaults">basis</option>
    </select>
</div>
<div class="swd-editor-title">
    Values:
</div>
`);
        this.table = new $18ede2b528b3800a$var$ValuesTable(".swd-editor-div", this);
        this.e.appendChild(this.table.e);
        let selector = this.getElement("select");
        selector.addEventListener("change", (_)=>this.table.switchInput(selector.value));
    }
    provide(step, ctx) {
        this.step = this.step === undefined ? step : this.step;
        this.ctx = this.ctx === undefined ? ctx : this.ctx;
        return this.e;
    }
    update() {
        this.step.properties = this.parent.properties;
        this.ctx.notifyPropertiesChanged();
    }
    getConvergenceParam() {
        return this.getElement("select").value;
    }
}
class $18ede2b528b3800a$var$ValuesTable extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(className, parent){
        super("div", className);
        this.editor = parent;
        this.setHTML(`<table style="width:80%; text-align: center;" class="table-class">
        <col style="width: 80%; text-align: center">
        <col style="width: 20%">
        <tbody>
        </tbody>
    </table>
    `);
        this.table = this.e.querySelector("table");
        this.input = undefined;
    }
    /** Switches inputs according to the chosen value
   * @param inputName {string}
   */ switchInput(inputName) {
        this.table.innerHTML = ""; // clear table
        switch(inputName){
            case "k_grid":
                this.input = new $18ede2b528b3800a$var$KPointsInput(this, this.table);
                break;
            case "species_defaults":
                this.input = new $18ede2b528b3800a$var$BasisInput(this, this.table);
                break;
            default:
                this.input = undefined;
        }
        if (this.input !== undefined) this.table.append(this.input.e);
    }
    getData() {
        return Array.from(this.table.rows).slice(0, -1).map((row)=>row.cells[0].textContent);
    }
}
class $18ede2b528b3800a$var$KPointsInput extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(parent, table){
        super("tr", ".k-grid-input");
        this.setHTML(`<td>
      <input type="text" style="width: 22%"> x
      <input type="text" style="width: 22%"> x
      <input type="text" style="width: 22%">
    </td>
    <td><button class="add-data" title="Add New Data">${(0, $9df7e97ee6fe1617$export$e3e86e4263fb9f0d)}</button></td>`);
        this.parent = parent;
        this.table = table;
        const addButton = this.getElement("button.add-data");
        addButton.addEventListener("click", (_)=>{
            const inputs = Array.from(this.getElements("input"));
            const values = inputs.map((el)=>el.value);
            if (values.some((x)=>x === "")) return;
            // get a new row with the values
            let row = this.table.insertRow(this.table.rows.length - 1);
            row.insertCell(0).appendChild(document.createTextNode(values.join(" x ")));
            let buttonDOM = document.createElement("template");
            buttonDOM.innerHTML = `<button class="delete-data" title="Remove keyword">${0, $9df7e97ee6fe1617$export$9c35f1cb8fe66314}</button>`;
            row.insertCell(1).appendChild(buttonDOM.content);
            const deleteButton = row.querySelector("button");
            deleteButton.addEventListener("click", (e)=>{
                this.table.deleteRow(e.target.closest("tr").rowIndex);
                // this I don't like. may be use some signals?
                this.parent.editor.parent.save();
            });
            this.parent.editor.parent.save();
        });
    }
}
class $18ede2b528b3800a$var$BasisInput extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(parent, table){
        super("tr", ".basis-input");
        this.parent = parent;
        this.table = table;
        this.setHTML(`<td>
      <select class="input-select" style="width: 80%;">
      </select>
    </td>
    <td><button class="add-data" title="Add New Data">${(0, $9df7e97ee6fe1617$export$e3e86e4263fb9f0d)}</button></td>`);
        const selector = this.getElement("select");
        this.getBases().then((bases)=>{
            bases.forEach((el)=>{
                let opt = document.createElement("option");
                opt.value = el;
                opt.innerHTML = el;
                selector.appendChild(opt);
            });
        });
        let addButton = this.getElement(".add-data");
        addButton.addEventListener("click", (_)=>{
            // get a new row with the values
            let row = this.table.insertRow(this.table.rows.length - 1);
            row.insertCell(0).appendChild(document.createTextNode(selector.value));
            let buttonDOM = document.createElement("template");
            buttonDOM.innerHTML = `<button class="delete-data" title="Remove keyword">${0, $9df7e97ee6fe1617$export$9c35f1cb8fe66314}</button>`;
            row.insertCell(1).appendChild(buttonDOM.content);
            // remove the value from the selector
            selector.removeChild(selector.querySelector(`option[value=${selector.value}]`));
            const deleteButton = row.querySelector("button");
            deleteButton.addEventListener("click", (e)=>{
                let value = e.target.closest("tr").querySelector("td").innerHTML;
                let opt = document.createElement("option");
                opt.value = value;
                opt.innerHTML = value;
                selector.appendChild(opt);
                this.table.deleteRow(e.target.closest("tr").rowIndex);
                this.parent.editor.parent.save();
            });
            this.parent.editor.parent.save();
        });
    }
    async getBases() {
        let response = await fetch(`/get-bases?code=${(0, $1ad59a1a7edcd764$export$9a0a9c75ccef13fb)()}`, {
            method: "GET"
        });
        if (!response.ok) {
            (0, $6ff060c6e60f738f$export$b8d0bb2aa0adefe5)("Could not get bases");
            return;
        }
        const text = await response.text();
        return JSON.parse(text);
    }
}


/**
 * @author Andrey Sobolev
 *
 * @overview A workflow definition
 */ const $aefe75f689d9112f$export$69f215ed977cdb73 = {
    properties: {},
    sequence: []
};


/**
 * @author Andrey Sobolev
 *
 * @overview A Workflow Designer configuration
 */ const $88b1d4339016e9cb$export$1670bf621bbc68f3 = {
    toolbox: {
        groups: []
    },
    validator: {},
    steps: {
        iconUrlProvider: (componentType, type)=>{
            return `${type}-icon.png`;
        },
        canInsertStep: (step, targetSequence, targetIndex)=>{
            if (targetIndex === 0 && targetSequence.length > 0 && targetSequence[0].type === "StructureBuilder") return false;
            if (step.type === "StructureBuilder") return targetIndex === 0;
            return targetSequence.length < 5;
        },
        canMoveStep: (sourceSequence, step, targetSequence, targetIndex)=>{
            if (step.type === "StructureBuilder" && targetIndex !== 0) return false;
            if (targetIndex === 0 && targetSequence.length > 0 && targetSequence[0].type === "StructureBuilder") return false;
        }
    },
    stepEditorContext: {},
    editors: {
        globalEditorProvider: (definition, context)=>{
            let editor = document.createElement("div");
            editor.classList.add("swd-editor");
            editor.innerHTML = `<h3><i>How to use the designer:</i></h3>
			<li> Drag the calculation steps from the toolbox on the left to the working field. After finishing, click 'Go 
			ahead' to choose the structure and generate the control.in file. As of now, only one structure 
			is supported.
			<li> <b>Note:</b> GW calculations are very computationally expensive! Check the size of your structure before 
			running calculations!
			<li> <b>One more note:</b> The restart of GW from DFT is not yet implemented! All the calculations are independent.`;
            return editor;
        },
        stepEditorProvider: (_)=>document.createElement("div") // are built dynamically
    },
    controlBar: true
};



const $84a664665add0dc5$var$WORKFLOW_STEPS = [
    (0, $8d41f7f77765cb8f$export$734eae8749d535a),
    (0, $50829c403813e334$export$45c3819e6ab69b4f),
    (0, $50829c403813e334$export$949217e3b4672d32),
    (0, $18ede2b528b3800a$export$5168ae7e3cfeba20)
];
const $84a664665add0dc5$var$defaultConfigValues = {
    theme: "light",
    // optional, default: 'light'
    isReadonly: false,
    // optional, default: false
    undoStackSize: 10 // optional, default: 0 - disabled, 1+ - enabled
};
class $84a664665add0dc5$export$2e2bcd8739ae039 {
    /**
   * A central class for the self-designed Workflow
   * @param placeholder {HTMLElement} a DOM element for the workflow designer
   */ constructor(placeholder){
        // creating configuration
        this.configuration = {
            ...$84a664665add0dc5$var$defaultConfigValues,
            ...(0, $88b1d4339016e9cb$export$1670bf621bbc68f3)
        };
        this.stepClasses = $84a664665add0dc5$var$WORKFLOW_STEPS.reduce((o, stepClass)=>({
                ...o,
                [stepClass.config.type]: stepClass
            }), {});
        this.steps = new Map();
        this.properties = {};
        // build `groups` section of configuration
        let groups = Object.fromEntries([
            ...new Set($84a664665add0dc5$var$WORKFLOW_STEPS.map((step)=>[
                    step.config.group,
                    []
                ]))
        ]);
        for (const v of $84a664665add0dc5$var$WORKFLOW_STEPS){
            let config = v.config;
            const group = config.group;
            delete config.group;
            groups[group].push(config);
        }
        this.configuration.toolbox.groups = Object.keys(groups).map((k)=>{
            return {
                name: k,
                steps: groups[k]
            };
        });
        this.configuration.editors.stepEditorProvider = (step, ctx)=>this.steps.get(step.id).editor.provide(step, ctx);
        this.configuration.validator.step = (step, _)=>this.steps.get(step.id).validate();
        this.designer = (0, $b668c8ebb790e355$export$803fba03ef8d998a).create(placeholder, (0, $aefe75f689d9112f$export$69f215ed977cdb73), this.configuration);
        this.designer.state.onDefinitionChanged.subscribe((e)=>changeDefinition(e));
        const instance = this;
        function changeDefinition(event) {
            const currentDef = instance.designer.getDefinition();
            if (event.changeType === 6) {
                // adding steps
                let step = currentDef.sequence.filter((s)=>s.id === event.stepId)[0];
                instance.steps.set(step.id, new instance.stepClasses[step.type](instance, step.id));
            } else if (event.changeType === 4) {
                // deleting steps
                instance.steps.get(event.stepId).destroy();
                instance.steps.delete(event.stepId);
            }
        }
    }
    isValid() {
        return this.designer.isValid();
    }
    /** Check if the workflow has structure set
   * @param stepId {string} an id for which we are searching structure in the workflow upstream
   * @return {boolean}
   */ hasStructure(stepId) {
        for (const step of this.designer.getDefinition().sequence){
            if (step.properties.structure !== undefined) return true;
            if (stepId === step.id) return false;
        }
    }
    /** Check if the workflow has structure set
   * @param stepId {string} an id for which we are searching structure in the workflow upstream
   * @return {boolean}
   */ hasControl(stepId) {
        for (const step of this.designer.getDefinition().sequence){
            if (step.properties.control !== undefined) return true;
            if (stepId === step.id) return false;
        }
    }
    /** Returns an upstream structure for stepId
   * @param stepId {string} an id for which we are searching structure in the workflow upstream
   * @return {Structure}
   */ getStructure(stepId) {
        let structure = undefined;
        for (const step of this.designer.getDefinition().sequence){
            if (step.properties.structure !== undefined) structure = step.properties.structure;
            if (stepId === step.id) return structure;
        }
    }
    /** Build the tar archive with the files that are asked for
   * @param listener {function} a callback to run after archive creation
   * @return {Promise<void>}
   */ async requestInputFiles(listener) {
        let response = await fetch("/generate-workflow", {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(this.designer.getDefinition())
        });
        if (response.ok) {
            // File or server controlled errors
            let tarFiles = await response.text(); //await response.arrayBuffer()
            listener(tarFiles);
        } else $6ff060c6e60f738f$export$b8d0bb2aa0adefe5("Unknown server error");
    }
}


class $44b7f26d75528191$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("div", ".WorkflowDesignerPage");
        this.setHTML(`
      <div class="workflow-designer" style="flex: 1;height: 600px"></div>
    `);
    }
    /**
   * Mandatory for all Workflow steps
   */ init() {
        const placeholder = this.getElement(".workflow-designer");
        this.workflow = new (0, $84a664665add0dc5$export$2e2bcd8739ae039)(placeholder);
    }
    /** Finds current workflow step
   * @returns {WorkflowStep}
   */ getCurrentStep() {
        return this.getStep(document.location.hash.split("#")[3]);
    }
    /** Gets a step from the workflow by its id value
   *
   * @param stepId {string} a step hash id value
   * @returns {WorkflowStep}
   */ getStep(stepId) {
        if (stepId === undefined) return undefined;
        return this.workflow.steps.get(stepId);
    }
    /** Returns the workflow definition
   *
   * @returns {{sequence: [], properties: {}}} the current workflow definition
   */ getDefinition() {
        return this.workflow.designer.getDefinition();
    }
    updateForCode(code) {
        console.log(code);
    }
}






/**
 * Returns a component (step content components) instance.
 * Maybe this implementation can be improved
 * @param  {string} componentId
 * @return {UIComponent}
 */ function $ca00c0f31acab1fa$var$getComponentInstance(componentId) {
    if (componentId === "StructureBuilder") return new (0, $5394a2fd932d6e8f$export$2e2bcd8739ae039)();
    else if (componentId === "OutputAnalyzer") return new (0, $4df3196f0fa11f92$export$2e2bcd8739ae039)();
    else if (componentId === "ControlGenerator") return new (0, $0eda6e4362e8054a$export$2e2bcd8739ae039)();
    else if (componentId === "DownloadInputFilesPage") return new (0, $5ad55c3ff0fdeb5f$export$2e2bcd8739ae039)();
    else if (componentId === "WorkflowDesigner") return new (0, $44b7f26d75528191$export$2e2bcd8739ae039)();
}
class $ca00c0f31acab1fa$export$2e2bcd8739ae039 extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param  {string} workflowId
   */ constructor(workflowId){
        super("div", ".Workflow");
        this.setHTML(`
    	<div class="header-box"></div>
    	<div class="component-box"></div>
    `);
        this.workflowId = workflowId;
        this.step = 0; // current  step array index
        // This points to the farthest step reached by the user
        // in order to prevent the user from access farther steps by the URL fragment
        this.maxStep = 0;
        this.componentIds = [];
        this.stepDataMap = new Map();
        this.config = (0, $42aee24e9c9e61b5$export$9bf3ee7c0a1089c5)[workflowId];
        this.header = new $ca00c0f31acab1fa$var$AssistantHeader(this);
        this.config.steps.forEach((stepConf, i)=>{
            const componentId = stepConf.component.split(":")[0];
            const componentInstance = $ca00c0f31acab1fa$var$getComponentInstance(componentId);
            this.stepDataMap.set(componentId, {
                label: "Step " + (i + 1) + ". " + stepConf.title,
                nextButtonText: stepConf.nextButtonText,
                component: componentInstance,
                componentId: componentId,
                componentInitParams: stepConf.component.split(":")[1],
                initialized: false
            });
            this.componentIds.push(componentId);
        });
        this.e.querySelector(".header-box").appendChild(this.header.e);
        this.componentBox = this.e.querySelector(".component-box");
    }
    /**
   * Does nothing but it's mandatory for every application module
   */ init() {}
    /**
   * Returns the current (step showing) component id
   * @return {string}
   */ getComponentId() {
        return this.componentIds[this.step];
    }
    /**
   * Processes the module URL fragment
   * @param  {string} fragment
   */ processUrlFragment(fragment) {
        this.setStep(fragment);
    }
    /**
   * Increases the step counter
   */ increaseStep() {
        this.step += 1;
        // update the farthest step reached in the session
        if (this.step > this.maxStep) this.maxStep = this.step;
    }
    /**
   * Moves the workflow to the next step
   */ setNextStep() {
        //log('setNextStep', this.step, this.stepData[this.step-1])
        const componentId = this.componentIds[this.step];
        const nextComponentId = this.componentIds[this.step + 1];
        if (componentId === "ControlGenerator") {
            // Async step advance
            // This server request, in addition to get the tar with files, is performing checking
            // of the control generator params. If it fails that indicates the params sent are not right
            let cgComponent = this.stepDataMap.get("ControlGenerator").component;
            cgComponent.requestDownloadInfo((downloadInfo)=>{
                console.log(downloadInfo);
                cgComponent.requestInputFiles((filesTar)=>{
                    this.increaseStep();
                    this.setStep("DownloadInputFilesPage");
                    // Access the DownloadInputFilesPage instance
                    let dComponent = this.stepDataMap.get("DownloadInputFilesPage").component;
                    dComponent.setDownloadInfo(downloadInfo);
                    dComponent.setInputFiles(filesTar);
                    document.location.hash = this.workflowId + "-workflow#DownloadInputFilesPage";
                });
            });
        } else if (componentId === "WorkflowDesigner") {
            let wdComponent = this.stepDataMap.get(componentId).component;
            const step = wdComponent.getCurrentStep();
            if (step === undefined) {
                // validate the workflow
                if (!wdComponent.workflow.isValid()) {
                    (0, $6ff060c6e60f738f$export$b8d0bb2aa0adefe5)("The workflow is not valid");
                    return;
                }
                // Go to Download files page...
                this.increaseStep();
                wdComponent.workflow.requestInputFiles((filesTar)=>{
                    this.setStep("DownloadInputFilesPage");
                    // Access the DownloadInputFilesPage instance
                    let dComponent = this.stepDataMap.get("DownloadInputFilesPage").component;
                    dComponent.setInputFiles(filesTar);
                });
                // setDownloadInfo - set information about the download (e.g. band path)
                // dComponent.setDownloadInfo(wdComponent.workflow.designer.getDefinition())
                document.location.hash = this.workflowId + "-workflow#" + nextComponentId;
                return;
            }
            if (wdComponent.getCurrentStep().save()) document.location.hash = this.workflowId + "-workflow#" + componentId;
        } else {
            // Sync
            this.increaseStep();
            if (componentId === "StructureBuilder") {
                this.setStep("ControlGenerator"); // The control generator needs to be set before : research  // this.stepDataMap.get('ControlGenerator').component.init()
                const structure = this.stepDataMap.get("StructureBuilder").component.getCurrentStructure();
                this.stepDataMap.get("ControlGenerator").component.setStructure(structure);
            }
            // Default case
            document.location.hash = this.workflowId + "-workflow#" + nextComponentId;
        }
    }
    /**
   * Goes back to the previous step
   */ setPrevStep() {
        const componentId = this.componentIds[this.step];
        if (componentId !== "WorkflowDesigner") this.step -= 1;
        document.location.hash = this.workflowId + "-workflow#" + this.componentIds[this.step];
    }
    /**
   * Sets up and initializes a new workflow step
   * @param {string} componentId
   */ setStep(componentId) {
        let componentParam = undefined;
        if (componentId.indexOf("#") > 0) [componentId, componentParam] = componentId.split("#");
        const index = this.componentIds.indexOf(componentId);
        if (index > this.maxStep) {
            document.location.hash = this.workflowId + "-workflow#" + this.componentIds[0];
            return;
        }
        this.step = index;
        let stepData = this.stepDataMap.get(componentId);
        if (componentParam) stepData = stepData.component.workflow.steps.get(componentParam);
        this.header.setStep(stepData);
        this.componentBox.innerHTML = "";
        // console.log('COMPONENT: ', stepData)
        if (stepData.component) {
            this.componentBox.appendChild(stepData.component.e);
            if (!stepData.initialized) {
                stepData.component.init(stepData.componentInitParams);
                stepData.initialized = true;
                $1ad59a1a7edcd764$export$f9520e6df29a226e(stepData.component);
                $1ad59a1a7edcd764$export$b3488c6aaadba6a8(stepData.component);
            }
        }
    }
    /**
   * Updates the component for a code change (application level event)
   * @param  {string} code
   */ updateForCode(code) {}
    /**
   * Updates the component for a setting change (application level event)
   * @param  {object} newSettings
   */ updateSettings(newSettings) {}
}
/**
 * Workflow component header. It shows step info and controls the advance
 * through steps
 */ class $ca00c0f31acab1fa$var$AssistantHeader extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    /**
   * @param  {Workflow} workflow Workflow instance
   */ constructor(workflow){
        super("div", ".AssistantHeader");
        this.setHTML(`

      <div class="prev-button-box">
        <button class="prev" >
          &nbsp; <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($a4dce173ac6e0d02$exports)))}" height="22px" style="" alt=""> &nbsp; Go back
        </button>
      </div>

      <div class="workflow-centered-box">
    	  <div class="workflow-title-box">${workflow.config.text} workflow</div>
        <div class="step-label-box"></div>
      </div>

      <div class="next-button-box">
        <button class="next" >
          <span class="next-button-extra-text"></span>
          Go ahead &nbsp; <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($96ee8327d03b4521$exports)))}" height="22px" alt=""> &nbsp;
        </button>
      </div>
    `);
        this.stepLabel = this.getElement(".step-label-box");
        this.buttons = this.getElements("button");
        this.buttons[0].addEventListener("click", (_)=>{
            workflow.setPrevStep();
        });
        this.buttons[1].addEventListener("click", (_)=>{
            workflow.setNextStep();
        });
        this.nextButtonExtraText = this.e.querySelector(".next-button-extra-text");
    }
    /**
   * Sets up a new workflow step
   * @param {object} stepData
   */ setStep(stepData) {
        this.stepLabel.innerHTML = stepData.label;
        this.buttons[0].style.visibility = [
            "StructureBuilder",
            "WorkflowDesigner"
        ].includes(stepData.componentId) ? "hidden" : "visible";
        this.buttons[1].style.visibility = stepData.componentId === "OutputAnalyzer" ? "hidden" : "visible";
        this.nextButtonExtraText.innerHTML = stepData.nextButtonText ? stepData.nextButtonText : "";
    }
}




var $aa895a086e467e6d$exports = {};
$aa895a086e467e6d$exports = new URL("BandStructure-icon.59236816.png", import.meta.url).toString();


var $aec265e44fcf9a30$exports = {};
$aec265e44fcf9a30$exports = new URL("GW-Workflow-icon.94691551.png", import.meta.url).toString();


var $aec6786736c769af$exports = {};
$aec6786736c769af$exports = new URL("MD-Workflow-icon.2ec9a2c9.png", import.meta.url).toString();


var $68e40ed5c0c90f62$exports = {};
$68e40ed5c0c90f62$exports = new URL("DesignedWorkflow-icon.c0d0b72f.png", import.meta.url).toString();


var $98916c4050d38dce$exports = {};
$98916c4050d38dce$exports = new URL("SISSOactive-icon.80ed65b9.png", import.meta.url).toString();


var $0f0a99620eec94c3$exports = {};
$0f0a99620eec94c3$exports = new URL("ControlGenerator-icon.7e7e6fcc.png", import.meta.url).toString();


var $db56d2296d085bc8$exports = {};
$db56d2296d085bc8$exports = new URL("OutputAnalyzer-icon.9f19e705.png", import.meta.url).toString();


var $91a5f22ef6459433$exports = {};
$91a5f22ef6459433$exports = new URL("SimpleCalculation-icon.f33bfdcc.png", import.meta.url).toString();


var $146b3ca246aab0d4$exports = {};
$146b3ca246aab0d4$exports = new URL("StructureBuilder-icon.37caf98b.png", import.meta.url).toString();


// Application Dashboard buttons info
const $5eca1eb31f9ec385$var$MAIN_BUTTONS_INFO = new Map([
    [
        "SimpleCalculation",
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($91a5f22ef6459433$exports))),
            text: `Generate the input files needed for a single calculation:<br>
      1) Create the Structure 2) Choose numerical settings 3) Download input files 4) Analyze your results.`
        }
    ],
    [
        "BandStructure",
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aa895a086e467e6d$exports))),
            text: `Automatically generate the band path for your periodic structure and setup all parameters needed for the 
    calculation. Finally, import the result and download the band structure.`
        }
    ],
    [
        "GWCalculation",
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aec265e44fcf9a30$exports))),
            text: `Generate band structure using the many-body perturbation theory in the GW approach. It improves the prediction
    of electronic band structure at higher computational cost.`
        }
    ],
    [
        "MDCalculation",
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aec6786736c769af$exports))),
            text: `Generate inputs specific for the molecular dynamics simulation.`
        }
    ],
    [
        "StructureBuilder",
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($146b3ca246aab0d4$exports))),
            text: "Import a structure or design from scratch! Manipulate the structure of molecules or solids. Export the results in the format needed for the code of your choice."
        }
    ],
    [
        "ControlGenerator",
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($0f0a99620eec94c3$exports))),
            text: `Choose the numerical settings for your calculation! The basis sets are attached, automatically.`
        }
    ],
    [
        "OutputAnalyzer",
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($db56d2296d085bc8$exports))),
            text: "Upload all of your output files and the most important data will be extracted and visualized! E.g.: Band structure, DOS, Energies, Numerical Convergence."
        }
    ],
    [
        "Designed",
        {
            name: "Workflow",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($68e40ed5c0c90f62$exports))),
            text: "Design a workflow, download its input files and batch process the outputs."
        }
    ],
    [
        "SISSOactive",
        {
            name: "Artificial Intelligence",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($98916c4050d38dce$exports))),
            text: "Finding the relevant materials genes and their quantitative correlation with the property of interest"
        }
    ]
]);
const $5eca1eb31f9ec385$var$DESKTOP_MODE = false; // true //
// Application title
let $5eca1eb31f9ec385$var$appTitle = document.querySelector("#app-title");
// When the application title is clicked the initial Dashboard module is shown
$5eca1eb31f9ec385$var$appTitle.addEventListener("click", (_)=>document.location.hash = "");
// Application breadcrumb and desktop version download popup
let $5eca1eb31f9ec385$var$breadcrumbBox = document.querySelector(".breadcrumb-box");
// At the top level page the breadcrumb is replaced by the desktop version download button
let $5eca1eb31f9ec385$var$desktopDownloadButton;
if (!$5eca1eb31f9ec385$var$DESKTOP_MODE) {
    $5eca1eb31f9ec385$var$desktopDownloadButton = new (0, $175b311ee190559c$export$2e2bcd8739ae039)("div", ".desktop-app-download");
    $5eca1eb31f9ec385$var$desktopDownloadButton.setHTML('<img style="vertical-align: middle; padding-right: 6px" src="' + (0, (/*@__PURE__*/$parcel$interopDefault($71de690891678265$exports))) + '" height="18px" alt="Download standalone version"> Desktop application');
    $5eca1eb31f9ec385$var$desktopDownloadButton.e.addEventListener("click", (_)=>{
        $9d993874406c4873$export$b964053cbf2907a2(`
			<h3 style="margin-top: 0">How to get the desktop application running on your computer:</h3>
			1. Download the latest release of the application binary file for your platform from &nbsp;&nbsp;
				<a target="_blank" href="https://gitlab.com/gims-developers/gims/-/releases">GIMS Releases page</a> <br><br>
			2. Start up the application server just by executing the downloaded file <br><br>
			3. Enjoy the application on your favorite browser via this local address: <a href="http://localhost:5000/"> GIMS local address </a>`);
        $9d993874406c4873$export$d7e8d4d4450c819c();
    });
    $5eca1eb31f9ec385$var$breadcrumbBox.appendChild($5eca1eb31f9ec385$var$desktopDownloadButton.e);
}
// Application version selection
const $5eca1eb31f9ec385$var$gimsSelectionBox = document.querySelector(".gims-selection-box select");
const $5eca1eb31f9ec385$var$gimsHost = {
    "gims-dev.ms1p.org/": "dev",
    "gims.ms1p.org/": "stable",
    "gims.ms1p.org/fallback/": "fallback"
};
const $5eca1eb31f9ec385$var$gimsVersion = Object.fromEntries(Object.entries($5eca1eb31f9ec385$var$gimsHost).map((a)=>a.reverse()));
const $5eca1eb31f9ec385$var$idx = window.location.pathname.indexOf("static");
const $5eca1eb31f9ec385$var$address = window.location.hostname + window.location.pathname.slice(0, $5eca1eb31f9ec385$var$idx);
if ($5eca1eb31f9ec385$var$address in $5eca1eb31f9ec385$var$gimsHost) $5eca1eb31f9ec385$var$gimsSelectionBox.value = $5eca1eb31f9ec385$var$gimsHost[$5eca1eb31f9ec385$var$address];
$5eca1eb31f9ec385$var$gimsSelectionBox.addEventListener("change", (e)=>window.location.href = "https://" + $5eca1eb31f9ec385$var$gimsVersion[e.target.value]);
// Application code selection
let $5eca1eb31f9ec385$var$codeSelectionBox = document.querySelector(".code-selection-box");
$5eca1eb31f9ec385$var$codeSelectionBox.querySelector("." + $1ad59a1a7edcd764$export$9a0a9c75ccef13fb() + "-code-button").classList.add("code-selected");
$5eca1eb31f9ec385$var$codeSelectionBox.addEventListener("click", (e)=>{
    const codeClass = e.target.classList.item(0);
    if (codeClass.includes("code-button")) {
        let code = codeClass.substring(0, codeClass.indexOf("-"));
        $1ad59a1a7edcd764$export$fedf157424a060a8(code); // log('code', code)
        $5eca1eb31f9ec385$var$codeSelectionBox.querySelector(".code-selected").classList.remove("code-selected");
        $5eca1eb31f9ec385$var$codeSelectionBox.querySelector("." + code + "-code-button").classList.add("code-selected");
    }
});
// Application settings
let $5eca1eb31f9ec385$var$settingsButton = document.querySelector(".settings-button");
$5eca1eb31f9ec385$var$settingsButton.addEventListener("click", (_)=>{
    $9d993874406c4873$export$a778490beb6e83b8(new (0, $33c426b17ad0a12d$export$2e2bcd8739ae039)().e);
    $9d993874406c4873$export$d7e8d4d4450c819c();
});
/**
 * Application front page component
 */ class $5eca1eb31f9ec385$var$Dashboard extends (0, $175b311ee190559c$export$2e2bcd8739ae039) {
    constructor(){
        super("div", "#app-dashboard");
        this.setHTML(`

      <div class="workflow-buttons-box">
        <!-- the buttons here are generated from the workflows declaration file  -->
      </div>

      <div>
        <div class=dashboard-h1>Calculation Apps</div>
        <div class="dashboard-row">
          ${getMainButtonHTML("Simple Calculation", true)}
          ${getMainButtonHTML("Band Structure", true)}
          ${getMainButtonHTML("GW Calculation", true)}
          ${getMainButtonHTML("MD Calculation", true)}
        </div>
      </div>

      <div>
        <div class=dashboard-h1>Elemental Apps</div>
        <div class="dashboard-row">
          ${getMainButtonHTML("Structure Builder")}
          ${getMainButtonHTML("Control Generator")}
          ${getMainButtonHTML("Output Analyzer")}
        </div>
      </div>

      ${getWorkflowHTML()}



    `);
        // let html = '<div class=dashboard-h1>Workflow Apps</div> <div class="dashboard-row">'
        // for (let w in workflows)
        // 	html += getMainButtonHTML(workflows[w].text, true)
        // html += '</div>'
        // this.getElement('.workflow-buttons-box').innerHTML = html
        function getWorkflowHTML() {
            const gims_build_sisso_workflow = undefined;
            if (gims_build_sisso_workflow === "true") return `<div>
          <div class=dashboard-h1>Workflow Apps</div>
          <div class="dashboard-row">
            <!--
            ${getMainButtonHTML("Designed", true)}
            -->
            ${getMainButtonURLHTML("SISSOactive", true, "/dash")}
          </div>
        </div>
        `;
            else return ``;
        }
        function getMainButtonHTML(name, workflow = false) {
            const nameRed = name.replace(/ /g, "").replace(/&/g, "");
            return `<div id="${nameRed}${workflow ? "-workflow" : ""}-button" class="dashboard-button">
		          <img class="main" src="${$5eca1eb31f9ec385$var$MAIN_BUTTONS_INFO.get(nameRed).icon}" alt="${name}"/>
		          <span style="width: 54%">${$5eca1eb31f9ec385$var$MAIN_BUTTONS_INFO.get(nameRed).name === undefined ? name : $5eca1eb31f9ec385$var$MAIN_BUTTONS_INFO.get(nameRed).name}</span>
		          <img  class="help-button" src="${0, (/*@__PURE__*/$parcel$interopDefault($729955f814b389dc$exports))}" width="22" alt="Help"/> &nbsp;

		          <div class="dashboard-button-explanation">
		        	${$5eca1eb31f9ec385$var$MAIN_BUTTONS_INFO.get(nameRed).text}
		          </div>

		        </div>
		        `;
        }
        function getMainButtonURLHTML(name, workflow = false, inputurl) {
            const nameRed = name.replace(/ /g, "").replace(/&/g, "");
            //log(nameRed, name)
            return `<div id="${nameRed}${workflow ? "-workflow" : ""}-button" class="dashboard-button">
		          <img class="main" src="${$5eca1eb31f9ec385$var$MAIN_BUTTONS_INFO.get(nameRed).icon}" alt="${name}"/>
		          <a href="${inputurl}" style="text-decoration:none"><span style="width: 54%">${$5eca1eb31f9ec385$var$MAIN_BUTTONS_INFO.get(nameRed).name === undefined ? name : $5eca1eb31f9ec385$var$MAIN_BUTTONS_INFO.get(nameRed).name}</span></a>
		          <img  class="help-button" src="${0, (/*@__PURE__*/$parcel$interopDefault($729955f814b389dc$exports))}" width="22" alt="Help"/> &nbsp;

		          <div class="dashboard-button-explanation">
		        	${$5eca1eb31f9ec385$var$MAIN_BUTTONS_INFO.get(nameRed).text}
		          </div>

		        </div>
		        `;
        }
    }
    /**
   * Sets the listener that will be called when the component is clicked
   * @param {function} listener
   */ setListener(listener) {
        this.e.addEventListener("click", (e)=>listener(e));
    }
}
/****** Application start up code ******/ const $5eca1eb31f9ec385$var$appElement = document.getElementById("app-placeholder");
let $5eca1eb31f9ec385$var$currentModule; // Module showing
const $5eca1eb31f9ec385$var$dashboard = new $5eca1eb31f9ec385$var$Dashboard();
// Dashboard buttons listener
$5eca1eb31f9ec385$var$dashboard.setListener((e)=>{
    const buttonId = e.target.id || e.target.parentElement.id;
    // Regular case, not workflow
    const moduleId = buttonId.substring(0, buttonId.indexOf("-button"));
    let urlHash = moduleId;
    if (buttonId.includes("workflow")) {
        // If workflow
        const workflowId = buttonId.substring(0, buttonId.indexOf("-workflow-button"));
        if ($5eca1eb31f9ec385$var$moduleMap.get(moduleId)) // workflow already instanced:
        // it asks for the current component in the workflow
        urlHash = moduleId + "#" + $5eca1eb31f9ec385$var$moduleMap.get(moduleId).getComponentId();
        else // workflow not instanced yet: it gets the first component
        urlHash = moduleId + "#" + (0, $42aee24e9c9e61b5$export$9bf3ee7c0a1089c5)[workflowId].steps[0].component;
    }
    document.location.hash = urlHash;
});
// application level modules
const $5eca1eb31f9ec385$var$moduleMap = new Map([
    [
        "StructureBuilder",
        undefined
    ],
    [
        "OutputAnalyzer",
        undefined
    ],
    [
        "ControlGenerator",
        undefined
    ],
    [
        "SimpleCalculation-workflow",
        undefined
    ],
    [
        "BandStructure-workflow",
        undefined
    ],
    [
        "GWCalculation-workflow",
        undefined
    ],
    [
        "MDCalculation-workflow",
        undefined
    ],
    [
        "Designed-workflow",
        undefined
    ],
    [
        "SISSOactive-workflow",
        undefined
    ]
]);
/**
 * Handles the application level modules. It's in charge
 * of displaying them and instantiating when necessary
 * @param  {string} moduleString
 *   module string identifier and configuration arguments
 * @param  {string} moduleParams Module params by the URL fragment
 */ function $5eca1eb31f9ec385$var$manageModules(moduleString, moduleParams) {
    console.log("manageModules", moduleString, moduleParams); //,  moduleMap)
    if (moduleString === "") {
        // exceptional case: Dashboard
        $5eca1eb31f9ec385$var$showModuleElement($5eca1eb31f9ec385$var$dashboard);
        $5eca1eb31f9ec385$var$breadcrumbBox.innerHTML = "";
        if ($5eca1eb31f9ec385$var$desktopDownloadButton) $5eca1eb31f9ec385$var$breadcrumbBox.appendChild($5eca1eb31f9ec385$var$desktopDownloadButton.e);
        return;
    }
    const moduleId = moduleString.split(":")[0];
    const moduleConf = moduleString.split(":")[1];
    let nextModule = $5eca1eb31f9ec385$var$moduleMap.get(moduleId);
    // remove extra hash in case of app refresh
    if (nextModule === undefined && moduleParams !== undefined && moduleParams.includes("#")) {
        document.location.hash = "";
        return;
    }
    if ($5eca1eb31f9ec385$var$moduleMap.has(moduleId)) {
        if (!nextModule) {
            // The module is not loaded yet
            nextModule = getModInstance(moduleId);
            $5eca1eb31f9ec385$var$moduleMap.set(moduleId, nextModule); //console.log('manageModules 1', moduleMap, nextModule)
            $1ad59a1a7edcd764$export$f9520e6df29a226e(nextModule);
            $1ad59a1a7edcd764$export$b3488c6aaadba6a8(nextModule);
            $5eca1eb31f9ec385$var$showModuleElement(nextModule);
            if (moduleConf) nextModule.init(moduleConf);
            else nextModule.init();
        } else {
            // The module is already loaded
            $5eca1eb31f9ec385$var$showModuleElement(nextModule);
            if (moduleConf) nextModule.init(moduleConf);
        }
        if (moduleParams) nextModule.processUrlFragment(moduleParams);
    } else {
        document.location.hash = "";
        return;
    }
    $5eca1eb31f9ec385$var$breadcrumbBox.innerHTML = moduleId.includes("workflow") ? moduleId.split("-").join(" ") : moduleId;
    // I think this is improvable
    function getModInstance(moduleId) {
        console.log("getModInstance", moduleId);
        if (moduleId === "StructureBuilder") return new (0, $5394a2fd932d6e8f$export$2e2bcd8739ae039)();
        else if (moduleId === "OutputAnalyzer") return new (0, $4df3196f0fa11f92$export$2e2bcd8739ae039)();
        else if (moduleId === "ControlGenerator") return new (0, $0eda6e4362e8054a$export$2e2bcd8739ae039)();
        else if (moduleId.includes("-workflow")) return new (0, $ca00c0f31acab1fa$export$2e2bcd8739ae039)(moduleId.substring(0, moduleId.indexOf("-")));
    }
}
/**
 * Displays the module component
 * @param  {Dashboard} module Module instance
 */ function $5eca1eb31f9ec385$var$showModuleElement(module) {
    if (module === $5eca1eb31f9ec385$var$currentModule) return;
    if ($5eca1eb31f9ec385$var$currentModule) $5eca1eb31f9ec385$var$appElement.removeChild($5eca1eb31f9ec385$var$currentModule.e);
    $5eca1eb31f9ec385$var$currentModule = module;
    $5eca1eb31f9ec385$var$appElement.appendChild($5eca1eb31f9ec385$var$currentModule.e);
}
// initial URL fragment analysis
$5eca1eb31f9ec385$var$processUrlHash();
// application level event to check the URL hash changes
window.addEventListener("hashchange", (_)=>{
    $5eca1eb31f9ec385$var$processUrlHash();
});
/**
 * Processes the URL hash. This is the application navigation mechanism
 */ function $5eca1eb31f9ec385$var$processUrlHash() {
    let urlHash = document.location.hash.substring(1);
    //log('processUrlHash', urlHash)
    if (urlHash.indexOf("#") > 0) {
        // Module with params
        const moduleId = urlHash.substring(0, urlHash.indexOf("#"));
        const moduleParams = urlHash.substring(urlHash.indexOf("#") + 1);
        $5eca1eb31f9ec385$var$manageModules(moduleId, moduleParams);
    } else // Module or workflows without params, urlHash = moduleId
    $5eca1eb31f9ec385$var$manageModules(urlHash);
}
// Application level Escape key function to hide the modal popup
document.addEventListener("keydown", (e)=>{
    if (e.code === "Escape") {
        e.preventDefault();
        $9d993874406c4873$export$af4939467128bcd0();
    }
});


//# sourceMappingURL=index.f77e0bd3.js.map
